export default {
  "110001": {
    "state": "Delhi",
    "district": "Central Delhi",
    "block": "New Delhi",
    "officename": "New Delhi GPO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi GPO Division"
  },
  "110002": {
    "state": "Delhi",
    "district": "Central Delhi",
    "block": "New Delhi",
    "officename": "Indraprastha HO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi Central Division"
  },
  "110003": {
    "state": "Delhi",
    "district": "South Delhi",
    "block": "New Delhi",
    "officename": "Lodi Road HO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi South Division"
  },
  "110004": {
    "state": "Delhi",
    "district": "Central Delhi",
    "block": "New Delhi",
    "officename": "Rashtrapati Bhawan SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi Central Division"
  },
  "110005": {
    "state": "Delhi",
    "district": "Central Delhi",
    "block": "New Delhi",
    "officename": "Karol Bagh SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi Central Division"
  },
  "110006": {
    "state": "Delhi",
    "district": "North Delhi",
    "block": "Delhi",
    "officename": "Delhi GPO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Delhi GPO Division"
  },
  "110007": {
    "state": "Delhi",
    "district": "North Delhi",
    "block": "Delhi",
    "officename": "Malka Ganj SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Delhi North Division"
  },
  "110008": {
    "state": "Delhi",
    "district": "Central Delhi",
    "block": "New Delhi",
    "officename": "Patel Nagar SO Central Delhi",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi Central Division"
  },
  "110009": {
    "state": "Delhi",
    "district": "North West Delhi",
    "block": "Delhi",
    "officename": "GTB Nagar SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Delhi North Division"
  },
  "110010": {
    "state": "Delhi",
    "district": "South West Delhi",
    "block": "New Delhi",
    "officename": "Delhi Cantt SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi South West Division"
  },
  "110011": {
    "state": "Delhi",
    "district": "Central Delhi",
    "block": "New Delhi",
    "officename": "Nirman Bhawan SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi Central Division"
  },
  "110012": {
    "state": "Delhi",
    "district": "Central Delhi",
    "block": "New Delhi",
    "officename": "IARI SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi Central Division"
  },
  "110013": {
    "state": "Delhi",
    "district": "South Delhi",
    "block": "New Delhi",
    "officename": "Hazrat Nizamuddin SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi South Division"
  },
  "110014": {
    "state": "Delhi",
    "district": "South Delhi",
    "block": "New Delhi",
    "officename": "Jungpura SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi South Division"
  },
  "110015": {
    "state": "Delhi",
    "district": "West Delhi",
    "block": "New Delhi",
    "officename": "Ramesh Nagar H.O",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi West Division"
  },
  "110016": {
    "state": "Delhi",
    "district": "South West Delhi",
    "block": "New Delhi",
    "officename": "Hauz Khas SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi South West Division"
  },
  "110017": {
    "state": "Delhi",
    "district": "South Delhi",
    "block": "New Delhi",
    "officename": "Malviya Nagar SO South Delhi",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi South Division"
  },
  "110018": {
    "state": "Delhi",
    "district": "West Delhi",
    "block": "New Delhi",
    "officename": "Tilak Nagar S.O (West Delhi)",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi West Division"
  },
  "110019": {
    "state": "Delhi",
    "district": "South Delhi",
    "block": "New Delhi",
    "officename": "Kalkaji HO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi South Division"
  },
  "110020": {
    "state": "Delhi",
    "district": "South Delhi",
    "block": "New Delhi",
    "officename": "Okhla Industrial Estate SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi South Division"
  },
  "110021": {
    "state": "Delhi",
    "district": "South West Delhi",
    "block": "New Delhi",
    "officename": "Chanakya Puri SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi South West Division"
  },
  "110022": {
    "state": "Delhi",
    "district": "South West Delhi",
    "block": "New Delhi",
    "officename": "R K Puram Sect5 SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi South West Division"
  },
  "110023": {
    "state": "Delhi",
    "district": "South West Delhi",
    "block": "New Delhi",
    "officename": "Sarojini Nagar HO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi South West Division"
  },
  "110024": {
    "state": "Delhi",
    "district": "South Delhi",
    "block": "New Delhi",
    "officename": "Lajpat Nagar South Delhi SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi South Division"
  },
  "110025": {
    "state": "Delhi",
    "district": "South Delhi",
    "block": "New Delhi",
    "officename": "New Friends Colony SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi South Division"
  },
  "110026": {
    "state": "Delhi",
    "district": "West Delhi",
    "block": "New Delhi",
    "officename": "Punjabi Bagh S.O",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi West Division"
  },
  "110027": {
    "state": "Delhi",
    "district": "West Delhi",
    "block": "New Delhi",
    "officename": "Tagore Garden S.O",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi West Division"
  },
  "110028": {
    "state": "Delhi",
    "district": "South West Delhi",
    "block": "New Delhi",
    "officename": "Naraina Industrial Estate H.O",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi West Division"
  },
  "110029": {
    "state": "Delhi",
    "district": "South West Delhi",
    "block": "New Delhi",
    "officename": "Safdarjung Enclave SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi South West Division"
  },
  "110030": {
    "state": "Delhi",
    "district": "South West Delhi",
    "block": "New Delhi",
    "officename": "Mehrauli SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi South West Division"
  },
  "110031": {
    "state": "Delhi",
    "district": "East Delhi",
    "block": "NA",
    "officename": "Gandhi Nagar SO East Delhi",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Delhi East Division"
  },
  "110032": {
    "state": "Delhi",
    "district": "North East Delhi",
    "block": "Delhi North East",
    "officename": "Shahdara SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Delhi East Division"
  },
  "110033": {
    "state": "Delhi",
    "district": "North West Delhi",
    "block": "Delhi",
    "officename": "NSMandi SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Delhi North Division"
  },
  "110034": {
    "state": "Delhi",
    "district": "North West Delhi",
    "block": "Delhi",
    "officename": "Saraswati Vihar SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Delhi North Division"
  },
  "110035": {
    "state": "Delhi",
    "district": "North West Delhi",
    "block": "Delhi",
    "officename": "Keshavpuram SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Delhi North Division"
  },
  "110036": {
    "state": "Delhi",
    "district": "North West Delhi",
    "block": "Delhi",
    "officename": "Alipur SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Delhi North Division"
  },
  "110037": {
    "state": "Delhi",
    "district": "South West Delhi",
    "block": "New Delhi",
    "officename": "Gurgaon Road SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi South West Division"
  },
  "110038": {
    "state": "Delhi",
    "district": "South West Delhi",
    "block": "New Delhi",
    "officename": "A F Rajokari SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi South West Division"
  },
  "110039": {
    "state": "Delhi",
    "district": "North West Delhi",
    "block": "Delhi",
    "officename": "Bawana SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Delhi North Division"
  },
  "110040": {
    "state": "Delhi",
    "district": "North West Delhi",
    "block": "Delhi",
    "officename": "Narela SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Delhi North Division"
  },
  "110041": {
    "state": "Delhi",
    "district": "West Delhi",
    "block": "New Delhi",
    "officename": "Nangloi S.O",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi West Division"
  },
  "110042": {
    "state": "Delhi",
    "district": "North West Delhi",
    "block": "Delhi",
    "officename": "Samai Pur SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Delhi North Division"
  },
  "110043": {
    "state": "Delhi",
    "district": "South West Delhi",
    "block": "New Delhi",
    "officename": "Najafgarh S.O",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi West Division"
  },
  "110044": {
    "state": "Delhi",
    "district": "South Delhi",
    "block": "New Delhi",
    "officename": "Badarpur SO South Delhi",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi South Division"
  },
  "110045": {
    "state": "Delhi",
    "district": "South West Delhi",
    "block": "New Delhi",
    "officename": "Palam Village S.O",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi West Division"
  },
  "110046": {
    "state": "Delhi",
    "district": "South West Delhi",
    "block": "New Delhi",
    "officename": "Nangal Raya S.O",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi West Division"
  },
  "110047": {
    "state": "Delhi",
    "district": "South West Delhi",
    "block": "New Delhi",
    "officename": "Arjungarh SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi South West Division"
  },
  "110048": {
    "state": "Delhi",
    "district": "South Delhi",
    "block": "New Delhi",
    "officename": "Greater Kailash SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi South Division"
  },
  "110049": {
    "state": "Delhi",
    "district": "South Delhi",
    "block": "New Delhi",
    "officename": "Andrewsganj SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi South Division"
  },
  "110051": {
    "state": "Delhi",
    "district": "East Delhi",
    "block": "NA",
    "officename": "Krishna Nagar HO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Delhi East Division"
  },
  "110052": {
    "state": "Delhi",
    "district": "North West Delhi",
    "block": "Delhi",
    "officename": "Ashok Vihar HO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Delhi North Division"
  },
  "110053": {
    "state": "Delhi",
    "district": "North East Delhi",
    "block": "Delhi North East",
    "officename": "Seelampur SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Delhi East Division"
  },
  "110054": {
    "state": "Delhi",
    "district": "North Delhi",
    "block": "North",
    "officename": "Civil Lines SO North Delhi",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Delhi North Division"
  },
  "110055": {
    "state": "Delhi",
    "district": "Central Delhi",
    "block": "New Delhi",
    "officename": "Swami Ram Tirth Nagar SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi Central Division"
  },
  "110056": {
    "state": "Delhi",
    "district": "North West Delhi",
    "block": "Delhi",
    "officename": "Shakur Basti Depot SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Delhi North Division"
  },
  "110057": {
    "state": "Delhi",
    "district": "South West Delhi",
    "block": "New Delhi",
    "officename": "Vasant Vihar1 SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi South West Division"
  },
  "110058": {
    "state": "Delhi",
    "district": "West Delhi",
    "block": "New Delhi",
    "officename": "Janakpuri B 1 S.O",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi West Division"
  },
  "110059": {
    "state": "Delhi",
    "district": "West Delhi",
    "block": "New Delhi",
    "officename": "D. K. Mohan Garden S.O",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi West Division"
  },
  "110060": {
    "state": "Delhi",
    "district": "Central Delhi",
    "block": "New Delhi",
    "officename": "Rajender Nagar SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi Central Division"
  },
  "110061": {
    "state": "Delhi",
    "district": "South West Delhi",
    "block": "New Delhi",
    "officename": "Bijwasan SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi South West Division"
  },
  "110062": {
    "state": "Delhi",
    "district": "South Delhi",
    "block": "New Delhi",
    "officename": "Pushpa Bhawan SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi South Division"
  },
  "110063": {
    "state": "Delhi",
    "district": "West Delhi",
    "block": "New Delhi",
    "officename": "Paschim Vihar S.O",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi West Division"
  },
  "110064": {
    "state": "Delhi",
    "district": "West Delhi",
    "block": "New Delhi",
    "officename": "Maya Puri S.O",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi West Division"
  },
  "110065": {
    "state": "Delhi",
    "district": "South Delhi",
    "block": "New Delhi",
    "officename": "Sriniwaspuri SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi South Division"
  },
  "110066": {
    "state": "Delhi",
    "district": "South West Delhi",
    "block": "New Delhi",
    "officename": "R K Puram Main SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi South West Division"
  },
  "110067": {
    "state": "Delhi",
    "district": "South West Delhi",
    "block": "New Delhi",
    "officename": "JNU SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi South West Division"
  },
  "110068": {
    "state": "Delhi",
    "district": "South West Delhi",
    "block": "New Delhi",
    "officename": "Ignou SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi South West Division"
  },
  "110069": {
    "state": "Delhi",
    "district": "Central Delhi",
    "block": "New Delhi",
    "officename": "Union Public Service Commission SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi Central Division"
  },
  "110070": {
    "state": "Delhi",
    "district": "South West Delhi",
    "block": "New Delhi",
    "officename": "Vasant Kunj SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi South West Division"
  },
  "110071": {
    "state": "Delhi",
    "district": "South West Delhi",
    "block": "New Delhi",
    "officename": "Chhawla S.O",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi West Division"
  },
  "110072": {
    "state": "Delhi",
    "district": "South West Delhi",
    "block": "New Delhi",
    "officename": "CRPF Jharoda Kalan S.O",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi West Division"
  },
  "110073": {
    "state": "Delhi",
    "district": "South West Delhi",
    "block": "New Delhi",
    "officename": "Ujwa S.O",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi West Division"
  },
  "110074": {
    "state": "Delhi",
    "district": "South West Delhi",
    "block": "New Delhi",
    "officename": "Chattarpur SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi South West Division"
  },
  "110075": {
    "state": "Delhi",
    "district": "South West Delhi",
    "block": "New Delhi",
    "officename": "Dwarka Sec-6 S.O",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi West Division"
  },
  "110076": {
    "state": "Delhi",
    "district": "South Delhi",
    "block": "New Delhi",
    "officename": "Sarita Vihar SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi South Division"
  },
  "110077": {
    "state": "Delhi",
    "district": "South West Delhi",
    "block": "New Delhi",
    "officename": "Raj Nagar   II S.O",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi West Division"
  },
  "110078": {
    "state": "Delhi",
    "district": "West Delhi",
    "block": "New Delhi",
    "officename": "N.S.I.T. Dwarka S.O",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi West Division"
  },
  "110080": {
    "state": "Delhi",
    "district": "South Delhi",
    "block": "South Delhi",
    "officename": "Sangam Vihar SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi South Division"
  },
  "110081": {
    "state": "Delhi",
    "district": "North West Delhi",
    "block": "Delhi",
    "officename": "Kanjhawla SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Delhi North Division"
  },
  "110082": {
    "state": "Delhi",
    "district": "North West Delhi",
    "block": "Delhi",
    "officename": "Khera Kalan SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Delhi North Division"
  },
  "110083": {
    "state": "Delhi",
    "district": "North West Delhi",
    "block": "Delhi",
    "officename": "Mangolpuri N Block SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Delhi North Division"
  },
  "110084": {
    "state": "Delhi",
    "district": "North Delhi",
    "block": "Delhi",
    "officename": "Burari SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Delhi North Division"
  },
  "110085": {
    "state": "Delhi",
    "district": "North Delhi",
    "block": "Delhi",
    "officename": "Rohini Sector7 SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Delhi North Division"
  },
  "110086": {
    "state": "Delhi",
    "district": "North West Delhi",
    "block": "Delhi",
    "officename": "Sultanpuri C Block SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Delhi North Division"
  },
  "110087": {
    "state": "Delhi",
    "district": "West Delhi",
    "block": "New Delhi",
    "officename": "Sunder Vihar S.O",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi West Division"
  },
  "110088": {
    "state": "Delhi",
    "district": "North West Delhi",
    "block": "Delhi",
    "officename": "Shalimar Bagh SO North West Delhi",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Delhi North Division"
  },
  "110089": {
    "state": "Delhi",
    "district": "North West Delhi",
    "block": "Delhi",
    "officename": "Rohini Sector 15 SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Delhi North Division"
  },
  "110090": {
    "state": "Delhi",
    "district": "East Delhi",
    "block": "East Delhi",
    "officename": "Karawal Nagar SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Delhi East Division"
  },
  "110091": {
    "state": "Delhi",
    "district": "East Delhi",
    "block": "NA",
    "officename": "Patparganj SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Delhi East Division"
  },
  "110092": {
    "state": "Delhi",
    "district": "East Delhi",
    "block": "NA",
    "officename": "Laxmi Nagar SO East Delhi",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Delhi East Division"
  },
  "110093": {
    "state": "Delhi",
    "district": "East Delhi",
    "block": "NA",
    "officename": "Nand Nagri C SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Delhi East Division"
  },
  "110094": {
    "state": "Delhi",
    "district": "North East Delhi",
    "block": "Delhi North East",
    "officename": "Gokal Puri SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Delhi East Division"
  },
  "110095": {
    "state": "Delhi",
    "district": "East Delhi",
    "block": "NA",
    "officename": "Jhilmil HO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Delhi East Division"
  },
  "110096": {
    "state": "Delhi",
    "district": "East Delhi",
    "block": "NA",
    "officename": "Vasundhra Enclave SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Delhi East Division"
  },
  "110097": {
    "state": "Delhi",
    "district": "South West Delhi",
    "block": "New Delhi",
    "officename": "Kapashera SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi South West Division"
  },
  "121001": {
    "state": "Haryana",
    "district": "Faridabad",
    "block": "Faridabad",
    "officename": "Faridabad NIT HO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Faridabad Division"
  },
  "121002": {
    "state": "Haryana",
    "district": "Faridabad",
    "block": "Faridabad",
    "officename": "Faridabad Sector 16a  SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Faridabad Division"
  },
  "121003": {
    "state": "Haryana",
    "district": "Faridabad",
    "block": "Faridabad",
    "officename": "Amarnagar SO Faridabad",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Faridabad Division"
  },
  "121004": {
    "state": "Haryana",
    "district": "Faridabad",
    "block": "Ballabgarh",
    "officename": "Ballabgarh SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Faridabad Division"
  },
  "121005": {
    "state": "Haryana",
    "district": "Faridabad",
    "block": "Faridabad",
    "officename": "Faridabad Sector 22 SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Faridabad Division"
  },
  "121006": {
    "state": "Haryana",
    "district": "Faridabad",
    "block": "Ballabgarh",
    "officename": "Faridabad Sector 7 SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Faridabad Division"
  },
  "121007": {
    "state": "Haryana",
    "district": "Faridabad",
    "block": "Faridabad",
    "officename": "Escortsnagar Faridabad SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Faridabad Division"
  },
  "121008": {
    "state": "Haryana",
    "district": "Faridabad",
    "block": "Faridabad",
    "officename": "Faridabad Sector 29 SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Faridabad Division"
  },
  "121009": {
    "state": "Haryana",
    "district": "Faridabad",
    "block": "Faridabad",
    "officename": "Surajkund Faridabad SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Faridabad Division"
  },
  "121010": {
    "state": "Haryana",
    "district": "Faridabad",
    "block": "Faridabad",
    "officename": "Nhpc Colony Faridabad SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Faridabad Division"
  },
  "121012": {
    "state": "Haryana",
    "district": "Faridabad",
    "block": "Faridabad",
    "officename": "Sector21D  SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Faridabad Division"
  },
  "121013": {
    "state": "Haryana",
    "district": "Faridabad",
    "block": "Faridabad",
    "officename": "Sec91 SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Faridabad Division"
  },
  "121101": {
    "state": "Haryana",
    "district": "Faridabad",
    "block": "Ballabgarh",
    "officename": "Tigaon SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Faridabad Division"
  },
  "121102": {
    "state": "Haryana",
    "district": "Faridabad",
    "block": "Palwal",
    "officename": "Palwal SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Faridabad Division"
  },
  "121103": {
    "state": "Haryana",
    "district": "Faridabad",
    "block": "Hathin",
    "officename": "Hathin SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Faridabad Division"
  },
  "121105": {
    "state": "Haryana",
    "district": "Faridabad",
    "block": "Palwal",
    "officename": "Aurangabad SO Faridabad",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Faridabad Division"
  },
  "121106": {
    "state": "Haryana",
    "district": "Faridabad",
    "block": "Hodal",
    "officename": "Hodal SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Faridabad Division"
  },
  "121107": {
    "state": "Haryana",
    "district": "Faridabad",
    "block": "Hodal",
    "officename": "Hassanpur SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Faridabad Division"
  },
  "122001": {
    "state": "Haryana",
    "district": "Gurgaon",
    "block": "Arjun Nagar",
    "officename": "Gurgaon HO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "122002": {
    "state": "Haryana",
    "district": "Gurgaon",
    "block": "Dlf Qe",
    "officename": "DLF QE SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "122003": {
    "state": "Haryana",
    "district": "Gurgaon",
    "block": "Sector -45",
    "officename": "Gurgaon Sector 45 SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "122004": {
    "state": "Haryana",
    "district": "Gurgaon",
    "block": "Dlf Qe",
    "officename": "Narsinghpur SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "122005": {
    "state": "Haryana",
    "district": "Gurgaon",
    "block": "Air Force",
    "officename": "Air Force SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "122006": {
    "state": "Haryana",
    "district": "Gurgaon",
    "block": "Dlf Qe",
    "officename": "Railwary Road SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "122007": {
    "state": "Haryana",
    "district": "Gurgaon",
    "block": "Industrial Estate",
    "officename": "Industrial Estate SO Gurgaon",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "122008": {
    "state": "Haryana",
    "district": "Gurgaon",
    "block": "Dlf Ph-ii",
    "officename": "DLF PhII SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "122009": {
    "state": "Haryana",
    "district": "Gurgaon",
    "block": "Galleria Dlf-iv",
    "officename": "Galleria DLFIV SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "122010": {
    "state": "Haryana",
    "district": "Gurgaon",
    "block": "Dlf Ph-iii",
    "officename": "DLF PhIII SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "122011": {
    "state": "Haryana",
    "district": "Gurgaon",
    "block": "Dlf Qe",
    "officename": "Gurgaon Sector 56 SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "122015": {
    "state": "Haryana",
    "district": "Gurgaon",
    "block": "Palam Road",
    "officename": "Palam Road SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "122016": {
    "state": "Haryana",
    "district": "Gurgaon",
    "block": "Dlf Qe",
    "officename": "Industrial Complex Dundahera SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "122017": {
    "state": "Haryana",
    "district": "Gurgaon",
    "block": "Dlf Qe",
    "officename": "Palam Vihar SO Gurgaon",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "122018": {
    "state": "Haryana",
    "district": "Gurgaon",
    "block": "Dlf Qe",
    "officename": "Gurgaon South City II SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "122051": {
    "state": "Haryana",
    "district": "Gurgaon",
    "block": "Dlf Qe",
    "officename": "Nsg Camp Manesar SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "122052": {
    "state": "Haryana",
    "district": "Gurgaon",
    "block": "Manesar",
    "officename": "IMT Manesar SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "122101": {
    "state": "Haryana",
    "district": "Gurgaon",
    "block": "Badshahpur",
    "officename": "Badshahpur SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "122102": {
    "state": "Haryana",
    "district": "Gurgaon",
    "block": "Bhondsi",
    "officename": "Bhondsi SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "122103": {
    "state": "Haryana",
    "district": "Gurgaon",
    "block": "Dlf Qe",
    "officename": "Sohna SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "122104": {
    "state": "Haryana",
    "district": "Gurgaon",
    "block": "Dlf Qe",
    "officename": "Ferozepur Jhirka SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Faridabad Division"
  },
  "122105": {
    "state": "Haryana",
    "district": "Gurgaon",
    "block": "Tauru",
    "officename": "Tauru SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Faridabad Division"
  },
  "122107": {
    "state": "Haryana",
    "district": "Gurgaon",
    "block": "Dlf Qe",
    "officename": "Nuh SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Faridabad Division"
  },
  "122108": {
    "state": "Haryana",
    "district": "Gurgaon",
    "block": "Dlf Qe",
    "officename": "Nagina SO Gurgaon",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Faridabad Division"
  },
  "122413": {
    "state": "Haryana",
    "district": "Gurgaon",
    "block": "Bhorakalan",
    "officename": "Bhorakalan SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "122414": {
    "state": "Haryana",
    "district": "Gurgaon",
    "block": "Dlf Qe",
    "officename": "Nanukalan SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "122502": {
    "state": "Haryana",
    "district": "Gurgaon",
    "block": "Dlf Qe",
    "officename": "Khalilpur SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "122503": {
    "state": "Haryana",
    "district": "Gurgaon",
    "block": "Dlf Qe",
    "officename": "Pataudi SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "122504": {
    "state": "Haryana",
    "district": "Gurgaon",
    "block": "Haillymandi",
    "officename": "Haillymandi SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "122505": {
    "state": "Haryana",
    "district": "Gurgaon",
    "block": "Dlf Qe",
    "officename": "Garhi Harsaru SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "122506": {
    "state": "Haryana",
    "district": "Gurgaon",
    "block": "Farrukh Nagar",
    "officename": "Farrukh Nagar SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "122508": {
    "state": "Haryana",
    "district": "Gurgaon",
    "block": "Dlf Qe",
    "officename": "Punhana SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Faridabad Division"
  },
  "123001": {
    "state": "Haryana",
    "district": "Mahendragarh",
    "block": "Azamabad Mukhota",
    "officename": "Narnaul HO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhiwani Division"
  },
  "123021": {
    "state": "Haryana",
    "district": "Rewari",
    "block": "Mandi Ateli",
    "officename": "Mandi Ateli SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhiwani Division"
  },
  "123023": {
    "state": "Haryana",
    "district": "Mahendragarh",
    "block": "Akberpur",
    "officename": "Nangal Chaudhry SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhiwani Division"
  },
  "123024": {
    "state": "Haryana",
    "district": "Mahendragarh",
    "block": "Barda",
    "officename": "Satnali SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhiwani Division"
  },
  "123027": {
    "state": "Haryana",
    "district": "Mahendragarh",
    "block": "Baghot",
    "officename": "Kanina SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhiwani Division"
  },
  "123028": {
    "state": "Haryana",
    "district": "Mahendragarh",
    "block": "Bairawas",
    "officename": "Nangal Sirohi SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhiwani Division"
  },
  "123029": {
    "state": "Haryana",
    "district": "Mahendragarh",
    "block": "Akoda",
    "officename": "Mohindergarh SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhiwani Division"
  },
  "123034": {
    "state": "Haryana",
    "district": "Mahendragarh",
    "block": "Bawania",
    "officename": "Bawania SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhiwani Division"
  },
  "123035": {
    "state": "Haryana",
    "district": "Rewari",
    "block": "Rewari",
    "officename": "Palhawas SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "123101": {
    "state": "Haryana",
    "district": "Rewari",
    "block": "Basbatori",
    "officename": "Khori SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "123102": {
    "state": "Haryana",
    "district": "Rewari",
    "block": "Ahrod",
    "officename": "Kund SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "123103": {
    "state": "Haryana",
    "district": "Rewari",
    "block": "Rewari",
    "officename": "Khol SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "123106": {
    "state": "Haryana",
    "district": "Rewari",
    "block": "Bhatsana",
    "officename": "Dharuhera SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "123110": {
    "state": "Haryana",
    "district": "Rewari",
    "block": "Dharuhera",
    "officename": "Industrial Area Dharuhera SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "123301": {
    "state": "Haryana",
    "district": "Rewari",
    "block": "Guriani",
    "officename": "Guriani SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "123302": {
    "state": "Haryana",
    "district": "Rewari",
    "block": "Bhakli",
    "officename": "Kosli SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "123303": {
    "state": "Haryana",
    "district": "Mahendragarh",
    "block": "Bawwa",
    "officename": "Nahar SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "123401": {
    "state": "Haryana",
    "district": "Rewari",
    "block": "B B Ashram",
    "officename": "Rewari SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "123411": {
    "state": "Haryana",
    "district": "Rewari",
    "block": "Rewari",
    "officename": "Dahina SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "123412": {
    "state": "Haryana",
    "district": "Rewari",
    "block": "Rewari",
    "officename": "Dharan SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "123501": {
    "state": "Haryana",
    "district": "Mahendragarh",
    "block": "Bawal",
    "officename": "Bawal SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "124001": {
    "state": "Haryana",
    "district": "Rohtak",
    "block": "Rohak",
    "officename": "Rohtak HO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtak Division"
  },
  "124010": {
    "state": "Haryana",
    "district": "Rohtak",
    "block": "Rohtak",
    "officename": "Police Training Center Sunaria SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtak Division"
  },
  "124021": {
    "state": "Haryana",
    "district": "Rohtak",
    "block": "Rohtak",
    "officename": "Asthal Bohar SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtak Division"
  },
  "124022": {
    "state": "Haryana",
    "district": "Rohtak",
    "block": "Rohtak",
    "officename": "Mokhra SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtak Division"
  },
  "124102": {
    "state": "Haryana",
    "district": "Jhajjar",
    "block": "Jhajjar",
    "officename": "Dujana SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtak Division"
  },
  "124103": {
    "state": "Haryana",
    "district": "Jhajjar",
    "block": "Jhajjar",
    "officename": "Jhajjar SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtak Division"
  },
  "124104": {
    "state": "Haryana",
    "district": "Jhajjar",
    "block": "Jhajjar",
    "officename": "Nehru College Jhajjar SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtak Division"
  },
  "124105": {
    "state": "Haryana",
    "district": "Jhajjar",
    "block": "Jhajjar",
    "officename": "Badli SO Jhajjar",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtak Division"
  },
  "124106": {
    "state": "Haryana",
    "district": "Jhajjar",
    "block": "Jhajjar",
    "officename": "Matanhail SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtak Division"
  },
  "124107": {
    "state": "Haryana",
    "district": "Jhajjar",
    "block": "Jhajjar",
    "officename": "Dighal SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtak Division"
  },
  "124108": {
    "state": "Haryana",
    "district": "Jhajjar",
    "block": "Jhajjar",
    "officename": "Machrauli SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtak Division"
  },
  "124109": {
    "state": "Haryana",
    "district": "Jhajjar",
    "block": "Jhajjar",
    "officename": "Dhakla SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtak Division"
  },
  "124111": {
    "state": "Haryana",
    "district": "Rohtak",
    "block": "Rohtak",
    "officename": "Madina SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtak Division"
  },
  "124112": {
    "state": "Haryana",
    "district": "Rohtak",
    "block": "Mehem",
    "officename": "Mehem SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtak Division"
  },
  "124113": {
    "state": "Haryana",
    "district": "Rohtak",
    "block": "Rohtak",
    "officename": "Kalanaur SO Rohtak",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtak Division"
  },
  "124141": {
    "state": "Haryana",
    "district": "Rohtak",
    "block": "Rohtak",
    "officename": "Power Plant Jharli SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtak Division"
  },
  "124142": {
    "state": "Haryana",
    "district": "Jhajjar",
    "block": "Jhajjar",
    "officename": "Bahu SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtak Division"
  },
  "124146": {
    "state": "Haryana",
    "district": "Jhajjar",
    "block": "Jhajjar",
    "officename": "Sahlawas SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtak Division"
  },
  "124201": {
    "state": "Haryana",
    "district": "Jhajjar",
    "block": "Jhajjar",
    "officename": "Beri SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtak Division"
  },
  "124202": {
    "state": "Haryana",
    "district": "Jhajjar",
    "block": "Jhajjar",
    "officename": "Dubaldhan SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtak Division"
  },
  "124303": {
    "state": "Haryana",
    "district": "Rohtak",
    "block": "Rohtak",
    "officename": "Sanghi SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtak Division"
  },
  "124401": {
    "state": "Haryana",
    "district": "Rohtak",
    "block": "Rohtak",
    "officename": "Bhalaut SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtak Division"
  },
  "124404": {
    "state": "Haryana",
    "district": "Jhajjar",
    "block": "Bahadurgarh",
    "officename": "Hassangarh SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtak Division"
  },
  "124406": {
    "state": "Haryana",
    "district": "Rohtak",
    "block": "Rohtak",
    "officename": "Kansala SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtak Division"
  },
  "124411": {
    "state": "Haryana",
    "district": "Rohtak",
    "block": "Rohtak",
    "officename": "Anwal SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtak Division"
  },
  "124412": {
    "state": "Haryana",
    "district": "Rohtak",
    "block": "Rohtak",
    "officename": "Kahnaur SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtak Division"
  },
  "124501": {
    "state": "Haryana",
    "district": "Rohtak",
    "block": "Rohtak",
    "officename": "Sampla SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtak Division"
  },
  "124504": {
    "state": "Haryana",
    "district": "Jhajjar",
    "block": "Bahadurgarh",
    "officename": "Charra SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtak Division"
  },
  "124505": {
    "state": "Haryana",
    "district": "Jhajjar",
    "block": "Bahadurgarh",
    "officename": "Assaudha SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtak Division"
  },
  "124506": {
    "state": "Haryana",
    "district": "Jhajjar",
    "block": "Bahadurgarh",
    "officename": "Mandothi SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtak Division"
  },
  "124507": {
    "state": "Haryana",
    "district": "Jhajjar",
    "block": "Bahadurgarh",
    "officename": "Bahadurgarh HO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtak Division"
  },
  "124508": {
    "state": "Haryana",
    "district": "Jhajjar",
    "block": "Bahadurgarh",
    "officename": "Bahadurgarh Mandi SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtak Division"
  },
  "124513": {
    "state": "Haryana",
    "district": "Rohtak",
    "block": "Mehem",
    "officename": "Nindana SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtak Division"
  },
  "124514": {
    "state": "Haryana",
    "district": "Rohtak",
    "block": "Mehem",
    "officename": "Lakhan Majra SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtak Division"
  },
  "125001": {
    "state": "Haryana",
    "district": "Hisar",
    "block": "Hisar",
    "officename": "Hisar HO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125004": {
    "state": "Haryana",
    "district": "Hisar",
    "block": "Hisar",
    "officename": "Ha U Hisar SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125005": {
    "state": "Haryana",
    "district": "Hisar",
    "block": "Hisar",
    "officename": "Modle Town Hisar SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125006": {
    "state": "Haryana",
    "district": "Hisar",
    "block": "Hisar",
    "officename": "Hisar Cantt SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125007": {
    "state": "Haryana",
    "district": "Hisar",
    "block": "Hisar",
    "officename": "Azad Nagar Hisar SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125011": {
    "state": "Haryana",
    "district": "Hisar",
    "block": "Hisar",
    "officename": "BSF Hisar SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125033": {
    "state": "Haryana",
    "district": "Hisar",
    "block": "Hansi",
    "officename": "Hansi SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125037": {
    "state": "Haryana",
    "district": "Hisar",
    "block": "Hisar",
    "officename": "Nalwa SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125038": {
    "state": "Haryana",
    "district": "Hisar",
    "block": "Hansi",
    "officename": "Khanda Kheri SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125039": {
    "state": "Haryana",
    "district": "Hisar",
    "block": "Hansi",
    "officename": "Narnaund SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125042": {
    "state": "Haryana",
    "district": "Hisar",
    "block": "Hansi",
    "officename": "Bass SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125044": {
    "state": "Haryana",
    "district": "Hisar",
    "block": "Hisar",
    "officename": "Satroad Khurd SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125047": {
    "state": "Haryana",
    "district": "Hisar",
    "block": "Hisar",
    "officename": "Agroha SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125048": {
    "state": "Haryana",
    "district": "Fatehabad",
    "block": "Fatehabad",
    "officename": "Badopal SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125049": {
    "state": "Haryana",
    "district": "Hisar",
    "block": "Hansi",
    "officename": "Sisai SO Hisar",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125050": {
    "state": "Haryana",
    "district": "Fatehabad",
    "block": "Fatehabad",
    "officename": "Fatehabad SO Fatehabad",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125051": {
    "state": "Haryana",
    "district": "Fatehabad",
    "block": "Rattia",
    "officename": "Rattia SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125052": {
    "state": "Haryana",
    "district": "Fatehabad",
    "block": "Hisar",
    "officename": "Mandi Adampur SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125053": {
    "state": "Haryana",
    "district": "Fatehabad",
    "block": "Fatehabad",
    "officename": "Bhattu Kalan SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125054": {
    "state": "Haryana",
    "district": "Sirsa",
    "block": "Sirsa",
    "officename": "Bahaudin SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125055": {
    "state": "Haryana",
    "district": "Sirsa",
    "block": "Sirsa",
    "officename": "Sirsa HO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125056": {
    "state": "Haryana",
    "district": "Sirsa",
    "block": "Sirsa",
    "officename": "JCD Vidyapeeth Sirsa",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125058": {
    "state": "Haryana",
    "district": "Sirsa",
    "block": "Sirsa",
    "officename": "Ding SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125060": {
    "state": "Haryana",
    "district": "Sirsa",
    "block": "Sirsa",
    "officename": "Sikander Pur SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125075": {
    "state": "Haryana",
    "district": "Sirsa",
    "block": "Sirsa",
    "officename": "Siri Jiwan Nagar SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125076": {
    "state": "Haryana",
    "district": "Sirsa",
    "block": "Rania",
    "officename": "Rania SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125077": {
    "state": "Haryana",
    "district": "Sirsa",
    "block": "Odhan",
    "officename": "Odhan SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125078": {
    "state": "Haryana",
    "district": "Sirsa",
    "block": "Baragudha",
    "officename": "Baragudha SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125101": {
    "state": "Haryana",
    "district": "Sirsa",
    "block": "Sirsa",
    "officename": "Chautala SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125102": {
    "state": "Haryana",
    "district": "Sirsa",
    "block": "Sirsa",
    "officename": "Ellenabad SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125103": {
    "state": "Haryana",
    "district": "Sirsa",
    "block": "Sirsa",
    "officename": "Goriwala SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125104": {
    "state": "Haryana",
    "district": "Sirsa",
    "block": "Mandi Dabwali",
    "officename": "Mandi Dabwali SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125106": {
    "state": "Haryana",
    "district": "Fatehabad",
    "block": "Tohana",
    "officename": "Dharsul Kalan SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125110": {
    "state": "Haryana",
    "district": "Sirsa",
    "block": "Sirsa",
    "officename": "Chopta Nathu Sari SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125111": {
    "state": "Haryana",
    "district": "Fatehabad",
    "block": "Fatehabad",
    "officename": "Bhuna SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125112": {
    "state": "Haryana",
    "district": "Hisar",
    "block": "Hisar",
    "officename": "Pabra SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125113": {
    "state": "Haryana",
    "district": "Fatehabad",
    "block": "Hisar",
    "officename": "Uklana Mandi SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125120": {
    "state": "Haryana",
    "district": "Fatehabad",
    "block": "Tohana",
    "officename": "Tohana Mandi SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125121": {
    "state": "Haryana",
    "district": "Hisar",
    "block": "Hisar",
    "officename": "Barwala SO Hisar",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125133": {
    "state": "Haryana",
    "district": "Fatehabad",
    "block": "Tohana",
    "officename": "Jakhal Mandi SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "125201": {
    "state": "Haryana",
    "district": "Sirsa",
    "block": "Kalanwali",
    "officename": "Kalanwali SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hissar Division"
  },
  "126101": {
    "state": "Haryana",
    "district": "Jind",
    "block": "Jind",
    "officename": "Julana S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "126102": {
    "state": "Haryana",
    "district": "Jind",
    "block": "Jind",
    "officename": "Jind H.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "126110": {
    "state": "Haryana",
    "district": "Jind",
    "block": "Jind",
    "officename": "Dharthrath S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "126111": {
    "state": "Haryana",
    "district": "Jind",
    "block": "Jind",
    "officename": "Alewa S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "126112": {
    "state": "Haryana",
    "district": "Jind",
    "block": "Safidon",
    "officename": "Safidon S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "126113": {
    "state": "Haryana",
    "district": "Jind",
    "block": "Safidon",
    "officename": "Pillukhera S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "126114": {
    "state": "Haryana",
    "district": "Jind",
    "block": "Safidon",
    "officename": "Shamlo Kalan S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "126115": {
    "state": "Haryana",
    "district": "Jind",
    "block": "Narwana",
    "officename": "Uchana S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "126116": {
    "state": "Haryana",
    "district": "Jind",
    "block": "Narwana",
    "officename": "Narwana S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "126125": {
    "state": "Haryana",
    "district": "Jind",
    "block": "Jind",
    "officename": "Naguran S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "126152": {
    "state": "Haryana",
    "district": "Jind",
    "block": "Jind",
    "officename": "Dhanoda Kalan S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "127021": {
    "state": "Haryana",
    "district": "Bhiwani",
    "block": "Bhiwani",
    "officename": "Bhiwani HO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhiwani Division"
  },
  "127022": {
    "state": "Haryana",
    "district": "Bhiwani",
    "block": "Dadari",
    "officename": "Chiriya SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhiwani Division"
  },
  "127025": {
    "state": "Haryana",
    "district": "Bhiwani",
    "block": "Dadri",
    "officename": "Baund SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhiwani Division"
  },
  "127026": {
    "state": "Haryana",
    "district": "Bhiwani",
    "block": "Dadri",
    "officename": "Birhi Kalan SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhiwani Division"
  },
  "127027": {
    "state": "Haryana",
    "district": "Bhiwani",
    "block": "Bhiwani",
    "officename": "Chang SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhiwani Division"
  },
  "127028": {
    "state": "Haryana",
    "district": "Bhiwani",
    "block": "Siwani",
    "officename": "Behl SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhiwani Division"
  },
  "127029": {
    "state": "Haryana",
    "district": "Bhiwani",
    "block": "Bhiwani",
    "officename": "Kairu SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhiwani Division"
  },
  "127030": {
    "state": "Haryana",
    "district": "Bhiwani",
    "block": "Biwani",
    "officename": "Jui Khurd SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhiwani Division"
  },
  "127031": {
    "state": "Haryana",
    "district": "Bhiwani",
    "block": "Bhiwani",
    "officename": "Tigrana SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhiwani Division"
  },
  "127032": {
    "state": "Haryana",
    "district": "Bhiwani",
    "block": "Bhiwani",
    "officename": "Bawani Khera SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhiwani Division"
  },
  "127035": {
    "state": "Haryana",
    "district": "Bhiwani",
    "block": "Bhiwani",
    "officename": "Jamalpur SO Bhiwani",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhiwani Division"
  },
  "127040": {
    "state": "Haryana",
    "district": "Bhiwani",
    "block": "Bhiwani",
    "officename": "Tosham SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhiwani Division"
  },
  "127041": {
    "state": "Haryana",
    "district": "Bhiwani",
    "block": "Bhiwani",
    "officename": "Mundhal Khurd SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhiwani Division"
  },
  "127042": {
    "state": "Haryana",
    "district": "Bhiwani",
    "block": "Charkhi Dadri",
    "officename": "Sanwar SO Bhiwani",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhiwani Division"
  },
  "127043": {
    "state": "Haryana",
    "district": "Bhiwani",
    "block": "Bhiwani",
    "officename": "Rodhan SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhiwani Division"
  },
  "127045": {
    "state": "Haryana",
    "district": "Bhiwani",
    "block": "Siwani",
    "officename": "Barwa SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhiwani Division"
  },
  "127046": {
    "state": "Haryana",
    "district": "Bhiwani",
    "block": "Siwani",
    "officename": "Siwani SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhiwani Division"
  },
  "127111": {
    "state": "Haryana",
    "district": "Bhiwani",
    "block": "Bhiwani",
    "officename": "Bapora SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhiwani Division"
  },
  "127114": {
    "state": "Haryana",
    "district": "Bhiwani",
    "block": "Bhiwani",
    "officename": "Kharak Kalan SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhiwani Division"
  },
  "127201": {
    "state": "Haryana",
    "district": "Bhiwani",
    "block": "Loharu",
    "officename": "Loharu SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhiwani Division"
  },
  "127306": {
    "state": "Haryana",
    "district": "Bhiwani",
    "block": "Charkhi Dadri",
    "officename": "Charkhi  Dadri Hsgii SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhiwani Division"
  },
  "127307": {
    "state": "Haryana",
    "district": "Bhiwani",
    "block": "Achina",
    "officename": "Achina SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhiwani Division"
  },
  "127308": {
    "state": "Haryana",
    "district": "Bhiwani",
    "block": "Dadri",
    "officename": "Badhara SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhiwani Division"
  },
  "127309": {
    "state": "Haryana",
    "district": "Bhiwani",
    "block": "Bhiwani",
    "officename": "Manheru SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhiwani Division"
  },
  "127310": {
    "state": "Haryana",
    "district": "Bhiwani",
    "block": "Dadri",
    "officename": "Jhojhu SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhiwani Division"
  },
  "131001": {
    "state": "Haryana",
    "district": "Sonipat",
    "block": "Sonipat",
    "officename": "Sonipat HO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sonepat Division"
  },
  "131021": {
    "state": "Haryana",
    "district": "Sonipat",
    "block": "Sonipat",
    "officename": "Bahalgarh SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sonepat Division"
  },
  "131022": {
    "state": "Haryana",
    "district": "Sonipat",
    "block": "Ganaur",
    "officename": "Bhatgaon SO Sonipat",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sonepat Division"
  },
  "131023": {
    "state": "Haryana",
    "district": "Sonipat",
    "block": "Ganaur",
    "officename": "Jakhauli SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sonepat Division"
  },
  "131024": {
    "state": "Haryana",
    "district": "Sonipat",
    "block": "Ganaur",
    "officename": "Juan SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sonepat Division"
  },
  "131027": {
    "state": "Haryana",
    "district": "Sonipat",
    "block": "Sonipat",
    "officename": "Murthal SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sonepat Division"
  },
  "131028": {
    "state": "Haryana",
    "district": "Sonipat",
    "block": "Sonipat",
    "officename": "Industrial Estate Kundli SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sonepat Division"
  },
  "131029": {
    "state": "Haryana",
    "district": "Sonipat",
    "block": "Ganaur",
    "officename": "PSRai SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sonepat Division"
  },
  "131039": {
    "state": "Haryana",
    "district": "Sonipat",
    "block": "Ganaur",
    "officename": "Engg College Muthal SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sonepat Division"
  },
  "131101": {
    "state": "Haryana",
    "district": "Sonipat",
    "block": "Ganaur",
    "officename": "Ganaur SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sonepat Division"
  },
  "131102": {
    "state": "Haryana",
    "district": "Sonipat",
    "block": "Ganaur",
    "officename": "Purkhas SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sonepat Division"
  },
  "131103": {
    "state": "Haryana",
    "district": "Sonipat",
    "block": "Ganaur",
    "officename": "Nahri SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sonepat Division"
  },
  "131301": {
    "state": "Haryana",
    "district": "Sonipat",
    "block": "Ganaur",
    "officename": "Gohana SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sonepat Division"
  },
  "131302": {
    "state": "Haryana",
    "district": "Sonipat",
    "block": "Ganaur",
    "officename": "Butana SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sonepat Division"
  },
  "131304": {
    "state": "Haryana",
    "district": "Sonipat",
    "block": "Ganaur",
    "officename": "Baroda SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sonepat Division"
  },
  "131305": {
    "state": "Haryana",
    "district": "Sonipat",
    "block": "Ganaur",
    "officename": "Kanyagurukul Khanpur SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sonepat Division"
  },
  "131306": {
    "state": "Haryana",
    "district": "Sonipat",
    "block": "Ganaur",
    "officename": "Mundlana SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sonepat Division"
  },
  "131402": {
    "state": "Haryana",
    "district": "Sonipat",
    "block": "Ganaur",
    "officename": "Kharkhauda SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sonepat Division"
  },
  "131403": {
    "state": "Haryana",
    "district": "Sonipat",
    "block": "Sonipat",
    "officename": "Rohat SO Sonipat",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sonepat Division"
  },
  "131408": {
    "state": "Haryana",
    "district": "Sonipat",
    "block": "Ganaur",
    "officename": "Farmana SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sonepat Division"
  },
  "131409": {
    "state": "Haryana",
    "district": "Sonipat",
    "block": "Ganaur",
    "officename": "Bhainswal Kalan SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sonepat Division"
  },
  "132001": {
    "state": "Haryana",
    "district": "Karnal",
    "block": "Karnal",
    "officename": "Karnal H.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "132022": {
    "state": "Haryana",
    "district": "Karnal",
    "block": "Kunjpura",
    "officename": "Kunjpura S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "132023": {
    "state": "Haryana",
    "district": "Karnal",
    "block": "S.s. Kunjpura",
    "officename": "S.S. Kunjpura S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "132024": {
    "state": "Haryana",
    "district": "Karnal",
    "block": "Nissing",
    "officename": "Nissing S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "132036": {
    "state": "Haryana",
    "district": "Karnal",
    "block": "Jundla",
    "officename": "Jundla S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "132037": {
    "state": "Haryana",
    "district": "Karnal",
    "block": "Karnal",
    "officename": "Madhuban S.O (Karnal)",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "132039": {
    "state": "Haryana",
    "district": "Karnal",
    "block": "Assandh",
    "officename": "Assandh S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "132040": {
    "state": "Haryana",
    "district": "Karnal",
    "block": "Assandh",
    "officename": "Ballah S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "132041": {
    "state": "Haryana",
    "district": "Karnal",
    "block": "Indri",
    "officename": "Indri S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "132046": {
    "state": "Haryana",
    "district": "Karnal",
    "block": "Assandh",
    "officename": "Salwan S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "132054": {
    "state": "Haryana",
    "district": "Karnal",
    "block": "Indri",
    "officename": "Garhi Birbal S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "132101": {
    "state": "Haryana",
    "district": "Panipat",
    "block": "Panipat",
    "officename": "Samalkha S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "132102": {
    "state": "Haryana",
    "district": "Panipat",
    "block": "Panipat",
    "officename": "Patti Kalyana S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "132103": {
    "state": "Haryana",
    "district": "Panipat",
    "block": "Panipat",
    "officename": "Panipat H.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "132104": {
    "state": "Haryana",
    "district": "Panipat",
    "block": "Panipat",
    "officename": "Panipat Khadi Ashram S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "132105": {
    "state": "Haryana",
    "district": "Panipat",
    "block": "Panipat",
    "officename": "Panipat Thermal Project S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "132106": {
    "state": "Haryana",
    "district": "Panipat",
    "block": "Panipat",
    "officename": "Panipat NFL S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "132107": {
    "state": "Haryana",
    "district": "Panipat",
    "block": "Panipat",
    "officename": "Israna S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "132108": {
    "state": "Haryana",
    "district": "Panipat",
    "block": "Panipat",
    "officename": "Panipat Beas Project S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "132113": {
    "state": "Haryana",
    "district": "Panipat",
    "block": "Panipat",
    "officename": "Madlauda S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "132114": {
    "state": "Haryana",
    "district": "Karnal",
    "block": "Gharunda",
    "officename": "Gharunda S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "132115": {
    "state": "Haryana",
    "district": "Panipat",
    "block": "Panipat",
    "officename": "Hathwala S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "132116": {
    "state": "Haryana",
    "district": "Karnal",
    "block": "Nilokheri",
    "officename": "Taraori S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "132117": {
    "state": "Haryana",
    "district": "Karnal",
    "block": "Nilokheri",
    "officename": "Nilokheri S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "132122": {
    "state": "Haryana",
    "district": "Panipat",
    "block": "Panipat",
    "officename": "Atta S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "132140": {
    "state": "Haryana",
    "district": "Panipat",
    "block": "Panipat",
    "officename": "Panipat Refinary S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "132145": {
    "state": "Haryana",
    "district": "Panipat",
    "block": "Panipat",
    "officename": "Neoltha S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "132157": {
    "state": "Haryana",
    "district": "Karnal",
    "block": "Nigdhu",
    "officename": "Nigdhu S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Karnal Division"
  },
  "133001": {
    "state": "Haryana",
    "district": "Ambala",
    "block": "Ambala",
    "officename": "Ambala G.P.O.",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "133004": {
    "state": "Haryana",
    "district": "Ambala",
    "block": "Ambala",
    "officename": "Kuldeep Nagar S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "133005": {
    "state": "Haryana",
    "district": "Ambala",
    "block": "Ambala",
    "officename": "Babyal S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "133006": {
    "state": "Haryana",
    "district": "Ambala",
    "block": "Ambala",
    "officename": "Ind estate S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "133101": {
    "state": "Haryana",
    "district": "Ambala",
    "block": "Ambala",
    "officename": "Bihta S.O (Ambala)",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "133102": {
    "state": "Haryana",
    "district": "Ambala",
    "block": "Ambala",
    "officename": "Kesri S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "133103": {
    "state": "Haryana",
    "district": "Yamuna Nagar",
    "block": "Ambala",
    "officename": "Saraswati Nagar S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "133104": {
    "state": "Haryana",
    "district": "Ambala",
    "block": "Ambala",
    "officename": "Saha S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "133201": {
    "state": "Haryana",
    "district": "Ambala",
    "block": "Ambala",
    "officename": "Barara S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "133202": {
    "state": "Haryana",
    "district": "Ambala",
    "block": "Barara",
    "officename": "Dhin S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "133203": {
    "state": "Haryana",
    "district": "Ambala",
    "block": "Barara",
    "officename": "Mullana S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "133204": {
    "state": "Haryana",
    "district": "Yamuna Nagar",
    "block": "Ambala",
    "officename": "Sadhaura S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "133205": {
    "state": "Haryana",
    "district": "Ambala",
    "block": "Barara",
    "officename": "Adhoya S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "133206": {
    "state": "Haryana",
    "district": "Yamuna Nagar",
    "block": "Ambala",
    "officename": "Sarawan S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "133207": {
    "state": "Haryana",
    "district": "Ambala",
    "block": "Barara",
    "officename": "M.M.E.Complex Mulana S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "133301": {
    "state": "Haryana",
    "district": "Panchkula",
    "block": "Kalka",
    "officename": "B.C.W. Suraj Pur S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "133302": {
    "state": "Haryana",
    "district": "Panchkula",
    "block": "Kalka",
    "officename": "Kalka S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "134003": {
    "state": "Haryana",
    "district": "Ambala",
    "block": "Ambala",
    "officename": "Ambala City H.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "134005": {
    "state": "Haryana",
    "district": "Ambala",
    "block": "Ambala city",
    "officename": "Jandli S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "134007": {
    "state": "Haryana",
    "district": "Ambala",
    "block": "Ambala",
    "officename": "Baldev Nagar S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "134101": {
    "state": "Haryana",
    "district": "Panchkula",
    "block": "Kalka",
    "officename": "H.M.T.Pinjore S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "134102": {
    "state": "Haryana",
    "district": "Panchkula",
    "block": "Panchkula",
    "officename": "Pinjore S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "134103": {
    "state": "Haryana",
    "district": "Panchkula",
    "block": "Panchkula",
    "officename": "I.T.B.P.  Bhanu S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "134104": {
    "state": "Haryana",
    "district": "Panchkula",
    "block": "Kalka",
    "officename": "C.R.P.F. Pinjore S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "134107": {
    "state": "Haryana",
    "district": "Panchkula",
    "block": "Panchkula",
    "officename": "Chandi Mandir Cantt S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "134108": {
    "state": "Haryana",
    "district": "Panchkula",
    "block": "Panchkula",
    "officename": "G.K. Panchkula S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "134109": {
    "state": "Haryana",
    "district": "Panchkula",
    "block": "Panchkula",
    "officename": "Panchkula Sector 8 S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "134112": {
    "state": "Haryana",
    "district": "Panchkula",
    "block": "Panchkula",
    "officename": "Panchkula Sector 4 S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "134113": {
    "state": "Haryana",
    "district": "Panchkula",
    "block": "Panchkula",
    "officename": "Sector 15 Panchkula S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "134114": {
    "state": "Haryana",
    "district": "Panchkula",
    "block": "Panchkula",
    "officename": "Mansa  Devi Sec 5 S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "134116": {
    "state": "Haryana",
    "district": "Panchkula",
    "block": "Panchkula",
    "officename": "Sector 26 Panchkula S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "134117": {
    "state": "Haryana",
    "district": "Panchkula",
    "block": "Panchkula",
    "officename": "Sector 20 Panchkula S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "134118": {
    "state": "Haryana",
    "district": "Panchkula",
    "block": "Ambala City Ho",
    "officename": "Barwala S.O (Panchkula)",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "134201": {
    "state": "Haryana",
    "district": "Ambala",
    "block": "Naraingarh",
    "officename": "Jatwar S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "134202": {
    "state": "Haryana",
    "district": "Panchkula",
    "block": "Panchkula",
    "officename": "Shahzadpur S.O.",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "134203": {
    "state": "Haryana",
    "district": "Ambala",
    "block": "Panchkula",
    "officename": "Naraingarh S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "134204": {
    "state": "Haryana",
    "district": "Panchkula",
    "block": "Panchkula",
    "officename": "Raipur Rani S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "134205": {
    "state": "Haryana",
    "district": "Panchkula",
    "block": "Panchkula",
    "officename": "Morni S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "135001": {
    "state": "Haryana",
    "district": "Yamuna Nagar",
    "block": "Jagadhri",
    "officename": "Yamunanagar H.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "135002": {
    "state": "Haryana",
    "district": "Yamuna Nagar",
    "block": "Ambala",
    "officename": "Jagdhari Work Shop S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "135003": {
    "state": "Haryana",
    "district": "Yamuna Nagar",
    "block": "Ambala",
    "officename": "Jagadhri S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "135004": {
    "state": "Haryana",
    "district": "Yamuna Nagar",
    "block": "Ambala",
    "officename": "Thermal Colony Yamuna Nagar S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "135021": {
    "state": "Haryana",
    "district": "Yamuna Nagar",
    "block": "Ambala",
    "officename": "Partap Nagar S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "135101": {
    "state": "Haryana",
    "district": "Yamuna Nagar",
    "block": "Ambala",
    "officename": "Buriya S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "135102": {
    "state": "Haryana",
    "district": "Yamuna Nagar",
    "block": "Jagadhri",
    "officename": "Bilaspur (Yamunanagar) S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "135103": {
    "state": "Haryana",
    "district": "Yamuna Nagar",
    "block": "Ambala",
    "officename": "Chhachrauli S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "135106": {
    "state": "Haryana",
    "district": "Yamuna Nagar",
    "block": "Yamuna Nagar",
    "officename": "Bhudkalan S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "135133": {
    "state": "Haryana",
    "district": "Yamuna Nagar",
    "block": "Ambala",
    "officename": "Radaur S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "136020": {
    "state": "Haryana",
    "district": "Kaithal",
    "block": "Pundri",
    "officename": "Dhand S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Kurukshetra Division"
  },
  "136021": {
    "state": "Haryana",
    "district": "Kaithal",
    "block": "Pundri",
    "officename": "Kaul S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Kurukshetra Division"
  },
  "136026": {
    "state": "Haryana",
    "district": "Kaithal",
    "block": "Pundri",
    "officename": "Pundri S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Kurukshetra Division"
  },
  "136027": {
    "state": "Haryana",
    "district": "Kaithal",
    "block": "Kaithal",
    "officename": "Kaithal S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Kurukshetra Division"
  },
  "136030": {
    "state": "Haryana",
    "district": "Kurukshetra",
    "block": "Pehowa",
    "officename": "Gumthala Garhu S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Kurukshetra Division"
  },
  "136033": {
    "state": "Haryana",
    "district": "Kaithal",
    "block": "Kaithal",
    "officename": "Siwan S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Kurukshetra Division"
  },
  "136034": {
    "state": "Haryana",
    "district": "Kaithal",
    "block": "Guhla",
    "officename": "Chika S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Kurukshetra Division"
  },
  "136035": {
    "state": "Haryana",
    "district": "Kaithal",
    "block": "Guhla",
    "officename": "Guhla S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Kurukshetra Division"
  },
  "136038": {
    "state": "Haryana",
    "district": "Kurukshetra",
    "block": "Thanesar",
    "officename": "Amin S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Kurukshetra Division"
  },
  "136042": {
    "state": "Haryana",
    "district": "Kaithal",
    "block": "Pundri",
    "officename": "Fatehpur S.O (Kaithal)",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Kurukshetra Division"
  },
  "136043": {
    "state": "Haryana",
    "district": "Kaithal",
    "block": "Pundri",
    "officename": "Pai S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Kurukshetra Division"
  },
  "136044": {
    "state": "Haryana",
    "district": "Kaithal",
    "block": "Rajaund",
    "officename": "Rajound S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Kurukshetra Division"
  },
  "136117": {
    "state": "Haryana",
    "district": "Kaithal",
    "block": "Kalayat",
    "officename": "Kalayat S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Kurukshetra Division"
  },
  "136118": {
    "state": "Haryana",
    "district": "Kurukshetra",
    "block": "Thanesar",
    "officename": "Kurukshetra H.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Kurukshetra Division"
  },
  "136119": {
    "state": "Haryana",
    "district": "Kurukshetra",
    "block": "Thanesar",
    "officename": "Kurukshetra University S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Kurukshetra Division"
  },
  "136128": {
    "state": "Haryana",
    "district": "Kurukshetra",
    "block": "Pehowa",
    "officename": "Pehowa S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Kurukshetra Division"
  },
  "136129": {
    "state": "Haryana",
    "district": "Kurukshetra",
    "block": "Pehowa",
    "officename": "Ismailabad S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Kurukshetra Division"
  },
  "136130": {
    "state": "Haryana",
    "district": "Kurukshetra",
    "block": "Shahbad",
    "officename": "Jhansa S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Kurukshetra Division"
  },
  "136131": {
    "state": "Haryana",
    "district": "Kurukshetra",
    "block": "Thanesar",
    "officename": "Pipli S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Kurukshetra Division"
  },
  "136132": {
    "state": "Haryana",
    "district": "Kurukshetra",
    "block": "Ladwa",
    "officename": "Ladwa S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Kurukshetra Division"
  },
  "136135": {
    "state": "Haryana",
    "district": "Kurukshetra",
    "block": "Shahbad\\",
    "officename": "Shahabad(M) S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Kurukshetra Division"
  },
  "136136": {
    "state": "Haryana",
    "district": "Kurukshetra",
    "block": "Shahbad",
    "officename": "Thol S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Kurukshetra Division"
  },
  "136156": {
    "state": "Haryana",
    "district": "Kurukshetra",
    "block": "Babain",
    "officename": "Babain S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Kurukshetra Division"
  },
  "140001": {
    "state": "Punjab",
    "district": "Rupnagar",
    "block": "Rupnagar",
    "officename": "Ropar HO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "140101": {
    "state": "Punjab",
    "district": "Rupnagar",
    "block": "Rupnagar",
    "officename": "Morinda SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "140102": {
    "state": "Punjab",
    "district": "Ropar",
    "block": "Ropar",
    "officename": "Lutheri SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "140103": {
    "state": "Punjab",
    "district": "Mohali",
    "block": "Rupnagar",
    "officename": "Kurali SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "140108": {
    "state": "Punjab",
    "district": "Rupnagar",
    "block": "Rupnagar",
    "officename": "Mian Pur SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "140109": {
    "state": "Punjab",
    "district": "Mohali",
    "block": "Khizrabad West",
    "officename": "Khizrabad West SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "140110": {
    "state": "Punjab",
    "district": "Mohali",
    "block": "Ropar",
    "officename": "Sialba Majri SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "140111": {
    "state": "Punjab",
    "district": "Rupnagar",
    "block": "Bela",
    "officename": "Bela SO Rupnagar",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "140112": {
    "state": "Punjab",
    "district": "Mohali",
    "block": "Ropar",
    "officename": "Chamkaur Sahib SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "140113": {
    "state": "Punjab",
    "district": "Rupnagar",
    "block": "Rupnagar",
    "officename": "Ghanauli SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "140114": {
    "state": "Punjab",
    "district": "Rupnagar",
    "block": "Bharatgarh",
    "officename": "Bharatgarh SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "140115": {
    "state": "Punjab",
    "district": "Ropar",
    "block": "Kiratpur Sahib",
    "officename": "Kiratpur Sahib SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "140116": {
    "state": "Punjab",
    "district": "Rupnagar",
    "block": "Anandpur Sahib",
    "officename": "Kotla Power House SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "140117": {
    "state": "Punjab",
    "district": "Rupnagar",
    "block": "Anandpur Sahib",
    "officename": "Nurpur Bedi SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "140118": {
    "state": "Punjab",
    "district": "Ropar",
    "block": "Ropar",
    "officename": "Anand Pur Sahib SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "140119": {
    "state": "Chandigarh",
    "district": "Chandigarh",
    "block": "Ropar",
    "officename": "Takhatgarh SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "140123": {
    "state": "Punjab",
    "district": "Rupnagar",
    "block": "Anandpur Sahib",
    "officename": "Ganugwal SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "140124": {
    "state": "Punjab",
    "district": "Rupnagar",
    "block": "Anandpur Sahib",
    "officename": "Nangal Township SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "140125": {
    "state": "Chandigarh",
    "district": "Chandigarh",
    "block": "Ropar",
    "officename": "Pratap Nagar Nangal SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "140126": {
    "state": "Punjab",
    "district": "Ropar",
    "block": "Ropar",
    "officename": "Fertilizer Factory Nangal SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "140133": {
    "state": "Punjab",
    "district": "Ropar",
    "block": "Bhanupali",
    "officename": "Bhanupali SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "140201": {
    "state": "Punjab",
    "district": "Patiala",
    "block": "Dera Bassi",
    "officename": "Mubarakpur SO Patiala",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "140301": {
    "state": "Punjab",
    "district": "Rupnagar",
    "block": "Ropar",
    "officename": "Kharar SO Rupnagar",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "140306": {
    "state": "Punjab",
    "district": "Rupnagar",
    "block": "S.A.S.Nagar (Mohali)",
    "officename": "Aerocity S.O",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "140307": {
    "state": "Punjab",
    "district": "Rupnagar",
    "block": "S.A.S.Nagar (Mohali)",
    "officename": "Landran SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "140308": {
    "state": "Punjab",
    "district": "Rupnagar",
    "block": "Ropar",
    "officename": "Sohana SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "140401": {
    "state": "Punjab",
    "district": "Patiala",
    "block": "Rajpura",
    "officename": "Rajpura HO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patiala Division"
  },
  "140402": {
    "state": "Punjab",
    "district": "Patiala",
    "block": "Rajpura",
    "officename": "Rajpura Township SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patiala Division"
  },
  "140405": {
    "state": "Punjab",
    "district": "Fatehgarh Sahib",
    "block": "Rajpura",
    "officename": "Sangatpur Sodhian SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patiala Division"
  },
  "140406": {
    "state": "Punjab",
    "district": "Fatehgarh Sahib",
    "block": "Sirhind",
    "officename": "Sirhind SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patiala Division"
  },
  "140407": {
    "state": "Punjab",
    "district": "Fatehgarh Sahib",
    "block": "Fatehgarh Sahib",
    "officename": "Fatehgarh Sahib SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patiala Division"
  },
  "140412": {
    "state": "Punjab",
    "district": "Fatehgarh Sahib",
    "block": "Bassi",
    "officename": "Bassi SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patiala Division"
  },
  "140413": {
    "state": "Punjab",
    "district": "Mohali",
    "block": "Ropar",
    "officename": "Gharuan SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "140417": {
    "state": "Punjab",
    "district": "Patiala",
    "block": "Rajpura",
    "officename": "Shambhu SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patiala Division"
  },
  "140501": {
    "state": "Punjab",
    "district": "Mohali",
    "block": "Derabassi",
    "officename": "Lalru SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "140506": {
    "state": "Punjab",
    "district": "Patiala",
    "block": "Dera Bassi",
    "officename": "Dappar Ad SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "140507": {
    "state": "Punjab",
    "district": "Mohali",
    "block": "Derabassi",
    "officename": "Derabassi SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "140601": {
    "state": "Punjab",
    "district": "Patiala",
    "block": "Rajpura",
    "officename": "Banur SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patiala Division"
  },
  "140602": {
    "state": "Punjab",
    "district": "Patiala",
    "block": "Derabassi",
    "officename": "Manakpur SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patiala Division"
  },
  "140603": {
    "state": "Punjab",
    "district": "Patiala",
    "block": "Rajpura",
    "officename": "Zirakpur SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "140604": {
    "state": "Punjab",
    "district": "Mohali",
    "block": "Dera Bassi",
    "officename": "Baltana SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "140701": {
    "state": "Punjab",
    "district": "Patiala",
    "block": "Rajpura",
    "officename": "Kauli SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patiala Division"
  },
  "140702": {
    "state": "Punjab",
    "district": "Patiala",
    "block": "Patiala",
    "officename": "Ghanaur SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patiala Division"
  },
  "140802": {
    "state": "Punjab",
    "district": "Patiala",
    "block": "Payal",
    "officename": "Sanghol SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patiala Division"
  },
  "140901": {
    "state": "Punjab",
    "district": "Mohali",
    "block": "Ropar",
    "officename": "Mullanpur SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "141001": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Ludhiana HO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana City Division"
  },
  "141002": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Model Town Ludhiana SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana City Division"
  },
  "141003": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Millerganj SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana City Division"
  },
  "141004": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "PAU SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana City Division"
  },
  "141006": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Gne College SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana City Division"
  },
  "141007": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Basti Jodhewal SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana City Division"
  },
  "141008": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Central Post Office SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana City Division"
  },
  "141010": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Focal Point SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana City Division"
  },
  "141012": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Rajguru Nagar SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana City Division"
  },
  "141013": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Basant Avenue SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana City Division"
  },
  "141014": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Dhandari Kalan SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana City Division"
  },
  "141015": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Mundian Kalan SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana City Division"
  },
  "141016": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Lohora SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana City Division"
  },
  "141101": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana (West)",
    "officename": "Dakha Mandi SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141102": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Dakha SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141103": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Khanna",
    "officename": "Mohie SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141104": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "KCG Sudhar SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141105": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Raikot",
    "officename": "Sarabha SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141106": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana (East)",
    "officename": "Halwara Aerodrome SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141107": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Halwara SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141108": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Pakhowal SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141109": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Raekot SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141110": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Hambran SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141112": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Kohara SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141113": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Katani Kalan SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141114": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Samrala SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141115": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Machhiwara SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141116": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Gill SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141117": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Payal",
    "officename": "Sihar SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141118": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Dehlon SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141119": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Maloudh SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141120": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Sanehwal SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141121": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Behlolpur SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141122": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Jaspal Banger SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141123": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana (East)",
    "officename": "Ramgarh SO Ludhiana",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141125": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Kakrala Kalan SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141126": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Sri Bhaini Sahib SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141127": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana (East)",
    "officename": "Koom Kalan SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141201": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Kila Raipur SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141202": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Gujjarwal SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141203": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana (East)",
    "officename": "Narangwal SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141204": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Ghungrana SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141205": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Latala SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141206": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana (East)",
    "officename": "Ghawaddi SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141401": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Khanna",
    "officename": "Khanna HO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141411": {
    "state": "Punjab",
    "district": "Patiala",
    "block": "Khamanoo",
    "officename": "Bhari SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patiala Division"
  },
  "141412": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Daheru SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141413": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Dhamote SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141414": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Issru SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141415": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Jarg SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141416": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Payal SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141417": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Rahawan SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141418": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Rampur SO Ludhiana",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141419": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Ghudani Kalan SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141421": {
    "state": "Punjab",
    "district": "Fatehgarh Sahib",
    "block": "Khamanon",
    "officename": "Doraha SO Ludhiana",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141422": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Jagraon",
    "officename": "Raqba BO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "141801": {
    "state": "Punjab",
    "district": "Fatehgarh Sahib",
    "block": "Khamanon",
    "officename": "Khamano Kalan SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patiala Division"
  },
  "142001": {
    "state": "Punjab",
    "district": "Moga",
    "block": "Moga",
    "officename": "Moga HO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "142002": {
    "state": "Punjab",
    "district": "Moga",
    "block": "Moga",
    "officename": "Purana Moga SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "142003": {
    "state": "Punjab",
    "district": "Moga",
    "block": "Moga",
    "officename": "Moga Kty SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "142011": {
    "state": "Punjab",
    "district": "Moga",
    "block": "Moga",
    "officename": "Dala SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "142021": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Baddowal SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "142022": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Lalton Kalan SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "142023": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Mann SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "142024": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Sidhwan Khurd SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "142025": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Sowaddi SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "142026": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Jagraon",
    "officename": "Jagraon HO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "142027": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana (West)",
    "officename": "Ayali Kalan SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "142029": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Jodhan SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "142030": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Jagraon",
    "officename": "Kamalpura SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "142031": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Hathur SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "142032": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Bassian SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "142033": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Sidhwan Bet SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "142034": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Jagraon",
    "officename": "Manuke SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "142035": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Mallah SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "142036": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana",
    "officename": "Galib Kalan SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana Moffusil Division"
  },
  "142037": {
    "state": "Punjab",
    "district": "Moga",
    "block": "Nihal Singh Wala",
    "officename": "Badhni Kalan SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "142038": {
    "state": "Punjab",
    "district": "Moga",
    "block": "Bhagha Purana",
    "officename": "Baghapurana SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "142039": {
    "state": "Punjab",
    "district": "Moga",
    "block": "Nihal Singhwala",
    "officename": "Bilaspur Moga SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "142040": {
    "state": "Punjab",
    "district": "Moga",
    "block": "Nihal Singh Wala",
    "officename": "Butter SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "142041": {
    "state": "Punjab",
    "district": "Firozpur",
    "block": "Moga",
    "officename": "Bhinder SO Firozpur",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Ferozpur Division"
  },
  "142042": {
    "state": "Punjab",
    "district": "Moga",
    "block": "Dharamkot",
    "officename": "Dharamkot SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Ferozpur Division"
  },
  "142043": {
    "state": "Punjab",
    "district": "Moga",
    "block": "Moga",
    "officename": "Kot Ise Khan SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Ferozpur Division"
  },
  "142044": {
    "state": "Punjab",
    "district": "Firozpur",
    "block": "Zira",
    "officename": "Makhu SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Ferozpur Division"
  },
  "142045": {
    "state": "Punjab",
    "district": "Moga",
    "block": "Baghapurana",
    "officename": "Manoke SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "142046": {
    "state": "Punjab",
    "district": "Moga",
    "block": "Nihal Singh Wala",
    "officename": "Patto Hira Singh SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "142047": {
    "state": "Punjab",
    "district": "Firozpur",
    "block": "Zira",
    "officename": "Zira SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Ferozpur Division"
  },
  "142048": {
    "state": "Punjab",
    "district": "Moga",
    "block": "Moga",
    "officename": "Ghall Kalan SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "142049": {
    "state": "Punjab",
    "district": "Moga",
    "block": "Bhagha Purana",
    "officename": "Smalsar S.O",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "142050": {
    "state": "Punjab",
    "district": "Firozpur",
    "block": "Zira",
    "officename": "Talwandi Bhai SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Ferozpur Division"
  },
  "142052": {
    "state": "Punjab",
    "district": "Firozpur",
    "block": "Firozepur",
    "officename": "Ferozeshah SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Ferozpur Division"
  },
  "142053": {
    "state": "Punjab",
    "district": "Moga",
    "block": "Moga",
    "officename": "Dhudike SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "142054": {
    "state": "Punjab",
    "district": "Moga",
    "block": "Moga",
    "officename": "Kokri Kalan SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "142055": {
    "state": "Punjab",
    "district": "Moga",
    "block": "Nihal Singh Wala",
    "officename": "Nihal Singh Wala SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "142056": {
    "state": "Punjab",
    "district": "Moga",
    "block": "Baghapurana",
    "officename": "Gholia Khurd SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "142057": {
    "state": "Punjab",
    "district": "Moga",
    "block": "Baghapurana",
    "officename": "Samadh Bhai SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "142058": {
    "state": "Punjab",
    "district": "Moga",
    "block": "Moga",
    "officename": "Kishanpura SO Moga",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Ferozpur Division"
  },
  "142060": {
    "state": "Punjab",
    "district": "Firozpur",
    "block": "Ferozpeur",
    "officename": "Mudki SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Ferozpur Division"
  },
  "143001": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Amritsar",
    "officename": "Amritsar GPO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143002": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Amritsar -I",
    "officename": "Khalsa College SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143005": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Amritsar -I",
    "officename": "Guru Nanak Dev University SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143006": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Amritsar -I",
    "officename": "Gandhi Bazar SO Amritsar",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143008": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Amritsar -I",
    "officename": "Sjs Avenue SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143009": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Amritsar -I",
    "officename": "Fatahpur SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143022": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Kot Mit Singh",
    "officename": "Kot Mit Singh SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143101": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Amritsar -I",
    "officename": "Raja Sansi SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143102": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Amritsar -I",
    "officename": "Ajnala SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143103": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Amritsar",
    "officename": "Chamiari SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143105": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Amritsar -I",
    "officename": "Chheharta SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143107": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Amritsar- II",
    "officename": "Distillery Khasa SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143108": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Amritsar- II",
    "officename": "Attari SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143109": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Amritsar -I",
    "officename": "Chogawan SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143111": {
    "state": "Punjab",
    "district": "Tarn Taran",
    "block": "Khilchian",
    "officename": "Khilchian SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143112": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Amritsar -I",
    "officename": "Rayya SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143113": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Amritsar",
    "officename": "Fatehpur Rajputan SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143114": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Amritsar -I",
    "officename": "Mehta Chowk SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143115": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Jandiala",
    "officename": "Jandiala Guru SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143116": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Amritsar -I",
    "officename": "Tarsika SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143117": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Amritsar -I",
    "officename": "Khadoor Sahib SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143118": {
    "state": "Punjab",
    "district": "Tarn Taran",
    "block": "TARN-TARAN",
    "officename": "Vairowal SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143119": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Amritsar -I",
    "officename": "Mattewal SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143149": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Amritsar -I",
    "officename": "Jandiala RS SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143201": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Baba Bakala",
    "officename": "Beas SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143202": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Amritsar -I",
    "officename": "Baba Bakala SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143203": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Baba Bakala",
    "officename": "Butala SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143204": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Amritsar -I",
    "officename": "DBJSingh SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143205": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Sathiala",
    "officename": "Sathiala SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143301": {
    "state": "Punjab",
    "district": "Tarn Taran",
    "block": "TARN-TARAN",
    "officename": "Chabhal SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143302": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Amritsar -I",
    "officename": "Sur Singh SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143303": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Amritsar -I",
    "officename": "Bhikhiwind SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143304": {
    "state": "Punjab",
    "district": "Tarn Taran",
    "block": "Khilchian",
    "officename": "Kacha Pacca SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143305": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Khalra",
    "officename": "Khalra SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143401": {
    "state": "Punjab",
    "district": "Tarn Taran",
    "block": "Khilchian",
    "officename": "Tarn Taran HO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143402": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Amritsar -I",
    "officename": "Police Lines Tarn Taran SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143406": {
    "state": "Punjab",
    "district": "Tarn Taran",
    "block": "Khilchian",
    "officename": "Kang SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143407": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Amritsar -I",
    "officename": "Fatehabad SO Amritsar",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143408": {
    "state": "Punjab",
    "district": "Tarn Taran",
    "block": "Khilchian",
    "officename": "Chohla Sahib SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143409": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Amritsar -I",
    "officename": "Naushehra Pannuan SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143410": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Sarhali",
    "officename": "Sarhali SO Tarn Taran",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143411": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Dhotian",
    "officename": "Dhotian SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143412": {
    "state": "Punjab",
    "district": "Tarn Taran",
    "block": "Harike",
    "officename": "Harike SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143413": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Bundala",
    "officename": "Bundala SO Amritsar",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143414": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "S.a. Khan",
    "officename": "Sarai Amant Khan SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143415": {
    "state": "Punjab",
    "district": "Tarn Taran",
    "block": "Kairon",
    "officename": "Kairon SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143416": {
    "state": "Punjab",
    "district": "Tarn Taran",
    "block": "Patti",
    "officename": "Patti SO Tarn Taran",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143419": {
    "state": "Punjab",
    "district": "Tarn Taran",
    "block": "Khem Karan",
    "officename": "Khem Karan SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143422": {
    "state": "Punjab",
    "district": "Tarn Taran",
    "block": "Khilchian",
    "officename": "Goindwal SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143501": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Verka",
    "officename": "Verka SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143502": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Kathunangal",
    "officename": "Kathunangal SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143504": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Amritsar",
    "officename": "Chawinda Devi SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143505": {
    "state": "Punjab",
    "district": "Gurdaspur",
    "block": "Batala",
    "officename": "Batala HO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Gurdaspur Division"
  },
  "143506": {
    "state": "Punjab",
    "district": "Gurdaspur",
    "block": "Batala",
    "officename": "Govt Poly Tech Batala SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Gurdaspur Division"
  },
  "143507": {
    "state": "Punjab",
    "district": "Gurdaspur",
    "block": "Batala",
    "officename": "Aliwal SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Gurdaspur Division"
  },
  "143511": {
    "state": "Punjab",
    "district": "Gurdaspur",
    "block": "Batala",
    "officename": "Bhagowal SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Gurdaspur Division"
  },
  "143512": {
    "state": "Punjab",
    "district": "Gurdaspur",
    "block": "Batala",
    "officename": "Kalanaur SO Gurdaspur",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Gurdaspur Division"
  },
  "143513": {
    "state": "Punjab",
    "district": "Gurdaspur",
    "block": "Batala",
    "officename": "Kala Afgana SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Gurdaspur Division"
  },
  "143514": {
    "state": "Punjab",
    "district": "Gurdaspur",
    "block": "Batala",
    "officename": "Ghoman SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Gurdaspur Division"
  },
  "143515": {
    "state": "Punjab",
    "district": "Gurdaspur",
    "block": "Batala",
    "officename": "Srihargobindpur SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Gurdaspur Division"
  },
  "143516": {
    "state": "Punjab",
    "district": "Gurdaspur",
    "block": "Gurdaspur",
    "officename": "Qadian SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Gurdaspur Division"
  },
  "143517": {
    "state": "Punjab",
    "district": "Gurdaspur",
    "block": "Gurdaspur",
    "officename": "Bhattian SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Gurdaspur Division"
  },
  "143518": {
    "state": "Punjab",
    "district": "Gurdaspur",
    "block": "Gurdaspur",
    "officename": "Naushera Majja Singh SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Gurdaspur Division"
  },
  "143519": {
    "state": "Punjab",
    "district": "Gurdaspur",
    "block": "Sub Tehsil Dhariwal",
    "officename": "Dhariwal SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Gurdaspur Division"
  },
  "143520": {
    "state": "Punjab",
    "district": "Gurdaspur",
    "block": "Gurdaspur",
    "officename": "Sohal SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Gurdaspur Division"
  },
  "143521": {
    "state": "Punjab",
    "district": "Gurdaspur",
    "block": "Gurdaspur",
    "officename": "Gurdaspur HO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Gurdaspur Division"
  },
  "143525": {
    "state": "Punjab",
    "district": "Gurdaspur",
    "block": "Gurdaspur",
    "officename": "Marara SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Gurdaspur Division"
  },
  "143526": {
    "state": "Punjab",
    "district": "Gurdaspur",
    "block": "Gurdaspur",
    "officename": "Dorangla SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Gurdaspur Division"
  },
  "143527": {
    "state": "Punjab",
    "district": "Gurdaspur",
    "block": "Batala",
    "officename": "Harchowal SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Gurdaspur Division"
  },
  "143528": {
    "state": "Punjab",
    "district": "Gurdaspur",
    "block": "Gurdaspur",
    "officename": "Kahnuwan SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Gurdaspur Division"
  },
  "143529": {
    "state": "Punjab",
    "district": "Gurdaspur",
    "block": "Gurdaspur",
    "officename": "Tibber SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Gurdaspur Division"
  },
  "143530": {
    "state": "Punjab",
    "district": "Gurdaspur",
    "block": "Gurdaspur",
    "officename": "Tibri SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Gurdaspur Division"
  },
  "143531": {
    "state": "Punjab",
    "district": "Gurdaspur",
    "block": "Gurdaspur",
    "officename": "Dinanagar SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Gurdaspur Division"
  },
  "143532": {
    "state": "Punjab",
    "district": "Gurdaspur",
    "block": "Gurdaspur",
    "officename": "Behrampur SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Gurdaspur Division"
  },
  "143533": {
    "state": "Punjab",
    "district": "Gurdaspur",
    "block": "Gurdaspur",
    "officename": "Gharota SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Gurdaspur Division"
  },
  "143534": {
    "state": "Punjab",
    "district": "Gurdaspur",
    "block": "Gurdaspur",
    "officename": "Taragarh Gurdaspur SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Gurdaspur Division"
  },
  "143601": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Amritsar -I",
    "officename": "Majitha SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143602": {
    "state": "Punjab",
    "district": "Gurdaspur",
    "block": "Dera Baba Nanak",
    "officename": "Fatehgarh Churian SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Gurdaspur Division"
  },
  "143603": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Ajnala",
    "officename": "Ramdass SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "143604": {
    "state": "Punjab",
    "district": "Gurdaspur",
    "block": "Dera Baba Nanak",
    "officename": "Dera Baba Nanak SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Gurdaspur Division"
  },
  "143605": {
    "state": "Punjab",
    "district": "Gurdaspur",
    "block": "Batala",
    "officename": "Dhianpur SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Gurdaspur Division"
  },
  "143606": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Amritsar -I",
    "officename": "Chetanpura SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "144001": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Jalandhar - I",
    "officename": "Jalandhar City HO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144002": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Jalandhar -II",
    "officename": "Basti Guzan SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144003": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Jalandhar - I",
    "officename": "Model Town Jalandhar SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144005": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Jalandhar",
    "officename": "Jalandhar Cantt HO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144006": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Jalandhar -II",
    "officename": "PAP Lines Jalandhar Cantt SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144007": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Jalandhar -II",
    "officename": "Ladhewali SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144008": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Jalandhar - I",
    "officename": "Grain Market SO Jalandhar",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144009": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Jalandhar - I",
    "officename": "Regional Campus GNDU SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144010": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Phillaur",
    "officename": "Dhanowali SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144020": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Jalandhar -II",
    "officename": "Jamsher SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144021": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Jalandhar - I",
    "officename": "Nagra SO Jalandhar",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144022": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Jalandhar -II",
    "officename": "Urban Estate SO Jalandhar",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144023": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Jalandhar -II",
    "officename": "Dakoha SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144024": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Jalandhar - I",
    "officename": "Kukar Pind SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144025": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Jalandhar",
    "officename": "Jandu Singha SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144026": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Jalandhar -II",
    "officename": "Lambra SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144027": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Jalandhar - I",
    "officename": "Suranussi SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144028": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Jalandhar",
    "officename": "Chitti SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144029": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Phillaur",
    "officename": "Moron SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144030": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Jalandhar",
    "officename": "Padhiana SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144031": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Phagwara",
    "officename": "RURKA KALAN SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144032": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Phagwara",
    "officename": "Samrai SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144033": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Phagwara",
    "officename": "JANDIALA SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144034": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Phagwara",
    "officename": "Bundala SO Jalandhar",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144035": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Phagwara Ho",
    "officename": "Partappura SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144036": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Phagwara",
    "officename": "Bilga SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144037": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Phagwara",
    "officename": "Pasla SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144039": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Nakodar",
    "officename": "Nurmahal SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144040": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Nakodar",
    "officename": "Nakoder SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144041": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Nakodar",
    "officename": "Mehatpur SO Jalandhar",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144042": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Nakodar",
    "officename": "Shankar SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144043": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Phagwara",
    "officename": "SARIH SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144044": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Nakodar",
    "officename": "SIDHWAN R S SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144101": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Jalandhar",
    "officename": "Patara SO Jalandhar",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144102": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Jalandhar - I",
    "officename": "Adampur Doaba SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144103": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Jalandhar - I",
    "officename": "Adampur AD SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144104": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Jalandhar",
    "officename": "Daroli Kalan SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144105": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Sham Chaurasi SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "144106": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Jalandhar - I",
    "officename": "Adda Kathar SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144201": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Jalandhar -II",
    "officename": "Bhogpur SO Jalandhar",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144202": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Miani SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "144204": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Urmar SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "144205": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Dasuya",
    "officename": "Dasuya HO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "144206": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Dholbaha SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "144207": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Garhdiwala SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "144208": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Hariana SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "144209": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Janauri SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "144210": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Bhunga SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "144211": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Mukerian SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "144212": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Budhipind SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "144213": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Bhanowal SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "144214": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Tanda Ram Sahai SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "144216": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Talwara Township SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "144221": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Hajipur SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "144222": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Datarpur SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "144223": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Kamahi Devi SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "144224": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Bhambotar SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "144301": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Jalandhar - I",
    "officename": "Alawalpur SO Jalandhar",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144302": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Jalandhar",
    "officename": "Beas Pind SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144303": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Jalandhar -II",
    "officename": "Kala Bakra SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144305": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Khudda SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "144306": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Bhangala SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "144311": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Phagwara",
    "officename": "DHESIAN KAHNA SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144401": {
    "state": "Punjab",
    "district": "Kapurthala",
    "block": "Phagwara",
    "officename": "Phagwara HO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144402": {
    "state": "Punjab",
    "district": "Kapurthala",
    "block": "Phagwara",
    "officename": "Satnampura SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144403": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Phagwara",
    "officename": "RANIPUR SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144404": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Ajnoha SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "144405": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Phagwara",
    "officename": "Narur SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144406": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Baddon SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "144407": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Phagwara",
    "officename": "DOMELI SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144408": {
    "state": "Punjab",
    "district": "Kapurthala",
    "block": "Phagwara",
    "officename": "PANCHHAT SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144409": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Phillaur",
    "officename": "Goraya SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144410": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Phillaur",
    "officename": "Phillaur SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144411": {
    "state": "Punjab",
    "district": "Kapurthala",
    "block": "Phagwara",
    "officename": "University Campus Nanak Nagri SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144415": {
    "state": "Punjab",
    "district": "Nawanshahr",
    "block": "Nawanshahar",
    "officename": "Lassara SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144416": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Phillaur",
    "officename": "Apra SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144417": {
    "state": "Punjab",
    "district": "Nawanshahr",
    "block": "Nawanshahar",
    "officename": "Aur SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144418": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Phillaur",
    "officename": "Bara Pind SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144419": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Phillaur",
    "officename": "Dayalpur SO Jalandhar",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144421": {
    "state": "Punjab",
    "district": "Nawanshahr",
    "block": "Nawanshahar",
    "officename": "Sahlon SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144422": {
    "state": "Punjab",
    "district": "Nawanshahr",
    "block": "Nawanshahr",
    "officename": "Urapar SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144501": {
    "state": "Punjab",
    "district": "Nawanshahr",
    "block": "Banga",
    "officename": "Kultham SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144502": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Phillaur",
    "officename": "Dosanjh Kalan SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144503": {
    "state": "Punjab",
    "district": "Nawanshahr",
    "block": "Banga",
    "officename": "Pharala SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144504": {
    "state": "Punjab",
    "district": "Nawanshahr",
    "block": "Banga",
    "officename": "Behram SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144505": {
    "state": "Punjab",
    "district": "Nawanshahr",
    "block": "Banga",
    "officename": "Banga SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144506": {
    "state": "Punjab",
    "district": "Nawanshahr",
    "block": "Banga",
    "officename": "Mahil Gailan SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144507": {
    "state": "Punjab",
    "district": "Nawanshahr",
    "block": "Banga",
    "officename": "Mokandpur SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144508": {
    "state": "Punjab",
    "district": "Nawanshahr",
    "block": "Banga",
    "officename": "Naura SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144509": {
    "state": "Punjab",
    "district": "Nawanshahr",
    "block": "Nawanshahar",
    "officename": "Khankhana SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144510": {
    "state": "Punjab",
    "district": "Nawanshahr",
    "block": "Nawanshahar",
    "officename": "Ladhana Jhikka SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144511": {
    "state": "Punjab",
    "district": "Nawanshahr",
    "block": "Banga",
    "officename": "Dosanjh Khurd SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144512": {
    "state": "Punjab",
    "district": "Nawanshahr",
    "block": "Nawanshahar",
    "officename": "Kahma SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144513": {
    "state": "Punjab",
    "district": "Nawanshahr",
    "block": "Nawanshahar",
    "officename": "Musapur SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144514": {
    "state": "Punjab",
    "district": "Nawanshahr",
    "block": "Nawanshahar",
    "officename": "Nawanshahar SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144515": {
    "state": "Punjab",
    "district": "Nawanshahr",
    "block": "Nawanshahr",
    "officename": "Jadla SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144516": {
    "state": "Punjab",
    "district": "Nawanshahr",
    "block": "Nawanshahar",
    "officename": "Langroya SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144517": {
    "state": "Punjab",
    "district": "Nawanshahr",
    "block": "Nawanshahar",
    "officename": "Rahon SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144518": {
    "state": "Punjab",
    "district": "Nawanshahr",
    "block": "Nawanshahar",
    "officename": "Garcha SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Jalandhar Division"
  },
  "144519": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Kotfathui SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "144520": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Binjon SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "144521": {
    "state": "Punjab",
    "district": "Nawanshahr",
    "block": "Balachaur",
    "officename": "Balachaur SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "144522": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Nawanshahar",
    "officename": "Kathagrh SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "144523": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Binewal SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "144524": {
    "state": "Punjab",
    "district": "Nawanshahr",
    "block": "Nawanshahar",
    "officename": "Saroa SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "144525": {
    "state": "Punjab",
    "district": "Nawanshahr",
    "block": "Balachaur",
    "officename": "Sahiba SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "144526": {
    "state": "Punjab",
    "district": "Nawanshahr",
    "block": "Balachaur",
    "officename": "Mehandpur SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "144527": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Garhshanker SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "144528": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Rampur Bilron SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "144529": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Saila Khurd SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "144530": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Jaijon SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "144531": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Moranwali SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "144532": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Samundra SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "144533": {
    "state": "Punjab",
    "district": "Nawanshahr",
    "block": "Balachaur",
    "officename": "Asron S.O",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshiarpur Division"
  },
  "144601": {
    "state": "Punjab",
    "district": "Kapurthala",
    "block": "Kapurthala",
    "officename": "Kapurthala HO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144602": {
    "state": "Punjab",
    "district": "Kapurthala",
    "block": "Kapurthala",
    "officename": "RAIL COACH FACTORY KAPURTHALA SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144603": {
    "state": "Punjab",
    "district": "Kapurthala",
    "block": "Kapurthala",
    "officename": "PTU Campus Kapurthala SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144606": {
    "state": "Punjab",
    "district": "Kapurthala",
    "block": "Kapurthala",
    "officename": "Talwandi Chaudharian SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144620": {
    "state": "Punjab",
    "district": "Kapurthala",
    "block": "Kapurthala",
    "officename": "Sheikhupur SO Kapurthala",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144621": {
    "state": "Punjab",
    "district": "Kapurthala",
    "block": "Kapurthala",
    "officename": "Begowal SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144622": {
    "state": "Punjab",
    "district": "Kapurthala",
    "block": "Bholath",
    "officename": "Bholath SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144623": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Nakodar",
    "officename": "Kala Sanghian SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144624": {
    "state": "Punjab",
    "district": "Kapurthala",
    "block": "Kapurthala",
    "officename": "Nadala SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144625": {
    "state": "Punjab",
    "district": "Kapurthala",
    "block": "Shahkot",
    "officename": "Sidhwan Dona SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144626": {
    "state": "Punjab",
    "district": "Kapurthala",
    "block": "Sultanpur",
    "officename": "Sultanpur Lodhi SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144628": {
    "state": "Punjab",
    "district": "Kapurthala",
    "block": "Kapurthala",
    "officename": "Thatha Jadid SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144629": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Shahkot",
    "officename": "Lohian SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144630": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Nakodar",
    "officename": "Bopa Rai Kalan SO Jalandhar",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144631": {
    "state": "Punjab",
    "district": "Kapurthala",
    "block": "Bhulath",
    "officename": "Nangal Lubana SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144632": {
    "state": "Punjab",
    "district": "Kapurthala",
    "block": "Phagwara",
    "officename": "Chachoki SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144633": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Phagwara",
    "officename": "SARHALI SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144701": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Nakodar",
    "officename": "Malsian SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144702": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Shahkot",
    "officename": "Shahkot SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144703": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Nakodar",
    "officename": "Nangal Ambian SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144801": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Jalandhar -II",
    "officename": "Kartarpur SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144802": {
    "state": "Punjab",
    "district": "Kapurthala",
    "block": "Kapurthala",
    "officename": "Jagatjit Nagar SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144803": {
    "state": "Punjab",
    "district": "Kapurthala",
    "block": "Kapurthala",
    "officename": "Dialpur SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144804": {
    "state": "Punjab",
    "district": "Kapurthala",
    "block": "Kapurthala",
    "officename": "Dhilwan SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144805": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Jalandhar -II",
    "officename": "CRPF Campus Sarai Khas SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144806": {
    "state": "Punjab",
    "district": "Jalandhar",
    "block": "Kapurthala",
    "officename": "Pattar Kalan SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "144819": {
    "state": "Punjab",
    "district": "Kapurthala",
    "block": "Bhulath",
    "officename": "IBRAHIMWAL",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Kapurthala Division"
  },
  "145001": {
    "state": "Punjab",
    "district": "Gurdaspur",
    "block": "Pathankot",
    "officename": "Pathankot SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Gurdaspur Division"
  },
  "145022": {
    "state": "Punjab",
    "district": "Gurdaspur",
    "block": "Dhar Kalan",
    "officename": "Dunera SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Gurdaspur Division"
  },
  "145023": {
    "state": "Punjab",
    "district": "Gurdaspur",
    "block": "Dera Baba Nanak",
    "officename": "Sujanpur SO Gurdaspur",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Gurdaspur Division"
  },
  "145024": {
    "state": "Punjab",
    "district": "Pathankot",
    "block": "Pathankot",
    "officename": "Madhopur SO Gurdaspur",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Gurdaspur Division"
  },
  "145025": {
    "state": "Punjab",
    "district": "Gurdaspur",
    "block": "Pathankot",
    "officename": "Malakpur SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Gurdaspur Division"
  },
  "145026": {
    "state": "Punjab",
    "district": "Gurdaspur",
    "block": "Pathankot",
    "officename": "Narot Jailmal Singh SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Gurdaspur Division"
  },
  "145027": {
    "state": "Punjab",
    "district": "Pathankot",
    "block": "Pathankot",
    "officename": "Bamial SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Gurdaspur Division"
  },
  "145029": {
    "state": "Punjab",
    "district": "Gurdaspur",
    "block": "Dhar Kalan",
    "officename": "Shahpur Kandi Township SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Gurdaspur Division"
  },
  "145101": {
    "state": "Punjab",
    "district": "Gurdaspur",
    "block": "Pathankot",
    "officename": "Mirthal SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Gurdaspur Division"
  },
  "146001": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Hoshiarpur HO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "146021": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Sadhu Ashram SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "146022": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Piplanwala SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "146023": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Bajwara SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "146024": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Factory Area Chohal SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "146101": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiar  Pur",
    "officename": "Barian  Kalan SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "146102": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Bassi Kalan SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "146103": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Bham SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "146104": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Bihala SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "146105": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Mahilpur SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "146106": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Nangal Kalan SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "146107": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Paldi SO Hoshiarpur",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "146108": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Sarhala Kalan SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "146109": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Tuto Mazara SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "146110": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Kot Abdul Khaliq SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "146111": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Purhiran SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "146112": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Rajpur Bhayan SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "146113": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Bulhowal SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "146114": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Nandachaur SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "146115": {
    "state": "Punjab",
    "district": "Nawanshahr",
    "block": "Balachaur",
    "officename": "Pajjodeotta SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "146116": {
    "state": "Punjab",
    "district": "Hoshiarpur",
    "block": "Hoshiarpur",
    "officename": "Kandhala Jattan SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Hoshiarpur Division"
  },
  "147001": {
    "state": "Punjab",
    "district": "Patiala",
    "block": "Patiala",
    "officename": "Patiala HO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patiala Division"
  },
  "147002": {
    "state": "Punjab",
    "district": "Patiala",
    "block": "Patiala",
    "officename": "University SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patiala Division"
  },
  "147003": {
    "state": "Punjab",
    "district": "Patiala",
    "block": "Patiala",
    "officename": "D C W SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patiala Division"
  },
  "147004": {
    "state": "Punjab",
    "district": "Patiala",
    "block": "Patiala",
    "officename": "Govt Printing Press SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patiala Division"
  },
  "147005": {
    "state": "Punjab",
    "district": "Patiala",
    "block": "Patiala",
    "officename": "Majithia Enclave SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patiala Division"
  },
  "147006": {
    "state": "Punjab",
    "district": "Patiala",
    "block": "Nabha",
    "officename": "RGNUL Punjab Patiala SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patiala Division"
  },
  "147007": {
    "state": "Punjab",
    "district": "Patiala",
    "block": "Patiala",
    "officename": "New Lal Bagh Colony SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patiala Division"
  },
  "147021": {
    "state": "Punjab",
    "district": "Patiala",
    "block": "Patiala",
    "officename": "Guruteghbahadurgarh SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patiala Division"
  },
  "147101": {
    "state": "Punjab",
    "district": "Patiala",
    "block": "Patiala",
    "officename": "Samana SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patiala Division"
  },
  "147102": {
    "state": "Punjab",
    "district": "Patiala",
    "block": "Samana",
    "officename": "Ghagga SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patiala Division"
  },
  "147103": {
    "state": "Punjab",
    "district": "Patiala",
    "block": "Patiala",
    "officename": "Sanaur SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patiala Division"
  },
  "147104": {
    "state": "Punjab",
    "district": "Patiala",
    "block": "Fatehgarh Sahib",
    "officename": "Chinarthal Kalan SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patiala Division"
  },
  "147105": {
    "state": "Punjab",
    "district": "Patiala",
    "block": "Samana",
    "officename": "Patran SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patiala Division"
  },
  "147111": {
    "state": "Punjab",
    "district": "Patiala",
    "block": "Patiala",
    "officename": "Devigarh SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patiala Division"
  },
  "147201": {
    "state": "Punjab",
    "district": "Patiala",
    "block": "Nabha",
    "officename": "Nabha SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patiala Division"
  },
  "147202": {
    "state": "Punjab",
    "district": "Patiala",
    "block": "Samana",
    "officename": "Bhadson SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patiala Division"
  },
  "147203": {
    "state": "Punjab",
    "district": "Fatehgarh Sahib",
    "block": "Amloh (P)",
    "officename": "Amloh SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patiala Division"
  },
  "147301": {
    "state": "Punjab",
    "district": "Fatehgarh Sahib",
    "block": "Fatehgarhsahib",
    "officename": "Mandigobindgarh SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patiala Division"
  },
  "148001": {
    "state": "Punjab",
    "district": "Sangrur",
    "block": "Sangrur",
    "officename": "Sangrur HO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sangrur Division"
  },
  "148002": {
    "state": "Punjab",
    "district": "Sangrur",
    "block": "Sangrur",
    "officename": "H R Sangrur SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sangrur Division"
  },
  "148017": {
    "state": "Punjab",
    "district": "Sangrur",
    "block": "Dhuri",
    "officename": "Bhalwan SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sangrur Division"
  },
  "148018": {
    "state": "Punjab",
    "district": "Sangrur",
    "block": "Malerkotla",
    "officename": "Bagrian SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sangrur Division"
  },
  "148019": {
    "state": "Punjab",
    "district": "Sangrur",
    "block": "Malerkotla",
    "officename": "Jitwal Kalan SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sangrur Division"
  },
  "148020": {
    "state": "Punjab",
    "district": "Sangrur",
    "block": "Malerkotla",
    "officename": "Sandhaur SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sangrur Division"
  },
  "148021": {
    "state": "Punjab",
    "district": "Sangrur",
    "block": "Malerkotla",
    "officename": "Ahmedgarh sO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sangrur Division"
  },
  "148022": {
    "state": "Punjab",
    "district": "Sangrur",
    "block": "Malerkotla",
    "officename": "Amargarh SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sangrur Division"
  },
  "148023": {
    "state": "Punjab",
    "district": "Sangrur",
    "block": "Malerkotla",
    "officename": "Malerkotla SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sangrur Division"
  },
  "148024": {
    "state": "Punjab",
    "district": "Sangrur",
    "block": "Dhuri",
    "officename": "Dhuri SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sangrur Division"
  },
  "148025": {
    "state": "Punjab",
    "district": "Sangrur",
    "block": "Dhuri",
    "officename": "Sherpur SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sangrur Division"
  },
  "148026": {
    "state": "Punjab",
    "district": "Sangrur",
    "block": "Sangrur",
    "officename": "Bhawanigarh SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sangrur Division"
  },
  "148027": {
    "state": "Punjab",
    "district": "Sangrur",
    "block": "Moonak",
    "officename": "Pakki Khanauri SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sangrur Division"
  },
  "148028": {
    "state": "Punjab",
    "district": "Sangrur",
    "block": "Sunam",
    "officename": "Sunam SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sangrur Division"
  },
  "148029": {
    "state": "Punjab",
    "district": "Sangrur",
    "block": "Sangrur",
    "officename": "Cheema SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sangrur Division"
  },
  "148030": {
    "state": "Punjab",
    "district": "Sangrur",
    "block": "Moonak",
    "officename": "Chhajli SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sangrur Division"
  },
  "148031": {
    "state": "Punjab",
    "district": "Sangrur",
    "block": "Moonak",
    "officename": "Lehragaga SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sangrur Division"
  },
  "148033": {
    "state": "Punjab",
    "district": "Sangrur",
    "block": "Sunam",
    "officename": "Moonak SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sangrur Division"
  },
  "148034": {
    "state": "Punjab",
    "district": "Sangrur",
    "block": "Dhuri",
    "officename": "Ladda SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sangrur Division"
  },
  "148035": {
    "state": "Punjab",
    "district": "Sangrur",
    "block": "Sunam",
    "officename": "Dirba SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sangrur Division"
  },
  "148100": {
    "state": "Punjab",
    "district": "Barnala",
    "block": "Barnala",
    "officename": "Tallewal SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sangrur Division"
  },
  "148101": {
    "state": "Punjab",
    "district": "Barnala",
    "block": "Barnala",
    "officename": "Barnala SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sangrur Division"
  },
  "148102": {
    "state": "Punjab",
    "district": "Sangrur",
    "block": "Barnala",
    "officename": "Bhadaur SO Sangrur",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sangrur Division"
  },
  "148103": {
    "state": "Punjab",
    "district": "Barnala",
    "block": "Barnala",
    "officename": "Shaina SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sangrur Division"
  },
  "148104": {
    "state": "Punjab",
    "district": "Barnala",
    "block": "Barnala",
    "officename": "Mehal Kalan SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sangrur Division"
  },
  "148105": {
    "state": "Punjab",
    "district": "Barnala",
    "block": "Barnala",
    "officename": "Dhanaula SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sangrur Division"
  },
  "148106": {
    "state": "Punjab",
    "district": "Barnala",
    "block": "Barnala",
    "officename": "Longowal SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sangrur Division"
  },
  "148107": {
    "state": "Punjab",
    "district": "Barnala",
    "block": "Barnala",
    "officename": "Handiaya SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sangrur Division"
  },
  "148108": {
    "state": "Punjab",
    "district": "Barnala",
    "block": "Barnala",
    "officename": "Tapa SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sangrur Division"
  },
  "148109": {
    "state": "Punjab",
    "district": "Barnala",
    "block": "Barnala",
    "officename": "Sanghera SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sangrur Division"
  },
  "151001": {
    "state": "Punjab",
    "district": "Bathinda",
    "block": "Bathinda",
    "officename": "Bathinda HO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Bhatinda Division"
  },
  "151002": {
    "state": "Punjab",
    "district": "Bathinda",
    "block": "Bti",
    "officename": "Gndtp Bathinda SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Bhatinda Division"
  },
  "151003": {
    "state": "Punjab",
    "district": "Bathinda",
    "block": "Bathinda",
    "officename": "Nfl Bathinda SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Bhatinda Division"
  },
  "151004": {
    "state": "Punjab",
    "district": "Bathinda",
    "block": "Bathinda",
    "officename": "Bathinda Cantt SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Bhatinda Division"
  },
  "151005": {
    "state": "Punjab",
    "district": "Bathinda",
    "block": "Bathinda",
    "officename": "Bathinda City SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Bhatinda Division"
  },
  "151101": {
    "state": "Punjab",
    "district": "Bathinda",
    "block": "Bhucho Manda",
    "officename": "Bhucho Mandi SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Bhatinda Division"
  },
  "151102": {
    "state": "Punjab",
    "district": "Bathinda",
    "block": "Bathinda",
    "officename": "Nathana SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Bhatinda Division"
  },
  "151103": {
    "state": "Punjab",
    "district": "Bathinda",
    "block": "Phul",
    "officename": "Rampura Phul SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Bhatinda Division"
  },
  "151104": {
    "state": "Punjab",
    "district": "Bathinda",
    "block": "Phul",
    "officename": "Phul SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Bhatinda Division"
  },
  "151105": {
    "state": "Punjab",
    "district": "Bathinda",
    "block": "Phul",
    "officename": "Mehraj SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Bhatinda Division"
  },
  "151106": {
    "state": "Punjab",
    "district": "Bathinda",
    "block": "Rampura Phul",
    "officename": "Bhai Rupa SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Bhatinda Division"
  },
  "151108": {
    "state": "Punjab",
    "district": "Bathinda",
    "block": "Phul",
    "officename": "Salabatpura SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Bhatinda Division"
  },
  "151111": {
    "state": "Punjab",
    "district": "Bathinda",
    "block": "Phul",
    "officename": "Ghtp Lehra Mohabbat SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Bhatinda Division"
  },
  "151201": {
    "state": "Punjab",
    "district": "Bathinda",
    "block": "Goniana Mandi",
    "officename": "Goniana Mandi SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Bhatinda Division"
  },
  "151202": {
    "state": "Punjab",
    "district": "Faridkot",
    "block": "Jaitu",
    "officename": "Jaitu SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "151203": {
    "state": "Punjab",
    "district": "Faridkot",
    "block": "Faridkot",
    "officename": "Faridkot HO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "151204": {
    "state": "Punjab",
    "district": "Faridkot",
    "block": "Jaitu",
    "officename": "Kotkapura SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "151205": {
    "state": "Punjab",
    "district": "Faridkot",
    "block": "Jaitu",
    "officename": "Baja Khana SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "151206": {
    "state": "Punjab",
    "district": "Bathinda",
    "block": "Rampura Phul",
    "officename": "Bhagta Bhai SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Bhatinda Division"
  },
  "151207": {
    "state": "Punjab",
    "district": "Faridkot",
    "block": "Faridkot",
    "officename": "Panj Grain Kalan SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "151208": {
    "state": "Punjab",
    "district": "Faridkot",
    "block": "Jaitu",
    "officename": "Bargari SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "151209": {
    "state": "Punjab",
    "district": "Faridkot",
    "block": "Kotkapura",
    "officename": "Sandhwan SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "151210": {
    "state": "Punjab",
    "district": "Muktsar",
    "block": "Malout",
    "officename": "Alamwala SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "151211": {
    "state": "Punjab",
    "district": "Muktsar",
    "block": "Malout",
    "officename": "Mandi Killianwali SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "151212": {
    "state": "Punjab",
    "district": "Faridkot",
    "block": "Faridkot",
    "officename": "Sadiq SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "151213": {
    "state": "Punjab",
    "district": "Faridkot",
    "block": "Faridkot",
    "officename": "Harindra Nagar Faridkot SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "151301": {
    "state": "Punjab",
    "district": "Bathinda",
    "block": "T Sabo",
    "officename": "Raman SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Bhatinda Division"
  },
  "151302": {
    "state": "Punjab",
    "district": "Bathinda",
    "block": "T.sabo",
    "officename": "Talwandi Sabo SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Bhatinda Division"
  },
  "151401": {
    "state": "Punjab",
    "district": "Bathinda",
    "block": "Sangat",
    "officename": "Sangat SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Bhatinda Division"
  },
  "151501": {
    "state": "Punjab",
    "district": "Bathinda",
    "block": "Bareta",
    "officename": "Bareta SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Bhatinda Division"
  },
  "151502": {
    "state": "Punjab",
    "district": "Mansa",
    "block": "Bdh",
    "officename": "Budhlada SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Bhatinda Division"
  },
  "151503": {
    "state": "Punjab",
    "district": "Mansa",
    "block": "Boha",
    "officename": "Boha SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Bhatinda Division"
  },
  "151504": {
    "state": "Punjab",
    "district": "Mansa",
    "block": "Bkh",
    "officename": "Bhikhi SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Bhatinda Division"
  },
  "151505": {
    "state": "Punjab",
    "district": "Mansa",
    "block": "Mansa",
    "officename": "Mansa SO Mansa",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Bhatinda Division"
  },
  "151506": {
    "state": "Punjab",
    "district": "Mansa",
    "block": "Mansa",
    "officename": "Jhunir SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Bhatinda Division"
  },
  "151507": {
    "state": "Punjab",
    "district": "Mansa",
    "block": "Mansa",
    "officename": "Sardulgarh SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Bhatinda Division"
  },
  "151508": {
    "state": "Punjab",
    "district": "Mansa",
    "block": "Mansa",
    "officename": "Bhaini Bagha SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Bhatinda Division"
  },
  "151509": {
    "state": "Punjab",
    "district": "Bathinda",
    "block": "Maur",
    "officename": "Maur Mandi SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Bhatinda Division"
  },
  "151510": {
    "state": "Punjab",
    "district": "Mansa",
    "block": "Mansa",
    "officename": "Joga SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Bhatinda Division"
  },
  "152001": {
    "state": "Punjab",
    "district": "Firozpur",
    "block": "Firozepur",
    "officename": "Ferozepur HO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Ferozpur Division"
  },
  "152002": {
    "state": "Punjab",
    "district": "Firozpur",
    "block": "Firozepur",
    "officename": "Ferozepur City SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Ferozpur Division"
  },
  "152003": {
    "state": "Punjab",
    "district": "Firozpur",
    "block": "Firozepur",
    "officename": "Canal Colony Ferozepur SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Ferozpur Division"
  },
  "152004": {
    "state": "Punjab",
    "district": "Firozpur",
    "block": "Ferozepur",
    "officename": "SBS Engg Colleger Ferozpeur SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Ferozpur Division"
  },
  "152005": {
    "state": "Punjab",
    "district": "Firozpur",
    "block": "Zira",
    "officename": "Sherkhan Wala SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Ferozpur Division"
  },
  "152021": {
    "state": "Punjab",
    "district": "Firozpur",
    "block": "Firozepur",
    "officename": "Mallanwala SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Ferozpur Division"
  },
  "152022": {
    "state": "Punjab",
    "district": "Firozpur",
    "block": "Jalalabad",
    "officename": "Guruharsahai SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Ferozpur Division"
  },
  "152023": {
    "state": "Punjab",
    "district": "Firozpur",
    "block": "Firozepur",
    "officename": "Mamdot SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Ferozpur Division"
  },
  "152024": {
    "state": "Punjab",
    "district": "Firozpur",
    "block": "Jalalabad",
    "officename": "Jalalabad W SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Ferozpur Division"
  },
  "152025": {
    "state": "Punjab",
    "district": "Muktsar",
    "block": "Giddarbaha",
    "officename": "Bariwala SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "152026": {
    "state": "Punjab",
    "district": "Muktsar",
    "block": "Muktsar",
    "officename": "Sri Muktsar Sahib MDG",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "152028": {
    "state": "Punjab",
    "district": "Moga",
    "block": "Moga",
    "officename": "Manawan SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Ferozpur Division"
  },
  "152031": {
    "state": "Punjab",
    "district": "Muktsar",
    "block": "Muktsar",
    "officename": "Doda SO Muktsar",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "152032": {
    "state": "Punjab",
    "district": "Muktsar",
    "block": "Malout",
    "officename": "Rupana SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "152033": {
    "state": "Punjab",
    "district": "Firozpur",
    "block": "Jalalabad",
    "officename": "Mandi Amin Ganj SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Ferozpur Division"
  },
  "152101": {
    "state": "Punjab",
    "district": "Muktsar",
    "block": "Giddarbaha",
    "officename": "Gidderbaha SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "152107": {
    "state": "Punjab",
    "district": "Muktsar",
    "block": "Malout",
    "officename": "Malout SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "152112": {
    "state": "Punjab",
    "district": "Muktsar",
    "block": "Giddarbaha",
    "officename": "Ram Nagar SO Muktsar",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "152113": {
    "state": "Punjab",
    "district": "Muktsar",
    "block": "Malout",
    "officename": "Lambi SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "152114": {
    "state": "Punjab",
    "district": "Muktsar",
    "block": "Malout",
    "officename": "Tappa Khera SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "152115": {
    "state": "Punjab",
    "district": "Muktsar",
    "block": "Malout",
    "officename": "Bhaika Khera SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "152116": {
    "state": "Punjab",
    "district": "Firozpur",
    "block": "Abohar",
    "officename": "Abohar SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Ferozpur Division"
  },
  "152117": {
    "state": "Punjab",
    "district": "Firozpur",
    "block": "Abohar",
    "officename": "Balluana SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Ferozpur Division"
  },
  "152118": {
    "state": "Punjab",
    "district": "Fazilka",
    "block": "Abohar",
    "officename": "Sitto SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Ferozpur Division"
  },
  "152121": {
    "state": "Punjab",
    "district": "Firozpur",
    "block": "Fazilka",
    "officename": "Khui Khera SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Ferozpur Division"
  },
  "152122": {
    "state": "Punjab",
    "district": "Firozpur",
    "block": "Fazilka",
    "officename": "Nihal Khera SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Ferozpur Division"
  },
  "152123": {
    "state": "Punjab",
    "district": "Firozpur",
    "block": "Fazilka",
    "officename": "Fazilka SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Ferozpur Division"
  },
  "152124": {
    "state": "Punjab",
    "district": "Firozpur",
    "block": "Fazilka",
    "officename": "Arniwala Sheikh Subhan SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Ferozpur Division"
  },
  "152128": {
    "state": "Punjab",
    "district": "Firozpur",
    "block": "Fazilka",
    "officename": "Khuiyan Server SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Ferozpur Division"
  },
  "152132": {
    "state": "Punjab",
    "district": "Firozpur",
    "block": "Abohar",
    "officename": "Maujgarh SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Ferozpur Division"
  },
  "160001": {
    "state": "Chandigarh",
    "district": "Chandigarh",
    "block": "Chandigarh",
    "officename": "New Sectt Chandigarh SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "160002": {
    "state": "Chandigarh",
    "district": "Chandigarh",
    "block": "Chandigarh",
    "officename": "Ind Area Chandigarh SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "160003": {
    "state": "Chandigarh",
    "district": "Chandigarh",
    "block": "Chandigarh",
    "officename": "Aerodrome SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "160004": {
    "state": "Chandigarh",
    "district": "Chandigarh",
    "block": "Chandigarh",
    "officename": "Airforce Highground SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "160009": {
    "state": "Chandigarh",
    "district": "Chandigarh",
    "block": "Chandigarh",
    "officename": "Sector 9 Chandigarh SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "160011": {
    "state": "Chandigarh",
    "district": "Chandigarh",
    "block": "Chandigarh",
    "officename": "Sector 11 Chandigarh SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "160012": {
    "state": "Chandigarh",
    "district": "Chandigarh",
    "block": "Chandigarh",
    "officename": "Sector 12 Chandigarh SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "160014": {
    "state": "Punjab",
    "district": "Rupnagar",
    "block": "S.A.S.Nagar (Mohali)",
    "officename": "Sector 14 Chandigarh SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "160015": {
    "state": "Chandigarh",
    "district": "Chandigarh",
    "block": "Chandigarh",
    "officename": "Sector 15 Chandigarh SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "160017": {
    "state": "Chandigarh",
    "district": "Chandigarh",
    "block": "Chandigarh",
    "officename": "Chandigarh GPO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "160018": {
    "state": "Chandigarh",
    "district": "Chandigarh",
    "block": "Chandigarh",
    "officename": "Sector 18 Chandigarh SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "160019": {
    "state": "Chandigarh",
    "district": "Chandigarh",
    "block": "Chandigarh",
    "officename": "Sector 19 Chandigarh SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "160020": {
    "state": "Chandigarh",
    "district": "Chandigarh",
    "block": "Chandigarh",
    "officename": "Sector 20 Chandigarh SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "160022": {
    "state": "Chandigarh",
    "district": "Chandigarh",
    "block": "Chandigarh",
    "officename": "Sector 22 Chandigarh SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "160023": {
    "state": "Chandigarh",
    "district": "Chandigarh",
    "block": "Chandigarh",
    "officename": "Sector 23  Chandigarh SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "160025": {
    "state": "Chandigarh",
    "district": "Chandigarh",
    "block": "Chandigarh",
    "officename": "Maloya Colony SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "160030": {
    "state": "Chandigarh",
    "district": "Chandigarh",
    "block": "Chandigarh",
    "officename": "Sector 30 Chandigarh SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "160036": {
    "state": "Chandigarh",
    "district": "Chandigarh",
    "block": "Chandigarh",
    "officename": "Sector 36 Chandigarh SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "160047": {
    "state": "Chandigarh",
    "district": "Chandigarh",
    "block": "Chandigarh",
    "officename": "Sector 47 Chandigarh SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "160055": {
    "state": "Punjab",
    "district": "Rupnagar",
    "block": "S.A.S.Nagar (Mohali)",
    "officename": "Chandigarh Sector 55 SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "160059": {
    "state": "Punjab",
    "district": "Rupnagar",
    "block": "S.A.S.Nagar (Mohali)",
    "officename": "Chandigarh Sector 59 SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "160062": {
    "state": "Punjab",
    "district": "Rupnagar",
    "block": "S.A.S.Nagar (Mohali)",
    "officename": "Chandigarh Sector 62 SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "160071": {
    "state": "Punjab",
    "district": "Rupnagar",
    "block": "S.A.S.Nagar (Mohali)",
    "officename": "Chandigarh Sector 71 SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "160101": {
    "state": "Chandigarh",
    "district": "Chandigarh",
    "block": "Chandigarh",
    "officename": "Manimajra SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "160102": {
    "state": "Chandigarh",
    "district": "Chandigarh",
    "block": "Chandigarh",
    "officename": "Mauli Jagran SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "160103": {
    "state": "Punjab",
    "district": "Mohali",
    "block": "Rupnagar",
    "officename": "Naya Gaon SO Mohali",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "160104": {
    "state": "Punjab",
    "district": "Mohali",
    "block": "Derabassi",
    "officename": "Dhakaoli SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "171001": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Shimla Urban(T)",
    "officename": "Shimla GPO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171002": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Shimla Urban(T)",
    "officename": "Shimla East SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171003": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Shimla Urban(T)",
    "officename": "AGPO SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171004": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Shimla Urban(T)",
    "officename": "Ambedkarchowk SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171005": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Shimla Urban(T)",
    "officename": "Summerhill SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171006": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Shimla",
    "officename": "Sanjauli SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171007": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Shimla",
    "officename": "Mashobra SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171008": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Shimla Urban(T)",
    "officename": "Jutogh SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171009": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Shimla Urban(T)",
    "officename": "Kasumpti SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171010": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Shimla Urban(T)",
    "officename": "Tara Devi SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171011": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Shimla",
    "officename": "Totu SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171012": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Shimla R",
    "officename": "Dhalli SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171013": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Shimla",
    "officename": "Mehli SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171018": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Suni",
    "officename": "Basanatpur SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171019": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Suni",
    "officename": "Jalog SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171102": {
    "state": "Himachal Pradesh",
    "district": "Solan",
    "block": "Kasauli",
    "officename": "Darla SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "171103": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Shimla",
    "officename": "Dhami SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171201": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Theog",
    "officename": "Theog SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171202": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Kotkhai",
    "officename": "Kotkhai SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171203": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Rohru",
    "officename": "Tikkar SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171204": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Kotkhai",
    "officename": "Kiari SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171205": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Jubbal",
    "officename": "Jubbal SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171206": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Jubbal",
    "officename": "Hatkoti SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171207": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Rohru",
    "officename": "Rohru SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171208": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Chirgaon",
    "officename": "Chirgaon SO Shimla",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171209": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Theog",
    "officename": "Fagu SO Shimla",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171210": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Chopal",
    "officename": "Nerwa SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171211": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Chopal",
    "officename": "Chopal SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171212": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Theog",
    "officename": "Matiana SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171213": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Kumarsain",
    "officename": "Narkanda SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171214": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Rohru",
    "officename": "Jangla SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171215": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Jubbal",
    "officename": "Mandhole SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171216": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Jubbal",
    "officename": "Mandal SO Shimla",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171217": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Chopal",
    "officename": "Kupvi SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171218": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Shimla",
    "officename": "Junga SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171219": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Shimla",
    "officename": "Shoghi SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171220": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Theog",
    "officename": "Bagain SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171221": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Rohru",
    "officename": "Kawar SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171222": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Theog",
    "officename": "Sandhu SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171223": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Rohru",
    "officename": "Arhal SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171224": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Rohru",
    "officename": "Summer Kot SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171225": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Kothkhai",
    "officename": "Baghi SO Shimla",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171226": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Theog",
    "officename": "Balag SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171301": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Suni",
    "officename": "Sunni Bhajji SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "172001": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Nankhari",
    "officename": "Rampur Bushahr HO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rampur Bushahr Division"
  },
  "172002": {
    "state": "Himachal Pradesh",
    "district": "Kullu",
    "block": "Nirmand",
    "officename": "Arsu SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rampur Bushahr Division"
  },
  "172021": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Nankhari",
    "officename": "Nankhari SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rampur Bushahr Division"
  },
  "172022": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Rampur Bushahr",
    "officename": "Nogli SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rampur Bushahr Division"
  },
  "172023": {
    "state": "Himachal Pradesh",
    "district": "Kullu",
    "block": "Nirmand",
    "officename": "Nirmand SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rampur Bushahr Division"
  },
  "172024": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Kumharsain(T)",
    "officename": "Kingal SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rampur Bushahr Division"
  },
  "172025": {
    "state": "Himachal Pradesh",
    "district": "Kullu",
    "block": "Ani(S.T)",
    "officename": "Dalash SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rampur Bushahr Division"
  },
  "172026": {
    "state": "Himachal Pradesh",
    "district": "Kullu",
    "block": "Anni",
    "officename": "Anni SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rampur Bushahr Division"
  },
  "172027": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Kumarsain",
    "officename": "Baragaon SO Shimla",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rampur Bushahr Division"
  },
  "172028": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Nankhari(S.T)",
    "officename": "Delath SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rampur Bushahr Division"
  },
  "172029": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Kumharsain(T)",
    "officename": "Kumarsain SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rampur Bushahr Division"
  },
  "172030": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Kumarsain",
    "officename": "Thanedhar SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rampur Bushahr Division"
  },
  "172031": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Kumharsain(T)",
    "officename": "Kotgarh SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rampur Bushahr Division"
  },
  "172032": {
    "state": "Himachal Pradesh",
    "district": "Kullu",
    "block": "Ani(S.T)",
    "officename": "Chowai SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rampur Bushahr Division"
  },
  "172033": {
    "state": "Himachal Pradesh",
    "district": "Kullu",
    "block": "Nermand(T)",
    "officename": "Nither SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rampur Bushahr Division"
  },
  "172034": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Rampur(T)",
    "officename": "Bonda SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rampur Bushahr Division"
  },
  "172101": {
    "state": "Himachal Pradesh",
    "district": "Kinnaur",
    "block": "Nichar(T)",
    "officename": "Jeori SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rampur Bushahr Division"
  },
  "172102": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Rampur(T)",
    "officename": "Sarahan BSR SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rampur Bushahr Division"
  },
  "172103": {
    "state": "Himachal Pradesh",
    "district": "Kinnaur",
    "block": "Nichar(T)",
    "officename": "Nichar SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rampur Bushahr Division"
  },
  "172104": {
    "state": "Himachal Pradesh",
    "district": "Kinnaur",
    "block": "Nichar(T)",
    "officename": "Tapri SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rampur Bushahr Division"
  },
  "172105": {
    "state": "Himachal Pradesh",
    "district": "Kinnaur",
    "block": "Sangla(T)",
    "officename": "Karcham SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rampur Bushahr Division"
  },
  "172106": {
    "state": "Himachal Pradesh",
    "district": "Kinnaur",
    "block": "Sangla(T)",
    "officename": "Sangla SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rampur Bushahr Division"
  },
  "172107": {
    "state": "Himachal Pradesh",
    "district": "Kinnaur",
    "block": "Kalpa(T)",
    "officename": "Reckong Peo HO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rampur Bushahr Division"
  },
  "172108": {
    "state": "Himachal Pradesh",
    "district": "Kinnaur",
    "block": "Kalpa(T)",
    "officename": "Kalpa SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rampur Bushahr Division"
  },
  "172109": {
    "state": "Himachal Pradesh",
    "district": "Kinnaur",
    "block": "Moorang",
    "officename": "Moorang SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rampur Bushahr Division"
  },
  "172110": {
    "state": "Himachal Pradesh",
    "district": "Kinnaur",
    "block": "Morang(T)",
    "officename": "Speelo SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rampur Bushahr Division"
  },
  "172111": {
    "state": "Himachal Pradesh",
    "district": "Kinnaur",
    "block": "Poo(T)",
    "officename": "Pooh SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rampur Bushahr Division"
  },
  "172112": {
    "state": "Himachal Pradesh",
    "district": "Kinnaur",
    "block": "Hangrang",
    "officename": "Liyo SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rampur Bushahr Division"
  },
  "172113": {
    "state": "Himachal Pradesh",
    "district": "Lahul & Spiti",
    "block": "Spiti",
    "officename": "Tabo SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rampur Bushahr Division"
  },
  "172114": {
    "state": "Himachal Pradesh",
    "district": "Lahul & Spiti",
    "block": "Spiti",
    "officename": "Kaza SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rampur Bushahr Division"
  },
  "172115": {
    "state": "Himachal Pradesh",
    "district": "Kinnaur",
    "block": "Nichar(T)",
    "officename": "Bhaba Nagar SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rampur Bushahr Division"
  },
  "172116": {
    "state": "Himachal Pradesh",
    "district": "Kinnaur",
    "block": "Poo(T)",
    "officename": "Ribba SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rampur Bushahr Division"
  },
  "172117": {
    "state": "Himachal Pradesh",
    "district": "Lahul & Spiti",
    "block": "Spiti",
    "officename": "Sagnam SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rampur Bushahr Division"
  },
  "172118": {
    "state": "Himachal Pradesh",
    "district": "Kinnaur",
    "block": "Nichar(T)",
    "officename": "Katgaon SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rampur Bushahr Division"
  },
  "172201": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Rampur Bushahr",
    "officename": "Jhakri SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rampur Bushahr Division"
  },
  "173001": {
    "state": "Himachal Pradesh",
    "district": "Sirmaur",
    "block": "Pachhad",
    "officename": "Nahan HO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173021": {
    "state": "Himachal Pradesh",
    "district": "Sirmaur",
    "block": "Paonta",
    "officename": "Majra SO Sirmaur",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173022": {
    "state": "Himachal Pradesh",
    "district": "Sirmaur",
    "block": "Paonta",
    "officename": "Dadahu SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173023": {
    "state": "Himachal Pradesh",
    "district": "Sirmaur",
    "block": "Sangrah",
    "officename": "Sangrah SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173024": {
    "state": "Himachal Pradesh",
    "district": "Sirmaur",
    "block": "Pachhad",
    "officename": "Sarahan SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173025": {
    "state": "Himachal Pradesh",
    "district": "Sirmaur",
    "block": "Paonta",
    "officename": "Paonta Sahib SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173026": {
    "state": "Himachal Pradesh",
    "district": "Sirmaur",
    "block": "Nahan",
    "officename": "Kw Bhood SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173027": {
    "state": "Himachal Pradesh",
    "district": "Sirmaur",
    "block": "Shillai",
    "officename": "Shillai SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173029": {
    "state": "Himachal Pradesh",
    "district": "Sirmaur",
    "block": "Shillai",
    "officename": "Sataun SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173030": {
    "state": "Himachal Pradesh",
    "district": "Sirmaur",
    "block": "Nahan",
    "officename": "Kala Amb SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173031": {
    "state": "Himachal Pradesh",
    "district": "Sirmaur",
    "block": "Poanta Sahib",
    "officename": "Dhualakuan",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173032": {
    "state": "Himachal Pradesh",
    "district": "Sirmaur",
    "block": "Sangarh",
    "officename": "Haripurdhar",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173101": {
    "state": "Himachal Pradesh",
    "district": "Sirmaur",
    "block": "Pachhad",
    "officename": "Rajgarh Siramur SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173104": {
    "state": "Himachal Pradesh",
    "district": "Sirmaur",
    "block": "Sangrah",
    "officename": "Nohra SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173201": {
    "state": "Himachal Pradesh",
    "district": "Solan",
    "block": "Kasauli",
    "officename": "Garkhal SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173202": {
    "state": "Himachal Pradesh",
    "district": "Solan",
    "block": "Kasauli",
    "officename": "Sanawar SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173204": {
    "state": "Himachal Pradesh",
    "district": "Solan",
    "block": "Kasauli",
    "officename": "Kasauli SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173205": {
    "state": "Himachal Pradesh",
    "district": "Solan",
    "block": "Nalagarh",
    "officename": "Baddi SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173206": {
    "state": "Himachal Pradesh",
    "district": "Solan",
    "block": "Kasauli",
    "officename": "Subathu SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173207": {
    "state": "Himachal Pradesh",
    "district": "Solan",
    "block": "Kandaghat",
    "officename": "Kunihar SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173208": {
    "state": "Himachal Pradesh",
    "district": "Solan",
    "block": "Kandaghat",
    "officename": "Arki SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173209": {
    "state": "Himachal Pradesh",
    "district": "Solan",
    "block": "Kasauli",
    "officename": "Dharampur SO Solan",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173210": {
    "state": "Himachal Pradesh",
    "district": "Solan",
    "block": "Solan",
    "officename": "Dagshai SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173211": {
    "state": "Himachal Pradesh",
    "district": "Solan",
    "block": "Solan",
    "officename": "Saproon SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173212": {
    "state": "Himachal Pradesh",
    "district": "Solan",
    "block": "Kasauli",
    "officename": "Solan HO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173213": {
    "state": "Himachal Pradesh",
    "district": "Solan",
    "block": "Solan",
    "officename": "Chambaghat SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173214": {
    "state": "Himachal Pradesh",
    "district": "Solan",
    "block": "Kasauli(T)",
    "officename": "Solan Brewery SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173215": {
    "state": "Himachal Pradesh",
    "district": "Solan",
    "block": "Kandaghat",
    "officename": "Kandaghat SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173217": {
    "state": "Himachal Pradesh",
    "district": "Solan",
    "block": "Kandaghat",
    "officename": "Chail SO Solan",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173218": {
    "state": "Himachal Pradesh",
    "district": "Solan",
    "block": "Ramshahar",
    "officename": "Diggal SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173220": {
    "state": "Himachal Pradesh",
    "district": "Solan",
    "block": "Kasauli",
    "officename": "Parwanoo SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173221": {
    "state": "Himachal Pradesh",
    "district": "Solan",
    "block": "Arki",
    "officename": "Domehar SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173222": {
    "state": "Himachal Pradesh",
    "district": "Solan",
    "block": "Kandaghat",
    "officename": "Mamlig SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173223": {
    "state": "Himachal Pradesh",
    "district": "Sirmaur",
    "block": "Rajghar",
    "officename": "Oachghat SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173225": {
    "state": "Himachal Pradesh",
    "district": "Solan",
    "block": "Kasauli",
    "officename": "Jubbar SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173229": {
    "state": "Himachal Pradesh",
    "district": "Solan",
    "block": "Kasauli",
    "officename": "Kumarhatti SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173230": {
    "state": "Himachal Pradesh",
    "district": "Solan",
    "block": "Kasauli",
    "officename": "Nauni SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173233": {
    "state": "Himachal Pradesh",
    "district": "Solan",
    "block": "Kasauli",
    "officename": "Patta SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173234": {
    "state": "Himachal Pradesh",
    "district": "Solan",
    "block": "Kandaghat",
    "officename": "Waknaghat SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173235": {
    "state": "Himachal Pradesh",
    "district": "Solan",
    "block": "Arki",
    "officename": "Dhundan SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "174001": {
    "state": "Himachal Pradesh",
    "district": "Bilaspur (HP)",
    "block": "Bilaspur",
    "officename": "Bilaspur Bilaspur HP HO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "174002": {
    "state": "Himachal Pradesh",
    "district": "Bilaspur (HP)",
    "block": "Bilaspur",
    "officename": "Bassi Kehloor SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "174003": {
    "state": "Himachal Pradesh",
    "district": "Bilaspur (HP)",
    "block": "Ghumarwin",
    "officename": "Harlog SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "174004": {
    "state": "Himachal Pradesh",
    "district": "Bilaspur (HP)",
    "block": "Bilaspur",
    "officename": "Kandraur SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "174005": {
    "state": "Himachal Pradesh",
    "district": "Bilaspur (HP)",
    "block": "Blaspur",
    "officename": "Raghunath Pura SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "174011": {
    "state": "Himachal Pradesh",
    "district": "Bilaspur (HP)",
    "block": "Naina Devi",
    "officename": "Swarghat SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "174012": {
    "state": "Himachal Pradesh",
    "district": "Bilaspur (HP)",
    "block": "Bilaspur",
    "officename": "Panjgain SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "174013": {
    "state": "Himachal Pradesh",
    "district": "Bilaspur (HP)",
    "block": "Bilaspur",
    "officename": "Barmana SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "174015": {
    "state": "Himachal Pradesh",
    "district": "Bilaspur (HP)",
    "block": "Naina Devi",
    "officename": "Behal SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "174017": {
    "state": "Himachal Pradesh",
    "district": "Bilaspur (HP)",
    "block": "Ghumarwin",
    "officename": "Jejwin SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "174021": {
    "state": "Himachal Pradesh",
    "district": "Bilaspur (HP)",
    "block": "Ghumarwin",
    "officename": "Ghumarwin SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "174023": {
    "state": "Himachal Pradesh",
    "district": "Bilaspur (HP)",
    "block": "Ghumarwin",
    "officename": "Dadhol SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "174024": {
    "state": "Himachal Pradesh",
    "district": "Bilaspur (HP)",
    "block": "Ghumarwin",
    "officename": "Auhar SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "174026": {
    "state": "Himachal Pradesh",
    "district": "Bilaspur (HP)",
    "block": "Ghumarwin",
    "officename": "Kuthera BLP SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "174027": {
    "state": "Himachal Pradesh",
    "district": "Bilaspur (HP)",
    "block": "Ghumarwin",
    "officename": "Lehri Sarail SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "174028": {
    "state": "Himachal Pradesh",
    "district": "Bilaspur (HP)",
    "block": "Ghumarwin",
    "officename": "Hatwar SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "174029": {
    "state": "Himachal Pradesh",
    "district": "Bilaspur (HP)",
    "block": "Jhanduta",
    "officename": "Berthin SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "174030": {
    "state": "Himachal Pradesh",
    "district": "Bilaspur (HP)",
    "block": "Jhandutta",
    "officename": "Tallai SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "174031": {
    "state": "Himachal Pradesh",
    "district": "Bilaspur (HP)",
    "block": "Jhandutta",
    "officename": "Jhandutta SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "174032": {
    "state": "Himachal Pradesh",
    "district": "Bilaspur (HP)",
    "block": "Bilaspur",
    "officename": "Namhol SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "174033": {
    "state": "Himachal Pradesh",
    "district": "Bilaspur (HP)",
    "block": "Bilaspur",
    "officename": "Jukhala SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "174034": {
    "state": "Himachal Pradesh",
    "district": "Bilaspur (HP)",
    "block": "Jhandutta",
    "officename": "Geharwin SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "174035": {
    "state": "Himachal Pradesh",
    "district": "Bilaspur (HP)",
    "block": "Jhandutha",
    "officename": "Kalol SO Bilaspur HP",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "174036": {
    "state": "Himachal Pradesh",
    "district": "Bilaspur (HP)",
    "block": "NA",
    "officename": "NTPC Jamthal SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "174101": {
    "state": "Himachal Pradesh",
    "district": "Solan",
    "block": "Kasauli",
    "officename": "Nalagarh SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "174102": {
    "state": "Himachal Pradesh",
    "district": "Solan",
    "block": "Kasauli",
    "officename": "Ramshahar SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "174103": {
    "state": "Himachal Pradesh",
    "district": "Solan",
    "block": "Kasauli",
    "officename": "Barotiwala SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "174201": {
    "state": "Himachal Pradesh",
    "district": "Bilaspur (HP)",
    "block": "Naina Devi",
    "officename": "Bhakra Dam SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "174301": {
    "state": "Himachal Pradesh",
    "district": "Una",
    "block": "Una",
    "officename": "Santokhgarh SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Una Division"
  },
  "174302": {
    "state": "Himachal Pradesh",
    "district": "Una",
    "block": "Amb",
    "officename": "Dhussara SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Una Division"
  },
  "174303": {
    "state": "Himachal Pradesh",
    "district": "Una",
    "block": "Una",
    "officename": "Una HO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Una Division"
  },
  "174304": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Barsar",
    "officename": "Bani SO HamirpurHP",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "174305": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Barsar",
    "officename": "Barsar HO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "174306": {
    "state": "Himachal Pradesh",
    "district": "Una",
    "block": "Una",
    "officename": "Dehlan SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Una Division"
  },
  "174307": {
    "state": "Himachal Pradesh",
    "district": "Una",
    "block": "Bangana(T)",
    "officename": "Bangana SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Una Division"
  },
  "174308": {
    "state": "Himachal Pradesh",
    "district": "Una",
    "block": "Bangana(T)",
    "officename": "Lathiani SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Una Division"
  },
  "174309": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Barsar",
    "officename": "Bahina SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "174310": {
    "state": "Himachal Pradesh",
    "district": "Bilaspur (HP)",
    "block": "Naina Devi",
    "officename": "Naina Devi SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "174311": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Bijhari",
    "officename": "Salauni SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "174312": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Barsar",
    "officename": "Jaure Amb SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "174314": {
    "state": "Himachal Pradesh",
    "district": "Una",
    "block": "Bangana",
    "officename": "Chowki Maniar SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Una Division"
  },
  "174315": {
    "state": "Himachal Pradesh",
    "district": "Una",
    "block": "Una(T)",
    "officename": "Mehatpur SO Una",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Una Division"
  },
  "174316": {
    "state": "Himachal Pradesh",
    "district": "Una",
    "block": "Amb",
    "officename": "Bhera SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Una Division"
  },
  "174317": {
    "state": "Himachal Pradesh",
    "district": "Una",
    "block": "Haroli",
    "officename": "Bhadsali SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Una Division"
  },
  "174319": {
    "state": "Himachal Pradesh",
    "district": "Una",
    "block": "Amb(T)",
    "officename": "Marwari SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Una Division"
  },
  "174320": {
    "state": "Himachal Pradesh",
    "district": "Una",
    "block": "Bangana",
    "officename": "Talmehra SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Una Division"
  },
  "174321": {
    "state": "Himachal Pradesh",
    "district": "Una",
    "block": "Bangana(T)",
    "officename": "Thanakalan SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Una Division"
  },
  "174405": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Nadaun",
    "officename": "Hareta SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "174503": {
    "state": "Himachal Pradesh",
    "district": "Una",
    "block": "Haroli",
    "officename": "Pubowal SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Una Division"
  },
  "174505": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Hamirpur",
    "officename": "Dhaned SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "174507": {
    "state": "Himachal Pradesh",
    "district": "Una",
    "block": "Haroli",
    "officename": "Tahliwal SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Una Division"
  },
  "175001": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Sadar",
    "officename": "Mandi HO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175002": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Sundarnagar(T)",
    "officename": "Bhojpur SO Mandi",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175003": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Sadar",
    "officename": "Kotli SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175004": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Sarkaghat",
    "officename": "Bhambla SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175005": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Sadar",
    "officename": "Kataula SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175006": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Sadar",
    "officename": "Gagal SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175007": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Sarkaghat",
    "officename": "Gopalpur SO Mandi",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175008": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Sadar",
    "officename": "Ner Chowk SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175009": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Karsog",
    "officename": "Tattapani SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175010": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Karsog",
    "officename": "Churag SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175011": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Karsog",
    "officename": "Karsog SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175012": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Joginder Nagar",
    "officename": "Padhar SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175013": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Baijnath",
    "officename": "Barot SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175014": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Jogindernagar",
    "officename": "Drubbal SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175015": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Jogindarnagar(T)",
    "officename": "Joginder Nagar SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175016": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Lad Bharol(T)",
    "officename": "Ladbharole SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175017": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Sunder Nagar",
    "officename": "Slapper SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175018": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Sunder Nagar",
    "officename": "Sunder Nagar1 SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175019": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Sunder Nagar",
    "officename": "Sunder Nagar Township HO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175021": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Sadar",
    "officename": "Bhangrotu SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175023": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Sadar",
    "officename": "Rewalsar SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175024": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Sarkaghat",
    "officename": "Sarkaghat SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175025": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Sarkaghat",
    "officename": "Sajao Pipluso SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175026": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Sarkaghat",
    "officename": "Tihra SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175027": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Sadar",
    "officename": "Baggi SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175028": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Chachiot",
    "officename": "Chachiot SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175029": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Chachiot",
    "officename": "Gohar SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175030": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Sundarnagar(T)",
    "officename": "Dehar SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175031": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Nihri(S.T)",
    "officename": "Jaidevi SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175032": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Jogindernagar",
    "officename": "Chauntra SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175033": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Sarkaghat",
    "officename": "Baldwara SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175034": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Sarkaghat",
    "officename": "Samaila SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175035": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Thunag(T)",
    "officename": "Bagsaid SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175036": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Sadar",
    "officename": "Gurkotha SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175037": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Sarkaghat(T)",
    "officename": "Cholthra SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175038": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Sunder Nagar",
    "officename": "Nihri SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175039": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Chachiot",
    "officename": "Jachh SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175040": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Dharmpur(S.T)",
    "officename": "Dharampur SO Mandi",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175042": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Sarkaghat(T)",
    "officename": "Rakhoh SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175046": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Karsog",
    "officename": "Pangna SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175047": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Thunag(T)",
    "officename": "Janjehli SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175048": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Thunag",
    "officename": "Thunag SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175049": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Sarkaghat",
    "officename": "Jamni SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175050": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Sarkaghat",
    "officename": "Marhi SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175051": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Sarkaghat",
    "officename": "Seoh SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175052": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Sadar",
    "officename": "Saigaloo SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175101": {
    "state": "Himachal Pradesh",
    "district": "Kullu",
    "block": "Kullu",
    "officename": "Kullu HO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175102": {
    "state": "Himachal Pradesh",
    "district": "Kullu",
    "block": "Kullu",
    "officename": "Bhutti SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175103": {
    "state": "Himachal Pradesh",
    "district": "Kullu",
    "block": "Manali(T)",
    "officename": "Bahang SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175104": {
    "state": "Himachal Pradesh",
    "district": "Kullu",
    "block": "Kullu(T)",
    "officename": "Larenkelo SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175105": {
    "state": "Himachal Pradesh",
    "district": "Kullu",
    "block": "Kullu(T)",
    "officename": "Jaree SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175106": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Thunag",
    "officename": "Balichowki SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175121": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Mandi",
    "officename": "Aut SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175123": {
    "state": "Himachal Pradesh",
    "district": "Kullu",
    "block": "Banjar(T)",
    "officename": "Banjar SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175124": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Sadar",
    "officename": "Pandoh SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175125": {
    "state": "Himachal Pradesh",
    "district": "Kullu",
    "block": "Kullu",
    "officename": "Bhuntar SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175126": {
    "state": "Himachal Pradesh",
    "district": "Kullu",
    "block": "Banjar",
    "officename": "Shamshi SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175128": {
    "state": "Himachal Pradesh",
    "district": "Kullu",
    "block": "Naggar",
    "officename": "Raison SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175129": {
    "state": "Himachal Pradesh",
    "district": "Kullu",
    "block": "Naggar",
    "officename": "Katrain SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175130": {
    "state": "Himachal Pradesh",
    "district": "Kullu",
    "block": "Naggar",
    "officename": "Naggar SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175131": {
    "state": "Himachal Pradesh",
    "district": "Kullu",
    "block": "Naggar",
    "officename": "Manali SO Kullu",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175132": {
    "state": "Himachal Pradesh",
    "district": "Lahul & Spiti",
    "block": "Lahaul",
    "officename": "Keylong HO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175133": {
    "state": "Himachal Pradesh",
    "district": "Lahul & Spiti",
    "block": "Lahaul",
    "officename": "Lote SO Lahul  Spiti",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175134": {
    "state": "Himachal Pradesh",
    "district": "Kullu",
    "block": "Sainj(S.T)",
    "officename": "Sainj SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175136": {
    "state": "Himachal Pradesh",
    "district": "Kullu",
    "block": "Kullu(T)",
    "officename": "Haripur SO Kullu",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175138": {
    "state": "Himachal Pradesh",
    "district": "Kullu",
    "block": "Kullu(T)",
    "officename": "Babeli SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175139": {
    "state": "Himachal Pradesh",
    "district": "Lahul & Spiti",
    "block": "Lahaul",
    "officename": "Jahalman SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175140": {
    "state": "Himachal Pradesh",
    "district": "Lahul & Spiti",
    "block": "Lahaul",
    "officename": "Gondhla SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175141": {
    "state": "Himachal Pradesh",
    "district": "Kullu",
    "block": "Kullu(T)",
    "officename": "Garsa SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175142": {
    "state": "Himachal Pradesh",
    "district": "Lahul & Spiti",
    "block": "Udaipur",
    "officename": "Udaipur SO HP Circle",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175143": {
    "state": "Himachal Pradesh",
    "district": "Kullu",
    "block": "Naggar",
    "officename": "Jagatsukh SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "176001": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Kangra",
    "officename": "Kangra HO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "176021": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Jawali(T)",
    "officename": "Bharmar SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "176022": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Nurpur(T)",
    "officename": "Rehan SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "176023": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Jawali",
    "officename": "Jawali SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "176025": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Fatehpur(T)",
    "officename": "Dhameta SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "176026": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Kangra",
    "officename": "Lanj SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "176027": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Jawali(T)",
    "officename": "Nagrota Surian SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "176028": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Dera Gopipur(T)",
    "officename": "Haripur SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "176029": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Baroh",
    "officename": "Ranital SO Kangra",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "176030": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Khundian(T)",
    "officename": "Khundian SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "176031": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Dera Gopipur(T)",
    "officename": "Jawalamukhi SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "176032": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Khuandian",
    "officename": "Tihri SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "176033": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Dehra",
    "officename": "Guler SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "176036": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Dehra",
    "officename": "Kohala SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "176037": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Baroh",
    "officename": "Sunhi SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "176038": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Kangra(T)",
    "officename": "Daulatpur SO Kangra",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "176039": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Bijhari",
    "officename": "Chakmoh SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "176040": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Bijhari",
    "officename": "Bijhari SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "176041": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Bhoranj",
    "officename": "Bhota SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "176042": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Ghumarwin",
    "officename": "Mair SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "176043": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Ghumarwin",
    "officename": "Ladraur SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "176044": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Ghumarwin",
    "officename": "Mundkhar SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "176045": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Bhoranj",
    "officename": "Bhoranj SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "176047": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Kangra(T)",
    "officename": "Nagrota Bagwan SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "176048": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Bhoranj",
    "officename": "Jahu SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "176049": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Bijhari",
    "officename": "Maharal SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "176051": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Jawali(T)",
    "officename": "Raja Ka Talab SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "176052": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Palampur",
    "officename": "Yol Camp SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176053": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Fatehpur",
    "officename": "Fatehpur SO Kangra",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "176054": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Baroh(T)",
    "officename": "Baroh SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "176055": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Dehra",
    "officename": "Thill SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "176056": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Kangra(T)",
    "officename": "Sunehar SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "176057": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Dharamsala",
    "officename": "Dari SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176058": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Nurpur",
    "officename": "Rey SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176059": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Palampur",
    "officename": "Chachian SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176060": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Palampur",
    "officename": "Darang SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176061": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Palampur",
    "officename": "Palampur HO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176062": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Palampur",
    "officename": "Auc Palampur SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176063": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Baijnath",
    "officename": "Majherna SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176064": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Palampur",
    "officename": "Paraur SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176065": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Palampur",
    "officename": "Rajhoon SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176066": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Dera Gopipur(T)",
    "officename": "Ghallour SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "176071": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Palampur",
    "officename": "Bhullanaso SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176073": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Palampur",
    "officename": "Bairhgat SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176075": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Palampur",
    "officename": "Duhak SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176076": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Palampur",
    "officename": "Bhawana SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176077": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Baijnath",
    "officename": "Bir SO Kangra",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176081": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Baijnath",
    "officename": "Taragarh Kangra SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176082": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Jaiinghpur",
    "officename": "Alampur SO Kangra",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176083": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Palampur",
    "officename": "Bhawarna SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176084": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Palampur",
    "officename": "Noura SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176085": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Palampur",
    "officename": "Sullah SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176086": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Palampur",
    "officename": "Khera SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176087": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Palampur",
    "officename": "Pahra SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176088": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Palampur",
    "officename": "Chadhiar SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176089": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Jaisinghpur",
    "officename": "Molag SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176090": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Sandhol(S.T)",
    "officename": "Sandhole SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "176091": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Jaisinghpur",
    "officename": "Sanghole SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176092": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Palampur",
    "officename": "Daroh SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176093": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Palampur",
    "officename": "Malkher SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176094": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Jaisinghpur",
    "officename": "Jalag SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176095": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Jaisinghpur",
    "officename": "Jaisinghpur SO Kangra",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176096": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Jaisinghpur",
    "officename": "Lambagaon SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176097": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Jaisinghpur",
    "officename": "Marera SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176098": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Jaisinghpur",
    "officename": "Lahru SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176101": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Palampur",
    "officename": "Dheera SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176102": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Palampur",
    "officename": "Maranda SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176103": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Baijnath",
    "officename": "Panchrukhi SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176107": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Jaisinghpur",
    "officename": "Thural SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176108": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Tira Sujanpur(T)",
    "officename": "Bhaleth SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "176109": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Sujanpur",
    "officename": "Jangal Beri SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "176110": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Hamirpur(T)",
    "officename": "Sujanpur Tira SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "176111": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Sp Tira",
    "officename": "Patlander SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "176115": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Baijnath",
    "officename": "Paprola SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176125": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Baijnath",
    "officename": "Baijnath SO Kangra",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176128": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Baijnath",
    "officename": "Chobin SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176200": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Nurpur",
    "officename": "Bhadwar SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176201": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Nurpur",
    "officename": "Jassur SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176202": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Nurpur",
    "officename": "Nurpur SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176203": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Nurpur",
    "officename": "Ladori SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176204": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Nurpur",
    "officename": "Gangtha SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176205": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Kotla",
    "officename": "Kotla SO Kangra",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176206": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Shahpur",
    "officename": "Shahpur Kangra SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176207": {
    "state": "Himachal Pradesh",
    "district": "Chamba",
    "block": "Sihunta",
    "officename": "Sihunta SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamba Division"
  },
  "176208": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Shahpur(T)",
    "officename": "Rait SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "176209": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Kangra",
    "officename": "Gaggal SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "176210": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Shahpur",
    "officename": "Harchakian SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176211": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Nurpur",
    "officename": "Saliali SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176214": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Kangra",
    "officename": "Tiara SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "176215": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Dharamsala",
    "officename": "Dharamsala HO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176216": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Dharamsala",
    "officename": "Dharamsala Cantt SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176217": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Sahpur",
    "officename": "Charri SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176218": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Dharamsala",
    "officename": "Khaniara SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176225": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Jawali",
    "officename": "Tilokpur SO Kangra",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176301": {
    "state": "Himachal Pradesh",
    "district": "Chamba",
    "block": "Bhatiyat",
    "officename": "Bakloh SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamba Division"
  },
  "176302": {
    "state": "Himachal Pradesh",
    "district": "Chamba",
    "block": "Bhatiyat",
    "officename": "Chowari SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamba Division"
  },
  "176303": {
    "state": "Himachal Pradesh",
    "district": "Chamba",
    "block": "Bhatiyat",
    "officename": "Banikhet SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamba Division"
  },
  "176304": {
    "state": "Himachal Pradesh",
    "district": "Chamba",
    "block": "Bhatiyat",
    "officename": "Dalhousie SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamba Division"
  },
  "176305": {
    "state": "Himachal Pradesh",
    "district": "Chamba",
    "block": "Dalhousie(T)",
    "officename": "Dalhousie cantt",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamba Division"
  },
  "176306": {
    "state": "Himachal Pradesh",
    "district": "Chamba",
    "block": "Bhatiyat",
    "officename": "BATHRI BAZAR SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamba Division"
  },
  "176308": {
    "state": "Himachal Pradesh",
    "district": "Chamba",
    "block": "Bhalei",
    "officename": "BHALEI SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamba Division"
  },
  "176309": {
    "state": "Himachal Pradesh",
    "district": "Chamba",
    "block": "Holi",
    "officename": "Garola SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamba Division"
  },
  "176310": {
    "state": "Himachal Pradesh",
    "district": "Chamba",
    "block": "Chamba(T)",
    "officename": "Chamba HO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamba Division"
  },
  "176311": {
    "state": "Himachal Pradesh",
    "district": "Chamba",
    "block": "Chamba",
    "officename": "Mehla SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamba Division"
  },
  "176312": {
    "state": "Himachal Pradesh",
    "district": "Chamba",
    "block": "Salooni",
    "officename": "Sundla SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamba Division"
  },
  "176313": {
    "state": "Himachal Pradesh",
    "district": "Chamba",
    "block": "Bhatiyat",
    "officename": "Kakira SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamba Division"
  },
  "176314": {
    "state": "Himachal Pradesh",
    "district": "Chamba",
    "block": "Chamba",
    "officename": "Sultanpur SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamba Division"
  },
  "176315": {
    "state": "Himachal Pradesh",
    "district": "Chamba",
    "block": "Bharmour",
    "officename": "Bharmour SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamba Division"
  },
  "176316": {
    "state": "Himachal Pradesh",
    "district": "Chamba",
    "block": "Churah",
    "officename": "Bhanjraru Tissa",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamba Division"
  },
  "176317": {
    "state": "Himachal Pradesh",
    "district": "Chamba",
    "block": "Salooni",
    "officename": "Surangani SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamba Division"
  },
  "176318": {
    "state": "Himachal Pradesh",
    "district": "Chamba",
    "block": "Chamba",
    "officename": "Hardaspura SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamba Division"
  },
  "176319": {
    "state": "Himachal Pradesh",
    "district": "Chamba",
    "block": "Chamba",
    "officename": "Pukhri SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamba Division"
  },
  "176320": {
    "state": "Himachal Pradesh",
    "district": "Chamba",
    "block": "Salooni",
    "officename": "Salooni SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamba Division"
  },
  "176321": {
    "state": "Himachal Pradesh",
    "district": "Chamba",
    "block": "Salooni",
    "officename": "Nakror SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamba Division"
  },
  "176323": {
    "state": "Himachal Pradesh",
    "district": "Chamba",
    "block": "Pangi",
    "officename": "Killar Pangi SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamba Division"
  },
  "176324": {
    "state": "Himachal Pradesh",
    "district": "Chamba",
    "block": "Bharmour",
    "officename": "Gehra SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamba Division"
  },
  "176325": {
    "state": "Himachal Pradesh",
    "district": "Chamba",
    "block": "Bhallai",
    "officename": "Samleu SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamba Division"
  },
  "176401": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Indora",
    "officename": "Indora SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176402": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Nurpur",
    "officename": "Kandrori SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176403": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Nurpur",
    "officename": "Damtal SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176501": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Quasba Kotla",
    "officename": "Sansarpur Terrace SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "176502": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Jaswan(T)",
    "officename": "Ghamroor SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "176601": {
    "state": "Himachal Pradesh",
    "district": "Una",
    "block": "Haroli",
    "officename": "Dulehar SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Una Division"
  },
  "177001": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Hamirpur",
    "officename": "Hamirpur HO HP Circle",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "177005": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Hamirpur(T)",
    "officename": "Govt Degree College Hamirpur SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "177006": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Nadaun",
    "officename": "Kashmir SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "177007": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Hamirpur",
    "officename": "Chabutra SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "177020": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Hamirpur",
    "officename": "Kuthera SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "177021": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Bhoranj",
    "officename": "Bagwara SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "177022": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Sp Tira",
    "officename": "Uhal SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "177023": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Hamirpur",
    "officename": "Tauni Devi SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "177024": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Bhoranj",
    "officename": "Bhareri SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "177025": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Bhorang",
    "officename": "Kanjian SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "177026": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Nadaun",
    "officename": "Galore SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "177027": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Hamirpur",
    "officename": "Kot SO HamirpurHP",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "177028": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Sp Tira",
    "officename": "Kakkar SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "177029": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Hamirpur",
    "officename": "Lambloo SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "177031": {
    "state": "Himachal Pradesh",
    "district": "Una",
    "block": "Bangana(T)",
    "officename": "Raipur SO Una",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Una Division"
  },
  "177033": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Nadaun",
    "officename": "Nadaun SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "177034": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Rakkar",
    "officename": "Pirsaluhi SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "177038": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Nadaun(T)",
    "officename": "Sera SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "177039": {
    "state": "Himachal Pradesh",
    "district": "Una",
    "block": "Bangana",
    "officename": "Sohari SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Una Division"
  },
  "177040": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Nadaun",
    "officename": "Kangoo SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "177041": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Nadaun",
    "officename": "Dhaneta SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "177042": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Nadaun(T)",
    "officename": "Jalari SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "177043": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Rakkar(S.T)",
    "officename": "Rakkar SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "177044": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Nadaun",
    "officename": "Bara SO HamirpurHP",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "177045": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Nadaun",
    "officename": "Rail SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "177048": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Nadaun",
    "officename": "Rangas SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "177101": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Dehra Gopipur",
    "officename": "Dehra HO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "177103": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Shahpur(T)",
    "officename": "Dhaliara SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "177104": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Dehra",
    "officename": "Nehran Pukhar SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "177105": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Shahpur(T)",
    "officename": "Thore SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "177106": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Dehra",
    "officename": "Dadasiba SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "177107": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Dehra",
    "officename": "Pragpur SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "177108": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Dehra",
    "officename": "Garli SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "177109": {
    "state": "Himachal Pradesh",
    "district": "Una",
    "block": "Bharwain",
    "officename": "Bharwain SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Una Division"
  },
  "177110": {
    "state": "Himachal Pradesh",
    "district": "Una",
    "block": "Bharwain(S.T)",
    "officename": "Chintpurni SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Una Division"
  },
  "177111": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Quasba Kotla",
    "officename": "Qusba Kotla SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "177112": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Jaswan(T)",
    "officename": "Tipri SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "177113": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Dehra",
    "officename": "Chanour SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "177114": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Dehra",
    "officename": "Bankhandi SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "177117": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Dehra",
    "officename": "Muhal SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "177118": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Bhoranj",
    "officename": "Bahanwin SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "177119": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Barsar(T)",
    "officename": "Bumbloo SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "177201": {
    "state": "Himachal Pradesh",
    "district": "Una",
    "block": "Amb(T)",
    "officename": "Gagret SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Una Division"
  },
  "177202": {
    "state": "Himachal Pradesh",
    "district": "Una",
    "block": "Amb",
    "officename": "Mubarikpur SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Una Division"
  },
  "177203": {
    "state": "Himachal Pradesh",
    "district": "Una",
    "block": "Amb",
    "officename": "Amb SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Una Division"
  },
  "177204": {
    "state": "Himachal Pradesh",
    "district": "Una",
    "block": "Amb",
    "officename": "Daulatpurchowk SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Una Division"
  },
  "177205": {
    "state": "Himachal Pradesh",
    "district": "Una",
    "block": "Amb",
    "officename": "Ambota SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Una Division"
  },
  "177206": {
    "state": "Himachal Pradesh",
    "district": "Una",
    "block": "Amb(T)",
    "officename": "Oel SO Una",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Una Division"
  },
  "177207": {
    "state": "Himachal Pradesh",
    "district": "Una",
    "block": "Haroli",
    "officename": "Pandogha SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Una Division"
  },
  "177208": {
    "state": "Himachal Pradesh",
    "district": "Una",
    "block": "Amb",
    "officename": "Panjawar SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Una Division"
  },
  "177209": {
    "state": "Himachal Pradesh",
    "district": "Una",
    "block": "Haroli",
    "officename": "Saloh SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Una Division"
  },
  "177210": {
    "state": "Himachal Pradesh",
    "district": "Una",
    "block": "Amb",
    "officename": "Nehri Nauranga SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Una Division"
  },
  "177211": {
    "state": "Himachal Pradesh",
    "district": "Una",
    "block": "Amb",
    "officename": "Thathal SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Una Division"
  },
  "177212": {
    "state": "Himachal Pradesh",
    "district": "Una",
    "block": "Amb(T)",
    "officename": "Ghanari SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Una Division"
  },
  "177213": {
    "state": "Himachal Pradesh",
    "district": "Una",
    "block": "Amb",
    "officename": "Gondpur Banera SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Una Division"
  },
  "177219": {
    "state": "Himachal Pradesh",
    "district": "Una",
    "block": "Amb(T)",
    "officename": "Sunkali SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Una Division"
  },
  "177220": {
    "state": "Himachal Pradesh",
    "district": "Una",
    "block": "Haroli",
    "officename": "Haroli SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Una Division"
  },
  "177301": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Nadaun",
    "officename": "Basaral SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "177401": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Hamirpur",
    "officename": "Didwin SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "177501": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Bhoranj",
    "officename": "Parol SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "177601": {
    "state": "Himachal Pradesh",
    "district": "Hamirpur(HP)",
    "block": "Bhoranj(T)",
    "officename": "Awah Devi SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hamirpur Division"
  },
  "180001": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Jammu HO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "180002": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Talab Tillo SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "180003": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Jammu Cantt SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "180004": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Gandhinagar HO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "180005": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Rehari Mohalla SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "180006": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "New University Campus SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "180007": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Janipur SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "180009": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "jammu",
    "officename": "SKUASTCHATHA SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "180010": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Gangyal SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "180011": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Sainik Colony SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "180012": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "jammu",
    "officename": "Railway Station SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "180013": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Roopnagar Jammu Tawi SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "180015": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Chani Himat SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "180016": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Vinaik Bazar SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "180017": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Majeen SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "180018": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Udheywala SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "180019": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Sidhra Housing colony",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "180020": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "TRIKUTA NAGAR",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "181101": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Miran Sahib SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "181102": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "RSPura SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "181111": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Dablehar SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "181121": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Paloura SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "181122": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Bhalwal SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "181123": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Bantalab SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "181124": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Bsf Camp Paloura SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "181131": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Arnia SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "181132": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Bishnah Adda SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "181133": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Bari Brahmna Icomplex SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "181141": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Samba",
    "officename": "Ramgarh SO Jammu",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "181143": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Gurah Salathia SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "181145": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Purmandal SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "181152": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Bathindi SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "181201": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Akhnoor SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "181202": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Jourian SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "181203": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Khour SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "181204": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Pallanwala SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "181205": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Muthi SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "181206": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Dumana SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "181207": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Pargwal SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "181221": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Kandoli Nagrota SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "181224": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Dansal SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "182101": {
    "state": "Jammu & Kashmir",
    "district": "Udhampur",
    "block": "Udhampur",
    "officename": "Udhampur HO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182104": {
    "state": "Jammu & Kashmir",
    "district": "Udhampur",
    "block": "Udhampur",
    "officename": "PTC Udhampur SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182121": {
    "state": "Jammu & Kashmir",
    "district": "Udhampur",
    "block": "Udhampur",
    "officename": "Garhi SO Udhampur",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182122": {
    "state": "Jammu & Kashmir",
    "district": "Udhampur",
    "block": "Ramnagar",
    "officename": "Ramnagar SO Udhampur",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182124": {
    "state": "Jammu & Kashmir",
    "district": "Udhampur",
    "block": "Udhampur",
    "officename": "Jaganoo SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182125": {
    "state": "Jammu & Kashmir",
    "district": "Udhampur",
    "block": "Udhampur",
    "officename": "Mir SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182126": {
    "state": "Jammu & Kashmir",
    "district": "Udhampur",
    "block": "Udhampur",
    "officename": "Roan SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182127": {
    "state": "Jammu & Kashmir",
    "district": "Udhampur",
    "block": "Ramnagar",
    "officename": "Majalta SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182128": {
    "state": "Jammu & Kashmir",
    "district": "Udhampur",
    "block": "Ramnagar",
    "officename": "Majouri SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182141": {
    "state": "Jammu & Kashmir",
    "district": "Udhampur",
    "block": "Chenani",
    "officename": "Chenani SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182142": {
    "state": "Jammu & Kashmir",
    "district": "Udhampur",
    "block": "Chenani",
    "officename": "Kud SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182143": {
    "state": "Jammu & Kashmir",
    "district": "Doda",
    "block": "Ramban",
    "officename": "Batote SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182144": {
    "state": "Jammu & Kashmir",
    "district": "Doda",
    "block": "Doda",
    "officename": "Ramban SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182145": {
    "state": "Jammu & Kashmir",
    "district": "Doda",
    "block": "Ramban",
    "officename": "Ramsu SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182146": {
    "state": "Jammu & Kashmir",
    "district": "Doda",
    "block": "Ramban",
    "officename": "Banihal SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182147": {
    "state": "Jammu & Kashmir",
    "district": "Doda",
    "block": "Doda",
    "officename": "Kastigarh SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182148": {
    "state": "Jammu & Kashmir",
    "district": "Doda",
    "block": "Ramban",
    "officename": "Chanderkot SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182161": {
    "state": "Jammu & Kashmir",
    "district": "Udhampur",
    "block": "Chenani",
    "officename": "Mantalai SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182201": {
    "state": "Jammu & Kashmir",
    "district": "Doda",
    "block": "Doda",
    "officename": "Khellani SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182202": {
    "state": "Jammu & Kashmir",
    "district": "Doda",
    "block": "Doda",
    "officename": "Doda SO Doda",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182203": {
    "state": "Jammu & Kashmir",
    "district": "Doda",
    "block": "Thathri",
    "officename": "Thathri SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182204": {
    "state": "Jammu & Kashmir",
    "district": "Doda",
    "block": "Kishtwar",
    "officename": "Kishtwar SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182205": {
    "state": "Jammu & Kashmir",
    "district": "Doda",
    "block": "Kishtwar",
    "officename": "Palmar SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182206": {
    "state": "Jammu & Kashmir",
    "district": "Doda",
    "block": "Kishtwar",
    "officename": "Dul Hasti Project SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182221": {
    "state": "Jammu & Kashmir",
    "district": "Doda",
    "block": "Bhaderwah",
    "officename": "Udrana SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182222": {
    "state": "Jammu & Kashmir",
    "district": "Doda",
    "block": "Bhaderwah",
    "officename": "Bhaderwah SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182301": {
    "state": "Jammu & Kashmir",
    "district": "Udhampur",
    "block": "Reasi",
    "officename": "Katra SO Udhampur",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182311": {
    "state": "Jammu & Kashmir",
    "district": "Udhampur",
    "block": "Reasi",
    "officename": "Reasi SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182312": {
    "state": "Jammu & Kashmir",
    "district": "Udhampur",
    "block": "Reasi",
    "officename": "Jyotipuram SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182313": {
    "state": "Jammu & Kashmir",
    "district": "Udhampur",
    "block": "Mahore",
    "officename": "Arnas SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182315": {
    "state": "Jammu & Kashmir",
    "district": "Udhampur",
    "block": "Mahore",
    "officename": "Mahore SO Udhampur",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182320": {
    "state": "Jammu & Kashmir",
    "district": "Udhampur",
    "block": "Udhampur",
    "officename": "SMVDU SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "184101": {
    "state": "Jammu & Kashmir",
    "district": "Kathua",
    "block": "Kathua",
    "officename": "Kathua HO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "184102": {
    "state": "Jammu & Kashmir",
    "district": "Kathua",
    "block": "Kathua",
    "officename": "Ie Kathua SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "184104": {
    "state": "Jammu & Kashmir",
    "district": "Kathua",
    "block": "Kathua",
    "officename": "Mini Sectt Kathua SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "184120": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Samba",
    "officename": "Vijaypur SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "184121": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Samba SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "184141": {
    "state": "Jammu & Kashmir",
    "district": "Kathua",
    "block": "Hiranagar",
    "officename": "Ghagwal SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "184142": {
    "state": "Jammu & Kashmir",
    "district": "Kathua",
    "block": "Hiranagar",
    "officename": "Hiranagar SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "184143": {
    "state": "Jammu & Kashmir",
    "district": "Kathua",
    "block": "Kathua",
    "officename": "Barwal SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "184144": {
    "state": "Jammu & Kashmir",
    "district": "Kathua",
    "block": "Hiranagar",
    "officename": "Dialachak SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "184145": {
    "state": "Jammu & Kashmir",
    "district": "Kathua",
    "block": "Hiranagar",
    "officename": "Rajpura SO Kathua",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "184148": {
    "state": "Jammu & Kashmir",
    "district": "Kathua",
    "block": "Hiranagar",
    "officename": "Sanjimore SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "184151": {
    "state": "Jammu & Kashmir",
    "district": "Kathua",
    "block": "Kathua",
    "officename": "Parole SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "184152": {
    "state": "Jammu & Kashmir",
    "district": "Kathua",
    "block": "Kathua",
    "officename": "Lakhanpur SO Kathua",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "184201": {
    "state": "Jammu & Kashmir",
    "district": "Kathua",
    "block": "Bashohli",
    "officename": "Basoli SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "184202": {
    "state": "Jammu & Kashmir",
    "district": "Kathua",
    "block": "Basoli",
    "officename": "Mahanpur SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "184203": {
    "state": "Jammu & Kashmir",
    "district": "Kathua",
    "block": "Billawar",
    "officename": "Bhaddu SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "184204": {
    "state": "Jammu & Kashmir",
    "district": "Kathua",
    "block": "Billawar",
    "officename": "Billawar SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "184205": {
    "state": "Jammu & Kashmir",
    "district": "Kathua",
    "block": "Billawar",
    "officename": "Ramkot SO Kathua",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "184206": {
    "state": "Jammu & Kashmir",
    "district": "Kathua",
    "block": "Bani",
    "officename": "Bani SO Kathua",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "185101": {
    "state": "Jammu & Kashmir",
    "district": "Poonch",
    "block": "Poonch",
    "officename": "Poonch SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Rajouri Division"
  },
  "185102": {
    "state": "Jammu & Kashmir",
    "district": "Poonch",
    "block": "Poonch",
    "officename": "Mandi SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Rajouri Division"
  },
  "185121": {
    "state": "Jammu & Kashmir",
    "district": "Poonch",
    "block": "Rajouri",
    "officename": "Samote SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Rajouri Division"
  },
  "185131": {
    "state": "Jammu & Kashmir",
    "district": "Rajauri",
    "block": "Rajouri",
    "officename": "Rajouri HO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Rajouri Division"
  },
  "185132": {
    "state": "Jammu & Kashmir",
    "district": "Rajauri",
    "block": "Rajouri",
    "officename": "Jawaharnagar SO Rajauri",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Rajouri Division"
  },
  "185135": {
    "state": "Jammu & Kashmir",
    "district": "Rajauri",
    "block": "Jammu",
    "officename": "Darhal Malkan SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Rajouri Division"
  },
  "185151": {
    "state": "Jammu & Kashmir",
    "district": "Rajauri",
    "block": "Rajouri",
    "officename": "Naushera SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Rajouri Division"
  },
  "185152": {
    "state": "Jammu & Kashmir",
    "district": "Rajauri",
    "block": "Rajouri",
    "officename": "Lamberi SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Rajouri Division"
  },
  "185153": {
    "state": "Jammu & Kashmir",
    "district": "Rajauri",
    "block": "Rajouri",
    "officename": "Sunderbani SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Rajouri Division"
  },
  "185154": {
    "state": "Jammu & Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Chowki Choura SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "185155": {
    "state": "Jammu & Kashmir",
    "district": "Rajauri",
    "block": "Rajouri",
    "officename": "Bhawani SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Rajouri Division"
  },
  "185156": {
    "state": "Jammu & Kashmir",
    "district": "Rajauri",
    "block": "Rajouri",
    "officename": "Kangri SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Rajouri Division"
  },
  "185201": {
    "state": "Jammu & Kashmir",
    "district": "Rajauri",
    "block": "Rajouri",
    "officename": "Solki SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Rajouri Division"
  },
  "185202": {
    "state": "Jammu & Kashmir",
    "district": "Rajauri",
    "block": "Rajouri",
    "officename": "Kalakot SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Rajouri Division"
  },
  "185203": {
    "state": "Jammu & Kashmir",
    "district": "Udhampur",
    "block": "Reasi",
    "officename": "Poni SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "185211": {
    "state": "Jammu & Kashmir",
    "district": "Poonch",
    "block": "Rajouri",
    "officename": "Dharamsal Mendhar SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Rajouri Division"
  },
  "185212": {
    "state": "Jammu & Kashmir",
    "district": "Rajauri",
    "block": "Rajouri",
    "officename": "Thanamandi SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Rajouri Division"
  },
  "185233": {
    "state": "Jammu & Kashmir",
    "district": "Reasi",
    "block": "Jammu",
    "officename": "Budhal SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Rajouri Division"
  },
  "185234": {
    "state": "Jammu & Kashmir",
    "district": "Rajauri",
    "block": "Rajouri",
    "officename": "Baba Ghulam Shah Badshah University SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Rajouri Division"
  },
  "190001": {
    "state": "Jammu & Kashmir",
    "district": "Srinagar",
    "block": "Badyar Balla",
    "officename": "Srinagar GPO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "190002": {
    "state": "Jammu & Kashmir",
    "district": "Srinagar",
    "block": "Srinagar",
    "officename": "SR Gunj SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "190003": {
    "state": "Jammu & Kashmir",
    "district": "Srinagar",
    "block": "Abi Karlpora",
    "officename": "Rainawari SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "190004": {
    "state": "Jammu & Kashmir",
    "district": "Srinagar",
    "block": "Batrara",
    "officename": "Batwara SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "190005": {
    "state": "Jammu & Kashmir",
    "district": "Budgam",
    "block": "Sanat Nagar",
    "officename": "Sanat Nagar SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "190006": {
    "state": "Jammu & Kashmir",
    "district": "Srinagar",
    "block": "Kashmir University",
    "officename": "Kashmir University",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "190007": {
    "state": "Jammu & Kashmir",
    "district": "Budgam",
    "block": "Budgam",
    "officename": "Sk Airport SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "190008": {
    "state": "Jammu & Kashmir",
    "district": "Srinagar",
    "block": "Jawahar Nagar",
    "officename": "Jawahar Nagar",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "190009": {
    "state": "Jammu & Kashmir",
    "district": "Srinagar",
    "block": "Srinagar",
    "officename": "New Secretariat Srinagar SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "190010": {
    "state": "Jammu & Kashmir",
    "district": "Srinagar",
    "block": "Karan Nagar",
    "officename": "Karan Nagar SO Srinagar",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "190011": {
    "state": "Jammu & Kashmir",
    "district": "Srinagar",
    "block": "Noushera",
    "officename": "Noushara SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "190012": {
    "state": "Jammu & Kashmir",
    "district": "Srinagar",
    "block": "Zainakote",
    "officename": "Zainakote SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "190014": {
    "state": "Jammu & Kashmir",
    "district": "Budgam",
    "block": "Hyderpora",
    "officename": "Hyderpora SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "190015": {
    "state": "Jammu & Kashmir",
    "district": "Srinagar",
    "block": "A K Pora",
    "officename": "Natipora SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "190017": {
    "state": "Jammu & Kashmir",
    "district": "Srinagar",
    "block": "Noushera",
    "officename": "Parimpora SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "190018": {
    "state": "Jammu & Kashmir",
    "district": "Srinagar",
    "block": "Noushera",
    "officename": "Bemina SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "190019": {
    "state": "Jammu & Kashmir",
    "district": "Srinagar",
    "block": "Bagh Mehtab",
    "officename": "Bagh Mehtab SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "190020": {
    "state": "Jammu & Kashmir",
    "district": "Srinagar",
    "block": "Noushera",
    "officename": "Buchpora SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "190021": {
    "state": "Jammu & Kashmir",
    "district": "Budgam",
    "block": "R H Hall",
    "officename": "Humhama SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "190023": {
    "state": "Jammu & Kashmir",
    "district": "Srinagar",
    "block": "Srinagar",
    "officename": "Lal Bazar SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "190024": {
    "state": "Jammu & Kashmir",
    "district": "Srinagar",
    "block": "Srinagar",
    "officename": "Zakoora",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "190025": {
    "state": "Jammu & Kashmir",
    "district": "Srinagar",
    "block": "Srinagar",
    "officename": "Skuast SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "191101": {
    "state": "Jammu & Kashmir",
    "district": "Srinagar",
    "block": "Noushera",
    "officename": "Pantha Chowk SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "191102": {
    "state": "Jammu & Kashmir",
    "district": "Srinagar",
    "block": "Wuyan",
    "officename": "Wuyan SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "191103": {
    "state": "Jammu & Kashmir",
    "district": "Srinagar",
    "block": "Khrew",
    "officename": "Khrew SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "191111": {
    "state": "Jammu & Kashmir",
    "district": "Budgam",
    "block": "Arath",
    "officename": "Budgam SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "191112": {
    "state": "Jammu & Kashmir",
    "district": "Budgam",
    "block": "Abhama",
    "officename": "Chrar-i-Sharief SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "191113": {
    "state": "Jammu & Kashmir",
    "district": "Budgam",
    "block": "R H Hall",
    "officename": "Chadoora SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "191121": {
    "state": "Jammu & Kashmir",
    "district": "Srinagar",
    "block": "Srinagar",
    "officename": "Brein",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "191131": {
    "state": "Jammu & Kashmir",
    "district": "Srinagar",
    "block": "Noushera",
    "officename": "Tulmulla SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "191132": {
    "state": "Jammu & Kashmir",
    "district": "Budgam",
    "block": "R H Hall",
    "officename": "Rangreth SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "191201": {
    "state": "Jammu & Kashmir",
    "district": "Srinagar",
    "block": "Ganderbal",
    "officename": "Ganderbal",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "191202": {
    "state": "Jammu & Kashmir",
    "district": "Srinagar",
    "block": "Kangan",
    "officename": "Kangan SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "192101": {
    "state": "Jammu & Kashmir",
    "district": "Ananthnag",
    "block": "Anantnag Ho",
    "officename": "Anantnag HO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "192121": {
    "state": "Jammu & Kashmir",
    "district": "Ananthnag",
    "block": "Pulwama",
    "officename": "Pampore SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "192122": {
    "state": "Jammu & Kashmir",
    "district": "Ananthnag",
    "block": "Awantipora",
    "officename": "Awantipora SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "192123": {
    "state": "Jammu & Kashmir",
    "district": "Pulwama",
    "block": "Aripal",
    "officename": "Tral SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "192124": {
    "state": "Jammu & Kashmir",
    "district": "Ananthnag",
    "block": "Awantipora",
    "officename": "Bijbehara SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "192125": {
    "state": "Jammu & Kashmir",
    "district": "Ananthnag",
    "block": "Anantnag",
    "officename": "Martand SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "192126": {
    "state": "Jammu & Kashmir",
    "district": "Ananthnag",
    "block": "Awantipora",
    "officename": "Pahalgam SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "192129": {
    "state": "Jammu & Kashmir",
    "district": "Ananthnag",
    "block": "Ananthnag",
    "officename": "S K Gund",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "192201": {
    "state": "Jammu & Kashmir",
    "district": "Ananthnag",
    "block": "Achabal",
    "officename": "Achabal SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "192202": {
    "state": "Jammu & Kashmir",
    "district": "Ananthnag",
    "block": "Awantipora",
    "officename": "Kokarnag SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "192210": {
    "state": "Jammu & Kashmir",
    "district": "Ananthnag",
    "block": "Dialgam",
    "officename": "Dialgam",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "192211": {
    "state": "Jammu & Kashmir",
    "district": "Ananthnag",
    "block": "Dooru",
    "officename": "Dooru SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "192212": {
    "state": "Jammu & Kashmir",
    "district": "Ananthnag",
    "block": "Bonagand",
    "officename": "Verinaag SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "192221": {
    "state": "Jammu & Kashmir",
    "district": "Ananthnag",
    "block": "Qazigund",
    "officename": "Qazigund SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "192231": {
    "state": "Jammu & Kashmir",
    "district": "Ananthnag",
    "block": "Awantipora",
    "officename": "Kulgam SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "192232": {
    "state": "Jammu & Kashmir",
    "district": "Ananthnag",
    "block": "Awenura",
    "officename": "Yaripora SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "192233": {
    "state": "Jammu & Kashmir",
    "district": "Kulgam",
    "block": "Damhal Hanji Pora",
    "officename": "Damhal Hanji Pora SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "192301": {
    "state": "Jammu & Kashmir",
    "district": "Pulwama",
    "block": "NA",
    "officename": "Pulwama SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "192302": {
    "state": "Jammu & Kashmir",
    "district": "Pulwama",
    "block": "NA",
    "officename": "Hawl SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "192303": {
    "state": "Jammu & Kashmir",
    "district": "Pulwama",
    "block": "Batpora",
    "officename": "Shopian SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "192304": {
    "state": "Jammu & Kashmir",
    "district": "Pulwama",
    "block": "Pulwama",
    "officename": "Kakapora",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "192305": {
    "state": "Jammu & Kashmir",
    "district": "Ananthnag",
    "block": "Achan",
    "officename": "Achan SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "192401": {
    "state": "Jammu & Kashmir",
    "district": "Ananthnag",
    "block": "Awantipora",
    "officename": "Srigufwaea SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "193101": {
    "state": "Jammu & Kashmir",
    "district": "Baramulla",
    "block": "Baramulla",
    "officename": "Baramulla H.O",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Baramulla Division"
  },
  "193103": {
    "state": "Jammu & Kashmir",
    "district": "Baramulla",
    "block": "Baramulla",
    "officename": "Khawaja Bagh S.O",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Baramulla Division"
  },
  "193108": {
    "state": "Jammu & Kashmir",
    "district": "Baramulla",
    "block": "Pattan",
    "officename": "Kreeri S.O",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Baramulla Division"
  },
  "193121": {
    "state": "Jammu & Kashmir",
    "district": "Baramulla",
    "block": "Pattan",
    "officename": "Pattan S.O",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Baramulla Division"
  },
  "193122": {
    "state": "Jammu & Kashmir",
    "district": "Baramulla",
    "block": "Uri",
    "officename": "Boniyar S.O",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Baramulla Division"
  },
  "193123": {
    "state": "Jammu & Kashmir",
    "district": "Baramulla",
    "block": "Uri",
    "officename": "Uri S.O",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Baramulla Division"
  },
  "193201": {
    "state": "Jammu & Kashmir",
    "district": "Baramulla",
    "block": "Sopore",
    "officename": "Sopore S.O",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Baramulla Division"
  },
  "193221": {
    "state": "Jammu & Kashmir",
    "district": "Kupwara",
    "block": "Handwara",
    "officename": "Handwara S.O",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Baramulla Division"
  },
  "193222": {
    "state": "Jammu & Kashmir",
    "district": "Kupwara",
    "block": "Kupwara",
    "officename": "Kupwara S.O",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Baramulla Division"
  },
  "193223": {
    "state": "Jammu & Kashmir",
    "district": "Kupwara",
    "block": "Sogam",
    "officename": "Sogam S.O",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Baramulla Division"
  },
  "193224": {
    "state": "Jammu & Kashmir",
    "district": "Kupwara",
    "block": "Kupwara",
    "officename": "TREHGAM S.O",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Baramulla Division"
  },
  "193225": {
    "state": "Jammu & Kashmir",
    "district": "Kupwara",
    "block": "Tagdhar",
    "officename": "Tangdhar S.O",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Baramulla Division"
  },
  "193301": {
    "state": "Jammu & Kashmir",
    "district": "Baramulla",
    "block": "Sopore",
    "officename": "Rohama S.O",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Baramulla Division"
  },
  "193302": {
    "state": "Jammu & Kashmir",
    "district": "Kupwara",
    "block": "Handwara",
    "officename": "Langate S.O",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Baramulla Division"
  },
  "193303": {
    "state": "Jammu & Kashmir",
    "district": "Ananthnag",
    "block": "Aharbal",
    "officename": "Dangiwacha S.O",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Baramulla Division"
  },
  "193401": {
    "state": "Jammu & Kashmir",
    "district": "Baramulla",
    "block": "Aripanthan",
    "officename": "Magam SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "193402": {
    "state": "Jammu & Kashmir",
    "district": "Baramulla",
    "block": "Tangmarg",
    "officename": "Tangmarg SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "193403": {
    "state": "Jammu & Kashmir",
    "district": "Baramulla",
    "block": "Gulmarg",
    "officename": "Gulmarg SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "193404": {
    "state": "Jammu & Kashmir",
    "district": "Baramulla",
    "block": "Tangmarg",
    "officename": "Kunzer SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "193411": {
    "state": "Jammu & Kashmir",
    "district": "Budgam",
    "block": "Beerwah",
    "officename": "Beerwah SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "193501": {
    "state": "Jammu & Kashmir",
    "district": "Baramulla",
    "block": "Sonawari",
    "officename": "Sonawari S.O",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Baramulla Division"
  },
  "193502": {
    "state": "Jammu & Kashmir",
    "district": "Baramulla",
    "block": "Bandipora",
    "officename": "Bandipora S.O",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Baramulla Division"
  },
  "193503": {
    "state": "Jammu & Kashmir",
    "district": "Bandipur",
    "block": "GUREZ",
    "officename": "Gurez S.O",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Baramulla Division"
  },
  "193504": {
    "state": "Jammu & Kashmir",
    "district": "Baramulla",
    "block": "Sumbal",
    "officename": "Safapora S.O",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Baramulla Division"
  },
  "194101": {
    "state": "Jammu & Kashmir",
    "district": "Leh",
    "block": "Leh",
    "officename": "Leh H.O",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Leh Division"
  },
  "194102": {
    "state": "Jammu & Kashmir",
    "district": "Kargil",
    "block": "Kargil",
    "officename": "Drass S.O",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Leh Division"
  },
  "194103": {
    "state": "Jammu & Kashmir",
    "district": "Kargil",
    "block": "Kargil",
    "officename": "Kargil S.O",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Leh Division"
  },
  "194104": {
    "state": "Jammu & Kashmir",
    "district": "Leh",
    "block": "Leh",
    "officename": "Chuglamsar S.O",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Leh Division"
  },
  "194105": {
    "state": "Jammu & Kashmir",
    "district": "Kargil",
    "block": "Kargil",
    "officename": "Baroo S.O",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Leh Division"
  },
  "194106": {
    "state": "Jammu & Kashmir",
    "district": "Leh",
    "block": "Leh",
    "officename": "Khalsi S.O",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Leh Division"
  },
  "194109": {
    "state": "Jammu & Kashmir",
    "district": "Kargil",
    "block": "Kargil Kargil",
    "officename": "Mulbek S.O",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Leh Division"
  },
  "194201": {
    "state": "Jammu & Kashmir",
    "district": "Leh",
    "block": "Leh",
    "officename": "Thiksay S.O",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Leh Division"
  },
  "194301": {
    "state": "Jammu & Kashmir",
    "district": "Kargil",
    "block": "Kargil",
    "officename": "Sankoo S.O",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Leh Division"
  },
  "194302": {
    "state": "Jammu & Kashmir",
    "district": "Kargil",
    "block": "Zanskar",
    "officename": "Padum S.O",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Leh Division"
  },
  "194401": {
    "state": "Jammu & Kashmir",
    "district": "Leh",
    "block": "Nobra",
    "officename": "Diskit S.O",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Leh Division"
  },
  "201001": {
    "state": "Uttar Pradesh",
    "district": "Ghaziabad",
    "block": "Ghaziabad",
    "officename": "Ghaziabad HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Ghaziabad Division"
  },
  "201002": {
    "state": "Uttar Pradesh",
    "district": "Ghaziabad",
    "block": "Ingram Institute",
    "officename": "Kavi Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Ghaziabad Division"
  },
  "201003": {
    "state": "Uttar Pradesh",
    "district": "Ghaziabad",
    "block": "Ator Nagla",
    "officename": "Meerut Road SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Ghaziabad Division"
  },
  "201004": {
    "state": "Uttar Pradesh",
    "district": "Ghaziabad",
    "block": "Ghaziabad",
    "officename": "Hindon Air Field SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Ghaziabad Division"
  },
  "201005": {
    "state": "Uttar Pradesh",
    "district": "Ghaziabad",
    "block": "Loni",
    "officename": "Sahibabad SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Ghaziabad Division"
  },
  "201006": {
    "state": "Uttar Pradesh",
    "district": "Ghaziabad",
    "block": "Ghaziabad",
    "officename": "Chikamberpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Ghaziabad Division"
  },
  "201007": {
    "state": "Uttar Pradesh",
    "district": "Ghaziabad",
    "block": "Ghaziabad",
    "officename": "Mohan Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Ghaziabad Division"
  },
  "201008": {
    "state": "Uttar Pradesh",
    "district": "Gautam Buddha Nagar",
    "block": "Bisara",
    "officename": "Vidyut Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Gautam Buddha Nagar Division office"
  },
  "201009": {
    "state": "Uttar Pradesh",
    "district": "Ghaziabad",
    "block": "Ghaziabad",
    "officename": "Ghaziabad City SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Ghaziabad Division"
  },
  "201010": {
    "state": "Uttar Pradesh",
    "district": "Ghaziabad",
    "block": "Ghaziabad",
    "officename": "IESahibabad SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Ghaziabad Division"
  },
  "201011": {
    "state": "Uttar Pradesh",
    "district": "Ghaziabad",
    "block": "Ghaziabad",
    "officename": "Chandra Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Ghaziabad Division"
  },
  "201012": {
    "state": "Uttar Pradesh",
    "district": "Ghaziabad",
    "block": "Ghaziabad",
    "officename": "Vasundhra SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Ghaziabad Division"
  },
  "201013": {
    "state": "Uttar Pradesh",
    "district": "Ghaziabad",
    "block": "Ghaziabad",
    "officename": "Govindpuram SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Ghaziabad Division"
  },
  "201014": {
    "state": "Uttar Pradesh",
    "district": "Ghaziabad",
    "block": "Ghaziabad",
    "officename": "Shipra Sun City SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Ghaziabad Division"
  },
  "201015": {
    "state": "Uttar Pradesh",
    "district": "Ghaziabad",
    "block": "Ghaziabad",
    "officename": "Hindon Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Ghaziabad Division"
  },
  "201016": {
    "state": "Uttar Pradesh",
    "district": "Ghaziabad",
    "block": "Ghaziabad",
    "officename": "Crossings Republik SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Ghaziabad Division"
  },
  "201017": {
    "state": "Uttar Pradesh",
    "district": "Ghaziabad",
    "block": "Ghaziabad",
    "officename": "Raj Nagar Extension SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Ghaziabad Division"
  },
  "201019": {
    "state": "Uttar Pradesh",
    "district": "Ghaziabad",
    "block": "Ghaziabad",
    "officename": "Vaishali SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Ghaziabad Division"
  },
  "201102": {
    "state": "Uttar Pradesh",
    "district": "Ghaziabad",
    "block": "Ghaziabad",
    "officename": "Loni SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Ghaziabad Division"
  },
  "201103": {
    "state": "Uttar Pradesh",
    "district": "Ghaziabad",
    "block": "NA",
    "officename": "Tronica City SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Ghaziabad Division"
  },
  "201201": {
    "state": "Uttar Pradesh",
    "district": "Ghaziabad",
    "block": "Hapur",
    "officename": "Govindpuri SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Ghaziabad Division"
  },
  "201204": {
    "state": "Uttar Pradesh",
    "district": "Ghaziabad",
    "block": "Modinagar",
    "officename": "Modi Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Ghaziabad Division"
  },
  "201206": {
    "state": "Uttar Pradesh",
    "district": "Ghaziabad",
    "block": "Ghaziabad",
    "officename": "Murad Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Ghaziabad Division"
  },
  "201301": {
    "state": "Uttar Pradesh",
    "district": "Gautam Buddha Nagar",
    "block": "Noida",
    "officename": "Noida HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Gautam Buddha Nagar Division office"
  },
  "201303": {
    "state": "Uttar Pradesh",
    "district": "Gautam Buddha Nagar",
    "block": "Noida",
    "officename": "Sec37 Noida SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Gautam Buddha Nagar Division office"
  },
  "201304": {
    "state": "Uttar Pradesh",
    "district": "Gautam Buddha Nagar",
    "block": "Dadri",
    "officename": "Maharshi Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Gautam Buddha Nagar Division office"
  },
  "201305": {
    "state": "Uttar Pradesh",
    "district": "Gautam Buddha Nagar",
    "block": "Dadri",
    "officename": "NEPZ SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Gautam Buddha Nagar Division office"
  },
  "201306": {
    "state": "Uttar Pradesh",
    "district": "Gautam Buddha Nagar",
    "block": "Bishrakh",
    "officename": "IA Surajpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Gautam Buddha Nagar Division office"
  },
  "201307": {
    "state": "Uttar Pradesh",
    "district": "Gautam Buddha Nagar",
    "block": "Dadri",
    "officename": "Sec34 Noida SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Gautam Buddha Nagar Division office"
  },
  "201309": {
    "state": "Uttar Pradesh",
    "district": "Gautam Buddha Nagar",
    "block": "Dadri",
    "officename": "Sec62 Noida SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Gautam Buddha Nagar Division office"
  },
  "201310": {
    "state": "Uttar Pradesh",
    "district": "Gautam Buddha Nagar",
    "block": "Noida",
    "officename": "Knowledge ParkI SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Gautam Buddha Nagar Division office"
  },
  "201311": {
    "state": "Uttar Pradesh",
    "district": "Gautam Buddha Nagar",
    "block": "Dadri",
    "officename": "Container Depot SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Gautam Buddha Nagar Division office"
  },
  "201312": {
    "state": "Uttar Pradesh",
    "district": "Gautam Buddha Nagar",
    "block": "G B nagar",
    "officename": "Gautam Budh University SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Gautam Buddha Nagar Division office"
  },
  "201313": {
    "state": "Uttar Pradesh",
    "district": "Gautam Buddha Nagar",
    "block": "Dadri",
    "officename": "Amity university SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Gautam Buddha Nagar Division office"
  },
  "201314": {
    "state": "Uttar Pradesh",
    "district": "Gautam Buddha Nagar",
    "block": "Dadri",
    "officename": "Shiv Nadar University SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Gautam Buddha Nagar Division office"
  },
  "202001": {
    "state": "Uttar Pradesh",
    "district": "Aligarh",
    "block": "Aligarh",
    "officename": "Aligarh HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "202002": {
    "state": "Uttar Pradesh",
    "district": "Aligarh",
    "block": "Aligarh",
    "officename": "Aligarh Muslim University S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "202121": {
    "state": "Uttar Pradesh",
    "district": "Aligarh",
    "block": "Aligarh",
    "officename": "Akrabad S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "202122": {
    "state": "Uttar Pradesh",
    "district": "Aligarh",
    "block": "Aligarh",
    "officename": "Aligarh Dairy Farm S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "202123": {
    "state": "Uttar Pradesh",
    "district": "Aligarh",
    "block": "Aligarh",
    "officename": "Gonda SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "202124": {
    "state": "Uttar Pradesh",
    "district": "Aligarh",
    "block": "Aligarh",
    "officename": "Iglas SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "202125": {
    "state": "Uttar Pradesh",
    "district": "Aligarh",
    "block": "Aligarh",
    "officename": "Harduaganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "202126": {
    "state": "Uttar Pradesh",
    "district": "Aligarh",
    "block": "Aligarh",
    "officename": "Jawan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "202127": {
    "state": "Uttar Pradesh",
    "district": "Aligarh",
    "block": "Aligarh",
    "officename": "Kasimpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "202128": {
    "state": "Uttar Pradesh",
    "district": "Aligarh",
    "block": "Aligarh",
    "officename": "Jalali SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "202129": {
    "state": "Uttar Pradesh",
    "district": "Aligarh",
    "block": "Aligarh",
    "officename": "Kauriyaganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "202130": {
    "state": "Uttar Pradesh",
    "district": "Aligarh",
    "block": "Aligarh",
    "officename": "Chharra SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "202131": {
    "state": "Uttar Pradesh",
    "district": "Aligarh",
    "block": "Aligarh",
    "officename": "Bijauli S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "202132": {
    "state": "Uttar Pradesh",
    "district": "Aligarh",
    "block": "Aligarh",
    "officename": "Chandaus S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "202133": {
    "state": "Uttar Pradesh",
    "district": "Aligarh",
    "block": "Aligarh",
    "officename": "Dadon SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "202134": {
    "state": "Uttar Pradesh",
    "district": "Aligarh",
    "block": "Aligarh",
    "officename": "Gangiri SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "202135": {
    "state": "Uttar Pradesh",
    "district": "Aligarh",
    "block": "Aligarh",
    "officename": "Gomat SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "202136": {
    "state": "Uttar Pradesh",
    "district": "Aligarh",
    "block": "Aligarh",
    "officename": "Gabhana SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "202137": {
    "state": "Uttar Pradesh",
    "district": "Aligarh",
    "block": "Aligarh",
    "officename": "Jattari SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "202138": {
    "state": "Uttar Pradesh",
    "district": "Aligarh",
    "block": "Aligarh",
    "officename": "Khair SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "202139": {
    "state": "Uttar Pradesh",
    "district": "Aligarh",
    "block": "Aligarh",
    "officename": "K G W Sasni SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "202140": {
    "state": "Uttar Pradesh",
    "district": "Aligarh",
    "block": "Aligarh",
    "officename": "Lodha SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "202141": {
    "state": "Uttar Pradesh",
    "district": "Aligarh",
    "block": "Aligarh",
    "officename": "Dayal Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "202142": {
    "state": "Uttar Pradesh",
    "district": "Aligarh",
    "block": "Aligarh",
    "officename": "Birpura S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "202143": {
    "state": "Uttar Pradesh",
    "district": "Aligarh",
    "block": "Aligarh",
    "officename": "Somna SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "202145": {
    "state": "Uttar Pradesh",
    "district": "Aligarh",
    "block": "Aligarh",
    "officename": "Beswan S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "202146": {
    "state": "Uttar Pradesh",
    "district": "Aligarh",
    "block": "Aligarh",
    "officename": "Mangalayatan University SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "202150": {
    "state": "Uttar Pradesh",
    "district": "Aligarh",
    "block": "Aligarh",
    "officename": "Palirajapur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "202155": {
    "state": "Uttar Pradesh",
    "district": "Aligarh",
    "block": "Aligarh",
    "officename": "Pisawah SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "202165": {
    "state": "Uttar Pradesh",
    "district": "Aligarh",
    "block": "Aligarh",
    "officename": "Tappal SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "202170": {
    "state": "Uttar Pradesh",
    "district": "Aligarh",
    "block": "Aligarh",
    "officename": "Bijaigarh S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "202280": {
    "state": "Uttar Pradesh",
    "district": "Aligarh",
    "block": "Aligarh",
    "officename": "Atrauli S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "202281": {
    "state": "Uttar Pradesh",
    "district": "Aligarh",
    "block": "Aligarh",
    "officename": "J D Singh SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "202282": {
    "state": "Uttar Pradesh",
    "district": "Aligarh",
    "block": "Aligarh",
    "officename": "Malviya Nagar SO Aligarh",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "203001": {
    "state": "Uttar Pradesh",
    "district": "Bulandshahr",
    "block": "Bulandshahr",
    "officename": "Bulandshahr HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Bulandshahar Division"
  },
  "203002": {
    "state": "Uttar Pradesh",
    "district": "Bulandshahr",
    "block": "Bulandshahr",
    "officename": "AgSchool SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Bulandshahar Division"
  },
  "203129": {
    "state": "Uttar Pradesh",
    "district": "Bulandshahr",
    "block": "Khurja",
    "officename": "Karora SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Bulandshahar Division"
  },
  "203131": {
    "state": "Uttar Pradesh",
    "district": "Bulandshahr",
    "block": "Bulandshahr",
    "officename": "Khurja MDG",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Bulandshahar Division"
  },
  "203132": {
    "state": "Uttar Pradesh",
    "district": "Bulandshahr",
    "block": "Khurja",
    "officename": "Khurja  Jn  RS SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Bulandshahar Division"
  },
  "203135": {
    "state": "Uttar Pradesh",
    "district": "Gautam Buddha Nagar",
    "block": "Jewer",
    "officename": "Jewar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Gautam Buddha Nagar Division office"
  },
  "203141": {
    "state": "Uttar Pradesh",
    "district": "Bulandshahr",
    "block": "Jewer",
    "officename": "Jahangirpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Gautam Buddha Nagar Division office"
  },
  "203150": {
    "state": "Uttar Pradesh",
    "district": "Bulandshahr",
    "block": "Bulandshahr",
    "officename": "Shahkarinagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Bulandshahar Division"
  },
  "203155": {
    "state": "Uttar Pradesh",
    "district": "Bulandshahr",
    "block": "Bulandshahr",
    "officename": "Thora SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Gautam Buddha Nagar Division office"
  },
  "203201": {
    "state": "Uttar Pradesh",
    "district": "Bulandshahr",
    "block": "Sikandrabad",
    "officename": "Dankaur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Gautam Buddha Nagar Division office"
  },
  "203202": {
    "state": "Uttar Pradesh",
    "district": "Gautam Buddha Nagar",
    "block": "Goutam Budd Nagar",
    "officename": "Gurukul  Sikandrabad SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Gautam Buddha Nagar Division office"
  },
  "203203": {
    "state": "Uttar Pradesh",
    "district": "Gautam Buddha Nagar",
    "block": "Sikandrabad",
    "officename": "Kakore SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Gautam Buddha Nagar Division office"
  },
  "203205": {
    "state": "Uttar Pradesh",
    "district": "Bulandshahr",
    "block": "Sikarndrabad",
    "officename": "Sikandrabad SO Bulandshahr",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Bulandshahar Division"
  },
  "203206": {
    "state": "Uttar Pradesh",
    "district": "Bulandshahr",
    "block": "Sikandrabad",
    "officename": "Industrial Estate Sikandrabad SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Bulandshahar Division"
  },
  "203207": {
    "state": "Uttar Pradesh",
    "district": "Gautam Buddha Nagar",
    "block": "Achheja",
    "officename": "Dadri SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Gautam Buddha Nagar Division office"
  },
  "203209": {
    "state": "Uttar Pradesh",
    "district": "Gautam Buddha Nagar",
    "block": "Jewer",
    "officename": "Rabupura SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Gautam Buddha Nagar Division office"
  },
  "203389": {
    "state": "Uttar Pradesh",
    "district": "Bulandshahr",
    "block": "Debai",
    "officename": "NAPP SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Bulandshahar Division"
  },
  "203390": {
    "state": "Uttar Pradesh",
    "district": "Bulandshahr",
    "block": "Anupshahr",
    "officename": "Anupshahr SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Bulandshahar Division"
  },
  "203391": {
    "state": "Uttar Pradesh",
    "district": "Bulandshahr",
    "block": "Anupshahr",
    "officename": "KSC Mill  Anupshahr SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Bulandshahar Division"
  },
  "203392": {
    "state": "Uttar Pradesh",
    "district": "Bulandshahr",
    "block": "Debai",
    "officename": "Danpur SO Bulandshahr",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Bulandshahar Division"
  },
  "203393": {
    "state": "Uttar Pradesh",
    "district": "Bulandshahr",
    "block": "Debai",
    "officename": "Debai SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Bulandshahar Division"
  },
  "203394": {
    "state": "Uttar Pradesh",
    "district": "Bulandshahr",
    "block": "Anoop Shahr",
    "officename": "Jahangirabad SO Bulandshahr",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Bulandshahar Division"
  },
  "203395": {
    "state": "Uttar Pradesh",
    "district": "Bulandshahr",
    "block": "Shikarpur",
    "officename": "Shikarpur SO Bulandshahr",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Bulandshahar Division"
  },
  "203396": {
    "state": "Uttar Pradesh",
    "district": "Bulandshahr",
    "block": "Debai",
    "officename": "Pahasu SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Bulandshahar Division"
  },
  "203397": {
    "state": "Uttar Pradesh",
    "district": "Bulandshahr",
    "block": "Debai",
    "officename": "Chhatary SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Bulandshahar Division"
  },
  "203398": {
    "state": "Uttar Pradesh",
    "district": "Bulandshahr",
    "block": "Anupshaher",
    "officename": "Uncha Gaon SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Bulandshahar Division"
  },
  "203399": {
    "state": "Uttar Pradesh",
    "district": "Bulandshahr",
    "block": "Jewer",
    "officename": "Ramghat SO Bulandshahr",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Bulandshahar Division"
  },
  "203401": {
    "state": "Uttar Pradesh",
    "district": "Bulandshahr",
    "block": "Bulandshahr",
    "officename": "Aurangabad SO Bulandshahr",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Bulandshahar Division"
  },
  "203402": {
    "state": "Uttar Pradesh",
    "district": "Bulandshahr",
    "block": "Bulandshahr",
    "officename": "Bb  Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Bulandshahar Division"
  },
  "203403": {
    "state": "Uttar Pradesh",
    "district": "Bulandshahr",
    "block": "Siyana",
    "officename": "Bugrasi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Bulandshahar Division"
  },
  "203405": {
    "state": "Uttar Pradesh",
    "district": "Bulandshahr",
    "block": "Siyana",
    "officename": "Khanpur SO Bulandshahr",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Bulandshahar Division"
  },
  "203407": {
    "state": "Uttar Pradesh",
    "district": "Bulandshahr",
    "block": "Siyana",
    "officename": "Lakhaoti SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Bulandshahar Division"
  },
  "203408": {
    "state": "Uttar Pradesh",
    "district": "Bulandshahr",
    "block": "Bulandshahr",
    "officename": "Gulaothi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Bulandshahar Division"
  },
  "203409": {
    "state": "Uttar Pradesh",
    "district": "Bulandshahr",
    "block": "Bulandshahr",
    "officename": "Sarai  Chhabila SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Bulandshahar Division"
  },
  "203411": {
    "state": "Uttar Pradesh",
    "district": "Bulandshahr",
    "block": "Siyana",
    "officename": "Saidpur SO Bulandshahr",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Bulandshahar Division"
  },
  "203412": {
    "state": "Uttar Pradesh",
    "district": "Bulandshahr",
    "block": "Siyana",
    "officename": "Siyana SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Bulandshahar Division"
  },
  "204101": {
    "state": "Uttar Pradesh",
    "district": "Hathras",
    "block": "Aligarh",
    "officename": "Hathras SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "204102": {
    "state": "Uttar Pradesh",
    "district": "Hathras",
    "block": "Aligarh",
    "officename": "Hathras Jn RS SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "204211": {
    "state": "Uttar Pradesh",
    "district": "Hathras",
    "block": "Aligarh",
    "officename": "Kachaura SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "204212": {
    "state": "Uttar Pradesh",
    "district": "Hathras",
    "block": "Aligarh",
    "officename": "Hasayan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "204213": {
    "state": "Uttar Pradesh",
    "district": "Aligarh",
    "block": "Aligarh",
    "officename": "Mursan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "204214": {
    "state": "Uttar Pradesh",
    "district": "Hathras",
    "block": "Aligarh",
    "officename": "Purdilpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "204215": {
    "state": "Uttar Pradesh",
    "district": "Aligarh",
    "block": "Aligarh",
    "officename": "Sikandra Rao SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "204216": {
    "state": "Uttar Pradesh",
    "district": "Hathras",
    "block": "Aligarh",
    "officename": "Sasni SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "205001": {
    "state": "Uttar Pradesh",
    "district": "Mainpuri",
    "block": "Mainpuri",
    "officename": "Mainpuri HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mainpuri Division"
  },
  "205119": {
    "state": "Uttar Pradesh",
    "district": "Mainpuri",
    "block": "Mainpuri",
    "officename": "Tindauli SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mainpuri Division"
  },
  "205121": {
    "state": "Uttar Pradesh",
    "district": "Mainpuri",
    "block": "Mainpuri",
    "officename": "Ghiror SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mainpuri Division"
  },
  "205247": {
    "state": "Uttar Pradesh",
    "district": "Mainpuri",
    "block": "Mainpuri",
    "officename": "Ajitganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mainpuri Division"
  },
  "205261": {
    "state": "Uttar Pradesh",
    "district": "Mainpuri",
    "block": "Karhal",
    "officename": "Baranahal SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mainpuri Division"
  },
  "205262": {
    "state": "Uttar Pradesh",
    "district": "Mainpuri",
    "block": "Bhongaon",
    "officename": "Bhongaon SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mainpuri Division"
  },
  "205263": {
    "state": "Uttar Pradesh",
    "district": "Mainpuri",
    "block": "Mainpuri",
    "officename": "Jeonti SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mainpuri Division"
  },
  "205264": {
    "state": "Uttar Pradesh",
    "district": "Mainpuri",
    "block": "Karahal",
    "officename": "Karhal SO Mainpuri",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mainpuri Division"
  },
  "205265": {
    "state": "Uttar Pradesh",
    "district": "Mainpuri",
    "block": "Mainpuri",
    "officename": "Kuraoli SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mainpuri Division"
  },
  "205267": {
    "state": "Uttar Pradesh",
    "district": "Mainpuri",
    "block": "Bhongaon",
    "officename": "Sultanganj SO Mainpuri",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mainpuri Division"
  },
  "205268": {
    "state": "Uttar Pradesh",
    "district": "Mainpuri",
    "block": "Mainpuri",
    "officename": "Kurra SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mainpuri Division"
  },
  "205301": {
    "state": "Uttar Pradesh",
    "district": "Mainpuri",
    "block": "Bhongaon",
    "officename": "Bewar SO Mainpuri",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mainpuri Division"
  },
  "205303": {
    "state": "Uttar Pradesh",
    "district": "Mainpuri",
    "block": "Bhongaon",
    "officename": "Kishni SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mainpuri Division"
  },
  "205304": {
    "state": "Uttar Pradesh",
    "district": "Mainpuri",
    "block": "Bhgaon",
    "officename": "Kusmara SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mainpuri Division"
  },
  "206001": {
    "state": "Uttar Pradesh",
    "district": "Etawah",
    "block": "Etawah",
    "officename": "Etawah HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etawah Division"
  },
  "206002": {
    "state": "Uttar Pradesh",
    "district": "Etawah",
    "block": "Saifai",
    "officename": "I T I Etawah SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etawah Division"
  },
  "206003": {
    "state": "Uttar Pradesh",
    "district": "Etawah",
    "block": "Etawah",
    "officename": "Ram Lila Road SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etawah Division"
  },
  "206120": {
    "state": "Uttar Pradesh",
    "district": "Etawah",
    "block": "Bharthana",
    "officename": "Aheripur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etawah Division"
  },
  "206121": {
    "state": "Uttar Pradesh",
    "district": "Auraiya",
    "block": "Auraiya",
    "officename": "Ajitmal SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etawah Division"
  },
  "206122": {
    "state": "Uttar Pradesh",
    "district": "Auraiya",
    "block": "Auraiya",
    "officename": "Auraiya HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etawah Division"
  },
  "206123": {
    "state": "Uttar Pradesh",
    "district": "Etawah",
    "block": "Bharthana",
    "officename": "Baralokpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etawah Division"
  },
  "206124": {
    "state": "Uttar Pradesh",
    "district": "Etawah",
    "block": "Bharthana",
    "officename": "Bakewar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etawah Division"
  },
  "206125": {
    "state": "Uttar Pradesh",
    "district": "Etawah",
    "block": "Chakar Nagar",
    "officename": "Chakar Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etawah Division"
  },
  "206126": {
    "state": "Uttar Pradesh",
    "district": "Etawah",
    "block": "Etawah",
    "officename": "Ekdil SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etawah Division"
  },
  "206127": {
    "state": "Uttar Pradesh",
    "district": "Etawah",
    "block": "Chakar Nagar",
    "officename": "Lakhana SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etawah Division"
  },
  "206128": {
    "state": "Uttar Pradesh",
    "district": "Etawah",
    "block": "Bharthana",
    "officename": "Mandir Mahewa SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etawah Division"
  },
  "206129": {
    "state": "Uttar Pradesh",
    "district": "Auraiya",
    "block": "Auraiya",
    "officename": "Muradganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etawah Division"
  },
  "206130": {
    "state": "Uttar Pradesh",
    "district": "Etawah",
    "block": "Saifai",
    "officename": "Saifai SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etawah Division"
  },
  "206131": {
    "state": "Uttar Pradesh",
    "district": "Etawah",
    "block": "Etawah",
    "officename": "Udi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etawah Division"
  },
  "206241": {
    "state": "Uttar Pradesh",
    "district": "Auraiya",
    "block": "Bidhuna",
    "officename": "Achhalda SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etawah Division"
  },
  "206242": {
    "state": "Uttar Pradesh",
    "district": "Etawah",
    "block": "Bharthana",
    "officename": "Bharthana SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etawah Division"
  },
  "206243": {
    "state": "Uttar Pradesh",
    "district": "Auraiya",
    "block": "Bidhuna",
    "officename": "Bidhuna SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etawah Division"
  },
  "206244": {
    "state": "Uttar Pradesh",
    "district": "Auraiya",
    "block": "Auraiya",
    "officename": "Dibiapur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etawah Division"
  },
  "206245": {
    "state": "Uttar Pradesh",
    "district": "Etawah",
    "block": "Jaswant Nagar",
    "officename": "Jaswant Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etawah Division"
  },
  "206246": {
    "state": "Uttar Pradesh",
    "district": "Auraiya",
    "block": "Auraiya",
    "officename": "Kanchausi Bazar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etawah Division"
  },
  "206247": {
    "state": "Uttar Pradesh",
    "district": "Auraiya",
    "block": "Auraiya",
    "officename": "Phaphund SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etawah Division"
  },
  "206248": {
    "state": "Uttar Pradesh",
    "district": "Auraiya",
    "block": "Bidhuna",
    "officename": "Sahar SO Auraiya",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etawah Division"
  },
  "206249": {
    "state": "Uttar Pradesh",
    "district": "Auraiya",
    "block": "Bidhuna",
    "officename": "Ruruganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etawah Division"
  },
  "206250": {
    "state": "Uttar Pradesh",
    "district": "Auraiya",
    "block": "Bidhuna",
    "officename": "Harchandpur SO Auraiya",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etawah Division"
  },
  "206251": {
    "state": "Uttar Pradesh",
    "district": "Auraiya",
    "block": "Bidhuna",
    "officename": "Bela SO Auraiya",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etawah Division"
  },
  "206252": {
    "state": "Uttar Pradesh",
    "district": "Auraiya",
    "block": "Bidhuna",
    "officename": "Airwa Katra SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etawah Division"
  },
  "206253": {
    "state": "Uttar Pradesh",
    "district": "Etawah",
    "block": "Saifai",
    "officename": "Basrehar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etawah Division"
  },
  "206255": {
    "state": "Uttar Pradesh",
    "district": "Auraiya",
    "block": "Bidhuna",
    "officename": "Malhosi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etawah Division"
  },
  "207001": {
    "state": "Uttar Pradesh",
    "district": "Etah",
    "block": "Etah",
    "officename": "Etah HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etah Division"
  },
  "207002": {
    "state": "Uttar Pradesh",
    "district": "Etah",
    "block": "Etah",
    "officename": "Aruna Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etah Division"
  },
  "207003": {
    "state": "Uttar Pradesh",
    "district": "Etah",
    "block": "Etah",
    "officename": "Brahm Sajiwan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etah Division"
  },
  "207120": {
    "state": "Uttar Pradesh",
    "district": "Etah",
    "block": "Etah",
    "officename": "Pilua SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etah Division"
  },
  "207121": {
    "state": "Uttar Pradesh",
    "district": "Etah",
    "block": "Etah",
    "officename": "Sakeet SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etah Division"
  },
  "207122": {
    "state": "Uttar Pradesh",
    "district": "Etah",
    "block": "Jalesar",
    "officename": "Nidholi Kalan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etah Division"
  },
  "207123": {
    "state": "Uttar Pradesh",
    "district": "Etah",
    "block": "Kasganj",
    "officename": "Kasganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etah Division"
  },
  "207124": {
    "state": "Uttar Pradesh",
    "district": "Etah",
    "block": "Kasganj",
    "officename": "Bilram SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etah Division"
  },
  "207125": {
    "state": "Uttar Pradesh",
    "district": "Etah",
    "block": "Kasganj",
    "officename": "Mirehachi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etah Division"
  },
  "207241": {
    "state": "Uttar Pradesh",
    "district": "Etah",
    "block": "Kasganj",
    "officename": "Amanpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etah Division"
  },
  "207242": {
    "state": "Uttar Pradesh",
    "district": "Etah",
    "block": "Patiali",
    "officename": "Gunjdundwara SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etah Division"
  },
  "207243": {
    "state": "Uttar Pradesh",
    "district": "Etah",
    "block": "Patiali",
    "officename": "Patiali SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etah Division"
  },
  "207244": {
    "state": "Uttar Pradesh",
    "district": "Etah",
    "block": "Aliganj",
    "officename": "Raja Ka Rampur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etah Division"
  },
  "207245": {
    "state": "Uttar Pradesh",
    "district": "Etah",
    "block": "Kasganj",
    "officename": "Sahawar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etah Division"
  },
  "207246": {
    "state": "Uttar Pradesh",
    "district": "Etah",
    "block": "Etah",
    "officename": "Sirhpura SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etah Division"
  },
  "207247": {
    "state": "Uttar Pradesh",
    "district": "Etah",
    "block": "Aliganj",
    "officename": "Aliganj SO Etah",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etah Division"
  },
  "207248": {
    "state": "Uttar Pradesh",
    "district": "Etah",
    "block": "Aliganj",
    "officename": "Dhumri SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etah Division"
  },
  "207249": {
    "state": "Uttar Pradesh",
    "district": "Etah",
    "block": "Aliganj",
    "officename": "Jaithra SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etah Division"
  },
  "207250": {
    "state": "Uttar Pradesh",
    "district": "Etah",
    "block": "Aliganj",
    "officename": "Sarai Aghat SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etah Division"
  },
  "207301": {
    "state": "Uttar Pradesh",
    "district": "Etah",
    "block": "Etah",
    "officename": "Awagarh SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etah Division"
  },
  "207302": {
    "state": "Uttar Pradesh",
    "district": "Etah",
    "block": "Jalesar",
    "officename": "Jalesar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etah Division"
  },
  "207401": {
    "state": "Uttar Pradesh",
    "district": "Etah",
    "block": "Kasganj",
    "officename": "Marehara SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etah Division"
  },
  "207402": {
    "state": "Uttar Pradesh",
    "district": "Etah",
    "block": "Kasganj",
    "officename": "Neoli SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etah Division"
  },
  "207403": {
    "state": "Uttar Pradesh",
    "district": "Etah",
    "block": "Kasganj",
    "officename": "Soron SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Etah Division"
  },
  "208001": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Dehat",
    "block": "Kanpur",
    "officename": "Kanpur HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur HO Division"
  },
  "208002": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Nagar",
    "block": "Csa",
    "officename": "Nawabganj HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur City Division"
  },
  "208003": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Nagar",
    "block": "Anwarganj",
    "officename": "Anwarganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur City Division"
  },
  "208004": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Nagar",
    "block": "Cantt.",
    "officename": "Kanpur Cantt HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur City Division"
  },
  "208005": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Nagar",
    "block": "Lajpat Nagar",
    "officename": "Hns Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur City Division"
  },
  "208006": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Nagar",
    "block": "Govind Nagar",
    "officename": "Govind Nagar SO Kanpur Nagar",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur City Division"
  },
  "208007": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Nagar",
    "block": "Harjinder Nagar",
    "officename": "Harjinder Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur City Division"
  },
  "208008": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Nagar",
    "block": "Chakeri",
    "officename": "Chakeri Aerodrum SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur City Division"
  },
  "208009": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Nagar",
    "block": "Kalpi Road",
    "officename": "Armapore SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur City Division"
  },
  "208010": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Nagar",
    "block": "Jajmau",
    "officename": "Shiwans Tanney SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur City Division"
  },
  "208011": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Nagar",
    "block": "Anand Nagar",
    "officename": "Kidwai Nagar SO Kanpur Nagar",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur City Division"
  },
  "208012": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Nagar",
    "block": "Fazalganj",
    "officename": "R K Nagar SO Kanpur Nagar",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur City Division"
  },
  "208013": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Nagar",
    "block": "Cod",
    "officename": "COD SO Kanpur Nagar",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur City Division"
  },
  "208014": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Nagar",
    "block": "Juhi",
    "officename": "Juhi Colony SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur City Division"
  },
  "208015": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Nagar",
    "block": "New Pac Lines",
    "officename": "New Pac Lines SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur City Division"
  },
  "208016": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Nagar",
    "block": "Kalyanpur",
    "officename": "Iit SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur City Division"
  },
  "208017": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Nagar",
    "block": "Avas Vikas Yojna No. 3",
    "officename": "Nsi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur City Division"
  },
  "208019": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Nagar",
    "block": "Rawatpur Gaon",
    "officename": "Rawatpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur City Division"
  },
  "208020": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Nagar",
    "block": "Panki",
    "officename": "Panki SO Kanpur Nagar",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur City Division"
  },
  "208021": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Nagar",
    "block": "Kasigaon",
    "officename": "N H Road SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur City Division"
  },
  "208022": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Nagar",
    "block": "Ratan Lal Nagar",
    "officename": "Udyog Nagar SO Kanpur Nagar",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur City Division"
  },
  "208023": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Nagar",
    "block": "Munshipurwa",
    "officename": "T P Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur City Division"
  },
  "208024": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Nagar",
    "block": "Vikas Nagar",
    "officename": "K P University SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur City Division"
  },
  "208025": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Nagar",
    "block": "Naveen Nagar",
    "officename": "Naveen Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur City Division"
  },
  "208026": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Nagar",
    "block": "Indira Nagar",
    "officename": "Indira Nagar SO Kanpur Nagar",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur City Division"
  },
  "208027": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Nagar",
    "block": "Barra",
    "officename": "Barra SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur City Division"
  },
  "209101": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Dehat",
    "block": "Akbarpur",
    "officename": "Akbarpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209111": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Dehat",
    "block": "Pukhraayan",
    "officename": "Pukhrayan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209112": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Dehat",
    "block": "Kanpur Dehat",
    "officename": "Amraudha SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209115": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Dehat",
    "block": "Kanpur Dehat",
    "officename": "Rajpur SO Kanpur Dehat",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209121": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Dehat",
    "block": "Kanpur Dehat",
    "officename": "Sarwankhera SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209125": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Dehat",
    "block": "Sikandra",
    "officename": "Sikandra SO Kanpur Dehat",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209202": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Dehat",
    "block": "Bilhaur",
    "officename": "BILHAUR",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209203": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Nagar",
    "block": "Kanpur",
    "officename": "Chaubepur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209204": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Dehat",
    "block": "Sheoli",
    "officename": "Sheoli SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209205": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Dehat",
    "block": "Shivrajpur",
    "officename": "Sheorajpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209206": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Dehat",
    "block": "Ghatampur",
    "officename": "Ghatampur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209208": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Dehat",
    "block": "Kanpur Dehat",
    "officename": "Musa Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209209": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Dehat",
    "block": "Kanpur Dehta",
    "officename": "BBGaon SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209210": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Dehat",
    "block": "Uttaripura",
    "officename": "Uttaripura SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209214": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Nagar",
    "block": "Bharu",
    "officename": "Bidhnoo SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur City Division"
  },
  "209217": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Nagar",
    "block": "Baikunthpur",
    "officename": "Mandhana SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur City Division"
  },
  "209301": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Dehat",
    "block": "Kanpur Dehat",
    "officename": "Derapur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209302": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Dehat",
    "block": "Jhinjhak",
    "officename": "Jhinjhak SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209303": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Dehat",
    "block": "Rura",
    "officename": "Rura SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209304": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Nagar",
    "block": "Binour",
    "officename": "Sachendi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur City Division"
  },
  "209305": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Nagar",
    "block": "Bhairampur",
    "officename": "Chakarpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur City Division"
  },
  "209306": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Dehat",
    "block": "Rasulabad",
    "officename": "Rasulabad SO Kanpur Dehat",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209307": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Dehat",
    "block": "Kanpur Dehat",
    "officename": "BHAUPUR",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209308": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Dehat",
    "block": "Kanpur Dehat",
    "officename": "Patara SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209310": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Dehat",
    "block": "Kanpur Dehat",
    "officename": "Mangalpur SO Kanpur Dehat",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209311": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Dehat",
    "block": "Kanpur Dehat",
    "officename": "Jainpur I A SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209312": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Dehat",
    "block": "Knpur Dehat",
    "officename": "BARAUR",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209401": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Nagar",
    "block": "Amour",
    "officename": "Narwal SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur City Division"
  },
  "209402": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Nagar",
    "block": "Bhadrsa",
    "officename": "Sarsaul SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur City Division"
  },
  "209501": {
    "state": "Uttar Pradesh",
    "district": "Farrukhabad",
    "block": "Farrukhabad",
    "officename": "Nawabganj SO Farrukhabad",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehgarh Division"
  },
  "209502": {
    "state": "Uttar Pradesh",
    "district": "Farrukhabad",
    "block": "Farrukhabad",
    "officename": "Kaimganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehgarh Division"
  },
  "209503": {
    "state": "Uttar Pradesh",
    "district": "Farrukhabad",
    "block": "Farrukhabad",
    "officename": "Shamsabad SO Farrukhabad",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehgarh Division"
  },
  "209504": {
    "state": "Uttar Pradesh",
    "district": "Farrukhabad",
    "block": "Farrukhabad",
    "officename": "Manjhana SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehgarh Division"
  },
  "209505": {
    "state": "Uttar Pradesh",
    "district": "Farrukhabad",
    "block": "Farrukhabad",
    "officename": "Kampil SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehgarh Division"
  },
  "209601": {
    "state": "Uttar Pradesh",
    "district": "Farrukhabad",
    "block": "Farrukhabad",
    "officename": "Fatehgarh HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehgarh Division"
  },
  "209602": {
    "state": "Uttar Pradesh",
    "district": "Farrukhabad",
    "block": "Farrukhabad",
    "officename": "Central Jail SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehgarh Division"
  },
  "209621": {
    "state": "Uttar Pradesh",
    "district": "Farrukhabad",
    "block": "Farrukhabad",
    "officename": "Aligarh SO Farrukhabad",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehgarh Division"
  },
  "209622": {
    "state": "Uttar Pradesh",
    "district": "Farrukhabad",
    "block": "Farrukhabad",
    "officename": "Amratpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehgarh Division"
  },
  "209625": {
    "state": "Uttar Pradesh",
    "district": "Farrukhabad",
    "block": "Farrukhabad",
    "officename": "Farrukhabad SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehgarh Division"
  },
  "209651": {
    "state": "Uttar Pradesh",
    "district": "Farrukhabad",
    "block": "Farrukhabad",
    "officename": "Mohamdabad SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehgarh Division"
  },
  "209652": {
    "state": "Uttar Pradesh",
    "district": "Farrukhabad",
    "block": "Farrukhabad",
    "officename": "Neebkarori SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehgarh Division"
  },
  "209720": {
    "state": "Uttar Pradesh",
    "district": "Kannauj",
    "block": "Kannauj",
    "officename": "Bishungarh SO Kannauj",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehgarh Division"
  },
  "209721": {
    "state": "Uttar Pradesh",
    "district": "Farrukhabad",
    "block": "Farrukhabad",
    "officename": "Chhibramau SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehgarh Division"
  },
  "209722": {
    "state": "Uttar Pradesh",
    "district": "Kannauj",
    "block": "Kannauj",
    "officename": "Gurusahaiganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehgarh Division"
  },
  "209723": {
    "state": "Uttar Pradesh",
    "district": "Kannauj",
    "block": "Kannauj",
    "officename": "Indergarh SO Kannauj",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehgarh Division"
  },
  "209724": {
    "state": "Uttar Pradesh",
    "district": "Farrukhabad",
    "block": "Farrukhabad",
    "officename": "Kamalganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehgarh Division"
  },
  "209725": {
    "state": "Uttar Pradesh",
    "district": "Kannauj",
    "block": "Kannauj",
    "officename": "Kannauj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehgarh Division"
  },
  "209726": {
    "state": "Uttar Pradesh",
    "district": "Kannauj",
    "block": "Kannauj",
    "officename": "Makrand Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehgarh Division"
  },
  "209727": {
    "state": "Uttar Pradesh",
    "district": "Kannauj",
    "block": "Kannauj",
    "officename": "Saraimira SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehgarh Division"
  },
  "209728": {
    "state": "Uttar Pradesh",
    "district": "Kannauj",
    "block": "Kannauj",
    "officename": "Saurikh SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehgarh Division"
  },
  "209729": {
    "state": "Uttar Pradesh",
    "district": "Kannauj",
    "block": "Kannauj",
    "officename": "Sikanderpur SO Kannauj",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehgarh Division"
  },
  "209731": {
    "state": "Uttar Pradesh",
    "district": "Kannauj",
    "block": "Kannauj",
    "officename": "Talgram SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehgarh Division"
  },
  "209732": {
    "state": "Uttar Pradesh",
    "district": "Kannauj",
    "block": "Kannauj",
    "officename": "Tirwa SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehgarh Division"
  },
  "209733": {
    "state": "Uttar Pradesh",
    "district": "Kannauj",
    "block": "Kannauj",
    "officename": "Jalalabad SO Kannauj",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehgarh Division"
  },
  "209734": {
    "state": "Uttar Pradesh",
    "district": "Kannauj",
    "block": "Kannauj",
    "officename": "Thathia SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehgarh Division"
  },
  "209735": {
    "state": "Uttar Pradesh",
    "district": "Kannauj",
    "block": "Kannauj",
    "officename": "Sarai Prayag SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehgarh Division"
  },
  "209736": {
    "state": "Uttar Pradesh",
    "district": "Kannauj",
    "block": "Kannauj",
    "officename": "Khairnagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehgarh Division"
  },
  "209738": {
    "state": "Uttar Pradesh",
    "district": "Kannauj",
    "block": "Kannauj",
    "officename": "Umarda SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehgarh Division"
  },
  "209739": {
    "state": "Uttar Pradesh",
    "district": "Farrukhabad",
    "block": "Farrukhabad",
    "officename": "Jahanganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehgarh Division"
  },
  "209743": {
    "state": "Uttar Pradesh",
    "district": "Farrukhabad",
    "block": "Farrukhabad",
    "officename": "Khimseypur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehgarh Division"
  },
  "209745": {
    "state": "Uttar Pradesh",
    "district": "Farrukhabad",
    "block": "Farrukhabad",
    "officename": "Roshnabad SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehgarh Division"
  },
  "209747": {
    "state": "Uttar Pradesh",
    "district": "Kannauj",
    "block": "Kannauj",
    "officename": "Sakrawa SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehgarh Division"
  },
  "209749": {
    "state": "Uttar Pradesh",
    "district": "Farrukhabad",
    "block": "Farrukhabad",
    "officename": "Yaqutganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehgarh Division"
  },
  "209801": {
    "state": "Uttar Pradesh",
    "district": "Unnao",
    "block": "Unnao",
    "officename": "Unnao HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209821": {
    "state": "Uttar Pradesh",
    "district": "Unnao",
    "block": "Unnao",
    "officename": "Maurawan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209825": {
    "state": "Uttar Pradesh",
    "district": "Unnao",
    "block": "Purwa",
    "officename": "Purwa SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209827": {
    "state": "Uttar Pradesh",
    "district": "Unnao",
    "block": "Unnao",
    "officename": "Chamiyani SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209831": {
    "state": "Uttar Pradesh",
    "district": "Unnao",
    "block": "Unnao",
    "officename": "Ajgain SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209841": {
    "state": "Uttar Pradesh",
    "district": "Unnao",
    "block": "Unnao",
    "officename": "Hasanganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209859": {
    "state": "Uttar Pradesh",
    "district": "Unnao",
    "block": "Unnao",
    "officename": "Nawabganj SO Unnao",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209861": {
    "state": "Uttar Pradesh",
    "district": "Unnao",
    "block": "Unnao",
    "officename": "Ganga Ghat SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209862": {
    "state": "Uttar Pradesh",
    "district": "Unnao",
    "block": "Unnao",
    "officename": "Magarwara SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209863": {
    "state": "Uttar Pradesh",
    "district": "Unnao",
    "block": "Unnao",
    "officename": "Bara SO Unnao",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209864": {
    "state": "Uttar Pradesh",
    "district": "Unnao",
    "block": "Unnao",
    "officename": "Bhagwant Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209865": {
    "state": "Uttar Pradesh",
    "district": "Unnao",
    "block": "Unnao",
    "officename": "Bighapur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209866": {
    "state": "Uttar Pradesh",
    "district": "Unnao",
    "block": "Unnaao",
    "officename": "Bihar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209867": {
    "state": "Uttar Pradesh",
    "district": "Unnao",
    "block": "Unnao",
    "officename": "Patan SO Unnao",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209868": {
    "state": "Uttar Pradesh",
    "district": "Unnao",
    "block": "Unnao",
    "officename": "Bangermau SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209869": {
    "state": "Uttar Pradesh",
    "district": "Unnao",
    "block": "Unnao",
    "officename": "Ganj Moradabad SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209870": {
    "state": "Uttar Pradesh",
    "district": "Unnao",
    "block": "Unnao",
    "officename": "Rasulabad SO Unnao",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209871": {
    "state": "Uttar Pradesh",
    "district": "Unnao",
    "block": "Safipur",
    "officename": "Safipur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "209881": {
    "state": "Uttar Pradesh",
    "district": "Unnao",
    "block": "Unnao",
    "officename": "Mohan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "210001": {
    "state": "Uttar Pradesh",
    "district": "Banda",
    "block": "Banda",
    "officename": "Banda HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "210120": {
    "state": "Uttar Pradesh",
    "district": "Banda",
    "block": "Banda",
    "officename": "Khurand RS SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "210121": {
    "state": "Uttar Pradesh",
    "district": "Banda",
    "block": "Banda",
    "officename": "Baberu SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "210123": {
    "state": "Uttar Pradesh",
    "district": "Banda",
    "block": "Banda",
    "officename": "Chillatara SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "210125": {
    "state": "Uttar Pradesh",
    "district": "Banda",
    "block": "Banda",
    "officename": "Kamasin SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "210126": {
    "state": "Uttar Pradesh",
    "district": "Banda",
    "block": "Banda",
    "officename": "Pailani SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "210128": {
    "state": "Uttar Pradesh",
    "district": "Banda",
    "block": "Banda",
    "officename": "Tindwari SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "210129": {
    "state": "Uttar Pradesh",
    "district": "Banda",
    "block": "Banda",
    "officename": "Naraini SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "210201": {
    "state": "Uttar Pradesh",
    "district": "Banda",
    "block": "Banda",
    "officename": "Atarra SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "210202": {
    "state": "Uttar Pradesh",
    "district": "Banda",
    "block": "Banda",
    "officename": "Badausa SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "210203": {
    "state": "Uttar Pradesh",
    "district": "Banda",
    "block": "Banda",
    "officename": "Bisanda SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "210204": {
    "state": "Uttar Pradesh",
    "district": "Chitrakoot",
    "block": "Banda",
    "officename": "Chitrakot SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "210205": {
    "state": "Uttar Pradesh",
    "district": "Chitrakoot",
    "block": "Banda",
    "officename": "Karwi MDG",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "210206": {
    "state": "Uttar Pradesh",
    "district": "Chitrakoot",
    "block": "Banda",
    "officename": "Pahari SO Chitrakoot",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "210207": {
    "state": "Uttar Pradesh",
    "district": "Chitrakoot",
    "block": "Banda",
    "officename": "Rajapur SO Chitrakoot",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "210208": {
    "state": "Uttar Pradesh",
    "district": "Chitrakoot",
    "block": "Banda",
    "officename": "Manikpur SO Chitrakoot",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "210209": {
    "state": "Uttar Pradesh",
    "district": "Chitrakoot",
    "block": "Banda",
    "officename": "Mauchhibu SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "210301": {
    "state": "Uttar Pradesh",
    "district": "Hamirpur",
    "block": "Hamirpur",
    "officename": "Hamirpur HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "210341": {
    "state": "Uttar Pradesh",
    "district": "Hamirpur",
    "block": "Hamirpur",
    "officename": "Ingohta SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "210421": {
    "state": "Uttar Pradesh",
    "district": "Mahoba",
    "block": "Hamirpur",
    "officename": "Charkhari State SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "210422": {
    "state": "Uttar Pradesh",
    "district": "Hamirpur",
    "block": "Hamirpur",
    "officename": "Jaria SO Hamirpur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "210423": {
    "state": "Uttar Pradesh",
    "district": "Mahoba",
    "block": "Hamirpur",
    "officename": "Jaitpur SO Mahoba",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "210424": {
    "state": "Uttar Pradesh",
    "district": "Mahoba",
    "block": "Hamirpur",
    "officename": "Kabrai SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "210425": {
    "state": "Uttar Pradesh",
    "district": "Mahoba",
    "block": "Hamirpur",
    "officename": "Kharela SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "210426": {
    "state": "Uttar Pradesh",
    "district": "Mahoba",
    "block": "Hamirpur",
    "officename": "Kulpahar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "210427": {
    "state": "Uttar Pradesh",
    "district": "Mahoba",
    "block": "Hamirpur",
    "officename": "Mahoba SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "210428": {
    "state": "Uttar Pradesh",
    "district": "Hamirpur",
    "block": "Hamirpur",
    "officename": "Majhagawan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "210429": {
    "state": "Uttar Pradesh",
    "district": "Mahoba",
    "block": "Hamirpur",
    "officename": "Panwari SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "210430": {
    "state": "Uttar Pradesh",
    "district": "Hamirpur",
    "block": "Hamirpur",
    "officename": "Gohand SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "210431": {
    "state": "Uttar Pradesh",
    "district": "Hamirpur",
    "block": "Hamirpur",
    "officename": "Rath SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "210432": {
    "state": "Uttar Pradesh",
    "district": "Hamirpur",
    "block": "Hamirpur",
    "officename": "Sarila State SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "210433": {
    "state": "Uttar Pradesh",
    "district": "Mahoba",
    "block": "Hamirpur",
    "officename": "Srinagar SO Mahoba",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "210501": {
    "state": "Uttar Pradesh",
    "district": "Hamirpur",
    "block": "Hamirpur",
    "officename": "Bewar SO Hamirpur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "210502": {
    "state": "Uttar Pradesh",
    "district": "Hamirpur",
    "block": "Hamirpur",
    "officename": "Baruwa Sumerpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "210504": {
    "state": "Uttar Pradesh",
    "district": "Hamirpur",
    "block": "Hamirpur",
    "officename": "Khanna SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "210505": {
    "state": "Uttar Pradesh",
    "district": "Hamirpur",
    "block": "Hamirpur",
    "officename": "Kurara SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "210506": {
    "state": "Uttar Pradesh",
    "district": "Hamirpur",
    "block": "Hamirpur",
    "officename": "Muskara SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "210507": {
    "state": "Uttar Pradesh",
    "district": "Hamirpur",
    "block": "Hamirpur",
    "officename": "Ragaul SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "211001": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Allahabad **",
    "officename": "PRAYAGRAJ HPO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "211002": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Allahabad",
    "officename": "Prayagraj Kty. H.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "211003": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Allahabad",
    "officename": "Prayagraj City SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "211004": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Allahabad",
    "officename": "Cavellary Lines SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "211005": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Allahabad",
    "officename": "Prayagraj Fort S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "211006": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Allahabad",
    "officename": "Daraganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "211007": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Allahabad",
    "officename": "Agriculture Institute SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "211008": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Karchhana",
    "officename": "Naini SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "211010": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Allahabad",
    "officename": "T S L SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "211011": {
    "state": "Uttar Pradesh",
    "district": "Kaushambi",
    "block": "Sirathu",
    "officename": "Dhoomanganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "211012": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Allahabad **",
    "officename": "Bamrauli SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "211013": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Phaphamau",
    "officename": "Phaphamau SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "211014": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Allahabad",
    "officename": "C D A P SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "211015": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Allahabad",
    "officename": "Subedarganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "211016": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Allahabad",
    "officename": "G T B Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "211017": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Allahabad",
    "officename": "Prayagraj High Court S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "211018": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Allahabad",
    "officename": "Public Service Commission SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "211019": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Allahabad **",
    "officename": "Jhunsi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "212104": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Allahabad",
    "officename": "Bharatganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "212105": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Allahabad",
    "officename": "Chheoki SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "212106": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Koraon **",
    "officename": "Jari Bazar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "212107": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Allahabad",
    "officename": "Jasra SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "212108": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Bara",
    "officename": "Shankargarh SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "212109": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Sikandra",
    "officename": "Sikandra SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "212111": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Bara",
    "officename": "Dandupur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "212201": {
    "state": "Uttar Pradesh",
    "district": "Kaushambi",
    "block": "Sirathu",
    "officename": "Bharwari SO Kaushambi",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "212202": {
    "state": "Uttar Pradesh",
    "district": "Kaushambi",
    "block": "Chail",
    "officename": "Chail SO Kaushambi",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "212203": {
    "state": "Uttar Pradesh",
    "district": "Kaushambi",
    "block": "Charwa",
    "officename": "Charwa SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "212204": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Allahabad",
    "officename": "Daranagar SO Allahabad",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "212205": {
    "state": "Uttar Pradesh",
    "district": "Kaushambi",
    "block": "Sirathu",
    "officename": "Kara SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "212206": {
    "state": "Uttar Pradesh",
    "district": "Kaushambi",
    "block": "Manjhanpur",
    "officename": "Karari SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "212207": {
    "state": "Uttar Pradesh",
    "district": "Kaushambi",
    "block": "Manjhanpur",
    "officename": "Manjhanpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "212208": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Allahabad",
    "officename": "Manauri SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "212212": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Allahabad",
    "officename": "Manauri AF SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "212213": {
    "state": "Uttar Pradesh",
    "district": "Kaushambi",
    "block": "Chail",
    "officename": "Mahgaon SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "212214": {
    "state": "Uttar Pradesh",
    "district": "Kaushambi",
    "block": "Manjhanpur",
    "officename": "Pashchim Sarira SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "212216": {
    "state": "Uttar Pradesh",
    "district": "Kaushambi",
    "block": "Manjhanpur",
    "officename": "Sarai Akil SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "212217": {
    "state": "Uttar Pradesh",
    "district": "Kaushambi",
    "block": "Manjhanpur",
    "officename": "Sirathu SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "212218": {
    "state": "Uttar Pradesh",
    "district": "Kaushambi",
    "block": "Chail",
    "officename": "Tilhapur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "212301": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Akorha",
    "officename": "Karchhana SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "212302": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Meja",
    "officename": "Meja SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "212303": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Meja",
    "officename": "Meja Road SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "212305": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Meja",
    "officename": "Sirsa SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "212306": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Koraon",
    "officename": "Koraon SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "212307": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Koraon **",
    "officename": "Khain SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "212401": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Handia",
    "officename": "Janghai Bazar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "212402": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Phulpur",
    "officename": "Phoolpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "212404": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Phulpur",
    "officename": "Ghiya Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "212405": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Ugrasenpur",
    "officename": "Ugrasen Pur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "212502": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Soraon",
    "officename": "Soraon SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "212503": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Allahabad",
    "officename": "Holagarh SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "212507": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Mau Aima",
    "officename": "Mau Aima SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "212601": {
    "state": "Uttar Pradesh",
    "district": "Fatehpur",
    "block": "Fatehpur",
    "officename": "Fatehpur HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehpur Division"
  },
  "212620": {
    "state": "Uttar Pradesh",
    "district": "Fatehpur",
    "block": "Fatehpur",
    "officename": "Asother SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehpur Division"
  },
  "212621": {
    "state": "Uttar Pradesh",
    "district": "Fatehpur",
    "block": "Fatehpur",
    "officename": "Ghazipur SO Fatehpur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehpur Division"
  },
  "212622": {
    "state": "Uttar Pradesh",
    "district": "Fatehpur",
    "block": "Fatehpur",
    "officename": "Bahrampur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehpur Division"
  },
  "212631": {
    "state": "Uttar Pradesh",
    "district": "Fatehpur",
    "block": "Fatehpur",
    "officename": "Amauli SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehpur Division"
  },
  "212635": {
    "state": "Uttar Pradesh",
    "district": "Fatehpur",
    "block": "Fatehpur",
    "officename": "Bindki SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehpur Division"
  },
  "212641": {
    "state": "Uttar Pradesh",
    "district": "Fatehpur",
    "block": "Fatehpur",
    "officename": "Dhata SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehpur Division"
  },
  "212645": {
    "state": "Uttar Pradesh",
    "district": "Fatehpur",
    "block": "Fatehpur",
    "officename": "Haswa SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehpur Division"
  },
  "212650": {
    "state": "Uttar Pradesh",
    "district": "Fatehpur",
    "block": "Fatehpur",
    "officename": "Chheolaha SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehpur Division"
  },
  "212651": {
    "state": "Uttar Pradesh",
    "district": "Fatehpur",
    "block": "Fatehpur",
    "officename": "Husainganj SO Fatehpur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehpur Division"
  },
  "212652": {
    "state": "Uttar Pradesh",
    "district": "Fatehpur",
    "block": "Fatehpur",
    "officename": "Hathgaon SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehpur Division"
  },
  "212653": {
    "state": "Uttar Pradesh",
    "district": "Fatehpur",
    "block": "Fatehpur",
    "officename": "Erayan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehpur Division"
  },
  "212654": {
    "state": "Uttar Pradesh",
    "district": "Fatehpur",
    "block": "Fatehpur",
    "officename": "Jamraon SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehpur Division"
  },
  "212655": {
    "state": "Uttar Pradesh",
    "district": "Fatehpur",
    "block": "Fatehpur",
    "officename": "Khaga SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehpur Division"
  },
  "212656": {
    "state": "Uttar Pradesh",
    "district": "Fatehpur",
    "block": "Fatehpur",
    "officename": "Khakhreru SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehpur Division"
  },
  "212657": {
    "state": "Uttar Pradesh",
    "district": "Fatehpur",
    "block": "Fatehpur",
    "officename": "Khajuha SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehpur Division"
  },
  "212658": {
    "state": "Uttar Pradesh",
    "district": "Fatehpur",
    "block": "Fatehpur",
    "officename": "Kishanpur SO Fatehpur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehpur Division"
  },
  "212659": {
    "state": "Uttar Pradesh",
    "district": "Fatehpur",
    "block": "Fatehpur",
    "officename": "Kora Jahanabad SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehpur Division"
  },
  "212661": {
    "state": "Uttar Pradesh",
    "district": "Fatehpur",
    "block": "Fatehpur",
    "officename": "Lalauli SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehpur Division"
  },
  "212663": {
    "state": "Uttar Pradesh",
    "district": "Fatehpur",
    "block": "Fatehpur",
    "officename": "Bahua SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehpur Division"
  },
  "212664": {
    "state": "Uttar Pradesh",
    "district": "Fatehpur",
    "block": "Fatehpur",
    "officename": "Malwan RS SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehpur Division"
  },
  "212665": {
    "state": "Uttar Pradesh",
    "district": "Fatehpur",
    "block": "Fatehpur",
    "officename": "Mauhar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Fatehpur Division"
  },
  "221001": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "Varanasi HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi East Division"
  },
  "221002": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "Varanasi Cantt HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi West Division"
  },
  "221003": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "VARANASI SHIVPUR SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi West Division"
  },
  "221004": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "DLW SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi West Division"
  },
  "221005": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "Hindu Vishwa Vidhyalaya SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi East Division"
  },
  "221006": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "Babatpur Ad SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi West Division"
  },
  "221007": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "Sarnath SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi East Division"
  },
  "221008": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "Ramnagar SO Varanasi",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi East Division"
  },
  "221009": {
    "state": "Uttar Pradesh",
    "district": "Chandauli",
    "block": "Chandauli",
    "officename": "Sahupuri SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi East Division"
  },
  "221010": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "Mahmoorganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi West Division"
  },
  "221011": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "Dafi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi East Division"
  },
  "221101": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "Cholapur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi East Division"
  },
  "221103": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "Manduadih SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi West Division"
  },
  "221104": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "Chaubeypur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi East Division"
  },
  "221105": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "Harhua SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi West Division"
  },
  "221106": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "Industrial Estate Varanasi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi West Division"
  },
  "221107": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "Lohta SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi West Division"
  },
  "221108": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "Bhulanpur Pac SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi West Division"
  },
  "221110": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "Basant Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi East Division"
  },
  "221112": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "CHIRAIGAON SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi East Division"
  },
  "221115": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "Tanda Kalan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi East Division"
  },
  "221116": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "Kaithi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi East Division"
  },
  "221201": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "Anai SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi West Division"
  },
  "221202": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "Mangari SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi West Division"
  },
  "221204": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Pindra",
    "officename": "Baragaon SO Varanasi",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi West Division"
  },
  "221206": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "Pindra SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi West Division"
  },
  "221207": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "Kathiraon SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi West Division"
  },
  "221208": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "Sindhora SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi West Division"
  },
  "221301": {
    "state": "Uttar Pradesh",
    "district": "Sant Ravidas Nagar",
    "block": "Gyanpur",
    "officename": "Aurai SO Sant Ravidas Nagar",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi West Division"
  },
  "221302": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "Gangapur Varanasi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi West Division"
  },
  "221303": {
    "state": "Uttar Pradesh",
    "district": "Sant Ravidas Nagar",
    "block": "Gyanpur",
    "officename": "Gopiganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi West Division"
  },
  "221304": {
    "state": "Uttar Pradesh",
    "district": "Sant Ravidas Nagar",
    "block": "Gyanpur",
    "officename": "Gyanpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi West Division"
  },
  "221305": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "Jakhini SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi West Division"
  },
  "221306": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "Khamaria SO Varanasi",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi West Division"
  },
  "221307": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "Mirzamurad SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi West Division"
  },
  "221308": {
    "state": "Uttar Pradesh",
    "district": "Sant Ravidas Nagar",
    "block": "Gyanpur",
    "officename": "Ozh SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi West Division"
  },
  "221309": {
    "state": "Uttar Pradesh",
    "district": "Sant Ravidas Nagar",
    "block": "Gyanpur",
    "officename": "Koirauna SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi West Division"
  },
  "221310": {
    "state": "Uttar Pradesh",
    "district": "Sant Ravidas Nagar",
    "block": "Gyanpur",
    "officename": "Jangiganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi West Division"
  },
  "221311": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "Rajatalab SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi West Division"
  },
  "221313": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "Kachhwa Road SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi West Division"
  },
  "221314": {
    "state": "Uttar Pradesh",
    "district": "Sant Ravidas Nagar",
    "block": "Gyanpur",
    "officename": "Mahrajganj SO Sant Ravidas Nagar",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi West Division"
  },
  "221401": {
    "state": "Uttar Pradesh",
    "district": "Sant Ravidas Nagar",
    "block": "Gyanpur",
    "officename": "Bhadohi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi West Division"
  },
  "221402": {
    "state": "Uttar Pradesh",
    "district": "Sant Ravidas Nagar",
    "block": "Gyanpur",
    "officename": "Parsipur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi West Division"
  },
  "221403": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "Sewapuri SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi West Division"
  },
  "221404": {
    "state": "Uttar Pradesh",
    "district": "Sant Ravidas Nagar",
    "block": "Gyanpur",
    "officename": "Suriyawan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi West Division"
  },
  "221405": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "Hathi Bazar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi West Division"
  },
  "221406": {
    "state": "Uttar Pradesh",
    "district": "Sant Ravidas Nagar",
    "block": "Gyanpur",
    "officename": "Mondh SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi West Division"
  },
  "221409": {
    "state": "Uttar Pradesh",
    "district": "Sant Ravidas Nagar",
    "block": "Gyanpur",
    "officename": "Nai Bazar SO Sant Ravidas Nagar",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi West Division"
  },
  "221502": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Baraut",
    "officename": "Baraut SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "221503": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Handia",
    "officename": "Handia SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "221505": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Hanumanganj",
    "officename": "Hanumanganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "221507": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Sahson",
    "officename": "Sahson SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "221508": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Handia",
    "officename": "Saidabad SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "221601": {
    "state": "Uttar Pradesh",
    "district": "Mau",
    "block": "Madhuban",
    "officename": "DUBARI SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "221602": {
    "state": "Uttar Pradesh",
    "district": "Mau",
    "block": "Madhuban",
    "officename": "MARYADPUR SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "221603": {
    "state": "Uttar Pradesh",
    "district": "Mau",
    "block": "Madhuban",
    "officename": "Madhu Ban SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "221701": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Rasra",
    "officename": "Chilkahar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "221705": {
    "state": "Uttar Pradesh",
    "district": "Mau",
    "block": "Sadar",
    "officename": "HALDHARPUR SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "221706": {
    "state": "Uttar Pradesh",
    "district": "Mau",
    "block": "Sadar",
    "officename": "Ratan Pura SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "221709": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Rasra",
    "officename": "GARHMALPUR SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "221711": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Rasra",
    "officename": "NAGRA SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "221712": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Rasra",
    "officename": "RASRA HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "221713": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Ballia",
    "officename": "Chitbaragaon SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "221715": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Bilthara Road",
    "officename": "BILTHARA ROAD SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "221716": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Bilthara Road",
    "officename": "Kidihirapur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "221717": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Sikanderpur",
    "officename": "Nawanagar SO Ballia",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "221718": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Bilthra Road",
    "officename": "Khandwa SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "222001": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Jaunpur",
    "officename": "Jaunpur HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222002": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Jaunpur",
    "officename": "Jaunpur Kty SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222003": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Jaunpur",
    "officename": "Purvanchal Vishwa Vidyalaya SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222101": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Shahganj",
    "officename": "Belwai S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "222105": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Mariahun",
    "officename": "Ramdayalganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222109": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Machhlishahr",
    "officename": "Naupedwa SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222125": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Badlapur",
    "officename": "Badlapur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222127": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Machhalishahar",
    "officename": "Baderi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222128": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Mariahu",
    "officename": "Bazar Neorhia SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222129": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Kerakat",
    "officename": "Chandwak SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222131": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Jaunpur",
    "officename": "Sikrara SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222132": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Jaunpur",
    "officename": "Fatehganj SO Jaunpur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222133": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Jaunpur",
    "officename": "Gaurabadshahpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222135": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Jaunpur",
    "officename": "Gulzarganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222136": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Kerakat",
    "officename": "Jalalpur SO Jaunpur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222137": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Mariahu",
    "officename": "Jamalapur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222138": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Jaunpur",
    "officename": "Kajgaon SO Jaunpur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222139": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Shahganj",
    "officename": "Khetasarai SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222141": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Badalapur",
    "officename": "Saraiharakhu SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222142": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Kerakat",
    "officename": "Kerakat SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222143": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Machhali Shahar",
    "officename": "Machhali Shahar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222144": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Machhalishahar",
    "officename": "Baraipar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222145": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Badalapur",
    "officename": "Mahraj Ganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222146": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Kerakat",
    "officename": "Kutir Chakkey SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222148": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Kerakat",
    "officename": "Leorua SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222149": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Kerakat",
    "officename": "Sgrd College Dobhi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222161": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Mariahun",
    "officename": "Mariahun SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222162": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Mariahu",
    "officename": "Barsathi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222165": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Mariahun",
    "officename": "Meerganj SO Jaunpur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222170": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Kerakat",
    "officename": "Muftiganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222175": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Badalapur",
    "officename": "Singramau SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222180": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Jaunpur",
    "officename": "Zafarabad SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222181": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Kerakat",
    "officename": "Thanagaddi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222201": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Machhali Shahar",
    "officename": "Balwarganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222202": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Machhali Shahar",
    "officename": "Mungra Badshahpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222203": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Mariahu",
    "officename": "Rampur SO Jaunpur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222204": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Machali Shahar",
    "officename": "Nibhapur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222301": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Lambhua",
    "officename": "Koiripur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "222302": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Lambhua",
    "officename": "Lambhua SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "222303": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Lambhua",
    "officename": "Maharani Pachchhim SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "223101": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Shahganj",
    "officename": "Shahganj SO Jaunpur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "223102": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Shahganj",
    "officename": "Patti Narendra SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "223103": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Shahganj",
    "officename": "Saraimohiddin SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "223104": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Shahganj",
    "officename": "Khuthan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "223105": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Shahganj",
    "officename": "Soithakalan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "223221": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Budanpur",
    "officename": "Aharaula SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "223222": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Phulpur",
    "officename": "Ambari SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "223223": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Budan Pur",
    "officename": "Ataraulia SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "223224": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Phool Pur.",
    "officename": "DIDARGANJ SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "223225": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Phoolpur",
    "officename": "MAHUL SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "223226": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Phoolpur",
    "officename": "PUSPNAGAR SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "223227": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Nizamabad",
    "officename": "Sanjar Pur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "224001": {
    "state": "Uttar Pradesh",
    "district": "Faizabad",
    "block": "Faizabad",
    "officename": "Faizabad HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224116": {
    "state": "Uttar Pradesh",
    "district": "Faizabad",
    "block": "Rudauli",
    "officename": "Bhilsar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224117": {
    "state": "Uttar Pradesh",
    "district": "Faizabad",
    "block": "Rudauli",
    "officename": "Mawai SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224118": {
    "state": "Uttar Pradesh",
    "district": "Barabanki",
    "block": "Rudauli",
    "officename": "Meermau SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224119": {
    "state": "Uttar Pradesh",
    "district": "Barabanki",
    "block": "Rudauli",
    "officename": "Patranga RS SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224120": {
    "state": "Uttar Pradesh",
    "district": "Barabanki",
    "block": "Rudauli",
    "officename": "Rudauli SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224121": {
    "state": "Uttar Pradesh",
    "district": "Faizabad",
    "block": "Milkipur",
    "officename": "Amaniganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224122": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Akbarpur",
    "officename": "Akbarpur HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224123": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Jalalpur",
    "officename": "Ayodhya SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224125": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Akbarpur",
    "officename": "Bandipur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224126": {
    "state": "Uttar Pradesh",
    "district": "Faizabad",
    "block": "Sohawal",
    "officename": "Baragaon RS SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224127": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Allapur",
    "officename": "Barun SO Ambedkar Nagar",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224129": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Alapur",
    "officename": "Baskhari SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224132": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Jalalpur",
    "officename": "Bhiti SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224133": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Allapur",
    "officename": "Dabha Samer SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224135": {
    "state": "Uttar Pradesh",
    "district": "Faizabad",
    "block": "Faizabad",
    "officename": "Darshan Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224137": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Alapur",
    "officename": "Deoria SO Ambedkar Nagar",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224139": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Jalalpur",
    "officename": "Dulahoopur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224141": {
    "state": "Uttar Pradesh",
    "district": "Faizabad",
    "block": "Faizabad",
    "officename": "Goshaiganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224143": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Alapur",
    "officename": "Hanswar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224145": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Tanda",
    "officename": "Iltifatganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224146": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Akberpur",
    "officename": "Jafarganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224147": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Alapur",
    "officename": "Jahangirganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224149": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Jalalpur",
    "officename": "Jalalpur SO Ambedkar Nagar",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224151": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Akberpur",
    "officename": "Katehari SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224152": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Jalalpur",
    "officename": "Mijhaura SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224153": {
    "state": "Uttar Pradesh",
    "district": "Faizabad",
    "block": "Milkipur",
    "officename": "Khandasa SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224155": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Tanda",
    "officename": "Kichhauccha SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224157": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Akbarur",
    "officename": "Khemapur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224158": {
    "state": "Uttar Pradesh",
    "district": "Faizabad",
    "block": "Milkipur",
    "officename": "Kuchera SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224159": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Jalalpur",
    "officename": "Malipur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224161": {
    "state": "Uttar Pradesh",
    "district": "Faizabad",
    "block": "Faizabad",
    "officename": "Maya SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224164": {
    "state": "Uttar Pradesh",
    "district": "Faizabad",
    "block": "Milkipur",
    "officename": "Milkipur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224168": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Akbarpur",
    "officename": "Pahitipur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224171": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Tanda",
    "officename": "Purah SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224172": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Tanda",
    "officename": "Rasulabad SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224176": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Jalalpur",
    "officename": "Rajesultanpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224181": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Alapur",
    "officename": "Ram Nagar SO Ambedkar Nagar",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224182": {
    "state": "Uttar Pradesh",
    "district": "Faizabad",
    "block": "Sohawal",
    "officename": "Raunahi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224183": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Jalalpur",
    "officename": "Saidahi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224186": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Alapur",
    "officename": "Sikandarpur SO Ambedkar Nagar",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224188": {
    "state": "Uttar Pradesh",
    "district": "Faizabad",
    "block": "Sohawal",
    "officename": "Sohawal RS SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224189": {
    "state": "Uttar Pradesh",
    "district": "Faizabad",
    "block": "Sohawal",
    "officename": "Deorhi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224190": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Jalalpur",
    "officename": "Tanda SO Ambedkar Nagar",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224195": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Akbarpur",
    "officename": "Tikari SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224201": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Akbarpur",
    "officename": "Motinagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224202": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Allapur",
    "officename": "Bharatkund SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224203": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Allapur **",
    "officename": "Rampur Bhagan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224204": {
    "state": "Uttar Pradesh",
    "district": "Faizabad",
    "block": "Bikapur",
    "officename": "Bikapur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224205": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Allapur **",
    "officename": "Khapradih SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224206": {
    "state": "Uttar Pradesh",
    "district": "Faizabad",
    "block": "Bikapur",
    "officename": "Khajurahat SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224207": {
    "state": "Uttar Pradesh",
    "district": "Faizabad",
    "block": "Bikapur",
    "officename": "Majurddinpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224208": {
    "state": "Uttar Pradesh",
    "district": "Faizabad",
    "block": "Bikapur",
    "officename": "Harringtonganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224209": {
    "state": "Uttar Pradesh",
    "district": "Faizabad",
    "block": "Bikapur",
    "officename": "Chaurebazar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224210": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Allapur",
    "officename": "Bariyawan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224225": {
    "state": "Uttar Pradesh",
    "district": "Faizabad",
    "block": "Faizabad",
    "officename": "Achhora SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224227": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Allapur **",
    "officename": "Surapur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224228": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Allapur **",
    "officename": "Inayatnagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224229": {
    "state": "Uttar Pradesh",
    "district": "Faizabad",
    "block": "Milkipur",
    "officename": "Kumarganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224230": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Tanda",
    "officename": "Kedarnagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224231": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Allapur **",
    "officename": "Maharuwa Gola SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224232": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Allapur",
    "officename": "Hakeem Pur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224234": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Jalalpur",
    "officename": "Mahboobganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224235": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Akbarpur",
    "officename": "UPSS Mill SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224238": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Jalalpur",
    "officename": "Vidhut Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "224284": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Jalalpur",
    "officename": "Shahganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "225001": {
    "state": "Uttar Pradesh",
    "district": "Barabanki",
    "block": "Nawabganj",
    "officename": "Barabanki HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Barabanki Division"
  },
  "225003": {
    "state": "Uttar Pradesh",
    "district": "Barabanki",
    "block": "Nawabganj",
    "officename": "Gandhi Aashram SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Barabanki Division"
  },
  "225119": {
    "state": "Uttar Pradesh",
    "district": "Barabanki",
    "block": "Haidergarh",
    "officename": "Kothi SO Barabanki",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Barabanki Division"
  },
  "225120": {
    "state": "Uttar Pradesh",
    "district": "Barabanki",
    "block": "Haider Garh",
    "officename": "Usmanpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Barabanki Division"
  },
  "225121": {
    "state": "Uttar Pradesh",
    "district": "Barabanki",
    "block": "Nawab Ganj",
    "officename": "Harakh SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Barabanki Division"
  },
  "225122": {
    "state": "Uttar Pradesh",
    "district": "Barabanki",
    "block": "Nawabganj",
    "officename": "Satrikh SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Barabanki Division"
  },
  "225123": {
    "state": "Uttar Pradesh",
    "district": "Barabanki",
    "block": "Nawabganj",
    "officename": "Somaiya Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Barabanki Division"
  },
  "225124": {
    "state": "Uttar Pradesh",
    "district": "Barabanki",
    "block": "Haider Garh",
    "officename": "Haidergarh SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Barabanki Division"
  },
  "225125": {
    "state": "Uttar Pradesh",
    "district": "Barabanki",
    "block": "Haider Garh",
    "officename": "Subeha SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Barabanki Division"
  },
  "225126": {
    "state": "Uttar Pradesh",
    "district": "Barabanki",
    "block": "Haider Garh",
    "officename": "Trivediganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Barabanki Division"
  },
  "225201": {
    "state": "Uttar Pradesh",
    "district": "Barabanki",
    "block": "Ramnagar",
    "officename": "Bahramghat SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Barabanki Division"
  },
  "225202": {
    "state": "Uttar Pradesh",
    "district": "Barabanki",
    "block": "Ramnagar",
    "officename": "Burhwal Sugar Mill SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Barabanki Division"
  },
  "225203": {
    "state": "Uttar Pradesh",
    "district": "Barabanki",
    "block": "Nawabganj",
    "officename": "Jahangeerabad Raj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Barabanki Division"
  },
  "225204": {
    "state": "Uttar Pradesh",
    "district": "Barabanki",
    "block": "Nawabganj",
    "officename": "Masauli SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Barabanki Division"
  },
  "225205": {
    "state": "Uttar Pradesh",
    "district": "Barabanki",
    "block": "Ramnagar",
    "officename": "Ramnagar SO Barabanki",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Barabanki Division"
  },
  "225206": {
    "state": "Uttar Pradesh",
    "district": "Barabanki",
    "block": "Sirauli Gauspur",
    "officename": "Saadatganj SO Barabanki",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Barabanki Division"
  },
  "225207": {
    "state": "Uttar Pradesh",
    "district": "Barabanki",
    "block": "Sirauli Gauspur",
    "officename": "Sirauli Gaus Pur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Barabanki Division"
  },
  "225208": {
    "state": "Uttar Pradesh",
    "district": "Barabanki",
    "block": "Ramnagar",
    "officename": "Tilokpur SO Barabanki",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Barabanki Division"
  },
  "225301": {
    "state": "Uttar Pradesh",
    "district": "Barabanki",
    "block": "Nawabganj",
    "officename": "Dewa Sharif SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Barabanki Division"
  },
  "225302": {
    "state": "Uttar Pradesh",
    "district": "Barabanki",
    "block": "Fateh Pur",
    "officename": "Kursi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Barabanki Division"
  },
  "225303": {
    "state": "Uttar Pradesh",
    "district": "Barabanki",
    "block": "Fateh Pur",
    "officename": "Mohammad Pur Khaley SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Barabanki Division"
  },
  "225304": {
    "state": "Uttar Pradesh",
    "district": "Barabanki",
    "block": "Fateh Pur",
    "officename": "Suratganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Barabanki Division"
  },
  "225305": {
    "state": "Uttar Pradesh",
    "district": "Barabanki",
    "block": "Fatehpur",
    "officename": "Tehsil Fateh Pur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Barabanki Division"
  },
  "225306": {
    "state": "Uttar Pradesh",
    "district": "Barabanki",
    "block": "Fateh Pur",
    "officename": "Shahpur Bhagauli SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Barabanki Division"
  },
  "225401": {
    "state": "Uttar Pradesh",
    "district": "Barabanki",
    "block": "Ram Sanehi Ghat",
    "officename": "Aliabad SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Barabanki Division"
  },
  "225403": {
    "state": "Uttar Pradesh",
    "district": "Barabanki",
    "block": "Ram Sanehi Ghat",
    "officename": "Dariya Bad SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Barabanki Division"
  },
  "225404": {
    "state": "Uttar Pradesh",
    "district": "Barabanki",
    "block": "Ramsanehighat",
    "officename": "Dariyabad RS SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Barabanki Division"
  },
  "225405": {
    "state": "Uttar Pradesh",
    "district": "Barabanki",
    "block": "Ram Sanehi Ghat",
    "officename": "Kotwa Sarak S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Barabanki Division"
  },
  "225409": {
    "state": "Uttar Pradesh",
    "district": "Barabanki",
    "block": "Ram Sanehi Ghat",
    "officename": "Ram Sanehi Ghat SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Barabanki Division"
  },
  "225412": {
    "state": "Uttar Pradesh",
    "district": "Barabanki",
    "block": "Nawabganj",
    "officename": "Safderganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Barabanki Division"
  },
  "225413": {
    "state": "Uttar Pradesh",
    "district": "Barabanki",
    "block": "Haider Garh",
    "officename": "Sidhaur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Barabanki Division"
  },
  "225414": {
    "state": "Uttar Pradesh",
    "district": "Barabanki",
    "block": "Nawabganj",
    "officename": "Zaidpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Barabanki Division"
  },
  "225415": {
    "state": "Uttar Pradesh",
    "district": "Barabanki",
    "block": "Ram Sanehi Ghat",
    "officename": "Tikait Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Barabanki Division"
  },
  "225416": {
    "state": "Uttar Pradesh",
    "district": "Barabanki",
    "block": "Haider Garh",
    "officename": "Asandra SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Barabanki Division"
  },
  "226001": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Lucknow",
    "officename": "Lucknow GPO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow GPO Division"
  },
  "226002": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Lucknow",
    "officename": "Dilkusha SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226003": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Lucknow",
    "officename": "Lucknow Chowk HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226004": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Lucknow",
    "officename": "Rajendranagar SO Lucknow",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226005": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Lucknow",
    "officename": "Alambagh SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226006": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Lucknow",
    "officename": "Mahanagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226007": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Lucknow",
    "officename": "New Hyderabad SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226008": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Lucknow",
    "officename": "Sarojini Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226009": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Lucknow",
    "officename": "AMAUSI AD SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226010": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Lucknow",
    "officename": "Gomti Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226011": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Lucknow",
    "officename": "MANAK NAGAR SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226012": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Lucknow",
    "officename": "LDA Colony SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226013": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Lucknow",
    "officename": "IIM Lucknow SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226014": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Lucknow",
    "officename": "Sgpgi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226015": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Lucknow",
    "officename": "Cimap SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226016": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Lucknow",
    "officename": "Indira Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226017": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Lucknow",
    "officename": "Avas Vikas Colony SO Lucknow",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226018": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Lucknow",
    "officename": "Aminabad Park SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226019": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Lucknow",
    "officename": "Industria Area Chinhat SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226020": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Lucknow",
    "officename": "Niralanagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226021": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Lucknow",
    "officename": "Jankipuram SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226022": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Lucknow",
    "officename": "Vikas Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226023": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Lucknow",
    "officename": "MANAS NAGAR SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226024": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Lucknow",
    "officename": "Aliganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226025": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Lucknow",
    "officename": "B R A University SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226026": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Lucknow",
    "officename": "Sanatan Dharam Vidya Peeth SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226027": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Mohanlalganj",
    "officename": "UPG Camp SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226028": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Lucknow",
    "officename": "Chinhat SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226029": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Lucknow",
    "officename": "Vrindavan Colony SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226030": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Lucknow",
    "officename": "Sushant Golf City SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226031": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Mohanlalganj",
    "officename": "Jankipuram Extension SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226101": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Lucknow",
    "officename": "Kakori SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226102": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Malihabad",
    "officename": "Malihabad SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226103": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Malihabad",
    "officename": "Rahimabad SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226104": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Malihabad",
    "officename": "MALL SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226201": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Bakshi Ka Talab",
    "officename": "Bakshi Ka Talab SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226202": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Mohanlalganj",
    "officename": "FFTC INDAURABAGH SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226203": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Bakshi Ka Ta",
    "officename": "Itaunja SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226301": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Mohanlalganj",
    "officename": "Mohanlalganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226302": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Mohanlalganj",
    "officename": "Nigohan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226303": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Mohanlalganj",
    "officename": "Nagram SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226401": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Lucknow",
    "officename": "Banthara SO Lucknow",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "226501": {
    "state": "Uttar Pradesh",
    "district": "Lucknow",
    "block": "Mohanlalganj",
    "officename": "Gosainganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Lucknow Division"
  },
  "227304": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Lambhua",
    "officename": "Bharkhare SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "227405": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Amethi",
    "officename": "Amethi HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "227406": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Amethi",
    "officename": "Bhadar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "227407": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Amethi",
    "officename": "Bisesarganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "227408": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Sultanpur",
    "officename": "Dhammaur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "227409": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Gauriganj",
    "officename": "Gauriganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "227411": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Gauraiganj",
    "officename": "Shahgarh SO Sultanpur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "227412": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Amethi",
    "officename": "H A L Korwa SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "227413": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Amethi",
    "officename": "Tikarmafi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "227801": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Gauriganj",
    "officename": "Gaura Jamon SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "227805": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Sultanpur",
    "officename": "Aliganj Bazar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "227806": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Musafirkhana",
    "officename": "Bazar Baldirai SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "227807": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Musafirkhana",
    "officename": "Pindara SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "227808": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Sultanpur",
    "officename": "Hasanpur SO Sultanpur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "227809": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Musafirkhana",
    "officename": "Jagdishpur SO Sultanpur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "227811": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Musafirkhana",
    "officename": "Sukul Ka Bazar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "227812": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Musafirkhana",
    "officename": "Wallipur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "227813": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Musafirkhana",
    "officename": "Musafirkhana SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "227814": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Sultanpur",
    "officename": "Ataula SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "227815": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Sultanpur",
    "officename": "Haliapur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "227816": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Amethi",
    "officename": "Raniganj SO Sultanpur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "227817": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Musafirkhana",
    "officename": "Jagdishpur Industrial Area SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "228001": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Sultanpur Sadar",
    "officename": "Sultanpur Avadh HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "228118": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Sultanpur",
    "officename": "Kamla Nehru Institute SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "228119": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Sultanpur",
    "officename": "Gosainganj SO Sultanpur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "228120": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Sultanpur",
    "officename": "Baraunsa SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "228121": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Sultanpur",
    "officename": "Atarsuma SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "228125": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Sultanpur",
    "officename": "Dwarikaganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "228131": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Kadipiur",
    "officename": "Dostpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "228132": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Kadipur",
    "officename": "Deara SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "228133": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Kadipur",
    "officename": "Belahari SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "228141": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Kadipur",
    "officename": "Jaisinghpur SO Sultanpur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "228142": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Sultanpur",
    "officename": "Mahmoodpur Semri SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "228145": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Kadipur",
    "officename": "Kadipur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "228151": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Sultanpur",
    "officename": "Kurebhar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "228155": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Sultanpur",
    "officename": "Kurwar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "228159": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Amethi",
    "officename": "Ramganj SO Sultanpur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "228161": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Kadipur",
    "officename": "Tawakkalpur Nagra SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "228171": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Kadipur",
    "officename": "Akhandnagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "229001": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Rae Bareli",
    "officename": "Raebarely HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229010": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Rae Bareli",
    "officename": "ITI SO Raebareli",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229103": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Mrg",
    "officename": "Hallaur SO Raebareli",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229120": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Lalganj",
    "officename": "Rail Coach Factory LalganjRaebareli SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229121": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Lalganj",
    "officename": "Aihar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229122": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Raebareli",
    "officename": "Gurbuxganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229123": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Mrg",
    "officename": "Hardoi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229124": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Salon",
    "officename": "K K Bajar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229125": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Dalmau",
    "officename": "Kathgar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229126": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Tiloi",
    "officename": "Semrauta SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229127": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Salon",
    "officename": "Salon SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229128": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Rbl",
    "officename": "Mejarganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229129": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Salon",
    "officename": "Parsadepur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229130": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Lalganj",
    "officename": "Malik Mau Chaubara SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229135": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Tiloi",
    "officename": "Aharwabhawani SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229201": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Lalganj",
    "officename": "Behta SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229202": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Lalganj",
    "officename": "Bhojpur SO Raebareli",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229203": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Dalmau",
    "officename": "Dalmau SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229204": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Dalmau",
    "officename": "Gaura SO Raebareli",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229205": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Lalganj",
    "officename": "Khiro SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229206": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Lalganj",
    "officename": "Lalganj Raebareli HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229207": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Dalmau",
    "officename": "Murai Ka Bagh SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229208": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Lalganj",
    "officename": "Nihastha SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229209": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Lalganj",
    "officename": "Paho SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229210": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Lalganj",
    "officename": "Atarhar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229211": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Lalganj",
    "officename": "Semri SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229212": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Lalganj",
    "officename": "Sareni SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229215": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Lalganj",
    "officename": "Purepandey SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229216": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Lalganj",
    "officename": "Cheolaha SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229301": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Mahrajganj",
    "officename": "Bachrawan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229302": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Tiloi",
    "officename": "Fursatganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229303": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Rbl",
    "officename": "Harchandpur SO Raebareli",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229304": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Salon",
    "officename": "Harbansganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229305": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Salon",
    "officename": "Jais SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229306": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Maharajganj",
    "officename": "Mahrajganj SO Raebareli",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229307": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Salon",
    "officename": "Nasirabad SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229308": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Mrg",
    "officename": "Shivgarh SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229309": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Tiloi",
    "officename": "Tiloi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229310": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Salon",
    "officename": "Deeh SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229311": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Mrg",
    "officename": "Sehgon SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229316": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Rae Bareli",
    "officename": "Ratapur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229401": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Unchahar **",
    "officename": "Itaurabujurg SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229402": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Unchahar",
    "officename": "Jagatpur SO Raebareli",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229404": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Unchahar **",
    "officename": "Mustafabad SO Raebareli",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229405": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Rbl",
    "officename": "Munshiganj SO Raebareli",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229406": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Unchahar",
    "officename": "Fgtp Unchahar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229408": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Kunda",
    "officename": "Kalakankar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "229410": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Lalganj",
    "officename": "Kaithola SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "229411": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Anapur",
    "officename": "Anapur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "229412": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Allahabad",
    "officename": "Atrampur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "229413": {
    "state": "Uttar Pradesh",
    "district": "Allahabad",
    "block": "Lalgopal Ganj",
    "officename": "Lalgopal Ganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "229801": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Tiloi",
    "officename": "Inhauna SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "229802": {
    "state": "Uttar Pradesh",
    "district": "Raebareli",
    "block": "Mrg",
    "officename": "Sheoratanganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Rae Bareilly Division"
  },
  "230001": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Pratapgarh",
    "officename": "Pratapgarh HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "230002": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Sadar",
    "officename": "Pratapgarh City SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "230121": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Patti",
    "officename": "PDCHAURAHA SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "230124": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Patti",
    "officename": "Amargarh SO Pratapgarh",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "230125": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Lalganj",
    "officename": "Atheha SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "230126": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Lalganj",
    "officename": "Babuganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "230127": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Raniganj",
    "officename": "Dalippur SO Pratapgarh",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "230128": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Kunda",
    "officename": "Derwa SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "230129": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Lalganj",
    "officename": "Jethwara SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "230130": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Lalganj",
    "officename": "Laxmanpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "230131": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Pratapgarh",
    "officename": "Katra Medniganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "230132": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Lalgang",
    "officename": "Lalganj",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "230133": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "NA",
    "officename": "PIRTHIGANJ BAZAR SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "230134": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Patti",
    "officename": "Oraiyadeeh SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "230135": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Patti",
    "officename": "Patti",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "230136": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Lalganj",
    "officename": "Sagra SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "230137": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Lalganj",
    "officename": "Sahebganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "230138": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Patti",
    "officename": "Saifabad SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "230139": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Lalganj",
    "officename": "Sangipur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "230141": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Kunda",
    "officename": "Sangramgarh SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "230142": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Patti",
    "officename": "Shitlaganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "230143": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Lalganj",
    "officename": "Babaganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "230144": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Sadar",
    "officename": "Ajgara SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "230201": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Kunda",
    "officename": "Bhadri SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "230202": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Kunda",
    "officename": "Garhi Manikpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "230204": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Kunda",
    "officename": "Kunda",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "230301": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Raniganj",
    "officename": "Gaura R S SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "230302": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Raniganj",
    "officename": "Jamtali SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "230304": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Raniganj",
    "officename": "Raniganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "230306": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Patti",
    "officename": "Suwansa SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "230401": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Patti",
    "officename": "Kohdaur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "230402": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Sadar",
    "officename": "Mandhata SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "230403": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Pratapgarh",
    "officename": "Madhoganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "230404": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Patti",
    "officename": "Vishwanathganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "230405": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Patti",
    "officename": "Darchhut SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "230501": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Sadar",
    "officename": "Antu SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "230502": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Sadar",
    "officename": "Garwara SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "230503": {
    "state": "Uttar Pradesh",
    "district": "Pratapgarh",
    "block": "Lalganj",
    "officename": "Kishunganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Pratapgarh Division"
  },
  "231001": {
    "state": "Uttar Pradesh",
    "district": "Mirzapur",
    "block": "Mirzapursadar",
    "officename": "Mirzapur HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Mirzapur Division"
  },
  "231205": {
    "state": "Uttar Pradesh",
    "district": "Sonbhadra",
    "block": "Robertsganj",
    "officename": "Chopan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Mirzapur Division"
  },
  "231206": {
    "state": "Uttar Pradesh",
    "district": "Sonbhadra",
    "block": "Robertsganj",
    "officename": "Churk SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Mirzapur Division"
  },
  "231207": {
    "state": "Uttar Pradesh",
    "district": "Sonbhadra",
    "block": "Sonbhadra",
    "officename": "Dalla SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Mirzapur Division"
  },
  "231208": {
    "state": "Uttar Pradesh",
    "district": "Sonbhadra",
    "block": "Sonbhadra",
    "officename": "Dudhi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Mirzapur Division"
  },
  "231209": {
    "state": "Uttar Pradesh",
    "district": "Sonbhadra",
    "block": "Sonbhadra",
    "officename": "Gurma Markundi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Mirzapur Division"
  },
  "231210": {
    "state": "Uttar Pradesh",
    "district": "Sonbhadra",
    "block": "Mirzapur",
    "officename": "Ghorawal SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Mirzapur Division"
  },
  "231211": {
    "state": "Uttar Pradesh",
    "district": "Mirzapur",
    "block": "Mirzapur",
    "officename": "Lalganj Mirzapur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Mirzapur Division"
  },
  "231212": {
    "state": "Uttar Pradesh",
    "district": "Sonbhadra",
    "block": "Mirzapur Sadar",
    "officename": "Amwar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Mirzapur Division"
  },
  "231213": {
    "state": "Uttar Pradesh",
    "district": "Sonbhadra",
    "block": "Sonbhadra",
    "officename": "Ram Garh SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Mirzapur Division"
  },
  "231215": {
    "state": "Uttar Pradesh",
    "district": "Sonbhadra",
    "block": "Sonbhadra",
    "officename": "Rajpur SO Sonbhadra",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Mirzapur Division"
  },
  "231216": {
    "state": "Uttar Pradesh",
    "district": "Sonbhadra",
    "block": "Sonbhadra",
    "officename": "Robertsganj HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Mirzapur Division"
  },
  "231217": {
    "state": "Uttar Pradesh",
    "district": "Sonbhadra",
    "block": "Sonbhadra",
    "officename": "Renukoot SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Mirzapur Division"
  },
  "231218": {
    "state": "Uttar Pradesh",
    "district": "Sonbhadra",
    "block": "Sonbhadra",
    "officename": "Renusagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Mirzapur Division"
  },
  "231219": {
    "state": "Uttar Pradesh",
    "district": "Sonbhadra",
    "block": "Sonbhadra",
    "officename": "Obra SO Sonbhadra",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Mirzapur Division"
  },
  "231220": {
    "state": "Uttar Pradesh",
    "district": "Sonbhadra",
    "block": "Sonbhadra",
    "officename": "Beena Project SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Mirzapur Division"
  },
  "231221": {
    "state": "Uttar Pradesh",
    "district": "Sonbhadra",
    "block": "Sonbhadra",
    "officename": "Turra SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Mirzapur Division"
  },
  "231222": {
    "state": "Uttar Pradesh",
    "district": "Sonbhadra",
    "block": "Sonbhadra",
    "officename": "Shaktinagar SO Sonbhadra",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Mirzapur Division"
  },
  "231223": {
    "state": "Uttar Pradesh",
    "district": "Sonbhadra",
    "block": "Sonbhadra",
    "officename": "Beej Pur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Mirzapur Division"
  },
  "231224": {
    "state": "Uttar Pradesh",
    "district": "Sonbhadra",
    "block": "Sonbhadra",
    "officename": "Kakari Project SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Mirzapur Division"
  },
  "231225": {
    "state": "Uttar Pradesh",
    "district": "Sonbhadra",
    "block": "Dudhi",
    "officename": "Anpara Tps SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Mirzapur Division"
  },
  "231226": {
    "state": "Uttar Pradesh",
    "district": "Sonbhadra",
    "block": "Dudhi",
    "officename": "Wyndhamganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Mirzapur Division"
  },
  "231301": {
    "state": "Uttar Pradesh",
    "district": "Mirzapur",
    "block": "Chunar",
    "officename": "Ahraura SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Mirzapur Division"
  },
  "231302": {
    "state": "Uttar Pradesh",
    "district": "Mirzapur",
    "block": "Sadar",
    "officename": "Adalhat SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Mirzapur Division"
  },
  "231303": {
    "state": "Uttar Pradesh",
    "district": "Mirzapur",
    "block": "Mirzapur",
    "officename": "Bijaipur SO Mirzapur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Mirzapur Division"
  },
  "231304": {
    "state": "Uttar Pradesh",
    "district": "Mirzapur",
    "block": "Chunar",
    "officename": "Chunar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Mirzapur Division"
  },
  "231305": {
    "state": "Uttar Pradesh",
    "district": "Mirzapur",
    "block": "Chunar",
    "officename": "Narainpur SO Mirzapur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Mirzapur Division"
  },
  "231306": {
    "state": "Uttar Pradesh",
    "district": "Mirzapur",
    "block": "Chunar",
    "officename": "Sikhar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Mirzapur Division"
  },
  "231307": {
    "state": "Uttar Pradesh",
    "district": "Mirzapur",
    "block": "Mirzapur",
    "officename": "Vindhyachal SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Mirzapur Division"
  },
  "231309": {
    "state": "Uttar Pradesh",
    "district": "Mirzapur",
    "block": "Mirzapur",
    "officename": "Kubari Patehara SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Mirzapur Division"
  },
  "231311": {
    "state": "Uttar Pradesh",
    "district": "Mirzapur",
    "block": "Chunar",
    "officename": "Chunar Cement Factory SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Mirzapur Division"
  },
  "231312": {
    "state": "Uttar Pradesh",
    "district": "Mirzapur",
    "block": "Mirzapur",
    "officename": "Chilh SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Mirzapur Division"
  },
  "231313": {
    "state": "Uttar Pradesh",
    "district": "Mirzapur",
    "block": "Mirzapur",
    "officename": "Jigna RS SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Mirzapur Division"
  },
  "231314": {
    "state": "Uttar Pradesh",
    "district": "Mirzapur",
    "block": "Mirzapur Sadar",
    "officename": "Jamua SO Mirzapur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Mirzapur Division"
  },
  "231501": {
    "state": "Uttar Pradesh",
    "district": "Mirzapur",
    "block": "Sadar",
    "officename": "Kachhwa SO Mirzapur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Mirzapur Division"
  },
  "232101": {
    "state": "Uttar Pradesh",
    "district": "Chandauli",
    "block": "Chandauli",
    "officename": "Pandit Deendayal Upadhyay SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi East Division"
  },
  "232102": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "Baburi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi East Division"
  },
  "232103": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "Chakia SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi East Division"
  },
  "232104": {
    "state": "Uttar Pradesh",
    "district": "Chandauli",
    "block": "Chandauli",
    "officename": "Chandauli SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi East Division"
  },
  "232105": {
    "state": "Uttar Pradesh",
    "district": "Chandauli",
    "block": "Sakaldhia",
    "officename": "Dhanapur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi East Division"
  },
  "232106": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "Kamalpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi East Division"
  },
  "232107": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Sakaldiha",
    "officename": "Ramgarh SO Chandauli",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi East Division"
  },
  "232108": {
    "state": "Uttar Pradesh",
    "district": "Chandauli",
    "block": "Sakaldiha",
    "officename": "Sakaldiha SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi East Division"
  },
  "232109": {
    "state": "Uttar Pradesh",
    "district": "Chandauli",
    "block": "Sakaldiha",
    "officename": "Sakaldiha Bazar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi East Division"
  },
  "232110": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "Saiyadraja SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi East Division"
  },
  "232111": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi",
    "officename": "Naugarh SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi East Division"
  },
  "232118": {
    "state": "Uttar Pradesh",
    "district": "Chandauli",
    "block": "Chakia",
    "officename": "Sahabganj SO Chandauli",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi East Division"
  },
  "232120": {
    "state": "Uttar Pradesh",
    "district": "Chandauli",
    "block": "Sakaldiha",
    "officename": "Sadalpura SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi East Division"
  },
  "232325": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Zamania",
    "officename": "BARA",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "232326": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Zamania",
    "officename": "Dildarnagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "232327": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Zamania",
    "officename": "Gahmar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "232328": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Zamania",
    "officename": "Reotipur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "232329": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Zamania",
    "officename": "Zamania SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "232330": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Zamania",
    "officename": "Usia SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "232331": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Zamania",
    "officename": "Zamania RS SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "232332": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Zamania",
    "officename": "Tarighat SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "232333": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Zamania",
    "officename": "Satramganj Bazar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "232336": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Zamania",
    "officename": "Dharhni SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "232339": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Zamania",
    "officename": "Karahiya SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "232340": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Zamania",
    "officename": "Deoria SO Ghazipur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "233001": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Ghazipur",
    "officename": "Ghazipur HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "233002": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Ghazipur",
    "officename": "Peernagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "233221": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Saidpur",
    "officename": "Aurihar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "233222": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Mohammedabad",
    "officename": "Gangauli SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "233223": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Saidpur",
    "officename": "Rampur SO Ghazipur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "233224": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Zamania",
    "officename": "Karanda SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "233225": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Mohammadabad",
    "officename": "Karimuddinpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "233226": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Ghazipur",
    "officename": "Mardah SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "233227": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Mohammedabad",
    "officename": "Mohammadabad Yusufpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "233228": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Mohammedabad",
    "officename": "Tajpur Dehma SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "233229": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Mohammadabad Yusufpur",
    "officename": "BARACHAWAR SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "233230": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Mohammadabad",
    "officename": "Kasimabad SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "233231": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Mohammadabad Yusufpur",
    "officename": "BHAWARKOL SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "233232": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Zamania",
    "officename": "Goshandepur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "233233": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Mohammedabad",
    "officename": "Khardiha SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "233300": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Ghazipur",
    "officename": "BIRNO SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "233301": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Mohammedabad",
    "officename": "Mubarakpur SO Ghazipur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "233302": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Saidpur",
    "officename": "Nandganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "233303": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Ghazipur",
    "officename": "Nonhara SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "233304": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Saidpur",
    "officename": "Saidpur SO Ghazipur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "233305": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Ghazipur",
    "officename": "ZANGIPUR SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "233306": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Saidpur",
    "officename": "Deokali SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "233307": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Saidpur",
    "officename": "BHIMAPAR SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "233310": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Ghazipur",
    "officename": "Malikpura SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "233311": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Saidpur",
    "officename": "NSS Mill SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "241001": {
    "state": "Uttar Pradesh",
    "district": "Hardoi",
    "block": "Hardoi",
    "officename": "Hardoi HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Hardoi Division"
  },
  "241121": {
    "state": "Uttar Pradesh",
    "district": "Hardoi",
    "block": "Hardoi",
    "officename": "Aihrori SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Hardoi Division"
  },
  "241122": {
    "state": "Uttar Pradesh",
    "district": "Hardoi",
    "block": "Hardoi",
    "officename": "Baghauli SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Hardoi Division"
  },
  "241123": {
    "state": "Uttar Pradesh",
    "district": "Hardoi",
    "block": "Sawayajpur",
    "officename": "Pali SO Hardoi",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Hardoi Division"
  },
  "241124": {
    "state": "Uttar Pradesh",
    "district": "Hardoi",
    "block": "Sawayajpur",
    "officename": "Shahabad SO Hardoi",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Hardoi Division"
  },
  "241125": {
    "state": "Uttar Pradesh",
    "district": "Hardoi",
    "block": "Hardoi",
    "officename": "Behta Gokul SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Hardoi Division"
  },
  "241126": {
    "state": "Uttar Pradesh",
    "district": "Hardoi",
    "block": "Sandila",
    "officename": "Kachhauna SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Hardoi Division"
  },
  "241127": {
    "state": "Uttar Pradesh",
    "district": "Hardoi",
    "block": "Sandila",
    "officename": "Sandila I Estate SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Hardoi Division"
  },
  "241201": {
    "state": "Uttar Pradesh",
    "district": "Hardoi",
    "block": "Sandila",
    "officename": "Behander SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Hardoi Division"
  },
  "241202": {
    "state": "Uttar Pradesh",
    "district": "Hardoi",
    "block": "Sandila",
    "officename": "Bharawan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Hardoi Division"
  },
  "241203": {
    "state": "Uttar Pradesh",
    "district": "Hardoi",
    "block": "Sandila",
    "officename": "Dhikunni SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Hardoi Division"
  },
  "241204": {
    "state": "Uttar Pradesh",
    "district": "Hardoi",
    "block": "Sandila",
    "officename": "Sandila SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Hardoi Division"
  },
  "241301": {
    "state": "Uttar Pradesh",
    "district": "Hardoi",
    "block": "Bilgram",
    "officename": "Bilgram SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Hardoi Division"
  },
  "241302": {
    "state": "Uttar Pradesh",
    "district": "Hardoi",
    "block": "Sandila",
    "officename": "Madhoganj SO Hardoi",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Hardoi Division"
  },
  "241303": {
    "state": "Uttar Pradesh",
    "district": "Hardoi",
    "block": "Sandila",
    "officename": "Mallawan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Hardoi Division"
  },
  "241304": {
    "state": "Uttar Pradesh",
    "district": "Hardoi",
    "block": "Sandila",
    "officename": "Beniganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Hardoi Division"
  },
  "241305": {
    "state": "Uttar Pradesh",
    "district": "Hardoi",
    "block": "Sandila",
    "officename": "Gaus Ganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Hardoi Division"
  },
  "241401": {
    "state": "Uttar Pradesh",
    "district": "Hardoi",
    "block": "Hardoi",
    "officename": "Barwan SO Hardoi",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Hardoi Division"
  },
  "241402": {
    "state": "Uttar Pradesh",
    "district": "Hardoi",
    "block": "Hardoi",
    "officename": "Harpalpur SO Hardoi",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Hardoi Division"
  },
  "241403": {
    "state": "Uttar Pradesh",
    "district": "Hardoi",
    "block": "Harodi",
    "officename": "Sandi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Hardoi Division"
  },
  "241404": {
    "state": "Uttar Pradesh",
    "district": "Hardoi",
    "block": "Hardoi",
    "officename": "Gopamau SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Hardoi Division"
  },
  "241405": {
    "state": "Uttar Pradesh",
    "district": "Hardoi",
    "block": "Hardoi",
    "officename": "Hariyawan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Hardoi Division"
  },
  "241406": {
    "state": "Uttar Pradesh",
    "district": "Hardoi",
    "block": "Hardoi",
    "officename": "Pihani SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Hardoi Division"
  },
  "241407": {
    "state": "Uttar Pradesh",
    "district": "Hardoi",
    "block": "Hardoi",
    "officename": "Saadat Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Hardoi Division"
  },
  "242001": {
    "state": "Uttar Pradesh",
    "district": "Shahjahanpur",
    "block": "Shahjahanpur",
    "officename": "Shahjahanpur HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Shahjahanpur Division"
  },
  "242021": {
    "state": "Uttar Pradesh",
    "district": "Budaun",
    "block": "Budaun",
    "officename": "IA Babrala SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Budaun Division"
  },
  "242042": {
    "state": "Uttar Pradesh",
    "district": "Shahjahanpur",
    "block": "Powayan",
    "officename": "Banda SO Shahjahanpur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Shahjahanpur Division"
  },
  "242127": {
    "state": "Uttar Pradesh",
    "district": "Shahjahanpur",
    "block": "Jalalabad",
    "officename": "R B Kalan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Shahjahanpur Division"
  },
  "242220": {
    "state": "Uttar Pradesh",
    "district": "Shahjahanpur",
    "block": "Jalalabad",
    "officename": "Allahganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Shahjahanpur Division"
  },
  "242221": {
    "state": "Uttar Pradesh",
    "district": "Shahjahanpur",
    "block": "Jalalabad",
    "officename": "Jalalabad SO Shahjahanpur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Shahjahanpur Division"
  },
  "242223": {
    "state": "Uttar Pradesh",
    "district": "Shahjahanpur",
    "block": "Sadar",
    "officename": "Kant SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Shahjahanpur Division"
  },
  "242226": {
    "state": "Uttar Pradesh",
    "district": "Shahjahanpur",
    "block": "Shahjahanpur",
    "officename": "M Ashram SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Shahjahanpur Division"
  },
  "242301": {
    "state": "Uttar Pradesh",
    "district": "Shahjahanpur",
    "block": "Tilhar",
    "officename": "Miranpur Katra SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Shahjahanpur Division"
  },
  "242303": {
    "state": "Uttar Pradesh",
    "district": "Shahjahanpur",
    "block": "Tilhar",
    "officename": "Khera Bajhera SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Shahjahanpur Division"
  },
  "242305": {
    "state": "Uttar Pradesh",
    "district": "Shahjahanpur",
    "block": "Tilhar",
    "officename": "Khudaganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Shahjahanpur Division"
  },
  "242306": {
    "state": "Uttar Pradesh",
    "district": "Shahjahanpur",
    "block": "Shahjahanpur",
    "officename": "Rosa RS SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Shahjahanpur Division"
  },
  "242307": {
    "state": "Uttar Pradesh",
    "district": "Shahjahanpur",
    "block": "Tilhar",
    "officename": "Tilhar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Shahjahanpur Division"
  },
  "242401": {
    "state": "Uttar Pradesh",
    "district": "Shahjahanpur",
    "block": "Powayan",
    "officename": "Powayan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Shahjahanpur Division"
  },
  "242405": {
    "state": "Uttar Pradesh",
    "district": "Shahjahanpur",
    "block": "Powayan",
    "officename": "Khutar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Shahjahanpur Division"
  },
  "242406": {
    "state": "Uttar Pradesh",
    "district": "Shahjahanpur",
    "block": "Sadar",
    "officename": "Rosa SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Shahjahanpur Division"
  },
  "242407": {
    "state": "Uttar Pradesh",
    "district": "Shahjahanpur",
    "block": "Tilhar",
    "officename": "Nigohi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Shahjahanpur Division"
  },
  "243001": {
    "state": "Uttar Pradesh",
    "district": "Bareilly",
    "block": "Bareilly",
    "officename": "Bareilly HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bareilly Division"
  },
  "243002": {
    "state": "Uttar Pradesh",
    "district": "Bareilly",
    "block": "Bareilly",
    "officename": "Airforce Station",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bareilly Division"
  },
  "243003": {
    "state": "Uttar Pradesh",
    "district": "Bareilly",
    "block": "Bareilly",
    "officename": "Bareilly City",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bareilly Division"
  },
  "243004": {
    "state": "Uttar Pradesh",
    "district": "Bareilly",
    "block": "Bareilly",
    "officename": "ITBP",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bareilly Division"
  },
  "243005": {
    "state": "Uttar Pradesh",
    "district": "Bareilly",
    "block": "Bareilly",
    "officename": "Shamat Ganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bareilly Division"
  },
  "243006": {
    "state": "Uttar Pradesh",
    "district": "Bareilly",
    "block": "Bareilly",
    "officename": "RKUniversity SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bareilly Division"
  },
  "243122": {
    "state": "Uttar Pradesh",
    "district": "Bareilly",
    "block": "Bareilly",
    "officename": "Izzatnagar",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bareilly Division"
  },
  "243123": {
    "state": "Uttar Pradesh",
    "district": "Bareilly",
    "block": "Bareilly",
    "officename": "PACDso SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bareilly Division"
  },
  "243126": {
    "state": "Uttar Pradesh",
    "district": "Bareilly",
    "block": "Bareilly",
    "officename": "Bhuta",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bareilly Division"
  },
  "243201": {
    "state": "Uttar Pradesh",
    "district": "Bareilly",
    "block": "Baheri",
    "officename": "Baheri",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bareilly Division"
  },
  "243202": {
    "state": "Uttar Pradesh",
    "district": "Bareilly",
    "block": "Baheri",
    "officename": "Bhojipura",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bareilly Division"
  },
  "243203": {
    "state": "Uttar Pradesh",
    "district": "Bareilly",
    "block": "Baheri",
    "officename": "Deorania",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bareilly Division"
  },
  "243301": {
    "state": "Uttar Pradesh",
    "district": "Bareilly",
    "block": "Aonla",
    "officename": "Aonla SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bareilly Division"
  },
  "243302": {
    "state": "Uttar Pradesh",
    "district": "Bareilly",
    "block": "Aonla",
    "officename": "Bisharatganj",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bareilly Division"
  },
  "243303": {
    "state": "Uttar Pradesh",
    "district": "Bareilly",
    "block": "Aonla",
    "officename": "Ram Nagar SO Bareilly",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bareilly Division"
  },
  "243401": {
    "state": "Uttar Pradesh",
    "district": "Bareilly",
    "block": "Aonla",
    "officename": "Bhamora SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bareilly Division"
  },
  "243402": {
    "state": "Uttar Pradesh",
    "district": "Bareilly",
    "block": "Bareilly",
    "officename": "Ballia SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bareilly Division"
  },
  "243403": {
    "state": "Uttar Pradesh",
    "district": "Bareilly",
    "block": "Aonla",
    "officename": "Iffco Township SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bareilly Division"
  },
  "243407": {
    "state": "Uttar Pradesh",
    "district": "Bareilly",
    "block": "Nawabganj",
    "officename": "Senthal SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bareilly Division"
  },
  "243501": {
    "state": "Uttar Pradesh",
    "district": "Bareilly",
    "block": "Bareilly",
    "officename": "B R Factory",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bareilly Division"
  },
  "243502": {
    "state": "Uttar Pradesh",
    "district": "Bareilly",
    "block": "Bareilly",
    "officename": "CBGanj",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bareilly Division"
  },
  "243503": {
    "state": "Uttar Pradesh",
    "district": "Bareilly",
    "block": "Faridpur",
    "officename": "Faridpur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bareilly Division"
  },
  "243504": {
    "state": "Uttar Pradesh",
    "district": "Bareilly",
    "block": "Meerganj",
    "officename": "Meerganj SO Bareilly",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bareilly Division"
  },
  "243505": {
    "state": "Uttar Pradesh",
    "district": "Bareilly",
    "block": "Meerganj",
    "officename": "Shahi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bareilly Division"
  },
  "243506": {
    "state": "Uttar Pradesh",
    "district": "Bareilly",
    "block": "Faridpur",
    "officename": "Fatehganj East",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bareilly Division"
  },
  "243601": {
    "state": "Uttar Pradesh",
    "district": "Budaun",
    "block": "Budaun",
    "officename": "Budaun HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Budaun Division"
  },
  "243630": {
    "state": "Uttar Pradesh",
    "district": "Budaun",
    "block": "Dataganj",
    "officename": "Samrer SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Budaun Division"
  },
  "243631": {
    "state": "Uttar Pradesh",
    "district": "Budaun",
    "block": "Dataganj",
    "officename": "Allapur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Budaun Division"
  },
  "243632": {
    "state": "Uttar Pradesh",
    "district": "Budaun",
    "block": "Busauli",
    "officename": "Asafpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Budaun Division"
  },
  "243633": {
    "state": "Uttar Pradesh",
    "district": "Budaun",
    "block": "Bilsi",
    "officename": "Bilsi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Budaun Division"
  },
  "243634": {
    "state": "Uttar Pradesh",
    "district": "Budaun",
    "block": "Budaun",
    "officename": "Binawar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Budaun Division"
  },
  "243635": {
    "state": "Uttar Pradesh",
    "district": "Budaun",
    "block": "Dataganj",
    "officename": "Dataganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Budaun Division"
  },
  "243636": {
    "state": "Uttar Pradesh",
    "district": "Budaun",
    "block": "Dataganj",
    "officename": "Kachhla SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Budaun Division"
  },
  "243637": {
    "state": "Uttar Pradesh",
    "district": "Budaun",
    "block": "Dataganj",
    "officename": "Kakrala SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Budaun Division"
  },
  "243638": {
    "state": "Uttar Pradesh",
    "district": "Budaun",
    "block": "Sahaswan",
    "officename": "Sahaswan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Budaun Division"
  },
  "243639": {
    "state": "Uttar Pradesh",
    "district": "Budaun",
    "block": "Budaun",
    "officename": "Ujhani SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Budaun Division"
  },
  "243641": {
    "state": "Uttar Pradesh",
    "district": "Budaun",
    "block": "Dataganj",
    "officename": "Usehat SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Budaun Division"
  },
  "243720": {
    "state": "Uttar Pradesh",
    "district": "Budaun",
    "block": "Bisuali",
    "officename": "Bisauli SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Budaun Division"
  },
  "243722": {
    "state": "Uttar Pradesh",
    "district": "Budaun",
    "block": "Gunnaur",
    "officename": "Gunnaur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Budaun Division"
  },
  "243723": {
    "state": "Uttar Pradesh",
    "district": "Budaun",
    "block": "Bilsi",
    "officename": "Islamnagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Budaun Division"
  },
  "243724": {
    "state": "Uttar Pradesh",
    "district": "Budaun",
    "block": "Bisauli",
    "officename": "Rudain SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Budaun Division"
  },
  "243725": {
    "state": "Uttar Pradesh",
    "district": "Budaun",
    "block": "Bisauli",
    "officename": "Saidpur SO Budaun",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Budaun Division"
  },
  "243726": {
    "state": "Uttar Pradesh",
    "district": "Budaun",
    "block": "Budaun",
    "officename": "Wazirganj SO Budaun",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Budaun Division"
  },
  "243727": {
    "state": "Uttar Pradesh",
    "district": "Budaun",
    "block": "Guoour",
    "officename": "Rajpura SO Budaun",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Budaun Division"
  },
  "243751": {
    "state": "Uttar Pradesh",
    "district": "Budaun",
    "block": "Budaun",
    "officename": "Babrala SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Budaun Division"
  },
  "244001": {
    "state": "Uttar Pradesh",
    "district": "Moradabad",
    "block": "Moradabad",
    "officename": "Moradabad HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244102": {
    "state": "Uttar Pradesh",
    "district": "Moradabad",
    "block": "Moradabad",
    "officename": "Pakbara SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244103": {
    "state": "Uttar Pradesh",
    "district": "Moradabad",
    "block": "Moradabad",
    "officename": "Majhola SO Moradabad",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244104": {
    "state": "Uttar Pradesh",
    "district": "Moradabad",
    "block": "Moradabad",
    "officename": "Mundha SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244221": {
    "state": "Uttar Pradesh",
    "district": "Jyotiba Phule Nagar",
    "block": "Amroha",
    "officename": "Amroha HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244222": {
    "state": "Uttar Pradesh",
    "district": "Jyotiba Phule Nagar",
    "block": "Amroha",
    "officename": "Joya SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244223": {
    "state": "Uttar Pradesh",
    "district": "Jyotiba Phule Nagar",
    "block": "Dhanaura",
    "officename": "Bhartiya Gram SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244225": {
    "state": "Uttar Pradesh",
    "district": "Jyotiba Phule Nagar",
    "block": "Amroha",
    "officename": "Bachhraon SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244231": {
    "state": "Uttar Pradesh",
    "district": "Jyotiba Phule Nagar",
    "block": "Dhanaura",
    "officename": "Dhanaura SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244235": {
    "state": "Uttar Pradesh",
    "district": "Jyotiba Phule Nagar",
    "block": "Hasanpur",
    "officename": "Gajraula SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244236": {
    "state": "Uttar Pradesh",
    "district": "Jyotiba Phule Nagar",
    "block": "Amroha",
    "officename": "Rajab Pur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244241": {
    "state": "Uttar Pradesh",
    "district": "Jyotiba Phule Nagar",
    "block": "Hasanpur",
    "officename": "Hasanpur SO Jyotiba Phule Nagar",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244242": {
    "state": "Uttar Pradesh",
    "district": "Jyotiba Phule Nagar",
    "block": "Hasanpur",
    "officename": "Ujhari SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244245": {
    "state": "Uttar Pradesh",
    "district": "Jyotiba Phule Nagar",
    "block": "Amroha",
    "officename": "Kundan Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244251": {
    "state": "Uttar Pradesh",
    "district": "Jyotiba Phule Nagar",
    "block": "Amroha",
    "officename": "Nawgawan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244255": {
    "state": "Uttar Pradesh",
    "district": "Jyotiba Phule Nagar",
    "block": "Hasanpur",
    "officename": "Rehra SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244301": {
    "state": "Uttar Pradesh",
    "district": "Moradabad",
    "block": "Sambhal",
    "officename": "Sirsi SO Moradabad",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244302": {
    "state": "Uttar Pradesh",
    "district": "Moradabad",
    "block": "Sambhal",
    "officename": "Sambhal SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244303": {
    "state": "Uttar Pradesh",
    "district": "Moradabad",
    "block": "Sambhal",
    "officename": "Sarai Tarin SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244304": {
    "state": "Uttar Pradesh",
    "district": "Jyotiba Phule Nagar",
    "block": "Sambhl",
    "officename": "Asmoli SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244401": {
    "state": "Uttar Pradesh",
    "district": "Moradabad",
    "block": "Thakurdwara",
    "officename": "Dilari SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244402": {
    "state": "Uttar Pradesh",
    "district": "Moradabad",
    "block": "Moradabad",
    "officename": "Pipalsana RS SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244410": {
    "state": "Uttar Pradesh",
    "district": "Moradabad",
    "block": "Chandausi",
    "officename": "Bahjoi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244411": {
    "state": "Uttar Pradesh",
    "district": "Moradabad",
    "block": "Bilari",
    "officename": "Bilari SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244412": {
    "state": "Uttar Pradesh",
    "district": "Moradabad",
    "block": "Chandausi",
    "officename": "Chandausi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244413": {
    "state": "Uttar Pradesh",
    "district": "Moradabad",
    "block": "Bilari",
    "officename": "Kundarki SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244414": {
    "state": "Uttar Pradesh",
    "district": "Moradabad",
    "block": "Chandausi",
    "officename": "Narauli SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244415": {
    "state": "Uttar Pradesh",
    "district": "Moradabad",
    "block": "Bilari",
    "officename": "Raja Ka Sahaspur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244501": {
    "state": "Uttar Pradesh",
    "district": "Jyotiba Phule Nagar",
    "block": "Kanth",
    "officename": "Kanth SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244504": {
    "state": "Uttar Pradesh",
    "district": "Moradabad",
    "block": "Moradabad",
    "officename": "Aghwanpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244601": {
    "state": "Uttar Pradesh",
    "district": "Moradabad",
    "block": "Thakuedwara",
    "officename": "Thakurdwara SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244602": {
    "state": "Uttar Pradesh",
    "district": "Moradabad",
    "block": "Thakurdwara",
    "officename": "Surjan Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244701": {
    "state": "Uttar Pradesh",
    "district": "Rampur",
    "block": "Milak",
    "officename": "Milak SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244712": {
    "state": "Uttarakhand",
    "district": "Udham Singh Nagar",
    "block": "Jaspur",
    "officename": "Jaspur SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "244713": {
    "state": "Uttarakhand",
    "district": "Udham Singh Nagar",
    "block": "Kashipur",
    "officename": "Kashipur Udham Singh Nagar SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "244715": {
    "state": "Uttarakhand",
    "district": "Almora",
    "block": "Bhikia Sain",
    "officename": "Ramnagar SO Nainital",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "244716": {
    "state": "Uttarakhand",
    "district": "Udham Singh Nagar",
    "block": "Kashipur",
    "officename": "RTC Hempur SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "244717": {
    "state": "Uttarakhand",
    "district": "Udham Singh Nagar",
    "block": "Kashipur",
    "officename": "SM Nadehi SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "244901": {
    "state": "Uttar Pradesh",
    "district": "Rampur",
    "block": "Rampur",
    "officename": "Rampur HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244921": {
    "state": "Uttar Pradesh",
    "district": "Rampur",
    "block": "Bilasour",
    "officename": "Bilaspur Rampur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244922": {
    "state": "Uttar Pradesh",
    "district": "Rampur",
    "block": "Shahabad",
    "officename": "Shahbad SO Rampur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244923": {
    "state": "Uttar Pradesh",
    "district": "Rampur",
    "block": "Rampur",
    "officename": "Bilaspur Chini Mill SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244924": {
    "state": "Uttar Pradesh",
    "district": "Rampur",
    "block": "Suar",
    "officename": "Suar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244925": {
    "state": "Uttar Pradesh",
    "district": "Rampur",
    "block": "Suar",
    "officename": "Tanda Badli SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244926": {
    "state": "Uttar Pradesh",
    "district": "Rampur",
    "block": "Rampur",
    "officename": "Modipur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244927": {
    "state": "Uttar Pradesh",
    "district": "Rampur",
    "block": "Rampur",
    "officename": "Said Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244928": {
    "state": "Uttar Pradesh",
    "district": "Rampur",
    "block": "Bilaspur",
    "officename": "Kemri SO Rampur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "245101": {
    "state": "Uttar Pradesh",
    "district": "Ghaziabad",
    "block": "Hapur",
    "officename": "New Hapur HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Ghaziabad Division"
  },
  "245201": {
    "state": "Uttar Pradesh",
    "district": "Ghaziabad",
    "block": "Hapur",
    "officename": "Babugarh SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Ghaziabad Division"
  },
  "245205": {
    "state": "Uttar Pradesh",
    "district": "Ghaziabad",
    "block": "Hapur",
    "officename": "Garhmukteshwar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Ghaziabad Division"
  },
  "245206": {
    "state": "Uttar Pradesh",
    "district": "Meerut",
    "block": "Meerut",
    "officename": "Kharkhauda SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Meerut Division"
  },
  "245207": {
    "state": "Uttar Pradesh",
    "district": "Ghaziabad",
    "block": "Modinagar",
    "officename": "Simbhaoli SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Ghaziabad Division"
  },
  "245208": {
    "state": "Uttar Pradesh",
    "district": "Ghaziabad",
    "block": "Hapur",
    "officename": "Bahadurgarh SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Ghaziabad Division"
  },
  "245301": {
    "state": "Uttar Pradesh",
    "district": "Ghaziabad",
    "block": "Dhaulana",
    "officename": "Dhaulana SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Ghaziabad Division"
  },
  "245304": {
    "state": "Uttar Pradesh",
    "district": "Ghaziabad",
    "block": "Hapur",
    "officename": "Pilkhuwa  SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Ghaziabad Division"
  },
  "246001": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Pauri",
    "officename": "Pauri HO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246113": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Pauri",
    "officename": "Kalzikhal SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246121": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Kotdwara",
    "officename": "Bhrigukhal A SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246123": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Pauri",
    "officename": "Chipalghat A SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246124": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Kotdwara",
    "officename": "Dadamandi SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246125": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Srinagar",
    "officename": "Dehalchauri SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246127": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Kotdwara",
    "officename": "Dugadda SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246128": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Lansdowne",
    "officename": "Dwarikhal SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246129": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Lansdowne",
    "officename": "Dudharkhal SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246130": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Thali Sain",
    "officename": "Chakisain B SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246131": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Lansdowne",
    "officename": "Ekeshwar A SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246141": {
    "state": "Uttarakhand",
    "district": "Rudraprayag",
    "block": "Jakholi",
    "officename": "Jakholi SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246142": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Kotdwara",
    "officename": "Kalagarh SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246144": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Kotdwara",
    "officename": "Kandakhal SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246146": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Pauri",
    "officename": "Kanskhet SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246147": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Srinagar",
    "officename": "Khirshu SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246148": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Pauri",
    "officename": "Kot SO Pauri Garhwal",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246149": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Kotdwara",
    "officename": "Kotdwara HO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246155": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Lansdowne",
    "officename": "Lansdowne HO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246159": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Pauri",
    "officename": "Lwali SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246161": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Dhumakot",
    "officename": "Nainidanda B SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246162": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Lansdowne",
    "officename": "Naugaonkhal SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246163": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Pauri",
    "officename": "Mawadhar SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246164": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Pauri",
    "officename": "Pabau B SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246165": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Pauri",
    "officename": "Paidul SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246166": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Pauri",
    "officename": "Parsundakhal SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246167": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Pauri",
    "officename": "Patisain SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246169": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Lansdowne",
    "officename": "Pokhra A SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246171": {
    "state": "Uttarakhand",
    "district": "Rudraprayag",
    "block": "Rudraprayag",
    "officename": "Rudraprayag SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246172": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Lansdowne",
    "officename": "Satpuli SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246173": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Lansdowne",
    "officename": "Silogi SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246174": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Srinagar",
    "officename": "Srinagar SO Pauri Garhwal",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246175": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Pauri",
    "officename": "Naithana SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246176": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Pauri",
    "officename": "Toli SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246177": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Dhumakot",
    "officename": "Vedikhal SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246179": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Lansdowne",
    "officename": "Rikhnikhal A SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246193": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Lansdowne",
    "officename": "Jahrikhal B SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246194": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Pauri",
    "officename": "GB Pant Engg College SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246275": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Thali Sain",
    "officename": "Baijrao A SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246276": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Pauri",
    "officename": "Bironkhal A SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246277": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Dhumakot",
    "officename": "Dhumakot SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246278": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Thalisain",
    "officename": "Syunsinagar SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246279": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Dhoomakot",
    "officename": "Dungri SO Pauri Garhwal",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246285": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Thalisain",
    "officename": "Thalisain SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246401": {
    "state": "Uttarakhand",
    "district": "Chamoli",
    "block": "Chamoli",
    "officename": "Gopeshwar HO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246419": {
    "state": "Uttarakhand",
    "district": "Rudraprayag",
    "block": "Jakholi",
    "officename": "Bhiri SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246421": {
    "state": "Uttarakhand",
    "district": "Rudraprayag",
    "block": "Rudraprayag",
    "officename": "Augustmuni SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246422": {
    "state": "Uttarakhand",
    "district": "Chamoli",
    "block": "Joshimath",
    "officename": "Badrinath Seasonal SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246424": {
    "state": "Uttarakhand",
    "district": "Chamoli",
    "block": "Chamoli",
    "officename": "Chamoli SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246425": {
    "state": "Uttarakhand",
    "district": "Rudraprayag",
    "block": "Jakholi",
    "officename": "Chandrapuri SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246426": {
    "state": "Uttarakhand",
    "district": "Chamoli",
    "block": "Chamoli",
    "officename": "Chhinka SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246427": {
    "state": "Uttarakhand",
    "district": "Chamoli",
    "block": "Tharali",
    "officename": "Debal SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246428": {
    "state": "Uttarakhand",
    "district": "Chamoli",
    "block": "Gairsain",
    "officename": "Gairsain SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246429": {
    "state": "Uttarakhand",
    "district": "Chamoli",
    "block": "Karanprayag",
    "officename": "Gauchar SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246431": {
    "state": "Uttarakhand",
    "district": "Chamoli",
    "block": "Gairsain",
    "officename": "Mehalchauri SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246435": {
    "state": "Uttarakhand",
    "district": "Chamoli",
    "block": "Ghat",
    "officename": "Ghat SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246439": {
    "state": "Uttarakhand",
    "district": "Rudraprayag",
    "block": "Okhimath",
    "officename": "Guptkashi SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246440": {
    "state": "Uttarakhand",
    "district": "Chamoli",
    "block": "Gairsain",
    "officename": "Adibadri SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246441": {
    "state": "Uttarakhand",
    "district": "Chamoli",
    "block": "Tharali",
    "officename": "Gwaldam SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246442": {
    "state": "Uttarakhand",
    "district": "Rudraprayag",
    "block": "Rudraprayag",
    "officename": "Jakhani SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246443": {
    "state": "Uttarakhand",
    "district": "Chamoli",
    "block": "Joshimath",
    "officename": "Joshimath SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246444": {
    "state": "Uttarakhand",
    "district": "Chamoli",
    "block": "Karanprayag",
    "officename": "Karanprayag SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246445": {
    "state": "Uttarakhand",
    "district": "Rudraprayag",
    "block": "Okhimath",
    "officename": "Kedarnath Seasional SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246446": {
    "state": "Uttarakhand",
    "district": "Chamoli",
    "block": "Pokhari",
    "officename": "Langasu SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246448": {
    "state": "Uttarakhand",
    "district": "Rudraprayag",
    "block": "Rudraprayg",
    "officename": "Maikoti SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246449": {
    "state": "Uttarakhand",
    "district": "Chamoli",
    "block": "Chamoli",
    "officename": "Nandprayag SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246453": {
    "state": "Uttarakhand",
    "district": "Chamoli",
    "block": "Tharali",
    "officename": "Nalgaun SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246455": {
    "state": "Uttarakhand",
    "district": "Chamoli",
    "block": "Tharali",
    "officename": "Narayan Bagar SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246469": {
    "state": "Uttarakhand",
    "district": "Rudraprayag",
    "block": "Okhimath",
    "officename": "Okhimath SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246471": {
    "state": "Uttarakhand",
    "district": "Rudraprayag",
    "block": "Okhimath",
    "officename": "Phata SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246472": {
    "state": "Uttarakhand",
    "district": "Chamoli",
    "block": "Chamoli",
    "officename": "Pipalkoti SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246473": {
    "state": "Uttarakhand",
    "district": "Chamoli",
    "block": "Pokhari",
    "officename": "Pokhari Nagnath SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246474": {
    "state": "Uttarakhand",
    "district": "Chamoli",
    "block": "Karanprayag",
    "officename": "Simli SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246475": {
    "state": "Uttarakhand",
    "district": "Rudraprayag",
    "block": "Jakholi",
    "officename": "Tilwara SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246481": {
    "state": "Uttarakhand",
    "district": "Chamoli",
    "block": "Tharali",
    "officename": "Tharali SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246482": {
    "state": "Uttarakhand",
    "district": "Chamoli",
    "block": "Tharali",
    "officename": "Talwari SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246483": {
    "state": "Uttarakhand",
    "district": "Chamoli",
    "block": "Joshimath",
    "officename": "Tapoban SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246486": {
    "state": "Uttarakhand",
    "district": "Chamoli",
    "block": "Gairsain",
    "officename": "Bachhuwaban SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246487": {
    "state": "Uttarakhand",
    "district": "Chamoli",
    "block": "Karanprayag",
    "officename": "Nauti SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246488": {
    "state": "Uttarakhand",
    "district": "Chamoli",
    "block": "Karanprayag",
    "officename": "Nainisain SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246495": {
    "state": "Uttarakhand",
    "district": "Rudraprayag",
    "block": "Rudraprayag",
    "officename": "Chopra SO Rudraprayag",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamoli Division"
  },
  "246701": {
    "state": "Uttar Pradesh",
    "district": "Bijnor",
    "block": "Bijnor",
    "officename": "Bijnor HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bijnor Division"
  },
  "246721": {
    "state": "Uttar Pradesh",
    "district": "Bijnor",
    "block": "Najibabad",
    "officename": "Mandawar SO Bijnor",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bijnor Division"
  },
  "246722": {
    "state": "Uttar Pradesh",
    "district": "Bijnor",
    "block": "Nagina",
    "officename": "Afzalgarh SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bijnor Division"
  },
  "246723": {
    "state": "Uttar Pradesh",
    "district": "Bijnor",
    "block": "Bijnor",
    "officename": "Balawali SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bijnor Division"
  },
  "246724": {
    "state": "Uttar Pradesh",
    "district": "Bijnor",
    "block": "Nagina",
    "officename": "Badhapur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bijnor Division"
  },
  "246725": {
    "state": "Uttar Pradesh",
    "district": "Bijnor",
    "block": "Chandpur",
    "officename": "Chandpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bijnor Division"
  },
  "246726": {
    "state": "Uttar Pradesh",
    "district": "Bijnor",
    "block": "Chandpur",
    "officename": "Haldaur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bijnor Division"
  },
  "246727": {
    "state": "Uttar Pradesh",
    "district": "Bijnor",
    "block": "Dhampur",
    "officename": "Hassupura SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bijnor Division"
  },
  "246728": {
    "state": "Uttar Pradesh",
    "district": "Bijnor",
    "block": "Chandpur",
    "officename": "Jhalu SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bijnor Division"
  },
  "246729": {
    "state": "Uttar Pradesh",
    "district": "Bijnor",
    "block": "Chandpur",
    "officename": "Chandpur Sugar Factory SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bijnor Division"
  },
  "246731": {
    "state": "Uttar Pradesh",
    "district": "Bijnor",
    "block": "Najibabad",
    "officename": "Kiratpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bijnor Division"
  },
  "246732": {
    "state": "Uttar Pradesh",
    "district": "Bijnor",
    "block": "Najibabad",
    "officename": "Nagal SO Bijnor",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bijnor Division"
  },
  "246733": {
    "state": "Uttar Pradesh",
    "district": "Bijnor",
    "block": "Dhampur",
    "officename": "Nehtaur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bijnor Division"
  },
  "246734": {
    "state": "Uttar Pradesh",
    "district": "Bijnor",
    "block": "Bijnor",
    "officename": "Noorpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bijnor Division"
  },
  "246735": {
    "state": "Uttar Pradesh",
    "district": "Bijnor",
    "block": "Dhampur",
    "officename": "Rajakatajpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bijnor Division"
  },
  "246736": {
    "state": "Uttar Pradesh",
    "district": "Bijnor",
    "block": "Chandpur",
    "officename": "Bashta SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bijnor Division"
  },
  "246737": {
    "state": "Uttar Pradesh",
    "district": "Bijnor",
    "block": "Dhampur",
    "officename": "Rahu Nagli SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bijnor Division"
  },
  "246745": {
    "state": "Uttar Pradesh",
    "district": "Bijnor",
    "block": "Dhampur",
    "officename": "Sahaspur SO Bijnor",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bijnor Division"
  },
  "246746": {
    "state": "Uttar Pradesh",
    "district": "Bijnor",
    "block": "Dhampur",
    "officename": "Seohara SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bijnor Division"
  },
  "246747": {
    "state": "Uttar Pradesh",
    "district": "Bijnor",
    "block": "Nagina",
    "officename": "Sherkot SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bijnor Division"
  },
  "246749": {
    "state": "Uttar Pradesh",
    "district": "Bijnor",
    "block": "Najibabad",
    "officename": "Sahanpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bijnor Division"
  },
  "246761": {
    "state": "Uttar Pradesh",
    "district": "Bijnor",
    "block": "Dhampur",
    "officename": "Dhampur HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bijnor Division"
  },
  "246762": {
    "state": "Uttar Pradesh",
    "district": "Bijnor",
    "block": "Nagina",
    "officename": "Nagina SO Bijnor",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bijnor Division"
  },
  "246763": {
    "state": "Uttar Pradesh",
    "district": "Bijnor",
    "block": "Najibabad",
    "officename": "Najibabad SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bijnor Division"
  },
  "246764": {
    "state": "Uttar Pradesh",
    "district": "Bijnor",
    "block": "Najibabad",
    "officename": "Kotwali SO Bijnor",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bijnor Division"
  },
  "247001": {
    "state": "Uttar Pradesh",
    "district": "Saharanpur",
    "block": "Saharanpur H.o.",
    "officename": "Saharanpur HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Saharanpur Division"
  },
  "247002": {
    "state": "Uttar Pradesh",
    "district": "Saharanpur",
    "block": "Saharanpur",
    "officename": "PTC SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Saharanpur Division"
  },
  "247120": {
    "state": "Uttar Pradesh",
    "district": "Saharanpur",
    "block": "Muzaffarabad",
    "officename": "Babail Buzurg SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Saharanpur Division"
  },
  "247121": {
    "state": "Uttar Pradesh",
    "district": "Saharanpur",
    "block": "Behat",
    "officename": "Behat SO Saharanpur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Saharanpur Division"
  },
  "247122": {
    "state": "Uttar Pradesh",
    "district": "Saharanpur",
    "block": "S.qudeem",
    "officename": "Badshahi Bagh SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Saharanpur Division"
  },
  "247129": {
    "state": "Uttar Pradesh",
    "district": "Saharanpur",
    "block": "M.bad",
    "officename": "Muzaffrabad SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Saharanpur Division"
  },
  "247231": {
    "state": "Uttar Pradesh",
    "district": "Saharanpur",
    "block": "Sarsawa",
    "officename": "Chilkana SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Saharanpur Division"
  },
  "247232": {
    "state": "Uttar Pradesh",
    "district": "Saharanpur",
    "block": "Sarsawa",
    "officename": "Sarsawa SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Saharanpur Division"
  },
  "247340": {
    "state": "Uttar Pradesh",
    "district": "Saharanpur",
    "block": "Nakur",
    "officename": "Ambehta SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Saharanpur Division"
  },
  "247341": {
    "state": "Uttar Pradesh",
    "district": "Saharanpur",
    "block": "Gangoh",
    "officename": "Gangoh SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Saharanpur Division"
  },
  "247342": {
    "state": "Uttar Pradesh",
    "district": "Saharanpur",
    "block": "Nakur",
    "officename": "Nakur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Saharanpur Division"
  },
  "247343": {
    "state": "Uttar Pradesh",
    "district": "Saharanpur",
    "block": "Nakur",
    "officename": "Titron SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Saharanpur Division"
  },
  "247451": {
    "state": "Uttar Pradesh",
    "district": "Saharanpur",
    "block": "Rampur",
    "officename": "Rampur SO Saharanpur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Saharanpur Division"
  },
  "247452": {
    "state": "Uttar Pradesh",
    "district": "Saharanpur",
    "block": "Nanauta",
    "officename": "Nanauta SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Saharanpur Division"
  },
  "247453": {
    "state": "Uttar Pradesh",
    "district": "Saharanpur",
    "block": "Nanauta",
    "officename": "Jaroda Panda SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Saharanpur Division"
  },
  "247551": {
    "state": "Uttar Pradesh",
    "district": "Saharanpur",
    "block": "Nagal",
    "officename": "Nagal SO Saharanpur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Saharanpur Division"
  },
  "247554": {
    "state": "Uttar Pradesh",
    "district": "Saharanpur",
    "block": "Deoband",
    "officename": "Deoband SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Saharanpur Division"
  },
  "247656": {
    "state": "Uttarakhand",
    "district": "Haridwar",
    "block": "Roorkee",
    "officename": "Manglour Town SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "247661": {
    "state": "Uttarakhand",
    "district": "Haridwar",
    "block": "Roorkee",
    "officename": "Bhagwanpur SO Haridwar",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "247662": {
    "state": "Uttar Pradesh",
    "district": "Saharanpur",
    "block": "M.bad",
    "officename": "Chhutmalpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Saharanpur Division"
  },
  "247663": {
    "state": "Uttarakhand",
    "district": "Haridwar",
    "block": "Roorkee",
    "officename": "Laksar SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "247664": {
    "state": "Uttarakhand",
    "district": "Haridwar",
    "block": "Roorkee",
    "officename": "Landhaura SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "247665": {
    "state": "Uttarakhand",
    "district": "Haridwar",
    "block": "Roorkee",
    "officename": "Jhabrera SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "247666": {
    "state": "Uttarakhand",
    "district": "Haridwar",
    "block": "Roorkee",
    "officename": "Milap Nagar SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "247667": {
    "state": "Uttarakhand",
    "district": "Haridwar",
    "block": "Roorkee",
    "officename": "Roorkee HO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "247668": {
    "state": "Uttarakhand",
    "district": "Haridwar",
    "block": "Roorkee",
    "officename": "Iqbalpur SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "247669": {
    "state": "Uttar Pradesh",
    "district": "Saharanpur",
    "block": "Saharanpur",
    "officename": "Gagalheri SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Saharanpur Division"
  },
  "247670": {
    "state": "Uttarakhand",
    "district": "Haridwar",
    "block": "Roorkee",
    "officename": "Gurkul Narsan SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "247671": {
    "state": "Uttarakhand",
    "district": "Haridwar",
    "block": "Laksar",
    "officename": "Raisi SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "247771": {
    "state": "Uttar Pradesh",
    "district": "Muzaffarnagar",
    "block": "Muzaffarnagar",
    "officename": "Ailum SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Baghpat Division"
  },
  "247772": {
    "state": "Uttar Pradesh",
    "district": "Muzaffarnagar",
    "block": "Shamli",
    "officename": "Jalalabad SO Muzaffarnagar",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Baghpat Division"
  },
  "247773": {
    "state": "Uttar Pradesh",
    "district": "Muzaffarnagar",
    "block": "Kairana",
    "officename": "Jhinjhana SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Baghpat Division"
  },
  "247774": {
    "state": "Uttar Pradesh",
    "district": "Muzaffarnagar",
    "block": "Kairana",
    "officename": "Kairana SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Baghpat Division"
  },
  "247775": {
    "state": "Uttar Pradesh",
    "district": "Muzaffarnagar",
    "block": "Shamli **",
    "officename": "Kandhala SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Baghpat Division"
  },
  "247776": {
    "state": "Uttar Pradesh",
    "district": "Muzaffarnagar",
    "block": "Shamli",
    "officename": "Shamli SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Baghpat Division"
  },
  "247777": {
    "state": "Uttar Pradesh",
    "district": "Muzaffarnagar",
    "block": "Kairana",
    "officename": "Thanabhawan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Baghpat Division"
  },
  "247778": {
    "state": "Uttar Pradesh",
    "district": "Muzaffarnagar",
    "block": "Kairana",
    "officename": "Un SO Muzaffarnagar",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Baghpat Division"
  },
  "248001": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Dehradun",
    "officename": "Dehradun GPO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "248002": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Dehradun",
    "officename": "Clementtown SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "248003": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Vikasnagar **",
    "officename": "Dehradun Cantt HO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "248005": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Dehradun",
    "officename": "IIP SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "248006": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Dehradun",
    "officename": "Newforest SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "248007": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Deharadun",
    "officename": "Prem Nagar SO Dehradun",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "248008": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Dehradun",
    "officename": "RaipurOF SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "248009": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Dehradun",
    "officename": "Rajpur SO Dehradun",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "248011": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Dehradun",
    "officename": "Selaqui SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "248012": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Dehradun",
    "officename": "Defence Colony SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "248013": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Dehradun",
    "officename": "Sahastradhara Road SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "248014": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Dehradun",
    "officename": "Nehrugram SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "248015": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Dehradun",
    "officename": "Sudhowala SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "248121": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Dehradun",
    "officename": "Ajabpur SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "248122": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Dehradun",
    "officename": "Barlowganj SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "248123": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Chakrata",
    "officename": "Chakrata SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "248124": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Dehradun",
    "officename": "Barontha SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "248125": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Vikasnagar",
    "officename": "Dakpathar SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "248140": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Dehradun",
    "officename": "Doiwala SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "248142": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Vikasnagar",
    "officename": "Herbertpur SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "248143": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Rishikesh",
    "officename": "Bhogpur SO Dehradun",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "248145": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Rishikesh",
    "officename": "Rani Pokhari SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "248146": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Dehradun",
    "officename": "Seemadwar SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "248158": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Chakrata",
    "officename": "Kalsi SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "248159": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Chakrata",
    "officename": "Kalsi Gate SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "248165": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Chakrata",
    "officename": "Koti SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "248171": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Dehradun",
    "officename": "Majra SO Dehradun",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "248179": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Dehradun",
    "officename": "Mussoorie SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "248195": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Dehradun",
    "officename": "IPE SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "248196": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Chakrata",
    "officename": "Sahiya SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "248197": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Chakrata",
    "officename": "Sahaspur SO Dehradun",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "248198": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Vikasnagar",
    "officename": "Vikasnagar SO Dehradun",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "248199": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Tuini",
    "officename": "Tuini SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "249001": {
    "state": "Uttarakhand",
    "district": "Tehri Garhwal",
    "block": "Tehri",
    "officename": "Tehri HO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tehri Division"
  },
  "249121": {
    "state": "Uttarakhand",
    "district": "Tehri Garhwal",
    "block": "Jakhnidhar",
    "officename": "Anjanisain SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tehri Division"
  },
  "249122": {
    "state": "Uttarakhand",
    "district": "Tehri Garhwal",
    "block": "Deoprayag",
    "officename": "Hindolakhal SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tehri Division"
  },
  "249123": {
    "state": "Uttarakhand",
    "district": "Tehri Garhwal",
    "block": "Jakhnidhar",
    "officename": "Jakhnidhar SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tehri Division"
  },
  "249124": {
    "state": "Uttarakhand",
    "district": "Tehri Garhwal",
    "block": "Tehri",
    "officename": "Bhagirathipuram SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tehri Division"
  },
  "249125": {
    "state": "Uttarakhand",
    "district": "Tehri Garhwal",
    "block": "Ghansali",
    "officename": "Chamiyala SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tehri Division"
  },
  "249126": {
    "state": "Uttarakhand",
    "district": "Tehri Garhwal",
    "block": "Deoprayag",
    "officename": "Bhallegaon SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tehri Division"
  },
  "249128": {
    "state": "Uttarakhand",
    "district": "Uttarkashi",
    "block": "Purola",
    "officename": "Mori SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tehri Division"
  },
  "249130": {
    "state": "Uttarakhand",
    "district": "Tehri Garhwal",
    "block": "Tehri",
    "officename": "VKPuram SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tehri Division"
  },
  "249131": {
    "state": "Uttarakhand",
    "district": "Tehri Garhwal",
    "block": "Tehri",
    "officename": "Kamand SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tehri Division"
  },
  "249132": {
    "state": "Uttarakhand",
    "district": "Tehri Garhwal",
    "block": "Tehri",
    "officename": "Chham SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tehri Division"
  },
  "249135": {
    "state": "Uttarakhand",
    "district": "Uttarkashi",
    "block": "Uttarkashi",
    "officename": "Bhatwari SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tehri Division"
  },
  "249137": {
    "state": "Uttarakhand",
    "district": "Tehri Garhwal",
    "block": "Narendernagar",
    "officename": "Munikireti SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tehri Division"
  },
  "249141": {
    "state": "Uttarakhand",
    "district": "Uttarkashi",
    "block": "Rajgarhi",
    "officename": "Burkot SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tehri Division"
  },
  "249145": {
    "state": "Uttarakhand",
    "district": "Tehri Garhwal",
    "block": "Tehri",
    "officename": "Chamma SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tehri Division"
  },
  "249146": {
    "state": "Uttarakhand",
    "district": "Tehri Garhwal",
    "block": "Gajja",
    "officename": "Gajja SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tehri Division"
  },
  "249151": {
    "state": "Uttarakhand",
    "district": "Uttarkashi",
    "block": "Dunda",
    "officename": "Dunda SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tehri Division"
  },
  "249152": {
    "state": "Uttarakhand",
    "district": "Uttarkashi",
    "block": "Dunda",
    "officename": "Geonla SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tehri Division"
  },
  "249155": {
    "state": "Uttarakhand",
    "district": "Tehri Garhwal",
    "block": "Ghansali",
    "officename": "Ghansali SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tehri Division"
  },
  "249161": {
    "state": "Uttarakhand",
    "district": "Tehri Garhwal",
    "block": "Kirtinagar",
    "officename": "Kirtinagar SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tehri Division"
  },
  "249165": {
    "state": "Uttarakhand",
    "district": "Tehri Garhwal",
    "block": "Pratapnagar",
    "officename": "Lambgaon SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tehri Division"
  },
  "249171": {
    "state": "Uttarakhand",
    "district": "Uttarkashi",
    "block": "Burkot",
    "officename": "Naugaon SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tehri Division"
  },
  "249175": {
    "state": "Uttarakhand",
    "district": "Tehri Garhwal",
    "block": "Narendra Nagar",
    "officename": "Narendra Nagar SO Tehri Garhwal",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tehri Division"
  },
  "249180": {
    "state": "Uttarakhand",
    "district": "Tehri Garhwal",
    "block": "Dhanolti",
    "officename": "Thatyur SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tehri Division"
  },
  "249181": {
    "state": "Uttarakhand",
    "district": "Tehri Garhwal",
    "block": "Ghansali",
    "officename": "Pilkhi SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tehri Division"
  },
  "249185": {
    "state": "Uttarakhand",
    "district": "Uttarkashi",
    "block": "Purola",
    "officename": "Purola SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tehri Division"
  },
  "249186": {
    "state": "Uttarakhand",
    "district": "Tehri Garhwal",
    "block": "Tehri",
    "officename": "Sigunisera SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tehri Division"
  },
  "249192": {
    "state": "Uttarakhand",
    "district": "Tehri Garhwal",
    "block": "Narendranagar",
    "officename": "Shivanand Nagar SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tehri Division"
  },
  "249193": {
    "state": "Uttarakhand",
    "district": "Uttarkashi",
    "block": "Uttarkashi",
    "officename": "Uttarkashi SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tehri Division"
  },
  "249194": {
    "state": "Uttarakhand",
    "district": "Uttarkashi",
    "block": "Dunda",
    "officename": "MD Colony SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tehri Division"
  },
  "249196": {
    "state": "Uttarakhand",
    "district": "Uttarkashi",
    "block": "Dunda",
    "officename": "Chinyalisour SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tehri Division"
  },
  "249199": {
    "state": "Uttarakhand",
    "district": "Tehri Garhwal",
    "block": "Tehri",
    "officename": "Ranichauri SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tehri Division"
  },
  "249201": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Rishikesh",
    "officename": "Rishikesh SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "249202": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Rishikesh",
    "officename": "Virbhadra SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "249203": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Rishikesh",
    "officename": "Pashulok SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "249204": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Dehradun",
    "officename": "SN Temple SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "249205": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Rishikesh",
    "officename": "Raiwala SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "249301": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Pauri",
    "officename": "Devprayag SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "249302": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Kotdwara",
    "officename": "Laxmanjhula B SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "249304": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Kotdwara",
    "officename": "Swargashram SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "249306": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Kotdwara",
    "officename": "Chila Colony SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "249401": {
    "state": "Uttarakhand",
    "district": "Haridwar",
    "block": "Hardwar",
    "officename": "Haridwar SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "249402": {
    "state": "Uttarakhand",
    "district": "Haridwar",
    "block": "Haridwar",
    "officename": "Bahadrabad SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "249403": {
    "state": "Uttarakhand",
    "district": "Haridwar",
    "block": "Hardwar",
    "officename": "BHEL SO Haridwar",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "249404": {
    "state": "Uttarakhand",
    "district": "Haridwar",
    "block": "Hardwar",
    "officename": "Gurukul Kangri SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "249405": {
    "state": "Uttarakhand",
    "district": "Haridwar",
    "block": "Haridwar",
    "officename": "Patanjali Yogpeeth SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "249407": {
    "state": "Uttarakhand",
    "district": "Haridwar",
    "block": "Hardwar",
    "officename": "Jwalapur SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "249408": {
    "state": "Uttarakhand",
    "district": "Haridwar",
    "block": "Hardwar",
    "officename": "Kankhal SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "249410": {
    "state": "Uttarakhand",
    "district": "Haridwar",
    "block": "Hardwar",
    "officename": "Sadhubela Bhupatwala SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "249411": {
    "state": "Uttarakhand",
    "district": "Haridwar",
    "block": "Hardwar",
    "officename": "Shantikunj SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "250001": {
    "state": "Uttar Pradesh",
    "district": "Meerut",
    "block": "Meerut",
    "officename": "Meerut Cantt HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Meerut Division"
  },
  "250002": {
    "state": "Uttar Pradesh",
    "district": "Meerut",
    "block": "Meerut",
    "officename": "Meerut City HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Meerut Division"
  },
  "250003": {
    "state": "Uttar Pradesh",
    "district": "Meerut",
    "block": "Meerut",
    "officename": "Meerut Kutchery SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Meerut Division"
  },
  "250004": {
    "state": "Uttar Pradesh",
    "district": "Meerut",
    "block": "Meerut",
    "officename": "L L R M Medcollege SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Meerut Division"
  },
  "250005": {
    "state": "Uttar Pradesh",
    "district": "Meerut",
    "block": "Meerut",
    "officename": "MIET SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Meerut Division"
  },
  "250101": {
    "state": "Uttar Pradesh",
    "district": "Bagpat",
    "block": "Baraut",
    "officename": "Khekra SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Baghpat Division"
  },
  "250103": {
    "state": "Uttar Pradesh",
    "district": "Meerut",
    "block": "Meerut",
    "officename": "I E Partapur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Meerut Division"
  },
  "250104": {
    "state": "Uttar Pradesh",
    "district": "Meerut",
    "block": "Meerut",
    "officename": "Kithore SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Meerut Division"
  },
  "250106": {
    "state": "Uttar Pradesh",
    "district": "Meerut",
    "block": "Meerut",
    "officename": "Machhara SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Meerut Division"
  },
  "250110": {
    "state": "Uttar Pradesh",
    "district": "Meerut",
    "block": "Meerut",
    "officename": "Modipuram SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Meerut Division"
  },
  "250205": {
    "state": "Uttar Pradesh",
    "district": "Meerut",
    "block": "Meerut",
    "officename": "Mohiuddinpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Meerut Division"
  },
  "250221": {
    "state": "Uttar Pradesh",
    "district": "Meerut",
    "block": "Sardhana",
    "officename": "Daurala SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Meerut Division"
  },
  "250222": {
    "state": "Uttar Pradesh",
    "district": "Meerut",
    "block": "Meerut",
    "officename": "Lawar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Meerut Division"
  },
  "250223": {
    "state": "Uttar Pradesh",
    "district": "Meerut",
    "block": "Sardhana",
    "officename": "Sakoti Tanda SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Meerut Division"
  },
  "250341": {
    "state": "Uttar Pradesh",
    "district": "Meerut",
    "block": "Meerut",
    "officename": "Dabathwa SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Meerut Division"
  },
  "250342": {
    "state": "Uttar Pradesh",
    "district": "Meerut",
    "block": "Sardhana",
    "officename": "Sardhana SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Meerut Division"
  },
  "250344": {
    "state": "Uttar Pradesh",
    "district": "Meerut",
    "block": "Sardhana",
    "officename": "Sarurpur Khurd SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Baghpat Division"
  },
  "250345": {
    "state": "Uttar Pradesh",
    "district": "Bagpat",
    "block": "Baraut",
    "officename": "Binauli SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Baghpat Division"
  },
  "250401": {
    "state": "Uttar Pradesh",
    "district": "Meerut",
    "block": "Mawana",
    "officename": "Mawana SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Meerut Division"
  },
  "250402": {
    "state": "Uttar Pradesh",
    "district": "Meerut",
    "block": "Mawana",
    "officename": "Mawana Factory SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Meerut Division"
  },
  "250404": {
    "state": "Uttar Pradesh",
    "district": "Meerut",
    "block": "Mawana",
    "officename": "Hastinapur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Meerut Division"
  },
  "250406": {
    "state": "Uttar Pradesh",
    "district": "Meerut",
    "block": "Mawana",
    "officename": "Parikshitgarh SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Meerut Division"
  },
  "250501": {
    "state": "Uttar Pradesh",
    "district": "Meerut",
    "block": "Meerut",
    "officename": "Jani SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Meerut Division"
  },
  "250502": {
    "state": "Uttar Pradesh",
    "district": "Meerut",
    "block": "Meerut",
    "officename": "Rasulpur Rohta SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Baghpat Division"
  },
  "250601": {
    "state": "Uttar Pradesh",
    "district": "Bagpat",
    "block": "Baraut",
    "officename": "Agarwal Mandi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Baghpat Division"
  },
  "250606": {
    "state": "Uttar Pradesh",
    "district": "Bagpat",
    "block": "Baraut",
    "officename": "Aminagar Sarai SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Baghpat Division"
  },
  "250609": {
    "state": "Uttar Pradesh",
    "district": "Bagpat",
    "block": "Baghpat",
    "officename": "Baghpat SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Baghpat Division"
  },
  "250611": {
    "state": "Uttar Pradesh",
    "district": "Bagpat",
    "block": "Baraut",
    "officename": "Baraut HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Baghpat Division"
  },
  "250615": {
    "state": "Uttar Pradesh",
    "district": "Bagpat",
    "block": "Baraut",
    "officename": "Dhikauli SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Baghpat Division"
  },
  "250617": {
    "state": "Uttar Pradesh",
    "district": "Bagpat",
    "block": "Baghpat",
    "officename": "Chhaprauli SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Baghpat Division"
  },
  "250619": {
    "state": "Uttar Pradesh",
    "district": "Bagpat",
    "block": "Baraut",
    "officename": "Sarurpur Kalan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Baghpat Division"
  },
  "250620": {
    "state": "Uttar Pradesh",
    "district": "Bagpat",
    "block": "Baraut",
    "officename": "Bamnauli SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Baghpat Division"
  },
  "250621": {
    "state": "Uttar Pradesh",
    "district": "Bagpat",
    "block": "Baraut",
    "officename": "Baoli SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Baghpat Division"
  },
  "250622": {
    "state": "Uttar Pradesh",
    "district": "Bagpat",
    "block": "Baraut",
    "officename": "Doghat SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Baghpat Division"
  },
  "250623": {
    "state": "Uttar Pradesh",
    "district": "Bagpat",
    "block": "Baraut",
    "officename": "Kishanpur Baral SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Baghpat Division"
  },
  "250625": {
    "state": "Uttar Pradesh",
    "district": "Bagpat",
    "block": "Baraut",
    "officename": "Tikri SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Baghpat Division"
  },
  "250626": {
    "state": "Uttar Pradesh",
    "district": "Bagpat",
    "block": "Meerut",
    "officename": "Baleni SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Baghpat Division"
  },
  "251001": {
    "state": "Uttar Pradesh",
    "district": "Muzaffarnagar",
    "block": "Muzaffarnagar",
    "officename": "Muzaffarnagar HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Muzaffarnagar Division"
  },
  "251002": {
    "state": "Uttar Pradesh",
    "district": "Muzaffarnagar",
    "block": "Muzaffarnagar",
    "officename": "Muzaffar Nagar City SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Muzaffarnagar Division"
  },
  "251003": {
    "state": "Uttar Pradesh",
    "district": "Muzaffarnagar",
    "block": "Muzaffarnagar",
    "officename": "Industrial Estate SO Muzaffarnagar",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Muzaffarnagar Division"
  },
  "251201": {
    "state": "Uttar Pradesh",
    "district": "Muzaffarnagar",
    "block": "Jansath",
    "officename": "Khatauli SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Muzaffarnagar Division"
  },
  "251202": {
    "state": "Uttar Pradesh",
    "district": "Muzaffarnagar",
    "block": "Muzaffarnagar",
    "officename": "Rohana Mills SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Muzaffarnagar Division"
  },
  "251203": {
    "state": "Uttar Pradesh",
    "district": "Muzaffarnagar",
    "block": "Muzaffarnagar",
    "officename": "Mansurpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Muzaffarnagar Division"
  },
  "251301": {
    "state": "Uttar Pradesh",
    "district": "Muzaffarnagar",
    "block": "Muzaffarnagar",
    "officename": "Alipur Kheri SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Muzaffarnagar Division"
  },
  "251305": {
    "state": "Uttar Pradesh",
    "district": "Muzaffarnagar",
    "block": "Kairana",
    "officename": "Babri SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Baghpat Division"
  },
  "251306": {
    "state": "Uttar Pradesh",
    "district": "Muzaffarnagar",
    "block": "Muzaffarnagar",
    "officename": "Baghra SO Muzaffarnagar",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Muzaffarnagar Division"
  },
  "251307": {
    "state": "Uttar Pradesh",
    "district": "Muzaffarnagar",
    "block": "Muzaffarnagar",
    "officename": "Barla SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Muzaffarnagar Division"
  },
  "251308": {
    "state": "Uttar Pradesh",
    "district": "Muzaffarnagar",
    "block": "Muzaffarnagar",
    "officename": "Bhopa SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Muzaffarnagar Division"
  },
  "251309": {
    "state": "Uttar Pradesh",
    "district": "Muzaffarnagar",
    "block": "Budhna",
    "officename": "Budhana SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Muzaffarnagar Division"
  },
  "251310": {
    "state": "Uttar Pradesh",
    "district": "Muzaffarnagar",
    "block": "Muzaffarnagar",
    "officename": "Basera SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Muzaffarnagar Division"
  },
  "251311": {
    "state": "Uttar Pradesh",
    "district": "Muzaffarnagar",
    "block": "Muzaffarnagar",
    "officename": "Charthawal SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Muzaffarnagar Division"
  },
  "251314": {
    "state": "Uttar Pradesh",
    "district": "Muzaffarnagar",
    "block": "Jansath",
    "officename": "Jansath SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Muzaffarnagar Division"
  },
  "251315": {
    "state": "Uttar Pradesh",
    "district": "Muzaffarnagar",
    "block": "Jansath",
    "officename": "Miranpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Muzaffarnagar Division"
  },
  "251316": {
    "state": "Uttar Pradesh",
    "district": "Muzaffarnagar",
    "block": "Muzaffarnagar",
    "officename": "Morna SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Muzaffarnagar Division"
  },
  "251318": {
    "state": "Uttar Pradesh",
    "district": "Muzaffarnagar",
    "block": "Budhana",
    "officename": "Shahpur Muzaffarnagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Muzaffarnagar Division"
  },
  "251319": {
    "state": "Uttar Pradesh",
    "district": "Muzaffarnagar",
    "block": "Kairana",
    "officename": "Sisauli SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Muzaffarnagar Division"
  },
  "251320": {
    "state": "Uttar Pradesh",
    "district": "Muzaffarnagar",
    "block": "Jansath",
    "officename": "Ramraj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Muzaffarnagar Division"
  },
  "251327": {
    "state": "Uttar Pradesh",
    "district": "Muzaffarnagar",
    "block": "Muzaffarnagar",
    "officename": "Purkazi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Muzaffarnagar Division"
  },
  "261001": {
    "state": "Uttar Pradesh",
    "district": "Sitapur",
    "block": "Sitapur",
    "officename": "Sitapur HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Sitapur Division"
  },
  "261121": {
    "state": "Uttar Pradesh",
    "district": "Sitapur",
    "block": "Sitapur",
    "officename": "HS Mills SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Sitapur Division"
  },
  "261125": {
    "state": "Uttar Pradesh",
    "district": "Sitapur",
    "block": "Sitapur",
    "officename": "Husainganj SO Sitapur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Sitapur Division"
  },
  "261131": {
    "state": "Uttar Pradesh",
    "district": "Sitapur",
    "block": "Sitapur",
    "officename": "Khairabad SO Sitapur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Sitapur Division"
  },
  "261135": {
    "state": "Uttar Pradesh",
    "district": "Sitapur",
    "block": "Laharpur",
    "officename": "Laharpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Sitapur Division"
  },
  "261136": {
    "state": "Uttar Pradesh",
    "district": "Sitapur",
    "block": "Laharpur",
    "officename": "Singhnapur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Sitapur Division"
  },
  "261141": {
    "state": "Uttar Pradesh",
    "district": "Sitapur",
    "block": "Mishrikh",
    "officename": "Maholi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Sitapur Division"
  },
  "261145": {
    "state": "Uttar Pradesh",
    "district": "Sitapur",
    "block": "Biswan",
    "officename": "Manpur SO Sitapur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Sitapur Division"
  },
  "261151": {
    "state": "Uttar Pradesh",
    "district": "Sitapur",
    "block": "Mishrikh",
    "officename": "Pisawan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Sitapur Division"
  },
  "261201": {
    "state": "Uttar Pradesh",
    "district": "Sitapur",
    "block": "Biswan",
    "officename": "Biswan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Sitapur Division"
  },
  "261202": {
    "state": "Uttar Pradesh",
    "district": "Sitapur",
    "block": "Biswan",
    "officename": "Jahangirabad SO Sitapur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Sitapur Division"
  },
  "261203": {
    "state": "Uttar Pradesh",
    "district": "Sitapur",
    "block": "Mahmudabad",
    "officename": "Mahmudabad SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Sitapur Division"
  },
  "261204": {
    "state": "Uttar Pradesh",
    "district": "Sitapur",
    "block": "Mahmoodabad",
    "officename": "Rampur Mathura SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Sitapur Division"
  },
  "261205": {
    "state": "Uttar Pradesh",
    "district": "Sitapur",
    "block": "Biswan",
    "officename": "Reosa SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Sitapur Division"
  },
  "261206": {
    "state": "Uttar Pradesh",
    "district": "Sitapur",
    "block": "Biswan",
    "officename": "Saraiyan Raja Saheb SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Sitapur Division"
  },
  "261207": {
    "state": "Uttar Pradesh",
    "district": "Sitapur",
    "block": "Laharpur",
    "officename": "Talgaon SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Sitapur Division"
  },
  "261208": {
    "state": "Uttar Pradesh",
    "district": "Sitapur",
    "block": "Biswan",
    "officename": "Tambour SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Sitapur Division"
  },
  "261301": {
    "state": "Uttar Pradesh",
    "district": "Sitapur",
    "block": "Sidhauli",
    "officename": "Bhandia SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Sitapur Division"
  },
  "261302": {
    "state": "Uttar Pradesh",
    "district": "Sitapur",
    "block": "Sidhauli",
    "officename": "Kamlapur SO Sitapur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Sitapur Division"
  },
  "261303": {
    "state": "Uttar Pradesh",
    "district": "Sitapur",
    "block": "Sidhauli",
    "officename": "Sidhauli SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Sitapur Division"
  },
  "261401": {
    "state": "Uttar Pradesh",
    "district": "Sitapur",
    "block": "Mishrikh",
    "officename": "Mishrikh SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Sitapur Division"
  },
  "261402": {
    "state": "Uttar Pradesh",
    "district": "Sitapur",
    "block": "Mishrikh",
    "officename": "Naimisharanya SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Sitapur Division"
  },
  "261403": {
    "state": "Uttar Pradesh",
    "district": "Sitapur",
    "block": "Mishrikh",
    "officename": "Aurangabad SO Sitapur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Sitapur Division"
  },
  "261404": {
    "state": "Uttar Pradesh",
    "district": "Sitapur",
    "block": "Sitapur",
    "officename": "Parsada SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Sitapur Division"
  },
  "261405": {
    "state": "Uttar Pradesh",
    "district": "Sitapur",
    "block": "Mishrikh",
    "officename": "Machharehta SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Sitapur Division"
  },
  "261501": {
    "state": "Uttar Pradesh",
    "district": "Kheri",
    "block": "Lakhimpur",
    "officename": "Behjam SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Kheri Division"
  },
  "261502": {
    "state": "Uttar Pradesh",
    "district": "Kheri",
    "block": "Dhaurahara",
    "officename": "Isanagar SO Kheri",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Kheri Division"
  },
  "261505": {
    "state": "Uttar Pradesh",
    "district": "Kheri",
    "block": "Mohammdi",
    "officename": "Maigal Ganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Kheri Division"
  },
  "261506": {
    "state": "Uttar Pradesh",
    "district": "Kheri",
    "block": "Lakhimpur",
    "officename": "Mahewa Ganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Kheri Division"
  },
  "262001": {
    "state": "Uttar Pradesh",
    "district": "Pilibhit",
    "block": "Pilibhit",
    "officename": "Pilibhit HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bareilly Division"
  },
  "262121": {
    "state": "Uttar Pradesh",
    "district": "Pilibhit",
    "block": "Amaria",
    "officename": "Amaria SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bareilly Division"
  },
  "262122": {
    "state": "Uttar Pradesh",
    "district": "Pilibhit",
    "block": "Pooranpur",
    "officename": "Pooranpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bareilly Division"
  },
  "262124": {
    "state": "Uttar Pradesh",
    "district": "Pilibhit",
    "block": "Puranpur",
    "officename": "Kali Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bareilly Division"
  },
  "262201": {
    "state": "Uttar Pradesh",
    "district": "Pilibhit",
    "block": "Bisalpur",
    "officename": "Bisalpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bareilly Division"
  },
  "262202": {
    "state": "Uttar Pradesh",
    "district": "Pilibhit",
    "block": "Barkhera",
    "officename": "Bilsanda SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bareilly Division"
  },
  "262203": {
    "state": "Uttar Pradesh",
    "district": "Pilibhit",
    "block": "Barkhera",
    "officename": "Barkhera SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bareilly Division"
  },
  "262302": {
    "state": "Uttar Pradesh",
    "district": "Pilibhit",
    "block": "Pilibhit",
    "officename": "Majhola SO Bareilly",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bareilly Division"
  },
  "262305": {
    "state": "Uttar Pradesh",
    "district": "Pilibhit",
    "block": "Pilibhit",
    "officename": "Neoria SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bareilly Division"
  },
  "262308": {
    "state": "Uttarakhand",
    "district": "Udham Singh Nagar",
    "block": "Khatima",
    "officename": "Khatima SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "262309": {
    "state": "Uttarakhand",
    "district": "Champawat",
    "block": "Tanakpur",
    "officename": "Tanakpur SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "262310": {
    "state": "Uttarakhand",
    "district": "Champawat",
    "block": "Champawat",
    "officename": "Chandani SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "262311": {
    "state": "Uttarakhand",
    "district": "Udham Singh Nagar",
    "block": "Sitarganj",
    "officename": "Nanakmatta SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "262401": {
    "state": "Uttarakhand",
    "district": "Udham Singh Nagar",
    "block": "Kashipur",
    "officename": "Bazpur SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "262402": {
    "state": "Uttarakhand",
    "district": "Nainital",
    "block": "Lalkuwan",
    "officename": "Lalkua SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "262405": {
    "state": "Uttarakhand",
    "district": "Udham Singh Nagar",
    "block": "Sittaganj",
    "officename": "Sittarganj SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "262406": {
    "state": "Uttar Pradesh",
    "district": "Bareilly",
    "block": "Nawabganj",
    "officename": "Nawabganj SO Bareilly",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bareilly Division"
  },
  "262501": {
    "state": "Uttarakhand",
    "district": "Pithoragarh",
    "block": "Pithoragarh",
    "officename": "Pithoragarh HO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pithoragarh Division"
  },
  "262502": {
    "state": "Uttarakhand",
    "district": "Pithoragarh",
    "block": "Pithoragarh",
    "officename": "Degree College SO Pithoragarh",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pithoragarh Division"
  },
  "262520": {
    "state": "Uttarakhand",
    "district": "Pithoragarh",
    "block": "Pithoragarh",
    "officename": "Bharkatia SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pithoragarh Division"
  },
  "262521": {
    "state": "Uttarakhand",
    "district": "Pithoragarh",
    "block": "Pithoragarh",
    "officename": "Wadda SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pithoragarh Division"
  },
  "262522": {
    "state": "Uttarakhand",
    "district": "Pithoragarh",
    "block": "Gangolihat",
    "officename": "Gangolihat SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pithoragarh Division"
  },
  "262523": {
    "state": "Uttarakhand",
    "district": "Champawat",
    "block": "Champawat",
    "officename": "Champawat SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pithoragarh Division"
  },
  "262524": {
    "state": "Uttarakhand",
    "district": "Champawat",
    "block": "Lohaghat",
    "officename": "Lohaghat SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pithoragarh Division"
  },
  "262525": {
    "state": "Uttarakhand",
    "district": "Champawat",
    "block": "Lohaghat",
    "officename": "Abbotmount SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pithoragarh Division"
  },
  "262526": {
    "state": "Uttarakhand",
    "district": "Pithoragarh",
    "block": "Pithoragarh",
    "officename": "Jhulaghat SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pithoragarh Division"
  },
  "262527": {
    "state": "Uttarakhand",
    "district": "Champawat",
    "block": "Lohaghat",
    "officename": "Barakote SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pithoragarh Division"
  },
  "262528": {
    "state": "Uttarakhand",
    "district": "Champawat",
    "block": "Lohaghat",
    "officename": "Khetikhan SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pithoragarh Division"
  },
  "262529": {
    "state": "Uttarakhand",
    "district": "Pithoragarh",
    "block": "Pithoragarh",
    "officename": "Gurna SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pithoragarh Division"
  },
  "262530": {
    "state": "Uttarakhand",
    "district": "Pithoragarh",
    "block": "Pithoragarh",
    "officename": "Aincholi SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pithoragarh Division"
  },
  "262531": {
    "state": "Uttarakhand",
    "district": "Pithoragarh",
    "block": "Berinag",
    "officename": "Berinag SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pithoragarh Division"
  },
  "262532": {
    "state": "Uttarakhand",
    "district": "Pithoragarh",
    "block": "Gangolihat",
    "officename": "Ganai Gangoli SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pithoragarh Division"
  },
  "262533": {
    "state": "Uttarakhand",
    "district": "Pithoragarh",
    "block": "Berinag",
    "officename": "Pankhu SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pithoragarh Division"
  },
  "262534": {
    "state": "Uttarakhand",
    "district": "Pithoragarh",
    "block": "Gangolihat",
    "officename": "Agar SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pithoragarh Division"
  },
  "262540": {
    "state": "Uttarakhand",
    "district": "Pithoragarh",
    "block": "Pithoragarh",
    "officename": "Jajardewal SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pithoragarh Division"
  },
  "262541": {
    "state": "Uttarakhand",
    "district": "Pithoragarh",
    "block": "Didihat",
    "officename": "Kanalichina SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pithoragarh Division"
  },
  "262542": {
    "state": "Uttarakhand",
    "district": "Pithoragarh",
    "block": "Didihat",
    "officename": "Dewalthal SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pithoragarh Division"
  },
  "262543": {
    "state": "Uttarakhand",
    "district": "Pithoragarh",
    "block": "Didihat",
    "officename": "Askote SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pithoragarh Division"
  },
  "262544": {
    "state": "Uttarakhand",
    "district": "Pithoragarh",
    "block": "Dharchula",
    "officename": "Jauljibi SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pithoragarh Division"
  },
  "262545": {
    "state": "Uttarakhand",
    "district": "Pithoragarh",
    "block": "Dharchula",
    "officename": "Dharchula SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pithoragarh Division"
  },
  "262546": {
    "state": "Uttarakhand",
    "district": "Pithoragarh",
    "block": "Dharchula",
    "officename": "Garbyang SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pithoragarh Division"
  },
  "262547": {
    "state": "Uttarakhand",
    "district": "Pithoragarh",
    "block": "Dharchula",
    "officename": "Pangu SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pithoragarh Division"
  },
  "262550": {
    "state": "Uttarakhand",
    "district": "Pithoragarh",
    "block": "Didihat",
    "officename": "Merthi SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pithoragarh Division"
  },
  "262551": {
    "state": "Uttarakhand",
    "district": "Pithoragarh",
    "block": "Didihat",
    "officename": "Didihat SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pithoragarh Division"
  },
  "262552": {
    "state": "Uttarakhand",
    "district": "Pithoragarh",
    "block": "Berinag",
    "officename": "Thal SO Pithoragarh",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pithoragarh Division"
  },
  "262553": {
    "state": "Uttarakhand",
    "district": "Pithoragarh",
    "block": "Munsiari",
    "officename": "Tejam SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pithoragarh Division"
  },
  "262554": {
    "state": "Uttarakhand",
    "district": "Pithoragarh",
    "block": "Munsiari",
    "officename": "Munsiari SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pithoragarh Division"
  },
  "262555": {
    "state": "Uttarakhand",
    "district": "Pithoragarh",
    "block": "Munsiari",
    "officename": "Bansbagar SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pithoragarh Division"
  },
  "262561": {
    "state": "Uttarakhand",
    "district": "Pithoragarh",
    "block": "Pithoragarh",
    "officename": "Pati SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pithoragarh Division"
  },
  "262576": {
    "state": "Uttarakhand",
    "district": "Pithoragarh",
    "block": "Dharchula",
    "officename": "Baluwakote SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pithoragarh Division"
  },
  "262580": {
    "state": "Uttarakhand",
    "district": "Champawat",
    "block": "Lohaghat",
    "officename": "Devidhura SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pithoragarh Division"
  },
  "262701": {
    "state": "Uttar Pradesh",
    "district": "Kheri",
    "block": "Lakhimpur",
    "officename": "Kheri HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Kheri Division"
  },
  "262702": {
    "state": "Uttar Pradesh",
    "district": "Kheri",
    "block": "Lakhimpur",
    "officename": "Kheri Town SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Kheri Division"
  },
  "262721": {
    "state": "Uttar Pradesh",
    "district": "Kheri",
    "block": "Lakhimpur",
    "officename": "Lagucha SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Kheri Division"
  },
  "262722": {
    "state": "Uttar Pradesh",
    "district": "Kheri",
    "block": "Dhaurahara",
    "officename": "Aira Estate SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Kheri Division"
  },
  "262723": {
    "state": "Uttar Pradesh",
    "district": "Kheri",
    "block": "Dhaurahara",
    "officename": "Dhaurahara SO Kheri",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Kheri Division"
  },
  "262724": {
    "state": "Uttar Pradesh",
    "district": "Kheri",
    "block": "Dhaurahara",
    "officename": "Jatpurwa SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Kheri Division"
  },
  "262725": {
    "state": "Uttar Pradesh",
    "district": "Kheri",
    "block": "Lakhimpur",
    "officename": "Oel SO Kheri",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Kheri Division"
  },
  "262726": {
    "state": "Uttar Pradesh",
    "district": "Kheri",
    "block": "Lakhimpur",
    "officename": "Sharda Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Kheri Division"
  },
  "262727": {
    "state": "Uttar Pradesh",
    "district": "Kheri",
    "block": "Mohammdi",
    "officename": "Mitauli SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Kheri Division"
  },
  "262728": {
    "state": "Uttar Pradesh",
    "district": "Kheri",
    "block": "Lakhimpur",
    "officename": "Nakha SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Kheri Division"
  },
  "262801": {
    "state": "Uttar Pradesh",
    "district": "Kheri",
    "block": "Gola Gokaran Nath",
    "officename": "Bankey Ganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Kheri Division"
  },
  "262802": {
    "state": "Uttar Pradesh",
    "district": "Kheri",
    "block": "Gola",
    "officename": "Gola Gokaran Nath SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Kheri Division"
  },
  "262803": {
    "state": "Uttar Pradesh",
    "district": "Kheri",
    "block": "Gola",
    "officename": "Mailani SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Kheri Division"
  },
  "262804": {
    "state": "Uttar Pradesh",
    "district": "Kheri",
    "block": "Mohammdi",
    "officename": "Mohammadi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Kheri Division"
  },
  "262805": {
    "state": "Uttar Pradesh",
    "district": "Kheri",
    "block": "Gola",
    "officename": "Sikandrabad SO Kheri",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Kheri Division"
  },
  "262901": {
    "state": "Uttar Pradesh",
    "district": "Kheri",
    "block": "Gola",
    "officename": "Bhira SO Kheri",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Kheri Division"
  },
  "262902": {
    "state": "Uttar Pradesh",
    "district": "Kheri",
    "block": "Palia",
    "officename": "Pallia SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Kheri Division"
  },
  "262903": {
    "state": "Uttar Pradesh",
    "district": "Kheri",
    "block": "Nighasan",
    "officename": "Nighasan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Kheri Division"
  },
  "262904": {
    "state": "Uttar Pradesh",
    "district": "Kheri",
    "block": "Palia",
    "officename": "Sampurna Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Kheri Division"
  },
  "262905": {
    "state": "Uttar Pradesh",
    "district": "Kheri",
    "block": "Nighasan",
    "officename": "Singahi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Kheri Division"
  },
  "262906": {
    "state": "Uttar Pradesh",
    "district": "Kheri",
    "block": "Nighasan",
    "officename": "Tikunia SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Kheri Division"
  },
  "262907": {
    "state": "Uttar Pradesh",
    "district": "Kheri",
    "block": "Dhaurahara",
    "officename": "Semra SO Kheri",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Kheri Division"
  },
  "262908": {
    "state": "Uttar Pradesh",
    "district": "Kheri",
    "block": "Palia",
    "officename": "Chandan Chauki SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Kheri Division"
  },
  "263001": {
    "state": "Uttarakhand",
    "district": "Nainital",
    "block": "Nainital",
    "officename": "Nainital HO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "263126": {
    "state": "Uttarakhand",
    "district": "Nainital",
    "block": "Nainital",
    "officename": "Kathgodam SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "263127": {
    "state": "Uttarakhand",
    "district": "Nainital",
    "block": "Nainital",
    "officename": "Jeolikote SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "263128": {
    "state": "Uttarakhand",
    "district": "Nainital",
    "block": "Nainital",
    "officename": "Patwadanger SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "263132": {
    "state": "Uttarakhand",
    "district": "Nainital",
    "block": "Dhari",
    "officename": "Bhowali SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "263134": {
    "state": "Uttarakhand",
    "district": "Nainital",
    "block": "Kosya Kutauli",
    "officename": "Betalghat SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "263135": {
    "state": "Uttarakhand",
    "district": "Nainital",
    "block": "Kosya Kutauli",
    "officename": "Garampani SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "263136": {
    "state": "Uttarakhand",
    "district": "Nainital",
    "block": "Dhari",
    "officename": "Bhimtal SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "263137": {
    "state": "Uttarakhand",
    "district": "Nainital",
    "block": "Nainital",
    "officename": "Ramgarh SO Nainital",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "263138": {
    "state": "Uttarakhand",
    "district": "Nainital",
    "block": "Kosya Kutauli",
    "officename": "MukteshwarKumaon SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "263139": {
    "state": "Uttarakhand",
    "district": "Nainital",
    "block": "Haldwani",
    "officename": "Haldwani HO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "263140": {
    "state": "Uttarakhand",
    "district": "Nainital",
    "block": "Kaladhungi",
    "officename": "Kaladhungi SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "263145": {
    "state": "Uttarakhand",
    "district": "Udham Singh Nagar",
    "block": "Kichha",
    "officename": "Pantnagar SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "263148": {
    "state": "Uttarakhand",
    "district": "Udham Singh Nagar",
    "block": "Kichha",
    "officename": "Kichha SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "263149": {
    "state": "Uttarakhand",
    "district": "Udham Singh Nagar",
    "block": "Kichha",
    "officename": "DF Nagla SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "263150": {
    "state": "Uttarakhand",
    "district": "Udham Singh Nagar",
    "block": "Bazpur",
    "officename": "Kelakhera SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "263151": {
    "state": "Uttarakhand",
    "district": "Udham Singh Nagar",
    "block": "Sitarganj",
    "officename": "Shaktifarm SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "263152": {
    "state": "Uttarakhand",
    "district": "Udham Singh Nagar",
    "block": "Kichha",
    "officename": "Gadarpur SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "263153": {
    "state": "Uttarakhand",
    "district": "Udham Singh Nagar",
    "block": "Kichha",
    "officename": "Rudarpur SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "263156": {
    "state": "Uttarakhand",
    "district": "Nainital",
    "block": "Nainital",
    "officename": "Ghorakhal SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "263157": {
    "state": "Uttarakhand",
    "district": "Nainital",
    "block": "Dhari",
    "officename": "Okhalkanda SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "263158": {
    "state": "Uttarakhand",
    "district": "Nainital",
    "block": "Nainital",
    "officename": "Narain Swamy Ashram SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "263159": {
    "state": "Uttarakhand",
    "district": "Nainital",
    "block": "Nainital",
    "officename": "Kotabagh SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "263160": {
    "state": "Uttarakhand",
    "district": "Udham Singh Nagar",
    "block": "Kichha",
    "officename": "Dineshpur SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "263601": {
    "state": "Uttarakhand",
    "district": "Almora",
    "block": "Almora",
    "officename": "Almora HO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263619": {
    "state": "Uttarakhand",
    "district": "Bageshwar",
    "block": "Bageshwar",
    "officename": "Ghingartola SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263620": {
    "state": "Uttarakhand",
    "district": "Almora",
    "block": "Garur",
    "officename": "Kausani Estate SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263621": {
    "state": "Uttarakhand",
    "district": "Almora",
    "block": "Dwarahat",
    "officename": "Bagwalipokhar SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263622": {
    "state": "Uttarakhand",
    "district": "Almora",
    "block": "Bhanoli",
    "officename": "Dania SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263623": {
    "state": "Uttarakhand",
    "district": "Almora",
    "block": "Bhanoli",
    "officename": "Panuwanaula SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263624": {
    "state": "Uttarakhand",
    "district": "Almora",
    "block": "Almora",
    "officename": "Barechhina SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263625": {
    "state": "Uttarakhand",
    "district": "Almora",
    "block": "Jainti",
    "officename": "Lamgara SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263626": {
    "state": "Uttarakhand",
    "district": "Almora",
    "block": "Jainti",
    "officename": "Jainti SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263628": {
    "state": "Uttarakhand",
    "district": "Bageshwar",
    "block": "Bageshwar",
    "officename": "Takula SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263629": {
    "state": "Uttarakhand",
    "district": "Almora",
    "block": "Someshwar",
    "officename": "Chanoda SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263630": {
    "state": "Uttarakhand",
    "district": "Bageshwar",
    "block": "Bageshwar",
    "officename": "Billori SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263631": {
    "state": "Uttarakhand",
    "district": "Bageshwar",
    "block": "Kanda",
    "officename": "Kanda SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263632": {
    "state": "Uttarakhand",
    "district": "Bageshwar",
    "block": "Kapkote",
    "officename": "Kapkote SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263633": {
    "state": "Uttarakhand",
    "district": "Bageshwar",
    "block": "Kapkote",
    "officename": "Shama SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263634": {
    "state": "Uttarakhand",
    "district": "Bageshwar",
    "block": "Kapkote",
    "officename": "Dofar SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263635": {
    "state": "Uttarakhand",
    "district": "Bageshwar",
    "block": "Garur",
    "officename": "Dangoli SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263636": {
    "state": "Uttarakhand",
    "district": "Almora",
    "block": "Almora",
    "officename": "Hawalbagh SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263637": {
    "state": "Uttarakhand",
    "district": "Almora",
    "block": "Someshwar",
    "officename": "Someshwar SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263638": {
    "state": "Uttarakhand",
    "district": "Almora",
    "block": "Someshwar",
    "officename": "Manan SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263639": {
    "state": "Uttarakhand",
    "district": "Almora",
    "block": "Someshwar",
    "officename": "Kausani SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263640": {
    "state": "Uttarakhand",
    "district": "Bageshwar",
    "block": "Kanda",
    "officename": "Kameridevi SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263641": {
    "state": "Uttarakhand",
    "district": "Bageshwar",
    "block": "Garur",
    "officename": "Baijnath SO Bageshwar",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263642": {
    "state": "Uttarakhand",
    "district": "Bageshwar",
    "block": "Bageshwar",
    "officename": "Bageshwar SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263643": {
    "state": "Uttarakhand",
    "district": "Almora",
    "block": "Almora",
    "officename": "Kosi SO Almora",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263645": {
    "state": "Uttarakhand",
    "district": "Almora",
    "block": "Ranikhet",
    "officename": "Ranikhet HO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263646": {
    "state": "Uttarakhand",
    "district": "Almora",
    "block": "Ranikhet",
    "officename": "Bhatronjkhan SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263651": {
    "state": "Uttarakhand",
    "district": "Almora",
    "block": "Ranikhet",
    "officename": "Chaubattia SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263652": {
    "state": "Uttarakhand",
    "district": "Almora",
    "block": "Ranikhet",
    "officename": "Majkhali SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263653": {
    "state": "Uttarakhand",
    "district": "Almora",
    "block": "Dwarahat",
    "officename": "Dwarahat SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263655": {
    "state": "Uttarakhand",
    "district": "Almora",
    "block": "Someshwar",
    "officename": "Daulaghat SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263656": {
    "state": "Uttarakhand",
    "district": "Almora",
    "block": "Chaukhutia",
    "officename": "Ganai SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263658": {
    "state": "Uttarakhand",
    "district": "Almora",
    "block": "Chaukhutia",
    "officename": "Masi SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263659": {
    "state": "Uttarakhand",
    "district": "Almora",
    "block": "Ranikhet",
    "officename": "Deghat SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263660": {
    "state": "Uttarakhand",
    "district": "Almora",
    "block": "Bhikiyasen",
    "officename": "Daula SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263661": {
    "state": "Uttarakhand",
    "district": "Almora",
    "block": "Bhikiyasen",
    "officename": "Syalde SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263663": {
    "state": "Uttarakhand",
    "district": "Almora",
    "block": "Ranikhet",
    "officename": "Tarikhet SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263664": {
    "state": "Uttarakhand",
    "district": "Almora",
    "block": "Ranikhet",
    "officename": "Deolikhet SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263665": {
    "state": "Uttarakhand",
    "district": "Almora",
    "block": "Bhikiyasen",
    "officename": "Matela SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263667": {
    "state": "Uttarakhand",
    "district": "Almora",
    "block": "Bhikiyasen",
    "officename": "Bhikiyasen SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263676": {
    "state": "Uttarakhand",
    "district": "Almora",
    "block": "Salt",
    "officename": "Maulekhal SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263678": {
    "state": "Uttarakhand",
    "district": "Almora",
    "block": "Almora",
    "officename": "Shitalakhet SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263679": {
    "state": "Uttarakhand",
    "district": "Bageshwar",
    "block": "Kapkote",
    "officename": "Bharari SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "263680": {
    "state": "Uttarakhand",
    "district": "Almora",
    "block": "Ranikhet",
    "officename": "Chaunallia SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Almora Division"
  },
  "271001": {
    "state": "Uttar Pradesh",
    "district": "Gonda",
    "block": "Gonda",
    "officename": "Gonda HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271002": {
    "state": "Uttar Pradesh",
    "district": "Gonda",
    "block": "Gonda",
    "officename": "Bargaon Gonda SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271003": {
    "state": "Uttar Pradesh",
    "district": "Gonda",
    "block": "Gonda",
    "officename": "Bus Station SO Gonda",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271122": {
    "state": "Uttar Pradesh",
    "district": "Gonda",
    "block": "Gonda",
    "officename": "Kauria SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271123": {
    "state": "Uttar Pradesh",
    "district": "Gonda",
    "block": "Gonda",
    "officename": "Khorasha SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271124": {
    "state": "Uttar Pradesh",
    "district": "Gonda",
    "block": "Tarabganj",
    "officename": "Wazeerganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271125": {
    "state": "Uttar Pradesh",
    "district": "Gonda",
    "block": "Colonelganj",
    "officename": "Balpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271126": {
    "state": "Uttar Pradesh",
    "district": "Gonda",
    "block": "Cononel Ganj",
    "officename": "BBSingh SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271129": {
    "state": "Uttar Pradesh",
    "district": "Gonda",
    "block": "Tarabganj",
    "officename": "Chandapur SO Gonda",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271201": {
    "state": "Uttar Pradesh",
    "district": "Balrampur",
    "block": "Balrampur",
    "officename": "Balrampur HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271202": {
    "state": "Uttar Pradesh",
    "district": "Gonda",
    "block": "Gonda",
    "officename": "Intyathok SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271203": {
    "state": "Uttar Pradesh",
    "district": "Balrampur",
    "block": "Tulsipur",
    "officename": "Jarwa SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271204": {
    "state": "Uttar Pradesh",
    "district": "Gonda",
    "block": "Balrampur",
    "officename": "Khargoopur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271205": {
    "state": "Uttar Pradesh",
    "district": "Balrampur",
    "block": "Tulsipur",
    "officename": "Mahrajganj SO Balrampur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271206": {
    "state": "Uttar Pradesh",
    "district": "Balrampur",
    "block": "Tulsipur",
    "officename": "Pachperwa SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271207": {
    "state": "Uttar Pradesh",
    "district": "Balrampur",
    "block": "Tulsipur",
    "officename": "Shivpura SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271208": {
    "state": "Uttar Pradesh",
    "district": "Balrampur",
    "block": "Tulsipur",
    "officename": "Tulsipur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271209": {
    "state": "Uttar Pradesh",
    "district": "Balrampur",
    "block": "Balrampur",
    "officename": "Jaiprabha Gram SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271210": {
    "state": "Uttar Pradesh",
    "district": "Balrampur",
    "block": "Tulsipur",
    "officename": "Gainsari SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271215": {
    "state": "Uttar Pradesh",
    "district": "Balrampur",
    "block": "Tulsipur",
    "officename": "Purani Bazar Pachperwa SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271301": {
    "state": "Uttar Pradesh",
    "district": "Gonda",
    "block": "Mankapur",
    "officename": "Motiganj SO Gonda",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271302": {
    "state": "Uttar Pradesh",
    "district": "Gonda",
    "block": "Mankapur",
    "officename": "Mankapur Bazar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271303": {
    "state": "Uttar Pradesh",
    "district": "Gonda",
    "block": "Tarabganj",
    "officename": "Nawabganj SO Gonda",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271304": {
    "state": "Uttar Pradesh",
    "district": "Gonda",
    "block": "Tarabganj",
    "officename": "Nawabganj S F SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271305": {
    "state": "Uttar Pradesh",
    "district": "Gonda",
    "block": "Mankapur",
    "officename": "Maskanwa Rs SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271306": {
    "state": "Uttar Pradesh",
    "district": "Balrampur",
    "block": "Utraula",
    "officename": "Rehra Bazar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271307": {
    "state": "Uttar Pradesh",
    "district": "Gonda",
    "block": "Gonda",
    "officename": "Sadullanagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271308": {
    "state": "Uttar Pradesh",
    "district": "Gonda",
    "block": "Mankapur",
    "officename": "Iti Mankapur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271309": {
    "state": "Uttar Pradesh",
    "district": "Gonda",
    "block": "Tarabganj",
    "officename": "DPGhat SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271310": {
    "state": "Uttar Pradesh",
    "district": "Gonda",
    "block": "Gonda",
    "officename": "Bankatwa Dehat SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271311": {
    "state": "Uttar Pradesh",
    "district": "Gonda",
    "block": "Colonelganj",
    "officename": "Bargadi Kot SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271312": {
    "state": "Uttar Pradesh",
    "district": "Gonda",
    "block": "Mankapur",
    "officename": "Gaura Chawki SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271313": {
    "state": "Uttar Pradesh",
    "district": "Gonda",
    "block": "Mankapur",
    "officename": "Babhnan Sugar Factory SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271319": {
    "state": "Uttar Pradesh",
    "district": "Gonda",
    "block": "Tarabganj",
    "officename": "Pure Shivdayal Ganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271401": {
    "state": "Uttar Pradesh",
    "district": "Gonda",
    "block": "Tarabganj",
    "officename": "Belser SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271402": {
    "state": "Uttar Pradesh",
    "district": "Gonda",
    "block": "Tarabganj",
    "officename": "Begamganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271403": {
    "state": "Uttar Pradesh",
    "district": "Gonda",
    "block": "Tarabganj",
    "officename": "Tarabganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271502": {
    "state": "Uttar Pradesh",
    "district": "Gonda",
    "block": "Colonelganj",
    "officename": "Colonelganj SO Gonda",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271503": {
    "state": "Uttar Pradesh",
    "district": "Gonda",
    "block": "Colonelganj",
    "officename": "Katra Bazar SO Gonda",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271504": {
    "state": "Uttar Pradesh",
    "district": "Gonda",
    "block": "Tarabganj",
    "officename": "Paraspur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271601": {
    "state": "Uttar Pradesh",
    "district": "Gonda",
    "block": "Gonda",
    "officename": "Bishunpur Bairiya SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271602": {
    "state": "Uttar Pradesh",
    "district": "Gonda",
    "block": "Gonda",
    "officename": "Dhaneypur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271603": {
    "state": "Uttar Pradesh",
    "district": "Gonda",
    "block": "Gonda",
    "officename": "Srinagar SO Gonda",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271604": {
    "state": "Uttar Pradesh",
    "district": "Balrampur",
    "block": "Utraula",
    "officename": "Utraula SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271607": {
    "state": "Uttar Pradesh",
    "district": "Balrampur",
    "block": "Utraula",
    "officename": "Sriduttganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271609": {
    "state": "Uttar Pradesh",
    "district": "Balrampur",
    "block": "Utraula",
    "officename": "Chamrupur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271801": {
    "state": "Uttar Pradesh",
    "district": "Bahraich",
    "block": "Bahraich",
    "officename": "Bahraich HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Bahraich Division"
  },
  "271802": {
    "state": "Uttar Pradesh",
    "district": "Bahraich",
    "block": "Bahraich",
    "officename": "Kalpipara SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Bahraich Division"
  },
  "271803": {
    "state": "Uttar Pradesh",
    "district": "Shrawasti",
    "block": "Bhinga",
    "officename": "Patna Malhipur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Bahraich Division"
  },
  "271804": {
    "state": "Uttar Pradesh",
    "district": "Bahraich",
    "block": "Bahraich",
    "officename": "Laxman Nagar Bazar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Bahraich Division"
  },
  "271805": {
    "state": "Uttar Pradesh",
    "district": "Shrawasti",
    "block": "Ikauna **",
    "officename": "Shravasti SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Bahraich Division"
  },
  "271821": {
    "state": "Uttar Pradesh",
    "district": "Shrawasti",
    "block": "Payagpur",
    "officename": "Bisheswarganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Bahraich Division"
  },
  "271824": {
    "state": "Uttar Pradesh",
    "district": "Bahraich",
    "block": "Mahasi",
    "officename": "Mahsi Tahsil SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Bahraich Division"
  },
  "271825": {
    "state": "Uttar Pradesh",
    "district": "Bahraich",
    "block": "Mahasi Tahsil",
    "officename": "Barnapur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Bahraich Division"
  },
  "271830": {
    "state": "Uttar Pradesh",
    "district": "Bahraich",
    "block": "Nanpara",
    "officename": "Shivpur SO Bahraich",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Bahraich Division"
  },
  "271831": {
    "state": "Uttar Pradesh",
    "district": "Shrawasti",
    "block": "Bhinga",
    "officename": "Bhinga SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Bahraich Division"
  },
  "271835": {
    "state": "Uttar Pradesh",
    "district": "Shrawasti",
    "block": "Ikauna",
    "officename": "Gilaula SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Bahraich Division"
  },
  "271840": {
    "state": "Uttar Pradesh",
    "district": "Shrawasti",
    "block": "Bhinga",
    "officename": "Sirsia SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Bahraich Division"
  },
  "271841": {
    "state": "Uttar Pradesh",
    "district": "Bahraich",
    "block": "Nanpara",
    "officename": "MATEHI CHAFARIA S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Bahraich Division"
  },
  "271845": {
    "state": "Uttar Pradesh",
    "district": "Shrawasti",
    "block": "Ikauna",
    "officename": "Ikauna SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Bahraich Division"
  },
  "271851": {
    "state": "Uttar Pradesh",
    "district": "Bahraich",
    "block": "Nanpara",
    "officename": "Kharighat SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Bahraich Division"
  },
  "271855": {
    "state": "Uttar Pradesh",
    "district": "Bahraich",
    "block": "Nanpara",
    "officename": "Mihinpurwa SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Bahraich Division"
  },
  "271861": {
    "state": "Uttar Pradesh",
    "district": "Balrampur",
    "block": "Tulsipur",
    "officename": "Mathura Bazar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gonda Division"
  },
  "271865": {
    "state": "Uttar Pradesh",
    "district": "Bahraich",
    "block": "Nanpara",
    "officename": "Nanpara SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Bahraich Division"
  },
  "271870": {
    "state": "Uttar Pradesh",
    "district": "Bahraich",
    "block": "Kaiserganj",
    "officename": "Chilwaria SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Bahraich Division"
  },
  "271871": {
    "state": "Uttar Pradesh",
    "district": "Bahraich",
    "block": "Bahraich",
    "officename": "Payagpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Bahraich Division"
  },
  "271872": {
    "state": "Uttar Pradesh",
    "district": "Bahraich",
    "block": "Kaiserganj",
    "officename": "Huzoorpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Bahraich Division"
  },
  "271875": {
    "state": "Uttar Pradesh",
    "district": "Bahraich",
    "block": "Nanpara",
    "officename": "Risia SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Bahraich Division"
  },
  "271881": {
    "state": "Uttar Pradesh",
    "district": "Bahraich",
    "block": "Nanpara",
    "officename": "Rupaidiha SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Bahraich Division"
  },
  "271882": {
    "state": "Uttar Pradesh",
    "district": "Bahraich",
    "block": "Nanpara",
    "officename": "Matera RS SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Bahraich Division"
  },
  "271901": {
    "state": "Uttar Pradesh",
    "district": "Bahraich",
    "block": "Kaiserganj",
    "officename": "Jarwal Road SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Bahraich Division"
  },
  "271902": {
    "state": "Uttar Pradesh",
    "district": "Bahraich",
    "block": "Kaiserganj",
    "officename": "Fakharpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Bahraich Division"
  },
  "271903": {
    "state": "Uttar Pradesh",
    "district": "Bahraich",
    "block": "Kaiserganj",
    "officename": "Kaiserganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Bahraich Division"
  },
  "271904": {
    "state": "Uttar Pradesh",
    "district": "Bahraich",
    "block": "Kaiserganj",
    "officename": "Jarwal SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Bahraich Division"
  },
  "272001": {
    "state": "Uttar Pradesh",
    "district": "Basti",
    "block": "Basti",
    "officename": "Basti HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272002": {
    "state": "Uttar Pradesh",
    "district": "Basti",
    "block": "Basti",
    "officename": "Purani Basti SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272123": {
    "state": "Uttar Pradesh",
    "district": "Basti",
    "block": "Basti",
    "officename": "Bankati Bazar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272124": {
    "state": "Uttar Pradesh",
    "district": "Basti",
    "block": "Basti Sadar",
    "officename": "Mahson SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272125": {
    "state": "Uttar Pradesh",
    "district": "Basti",
    "block": "Basti",
    "officename": "Dudhara SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272126": {
    "state": "Uttar Pradesh",
    "district": "Sant Kabir Nagar",
    "block": "Basti Sadar",
    "officename": "Semariyawan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272127": {
    "state": "Uttar Pradesh",
    "district": "Basti",
    "block": "Harraiya",
    "officename": "Amorha",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272128": {
    "state": "Uttar Pradesh",
    "district": "Basti",
    "block": "Harraiya",
    "officename": "Bishesharganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272129": {
    "state": "Uttar Pradesh",
    "district": "Siddharthnagar",
    "block": "Domariaganj",
    "officename": "Shankarpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272130": {
    "state": "Uttar Pradesh",
    "district": "Basti",
    "block": "Harraiya",
    "officename": "Parasrampur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272131": {
    "state": "Uttar Pradesh",
    "district": "Basti",
    "block": "Basti",
    "officename": "Captainganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272148": {
    "state": "Uttar Pradesh",
    "district": "Siddharthnagar",
    "block": "Bansi",
    "officename": "Rayath SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272150": {
    "state": "Uttar Pradesh",
    "district": "Basti",
    "block": "Basti",
    "officename": "Hanumanganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272151": {
    "state": "Uttar Pradesh",
    "district": "Basti",
    "block": "Basti",
    "officename": "Rudranagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272152": {
    "state": "Uttar Pradesh",
    "district": "Siddharthnagar",
    "block": "Menhdawal",
    "officename": "Daldala SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272153": {
    "state": "Uttar Pradesh",
    "district": "Siddharthnagar",
    "block": "Bansi",
    "officename": "Bansi S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272154": {
    "state": "Uttar Pradesh",
    "district": "Siddharthnagar",
    "block": "Bansi",
    "officename": "Dharamsinghwa SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272155": {
    "state": "Uttar Pradesh",
    "district": "Basti",
    "block": "Harraiya",
    "officename": "Harraiya SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272161": {
    "state": "Uttar Pradesh",
    "district": "Basti",
    "block": "Basti",
    "officename": "Babhnan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272162": {
    "state": "Uttar Pradesh",
    "district": "Sant Kabir Nagar",
    "block": "Dhanghata",
    "officename": "Dhanghata SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272163": {
    "state": "Uttar Pradesh",
    "district": "Basti",
    "block": "Harraiya",
    "officename": "Gaur RS SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272164": {
    "state": "Uttar Pradesh",
    "district": "Sant Kabir Nagar",
    "block": "Dhanghata",
    "officename": "Hariharpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272165": {
    "state": "Uttar Pradesh",
    "district": "Sant Kabir Nagar",
    "block": "Dhanghata",
    "officename": "Hainsar Bazar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272171": {
    "state": "Uttar Pradesh",
    "district": "Basti",
    "block": "Basti Sadar",
    "officename": "Lalganj Basti SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272172": {
    "state": "Uttar Pradesh",
    "district": "Sant Kabir Nagar",
    "block": "Dhanghata",
    "officename": "Mahuli SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272173": {
    "state": "Uttar Pradesh",
    "district": "Sant Kabir Nagar",
    "block": "Khalilabad",
    "officename": "Maghar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272175": {
    "state": "Uttar Pradesh",
    "district": "Basti",
    "block": "Basti",
    "officename": "Khalilabad SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272176": {
    "state": "Uttar Pradesh",
    "district": "Sant Kabir Nagar",
    "block": "Dhanghata",
    "officename": "Ganpatganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272177": {
    "state": "Uttar Pradesh",
    "district": "Basti",
    "block": "Basti",
    "officename": "Banpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272181": {
    "state": "Uttar Pradesh",
    "district": "Basti",
    "block": "Harraiya",
    "officename": "Paikolia SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272182": {
    "state": "Uttar Pradesh",
    "district": "Basti",
    "block": "Basti East",
    "officename": "Walterganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272189": {
    "state": "Uttar Pradesh",
    "district": "Siddharthnagar",
    "block": "Domariaganj",
    "officename": "Domariyaganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272190": {
    "state": "Uttar Pradesh",
    "district": "Basti",
    "block": "Bhanpur",
    "officename": "Saltauwa SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272191": {
    "state": "Uttar Pradesh",
    "district": "Basti",
    "block": "Basti",
    "officename": "Hallaur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272192": {
    "state": "Uttar Pradesh",
    "district": "Siddharthnagar",
    "block": "Itwa",
    "officename": "Itwa SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272193": {
    "state": "Uttar Pradesh",
    "district": "Siddharthnagar",
    "block": "Itwa",
    "officename": "Bhanwapur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272194": {
    "state": "Uttar Pradesh",
    "district": "Basti",
    "block": "Bhanpur",
    "officename": "Asnahra SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272195": {
    "state": "Uttar Pradesh",
    "district": "Siddharthnagar",
    "block": "Domariaganj",
    "officename": "Bayara SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272199": {
    "state": "Uttar Pradesh",
    "district": "Sant Kabir Nagar",
    "block": "Khalilabad",
    "officename": "Bakhira SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272201": {
    "state": "Uttar Pradesh",
    "district": "Basti",
    "block": "Basti",
    "officename": "Barhni SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272202": {
    "state": "Uttar Pradesh",
    "district": "Siddharthnagar",
    "block": "Naugarh",
    "officename": "Birdpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272203": {
    "state": "Uttar Pradesh",
    "district": "Siddharthnagar",
    "block": "Naugarh",
    "officename": "Naugarh SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272204": {
    "state": "Uttar Pradesh",
    "district": "Siddharthnagar",
    "block": "Naugarh",
    "officename": "Udairajganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272205": {
    "state": "Uttar Pradesh",
    "district": "Siddharthnagar",
    "block": "Shohratgarh",
    "officename": "Shoharatgarh SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272206": {
    "state": "Uttar Pradesh",
    "district": "Siddharthnagar",
    "block": "Naugarh",
    "officename": "Sheopatinagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272207": {
    "state": "Uttar Pradesh",
    "district": "Siddharthnagar",
    "block": "Naugarh",
    "officename": "SIDDHARTH NAGAR H.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272208": {
    "state": "Uttar Pradesh",
    "district": "Siddharthnagar",
    "block": "Naugarh",
    "officename": "Uska Bazar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272270": {
    "state": "Uttar Pradesh",
    "district": "Sant Kabir Nagar",
    "block": "Menhdawal",
    "officename": "Santha SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272271": {
    "state": "Uttar Pradesh",
    "district": "Sant Kabir Nagar",
    "block": "Menhdawal",
    "officename": "Menhdawal SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272301": {
    "state": "Uttar Pradesh",
    "district": "Basti",
    "block": "Basti",
    "officename": "Kalwari SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "272302": {
    "state": "Uttar Pradesh",
    "district": "Basti",
    "block": "Basti",
    "officename": "Nagar Bazar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "273001": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Gorakhpur",
    "officename": "Gorakhpur HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273002": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Sadar",
    "officename": "A.P.Station S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273003": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Gorakhpur",
    "officename": "Arogyamandir SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273004": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Gorakhpur",
    "officename": "Basharatpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273005": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Gorakhpur",
    "officename": "Gita Press SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273006": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Gorakhpur",
    "officename": "Gita Vatika SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273007": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Sadar",
    "officename": "Fertilizer Factory S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273008": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Gorakhpur Sadar",
    "officename": "Kunraghat S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273009": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Gorakhpur Sadar",
    "officename": "Gorakhpur University SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273010": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Sadar",
    "officename": "M.M.M.E.College S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273012": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Gorakhpur",
    "officename": "Railway Colony SO Gorakhpur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273013": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Gorakhpur",
    "officename": "BRD Medical College SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273014": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Sadar",
    "officename": "Pac Camp SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273015": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Sadar",
    "officename": "Gorakhnath Mandir SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273016": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Sader",
    "officename": "Shivpurinewcolony SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273017": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Gorakhpur",
    "officename": "Siddharth Enclave SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273151": {
    "state": "Uttar Pradesh",
    "district": "Maharajganj",
    "block": "Mahrajganj",
    "officename": "Ghughli R.S. S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273152": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Sadar",
    "officename": "Pipraich S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273155": {
    "state": "Uttar Pradesh",
    "district": "Maharajganj",
    "block": "Pharenda",
    "officename": "Anandnagar S.O  Maharajganj",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273157": {
    "state": "Uttar Pradesh",
    "district": "Maharajganj",
    "block": "Farenda",
    "officename": "Bribgemanganj S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273158": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Campierganj",
    "officename": "Campierganj S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273161": {
    "state": "Uttar Pradesh",
    "district": "Maharajganj",
    "block": "Farenda",
    "officename": "Dhani Bazar S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273162": {
    "state": "Uttar Pradesh",
    "district": "Maharajganj",
    "block": "Nautanwa",
    "officename": "Laxmipur Maharajganj S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273163": {
    "state": "Uttar Pradesh",
    "district": "Maharajganj",
    "block": "Nichlaul",
    "officename": "Siswa Bazar S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273164": {
    "state": "Uttar Pradesh",
    "district": "Maharajganj",
    "block": "Nautanawa",
    "officename": "Nautanwa Bazar S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273165": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Gorakhpur",
    "officename": "Pepeeganj S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273201": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Chauri Chaura",
    "officename": "Chauri Chaura S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273202": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Sadar",
    "officename": "Sardar Nagar S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273203": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Chauri Chaura",
    "officename": "Brahmpur S.O Gorakhpur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273207": {
    "state": "Uttar Pradesh",
    "district": "Maharajganj",
    "block": "Mahrajganj",
    "officename": "Mithaura Bazar S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273209": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Sadar",
    "officename": "Sahajanwa SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273211": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Sadar",
    "officename": "Dhakhwa Bazar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273212": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Khajani",
    "officename": "Khajni SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273213": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Khajani",
    "officename": "Sikriganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273301": {
    "state": "Uttar Pradesh",
    "district": "Maharajganj",
    "block": "Mahrajganj",
    "officename": "Partawal Bazar S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273302": {
    "state": "Uttar Pradesh",
    "district": "Maharajganj",
    "block": "Mahrajgang",
    "officename": "Bhitauli Bazar S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273303": {
    "state": "Uttar Pradesh",
    "district": "Maharajganj",
    "block": "Mahrajganj",
    "officename": "Maharajganj H.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273304": {
    "state": "Uttar Pradesh",
    "district": "Maharajganj",
    "block": "Nichlaul",
    "officename": "Nichlaul S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273305": {
    "state": "Uttar Pradesh",
    "district": "Maharajganj",
    "block": "Nautanwa",
    "officename": "Thuthibari S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273306": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Sadar",
    "officename": "Bhathat S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273308": {
    "state": "Uttar Pradesh",
    "district": "Maharajganj",
    "block": "Nautanwa",
    "officename": "Sonauli S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273309": {
    "state": "Uttar Pradesh",
    "district": "Maharajganj",
    "block": "Pharenda",
    "officename": "Koluhi S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273310": {
    "state": "Uttar Pradesh",
    "district": "Maharajganj",
    "block": "Campeirganj",
    "officename": "Paniyara S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273311": {
    "state": "Uttar Pradesh",
    "district": "Maharajganj",
    "block": "Nichlaul",
    "officename": "Orwalliya S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273401": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Bhowapar",
    "officename": "Bhowapar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273402": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Sadar",
    "officename": "Barhalganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273403": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Basgaon",
    "officename": "Bansgaon SO Gorakhpur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273404": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Khajni",
    "officename": "Belghat SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273405": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Chauri Chaura",
    "officename": "Barhi S.O Gorakhpur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273406": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Sadar",
    "officename": "Unwal SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273407": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Gola",
    "officename": "Uruwa Bazar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273408": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Gola",
    "officename": "Gola SO Gorakhpur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273409": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Gola",
    "officename": "Deidiha SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273411": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Basgaon",
    "officename": "Gagaha SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273412": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Gola",
    "officename": "Shivpur SO Gorakhpur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "273413": {
    "state": "Uttar Pradesh",
    "district": "Gorakhpur",
    "block": "Basgaon",
    "officename": "Kauriram SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "274001": {
    "state": "Uttar Pradesh",
    "district": "Deoria",
    "block": "Deoria Sadar",
    "officename": "Deoria HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274149": {
    "state": "Uttar Pradesh",
    "district": "Kushinagar",
    "block": "Hata",
    "officename": "Bodarwar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274182": {
    "state": "Uttar Pradesh",
    "district": "Deoria",
    "block": "Deoria Sadar",
    "officename": "Bhaluani SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274201": {
    "state": "Uttar Pradesh",
    "district": "Deoria",
    "block": "Deoria Sadar",
    "officename": "Baitalpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274202": {
    "state": "Uttar Pradesh",
    "district": "Deoria",
    "block": "Deoria Sadar",
    "officename": "Gauri Bazar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274203": {
    "state": "Uttar Pradesh",
    "district": "Kushinagar",
    "block": "Hata",
    "officename": "HATA SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274204": {
    "state": "Uttar Pradesh",
    "district": "Deoria",
    "block": "Rudrapur",
    "officename": "Rudrapur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274205": {
    "state": "Uttar Pradesh",
    "district": "Deoria",
    "block": "Deoria Sadar",
    "officename": "Madanpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274206": {
    "state": "Uttar Pradesh",
    "district": "Kushinagar",
    "block": "Hata",
    "officename": "Hetimpur S O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274207": {
    "state": "Uttar Pradesh",
    "district": "Kushinagar",
    "block": "Hata",
    "officename": "Sukrauli SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274208": {
    "state": "Uttar Pradesh",
    "district": "Deoria",
    "block": "Deoria Sadar",
    "officename": "Saraon SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274301": {
    "state": "Uttar Pradesh",
    "district": "Kushinagar",
    "block": "Hata",
    "officename": "Captainganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274302": {
    "state": "Uttar Pradesh",
    "district": "Kushinagar",
    "block": "Tamkuhi Raj",
    "officename": "Dudhai SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274303": {
    "state": "Uttar Pradesh",
    "district": "Kushinagar",
    "block": "Padrauna",
    "officename": "Kathkuiyan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274304": {
    "state": "Uttar Pradesh",
    "district": "Kushinagar",
    "block": "Hata",
    "officename": "Padrauna HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274305": {
    "state": "Uttar Pradesh",
    "district": "Kushinagar",
    "block": "Hata",
    "officename": "Ramkola SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274306": {
    "state": "Uttar Pradesh",
    "district": "Kushinagar",
    "block": "Hata",
    "officename": "Laxmiganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274401": {
    "state": "Uttar Pradesh",
    "district": "Kushinagar",
    "block": "Hata",
    "officename": "Fazilnagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274402": {
    "state": "Uttar Pradesh",
    "district": "Deoria",
    "block": "Salempur",
    "officename": "Kasia S O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274403": {
    "state": "Uttar Pradesh",
    "district": "Kushinagar",
    "block": "Kasia",
    "officename": "KUSHINAGAR SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274404": {
    "state": "Uttar Pradesh",
    "district": "Deoria",
    "block": "Deoria Sadar",
    "officename": "Patherdewa SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274405": {
    "state": "Uttar Pradesh",
    "district": "Deoria",
    "block": "Deoria Sadar",
    "officename": "Rampur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274406": {
    "state": "Uttar Pradesh",
    "district": "Kushinagar",
    "block": "Hata",
    "officename": "Seorahi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274407": {
    "state": "Uttar Pradesh",
    "district": "Kushinagar",
    "block": "Hata",
    "officename": "Tamkuhi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274408": {
    "state": "Uttar Pradesh",
    "district": "Deoria",
    "block": "Deoria Sadar",
    "officename": "Tarkulwa SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274409": {
    "state": "Uttar Pradesh",
    "district": "Kushinagar",
    "block": "Tamkuhi",
    "officename": "Tarya Sujan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274501": {
    "state": "Uttar Pradesh",
    "district": "Deoria",
    "block": "Salempur",
    "officename": "Khukhundoo SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274502": {
    "state": "Uttar Pradesh",
    "district": "Deoria",
    "block": "Deoria Sadar",
    "officename": "Lar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274505": {
    "state": "Uttar Pradesh",
    "district": "Deoria",
    "block": "Deoria Sadar",
    "officename": "Lar Road SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274506": {
    "state": "Uttar Pradesh",
    "district": "Deoria",
    "block": "Salempur",
    "officename": "Majhauli Raj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274508": {
    "state": "Uttar Pradesh",
    "district": "Deoria",
    "block": "Salempur",
    "officename": "Pindi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274509": {
    "state": "Uttar Pradesh",
    "district": "Deoria",
    "block": "Salempur",
    "officename": "Salaempur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274601": {
    "state": "Uttar Pradesh",
    "district": "Deoria",
    "block": "Deoria Sadar",
    "officename": "Barhaj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274602": {
    "state": "Uttar Pradesh",
    "district": "Deoria",
    "block": "Deoria Sadar",
    "officename": "Bhagalpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274603": {
    "state": "Uttar Pradesh",
    "district": "Deoria",
    "block": "Deoria Sadar",
    "officename": "Gaura Jai Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274604": {
    "state": "Uttar Pradesh",
    "district": "Deoria",
    "block": "Barhaj **",
    "officename": "Paina SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274701": {
    "state": "Uttar Pradesh",
    "district": "Deoria",
    "block": "Salempur",
    "officename": "Bhatani SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274702": {
    "state": "Uttar Pradesh",
    "district": "Deoria",
    "block": "Bhatpar Rani **",
    "officename": "Bhatpar Rani SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274703": {
    "state": "Uttar Pradesh",
    "district": "Deoria",
    "block": "Bhatpar Rani",
    "officename": "Paratappur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274704": {
    "state": "Uttar Pradesh",
    "district": "Deoria",
    "block": "Deoria Sadar",
    "officename": "Bankata SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274705": {
    "state": "Uttar Pradesh",
    "district": "Deoria",
    "block": "Salempur",
    "officename": "Ghanti SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274801": {
    "state": "Uttar Pradesh",
    "district": "Kushinagar",
    "block": "Hata",
    "officename": "Chhitauni SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274802": {
    "state": "Uttar Pradesh",
    "district": "Kushinagar",
    "block": "Hata",
    "officename": "Raja Bazar Khadda SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274806": {
    "state": "Uttar Pradesh",
    "district": "Deoria",
    "block": "deoria",
    "officename": "Deoria Railway Station SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274807": {
    "state": "Uttar Pradesh",
    "district": "Deoria",
    "block": "Deoria",
    "officename": "SANT VINOBA MARG SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274808": {
    "state": "Uttar Pradesh",
    "district": "Deoria",
    "block": "Salempur",
    "officename": "Chakara Gosai SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "275101": {
    "state": "Uttar Pradesh",
    "district": "Mau",
    "block": "Sadar",
    "officename": "Mau HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "275102": {
    "state": "Uttar Pradesh",
    "district": "Mau",
    "block": "Maunath Bhanjan",
    "officename": "INDARA",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "275103": {
    "state": "Uttar Pradesh",
    "district": "Mau",
    "block": "Sadar",
    "officename": "Kushmaur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "275105": {
    "state": "Uttar Pradesh",
    "district": "Mau",
    "block": "Ghosi",
    "officename": "JAMALMIRZAPUR SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "275201": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Ghazipur",
    "officename": "Bahadurganj",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "275202": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Saidpur",
    "officename": "Dullahpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "275203": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Jakhania",
    "officename": "Jakhania SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "275204": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Zamania",
    "officename": "Sadat SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "275205": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Saidpur",
    "officename": "Shadiabad SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "275301": {
    "state": "Uttar Pradesh",
    "district": "Mau",
    "block": "Ghosi",
    "officename": "Amila SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "275302": {
    "state": "Uttar Pradesh",
    "district": "Mau",
    "block": "Ghosi",
    "officename": "Bhopaura SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "275303": {
    "state": "Uttar Pradesh",
    "district": "Mau",
    "block": "Ghosi",
    "officename": "Dohari  Ghat SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "275304": {
    "state": "Uttar Pradesh",
    "district": "Mau",
    "block": "Ghosi",
    "officename": "GHOSI SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "275305": {
    "state": "Uttar Pradesh",
    "district": "Mau",
    "block": "Sadar",
    "officename": "KOPAGANJ SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "275306": {
    "state": "Uttar Pradesh",
    "district": "Mau",
    "block": "Mohamda Bad Gohana",
    "officename": "KOIRIYAPAR SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "275307": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Azamgarh",
    "officename": "Semari Jamal Pur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276001": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Sadar",
    "officename": "Azamgarh HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276121": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Sagari",
    "officename": "Bilaria Ganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276122": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Sagari",
    "officename": "RAUNAPAR SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276123": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Lalganj",
    "officename": "Tarawa SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276124": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Sagari",
    "officename": "Ajamat Garh Estate SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276125": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Sadar",
    "officename": "Bankat SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276126": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Mehnagar",
    "officename": "Bansgaon SO Azamgarh",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276127": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Azamgarh",
    "officename": "Bazar Gosain SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276128": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Sadar",
    "officename": "CHANDESAR",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276129": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Sadar",
    "officename": "Chiraia Kot SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276131": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Sadar",
    "officename": "JAHANAGANJ SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276135": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Sadar",
    "officename": "KANDHARAPUR SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276136": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Sagari",
    "officename": "LATGHAT SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276137": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Azamgarh",
    "officename": "MAHARAJGANJ SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276138": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Sagari",
    "officename": "SAGRI SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276139": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Sagari",
    "officename": "Sardaha SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276140": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Sagari",
    "officename": "JIYANPUR SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276141": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Nizamabad",
    "officename": "Terahi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276142": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Budan Pur",
    "officename": "KOILSA SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276143": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Phoolpur",
    "officename": "MITTOOPUR",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276201": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Azamgarh",
    "officename": "DEOGAON SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276202": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Azamgarh",
    "officename": "LALGANJ SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276203": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Burhanpur",
    "officename": "MEHNAJPUR SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276204": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Nizamabad **",
    "officename": "MEHNAGAR SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276205": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Burhanpur",
    "officename": "MOHAMMADPUR SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276206": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Nizamabad",
    "officename": "NIZAMBAD SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276207": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Sadar",
    "officename": "RANI KI SARAI SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276208": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Nizamabad",
    "officename": "Tika Pur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276288": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Phool Pur",
    "officename": "PAWAI SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276301": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Phoolpur",
    "officename": "Bardah SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276302": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Lal Ganj",
    "officename": "GAMBHIRPUR SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276303": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Lal Ganj",
    "officename": "Thekma SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276304": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Phoolpur",
    "officename": "PHOOLPUR SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276305": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Nizamabad **",
    "officename": "Saraimeer SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276306": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Azamgarh",
    "officename": "Suraj Pur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276402": {
    "state": "Uttar Pradesh",
    "district": "Mau",
    "block": "M.b. Gohana",
    "officename": "KARAHA SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276403": {
    "state": "Uttar Pradesh",
    "district": "Mau",
    "block": "Mohammadabad Gohana",
    "officename": "Mohammadabad Gohna SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276404": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Sadar",
    "officename": "MUBARAKPUR SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276405": {
    "state": "Uttar Pradesh",
    "district": "Mau",
    "block": "Mohammadabad Gohana",
    "officename": "Walid Pur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "276406": {
    "state": "Uttar Pradesh",
    "district": "Azamgarh",
    "block": "Sadar",
    "officename": "Sathion SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Azamgarh Division"
  },
  "277001": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Ballia",
    "officename": "BALLIA HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "277121": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Ballia",
    "officename": "Garwar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "277123": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Ballia",
    "officename": "RATSAR SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "277124": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Sikandarour",
    "officename": "Pur SO Ballia",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "277201": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Bairia",
    "officename": "Bairia SO Ballia",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "277202": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Bansdih",
    "officename": "Bansdih SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "277203": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Ballia",
    "officename": "Bansdih Road SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "277204": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Bairia",
    "officename": "Dallan Chhapra SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "277205": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Bairia",
    "officename": "Dubey Chhapra SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "277207": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Sikanderpur",
    "officename": "Maniar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "277208": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Bairia",
    "officename": "Raniganj Bazar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "277209": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Bairia",
    "officename": "REOTI SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "277210": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Ballia",
    "officename": "Chhata SO Ballia",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "277211": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Bansdih",
    "officename": "Sahatwar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "277213": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Bansdih",
    "officename": "VBNarayanpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "277214": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Bairia",
    "officename": "Karanchhapa SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "277216": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Bairia",
    "officename": "Lalganj Ballia SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "277219": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Bansdih",
    "officename": "Kheosar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "277301": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Ballia",
    "officename": "Basantpur SO Ballia",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "277302": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Sikandarpur",
    "officename": "Kharasara SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "277303": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Sikandar Pur",
    "officename": "SIKANDERPUR SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "277304": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Bansdih",
    "officename": "SUKHPURA SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "277401": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Ballia",
    "officename": "Bharsar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "277402": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Bairia",
    "officename": "Haldi SO Ballia",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "277403": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Ballia",
    "officename": "Majhua SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "277501": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Ballia",
    "officename": "Korantadih SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "277502": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Ballia",
    "officename": "Narhi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "277503": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Ballia",
    "officename": "Phehpana SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "277504": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Ballia",
    "officename": "SOHAON SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "277506": {
    "state": "Uttar Pradesh",
    "district": "Ballia",
    "block": "Ballia",
    "officename": "Sagarpali SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ballia Division"
  },
  "281001": {
    "state": "Uttar Pradesh",
    "district": "Mathura",
    "block": "Mathura",
    "officename": "Mathura HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mathura Division"
  },
  "281003": {
    "state": "Uttar Pradesh",
    "district": "Mathura",
    "block": "Mathura",
    "officename": "Gayatri Tapo Bhoomi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mathura Division"
  },
  "281004": {
    "state": "Uttar Pradesh",
    "district": "Mathura",
    "block": "Mathura",
    "officename": "Krishna Nagar SO Mathura",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mathura Division"
  },
  "281005": {
    "state": "Uttar Pradesh",
    "district": "Mathura",
    "block": "Mathura",
    "officename": "Mathura Refinery SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mathura Division"
  },
  "281006": {
    "state": "Uttar Pradesh",
    "district": "Mathura",
    "block": "Mathura",
    "officename": "Refinery Nagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mathura Division"
  },
  "281104": {
    "state": "Uttar Pradesh",
    "district": "Hathras",
    "block": "Sadabad",
    "officename": "Jalesar RS SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mathura Division"
  },
  "281121": {
    "state": "Uttar Pradesh",
    "district": "Mathura",
    "block": "Mathura",
    "officename": "Vrindaban SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mathura Division"
  },
  "281122": {
    "state": "Uttar Pradesh",
    "district": "Mathura",
    "block": "Mathura",
    "officename": "Farah SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mathura Division"
  },
  "281123": {
    "state": "Uttar Pradesh",
    "district": "Mathura",
    "block": "Mathura",
    "officename": "Sonkh SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mathura Division"
  },
  "281201": {
    "state": "Uttar Pradesh",
    "district": "Mathura",
    "block": "Mant",
    "officename": "Bajna SO Mathura",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mathura Division"
  },
  "281202": {
    "state": "Uttar Pradesh",
    "district": "Mathura",
    "block": "Mant",
    "officename": "Mant SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mathura Division"
  },
  "281203": {
    "state": "Uttar Pradesh",
    "district": "Mathura",
    "block": "Mant",
    "officename": "Nauhjhil SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mathura Division"
  },
  "281204": {
    "state": "Uttar Pradesh",
    "district": "Mathura",
    "block": "Mathura",
    "officename": "Raya SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mathura Division"
  },
  "281205": {
    "state": "Uttar Pradesh",
    "district": "Mathura",
    "block": "Mant",
    "officename": "Surir SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mathura Division"
  },
  "281206": {
    "state": "Uttar Pradesh",
    "district": "Mathura",
    "block": "Mant",
    "officename": "Sonai SO Mathura",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mathura Division"
  },
  "281301": {
    "state": "Uttar Pradesh",
    "district": "Mathura",
    "block": "Mathura",
    "officename": "Baldeo SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mathura Division"
  },
  "281302": {
    "state": "Uttar Pradesh",
    "district": "Mathura",
    "block": "Sadabad",
    "officename": "Bisawar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mathura Division"
  },
  "281303": {
    "state": "Uttar Pradesh",
    "district": "Mathura",
    "block": "Mathura",
    "officename": "Gokul SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mathura Division"
  },
  "281305": {
    "state": "Uttar Pradesh",
    "district": "Mathura",
    "block": "Mathura",
    "officename": "Mahaban SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mathura Division"
  },
  "281306": {
    "state": "Uttar Pradesh",
    "district": "Hathras",
    "block": "Sadabad",
    "officename": "Sadabad SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mathura Division"
  },
  "281307": {
    "state": "Uttar Pradesh",
    "district": "Hathras",
    "block": "Sadabad",
    "officename": "Sahpau SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mathura Division"
  },
  "281308": {
    "state": "Uttar Pradesh",
    "district": "Mathura",
    "block": "Sadabad",
    "officename": "Jugasana SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mathura Division"
  },
  "281401": {
    "state": "Uttar Pradesh",
    "district": "Mathura",
    "block": "Chhata",
    "officename": "Chhata SO Mathura",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mathura Division"
  },
  "281403": {
    "state": "Uttar Pradesh",
    "district": "Mathura",
    "block": "Chhata",
    "officename": "Kosi Kalan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mathura Division"
  },
  "281404": {
    "state": "Uttar Pradesh",
    "district": "Mathura",
    "block": "Chhata",
    "officename": "Shergarh SO Mathura",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mathura Division"
  },
  "281405": {
    "state": "Uttar Pradesh",
    "district": "Mathura",
    "block": "Chhata",
    "officename": "Barsana SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mathura Division"
  },
  "281406": {
    "state": "Uttar Pradesh",
    "district": "Mathura",
    "block": "Chhata",
    "officename": "Chaumuhan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mathura Division"
  },
  "281501": {
    "state": "Uttar Pradesh",
    "district": "Mathura",
    "block": "Mathura",
    "officename": "Aring SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mathura Division"
  },
  "281502": {
    "state": "Uttar Pradesh",
    "district": "Mathura",
    "block": "Mathura",
    "officename": "Goverdhan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mathura Division"
  },
  "281504": {
    "state": "Uttar Pradesh",
    "district": "Mathura",
    "block": "Mathura",
    "officename": "Radhakund SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mathura Division"
  },
  "282001": {
    "state": "Uttar Pradesh",
    "district": "Agra",
    "block": "Etmadpur",
    "officename": "Agra HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Agra Division"
  },
  "282002": {
    "state": "Uttar Pradesh",
    "district": "Agra",
    "block": "Etmadpur",
    "officename": "SANJAY PLACE SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Agra Division"
  },
  "282003": {
    "state": "Uttar Pradesh",
    "district": "Agra",
    "block": "Etmadpur",
    "officename": "Agra Fort HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Agra Division"
  },
  "282004": {
    "state": "Uttar Pradesh",
    "district": "Agra",
    "block": "Etmadpur",
    "officename": "TAJ NAGRI",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Agra Division"
  },
  "282005": {
    "state": "Uttar Pradesh",
    "district": "Agra",
    "block": "Etmadpur",
    "officename": "Dayal Bagh",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Agra Division"
  },
  "282006": {
    "state": "Uttar Pradesh",
    "district": "Agra",
    "block": "Agra",
    "officename": "YAMUNA BRIDGE  SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Agra Division"
  },
  "282007": {
    "state": "Uttar Pradesh",
    "district": "Agra",
    "block": "Etmadpur",
    "officename": "SIKANDRA SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Agra Division"
  },
  "282008": {
    "state": "Uttar Pradesh",
    "district": "Agra",
    "block": "Etmadpur",
    "officename": "IAF SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Agra Division"
  },
  "282009": {
    "state": "Uttar Pradesh",
    "district": "Agra",
    "block": "Agra",
    "officename": "COD SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Agra Division"
  },
  "282010": {
    "state": "Uttar Pradesh",
    "district": "Agra",
    "block": "Etmadpur",
    "officename": "SHAHGANJ SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Agra Division"
  },
  "283101": {
    "state": "Uttar Pradesh",
    "district": "Agra",
    "block": "Etmadpur",
    "officename": "Achhnera SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Agra Division"
  },
  "283102": {
    "state": "Uttar Pradesh",
    "district": "Agra",
    "block": "Kiraoli",
    "officename": "Akola SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Agra Division"
  },
  "283103": {
    "state": "Uttar Pradesh",
    "district": "Firozabad",
    "block": "Firozabad",
    "officename": "Oef  Firozabad SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mainpuri Division"
  },
  "283104": {
    "state": "Uttar Pradesh",
    "district": "Agra",
    "block": "Etmadpur",
    "officename": "Bah SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Agra Division"
  },
  "283105": {
    "state": "Uttar Pradesh",
    "district": "Agra",
    "block": "Etmadpur",
    "officename": "BV Bichpuri SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Agra Division"
  },
  "283110": {
    "state": "Uttar Pradesh",
    "district": "Agra",
    "block": "Kiraoli",
    "officename": "Fatehpur Sikri",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Agra Division"
  },
  "283111": {
    "state": "Uttar Pradesh",
    "district": "Agra",
    "block": "Bah",
    "officename": "Fatehabad",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Agra Division"
  },
  "283112": {
    "state": "Uttar Pradesh",
    "district": "Agra",
    "block": "Kheragarh",
    "officename": "IRADAT NAGAR SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Agra Division"
  },
  "283113": {
    "state": "Uttar Pradesh",
    "district": "Agra",
    "block": "Agra",
    "officename": "Bhadrauli SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Agra Division"
  },
  "283114": {
    "state": "Uttar Pradesh",
    "district": "Agra",
    "block": "Bah",
    "officename": "JAITPUR SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Agra Division"
  },
  "283115": {
    "state": "Uttar Pradesh",
    "district": "Agra",
    "block": "Etmadpur",
    "officename": "JAGNER SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Agra Division"
  },
  "283119": {
    "state": "Uttar Pradesh",
    "district": "Agra",
    "block": "Kheragarh",
    "officename": "KAGROL SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Agra Division"
  },
  "283121": {
    "state": "Uttar Pradesh",
    "district": "Agra",
    "block": "Etmadpur",
    "officename": "KHERAGARH SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Agra Division"
  },
  "283122": {
    "state": "Uttar Pradesh",
    "district": "Agra",
    "block": "Etmadpur",
    "officename": "KIRAOLI SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Agra Division"
  },
  "283123": {
    "state": "Uttar Pradesh",
    "district": "Agra",
    "block": "Bah",
    "officename": "PINAHAT",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Agra Division"
  },
  "283124": {
    "state": "Uttar Pradesh",
    "district": "Agra",
    "block": "Etmadpur",
    "officename": "SAIYAN  SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Agra Division"
  },
  "283125": {
    "state": "Uttar Pradesh",
    "district": "Agra",
    "block": "Etmadpur",
    "officename": "SHAMSABAD SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Agra Division"
  },
  "283126": {
    "state": "Uttar Pradesh",
    "district": "Agra",
    "block": "Etmadpur",
    "officename": "KHANDAULI SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Agra Division"
  },
  "283130": {
    "state": "Uttar Pradesh",
    "district": "Firozabad",
    "block": "Jasarana",
    "officename": "Parham SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mainpuri Division"
  },
  "283135": {
    "state": "Uttar Pradesh",
    "district": "Firozabad",
    "block": "Shikohabad",
    "officename": "Shikohabad SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mainpuri Division"
  },
  "283136": {
    "state": "Uttar Pradesh",
    "district": "Firozabad",
    "block": "Jasrana",
    "officename": "Jasrana SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mainpuri Division"
  },
  "283141": {
    "state": "Uttar Pradesh",
    "district": "Firozabad",
    "block": "Shikohabad",
    "officename": "Shikohabad RS SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mainpuri Division"
  },
  "283142": {
    "state": "Uttar Pradesh",
    "district": "Firozabad",
    "block": "Jasarana",
    "officename": "Pariyar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mainpuri Division"
  },
  "283145": {
    "state": "Uttar Pradesh",
    "district": "Firozabad",
    "block": "Shikohabad",
    "officename": "Makkhanpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mainpuri Division"
  },
  "283151": {
    "state": "Uttar Pradesh",
    "district": "Firozabad",
    "block": "Shikohabad",
    "officename": "Sirsaganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mainpuri Division"
  },
  "283152": {
    "state": "Uttar Pradesh",
    "district": "Firozabad",
    "block": "Jasrana",
    "officename": "Eka SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mainpuri Division"
  },
  "283201": {
    "state": "Uttar Pradesh",
    "district": "Agra",
    "block": "Etmadpur",
    "officename": "Barhan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Agra Division"
  },
  "283202": {
    "state": "Uttar Pradesh",
    "district": "Agra",
    "block": "Etmadpur",
    "officename": "Etmadpur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Agra Division"
  },
  "283203": {
    "state": "Uttar Pradesh",
    "district": "Firozabad",
    "block": "Firozabad",
    "officename": "Firozabad HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mainpuri Division"
  },
  "283204": {
    "state": "Uttar Pradesh",
    "district": "Firozabad",
    "block": "Firozabad",
    "officename": "Tundla SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mainpuri Division"
  },
  "283205": {
    "state": "Uttar Pradesh",
    "district": "Firozabad",
    "block": "Firozabad",
    "officename": "Collectorate firozabad SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mainpuri Division"
  },
  "283206": {
    "state": "Uttar Pradesh",
    "district": "Firozabad",
    "block": "Shikohabad",
    "officename": "Kotla SO Firozabad",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mainpuri Division"
  },
  "283207": {
    "state": "Uttar Pradesh",
    "district": "Firozabad",
    "block": "Jasarana",
    "officename": "Phariha SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Mainpuri Division"
  },
  "284001": {
    "state": "Uttar Pradesh",
    "district": "Jhansi",
    "block": "Jhansi",
    "officename": "JHANSI HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "284002": {
    "state": "Uttar Pradesh",
    "district": "Jhansi",
    "block": "Jhansi",
    "officename": "Jhansi City SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "284003": {
    "state": "Uttar Pradesh",
    "district": "Jhansi",
    "block": "Jhansi",
    "officename": "Sipri Bazar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "284120": {
    "state": "Uttar Pradesh",
    "district": "Jhansi",
    "block": "Jhansi",
    "officename": "BHEL SO Jhansi",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "284121": {
    "state": "Uttar Pradesh",
    "district": "Jhansi",
    "block": "Jhansi",
    "officename": "Baragaon SO Jhansi",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "284122": {
    "state": "Uttar Pradesh",
    "district": "Lalitpur",
    "block": "Lalitpur",
    "officename": "Bansi SO Lalitpur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "284123": {
    "state": "Uttar Pradesh",
    "district": "Lalitpur",
    "block": "Lalitpur",
    "officename": "Barh SO Lalitpur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "284124": {
    "state": "Uttar Pradesh",
    "district": "Lalitpur",
    "block": "Lalitpur",
    "officename": "Jakhaura SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "284125": {
    "state": "Uttar Pradesh",
    "district": "Lalitpur",
    "block": "Lalitpur",
    "officename": "Lakeviewcamp SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "284126": {
    "state": "Uttar Pradesh",
    "district": "Lalitpur",
    "block": "Talbehat",
    "officename": "Talbehat SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "284127": {
    "state": "Uttar Pradesh",
    "district": "Jhansi",
    "block": "Jhansi",
    "officename": "Bhattagaon SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "284128": {
    "state": "Uttar Pradesh",
    "district": "Jhansi",
    "block": "Jhansi",
    "officename": "Mlb Medical College SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "284135": {
    "state": "Uttar Pradesh",
    "district": "Jhansi",
    "block": "Jhansi",
    "officename": "33 Bn Pac Jhansi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "284136": {
    "state": "Uttar Pradesh",
    "district": "Lalitpur",
    "block": "Talbehat",
    "officename": "Matatila SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "284201": {
    "state": "Uttar Pradesh",
    "district": "Jhansi",
    "block": "Jhansi",
    "officename": "Barwasagar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "284202": {
    "state": "Uttar Pradesh",
    "district": "Jhansi",
    "block": "Garautha",
    "officename": "Gursarai SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "284203": {
    "state": "Uttar Pradesh",
    "district": "Jhansi",
    "block": "Garautha",
    "officename": "Garautha SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "284204": {
    "state": "Uttar Pradesh",
    "district": "Jhansi",
    "block": "Jhansi",
    "officename": "Mauranipur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "284205": {
    "state": "Uttar Pradesh",
    "district": "Jhansi",
    "block": "Mauranipur",
    "officename": "Ranipur SO Jhansi",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "284206": {
    "state": "Uttar Pradesh",
    "district": "Jhansi",
    "block": "Jhansi",
    "officename": "Tori Fatehpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "284301": {
    "state": "Uttar Pradesh",
    "district": "Jhansi",
    "block": "Jhansi",
    "officename": "Chirgaon SO Jhansi",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "284302": {
    "state": "Uttar Pradesh",
    "district": "Jhansi",
    "block": "Jhansi",
    "officename": "Erich SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "284303": {
    "state": "Uttar Pradesh",
    "district": "Jhansi",
    "block": "Moth",
    "officename": "Moth SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "284304": {
    "state": "Uttar Pradesh",
    "district": "Jhansi",
    "block": "Jhansi",
    "officename": "Samthar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "284305": {
    "state": "Uttar Pradesh",
    "district": "Jhansi",
    "block": "Jhansi",
    "officename": "Parichha Thermal Power Project SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "284306": {
    "state": "Uttar Pradesh",
    "district": "Jhansi",
    "block": "Moth",
    "officename": "Poonchh SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "284401": {
    "state": "Uttar Pradesh",
    "district": "Jhansi",
    "block": "Jhansi",
    "officename": "Babina Cantt SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "284402": {
    "state": "Uttar Pradesh",
    "district": "Lalitpur",
    "block": "Mahroni",
    "officename": "Banpur SO Lalitpur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "284403": {
    "state": "Uttar Pradesh",
    "district": "Lalitpur",
    "block": "Talbehat",
    "officename": "LALITPUR HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "284404": {
    "state": "Uttar Pradesh",
    "district": "Lalitpur",
    "block": "Talbehat",
    "officename": "Madawra SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "284405": {
    "state": "Uttar Pradesh",
    "district": "Lalitpur",
    "block": "Mahroni",
    "officename": "Mahroni SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "284406": {
    "state": "Uttar Pradesh",
    "district": "Lalitpur",
    "block": "Mahroni",
    "officename": "Narahat SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "284419": {
    "state": "Uttar Pradesh",
    "district": "Jhansi",
    "block": "Jhansi",
    "officename": "Raksa SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "284501": {
    "state": "Uttar Pradesh",
    "district": "Lalitpur",
    "block": "Lalitpur",
    "officename": "Rajghat Dam Project SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "285001": {
    "state": "Uttar Pradesh",
    "district": "Jalaun",
    "block": "Orai",
    "officename": "ORAI HO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "285121": {
    "state": "Uttar Pradesh",
    "district": "Jalaun",
    "block": "Jalaun",
    "officename": "Bangra SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "285122": {
    "state": "Uttar Pradesh",
    "district": "Jalaun",
    "block": "Orai",
    "officename": "Dakore SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "285123": {
    "state": "Uttar Pradesh",
    "district": "Jalaun",
    "block": "Jalaun",
    "officename": "Jalaun SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "285124": {
    "state": "Uttar Pradesh",
    "district": "Jalaun",
    "block": "Jalaun",
    "officename": "Jagammanpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "285125": {
    "state": "Uttar Pradesh",
    "district": "Jalaun",
    "block": "Madhogarh",
    "officename": "Kuthond SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "285126": {
    "state": "Uttar Pradesh",
    "district": "Jalaun",
    "block": "Madhogarh",
    "officename": "Madhogarh SO Jalaun",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "285127": {
    "state": "Uttar Pradesh",
    "district": "Jalaun",
    "block": "Madhogarh",
    "officename": "Rampura SO Jalaun",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "285128": {
    "state": "Uttar Pradesh",
    "district": "Jalaun",
    "block": "Jalaun",
    "officename": "Hadrukh SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "285129": {
    "state": "Uttar Pradesh",
    "district": "Jalaun",
    "block": "Madhogarh",
    "officename": "Umri SO Jalaun",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "285130": {
    "state": "Uttar Pradesh",
    "district": "Jalaun",
    "block": "Madhogarh",
    "officename": "Madaripur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "285201": {
    "state": "Uttar Pradesh",
    "district": "Jalaun",
    "block": "Konch",
    "officename": "Ait SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "285202": {
    "state": "Uttar Pradesh",
    "district": "Jalaun",
    "block": "Orai",
    "officename": "Ata SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "285203": {
    "state": "Uttar Pradesh",
    "district": "Jalaun",
    "block": "Kalpi",
    "officename": "Baoni Estate SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "285204": {
    "state": "Uttar Pradesh",
    "district": "Jalaun",
    "block": "Kalpi",
    "officename": "Kalpi SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "285205": {
    "state": "Uttar Pradesh",
    "district": "Jalaun",
    "block": "Konch",
    "officename": "Konch SO Jalaun",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "285206": {
    "state": "Uttar Pradesh",
    "district": "Jalaun",
    "block": "Konch",
    "officename": "Nadigaon SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "285223": {
    "state": "Uttar Pradesh",
    "district": "Jalaun",
    "block": "Konch",
    "officename": "Kotra SO Jalaun",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Jhansi Division"
  },
  "301001": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Alwar",
    "officename": "Alwar H.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301018": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Tijara",
    "officename": "Khazuri Bass S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301019": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Tijara",
    "officename": "Bhiwari Ind. Area. Alwar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301020": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Bahror",
    "officename": "Barrod S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301021": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Laxaman Garh",
    "officename": "Barodameo S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301022": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Thanagazi",
    "officename": "Thanagazi S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301023": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Alwar",
    "officename": "Vijay Mandir S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301024": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Thanagazi",
    "officename": "Narainpur S.O (Alwar)",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301025": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Ramgarh",
    "officename": "Nogaon S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301026": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Ramgarh",
    "officename": "Ramgarh S.O (Alwar)",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301027": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Tana Gazi",
    "officename": "Pratap Garh S.O (Alwar)",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301028": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Alwar",
    "officename": "Bahadurpur S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301030": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Alwar",
    "officename": "Matasya Ind. Area S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301035": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Rajgarh",
    "officename": "Ronijathan S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301401": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Alwar",
    "officename": "Ajerka S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301402": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Bansur",
    "officename": "Bansur S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301403": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Mandawar",
    "officename": "Harsauli S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301404": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Mandawar",
    "officename": "Khairthal S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301405": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Kishan Garh",
    "officename": "Kishan Garh Bass S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301406": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Alwar",
    "officename": "Malakhera S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301407": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Mandawar",
    "officename": "Mandawar S.O (Alwar)",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301408": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Rajgarh",
    "officename": "Rajgarh (Alwar) S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301409": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Rajgarh",
    "officename": "Reni S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301410": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Rajgarh",
    "officename": "Tehla S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301411": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Tizara",
    "officename": "Tizara S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301412": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Mandawar",
    "officename": "Harsora S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301413": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Rajgarh",
    "officename": "Garhi Sawai Ram S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301414": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Rajgarh",
    "officename": "Dhigawara S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301415": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Rajgarh",
    "officename": "Rajpur S.O (Alwar)",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301416": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Bansur",
    "officename": "Rampur S.O (Alwar)",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301427": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Mandawar",
    "officename": "Karni Kot S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301604": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Laxmzn Garh",
    "officename": "Govind Garh Alwar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301701": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Bahror",
    "officename": "Bahror H.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301702": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Kishan Garh Bass",
    "officename": "Kotkassim S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301703": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Bahror",
    "officename": "Majari Kalan S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301704": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Neemrana",
    "officename": "Mandhan S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301705": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Neemrana",
    "officename": "Neemrana S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301706": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Neemrana",
    "officename": "Shahjahanpur S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301707": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Tizara",
    "officename": "Tapukara S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301708": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Mandawar",
    "officename": "Kutina S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301709": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Bahror",
    "officename": "Gandala S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301713": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Bahror",
    "officename": "Jakhrana S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "301714": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Bahror",
    "officename": "Bahror Jat S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "302001": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Jaipur G.P.O.",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur City Division"
  },
  "302002": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Tripolia Bazar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur City Division"
  },
  "302003": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Jaipur City S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur City Division"
  },
  "302004": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Jawahar Nagar H.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur City Division"
  },
  "302005": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Rajasthan Secretariate S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur City Division"
  },
  "302006": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Jaipur R.S. S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur City Division"
  },
  "302012": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Jhotwara S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur City Division"
  },
  "302013": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Vishwakarma Industrial Area S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur City Division"
  },
  "302015": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Gandhi Nagar S.O (Jaipur)",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur City Division"
  },
  "302016": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Shastri Nagar H.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur City Division"
  },
  "302017": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Malviya Nagar S.O (Jaipur)",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur City Division"
  },
  "302018": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Durgapura S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur City Division"
  },
  "302019": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Shyam Nagar S.O (Jaipur)",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur City Division"
  },
  "302020": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Mansarovar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur City Division"
  },
  "302021": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Vaishali Nagar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur City Division"
  },
  "302022": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Sanganer",
    "officename": "Sitapura Industrial Area S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur City Division"
  },
  "302026": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Bhankrota S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur City Division"
  },
  "302027": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Amer",
    "officename": "Crpf Campus  Lalwas S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur City Division"
  },
  "302028": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Amer",
    "officename": "Amer S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur City Division"
  },
  "302029": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Sanganer",
    "officename": "Sanganer Bazar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur City Division"
  },
  "302031": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Jamdoli S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur City Division"
  },
  "302033": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Pratap Nagar Sector 11 S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur City Division"
  },
  "302034": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Panchyawala S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur City Division"
  },
  "302037": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Sanganer",
    "officename": "Mahindra World City S.O (Jaipur)",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur City Division"
  },
  "302039": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Murlipura S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur City Division"
  },
  "303001": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Andhi SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303002": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Achrol SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303003": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Med SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303004": {
    "state": "Rajasthan",
    "district": "Dausa",
    "block": "Dausa",
    "officename": "Lawain SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303005": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Phagi SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303006": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Madhorajpura SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303007": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Bagru SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303008": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Dudu SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303009": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Mozmabad SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303012": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Kanota SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303102": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Virat Nagar SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303103": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Shahpura HO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303104": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Manoharpur SO Jaipur",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303105": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Nareda SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303106": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "PaotaJaipur SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303107": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Pragpura SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303108": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Kotputli SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303109": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Jamwaramgarh SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303110": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Rajnauta SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303119": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Bhabroo SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303120": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Gathwadi SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303121": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Amer",
    "officename": "NIMS University SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303122": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Vedaant Gyan Valley SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303301": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Bassi SO Jaipur",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303302": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Dausa",
    "officename": "Toonga SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303303": {
    "state": "Rajasthan",
    "district": "Dausa",
    "block": "Dausa",
    "officename": "Dausa HO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303304": {
    "state": "Rajasthan",
    "district": "Dausa",
    "block": "Dausa",
    "officename": "Dubbi SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303305": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Banskho SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303313": {
    "state": "Rajasthan",
    "district": "Dausa",
    "block": "Dausa",
    "officename": "Bandikui SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303315": {
    "state": "Rajasthan",
    "district": "Dausa",
    "block": "Dausa",
    "officename": "Bewai SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303323": {
    "state": "Rajasthan",
    "district": "Dausa",
    "block": "Dausa",
    "officename": "Gudha Katla SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303325": {
    "state": "Rajasthan",
    "district": "Dausa",
    "block": "Dausa",
    "officename": "Kundal SO Dausa",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303326": {
    "state": "Rajasthan",
    "district": "Dausa",
    "block": "Dausa",
    "officename": "Sikandra SO Dausa",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303327": {
    "state": "Rajasthan",
    "district": "Dausa",
    "block": "Dausa",
    "officename": "Baswa SO Dausa",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303328": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Jobner SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303329": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "A C Jobner SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303338": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Phulera SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303348": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Naraina SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303501": {
    "state": "Rajasthan",
    "district": "Dausa",
    "block": "Dausa",
    "officename": "Bhandarej SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303502": {
    "state": "Rajasthan",
    "district": "Dausa",
    "block": "Dausa",
    "officename": "Geejgarh SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303503": {
    "state": "Rajasthan",
    "district": "Dausa",
    "block": "Dausa",
    "officename": "Lalsot SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303504": {
    "state": "Rajasthan",
    "district": "Dausa",
    "block": "Dausa",
    "officename": "Mandawari SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303505": {
    "state": "Rajasthan",
    "district": "Dausa",
    "block": "Dausa",
    "officename": "Nangal Rajawatan SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303506": {
    "state": "Rajasthan",
    "district": "Dausa",
    "block": "Dausa",
    "officename": "Paparda SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303507": {
    "state": "Rajasthan",
    "district": "Dausa",
    "block": "Dausa",
    "officename": "Sainthal SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303508": {
    "state": "Rajasthan",
    "district": "Dausa",
    "block": "Dausa",
    "officename": "Sikrai SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303509": {
    "state": "Rajasthan",
    "district": "Dausa",
    "block": "Dausa",
    "officename": "Manpur SO Dausa",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303510": {
    "state": "Rajasthan",
    "district": "Dausa",
    "block": "Dausa",
    "officename": "Ramgarh Pachwara SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303511": {
    "state": "Rajasthan",
    "district": "Dausa",
    "block": "Dausa",
    "officename": "Didwana SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303601": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Amarsar SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303602": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Badhal SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303603": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Renwal SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303604": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Sambhar Lake HO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303701": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Jahota SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303702": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Chomu SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303704": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Jaitpura I A SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303706": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Kalwad SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303712": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Govindgarh SO Jaipur",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303801": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Kaladera SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303803": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Khejroli SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303804": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Etwa Bhopji SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303805": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Morija SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303806": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Samod SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303807": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Udaipuria SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303901": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Chaksu SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303903": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Shivdaspura SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303904": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Chittora Renwal SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303905": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Watika SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303908": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur",
    "officename": "Kotkhawada SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "304001": {
    "state": "Rajasthan",
    "district": "Tonk",
    "block": "Tonk",
    "officename": "Tonk Raj H.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Tonk Division"
  },
  "304021": {
    "state": "Rajasthan",
    "district": "Tonk",
    "block": "Tonk",
    "officename": "Newai S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Tonk Division"
  },
  "304022": {
    "state": "Rajasthan",
    "district": "Tonk",
    "block": "Tonk",
    "officename": "Banasthali Vidya Peeth S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Tonk Division"
  },
  "304023": {
    "state": "Rajasthan",
    "district": "Tonk",
    "block": "Tonk",
    "officename": "Aligarh S.O (Tonk)",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Tonk Division"
  },
  "304024": {
    "state": "Rajasthan",
    "district": "Tonk",
    "block": "Tonk",
    "officename": "Uniara S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Tonk Division"
  },
  "304025": {
    "state": "Rajasthan",
    "district": "Tonk",
    "block": "Tonk",
    "officename": "Jhilai S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Tonk Division"
  },
  "304501": {
    "state": "Rajasthan",
    "district": "Tonk",
    "block": "Tonk",
    "officename": "Avikanagar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Tonk Division"
  },
  "304502": {
    "state": "Rajasthan",
    "district": "Tonk",
    "block": "Tonk",
    "officename": "Malpura S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Tonk Division"
  },
  "304503": {
    "state": "Rajasthan",
    "district": "Tonk",
    "block": "Tonk",
    "officename": "Lambaharisingh S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Tonk Division"
  },
  "304504": {
    "state": "Rajasthan",
    "district": "Tonk",
    "block": "Tonk",
    "officename": "Diggi S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Tonk Division"
  },
  "304505": {
    "state": "Rajasthan",
    "district": "Tonk",
    "block": "Tonk",
    "officename": "Todarai Singh S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Tonk Division"
  },
  "304507": {
    "state": "Rajasthan",
    "district": "Tonk",
    "block": "Tonk",
    "officename": "Nasirda S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Tonk Division"
  },
  "304801": {
    "state": "Rajasthan",
    "district": "Tonk",
    "block": "Tonk",
    "officename": "Peeplu S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Tonk Division"
  },
  "304802": {
    "state": "Rajasthan",
    "district": "Tonk",
    "block": "Tonk",
    "officename": "Duni S.O (Tonk)",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Tonk Division"
  },
  "304803": {
    "state": "Rajasthan",
    "district": "Tonk",
    "block": "Tonk",
    "officename": "Panwar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Tonk Division"
  },
  "304804": {
    "state": "Rajasthan",
    "district": "Tonk",
    "block": "Tonk",
    "officename": "Deoli S.O (Tonk)",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Tonk Division"
  },
  "305001": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Ajmer",
    "officename": "Ajmer H.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Ajmer Division"
  },
  "305002": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Ajmer",
    "officename": "Ie Makhu Pura Ajmer S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Ajmer Division"
  },
  "305003": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Ajmer",
    "officename": "Hmt Ajmer Dtso S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Ajmer Division"
  },
  "305004": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Ajmer",
    "officename": "Regional College Ajmer S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Ajmer Division"
  },
  "305005": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Ajmer",
    "officename": "Crpf Ajmer S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Ajmer Division"
  },
  "305007": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Ajmer",
    "officename": "Gc Road Ajmer S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Ajmer Division"
  },
  "305009": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Ajmer",
    "officename": "Mds University Ajmer S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Ajmer Division"
  },
  "305012": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Ajmer",
    "officename": "Mss Hatundi S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Ajmer Division"
  },
  "305021": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Ajmer",
    "officename": "Karel S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Ajmer Division"
  },
  "305022": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Ajmer",
    "officename": "Pushkar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Ajmer Division"
  },
  "305023": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Ajmer",
    "officename": "Gagwana S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Ajmer Division"
  },
  "305024": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Ajmer",
    "officename": "Maday S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Ajmer Division"
  },
  "305025": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Ajmer",
    "officename": "Srinagar S.O (Ajmer)",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Ajmer Division"
  },
  "305026": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Merta",
    "officename": "Thanwala S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "305201": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Pisangan",
    "officename": "Govind Garh S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Beawar Division"
  },
  "305202": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Beawar",
    "officename": "Kharwa S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Beawar Division"
  },
  "305203": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Beawar",
    "officename": "Mangliawas S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Beawar Division"
  },
  "305204": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Beawar",
    "officename": "Pisangan S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Beawar Division"
  },
  "305205": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Ajmer",
    "officename": "Raj Garh (Ajmer) S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Ajmer Division"
  },
  "305206": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Ajmer",
    "officename": "Saradhana S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Ajmer Division"
  },
  "305207": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Beawar",
    "officename": "Jethana S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Beawar Division"
  },
  "305401": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Nasirabad",
    "officename": "Bhwani Khera S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Beawar Division"
  },
  "305402": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Nasirabad",
    "officename": "Ramsar S.O (Ajmer)",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Beawar Division"
  },
  "305403": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Sarwar",
    "officename": "Sarwar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Beawar Division"
  },
  "305404": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Kekri",
    "officename": "Kekri S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Beawar Division"
  },
  "305405": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Kekri",
    "officename": "Kadera S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Beawar Division"
  },
  "305406": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Nasirabad",
    "officename": "Junia S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Beawar Division"
  },
  "305407": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Kekri",
    "officename": "Sawar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Beawar Division"
  },
  "305408": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Kekri",
    "officename": "PARA S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Beawar Division"
  },
  "305412": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Nasirabad",
    "officename": "Fathegarh S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Beawar Division"
  },
  "305415": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Nasirabad",
    "officename": "Baghera S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Beawar Division"
  },
  "305601": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Nasirabad",
    "officename": "Nasirabad H.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Beawar Division"
  },
  "305621": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Nasirabad",
    "officename": "Bandanwara S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Beawar Division"
  },
  "305622": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Bhinai",
    "officename": "Bhinai S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Beawar Division"
  },
  "305623": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Beawar",
    "officename": "Masuda S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Beawar Division"
  },
  "305624": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Nasirabad",
    "officename": "Bijainagar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Beawar Division"
  },
  "305625": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Nasirabad",
    "officename": "Jalia  II S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Beawar Division"
  },
  "305627": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Nasirabad",
    "officename": "Tantoti S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Beawar Division"
  },
  "305628": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Bhinai",
    "officename": "Nagola S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Beawar Division"
  },
  "305629": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Bhinai",
    "officename": "Champaneri S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Beawar Division"
  },
  "305630": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Beawar",
    "officename": "Jamola S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Beawar Division"
  },
  "305801": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Kishangarh",
    "officename": "Madanganj Kishangarh H.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Ajmer Division"
  },
  "305802": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Kishangarh",
    "officename": "Kishangarh City S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Ajmer Division"
  },
  "305811": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Ajmer",
    "officename": "Kuchil S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Ajmer Division"
  },
  "305812": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Kishan Garh",
    "officename": "Harmara S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Ajmer Division"
  },
  "305813": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Kishangarh",
    "officename": "Arain S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Ajmer Division"
  },
  "305814": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Kishan Garh",
    "officename": "Roopnagar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Ajmer Division"
  },
  "305815": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Kishan Garh",
    "officename": "Salemabad S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Ajmer Division"
  },
  "305816": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Kishangarh",
    "officename": "Tiloniya S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Ajmer Division"
  },
  "305817": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Kishangarh",
    "officename": "Central University of Rajasthan S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Ajmer Division"
  },
  "305819": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Kishangarh",
    "officename": "Karkeri S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Ajmer Division"
  },
  "305901": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Beawar",
    "officename": "Beawar (Raj) H.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Beawar Division"
  },
  "305921": {
    "state": "Rajasthan",
    "district": "Rajsamand",
    "block": "Rajsamand",
    "officename": "Bhim S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "305922": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Beawar",
    "officename": "Jawaja S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Beawar Division"
  },
  "305923": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Beawar",
    "officename": "Lotiyana S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Beawar Division"
  },
  "305924": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Beawar",
    "officename": "Todgarh S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Beawar Division"
  },
  "305925": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Bewar",
    "officename": "Rajiawas S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Beawar Division"
  },
  "305926": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Beawar",
    "officename": "Barakhera S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Beawar Division"
  },
  "305927": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Beawar",
    "officename": "Kabra S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Beawar Division"
  },
  "306001": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Marwar Jn.",
    "officename": "Marwar Jn. H.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306021": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Marwar Jn.",
    "officename": "Auwa S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306022": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Marwar Jn.",
    "officename": "Jojawar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306023": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Marwar Jn.",
    "officename": "Ranawas S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306101": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Jaitaran",
    "officename": "Babra S.O (Pali)",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306102": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Raipur  Mwr",
    "officename": "Sendra S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306103": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Sojat",
    "officename": "Sojat  Road S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306104": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Sojat",
    "officename": "Sojat S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306105": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Raipur",
    "officename": "Bar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306114": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Sojat",
    "officename": "Bagri Nagar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306115": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Desuri",
    "officename": "Rani S.O (Pali)",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306116": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Marwar Jn.",
    "officename": "Falna S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306119": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Pali Mwr",
    "officename": "Khod S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306126": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Marwar Jn.",
    "officename": "Jawai  Bandh S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306301": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Jetaran",
    "officename": "Anandpur Kalu S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306302": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Jaitaran",
    "officename": "Jaitaran S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306303": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Jaitaran",
    "officename": "Nimaj S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306304": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Raipur",
    "officename": "Raipur  Marwar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306305": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Raipur",
    "officename": "Kushalpura S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306306": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Sojat",
    "officename": "Chandawal S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306307": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Raipur",
    "officename": "Pipliya Kalan S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306308": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Jaitaran",
    "officename": "Balunda S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306401": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Pali Mwr",
    "officename": "Pali Marwar H.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306421": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Rohat",
    "officename": "Rohat S.O (Pali)",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306422": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Pali Mwr",
    "officename": "Gundoj S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306501": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Marwar Jn.",
    "officename": "Khairwa S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306502": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Desuri",
    "officename": "Khinwara S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306503": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Desuri",
    "officename": "Somesar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306504": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Bali",
    "officename": "Nana S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306601": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Desuri",
    "officename": "Bijowa S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306602": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Sumerpur",
    "officename": "Chanod S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306603": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Desuri",
    "officename": "Nadol S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306701": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Bali",
    "officename": "Bali S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306702": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Desuri",
    "officename": "Sadri S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306703": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Desuri",
    "officename": "Desuri S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306704": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Bali",
    "officename": "Ghanerao S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306705": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Bali",
    "officename": "Mundara S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306706": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Bali",
    "officename": "Lunawa S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306707": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Bali",
    "officename": "Sewari S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306708": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Sumerpur",
    "officename": "Sanderao S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306709": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Jaitaran",
    "officename": "Dlf Rabriyawas S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306901": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Sumerpur",
    "officename": "Bankli S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306902": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Sumerpur",
    "officename": "Sumerpur S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "306912": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Sumerpur",
    "officename": "Tagatgarh S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "307001": {
    "state": "Rajasthan",
    "district": "Sirohi",
    "block": "Sirohi",
    "officename": "Sirohi H.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "307019": {
    "state": "Rajasthan",
    "district": "Sirohi",
    "block": "Pindwara",
    "officename": "Jkpuram S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "307022": {
    "state": "Rajasthan",
    "district": "Sirohi",
    "block": "Pindwara",
    "officename": "Pindwara S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "307023": {
    "state": "Rajasthan",
    "district": "Sirohi",
    "block": "Pindwara",
    "officename": "Sarupganj S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "307024": {
    "state": "Rajasthan",
    "district": "Sirohi",
    "block": "Pindwara",
    "officename": "Rohida S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "307025": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Kotra",
    "officename": "Kotra S.O (Udaipur)",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "307026": {
    "state": "Rajasthan",
    "district": "Sirohi",
    "block": "Abu Road",
    "officename": "Aburoad S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "307027": {
    "state": "Rajasthan",
    "district": "Sirohi",
    "block": "Pindwara",
    "officename": "Sheoganj S.O (Sirohi)",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "307028": {
    "state": "Rajasthan",
    "district": "Sirohi",
    "block": "Pindwara",
    "officename": "Posalia S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "307029": {
    "state": "Rajasthan",
    "district": "Jalor",
    "block": "Ahore",
    "officename": "Ahore S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "307030": {
    "state": "Rajasthan",
    "district": "Jalor",
    "block": "Ahore",
    "officename": "Gudabalotan S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "307031": {
    "state": "Rajasthan",
    "district": "Sirohi",
    "block": "Pindwara",
    "officename": "Adityanagar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "307043": {
    "state": "Rajasthan",
    "district": "Sirohi",
    "block": "Pindwara",
    "officename": "Palri M S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "307501": {
    "state": "Rajasthan",
    "district": "Sirohi",
    "block": "Aburoad",
    "officename": "Abu S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "307510": {
    "state": "Rajasthan",
    "district": "Sirohi",
    "block": "Pindwara",
    "officename": "Shantivan S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "307511": {
    "state": "Rajasthan",
    "district": "Sirohi",
    "block": "Reodar",
    "officename": "Anadra S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "307512": {
    "state": "Rajasthan",
    "district": "Sirohi",
    "block": "Pindwara",
    "officename": "Dantrai S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "307513": {
    "state": "Rajasthan",
    "district": "Sirohi",
    "block": "Pindwara",
    "officename": "Mandar S.O (Sirohi)",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "307514": {
    "state": "Rajasthan",
    "district": "Sirohi",
    "block": "Pindwara",
    "officename": "Reodar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "307515": {
    "state": "Rajasthan",
    "district": "Jalor",
    "block": "Ahore",
    "officename": "Jaswantpura S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "307801": {
    "state": "Rajasthan",
    "district": "Sirohi",
    "block": "Pindwara",
    "officename": "Jawal S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "307802": {
    "state": "Rajasthan",
    "district": "Sirohi",
    "block": "Pindwara",
    "officename": "Kalandari S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "307803": {
    "state": "Rajasthan",
    "district": "Jalor",
    "block": "Ahore",
    "officename": "Ramseen S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "311001": {
    "state": "Rajasthan",
    "district": "Bhilwara",
    "block": "Bhilwara",
    "officename": "Bhilwara H.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Bhilwara Division"
  },
  "311011": {
    "state": "Rajasthan",
    "district": "Bhilwara",
    "block": "Bhilwara",
    "officename": "Suwana S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Bhilwara Division"
  },
  "311021": {
    "state": "Rajasthan",
    "district": "Bhilwara",
    "block": "Bhilwara",
    "officename": "Gulabpura S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Bhilwara Division"
  },
  "311022": {
    "state": "Rajasthan",
    "district": "Bhilwara",
    "block": "Bhilwara",
    "officename": "Hurda S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Bhilwara Division"
  },
  "311023": {
    "state": "Rajasthan",
    "district": "Bhilwara",
    "block": "Bhilwara",
    "officename": "Kothian S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Bhilwara Division"
  },
  "311024": {
    "state": "Rajasthan",
    "district": "Bhilwara",
    "block": "Bhilwara",
    "officename": "Railagaon S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Bhilwara Division"
  },
  "311025": {
    "state": "Rajasthan",
    "district": "Bhilwara",
    "block": "Bhilwara",
    "officename": "Hamirgarh S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Bhilwara Division"
  },
  "311026": {
    "state": "Rajasthan",
    "district": "Bhilwara",
    "block": "Bhilwara",
    "officename": "Mod Ka Nimbahera S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Bhilwara Division"
  },
  "311030": {
    "state": "Rajasthan",
    "district": "Bhilwara",
    "block": "Bhilwara",
    "officename": "Rupaheli S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Bhilwara Division"
  },
  "311201": {
    "state": "Rajasthan",
    "district": "Bhilwara",
    "block": "Bhilwara",
    "officename": "Jahazpur S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Bhilwara Division"
  },
  "311202": {
    "state": "Rajasthan",
    "district": "Bhilwara",
    "block": "Bhilwara",
    "officename": "Pander S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Bhilwara Division"
  },
  "311203": {
    "state": "Rajasthan",
    "district": "Bhilwara",
    "block": "Bhilwara",
    "officename": "Piplund S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Bhilwara Division"
  },
  "311204": {
    "state": "Rajasthan",
    "district": "Bhilwara",
    "block": "Bhilwara",
    "officename": "Shambhugarh S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Bhilwara Division"
  },
  "311301": {
    "state": "Rajasthan",
    "district": "Bhilwara",
    "block": "Bhilwara",
    "officename": "Asind S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Bhilwara Division"
  },
  "311302": {
    "state": "Rajasthan",
    "district": "Bhilwara",
    "block": "Bhilwara",
    "officename": "Badnore S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Bhilwara Division"
  },
  "311401": {
    "state": "Rajasthan",
    "district": "Bhilwara",
    "block": "Bhilwara",
    "officename": "Banera S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Bhilwara Division"
  },
  "311402": {
    "state": "Rajasthan",
    "district": "Bhilwara",
    "block": "Bhilwara",
    "officename": "Bagore S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Bhilwara Division"
  },
  "311403": {
    "state": "Rajasthan",
    "district": "Bhilwara",
    "block": "Bhilwara",
    "officename": "Mandal S.O (Bhilwara)",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Bhilwara Division"
  },
  "311404": {
    "state": "Rajasthan",
    "district": "Bhilwara",
    "block": "Bhilwara",
    "officename": "Shahpura Raj S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Bhilwara Division"
  },
  "311407": {
    "state": "Rajasthan",
    "district": "Bhilwara",
    "block": "Bhilwara",
    "officename": "Phulia Kalan S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Bhilwara Division"
  },
  "311408": {
    "state": "Rajasthan",
    "district": "Bhilwara",
    "block": "Bhilwara",
    "officename": "Upreda S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Bhilwara Division"
  },
  "311601": {
    "state": "Rajasthan",
    "district": "Bhilwara",
    "block": "Bhilwara",
    "officename": "Bigod S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Bhilwara Division"
  },
  "311602": {
    "state": "Rajasthan",
    "district": "Bhilwara",
    "block": "Bhilwara",
    "officename": "Bijolian S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Bhilwara Division"
  },
  "311603": {
    "state": "Rajasthan",
    "district": "Bhilwara",
    "block": "Bhilwara",
    "officename": "Kotri S.O (Bhilwara)",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Bhilwara Division"
  },
  "311604": {
    "state": "Rajasthan",
    "district": "Bhilwara",
    "block": "Bhilwara",
    "officename": "Mandalgarh S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Bhilwara Division"
  },
  "311605": {
    "state": "Rajasthan",
    "district": "Bhilwara",
    "block": "Bhilwara",
    "officename": "Kachola S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Bhilwara Division"
  },
  "311801": {
    "state": "Rajasthan",
    "district": "Bhilwara",
    "block": "Bhilwara",
    "officename": "Gangapur (Bhilwara) S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Bhilwara Division"
  },
  "311802": {
    "state": "Rajasthan",
    "district": "Bhilwara",
    "block": "Bhilwara",
    "officename": "Pur S.O (Bhilwara)",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Bhilwara Division"
  },
  "311803": {
    "state": "Rajasthan",
    "district": "Bhilwara",
    "block": "Bhilwara",
    "officename": "Raipur S.O (Bhilwara)",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Bhilwara Division"
  },
  "311804": {
    "state": "Rajasthan",
    "district": "Bhilwara",
    "block": "Bhilwara",
    "officename": "Raja Ji Ka Kareda S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Bhilwara Division"
  },
  "311805": {
    "state": "Rajasthan",
    "district": "Bhilwara",
    "block": "Bhilwara",
    "officename": "Koshithal S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Bhilwara Division"
  },
  "311806": {
    "state": "Rajasthan",
    "district": "Bhilwara",
    "block": "Bhilwara",
    "officename": "Sahada S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Bhilwara Division"
  },
  "312001": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Chittorgah",
    "officename": "Chittorgarh H.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312021": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Chittorgarh",
    "officename": "Cement Factory S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312022": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Chittorgah",
    "officename": "Bassi S.O (Chittorgarh)",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312023": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Begun",
    "officename": "Begun S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312024": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Bhadesar",
    "officename": "Bhadsaura S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312025": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Chittorgarh",
    "officename": "Senthi S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312027": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Bhadesar",
    "officename": "Mandfia S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312201": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Chittorgarh",
    "officename": "Gosunda S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312202": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Kapasan",
    "officename": "Kapasan S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312203": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Rashmi",
    "officename": "Rashmi S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312204": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Bhupalsagar",
    "officename": "Bhoopal sagar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312205": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Bhupalsagar",
    "officename": "Akola S.O (Chittorgarh)",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312206": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Rashmi",
    "officename": "Pahuna S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312207": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Kapasan",
    "officename": "Singhpur S.O (Chittorgarh)",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312401": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Bari Sadari",
    "officename": "Bansi S.O (Chittorgarh)",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312402": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Doongla",
    "officename": "Doongla S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312403": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Barisadari",
    "officename": "Barisadari S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312404": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Bari Sadari",
    "officename": "Bohera S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312601": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Nimbahera",
    "officename": "Nimbahera S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312602": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Bhadesar",
    "officename": "Bhadesar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312603": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Bari Sadari",
    "officename": "Nikumbh S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312604": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Chhoti Sadari",
    "officename": "Chhoti Sadari S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312605": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Pratapgarh",
    "officename": "Pratap garh S.O (Chittorgarh)",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312606": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Nimbahera",
    "officename": "Kanera S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312612": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Shambhupura",
    "officename": "Shambhupura S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312613": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Nimbahera",
    "officename": "Sawa S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312614": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Nimbahera",
    "officename": "Binota S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312615": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Arnod",
    "officename": "Arnod S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312616": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Dhamotar",
    "officename": "Dhamotar  S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312617": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Nimbahera",
    "officename": "Kailash  Nagar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312619": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Arnod",
    "officename": "Dalot S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312620": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Mangrol",
    "officename": "Mangrol S.O (Chittorgarh)",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312622": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Bhupalsagar",
    "officename": "Adityapuram S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312623": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Partapgarh",
    "officename": "Rathajana S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312901": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Gangrar",
    "officename": "Gangrar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "313001": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Girwa",
    "officename": "Udaipur Shastri Circle S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313002": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Girwa",
    "officename": "Udaipur H Magri S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313003": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Girwa",
    "officename": "Udaipur Industrial Area S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313004": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Girwa",
    "officename": "Udaipur H.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313011": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Badgaon",
    "officename": "Badgaon S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313022": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Vallabhnagar",
    "officename": "Dabok S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313024": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Girwa",
    "officename": "Zinc Smelter S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313026": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Salumber",
    "officename": "Intali Khera S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313027": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Salumber",
    "officename": "Salumber S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313031": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Girva",
    "officename": "Nai S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313038": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Salumber",
    "officename": "Jhallara S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313201": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Mavli",
    "officename": "Khemli S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313202": {
    "state": "Rajasthan",
    "district": "Rajsamand",
    "block": "Nathdwara",
    "officename": "Delwara S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313203": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Mavli",
    "officename": "Mavli Jn. S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313204": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Mavli",
    "officename": "Palana Khurd S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313205": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Mavli",
    "officename": "Fatehnagar S.O (Udaipur)",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313206": {
    "state": "Rajasthan",
    "district": "Rajsamand",
    "block": "Mavli",
    "officename": "Sanwar S.O (Udaipur)",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313207": {
    "state": "Rajasthan",
    "district": "Rajsamand",
    "block": "Gilund",
    "officename": "Gilund S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313211": {
    "state": "Rajasthan",
    "district": "Rajsamand",
    "block": "Railmagra",
    "officename": "Dariba S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313301": {
    "state": "Rajasthan",
    "district": "Rajsamand",
    "block": "Nathdwara",
    "officename": "Nathdwara S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313321": {
    "state": "Rajasthan",
    "district": "Rajsamand",
    "block": "Nathdwara",
    "officename": "Goanguda S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313322": {
    "state": "Rajasthan",
    "district": "Rajsamand",
    "block": "Khamnore",
    "officename": "Khamnore S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313323": {
    "state": "Rajasthan",
    "district": "Rajsamand",
    "block": "Nathdwara",
    "officename": "Kotharia S.O (Rajsamand)",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313324": {
    "state": "Rajasthan",
    "district": "Rajsamand",
    "block": "Rajsamand",
    "officename": "Kankroli H.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313325": {
    "state": "Rajasthan",
    "district": "Rajsamand",
    "block": "Kumbhalgarh",
    "officename": "Kelwara S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313327": {
    "state": "Rajasthan",
    "district": "Rajsamand",
    "block": "Rajsamand",
    "officename": "Koaria S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313328": {
    "state": "Rajasthan",
    "district": "Rajsamand",
    "block": "Railmagra",
    "officename": "Kuraj S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313329": {
    "state": "Rajasthan",
    "district": "Rajsamand",
    "block": "Railmagra",
    "officename": "Railmagra S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313330": {
    "state": "Rajasthan",
    "district": "Rajsamand",
    "block": "Lawa Sardargarh",
    "officename": "Lawa Sardargarh S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313331": {
    "state": "Rajasthan",
    "district": "Rajsamand",
    "block": "Deogarh",
    "officename": "Deogarh S.O (Rajsamand)",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313332": {
    "state": "Rajasthan",
    "district": "Rajsamand",
    "block": "Amet",
    "officename": "Charbhuja Road S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313333": {
    "state": "Rajasthan",
    "district": "Rajsamand",
    "block": "Amet",
    "officename": "Charbhuja S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313334": {
    "state": "Rajasthan",
    "district": "Rajsamand",
    "block": "Rajsamand",
    "officename": "Kelwa S.O (Rajsamand)",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313341": {
    "state": "Rajasthan",
    "district": "Rajsamand",
    "block": "Bhim",
    "officename": "Barar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313342": {
    "state": "Rajasthan",
    "district": "Rajsamand",
    "block": "Rajsamand",
    "officename": "T F Kankroli S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313601": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Vallabhnagar",
    "officename": "Vallabhnagar S.O (Udaipur)",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313602": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Bhinder",
    "officename": "Kheroda S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313603": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Bhinder",
    "officename": "Bhinder S.O (Udaipur)",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313604": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Bhinder",
    "officename": "Kanore S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313701": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Jhadol",
    "officename": "Phalasia S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313702": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Salumber",
    "officename": "Jhadol (P) S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313703": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Girwa",
    "officename": "Kurawar S.O (Udaipur)",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313704": {
    "state": "Rajasthan",
    "district": "Rajsamand",
    "block": "Gogunda",
    "officename": "Sayra S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313705": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Gogunda",
    "officename": "Gogunda S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313706": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Salumber",
    "officename": "Bambora S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313708": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Gogunda",
    "officename": "Nandeshma S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313801": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Kherwara",
    "officename": "Parsad S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313802": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Kherwara",
    "officename": "Rishabhdeo S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313803": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Kherwara",
    "officename": "Kherwara S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313804": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Kherwara",
    "officename": "Chhani S.O (Udaipur)",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313901": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Girwa",
    "officename": "Zawar Mines S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313902": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Sarara",
    "officename": "Sarara S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313903": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Sarara",
    "officename": "Semari S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313904": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Sarara",
    "officename": "Chawand S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313905": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Sarara",
    "officename": "Jhadol (S) S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313906": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Jhadol",
    "officename": "Ogna S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "314001": {
    "state": "Rajasthan",
    "district": "Dungarpur",
    "block": "Dungarpur",
    "officename": "Dungarpur H.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "314011": {
    "state": "Rajasthan",
    "district": "Dungarpur",
    "block": "Dungarpur",
    "officename": "Paldeval S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "314021": {
    "state": "Rajasthan",
    "district": "Dungarpur",
    "block": "Dungarpur",
    "officename": "Aspur S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "314022": {
    "state": "Rajasthan",
    "district": "Dungarpur",
    "block": "Dungarpur",
    "officename": "Sabla S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "314023": {
    "state": "Rajasthan",
    "district": "Dungarpur",
    "block": "Aspur",
    "officename": "Bankora S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "314024": {
    "state": "Rajasthan",
    "district": "Dungarpur",
    "block": "Dungarpur",
    "officename": "Padwa S.O (Dungarpur)",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "314025": {
    "state": "Rajasthan",
    "district": "Dungarpur",
    "block": "Dungarpur",
    "officename": "Sagwara S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "314026": {
    "state": "Rajasthan",
    "district": "Dungarpur",
    "block": "Dungarpur",
    "officename": "Galiakot S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "314027": {
    "state": "Rajasthan",
    "district": "Dungarpur",
    "block": "Dungarpur",
    "officename": "Khadagda S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "314028": {
    "state": "Rajasthan",
    "district": "Dungarpur",
    "block": "Dungarpur",
    "officename": "Punali S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "314029": {
    "state": "Rajasthan",
    "district": "Dungarpur",
    "block": "Dungarpur",
    "officename": "Thakarda S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "314030": {
    "state": "Rajasthan",
    "district": "Dungarpur",
    "block": "Dungarpur",
    "officename": "Chikhli S.O (Dungarpur)",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "314031": {
    "state": "Rajasthan",
    "district": "Dungarpur",
    "block": "Dungarpur",
    "officename": "Bhiluda S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "314032": {
    "state": "Rajasthan",
    "district": "Dungarpur",
    "block": "Dungarpur",
    "officename": "Saroda S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "314034": {
    "state": "Rajasthan",
    "district": "Dungarpur",
    "block": "Dungarpur",
    "officename": "Ramgarh S.O (Dungarpur)",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "314035": {
    "state": "Rajasthan",
    "district": "Dungarpur",
    "block": "Dungarpur",
    "officename": "Chitri S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "314036": {
    "state": "Rajasthan",
    "district": "Dungarpur",
    "block": "Dungarpur",
    "officename": "Damdi S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "314037": {
    "state": "Rajasthan",
    "district": "Dungarpur",
    "block": "Dungarpur",
    "officename": "Antri S.O (Dungarpur)",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "314038": {
    "state": "Rajasthan",
    "district": "Dungarpur",
    "block": "Dungarpur",
    "officename": "Punjpur S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "314401": {
    "state": "Rajasthan",
    "district": "Dungarpur",
    "block": "Dungarpur",
    "officename": "Obri S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "314402": {
    "state": "Rajasthan",
    "district": "Dungarpur",
    "block": "Dungarpur",
    "officename": "Dhambola S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "314403": {
    "state": "Rajasthan",
    "district": "Dungarpur",
    "block": "Dungarpur",
    "officename": "Simalwara S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "314404": {
    "state": "Rajasthan",
    "district": "Dungarpur",
    "block": "Dungarpur",
    "officename": "Vikasnagar S.O (Dungarpur)",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "314406": {
    "state": "Rajasthan",
    "district": "Dungarpur",
    "block": "Dungarpur",
    "officename": "Peeth S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "314801": {
    "state": "Rajasthan",
    "district": "Dungarpur",
    "block": "Dungarpur",
    "officename": "Bichhiwara S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "314804": {
    "state": "Rajasthan",
    "district": "Dungarpur",
    "block": "Dungarpur",
    "officename": "Kanba S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "321001": {
    "state": "Rajasthan",
    "district": "Bharatpur",
    "block": "Bharatpur",
    "officename": "Bharatpur H.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bharatpur Division"
  },
  "321021": {
    "state": "Rajasthan",
    "district": "Bharatpur",
    "block": "Bharatpur",
    "officename": "Jaghina S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bharatpur Division"
  },
  "321022": {
    "state": "Rajasthan",
    "district": "Bharatpur",
    "block": "Bharatpur",
    "officename": "Kamanlsg S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bharatpur Division"
  },
  "321023": {
    "state": "Rajasthan",
    "district": "Bharatpur",
    "block": "Bharatpur",
    "officename": "Jurhera S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bharatpur Division"
  },
  "321024": {
    "state": "Rajasthan",
    "district": "Bharatpur",
    "block": "Bharatpur",
    "officename": "Sikri S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bharatpur Division"
  },
  "321025": {
    "state": "Rajasthan",
    "district": "Bharatpur",
    "block": "Bharatpur",
    "officename": "Rareh S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bharatpur Division"
  },
  "321026": {
    "state": "Rajasthan",
    "district": "Bharatpur",
    "block": "Bharatpur",
    "officename": "Kanjoli Line S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bharatpur Division"
  },
  "321028": {
    "state": "Rajasthan",
    "district": "Bharatpur",
    "block": "Bharatpur",
    "officename": "Kherli Gadasia S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bharatpur Division"
  },
  "321201": {
    "state": "Rajasthan",
    "district": "Bharatpur",
    "block": "Kumher",
    "officename": "Kumher S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bharatpur Division"
  },
  "321202": {
    "state": "Rajasthan",
    "district": "Bharatpur",
    "block": "Bharatpur",
    "officename": "Penghore S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bharatpur Division"
  },
  "321203": {
    "state": "Rajasthan",
    "district": "Bharatpur",
    "block": "Bharatpur",
    "officename": "Deeg H.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bharatpur Division"
  },
  "321204": {
    "state": "Rajasthan",
    "district": "Bharatpur",
    "block": "Bharatpur",
    "officename": "Pahari S.O (Bharatpur)",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bharatpur Division"
  },
  "321205": {
    "state": "Rajasthan",
    "district": "Bharatpur",
    "block": "Bharatpur",
    "officename": "Nagar S.O (Bharatpur)",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bharatpur Division"
  },
  "321206": {
    "state": "Rajasthan",
    "district": "Bharatpur",
    "block": "Deeg",
    "officename": "Janoothar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bharatpur Division"
  },
  "321301": {
    "state": "Rajasthan",
    "district": "Bharatpur",
    "block": "Bharatpur",
    "officename": "Pichuna S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bharatpur Division"
  },
  "321302": {
    "state": "Rajasthan",
    "district": "Bharatpur",
    "block": "Bharatpur",
    "officename": "Uchain S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bharatpur Division"
  },
  "321303": {
    "state": "Rajasthan",
    "district": "Bharatpur",
    "block": "Kumher",
    "officename": "Sewar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bharatpur Division"
  },
  "321401": {
    "state": "Rajasthan",
    "district": "Bharatpur",
    "block": "Bayana",
    "officename": "Bayana SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dholpur Division"
  },
  "321402": {
    "state": "Rajasthan",
    "district": "Bharatpur",
    "block": "Bayana Mdg",
    "officename": "Rudawal SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dholpur Division"
  },
  "321403": {
    "state": "Rajasthan",
    "district": "Bharatpur",
    "block": "Bayana Mdg",
    "officename": "Banshi Paharpur SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dholpur Division"
  },
  "321404": {
    "state": "Rajasthan",
    "district": "Bharatpur",
    "block": "Bayana Mdg",
    "officename": "Roopbas SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dholpur Division"
  },
  "321405": {
    "state": "Rajasthan",
    "district": "Bharatpur",
    "block": "Bayana",
    "officename": "Band Baretha SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dholpur Division"
  },
  "321406": {
    "state": "Rajasthan",
    "district": "Bharatpur",
    "block": "Bharatpur",
    "officename": "Bhusawar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bharatpur Division"
  },
  "321407": {
    "state": "Rajasthan",
    "district": "Bharatpur",
    "block": "Bharatpur",
    "officename": "Chhonkarwara Kalan S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bharatpur Division"
  },
  "321408": {
    "state": "Rajasthan",
    "district": "Bharatpur",
    "block": "Weir",
    "officename": "Weir SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dholpur Division"
  },
  "321409": {
    "state": "Rajasthan",
    "district": "Bharatpur",
    "block": "Bharatpur",
    "officename": "Ballabhgarh S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bharatpur Division"
  },
  "321410": {
    "state": "Rajasthan",
    "district": "Bharatpur",
    "block": "Bayana Mdg",
    "officename": "Brahmbad SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dholpur Division"
  },
  "321411": {
    "state": "Rajasthan",
    "district": "Bharatpur",
    "block": "Bayana Mdg",
    "officename": "Khareri SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dholpur Division"
  },
  "321601": {
    "state": "Rajasthan",
    "district": "Bharatpur",
    "block": "Bharatpur",
    "officename": "Halena S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bharatpur Division"
  },
  "321602": {
    "state": "Rajasthan",
    "district": "Bharatpur",
    "block": "Bharatpur",
    "officename": "Nadbai S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bharatpur Division"
  },
  "321605": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Laxmangarh Alwar",
    "officename": "Kathumar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "321606": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Laxman Garh",
    "officename": "Kherli S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "321607": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Laxman Garh",
    "officename": "Laxman Garh S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "321608": {
    "state": "Rajasthan",
    "district": "Dausa",
    "block": "Dausa",
    "officename": "Mahwa SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "321609": {
    "state": "Rajasthan",
    "district": "Dausa",
    "block": "Dausa",
    "officename": "Mahwa Road SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "321610": {
    "state": "Rajasthan",
    "district": "Karauli",
    "block": "Todabhim",
    "officename": "Ghatabalaji SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "321611": {
    "state": "Rajasthan",
    "district": "Karauli",
    "block": "Todabhim",
    "officename": "Todabhim SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "321612": {
    "state": "Rajasthan",
    "district": "Dausa",
    "block": "Dausa",
    "officename": "Paota Dausa SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "321613": {
    "state": "Rajasthan",
    "district": "Dausa",
    "block": "Dausa",
    "officename": "Rasidpur SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "321614": {
    "state": "Rajasthan",
    "district": "Bharatpur",
    "block": "Bharatpur",
    "officename": "Akhaigarh S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bharatpur Division"
  },
  "321615": {
    "state": "Rajasthan",
    "district": "Bharatpur",
    "block": "Bharatpur",
    "officename": "Pathena S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bharatpur Division"
  },
  "321633": {
    "state": "Rajasthan",
    "district": "Alwar",
    "block": "Lachhmangarh",
    "officename": "Mauj Pur S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Alwar Division"
  },
  "321642": {
    "state": "Rajasthan",
    "district": "Bharatpur",
    "block": "Bharatpur",
    "officename": "Sarsena S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bharatpur Division"
  },
  "322001": {
    "state": "Rajasthan",
    "district": "Sawai Madhopur",
    "block": "Sawaimadhopur",
    "officename": "Sawaimadhopur HO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322021": {
    "state": "Rajasthan",
    "district": "Sawai Madhopur",
    "block": "Sawaimadhopur",
    "officename": "Alanpur SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322023": {
    "state": "Rajasthan",
    "district": "Sawai Madhopur",
    "block": "Bonli",
    "officename": "Bonli SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322024": {
    "state": "Rajasthan",
    "district": "Sawai Madhopur",
    "block": "Malarna Dungar",
    "officename": "Khirni SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322025": {
    "state": "Rajasthan",
    "district": "Sawai Madhopur",
    "block": "Khandar",
    "officename": "Khandar SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322026": {
    "state": "Rajasthan",
    "district": "Sawai Madhopur",
    "block": "Sawaimadhopur",
    "officename": "Phalodi Quarry SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322027": {
    "state": "Rajasthan",
    "district": "Sawai Madhopur",
    "block": "Sawaimadhopur",
    "officename": "Soorwal SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322028": {
    "state": "Rajasthan",
    "district": "Sawai Madhopur",
    "block": "Malrna Doongar",
    "officename": "Malrna Doongar SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322029": {
    "state": "Rajasthan",
    "district": "Sawai Madhopur",
    "block": "Sawaimadhopur",
    "officename": "Kundera SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322030": {
    "state": "Rajasthan",
    "district": "Sawai Madhopur",
    "block": "Bonli",
    "officename": "Malrna Chaur SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322033": {
    "state": "Rajasthan",
    "district": "Sawai Madhopur",
    "block": "Khandar",
    "officename": "Malarna R S SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322034": {
    "state": "Rajasthan",
    "district": "Sawai Madhopur",
    "block": "Sawaimadhopur",
    "officename": "Chakeri SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322201": {
    "state": "Rajasthan",
    "district": "Sawai Madhopur",
    "block": "Gangapur",
    "officename": "Gangapur HO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322202": {
    "state": "Rajasthan",
    "district": "Karauli",
    "block": "Sapotara",
    "officename": "Mahukala SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322203": {
    "state": "Rajasthan",
    "district": "Karauli",
    "block": "Sapotara",
    "officename": "Narauli Dang SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322204": {
    "state": "Rajasthan",
    "district": "Karauli",
    "block": "Nadoti",
    "officename": "Shahar SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322205": {
    "state": "Rajasthan",
    "district": "Sawai Madhopur",
    "block": "Gangapur",
    "officename": "Piloda SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322211": {
    "state": "Rajasthan",
    "district": "Sawai Madhopur",
    "block": "Bamanwas",
    "officename": "Bamanwas SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322212": {
    "state": "Rajasthan",
    "district": "Sawai Madhopur",
    "block": "Bamanwas",
    "officename": "Garhmoran SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322213": {
    "state": "Rajasthan",
    "district": "Karauli",
    "block": "Nadoti",
    "officename": "Gudhachandraji SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322214": {
    "state": "Rajasthan",
    "district": "Sawai Madhopur",
    "block": "Bamanwas",
    "officename": "Piplai SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322215": {
    "state": "Rajasthan",
    "district": "Karauli",
    "block": "Nadoti",
    "officename": "Nadoti SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322216": {
    "state": "Rajasthan",
    "district": "Karauli",
    "block": "Nadoti",
    "officename": "Kemri SO Karauli",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322218": {
    "state": "Rajasthan",
    "district": "Karauli",
    "block": "Sapotara",
    "officename": "Sapotara SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322219": {
    "state": "Rajasthan",
    "district": "Sawai Madhopur",
    "block": "Gangapur",
    "officename": "Wazirpur SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322220": {
    "state": "Rajasthan",
    "district": "Karauli",
    "block": "Hindaun",
    "officename": "Shrimahaveerji SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322230": {
    "state": "Rajasthan",
    "district": "Karauli",
    "block": "Hindaun",
    "officename": "Hindaun HO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322234": {
    "state": "Rajasthan",
    "district": "Karauli",
    "block": "Hindaun",
    "officename": "Kheda SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322236": {
    "state": "Rajasthan",
    "district": "Karauli",
    "block": "Hindaun",
    "officename": "Dhindora SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322238": {
    "state": "Rajasthan",
    "district": "Karauli",
    "block": "Todabhim",
    "officename": "Balghat SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322240": {
    "state": "Rajasthan",
    "district": "Dausa",
    "block": "Dausa",
    "officename": "Kherla SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "322241": {
    "state": "Rajasthan",
    "district": "Karauli",
    "block": "Karauli",
    "officename": "Karauli SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322242": {
    "state": "Rajasthan",
    "district": "Karauli",
    "block": "Karauli",
    "officename": "Masalpur SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322243": {
    "state": "Rajasthan",
    "district": "Karauli",
    "block": "Karauli",
    "officename": "Kailadevi SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322249": {
    "state": "Rajasthan",
    "district": "Karauli",
    "block": "Sapotara",
    "officename": "Langra SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322251": {
    "state": "Rajasthan",
    "district": "Karauli",
    "block": "Mandrail",
    "officename": "Mandrail SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322252": {
    "state": "Rajasthan",
    "district": "Karauli",
    "block": "Hindaun",
    "officename": "Suroth SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322254": {
    "state": "Rajasthan",
    "district": "Karauli",
    "block": "Hindaun",
    "officename": "Ghonsla SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322255": {
    "state": "Rajasthan",
    "district": "Karauli",
    "block": "Karauli",
    "officename": "Kurgaon SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322701": {
    "state": "Rajasthan",
    "district": "Sawai Madhopur",
    "block": "Chauth Ka Barwara",
    "officename": "Bhagwatgarh SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322702": {
    "state": "Rajasthan",
    "district": "Sawai Madhopur",
    "block": "Chauth Ka Barwara",
    "officename": "Chauth Ka Barwara SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322703": {
    "state": "Rajasthan",
    "district": "Sawai Madhopur",
    "block": "Chauth Ka Barwara",
    "officename": "Isharda SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "322704": {
    "state": "Rajasthan",
    "district": "Sawai Madhopur",
    "block": "Chauth Ka Barwara",
    "officename": "Shiwar SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sawaimadhopur Division"
  },
  "323001": {
    "state": "Rajasthan",
    "district": "Bundi",
    "block": "Bundi",
    "officename": "Bundi H.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Tonk Division"
  },
  "323021": {
    "state": "Rajasthan",
    "district": "Bundi",
    "block": "Bundi",
    "officename": "Talera S.O (Bundi)",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Tonk Division"
  },
  "323022": {
    "state": "Rajasthan",
    "district": "Bundi",
    "block": "Bundi",
    "officename": "Namana S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Tonk Division"
  },
  "323023": {
    "state": "Rajasthan",
    "district": "Bundi",
    "block": "Bundi",
    "officename": "Hindoli S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Tonk Division"
  },
  "323024": {
    "state": "Rajasthan",
    "district": "Bundi",
    "block": "Bundi",
    "officename": "Baranaya Gaon S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Tonk Division"
  },
  "323025": {
    "state": "Rajasthan",
    "district": "Bundi",
    "block": "Bundi",
    "officename": "Umar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Tonk Division"
  },
  "323301": {
    "state": "Rajasthan",
    "district": "Bundi",
    "block": "Bundi",
    "officename": "Kapren S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Tonk Division"
  },
  "323303": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Rawatbhata",
    "officename": "Anushakti S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "323304": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Rawatbhatta",
    "officename": "Bhenshroadgarh S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "323305": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Rawatbhata",
    "officename": "Rawatbhatta  Bazar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "323307": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Rawatbhata",
    "officename": "Bhabhanagar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "323601": {
    "state": "Rajasthan",
    "district": "Bundi",
    "block": "Bundi",
    "officename": "Kesoraipatan S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Tonk Division"
  },
  "323602": {
    "state": "Rajasthan",
    "district": "Bundi",
    "block": "Bundi",
    "officename": "Kesoraipatan Sugar Factoy S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Tonk Division"
  },
  "323603": {
    "state": "Rajasthan",
    "district": "Bundi",
    "block": "Bundi",
    "officename": "Lakheri S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Tonk Division"
  },
  "323613": {
    "state": "Rajasthan",
    "district": "Bundi",
    "block": "Bundi",
    "officename": "Indergarh S.O (Bundi)",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Tonk Division"
  },
  "323614": {
    "state": "Rajasthan",
    "district": "Bundi",
    "block": "Bundi",
    "officename": "Sumerganj Mandi S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Tonk Division"
  },
  "323615": {
    "state": "Rajasthan",
    "district": "Bundi",
    "block": "Bundi",
    "officename": "Lakheri Gaon S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Tonk Division"
  },
  "323616": {
    "state": "Rajasthan",
    "district": "Bundi",
    "block": "Bundi",
    "officename": "Karwar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Tonk Division"
  },
  "323801": {
    "state": "Rajasthan",
    "district": "Bundi",
    "block": "Bundi",
    "officename": "Nainwan S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Tonk Division"
  },
  "323802": {
    "state": "Rajasthan",
    "district": "Bundi",
    "block": "Bundi",
    "officename": "Dei S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Tonk Division"
  },
  "323803": {
    "state": "Rajasthan",
    "district": "Bundi",
    "block": "Bundi",
    "officename": "Khatkar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Tonk Division"
  },
  "324001": {
    "state": "Rajasthan",
    "district": "Kota",
    "block": "Kota",
    "officename": "Kota H.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Kota Division"
  },
  "324002": {
    "state": "Rajasthan",
    "district": "Kota",
    "block": "Kota",
    "officename": "Kota Jn. S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Kota Division"
  },
  "324003": {
    "state": "Rajasthan",
    "district": "Kota",
    "block": "Kota",
    "officename": "Industerial Estate Kota S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Kota Division"
  },
  "324004": {
    "state": "Rajasthan",
    "district": "Kota",
    "block": "Kota",
    "officename": "Udyog Puri Kota S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Kota Division"
  },
  "324005": {
    "state": "Rajasthan",
    "district": "Kota",
    "block": "Kota",
    "officename": "P.I.P. Kota S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Kota Division"
  },
  "324006": {
    "state": "Rajasthan",
    "district": "Kota",
    "block": "Kota",
    "officename": "Kota City S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Kota Division"
  },
  "324007": {
    "state": "Rajasthan",
    "district": "Kota",
    "block": "Kota",
    "officename": "New Grain Mandi Kota H.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Kota Division"
  },
  "324008": {
    "state": "Rajasthan",
    "district": "Kota",
    "block": "Kota",
    "officename": "Thermal Colony Kota S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Kota Division"
  },
  "324009": {
    "state": "Rajasthan",
    "district": "Kota",
    "block": "NA",
    "officename": "Dadabari Kota S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Kota Division"
  },
  "324010": {
    "state": "Rajasthan",
    "district": "Kota",
    "block": "Kota",
    "officename": "Engineering College Kota S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Kota Division"
  },
  "325001": {
    "state": "Rajasthan",
    "district": "Kota",
    "block": "Kota",
    "officename": "Kaithun S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Kota Division"
  },
  "325003": {
    "state": "Rajasthan",
    "district": "Kota",
    "block": "Kota",
    "officename": "MANDANA S. O.",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Kota Division"
  },
  "325004": {
    "state": "Rajasthan",
    "district": "Kota",
    "block": "Kota",
    "officename": "Itawa S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Kota Division"
  },
  "325009": {
    "state": "Rajasthan",
    "district": "Kota",
    "block": "Kota",
    "officename": "Khatoli S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Kota Division"
  },
  "325201": {
    "state": "Rajasthan",
    "district": "Kota",
    "block": "Kota",
    "officename": "Digod S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Kota Division"
  },
  "325202": {
    "state": "Rajasthan",
    "district": "Baran",
    "block": "Kota",
    "officename": "Anta S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Jhalawar Division"
  },
  "325203": {
    "state": "Rajasthan",
    "district": "Kota",
    "block": "Kota",
    "officename": "Simlia S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Kota Division"
  },
  "325204": {
    "state": "Rajasthan",
    "district": "Kota",
    "block": "Digod",
    "officename": "Sultanpur S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Kota Division"
  },
  "325205": {
    "state": "Rajasthan",
    "district": "Baran",
    "block": "Baran",
    "officename": "Baran MDG S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Jhalawar Division"
  },
  "325206": {
    "state": "Rajasthan",
    "district": "Baran",
    "block": "Kota",
    "officename": "Siswali S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Jhalawar Division"
  },
  "325207": {
    "state": "Rajasthan",
    "district": "Kota",
    "block": "Jhalawar",
    "officename": "Bapawar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Kota Division"
  },
  "325208": {
    "state": "Rajasthan",
    "district": "Kota",
    "block": "Kota",
    "officename": "Gadepan S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Kota Division"
  },
  "325209": {
    "state": "Rajasthan",
    "district": "Baran",
    "block": "Kota",
    "officename": "Anta Gas Power Project Anta S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Jhalawar Division"
  },
  "325214": {
    "state": "Rajasthan",
    "district": "Kota",
    "block": "Baran",
    "officename": "Ayana S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Kota Division"
  },
  "325215": {
    "state": "Rajasthan",
    "district": "Baran",
    "block": "Baran",
    "officename": "Mangrol S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Jhalawar Division"
  },
  "325216": {
    "state": "Rajasthan",
    "district": "Baran",
    "block": "Baran",
    "officename": "Kishan Ganj S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Jhalawar Division"
  },
  "325217": {
    "state": "Rajasthan",
    "district": "Baran",
    "block": "Baran",
    "officename": "Shahabad S.O (Baran)",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Jhalawar Division"
  },
  "325218": {
    "state": "Rajasthan",
    "district": "Baran",
    "block": "Baran",
    "officename": "ATRU S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Jhalawar Division"
  },
  "325219": {
    "state": "Rajasthan",
    "district": "Baran",
    "block": "Baran",
    "officename": "Salpura S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Jhalawar Division"
  },
  "325220": {
    "state": "Rajasthan",
    "district": "Baran",
    "block": "Baran",
    "officename": "Chhabra S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Jhalawar Division"
  },
  "325221": {
    "state": "Rajasthan",
    "district": "Baran",
    "block": "Baran",
    "officename": "Chhipa Barod S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Jhalawar Division"
  },
  "325222": {
    "state": "Rajasthan",
    "district": "Baran",
    "block": "Baran",
    "officename": "Bohat S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Jhalawar Division"
  },
  "325223": {
    "state": "Rajasthan",
    "district": "Baran",
    "block": "Baran",
    "officename": "Atone S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Jhalawar Division"
  },
  "325601": {
    "state": "Rajasthan",
    "district": "Kota",
    "block": "Kota",
    "officename": "Sangod S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Kota Division"
  },
  "325602": {
    "state": "Rajasthan",
    "district": "Kota",
    "block": "Kota",
    "officename": "Kanwas S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Kota Division"
  },
  "326001": {
    "state": "Rajasthan",
    "district": "Jhalawar",
    "block": "Jhalawar",
    "officename": "Jhalawar H.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Jhalawar Division"
  },
  "326021": {
    "state": "Rajasthan",
    "district": "Jhalawar",
    "block": "Jhalawar",
    "officename": "Asnawar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Jhalawar Division"
  },
  "326022": {
    "state": "Rajasthan",
    "district": "Jhalawar",
    "block": "Jhalawar",
    "officename": "Bakani S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Jhalawar Division"
  },
  "326023": {
    "state": "Rajasthan",
    "district": "Jhalawar",
    "block": "Jhalawar",
    "officename": "Jhalara Patan City S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Jhalawar Division"
  },
  "326033": {
    "state": "Rajasthan",
    "district": "Jhalawar",
    "block": "Jhalawar",
    "officename": "Aklera S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Jhalawar Division"
  },
  "326034": {
    "state": "Rajasthan",
    "district": "Jhalawar",
    "block": "Jhalawar",
    "officename": "Pirawa S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Jhalawar Division"
  },
  "326035": {
    "state": "Rajasthan",
    "district": "Jhalawar",
    "block": "Jhalawar",
    "officename": "Sarola S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Jhalawar Division"
  },
  "326036": {
    "state": "Rajasthan",
    "district": "Jhalawar",
    "block": "Jhalawar",
    "officename": "Raipur S.O (Jhalawar)",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Jhalawar Division"
  },
  "326037": {
    "state": "Rajasthan",
    "district": "Jhalawar",
    "block": "Jhalawar",
    "officename": "Manohar Thana S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Jhalawar Division"
  },
  "326038": {
    "state": "Rajasthan",
    "district": "Jhalawar",
    "block": "Jhalawar",
    "officename": "Khanpur S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Jhalawar Division"
  },
  "326039": {
    "state": "Rajasthan",
    "district": "Jhalawar",
    "block": "Jhalawar",
    "officename": "Ghatoli S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Jhalawar Division"
  },
  "326501": {
    "state": "Rajasthan",
    "district": "Jhalawar",
    "block": "Jhalawar",
    "officename": "Shrichhattarpur S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Jhalawar Division"
  },
  "326502": {
    "state": "Rajasthan",
    "district": "Jhalawar",
    "block": "Jhalawar",
    "officename": "Bhawanimandi S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Jhalawar Division"
  },
  "326512": {
    "state": "Rajasthan",
    "district": "Jhalawar",
    "block": "Jhalawar",
    "officename": "Pach Pahar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Jhalawar Division"
  },
  "326513": {
    "state": "Rajasthan",
    "district": "Jhalawar",
    "block": "Jhalawar",
    "officename": "Sunel S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Jhalawar Division"
  },
  "326514": {
    "state": "Rajasthan",
    "district": "Jhalawar",
    "block": "Jhalawar",
    "officename": "Dag S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Jhalawar Division"
  },
  "326515": {
    "state": "Rajasthan",
    "district": "Jhalawar",
    "block": "Jhalawar",
    "officename": "Chaumahla S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Jhalawar Division"
  },
  "326516": {
    "state": "Rajasthan",
    "district": "Jhalawar",
    "block": "Jhalawar",
    "officename": "Gangdhar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Jhalawar Division"
  },
  "326517": {
    "state": "Rajasthan",
    "district": "Kota",
    "block": "Kota",
    "officename": "Morak S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Kota Division"
  },
  "326518": {
    "state": "Rajasthan",
    "district": "Kota",
    "block": "Kota",
    "officename": "Chechat S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Kota Division"
  },
  "326519": {
    "state": "Rajasthan",
    "district": "Kota",
    "block": "Kota",
    "officename": "Ram Ganj Mandi S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Kota Division"
  },
  "326520": {
    "state": "Rajasthan",
    "district": "Kota",
    "block": "Kota",
    "officename": "Aditya Nagar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Kota Division"
  },
  "326529": {
    "state": "Rajasthan",
    "district": "Kota",
    "block": "Kota",
    "officename": "Khairabad S.O (Kota)",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Kota Division"
  },
  "326530": {
    "state": "Rajasthan",
    "district": "Kota",
    "block": "Kota",
    "officename": "Suket S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Kota Division"
  },
  "327001": {
    "state": "Rajasthan",
    "district": "Banswara",
    "block": "Banswara",
    "officename": "Banswara H.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "327021": {
    "state": "Rajasthan",
    "district": "Banswara",
    "block": "Banswara",
    "officename": "Ganoda S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "327022": {
    "state": "Rajasthan",
    "district": "Banswara",
    "block": "Banswara",
    "officename": "Garhi S.O (Banswara)",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "327023": {
    "state": "Rajasthan",
    "district": "Banswara",
    "block": "Banswara",
    "officename": "Ghatol S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "327024": {
    "state": "Rajasthan",
    "district": "Banswara",
    "block": "Banswara",
    "officename": "Partapur S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "327025": {
    "state": "Rajasthan",
    "district": "Banswara",
    "block": "Banswara",
    "officename": "Talwara S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "327026": {
    "state": "Rajasthan",
    "district": "Banswara",
    "block": "Banswara",
    "officename": "Mahidam S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "327027": {
    "state": "Rajasthan",
    "district": "Banswara",
    "block": "Banswara",
    "officename": "Khamera S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "327031": {
    "state": "Rajasthan",
    "district": "Banswara",
    "block": "Banswara",
    "officename": "Anandpuri S.O (Banswara)",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "327032": {
    "state": "Rajasthan",
    "district": "Banswara",
    "block": "Banswara",
    "officename": "Arthuna S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "327034": {
    "state": "Rajasthan",
    "district": "Banswara",
    "block": "Banswara",
    "officename": "Jolana S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "327601": {
    "state": "Rajasthan",
    "district": "Banswara",
    "block": "Banswara",
    "officename": "Bagidora S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "327602": {
    "state": "Rajasthan",
    "district": "Banswara",
    "block": "Banswara",
    "officename": "Sajjan Garh S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "327603": {
    "state": "Rajasthan",
    "district": "Banswara",
    "block": "Banswara",
    "officename": "Chhinch S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "327604": {
    "state": "Rajasthan",
    "district": "Banswara",
    "block": "Banswara",
    "officename": "Barodia S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "327605": {
    "state": "Rajasthan",
    "district": "Banswara",
    "block": "Banswara",
    "officename": "Luharia S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "327606": {
    "state": "Rajasthan",
    "district": "Banswara",
    "block": "Banswara",
    "officename": "Kalinjara S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "327801": {
    "state": "Rajasthan",
    "district": "Banswara",
    "block": "Banswara",
    "officename": "Kushalgarh S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Dungarpur Division"
  },
  "328001": {
    "state": "Rajasthan",
    "district": "Dholpur",
    "block": "Rajakhera",
    "officename": "Dholpur HO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dholpur Division"
  },
  "328021": {
    "state": "Rajasthan",
    "district": "Dholpur",
    "block": "Bari",
    "officename": "Bari SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dholpur Division"
  },
  "328022": {
    "state": "Rajasthan",
    "district": "Dholpur",
    "block": "Baresei",
    "officename": "Baseri SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dholpur Division"
  },
  "328023": {
    "state": "Rajasthan",
    "district": "Dholpur",
    "block": "Saipau",
    "officename": "Basai Nabab SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dholpur Division"
  },
  "328024": {
    "state": "Rajasthan",
    "district": "Dholpur",
    "block": "Dholpur",
    "officename": "Maniya SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dholpur Division"
  },
  "328025": {
    "state": "Rajasthan",
    "district": "Dholpur",
    "block": "Rajakhera",
    "officename": "Rajakhera SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dholpur Division"
  },
  "328026": {
    "state": "Rajasthan",
    "district": "Dholpur",
    "block": "Baresei",
    "officename": "Sarmathura SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dholpur Division"
  },
  "328027": {
    "state": "Rajasthan",
    "district": "Dholpur",
    "block": "Saipau",
    "officename": "Saipau SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dholpur Division"
  },
  "328028": {
    "state": "Rajasthan",
    "district": "Dholpur",
    "block": "Dholpur",
    "officename": "Keshar Bagh SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dholpur Division"
  },
  "328029": {
    "state": "Rajasthan",
    "district": "Dholpur",
    "block": "Rajakhera",
    "officename": "Marena SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dholpur Division"
  },
  "328030": {
    "state": "Rajasthan",
    "district": "Dholpur",
    "block": "Dholpur",
    "officename": "Panch Gaon SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dholpur Division"
  },
  "328031": {
    "state": "Rajasthan",
    "district": "Dholpur",
    "block": "Baresei",
    "officename": "Barauli SO Dholpur",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dholpur Division"
  },
  "328041": {
    "state": "Rajasthan",
    "district": "Dholpur",
    "block": "Bari",
    "officename": "Kanchanpur SO Dholpur",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dholpur Division"
  },
  "331001": {
    "state": "Rajasthan",
    "district": "Churu",
    "block": "Churu",
    "officename": "Churu H.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Churu Division"
  },
  "331021": {
    "state": "Rajasthan",
    "district": "Churu",
    "block": "Churu",
    "officename": "Ratan Nagar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Churu Division"
  },
  "331022": {
    "state": "Rajasthan",
    "district": "Churu",
    "block": "Ratangarh",
    "officename": "Ratangarh H.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Churu Division"
  },
  "331023": {
    "state": "Rajasthan",
    "district": "Churu",
    "block": "Sadulpur",
    "officename": "Sadulpur S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Churu Division"
  },
  "331024": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Fatehpur",
    "officename": "Ramgarh Shekhawati SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "331025": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Jhunjhunu",
    "officename": "Alsisar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "331026": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Alsisar",
    "officename": "Tamkore S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "331027": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Jhunjhunu",
    "officename": "Bissau S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "331028": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Alsisar",
    "officename": "Malsisar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "331029": {
    "state": "Rajasthan",
    "district": "Churu",
    "block": "Churu",
    "officename": "Dudhwakhara S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Churu Division"
  },
  "331031": {
    "state": "Rajasthan",
    "district": "Churu",
    "block": "Churu",
    "officename": "Satra S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Churu Division"
  },
  "331301": {
    "state": "Rajasthan",
    "district": "Churu",
    "block": "Sadulpur",
    "officename": "Rampura Beri S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Churu Division"
  },
  "331302": {
    "state": "Rajasthan",
    "district": "Churu",
    "block": "Taranagar",
    "officename": "Sahwa S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Churu Division"
  },
  "331303": {
    "state": "Rajasthan",
    "district": "Churu",
    "block": "Sadulpur",
    "officename": "Sankhu Fort S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Churu Division"
  },
  "331304": {
    "state": "Rajasthan",
    "district": "Churu",
    "block": "Taranagar",
    "officename": "Taranagar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Churu Division"
  },
  "331305": {
    "state": "Rajasthan",
    "district": "Churu",
    "block": "Sadulpur",
    "officename": "Hamirwas S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Churu Division"
  },
  "331402": {
    "state": "Rajasthan",
    "district": "Churu",
    "block": "Sardarshahar",
    "officename": "Pulasar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Churu Division"
  },
  "331403": {
    "state": "Rajasthan",
    "district": "Churu",
    "block": "Sardarshahar",
    "officename": "Sardarshahar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Churu Division"
  },
  "331411": {
    "state": "Rajasthan",
    "district": "Churu",
    "block": "Sardarshahr",
    "officename": "Bhanipura S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Churu Division"
  },
  "331501": {
    "state": "Rajasthan",
    "district": "Churu",
    "block": "Ratangarh",
    "officename": "Bidasar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Churu Division"
  },
  "331502": {
    "state": "Rajasthan",
    "district": "Churu",
    "block": "Sujangarh",
    "officename": "Chhapar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Churu Division"
  },
  "331503": {
    "state": "Rajasthan",
    "district": "Churu",
    "block": "Sujangarh",
    "officename": "Charwas S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Churu Division"
  },
  "331504": {
    "state": "Rajasthan",
    "district": "Churu",
    "block": "Ratangarh",
    "officename": "Gogasar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Churu Division"
  },
  "331505": {
    "state": "Rajasthan",
    "district": "Churu",
    "block": "Sujangahr",
    "officename": "Parihara S.O (Churu)",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Churu Division"
  },
  "331506": {
    "state": "Rajasthan",
    "district": "Churu",
    "block": "Sujangarh",
    "officename": "Salasar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Churu Division"
  },
  "331507": {
    "state": "Rajasthan",
    "district": "Churu",
    "block": "Sujangarh",
    "officename": "Sujangarh S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Churu Division"
  },
  "331517": {
    "state": "Rajasthan",
    "district": "Churu",
    "block": "Sujangarh",
    "officename": "Sandwa S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Churu Division"
  },
  "331518": {
    "state": "Rajasthan",
    "district": "Churu",
    "block": "Sujangarh",
    "officename": "Lalgarh S.O (Churu)",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Churu Division"
  },
  "331701": {
    "state": "Rajasthan",
    "district": "Churu",
    "block": "Sadulpur",
    "officename": "Sidhmukh S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Churu Division"
  },
  "331801": {
    "state": "Rajasthan",
    "district": "Bikaner",
    "block": "Bikaner",
    "officename": "Momasar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Bikaner Division"
  },
  "331802": {
    "state": "Rajasthan",
    "district": "Churu",
    "block": "Ratangarh",
    "officename": "Rajaldesar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Churu Division"
  },
  "331803": {
    "state": "Rajasthan",
    "district": "Churu",
    "block": "Dungargarh",
    "officename": "Shri Dungargarh S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Bikaner Division"
  },
  "331811": {
    "state": "Rajasthan",
    "district": "Bikaner",
    "block": "Bikaner",
    "officename": "Sudsar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Bikaner Division"
  },
  "332001": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Sikar",
    "officename": "Sikar HO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332002": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Sikar",
    "officename": "Dhod SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332021": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Sikar",
    "officename": "Bajajgram SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332023": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Sikar",
    "officename": "Khoor SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332024": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Sikar",
    "officename": "Katrathal SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332025": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Sikar",
    "officename": "Losal SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332026": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Sikar",
    "officename": "Nechhwa SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332027": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Sikar",
    "officename": "Piprali SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332028": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Sikar",
    "officename": "Sihot Badi SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332029": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Sikar",
    "officename": "Ganeri SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332030": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Sikar",
    "officename": "Singrawat SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332031": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Sikar",
    "officename": "Koodan SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332041": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Sikar",
    "officename": "Phagalwa SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332042": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Sikar",
    "officename": "Tatanwa SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332301": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Fatehpur",
    "officename": "Fatehpur Shekhawati SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332302": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Fatehpur Shekhawati",
    "officename": "Dhandhan SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332303": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Fatehpur",
    "officename": "Beswa SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332304": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Fatehpur",
    "officename": "Rolsabsar SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332305": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Fatehpur",
    "officename": "Sadinsar SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332307": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Fatehpur",
    "officename": "Tihawali SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332311": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Fatehpur",
    "officename": "Lachhmangarh SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332312": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Sikar",
    "officename": "Patoda SO Sikar",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332315": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Fatehpur",
    "officename": "Khuri Badi SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332316": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Fatehpur Shekhawati",
    "officename": "Beedasar SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332317": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Fatehpur",
    "officename": "Roru Badi SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332318": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Fatehpur",
    "officename": "Jajod SO Lachhmangarh",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332401": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Fatehpur",
    "officename": "Balaran SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332402": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Sikar",
    "officename": "Palsana SO Sikar",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332403": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Sikar",
    "officename": "Ranoli SO Sikar",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332404": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Srimadhopur",
    "officename": "Ringas SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332405": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Sikar",
    "officename": "Shishu SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332406": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Sikar",
    "officename": "Kochhore SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332411": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Srimadhopur",
    "officename": "Baori SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332601": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Srimadhopur",
    "officename": "Baya SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332602": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Srimadhopur",
    "officename": "Khatushyamjika SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332603": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Srimadhopur",
    "officename": "Mahroli SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332701": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Srimadhopur",
    "officename": "Ajitgarh Amarsar SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332702": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Srimadhopur",
    "officename": "Danta SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332703": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Srimadhopur",
    "officename": "Danta Ramgarh SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332705": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Nimkathana",
    "officename": "Ganeshwar SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332706": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Nimkathana",
    "officename": "Guhala SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332707": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Nimkathana",
    "officename": "Jharli SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332708": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Nimkathana",
    "officename": "Kanwat Town SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332709": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Nimkathana",
    "officename": "Khandela SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332710": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Danta Ramgarh",
    "officename": "Khachariawas SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332711": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Nimkathana",
    "officename": "Maonda RS SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332712": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Srimadhopur",
    "officename": "Mundru SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332713": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Nimkathana",
    "officename": "Nimkathana Town SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332714": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Nimkathana",
    "officename": "Sirohi SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332715": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Srimadhopur",
    "officename": "Srimadhopur HO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332716": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Khetri",
    "officename": "Sefragunwar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "332718": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Nimkathana",
    "officename": "Patan SO Sikar",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332719": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Nimkathana",
    "officename": "Thoi SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332721": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Nimkathana",
    "officename": "Gurara SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332722": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Srimadhopur",
    "officename": "Jajod SO Srimadhopur",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332742": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Srimadhopur",
    "officename": "Mandha Surera SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sikar Division"
  },
  "332746": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Khetri",
    "officename": "Shimala S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333001": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Jhunjhunu",
    "officename": "Jhunjhunu H.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333011": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Jhunjhunu",
    "officename": "Dhanuri S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333012": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Udaiprwati",
    "officename": "Titanwar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333021": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Udaipurwati",
    "officename": "Baragaon (Jhunjhunu)S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333022": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Udaipurwati",
    "officename": "Gudhagorjika S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333023": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Jhunjhunu",
    "officename": "Bagar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333024": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Jhunjhunun",
    "officename": "Islampur S.O (Jhujhunu)",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333025": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Chirawa",
    "officename": "Mandrella S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333026": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Chirawa",
    "officename": "Chirawa H.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333027": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Chirawa",
    "officename": "Ardawata S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333028": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Chirawa",
    "officename": "Sultana S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333029": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Surajgarh",
    "officename": "Surajgarh S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333030": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Surajgarh",
    "officename": "Kajara S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333031": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Chirawa",
    "officename": "Pilani S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333032": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Udaipurwati",
    "officename": "Bhorki S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333033": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Surajgarh",
    "officename": "Jakhod S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333034": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Khetri",
    "officename": "Kuharwas S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333035": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Chirawa",
    "officename": "Narhar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333036": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Khetri",
    "officename": "Tibabasai S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333041": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Jhunjhunu",
    "officename": "Nua S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333042": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Nawalgarh",
    "officename": "Nawalgarh S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333053": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Udaipurwati",
    "officename": "Ponkh S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333302": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Udaipurwati",
    "officename": "Chhapoli S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333303": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Udaipurwati",
    "officename": "Chirana S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333304": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Nawalgarh",
    "officename": "Jhajhar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333305": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Nawalgarh",
    "officename": "Jakhal S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333307": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Udaipurwati",
    "officename": "Udaipurwati S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333308": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Nawalgarh",
    "officename": "Parasrampura S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333501": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Khetri",
    "officename": "Babai S.O (Jhujhunu)",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333502": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Buhana",
    "officename": "Buhana S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333503": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Khetri",
    "officename": "Khetri S.O (Jhujhunu)",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333504": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Khetri",
    "officename": "Khetri Nagar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333514": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Khetri",
    "officename": "Jasrapur S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333515": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Buhana",
    "officename": "Pacheri Badi S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333516": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Buhaana",
    "officename": "Singhana S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333701": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Jhunjhunun",
    "officename": "Churiajitgarh S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333702": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Nawlgarh",
    "officename": "Dundlod S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333704": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Jhunjhunun",
    "officename": "Mandawa S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333705": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Nawalgarh",
    "officename": "Mukundgarh S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333707": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Nawalgarh",
    "officename": "Doomra S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333801": {
    "state": "Rajasthan",
    "district": "Jhujhunu",
    "block": "Udaipurwati",
    "officename": "Saraisurpura S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "334001": {
    "state": "Rajasthan",
    "district": "Bikaner",
    "block": "Bikaner",
    "officename": "Bikaner H.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Bikaner Division"
  },
  "334003": {
    "state": "Rajasthan",
    "district": "Bikaner",
    "block": "Bikaner",
    "officename": "Pawanpuri S.O (Bikaner)",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Bikaner Division"
  },
  "334004": {
    "state": "Rajasthan",
    "district": "Bikaner",
    "block": "Bikaner",
    "officename": "Bangalanagar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Bikaner Division"
  },
  "334006": {
    "state": "Rajasthan",
    "district": "Bikaner",
    "block": "Bikaner",
    "officename": "Bichhwal Ind.Area S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Bikaner Division"
  },
  "334021": {
    "state": "Rajasthan",
    "district": "Bikaner",
    "block": "Chhatargarh",
    "officename": "Chhatararh S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Bikaner Division"
  },
  "334022": {
    "state": "Rajasthan",
    "district": "Bikaner",
    "block": "Bikaner",
    "officename": "Udasar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Bikaner Division"
  },
  "334023": {
    "state": "Rajasthan",
    "district": "Bikaner",
    "block": "Bikaner",
    "officename": "Khajuwala S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Bikaner Division"
  },
  "334201": {
    "state": "Rajasthan",
    "district": "Bikaner",
    "block": "Bikaner",
    "officename": "Napasar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Bikaner Division"
  },
  "334202": {
    "state": "Rajasthan",
    "district": "Bikaner",
    "block": "Bikaner",
    "officename": "Sinthal S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Bikaner Division"
  },
  "334302": {
    "state": "Rajasthan",
    "district": "Bikaner",
    "block": "Bikaner",
    "officename": "Sri Kolayat Ji S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Bikaner Division"
  },
  "334303": {
    "state": "Rajasthan",
    "district": "Bikaner",
    "block": "Bikaner",
    "officename": "Diyatra S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Bikaner Division"
  },
  "334305": {
    "state": "Rajasthan",
    "district": "Bikaner",
    "block": "Bikaner",
    "officename": "Bajju S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Bikaner Division"
  },
  "334401": {
    "state": "Rajasthan",
    "district": "Bikaner",
    "block": "Bikaner",
    "officename": "Gangashahar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Bikaner Division"
  },
  "334402": {
    "state": "Rajasthan",
    "district": "Bikaner",
    "block": "Bikaner",
    "officename": "Udairamsar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Bikaner Division"
  },
  "334403": {
    "state": "Rajasthan",
    "district": "Bikaner",
    "block": "Bikaner",
    "officename": "Bhinasar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Bikaner Division"
  },
  "334601": {
    "state": "Rajasthan",
    "district": "Bikaner",
    "block": "Bikaner",
    "officename": "Jamsar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Bikaner Division"
  },
  "334602": {
    "state": "Rajasthan",
    "district": "Bikaner",
    "block": "Bikaner",
    "officename": "Kalu S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Bikaner Division"
  },
  "334603": {
    "state": "Rajasthan",
    "district": "Bikaner",
    "block": "Bikaner",
    "officename": "Lunkaransar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Bikaner Division"
  },
  "334604": {
    "state": "Rajasthan",
    "district": "Bikaner",
    "block": "Bikaner",
    "officename": "Mahajan S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Bikaner Division"
  },
  "334801": {
    "state": "Rajasthan",
    "district": "Bikaner",
    "block": "Bikaner",
    "officename": "Deshnoke S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Bikaner Division"
  },
  "334802": {
    "state": "Rajasthan",
    "district": "Bikaner",
    "block": "Bikaner",
    "officename": "Himatsar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Bikaner Division"
  },
  "334803": {
    "state": "Rajasthan",
    "district": "Bikaner",
    "block": "Bikaner",
    "officename": "Nokha S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Bikaner Division"
  },
  "334804": {
    "state": "Rajasthan",
    "district": "Bikaner",
    "block": "Bikaner",
    "officename": "Panchoo S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Bikaner Division"
  },
  "334808": {
    "state": "Rajasthan",
    "district": "Bikaner",
    "block": "Bikaner",
    "officename": "Pugal S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Bikaner Division"
  },
  "335001": {
    "state": "Rajasthan",
    "district": "Ganganagar",
    "block": "Sriganganagar",
    "officename": "Sriganganagar H.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335002": {
    "state": "Rajasthan",
    "district": "Ganganagar",
    "block": "Sriganganagar",
    "officename": "Udyog Vihar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335021": {
    "state": "Rajasthan",
    "district": "Ganganagar",
    "block": "Raisinghnagar",
    "officename": "Bishanpura S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335022": {
    "state": "Rajasthan",
    "district": "Ganganagar",
    "block": "Sriganganagar",
    "officename": "Chunawadh S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335024": {
    "state": "Rajasthan",
    "district": "Ganganagar",
    "block": "Gajsinghpur",
    "officename": "Gajsinghpur S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335025": {
    "state": "Rajasthan",
    "district": "Ganganagar",
    "block": "Sadulsahar",
    "officename": "Ganeshgarh S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335027": {
    "state": "Rajasthan",
    "district": "Ganganagar",
    "block": "Kesrisinghpur",
    "officename": "Kesrisinghpur S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335037": {
    "state": "Rajasthan",
    "district": "Ganganagar",
    "block": "Sadulshahar",
    "officename": "Lalgarh Jatan S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335038": {
    "state": "Rajasthan",
    "district": "Ganganagar",
    "block": "Sriganganagar",
    "officename": "Mirzewala S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335039": {
    "state": "Rajasthan",
    "district": "Ganganagar",
    "block": "Raisinghnagar",
    "officename": "Mukalawa S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335040": {
    "state": "Rajasthan",
    "district": "Ganganagar",
    "block": "Padampur",
    "officename": "Nizampura S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335041": {
    "state": "Rajasthan",
    "district": "Ganganagar",
    "block": "Padampur",
    "officename": "Padampur S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335051": {
    "state": "Rajasthan",
    "district": "Ganganagar",
    "block": "Raisinghnagar",
    "officename": "Raisinghnagar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335061": {
    "state": "Rajasthan",
    "district": "Ganganagar",
    "block": "Padampur",
    "officename": "Ridmalsar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335062": {
    "state": "Rajasthan",
    "district": "Ganganagar",
    "block": "Sadulshahar",
    "officename": "Sadulshahar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335063": {
    "state": "Rajasthan",
    "district": "Hanumangarh",
    "block": "Sangaria",
    "officename": "Sangaria S.O (Hanumangarh)",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335064": {
    "state": "Rajasthan",
    "district": "Hanumangarh",
    "block": "Hanumangarh",
    "officename": "Dholipal S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335065": {
    "state": "Rajasthan",
    "district": "Ganganagar",
    "block": "Suratgarh",
    "officename": "Manaksar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335073": {
    "state": "Rajasthan",
    "district": "Ganganagar",
    "block": "Srikaranpur",
    "officename": "Srikaranpur S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335501": {
    "state": "Rajasthan",
    "district": "Hanumangarh",
    "block": "Bhadra",
    "officename": "Bhadra S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335502": {
    "state": "Rajasthan",
    "district": "Hanumangarh",
    "block": "Bhadra",
    "officename": "Kalana S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335503": {
    "state": "Rajasthan",
    "district": "Hanumangarh",
    "block": "Bhadra",
    "officename": "Dabri S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335504": {
    "state": "Rajasthan",
    "district": "Hanumangarh",
    "block": "Nohar",
    "officename": "Gogameri S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335511": {
    "state": "Rajasthan",
    "district": "Hanumangarh",
    "block": "Bhadra",
    "officename": "Channibari S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335512": {
    "state": "Rajasthan",
    "district": "Hanumangarh",
    "block": "Hanumangarh Jn.",
    "officename": "Hanumangarh Jn. H.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335513": {
    "state": "Rajasthan",
    "district": "Hanumangarh",
    "block": "Hanumangarh",
    "officename": "Hanumangarh Town S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335523": {
    "state": "Rajasthan",
    "district": "Hanumangarh",
    "block": "Nohar",
    "officename": "Nohar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335524": {
    "state": "Rajasthan",
    "district": "Hanumangarh",
    "block": "Rawatsar",
    "officename": "Rawatsar S.O (Hanumangarh)",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335525": {
    "state": "Rajasthan",
    "district": "Hanumangarh",
    "block": "Tibbi",
    "officename": "Talwara Jheel S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335526": {
    "state": "Rajasthan",
    "district": "Hanumangarh",
    "block": "Tibbi",
    "officename": "Tibbi S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335701": {
    "state": "Rajasthan",
    "district": "Ganganagar",
    "block": "Anupgarh",
    "officename": "Anupgarh S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335702": {
    "state": "Rajasthan",
    "district": "Ganganagar",
    "block": "Sribijenagar",
    "officename": "Jetsar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335703": {
    "state": "Rajasthan",
    "district": "Ganganagar",
    "block": "Sribijeynagar",
    "officename": "Ramsinghpur S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335704": {
    "state": "Rajasthan",
    "district": "Ganganagar",
    "block": "Sribijaynagar",
    "officename": "Sribijaynagar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335707": {
    "state": "Rajasthan",
    "district": "Ganganagar",
    "block": "Gharsana",
    "officename": "Gharsana S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335711": {
    "state": "Rajasthan",
    "district": "Ganganagar",
    "block": "Gharsana",
    "officename": "Mandi Gharsana S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335801": {
    "state": "Rajasthan",
    "district": "Hanumangarh",
    "block": "Bhadra",
    "officename": "Dabli Rathan S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335802": {
    "state": "Rajasthan",
    "district": "Hanumangarh",
    "block": "Pilibanga",
    "officename": "Goluwala S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335803": {
    "state": "Rajasthan",
    "district": "Hanumangarh",
    "block": "Pilibangan",
    "officename": "Pilibangan S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335804": {
    "state": "Rajasthan",
    "district": "Ganganagar",
    "block": "Suratgarh",
    "officename": "Suratgarh S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335805": {
    "state": "Rajasthan",
    "district": "Ganganagar",
    "block": "Suratgarh",
    "officename": "STPS Suratgarh S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335901": {
    "state": "Rajasthan",
    "district": "Ganganagar",
    "block": "Kesrisinghpur",
    "officename": "Hindumalkote S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "341001": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Nagaur",
    "officename": "Nagaur H.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341021": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Nagaur",
    "officename": "Basni S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341022": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Nagaur",
    "officename": "Deh S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341023": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Jael",
    "officename": "Jael S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341024": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Nagaur",
    "officename": "Kuchera S.O (Nagaur)",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341025": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Khinwsar",
    "officename": "Khinwsar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341026": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Nagaur",
    "officename": "Marwar Mundwa S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341027": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Nagaur",
    "officename": "Rol S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341028": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Mundwa",
    "officename": "Khajwana S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341029": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Nagaur",
    "officename": "Sribalaji S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341030": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Nagaur",
    "officename": "Tarnau S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341031": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Nagaur",
    "officename": "Padukallan S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341301": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Didwana",
    "officename": "Bari Khatu S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341302": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Degana",
    "officename": "Chhotikhatu S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341303": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Didwana",
    "officename": "Didwana H.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341304": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Ladnun",
    "officename": "Jaswantgarh S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341305": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Didwana",
    "officename": "Koliya S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341306": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Ladnun",
    "officename": "Ladnun Lsg S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341316": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Ladnun",
    "officename": "Nimbijodhan S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341317": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Ladnun",
    "officename": "Ratau S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341318": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Degana",
    "officename": "Khunkhuna S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341319": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Degana",
    "officename": "Toshina S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341501": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Degana",
    "officename": "Badu S.O (Nagaur)",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341502": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Parbatsar",
    "officename": "Borawar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341503": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Degana",
    "officename": "Degana S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341504": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Degana",
    "officename": "Gachhipura S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341505": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Parbatsar",
    "officename": "Makrana Rs S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341506": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Didwana",
    "officename": "Maulasar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341507": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Nawacity",
    "officename": "Maroth S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341508": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Nawacity",
    "officename": "Kuchamancity S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341509": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Nawacity",
    "officename": "Nawacity Lsg S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341510": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Merta",
    "officename": "Merta S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341511": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Merta",
    "officename": "Merta Road S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341512": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Parbatsar",
    "officename": "Parbatsar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341513": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Merta",
    "officename": "Riyan S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341514": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Merta",
    "officename": "Ren S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341515": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Degana",
    "officename": "Harsore S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341516": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Didwana",
    "officename": "Dhankoli S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341517": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Ladnun",
    "officename": "Ladariya S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341518": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Merta",
    "officename": "Jasnagar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341519": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Nawacity",
    "officename": "Kukanwali S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341520": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Degana",
    "officename": "Besroli S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341533": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Nawacity",
    "officename": "Mithri S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341551": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Didwana",
    "officename": "Berichhoti S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "342001": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Jodhpur",
    "officename": "Jodhpur HO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342003": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Jodhpur",
    "officename": "Jodhpur Shastri Nagar SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342005": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Jodhpur",
    "officename": "Jodhpur KUM Bhagat Ki Kothi SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342006": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Jodhpur",
    "officename": "Jodhpur Kachery SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342007": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Jodhpur",
    "officename": "Jodhpur KUM Mandore Road SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342008": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Jodhpur",
    "officename": "Nandanwan SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342011": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Jodhpur",
    "officename": "Jodhpur Residency Road SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342012": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Asop",
    "officename": "Boranada SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342013": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Jodhpur",
    "officename": "Sangaria SO Jodhpur",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342014": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Jodhpur",
    "officename": "Pal SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342015": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Jodhpur",
    "officename": "Saran Nagar SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342021": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Setrawa",
    "officename": "Somesar SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342022": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Jodhpur",
    "officename": "Shergarh SO Jodhpur",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342023": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Jodhpur",
    "officename": "Balesar SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342024": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Asop",
    "officename": "Soorsagar SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342025": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Setrawa",
    "officename": "Setrawa SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342026": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Jodhpur",
    "officename": "Jodhpur BSF Trg Centre SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342027": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Jodhpur",
    "officename": "Banar SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342028": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Tena",
    "officename": "Tena SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342037": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Lavera Baori",
    "officename": "Lavera Baori SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342301": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Phalodi",
    "officename": "Phalodi SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jaisalmer Division"
  },
  "342302": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Lohawat",
    "officename": "Lohawat SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342303": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Osian",
    "officename": "Osian SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342304": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Jodhpur",
    "officename": "Mandore SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342305": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Mathania",
    "officename": "Mathania SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342306": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Teori",
    "officename": "Teori SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342307": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Jodhpur",
    "officename": "Bap SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jaisalmer Division"
  },
  "342308": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Khichan",
    "officename": "Khichan SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jaisalmer Division"
  },
  "342309": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Peelwa",
    "officename": "Peelwa SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342310": {
    "state": "Rajasthan",
    "district": "Jaisalmer",
    "block": "Jaisalmer",
    "officename": "Nokh SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jaisalmer Division"
  },
  "342311": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Aau",
    "officename": "Aau SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jaisalmer Division"
  },
  "342312": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Chadi",
    "officename": "Chadi SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342314": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Jodhpur",
    "officename": "Dechu SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342601": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Pipar",
    "officename": "Pipar SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342602": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Bilara",
    "officename": "Bilara SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342603": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Bhopalgarh",
    "officename": "Bhopalgarh SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342604": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Jodhpur",
    "officename": "Borunda SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342605": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Bhavi",
    "officename": "Bhavi SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342606": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Pipar Road",
    "officename": "Pipar Road SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342801": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Dunara",
    "officename": "Dunara SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342802": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Shergarh",
    "officename": "Luni SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342901": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Asop",
    "officename": "Asop SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342902": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Merta",
    "officename": "Gotan S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "343001": {
    "state": "Rajasthan",
    "district": "Jalor",
    "block": "Ahore",
    "officename": "Jalore H.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "343002": {
    "state": "Rajasthan",
    "district": "Jalor",
    "block": "Ahore",
    "officename": "I.A.Jalore S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "343021": {
    "state": "Rajasthan",
    "district": "Jalor",
    "block": "Ahore",
    "officename": "Ummedabad S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "343022": {
    "state": "Rajasthan",
    "district": "Jalor",
    "block": "Ahore",
    "officename": "Sayla S.O (Jalor)",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "343023": {
    "state": "Rajasthan",
    "district": "Jalor",
    "block": "Ahore",
    "officename": "Dhansa S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "343024": {
    "state": "Rajasthan",
    "district": "Jalor",
    "block": "Ahore",
    "officename": "Siana S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "343025": {
    "state": "Rajasthan",
    "district": "Jalor",
    "block": "Sanchore",
    "officename": "Bagra S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "343027": {
    "state": "Rajasthan",
    "district": "Jalor",
    "block": "Ahore",
    "officename": "Hadecha S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "343028": {
    "state": "Rajasthan",
    "district": "Jalor",
    "block": "Ahore",
    "officename": "Modran S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "343029": {
    "state": "Rajasthan",
    "district": "Jalor",
    "block": "Bhinmal",
    "officename": "Bhinmal S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "343030": {
    "state": "Rajasthan",
    "district": "Jalor",
    "block": "Ahore",
    "officename": "Joojani S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "343032": {
    "state": "Rajasthan",
    "district": "Jalor",
    "block": "Jalore",
    "officename": "Bagoda S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "343039": {
    "state": "Rajasthan",
    "district": "Jalor",
    "block": "Ahore",
    "officename": "Malwara S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "343040": {
    "state": "Rajasthan",
    "district": "Jalor",
    "block": "Ahore",
    "officename": "Raniwara S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "343041": {
    "state": "Rajasthan",
    "district": "Jalor",
    "block": "Ahore",
    "officename": "Sanchore S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "343042": {
    "state": "Rajasthan",
    "district": "Jalor",
    "block": "Ahore",
    "officename": "Mandwala S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "343048": {
    "state": "Rajasthan",
    "district": "Jalor",
    "block": "Ahore",
    "officename": "Vadgaon S.O (Jalor)",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "343049": {
    "state": "Rajasthan",
    "district": "Jalor",
    "block": "Ahore",
    "officename": "Kagmala S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "344001": {
    "state": "Rajasthan",
    "district": "Barmer",
    "block": "Barmer",
    "officename": "Barmer H.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Barmer Division"
  },
  "344011": {
    "state": "Rajasthan",
    "district": "Barmer",
    "block": "Bishala",
    "officename": "Bishala S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Barmer Division"
  },
  "344012": {
    "state": "Rajasthan",
    "district": "Barmer",
    "block": "Ranigaon",
    "officename": "Ranigaon S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Barmer Division"
  },
  "344021": {
    "state": "Rajasthan",
    "district": "Barmer",
    "block": "Samdari",
    "officename": "Samdari S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Barmer Division"
  },
  "344022": {
    "state": "Rajasthan",
    "district": "Barmer",
    "block": "Balotra",
    "officename": "Balotra S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Barmer Division"
  },
  "344024": {
    "state": "Rajasthan",
    "district": "Barmer",
    "block": "Jasol",
    "officename": "Jasol S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Barmer Division"
  },
  "344025": {
    "state": "Rajasthan",
    "district": "Barmer",
    "block": "Mewanagar",
    "officename": "Mewanagar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Barmer Division"
  },
  "344026": {
    "state": "Rajasthan",
    "district": "Barmer",
    "block": "Kalyanpur",
    "officename": "Kalyanpur S.O (Barmer)",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Barmer Division"
  },
  "344027": {
    "state": "Rajasthan",
    "district": "Barmer",
    "block": "P;arlu",
    "officename": "Parlu S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Barmer Division"
  },
  "344031": {
    "state": "Rajasthan",
    "district": "Barmer",
    "block": "Gudamalani",
    "officename": "Gudamalani S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Barmer Division"
  },
  "344032": {
    "state": "Rajasthan",
    "district": "Barmer",
    "block": "Pachpadra City",
    "officename": "Pachpadra City S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Barmer Division"
  },
  "344033": {
    "state": "Rajasthan",
    "district": "Barmer",
    "block": "Sindhari",
    "officename": "Sindhari S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Barmer Division"
  },
  "344034": {
    "state": "Rajasthan",
    "district": "Barmer",
    "block": "Baitu",
    "officename": "Baitu S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Barmer Division"
  },
  "344035": {
    "state": "Rajasthan",
    "district": "Barmer",
    "block": "Kavas",
    "officename": "Kavas S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Barmer Division"
  },
  "344037": {
    "state": "Rajasthan",
    "district": "Barmer",
    "block": "Swau Padamsingh",
    "officename": "Swau Padamsingh S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Barmer Division"
  },
  "344043": {
    "state": "Rajasthan",
    "district": "Barmer",
    "block": "Mokalsar",
    "officename": "Mokalsar S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Barmer Division"
  },
  "344044": {
    "state": "Rajasthan",
    "district": "Barmer",
    "block": "Siwana",
    "officename": "Siwana S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Barmer Division"
  },
  "344501": {
    "state": "Rajasthan",
    "district": "Barmer",
    "block": "Gadra Road",
    "officename": "Gadra Road S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Barmer Division"
  },
  "344502": {
    "state": "Rajasthan",
    "district": "Barmer",
    "block": "Ramsar",
    "officename": "Ramsar S.O (Barmer)",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Barmer Division"
  },
  "344701": {
    "state": "Rajasthan",
    "district": "Barmer",
    "block": "Gunga",
    "officename": "Shiv S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Barmer Division"
  },
  "344702": {
    "state": "Rajasthan",
    "district": "Barmer",
    "block": "Chohtan",
    "officename": "Chohtan S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Barmer Division"
  },
  "344703": {
    "state": "Rajasthan",
    "district": "Barmer",
    "block": "Rawatsar",
    "officename": "Rawatsar S.O (Barmer)",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Barmer Division"
  },
  "344704": {
    "state": "Rajasthan",
    "district": "Barmer",
    "block": "Dhorimana",
    "officename": "Dhorimana S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Barmer Division"
  },
  "344705": {
    "state": "Rajasthan",
    "district": "Barmer",
    "block": "Gunga",
    "officename": "Gunga S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Barmer Division"
  },
  "344706": {
    "state": "Rajasthan",
    "district": "Barmer",
    "block": "Sedwa",
    "officename": "Sedwa S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Barmer Division"
  },
  "344708": {
    "state": "Rajasthan",
    "district": "Barmer",
    "block": "Dhorimana",
    "officename": "Sanawara S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Barmer Division"
  },
  "344801": {
    "state": "Rajasthan",
    "district": "Barmer",
    "block": "Padru",
    "officename": "Padru S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Barmer Division"
  },
  "345001": {
    "state": "Rajasthan",
    "district": "Jaisalmer",
    "block": "Jaisalmer",
    "officename": "Jaisalmer HO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jaisalmer Division"
  },
  "345021": {
    "state": "Rajasthan",
    "district": "Jaisalmer",
    "block": "Jaisalmer",
    "officename": "Pokaran SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jaisalmer Division"
  },
  "345022": {
    "state": "Rajasthan",
    "district": "Jaisalmer",
    "block": "Jaisalmer",
    "officename": "Ramgarh SO Jaisalmer",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jaisalmer Division"
  },
  "345023": {
    "state": "Rajasthan",
    "district": "Jaisalmer",
    "block": "Jaisalmer",
    "officename": "Ramdeora SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jaisalmer Division"
  },
  "345024": {
    "state": "Rajasthan",
    "district": "Jaisalmer",
    "block": "Jaisalmer",
    "officename": "Bhaniyana SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jaisalmer Division"
  },
  "345025": {
    "state": "Rajasthan",
    "district": "Jaisalmer",
    "block": "Jaisalmer",
    "officename": "Phalsund SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jaisalmer Division"
  },
  "345026": {
    "state": "Rajasthan",
    "district": "Jaisalmer",
    "block": "Jaisalmer",
    "officename": "Sankra SO Jaisalmer",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jaisalmer Division"
  },
  "345027": {
    "state": "Rajasthan",
    "district": "Jaisalmer",
    "block": "Jaisalmer",
    "officename": "Fatehgarh SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jaisalmer Division"
  },
  "345028": {
    "state": "Rajasthan",
    "district": "Jaisalmer",
    "block": "Jaisalmer",
    "officename": "Nachana SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jaisalmer Division"
  },
  "345031": {
    "state": "Rajasthan",
    "district": "Jaisalmer",
    "block": "Jaisalmer",
    "officename": "Lathi SO Jaisalmer",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jaisalmer Division"
  },
  "345033": {
    "state": "Rajasthan",
    "district": "Jaisalmer",
    "block": "Jaisalmer",
    "officename": "Mohangarh SO Jaisalmer",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jaisalmer Division"
  },
  "345034": {
    "state": "Rajasthan",
    "district": "Jaisalmer",
    "block": "Jaisalmer",
    "officename": "Khoohri SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jaisalmer Division"
  },
  "360001": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Rajkot",
    "officename": "Rajkot HO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Rajkot Division"
  },
  "360002": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Rajkot",
    "officename": "Rajkot Bhaktinagar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Rajkot Division"
  },
  "360003": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Rajkot",
    "officename": "Rajkot Bedipara SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Rajkot Division"
  },
  "360004": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Rajkot",
    "officename": "Rajkot Postal Colony SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Rajkot Division"
  },
  "360005": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Rajkot",
    "officename": "Rajkot Sau Uni Area SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Rajkot Division"
  },
  "360006": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Rajkot",
    "officename": "Rajkot Madhapar DSO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Rajkot Division"
  },
  "360007": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Rajkot",
    "officename": "Rajkot Raiya Road SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Rajkot Division"
  },
  "360020": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Rajkot",
    "officename": "Kasturbadham SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Rajkot Division"
  },
  "360021": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Lodhika",
    "officename": "Rajkot Metoda Gidc SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Rajkot Division"
  },
  "360022": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Rajkot",
    "officename": "KOTHARIA SO Rajkot",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Rajkot Division"
  },
  "360023": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Rajkot",
    "officename": "KUVADAVA SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Rajkot Division"
  },
  "360024": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Lodhika",
    "officename": "Veraval Shapar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Rajkot Division"
  },
  "360025": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Rajkot",
    "officename": "Sardhar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Rajkot Division"
  },
  "360030": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Kotda Sangani",
    "officename": "Kotda Sangani SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Gondal Division"
  },
  "360035": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Lodhika",
    "officename": "Lodhika SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Gondal Division"
  },
  "360040": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Jasdan",
    "officename": "Atkot SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Gondal Division"
  },
  "360050": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Jasdan",
    "officename": "Jasdan SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Gondal Division"
  },
  "360055": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Jasdan",
    "officename": "Vinchhiya SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Gondal Division"
  },
  "360060": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Jasdan",
    "officename": "Virnagar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Rajkot Division"
  },
  "360070": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Kotda",
    "officename": "Mengni SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Gondal Division"
  },
  "360110": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Paddhari",
    "officename": "Paddhari SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Rajkot Division"
  },
  "360311": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Gondal",
    "officename": "Gondal HO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Gondal Division"
  },
  "360320": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Gondal",
    "officename": "Gomta SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Gondal Division"
  },
  "360330": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Gondal",
    "officename": "Moviya SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Gondal Division"
  },
  "360360": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Jetpur",
    "officename": "Jetalsar Jn SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Gondal Division"
  },
  "360370": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Jetpur",
    "officename": "Jetpur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Gondal Division"
  },
  "360375": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Jetpur",
    "officename": "Navagadh SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Gondal Division"
  },
  "360380": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Jetpur",
    "officename": "Virpur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Gondal Division"
  },
  "360405": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Jamkandorna",
    "officename": "Jamkandorna SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Gondal Division"
  },
  "360410": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Dhoraji",
    "officename": "Dhoraji SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Gondal Division"
  },
  "360421": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Dhoraji",
    "officename": "Moti Marad SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Gondal Division"
  },
  "360430": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Dhoraji",
    "officename": "Patanvav SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Gondal Division"
  },
  "360440": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Upleta",
    "officename": "Supedi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Gondal Division"
  },
  "360450": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Upleta",
    "officename": "Bhayavadar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Gondal Division"
  },
  "360452": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Jamkandorna",
    "officename": "Chitravad SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Gondal Division"
  },
  "360460": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Upleta",
    "officename": "Dhank SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Gondal Division"
  },
  "360470": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Upleta",
    "officename": "Kolki SO Rajkot",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Gondal Division"
  },
  "360480": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Jamjodhpur",
    "officename": "Paneli SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Gondal Division"
  },
  "360490": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Upleta",
    "officename": "Upleta Lati Plot SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Gondal Division"
  },
  "360510": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Bhanvad",
    "officename": "Bhanvad SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "360515": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Bhanvad",
    "officename": "Verad SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "360520": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Jamjodhpur",
    "officename": "Dhrafa SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "360530": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Jamjodhpur",
    "officename": "Jamjodhpur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "360531": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Jamjodhpur",
    "officename": "Satapar S.O",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "360540": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Kalavad",
    "officename": "Kharedi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "360545": {
    "state": "Gujarat",
    "district": "Porbandar",
    "block": "Porbandar",
    "officename": "Adityana SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Porbandar Division"
  },
  "360550": {
    "state": "Gujarat",
    "district": "Porbandar",
    "block": "Ranavav",
    "officename": "Ranavav SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Porbandar Division"
  },
  "360570": {
    "state": "Gujarat",
    "district": "Porbandar",
    "block": "Kutiyana",
    "officename": "Ranakandorana SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Porbandar Division"
  },
  "360575": {
    "state": "Gujarat",
    "district": "Porbandar",
    "block": "Porbandar",
    "officename": "Porbandar HO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Porbandar Division"
  },
  "360576": {
    "state": "Gujarat",
    "district": "Porbandar",
    "block": "Porbandar",
    "officename": "Porbandar Birla Sagar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Porbandar Division"
  },
  "360577": {
    "state": "Gujarat",
    "district": "Porbandar",
    "block": "Porbandar",
    "officename": "Porbandar Seva Sadan SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Porbandar Division"
  },
  "360578": {
    "state": "Gujarat",
    "district": "Porbandar",
    "block": "Porbandar",
    "officename": "Chhaya SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Porbandar Division"
  },
  "360579": {
    "state": "Gujarat",
    "district": "Porbandar",
    "block": "Porbandar",
    "officename": "Bokhira SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Porbandar Division"
  },
  "360590": {
    "state": "Gujarat",
    "district": "Porbandar",
    "block": "Porbandar",
    "officename": "Bagvadar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Porbandar Division"
  },
  "361001": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Kalavad",
    "officename": "Jamnagar HO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361002": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Kalavad",
    "officename": "Bedeshwar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361003": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Jodiya",
    "officename": "Aerodromme SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361004": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Kalavad",
    "officename": "Udyognagar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361005": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Kalavad",
    "officename": "Digvijay Plot SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361006": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Jamnagar",
    "officename": "Khodiyar Colony SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361007": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Kalavad",
    "officename": "Gulabnagar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361008": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Jamnagar",
    "officename": "Patel Colony SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361009": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Jamnagar",
    "officename": "Bedi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361010": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Khambhalia",
    "officename": "Vadinar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361011": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Jodia",
    "officename": "Hadiana SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361012": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Jamnagar",
    "officename": "Dared S.O",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361013": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Kalavad",
    "officename": "Khandhera SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361110": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Jamnagar",
    "officename": "Aliabada SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361120": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Jamnagar",
    "officename": "Dhuvav SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361130": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Jamnagar",
    "officename": "Jamwanthali SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361140": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Jamnagar",
    "officename": "Digvijay Gram SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361142": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Jamnagar",
    "officename": "Reliance Greens SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361150": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Jamnagar",
    "officename": "Valsura SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361160": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Kalavad",
    "officename": "Kalavad SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361162": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Kalavad",
    "officename": "Nikava SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361170": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Lalpur",
    "officename": "Lalpur SO Jamnagar",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361210": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Dhrol",
    "officename": "Dhrol SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361220": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Dhrol",
    "officename": "Latipur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361230": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Jodia",
    "officename": "Balachadi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361240": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Jodiya",
    "officename": "Balambha SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361250": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Jodia",
    "officename": "Jodia SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361280": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Lalpur",
    "officename": "Kanalush SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361305": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Jamnagar",
    "officename": "Khambhalia SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361306": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Khambhalia",
    "officename": "Bhadthar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361310": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Khambhalia",
    "officename": "Salaya SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361315": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Kalyanpur",
    "officename": "Bhatia SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361320": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Jamkalyanpur",
    "officename": "Jamkalyanpur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361325": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Jamkalyanpur",
    "officename": "Raval SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361330": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Okhamandal",
    "officename": "Bet SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361335": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Okhamandal",
    "officename": "Dwarka SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361345": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Khambhalia",
    "officename": "Mithapur SO Jamnagar",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361347": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Okhamandal",
    "officename": "Surajkaradi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "361350": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Okhamandal",
    "officename": "Okha SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "362001": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Junagadh",
    "officename": "Junagadh HO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362002": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Junagadh",
    "officename": "Junagadh Joshipura SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362011": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Junagadh",
    "officename": "Majevadi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362015": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Junagadh",
    "officename": "Timbavadi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362020": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Junagadh",
    "officename": "Bhesan SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362030": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Junagadh",
    "officename": "RanpurS SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362037": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Junagadh",
    "officename": "Dolatpara SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362110": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Junagadh",
    "officename": "Bilkha SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362120": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Junagadh",
    "officename": "Sarsai SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362130": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Junagadh",
    "officename": "Visavadar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362135": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Junagadh",
    "officename": "Sasan Gir SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362140": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Junagadh",
    "officename": "Akolvadi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362150": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Junagadh",
    "officename": "Talala SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362205": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Junagadh",
    "officename": "ShapurS SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362215": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Junagadh",
    "officename": "Lushala SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362220": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Keshod",
    "officename": "Keshod SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362222": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Keshod",
    "officename": "Agatrai SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362225": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Mangrol",
    "officename": "Mangrol SO Junagadh",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Porbandar Division"
  },
  "362226": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Mangrol",
    "officename": "Mangrol Bundar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Porbandar Division"
  },
  "362227": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Keshod",
    "officename": "Kevadra SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362230": {
    "state": "Gujarat",
    "district": "Porbandar",
    "block": "Porbandar",
    "officename": "Madhavpur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Porbandar Division"
  },
  "362240": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Mangrol",
    "officename": "Shil SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Porbandar Division"
  },
  "362245": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Junagadh",
    "officename": "Malia Hatina SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362250": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Junagadh",
    "officename": "Chorvad SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362255": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Junagadh",
    "officename": "Sherbaug SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362260": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Junagadh",
    "officename": "Mendarda SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362263": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Junagadh",
    "officename": "Bagdu SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362265": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Patan-Veraval",
    "officename": "Veraval SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362268": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Junagadh",
    "officename": "Prabhas Patan SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362269": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Junagadh",
    "officename": "Inaj BO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362275": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Junagadh",
    "officename": "Sutrapada SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362310": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Junagadh",
    "officename": "Vadal SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362315": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Junagadh",
    "officename": "Choki SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362510": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Una",
    "officename": "Delvada SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362520": {
    "state": "Daman & Diu",
    "district": "Diu",
    "block": "Diu",
    "officename": "Diu SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362530": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Una",
    "officename": "Girgadhda SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362540": {
    "state": "Daman & Diu",
    "district": "Diu",
    "block": "Diu U.T.",
    "officename": "Ghoghla SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362550": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Una",
    "officename": "Sanakhda SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362560": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Una",
    "officename": "Una SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362565": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Una",
    "officename": "Dhokadva SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362570": {
    "state": "Daman & Diu",
    "district": "Diu",
    "block": "Diu",
    "officename": "Wanakbara SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362610": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Junagadh",
    "officename": "VanthaliS SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362620": {
    "state": "Gujarat",
    "district": "Porbandar",
    "block": "Kutiyana",
    "officename": "Bantwa SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Porbandar Division"
  },
  "362625": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Manavadar",
    "officename": "Nanadia SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Porbandar Division"
  },
  "362630": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Manavadar",
    "officename": "Manavadar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Porbandar Division"
  },
  "362640": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Manavadar",
    "officename": "Sardargadh SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Porbandar Division"
  },
  "362650": {
    "state": "Gujarat",
    "district": "Porbandar",
    "block": "Kutiyana",
    "officename": "Kutiyana S.O",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Porbandar Division"
  },
  "362710": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Junagadh",
    "officename": "Ghantvad SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362715": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Kodinar",
    "officename": "Ambujanagar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "362720": {
    "state": "Gujarat",
    "district": "Junagadh",
    "block": "Kodinar",
    "officename": "Kodinar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Junagadh Division"
  },
  "363001": {
    "state": "Gujarat",
    "district": "Surendra Nagar",
    "block": "Wadhwanicity",
    "officename": "Surendranagar HO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Surendranagar Division"
  },
  "363020": {
    "state": "Gujarat",
    "district": "Surendra Nagar",
    "block": "Wadhwan",
    "officename": "Joravarnagar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Surendranagar Division"
  },
  "363030": {
    "state": "Gujarat",
    "district": "Surendra Nagar",
    "block": "Wadhwancity",
    "officename": "Wadhwancity SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Surendranagar Division"
  },
  "363040": {
    "state": "Gujarat",
    "district": "Surendra Nagar",
    "block": "Wadhwancity",
    "officename": "Dudhrej SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Surendranagar Division"
  },
  "363110": {
    "state": "Gujarat",
    "district": "Surendra Nagar",
    "block": "Lakhtar",
    "officename": "Vana SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Surendranagar Division"
  },
  "363115": {
    "state": "Gujarat",
    "district": "Surendra Nagar",
    "block": "Lakhtar",
    "officename": "VITHALGADH SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Surendranagar Division"
  },
  "363310": {
    "state": "Gujarat",
    "district": "Surendra Nagar",
    "block": "Dhrangadhra",
    "officename": "Dhrangadhra SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Surendranagar Division"
  },
  "363320": {
    "state": "Gujarat",
    "district": "Surendra Nagar",
    "block": "Dhrangadhra",
    "officename": "Rajsitapur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Surendranagar Division"
  },
  "363330": {
    "state": "Gujarat",
    "district": "Surendra Nagar",
    "block": "Halvad",
    "officename": "Halvad SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Surendranagar Division"
  },
  "363351": {
    "state": "Gujarat",
    "district": "Surendra Nagar",
    "block": "Halvad",
    "officename": "Mayurnagar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Surendranagar Division"
  },
  "363410": {
    "state": "Gujarat",
    "district": "Surendra Nagar",
    "block": "Limbdi",
    "officename": "Chuda SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Surendranagar Division"
  },
  "363421": {
    "state": "Gujarat",
    "district": "Surendra Nagar",
    "block": "Limbdi",
    "officename": "Limbdi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Surendranagar Division"
  },
  "363423": {
    "state": "Gujarat",
    "district": "Surendra Nagar",
    "block": "Limbdi",
    "officename": "Panshina SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Surendranagar Division"
  },
  "363427": {
    "state": "Gujarat",
    "district": "Surendra Nagar",
    "block": "Limbdi",
    "officename": "Shiyani SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Surendranagar Division"
  },
  "363430": {
    "state": "Gujarat",
    "district": "Surendra Nagar",
    "block": "Sayla",
    "officename": "Sayla SO Surendra Nagar",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Surendranagar Division"
  },
  "363435": {
    "state": "Gujarat",
    "district": "Surendra Nagar",
    "block": "Wadhwancity",
    "officename": "Kholadiyad SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Surendranagar Division"
  },
  "363440": {
    "state": "Gujarat",
    "district": "Surendra Nagar",
    "block": "Sayla",
    "officename": "Sudamada SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Surendranagar Division"
  },
  "363510": {
    "state": "Gujarat",
    "district": "Surendra Nagar",
    "block": "Muli",
    "officename": "Muli SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Surendranagar Division"
  },
  "363520": {
    "state": "Gujarat",
    "district": "Surendra Nagar",
    "block": "Chotila",
    "officename": "Chotila SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Surendranagar Division"
  },
  "363530": {
    "state": "Gujarat",
    "district": "Surendra Nagar",
    "block": "Chotila",
    "officename": "Thangadh SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Surendranagar Division"
  },
  "363621": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Wankaner",
    "officename": "Wankaner SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Rajkot Division"
  },
  "363630": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Morvi",
    "officename": "Jetpar M SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Rajkot Division"
  },
  "363641": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Morbi",
    "officename": "Morbi MDG SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Rajkot Division"
  },
  "363642": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Morbi",
    "officename": "Morbi Lal Baug SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Rajkot Division"
  },
  "363650": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Tankara",
    "officename": "Tankara SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Rajkot Division"
  },
  "363655": {
    "state": "Gujarat",
    "district": "Jamnagar",
    "block": "Jodia",
    "officename": "Amran SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Jamnagar Division"
  },
  "363660": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Dahisara",
    "officename": "Dahisara SO Rajkot",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Rajkot Division"
  },
  "363670": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Maliya Miyana",
    "officename": "Maliya Miyana SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Rajkot Division"
  },
  "364001": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Bhavnagar",
    "officename": "Bhavnagar HO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364002": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Bhavnagar",
    "officename": "Bhavnagar Takhteshwar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364003": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Bhavnagar",
    "officename": "Bhavnagar Para SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364004": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Bhavnagar",
    "officename": "Bhavnagar Chitra SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364005": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Bhavnagar",
    "officename": "Bhavnagar Anandnagar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364006": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Bhavnagar",
    "officename": "Bhavnagar Station Road SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364050": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Bhavnagar",
    "officename": "Bhandariya SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364060": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Bhavnagar",
    "officename": "Vartej SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364070": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Bhavnagar",
    "officename": "Koliyak SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364081": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Talaja",
    "officename": "Alang SBY SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364110": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Gogha",
    "officename": "Gogha SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364120": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Gogha",
    "officename": "Tansa SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364130": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Talaja",
    "officename": "Datha SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364135": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Talaja",
    "officename": "Pithalpur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364140": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Talaja",
    "officename": "Talaja SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364145": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Talaja",
    "officename": "Thaliya SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364150": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Talaja",
    "officename": "Trapaj SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364210": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Sihor",
    "officename": "Amargadh SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364230": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Sihor",
    "officename": "Sanosara SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364240": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Sihor",
    "officename": "Sihor SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364250": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Sihor",
    "officename": "Songadh SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364260": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Sihor",
    "officename": "Tana SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364265": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Palitana",
    "officename": "Gheti SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364270": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Palitana",
    "officename": "Palitana SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364275": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Gariyadhar",
    "officename": "Parvadi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364280": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Mahuva",
    "officename": "Motakhuntavada SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364290": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Mahuva",
    "officename": "Mahuva SO Bhavnagar",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364295": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Mahuva",
    "officename": "Bhadrod SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364310": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Vallabhipur",
    "officename": "Vallabhipur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364313": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Vallbhipur",
    "officename": "Ratanpur Bhal SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364320": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Umrala",
    "officename": "Dhola SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364330": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Umrala",
    "officename": "Umrala SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364505": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Gariyadhar",
    "officename": "Gariyadhar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364510": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Sihor",
    "officename": "Jesar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364515": {
    "state": "Gujarat",
    "district": "Amreli",
    "block": "Amreli",
    "officename": "Savarkundla SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Amreli Division"
  },
  "364521": {
    "state": "Gujarat",
    "district": "Amreli",
    "block": "Amreli",
    "officename": "Jira SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Amreli Division"
  },
  "364522": {
    "state": "Gujarat",
    "district": "Amreli",
    "block": "Savar Kundla",
    "officename": "Badhada SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Amreli Division"
  },
  "364525": {
    "state": "Gujarat",
    "district": "Amreli",
    "block": "Amreli",
    "officename": "Vanda SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Amreli Division"
  },
  "364530": {
    "state": "Gujarat",
    "district": "Amreli",
    "block": "Amreli",
    "officename": "Vijpadi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Amreli Division"
  },
  "364710": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Botad",
    "officename": "Botad SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364720": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Botad",
    "officename": "Paliyad SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364730": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Gadhada",
    "officename": "Dhasa Gam SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364740": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Gadhada Sn",
    "officename": "Dhasa Jn SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364750": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Gadhada",
    "officename": "Gadhada Sn SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364760": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Sihor",
    "officename": "Ningala SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "364765": {
    "state": "Gujarat",
    "district": "Bhavnagar",
    "block": "Gadhada",
    "officename": "Ugamedi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Bhavnagar Division"
  },
  "365220": {
    "state": "Gujarat",
    "district": "Amreli",
    "block": "Amreli",
    "officename": "Damnagar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Amreli Division"
  },
  "365410": {
    "state": "Gujarat",
    "district": "Amreli",
    "block": "Babra",
    "officename": "Chamaradi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Amreli Division"
  },
  "365421": {
    "state": "Gujarat",
    "district": "Amreli",
    "block": "Amreli",
    "officename": "Babra SO Amreli",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Amreli Division"
  },
  "365430": {
    "state": "Gujarat",
    "district": "Amreli",
    "block": "Amreli",
    "officename": "Lathi SO Amreli",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Amreli Division"
  },
  "365435": {
    "state": "Gujarat",
    "district": "Amreli",
    "block": "Lathi",
    "officename": "Chavand SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Amreli Division"
  },
  "365440": {
    "state": "Gujarat",
    "district": "Amreli",
    "block": "Bagasara",
    "officename": "Bagasra SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Amreli Division"
  },
  "365450": {
    "state": "Gujarat",
    "district": "Amreli",
    "block": "Amreli",
    "officename": "Kunkavav SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Amreli Division"
  },
  "365455": {
    "state": "Gujarat",
    "district": "Amreli",
    "block": "Amreli",
    "officename": "Motaankadiya SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Amreli Division"
  },
  "365456": {
    "state": "Gujarat",
    "district": "Amreli",
    "block": "Amreli",
    "officename": "Vaghaniya SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Amreli Division"
  },
  "365460": {
    "state": "Gujarat",
    "district": "Amreli",
    "block": "Amreli",
    "officename": "Lunidhar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Amreli Division"
  },
  "365480": {
    "state": "Gujarat",
    "district": "Amreli",
    "block": "Amreli",
    "officename": "Vadia SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Amreli Division"
  },
  "365535": {
    "state": "Gujarat",
    "district": "Amreli",
    "block": "Amreli",
    "officename": "Liliya SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Amreli Division"
  },
  "365540": {
    "state": "Gujarat",
    "district": "Amreli",
    "block": "Amreli",
    "officename": "Jafrabad SO Amreli",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Amreli Division"
  },
  "365541": {
    "state": "Gujarat",
    "district": "Amreli",
    "block": "Amreli",
    "officename": "UTCL Kovaya SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Amreli Division"
  },
  "365550": {
    "state": "Gujarat",
    "district": "Amreli",
    "block": "Amreli",
    "officename": "Dedan SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Amreli Division"
  },
  "365555": {
    "state": "Gujarat",
    "district": "Amreli",
    "block": "Amreli",
    "officename": "Dungar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Amreli Division"
  },
  "365560": {
    "state": "Gujarat",
    "district": "Amreli",
    "block": "Amreli",
    "officename": "Rajula SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Amreli Division"
  },
  "365601": {
    "state": "Gujarat",
    "district": "Amreli",
    "block": "Amreli",
    "officename": "Amreli HO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Amreli Division"
  },
  "365610": {
    "state": "Gujarat",
    "district": "Amreli",
    "block": "Amreli",
    "officename": "Babapur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Amreli Division"
  },
  "365620": {
    "state": "Gujarat",
    "district": "Amreli",
    "block": "Amreli",
    "officename": "Chital SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Amreli Division"
  },
  "365630": {
    "state": "Gujarat",
    "district": "Amreli",
    "block": "Amreli",
    "officename": "Chalala SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Amreli Division"
  },
  "365635": {
    "state": "Gujarat",
    "district": "Amreli",
    "block": "Amreli",
    "officename": "Motasamdhiyala SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Amreli Division"
  },
  "365640": {
    "state": "Gujarat",
    "district": "Amreli",
    "block": "Amreli",
    "officename": "Dhari SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Amreli Division"
  },
  "365645": {
    "state": "Gujarat",
    "district": "Amreli",
    "block": "Dhari",
    "officename": "Bhader SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Amreli Division"
  },
  "365650": {
    "state": "Gujarat",
    "district": "Amreli",
    "block": "Amreli",
    "officename": "Khambha SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Amreli Division"
  },
  "370001": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Bhuj",
    "officename": "Bhuj HO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370015": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Bhuj",
    "officename": "Kachchh University DSO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370020": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Bhachau",
    "officename": "Madhapar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370030": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Bhuj",
    "officename": "Mankuwa SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370040": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Bhuj",
    "officename": "Sukhpar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370105": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Bhuj",
    "officename": "Kukma SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370110": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Anjar",
    "officename": "Anjar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370115": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Bhuj",
    "officename": "New Dudhai SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370130": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Anjar",
    "officename": "Khedoi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370135": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Bhachau",
    "officename": "Adhoi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370140": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Bhachau",
    "officename": "Bhachau SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370145": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Rahpar",
    "officename": "Lakadia SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370150": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Bhachau",
    "officename": "Samkhiyali SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370155": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Rahpar",
    "officename": "Adesar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370160": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Rahpar",
    "officename": "Bhimasar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370165": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Rahpar",
    "officename": "Rahpar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370201": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Gandhidham",
    "officename": "Gandhidham SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370203": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Gandhidham",
    "officename": "Udaynagar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370205": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Gandhidham",
    "officename": "Adipur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370210": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Gandhidham",
    "officename": "Kandla Port SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370230": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Gandhidham",
    "officename": "Kandla Special Economic Zone",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370405": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Mundra",
    "officename": "Bhujpur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370410": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Mundra",
    "officename": "Gundala SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370415": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Mundra",
    "officename": "Kapaya SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370421": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Mundra",
    "officename": "Mundra SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370425": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Mundra",
    "officename": "Patri SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370427": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Bhuj",
    "officename": "Baladia SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370430": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Bhuj",
    "officename": "Kera SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370435": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Mandvi",
    "officename": "Bidada SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370445": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Mandvi",
    "officename": "Gadhasisa SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370450": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Mandvi",
    "officename": "Godhra SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370455": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Mandvi",
    "officename": "Gundiyali SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370460": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Mandvi",
    "officename": "Koday SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370465": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Mandvi",
    "officename": "Kachchh Mandvi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370475": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Mandvi",
    "officename": "Laija SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370485": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Mandvi",
    "officename": "Dahisara SO Kachchh",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370490": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Abdasa",
    "officename": "Dumara SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370510": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Bhuj",
    "officename": "Khavda SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370601": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Lakhpat",
    "officename": "Shyamji Krishna Varma Nagar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370605": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Nakhatrana",
    "officename": "KotdaN SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370610": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Nakhatrana",
    "officename": "Manjal SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370615": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Nakhatrana",
    "officename": "Nakhatrana SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370620": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Abdasa",
    "officename": "Netra SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370625": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Lakhpat",
    "officename": "Ravapar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370627": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Lakhpat",
    "officename": "Gaduli SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370630": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Kachch",
    "officename": "Daypar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370645": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Abdasa",
    "officename": "Kothara SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370650": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Abdasa",
    "officename": "Mothara SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370655": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Abdasa",
    "officename": "Naliya SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370660": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Abdasa",
    "officename": "Tera SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370665": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Nakhatrana",
    "officename": "Virani SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370670": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Nakhatrana",
    "officename": "Khombhadi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "370675": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Nakhatrana",
    "officename": "Vithon SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "380001": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ahmadabad City",
    "officename": "Ahmedabad GPO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad GPO Division"
  },
  "380002": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ahmadabad City",
    "officename": "Revdibazar HO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "380004": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ahmadabad City",
    "officename": "Shahibag SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "380005": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ahmadabad City",
    "officename": "Sabarmati SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "380006": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ahmadabad City",
    "officename": "Ellisbridge SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "380007": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ahmadabad City",
    "officename": "Paldi SO Ahmedabad",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "380008": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ahmadabad City",
    "officename": "Maninagar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "380009": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "City Ahmedabad",
    "officename": "Navrangpura HO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "380013": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ahmadabad City",
    "officename": "Naranpura Vistar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "380014": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ahmadabad City",
    "officename": "Navjivan SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "380015": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ahmadabad City",
    "officename": "Manekbag SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "380016": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ahmadabad City",
    "officename": "Civil Hospital SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "380018": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ahmadabad City",
    "officename": "Saraspur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "380019": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ahmadabad City",
    "officename": "Railway Colony SO Ahmedabad",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "380021": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ahmadabad City",
    "officename": "Rajpur Gomtipur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "380022": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ahmadabad City",
    "officename": "Behrampura SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "380023": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ahmadabad City",
    "officename": "Rakhial Udyog Vistar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "380024": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ahmadabad City",
    "officename": "I E Bapunagar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "380026": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ahmadabad City",
    "officename": "Amraiwadi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "380027": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ahmadabad City",
    "officename": "Gandhi Ashram SO Ahmedabad",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "380028": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ahmadabad City",
    "officename": "Shah Alam Roza SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "380050": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ahmadabad City",
    "officename": "Ghodasar SO Ahmedabad",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "380051": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ahmadabad City",
    "officename": "Jivraj Park SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "380052": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ahmadabad City",
    "officename": "Memnagar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "380054": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ahmadabad City",
    "officename": "Bodakdev SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "380055": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ahmadabad City",
    "officename": "Juhapura SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "380058": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Daskroi",
    "officename": "Bopal SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "380059": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Daskroi",
    "officename": "Thaltej SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "380060": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Daskroi",
    "officename": "Gujarat High Court SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "380061": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ahmadabad City",
    "officename": "Ghatlodia SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "380063": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ahmadabad City",
    "officename": "Sola H B C SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "382006": {
    "state": "Gujarat",
    "district": "Gandhi Nagar",
    "block": "Gandhinagar",
    "officename": "Gandhinagar Sector 6 SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382007": {
    "state": "Gujarat",
    "district": "Gandhi Nagar",
    "block": "Gandhinagar",
    "officename": "Gandhinagar Sector 7 SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382010": {
    "state": "Gujarat",
    "district": "Gandhi Nagar",
    "block": "Gandhinagar",
    "officename": "Gandhinagar Gujarat HO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382016": {
    "state": "Gujarat",
    "district": "Gandhi Nagar",
    "block": "Gandhinagar",
    "officename": "Gandhinagar Sector 16 SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382021": {
    "state": "Gujarat",
    "district": "Gandhi Nagar",
    "block": "Gandhinagar",
    "officename": "Gandhinagar Sector 21 SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382028": {
    "state": "Gujarat",
    "district": "Gandhi Nagar",
    "block": "Gandhinagar",
    "officename": "Gandhinagar Sector 28 SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382030": {
    "state": "Gujarat",
    "district": "Gandhi Nagar",
    "block": "Gandhinagar",
    "officename": "NDC Gandhinagar",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382041": {
    "state": "Gujarat",
    "district": "Gandhi Nagar",
    "block": "Gandhinagar",
    "officename": "Thermal Power Station SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382042": {
    "state": "Gujarat",
    "district": "Gandhi Nagar",
    "block": "Gandhinagar",
    "officename": "CRPF Campus G Nagar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382045": {
    "state": "Gujarat",
    "district": "Gandhi Nagar",
    "block": "Gandhinagar",
    "officename": "BSF GANDHINAGAR SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382110": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Sanand",
    "officename": "Sanand SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382115": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Sanand",
    "officename": "Godhavi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382120": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Detroj-rampura",
    "officename": "Detroj SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382130": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Mandal",
    "officename": "Mandal SO Ahmedabad",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382140": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Detroj-rampura",
    "officename": "Rampura SO Ahmedabad",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382145": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Detroj-rampura",
    "officename": "Katosan Road SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382150": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Viramgam",
    "officename": "Viramgam SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382170": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Sanand",
    "officename": "Virochannagar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382210": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Dascroi",
    "officename": "Sarkhej SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "382213": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Sanand",
    "officename": "Changodar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382220": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Bavla",
    "officename": "Bavla SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382225": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Dholka",
    "officename": "Dholka SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382230": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Dholka",
    "officename": "Lothal Bhurkhi RS SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382240": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Bavla",
    "officename": "Koth SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382245": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ranpur",
    "officename": "Ranpur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382250": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Dhandhuka",
    "officename": "Polarpur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382255": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ranpur",
    "officename": "Jalila SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382260": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Dholka",
    "officename": "Chaloda SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382265": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Dholka",
    "officename": "Kauka SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382305": {
    "state": "Gujarat",
    "district": "Gandhi Nagar",
    "block": "Dehgam",
    "officename": "Dehgam SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382308": {
    "state": "Gujarat",
    "district": "Gandhi Nagar",
    "block": "Dehgam",
    "officename": "Bahiyal SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382315": {
    "state": "Gujarat",
    "district": "Gandhi Nagar",
    "block": "Dehgam",
    "officename": "Rakhial RS SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382320": {
    "state": "Gujarat",
    "district": "Gandhi Nagar",
    "block": "Gandhinagar",
    "officename": "Sadra SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382321": {
    "state": "Gujarat",
    "district": "Gandhi Nagar",
    "block": "Gandhinagar",
    "officename": "Chhala SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382330": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Daskroi",
    "officename": "Naroda I E SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "382340": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ahmadabad City",
    "officename": "Kubernagar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "382345": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ahmadabad City",
    "officename": "Saijpur Bogha SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "382350": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ahmadabad City",
    "officename": "T B Nagar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "382355": {
    "state": "Gujarat",
    "district": "Gandhi Nagar",
    "block": "Gandhinagar",
    "officename": "Dabhoda SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382405": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ahmadabad City",
    "officename": "Narol SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "382415": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ahmadabad City",
    "officename": "Odhav Industrial Estate SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "382418": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Daskroi",
    "officename": "Vastral SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "382421": {
    "state": "Gujarat",
    "district": "Gandhi Nagar",
    "block": "Gandhinagar",
    "officename": "Adalaj SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382422": {
    "state": "Gujarat",
    "district": "Gandhi Nagar",
    "block": "Gandhinagar",
    "officename": "Uvarsad SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382423": {
    "state": "Gujarat",
    "district": "Gandhi Nagar",
    "block": "Gandhinagar",
    "officename": "Kasturinagar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382424": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Gandhinagar",
    "officename": "Chandkheda Society Area SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "382425": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Dasroi",
    "officename": "Bareja SO Ahmedabad",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "382427": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Daskroi",
    "officename": "Aslali SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "382428": {
    "state": "Gujarat",
    "district": "Gandhi Nagar",
    "block": "Gandhinagar",
    "officename": "Bhat SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382430": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Dascroi",
    "officename": "Kathwada Maize Product SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "382433": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Dascroi",
    "officename": "Kuha SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "382435": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Dascroi",
    "officename": "Nandej SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "382443": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ahmadabad City",
    "officename": "Isanpur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "382445": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Daskroi",
    "officename": "Vatva Industrial Estate SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "382449": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Dascroi",
    "officename": "Jantanagar S.O",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "382450": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Barwala",
    "officename": "Barwala Ghelasha SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382455": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Dhandhuka",
    "officename": "Dholera SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382460": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Dhandhuka",
    "officename": "Dhandhuka SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382463": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Dhandhuka",
    "officename": "Bhadiad SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382465": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Dhandhuka",
    "officename": "Fedra SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382470": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ahmadabad City",
    "officename": "Digvijaynagar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "382475": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ahmadabad City",
    "officename": "Sardarnagar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "382480": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Ahmadabad City",
    "officename": "Ranip SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "382481": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Gandhinagar",
    "officename": "Chandlodiya SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "382610": {
    "state": "Gujarat",
    "district": "Gandhi Nagar",
    "block": "Gandhinagar",
    "officename": "Pethapur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382620": {
    "state": "Gujarat",
    "district": "Gandhi Nagar",
    "block": "Gandhinagar",
    "officename": "Randheja SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382630": {
    "state": "Gujarat",
    "district": "Gandhi Nagar",
    "block": "Gandhinagar",
    "officename": "Rupal SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382640": {
    "state": "Gujarat",
    "district": "Gandhi Nagar",
    "block": "Gandhinagar",
    "officename": "Sardhav SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382650": {
    "state": "Gujarat",
    "district": "Gandhi Nagar",
    "block": "Gandhinagar",
    "officename": "Unava  Balva SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382721": {
    "state": "Gujarat",
    "district": "Gandhi Nagar",
    "block": "Kalol",
    "officename": "Kalol HO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382725": {
    "state": "Gujarat",
    "district": "Gandhi Nagar",
    "block": "Kalol",
    "officename": "Kalol Industrial Estate SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382729": {
    "state": "Gujarat",
    "district": "Gandhi Nagar",
    "block": "Kalol",
    "officename": "Chhatral SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382735": {
    "state": "Gujarat",
    "district": "Gandhi Nagar",
    "block": "Kalol",
    "officename": "Nardipur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382740": {
    "state": "Gujarat",
    "district": "Gandhi Nagar",
    "block": "Kalol",
    "officename": "Pansar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382810": {
    "state": "Gujarat",
    "district": "Gandhi Nagar",
    "block": "Mansa",
    "officename": "Charada SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382835": {
    "state": "Gujarat",
    "district": "Gandhi Nagar",
    "block": "Mansa",
    "officename": "Lodra SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382845": {
    "state": "Gujarat",
    "district": "Gandhi Nagar",
    "block": "Mansa",
    "officename": "Mansa SO Gandhi Nagar",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382855": {
    "state": "Gujarat",
    "district": "Gandhi Nagar",
    "block": "Mansa",
    "officename": "Pundhara SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "383001": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Himatnagar",
    "officename": "Himatnagar HO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383006": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Himatnagar",
    "officename": "Boria SO Sabarkantha",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383010": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Himatnagar",
    "officename": "Vaktapur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383030": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Himatnagar",
    "officename": "Gambhoi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383110": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Idar",
    "officename": "Jadar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383120": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Prantij",
    "officename": "Salal SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383205": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Prantij",
    "officename": "Prantij SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383210": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Prantij",
    "officename": "Sonasan SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383215": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Prantij",
    "officename": "Talod SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383220": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Himatnagar",
    "officename": "Ilol SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383225": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Idar",
    "officename": "Davad SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383230": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Idar",
    "officename": "Umedgadh SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383235": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Vadali",
    "officename": "Vadali SO Sabarkantha",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383240": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Bhiloda",
    "officename": "Bamna SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383245": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Bhiloda",
    "officename": "Bhiloda SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383246": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Bhiloda",
    "officename": "Takatuka SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383250": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Modasa",
    "officename": "Tintoi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383251": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Bhiloda",
    "officename": "Lusadia SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383255": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Khedbrahma",
    "officename": "Khedbrahma SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383260": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Dhansura",
    "officename": "Akrund SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383270": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Khedbrahma",
    "officename": "Radhiwad SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383275": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Khedbrahma",
    "officename": "Laxmipura Sabarkantha SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383276": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Himatnagar",
    "officename": "Raigadh SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383305": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Talod",
    "officename": "Harsol SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383307": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Dhansura",
    "officename": "Vadagam SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383310": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Dhansura",
    "officename": "Dhansura SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383315": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Modasa",
    "officename": "Modasa SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383316": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Modasa",
    "officename": "Limbhoi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383317": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Modasa",
    "officename": "Dadhalia SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383320": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Modasa",
    "officename": "Sardoi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383325": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Bayad",
    "officename": "Bayad SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383330": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Bayad",
    "officename": "Demai SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383335": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Bayad",
    "officename": "Gabat SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383340": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Bayad",
    "officename": "Sathamba SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383345": {
    "state": "Gujarat",
    "district": "Ahmedabad",
    "block": "Malpur",
    "officename": "Malpur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383350": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Meghraj",
    "officename": "Meghraj SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383355": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Bhiloda",
    "officename": "Shamlaji SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383410": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Idar",
    "officename": "Badoli SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383421": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Idar",
    "officename": "Chitroda SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383422": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Khedbrahma",
    "officename": "Poshina SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383430": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Idar",
    "officename": "Idar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383434": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Idar",
    "officename": "Verabar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383440": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Idar",
    "officename": "Kadiadra SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383450": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Bhiloda",
    "officename": "Vasai SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383460": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Vijaynagar",
    "officename": "Vijaynagar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "383462": {
    "state": "Gujarat",
    "district": "Sabarkantha",
    "block": "Vijaynagar",
    "officename": "Kodiawada SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "384001": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Mahesana",
    "officename": "Mahesana HO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384002": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Mahesana",
    "officename": "Mahesana I E SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384003": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Mahesana",
    "officename": "Mahesana Ongc Colony SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384012": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Mahesana",
    "officename": "Ganpat Vidyanagar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384110": {
    "state": "Gujarat",
    "district": "Patan",
    "block": "Patan",
    "officename": "Balisana SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Patan Division"
  },
  "384120": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Mahesana",
    "officename": "Bhandu SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384130": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Unjha",
    "officename": "Kahoda SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384140": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Unjha",
    "officename": "Kamli SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384151": {
    "state": "Gujarat",
    "district": "Patan",
    "block": "Sidhpur",
    "officename": "Sidhpur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Patan Division"
  },
  "384160": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Unjha",
    "officename": "Unava SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384170": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Unjha",
    "officename": "Unjha SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384220": {
    "state": "Gujarat",
    "district": "Patan",
    "block": "Chanasma",
    "officename": "Chanasma SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Patan Division"
  },
  "384221": {
    "state": "Gujarat",
    "district": "Patan",
    "block": "Chanasma",
    "officename": "Vadavali SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Patan Division"
  },
  "384225": {
    "state": "Gujarat",
    "district": "Patan",
    "block": "Chanasma",
    "officename": "Dhinoj SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Patan Division"
  },
  "384229": {
    "state": "Gujarat",
    "district": "Patan",
    "block": "Chanasma",
    "officename": "Lanva SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Patan Division"
  },
  "384230": {
    "state": "Gujarat",
    "district": "Patan",
    "block": "Chanasma",
    "officename": "Kamboi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Patan Division"
  },
  "384240": {
    "state": "Gujarat",
    "district": "Patan",
    "block": "Sami",
    "officename": "Harij SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Patan Division"
  },
  "384241": {
    "state": "Gujarat",
    "district": "Patan",
    "block": "Sami",
    "officename": "Mujpur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Patan Division"
  },
  "384245": {
    "state": "Gujarat",
    "district": "Patan",
    "block": "Sami",
    "officename": "Sami SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Patan Division"
  },
  "384246": {
    "state": "Gujarat",
    "district": "Patan",
    "block": "Sami",
    "officename": "Sankheshwar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Patan Division"
  },
  "384255": {
    "state": "Gujarat",
    "district": "Patan",
    "block": "Harij",
    "officename": "Kungher SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Patan Division"
  },
  "384260": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Patan",
    "officename": "Manund SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Patan Division"
  },
  "384265": {
    "state": "Gujarat",
    "district": "Patan",
    "block": "Patan",
    "officename": "Patan HO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Patan Division"
  },
  "384272": {
    "state": "Gujarat",
    "district": "Patan",
    "block": "Patan",
    "officename": "Sariyad SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Patan Division"
  },
  "384275": {
    "state": "Gujarat",
    "district": "Patan",
    "block": "Patan",
    "officename": "Ranuj SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Patan Division"
  },
  "384285": {
    "state": "Gujarat",
    "district": "Patan",
    "block": "Patan",
    "officename": "Wagdod SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Patan Division"
  },
  "384290": {
    "state": "Gujarat",
    "district": "Patan",
    "block": "Sidhpur",
    "officename": "Kakoshi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Patan Division"
  },
  "384305": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Visnagar",
    "officename": "Kada SO Mahesana",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384310": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Visnagar",
    "officename": "Valam SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384315": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Visnagar",
    "officename": "Visnagar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384320": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Visnagar",
    "officename": "Umta SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384325": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Kheralu",
    "officename": "Kheralu SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384330": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Satlasana",
    "officename": "Satlasana SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384335": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Kheralu",
    "officename": "Sipor SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384340": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Vijapur",
    "officename": "Sudasana SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384345": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Vadnagar",
    "officename": "Sundhia SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384355": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Vadnagar",
    "officename": "Vadnagar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384360": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Satlasana",
    "officename": "Dharoi DSC SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384410": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Becharaji",
    "officename": "Balol SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384421": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Mahesana",
    "officename": "Jhotana SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384430": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Mahesana",
    "officename": "Santhal SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384435": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Mahesana",
    "officename": "Linch SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "385001": {
    "state": "Gujarat",
    "district": "Banaskantha",
    "block": "Palanpur",
    "officename": "Palanpur HO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Banaskantha Division"
  },
  "385010": {
    "state": "Gujarat",
    "district": "Banaskantha",
    "block": "Palanpur",
    "officename": "Chitrasani SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Banaskantha Division"
  },
  "385110": {
    "state": "Gujarat",
    "district": "Banaskantha",
    "block": "Danta",
    "officename": "Ambaji SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Banaskantha Division"
  },
  "385120": {
    "state": "Gujarat",
    "district": "Banaskantha",
    "block": "Danta",
    "officename": "Danta Bhavangadh SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Banaskantha Division"
  },
  "385130": {
    "state": "Gujarat",
    "district": "Banaskantha",
    "block": "Shri Amirgadh",
    "officename": "Shri Amirgadh SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Banaskantha Division"
  },
  "385135": {
    "state": "Gujarat",
    "district": "Banaskantha",
    "block": "Amirgadh",
    "officename": "Iqbalgadh SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Banaskantha Division"
  },
  "385210": {
    "state": "Gujarat",
    "district": "Banaskantha",
    "block": "Vadgam",
    "officename": "Chhapi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Banaskantha Division"
  },
  "385310": {
    "state": "Gujarat",
    "district": "Banaskantha",
    "block": "Dhanera",
    "officename": "Dhanera SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Banaskantha Division"
  },
  "385320": {
    "state": "Gujarat",
    "district": "Banaskantha",
    "block": "Bhabhar",
    "officename": "Bhabhar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Banaskantha Division"
  },
  "385330": {
    "state": "Gujarat",
    "district": "Banaskantha",
    "block": "Deodar",
    "officename": "Deodar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Banaskantha Division"
  },
  "385340": {
    "state": "Gujarat",
    "district": "Patan",
    "block": "Radhanpur",
    "officename": "Radhanpur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Patan Division"
  },
  "385350": {
    "state": "Gujarat",
    "district": "Patan",
    "block": "Santalpur",
    "officename": "Santalpur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Patan Division"
  },
  "385360": {
    "state": "Gujarat",
    "district": "Patan",
    "block": "Santalpur",
    "officename": "Varahi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Patan Division"
  },
  "385410": {
    "state": "Gujarat",
    "district": "Banaskantha",
    "block": "Palanpur",
    "officename": "Vadgam SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Banaskantha Division"
  },
  "385421": {
    "state": "Gujarat",
    "district": "Banaskantha",
    "block": "Vadgam",
    "officename": "Memadpur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Banaskantha Division"
  },
  "385505": {
    "state": "Gujarat",
    "district": "Banaskantha",
    "block": "Danta",
    "officename": "Dantiwada Colony SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Banaskantha Division"
  },
  "385506": {
    "state": "Gujarat",
    "district": "Banaskantha",
    "block": "Dantiwada",
    "officename": "Sardar Krishinagar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Banaskantha Division"
  },
  "385510": {
    "state": "Gujarat",
    "district": "Banaskantha",
    "block": "Palanpur",
    "officename": "Chandisar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Banaskantha Division"
  },
  "385515": {
    "state": "Gujarat",
    "district": "Banaskantha",
    "block": "Palanpur",
    "officename": "Gadh SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Banaskantha Division"
  },
  "385520": {
    "state": "Gujarat",
    "district": "Banaskantha",
    "block": "Vadgam",
    "officename": "Kanodar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Banaskantha Division"
  },
  "385530": {
    "state": "Gujarat",
    "district": "Banaskantha",
    "block": "Disa",
    "officename": "Bhildi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Banaskantha Division"
  },
  "385535": {
    "state": "Gujarat",
    "district": "Banaskantha",
    "block": "Disa",
    "officename": "Disa Mukhya Dak Ghar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Banaskantha Division"
  },
  "385540": {
    "state": "Gujarat",
    "district": "Banaskantha",
    "block": "Disa",
    "officename": "Junadisa SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Banaskantha Division"
  },
  "385545": {
    "state": "Gujarat",
    "district": "Banaskantha",
    "block": "Dhanera",
    "officename": "Khimat SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Banaskantha Division"
  },
  "385550": {
    "state": "Gujarat",
    "district": "Banaskantha",
    "block": "Kankrej",
    "officename": "Sihori SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Banaskantha Division"
  },
  "385555": {
    "state": "Gujarat",
    "district": "Banaskantha",
    "block": "Kankrej",
    "officename": "Thara SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Banaskantha Division"
  },
  "385560": {
    "state": "Gujarat",
    "district": "Banaskantha",
    "block": "Kankrej",
    "officename": "Un SO Banaskantha",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Banaskantha Division"
  },
  "385565": {
    "state": "Gujarat",
    "district": "Banaskantha",
    "block": "Tharad",
    "officename": "Tharad SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Banaskantha Division"
  },
  "385566": {
    "state": "Gujarat",
    "district": "Banaskantha",
    "block": "Vav",
    "officename": "Dhima SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Banaskantha Division"
  },
  "385570": {
    "state": "Gujarat",
    "district": "Banaskantha",
    "block": "Vav",
    "officename": "Suigam SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Banaskantha Division"
  },
  "385575": {
    "state": "Gujarat",
    "district": "Banaskantha",
    "block": "Vav",
    "officename": "Vav SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Banaskantha Division"
  },
  "387001": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Nadiad",
    "officename": "Nadiad HO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387002": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Naidiad",
    "officename": "Patel Society Area Tso Nad SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387110": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Mahemdavad",
    "officename": "Ghodasar SO Kheda",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387115": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Nadiad",
    "officename": "Alindra Nadiad SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387120": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Kheda",
    "officename": "Kanij SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387130": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Mehmedabad",
    "officename": "Mahemdavad SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387210": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Sojitra",
    "officename": "Dabhou SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387220": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Sojitra",
    "officename": "Malataj SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387230": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Nadiad",
    "officename": "Pij SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387240": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Sojitra",
    "officename": "Sojitra SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387305": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Mahudha",
    "officename": "Alina SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387310": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Anand",
    "officename": "Boriavi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "387315": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Nadiad",
    "officename": "Chaklashi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387320": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Nadiad",
    "officename": "Dabhan SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387325": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Nadiad",
    "officename": "Kanjari SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387330": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Nadiad",
    "officename": "Mohlel SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387335": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Kathlal",
    "officename": "Mahudha SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387340": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Mahudha",
    "officename": "Mahisa SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387345": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Petlad",
    "officename": "Narsanda SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387350": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Nadiad",
    "officename": "Palana SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387355": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Nadiad",
    "officename": "Piplag SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387360": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Nadiad",
    "officename": "Salun SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387365": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Kapadwanj",
    "officename": "Torna SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387370": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Nadiad",
    "officename": "Uttarsanda SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387375": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Petlad",
    "officename": "Vadtal SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387380": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Sojitra",
    "officename": "Vaso SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387411": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Kheda",
    "officename": "Kheda HO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387430": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Mahemdavad",
    "officename": "Sinhuj SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387510": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Matar",
    "officename": "Alindra Matar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387520": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Matar",
    "officename": "Limbasi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387530": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Matar",
    "officename": "Matar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387540": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Kheda",
    "officename": "Navagam SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387550": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Kheda",
    "officename": "Nayka SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387560": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Kheda",
    "officename": "Radhu SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387570": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Matar",
    "officename": "Ratanpur SO Kheda",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387610": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Kathlal",
    "officename": "Attarsumba SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387620": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Kapadwanj",
    "officename": "Kapadwanj SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387630": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Kathlal",
    "officename": "Kathlal SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387635": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Kathlal",
    "officename": "Chhipdi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387640": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Kathlal",
    "officename": "Lasundra SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387650": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Kapadwanj",
    "officename": "Nirmali SO Kheda",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387710": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Petlad",
    "officename": "Ramol SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "388001": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Anand",
    "officename": "Anand HO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388110": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Anand",
    "officename": "Anand Agri Inst  Anand SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388120": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Anand",
    "officename": "Vallabh  Vidyanagar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388130": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Petlad",
    "officename": "Boria SO Anand",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388140": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Borsad",
    "officename": "Bochasan RS SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "388150": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Petlad",
    "officename": "Nar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "388160": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Petlad",
    "officename": "Pandoli SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "388170": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Khambhat",
    "officename": "Sayma SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "388180": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Matar",
    "officename": "Tarapur SO Anand",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "388205": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Umreth",
    "officename": "Bhalej SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388210": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Umreth",
    "officename": "Ode SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388215": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Thasra",
    "officename": "Thamna SO Anand",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388220": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Umreth",
    "officename": "Umreth SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388225": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Thasra",
    "officename": "Dakor SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388230": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Thasra",
    "officename": "Kalsar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388235": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Thasra",
    "officename": "Timbana Muvada S.O",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388239": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Thasra",
    "officename": "Wanakbori TPS SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388245": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Thasra",
    "officename": "Sevalia  Rs SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388250": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Thasra",
    "officename": "Thasra SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388255": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Balasinor",
    "officename": "Vadasinor SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388260": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Birpur",
    "officename": "Birpur SO Kheda",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388265": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Balasinor",
    "officename": "Pandva SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388270": {
    "state": "Gujarat",
    "district": "Panch Mahals",
    "block": "Lunawada",
    "officename": "Vardhari SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "388305": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Anand",
    "officename": "Adas SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388306": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Anand",
    "officename": "Vasad SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388307": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Anklav",
    "officename": "Kantharia SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388310": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Anand",
    "officename": "Ajarpura SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388315": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Anand",
    "officename": "Bakrol SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388320": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Anand",
    "officename": "Chikhodra SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388325": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Anand",
    "officename": "Karamsad SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388330": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Anand",
    "officename": "Khambholej SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388335": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Anand",
    "officename": "Kunjrav SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388340": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Anand",
    "officename": "Mogar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388345": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Anand",
    "officename": "Mogri SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388350": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Anklav",
    "officename": "Napad SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388355": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Anand",
    "officename": "Navli SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388360": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Anand",
    "officename": "Samarkha SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388365": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Umreth",
    "officename": "Sarsa SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388370": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Anand",
    "officename": "Vadod SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388410": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Nadiad",
    "officename": "Bandhani SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "388421": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Nadiad",
    "officename": "Changa SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "388430": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Petlad",
    "officename": "Dharmaj SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "388440": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Petlad",
    "officename": "Mahelav SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "388450": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Petlad",
    "officename": "Petlad SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "388460": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Sojitra",
    "officename": "Piplav SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "388465": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Petlad",
    "officename": "Palaj SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "388470": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Petlad",
    "officename": "Sunav SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "388480": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Borsad",
    "officename": "Sundarna SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "388510": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Anklav",
    "officename": "Anklav SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388520": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Anklav",
    "officename": "Bamangam SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388530": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Borsad",
    "officename": "Bhadran SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388540": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Borsad",
    "officename": "Borsad SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388543": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Borsad",
    "officename": "Alarsa SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388545": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Borsad",
    "officename": "Kavitha SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388550": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Khambhat",
    "officename": "Kathana RS SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "388560": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Borsad",
    "officename": "Napa SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Anand Division"
  },
  "388570": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Borsad",
    "officename": "Ras SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "388580": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Khambhat",
    "officename": "Virsad SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "388590": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Borsad",
    "officename": "Jharola SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "388610": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Khambhat",
    "officename": "Dhuvaran Power Station SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "388620": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Tarapur",
    "officename": "Khambhat SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "388625": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Tarapur",
    "officename": "Gudel SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "388630": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Khambhat",
    "officename": "Kansari SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "388640": {
    "state": "Gujarat",
    "district": "Anand",
    "block": "Khambhat",
    "officename": "Undel SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "388710": {
    "state": "Gujarat",
    "district": "Panch Mahals",
    "block": "Godhra",
    "officename": "Timba Road SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "388713": {
    "state": "Gujarat",
    "district": "Panch Mahals",
    "block": "Godhra",
    "officename": "Kakanpur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389001": {
    "state": "Gujarat",
    "district": "Panch Mahals",
    "block": "Godhra",
    "officename": "Godhra HO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389002": {
    "state": "Gujarat",
    "district": "Panch Mahals",
    "block": "Godhra",
    "officename": "Godhra Bhuravav SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389110": {
    "state": "Gujarat",
    "district": "Panch Mahals",
    "block": "Santrampur",
    "officename": "Mora SO Panch Mahals",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389115": {
    "state": "Gujarat",
    "district": "Panch Mahals",
    "block": "Morva Hadaf",
    "officename": "Morva Hadaf SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389120": {
    "state": "Gujarat",
    "district": "Panch Mahals",
    "block": "Godhra",
    "officename": "Sant Road SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389130": {
    "state": "Gujarat",
    "district": "Dahod",
    "block": "Devgadbaria",
    "officename": "Piplod SO Dahod",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389140": {
    "state": "Gujarat",
    "district": "Dahod",
    "block": "Limkheda",
    "officename": "Limkheda SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389146": {
    "state": "Gujarat",
    "district": "Dahod",
    "block": "Limkheda",
    "officename": "Dudhia SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389151": {
    "state": "Gujarat",
    "district": "Dahod",
    "block": "Dohad",
    "officename": "Dahod HO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389152": {
    "state": "Gujarat",
    "district": "Dahod",
    "block": "Garbada",
    "officename": "Jesawada SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389154": {
    "state": "Gujarat",
    "district": "Dahod",
    "block": "Dahod",
    "officename": "Katwara SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389155": {
    "state": "Gujarat",
    "district": "Dahod",
    "block": "Garbada",
    "officename": "Garbada SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389160": {
    "state": "Gujarat",
    "district": "Dahod",
    "block": "Dahod",
    "officename": "Freelandganj SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389170": {
    "state": "Gujarat",
    "district": "Dahod",
    "block": "Jhalod",
    "officename": "Jhalod SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389172": {
    "state": "Gujarat",
    "district": "Dahod",
    "block": "Santrampur",
    "officename": "Fatepura SO Dahod",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389175": {
    "state": "Gujarat",
    "district": "Dahod",
    "block": "Limkheda",
    "officename": "Sanjeli SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389180": {
    "state": "Gujarat",
    "district": "Dahod",
    "block": "Jahlod",
    "officename": "Limdi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389190": {
    "state": "Gujarat",
    "district": "Dahod",
    "block": "Fatepura",
    "officename": "Sukhsar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389210": {
    "state": "Gujarat",
    "district": "Panch Mahals",
    "block": "Shehera",
    "officename": "Shehera SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389220": {
    "state": "Gujarat",
    "district": "Panch Mahals",
    "block": "Shehera",
    "officename": "Kothamba SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389230": {
    "state": "Gujarat",
    "district": "Panch Mahals",
    "block": "Lunawada",
    "officename": "Lunawada SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389232": {
    "state": "Gujarat",
    "district": "Panch Mahals",
    "block": "Khanpur",
    "officename": "Bakor SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389235": {
    "state": "Gujarat",
    "district": "Panch Mahals",
    "block": "Lunawada",
    "officename": "Malekpur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389250": {
    "state": "Gujarat",
    "district": "Panch Mahals",
    "block": "Kadana",
    "officename": "Diwda Colony SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389260": {
    "state": "Gujarat",
    "district": "Panch Mahals",
    "block": "Santrampur",
    "officename": "Santrampur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389265": {
    "state": "Gujarat",
    "district": "Panch Mahals",
    "block": "Santrampur",
    "officename": "Malvan SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389310": {
    "state": "Gujarat",
    "district": "Panch Mahals",
    "block": "Kalol",
    "officename": "Delol SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389320": {
    "state": "Gujarat",
    "district": "Panch Mahals",
    "block": "Kalol",
    "officename": "Derol R S SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389330": {
    "state": "Gujarat",
    "district": "Panch Mahals",
    "block": "Kalol",
    "officename": "Kalol SO Panch Mahals",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389340": {
    "state": "Gujarat",
    "district": "Panch Mahals",
    "block": "Godhra",
    "officename": "Vejalpur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389341": {
    "state": "Gujarat",
    "district": "Panch Mahals",
    "block": "Kalol",
    "officename": "Adadra SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389350": {
    "state": "Gujarat",
    "district": "Panch Mahals",
    "block": "Halol",
    "officename": "Halol SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389360": {
    "state": "Gujarat",
    "district": "Panch Mahals",
    "block": "Halol",
    "officename": "Pavagadh SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389365": {
    "state": "Gujarat",
    "district": "Panch Mahals",
    "block": "Ghoghmba",
    "officename": "Ghoghmba SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389370": {
    "state": "Gujarat",
    "district": "Panch Mahals",
    "block": "Holol",
    "officename": "Shivrajpur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389380": {
    "state": "Gujarat",
    "district": "Panch Mahals",
    "block": "Devgadh Baria",
    "officename": "Devgadh Baria SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389382": {
    "state": "Gujarat",
    "district": "Dahod",
    "block": "Dhanpur",
    "officename": "Dhanpur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "389390": {
    "state": "Gujarat",
    "district": "Panch Mahals",
    "block": "Jambughoda",
    "officename": "Jambughoda SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "390001": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vadodara",
    "officename": "Vadodara HO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara East Division"
  },
  "390002": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vadodara",
    "officename": "Fateganj HO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "390003": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vadodara",
    "officename": "Chemical Industries SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "390004": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vadodara",
    "officename": "Pratapnagar SO Vadodara",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara East Division"
  },
  "390006": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vadodara",
    "officename": "Fatepura SO Vadodara",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara East Division"
  },
  "390007": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vadodara",
    "officename": "Racecourse SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "390008": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vadodara",
    "officename": "NDC FATEGANJ",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "390009": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vadodara",
    "officename": "Ongc Col SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara East Division"
  },
  "390010": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vadodara",
    "officename": "MI Estate SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara East Division"
  },
  "390011": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vadodara",
    "officename": "Manjalpur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara East Division"
  },
  "390012": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vadodara",
    "officename": "Atladara SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "390013": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vadodara",
    "officename": "Maneja SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara East Division"
  },
  "390014": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vadodara",
    "officename": "Makarpura SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara East Division"
  },
  "390016": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vadodara",
    "officename": "Industrial Estate Vadodara SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "390017": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vadodara",
    "officename": "Wadi SN Road SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara East Division"
  },
  "390018": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vadodara",
    "officename": "Karelibaug SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara East Division"
  },
  "390019": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vadodara",
    "officename": "Ajwa Road SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara East Division"
  },
  "390020": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vadodara",
    "officename": "Akota SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "390021": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vadodara",
    "officename": "T B Sanatorium SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "390022": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vadodara",
    "officename": "Harni Colony SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara East Division"
  },
  "390023": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vadodara",
    "officename": "Subhanpura SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "390024": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vadodara",
    "officename": "Chhani Rd SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "390025": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vadodara",
    "officename": "Soma Talav SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara East Division"
  },
  "391101": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vadodara",
    "officename": "Sevasi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "391105": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Sinor",
    "officename": "Chandod SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara East Division"
  },
  "391107": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Dabhoi",
    "officename": "Thuwavi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara East Division"
  },
  "391110": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Sinor",
    "officename": "Dabhoi HO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara East Division"
  },
  "391115": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Sinor",
    "officename": "Sinor SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara East Division"
  },
  "391120": {
    "state": "Gujarat",
    "district": "Narmada",
    "block": "Tilakwada",
    "officename": "Tilakwada SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara East Division"
  },
  "391125": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Sankheda",
    "officename": "Bahadarpur SO Vadodara",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara East Division"
  },
  "391130": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Sankheda",
    "officename": "Bhatpur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara East Division"
  },
  "391135": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Sankheda",
    "officename": "Bodeli SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara East Division"
  },
  "391140": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Pavijetpur",
    "officename": "Kosindra SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara East Division"
  },
  "391145": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Sankheda",
    "officename": "Sankheda SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara East Division"
  },
  "391150": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Naswadi",
    "officename": "Naswadi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara East Division"
  },
  "391152": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Naswadi",
    "officename": "Gadhboriad SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara East Division"
  },
  "391156": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Chhotaudepur",
    "officename": "Tejgadh SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara East Division"
  },
  "391160": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Pavijetpur",
    "officename": "Pavijetpur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara East Division"
  },
  "391165": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Chhota Udepur",
    "officename": "Chhotaudepur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara East Division"
  },
  "391168": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Ch.udepur",
    "officename": "Panvad SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara East Division"
  },
  "391170": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Kawant",
    "officename": "Kawant SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara East Division"
  },
  "391210": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Dabhoi",
    "officename": "Kandari SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "391220": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Dabhoi",
    "officename": "Kayavahron SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "391240": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Karjan",
    "officename": "Miyagam Karjan SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "391243": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Karjan",
    "officename": "POR SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "391244": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Karjan",
    "officename": "Choranda SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "391250": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Sinor",
    "officename": "Sadhli SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara East Division"
  },
  "391310": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vadodara",
    "officename": "Bajwa SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "391320": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vadodara",
    "officename": "Jawahar Nagar SO Vadodara",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "391330": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vadodara",
    "officename": "Koyali SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "391340": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vadodara",
    "officename": "Nandesari Ind Estate SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "391345": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vadodara",
    "officename": "Petrochemical  T Ship SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "391350": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vadodara",
    "officename": "Ranoli SO Vadodara",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "391410": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vadodara",
    "officename": "Bhaily SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "391421": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Padra",
    "officename": "Masar Road SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "391430": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Padra",
    "officename": "Mobha Road SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "391440": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Padra",
    "officename": "Padra SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "391445": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Padra",
    "officename": "Ranu SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "391450": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Padra",
    "officename": "Karkhadi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "391510": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vaghodia",
    "officename": "Jarod SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "391520": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Savli",
    "officename": "Samlaya R S SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "391530": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Savli",
    "officename": "Sandasal SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "391740": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vadodara",
    "officename": "Chhani SO Vadodara",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "391745": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vadodara",
    "officename": "Sokhda SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "391750": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vadodara",
    "officename": "Fartilizer Nagar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "391760": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vaghodia",
    "officename": "Vaghodia SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "391761": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Dabhoi",
    "officename": "Rustampura SO Vadodara",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "391770": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Savli",
    "officename": "Savli SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "391774": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Savli",
    "officename": "Desar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "391775": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Savli",
    "officename": "Tundav SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "391780": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Savli",
    "officename": "Bhadarwa SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "391810": {
    "state": "Gujarat",
    "district": "Bharuch",
    "block": "Jambusar",
    "officename": "Gajera SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "392001": {
    "state": "Gujarat",
    "district": "Bharuch",
    "block": "Bahruch",
    "officename": "Bharuch HO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "392011": {
    "state": "Gujarat",
    "district": "Bharuch",
    "block": "Bharuch",
    "officename": "Zadeshwar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "392012": {
    "state": "Gujarat",
    "district": "Bharuch",
    "block": "Hansot",
    "officename": "Maktampur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "392015": {
    "state": "Gujarat",
    "district": "Bharuch",
    "block": "Bharuch",
    "officename": "Narmada Nagar SO Bharuch",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "392020": {
    "state": "Gujarat",
    "district": "Bharuch",
    "block": "Bharuch",
    "officename": "Dayadra SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "392025": {
    "state": "Gujarat",
    "district": "Bharuch",
    "block": "Amod",
    "officename": "Samni SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "392030": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Bharuch",
    "officename": "Shuklatirth SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "392035": {
    "state": "Gujarat",
    "district": "Bharuch",
    "block": "Amod",
    "officename": "Sarbhan SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "392040": {
    "state": "Gujarat",
    "district": "Bharuch",
    "block": "Jambusar",
    "officename": "Tankari SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "392110": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vadodara",
    "officename": "Amod SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "392130": {
    "state": "Gujarat",
    "district": "Bharuch",
    "block": "Vagra",
    "officename": "Dahej SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "392135": {
    "state": "Gujarat",
    "district": "Bharuch",
    "block": "Vagra",
    "officename": "Jolva SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "392140": {
    "state": "Gujarat",
    "district": "Bharuch",
    "block": "Vagra",
    "officename": "Vagra SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "392150": {
    "state": "Gujarat",
    "district": "Bharuch",
    "block": "Jambusar",
    "officename": "Jambusar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "392155": {
    "state": "Gujarat",
    "district": "Bharuch",
    "block": "Jambusar",
    "officename": "Kora SO Bharuch",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "392160": {
    "state": "Gujarat",
    "district": "Bharuch",
    "block": "Bharuch",
    "officename": "Karmad SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "392165": {
    "state": "Gujarat",
    "district": "Bharuch",
    "block": "Vagra",
    "officename": "Pakhajan SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "392170": {
    "state": "Gujarat",
    "district": "Bharuch",
    "block": "Jambusar",
    "officename": "Kavi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "392180": {
    "state": "Gujarat",
    "district": "Bharuch",
    "block": "Jambusar",
    "officename": "Sarod SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "392210": {
    "state": "Gujarat",
    "district": "Bharuch",
    "block": "Bharuch",
    "officename": "Nabipur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "392215": {
    "state": "Gujarat",
    "district": "Bharuch",
    "block": "Bharuch",
    "officename": "Urja Nagar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "392220": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Bharuch",
    "officename": "Palej SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "392230": {
    "state": "Gujarat",
    "district": "Bharuch",
    "block": "Amod",
    "officename": "Ikhar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "392240": {
    "state": "Gujarat",
    "district": "Bharuch",
    "block": "Bharuch",
    "officename": "Tankaria SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "392310": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Karjan",
    "officename": "Valan SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "393001": {
    "state": "Gujarat",
    "district": "Bharuch",
    "block": "Ankleshwar",
    "officename": "Ankleshwar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "393002": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Ankleshwar",
    "officename": "Ankleshwar IE SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "393010": {
    "state": "Gujarat",
    "district": "Bharuch",
    "block": "Anklesvar",
    "officename": "ONGC Colony SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "393017": {
    "state": "Gujarat",
    "district": "Bharuch",
    "block": "Jhagadia",
    "officename": "Avidha SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "393020": {
    "state": "Gujarat",
    "district": "Bharuch",
    "block": "Anklesvar",
    "officename": "Sajod SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "393025": {
    "state": "Gujarat",
    "district": "Bharuch",
    "block": "Jhagadia",
    "officename": "Selamba SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "393030": {
    "state": "Gujarat",
    "district": "Bharuch",
    "block": "Hansot",
    "officename": "Hansot SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "393040": {
    "state": "Gujarat",
    "district": "Narmada",
    "block": "Dediapada",
    "officename": "Dediapada SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "393041": {
    "state": "Gujarat",
    "district": "Bharuch",
    "block": "Dediapada",
    "officename": "Ambawadi SO Bharuch",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "393050": {
    "state": "Gujarat",
    "district": "Narmada",
    "block": "Sagbara",
    "officename": "Sagbara SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "393105": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Karjan",
    "officename": "Bhalod SO Vadodara",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "393110": {
    "state": "Gujarat",
    "district": "Bharuch",
    "block": "Jhagadia",
    "officename": "Jhagadia SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "393115": {
    "state": "Gujarat",
    "district": "Bharuch",
    "block": "Jhagadia",
    "officename": "Rajpardi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "393120": {
    "state": "Gujarat",
    "district": "Bharuch",
    "block": "Jhagadia",
    "officename": "Umalla SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "393125": {
    "state": "Gujarat",
    "district": "Bharuch",
    "block": "Valia",
    "officename": "Dehali SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "393130": {
    "state": "Gujarat",
    "district": "Narmada",
    "block": "Dediapada",
    "officename": "Netrang SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "393135": {
    "state": "Gujarat",
    "district": "Bharuch",
    "block": "Valia",
    "officename": "Valia SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "393140": {
    "state": "Gujarat",
    "district": "Narmada",
    "block": "Nandod",
    "officename": "Pratap Nagar SO Narmada",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "393145": {
    "state": "Gujarat",
    "district": "Narmada",
    "block": "Nandod",
    "officename": "Rajpipla SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "393150": {
    "state": "Gujarat",
    "district": "Narmada",
    "block": "Nandod",
    "officename": "Lachharas SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "393151": {
    "state": "Gujarat",
    "district": "Narmada",
    "block": "Nandod",
    "officename": "Kevadia Colony SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "394101": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Chorasi",
    "officename": "Mota Varachha SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "394105": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Chorasi",
    "officename": "Utran Power House SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "394107": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Chorasi",
    "officename": "Amroli SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "394110": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Olpad",
    "officename": "Kim SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "394115": {
    "state": "Gujarat",
    "district": "Bharuch",
    "block": "Anklesvar",
    "officename": "Panoli SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "394120": {
    "state": "Gujarat",
    "district": "Bharuch",
    "block": "Olpad",
    "officename": "Kosamba RS SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "394125": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Mangrol",
    "officename": "Hathuran SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "394130": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Sayan",
    "officename": "Sayan SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "394140": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Mandvi",
    "officename": "Bodhan SO Surat",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394150": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Kamrej",
    "officename": "Kathor SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394155": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Kamrej",
    "officename": "Ghala SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394160": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Mandvi",
    "officename": "Mandvi SR SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394163": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Mandvi",
    "officename": "Godsamba SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394170": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Mandvi",
    "officename": "Tadkeshwar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394180": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Kamrej",
    "officename": "Kamrej SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394185": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Kamrej",
    "officename": "Kamrej Char Rasta SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394190": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Kamrej",
    "officename": "Kholvad SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394210": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Chorasi",
    "officename": "Udhna SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "394221": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Surat City",
    "officename": "Pandesara IE SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "394230": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Sachin",
    "officename": "Sachin SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "394235": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Lajpore",
    "officename": "Lajpore SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "394240": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Mahuva",
    "officename": "Karchelia SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394245": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Mahuva",
    "officename": "Zervavra SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394246": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Valod",
    "officename": "Sugar Factory Bamania SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394248": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Mahuva",
    "officename": "Valvada SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394250": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Mahuva",
    "officename": "Mahuva SO Surat",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394270": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Surat",
    "officename": "Hajira SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "394305": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Palsana",
    "officename": "Chalthan SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394310": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Palsana",
    "officename": "Gangadhara RS SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394315": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Palsana",
    "officename": "Palsana SO Surat",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394317": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Palsana",
    "officename": "Baleshwar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394320": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Kamrej",
    "officename": "Sevni SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394325": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Palsana",
    "officename": "Umbhel SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394326": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Kamrej",
    "officename": "Vav Kathodara SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394327": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Palsana",
    "officename": "Kadodara SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394330": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Kamrej",
    "officename": "Orna SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394335": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Bardoli",
    "officename": "Kadod SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394340": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Mandvi",
    "officename": "Madhi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394345": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Bardoli",
    "officename": "Mota SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394350": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Palsana",
    "officename": "Sarbhon SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394352": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Palsana",
    "officename": "Puni SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394355": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Bardoli",
    "officename": "Varad SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394365": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Songadh",
    "officename": "Raniamba SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394370": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Nizar",
    "officename": "Nijhar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394375": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Uchchhal",
    "officename": "Uchchhal SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394380": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Nizar",
    "officename": "Kukurmunda SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394405": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Mangrol",
    "officename": "Velachha SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "394410": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Mangrol",
    "officename": "Mota Miya Mangrol SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "394421": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Mangrol",
    "officename": "Mosali SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "394430": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Vankal",
    "officename": "Vankal SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "394440": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Zankhvav",
    "officename": "Zankhvav SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "394445": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Umarpada",
    "officename": "Umarpada SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "394510": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Choryasi",
    "officename": "Bhatha SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "394515": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Chorasi",
    "officename": "Kribhconagar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "394516": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Chorasi",
    "officename": "Adityanagar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "394517": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Choryasi",
    "officename": "Mora SO Surat",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "394518": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Chorasi",
    "officename": "Ongc Nagar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "394520": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Variav",
    "officename": "Variav SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "394530": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Olpad",
    "officename": "Mor SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "394540": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Olpad",
    "officename": "Olpad SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "394550": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Variav",
    "officename": "Dumas SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "394601": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Bardoli",
    "officename": "Bardoli HO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394620": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Bardoli",
    "officename": "Vankaner SR SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394630": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Valod",
    "officename": "Buhari SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394633": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Vyara",
    "officename": "Gadat SO Tapi",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394635": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Valod",
    "officename": "Dolvan SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394640": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Valod",
    "officename": "Valod SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394641": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Valod",
    "officename": "Gandhi Vidhyapith BO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394650": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Vyara",
    "officename": "Vyara SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394651": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Songadh",
    "officename": "Anumala SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394655": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Vyara",
    "officename": "Kapura SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394660": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Songadh",
    "officename": "Centrap Pulp Mill SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394670": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Songadh",
    "officename": "Fort Songadh SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394680": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Songadh",
    "officename": "Ukai Dam SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394690": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Valod",
    "officename": "Bajipura SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394710": {
    "state": "Gujarat",
    "district": "The Dangs",
    "block": "Ahwa",
    "officename": "Ahwadangs SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394715": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Ahwa",
    "officename": "Pimpri SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394716": {
    "state": "Gujarat",
    "district": "The Dangs",
    "block": "Dang",
    "officename": "Subir SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394720": {
    "state": "Gujarat",
    "district": "The Dangs",
    "block": "Dang",
    "officename": "Saputara SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394730": {
    "state": "Gujarat",
    "district": "The Dangs",
    "block": "Dang",
    "officename": "Waghai SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "394810": {
    "state": "Gujarat",
    "district": "Bharuch",
    "block": "Hansot",
    "officename": "Ilav SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bharuch Division"
  },
  "395001": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Surat City",
    "officename": "Nanpura HO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "395002": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Surat City",
    "officename": "Sagrampura Putli SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "395003": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Variav",
    "officename": "Surat HO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "395004": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Surat City",
    "officename": "Katargam SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "395005": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Surat",
    "officename": "Rander SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "395006": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Surat",
    "officename": "Varachha Road SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "395007": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Surat",
    "officename": "SVR College SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "395008": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Surat City",
    "officename": "A K Road SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "395009": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Surat City",
    "officename": "Navyug College SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "395010": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Surat City",
    "officename": "Bombay Market SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "395011": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Choryasi",
    "officename": "Puna Kumbharia SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "395012": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Surat City",
    "officename": "Limbayat SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "395013": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Choryasi",
    "officename": "Sarthana SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "395017": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Surat City",
    "officename": "Althan SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "395023": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Surat",
    "officename": "Bhestan SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "396001": {
    "state": "Gujarat",
    "district": "Valsad",
    "block": "Valsad",
    "officename": "Valsad HO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396002": {
    "state": "Gujarat",
    "district": "Valsad",
    "block": "Valsad",
    "officename": "Valsad Abrama SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396007": {
    "state": "Gujarat",
    "district": "Valsad",
    "block": "Valsad",
    "officename": "Valsad Sugar Factory SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396020": {
    "state": "Gujarat",
    "district": "Valsad",
    "block": "Valsad",
    "officename": "Atul SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396030": {
    "state": "Gujarat",
    "district": "Valsad",
    "block": "Valsad",
    "officename": "Hanuman Bhagda SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396035": {
    "state": "Gujarat",
    "district": "Valsad",
    "block": "Valsad",
    "officename": "Valsad IE SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396040": {
    "state": "Gujarat",
    "district": "Navsari",
    "block": "Chikhli",
    "officename": "Khergam SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Navsari Division"
  },
  "396045": {
    "state": "Gujarat",
    "district": "Valsad",
    "block": "Valsad",
    "officename": "Atgam SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396050": {
    "state": "Gujarat",
    "district": "Valsad",
    "block": "Dharampur",
    "officename": "Dharampur SO Valsad",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396051": {
    "state": "Gujarat",
    "district": "Valsad",
    "block": "Dharampur",
    "officename": "Amba Talat SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396055": {
    "state": "Gujarat",
    "district": "Valsad",
    "block": "Valsad",
    "officename": "Ronvel SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396060": {
    "state": "Gujarat",
    "district": "Navsari",
    "block": "Chikhli",
    "officename": "Rumla SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Navsari Division"
  },
  "396065": {
    "state": "Gujarat",
    "district": "Valsad",
    "block": "Kaprada",
    "officename": "Nanivahiyal SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396105": {
    "state": "Gujarat",
    "district": "Valsad",
    "block": "Umargam",
    "officename": "Bhilad SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396110": {
    "state": "Gujarat",
    "district": "Navsari",
    "block": "Gandevi",
    "officename": "Bigri SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Navsari Division"
  },
  "396115": {
    "state": "Gujarat",
    "district": "Valsad",
    "block": "Pardi",
    "officename": "Kolak SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396120": {
    "state": "Gujarat",
    "district": "Valsad",
    "block": "Umargam",
    "officename": "Khatalwada SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396125": {
    "state": "Gujarat",
    "district": "Valsad",
    "block": "Pardi",
    "officename": "Killa Pardi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396126": {
    "state": "Gujarat",
    "district": "Valsad",
    "block": "Kaprada",
    "officename": "Nanapondha SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396130": {
    "state": "Gujarat",
    "district": "Valsad",
    "block": "Umbergaon",
    "officename": "Maroli Sanjan SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396135": {
    "state": "Gujarat",
    "district": "Valsad",
    "block": "Umargam",
    "officename": "Nargol SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396140": {
    "state": "Gujarat",
    "district": "Valsad",
    "block": "Umargam",
    "officename": "Phansa SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396145": {
    "state": "Gujarat",
    "district": "Valsad",
    "block": "Pardi",
    "officename": "Pardi Paria SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396150": {
    "state": "Gujarat",
    "district": "Valsad",
    "block": "Umargam",
    "officename": "Sanjan SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396155": {
    "state": "Gujarat",
    "district": "Valsad",
    "block": "Umargam",
    "officename": "Sarigam SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396165": {
    "state": "Gujarat",
    "district": "Valsad",
    "block": "Umargam",
    "officename": "Solsumba SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396170": {
    "state": "Gujarat",
    "district": "Valsad",
    "block": "Umargam",
    "officename": "Umargam SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396171": {
    "state": "Gujarat",
    "district": "Valsad",
    "block": "Umbergaon",
    "officename": "Umargam IE SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396180": {
    "state": "Gujarat",
    "district": "Valsad",
    "block": "Pardi",
    "officename": "Udvada SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396185": {
    "state": "Gujarat",
    "district": "Valsad",
    "block": "Pardi",
    "officename": "Udvada RS SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396191": {
    "state": "Gujarat",
    "district": "Valsad",
    "block": "Pardi",
    "officename": "Vapi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396193": {
    "state": "Dadra & Nagar Haveli",
    "district": "Dadra & Nagar Haveli",
    "block": "Dadra & Nagar Haveli",
    "officename": "Dadra SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396195": {
    "state": "Gujarat",
    "district": "Valsad",
    "block": "Pardi",
    "officename": "Vapi IE SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396210": {
    "state": "Daman & Diu",
    "district": "Daman",
    "block": "Daman",
    "officename": "Daman SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396215": {
    "state": "Daman & Diu",
    "district": "Daman",
    "block": "Daman",
    "officename": "Daman IE SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396220": {
    "state": "Daman & Diu",
    "district": "Daman",
    "block": "Daman",
    "officename": "Moti Daman SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396230": {
    "state": "Gujarat",
    "district": "Valsad",
    "block": "Umbergaon",
    "officename": "Silvassa SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396235": {
    "state": "Gujarat",
    "district": "Valsad",
    "block": "Umargam",
    "officename": "Naroli SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396240": {
    "state": "Dadra & Nagar Haveli",
    "district": "Dadra & Nagar Haveli",
    "block": "Dadra & Nagar Haveli",
    "officename": "Karad Daman Project SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396310": {
    "state": "Gujarat",
    "district": "Navsari",
    "block": "Gandevi",
    "officename": "Amalsad SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Navsari Division"
  },
  "396321": {
    "state": "Gujarat",
    "district": "Navsari",
    "block": "Gandevi",
    "officename": "Bilimora SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Navsari Division"
  },
  "396325": {
    "state": "Gujarat",
    "district": "Navsari",
    "block": "Gandevi",
    "officename": "Antalia SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Navsari Division"
  },
  "396350": {
    "state": "Gujarat",
    "district": "Navsari",
    "block": "Gandevi",
    "officename": "Gadat SO Navsari",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Navsari Division"
  },
  "396360": {
    "state": "Gujarat",
    "district": "Navsari",
    "block": "Gandevi",
    "officename": "Gandevi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Navsari Division"
  },
  "396370": {
    "state": "Gujarat",
    "district": "Navsari",
    "block": "Gandevi",
    "officename": "Kachholi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Navsari Division"
  },
  "396375": {
    "state": "Gujarat",
    "district": "Valsad",
    "block": "Valsad",
    "officename": "Dungri SO Valsad",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396380": {
    "state": "Gujarat",
    "district": "Navsari",
    "block": "Gandevi",
    "officename": "Devsar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Navsari Division"
  },
  "396385": {
    "state": "Gujarat",
    "district": "Valsad",
    "block": "Valsad",
    "officename": "Untdi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "396403": {
    "state": "Gujarat",
    "district": "Navsari",
    "block": "Jalalpore",
    "officename": "Aat SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Navsari Division"
  },
  "396406": {
    "state": "Gujarat",
    "district": "Navsari",
    "block": "Jalalpore",
    "officename": "Abrama SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Navsari Division"
  },
  "396409": {
    "state": "Gujarat",
    "district": "Navsari",
    "block": "Chikhli",
    "officename": "Alipore SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Navsari Division"
  },
  "396412": {
    "state": "Gujarat",
    "district": "Navsari",
    "block": "Jalalpore",
    "officename": "Bori Falia SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Navsari Division"
  },
  "396415": {
    "state": "Gujarat",
    "district": "Navsari",
    "block": "Jalalpore",
    "officename": "Dabhel SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Navsari Division"
  },
  "396418": {
    "state": "Gujarat",
    "district": "Navsari",
    "block": "Navsari",
    "officename": "Gurukulsupa SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Navsari Division"
  },
  "396421": {
    "state": "Gujarat",
    "district": "Navsari",
    "block": "Jalalpore",
    "officename": "Jalalpore SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Navsari Division"
  },
  "396427": {
    "state": "Gujarat",
    "district": "Navsari",
    "block": "Navsari",
    "officename": "Kaliawadi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Navsari Division"
  },
  "396430": {
    "state": "Gujarat",
    "district": "Navsari",
    "block": "Gandevi",
    "officename": "Kharel SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Navsari Division"
  },
  "396433": {
    "state": "Gujarat",
    "district": "Navsari",
    "block": "Navsari",
    "officename": "Khadsupa Boarding SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Navsari Division"
  },
  "396436": {
    "state": "Gujarat",
    "district": "Navsari",
    "block": "Jalalpore",
    "officename": "Maroli Bazar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Navsari Division"
  },
  "396439": {
    "state": "Gujarat",
    "district": "Navsari",
    "block": "Jalalpore",
    "officename": "Matvad SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Navsari Division"
  },
  "396445": {
    "state": "Gujarat",
    "district": "Navsari",
    "block": "Navsari",
    "officename": "Navsari HO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Navsari Division"
  },
  "396450": {
    "state": "Gujarat",
    "district": "Navsari",
    "block": "Jalalpore",
    "officename": "Eru Ac SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Navsari Division"
  },
  "396460": {
    "state": "Gujarat",
    "district": "Navsari",
    "block": "Jalalpore",
    "officename": "Panar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Navsari Division"
  },
  "396463": {
    "state": "Gujarat",
    "district": "Navsari",
    "block": "Navsari",
    "officename": "Sisodra SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Navsari Division"
  },
  "396466": {
    "state": "Gujarat",
    "district": "Navsari",
    "block": "Navsari",
    "officename": "Satem SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Navsari Division"
  },
  "396469": {
    "state": "Gujarat",
    "district": "Navsari",
    "block": "Navsari",
    "officename": "Ugat SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Navsari Division"
  },
  "396472": {
    "state": "Gujarat",
    "district": "Navsari",
    "block": "Navsari",
    "officename": "Vedchha SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Navsari Division"
  },
  "396475": {
    "state": "Gujarat",
    "district": "Navsari",
    "block": "Jalalpore",
    "officename": "Vesma SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Navsari Division"
  },
  "396510": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Mahuva",
    "officename": "Anaval SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "396521": {
    "state": "Gujarat",
    "district": "Navsari",
    "block": "Chikhli",
    "officename": "Chikhli SO Navsari",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Navsari Division"
  },
  "396530": {
    "state": "Gujarat",
    "district": "Navsari",
    "block": "Chikhli",
    "officename": "Degam SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Navsari Division"
  },
  "396540": {
    "state": "Gujarat",
    "district": "Navsari",
    "block": "Chikhli",
    "officename": "Fadvel SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Navsari Division"
  },
  "396560": {
    "state": "Gujarat",
    "district": "Navsari",
    "block": "Chikhli",
    "officename": "Rankuva SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Navsari Division"
  },
  "396570": {
    "state": "Gujarat",
    "district": "Navsari",
    "block": "Chikhli",
    "officename": "Digendranagar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Navsari Division"
  },
  "396580": {
    "state": "Gujarat",
    "district": "Navsari",
    "block": "Vansda",
    "officename": "Vansda SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Navsari Division"
  },
  "396590": {
    "state": "Gujarat",
    "district": "Navsari",
    "block": "Vansda",
    "officename": "Unai SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Navsari Division"
  },
  "400001": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Mumbai GPO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai GPO Division"
  },
  "400002": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Kalbadevi H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City South Division"
  },
  "400003": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Mandvi S.O (Mumbai)",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City East Division"
  },
  "400004": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Girgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City South Division"
  },
  "400005": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Colaba SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City South Division"
  },
  "400006": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Malabar Hill S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City West Division"
  },
  "400007": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Grant Road S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City West Division"
  },
  "400008": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Mumbai Central H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City West Division"
  },
  "400009": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "CHINCHBUNDER S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City East Division"
  },
  "400010": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Mazgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City East Division"
  },
  "400011": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Jacob Circle S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City West Division"
  },
  "400012": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Parel S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City East Division"
  },
  "400013": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Delisle Road S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City West Division"
  },
  "400014": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Dadar H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City East Division"
  },
  "400015": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Sewri S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City East Division"
  },
  "400016": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Mahim H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City West Division"
  },
  "400017": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Dharavi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City West Division"
  },
  "400018": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Worli S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City West Division"
  },
  "400019": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Matunga SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North East Division"
  },
  "400020": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Marine Lines S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City South Division"
  },
  "400021": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Nariman Point SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City South Division"
  },
  "400022": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Sion SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North East Division"
  },
  "400024": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Nehru Nagar SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North East Division"
  },
  "400025": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Prabhadevi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City West Division"
  },
  "400026": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Cumballa Hill S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City West Division"
  },
  "400027": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "V J B Udyan S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City East Division"
  },
  "400028": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Bhawani Shankar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City West Division"
  },
  "400029": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Santacruz P and T  Colony S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North Division"
  },
  "400030": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Worli Colony S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City West Division"
  },
  "400031": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Wadala S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City East Division"
  },
  "400032": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Mantralaya SO Mumbai",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City South Division"
  },
  "400033": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Tank Road S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City East Division"
  },
  "400034": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Tulsiwadi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City West Division"
  },
  "400035": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Rajbhavan S.O (Mumbai)",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City West Division"
  },
  "400037": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Antop Hill S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City East Division"
  },
  "400042": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Bhandup East SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North East Division"
  },
  "400043": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Shivaji Nagar SO Mumbai",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North East Division"
  },
  "400049": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Juhu S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North Division"
  },
  "400050": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Bandra West S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North Division"
  },
  "400051": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Bandra",
    "officename": "Bandra(East) S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North Division"
  },
  "400052": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Khar Delivery S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North Division"
  },
  "400053": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Andheri H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North Division"
  },
  "400054": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Santacruz(West) S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North Division"
  },
  "400055": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Santacruz(East) S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North Division"
  },
  "400056": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Vileparle(West) S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North Division"
  },
  "400057": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Vileeparle (East) S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North Division"
  },
  "400058": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Andheri Railway Station S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North Division"
  },
  "400059": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "J.B. Nagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North Division"
  },
  "400060": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Jogeshwari East",
    "officename": "Jogeshwari East SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North West Division"
  },
  "400061": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Vesava S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North Division"
  },
  "400063": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Goregaon East",
    "officename": "Goregaon East SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North West Division"
  },
  "400064": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Malad West",
    "officename": "Malad West Dely SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North West Division"
  },
  "400065": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Goregaon East",
    "officename": "Aareymilk Colony SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North West Division"
  },
  "400066": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Borivlai East",
    "officename": "Borivali East SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North West Division"
  },
  "400067": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Kandivlai West",
    "officename": "Kandivali West SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North West Division"
  },
  "400068": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Dahisar East",
    "officename": "Dahisar SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North West Division"
  },
  "400069": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Andheri East S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North Division"
  },
  "400070": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Kurla West SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North East Division"
  },
  "400071": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Chembur HO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North East Division"
  },
  "400072": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Sakinaka SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North East Division"
  },
  "400074": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "FCI SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North East Division"
  },
  "400075": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Pant Nagar SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North East Division"
  },
  "400076": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Powai Iit SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North East Division"
  },
  "400077": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Rajawadi SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North East Division"
  },
  "400078": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Bhandup West SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North East Division"
  },
  "400079": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Vikhroli SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North East Division"
  },
  "400080": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Mulund West SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North East Division"
  },
  "400081": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Mulund East SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North East Division"
  },
  "400082": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Bhandup Complex SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North East Division"
  },
  "400083": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Tagore Nagar SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North East Division"
  },
  "400084": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Barve Nagar SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North East Division"
  },
  "400085": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "BARC SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North East Division"
  },
  "400086": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Ghatkopar West SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North East Division"
  },
  "400087": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "IIM Mumbai PO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North East Division"
  },
  "400088": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "T F Deonar SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North East Division"
  },
  "400089": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Tilak Nagar SO Mumbai",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North East Division"
  },
  "400091": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Borivali West",
    "officename": "Borivali HO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North West Division"
  },
  "400092": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Borivali West",
    "officename": "Borivali West SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North West Division"
  },
  "400093": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Chakala Midc S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North Division"
  },
  "400094": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Anushakti Nagar SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North East Division"
  },
  "400095": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Malad West",
    "officename": "Kharodi SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North West Division"
  },
  "400096": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Seepz S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North Division"
  },
  "400097": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Malad East",
    "officename": "Malad East SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North West Division"
  },
  "400098": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Vidyanagari S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North Division"
  },
  "400099": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Mumbai",
    "officename": "Sahar P and T Colony S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North Division"
  },
  "400101": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Kandivali East",
    "officename": "Kandivali East SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North West Division"
  },
  "400102": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Jogeshwari West",
    "officename": "Jogeshwari West SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North West Division"
  },
  "400103": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Borivali West",
    "officename": "Mandapeshwar SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North West Division"
  },
  "400104": {
    "state": "Maharashtra",
    "district": "Mumbai",
    "block": "Goregaon West",
    "officename": "Motilal Nagar SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Mumbai Region",
    "divisionname": "Mumbai City North West Division"
  },
  "400601": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Thane",
    "officename": "Thane H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "400602": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Thane",
    "officename": "Naupada S.O (Thane)",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "400603": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Thane",
    "officename": "Thane East S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "400604": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Thane",
    "officename": "Wagle I.E. S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "400605": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Thane",
    "officename": "Kalwa S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "400606": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Thane",
    "officename": "Jekegram S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "400607": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Thane",
    "officename": "Sandozbaugh S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "400608": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Thane",
    "officename": "Balkum S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "400610": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Thane",
    "officename": "Apna Bazar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "400612": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Thane",
    "officename": "Mumbra S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "400614": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Thane",
    "officename": "Konkan Bhavan S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Navi Mumbai Division"
  },
  "400615": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Thane",
    "officename": "Kasarvadavali S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "400701": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Rabale",
    "officename": "Ghansoli S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Navi Mumbai Division"
  },
  "400702": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Uran",
    "officename": "Uran S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Navi Mumbai Division"
  },
  "400703": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Thane",
    "officename": "Vashi S.O (Thane)",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Navi Mumbai Division"
  },
  "400704": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Uran",
    "officename": "N.S.Karanja S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Navi Mumbai Division"
  },
  "400705": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Thane",
    "officename": "Sanpada S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Navi Mumbai Division"
  },
  "400706": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Thane",
    "officename": "Nerul Node III S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Navi Mumbai Division"
  },
  "400707": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Uran",
    "officename": "Jnpt S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Navi Mumbai Division"
  },
  "400708": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Digha",
    "officename": "Airoli S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Navi Mumbai Division"
  },
  "400709": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Thane",
    "officename": "Kopar Khairne S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Navi Mumbai Division"
  },
  "400710": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Thane",
    "officename": "Millenium Business Park S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Navi Mumbai Division"
  },
  "401101": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Thane",
    "officename": "Bhayander West S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401102": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Mokhada",
    "officename": "Umbarpada S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401103": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Dahanu",
    "officename": "Vangaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401105": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Thane",
    "officename": "Bhayander East S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401106": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Vasai",
    "officename": "Uttan S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401107": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Vasai",
    "officename": "Mira Road S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401201": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Bassein",
    "officename": "Bassein S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401202": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Bassein",
    "officename": "Bassein Road S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401203": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Vasai",
    "officename": "Sopara S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401204": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Vada",
    "officename": "Vajreshwari S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401206": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Bhiwandi"
  },
  "401207": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Vasai",
    "officename": "Papdi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401208": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Vasai",
    "officename": "Vasai East IE S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401209": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Vasai",
    "officename": "Nallosapare E S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401301": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Vasai",
    "officename": "Agashi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401302": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Vasai",
    "officename": "Arnala S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401303": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Vasai",
    "officename": "Virar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401304": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Vasai",
    "officename": "Nirmal S.O (Thane)",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401305": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Vasai",
    "officename": "Virar East S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401401": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Palghar",
    "officename": "Kelwa S.O (Thane)",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401402": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Palghar",
    "officename": "Kelwa mahim S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401403": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Palghar",
    "officename": "Manor S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401404": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Palghar",
    "officename": "Palghar H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401405": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Palghar",
    "officename": "Satpati S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401501": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Dahanu",
    "officename": "Boisar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401502": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Palghar",
    "officename": "Tarapur S.O (Thane)",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401503": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Dahanu",
    "officename": "Chinchani S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401504": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Palghar",
    "officename": "Tarapur App S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401506": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Palghar",
    "officename": "Tarapur Ti S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401601": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Dahanu",
    "officename": "Dahanu S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401602": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Mokhada",
    "officename": "Dahanu Road S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401603": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Dahanu",
    "officename": "Jawhar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401604": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Mokhada",
    "officename": "Mokhada S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401605": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Palghar",
    "officename": "Vikramgad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401606": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Talasari",
    "officename": "Talasari S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401607": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Dahanu",
    "officename": "Kasa S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401608": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Dahanu",
    "officename": "Dahanu TPS S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401701": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Dahanu",
    "officename": "Bordi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401702": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Dahanu",
    "officename": "Gholvad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "401703": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Dahanu",
    "officename": "Kosbad hill S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "402101": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Mhasla",
    "officename": "Ambet SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402102": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Mahad",
    "officename": "Dasgaon SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402103": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Mangaon",
    "officename": "Goregaon SO RaigarhMH",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402104": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Mangaon",
    "officename": "Mangaon SO RaigarhMH",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402105": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Mhasla",
    "officename": "Mhasla SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402106": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Roha",
    "officename": "Nagothane SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402107": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Pen",
    "officename": "Pen SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402108": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Alibag",
    "officename": "Poynad SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402109": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Roha",
    "officename": "Roha SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402110": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Shrivardhan",
    "officename": "Shriwardhan SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402111": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Mangaon",
    "officename": "Tala SO RaigarhMH",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402112": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Mangaon",
    "officename": "Talashet SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402113": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Shrivardhan",
    "officename": "Walwati SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402114": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Shriwardhan",
    "officename": "Bagmandla SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402115": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Mahad",
    "officename": "Upper Tudil SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402116": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Roha",
    "officename": "Roha AV SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402117": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Mangaon",
    "officename": "Morba SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402120": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Mangaon",
    "officename": "Nizampur SO RaigarhMH",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402122": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Mangaon",
    "officename": "Sai SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402125": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Pen",
    "officename": "PCTS Nagothane SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402126": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Roha",
    "officename": "Pipenagar SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402201": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Alibag",
    "officename": "Alibag HO",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402202": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Alibag",
    "officename": "Revdanda SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402203": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Shriwardhan",
    "officename": "Chaul SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402204": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Alibag",
    "officename": "Nagaon SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402207": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Alibag",
    "officename": "Thal SO RaigarhMH",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402208": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Alibag",
    "officename": "RCF Thal SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402209": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Alibag",
    "officename": "Kurul RCF Colony SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402301": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Mahad",
    "officename": "Mahad SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402302": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Mahad",
    "officename": "Birwadi SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402303": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Poladpur",
    "officename": "Poladpur SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402304": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Roha",
    "officename": "Kolad SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402305": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Mahad",
    "officename": "Nate SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402306": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Mahad",
    "officename": "Varandh SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402307": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Mahad",
    "officename": "Vinhere SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402308": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Roha",
    "officename": "Bhira SO RaigarhMH",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402309": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Mahad",
    "officename": "Midc Mahad SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402401": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Murud",
    "officename": "Janjira Murud SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402402": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Shriwardhan",
    "officename": "Dighi SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402403": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Shriwardhan",
    "officename": "Borlipanchatan SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "402404": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Shriwardhan",
    "officename": "Diveagar SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "403001": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Tiswadi",
    "officename": "Panaji H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403002": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Tiswadi",
    "officename": "Caranzalem S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403004": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Tiswadi",
    "officename": "Nio Dona Paula S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403005": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Tiswadi",
    "officename": "Santa Cruz S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403006": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Tiswadi",
    "officename": "Ribandar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403101": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Bardez",
    "officename": "Betim S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403102": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Tiswadi",
    "officename": "Chorao S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403103": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Ponda",
    "officename": "Shiroda S.O (South Goa)",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403104": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Tiswadi",
    "officename": "Neura S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403105": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Sattari",
    "officename": "Pale S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403106": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Ponda",
    "officename": "Sant Estevam S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403107": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Sanquelim",
    "officename": "Marcela S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403108": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Tiswadi",
    "officename": "Goa  velha S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403109": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Tiswadi",
    "officename": "N B Verem S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403110": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Tiswadi",
    "officename": "Corlim IE S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403114": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Tiswadi",
    "officename": "Reis Magos S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403115": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Ponda",
    "officename": "Cundaim I.E. S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403201": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Tiswadi",
    "officename": "Bambolim Camp S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403202": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Tiswadi",
    "officename": "Bambolim Complex S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403203": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Tiswadi",
    "officename": "Pilar S.O (North Goa)",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403204": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Tiswadi",
    "officename": "St. Lourence S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403206": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Tiswadi",
    "officename": "Goa University S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403401": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Ponda",
    "officename": "Ponda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403402": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Tiswadi",
    "officename": "Velha goa S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403403": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Tiswadi",
    "officename": "Piedade S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403404": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Ponda",
    "officename": "Mardol S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403406": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Ponda",
    "officename": "Tisca S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403409": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Ponda",
    "officename": "Betora I.E. S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403410": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Quepem",
    "officename": "Collem S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403501": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Bardez",
    "officename": "Porvorim S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403502": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Bicholim",
    "officename": "Tivim S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403503": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Bicholim",
    "officename": "Assonora S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403504": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Bicholim",
    "officename": "Bicholim S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403505": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Bicholim",
    "officename": "Sanquelim S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403506": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Sattari",
    "officename": "Valpoi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403507": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Bardez",
    "officename": "Mapusa S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403508": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Bardez",
    "officename": "Aldona S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403509": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Bardez",
    "officename": "Anjuna S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403510": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Bardez",
    "officename": "Parra S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403511": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Bardez",
    "officename": "Saligao S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403512": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Pernem",
    "officename": "Pernem S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403513": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Bardez",
    "officename": "Colvale S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403515": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Bardez",
    "officename": "Candolim S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403516": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Bardez",
    "officename": "Calangute S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403517": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Bardez",
    "officename": "Siolim S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403521": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Bardez",
    "officename": "Alto porvorim S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403523": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Bardez",
    "officename": "Carona S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403524": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Bardez",
    "officename": "Arambol S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403526": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Bardez",
    "officename": "Tivim Ie S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403527": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Pernem",
    "officename": "Mandrem S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403529": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Bicholim",
    "officename": "Bicholim Industrial Estate S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403530": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Sattari",
    "officename": "Onda I.E. S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403601": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Salcete",
    "officename": "Margao H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403602": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Salcete",
    "officename": "Fatorda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403701": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Salcete",
    "officename": "Assolna S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403702": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Canacona",
    "officename": "Canacona S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403703": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Salcete",
    "officename": "Cuncolim S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403704": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Sangaum",
    "officename": "Sanguem S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403705": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Quepem",
    "officename": "Quepem S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403706": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Quepem",
    "officename": "Curchorem S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403707": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Salcete",
    "officename": "Navelim S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403708": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Salcete",
    "officename": "Colva S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403709": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Salcete",
    "officename": "Curtorim S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403710": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Salcete",
    "officename": "Cortalim S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403711": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Mormugao",
    "officename": "Chicalim S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403712": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Salcete",
    "officename": "Cansaulim S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403713": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Salcete",
    "officename": "Majorda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403714": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Salcete",
    "officename": "Chandor S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403715": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Salcete",
    "officename": "Chinchinim S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403716": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Salcete",
    "officename": "Benaulim S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403717": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Salcete",
    "officename": "Carmona S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403718": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Salcete",
    "officename": "Loutolim S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403719": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Salcete",
    "officename": "Sem rachol  Soso S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403720": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Salcete",
    "officename": "Raia S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403721": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Salcete",
    "officename": "Varca S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403722": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Salcete",
    "officename": "Verna S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403723": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Salcate",
    "officename": "Velim S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403724": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Salcete",
    "officename": "Orlim S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403725": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Salcete",
    "officename": "Dramapur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403726": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Mormugao",
    "officename": "Zuarinagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403728": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Canacona",
    "officename": "Loliem S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403729": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Salcete",
    "officename": "Navelim Camp S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403731": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Salcete",
    "officename": "Cavelossim S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403801": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Mormugao",
    "officename": "A.P.Dabolim S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403802": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Mormugao",
    "officename": "Vasco Da Gama S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403803": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Mormugao",
    "officename": "Mormugao S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403804": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Mormugao",
    "officename": "Sada S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "403806": {
    "state": "Goa",
    "district": "South Goa",
    "block": "Mormugao",
    "officename": "Bogmalo S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "410101": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Karjat",
    "officename": "Neral S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Navi Mumbai Division"
  },
  "410102": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Karjat",
    "officename": "Matheran S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Navi Mumbai Division"
  },
  "410201": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Panvel",
    "officename": "Karjat S.O (Raigarh(MH))",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Navi Mumbai Division"
  },
  "410202": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Khalapur",
    "officename": "Khalapur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Navi Mumbai Division"
  },
  "410203": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Khalapur",
    "officename": "Shilphata S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Navi Mumbai Division"
  },
  "410204": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Khopoli",
    "officename": "Khopoli Power House S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Navi Mumbai Division"
  },
  "410205": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Sudhagad",
    "officename": "Pali SO RaigarhMH",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "410206": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Panvel",
    "officename": "Panvel H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Navi Mumbai Division"
  },
  "410207": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Panvel",
    "officename": "Rasayani S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Navi Mumbai Division"
  },
  "410208": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Panvel",
    "officename": "Taloja A.V. S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Navi Mumbai Division"
  },
  "410210": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Panvel",
    "officename": "Kharghar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Navi Mumbai Division"
  },
  "410216": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Karjat",
    "officename": "Jagdish Nagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Navi Mumbai Division"
  },
  "410218": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Panvel",
    "officename": "Kalamboli Node S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Navi Mumbai Division"
  },
  "410220": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Khalapur",
    "officename": "Patalganga S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Navi Mumbai Division"
  },
  "410221": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Panvel",
    "officename": "Ongc Complexpanvel S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Navi Mumbai Division"
  },
  "410222": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Khalapur",
    "officename": "Mohopada S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Navi Mumbai Division"
  },
  "410301": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Maval",
    "officename": "Khandala S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "410302": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Maval",
    "officename": "R P T S Khandala S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "410401": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Maval",
    "officename": "Lonavala S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "410402": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Mawal",
    "officename": "Ins Shivaji Lonavale S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "410403": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Maval",
    "officename": "Kaivalyadham S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "410405": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Maval",
    "officename": "Kamshet S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "410406": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Mawal",
    "officename": "Pawananagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "410501": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Khed",
    "officename": "Chakan S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "410502": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Junnar",
    "officename": "Junnar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "410503": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Ambegaon",
    "officename": "Manchar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "410504": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Junnar",
    "officename": "Narayangaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "410505": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Khed",
    "officename": "Rajgurunagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "410506": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Maval",
    "officename": "Talegaon Dabhade S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "410507": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Maval",
    "officename": "Talegaon G H S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "410508": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Ambegaon",
    "officename": "Dhamani S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "410509": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Ambegaon",
    "officename": "Dimbhe Colony S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "410510": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Ambegaon",
    "officename": "Loni Dhamani S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "410511": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Junnar",
    "officename": "Shiroli B K S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "410512": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Khed",
    "officename": "Peth S.O (Pune)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "410513": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Khed",
    "officename": "Chas S.O (Pune)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "410515": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Ambegaon",
    "officename": "Kalamb S.O (Pune)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "410516": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Ambegaon",
    "officename": "Shinoli S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "411001": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "Pune H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City East Division"
  },
  "411002": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "Pune City H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City West Division"
  },
  "411003": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "Khadki S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City East Division"
  },
  "411004": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "Deccan Gymkhana S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City West Division"
  },
  "411005": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "Shivajinagar H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "411006": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "Yerwada S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City East Division"
  },
  "411007": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Haveli",
    "officename": "Ganeshkhind S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City West Division"
  },
  "411008": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "N.C.L. Pune S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City West Division"
  },
  "411009": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "Parvati S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City West Division"
  },
  "411011": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "Kasba Peth S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City West Division"
  },
  "411012": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "Dapodi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City East Division"
  },
  "411013": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "Hadpsar I.E. S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City East Division"
  },
  "411014": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "Dunkirk lines S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City East Division"
  },
  "411015": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "Dighi Camp S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City East Division"
  },
  "411016": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Haveli",
    "officename": "Model Colony S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City West Division"
  },
  "411017": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "Pimpri Colony S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City East Division"
  },
  "411018": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "Pimpri P F S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City East Division"
  },
  "411019": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "Chinchwad East S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City East Division"
  },
  "411020": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "Range Hills S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City West Division"
  },
  "411021": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "Armament S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City West Division"
  },
  "411022": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "Srpf S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City East Division"
  },
  "411023": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Haveli",
    "officename": "N.D.A. Khadakwasla S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City West Division"
  },
  "411024": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "Khadakwasla R.S. S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City West Division"
  },
  "411025": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Haveli",
    "officename": "I.A.T S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City West Division"
  },
  "411026": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "Bhosari I.E. S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City East Division"
  },
  "411027": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "Aundh Camp S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City East Division"
  },
  "411028": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune",
    "officename": "Hadapsar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City East Division"
  },
  "411030": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "S.P. College S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City West Division"
  },
  "411031": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "C M E S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City East Division"
  },
  "411032": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "Iaf Station S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City East Division"
  },
  "411033": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "Chinchwadgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City East Division"
  },
  "411034": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "Kasarwadi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City East Division"
  },
  "411035": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "Akurdi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City East Division"
  },
  "411036": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "Mundhva AV S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City East Division"
  },
  "411037": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "Market Yard S.O (Pune)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City East Division"
  },
  "411038": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "Ex. Serviceman Colony S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City West Division"
  },
  "411039": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "Bhosarigoan S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City East Division"
  },
  "411040": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "Wanowarie S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City East Division"
  },
  "411041": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Haveli",
    "officename": "Vadgaon Budruk S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City West Division"
  },
  "411042": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "Swargate S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City West Division"
  },
  "411043": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "Dhankawadi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City West Division"
  },
  "411044": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "P.C.N.T. S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City East Division"
  },
  "411045": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Haveli",
    "officename": "N.I.A. S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City West Division"
  },
  "411046": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Haveli",
    "officename": "Katraj S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City West Division"
  },
  "411047": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "Lohogaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City East Division"
  },
  "411048": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "N I B M S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City East Division"
  },
  "411051": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "Anandnagar S.O (Pune)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City West Division"
  },
  "411052": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "Navsahyadri S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City West Division"
  },
  "411057": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Haveli",
    "officename": "Infotech  Park (Hinjawadi) S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City East Division"
  },
  "411058": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "Warje S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City West Division"
  },
  "411060": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City",
    "officename": "Mohamadwadi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City East Division"
  },
  "411061": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Haveli",
    "officename": "Pimple Gurav S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City East Division"
  },
  "411062": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Haveli",
    "officename": "Rupeenagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City East Division"
  },
  "412101": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Haveli",
    "officename": "Dehu Road Cantt S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "412102": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Purandar",
    "officename": "Nira R S S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Baramati Division"
  },
  "412103": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Baramati",
    "officename": "Vadgaon Nimbalkar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Baramati Division"
  },
  "412104": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Purandar",
    "officename": "Rajewadi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Baramati Division"
  },
  "412105": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Khed",
    "officename": "Alandi Devachi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "412106": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Maval",
    "officename": "Vadgaon S.O (Pune)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "412107": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Velhe",
    "officename": "Panshet S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "412108": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Mulshi",
    "officename": "Paud S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "412109": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Haveli",
    "officename": "Dehu S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "412110": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Haveli",
    "officename": "Theur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "412112": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Mulshi",
    "officename": "Dasve Lavasa S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "412115": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Mulshi",
    "officename": "Pirangut S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "412201": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Haveli",
    "officename": "Loni Kalbhor S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "412202": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Daund",
    "officename": "Urulikanchan S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "412203": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Daund",
    "officename": "Kedgaon S.O (Pune)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Baramati Division"
  },
  "412204": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Baramati",
    "officename": "Supa S.O (Pune)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Baramati Division"
  },
  "412205": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Bhor",
    "officename": "Khed Shivapur Baug S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "412206": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Bhor",
    "officename": "Bhor S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "412207": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Haveli",
    "officename": "Vagholi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City East Division"
  },
  "412208": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Shirur",
    "officename": "Talegaon Dhamdhere S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Baramati Division"
  },
  "412209": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Shirur",
    "officename": "Ranjangaon Ganpati S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Baramati Division"
  },
  "412210": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Shirur",
    "officename": "Shirur S.O (Pune)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Baramati Division"
  },
  "412211": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Shirur",
    "officename": "Nhavare S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Baramati Division"
  },
  "412212": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Velhe",
    "officename": "Velhe S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "412213": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Bhor",
    "officename": "Nasrapur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "412214": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Daund",
    "officename": "Yavat S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Baramati Division"
  },
  "412215": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Daund",
    "officename": "Varvand S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Baramati Division"
  },
  "412216": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Haveli",
    "officename": "Koregaon Bhima S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "412218": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Shirur",
    "officename": "Malthan S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Baramati Division"
  },
  "412219": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Daund",
    "officename": "Madhukarnagar Patas S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Baramati Division"
  },
  "412220": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Shirur",
    "officename": "Midc Ranjangaon Ganpati S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Baramati Division"
  },
  "412301": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Purandar",
    "officename": "Saswad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Baramati Division"
  },
  "412303": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Purandar",
    "officename": "Jejuri S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Baramati Division"
  },
  "412304": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Baramati",
    "officename": "Morgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Baramati Division"
  },
  "412305": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Purandar",
    "officename": "Valha S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Baramati Division"
  },
  "412306": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Baramati",
    "officename": "Someshwarnagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Baramati Division"
  },
  "412307": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Haveli",
    "officename": "Manjari Farm S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City East Division"
  },
  "412308": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Haveli",
    "officename": "Phursungi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City East Division"
  },
  "412311": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Purandar",
    "officename": "Parinche S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Baramati Division"
  },
  "412312": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Purandar",
    "officename": "Veer S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Baramati Division"
  },
  "412401": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Junnar",
    "officename": "Arvi S.O (Pune)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "412402": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Khed",
    "officename": "Vada S.O (Pune)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "412403": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Shirur",
    "officename": "Pabal S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Baramati Division"
  },
  "412404": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Khed",
    "officename": "Kadus S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "412405": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Ambegaon",
    "officename": "Avsari KH S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "412406": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Ambegaon",
    "officename": "Avasari BK S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "412408": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Ambegaon",
    "officename": "Ghodegaon S.O (Pune)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "412409": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Junnar",
    "officename": "Otur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "412410": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Junnar",
    "officename": "Belha S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "412411": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Junnar",
    "officename": "Ala S.O (Pune)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "412412": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Junnar",
    "officename": "Pimpalwandi S.O (Pune)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "412801": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Khandala",
    "officename": "Shirval S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "412802": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Khandala Bawada.",
    "officename": "Khandala Bavada S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "412803": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Wai",
    "officename": "Wai S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "412804": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Wai",
    "officename": "Bavdhan S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "412805": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Mahabaleshwar",
    "officename": "Panchgani S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "412806": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Jawali",
    "officename": "Mahableshwar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "413001": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Solapur North",
    "officename": "Solapur H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Solapur Division"
  },
  "413002": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Solapur South",
    "officename": "Solapur Mkt. S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Solapur Division"
  },
  "413003": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Solapur North",
    "officename": "Gurunanak Nagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Solapur Division"
  },
  "413004": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "North Solapur",
    "officename": "Indiranagar S.O (Solapur)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Solapur Division"
  },
  "413005": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Solapur North",
    "officename": "Daji Peth S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Solapur Division"
  },
  "413006": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Solapur North",
    "officename": "Midc Solapur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Solapur Division"
  },
  "413007": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Solapur North",
    "officename": "Solapur City S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Solapur Division"
  },
  "413008": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "North Solapur",
    "officename": "SRPF Camp Solapur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Solapur Division"
  },
  "413101": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Malshiras",
    "officename": "Akluj S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pandharpur Division"
  },
  "413102": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Baramati",
    "officename": "Baramati H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Baramati Division"
  },
  "413103": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Indapur",
    "officename": "Bawada S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Baramati Division"
  },
  "413104": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Indapur",
    "officename": "Bhavaninagar S.O (Pune)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Baramati Division"
  },
  "413105": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Indapur",
    "officename": "Bhigwan R S S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Baramati Division"
  },
  "413106": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Indapur",
    "officename": "Indapur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Baramati Division"
  },
  "413107": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Malsiras",
    "officename": "Malsiras S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pandharpur Division"
  },
  "413108": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Malsiras",
    "officename": "Malinagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pandharpur Division"
  },
  "413109": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Malshiras",
    "officename": "Natepute S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pandharpur Division"
  },
  "413110": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Baramati",
    "officename": "Pandare S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Baramati Division"
  },
  "413111": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Malshiras",
    "officename": "Sadashivenagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pandharpur Division"
  },
  "413112": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Malshiras",
    "officename": "Shreepur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pandharpur Division"
  },
  "413113": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Malshiras",
    "officename": "Velapur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pandharpur Division"
  },
  "413114": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Indapur",
    "officename": "Walchandnagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Baramati Division"
  },
  "413115": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Baramati",
    "officename": "Malegaon BK S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Baramati Division"
  },
  "413116": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Baramati",
    "officename": "Shivnagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Baramati Division"
  },
  "413118": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Malsras",
    "officename": "Yeshwantnagar S.O (Solapur)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pandharpur Division"
  },
  "413120": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Indapur",
    "officename": "Nimgaon Ketki S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Baramati Division"
  },
  "413130": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Indapur",
    "officename": "Bhigwan S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Baramati Division"
  },
  "413132": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Indapur",
    "officename": "Palasdeo S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Baramati Division"
  },
  "413133": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Baramati",
    "officename": "Baramati MIDC S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Baramati Division"
  },
  "413201": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Jamkhed",
    "officename": "Jamkhed S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "413202": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Karmala",
    "officename": "Jeur S.O (Solapur)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pandharpur Division"
  },
  "413203": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Karmala",
    "officename": "Karmala S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pandharpur Division"
  },
  "413204": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Jamkhed",
    "officename": "Kharda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "413205": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Jamkhed",
    "officename": "Nanaj S.O (Ahmed Nagar)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "413206": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Karmala",
    "officename": "Kettur II S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pandharpur Division"
  },
  "413207": {
    "state": "Maharashtra",
    "district": "Beed",
    "block": "Patoda",
    "officename": "Amalner S.O (Beed)",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Beed Division"
  },
  "413208": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Madha",
    "officename": "Kurduvadi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pandharpur Division"
  },
  "413209": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Madha",
    "officename": "Madha S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pandharpur Division"
  },
  "413210": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Madha",
    "officename": "Pimpelner S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pandharpur Division"
  },
  "413211": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Madha",
    "officename": "Tembhurni S.O (Solapur)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pandharpur Division"
  },
  "413212": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Madha",
    "officename": "Bhimanagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pandharpur Division"
  },
  "413213": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Mohol",
    "officename": "Mohol S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Solapur Division"
  },
  "413214": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Mohol",
    "officename": "Angar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Solapur Division"
  },
  "413215": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "South Solapur",
    "officename": "Hotgi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Solapur Division"
  },
  "413216": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Akkalkot",
    "officename": "Akkalkot S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Solapur Division"
  },
  "413217": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Akkalkot",
    "officename": "Maindargi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Solapur Division"
  },
  "413218": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Akkalkot",
    "officename": "Wagadari S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Solapur Division"
  },
  "413219": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Akkalkot",
    "officename": "Karajagi S.O (Solapur)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Solapur Division"
  },
  "413220": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Akkalkot",
    "officename": "Dudhani S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Solapur Division"
  },
  "413221": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Solapur South",
    "officename": "Mandrup S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Solapur Division"
  },
  "413222": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Solapur North",
    "officename": "Nanaj S.O (Solapur)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Solapur Division"
  },
  "413223": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Karmala",
    "officename": "Kem S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pandharpur Division"
  },
  "413224": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Solapur South",
    "officename": "Shivshahi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Solapur Division"
  },
  "413226": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Akkalkot",
    "officename": "Chapalgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Solapur Division"
  },
  "413227": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Akkalkot",
    "officename": "Nagansur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Solapur Division"
  },
  "413228": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "S.solapur",
    "officename": "Valsang S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Solapur Division"
  },
  "413229": {
    "state": "Maharashtra",
    "district": "Beed",
    "block": "Patoda",
    "officename": "Pimpalwandi S.O (Beed)",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Beed Division"
  },
  "413248": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Mohol",
    "officename": "Pennur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Solapur Division"
  },
  "413249": {
    "state": "Maharashtra",
    "district": "Beed",
    "block": "Shirur K",
    "officename": "Shirur S.O (Beed)",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Beed Division"
  },
  "413250": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Madha",
    "officename": "Mahisgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pandharpur Division"
  },
  "413251": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Karmala",
    "officename": "Sade S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pandharpur Division"
  },
  "413252": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Madha",
    "officename": "Ropla ( Kvd ) S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pandharpur Division"
  },
  "413253": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Mohol",
    "officename": "Kamati Khurd S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Solapur Division"
  },
  "413255": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Solapur North",
    "officename": "Midc Chincholi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Solapur Division"
  },
  "413301": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Madha",
    "officename": "Modnimb S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pandharpur Division"
  },
  "413302": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Pandharpur",
    "officename": "Karkam S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pandharpur Division"
  },
  "413303": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Mohol",
    "officename": "Ashti S.O (Solapur)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Solapur Division"
  },
  "413304": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Pandharpur",
    "officename": "Pandharpur H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pandharpur Division"
  },
  "413305": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Mangalvedha",
    "officename": "Mangalvedha S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pandharpur Division"
  },
  "413306": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Sangola",
    "officename": "Mahud S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pandharpur Division"
  },
  "413307": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Sangola",
    "officename": "Sangola S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pandharpur Division"
  },
  "413308": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Sangola",
    "officename": "Nazara S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pandharpur Division"
  },
  "413309": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Sangola",
    "officename": "Jawala S.O (Solapur)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pandharpur Division"
  },
  "413310": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Pandharpur",
    "officename": "Piliv S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pandharpur Division"
  },
  "413314": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Sangola",
    "officename": "Kole S.O (Solapur)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pandharpur Division"
  },
  "413315": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Pandharpur",
    "officename": "Bhosa (K) S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pandharpur Division"
  },
  "413317": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Sangola",
    "officename": "Khardi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pandharpur Division"
  },
  "413319": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Mangalvedha",
    "officename": "Marwade S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pandharpur Division"
  },
  "413322": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Mangalvedha",
    "officename": "Bhosa (M) S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pandharpur Division"
  },
  "413324": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Mohol",
    "officename": "Shetphal S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Solapur Division"
  },
  "413401": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Barshi",
    "officename": "Barshi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Solapur Division"
  },
  "413402": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Barshi",
    "officename": "Vairag S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Solapur Division"
  },
  "413403": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Barshi",
    "officename": "Pangaon S.O (Solapur)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Solapur Division"
  },
  "413404": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Barshi",
    "officename": "Pangri S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Solapur Division"
  },
  "413405": {
    "state": "Maharashtra",
    "district": "Osmanabad",
    "block": "Osmanabad",
    "officename": "Yedshi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413406": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Barshi",
    "officename": "Gaudgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Solapur Division"
  },
  "413409": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Barshi",
    "officename": "Agalgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Solapur Division"
  },
  "413410": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Madha",
    "officename": "Manegaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Solapur Division"
  },
  "413411": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Barshi",
    "officename": "K.V.Nagar Barshi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Solapur Division"
  },
  "413412": {
    "state": "Maharashtra",
    "district": "Solapur",
    "block": "Barshi",
    "officename": "Tulsidas Nagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Solapur Division"
  },
  "413501": {
    "state": "Maharashtra",
    "district": "Osmanabad",
    "block": "Osmanabad",
    "officename": "Osmanabad HO",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413502": {
    "state": "Maharashtra",
    "district": "Osmanabad",
    "block": "Paranda",
    "officename": "Paranda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413503": {
    "state": "Maharashtra",
    "district": "Osmanabad",
    "block": "Vashi",
    "officename": "Vashi S.O (Osmanabad)",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413504": {
    "state": "Maharashtra",
    "district": "Osmanabad",
    "block": "Bhoom",
    "officename": "Bhoom S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413505": {
    "state": "Maharashtra",
    "district": "Osmanabad",
    "block": "Paranda",
    "officename": "Sonari S.O (Osmanabad)",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413506": {
    "state": "Maharashtra",
    "district": "Osmanabad",
    "block": "Osmanabad",
    "officename": "Bembli S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413507": {
    "state": "Maharashtra",
    "district": "Osmanabad",
    "block": "Kallam",
    "officename": "Kallam S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413508": {
    "state": "Maharashtra",
    "district": "Osmanabad",
    "block": "Osmanabad",
    "officename": "Dhoki S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413509": {
    "state": "Maharashtra",
    "district": "Osmanabad",
    "block": "Osmanabad",
    "officename": "Ter S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413510": {
    "state": "Maharashtra",
    "district": "Latur",
    "block": "Latur",
    "officename": "Murud S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413511": {
    "state": "Maharashtra",
    "district": "Latur",
    "block": "Latur",
    "officename": "Borgaon S.O (Latur)",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413512": {
    "state": "Maharashtra",
    "district": "Latur",
    "block": "Latur",
    "officename": "Latur H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413513": {
    "state": "Maharashtra",
    "district": "Latur",
    "block": "Chakur",
    "officename": "Chakur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413514": {
    "state": "Maharashtra",
    "district": "Osmanabad",
    "block": "Ahmedpur",
    "officename": "Shirur Tajband S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413515": {
    "state": "Maharashtra",
    "district": "Latur",
    "block": "Ahmedpur",
    "officename": "Ahmedpur S.O (Latur)",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413516": {
    "state": "Maharashtra",
    "district": "Osmanabad",
    "block": "Ahmedpur",
    "officename": "Killari S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413517": {
    "state": "Maharashtra",
    "district": "Latur",
    "block": "Shirur-Anantpal",
    "officename": "Udgir S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413518": {
    "state": "Maharashtra",
    "district": "Latur",
    "block": "Shirur-Anantpal",
    "officename": "Wadhona S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413519": {
    "state": "Maharashtra",
    "district": "Latur",
    "block": "Deoni",
    "officename": "Deoni S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413520": {
    "state": "Maharashtra",
    "district": "Latur",
    "block": "Ausa",
    "officename": "Ausa S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413521": {
    "state": "Maharashtra",
    "district": "Latur",
    "block": "Nilanga",
    "officename": "Nilanga S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413522": {
    "state": "Maharashtra",
    "district": "Latur",
    "block": "Nilanga",
    "officename": "Aurad Shahajani S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413523": {
    "state": "Maharashtra",
    "district": "Osmanabad",
    "block": "Ahmedpur",
    "officename": "Kingaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413524": {
    "state": "Maharashtra",
    "district": "Latur",
    "block": "Shirur-Anantpal",
    "officename": "Nalegaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413525": {
    "state": "Maharashtra",
    "district": "Osmanabad",
    "block": "Kallam",
    "officename": "Yermala S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413526": {
    "state": "Maharashtra",
    "district": "Osmanabad",
    "block": "Bhoom",
    "officename": "Pargaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413527": {
    "state": "Maharashtra",
    "district": "Osmanabad",
    "block": "Ahmedpur",
    "officename": "Renapur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413528": {
    "state": "Maharashtra",
    "district": "Osmanabad",
    "block": "Kallam",
    "officename": "Shiradhon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413529": {
    "state": "Maharashtra",
    "district": "Latur",
    "block": "Shirur-Anantpal",
    "officename": "Wadwal Nagnath S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413530": {
    "state": "Maharashtra",
    "district": "Latur",
    "block": "Nilanga",
    "officename": "Nitoor S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413531": {
    "state": "Maharashtra",
    "district": "Osmanabad",
    "block": "Ahmedpur",
    "officename": "Tilaknagar Latur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413532": {
    "state": "Maharashtra",
    "district": "Latur",
    "block": "Shirur-Anantpal",
    "officename": "Jalkot S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413534": {
    "state": "Maharashtra",
    "district": "Osmanabad",
    "block": "Bhoom",
    "officename": "Ieet S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413544": {
    "state": "Maharashtra",
    "district": "Osmanabad",
    "block": "Ahmedpur",
    "officename": "Shirur Anantpal S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413581": {
    "state": "Maharashtra",
    "district": "Osmanabad",
    "block": "Ahmedpur",
    "officename": "JJJKSSK Nalegaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413582": {
    "state": "Maharashtra",
    "district": "Osmanabad",
    "block": "Osmanabad",
    "officename": "Anandnagar S.O (Osmanabad)",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413601": {
    "state": "Maharashtra",
    "district": "Osmanabad",
    "block": "Tuljapur",
    "officename": "Tuljapur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413602": {
    "state": "Maharashtra",
    "district": "Osmanabad",
    "block": "Tuljapur",
    "officename": "Naldurg S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413603": {
    "state": "Maharashtra",
    "district": "Osmanabad",
    "block": "Tuljapur",
    "officename": "Andora S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413604": {
    "state": "Maharashtra",
    "district": "Osmanabad",
    "block": "Osmanabad",
    "officename": "Dalimb S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413605": {
    "state": "Maharashtra",
    "district": "Osmanabad",
    "block": "Omerga",
    "officename": "Murum S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413606": {
    "state": "Maharashtra",
    "district": "Osmanabad",
    "block": "Omerga",
    "officename": "Omerga S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413607": {
    "state": "Maharashtra",
    "district": "Latur",
    "block": "Shirur-Anantpal",
    "officename": "Kasarsirsi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413608": {
    "state": "Maharashtra",
    "district": "Osmanabad",
    "block": "Lohara",
    "officename": "Lohara S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413623": {
    "state": "Maharashtra",
    "district": "Osmanabad",
    "block": "Tuljapur",
    "officename": "Malumbra S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413624": {
    "state": "Maharashtra",
    "district": "Osmanabad",
    "block": "Tuljapur",
    "officename": "Kati S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413701": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Shrigonda",
    "officename": "Shrigonda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "413702": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Shrigonda",
    "officename": "Belwandi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "413703": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Shrigonda",
    "officename": "Visapur S.O (Ahmed Nagar)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "413704": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Rahuri",
    "officename": "Vambori S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "413705": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Rahuri",
    "officename": "Rahuri S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "413706": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Rahuri",
    "officename": "Rahuri Factory S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "413707": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Rahata",
    "officename": "Puntamba S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "413708": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Kopargaon",
    "officename": "Sakarwadi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "413709": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Shrirampur",
    "officename": "Shrirampur H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "413710": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Rahta",
    "officename": "Kolhar S.O (Ahmed Nagar)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "413711": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Shrirampur.",
    "officename": "Songaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "413712": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Rahta",
    "officename": "Pravaranagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "413713": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Rahata",
    "officename": "Loni Kd S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "413714": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Sangamner",
    "officename": "Ashvi BK S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "413715": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Shrirampur.",
    "officename": "Belapur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "413716": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Rahuri",
    "officename": "Deolali Pravara S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "413717": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Shrirampur",
    "officename": "Karegaon Factory S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "413718": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Shrirampur.",
    "officename": "Harigaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "413719": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Rahta",
    "officename": "Ranjangaon Kd S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "413720": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Shrirampur",
    "officename": "Tilaknagar S.O (Ahmed Nagar)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "413721": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Shrirampur.",
    "officename": "Padhegaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "413722": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Rahuri",
    "officename": "Rahuri MPKV S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "413723": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Rahta",
    "officename": "Changdeonagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "413725": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Shrirampur.",
    "officename": "Takalibhan S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "413726": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Shrigonda",
    "officename": "Shrigonda SSK S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "413728": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Shrigonda",
    "officename": "Kolgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "413736": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Rahata",
    "officename": "Loni Bk S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "413737": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Rahta",
    "officename": "Babhleshwar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "413738": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Sangamner",
    "officename": "Ashvi Kd S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "413739": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Shrirampur.",
    "officename": "Vadala Mahadeo S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "413801": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Daund",
    "officename": "Daund S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Baramati Division"
  },
  "413802": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Daund",
    "officename": "Midc Kurkumbh S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Baramati Division"
  },
  "414001": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Ahmednagar",
    "officename": "Ahmednagar H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "414002": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Ahmednagar",
    "officename": "Ahmednagar Camp S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "414003": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Ahmednagar",
    "officename": "Savedi Road S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "414005": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Ahmednagar",
    "officename": "Ahmednagar R.S. S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "414006": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Ahmednagar",
    "officename": "Vahannagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "414101": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Shrigonda",
    "officename": "Mandavgan S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "414102": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Pathardi",
    "officename": "Pathardi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "414103": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Parner",
    "officename": "Jamgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "414105": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Newasa",
    "officename": "Sonai S.O (Ahmed Nagar)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "414106": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Pathadi",
    "officename": "Tisgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "414110": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Ahmednagar",
    "officename": "MIRC S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "414111": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Ahmednagar",
    "officename": "MIDC (ANR) S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "414113": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Pathardi",
    "officename": "Kharwandi Kasar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "414201": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Nagar",
    "officename": "Chichondi Patil S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "414202": {
    "state": "Maharashtra",
    "district": "Beed",
    "block": "Ashti",
    "officename": "Kada S.O (Beed)",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Beed Division"
  },
  "414203": {
    "state": "Maharashtra",
    "district": "Beed",
    "block": "Ashti",
    "officename": "Ashti S.O (Beed)",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Beed Division"
  },
  "414204": {
    "state": "Maharashtra",
    "district": "Beed",
    "block": "Patoda",
    "officename": "Patoda S.O (Beed)",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Beed Division"
  },
  "414205": {
    "state": "Maharashtra",
    "district": "Beed",
    "block": "Beed",
    "officename": "Rajuri Navgan S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Beed Division"
  },
  "414208": {
    "state": "Maharashtra",
    "district": "Beed",
    "block": "Ashti",
    "officename": "Kadasakhar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Beed Division"
  },
  "414301": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Parner",
    "officename": "Supa S.O (Ahmed Nagar)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "414302": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Parner",
    "officename": "Parner S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "414303": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Parner",
    "officename": "Kanhur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "414304": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Parner",
    "officename": "Takali Dhokeshwar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "414305": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Parner",
    "officename": "Alkuti S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "414306": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Parner",
    "officename": "Nighoj S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "414401": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Karjat",
    "officename": "Mirajgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "414402": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Karjat",
    "officename": "Karjat S.O (Ahmed Nagar)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "414403": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Karjat",
    "officename": "Rashin S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "414501": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Pathardi",
    "officename": "Miri S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "414502": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Shevgaon",
    "officename": "Shevgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "414503": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Shevgaon",
    "officename": "Bodhegaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "414504": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Shevgaon",
    "officename": "Balamtakali S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "414505": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Pathardi",
    "officename": "Vridheshwar SSK S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "414601": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Ahmednagar",
    "officename": "Jeur S.O (Ahmed Nagar)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "414602": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Newasa",
    "officename": "Vadalamission S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "414603": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Nevasa",
    "officename": "Nevasa S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "414604": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Nevasa",
    "officename": "Kukana S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "414605": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Nevasa",
    "officename": "Bhende SK S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "414606": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Newasa",
    "officename": "Chanda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "414607": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Newasa",
    "officename": "Ghodegaon S.O (Ahmed Nagar)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "414609": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Nevasa",
    "officename": "Bhanashivara S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "414701": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Shrigonda",
    "officename": "Kashti S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Ahmednagar Division"
  },
  "415001": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Satara",
    "officename": "Satara H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415002": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Satara",
    "officename": "Satara City S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415003": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Satara",
    "officename": "Sangamnagar Satara S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415004": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Satara",
    "officename": "MIDC Satara S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415010": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Koregaon",
    "officename": "Satararoad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415011": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Koregaon",
    "officename": "Vaduth S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415012": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Jawali",
    "officename": "Medha S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415013": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Satara",
    "officename": "Parali S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415014": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Patan",
    "officename": "Tarale S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Karad Division"
  },
  "415015": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Satara",
    "officename": "Limbgove S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415019": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Satara",
    "officename": "Angapur Vandan S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415020": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Jawali",
    "officename": "Anewadi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415021": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Koregaon",
    "officename": "Kinhai S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415022": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Jawali",
    "officename": "Vennanagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415023": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Man (dahiwadi)",
    "officename": "Mahimangad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415101": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Shahuwadi",
    "officename": "Malkapur S.O (Kolhapur)",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "415102": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Khatav",
    "officename": "Mayani S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Karad Division"
  },
  "415103": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Patan",
    "officename": "Kole S.O (Satara)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Karad Division"
  },
  "415104": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Karad",
    "officename": "Kale S.O (Satara)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Karad Division"
  },
  "415105": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Karad",
    "officename": "Ogalewadi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Karad Division"
  },
  "415106": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Karad",
    "officename": "Masur S.O (Satara)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Karad Division"
  },
  "415107": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Satara",
    "officename": "Targaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415108": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Karad",
    "officename": "Shivnagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Karad Division"
  },
  "415109": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Karad",
    "officename": "Umbraj S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Karad Division"
  },
  "415110": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Karad",
    "officename": "Karad H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Karad Division"
  },
  "415111": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Karad",
    "officename": "Ond S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Karad Division"
  },
  "415112": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Patan",
    "officename": "Dhebewadi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Karad Division"
  },
  "415114": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Karad",
    "officename": "Supane S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Karad Division"
  },
  "415115": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Karad",
    "officename": "Yashvantnagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Karad Division"
  },
  "415116": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Koregaon",
    "officename": "Vathar Kiroli S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415122": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Karad",
    "officename": "Wing S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Karad Division"
  },
  "415124": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Karad",
    "officename": "Vidyanagar Karad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Karad Division"
  },
  "415202": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Mandangad",
    "officename": "Latwan S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415203": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Mandangad",
    "officename": "Mandangad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415205": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Patan",
    "officename": "Malharpeth Karad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Karad Division"
  },
  "415206": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Karad",
    "officename": "Patan S.O (Satara)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Karad Division"
  },
  "415207": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Patan",
    "officename": "Koyna S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Karad Division"
  },
  "415208": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Mandangad",
    "officename": "Veshvi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415209": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Patan",
    "officename": "Bahule S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Karad Division"
  },
  "415211": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Patan",
    "officename": "Daulat Nagar S.O (Satara)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Karad Division"
  },
  "415212": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Patan",
    "officename": "Marul Haveli S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Karad Division"
  },
  "415213": {
    "state": "Maharashtra",
    "district": "Raigarh(MH)",
    "block": "Mahad",
    "officename": "Chimbhave SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Raigad Division"
  },
  "415214": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Mandangad",
    "officename": "Panderi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415301": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Atpadi",
    "officename": "Atpadi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "415302": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Valva",
    "officename": "Bhavaninagar S.O (Sangli)",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "415303": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Kadegaon",
    "officename": "Devrashtra S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "415304": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Kadegaon",
    "officename": "Kadegaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "415305": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Kadegaon",
    "officename": "Kadepur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "415306": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Atpadi",
    "officename": "Kargani S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "415307": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Khanapur",
    "officename": "Khanapur S.O (Sangli)",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "415308": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Atpadi",
    "officename": "Kharsundi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "415309": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Khanapur",
    "officename": "Lengare S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "415310": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Khanapur",
    "officename": "Mahuli S.O (Sangli)",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "415311": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Khanapur",
    "officename": "Vite S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "415312": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Khatav",
    "officename": "Kaledhon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Karad Division"
  },
  "415313": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Valva",
    "officename": "Takari S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "415315": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Atpadi",
    "officename": "Dighanchi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "415401": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Valva",
    "officename": "Aitawade BK S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "415402": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Shirala",
    "officename": "Bilashi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "415403": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Walva",
    "officename": "Kameri S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "415404": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Valva",
    "officename": "Kasegaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "415405": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Shirala",
    "officename": "Kokrud S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "415406": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Walva",
    "officename": "Nerla S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "415407": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Walva",
    "officename": "Peth S.O (Sangli)",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "415408": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Shirala",
    "officename": "Shirala S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "415409": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Walva",
    "officename": "Urun Islampur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "415410": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Shirala",
    "officename": "Wategaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "415411": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Walva",
    "officename": "Yelur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "415412": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Shirala",
    "officename": "Chikurde S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "415413": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Valva",
    "officename": "Borgaon S.O (Sangli)",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "415414": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Valva",
    "officename": "S S K Sakharale S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "415415": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Shirala",
    "officename": "Warnavati Vasahat S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "415501": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Koregaon",
    "officename": "Koregaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415502": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Khatav",
    "officename": "Pusegaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415503": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Khatav",
    "officename": "Budh S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415504": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Khatav",
    "officename": "Diskal Mol S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415505": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Khatav",
    "officename": "Khatav S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415506": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Khatav",
    "officename": "Vaduj S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Karad Division"
  },
  "415507": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Khatav",
    "officename": "Katarkhatav S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Karad Division"
  },
  "415508": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Man",
    "officename": "Dahivadi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Karad Division"
  },
  "415509": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Man",
    "officename": "Mhasvad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Karad Division"
  },
  "415510": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Khatav",
    "officename": "Aundh S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Karad Division"
  },
  "415511": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Koregaon",
    "officename": "Rahimatpur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415512": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Khatav",
    "officename": "Pusesavali S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Karad Division"
  },
  "415513": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Wai",
    "officename": "Pachvad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415514": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Jawali",
    "officename": "Kudal S.O (Satara)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415515": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Wai",
    "officename": "Bhuinj S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415516": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Wai",
    "officename": "Kavathe S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415517": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Wai",
    "officename": "Surur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415518": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Satara",
    "officename": "Apshinge S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415519": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Satara",
    "officename": "Nagthane S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415520": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Patan",
    "officename": "Chaphal S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Karad Division"
  },
  "415521": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Khandala Bawada",
    "officename": "Lonand S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415522": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Phalatan",
    "officename": "Sakharwadi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415523": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Phaltan",
    "officename": "Phaltan S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415524": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Koregaon",
    "officename": "Vathar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415525": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Koregaon",
    "officename": "Pimpode BK S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415526": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Khandala Bawada",
    "officename": "Vathar BK S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415527": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Khatav",
    "officename": "Kuroli Sidheshwar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415528": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Phaltan",
    "officename": "Taradgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415530": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Wai",
    "officename": "Kisanveernagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415536": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Wai",
    "officename": "Kenjal S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415537": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Phaltan",
    "officename": "Adarki BK S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Satara Division"
  },
  "415538": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Karad",
    "officename": "Mhasurne S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Karad Division"
  },
  "415539": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Karad",
    "officename": "Malkapur Karad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Karad Division"
  },
  "415540": {
    "state": "Maharashtra",
    "district": "Satara",
    "block": "Man",
    "officename": "Gondavale BK S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Karad Division"
  },
  "415601": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Chiplun",
    "officename": "Pophali S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415602": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Chiplun",
    "officename": "Shirgaon (CPN) S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415603": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Chiplun",
    "officename": "Alore S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415604": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Chiplun",
    "officename": "Kherdi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415605": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Chiplun",
    "officename": "Chiplun H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415606": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Chiplun",
    "officename": "Sawarda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415607": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Chiplun",
    "officename": "Nandgaon (CPN) S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415608": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Sangmeshwar",
    "officename": "Makhajan S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415609": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Sangmeshwar",
    "officename": "Kadwai S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415610": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Sangmeshwar",
    "officename": "Kasba S.O (Ratnagiri)",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415611": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Sangmeshwar",
    "officename": "Sangmeshwar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415612": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Ratnagiri",
    "officename": "Ratnagiri H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415613": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Ratnagiri",
    "officename": "Saitavada S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415614": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Ratnagiri",
    "officename": "Jaigad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415615": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Ratnagiri",
    "officename": "Malgund S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415616": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Ratnagiri",
    "officename": "Pawas S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415617": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Ratnagiri",
    "officename": "Kotawada S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415619": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Ratnagiri",
    "officename": "Hatkhamba S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415620": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Ratnagiri",
    "officename": "Khalgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415621": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Khed",
    "officename": "Bharane S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415626": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Ratnagiri",
    "officename": "Gavkhadi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415628": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Chiplun",
    "officename": "Shiral S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415629": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Ratnagiri",
    "officename": "Shirgaon (RTG) S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415634": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Chiplun",
    "officename": "RGPPL Anjanvel S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415637": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Chiplun",
    "officename": "Ambed Budruk S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415639": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Ratnagiri",
    "officename": "MIDC (RTG) S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415640": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Khed (rtg)",
    "officename": "Khavati S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415641": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Chiplun",
    "officename": "Niwali (CPN) S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415643": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Lanja",
    "officename": "Watul S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415701": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Chiplun",
    "officename": "Rampur S.O (Ratnagiri)",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415702": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Guhagar",
    "officename": "Margatamhane S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415703": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Guhagar",
    "officename": "Guhagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415705": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Guhagar",
    "officename": "Adur S.O (Ratnagiri)",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415706": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Dapoli",
    "officename": "Dabhol S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415708": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Khed (rtg)",
    "officename": "Lavel S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415709": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Khed (rtg)",
    "officename": "Khed (RTG) S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415710": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Khed (rtg)",
    "officename": "Furus S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415711": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Dapoli",
    "officename": "Vakavali S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415712": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Dapoli",
    "officename": "Dapoli S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415713": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Dapoli",
    "officename": "Harnai S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415714": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Dapoli",
    "officename": "Anjarla S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415715": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Khed (rtg)",
    "officename": "Khopi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415716": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Dapoli",
    "officename": "Palgad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415717": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Dapoli",
    "officename": "Kelshi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415718": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Khed (rtg)",
    "officename": "Dhamanand S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415719": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Guhagar",
    "officename": "Talavali S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415720": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Dapoli",
    "officename": "Burondi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415722": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Khed (rtg)",
    "officename": "Lote S.O (Ratnagiri)",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415724": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Guhagar",
    "officename": "Shringartali S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415726": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Guhagar",
    "officename": "Abaloli S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415727": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Khed (rtg)",
    "officename": "Karji S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415728": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Guhagar",
    "officename": "Hedavi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415729": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Guhagar",
    "officename": "Welneshwar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415730": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Khed",
    "officename": "Ambavali S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415801": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Sangmeshwar",
    "officename": "Sakharpa S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415802": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Lanja",
    "officename": "Shiposhi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415803": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Lanja",
    "officename": "Pali (RTG) S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415804": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Chiplun",
    "officename": "Devrukh S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415805": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Rajapur",
    "officename": "Jaitapur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415806": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Rajapur",
    "officename": "Nata S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "415807": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Chiplun",
    "officename": "Devale S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "416001": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Karveer",
    "officename": "Kolhapur RS S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416002": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Karvir",
    "officename": "Shaniwar Peth S.O (Kolhapur)",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416003": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Karvir",
    "officename": "Kolhapur H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416004": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Karvir",
    "officename": "Shivaji University S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416005": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Karvir",
    "officename": "Gur Market Yard S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416006": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Karvir",
    "officename": "Kasba Bavada S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416007": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Karvir",
    "officename": "Kalamba S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416008": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Karvir",
    "officename": "Pratibhanagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416010": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Karveer",
    "officename": "Phulewadi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416011": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Karvir",
    "officename": "Sane Guruji Vasahat S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416012": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Karvir",
    "officename": "Kolhapur City H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416013": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Karveer",
    "officename": "R K Nagar S.O (Kolhapur)",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416101": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Hatkanangale",
    "officename": "Jaysingpur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416102": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Shirol",
    "officename": "Nandani S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416103": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Shirol",
    "officename": "Shirol S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416104": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Shirol",
    "officename": "Narsobawadi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416105": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Shirol",
    "officename": "Ganeshwadi S.O (Kolhapur)",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416106": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Shirol",
    "officename": "Kurundwad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416107": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Shirol",
    "officename": "Dattawad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416108": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Shirol",
    "officename": "Takali S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416109": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Hatkanangle",
    "officename": "Hatkalangada S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416110": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Hatkanangle",
    "officename": "Bahubali S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416111": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Hatkanangale",
    "officename": "Kumbhoj S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416112": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Hatkanangale",
    "officename": "Vadgaon S.O (Kolhapur)",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416113": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Panhala",
    "officename": "Warnanagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416114": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Panhala",
    "officename": "Kodoli S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416115": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Hatkanangle",
    "officename": "Ichalkaranji H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416116": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Hatkanangale",
    "officename": "Ganganagar Ichalkaranji S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416118": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Hatkanangale",
    "officename": "Rukadi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416119": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Karveer",
    "officename": "Gandhinagar S.O (Kolhapur)",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416120": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Shirol",
    "officename": "Dattanagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416121": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Shirol",
    "officename": "R K Nagar Ichalkaranji S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416122": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Hatkanangle",
    "officename": "MIDC Shiroli S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416143": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Shirol",
    "officename": "ICO Spinning Mills S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416144": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Shirol",
    "officename": "Akiwate Industrial Estate S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416146": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Hatkanangle",
    "officename": "Parvati Industrial Estate S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416201": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Panhala",
    "officename": "Panhala S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416202": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Hatkanangale",
    "officename": "Pattankodoli S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416203": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Hatkanangle",
    "officename": "Hupari S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416204": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Karveer",
    "officename": "Kuditre S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416205": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Panhala",
    "officename": "Kale S.O (Kolhapur)",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416206": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Gaganbavada",
    "officename": "Gaganbavada S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416207": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Kagal",
    "officename": "Ispurli S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416208": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Kagal",
    "officename": "Bidri S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416209": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Bhudargad",
    "officename": "Gargoti S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416210": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Bhudargad",
    "officename": "Kadgaon Gargoti S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416211": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Radhanagari",
    "officename": "Parite S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416212": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Radhanagari",
    "officename": "Radhanagari S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416213": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Shahuwadi",
    "officename": "Bambavada S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416214": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Shahuwadi",
    "officename": "Sarud S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416215": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Shahuwadi",
    "officename": "Shahuwadi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416216": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Kagal",
    "officename": "Kagal S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416218": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Kagal",
    "officename": "Kapshi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416219": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Kagal",
    "officename": "Murgud S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416220": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Ajra",
    "officename": "Uttur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416221": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Radhanagari",
    "officename": "Walwa Bk S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416223": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Bhudargad",
    "officename": "Mhasve S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416229": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Karveer",
    "officename": "Ambewadi S.O (Kolhapur)",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416230": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Panhala",
    "officename": "Kotoli S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416231": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Radhanagari",
    "officename": "Dudhganganagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416232": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Kagal",
    "officename": "Sidhnerli S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416234": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Karveer",
    "officename": "MIDC Gokul Shirgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416235": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Kagal",
    "officename": "Sadashivnagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416236": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Kagal",
    "officename": "5 Star MIDC Kagal S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416301": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Valva",
    "officename": "Ashte S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416302": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Valva",
    "officename": "Bagani S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416303": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Tasgaon",
    "officename": "Bhilavadi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416304": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Miraj",
    "officename": "Budhgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416305": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Miraj",
    "officename": "Digraj Kasaba S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416306": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Miraj",
    "officename": "Kavalapur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416307": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Tasgaon",
    "officename": "Kavathe Ekand S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416308": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Palus",
    "officename": "Kirloskarwadi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416309": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Tasgaon",
    "officename": "Kundal S.O (Sangli)",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416310": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Palus",
    "officename": "Palus S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416311": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Tasgaon",
    "officename": "Savlaj S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416312": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Tasgaon",
    "officename": "Tasgaon M.D.G S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416313": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Walva",
    "officename": "Walwa S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416314": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Tasgaon",
    "officename": "Visapur S.O (Sangli)",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416315": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Miraj",
    "officename": "Dudhgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416316": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Palus",
    "officename": "Ankalkhop S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416401": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Miraj",
    "officename": "Arag S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416402": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Jat",
    "officename": "Daphalapur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416403": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Kavathe Mahankal",
    "officename": "Dhalgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416404": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Jat",
    "officename": "Jath S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416405": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "K. Mahankal",
    "officename": "Kavathe Mahankal S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416406": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Miraj",
    "officename": "Madhavnagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416407": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Miraj",
    "officename": "Malgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416408": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Tasgaon",
    "officename": "Manerajuri S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416409": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Miraj",
    "officename": "Mhaisal S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416410": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Kavathe Mahankal",
    "officename": "Miraj H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416411": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "K Mahankal",
    "officename": "Ranjani S.O (Sangli)",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416412": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Jat",
    "officename": "Sankh S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416413": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Jat",
    "officename": "Umadi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416414": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Miraj",
    "officename": "District Court Sangli SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416415": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Miraj",
    "officename": "Willingdon College Sangli S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416416": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Miraj",
    "officename": "Sangli H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416417": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Miraj",
    "officename": "Kavathe Piran S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416418": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Kavathe Mahankal",
    "officename": "Salgare S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416419": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Kavathe Mahankal",
    "officename": "Shirdhon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416420": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Miraj",
    "officename": "Soni S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416436": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Miraj",
    "officename": "Kupwad MIDC Area S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416437": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Miraj",
    "officename": "Subhashnagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416501": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Chandgad",
    "officename": "Dundage S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416502": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Gadhinglaj",
    "officename": "Gadhinglaj S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416503": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Gadhinglaj",
    "officename": "Mahagaon (Kolhapur) S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416504": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Gadhinglaj",
    "officename": "Nesari S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416505": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Ajara",
    "officename": "Ajara S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416506": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Gadhinglaj",
    "officename": "Halkarni S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416507": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Chandgad",
    "officename": "Karve S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416508": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Chandgad",
    "officename": "Kowad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416509": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Chandgad",
    "officename": "Chandgad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416510": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Sawantwadi",
    "officename": "Sawantwadi H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416511": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Sawantwadi",
    "officename": "Banda S.O (Sindhudurg)",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416512": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Dodamarg",
    "officename": "Dodamarg S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416513": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Sawantwadi",
    "officename": "Aronda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416514": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Sawantwadi",
    "officename": "Satarda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416515": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Vengurla",
    "officename": "Tulas S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416516": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Vengurla",
    "officename": "Vengurla S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416517": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Vengurla",
    "officename": "Redi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416518": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Sawantwadi",
    "officename": "Shiroda S.O (Sindhudurg)",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416519": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Kudal",
    "officename": "Mangaon S.O (Sindhudurg)",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416520": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Kudal",
    "officename": "Kudal S.O (Sindhudurg)",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416521": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Kudal",
    "officename": "Kadaval S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416522": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Kudal",
    "officename": "Pat S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416523": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Vengurla",
    "officename": "Parula S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416524": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Kudal",
    "officename": "Walaval S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416525": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Kudal",
    "officename": "Deulwada Nerur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416526": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Gadhinglaj",
    "officename": "Koulage S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416527": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Chandgad",
    "officename": "Tillarinagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416528": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Kudal",
    "officename": "Industrial Area Pinguli S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416529": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Vengurla",
    "officename": "Talavade S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416531": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Sawantwadi",
    "officename": "Kalmist S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416534": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Malvan",
    "officename": "Sukalwadi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416549": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Dodamarg",
    "officename": "Sateli Tarf Bhedshi SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416550": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Kudal",
    "officename": "Kudal Audyogik Samuha S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416551": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Gadhinglaj",
    "officename": "Nool S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416552": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Chandgad",
    "officename": "DSF Halkarni S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416601": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Devgad",
    "officename": "Phondaghat S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416602": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Kankavli",
    "officename": "Kankavli S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416603": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Kudal",
    "officename": "Kasal S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416604": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Malvan",
    "officename": "Katta S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416605": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Malvan",
    "officename": "Chouke S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416606": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Malvan",
    "officename": "Malvan H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416608": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Malvan",
    "officename": "Masura S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416609": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Kankavli",
    "officename": "Sangve S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416610": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Devgad",
    "officename": "Shirgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416611": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Devgad",
    "officename": "Talebazar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416612": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Devgad",
    "officename": "Jamsande S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416613": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Devgad",
    "officename": "Devgad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416614": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Malvan",
    "officename": "Achara S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416615": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Devgad",
    "officename": "Mithbav S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416616": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Kankal I",
    "officename": "Ramgad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416620": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Kankavli",
    "officename": "Kalsuli S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416623": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Devgad",
    "officename": "Mond S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416626": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Malvan",
    "officename": "Hadi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416628": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Kudal",
    "officename": "Ambrad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416630": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Devgad",
    "officename": "Naringre S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416632": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Kudal",
    "officename": "Jambhavade S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416701": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Lanja",
    "officename": "Lanja S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "416702": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Rajapur",
    "officename": "Rajapur S.O (Ratnagiri)",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "416703": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Kankavli",
    "officename": "Kharepatan S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416704": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Rajapur",
    "officename": "Pachal S.O (Ratnagiri)",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "416705": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Rajapur",
    "officename": "Oni S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "416707": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Chiplun",
    "officename": "Adivare S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "416709": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Rajapur",
    "officename": "Sagave S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "416712": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Lanja",
    "officename": "Devadhe S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "416713": {
    "state": "Maharashtra",
    "district": "Ratnagiri",
    "block": "Rajapur",
    "officename": "Bhoo S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "RATNAGIRI DIVISION"
  },
  "416801": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Kankalvi",
    "officename": "Talera S.O (Sindhudurg)",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416803": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Devgad",
    "officename": "Mutat S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416804": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Devgad",
    "officename": "Padel S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416805": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Devgad",
    "officename": "Vada S.O (Sindhudurg)",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416806": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Devgad",
    "officename": "Vijaydurg S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416807": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Devgad",
    "officename": "Tirlot S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416810": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Vaibhavwadi",
    "officename": "Vaibhavwadi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416811": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Devgad",
    "officename": "Phanasgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416812": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Kudal",
    "officename": "Sindhudurgnagari MDG S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "416813": {
    "state": "Maharashtra",
    "district": "Sindhudurg",
    "block": "Vaibhavwadi",
    "officename": "Umbarde S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SINDHUDURG DIVISION"
  },
  "421002": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Ambarnath",
    "officename": "Ulhasnagar 2 S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "421004": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Kalyan",
    "officename": "Ulhasnagar 4 S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "421005": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Kalyan",
    "officename": "Ulhasnagar 5 S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "421101": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Bhiwandi",
    "officename": "Padgha S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "421102": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Kalyan",
    "officename": "Mohone S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "421103": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Kalyan",
    "officename": "Shahad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "421201": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Kalyan",
    "officename": "Tilaknagar S.O (Thane)",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "421202": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Kalyan",
    "officename": "Vishnunagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "421203": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Kalyan",
    "officename": "Dombivali I.A. S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "421204": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Kalyan",
    "officename": "Manpada S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "421301": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Kalyan",
    "officename": "Kalyan City H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "421302": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Bhiwandi",
    "officename": "Dandekarwadi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "421303": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Wada",
    "officename": "Wada S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "421305": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Bhiwandi",
    "officename": "Vidyashram S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "421306": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Kalyan",
    "officename": "Katemanivali S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "421308": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Bhiwandi",
    "officename": "Bhiwandi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "421311": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Bhiwandi",
    "officename": "Saravali S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "421312": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Wada",
    "officename": "Kudus S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "421401": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Murbad",
    "officename": "Murbad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "421402": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Thane",
    "officename": "Dhasai S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "421403": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Shahapur",
    "officename": "Kinholi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "421501": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Kalyan",
    "officename": "Ambernath S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "421502": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Ambarnath",
    "officename": "O.E.Ambernath S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "421503": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Ambarnath",
    "officename": "Kulgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "421505": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Kalyan",
    "officename": "Netaji Bazar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "421506": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Ambarnath",
    "officename": "Additional Ambernath S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "421601": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Kalyan",
    "officename": "Shahapur S.O (Thane)",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "421602": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Shahapur",
    "officename": "Kasara S.O (Thane)",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "421603": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Shahapur",
    "officename": "Bhatsanagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "421605": {
    "state": "Maharashtra",
    "district": "Thane",
    "block": "Kalyan",
    "officename": "Manda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Thane Division"
  },
  "422001": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Nashik",
    "officename": "Nashik H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422002": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Nashik",
    "officename": "Gole Colony S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422003": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Nashik",
    "officename": "Panchvati S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422004": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Dindori",
    "officename": "Meri Colony S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422005": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Nashik",
    "officename": "H P T College S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422006": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Nashik",
    "officename": "Gandhi Nagar (Nashik) S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422007": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Surgana",
    "officename": "Industrial Estate S.O (Nashik)",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422008": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Nashik",
    "officename": "Trimurti Chowk S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422009": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Nashik",
    "officename": "Cidco Colony S.O (Nashik)",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422010": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Nashik",
    "officename": "Ambad A.S. S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422011": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Nashik",
    "officename": "Dwarka Corner S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422012": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Nashik",
    "officename": "Ashok Nagar S.O (Nashik)",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422013": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Nashik",
    "officename": "Sawarkar Nagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422101": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Nashik",
    "officename": "Nashik Road H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422102": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Sinnar",
    "officename": "Nashik Road Camp S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422103": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Sinnar",
    "officename": "Sinnar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422104": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Sinnar",
    "officename": "Wavi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422105": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Nashik",
    "officename": "TP Station Eklahre S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422112": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Sinnar",
    "officename": "I.A. Musalgaon Sinnar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422113": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Sinnar",
    "officename": "Ind. Est. Malegaon Sinnar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422201": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Niphad",
    "officename": "Chandori S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422202": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Dindori",
    "officename": "Dindori S.O (Nashik)",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422203": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Nashik",
    "officename": "Girnara S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422204": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Nashik",
    "officename": "Harsul S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422205": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Chandvad",
    "officename": "Khedgaon S.O (Nashik)",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Malegaon Division"
  },
  "422206": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Niphad",
    "officename": "Ojhar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422207": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Dindori",
    "officename": "Ojhar T.S. S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422208": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Peint",
    "officename": "Peint S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422209": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Niphad",
    "officename": "Pimpalgaon Baswant S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Malegaon Division"
  },
  "422210": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Niphad",
    "officename": "Saykheda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422211": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Surgana",
    "officename": "Surgana S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422212": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Trimbakeshwar",
    "officename": "Trimbak S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422213": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Nashik",
    "officename": "Trimbak Vidya Mandir S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422214": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Trimbakeshwar",
    "officename": "Vaitarna Nagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422215": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Dindori",
    "officename": "Vani S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422221": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Niphad",
    "officename": "Ojhar A.F. Stn. S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422222": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Nashik",
    "officename": "Ycm Open Univesity S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422301": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Niphad",
    "officename": "B.S. Nagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422302": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Niphad",
    "officename": "Sukena S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422303": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Niphad",
    "officename": "Niphad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Malegaon Division"
  },
  "422304": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Niphad",
    "officename": "Ugaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Malegaon Division"
  },
  "422305": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Niphad",
    "officename": "Vinchur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Malegaon Division"
  },
  "422306": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Niphad",
    "officename": "Lasalgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Malegaon Division"
  },
  "422308": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Niphad",
    "officename": "K.K.Nagar S.O (Nashik)",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Malegaon Division"
  },
  "422401": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Nashik",
    "officename": "Devlali S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422402": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Nashik",
    "officename": "Ghoti S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422403": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Igatpuri",
    "officename": "Igatpuri S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422501": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Nashik",
    "officename": "Devlali Air Force S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422502": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Sinnar",
    "officename": "Bhagur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422601": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Akole",
    "officename": "Akole S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "422602": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Sangamner",
    "officename": "Bota S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "422603": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Sangamner",
    "officename": "Dhandharphal S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "422604": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Akole",
    "officename": "Rajur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "422605": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Sangamner",
    "officename": "Sangamner S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "422606": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Sinnar",
    "officename": "Nandurshingote S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Nasik Division"
  },
  "422608": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Sangamner",
    "officename": "Sangamner SK S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "422610": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Akole",
    "officename": "Kotul S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "422611": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Sangamner",
    "officename": "Talegaon Dighe S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "422620": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Sangamner",
    "officename": "Ghargaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "422622": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Sangamner",
    "officename": "Sakur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "423101": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Chandwad",
    "officename": "Chandwad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Malegaon Division"
  },
  "423102": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Devla",
    "officename": "Devla S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Malegaon Division"
  },
  "423104": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Yeola",
    "officename": "Manmad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Malegaon Division"
  },
  "423105": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Malegaon",
    "officename": "Malegaon Camp S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Malegaon Division"
  },
  "423106": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Nandgaon",
    "officename": "Nandgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Malegaon Division"
  },
  "423107": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Rahata",
    "officename": "Rahata S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "423108": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Malegaon",
    "officename": "Ravalgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Malegaon Division"
  },
  "423109": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Rahata",
    "officename": "Shirdi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "423110": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Deola",
    "officename": "Umrana S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Malegaon Division"
  },
  "423111": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Chandvad",
    "officename": "Vadner Bhairav S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Malegaon Division"
  },
  "423117": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Chandwad",
    "officename": "Vadali Bhoi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Malegaon Division"
  },
  "423201": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Malegaon",
    "officename": "Dabhadi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Malegaon Division"
  },
  "423202": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Malegaon",
    "officename": "G.S.S.K. S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Malegaon Division"
  },
  "423203": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Malegaon",
    "officename": "Malegaon H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Malegaon Division"
  },
  "423204": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Malegaon",
    "officename": "Nampur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Malegaon Division"
  },
  "423205": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Malegaon",
    "officename": "Zodga S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Malegaon Division"
  },
  "423206": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Malegaon",
    "officename": "Vadner Malegaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Malegaon Division"
  },
  "423208": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Malegaon",
    "officename": "Saundana S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Malegaon Division"
  },
  "423212": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Malegaon",
    "officename": "Nimgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Malegaon Division"
  },
  "423213": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Satana",
    "officename": "Lakhamapur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Malegaon Division"
  },
  "423301": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Satana",
    "officename": "Satana S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Malegaon Division"
  },
  "423302": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Satana",
    "officename": "Taharabad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Malegaon Division"
  },
  "423303": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Satana",
    "officename": "Jaikheda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Malegaon Division"
  },
  "423401": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Yeola",
    "officename": "Yeola S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Malegaon Division"
  },
  "423402": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Yeola",
    "officename": "Andarsul S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Malegaon Division"
  },
  "423403": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Yeola",
    "officename": "Nagarsul S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Malegaon Division"
  },
  "423501": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Kalwan",
    "officename": "Kalwan S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Malegaon Division"
  },
  "423502": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Kalwan",
    "officename": "Abhona S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Malegaon Division"
  },
  "423601": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Kopergaon",
    "officename": "Kopargaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "423602": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Kopergaon",
    "officename": "Kolpewadi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "423603": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Kopargaon",
    "officename": "Shinganapur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "423604": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Kopargaon",
    "officename": "Chasnali S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "423605": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Kopergaon",
    "officename": "Pohegaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "423607": {
    "state": "Maharashtra",
    "district": "Ahmed Nagar",
    "block": "Kopergaon",
    "officename": "Dhamori S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Shrirampur Division"
  },
  "423701": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Vaijapur",
    "officename": "Vaijapur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "423702": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Gangapur",
    "officename": "Lasur Station S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "423703": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Vaijapur",
    "officename": "Parsoda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "424001": {
    "state": "Maharashtra",
    "district": "Dhule",
    "block": "Dhule",
    "officename": "Dhule H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "424002": {
    "state": "Maharashtra",
    "district": "Dhule",
    "block": "Dhule",
    "officename": "Dhule Jaihind Colony S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "424004": {
    "state": "Maharashtra",
    "district": "Dhule",
    "block": "Dhule",
    "officename": "Dhule Market Yard S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "424005": {
    "state": "Maharashtra",
    "district": "Dhule",
    "block": "Dhule",
    "officename": "Dhule Vidya Nagari S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "424006": {
    "state": "Maharashtra",
    "district": "Dhule",
    "block": "Dhule",
    "officename": "Dhule Midc S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "424101": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Chalisgaon",
    "officename": "Chalisgaon H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Jalgaon Division"
  },
  "424102": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Chalisgaon",
    "officename": "Patonda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Jalgaon Division"
  },
  "424103": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Chalisgaon",
    "officename": "Kajgaon S.O (Jalgaon)",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Jalgaon Division"
  },
  "424104": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Pachora",
    "officename": "Nagardeola S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Jalgaon Division"
  },
  "424105": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Bhadgaon",
    "officename": "Bhadgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Jalgaon Division"
  },
  "424106": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Chalisgaon",
    "officename": "Mehunbare S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Jalgaon Division"
  },
  "424107": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Chalisgaon",
    "officename": "Khedgaon S.O (Jalgaon)",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Jalgaon Division"
  },
  "424108": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Chalisgaon",
    "officename": "Hirapur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Jalgaon Division"
  },
  "424109": {
    "state": "Maharashtra",
    "district": "Nashik",
    "block": "Nandgaon",
    "officename": "Naydongri S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Malegaon Division"
  },
  "424119": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Chalisgaon",
    "officename": "C.T. Mill Road S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Jalgaon Division"
  },
  "424201": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Pachora",
    "officename": "Pachora S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Jalgaon Division"
  },
  "424202": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Pachora",
    "officename": "Varkhedi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Jalgaon Division"
  },
  "424203": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Pachora",
    "officename": "Pimpalgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Jalgaon Division"
  },
  "424204": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Jalgaon",
    "officename": "Shendurni S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Bhusaval Division"
  },
  "424205": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Jalgaon",
    "officename": "Pahur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Bhusaval Division"
  },
  "424206": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Jalgaon",
    "officename": "Jamner S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Bhusaval Division"
  },
  "424207": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Jalgaon",
    "officename": "Wakadi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Bhusaval Division"
  },
  "424208": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Jalgoan",
    "officename": "Fattepur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Bhusaval Division"
  },
  "424301": {
    "state": "Maharashtra",
    "district": "Dhule",
    "block": "Dhule",
    "officename": "Fagana S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "424302": {
    "state": "Maharashtra",
    "district": "Dhule",
    "block": "Dhule",
    "officename": "Kusumba S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "424303": {
    "state": "Maharashtra",
    "district": "Dhule",
    "block": "Dhule",
    "officename": "Ner S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "424304": {
    "state": "Maharashtra",
    "district": "Dhule",
    "block": "Sakri",
    "officename": "Sakri (Dhule) S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "424305": {
    "state": "Maharashtra",
    "district": "Dhule",
    "block": "Sakri",
    "officename": "Nizampur S.O (Dhule)",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "424306": {
    "state": "Maharashtra",
    "district": "Dhule",
    "block": "Sakri",
    "officename": "Pimpalner S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "424307": {
    "state": "Maharashtra",
    "district": "Dhule",
    "block": "Dhule",
    "officename": "Kapadna S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "424308": {
    "state": "Maharashtra",
    "district": "Dhule",
    "block": "Dhule",
    "officename": "Shirud S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "424309": {
    "state": "Maharashtra",
    "district": "Dhule",
    "block": "Dhule",
    "officename": "Songir S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "424310": {
    "state": "Maharashtra",
    "district": "Dhule",
    "block": "Sakri",
    "officename": "Kasara S.O (Dhule)",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "424311": {
    "state": "Maharashtra",
    "district": "Dhule",
    "block": "Dhule",
    "officename": "Mohadi Laling S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "424318": {
    "state": "Maharashtra",
    "district": "Dhule",
    "block": "Dhule",
    "officename": "Naval Nagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "425001": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Jalgaon",
    "officename": "Jalgaon H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Jalgaon Division"
  },
  "425002": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Jalgaon",
    "officename": "M.J.College Jalgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Jalgaon Division"
  },
  "425003": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Jalgaon",
    "officename": "Audyogik Vasahat Jalgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Jalgaon Division"
  },
  "425004": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Jalgaon",
    "officename": "N M University Jalgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Jalgaon Division"
  },
  "425101": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Jalgaon",
    "officename": "Asoda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Jalgaon Division"
  },
  "425102": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Jalgaon",
    "officename": "Bhadli BK S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Jalgaon Division"
  },
  "425103": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Dharangaon",
    "officename": "Paldhi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Jalgaon Division"
  },
  "425104": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Dharangaon",
    "officename": "Pimpri Khurd S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Jalgaon Division"
  },
  "425105": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Dharangaon",
    "officename": "Dharangaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Jalgaon Division"
  },
  "425107": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Jalgaon",
    "officename": "Chopda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Bhusaval Division"
  },
  "425108": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Jalgaon",
    "officename": "Akulkheda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Bhusaval Division"
  },
  "425109": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Erandol",
    "officename": "Erandol S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Jalgaon Division"
  },
  "425110": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Erandol",
    "officename": "Kasoda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Jalgaon Division"
  },
  "425111": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Parola",
    "officename": "Parola SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Jalgaon Division"
  },
  "425112": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Parola",
    "officename": "Deogaon S.O (Jalgaon)",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Jalgaon Division"
  },
  "425113": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Parola",
    "officename": "Bahadarpur S.O (Jalgaon)",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Jalgaon Division"
  },
  "425114": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Jalgaon",
    "officename": "Neri BK S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Bhusaval Division"
  },
  "425115": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Pachora",
    "officename": "Nandra Pachora S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Jalgaon Division"
  },
  "425116": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Jalgaon",
    "officename": "Mhasawad S.O (Jalgaon)",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Jalgaon Division"
  },
  "425201": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Bhusawal",
    "officename": "Bhusawal H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Bhusaval Division"
  },
  "425203": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Bhusawal",
    "officename": "Bhusawal Ordnance Factory S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Bhusaval Division"
  },
  "425301": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Yawal",
    "officename": "Yawal S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Bhusaval Division"
  },
  "425302": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Yawal",
    "officename": "Sakali S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Bhusaval Division"
  },
  "425303": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Chopda",
    "officename": "Adavad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Bhusaval Division"
  },
  "425304": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Yawal",
    "officename": "Bhalod S.O (Jalgaon)",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Bhusaval Division"
  },
  "425305": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Bhusawal",
    "officename": "Varangaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Bhusaval Division"
  },
  "425306": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Muktainagar",
    "officename": "Muktainagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Bhusaval Division"
  },
  "425307": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Bhusawal",
    "officename": "Deepnagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Bhusaval Division"
  },
  "425308": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Bhusawal",
    "officename": "Varangaon Ord.Factory S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Bhusaval Division"
  },
  "425309": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Jalgaon",
    "officename": "Nashirabad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Bhusaval Division"
  },
  "425310": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Raver",
    "officename": "Bodwad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Bhusaval Division"
  },
  "425311": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Bhusawal",
    "officename": "Kurha S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Bhusaval Division"
  },
  "425327": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Muktai Nagar",
    "officename": "Kurha kakoda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Bhusaval Division"
  },
  "425401": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Amalner",
    "officename": "Amalner S.O (Jalgaon)",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Jalgaon Division"
  },
  "425402": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Amalner",
    "officename": "Marwad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Jalgaon Division"
  },
  "425403": {
    "state": "Maharashtra",
    "district": "Dhule",
    "block": "Shinkheda",
    "officename": "Betawad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "425404": {
    "state": "Maharashtra",
    "district": "Dhule",
    "block": "Shindkheda",
    "officename": "Nardana S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "425405": {
    "state": "Maharashtra",
    "district": "Dhule",
    "block": "Shirpur",
    "officename": "Shirpur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "425406": {
    "state": "Maharashtra",
    "district": "Dhule",
    "block": "Shindkheda",
    "officename": "Shindkheda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "425407": {
    "state": "Maharashtra",
    "district": "Dhule",
    "block": "Sindkheda",
    "officename": "Chimthana S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "425408": {
    "state": "Maharashtra",
    "district": "Dhule",
    "block": "Sindkheda",
    "officename": "Dondaicha S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "425409": {
    "state": "Maharashtra",
    "district": "Nandurbar",
    "block": "Shahada",
    "officename": "Shahada S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "425410": {
    "state": "Maharashtra",
    "district": "Nandurbar",
    "block": "Shahade",
    "officename": "Sarangkheda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "425411": {
    "state": "Maharashtra",
    "district": "Nandurbar",
    "block": "Nandurbar",
    "officename": "Ranala S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "425412": {
    "state": "Maharashtra",
    "district": "Nandurbar",
    "block": "Nandurbar",
    "officename": "Nandurbar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "425413": {
    "state": "Maharashtra",
    "district": "Nandurbar",
    "block": "Shahada",
    "officename": "Taloda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "425414": {
    "state": "Maharashtra",
    "district": "Nandurbar",
    "block": "Dhadgaon",
    "officename": "Dhadgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "425415": {
    "state": "Maharashtra",
    "district": "Nandurbar",
    "block": "Akkalkuwa",
    "officename": "Akkalkuwa S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "425416": {
    "state": "Maharashtra",
    "district": "Nandurbar",
    "block": "Navapur",
    "officename": "Khandbara S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "425417": {
    "state": "Maharashtra",
    "district": "Nandurbar",
    "block": "Navapur",
    "officename": "Chinchpada S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "425418": {
    "state": "Maharashtra",
    "district": "Nandurbar",
    "block": "Nawapur",
    "officename": "Navapur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "425419": {
    "state": "Maharashtra",
    "district": "Nandurbar",
    "block": "Akkalkuwa",
    "officename": "Khapar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "425420": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Amalner",
    "officename": "Amalgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Jalgaon Division"
  },
  "425421": {
    "state": "Maharashtra",
    "district": "Dhule",
    "block": "Shirpur",
    "officename": "Thalner S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "425422": {
    "state": "Maharashtra",
    "district": "Nandurbar",
    "block": "Shahada",
    "officename": "Prakasha S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "425423": {
    "state": "Maharashtra",
    "district": "Nandurbar",
    "block": "Shahada",
    "officename": "Vadali S.O (Nandurbar)",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "425424": {
    "state": "Maharashtra",
    "district": "Nandurbar",
    "block": "Shahada",
    "officename": "Purushottam Nagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "425426": {
    "state": "Maharashtra",
    "district": "Nandurbar",
    "block": "Navapur",
    "officename": "Visarwadi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "425427": {
    "state": "Maharashtra",
    "district": "Dhule",
    "block": "Shirpur",
    "officename": "Vikharan (Shirpur) S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "425428": {
    "state": "Maharashtra",
    "district": "Dhule",
    "block": "Shirpur",
    "officename": "Boradi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "425432": {
    "state": "Maharashtra",
    "district": "Nandurbar",
    "block": "Shahad",
    "officename": "Mhasawad S.O (Nandurbar)",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "425442": {
    "state": "Maharashtra",
    "district": "Nandurbar",
    "block": "Taloda",
    "officename": "Borad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "425444": {
    "state": "Maharashtra",
    "district": "Nandurbar",
    "block": "Shahada",
    "officename": "Mandana S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "425452": {
    "state": "Maharashtra",
    "district": "Nandurbar",
    "block": "Dhadgaon",
    "officename": "Molgi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Dhule Division"
  },
  "425501": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Raver",
    "officename": "Thorgavan S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Bhusaval Division"
  },
  "425502": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Raver",
    "officename": "Savda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Bhusaval Division"
  },
  "425503": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Yawal",
    "officename": "Faizpur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Bhusaval Division"
  },
  "425504": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Raver",
    "officename": "Khiroda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Bhusaval Division"
  },
  "425505": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Raver",
    "officename": "Chinawal S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Bhusaval Division"
  },
  "425506": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Raver",
    "officename": "Nimbhora S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Bhusaval Division"
  },
  "425507": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Raver",
    "officename": "Khirdi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Bhusaval Division"
  },
  "425508": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Raver",
    "officename": "Raver S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Bhusaval Division"
  },
  "425524": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Yawal",
    "officename": "M.S.S.K.Faizpur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Bhusaval Division"
  },
  "431001": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Aurangabad",
    "officename": "Chhatrapati Sambhajinagar (MH) H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431002": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Aurangabad",
    "officename": "Chhatrapati Sambhajinagar Cantonment S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431003": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Aurangabad",
    "officename": "Cidco Colony S.O (Chhatrapati Sambhajinagar)",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431004": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Aurangabad",
    "officename": "Dr. B.A. Marathwada University S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431005": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Aurangabad",
    "officename": "Kranti Chowk S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431006": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Aurangabad",
    "officename": "Chikalthana Industrial Area S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431007": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Aurangabad",
    "officename": "Chikalthana S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431008": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Aurangabad",
    "officename": "Harsool S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431009": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Aurangabad",
    "officename": "Garkheda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431010": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Aurangabad",
    "officename": "Satara Parisar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431101": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Khuldabad",
    "officename": "Khuldabad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431102": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Khuldabad",
    "officename": "Ellora S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431103": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Kannad",
    "officename": "Kannad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431104": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Kannad",
    "officename": "Pishore S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431105": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Paithan",
    "officename": "Bidkingaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431107": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Paithan",
    "officename": "Paithan S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431109": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Gangapur",
    "officename": "Gangapur (Chhatrapati Sambhajinagar MH) S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431110": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Gangapur",
    "officename": "Raghunath Nagar S.O (Chhatrapati Sambhajinagar)",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431111": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Khuldabad",
    "officename": "Phulmbri S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431112": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Sillod",
    "officename": "Sillod S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431113": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Sillod",
    "officename": "Bharadi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431114": {
    "state": "Maharashtra",
    "district": "Jalna",
    "block": "Bhokardan",
    "officename": "Bhokardan S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431115": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Vaijapur",
    "officename": "Deogaon Rangari S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431116": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Valijapur",
    "officename": "Shivar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431117": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Sillod",
    "officename": "Ajantha S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431118": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Sillod",
    "officename": "Phardapur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431120": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Sillod",
    "officename": "Soegaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431121": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Paithan",
    "officename": "Pachod S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431122": {
    "state": "Maharashtra",
    "district": "Beed",
    "block": "Beed",
    "officename": "Beed H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Beed Division"
  },
  "431123": {
    "state": "Maharashtra",
    "district": "Beed",
    "block": "Kaij",
    "officename": "Kaij S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Beed Division"
  },
  "431124": {
    "state": "Maharashtra",
    "district": "Beed",
    "block": "K Dharur",
    "officename": "Kille Dharur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Beed Division"
  },
  "431125": {
    "state": "Maharashtra",
    "district": "Beed",
    "block": "Bid",
    "officename": "Naiknoor S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Beed Division"
  },
  "431126": {
    "state": "Maharashtra",
    "district": "Beed",
    "block": "Beed",
    "officename": "Chousala S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Beed Division"
  },
  "431127": {
    "state": "Maharashtra",
    "district": "Beed",
    "block": "Georai",
    "officename": "Gevrai S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Beed Division"
  },
  "431128": {
    "state": "Maharashtra",
    "district": "Beed",
    "block": "Bid",
    "officename": "Dindrood S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Beed Division"
  },
  "431129": {
    "state": "Maharashtra",
    "district": "Beed",
    "block": "Georai",
    "officename": "Talkhed S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Beed Division"
  },
  "431130": {
    "state": "Maharashtra",
    "district": "Beed",
    "block": "Georai",
    "officename": "Umapur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Beed Division"
  },
  "431131": {
    "state": "Maharashtra",
    "district": "Beed",
    "block": "Majalgaon",
    "officename": "Majalgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Beed Division"
  },
  "431132": {
    "state": "Maharashtra",
    "district": "Jalna",
    "block": "Bhokardan",
    "officename": "Shivna S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431133": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Gangapur",
    "officename": "Waluj S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431134": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Phulumbri",
    "officename": "Badod Bazar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431135": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Sillod",
    "officename": "Sillod Sakhar Karkhana S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431136": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Gangapur",
    "officename": "Bajaj Nagar Midc Waluj S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431137": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Paithan",
    "officename": "Bihamandwa S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431142": {
    "state": "Maharashtra",
    "district": "Beed",
    "block": "Manjlegaon",
    "officename": "Kesapuri Camp S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Beed Division"
  },
  "431143": {
    "state": "Maharashtra",
    "district": "Beed",
    "block": "Georai",
    "officename": "JBSSK GADI S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Beed Division"
  },
  "431144": {
    "state": "Maharashtra",
    "district": "Beed",
    "block": "Wadwani",
    "officename": "Wadwani S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Beed Division"
  },
  "431147": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Kannad",
    "officename": "Chincholi Limbaji S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431148": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Paithan",
    "officename": "Paithan Sakhar Karkhana S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431150": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Soegaon",
    "officename": "Banoti S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431151": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Sillod",
    "officename": "Andhari S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431153": {
    "state": "Maharashtra",
    "district": "Beed",
    "block": "Beed",
    "officename": "Beed ST Stand S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Beed Division"
  },
  "431154": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Aurangabad",
    "officename": "Shendra MIDC Area S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431202": {
    "state": "Maharashtra",
    "district": "Jalna",
    "block": "Badnapur",
    "officename": "Badnapur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431203": {
    "state": "Maharashtra",
    "district": "Jalna",
    "block": "Jalna",
    "officename": "Jalna H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431204": {
    "state": "Maharashtra",
    "district": "Jalna",
    "block": "Ambad",
    "officename": "Ambad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431205": {
    "state": "Maharashtra",
    "district": "Jalna",
    "block": "Ambad",
    "officename": "Wadigodri S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431206": {
    "state": "Maharashtra",
    "district": "Jalna",
    "block": "Jaffrabad",
    "officename": "Jaffrabad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431207": {
    "state": "Maharashtra",
    "district": "Jalna",
    "block": "Badnapur",
    "officename": "Ranjani S.O (Jalna)",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431208": {
    "state": "Maharashtra",
    "district": "Jalna",
    "block": "Jaffrabad",
    "officename": "Tembhurni S.O (Jalna)",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431209": {
    "state": "Maharashtra",
    "district": "Jalna",
    "block": "Ghansawangi",
    "officename": "Ghansawangi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431211": {
    "state": "Maharashtra",
    "district": "Jalna",
    "block": "Ghansawangi",
    "officename": "Kumbhar Pimpalgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431212": {
    "state": "Maharashtra",
    "district": "Jalna",
    "block": "Jalna",
    "officename": "Ankush Nagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431213": {
    "state": "Maharashtra",
    "district": "Jalna",
    "block": "Jalna",
    "officename": "Jalna Railway Station S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431214": {
    "state": "Maharashtra",
    "district": "Jalna",
    "block": "Jalna",
    "officename": "Ramnagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431215": {
    "state": "Maharashtra",
    "district": "Jalna",
    "block": "Jalna",
    "officename": "Rajur",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431401": {
    "state": "Maharashtra",
    "district": "Parbhani",
    "block": "Parbhani",
    "officename": "Parbhani H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Pharbhani Division"
  },
  "431402": {
    "state": "Maharashtra",
    "district": "Parbhani",
    "block": "Parbhani",
    "officename": "Mau Parbhani S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Pharbhani Division"
  },
  "431501": {
    "state": "Maharashtra",
    "district": "Hingoli",
    "block": "Basmath",
    "officename": "Partur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Pharbhani Division"
  },
  "431502": {
    "state": "Maharashtra",
    "district": "Jalna",
    "block": "Partur",
    "officename": "Satona S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Pharbhani Division"
  },
  "431503": {
    "state": "Maharashtra",
    "district": "Parbhani",
    "block": "Sailu",
    "officename": "Sailu S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Pharbhani Division"
  },
  "431504": {
    "state": "Maharashtra",
    "district": "Jalna",
    "block": "Mantha",
    "officename": "Mantha S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Pharbhani Division"
  },
  "431505": {
    "state": "Maharashtra",
    "district": "Parbhani",
    "block": "Manwath",
    "officename": "Manwath S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Pharbhani Division"
  },
  "431506": {
    "state": "Maharashtra",
    "district": "Parbhani",
    "block": "Pathri",
    "officename": "Pathri S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Pharbhani Division"
  },
  "431507": {
    "state": "Maharashtra",
    "district": "Jalna",
    "block": "Partur",
    "officename": "Ashti S.O (Jalna)",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Pharbhani Division"
  },
  "431508": {
    "state": "Maharashtra",
    "district": "Parbhani",
    "block": "Jintur",
    "officename": "Bori S.O (Parbhani)",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Pharbhani Division"
  },
  "431509": {
    "state": "Maharashtra",
    "district": "Parbhani",
    "block": "Jintur",
    "officename": "Jintur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Pharbhani Division"
  },
  "431510": {
    "state": "Maharashtra",
    "district": "Parbhani",
    "block": "Jintur",
    "officename": "Yeldari S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Pharbhani Division"
  },
  "431511": {
    "state": "Maharashtra",
    "district": "Parbhani",
    "block": "Purna",
    "officename": "Purna S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Pharbhani Division"
  },
  "431512": {
    "state": "Maharashtra",
    "district": "Jalna",
    "block": "Partur",
    "officename": "Basmathnagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Pharbhani Division"
  },
  "431513": {
    "state": "Maharashtra",
    "district": "Hingoli",
    "block": "Hingoli",
    "officename": "Hingoli S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Pharbhani Division"
  },
  "431514": {
    "state": "Maharashtra",
    "district": "Parbhani",
    "block": "Gangakhed",
    "officename": "Gangakhed S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Pharbhani Division"
  },
  "431515": {
    "state": "Maharashtra",
    "district": "Beed",
    "block": "Parlivaij",
    "officename": "Parli Vaijinath S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Beed Division"
  },
  "431516": {
    "state": "Maharashtra",
    "district": "Parbhani",
    "block": "Sonpeth",
    "officename": "Sonpeth S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Pharbhani Division"
  },
  "431517": {
    "state": "Maharashtra",
    "district": "Beed",
    "block": "Georai",
    "officename": "Ambajogai S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Beed Division"
  },
  "431518": {
    "state": "Maharashtra",
    "district": "Beed",
    "block": "Ambajogai",
    "officename": "Bansorala S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Beed Division"
  },
  "431519": {
    "state": "Maharashtra",
    "district": "Beed",
    "block": "Ambajogai",
    "officename": "Ghatnandur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Beed Division"
  },
  "431520": {
    "state": "Maharashtra",
    "district": "Beed",
    "block": "Parli",
    "officename": "Parli Tps S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Beed Division"
  },
  "431521": {
    "state": "Maharashtra",
    "district": "Parbhani",
    "block": "Parbhani",
    "officename": "Daithana S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Pharbhani Division"
  },
  "431522": {
    "state": "Maharashtra",
    "district": "Osmanabad",
    "block": "Ahmedpur",
    "officename": "Pangaon S.O (Latur)",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "431523": {
    "state": "Maharashtra",
    "district": "Beed",
    "block": "Ambejogai",
    "officename": "Ambasakhar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Beed Division"
  },
  "431530": {
    "state": "Maharashtra",
    "district": "Beed",
    "block": "Parli Vaij.",
    "officename": "Vssk Pangri S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Beed Division"
  },
  "431536": {
    "state": "Maharashtra",
    "district": "Parbhani",
    "block": "Palam",
    "officename": "Ranisawargaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Pharbhani Division"
  },
  "431537": {
    "state": "Maharashtra",
    "district": "Parbhani",
    "block": "Parbhani",
    "officename": "Pedgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Pharbhani Division"
  },
  "431540": {
    "state": "Maharashtra",
    "district": "Parbhani",
    "block": "Parbhani",
    "officename": "Zari S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Pharbhani Division"
  },
  "431541": {
    "state": "Maharashtra",
    "district": "Parbhani",
    "block": "Manwath",
    "officename": "Rampuri BK S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Pharbhani Division"
  },
  "431542": {
    "state": "Maharashtra",
    "district": "Hingoli",
    "block": "Sengaon",
    "officename": "Sengaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Pharbhani Division"
  },
  "431601": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Bhokar",
    "officename": "Nanded H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431602": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Naigaon",
    "officename": "Shivajinagar S.O (Nanded)",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431603": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Nanded",
    "officename": "Cidco Nanded S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431604": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Bhokar",
    "officename": "Itwara Nanded S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431605": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Bhokar",
    "officename": "Taroda Road Nanded S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431606": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Himayatnagar",
    "officename": "SRTMU Nanded S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431701": {
    "state": "Maharashtra",
    "district": "Hingoli",
    "block": "Kalamnuri",
    "officename": "Akhada Balapur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Pharbhani Division"
  },
  "431702": {
    "state": "Maharashtra",
    "district": "Hingoli",
    "block": "Kalamnuri",
    "officename": "Kalamnuri S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Pharbhani Division"
  },
  "431703": {
    "state": "Maharashtra",
    "district": "Hingoli",
    "block": "Sengaon",
    "officename": "Goregaon S.O (Hingoli)",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Pharbhani Division"
  },
  "431704": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Ardhapur",
    "officename": "Ardhapur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431705": {
    "state": "Maharashtra",
    "district": "Hingoli",
    "block": "Basmath",
    "officename": "Aundha Nagnath S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Pharbhani Division"
  },
  "431707": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Loha",
    "officename": "Osmannagar S.O (Nanded)",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431708": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Loha",
    "officename": "Loha S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431709": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Naigaon",
    "officename": "Naigaon S.O (Nanded)",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431710": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Biloli",
    "officename": "Biloli S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431711": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Biloli",
    "officename": "Kundalwadi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431712": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Hadgaon",
    "officename": "Hadgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431713": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Hadgaon",
    "officename": "Tamsa S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431714": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Kandhar",
    "officename": "Kandhar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431715": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Mukhed",
    "officename": "Mukhed S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431716": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Mukhed",
    "officename": "Jamb B K S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431717": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Degloor",
    "officename": "Degloor S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431718": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Degloor",
    "officename": "Karadkhed S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431719": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Mukhed",
    "officename": "Mukramabad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431720": {
    "state": "Maharashtra",
    "district": "Parbhani",
    "block": "Palam",
    "officename": "Palam S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Pharbhani Division"
  },
  "431721": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Mahore",
    "officename": "Mahore S.O (Nanded)",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431722": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Naigaon",
    "officename": "Gadga S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431723": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Degloor",
    "officename": "Shahapur S.O (Nanded)",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431731": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Biloli",
    "officename": "Sagroli S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431736": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Biloli",
    "officename": "Shankarnagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431741": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Degloor",
    "officename": "Hanegaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431742": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Kandhr",
    "officename": "Kurula S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431743": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Hadgaon",
    "officename": "Niwgha S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431745": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Mudkhed",
    "officename": "Barad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431746": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Kandhar",
    "officename": "Barul S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431750": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Ardhapur",
    "officename": "Malegaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431801": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Bhokar",
    "officename": "Bhokar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431802": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Himayatnagar",
    "officename": "Himayatnagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431803": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Kinwat",
    "officename": "Islapur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431804": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Kinwat",
    "officename": "Kinwat S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431805": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Kinwat",
    "officename": "Mandvi S.O (Nanded)",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431806": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Mudkhed",
    "officename": "Mudkhed Station S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431807": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Umari",
    "officename": "Umri S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431808": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Dharmabad",
    "officename": "Karkheli S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431809": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Dharmabad",
    "officename": "Dharmabad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431810": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Kinwat",
    "officename": "Bodhadi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "431811": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Kinwat",
    "officename": "Gokunda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "440001": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Nagpur",
    "officename": "Nagpur GPO",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur City Division"
  },
  "440002": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Nagpur",
    "officename": "Nagpur City H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur City Division"
  },
  "440003": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Nagpur",
    "officename": "Ajni S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur City Division"
  },
  "440005": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Nagpur",
    "officename": "Nagpur Airport S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur City Division"
  },
  "440006": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Nagpur",
    "officename": "Seminary Hills S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur City Division"
  },
  "440007": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Nagpur",
    "officename": "Vayusena Nagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur City Division"
  },
  "440008": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Nagpur",
    "officename": "Bagadganj S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur City Division"
  },
  "440010": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Nagpur",
    "officename": "Shankar Nagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur City Division"
  },
  "440012": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Nagpur",
    "officename": "Patwardhan Ground S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur City Division"
  },
  "440013": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Nagpur",
    "officename": "Katolroad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur City Division"
  },
  "440014": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Nagpur",
    "officename": "Jaripatka S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur City Division"
  },
  "440015": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Nagpur",
    "officename": "Vivekanand Nagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur City Division"
  },
  "440016": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Nagpur (Urban)",
    "officename": "Indl.Area Nagpur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "440017": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Nagpur",
    "officename": "Dr.Ambedkar Marg S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur City Division"
  },
  "440018": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Nagpur",
    "officename": "Mahatma Fule Bazar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur City Division"
  },
  "440019": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Nagpur",
    "officename": "C.R.P.F. Nagpur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur City Division"
  },
  "440020": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Nagpur",
    "officename": "Neeri S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur City Division"
  },
  "440021": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Nagpur (Urban)",
    "officename": "A.D. Project S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "440022": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Nagpur",
    "officename": "Ranapratap Nagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur City Division"
  },
  "440023": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Hingna",
    "officename": "Wadi S.O (Nagpur)",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "440024": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Nagpur",
    "officename": "Ayodhya Nagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur City Division"
  },
  "440025": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Nagpur",
    "officename": "Khamla S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur City Division"
  },
  "440026": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Kamthi",
    "officename": "Uppalwadi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur City Division"
  },
  "440027": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Nagpur",
    "officename": "Parvati Nagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur City Division"
  },
  "440030": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Nagpur",
    "officename": "Mankapur S.O (Nagpur)",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur City Division"
  },
  "440032": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Nagpur",
    "officename": "Mahal S.O (Nagpur)",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur City Division"
  },
  "440033": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Nagpur",
    "officename": "University Campus S.O (Nagpur)",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur City Division"
  },
  "440034": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Nagpur",
    "officename": "Mhalginagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur City Division"
  },
  "440035": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Nagpur",
    "officename": "Kalmna Market Yard S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur City Division"
  },
  "440036": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Nagpur",
    "officename": "Jaitala S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur City Division"
  },
  "440037": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Nagpur",
    "officename": "BESA Road S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur City Division"
  },
  "441001": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Kamthi",
    "officename": "Kamthi H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441101": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Saoner",
    "officename": "Khapa S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441102": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Kamptee",
    "officename": "Khaperkheda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441103": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Katol",
    "officename": "Kondhali S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441104": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Mouda",
    "officename": "Mauda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441105": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Parseoni",
    "officename": "Parseoni S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441106": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Ramtek",
    "officename": "Ramtek S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441107": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Saoner",
    "officename": "Saoner S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441108": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Nagpur",
    "officename": "Bori S.O (Nagpur)",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441109": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Saoner",
    "officename": "Sillewara Project S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441110": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Hingna",
    "officename": "Hingna S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441111": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Kamthi",
    "officename": "Koradi Tps S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441112": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Saoner",
    "officename": "Kelod S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441113": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Saoner",
    "officename": "Patansaongi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441122": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Nagpur",
    "officename": "Industrial Area Butibori S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441123": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Kamthi",
    "officename": "Godhani S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441201": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Bhiwapur",
    "officename": "Bhiwapur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441202": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Kuhi",
    "officename": "Kuhi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441203": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Umrer",
    "officename": "Umred S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441204": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Umrer",
    "officename": "Umred Project S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441205": {
    "state": "Maharashtra",
    "district": "Chandrapur",
    "block": "Nagbhid",
    "officename": "Nagbhid S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "441206": {
    "state": "Maharashtra",
    "district": "Chandrapur",
    "block": "Bramhapuri",
    "officename": "Bramhapuri S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "441207": {
    "state": "Maharashtra",
    "district": "Chandrapur",
    "block": "Desaiganj",
    "officename": "Desaiganj S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "441208": {
    "state": "Maharashtra",
    "district": "Gadchiroli",
    "block": "Armori",
    "officename": "Armori S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "441209": {
    "state": "Maharashtra",
    "district": "Gadchiroli",
    "block": "Korchi",
    "officename": "Kurkheda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "441210": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Kuhi",
    "officename": "Mandhal S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441212": {
    "state": "Maharashtra",
    "district": "Chandrapur",
    "block": "Mul",
    "officename": "Rajoli S.O (Chandrapur)",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "441214": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Umrer",
    "officename": "Sirsi S.O (Nagpur)",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441215": {
    "state": "Maharashtra",
    "district": "Chandrapur",
    "block": "Saoli",
    "officename": "Pathari S.O (Chandrapur)",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "441217": {
    "state": "Maharashtra",
    "district": "Gadchiroli",
    "block": "Kurkheda",
    "officename": "Vairagadh S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "441221": {
    "state": "Maharashtra",
    "district": "Chandrapur",
    "block": "Nagbhir",
    "officename": "Talodhi Balapur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "441222": {
    "state": "Maharashtra",
    "district": "Chandrapur",
    "block": "Sindewahi",
    "officename": "Sindewahi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "441223": {
    "state": "Maharashtra",
    "district": "Chandrapur",
    "block": "Sindewahi",
    "officename": "Nawargaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "441224": {
    "state": "Maharashtra",
    "district": "Chandrapur",
    "block": "Mul",
    "officename": "Mul S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "441225": {
    "state": "Maharashtra",
    "district": "Chandrapur",
    "block": "Saoli",
    "officename": "Saoli S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "441226": {
    "state": "Maharashtra",
    "district": "Chandrapur",
    "block": "Mul",
    "officename": "Bembal S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "441301": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Narkhed",
    "officename": "Jalalkheda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441302": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Katol",
    "officename": "Katol S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441303": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Narkhed",
    "officename": "Mowad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441304": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Narkhed",
    "officename": "Narkher S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441305": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Katol",
    "officename": "Paradsinga S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441306": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Narkher",
    "officename": "Sawargaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441401": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Kamthi",
    "officename": "Kanhan Pipri S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441404": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Parseoni",
    "officename": "Kamthi Colliery S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441501": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Kalmeshwar",
    "officename": "Kalmeshwar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441502": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Kalmeshwar",
    "officename": "Mohpa S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441601": {
    "state": "Maharashtra",
    "district": "Gondia",
    "block": "Gondia",
    "officename": "Gondia H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441614": {
    "state": "Maharashtra",
    "district": "Gondia",
    "block": "Gondia",
    "officename": "Gondia City S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441701": {
    "state": "Maharashtra",
    "district": "Gondia",
    "block": "Arjuni Morgaon",
    "officename": "Arjuni Morgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441702": {
    "state": "Maharashtra",
    "district": "Gondia",
    "block": "Arjuni Morgaon",
    "officename": "Navegaon Bandh S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441801": {
    "state": "Maharashtra",
    "district": "Gondia",
    "block": "Goregaon",
    "officename": "Goregaon S.O (Gondia)",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441802": {
    "state": "Maharashtra",
    "district": "Bhandara",
    "block": "Sakoli",
    "officename": "Sakoli S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441803": {
    "state": "Maharashtra",
    "district": "Bhandara",
    "block": "Lakhandur",
    "officename": "Lakhandur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441804": {
    "state": "Maharashtra",
    "district": "Bhandara",
    "block": "Lakhani",
    "officename": "Lakhni S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441805": {
    "state": "Maharashtra",
    "district": "Bhandara",
    "block": "Lakhandur",
    "officename": "Dighori S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441806": {
    "state": "Maharashtra",
    "district": "Gondia",
    "block": "Sadak Arjuni",
    "officename": "Soundad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441807": {
    "state": "Maharashtra",
    "district": "Gondia",
    "block": "Sadak Arjuni",
    "officename": "Sadak Arjuni S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441809": {
    "state": "Maharashtra",
    "district": "Bhandara",
    "block": "Lakhni",
    "officename": "Pohra S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441901": {
    "state": "Maharashtra",
    "district": "Gondia",
    "block": "Deori",
    "officename": "Deori S.O (Gondia)",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441902": {
    "state": "Maharashtra",
    "district": "Gondia",
    "block": "Amgaon",
    "officename": "Amgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441903": {
    "state": "Maharashtra",
    "district": "Bhandara",
    "block": "Pauni",
    "officename": "Adyar S.O (Bhandara)",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441904": {
    "state": "Maharashtra",
    "district": "Bhandara",
    "block": "Bhandara",
    "officename": "Bhandara H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441905": {
    "state": "Maharashtra",
    "district": "Bhandara",
    "block": "Mohadi",
    "officename": "Bhandara Road S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441906": {
    "state": "Maharashtra",
    "district": "Bhandara",
    "block": "Bhandarra",
    "officename": "Bhandara Of S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441907": {
    "state": "Maharashtra",
    "district": "Bhandara",
    "block": "Tumsar",
    "officename": "Gobarwahi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441908": {
    "state": "Maharashtra",
    "district": "Bhandara",
    "block": "Pauni",
    "officename": "Konda Kosra S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441909": {
    "state": "Maharashtra",
    "district": "Bhandara",
    "block": "Mohadi",
    "officename": "Mohadi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441910": {
    "state": "Maharashtra",
    "district": "Bhandara",
    "block": "Pauni",
    "officename": "Pauni S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441911": {
    "state": "Maharashtra",
    "district": "Gondia",
    "block": "Tirora",
    "officename": "Tirora S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441912": {
    "state": "Maharashtra",
    "district": "Bhandara",
    "block": "Tumsar",
    "officename": "Tumsar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441913": {
    "state": "Maharashtra",
    "district": "Bhandara",
    "block": "Tumsar",
    "officename": "Tumsar Road S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441914": {
    "state": "Maharashtra",
    "district": "Bhandara",
    "block": "Mohadi",
    "officename": "Andhalgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441915": {
    "state": "Maharashtra",
    "district": "Bhandara",
    "block": "Tumsar",
    "officename": "Sihora S.O (Bhandara)",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441916": {
    "state": "Maharashtra",
    "district": "Gondia",
    "block": "Salekasa",
    "officename": "Salekasa S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "441924": {
    "state": "Maharashtra",
    "district": "Bhandara",
    "block": "Bhandara",
    "officename": "Pahela S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur Moffusil Division"
  },
  "442001": {
    "state": "Maharashtra",
    "district": "Wardha",
    "block": "Seloo",
    "officename": "Wardha H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Wardha Division"
  },
  "442003": {
    "state": "Maharashtra",
    "district": "Wardha",
    "block": "Wardha",
    "officename": "Hindinagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Wardha Division"
  },
  "442101": {
    "state": "Maharashtra",
    "district": "Wardha",
    "block": "Deoli",
    "officename": "Deoli S.O (Wardha)",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Wardha Division"
  },
  "442102": {
    "state": "Maharashtra",
    "district": "Wardha",
    "block": "Samudrapur",
    "officename": "Sewagram S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Wardha Division"
  },
  "442104": {
    "state": "Maharashtra",
    "district": "Wardha",
    "block": "Seloo",
    "officename": "Seloo S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Wardha Division"
  },
  "442105": {
    "state": "Maharashtra",
    "district": "Wardha",
    "block": "Seloo",
    "officename": "Sindi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Wardha Division"
  },
  "442106": {
    "state": "Maharashtra",
    "district": "Wardha",
    "block": "Arvi",
    "officename": "Kharangna S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Wardha Division"
  },
  "442111": {
    "state": "Maharashtra",
    "district": "Wardha",
    "block": "Wardha",
    "officename": "Paunar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Wardha Division"
  },
  "442201": {
    "state": "Maharashtra",
    "district": "Wardha",
    "block": "Arvi",
    "officename": "Arvi S.O (Wardha)",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Wardha Division"
  },
  "442202": {
    "state": "Maharashtra",
    "district": "Wardha",
    "block": "Ashti",
    "officename": "Ashti S.O (Wardha)",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Wardha Division"
  },
  "442203": {
    "state": "Maharashtra",
    "district": "Wardha",
    "block": "Karanja",
    "officename": "Karanja S.O (Wardha)",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Wardha Division"
  },
  "442301": {
    "state": "Maharashtra",
    "district": "Wardha",
    "block": "Hinganghat",
    "officename": "Hinganghat S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Wardha Division"
  },
  "442302": {
    "state": "Maharashtra",
    "district": "Wardha",
    "block": "Arvi",
    "officename": "Pulgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Wardha Division"
  },
  "442303": {
    "state": "Maharashtra",
    "district": "Wardha",
    "block": "Deoli",
    "officename": "Pulgaon Camp S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Wardha Division"
  },
  "442304": {
    "state": "Maharashtra",
    "district": "Wardha",
    "block": "Hinganghat",
    "officename": "Allipur S.O (Wardha)",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Wardha Division"
  },
  "442305": {
    "state": "Maharashtra",
    "district": "Wardha",
    "block": "Samudrapur",
    "officename": "Samudrapur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Wardha Division"
  },
  "442306": {
    "state": "Maharashtra",
    "district": "Wardha",
    "block": "Deoli",
    "officename": "Nachangaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Wardha Division"
  },
  "442307": {
    "state": "Maharashtra",
    "district": "Wardha",
    "block": "Hinganghat",
    "officename": "Wadner S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Wardha Division"
  },
  "442401": {
    "state": "Maharashtra",
    "district": "Chandrapur",
    "block": "Chandrapur Ho",
    "officename": "Chandrapur H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "442402": {
    "state": "Maharashtra",
    "district": "Chandrapur",
    "block": "Chandrapur",
    "officename": "Chandrapur City S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "442403": {
    "state": "Maharashtra",
    "district": "Chandrapur",
    "block": "Chandrapur",
    "officename": "Babupeth S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "442404": {
    "state": "Maharashtra",
    "district": "Chandrapur",
    "block": "Chandrapur",
    "officename": "Chandrapur TPS S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "442406": {
    "state": "Maharashtra",
    "district": "Chandrapur",
    "block": "Chandrapur",
    "officename": "MIDC (P) S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "442501": {
    "state": "Maharashtra",
    "district": "Chandrapur",
    "block": "Chandrapur",
    "officename": "Chandrapur Ord Fact S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "442502": {
    "state": "Maharashtra",
    "district": "Chandrapur",
    "block": "Chandrapur",
    "officename": "Cementnagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "442503": {
    "state": "Maharashtra",
    "district": "Chandrapur",
    "block": "Bhadrawati",
    "officename": "Shivjinagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "442504": {
    "state": "Maharashtra",
    "district": "Gadchiroli",
    "block": "Sironcha",
    "officename": "Sironcha S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "442505": {
    "state": "Maharashtra",
    "district": "Chandrapur",
    "block": "Chandrapur",
    "officename": "Ghugus Colliery S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "442507": {
    "state": "Maharashtra",
    "district": "Chandrapur",
    "block": "Chandrapur",
    "officename": "H.L.C. S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "442603": {
    "state": "Maharashtra",
    "district": "Gadchiroli",
    "block": "Chamorshi",
    "officename": "Chamorshi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "442604": {
    "state": "Maharashtra",
    "district": "Gadchiroli",
    "block": "Chamorshi",
    "officename": "Ghot S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "442605": {
    "state": "Maharashtra",
    "district": "Gadchiroli",
    "block": "Gadchiroli",
    "officename": "Gadchiroli S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "442606": {
    "state": "Maharashtra",
    "district": "Gadchiroli",
    "block": "Dhanora",
    "officename": "Dhanora S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "442701": {
    "state": "Maharashtra",
    "district": "Chandrapur",
    "block": "Ballarpur",
    "officename": "Ballarpur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "442702": {
    "state": "Maharashtra",
    "district": "Chandrapur",
    "block": "Gondipipri",
    "officename": "Gondpipri S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "442703": {
    "state": "Maharashtra",
    "district": "Gadchiroli",
    "block": "Aheri",
    "officename": "Allapalli S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "442704": {
    "state": "Maharashtra",
    "district": "Gadchiroli",
    "block": "Etapalli",
    "officename": "Ettapalli S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "442705": {
    "state": "Maharashtra",
    "district": "Gadchiroli",
    "block": "Aheri",
    "officename": "Aheri S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "442707": {
    "state": "Maharashtra",
    "district": "Gadchiroli",
    "block": "Mulchera",
    "officename": "Ashti S.O (Gadchiroli)",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "442709": {
    "state": "Maharashtra",
    "district": "Gadchiroli",
    "block": "Aheri",
    "officename": "Kamlapur S.O (Gadchiroli)",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "442710": {
    "state": "Maharashtra",
    "district": "Gadchiroli",
    "block": "Bhamragadh",
    "officename": "Bhamragadh S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "442901": {
    "state": "Maharashtra",
    "district": "Chandrapur",
    "block": "Ballarpur",
    "officename": "Ballarpur Paper Mill S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "442902": {
    "state": "Maharashtra",
    "district": "Chandrapur",
    "block": "Bhadrawati",
    "officename": "Bhadrawati S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "442903": {
    "state": "Maharashtra",
    "district": "Chandrapur",
    "block": "Chimur",
    "officename": "Chimur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "442904": {
    "state": "Maharashtra",
    "district": "Chandrapur",
    "block": "Chimur",
    "officename": "Neri S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "442905": {
    "state": "Maharashtra",
    "district": "Chandrapur",
    "block": "Rajura",
    "officename": "Rajura (M) S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "442906": {
    "state": "Maharashtra",
    "district": "Chandrapur",
    "block": "Chimur",
    "officename": "Segaon S.O (Chandrapur)",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "442907": {
    "state": "Maharashtra",
    "district": "Chandrapur",
    "block": "Warora",
    "officename": "Warora S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "442908": {
    "state": "Maharashtra",
    "district": "Chandrapur",
    "block": "Korphana",
    "officename": "Chandur S.O (Chandrapur)",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "442914": {
    "state": "Maharashtra",
    "district": "Chandrapur",
    "block": "Warora",
    "officename": "Anandwan S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "442916": {
    "state": "Maharashtra",
    "district": "Chandrapur",
    "block": "Korpana",
    "officename": "Korpana SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "442917": {
    "state": "Maharashtra",
    "district": "Chandrapur",
    "block": "Korphana",
    "officename": "Awalpur Cement Project S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "442918": {
    "state": "Maharashtra",
    "district": "Chandrapur",
    "block": "Mul",
    "officename": "Pombhurna S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "443001": {
    "state": "Maharashtra",
    "district": "Buldhana",
    "block": "Buldana",
    "officename": "Buldana H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Buldana Division"
  },
  "443002": {
    "state": "Maharashtra",
    "district": "Buldhana",
    "block": "Buldana",
    "officename": "Chaitanya Wadi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Buldana Division"
  },
  "443101": {
    "state": "Maharashtra",
    "district": "Buldhana",
    "block": "Motala",
    "officename": "Malkapur S.O (Buldhana)",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Buldana Division"
  },
  "443102": {
    "state": "Maharashtra",
    "district": "Buldhana",
    "block": "Malkapur",
    "officename": "Datala S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Buldana Division"
  },
  "443103": {
    "state": "Maharashtra",
    "district": "Buldhana",
    "block": "Motala",
    "officename": "Motala S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Buldana Division"
  },
  "443104": {
    "state": "Maharashtra",
    "district": "Buldhana",
    "block": "Motala",
    "officename": "Dhamangaon Badhe S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Buldana Division"
  },
  "443106": {
    "state": "Maharashtra",
    "district": "Buldhana",
    "block": "Buldana",
    "officename": "Dhad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Buldana Division"
  },
  "443112": {
    "state": "Maharashtra",
    "district": "Buldhana",
    "block": "Malkapur",
    "officename": "Dharangaon S.O (Buldhana)",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Buldana Division"
  },
  "443201": {
    "state": "Maharashtra",
    "district": "Buldhana",
    "block": "Deulgaon Raja",
    "officename": "Chikhli S.O (Buldhana)",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Buldana Division"
  },
  "443202": {
    "state": "Maharashtra",
    "district": "Buldhana",
    "block": "Lonar",
    "officename": "Sakhar Kherda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Buldana Division"
  },
  "443203": {
    "state": "Maharashtra",
    "district": "Buldhana",
    "block": "Sindkhed Raja",
    "officename": "Sindkhed Raja S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Buldana Division"
  },
  "443204": {
    "state": "Maharashtra",
    "district": "Buldhana",
    "block": "Deulgaon Raja",
    "officename": "Deulgaon Raja S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Buldana Division"
  },
  "443206": {
    "state": "Maharashtra",
    "district": "Buldhana",
    "block": "Deulgaon Raja",
    "officename": "Deulgaon Mahi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Buldana Division"
  },
  "443301": {
    "state": "Maharashtra",
    "district": "Buldhana",
    "block": "Mehkar",
    "officename": "Mehkar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Buldana Division"
  },
  "443302": {
    "state": "Maharashtra",
    "district": "Buldhana",
    "block": "Lonar",
    "officename": "Lonar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Buldana Division"
  },
  "443303": {
    "state": "Maharashtra",
    "district": "Buldhana",
    "block": "Mehkar",
    "officename": "Dongaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Buldana Division"
  },
  "443304": {
    "state": "Maharashtra",
    "district": "Buldhana",
    "block": "Mehkar",
    "officename": "Janephal S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Buldana Division"
  },
  "443308": {
    "state": "Maharashtra",
    "district": "Buldhana",
    "block": "Sindkhed Raja",
    "officename": "Dusarbid S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Buldana Division"
  },
  "443401": {
    "state": "Maharashtra",
    "district": "Buldhana",
    "block": "Nandura",
    "officename": "Chandur Biswa S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Buldana Division"
  },
  "443402": {
    "state": "Maharashtra",
    "district": "Buldhana",
    "block": "Jalgaon",
    "officename": "Jalgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Buldana Division"
  },
  "443403": {
    "state": "Maharashtra",
    "district": "Buldhana",
    "block": "Khamgaon",
    "officename": "Pimpalgaon Kale S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Buldana Division"
  },
  "443404": {
    "state": "Maharashtra",
    "district": "Buldhana",
    "block": "Nandura",
    "officename": "Nandura S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Buldana Division"
  },
  "444001": {
    "state": "Maharashtra",
    "district": "Akola",
    "block": "Akola",
    "officename": "Akola H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444002": {
    "state": "Maharashtra",
    "district": "Akola",
    "block": "Akola",
    "officename": "Akola City S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444003": {
    "state": "Maharashtra",
    "district": "Akola",
    "block": "Akola",
    "officename": "Shivaji Park Akola S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444004": {
    "state": "Maharashtra",
    "district": "Washim",
    "block": "Akola",
    "officename": "Gandhinagar Akola S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444005": {
    "state": "Maharashtra",
    "district": "Akola",
    "block": "Akola",
    "officename": "Jatharpeth Akola S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444006": {
    "state": "Maharashtra",
    "district": "Akola",
    "block": "Akola",
    "officename": "Tajnapeth Akola S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444101": {
    "state": "Maharashtra",
    "district": "Akola",
    "block": "Akola",
    "officename": "Akot S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444102": {
    "state": "Maharashtra",
    "district": "Akola",
    "block": "Akola",
    "officename": "Borgaon Manju S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444103": {
    "state": "Maharashtra",
    "district": "Akola",
    "block": "Akola",
    "officename": "Hiwarkhed Ruprao S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444104": {
    "state": "Maharashtra",
    "district": "Akola",
    "block": "Akola",
    "officename": "Krishinagar Akola S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444105": {
    "state": "Maharashtra",
    "district": "Washim",
    "block": "Washim",
    "officename": "Karanja S.O (Washim)",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444106": {
    "state": "Maharashtra",
    "district": "Akola",
    "block": "Akola",
    "officename": "Mana S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444107": {
    "state": "Maharashtra",
    "district": "Akola",
    "block": "Akola",
    "officename": "Murtizapur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444108": {
    "state": "Maharashtra",
    "district": "Akola",
    "block": "Akola",
    "officename": "Telhara S.O (Akola)",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444109": {
    "state": "Maharashtra",
    "district": "Akola",
    "block": "Akola",
    "officename": "Vidyutnagar Paras S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444110": {
    "state": "Maharashtra",
    "district": "Washim",
    "block": "Akola",
    "officename": "Kamargaon S.O (Washim)",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444111": {
    "state": "Maharashtra",
    "district": "Akola",
    "block": "Akola",
    "officename": "Dahihanda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444117": {
    "state": "Maharashtra",
    "district": "Akola",
    "block": "Akola",
    "officename": "Mundgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444126": {
    "state": "Maharashtra",
    "district": "Akola",
    "block": "Akot",
    "officename": "Adgaon Bk S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444201": {
    "state": "Maharashtra",
    "district": "Buldhana",
    "block": "Sangrampur",
    "officename": "Paturda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Buldana Division"
  },
  "444202": {
    "state": "Maharashtra",
    "district": "Buldhana",
    "block": "Sangrampur",
    "officename": "Sangrampur S.O (Buldhana)",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Buldana Division"
  },
  "444203": {
    "state": "Maharashtra",
    "district": "Buldhana",
    "block": "Shegaon",
    "officename": "Shegaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Buldana Division"
  },
  "444204": {
    "state": "Maharashtra",
    "district": "Buldhana",
    "block": "Sonala",
    "officename": "Sonala S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Buldana Division"
  },
  "444301": {
    "state": "Maharashtra",
    "district": "Buldhana",
    "block": "Chikhli",
    "officename": "Amdapur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Buldana Division"
  },
  "444302": {
    "state": "Maharashtra",
    "district": "Akola",
    "block": "Akola",
    "officename": "Balapur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444303": {
    "state": "Maharashtra",
    "district": "Buldhana",
    "block": "Khamgaon",
    "officename": "Khamgaon H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Buldana Division"
  },
  "444304": {
    "state": "Maharashtra",
    "district": "Buldhana",
    "block": "Shegaon",
    "officename": "Matergaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Buldana Division"
  },
  "444306": {
    "state": "Maharashtra",
    "district": "Buldhana",
    "block": "Khamgoan",
    "officename": "Pimpalgaon Raja S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Buldana Division"
  },
  "444311": {
    "state": "Maharashtra",
    "district": "Akola",
    "block": "Akola",
    "officename": "Nimba S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444312": {
    "state": "Maharashtra",
    "district": "Buldhana",
    "block": "Shegaon",
    "officename": "G.S.College Khamgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Buldana Division"
  },
  "444401": {
    "state": "Maharashtra",
    "district": "Akola",
    "block": "Akola",
    "officename": "Barshitakli S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444402": {
    "state": "Maharashtra",
    "district": "Akola",
    "block": "Akola",
    "officename": "Shelubazar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444403": {
    "state": "Maharashtra",
    "district": "Washim",
    "block": "Mangrulpir",
    "officename": "Mangrulpir S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444404": {
    "state": "Maharashtra",
    "district": "Washim",
    "block": "Mangrulpir",
    "officename": "Manora S.O (Washim)",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444405": {
    "state": "Maharashtra",
    "district": "Akola",
    "block": "Akola",
    "officename": "Mahan S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444407": {
    "state": "Maharashtra",
    "district": "Akola",
    "block": "Akola",
    "officename": "Pinjar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444409": {
    "state": "Maharashtra",
    "district": "Washim",
    "block": "Akola",
    "officename": "Asegaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444501": {
    "state": "Maharashtra",
    "district": "Akola",
    "block": "Akola",
    "officename": "Patur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444502": {
    "state": "Maharashtra",
    "district": "Akola",
    "block": "Akola",
    "officename": "Vadegaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444503": {
    "state": "Maharashtra",
    "district": "Washim",
    "block": "Washim",
    "officename": "Malegaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444504": {
    "state": "Maharashtra",
    "district": "Washim",
    "block": "Washim",
    "officename": "Shirpur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444505": {
    "state": "Maharashtra",
    "district": "Washim",
    "block": "Washim",
    "officename": "Washim S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444506": {
    "state": "Maharashtra",
    "district": "Akola",
    "block": "Akola",
    "officename": "Risod S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444507": {
    "state": "Maharashtra",
    "district": "Washim",
    "block": "Washim",
    "officename": "Ansing S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444510": {
    "state": "Maharashtra",
    "district": "Washim",
    "block": "Washim",
    "officename": "Rithad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444511": {
    "state": "Maharashtra",
    "district": "Akola",
    "block": "Akola",
    "officename": "Alegaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444601": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Amravati",
    "officename": "Amravati H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444602": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Amravati",
    "officename": "Amravati Camp S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444603": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Amravati",
    "officename": "Shivaji Nagar S.O (Amravati)",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444604": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Amravati",
    "officename": "V.M.V. (Amravati) S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444605": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Amravati",
    "officename": "H. V. Nagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444606": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Amravati",
    "officename": "Rukhmini Nagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444607": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Amravati",
    "officename": "Sai Nagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444701": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Amravati",
    "officename": "Badnera S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444702": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Amravati",
    "officename": "Dharni S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444704": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Chandur Bazar",
    "officename": "Chandur Bazar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444705": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Amravati",
    "officename": "Anjangaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444706": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Daryapur",
    "officename": "Yeoda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444707": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Amravati",
    "officename": "Nerpingalai S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444708": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Amravati",
    "officename": "Nandgaon Khandeshwar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444709": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Amravati",
    "officename": "Dhamangaon R.S. S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444710": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Amravati",
    "officename": "Talegaon Dashasar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444711": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Amravati",
    "officename": "Mangrul Dastgir S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444717": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Amravati",
    "officename": "Dhamangaon Gadhi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444719": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Amravati",
    "officename": "Kalamkhar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444720": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Chandur Bazar",
    "officename": "Brahmanwada Thadi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444723": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Amravati",
    "officename": "Sirajgaon Band S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444801": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Amravati",
    "officename": "Walgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444802": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Amravati",
    "officename": "Kholapur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444803": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Daryapur",
    "officename": "Daryapur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444804": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Amravati",
    "officename": "Purna Nagar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444805": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Paratwada",
    "officename": "Paratwada H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444806": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Achalpur City",
    "officename": "Achalpur City S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444807": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Chikhaldara",
    "officename": "Chikhaldara S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444808": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Amravati",
    "officename": "Pathrot S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444809": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Chandur Bazar",
    "officename": "Karajgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444810": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Chandur Bazar",
    "officename": "Sirasgaon Kasba S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444813": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Amravati",
    "officename": "Semadoh S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444901": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Amravati",
    "officename": "Nandgaon Peth S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444902": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Teosa",
    "officename": "Gurukunj Ashram S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444903": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Amravati",
    "officename": "Tiosa S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444904": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Chandur Raiway",
    "officename": "Chandur Railway S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444905": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Amravati",
    "officename": "Morshi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444906": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Amravati",
    "officename": "Warud S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444907": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Amravati",
    "officename": "Shendurjana Ghat S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "444908": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Amravati",
    "officename": "Jarud S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "445001": {
    "state": "Maharashtra",
    "district": "Yavatmal",
    "block": "Yavatmal",
    "officename": "Yavatmal H.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Yeotmal Division"
  },
  "445002": {
    "state": "Maharashtra",
    "district": "Yavatmal",
    "block": "Yavatmal",
    "officename": "Zillla Parishad (Yavatmal) S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Yeotmal Division"
  },
  "445101": {
    "state": "Maharashtra",
    "district": "Yavatmal",
    "block": "Kalamb",
    "officename": "Babhulgaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Yeotmal Division"
  },
  "445102": {
    "state": "Maharashtra",
    "district": "Yavatmal",
    "block": "Ner Persopant",
    "officename": "Ner Parsopant S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Yeotmal Division"
  },
  "445103": {
    "state": "Maharashtra",
    "district": "Yavatmal",
    "block": "Arni",
    "officename": "Arni S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Yeotmal Division"
  },
  "445105": {
    "state": "Maharashtra",
    "district": "Yavatmal",
    "block": "Yavatmal",
    "officename": "Jawala S.O (Yavatmal)",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Yeotmal Division"
  },
  "445106": {
    "state": "Maharashtra",
    "district": "Yavatmal",
    "block": "Arni",
    "officename": "Sawali Sadoba S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Yeotmal Division"
  },
  "445109": {
    "state": "Maharashtra",
    "district": "Yavatmal",
    "block": "Ghatanji",
    "officename": "Akola Bazar S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Yeotmal Division"
  },
  "445110": {
    "state": "Maharashtra",
    "district": "Yavatmal",
    "block": "Digras",
    "officename": "Mahagaon Kasba S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Yeotmal Division"
  },
  "445201": {
    "state": "Maharashtra",
    "district": "Yavatmal",
    "block": "Ner Parsopant",
    "officename": "Bori Arab S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Yeotmal Division"
  },
  "445202": {
    "state": "Maharashtra",
    "district": "Yavatmal",
    "block": "Darwha",
    "officename": "Darwha S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Yeotmal Division"
  },
  "445203": {
    "state": "Maharashtra",
    "district": "Yavatmal",
    "block": "Digras",
    "officename": "Digras S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Yeotmal Division"
  },
  "445204": {
    "state": "Maharashtra",
    "district": "Yavatmal",
    "block": "Pusad",
    "officename": "Pusad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Yeotmal Division"
  },
  "445205": {
    "state": "Maharashtra",
    "district": "Yavatmal",
    "block": "Mahagaon",
    "officename": "Mahagaon (Yavatmal) S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Yeotmal Division"
  },
  "445206": {
    "state": "Maharashtra",
    "district": "Yavatmal",
    "block": "Umerkhed",
    "officename": "Umarkhed S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Yeotmal Division"
  },
  "445207": {
    "state": "Maharashtra",
    "district": "Yavatmal",
    "block": "Umarkhed",
    "officename": "Dhanki S.O (Yavatmal)",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Yeotmal Division"
  },
  "445209": {
    "state": "Maharashtra",
    "district": "Yavatmal",
    "block": "Pusad",
    "officename": "Issapur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Yeotmal Division"
  },
  "445210": {
    "state": "Maharashtra",
    "district": "Yavatmal",
    "block": "Ner Parsopant",
    "officename": "Lohi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Yeotmal Division"
  },
  "445211": {
    "state": "Maharashtra",
    "district": "Yavatmal",
    "block": "Umerkhed",
    "officename": "Mulawa S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Yeotmal Division"
  },
  "445215": {
    "state": "Maharashtra",
    "district": "Yavatmal",
    "block": "Pusad",
    "officename": "Soot Girni S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Yeotmal Division"
  },
  "445216": {
    "state": "Maharashtra",
    "district": "Yavatmal",
    "block": "Pusad",
    "officename": "P.N.C. Pusad S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Yeotmal Division"
  },
  "445230": {
    "state": "Maharashtra",
    "district": "Yavatmal",
    "block": "Umarkhed",
    "officename": "Fulsavangi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Yeotmal Division"
  },
  "445301": {
    "state": "Maharashtra",
    "district": "Yavatmal",
    "block": "Yavatmal",
    "officename": "Ghatanji S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Yeotmal Division"
  },
  "445302": {
    "state": "Maharashtra",
    "district": "Yavatmal",
    "block": "Kalapur",
    "officename": "Pandharkawda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Yeotmal Division"
  },
  "445303": {
    "state": "Maharashtra",
    "district": "Yavatmal",
    "block": "Maregaon",
    "officename": "Maregaon Road S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Yeotmal Division"
  },
  "445304": {
    "state": "Maharashtra",
    "district": "Yavatmal",
    "block": "Zari Jamni",
    "officename": "Wani S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Yeotmal Division"
  },
  "445305": {
    "state": "Maharashtra",
    "district": "Yavatmal",
    "block": "Ghatanji",
    "officename": "Patanbori S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Yeotmal Division"
  },
  "445306": {
    "state": "Maharashtra",
    "district": "Yavatmal",
    "block": "Ghatanji",
    "officename": "Parwa S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Yeotmal Division"
  },
  "445307": {
    "state": "Maharashtra",
    "district": "Yavatmal",
    "block": "Wani",
    "officename": "Sindhola Mines S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Yeotmal Division"
  },
  "445308": {
    "state": "Maharashtra",
    "district": "Yavatmal",
    "block": "Ralegaon",
    "officename": "Wadki S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Yeotmal Division"
  },
  "445323": {
    "state": "Maharashtra",
    "district": "Yavatmal",
    "block": "Kelapur",
    "officename": "Mohda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Yeotmal Division"
  },
  "445401": {
    "state": "Maharashtra",
    "district": "Yavatmal",
    "block": "Kalamb",
    "officename": "Kalamb S.O (Yavatmal)",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Yeotmal Division"
  },
  "445402": {
    "state": "Maharashtra",
    "district": "Yavatmal",
    "block": "Ralegaon",
    "officename": "Ralegaon S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Yeotmal Division"
  },
  "450001": {
    "state": "Madhya Pradesh",
    "district": "East Nimar",
    "block": "Khandwa",
    "officename": "Khandwa H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "450051": {
    "state": "Madhya Pradesh",
    "district": "East Nimar",
    "block": "Khandwa",
    "officename": "Kharkalan S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "450110": {
    "state": "Madhya Pradesh",
    "district": "East Nimar",
    "block": "Harsud",
    "officename": "Bir S.O (East Nimar)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "450112": {
    "state": "Madhya Pradesh",
    "district": "East Nimar",
    "block": "Khandwa",
    "officename": "Mundi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "450114": {
    "state": "Madhya Pradesh",
    "district": "East Nimar",
    "block": "Khandwa",
    "officename": "Punasa S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "450116": {
    "state": "Madhya Pradesh",
    "district": "East Nimar",
    "block": "Harsud",
    "officename": "Naya Harsud S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "450117": {
    "state": "Madhya Pradesh",
    "district": "Khandwa",
    "block": "Harsud",
    "officename": "Khalwa S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "450119": {
    "state": "Madhya Pradesh",
    "district": "East Nimar",
    "block": "Khandwa",
    "officename": "Narmada Nagar S.O (East Nimar)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "450221": {
    "state": "Madhya Pradesh",
    "district": "Burhanpur",
    "block": "Nepanagar",
    "officename": "Nepanagar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "450331": {
    "state": "Madhya Pradesh",
    "district": "East Nimar",
    "block": "Nepanagar",
    "officename": "Burhanpur S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "450332": {
    "state": "Madhya Pradesh",
    "district": "East Nimar",
    "block": "Khaknar",
    "officename": "Khaknar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "450337": {
    "state": "Madhya Pradesh",
    "district": "East Nimar",
    "block": "Pandhana",
    "officename": "Rustampur S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "450445": {
    "state": "Madhya Pradesh",
    "district": "Burhanpur",
    "block": "Burhanpur",
    "officename": "Shahpur (Nimar) S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "450551": {
    "state": "Madhya Pradesh",
    "district": "East Nimar",
    "block": "Khandwa",
    "officename": "Nimarkhedi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "450554": {
    "state": "Madhya Pradesh",
    "district": "West Nimar",
    "block": "Khandwa",
    "officename": "Mandhata Omkareshwar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "450661": {
    "state": "Madhya Pradesh",
    "district": "East Nimar",
    "block": "Pandhana",
    "officename": "Pandhana S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "450771": {
    "state": "Madhya Pradesh",
    "district": "East Nimar",
    "block": "Khandwa",
    "officename": "Chhegaon Makhan S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "450881": {
    "state": "Madhya Pradesh",
    "district": "East Nimar",
    "block": "Khandwa",
    "officename": "Jaswadi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "450991": {
    "state": "Madhya Pradesh",
    "district": "East Nimar",
    "block": "Khandwa",
    "officename": "Jawar S.O (East Nimar)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "451001": {
    "state": "Madhya Pradesh",
    "district": "West Nimar",
    "block": "Khargone",
    "officename": "Khargone H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "451111": {
    "state": "Madhya Pradesh",
    "district": "West Nimar",
    "block": "Barwaha",
    "officename": "Sanawad S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "451113": {
    "state": "Madhya Pradesh",
    "district": "West Nimar",
    "block": "Bhikangaon",
    "officename": "Bedia S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "451115": {
    "state": "Madhya Pradesh",
    "district": "West Nimar",
    "block": "Barwaha",
    "officename": "Barwaha S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "451220": {
    "state": "Madhya Pradesh",
    "district": "West Nimar",
    "block": "Barwaha",
    "officename": "Karhi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "451221": {
    "state": "Madhya Pradesh",
    "district": "West Nimar",
    "block": "Maheshwar",
    "officename": "Mandleshwar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "451224": {
    "state": "Madhya Pradesh",
    "district": "West Nimar",
    "block": "Maheshwar",
    "officename": "Maheshwar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "451225": {
    "state": "Madhya Pradesh",
    "district": "West Nimar",
    "block": "Maheshwar",
    "officename": "Piplya Buzurg S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "451228": {
    "state": "Madhya Pradesh",
    "district": "West Nimar",
    "block": "Kasrawad",
    "officename": "Kasrawad S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "451331": {
    "state": "Madhya Pradesh",
    "district": "West Nimar",
    "block": "Bhikangaon",
    "officename": "Bhikangaon S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "451332": {
    "state": "Madhya Pradesh",
    "district": "West Nimar",
    "block": "Jhiranya",
    "officename": "Jhirnia S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "451335": {
    "state": "Madhya Pradesh",
    "district": "West Nimar",
    "block": "Bhikangaon",
    "officename": "Gogawa S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "451440": {
    "state": "Madhya Pradesh",
    "district": "West Nimar",
    "block": "Segaon",
    "officename": "Un S.O (West Nimar)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "451441": {
    "state": "Madhya Pradesh",
    "district": "East Nimar",
    "block": "Bhagwanpura",
    "officename": "Bistan S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "451442": {
    "state": "Madhya Pradesh",
    "district": "Barwani",
    "block": "Rajpur",
    "officename": "Segaon S.O (West Nimar)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "451447": {
    "state": "Madhya Pradesh",
    "district": "Barwani",
    "block": "Thikari",
    "officename": "Rajpur Barwani S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "451449": {
    "state": "Madhya Pradesh",
    "district": "Barwani",
    "block": "Thikari",
    "officename": "Julwania S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "451551": {
    "state": "Madhya Pradesh",
    "district": "Barwani",
    "block": "Barwani",
    "officename": "Barwani S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "451556": {
    "state": "Madhya Pradesh",
    "district": "Barwani",
    "block": "Anjad",
    "officename": "Anjad S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "451660": {
    "state": "Madhya Pradesh",
    "district": "West Nimar",
    "block": "Kasrawad",
    "officename": "Thikari S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "451666": {
    "state": "Madhya Pradesh",
    "district": "Barwani",
    "block": "Sendhwa",
    "officename": "Sendhwa S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "451770": {
    "state": "Madhya Pradesh",
    "district": "Barwani",
    "block": "Pansemal",
    "officename": "Pansemal S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "451881": {
    "state": "Madhya Pradesh",
    "district": "Barwani",
    "block": "Pansemal",
    "officename": "Khetia S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "452001": {
    "state": "Madhya Pradesh",
    "district": "Indore",
    "block": "Indore",
    "officename": "Indore G.P.O.",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore City Division"
  },
  "452002": {
    "state": "Madhya Pradesh",
    "district": "Indore",
    "block": "Indore",
    "officename": "Indore City 2 S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore City Division"
  },
  "452003": {
    "state": "Madhya Pradesh",
    "district": "Indore",
    "block": "Indore",
    "officename": "Vallabhnagar S.O (Indore)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore City Division"
  },
  "452005": {
    "state": "Madhya Pradesh",
    "district": "Indore",
    "block": "Indore",
    "officename": "Bijasan Road S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore City Division"
  },
  "452006": {
    "state": "Madhya Pradesh",
    "district": "Indore",
    "block": "Indore",
    "officename": "Army Head Quarter S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore City Division"
  },
  "452007": {
    "state": "Madhya Pradesh",
    "district": "Indore",
    "block": "Indore",
    "officename": "Indore Nagar H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore City Division"
  },
  "452009": {
    "state": "Madhya Pradesh",
    "district": "Indore",
    "block": "Indore",
    "officename": "Sudama Nagar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore City Division"
  },
  "452010": {
    "state": "Madhya Pradesh",
    "district": "Indore",
    "block": "Indore",
    "officename": "Vijay Nagar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore City Division"
  },
  "452011": {
    "state": "Madhya Pradesh",
    "district": "Indore",
    "block": "Indore",
    "officename": "Nanda Nagar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore City Division"
  },
  "452012": {
    "state": "Madhya Pradesh",
    "district": "Indore",
    "block": "Indore",
    "officename": "Rajendra Nagar S.O (Indore)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore City Division"
  },
  "452013": {
    "state": "Madhya Pradesh",
    "district": "Indore",
    "block": "Indore",
    "officename": "Indore Cat S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore City Division"
  },
  "452014": {
    "state": "Madhya Pradesh",
    "district": "Indore",
    "block": "Indore",
    "officename": "Khatiwala Tank S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore City Division"
  },
  "452015": {
    "state": "Madhya Pradesh",
    "district": "Indore",
    "block": "Indore",
    "officename": "Industrial Estate S.O (Indore)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore City Division"
  },
  "452016": {
    "state": "Madhya Pradesh",
    "district": "Indore",
    "block": "Indore",
    "officename": "Indore Kanadia Road S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore City Division"
  },
  "452018": {
    "state": "Madhya Pradesh",
    "district": "Indore",
    "block": "Indore",
    "officename": "Indore Tillaknagar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore City Division"
  },
  "452020": {
    "state": "Madhya Pradesh",
    "district": "Indore",
    "block": "Indore",
    "officename": "Kasturbagram S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "453001": {
    "state": "Madhya Pradesh",
    "district": "Indore",
    "block": "Depalpur",
    "officename": "Betma S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "453111": {
    "state": "Madhya Pradesh",
    "district": "Indore",
    "block": "Depalpur",
    "officename": "Hatod S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "453112": {
    "state": "Madhya Pradesh",
    "district": "Indore",
    "block": "Depalpur",
    "officename": "Gandhinagar S.O (Indore)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "453115": {
    "state": "Madhya Pradesh",
    "district": "Indore",
    "block": "Depalpur",
    "officename": "Depalpur S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "453220": {
    "state": "Madhya Pradesh",
    "district": "Indore",
    "block": "Depalpur",
    "officename": "Gautampura S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "453331": {
    "state": "Madhya Pradesh",
    "district": "Indore",
    "block": "Mhow",
    "officename": "Rao S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "453441": {
    "state": "Madhya Pradesh",
    "district": "Indore",
    "block": "Mhow",
    "officename": "Mhow S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "453446": {
    "state": "Madhya Pradesh",
    "district": "Indore",
    "block": "Mhow",
    "officename": "Rasalpura S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "453551": {
    "state": "Madhya Pradesh",
    "district": "Indore",
    "block": "Sanwer",
    "officename": "Sanwer S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "453555": {
    "state": "Madhya Pradesh",
    "district": "Indore",
    "block": "Sanwer",
    "officename": "Shri Aurobindo S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "453556": {
    "state": "Madhya Pradesh",
    "district": "Indore",
    "block": "Indore",
    "officename": "IIM CAMPUS RAO S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "453661": {
    "state": "Madhya Pradesh",
    "district": "Indore",
    "block": "Mhow",
    "officename": "Manpur S.O (Indore)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "453771": {
    "state": "Madhya Pradesh",
    "district": "Indore",
    "block": "Indore",
    "officename": "Manglia S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "454001": {
    "state": "Madhya Pradesh",
    "district": "Dhar",
    "block": "Dhar",
    "officename": "Dhar H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "454010": {
    "state": "Madhya Pradesh",
    "district": "Dhar",
    "block": "Dhar",
    "officename": "Mandu S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "454111": {
    "state": "Madhya Pradesh",
    "district": "Dhar",
    "block": "Sardarpur",
    "officename": "Sardarpur S.O (Dhar)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "454116": {
    "state": "Madhya Pradesh",
    "district": "Dhar",
    "block": "Sardarpur",
    "officename": "Rajgarh (Dhar) S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "454221": {
    "state": "Madhya Pradesh",
    "district": "Dhar",
    "block": "Kukshai",
    "officename": "Bagh S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "454331": {
    "state": "Madhya Pradesh",
    "district": "Dhar",
    "block": "Kukshi",
    "officename": "Kukshi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "454335": {
    "state": "Madhya Pradesh",
    "district": "Dhar",
    "block": "Kukshi",
    "officename": "Nisarpur S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "454441": {
    "state": "Madhya Pradesh",
    "district": "Dhar",
    "block": "Sardarpur",
    "officename": "Amjhera S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "454446": {
    "state": "Madhya Pradesh",
    "district": "Dhar",
    "block": "Manawar",
    "officename": "Manawar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "454449": {
    "state": "Madhya Pradesh",
    "district": "Dhar",
    "block": "Dharampuri",
    "officename": "Dharampuri S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "454552": {
    "state": "Madhya Pradesh",
    "district": "Dhar",
    "block": "Dharampuri",
    "officename": "Dhamnod S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "454660": {
    "state": "Madhya Pradesh",
    "district": "Dhar",
    "block": "Badnawar",
    "officename": "Badnawar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "454665": {
    "state": "Madhya Pradesh",
    "district": "Dhar",
    "block": "Badnawar",
    "officename": "Kanwan S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "454773": {
    "state": "Madhya Pradesh",
    "district": "Dhar",
    "block": "Dhar",
    "officename": "Dehri Ghata Billod S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "454774": {
    "state": "Madhya Pradesh",
    "district": "Dhar",
    "block": "Dhar",
    "officename": "Pithampur Sector III S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "454775": {
    "state": "Madhya Pradesh",
    "district": "Dhar",
    "block": "Dhar",
    "officename": "Pithampur S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "455001": {
    "state": "Madhya Pradesh",
    "district": "Dewas",
    "block": "Dewas",
    "officename": "Dewas H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "455111": {
    "state": "Madhya Pradesh",
    "district": "Dewas",
    "block": "Dewas",
    "officename": "Balgarh S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "455115": {
    "state": "Madhya Pradesh",
    "district": "Dewas",
    "block": "Bagli",
    "officename": "Bhonrasa S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "455116": {
    "state": "Madhya Pradesh",
    "district": "Dewas",
    "block": "Sonkutch",
    "officename": "Tonkhurd S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "455118": {
    "state": "Madhya Pradesh",
    "district": "Dewas",
    "block": "Sonkutch",
    "officename": "Sonkutch S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "455221": {
    "state": "Madhya Pradesh",
    "district": "Dewas",
    "block": "Bagli",
    "officename": "Karnawad S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "455223": {
    "state": "Madhya Pradesh",
    "district": "Dewas",
    "block": "Bagli",
    "officename": "Hatpipliya S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "455227": {
    "state": "Madhya Pradesh",
    "district": "Dewas",
    "block": "Bagli",
    "officename": "Bagli S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "455332": {
    "state": "Madhya Pradesh",
    "district": "Dewas",
    "block": "Kannod",
    "officename": "Kannod S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "455336": {
    "state": "Madhya Pradesh",
    "district": "Dewas",
    "block": "Khategaon",
    "officename": "Khategaon S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "455339": {
    "state": "Madhya Pradesh",
    "district": "Dewas",
    "block": "Khategaon",
    "officename": "Nemawar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "455440": {
    "state": "Madhya Pradesh",
    "district": "Dewas",
    "block": "Kannod",
    "officename": "Kantaphod S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "455459": {
    "state": "Madhya Pradesh",
    "district": "Dewas",
    "block": "Kannod",
    "officename": "Satwas S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "456001": {
    "state": "Madhya Pradesh",
    "district": "Ujjain",
    "block": "Ujjain",
    "officename": "Ujjain H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "456003": {
    "state": "Madhya Pradesh",
    "district": "Ujjain",
    "block": "Ghatiya",
    "officename": "Ujjain  Bherugarh S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "456006": {
    "state": "Madhya Pradesh",
    "district": "Ujjain",
    "block": "Ghatiya",
    "officename": "Ujjain  City S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "456010": {
    "state": "Madhya Pradesh",
    "district": "Ujjain",
    "block": "Ujjain",
    "officename": "Ujjain  M.L.Nagar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "456221": {
    "state": "Madhya Pradesh",
    "district": "Ujjain",
    "block": "Nagda",
    "officename": "Unhel S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "456222": {
    "state": "Madhya Pradesh",
    "district": "Ujjain",
    "block": "Barnagar",
    "officename": "Baledi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "456224": {
    "state": "Madhya Pradesh",
    "district": "Ujjain",
    "block": "Khacharod",
    "officename": "Khachraud S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "456313": {
    "state": "Madhya Pradesh",
    "district": "Ujjain",
    "block": "Bhatpachlana",
    "officename": "Bhatpachlana S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "456331": {
    "state": "Madhya Pradesh",
    "district": "Ujjain",
    "block": "Khachraud",
    "officename": "Birlagram  Nagda S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "456335": {
    "state": "Madhya Pradesh",
    "district": "Ujjain",
    "block": "Khachraud",
    "officename": "Nagda S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "456337": {
    "state": "Madhya Pradesh",
    "district": "Ujjain",
    "block": "Badnagar",
    "officename": "Piploda  Baghla S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "456440": {
    "state": "Madhya Pradesh",
    "district": "Ujjain",
    "block": "Mahidpur",
    "officename": "Mehidpur  Road S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "456441": {
    "state": "Madhya Pradesh",
    "district": "Ujjain",
    "block": "Mehidpur",
    "officename": "Jharda S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "456443": {
    "state": "Madhya Pradesh",
    "district": "Ujjain",
    "block": "Mahidpur",
    "officename": "Mehidpur S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "456550": {
    "state": "Madhya Pradesh",
    "district": "Ujjain",
    "block": "Ghatiya",
    "officename": "Ghattia S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "456661": {
    "state": "Madhya Pradesh",
    "district": "Ujjain",
    "block": "Ujjain",
    "officename": "Tajpur S.O (Ujjain)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "456664": {
    "state": "Madhya Pradesh",
    "district": "Ujjain",
    "block": "Ujjain",
    "officename": "Narwar S.O (Ujjain)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "456665": {
    "state": "Madhya Pradesh",
    "district": "Ujjain",
    "block": "Tarana",
    "officename": "Tarana S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "456668": {
    "state": "Madhya Pradesh",
    "district": "Ujjain",
    "block": "Tarana",
    "officename": "Makdone S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "456770": {
    "state": "Madhya Pradesh",
    "district": "Ujjain",
    "block": "Tarana",
    "officename": "Kanasia S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "456771": {
    "state": "Madhya Pradesh",
    "district": "Ujjain",
    "block": "Badnagar",
    "officename": "Barnagar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "456776": {
    "state": "Madhya Pradesh",
    "district": "Ujjain",
    "block": "Badnagar",
    "officename": "Runija S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "457001": {
    "state": "Madhya Pradesh",
    "district": "Ratlam",
    "block": "Ratlam",
    "officename": "Ratlam H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ratlam Division"
  },
  "457114": {
    "state": "Madhya Pradesh",
    "district": "Ratlam",
    "block": "Alot",
    "officename": "Alote S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ratlam Division"
  },
  "457118": {
    "state": "Madhya Pradesh",
    "district": "Ratlam",
    "block": "Ratlam",
    "officename": "Tal S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ratlam Division"
  },
  "457119": {
    "state": "Madhya Pradesh",
    "district": "Ratlam",
    "block": "Alote",
    "officename": "Kharwa kalan S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ratlam Division"
  },
  "457222": {
    "state": "Madhya Pradesh",
    "district": "Ratlam",
    "block": "Ratlam",
    "officename": "Namli S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ratlam Division"
  },
  "457226": {
    "state": "Madhya Pradesh",
    "district": "Ratlam",
    "block": "Jaora",
    "officename": "Jaora S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ratlam Division"
  },
  "457331": {
    "state": "Madhya Pradesh",
    "district": "Ratlam",
    "block": "Piploda",
    "officename": "Piploda S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ratlam Division"
  },
  "457333": {
    "state": "Madhya Pradesh",
    "district": "Ratlam",
    "block": "Piploda",
    "officename": "Sukheda S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ratlam Division"
  },
  "457336": {
    "state": "Madhya Pradesh",
    "district": "Ratlam",
    "block": "Ratlam",
    "officename": "Ringnod S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ratlam Division"
  },
  "457339": {
    "state": "Madhya Pradesh",
    "district": "Ratlam",
    "block": "Piploda",
    "officename": "Dhodhar RS S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ratlam Division"
  },
  "457340": {
    "state": "Madhya Pradesh",
    "district": "Ratlam",
    "block": "Ratlam",
    "officename": "KALUKHEDA S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ratlam Division"
  },
  "457441": {
    "state": "Madhya Pradesh",
    "district": "Ratlam",
    "block": "Ratlam",
    "officename": "Bilpank S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ratlam Division"
  },
  "457550": {
    "state": "Madhya Pradesh",
    "district": "Jhabua",
    "block": "Jhabua",
    "officename": "Sailana S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ratlam Division"
  },
  "457555": {
    "state": "Madhya Pradesh",
    "district": "Ratlam",
    "block": "Ratlam",
    "officename": "Bajna S.O (Ratlam)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ratlam Division"
  },
  "457661": {
    "state": "Madhya Pradesh",
    "district": "Jhabua",
    "block": "Jhabua",
    "officename": "Jhabua H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ratlam Division"
  },
  "457770": {
    "state": "Madhya Pradesh",
    "district": "Jhabua",
    "block": "Jhabua",
    "officename": "Bamnia S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ratlam Division"
  },
  "457772": {
    "state": "Madhya Pradesh",
    "district": "Jhabua",
    "block": "Jhabua",
    "officename": "Khawasa S.O (Jhabua)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ratlam Division"
  },
  "457773": {
    "state": "Madhya Pradesh",
    "district": "Jhabua",
    "block": "Jhabua",
    "officename": "Petlawad S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ratlam Division"
  },
  "457775": {
    "state": "Madhya Pradesh",
    "district": "Jhabua",
    "block": "Jhabua",
    "officename": "Raipuria S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ratlam Division"
  },
  "457777": {
    "state": "Madhya Pradesh",
    "district": "Jhabua",
    "block": "Thandla",
    "officename": "Thandla S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ratlam Division"
  },
  "457779": {
    "state": "Madhya Pradesh",
    "district": "Jhabua",
    "block": "Meghnagar",
    "officename": "Meghnagar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ratlam Division"
  },
  "457882": {
    "state": "Madhya Pradesh",
    "district": "Jhabua",
    "block": "Jhabua",
    "officename": "Chandra Shekhar Azad Nagar",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ratlam Division"
  },
  "457885": {
    "state": "Madhya Pradesh",
    "district": "Jhabua",
    "block": "Jhabua",
    "officename": "Katthiwada S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ratlam Division"
  },
  "457887": {
    "state": "Madhya Pradesh",
    "district": "Jhabua",
    "block": "Jhabua",
    "officename": "Alirajpur S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ratlam Division"
  },
  "457888": {
    "state": "Madhya Pradesh",
    "district": "Jhabua",
    "block": "Jhabua",
    "officename": "Sondwa S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ratlam Division"
  },
  "457990": {
    "state": "Madhya Pradesh",
    "district": "Jhabua",
    "block": "Jhabua",
    "officename": "Jobat S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ratlam Division"
  },
  "457993": {
    "state": "Madhya Pradesh",
    "district": "Jhabua",
    "block": "Ranapur",
    "officename": "Ranapur S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ratlam Division"
  },
  "458001": {
    "state": "Madhya Pradesh",
    "district": "Mandsaur",
    "block": "Mandsaur",
    "officename": "Mandsaur H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Mandsaur Division"
  },
  "458002": {
    "state": "Madhya Pradesh",
    "district": "Mandsaur",
    "block": "Mandsaur",
    "officename": "Mandsaur City S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Mandsaur Division"
  },
  "458110": {
    "state": "Madhya Pradesh",
    "district": "Neemuch",
    "block": "Manasa",
    "officename": "Manasa S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Mandsaur Division"
  },
  "458113": {
    "state": "Madhya Pradesh",
    "district": "Neemuch",
    "block": "Manasa",
    "officename": "Mahagarh S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Mandsaur Division"
  },
  "458116": {
    "state": "Madhya Pradesh",
    "district": "Neemuch",
    "block": "Manasa",
    "officename": "Kukdeshwar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Mandsaur Division"
  },
  "458118": {
    "state": "Madhya Pradesh",
    "district": "Neemuch",
    "block": "Manasa",
    "officename": "Rampura S.O (Neemuch)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Mandsaur Division"
  },
  "458220": {
    "state": "Madhya Pradesh",
    "district": "Neemuch",
    "block": "Jawad",
    "officename": "Sarwania Maharaj S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Mandsaur Division"
  },
  "458226": {
    "state": "Madhya Pradesh",
    "district": "Neemuch",
    "block": "Jawad",
    "officename": "Ratangarh S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Mandsaur Division"
  },
  "458228": {
    "state": "Madhya Pradesh",
    "district": "Neemuch",
    "block": "Jawad",
    "officename": "Singoli S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Mandsaur Division"
  },
  "458330": {
    "state": "Madhya Pradesh",
    "district": "Neemuch",
    "block": "Jawad",
    "officename": "Jawad S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Mandsaur Division"
  },
  "458336": {
    "state": "Madhya Pradesh",
    "district": "Neemuch",
    "block": "Neemuch",
    "officename": "Jeeran S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Mandsaur Division"
  },
  "458339": {
    "state": "Madhya Pradesh",
    "district": "Mandsaur",
    "block": "Malhargarh",
    "officename": "Malhargarh S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Mandsaur Division"
  },
  "458389": {
    "state": "Madhya Pradesh",
    "district": "Mandsaur",
    "block": "Sitamau",
    "officename": "Laduna S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Mandsaur Division"
  },
  "458441": {
    "state": "Madhya Pradesh",
    "district": "Neemuch",
    "block": "Neemuch",
    "officename": "Neemuch H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Mandsaur Division"
  },
  "458468": {
    "state": "Madhya Pradesh",
    "district": "Neemuch",
    "block": "Jawad",
    "officename": "Nayagaon C F S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Mandsaur Division"
  },
  "458470": {
    "state": "Madhya Pradesh",
    "district": "Neemuch",
    "block": "Jawad",
    "officename": "Khor S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Mandsaur Division"
  },
  "458553": {
    "state": "Madhya Pradesh",
    "district": "Mandsaur",
    "block": "Malhargarh",
    "officename": "Narayangarh S.O (Mandsaur)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Mandsaur Division"
  },
  "458556": {
    "state": "Madhya Pradesh",
    "district": "Mandsaur",
    "block": "Malhargarh",
    "officename": "Budha S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Mandsaur Division"
  },
  "458558": {
    "state": "Madhya Pradesh",
    "district": "Mandsaur",
    "block": "Sitamau",
    "officename": "Nahargarh S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Mandsaur Division"
  },
  "458664": {
    "state": "Madhya Pradesh",
    "district": "Mandsaur",
    "block": "Malhargarh",
    "officename": "Piplia S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Mandsaur Division"
  },
  "458667": {
    "state": "Madhya Pradesh",
    "district": "Mandsaur",
    "block": "Mandsaur",
    "officename": "Dalauda S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Mandsaur Division"
  },
  "458669": {
    "state": "Madhya Pradesh",
    "district": "Mandsaur",
    "block": "Mandsaur",
    "officename": "Kachnara Flag S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Mandsaur Division"
  },
  "458771": {
    "state": "Madhya Pradesh",
    "district": "Mandsaur",
    "block": "Bhanpura",
    "officename": "Gandhi Sagar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Mandsaur Division"
  },
  "458775": {
    "state": "Madhya Pradesh",
    "district": "Mandsaur",
    "block": "Bhanpura",
    "officename": "Bhanpura S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Mandsaur Division"
  },
  "458778": {
    "state": "Madhya Pradesh",
    "district": "Mandsaur",
    "block": "Bhanpura",
    "officename": "Bhensoda Mandi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Mandsaur Division"
  },
  "458880": {
    "state": "Madhya Pradesh",
    "district": "Mandsaur",
    "block": "Garoth",
    "officename": "Garoth S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Mandsaur Division"
  },
  "458883": {
    "state": "Madhya Pradesh",
    "district": "Mandsaur",
    "block": "Garoth",
    "officename": "Shamgarh S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Mandsaur Division"
  },
  "458888": {
    "state": "Madhya Pradesh",
    "district": "Mandsaur",
    "block": "Suwasara Mandi",
    "officename": "Suwasara Mandi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Mandsaur Division"
  },
  "458895": {
    "state": "Madhya Pradesh",
    "district": "Mandsaur",
    "block": "Mandsaur",
    "officename": "Degaon Mali S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Mandsaur Division"
  },
  "458990": {
    "state": "Madhya Pradesh",
    "district": "Mandsaur",
    "block": "Sitamau",
    "officename": "Sitamau S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Mandsaur Division"
  },
  "460001": {
    "state": "Madhya Pradesh",
    "district": "Betul",
    "block": "Betul",
    "officename": "Betul H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "460004": {
    "state": "Madhya Pradesh",
    "district": "Betul",
    "block": "Betul",
    "officename": "Betul Bazaar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "460110": {
    "state": "Madhya Pradesh",
    "district": "Betul",
    "block": "Bhainsdehi",
    "officename": "Athanair S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "460220": {
    "state": "Madhya Pradesh",
    "district": "Betul",
    "block": "Bhainsdehi",
    "officename": "Bhainsdehi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "460225": {
    "state": "Madhya Pradesh",
    "district": "Betul",
    "block": "Betul",
    "officename": "Khedisaoligarh S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "460330": {
    "state": "Madhya Pradesh",
    "district": "Betul",
    "block": "Betul",
    "officename": "Chicholi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "460440": {
    "state": "Madhya Pradesh",
    "district": "Betul",
    "block": "Shahpur",
    "officename": "Shahpur S.O (Betul)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "460443": {
    "state": "Madhya Pradesh",
    "district": "Betul",
    "block": "Shahpur",
    "officename": "Ghoradongari S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "460447": {
    "state": "Madhya Pradesh",
    "district": "Betul",
    "block": "Betul",
    "officename": "Sarni S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "460449": {
    "state": "Madhya Pradesh",
    "district": "Betul",
    "block": "Bhainsdehi",
    "officename": "Pathakheda S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "460551": {
    "state": "Madhya Pradesh",
    "district": "Betul",
    "block": "Amla",
    "officename": "Amla S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "460553": {
    "state": "Madhya Pradesh",
    "district": "Betul",
    "block": "Amla",
    "officename": "Amla Depot S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "460554": {
    "state": "Madhya Pradesh",
    "district": "Betul",
    "block": "Amla",
    "officename": "Bordehi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "460557": {
    "state": "Madhya Pradesh",
    "district": "Betul",
    "block": "Multai",
    "officename": "Sainkheda S.O (Betul)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "460661": {
    "state": "Madhya Pradesh",
    "district": "Betul",
    "block": "Multai",
    "officename": "Multai S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "460663": {
    "state": "Madhya Pradesh",
    "district": "Betul",
    "block": "Multai",
    "officename": "Dunawa S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "460665": {
    "state": "Madhya Pradesh",
    "district": "Betul",
    "block": "Multai",
    "officename": "Prabhat Pattan S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "460666": {
    "state": "Madhya Pradesh",
    "district": "Betul",
    "block": "Multai",
    "officename": "Rai Amla S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "460668": {
    "state": "Madhya Pradesh",
    "district": "Betul",
    "block": "Multai",
    "officename": "Masod S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "461001": {
    "state": "Madhya Pradesh",
    "district": "Hoshangabad",
    "block": "Hoshangabad",
    "officename": "Hoshangabad H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshangabad Division"
  },
  "461005": {
    "state": "Madhya Pradesh",
    "district": "Hoshangabad",
    "block": "Hoshangabad",
    "officename": "Sp Mills Hoshangabad S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshangabad Division"
  },
  "461110": {
    "state": "Madhya Pradesh",
    "district": "Hoshangabad",
    "block": "Hoshangabad",
    "officename": "Powarkheda S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshangabad Division"
  },
  "461111": {
    "state": "Madhya Pradesh",
    "district": "Hoshangabad",
    "block": "Itarsi",
    "officename": "Itarsi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshangabad Division"
  },
  "461114": {
    "state": "Madhya Pradesh",
    "district": "Hoshangabad",
    "block": "Itarsi",
    "officename": "Cpe Itarsi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshangabad Division"
  },
  "461115": {
    "state": "Madhya Pradesh",
    "district": "Hoshangabad",
    "block": "Itarsi",
    "officename": "NYC Itarsi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshangabad Division"
  },
  "461116": {
    "state": "Madhya Pradesh",
    "district": "Hoshangabad",
    "block": "Itarsi",
    "officename": "Dolaria S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshangabad Division"
  },
  "461122": {
    "state": "Madhya Pradesh",
    "district": "Hoshangabad",
    "block": "Itarsi",
    "officename": "OFE Itarsi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshangabad Division"
  },
  "461221": {
    "state": "Madhya Pradesh",
    "district": "Hoshangabad",
    "block": "Itarsi",
    "officename": "Banapura S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshangabad Division"
  },
  "461223": {
    "state": "Madhya Pradesh",
    "district": "Hoshangabad",
    "block": "Itarsi",
    "officename": "Seoni Malwa S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshangabad Division"
  },
  "461228": {
    "state": "Madhya Pradesh",
    "district": "Hoshangabad",
    "block": "Itarsi",
    "officename": "Timarni S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshangabad Division"
  },
  "461331": {
    "state": "Madhya Pradesh",
    "district": "Hoshangabad",
    "block": "Itarsi",
    "officename": "Harda S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshangabad Division"
  },
  "461441": {
    "state": "Madhya Pradesh",
    "district": "Hoshangabad",
    "block": "Itarsi",
    "officename": "Khirkiyan R.S. S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshangabad Division"
  },
  "461446": {
    "state": "Madhya Pradesh",
    "district": "Hoshangabad",
    "block": "Itarsi",
    "officename": "Of Itarsi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshangabad Division"
  },
  "461551": {
    "state": "Madhya Pradesh",
    "district": "Hoshangabad",
    "block": "Itarsi",
    "officename": "Tawa Nagar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshangabad Division"
  },
  "461661": {
    "state": "Madhya Pradesh",
    "district": "Hoshangabad",
    "block": "Itarsi",
    "officename": "Babai S.O (Hoshangabad)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshangabad Division"
  },
  "461668": {
    "state": "Madhya Pradesh",
    "district": "Hoshangabad",
    "block": "Babai",
    "officename": "Semri Harchand S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshangabad Division"
  },
  "461771": {
    "state": "Madhya Pradesh",
    "district": "Hoshangabad",
    "block": "Itarsi",
    "officename": "Sohagpur R.S. S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshangabad Division"
  },
  "461775": {
    "state": "Madhya Pradesh",
    "district": "Hoshangabad",
    "block": "Itarsi",
    "officename": "Piparia S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshangabad Division"
  },
  "461881": {
    "state": "Madhya Pradesh",
    "district": "Hoshangabad",
    "block": "Pipariya",
    "officename": "Pachmarhi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshangabad Division"
  },
  "461990": {
    "state": "Madhya Pradesh",
    "district": "Hoshangabad",
    "block": "Itarsi",
    "officename": "Bankhedi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshangabad Division"
  },
  "462001": {
    "state": "Madhya Pradesh",
    "district": "Bhopal",
    "block": "Huzur",
    "officename": "Bhopal G.P.O.",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhopal Division"
  },
  "462002": {
    "state": "Madhya Pradesh",
    "district": "Bhopal",
    "block": "Huzur",
    "officename": "Vidya Vihar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhopal Division"
  },
  "462003": {
    "state": "Madhya Pradesh",
    "district": "Bhopal",
    "block": "Huzur",
    "officename": "C.T.T.Nagar H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhopal Division"
  },
  "462004": {
    "state": "Madhya Pradesh",
    "district": "Bhopal",
    "block": "Huzur",
    "officename": "Satpura S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhopal Division"
  },
  "462008": {
    "state": "Madhya Pradesh",
    "district": "Bhopal",
    "block": "Huzur",
    "officename": "Jahangirabad S.O (Bhopal)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhopal Division"
  },
  "462010": {
    "state": "Madhya Pradesh",
    "district": "Bhopal",
    "block": "Bhopal",
    "officename": "Sikandri Sarai S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhopal Division"
  },
  "462011": {
    "state": "Madhya Pradesh",
    "district": "Bhopal",
    "block": "Huzur",
    "officename": "Shiksha Mandal S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhopal Division"
  },
  "462016": {
    "state": "Madhya Pradesh",
    "district": "Bhopal",
    "block": "Huzur",
    "officename": "R.S.Nagar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhopal Division"
  },
  "462020": {
    "state": "Madhya Pradesh",
    "district": "Bhopal",
    "block": "Huzur",
    "officename": "AIIMS S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhopal Division"
  },
  "462022": {
    "state": "Madhya Pradesh",
    "district": "Bhopal",
    "block": "Huzur",
    "officename": "Bhel H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhopal Division"
  },
  "462023": {
    "state": "Madhya Pradesh",
    "district": "Bhopal",
    "block": "Huzur",
    "officename": "Govindpura S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhopal Division"
  },
  "462024": {
    "state": "Madhya Pradesh",
    "district": "Bhopal",
    "block": "Huzur",
    "officename": "H.E. Hospital S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhopal Division"
  },
  "462026": {
    "state": "Madhya Pradesh",
    "district": "Bhopal",
    "block": "Bhopal",
    "officename": "University S.O (Bhopal)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhopal Division"
  },
  "462027": {
    "state": "Madhya Pradesh",
    "district": "Bhopal",
    "block": "Huzur",
    "officename": "Arera Hills S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhopal Division"
  },
  "462030": {
    "state": "Madhya Pradesh",
    "district": "Bhopal",
    "block": "Huzur",
    "officename": "Bairagarh S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhopal Division"
  },
  "462031": {
    "state": "Madhya Pradesh",
    "district": "Bhopal",
    "block": "Huzur",
    "officename": "3 EME Centre S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhopal Division"
  },
  "462033": {
    "state": "Madhya Pradesh",
    "district": "Bhopal",
    "block": "Huzur",
    "officename": "RGPV S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhopal Division"
  },
  "462036": {
    "state": "Madhya Pradesh",
    "district": "Bhopal",
    "block": "Huzur",
    "officename": "Gandhi Nagar (Bhopal) S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhopal Division"
  },
  "462037": {
    "state": "Madhya Pradesh",
    "district": "Bhopal",
    "block": "Huzur",
    "officename": "Peoples Campus S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhopal Division"
  },
  "462038": {
    "state": "Madhya Pradesh",
    "district": "Bhopal",
    "block": "Bhopal",
    "officename": "M.L. Nagar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhopal Division"
  },
  "462039": {
    "state": "Madhya Pradesh",
    "district": "Bhopal",
    "block": "Huzur",
    "officename": "Trilanga S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhopal Division"
  },
  "462041": {
    "state": "Madhya Pradesh",
    "district": "Bhopal",
    "block": "Huzur",
    "officename": "Ayodhaya Nagar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhopal Division"
  },
  "462042": {
    "state": "Madhya Pradesh",
    "district": "Bhopal",
    "block": "Bhopal",
    "officename": "Kolar Road S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhopal Division"
  },
  "462043": {
    "state": "Madhya Pradesh",
    "district": "Bhopal",
    "block": "Huzur",
    "officename": "Bag Mungalia S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhopal Division"
  },
  "462044": {
    "state": "Madhya Pradesh",
    "district": "Bhopal",
    "block": "Bhopal",
    "officename": "Suraj Nagar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhopal Division"
  },
  "462045": {
    "state": "Madhya Pradesh",
    "district": "Bhopal",
    "block": "Bhopal",
    "officename": "Bangrasia S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhopal Division"
  },
  "462046": {
    "state": "Madhya Pradesh",
    "district": "Bhopal",
    "block": "Huzur",
    "officename": "Mandideep S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhopal Division"
  },
  "462047": {
    "state": "Madhya Pradesh",
    "district": "Bhopal",
    "block": "Huzur",
    "officename": "Misord S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhopal Division"
  },
  "462066": {
    "state": "Madhya Pradesh",
    "district": "Bhopal",
    "block": "Huzur",
    "officename": "IISER Bhouri S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhopal Division"
  },
  "462101": {
    "state": "Madhya Pradesh",
    "district": "Bhopal",
    "block": "Bhopal",
    "officename": "Dillod S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhopal Division"
  },
  "462120": {
    "state": "Madhya Pradesh",
    "district": "Bhopal",
    "block": "Bhopal",
    "officename": "Nazirabad S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhopal Division"
  },
  "463106": {
    "state": "Madhya Pradesh",
    "district": "Bhopal",
    "block": "Bhopal",
    "officename": "Berasia Bhopal S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhopal Division"
  },
  "463111": {
    "state": "Madhya Pradesh",
    "district": "Bhopal",
    "block": "Bhopal",
    "officename": "Lalariya S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhopal Division"
  },
  "464001": {
    "state": "Madhya Pradesh",
    "district": "Vidisha",
    "block": "Vidisha",
    "officename": "Vidisha H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vidisha Division"
  },
  "464111": {
    "state": "Madhya Pradesh",
    "district": "Vidisha",
    "block": "Nateran",
    "officename": "Shamshabad S.O (Vidisha)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vidisha Division"
  },
  "464113": {
    "state": "Madhya Pradesh",
    "district": "Vidisha",
    "block": "Vidisha",
    "officename": "Pipalkheda S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vidisha Division"
  },
  "464114": {
    "state": "Madhya Pradesh",
    "district": "Vidisha",
    "block": "Lateri",
    "officename": "Lateri S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vidisha Division"
  },
  "464220": {
    "state": "Madhya Pradesh",
    "district": "Vidisha",
    "block": "Vidisha",
    "officename": "Gulabganj S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vidisha Division"
  },
  "464221": {
    "state": "Madhya Pradesh",
    "district": "Vidisha",
    "block": "Vidisha",
    "officename": "Ganjbasoda S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vidisha Division"
  },
  "464224": {
    "state": "Madhya Pradesh",
    "district": "Vidisha",
    "block": "Kurwai",
    "officename": "Kurwai S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vidisha Division"
  },
  "464226": {
    "state": "Madhya Pradesh",
    "district": "Vidisha",
    "block": "Vidisha",
    "officename": "Khamkheda S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vidisha Division"
  },
  "464228": {
    "state": "Madhya Pradesh",
    "district": "Vidisha",
    "block": "Sironj",
    "officename": "Sironj S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vidisha Division"
  },
  "464240": {
    "state": "Madhya Pradesh",
    "district": "Sagar",
    "block": "Bina",
    "officename": "Bamora R.S S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vidisha Division"
  },
  "464258": {
    "state": "Madhya Pradesh",
    "district": "Vidisha",
    "block": "Vidisha",
    "officename": "Nateran S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vidisha Division"
  },
  "464331": {
    "state": "Madhya Pradesh",
    "district": "Vidisha",
    "block": "Vidisha",
    "officename": "Gyraspur S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vidisha Division"
  },
  "464337": {
    "state": "Madhya Pradesh",
    "district": "Vidisha",
    "block": "Kurwai",
    "officename": "Pathari S.O (Vidisha)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vidisha Division"
  },
  "464551": {
    "state": "Madhya Pradesh",
    "district": "Raisen",
    "block": "Gairatganj",
    "officename": "Raisen H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vidisha Division"
  },
  "464651": {
    "state": "Madhya Pradesh",
    "district": "Raisen",
    "block": "Raisen",
    "officename": "Salamatpur Mandi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vidisha Division"
  },
  "464661": {
    "state": "Madhya Pradesh",
    "district": "Raisen",
    "block": "Raisen",
    "officename": "Sanchi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vidisha Division"
  },
  "464665": {
    "state": "Madhya Pradesh",
    "district": "Raisen",
    "block": "Baraily",
    "officename": "Badi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vidisha Division"
  },
  "464668": {
    "state": "Madhya Pradesh",
    "district": "Raisen",
    "block": "Baraily",
    "officename": "Bareli S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vidisha Division"
  },
  "464671": {
    "state": "Madhya Pradesh",
    "district": "Raisen",
    "block": "Udaipura",
    "officename": "Khargone S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vidisha Division"
  },
  "464672": {
    "state": "Madhya Pradesh",
    "district": "Raisen",
    "block": "Silwani",
    "officename": "Bamhori S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vidisha Division"
  },
  "464770": {
    "state": "Madhya Pradesh",
    "district": "Raisen",
    "block": "Udaipura",
    "officename": "Udaipura S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vidisha Division"
  },
  "464774": {
    "state": "Madhya Pradesh",
    "district": "Raisen",
    "block": "Udaipura",
    "officename": "Deori S.O (Raisen)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vidisha Division"
  },
  "464881": {
    "state": "Madhya Pradesh",
    "district": "Raisen",
    "block": "Begamganj",
    "officename": "Begumganj S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vidisha Division"
  },
  "464884": {
    "state": "Madhya Pradesh",
    "district": "Raisen",
    "block": "Gairatganj",
    "officename": "Gairatganj S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vidisha Division"
  },
  "464886": {
    "state": "Madhya Pradesh",
    "district": "Raisen",
    "block": "Silwani",
    "officename": "Silwani S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vidisha Division"
  },
  "464986": {
    "state": "Madhya Pradesh",
    "district": "Raisen",
    "block": "Goharganj",
    "officename": "Sultanpur S.O (Raisen)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vidisha Division"
  },
  "464990": {
    "state": "Madhya Pradesh",
    "district": "Raisen",
    "block": "Goharganj",
    "officename": "Goharganj S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vidisha Division"
  },
  "464993": {
    "state": "Madhya Pradesh",
    "district": "Raisen",
    "block": "Goharganj",
    "officename": "Obedullaganj S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhopal Division"
  },
  "465001": {
    "state": "Madhya Pradesh",
    "district": "Shajapur",
    "block": "Shajapur",
    "officename": "Shajapur H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "465106": {
    "state": "Madhya Pradesh",
    "district": "Shajapur",
    "block": "Shajapur",
    "officename": "Maksi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "465110": {
    "state": "Madhya Pradesh",
    "district": "Shajapur",
    "block": "Shajapur",
    "officename": "Berchha S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "465113": {
    "state": "Madhya Pradesh",
    "district": "Shajapur",
    "block": "Shujalpur",
    "officename": "Sundersi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "465116": {
    "state": "Madhya Pradesh",
    "district": "Shajapur",
    "block": "Shujalpur",
    "officename": "Polai Kalan S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "465118": {
    "state": "Madhya Pradesh",
    "district": "Shajapur",
    "block": "Awantipur Barodiya",
    "officename": "AWANTIPUR BARODIYA",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "465220": {
    "state": "Madhya Pradesh",
    "district": "Shajapur",
    "block": "Kalisindh",
    "officename": "Kalisindh S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "465223": {
    "state": "Madhya Pradesh",
    "district": "Shajapur",
    "block": "Moman Badodiya",
    "officename": "Akodia S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "465226": {
    "state": "Madhya Pradesh",
    "district": "Shajapur",
    "block": "Moman Badodiya",
    "officename": "Barodia Kumaria S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "465227": {
    "state": "Madhya Pradesh",
    "district": "Shajapur",
    "block": "Moman Badodiya",
    "officename": "Salsalai S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "465230": {
    "state": "Madhya Pradesh",
    "district": "Shajapur",
    "block": "Moman Badodiya",
    "officename": "Kanad S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "465333": {
    "state": "Madhya Pradesh",
    "district": "Shajapur",
    "block": "Kalapipal",
    "officename": "Shujalpur  Mandi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "465335": {
    "state": "Madhya Pradesh",
    "district": "Shajapur",
    "block": "Jamner",
    "officename": "Jamner S.O (Shajapur)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "465337": {
    "state": "Madhya Pradesh",
    "district": "Shajapur",
    "block": "Kalapipal",
    "officename": "Kalapipal S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "465339": {
    "state": "Madhya Pradesh",
    "district": "Shajapur",
    "block": "Khokra Kalan",
    "officename": "Khokra Kalan S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "465441": {
    "state": "Madhya Pradesh",
    "district": "Shajapur",
    "block": "Agar Malwa",
    "officename": "Agar Malwa S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "465445": {
    "state": "Madhya Pradesh",
    "district": "Shajapur",
    "block": "Agar",
    "officename": "Nalkheda S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "465447": {
    "state": "Madhya Pradesh",
    "district": "Shajapur",
    "block": "Susner",
    "officename": "Susner S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "465449": {
    "state": "Madhya Pradesh",
    "district": "Shajapur",
    "block": "Susner",
    "officename": "Soyat Kalan S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "465550": {
    "state": "Madhya Pradesh",
    "district": "Shajapur",
    "block": "Barode",
    "officename": "Barode S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "465661": {
    "state": "Madhya Pradesh",
    "district": "Rajgarh",
    "block": "Rajgarh(bia)",
    "officename": "Rajgarh(Bia) H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Sehore Division"
  },
  "465667": {
    "state": "Madhya Pradesh",
    "district": "Rajgarh",
    "block": "Narsinghgarh",
    "officename": "Kurawar S.O (Rajgarh)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Sehore Division"
  },
  "465669": {
    "state": "Madhya Pradesh",
    "district": "Rajgarh",
    "block": "Narsinghgarh",
    "officename": "Narsinghgarh S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Sehore Division"
  },
  "465674": {
    "state": "Madhya Pradesh",
    "district": "Rajgarh",
    "block": "Biaora",
    "officename": "Biaora S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Sehore Division"
  },
  "465677": {
    "state": "Madhya Pradesh",
    "district": "Rajgarh",
    "block": "Talen",
    "officename": "Suthalia S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Sehore Division"
  },
  "465679": {
    "state": "Madhya Pradesh",
    "district": "Rajgarh",
    "block": "Khilchipur",
    "officename": "Khilchipur S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Sehore Division"
  },
  "465680": {
    "state": "Madhya Pradesh",
    "district": "Rajgarh",
    "block": "Talen",
    "officename": "Talen S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Sehore Division"
  },
  "465683": {
    "state": "Madhya Pradesh",
    "district": "Rajgarh",
    "block": "Pachore",
    "officename": "Pachore S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Sehore Division"
  },
  "465685": {
    "state": "Madhya Pradesh",
    "district": "Rajgarh",
    "block": "Narsinghgarh",
    "officename": "Boda S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Sehore Division"
  },
  "465687": {
    "state": "Madhya Pradesh",
    "district": "Rajgarh",
    "block": "Sarangpur",
    "officename": "Khujner S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Sehore Division"
  },
  "465689": {
    "state": "Madhya Pradesh",
    "district": "Rajgarh",
    "block": "Chhapiheda",
    "officename": "Chhapiheda S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Sehore Division"
  },
  "465691": {
    "state": "Madhya Pradesh",
    "district": "Rajgarh",
    "block": "Zeerapur",
    "officename": "Zeerapur S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Sehore Division"
  },
  "465693": {
    "state": "Madhya Pradesh",
    "district": "Rajgarh",
    "block": "Jirapur",
    "officename": "Machalpur S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Sehore Division"
  },
  "465697": {
    "state": "Madhya Pradesh",
    "district": "Rajgarh",
    "block": "Sarangpur",
    "officename": "Sarangpur S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Sehore Division"
  },
  "466001": {
    "state": "Madhya Pradesh",
    "district": "Sehore",
    "block": "Sehore",
    "officename": "Sehore H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Sehore Division"
  },
  "466111": {
    "state": "Madhya Pradesh",
    "district": "Sehore",
    "block": "Bilkisganj",
    "officename": "Bilkisganj S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Sehore Division"
  },
  "466113": {
    "state": "Madhya Pradesh",
    "district": "Sehore",
    "block": "Sehore",
    "officename": "Amlaha S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Sehore Division"
  },
  "466114": {
    "state": "Madhya Pradesh",
    "district": "Sehore",
    "block": "Ashta",
    "officename": "Kotri S.O (Sehore)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Sehore Division"
  },
  "466115": {
    "state": "Madhya Pradesh",
    "district": "Sehore",
    "block": "Ichawar",
    "officename": "Ichawar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Sehore Division"
  },
  "466116": {
    "state": "Madhya Pradesh",
    "district": "Sehore",
    "block": "Sehore",
    "officename": "Ashta S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Sehore Division"
  },
  "466118": {
    "state": "Madhya Pradesh",
    "district": "Sehore",
    "block": "Metwada",
    "officename": "Metwada S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Sehore Division"
  },
  "466120": {
    "state": "Madhya Pradesh",
    "district": "Sehore",
    "block": "Siddikganj",
    "officename": "Siddikganj S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Sehore Division"
  },
  "466125": {
    "state": "Madhya Pradesh",
    "district": "Sehore",
    "block": "Ashta",
    "officename": "Maina S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Sehore Division"
  },
  "466221": {
    "state": "Madhya Pradesh",
    "district": "Sehore",
    "block": "Ashta",
    "officename": "Jawar S.O (Sehore)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Sehore Division"
  },
  "466331": {
    "state": "Madhya Pradesh",
    "district": "Sehore",
    "block": "Nasrullaganj",
    "officename": "Bhairunda Sub Post Office",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Sehore Division"
  },
  "466445": {
    "state": "Madhya Pradesh",
    "district": "Sehore",
    "block": "Budhni",
    "officename": "Budhni T.N. S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Sehore Division"
  },
  "466446": {
    "state": "Madhya Pradesh",
    "district": "Sehore",
    "block": "Rehti",
    "officename": "Rehti S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Sehore Division"
  },
  "466448": {
    "state": "Madhya Pradesh",
    "district": "Sehore",
    "block": "Baktara",
    "officename": "Baktara S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Sehore Division"
  },
  "466554": {
    "state": "Madhya Pradesh",
    "district": "Sehore",
    "block": "Shahganj",
    "officename": "Shahganj S.O (Sehore)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Sehore Division"
  },
  "466651": {
    "state": "Madhya Pradesh",
    "district": "Sehore",
    "block": "Ashta",
    "officename": "Shyampur S.O (Sehore)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Sehore Division"
  },
  "466661": {
    "state": "Madhya Pradesh",
    "district": "Sehore",
    "block": "Sehore",
    "officename": "Doraha S.O (Sehore)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Sehore Division"
  },
  "466665": {
    "state": "Madhya Pradesh",
    "district": "Sehore",
    "block": "Sehore",
    "officename": "Ahmedpur S.O (Sehore)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Sehore Division"
  },
  "470001": {
    "state": "Madhya Pradesh",
    "district": "Sagar",
    "block": "Sagar",
    "officename": "Sagar Cantt H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470002": {
    "state": "Madhya Pradesh",
    "district": "Sagar",
    "block": "Sagar",
    "officename": "Sagar City S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470003": {
    "state": "Madhya Pradesh",
    "district": "Sagar",
    "block": "Sagar",
    "officename": "Sagar University S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470004": {
    "state": "Madhya Pradesh",
    "district": "Sagar",
    "block": "Banda",
    "officename": "Sagar Makronia Camp S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470021": {
    "state": "Madhya Pradesh",
    "district": "Sagar",
    "block": "Sagar",
    "officename": "Bamora S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470051": {
    "state": "Madhya Pradesh",
    "district": "Sagar",
    "block": "Sagar",
    "officename": "Bilahra Raja S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470113": {
    "state": "Madhya Pradesh",
    "district": "Sagar",
    "block": "Bina",
    "officename": "Bina S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470115": {
    "state": "Madhya Pradesh",
    "district": "Sagar",
    "block": "Khurai",
    "officename": "Jaruakheda S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470117": {
    "state": "Madhya Pradesh",
    "district": "Sagar",
    "block": "Khurai",
    "officename": "Khurai S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470118": {
    "state": "Madhya Pradesh",
    "district": "Sagar",
    "block": "Banda",
    "officename": "Khimlasa S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470119": {
    "state": "Madhya Pradesh",
    "district": "Sagar",
    "block": "Sagar",
    "officename": "Rahatgarh S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470120": {
    "state": "Madhya Pradesh",
    "district": "Sagar",
    "block": "Sagar",
    "officename": "Sihora S.O (Sagar)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470124": {
    "state": "Madhya Pradesh",
    "district": "Sagar",
    "block": "Bina",
    "officename": "Bina BPCL Refinery S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470125": {
    "state": "Madhya Pradesh",
    "district": "Sagar",
    "block": "Sagar",
    "officename": "Jaisinagar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470221": {
    "state": "Madhya Pradesh",
    "district": "Sagar",
    "block": "Sagar",
    "officename": "Surkhi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470223": {
    "state": "Madhya Pradesh",
    "district": "Sagar",
    "block": "Sagar",
    "officename": "Gaurjhamar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470226": {
    "state": "Madhya Pradesh",
    "district": "Sagar",
    "block": "Deori",
    "officename": "Deori S.O (Sagar)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470227": {
    "state": "Madhya Pradesh",
    "district": "Sagar",
    "block": "Garhakota",
    "officename": "Rehli S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470228": {
    "state": "Madhya Pradesh",
    "district": "Sagar",
    "block": "Sagar",
    "officename": "Dhana S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470229": {
    "state": "Madhya Pradesh",
    "district": "Sagar",
    "block": "Garhakota",
    "officename": "Garhakota S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470232": {
    "state": "Madhya Pradesh",
    "district": "Sagar",
    "block": "Garhakota",
    "officename": "Garhakota Nadipar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470235": {
    "state": "Madhya Pradesh",
    "district": "Sagar",
    "block": "Kesli",
    "officename": "Kesli S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470335": {
    "state": "Madhya Pradesh",
    "district": "Sagar",
    "block": "Sagar",
    "officename": "Banda Belai S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470337": {
    "state": "Madhya Pradesh",
    "district": "Sagar",
    "block": "Banda",
    "officename": "Karrapur S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470339": {
    "state": "Madhya Pradesh",
    "district": "Sagar",
    "block": "Banda",
    "officename": "Shahgarh S.O (Sagar)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470441": {
    "state": "Madhya Pradesh",
    "district": "Sagar",
    "block": "Khurai",
    "officename": "Malthone S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470442": {
    "state": "Madhya Pradesh",
    "district": "Sagar",
    "block": "Sagar",
    "officename": "Bandri S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470661": {
    "state": "Madhya Pradesh",
    "district": "Damoh",
    "block": "Damoh",
    "officename": "Damoh H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470663": {
    "state": "Madhya Pradesh",
    "district": "Damoh",
    "block": "Batiyagarh",
    "officename": "Nohata S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470664": {
    "state": "Madhya Pradesh",
    "district": "Damoh",
    "block": "Damoh",
    "officename": "Bandakpur S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470666": {
    "state": "Madhya Pradesh",
    "district": "Damoh",
    "block": "Pathariya",
    "officename": "Pathariya S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470669": {
    "state": "Madhya Pradesh",
    "district": "Sagar",
    "block": "Sagar",
    "officename": "Shahpur Magrone S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470672": {
    "state": "Madhya Pradesh",
    "district": "Damoh",
    "block": "Damoh",
    "officename": "Bansa Tarkheda S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470673": {
    "state": "Madhya Pradesh",
    "district": "Damoh",
    "block": "Damoh",
    "officename": "Batiagarh S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470675": {
    "state": "Madhya Pradesh",
    "district": "Damoh",
    "block": "Damoh",
    "officename": "Narsingarh S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470771": {
    "state": "Madhya Pradesh",
    "district": "Damoh",
    "block": "Damoh",
    "officename": "Hindoriya S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470772": {
    "state": "Madhya Pradesh",
    "district": "Damoh",
    "block": "Patera",
    "officename": "Patera S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470775": {
    "state": "Madhya Pradesh",
    "district": "Damoh",
    "block": "Hatta",
    "officename": "Hatta S.O (Damoh)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470880": {
    "state": "Madhya Pradesh",
    "district": "Damoh",
    "block": "Damoh",
    "officename": "Tendukheda S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470881": {
    "state": "Madhya Pradesh",
    "district": "Damoh",
    "block": "Damoh",
    "officename": "Jabera S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "471001": {
    "state": "Madhya Pradesh",
    "district": "Chhatarpur",
    "block": "Chhatarpur",
    "officename": "Chhatarpur H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhatarpur Division"
  },
  "471101": {
    "state": "Madhya Pradesh",
    "district": "Chhatarpur",
    "block": "Chhatarpur",
    "officename": "Chandra Nagar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhatarpur Division"
  },
  "471105": {
    "state": "Madhya Pradesh",
    "district": "Chhatarpur",
    "block": "Chhatarpur",
    "officename": "Bamitha S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhatarpur Division"
  },
  "471111": {
    "state": "Madhya Pradesh",
    "district": "Chhatarpur",
    "block": "Nowgong",
    "officename": "Harpalpur S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhatarpur Division"
  },
  "471201": {
    "state": "Madhya Pradesh",
    "district": "Chhatarpur",
    "block": "Nowgong",
    "officename": "Nowgong S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhatarpur Division"
  },
  "471301": {
    "state": "Madhya Pradesh",
    "district": "Chhatarpur",
    "block": "Malehara",
    "officename": "Gulganj S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhatarpur Division"
  },
  "471311": {
    "state": "Madhya Pradesh",
    "district": "Chhatarpur",
    "block": "Malehara",
    "officename": "Badamalehara S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhatarpur Division"
  },
  "471313": {
    "state": "Madhya Pradesh",
    "district": "Chhatarpur",
    "block": "Malehara",
    "officename": "Ghaura S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhatarpur Division"
  },
  "471315": {
    "state": "Madhya Pradesh",
    "district": "Chhatarpur",
    "block": "Laundi",
    "officename": "Ishanagar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhatarpur Division"
  },
  "471318": {
    "state": "Madhya Pradesh",
    "district": "Chhatarpur",
    "block": "Malahara",
    "officename": "Buxwaha S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhatarpur Division"
  },
  "471405": {
    "state": "Madhya Pradesh",
    "district": "Chhatarpur",
    "block": "Bijawar",
    "officename": "Bijawar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhatarpur Division"
  },
  "471408": {
    "state": "Madhya Pradesh",
    "district": "Chhatarpur",
    "block": "Chhatarpur",
    "officename": "Satai S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhatarpur Division"
  },
  "471411": {
    "state": "Madhya Pradesh",
    "district": "Chhatarpur",
    "block": "Chhatarpur",
    "officename": "Gadimalehara S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhatarpur Division"
  },
  "471501": {
    "state": "Madhya Pradesh",
    "district": "Chhatarpur",
    "block": "Chhatarpur",
    "officename": "Maharajpur S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhatarpur Division"
  },
  "471510": {
    "state": "Madhya Pradesh",
    "district": "Chhatarpur",
    "block": "Laundi",
    "officename": "Jujhar Nagar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhatarpur Division"
  },
  "471515": {
    "state": "Madhya Pradesh",
    "district": "Chhatarpur",
    "block": "Laundi",
    "officename": "Laundi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhatarpur Division"
  },
  "471516": {
    "state": "Madhya Pradesh",
    "district": "Chhatarpur",
    "block": "Gaurihar",
    "officename": "Gaurihar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhatarpur Division"
  },
  "471525": {
    "state": "Madhya Pradesh",
    "district": "Chhatarpur",
    "block": "Laundi",
    "officename": "Chandla S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhatarpur Division"
  },
  "471606": {
    "state": "Madhya Pradesh",
    "district": "Chhatarpur",
    "block": "Laundi",
    "officename": "Khajuraho S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhatarpur Division"
  },
  "471625": {
    "state": "Madhya Pradesh",
    "district": "Chhatarpur",
    "block": "Rajnagar",
    "officename": "Rajnagar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhatarpur Division"
  },
  "472001": {
    "state": "Madhya Pradesh",
    "district": "Chhatarpur",
    "block": "Tikamgarh",
    "officename": "Tikamgarh H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhatarpur Division"
  },
  "472005": {
    "state": "Madhya Pradesh",
    "district": "Tikamgarh",
    "block": "Tikamgarh",
    "officename": "Kundeshwar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhatarpur Division"
  },
  "472010": {
    "state": "Madhya Pradesh",
    "district": "Chhatarpur",
    "block": "Tikamgarh",
    "officename": "Badagaon S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhatarpur Division"
  },
  "472101": {
    "state": "Madhya Pradesh",
    "district": "Tikamgarh",
    "block": "Tikamgarh",
    "officename": "Mohangarh S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhatarpur Division"
  },
  "472111": {
    "state": "Madhya Pradesh",
    "district": "Chhatarpur",
    "block": "Baldeogarh",
    "officename": "Baldeogarh S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhatarpur Division"
  },
  "472115": {
    "state": "Madhya Pradesh",
    "district": "Tikamgarh",
    "block": "Khargapur",
    "officename": "Khargapur S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhatarpur Division"
  },
  "472118": {
    "state": "Madhya Pradesh",
    "district": "Tikamgarh",
    "block": "Jatara",
    "officename": "Jatara S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhatarpur Division"
  },
  "472221": {
    "state": "Madhya Pradesh",
    "district": "Tikamgarh",
    "block": "Palera",
    "officename": "Palera S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhatarpur Division"
  },
  "472246": {
    "state": "Madhya Pradesh",
    "district": "Tikamgarh",
    "block": "Orchha",
    "officename": "Orchha S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhatarpur Division"
  },
  "472331": {
    "state": "Madhya Pradesh",
    "district": "Tikamgarh",
    "block": "Baldeogarh",
    "officename": "Lidhora S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhatarpur Division"
  },
  "472336": {
    "state": "Madhya Pradesh",
    "district": "Tikamgarh",
    "block": "Tikamgarh",
    "officename": "Prithvipur S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhatarpur Division"
  },
  "472337": {
    "state": "Madhya Pradesh",
    "district": "Tikamgarh",
    "block": "Tikamgarh",
    "officename": "Jeron S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhatarpur Division"
  },
  "472339": {
    "state": "Madhya Pradesh",
    "district": "Tikamgarh",
    "block": "Baldeogarh",
    "officename": "Digoda S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhatarpur Division"
  },
  "472442": {
    "state": "Madhya Pradesh",
    "district": "Tikamgarh",
    "block": "Niwari",
    "officename": "Niwari S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhatarpur Division"
  },
  "472445": {
    "state": "Madhya Pradesh",
    "district": "Tikamgarh",
    "block": "Tikamgarh",
    "officename": "Taricharkala S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhatarpur Division"
  },
  "472447": {
    "state": "Madhya Pradesh",
    "district": "Tikamgarh",
    "block": "Tikamgarh",
    "officename": "Teharka S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhatarpur Division"
  },
  "473001": {
    "state": "Madhya Pradesh",
    "district": "Guna",
    "block": "Guna",
    "officename": "Guna H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guna Division"
  },
  "473101": {
    "state": "Madhya Pradesh",
    "district": "Guna",
    "block": "Guna",
    "officename": "Aroun S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guna Division"
  },
  "473105": {
    "state": "Madhya Pradesh",
    "district": "Guna",
    "block": "Bamori",
    "officename": "Bamori S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guna Division"
  },
  "473110": {
    "state": "Madhya Pradesh",
    "district": "Guna",
    "block": "Raghogarh",
    "officename": "Ruthiyai S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guna Division"
  },
  "473111": {
    "state": "Madhya Pradesh",
    "district": "Guna",
    "block": "Raghogarh",
    "officename": "N.F.L.Vijaipur S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guna Division"
  },
  "473112": {
    "state": "Madhya Pradesh",
    "district": "Guna",
    "block": "Raghogarh",
    "officename": "Gail Complex S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guna Division"
  },
  "473113": {
    "state": "Madhya Pradesh",
    "district": "Guna",
    "block": "Guna",
    "officename": "Myana S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guna Division"
  },
  "473115": {
    "state": "Madhya Pradesh",
    "district": "Guna",
    "block": "Chacauda",
    "officename": "Binaganj S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guna Division"
  },
  "473118": {
    "state": "Madhya Pradesh",
    "district": "Guna",
    "block": "Chachauda",
    "officename": "Chachauda S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guna Division"
  },
  "473222": {
    "state": "Madhya Pradesh",
    "district": "Guna",
    "block": "Kumbhraj",
    "officename": "Kumbhraj S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guna Division"
  },
  "473226": {
    "state": "Madhya Pradesh",
    "district": "Guna",
    "block": "Raghogarh",
    "officename": "Raghogarh S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guna Division"
  },
  "473249": {
    "state": "Madhya Pradesh",
    "district": "Guna",
    "block": "Guna",
    "officename": "Bajranggarh S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guna Division"
  },
  "473287": {
    "state": "Madhya Pradesh",
    "district": "Guna",
    "block": "Maksudangarh",
    "officename": "Maksudangarh S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guna Division"
  },
  "473330": {
    "state": "Madhya Pradesh",
    "district": "Ashok Nagar",
    "block": "Ashoknagar",
    "officename": "Shadora S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guna Division"
  },
  "473331": {
    "state": "Madhya Pradesh",
    "district": "Guna",
    "block": "Ashoknagar",
    "officename": "Ashoknagar H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guna Division"
  },
  "473332": {
    "state": "Madhya Pradesh",
    "district": "Ashok Nagar",
    "block": "Ashoknagar",
    "officename": "Naisarai S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guna Division"
  },
  "473335": {
    "state": "Madhya Pradesh",
    "district": "Ashok Nagar",
    "block": "Esagarh",
    "officename": "Esagarh S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guna Division"
  },
  "473440": {
    "state": "Madhya Pradesh",
    "district": "Ashok Nagar",
    "block": "Mungaoli",
    "officename": "Piprai S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guna Division"
  },
  "473443": {
    "state": "Madhya Pradesh",
    "district": "Ashok Nagar",
    "block": "Mungaoli",
    "officename": "Mungaoli S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guna Division"
  },
  "473444": {
    "state": "Madhya Pradesh",
    "district": "Ashok Nagar",
    "block": "Mungaoli",
    "officename": "Sehrai S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guna Division"
  },
  "473446": {
    "state": "Madhya Pradesh",
    "district": "Ashok Nagar",
    "block": "Chanderi",
    "officename": "Chanderi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guna Division"
  },
  "473551": {
    "state": "Madhya Pradesh",
    "district": "Shivpuri",
    "block": "Shivpuri",
    "officename": "Shivpuri H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shivpuri Division"
  },
  "473585": {
    "state": "Madhya Pradesh",
    "district": "Shivpuri",
    "block": "Khaniadhana",
    "officename": "Bamorkalan S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shivpuri Division"
  },
  "473638": {
    "state": "Madhya Pradesh",
    "district": "Shivpuri",
    "block": "Shivpuri",
    "officename": "Katthamil Shivpuri S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shivpuri Division"
  },
  "473660": {
    "state": "Madhya Pradesh",
    "district": "Shivpuri",
    "block": "Karera",
    "officename": "Karera S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shivpuri Division"
  },
  "473662": {
    "state": "Madhya Pradesh",
    "district": "Shivpuri",
    "block": "Karera",
    "officename": "T.C.Karera S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shivpuri Division"
  },
  "473665": {
    "state": "Madhya Pradesh",
    "district": "Shivpuri",
    "block": "Karera",
    "officename": "Dinara S.O (Shivpuri",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shivpuri Division"
  },
  "473670": {
    "state": "Madhya Pradesh",
    "district": "Shivpuri",
    "block": "Pichhore",
    "officename": "Manpura S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shivpuri Division"
  },
  "473770": {
    "state": "Madhya Pradesh",
    "district": "Shivpuri",
    "block": "Kolaras",
    "officename": "Kolaras S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shivpuri Division"
  },
  "473774": {
    "state": "Madhya Pradesh",
    "district": "Shivpuri",
    "block": "Kolaras",
    "officename": "Jagatpur S.O (Shivpuri",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shivpuri Division"
  },
  "473775": {
    "state": "Madhya Pradesh",
    "district": "Shivpuri",
    "block": "Pohri",
    "officename": "Pohari S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shivpuri Division"
  },
  "473781": {
    "state": "Madhya Pradesh",
    "district": "Shivpuri",
    "block": "Kolaras",
    "officename": "Rannod S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shivpuri Division"
  },
  "473793": {
    "state": "Madhya Pradesh",
    "district": "Shivpuri",
    "block": "Pohri",
    "officename": "Berad S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shivpuri Division"
  },
  "473865": {
    "state": "Madhya Pradesh",
    "district": "Shivpuri",
    "block": "Narwar",
    "officename": "Magroni S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shivpuri Division"
  },
  "473880": {
    "state": "Madhya Pradesh",
    "district": "Shivpuri",
    "block": "Narwar",
    "officename": "Narwar S.O (Shivpuri",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shivpuri Division"
  },
  "473885": {
    "state": "Madhya Pradesh",
    "district": "Shivpuri",
    "block": "Kolaras",
    "officename": "Badarwas S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shivpuri Division"
  },
  "473990": {
    "state": "Madhya Pradesh",
    "district": "Shivpuri",
    "block": "Khaniadhana",
    "officename": "Khaniyadhana S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shivpuri Division"
  },
  "473995": {
    "state": "Madhya Pradesh",
    "district": "Shivpuri",
    "block": "Pichhore",
    "officename": "Pichhore S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shivpuri Division"
  },
  "474001": {
    "state": "Madhya Pradesh",
    "district": "Gwalior",
    "block": "Gwalior",
    "officename": "Lashkar H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gwalior Division"
  },
  "474002": {
    "state": "Madhya Pradesh",
    "district": "Gwalior",
    "block": "Gird",
    "officename": "Gwalior R.S. S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gwalior Division"
  },
  "474003": {
    "state": "Madhya Pradesh",
    "district": "Gwalior",
    "block": "Gird",
    "officename": "GWALIOR CITY SO",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gwalior Division"
  },
  "474004": {
    "state": "Madhya Pradesh",
    "district": "Gwalior",
    "block": "Gird",
    "officename": "Birla Nagar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gwalior Division"
  },
  "474005": {
    "state": "Madhya Pradesh",
    "district": "Gwalior",
    "block": "Gwalior",
    "officename": "Gwalior Residency S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gwalior Division"
  },
  "474006": {
    "state": "Madhya Pradesh",
    "district": "Gwalior",
    "block": "Gwalior",
    "officename": "Morar H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gwalior Division"
  },
  "474007": {
    "state": "Madhya Pradesh",
    "district": "Gwalior",
    "block": "Gird",
    "officename": "Moti Mahal S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gwalior Division"
  },
  "474008": {
    "state": "Madhya Pradesh",
    "district": "Gwalior",
    "block": "Gird",
    "officename": "Gwalior Fort S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gwalior Division"
  },
  "474009": {
    "state": "Madhya Pradesh",
    "district": "Gwalior",
    "block": "Gird",
    "officename": "Lashkar City S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gwalior Division"
  },
  "474010": {
    "state": "Madhya Pradesh",
    "district": "Gwalior",
    "block": "Gwalior",
    "officename": "Moti Jheel S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gwalior Division"
  },
  "474011": {
    "state": "Madhya Pradesh",
    "district": "Gwalior",
    "block": "Gird",
    "officename": "R. K. Puri Gwalior SO",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gwalior Division"
  },
  "474012": {
    "state": "Madhya Pradesh",
    "district": "Gwalior",
    "block": "Gird",
    "officename": "S.P. Ashram S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gwalior Division"
  },
  "474015": {
    "state": "Madhya Pradesh",
    "district": "Gwalior",
    "block": "Gird",
    "officename": "AB VIII TM Gwalior S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gwalior Division"
  },
  "474020": {
    "state": "Madhya Pradesh",
    "district": "Gwalior",
    "block": "Morar",
    "officename": "Maharajpura A.F. S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gwalior Division"
  },
  "475001": {
    "state": "Madhya Pradesh",
    "district": "Gwalior",
    "block": "Gwalior",
    "officename": "Antri S.O (Gwalior",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gwalior Division"
  },
  "475002": {
    "state": "Madhya Pradesh",
    "district": "Gwalior",
    "block": "Gwalior",
    "officename": "Behat S.O (Gwalior",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gwalior Division"
  },
  "475005": {
    "state": "Madhya Pradesh",
    "district": "Gwalior",
    "block": "Gwalior",
    "officename": "Tekanpur S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gwalior Division"
  },
  "475110": {
    "state": "Madhya Pradesh",
    "district": "Gwalior",
    "block": "Dabra",
    "officename": "Dabra S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gwalior Division"
  },
  "475115": {
    "state": "Madhya Pradesh",
    "district": "Gwalior",
    "block": "Dabra",
    "officename": "Pichhore Gird S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gwalior Division"
  },
  "475220": {
    "state": "Madhya Pradesh",
    "district": "Gwalior",
    "block": "Bhitarwar",
    "officename": "Bhitarwar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gwalior Division"
  },
  "475330": {
    "state": "Madhya Pradesh",
    "district": "Gwalior",
    "block": "Gwalior",
    "officename": "Mohna S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gwalior Division"
  },
  "475335": {
    "state": "Madhya Pradesh",
    "district": "Datia",
    "block": "Bhandair",
    "officename": "Bhandair S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gwalior Division"
  },
  "475336": {
    "state": "Madhya Pradesh",
    "district": "Datia",
    "block": "Bhandair",
    "officename": "Salon B. S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gwalior Division"
  },
  "475661": {
    "state": "Madhya Pradesh",
    "district": "Datia",
    "block": "Datia",
    "officename": "Datia S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gwalior Division"
  },
  "475671": {
    "state": "Madhya Pradesh",
    "district": "Datia",
    "block": "Datia",
    "officename": "Unnao S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gwalior Division"
  },
  "475673": {
    "state": "Madhya Pradesh",
    "district": "Datia",
    "block": "Seondha",
    "officename": "Tharet S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gwalior Division"
  },
  "475675": {
    "state": "Madhya Pradesh",
    "district": "Datia",
    "block": "Indergarh",
    "officename": "Indergarh S.O (Datia",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gwalior Division"
  },
  "475682": {
    "state": "Madhya Pradesh",
    "district": "Datia",
    "block": "Seondha",
    "officename": "Seondha S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gwalior Division"
  },
  "475685": {
    "state": "Madhya Pradesh",
    "district": "Datia",
    "block": "Datia",
    "officename": "Sonagir S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gwalior Division"
  },
  "475686": {
    "state": "Madhya Pradesh",
    "district": "Gwalior",
    "block": "Gird",
    "officename": "Baroni Datia S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gwalior Division"
  },
  "476001": {
    "state": "Madhya Pradesh",
    "district": "Morena",
    "block": "Morena",
    "officename": "Morena H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Morena Division"
  },
  "476111": {
    "state": "Madhya Pradesh",
    "district": "Morena",
    "block": "Ambah",
    "officename": "Ambah S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Morena Division"
  },
  "476115": {
    "state": "Madhya Pradesh",
    "district": "Morena",
    "block": "Porsa",
    "officename": "Porsa S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Morena Division"
  },
  "476134": {
    "state": "Madhya Pradesh",
    "district": "Morena",
    "block": "Ambah",
    "officename": "Dimni S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Morena Division"
  },
  "476219": {
    "state": "Madhya Pradesh",
    "district": "Morena",
    "block": "Joura",
    "officename": "Baghchini S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Morena Division"
  },
  "476221": {
    "state": "Madhya Pradesh",
    "district": "Morena",
    "block": "Joura",
    "officename": "Joura S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Morena Division"
  },
  "476224": {
    "state": "Madhya Pradesh",
    "district": "Morena",
    "block": "Kailaras",
    "officename": "Kelaras S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Morena Division"
  },
  "476228": {
    "state": "Madhya Pradesh",
    "district": "Morena",
    "block": "Joura",
    "officename": "Pahadgarh S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Morena Division"
  },
  "476229": {
    "state": "Madhya Pradesh",
    "district": "Morena",
    "block": "Sabalgarh",
    "officename": "Sabalgarh S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Morena Division"
  },
  "476332": {
    "state": "Madhya Pradesh",
    "district": "Sheopur",
    "block": "Bijaypur",
    "officename": "Bijaipur S.O (Sheopur",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shivpuri Division"
  },
  "476335": {
    "state": "Madhya Pradesh",
    "district": "Sheopur",
    "block": "Bijaypur",
    "officename": "Beerpur S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shivpuri Division"
  },
  "476337": {
    "state": "Madhya Pradesh",
    "district": "Sheopur",
    "block": "Sheopur",
    "officename": "Sheopur S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shivpuri Division"
  },
  "476339": {
    "state": "Madhya Pradesh",
    "district": "Sheopur",
    "block": "Sheopur",
    "officename": "Sheopur Baroda S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Morena Division"
  },
  "476355": {
    "state": "Madhya Pradesh",
    "district": "Sheopur",
    "block": "Karahal",
    "officename": "Karhal S.O (Sheopur",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shivpuri Division"
  },
  "476444": {
    "state": "Madhya Pradesh",
    "district": "Morena",
    "block": "Morena",
    "officename": "Banmore S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Morena Division"
  },
  "476554": {
    "state": "Madhya Pradesh",
    "district": "Morena",
    "block": "Ambah",
    "officename": "Khadiahar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Morena Division"
  },
  "477001": {
    "state": "Madhya Pradesh",
    "district": "Bhind",
    "block": "Bhind",
    "officename": "Bhind H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Morena Division"
  },
  "477105": {
    "state": "Madhya Pradesh",
    "district": "Bhind",
    "block": "Bhind",
    "officename": "Nai Zameen Bhind S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Morena Division"
  },
  "477111": {
    "state": "Madhya Pradesh",
    "district": "Bhind",
    "block": "Attair",
    "officename": "Attair S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Morena Division"
  },
  "477116": {
    "state": "Madhya Pradesh",
    "district": "Bhind",
    "block": "Gohad",
    "officename": "Gohad S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Morena Division"
  },
  "477117": {
    "state": "Madhya Pradesh",
    "district": "Bhind",
    "block": "Gohad",
    "officename": "Malanpur S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Morena Division"
  },
  "477222": {
    "state": "Madhya Pradesh",
    "district": "Bhind",
    "block": "Mehgoun",
    "officename": "Mau S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Morena Division"
  },
  "477227": {
    "state": "Madhya Pradesh",
    "district": "Bhind",
    "block": "Mehgoun",
    "officename": "Amayan S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Morena Division"
  },
  "477331": {
    "state": "Madhya Pradesh",
    "district": "Bhind",
    "block": "Bhind",
    "officename": "Umri S.O (Bhind",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Morena Division"
  },
  "477332": {
    "state": "Madhya Pradesh",
    "district": "Bhind",
    "block": "Bhind",
    "officename": "Akoda S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Morena Division"
  },
  "477333": {
    "state": "Madhya Pradesh",
    "district": "Bhind",
    "block": "Bhind",
    "officename": "Sagra S.O (Bhind",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Morena Division"
  },
  "477335": {
    "state": "Madhya Pradesh",
    "district": "Bhind",
    "block": "Ron",
    "officename": "Raun S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Morena Division"
  },
  "477441": {
    "state": "Madhya Pradesh",
    "district": "Bhind",
    "block": "Mihona",
    "officename": "Mihona S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Morena Division"
  },
  "477445": {
    "state": "Madhya Pradesh",
    "district": "Bhind",
    "block": "Lahar",
    "officename": "Lahar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Morena Division"
  },
  "477446": {
    "state": "Madhya Pradesh",
    "district": "Bhind",
    "block": "Lahar",
    "officename": "Aswar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Morena Division"
  },
  "477447": {
    "state": "Madhya Pradesh",
    "district": "Bhind",
    "block": "Lahar",
    "officename": "Daboh S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Morena Division"
  },
  "477449": {
    "state": "Madhya Pradesh",
    "district": "Bhind",
    "block": "Lahar",
    "officename": "Alampur S.O (Bhind",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Morena Division"
  },
  "477555": {
    "state": "Madhya Pradesh",
    "district": "Bhind",
    "block": "Ater",
    "officename": "Phoop S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Morena Division"
  },
  "477557": {
    "state": "Madhya Pradesh",
    "district": "Bhind",
    "block": "Mehgoun",
    "officename": "Mehgoun S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Morena Division"
  },
  "477566": {
    "state": "Madhya Pradesh",
    "district": "Bhind",
    "block": "Bhind",
    "officename": "Barhi S.O (Bhind",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Morena Division"
  },
  "477660": {
    "state": "Madhya Pradesh",
    "district": "Bhind",
    "block": "Mehgoun",
    "officename": "Gormi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Morena Division"
  },
  "480001": {
    "state": "Madhya Pradesh",
    "district": "Chhindwara",
    "block": "Chhindwara",
    "officename": "Chhindwara H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "480003": {
    "state": "Madhya Pradesh",
    "district": "Chhindwara",
    "block": "Pandhurna",
    "officename": "CHANDANGAON SO",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "480105": {
    "state": "Madhya Pradesh",
    "district": "Chhindwara",
    "block": "Sausar",
    "officename": "Mohgaon Haveli S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "480106": {
    "state": "Madhya Pradesh",
    "district": "Chhindwara",
    "block": "Pandhurna",
    "officename": "Sausar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "480107": {
    "state": "Madhya Pradesh",
    "district": "Chhindwara",
    "block": "Chhindwara",
    "officename": "Umaranala S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "480108": {
    "state": "Madhya Pradesh",
    "district": "Chhindwara",
    "block": "Sausar",
    "officename": "Lodhikheda S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "480109": {
    "state": "Madhya Pradesh",
    "district": "Chhindwara",
    "block": "Sausar",
    "officename": "Piplanarayanwar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "480110": {
    "state": "Madhya Pradesh",
    "district": "Chhindwara",
    "block": "Chaurai",
    "officename": "Chand S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "480111": {
    "state": "Madhya Pradesh",
    "district": "Chhindwara",
    "block": "Bichhua",
    "officename": "Bichhua S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "480112": {
    "state": "Madhya Pradesh",
    "district": "Chhindwara",
    "block": "Pandhurna",
    "officename": "MOHKHED SO",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "480115": {
    "state": "Madhya Pradesh",
    "district": "Chhindwara",
    "block": "Chourak",
    "officename": "Chourai S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "480221": {
    "state": "Madhya Pradesh",
    "district": "Chhindwara",
    "block": "Amarwara",
    "officename": "Amarwara S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "480223": {
    "state": "Madhya Pradesh",
    "district": "Chhindwara",
    "block": "Amarwara",
    "officename": "Singodi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "480224": {
    "state": "Madhya Pradesh",
    "district": "Chhindwara",
    "block": "Amarwara",
    "officename": "Harrai S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "480331": {
    "state": "Madhya Pradesh",
    "district": "Chhindwara",
    "block": "Chhindwara",
    "officename": "Saori Bazaar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "480334": {
    "state": "Madhya Pradesh",
    "district": "Chhindwara",
    "block": "Pandhurna",
    "officename": "Pandhurna S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "480337": {
    "state": "Madhya Pradesh",
    "district": "Chhindwara",
    "block": "Chhindwara",
    "officename": "Seoni Sausar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "480338": {
    "state": "Madhya Pradesh",
    "district": "Chhindwara",
    "block": "Pandhurna",
    "officename": "Teegaon S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "480441": {
    "state": "Madhya Pradesh",
    "district": "Chhindwara",
    "block": "Parasia",
    "officename": "Parasia S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "480447": {
    "state": "Madhya Pradesh",
    "district": "Chhindwara",
    "block": "Chandametta",
    "officename": "Chandametta S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "480449": {
    "state": "Madhya Pradesh",
    "district": "Chhindwara",
    "block": "Junnardeo",
    "officename": "Eklehra S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "480551": {
    "state": "Madhya Pradesh",
    "district": "Chhindwara",
    "block": "Junnardeo",
    "officename": "Junnardeo S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "480555": {
    "state": "Madhya Pradesh",
    "district": "Chhindwara",
    "block": "Parasia",
    "officename": "Damua S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "480557": {
    "state": "Madhya Pradesh",
    "district": "Chhindwara",
    "block": "Parasia",
    "officename": "Newton Chikhali S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "480559": {
    "state": "Madhya Pradesh",
    "district": "Chhindwara",
    "block": "Tamia",
    "officename": "Tamia S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Chhindwara Division"
  },
  "480661": {
    "state": "Madhya Pradesh",
    "district": "Seoni",
    "block": "Seoni",
    "officename": "Seoni H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Balaghat Division"
  },
  "480667": {
    "state": "Madhya Pradesh",
    "district": "Seoni",
    "block": "Barghat",
    "officename": "Barghat S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Balaghat Division"
  },
  "480771": {
    "state": "Madhya Pradesh",
    "district": "Seoni",
    "block": "Barghat",
    "officename": "Ari S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Balaghat Division"
  },
  "480880": {
    "state": "Madhya Pradesh",
    "district": "Seoni",
    "block": "Korai",
    "officename": "Korai S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Balaghat Division"
  },
  "480881": {
    "state": "Madhya Pradesh",
    "district": "Seoni",
    "block": "Korai",
    "officename": "Khawasa S.O (Seoni)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Balaghat Division"
  },
  "480882": {
    "state": "Madhya Pradesh",
    "district": "Seoni",
    "block": "Seoni",
    "officename": "Bandol S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Balaghat Division"
  },
  "480884": {
    "state": "Madhya Pradesh",
    "district": "Seoni",
    "block": "Lakhanadon",
    "officename": "Chhapara S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Balaghat Division"
  },
  "480886": {
    "state": "Madhya Pradesh",
    "district": "Seoni",
    "block": "Lakhnadon",
    "officename": "Lakhnadon S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Balaghat Division"
  },
  "480887": {
    "state": "Madhya Pradesh",
    "district": "Seoni",
    "block": "Lakhnadon",
    "officename": "Adegaon S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Balaghat Division"
  },
  "480888": {
    "state": "Madhya Pradesh",
    "district": "Seoni",
    "block": "Lakhanadon",
    "officename": "Dhuma S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Balaghat Division"
  },
  "480990": {
    "state": "Madhya Pradesh",
    "district": "Seoni",
    "block": "Seoni",
    "officename": "Kanhiwada S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Balaghat Division"
  },
  "480991": {
    "state": "Madhya Pradesh",
    "district": "Seoni",
    "block": "Keolari",
    "officename": "Khairapalari S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Balaghat Division"
  },
  "480994": {
    "state": "Madhya Pradesh",
    "district": "Seoni",
    "block": "Keolari",
    "officename": "Keolari S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Balaghat Division"
  },
  "480996": {
    "state": "Madhya Pradesh",
    "district": "Seoni",
    "block": "Keolari",
    "officename": "Ugli S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Balaghat Division"
  },
  "480997": {
    "state": "Madhya Pradesh",
    "district": "Seoni",
    "block": "Ghansore",
    "officename": "Ghansore S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Balaghat Division"
  },
  "480999": {
    "state": "Madhya Pradesh",
    "district": "Seoni",
    "block": "Ghansore",
    "officename": "Kahani S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Balaghat Division"
  },
  "481001": {
    "state": "Madhya Pradesh",
    "district": "Balaghat",
    "block": "Balaghat",
    "officename": "Balaghat H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Balaghat Division"
  },
  "481051": {
    "state": "Madhya Pradesh",
    "district": "Balaghat",
    "block": "Baihar",
    "officename": "Birsa S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Balaghat Division"
  },
  "481102": {
    "state": "Madhya Pradesh",
    "district": "Balaghat",
    "block": "Balaghat",
    "officename": "Bharveli S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Balaghat Division"
  },
  "481105": {
    "state": "Madhya Pradesh",
    "district": "Balaghat",
    "block": "Baihar",
    "officename": "Ukwa S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Balaghat Division"
  },
  "481111": {
    "state": "Madhya Pradesh",
    "district": "Balaghat",
    "block": "Baihar",
    "officename": "Baihar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Balaghat Division"
  },
  "481115": {
    "state": "Madhya Pradesh",
    "district": "Balaghat",
    "block": "Kirnapur",
    "officename": "Kirnapur S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Balaghat Division"
  },
  "481116": {
    "state": "Madhya Pradesh",
    "district": "Balaghat",
    "block": "Baihar",
    "officename": "Malanjkhand S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Balaghat Division"
  },
  "481117": {
    "state": "Madhya Pradesh",
    "district": "Balaghat",
    "block": "Baihar",
    "officename": "Garhi S.O (Balaghat)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Balaghat Division"
  },
  "481222": {
    "state": "Madhya Pradesh",
    "district": "Balaghat",
    "block": "Lanji",
    "officename": "Lanji S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Balaghat Division"
  },
  "481224": {
    "state": "Madhya Pradesh",
    "district": "Balaghat",
    "block": "Lanji",
    "officename": "Karanja S.O (Balaghat)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Balaghat Division"
  },
  "481226": {
    "state": "Madhya Pradesh",
    "district": "Balaghat",
    "block": "Khairlanji",
    "officename": "Hatta S.O (Balaghat)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Balaghat Division"
  },
  "481331": {
    "state": "Madhya Pradesh",
    "district": "Balaghat",
    "block": "Lalburra",
    "officename": "Waraseoni S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Balaghat Division"
  },
  "481332": {
    "state": "Madhya Pradesh",
    "district": "Balaghat",
    "block": "Katangi",
    "officename": "Budbuda S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Balaghat Division"
  },
  "481335": {
    "state": "Madhya Pradesh",
    "district": "Balaghat",
    "block": "Waraseoni",
    "officename": "Rampaily S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Balaghat Division"
  },
  "481337": {
    "state": "Madhya Pradesh",
    "district": "Balaghat",
    "block": "Khairlanji",
    "officename": "Khairlanji S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Balaghat Division"
  },
  "481441": {
    "state": "Madhya Pradesh",
    "district": "Balaghat",
    "block": "Lalbarra",
    "officename": "Lalbarra S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Balaghat Division"
  },
  "481445": {
    "state": "Madhya Pradesh",
    "district": "Balaghat",
    "block": "Katangi",
    "officename": "Katangi S.O (Balaghat)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Balaghat Division"
  },
  "481449": {
    "state": "Madhya Pradesh",
    "district": "Balaghat",
    "block": "Tirodi",
    "officename": "Tirodi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Balaghat Division"
  },
  "481551": {
    "state": "Madhya Pradesh",
    "district": "Balaghat",
    "block": "Balaghat",
    "officename": "Lamta S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Balaghat Division"
  },
  "481556": {
    "state": "Madhya Pradesh",
    "district": "Balaghat",
    "block": "Baihar",
    "officename": "Paraswada S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Balaghat Division"
  },
  "481661": {
    "state": "Madhya Pradesh",
    "district": "Mandla",
    "block": "Mandla",
    "officename": "Mandla H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Mandla Division"
  },
  "481662": {
    "state": "Madhya Pradesh",
    "district": "Mandla",
    "block": "Niwas",
    "officename": "Padariyanarayan Ganj S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Mandla Division"
  },
  "481663": {
    "state": "Madhya Pradesh",
    "district": "Mandla",
    "block": "Mandla",
    "officename": "Mohgaon S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Mandla Division"
  },
  "481664": {
    "state": "Madhya Pradesh",
    "district": "Mandla",
    "block": "Mandla",
    "officename": "Ghughri S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Mandla Division"
  },
  "481665": {
    "state": "Madhya Pradesh",
    "district": "Balaghat",
    "block": "Balaghat",
    "officename": "Maharajpur S.O (Mandla)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Mandla Division"
  },
  "481666": {
    "state": "Madhya Pradesh",
    "district": "Mandla",
    "block": "Mandla",
    "officename": "Beejadandi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Mandla Division"
  },
  "481668": {
    "state": "Madhya Pradesh",
    "district": "Mandla",
    "block": "Nainpur",
    "officename": "Pindrai S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Mandla Division"
  },
  "481672": {
    "state": "Madhya Pradesh",
    "district": "Mandla",
    "block": "Sahpura Niwas",
    "officename": "Chabi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Mandla Division"
  },
  "481768": {
    "state": "Madhya Pradesh",
    "district": "Mandla",
    "block": "Nainpur",
    "officename": "Chiraidongri S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Mandla Division"
  },
  "481771": {
    "state": "Madhya Pradesh",
    "district": "Mandla",
    "block": "Mandla",
    "officename": "Bamni S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Mandla Division"
  },
  "481776": {
    "state": "Madhya Pradesh",
    "district": "Mandla",
    "block": "Nainpur",
    "officename": "Nainpur S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Mandla Division"
  },
  "481778": {
    "state": "Madhya Pradesh",
    "district": "Dindori",
    "block": "Dindori",
    "officename": "Samnapur S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Mandla Division"
  },
  "481879": {
    "state": "Madhya Pradesh",
    "district": "Dindori",
    "block": "Dindori",
    "officename": "Shahpur S.O (Dindori)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Mandla Division"
  },
  "481880": {
    "state": "Madhya Pradesh",
    "district": "Dindori",
    "block": "Dindori",
    "officename": "Dindori S.O (Dindori)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Mandla Division"
  },
  "481882": {
    "state": "Madhya Pradesh",
    "district": "Dindori",
    "block": "Dindori",
    "officename": "Gadasarai S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Mandla Division"
  },
  "481884": {
    "state": "Madhya Pradesh",
    "district": "Dindori",
    "block": "Dindori",
    "officename": "Gorakhpur S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Mandla Division"
  },
  "481885": {
    "state": "Madhya Pradesh",
    "district": "Mandla",
    "block": "Niwas",
    "officename": "Niwas S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Mandla Division"
  },
  "481990": {
    "state": "Madhya Pradesh",
    "district": "Dindori",
    "block": "Shahpura",
    "officename": "Shahpura Niwas S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Mandla Division"
  },
  "481995": {
    "state": "Madhya Pradesh",
    "district": "Mandla",
    "block": "Bhuabichhiya",
    "officename": "Bhuabichhia S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Mandla Division"
  },
  "481996": {
    "state": "Madhya Pradesh",
    "district": "Mandla",
    "block": "Bhuabichhia",
    "officename": "Sijhora S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Mandla Division"
  },
  "481998": {
    "state": "Madhya Pradesh",
    "district": "Mandla",
    "block": "Bhua Bichhiya",
    "officename": "Anjania S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Mandla Division"
  },
  "482001": {
    "state": "Madhya Pradesh",
    "district": "Jabalpur",
    "block": "Jabalpur",
    "officename": "Jabalpur H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Jabalpur Division"
  },
  "482002": {
    "state": "Madhya Pradesh",
    "district": "Jabalpur",
    "block": "Jabalpur",
    "officename": "Jabalpur City S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Jabalpur Division"
  },
  "482003": {
    "state": "Madhya Pradesh",
    "district": "Jabalpur",
    "block": "Jabalpur",
    "officename": "Garha S.O (Jabalpur)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Jabalpur Division"
  },
  "482004": {
    "state": "Madhya Pradesh",
    "district": "Jabalpur",
    "block": "Jabalpur",
    "officename": "Adhartal S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Jabalpur Division"
  },
  "482005": {
    "state": "Madhya Pradesh",
    "district": "Jabalpur",
    "block": "Jabalpur",
    "officename": "Khamaria S.O (Jabalpur)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Jabalpur Division"
  },
  "482008": {
    "state": "Madhya Pradesh",
    "district": "Jabalpur",
    "block": "Jabalpur",
    "officename": "Vidyut Nagar S.O (Jabalpur)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Jabalpur Division"
  },
  "482009": {
    "state": "Madhya Pradesh",
    "district": "Jabalpur",
    "block": "Jabalpur",
    "officename": "Vehicle Factory S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Jabalpur Division"
  },
  "482010": {
    "state": "Madhya Pradesh",
    "district": "Jabalpur",
    "block": "Jabalpur",
    "officename": "Richhai S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Jabalpur Division"
  },
  "482011": {
    "state": "Madhya Pradesh",
    "district": "Jabalpur",
    "block": "Jabalpur",
    "officename": "Gokulpur S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Jabalpur Division"
  },
  "482020": {
    "state": "Madhya Pradesh",
    "district": "Jabalpur",
    "block": "Jabalpur",
    "officename": "Bilhari S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Jabalpur Division"
  },
  "482021": {
    "state": "Madhya Pradesh",
    "district": "Jabalpur",
    "block": "Jabalpur",
    "officename": "R.F.R.C. S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Jabalpur Division"
  },
  "482051": {
    "state": "Madhya Pradesh",
    "district": "Jabalpur",
    "block": "Jabalpur",
    "officename": "Bargi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Jabalpur Division"
  },
  "482056": {
    "state": "Madhya Pradesh",
    "district": "Jabalpur",
    "block": "Jabalpur",
    "officename": "Bargi Nagar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Jabalpur Division"
  },
  "483001": {
    "state": "Madhya Pradesh",
    "district": "Jabalpur",
    "block": "Jabalpur",
    "officename": "Barela S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Jabalpur Division"
  },
  "483053": {
    "state": "Madhya Pradesh",
    "district": "Jabalpur",
    "block": "Jabalpur",
    "officename": "Bheraghat S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Jabalpur Division"
  },
  "483105": {
    "state": "Madhya Pradesh",
    "district": "Jabalpur",
    "block": "Patan",
    "officename": "Katangi S.O (Jabalpur)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Jabalpur Division"
  },
  "483110": {
    "state": "Madhya Pradesh",
    "district": "Jabalpur",
    "block": "Kundam",
    "officename": "Kundam S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Jabalpur Division"
  },
  "483113": {
    "state": "Madhya Pradesh",
    "district": "Jabalpur",
    "block": "Patan",
    "officename": "Patan S.O (Jabalpur)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Jabalpur Division"
  },
  "483119": {
    "state": "Madhya Pradesh",
    "district": "Jabalpur",
    "block": "Patan",
    "officename": "Shahpura (Jabalpur) S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Jabalpur Division"
  },
  "483220": {
    "state": "Madhya Pradesh",
    "district": "Jabalpur",
    "block": "Jabalpur",
    "officename": "Panagar S.O (Jabalpur)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Jabalpur Division"
  },
  "483222": {
    "state": "Madhya Pradesh",
    "district": "Katni",
    "block": "Sihora",
    "officename": "Gosalpur S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Jabalpur Division"
  },
  "483225": {
    "state": "Madhya Pradesh",
    "district": "Katni",
    "block": "Sihora",
    "officename": "Sihora(MP) S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Jabalpur Division"
  },
  "483330": {
    "state": "Madhya Pradesh",
    "district": "Katni",
    "block": "Katni",
    "officename": "Bahori Band S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Jabalpur Division"
  },
  "483331": {
    "state": "Madhya Pradesh",
    "district": "Katni",
    "block": "Katni",
    "officename": "Bakal S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Jabalpur Division"
  },
  "483332": {
    "state": "Madhya Pradesh",
    "district": "Katni",
    "block": "Sihora",
    "officename": "Umaria Pan S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Jabalpur Division"
  },
  "483334": {
    "state": "Madhya Pradesh",
    "district": "Katni",
    "block": "Sihora",
    "officename": "Saroli Majhgawan S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Jabalpur Division"
  },
  "483336": {
    "state": "Madhya Pradesh",
    "district": "Katni",
    "block": "Sihora",
    "officename": "Majholi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Jabalpur Division"
  },
  "483440": {
    "state": "Madhya Pradesh",
    "district": "Jabalpur",
    "block": "Sihora",
    "officename": "Sleemnabad S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Jabalpur Division"
  },
  "483442": {
    "state": "Madhya Pradesh",
    "district": "Katni",
    "block": "Katni",
    "officename": "Niwar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Jabalpur Division"
  },
  "483501": {
    "state": "Madhya Pradesh",
    "district": "Katni",
    "block": "Katni",
    "officename": "Katni H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Jabalpur Division"
  },
  "483504": {
    "state": "Madhya Pradesh",
    "district": "Katni",
    "block": "Murwara",
    "officename": "Katni Cement Factory S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Jabalpur Division"
  },
  "483770": {
    "state": "Madhya Pradesh",
    "district": "Katni",
    "block": "Vijayaraghavgarh",
    "officename": "Barhi S.O (Katni)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Jabalpur Division"
  },
  "483773": {
    "state": "Madhya Pradesh",
    "district": "Katni",
    "block": "Katni",
    "officename": "Badwara S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Jabalpur Division"
  },
  "483775": {
    "state": "Madhya Pradesh",
    "district": "Katni",
    "block": "Ijayaraghavgarh.",
    "officename": "Vijayraghavgarh S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Jabalpur Division"
  },
  "483880": {
    "state": "Madhya Pradesh",
    "district": "Katni",
    "block": "Vijayaraghavgarh",
    "officename": "Kymore S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Jabalpur Division"
  },
  "483990": {
    "state": "Madhya Pradesh",
    "district": "Katni",
    "block": "Rithi",
    "officename": "Rithi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Jabalpur Division"
  },
  "484001": {
    "state": "Madhya Pradesh",
    "district": "Umaria",
    "block": "B. Pali",
    "officename": "Shahdol H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Shahdol Division"
  },
  "484110": {
    "state": "Madhya Pradesh",
    "district": "Shahdol",
    "block": "Sohagpur",
    "officename": "Burhar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Shahdol Division"
  },
  "484113": {
    "state": "Madhya Pradesh",
    "district": "Anuppur",
    "block": "Jaithari",
    "officename": "Venkatnagar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Shahdol Division"
  },
  "484114": {
    "state": "Madhya Pradesh",
    "district": "Shahdol",
    "block": "Sohagpur",
    "officename": "Dhanpuri S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Shahdol Division"
  },
  "484116": {
    "state": "Madhya Pradesh",
    "district": "Anuppur",
    "block": "Anuppur",
    "officename": "Amai Colliery S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Shahdol Division"
  },
  "484117": {
    "state": "Madhya Pradesh",
    "district": "Shahdol",
    "block": "Sohagpur",
    "officename": "Amlai Paper Mills S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Shahdol Division"
  },
  "484120": {
    "state": "Madhya Pradesh",
    "district": "Shahdol",
    "block": "Sohagpur",
    "officename": "S.K. Nagar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Shahdol Division"
  },
  "484220": {
    "state": "Madhya Pradesh",
    "district": "Anuppur",
    "block": "Anuppur",
    "officename": "Chachai S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Shahdol Division"
  },
  "484224": {
    "state": "Madhya Pradesh",
    "district": "Anuppur",
    "block": "Anuppur",
    "officename": "Anuppur S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Shahdol Division"
  },
  "484330": {
    "state": "Madhya Pradesh",
    "district": "Anuppur",
    "block": "Jaithari",
    "officename": "Jaithari S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Shahdol Division"
  },
  "484334": {
    "state": "Madhya Pradesh",
    "district": "Anuppur",
    "block": "Kotma",
    "officename": "Kotma S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Shahdol Division"
  },
  "484336": {
    "state": "Madhya Pradesh",
    "district": "Anuppur",
    "block": "Kotma",
    "officename": "Kotma Colliery S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Shahdol Division"
  },
  "484440": {
    "state": "Madhya Pradesh",
    "district": "Anuppur",
    "block": "Kotma",
    "officename": "Bijuri S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Shahdol Division"
  },
  "484444": {
    "state": "Madhya Pradesh",
    "district": "Anuppur",
    "block": "Kotma",
    "officename": "Jamuna Colliery S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Shahdol Division"
  },
  "484446": {
    "state": "Madhya Pradesh",
    "district": "Shahdol",
    "block": "Jaisinghnagar",
    "officename": "Rajnagar Colliery S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Shahdol Division"
  },
  "484551": {
    "state": "Madhya Pradesh",
    "district": "Umaria",
    "block": "Birsinghpur Pali",
    "officename": "Birsinghpur Pali S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Shahdol Division"
  },
  "484555": {
    "state": "Madhya Pradesh",
    "district": "Anuppur",
    "block": "Anuppur",
    "officename": "Nowrozabad S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Shahdol Division"
  },
  "484660": {
    "state": "Madhya Pradesh",
    "district": "Umaria",
    "block": "Umaria",
    "officename": "Chandia S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Shahdol Division"
  },
  "484661": {
    "state": "Madhya Pradesh",
    "district": "Umaria",
    "block": "Umaria",
    "officename": "Umaria S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Shahdol Division"
  },
  "484664": {
    "state": "Madhya Pradesh",
    "district": "Umaria",
    "block": "Umaria",
    "officename": "Bandhavgarh National Park S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Shahdol Division"
  },
  "484665": {
    "state": "Madhya Pradesh",
    "district": "Umaria",
    "block": "Bandhogarh",
    "officename": "Manpur S.O (Umaria)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Shahdol Division"
  },
  "484669": {
    "state": "Madhya Pradesh",
    "district": "Shahdol",
    "block": "Burhar",
    "officename": "Jaitpur S.O (Shahdol)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Shahdol Division"
  },
  "484770": {
    "state": "Madhya Pradesh",
    "district": "Shahdol",
    "block": "Sohagpur",
    "officename": "Gohparu S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Shahdol Division"
  },
  "484771": {
    "state": "Madhya Pradesh",
    "district": "Shahdol",
    "block": "Jaisinghnagar",
    "officename": "Jaisinghnagar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Shahdol Division"
  },
  "484774": {
    "state": "Madhya Pradesh",
    "district": "Shahdol",
    "block": "Beohari",
    "officename": "Beohari S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Shahdol Division"
  },
  "484776": {
    "state": "Madhya Pradesh",
    "district": "Shahdol",
    "block": "Beohari",
    "officename": "Bansagar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Shahdol Division"
  },
  "484881": {
    "state": "Madhya Pradesh",
    "district": "Anuppur",
    "block": "Pushparajgarh",
    "officename": "Rajendragram S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Shahdol Division"
  },
  "484886": {
    "state": "Madhya Pradesh",
    "district": "Anuppur",
    "block": "Pushparajgarh",
    "officename": "Amarkantak S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Shahdol Division"
  },
  "484887": {
    "state": "Madhya Pradesh",
    "district": "Anuppur",
    "block": "Pushprajgarh",
    "officename": "Igntu Amarkantak S.O.",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Shahdol Division"
  },
  "485001": {
    "state": "Madhya Pradesh",
    "district": "Satna",
    "block": "Raghurajnagar",
    "officename": "Satna H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Satna Division"
  },
  "485005": {
    "state": "Madhya Pradesh",
    "district": "Satna",
    "block": "Raghurajnagar",
    "officename": "Satna Birla Vikas S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Satna Division"
  },
  "485111": {
    "state": "Madhya Pradesh",
    "district": "Satna",
    "block": "Rampur-Baghelan",
    "officename": "Ramvan S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Satna Division"
  },
  "485112": {
    "state": "Madhya Pradesh",
    "district": "Satna",
    "block": "Raghurajnagar",
    "officename": "Babupur S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Satna Division"
  },
  "485113": {
    "state": "Madhya Pradesh",
    "district": "Satna",
    "block": "Raghurajnagar",
    "officename": "Madhogarh S.O (Satna)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Satna Division"
  },
  "485114": {
    "state": "Madhya Pradesh",
    "district": "Satna",
    "block": "Raghurajnagar",
    "officename": "Sagmania S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Satna Division"
  },
  "485115": {
    "state": "Madhya Pradesh",
    "district": "Satna",
    "block": "Rampur-Baghelan",
    "officename": "Rampur Baghelan S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Satna Division"
  },
  "485221": {
    "state": "Madhya Pradesh",
    "district": "Satna",
    "block": "Nagod",
    "officename": "Jaitwara S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Satna Division"
  },
  "485226": {
    "state": "Madhya Pradesh",
    "district": "Satna",
    "block": "Nagod",
    "officename": "Birsinghpur S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Satna Division"
  },
  "485331": {
    "state": "Madhya Pradesh",
    "district": "Satna",
    "block": "Nagod",
    "officename": "Majhgawan S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Satna Division"
  },
  "485334": {
    "state": "Madhya Pradesh",
    "district": "Satna",
    "block": "Raghurajnagar",
    "officename": "M G  G V chitrakoot S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Satna Division"
  },
  "485441": {
    "state": "Madhya Pradesh",
    "district": "Satna",
    "block": "Raghurajnagar",
    "officename": "Sohawal S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Satna Division"
  },
  "485446": {
    "state": "Madhya Pradesh",
    "district": "Satna",
    "block": "Nagod",
    "officename": "Nagod S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Satna Division"
  },
  "485447": {
    "state": "Madhya Pradesh",
    "district": "Satna",
    "block": "Nagod",
    "officename": "Singhpur S.O (Satna)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Satna Division"
  },
  "485551": {
    "state": "Madhya Pradesh",
    "district": "Satna",
    "block": "Nagod",
    "officename": "Jaso S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Satna Division"
  },
  "485661": {
    "state": "Madhya Pradesh",
    "district": "Satna",
    "block": "Unchehara",
    "officename": "Unchehara S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Satna Division"
  },
  "485666": {
    "state": "Madhya Pradesh",
    "district": "Satna",
    "block": "Raghurajnagar",
    "officename": "Kothi S.O (Satna)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Satna Division"
  },
  "485771": {
    "state": "Madhya Pradesh",
    "district": "Satna",
    "block": "Maihar",
    "officename": "Maihar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Satna Division"
  },
  "485772": {
    "state": "Madhya Pradesh",
    "district": "Satna",
    "block": "Maihar",
    "officename": "Sarlanagar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Satna Division"
  },
  "485773": {
    "state": "Madhya Pradesh",
    "district": "Satna",
    "block": "Maihar",
    "officename": "Amadara S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Satna Division"
  },
  "485774": {
    "state": "Madhya Pradesh",
    "district": "Satna",
    "block": "Amarpatan",
    "officename": "Nadan S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Satna Division"
  },
  "485775": {
    "state": "Madhya Pradesh",
    "district": "Satna",
    "block": "Amarpatan",
    "officename": "Amarpatan S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Satna Division"
  },
  "485778": {
    "state": "Madhya Pradesh",
    "district": "Satna",
    "block": "Amarpatan",
    "officename": "Kathaha S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Satna Division"
  },
  "485881": {
    "state": "Madhya Pradesh",
    "district": "Satna",
    "block": "Ramnagar",
    "officename": "Ramnagar S.O (Satna)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Satna Division"
  },
  "486001": {
    "state": "Madhya Pradesh",
    "district": "Rewa",
    "block": "Huzur",
    "officename": "Rewa H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486002": {
    "state": "Madhya Pradesh",
    "district": "Rewa",
    "block": "Huzur",
    "officename": "Rewa Engineering College S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486003": {
    "state": "Madhya Pradesh",
    "district": "Rewa",
    "block": "Huzur",
    "officename": "Rewa APSU S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486005": {
    "state": "Madhya Pradesh",
    "district": "Rewa",
    "block": "Huzur",
    "officename": "Rewa Bansagar Coloney S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486006": {
    "state": "Madhya Pradesh",
    "district": "Rewa",
    "block": "Huzur",
    "officename": "Chorahata S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486111": {
    "state": "Madhya Pradesh",
    "district": "Rewa",
    "block": "Sirmour",
    "officename": "Mangawan S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486114": {
    "state": "Madhya Pradesh",
    "district": "Rewa",
    "block": "Raipur - Karchuliyan",
    "officename": "Raipur Karchulion S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486115": {
    "state": "Madhya Pradesh",
    "district": "Rewa",
    "block": "Sirmour",
    "officename": "Garh S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486117": {
    "state": "Madhya Pradesh",
    "district": "Rewa",
    "block": "Teonthar",
    "officename": "Katra S.O (Rewa)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486123": {
    "state": "Madhya Pradesh",
    "district": "Rewa",
    "block": "Raipur - Karchuliyan",
    "officename": "Manikwar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486220": {
    "state": "Madhya Pradesh",
    "district": "Rewa",
    "block": "Teonthar",
    "officename": "Teonthar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486223": {
    "state": "Madhya Pradesh",
    "district": "Rewa",
    "block": "Teonthar",
    "officename": "Jawa S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486226": {
    "state": "Madhya Pradesh",
    "district": "Rewa",
    "block": "Teonthar",
    "officename": "Chak S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486331": {
    "state": "Madhya Pradesh",
    "district": "Rewa",
    "block": "Mauganj",
    "officename": "Mauganj S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486333": {
    "state": "Madhya Pradesh",
    "district": "Rewa",
    "block": "Mauganj",
    "officename": "Dhera S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486335": {
    "state": "Madhya Pradesh",
    "district": "Rewa",
    "block": "Hanumana",
    "officename": "Hanumana S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486338": {
    "state": "Madhya Pradesh",
    "district": "Rewa",
    "block": "Mauganj",
    "officename": "Raghunathganj S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486340": {
    "state": "Madhya Pradesh",
    "district": "Rewa",
    "block": "Teonthar",
    "officename": "Naigarhi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486341": {
    "state": "Madhya Pradesh",
    "district": "Rewa",
    "block": "Mauganj",
    "officename": "Deotalab S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486440": {
    "state": "Madhya Pradesh",
    "district": "Rewa",
    "block": "Sirmour",
    "officename": "Laxmanpur S.O (Rewa)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486441": {
    "state": "Madhya Pradesh",
    "district": "Rewa",
    "block": "Sirmour",
    "officename": "Baikunthpur S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486445": {
    "state": "Madhya Pradesh",
    "district": "Rewa",
    "block": "Sirmour",
    "officename": "Semariya S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486446": {
    "state": "Madhya Pradesh",
    "district": "Rewa",
    "block": "Sirmour",
    "officename": "Beeda S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486447": {
    "state": "Madhya Pradesh",
    "district": "Rewa",
    "block": "Teonthar",
    "officename": "Patehara S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486448": {
    "state": "Madhya Pradesh",
    "district": "Rewa",
    "block": "Sirmour",
    "officename": "Sirmour S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486450": {
    "state": "Madhya Pradesh",
    "district": "Rewa",
    "block": "Huzur",
    "officename": "Jaypee Nagar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486550": {
    "state": "Madhya Pradesh",
    "district": "Rewa",
    "block": "Huzur",
    "officename": "Govindgarh S.O (Rewa)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486553": {
    "state": "Madhya Pradesh",
    "district": "Rewa",
    "block": "Gurh",
    "officename": "Gurh S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486556": {
    "state": "Madhya Pradesh",
    "district": "Rewa",
    "block": "Teonthar",
    "officename": "Dabhaura S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486661": {
    "state": "Madhya Pradesh",
    "district": "Sidhi",
    "block": "Gopad Vanas",
    "officename": "Sidhi H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486666": {
    "state": "Madhya Pradesh",
    "district": "Sidhi",
    "block": "Majauli",
    "officename": "Majauli S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486669": {
    "state": "Madhya Pradesh",
    "district": "Sidhi",
    "block": "Majauli",
    "officename": "Madwas S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486670": {
    "state": "Madhya Pradesh",
    "district": "Sidhi",
    "block": "Sihawal",
    "officename": "Sihawal S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486675": {
    "state": "Madhya Pradesh",
    "district": "Sidhi",
    "block": "Sidhi",
    "officename": "Bahri S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486771": {
    "state": "Madhya Pradesh",
    "district": "Sidhi",
    "block": "Churhat",
    "officename": "Churhat S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486775": {
    "state": "Madhya Pradesh",
    "district": "Sidhi",
    "block": "Rampur Naikin",
    "officename": "Rampur Naikin S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486776": {
    "state": "Madhya Pradesh",
    "district": "Sidhi",
    "block": "Rampur Naikin",
    "officename": "Bharatpur S.O (Sidhi)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486881": {
    "state": "Madhya Pradesh",
    "district": "Sidhi",
    "block": "Devsar",
    "officename": "Jiawan S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486882": {
    "state": "Madhya Pradesh",
    "district": "Sidhi",
    "block": "Chitrangi",
    "officename": "Chitrangi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486884": {
    "state": "Madhya Pradesh",
    "district": "Sidhi",
    "block": "Gopadbanas",
    "officename": "Nigahi Project S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486885": {
    "state": "Madhya Pradesh",
    "district": "Singrauli",
    "block": "Singrauli",
    "officename": "Vindhyanagar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486886": {
    "state": "Madhya Pradesh",
    "district": "Sidhi",
    "block": "Singrauli Colliery",
    "officename": "Waidhan S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486887": {
    "state": "Madhya Pradesh",
    "district": "Singrauli",
    "block": "Singrauli",
    "officename": "Amlori Project S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486889": {
    "state": "Madhya Pradesh",
    "district": "Sidhi",
    "block": "Singrauli Colliery",
    "officename": "Singrauli Colliery S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486890": {
    "state": "Madhya Pradesh",
    "district": "Sidhi",
    "block": "Gopadbanas",
    "officename": "Jayant Colliery S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "486892": {
    "state": "Madhya Pradesh",
    "district": "Sidhi",
    "block": "Chitrangi",
    "officename": "Gorbi S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "487001": {
    "state": "Madhya Pradesh",
    "district": "Narsinghpur",
    "block": "Narsimhapur",
    "officename": "Narsinghpur H.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshangabad Division"
  },
  "487110": {
    "state": "Madhya Pradesh",
    "district": "Narsinghpur",
    "block": "Narsimhapur",
    "officename": "Singhpur S.O (Narsinghpur)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshangabad Division"
  },
  "487114": {
    "state": "Madhya Pradesh",
    "district": "Narsinghpur",
    "block": "Narsimhapur",
    "officename": "Karakbel S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshangabad Division"
  },
  "487118": {
    "state": "Madhya Pradesh",
    "district": "Narsinghpur",
    "block": "Narsimhapur",
    "officename": "Gotegaon S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshangabad Division"
  },
  "487221": {
    "state": "Madhya Pradesh",
    "district": "Narsinghpur",
    "block": "Narsimhapur",
    "officename": "Kareli S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshangabad Division"
  },
  "487225": {
    "state": "Madhya Pradesh",
    "district": "Narsinghpur",
    "block": "Gadarwara",
    "officename": "Amgaon Bada S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshangabad Division"
  },
  "487330": {
    "state": "Madhya Pradesh",
    "district": "Narsinghpur",
    "block": "Kareli",
    "officename": "Barman S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshangabad Division"
  },
  "487334": {
    "state": "Madhya Pradesh",
    "district": "Narsinghpur",
    "block": "Tendukheda",
    "officename": "Dobhi S.O (M.P Circle)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshangabad Division"
  },
  "487337": {
    "state": "Madhya Pradesh",
    "district": "Narsinghpur",
    "block": "Tendukheda",
    "officename": "Sagoni Tendukheda S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshangabad Division"
  },
  "487441": {
    "state": "Madhya Pradesh",
    "district": "Narsinghpur",
    "block": "Gadarwara",
    "officename": "Sihora S.O (Narsinghpur)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshangabad Division"
  },
  "487551": {
    "state": "Madhya Pradesh",
    "district": "Narsinghpur",
    "block": "Narsimhapur",
    "officename": "Gadarwara S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshangabad Division"
  },
  "487555": {
    "state": "Madhya Pradesh",
    "district": "Narsinghpur",
    "block": "Narsimhapur",
    "officename": "Kaudia S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshangabad Division"
  },
  "487661": {
    "state": "Madhya Pradesh",
    "district": "Narsinghpur",
    "block": "Narsimhapur",
    "officename": "Sainkheda S.O (Narsinghpur)",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshangabad Division"
  },
  "487770": {
    "state": "Madhya Pradesh",
    "district": "Narsinghpur",
    "block": "Gadarwara",
    "officename": "Chichli S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshangabad Division"
  },
  "487881": {
    "state": "Madhya Pradesh",
    "district": "Narsinghpur",
    "block": "Narsimhapur",
    "officename": "Sali Choka Road S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshangabad Division"
  },
  "488001": {
    "state": "Madhya Pradesh",
    "district": "Panna",
    "block": "Panna",
    "officename": "Panna MDG S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Satna Division"
  },
  "488050": {
    "state": "Madhya Pradesh",
    "district": "Panna",
    "block": "Panna",
    "officename": "Kakrehti S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Satna Division"
  },
  "488059": {
    "state": "Madhya Pradesh",
    "district": "Panna",
    "block": "Gunnor",
    "officename": "Gunour S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Satna Division"
  },
  "488220": {
    "state": "Madhya Pradesh",
    "district": "Panna",
    "block": "Ajaigarh",
    "officename": "Ajaigarh S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Satna Division"
  },
  "488222": {
    "state": "Madhya Pradesh",
    "district": "Panna",
    "block": "Panna",
    "officename": "Dharampur S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Satna Division"
  },
  "488333": {
    "state": "Madhya Pradesh",
    "district": "Panna",
    "block": "Devendra Nagar",
    "officename": "Devendra Nagar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Satna Division"
  },
  "488441": {
    "state": "Madhya Pradesh",
    "district": "Panna",
    "block": "Panna",
    "officename": "Amanganj S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Satna Division"
  },
  "488442": {
    "state": "Madhya Pradesh",
    "district": "Panna",
    "block": "Baldeogarh",
    "officename": "Simariya S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Satna Division"
  },
  "488443": {
    "state": "Madhya Pradesh",
    "district": "Panna",
    "block": "Raipura",
    "officename": "Raipura S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Satna Division"
  },
  "488446": {
    "state": "Madhya Pradesh",
    "district": "Panna",
    "block": "Pawai",
    "officename": "Pawai S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Satna Division"
  },
  "488448": {
    "state": "Madhya Pradesh",
    "district": "Panna",
    "block": "Pawai",
    "officename": "Shahnagar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Satna Division"
  },
  "490001": {
    "state": "Chattisgarh",
    "district": "Durg",
    "block": "Durg",
    "officename": "Bhilai 1 SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Durg Division"
  },
  "490006": {
    "state": "Chattisgarh",
    "district": "Durg",
    "block": "Durg",
    "officename": "Civic Centre Bhilai SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Durg Division"
  },
  "490009": {
    "state": "Chattisgarh",
    "district": "Durg",
    "block": "Durg",
    "officename": "Bhilai West SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Durg Division"
  },
  "490011": {
    "state": "Chattisgarh",
    "district": "Durg",
    "block": "Durg",
    "officename": "Khursipar Bhilai SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Durg Division"
  },
  "490020": {
    "state": "Chattisgarh",
    "district": "Durg",
    "block": "Durg",
    "officename": "Motilal Nehru Nagr Bhilai SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Durg Division"
  },
  "490021": {
    "state": "Chattisgarh",
    "district": "Durg",
    "block": "Durg",
    "officename": "Bhilai East SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Durg Division"
  },
  "490022": {
    "state": "Chattisgarh",
    "district": "Durg",
    "block": "Durg",
    "officename": "S A F Lines Bhilai SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Durg Division"
  },
  "490023": {
    "state": "Chattisgarh",
    "district": "Durg",
    "block": "Durg",
    "officename": "Supela Bhilai SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Durg Division"
  },
  "490024": {
    "state": "Chattisgarh",
    "district": "Durg",
    "block": "Durg",
    "officename": "Jamul Cement Works SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Durg Division"
  },
  "490025": {
    "state": "Chattisgarh",
    "district": "Durg",
    "block": "Durg",
    "officename": "Bhilai Marshalling Yard SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Durg Division"
  },
  "490026": {
    "state": "Chattisgarh",
    "district": "Durg",
    "block": "Durg",
    "officename": "I E Bhilai SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Durg Division"
  },
  "490036": {
    "state": "Chattisgarh",
    "district": "Durg",
    "block": "Dhamdha",
    "officename": "Nandini SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Durg Division"
  },
  "490042": {
    "state": "Chattisgarh",
    "district": "Durg",
    "block": "Patan",
    "officename": "Kumhari SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Durg Division"
  },
  "491001": {
    "state": "Chattisgarh",
    "district": "Durg",
    "block": "Durg",
    "officename": "Durg HO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Durg Division"
  },
  "491107": {
    "state": "Chattisgarh",
    "district": "Durg",
    "block": "Patan",
    "officename": "Utai SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Durg Division"
  },
  "491111": {
    "state": "Chattisgarh",
    "district": "Durg",
    "block": "Patan",
    "officename": "Patan SO Durg",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Durg Division"
  },
  "491221": {
    "state": "Chattisgarh",
    "district": "Durg",
    "block": "Gunderdehi",
    "officename": "Anda SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Durg Division"
  },
  "491222": {
    "state": "Chattisgarh",
    "district": "Durg",
    "block": "Gunderdehi",
    "officename": "Sikosa SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Durg Division"
  },
  "491223": {
    "state": "Chattisgarh",
    "district": "Durg",
    "block": "Gunderdehi",
    "officename": "Gunderdehi SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Durg Division"
  },
  "491225": {
    "state": "Chattisgarh",
    "district": "Durg",
    "block": "Gunderdehi",
    "officename": "Arjunda SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Durg Division"
  },
  "491226": {
    "state": "Chattisgarh",
    "district": "Durg",
    "block": "Balod",
    "officename": "Balod SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Durg Division"
  },
  "491227": {
    "state": "Chattisgarh",
    "district": "Durg",
    "block": "Gurur",
    "officename": "Gurur SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Durg Division"
  },
  "491228": {
    "state": "Chattisgarh",
    "district": "Durg",
    "block": "Dondi Awari",
    "officename": "Dallirajhara SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Durg Division"
  },
  "491229": {
    "state": "Chattisgarh",
    "district": "Rajnandgaon",
    "block": "Manpur",
    "officename": "Manpur SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rajnandgaon Division"
  },
  "491331": {
    "state": "Chattisgarh",
    "district": "Durg",
    "block": "Dhamdha",
    "officename": "Dhamdha SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Durg Division"
  },
  "491332": {
    "state": "Chattisgarh",
    "district": "Durg",
    "block": "Berla",
    "officename": "Berla SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Durg Division"
  },
  "491335": {
    "state": "Chattisgarh",
    "district": "Durg",
    "block": "Bemetara",
    "officename": "Bemetara SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Durg Division"
  },
  "491336": {
    "state": "Chattisgarh",
    "district": "Kawardha",
    "block": "Kawardha",
    "officename": "Dashrangpur SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rajnandgaon Division"
  },
  "491337": {
    "state": "Chattisgarh",
    "district": "Durg",
    "block": "Nawagarh",
    "officename": "Nawagarh SO Durg",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Durg Division"
  },
  "491338": {
    "state": "Chattisgarh",
    "district": "Durg",
    "block": "Saja",
    "officename": "Khamaria SO Durg",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Durg Division"
  },
  "491340": {
    "state": "Chattisgarh",
    "district": "Durg",
    "block": "Nandghat",
    "officename": "Nandghat SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Durg Division"
  },
  "491441": {
    "state": "Chattisgarh",
    "district": "Rajnandgaon",
    "block": "Dongargaon",
    "officename": "Rajnandgaon HO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rajnandgaon Division"
  },
  "491444": {
    "state": "Chattisgarh",
    "district": "Rajnandgaon",
    "block": "Rajnandgaon",
    "officename": "Ghumka SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rajnandgaon Division"
  },
  "491445": {
    "state": "Chattisgarh",
    "district": "Rajnandgaon",
    "block": "Dongargarh",
    "officename": "Dongargarh SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rajnandgaon Division"
  },
  "491557": {
    "state": "Chattisgarh",
    "district": "Rajnandgaon",
    "block": "Chhuria",
    "officename": "Chichola SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rajnandgaon Division"
  },
  "491558": {
    "state": "Chattisgarh",
    "district": "Rajnandgaon",
    "block": "Dongargaon",
    "officename": "Chhuria SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rajnandgaon Division"
  },
  "491559": {
    "state": "Chattisgarh",
    "district": "Kawardha",
    "block": "Pandaria",
    "officename": "Pandaria SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rajnandgaon Division"
  },
  "491661": {
    "state": "Chattisgarh",
    "district": "Rajnandgaon",
    "block": "Dongargaon",
    "officename": "Dongargaon SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rajnandgaon Division"
  },
  "491665": {
    "state": "Chattisgarh",
    "district": "Rajnandgaon",
    "block": "Ambagarh Chowk",
    "officename": "Ambagarh Chowki SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rajnandgaon Division"
  },
  "491666": {
    "state": "Chattisgarh",
    "district": "Rajnandgaon",
    "block": "Mohla",
    "officename": "Mohla SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rajnandgaon Division"
  },
  "491668": {
    "state": "Chattisgarh",
    "district": "Rajnandgaon",
    "block": "Ambagarh Chowki",
    "officename": "Bandha Bazar SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rajnandgaon Division"
  },
  "491771": {
    "state": "Chattisgarh",
    "district": "Durg",
    "block": "Dondi Lohara",
    "officename": "Dondi Lohara SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Durg Division"
  },
  "491881": {
    "state": "Chattisgarh",
    "district": "Rajnandgaon",
    "block": "Khairagarh",
    "officename": "Khairagarh Raj SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rajnandgaon Division"
  },
  "491885": {
    "state": "Chattisgarh",
    "district": "Rajnandgaon",
    "block": "Chhuikhadan",
    "officename": "Chhuikhadan SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rajnandgaon Division"
  },
  "491888": {
    "state": "Chattisgarh",
    "district": "Rajnandgaon",
    "block": "Khairagarh",
    "officename": "Gandai Pandaria SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rajnandgaon Division"
  },
  "491993": {
    "state": "Chattisgarh",
    "district": "Durg",
    "block": "Saja",
    "officename": "Saja SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Durg Division"
  },
  "491995": {
    "state": "Chattisgarh",
    "district": "Kawardha",
    "block": "Kawardha",
    "officename": "Kawardha SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rajnandgaon Division"
  },
  "492001": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Raipur",
    "officename": "Raipur HO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "492002": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Raipur",
    "officename": "Mantralaya Raipur SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "492003": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Baikunth",
    "officename": "Urla SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "492004": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Raipur",
    "officename": "Pandri SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "492005": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Raipur",
    "officename": "Vidhan Sabha SO Raipur",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "492008": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Raipur",
    "officename": "WRSColony SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "492009": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Raipur",
    "officename": "Raipur Ganj SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "492010": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Raipur",
    "officename": "Ravi Shankar University SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "492012": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Raipur",
    "officename": "Krishak Nagar SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "492013": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Baikunth",
    "officename": "Sunder Nagar SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "492014": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Raipur",
    "officename": "Saddu SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "492015": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Mana Camp",
    "officename": "Mana Camp SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "492099": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Dharsiwa",
    "officename": "Tatibandh SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "492101": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Mandi R Hasod",
    "officename": "Mandir Hasod SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "492109": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Panduka",
    "officename": "Panduka SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "492112": {
    "state": "Chattisgarh",
    "district": "Mahasamund",
    "block": "Mahasamund",
    "officename": "Sankra SO Mahasamund",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493101": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Simga",
    "officename": "Simga SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493111": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Manddar Cement Factory",
    "officename": "Mandhar Cement Factory SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493113": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Hathband",
    "officename": "Hathband SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493114": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Neora",
    "officename": "Tilda - Neora S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493116": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Baikunth",
    "officename": "Baikunth SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493118": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Bhatapara",
    "officename": "Bhatapara SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493195": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Hirmi",
    "officename": "Hirmi SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493196": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Grasim Vihar Rawan",
    "officename": "Grasim Vihar Rawan SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493221": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Baikunth",
    "officename": "Birgaon SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493222": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Bilaigarh",
    "officename": "Bhatgaon SO Raipur",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493225": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Kharora",
    "officename": "Kharora SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493228": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Pallari",
    "officename": "Pallari SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493229": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Watgan",
    "officename": "Watgan SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493331": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Rawan",
    "officename": "Rawan SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493332": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Baloda Bazar",
    "officename": "Baloda Bazar SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493335": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Kasdol",
    "officename": "Kasdol SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493338": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Bilaigarh",
    "officename": "Bilaigarh SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493344": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Katgi",
    "officename": "Katgi SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493441": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Arang",
    "officename": "Arang SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493445": {
    "state": "Chattisgarh",
    "district": "Mahasamund",
    "block": "Mahasamund",
    "officename": "Mahasamund SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493448": {
    "state": "Chattisgarh",
    "district": "Mahasamund",
    "block": "GP Village Bhotha",
    "officename": "Komakhan SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493449": {
    "state": "Chattisgarh",
    "district": "Mahasamund",
    "block": "Mahasamund",
    "officename": "Bagbahra SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493526": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Lawan",
    "officename": "Lawan SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493551": {
    "state": "Chattisgarh",
    "district": "Mahasamund",
    "block": "Pithora",
    "officename": "Pithora SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493554": {
    "state": "Chattisgarh",
    "district": "Mahasamund",
    "block": "Bsna",
    "officename": "Basna SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493555": {
    "state": "Chattisgarh",
    "district": "Mahasamund",
    "block": "Jagdishpur",
    "officename": "Jagdishpur SO Mahasamund",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493558": {
    "state": "Chattisgarh",
    "district": "Mahasamund",
    "block": "Saraipali",
    "officename": "Saraipali SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493559": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Sarsiwa",
    "officename": "Sarsiwa SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493661": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Abhanpur",
    "officename": "Abhanpur SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493662": {
    "state": "Chattisgarh",
    "district": "Dhamtari",
    "block": "Kurud",
    "officename": "Magarlod SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493663": {
    "state": "Chattisgarh",
    "district": "Dhamtari",
    "block": "Kurud",
    "officename": "Kurud SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493770": {
    "state": "Chattisgarh",
    "district": "Dhamtari",
    "block": "Kurud",
    "officename": "Bhakhara SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493773": {
    "state": "Chattisgarh",
    "district": "Dhamtari",
    "block": "Dhamtari",
    "officename": "Dhamtari SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493776": {
    "state": "Chattisgarh",
    "district": "Dhamtari",
    "block": "Rudri",
    "officename": "Rudri SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493778": {
    "state": "Chattisgarh",
    "district": "Dhamtari",
    "block": "Nagri",
    "officename": "Nagri SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493881": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Rajim",
    "officename": "Nawapara Rajim SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493885": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Rajim",
    "officename": "Rajim SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493887": {
    "state": "Chattisgarh",
    "district": "Gariaband",
    "block": "Gariaband",
    "officename": "Kopra SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493888": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Gariaband",
    "officename": "Mainpur SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493889": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Gariaband",
    "officename": "Gariaband SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493890": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Deobhog",
    "officename": "Deobhog SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493891": {
    "state": "Chattisgarh",
    "district": "Gariaband",
    "block": "Gariaband",
    "officename": "Gohrapadar SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493992": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Phingeshwar",
    "officename": "Phingeshwar SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "493996": {
    "state": "Chattisgarh",
    "district": "Raipur",
    "block": "Chhura",
    "officename": "Chhura SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "494001": {
    "state": "Chattisgarh",
    "district": "Bastar",
    "block": "Jagdalpur",
    "officename": "Jagdalpur H.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494010": {
    "state": "Chattisgarh",
    "district": "Bastar",
    "block": "Jagdalpur",
    "officename": "Lohandiguda S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494111": {
    "state": "Chattisgarh",
    "district": "Dantewada",
    "block": "Konta",
    "officename": "Sukma S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494114": {
    "state": "Chattisgarh",
    "district": "Dantewada",
    "block": "Konta",
    "officename": "Konta S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494115": {
    "state": "Chattisgarh",
    "district": "Dantewada",
    "block": "Konta",
    "officename": "Tongpal S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494122": {
    "state": "Chattisgarh",
    "district": "Dantewada",
    "block": "Konta",
    "officename": "Dornapal S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494221": {
    "state": "Chattisgarh",
    "district": "Bastar",
    "block": "Jagdalpur",
    "officename": "Asna S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494222": {
    "state": "Chattisgarh",
    "district": "Bastar",
    "block": "Jagdalpur",
    "officename": "Bakawand S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494223": {
    "state": "Chattisgarh",
    "district": "Bastar",
    "block": "Jagdalpur",
    "officename": "Bastar S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494224": {
    "state": "Chattisgarh",
    "district": "Bastar",
    "block": "Jagdalpur",
    "officename": "Bhanpuri S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494226": {
    "state": "Chattisgarh",
    "district": "Bastar",
    "block": "Kondagaon",
    "officename": "Kondagaon S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494228": {
    "state": "Chattisgarh",
    "district": "Bastar",
    "block": "Keshkal",
    "officename": "Pharasgaon S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494229": {
    "state": "Chattisgarh",
    "district": "Bastar",
    "block": "Keshkal",
    "officename": "Pharasgaon Camp S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494230": {
    "state": "Chattisgarh",
    "district": "Bastar",
    "block": "Keshkal",
    "officename": "Piprabahigaon S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494331": {
    "state": "Chattisgarh",
    "district": "Bastar",
    "block": "Keshkal",
    "officename": "Keshkal S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494333": {
    "state": "Chattisgarh",
    "district": "Kanker",
    "block": "Kanker",
    "officename": "Narharpur S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494334": {
    "state": "Chattisgarh",
    "district": "Kanker",
    "block": "Kanker",
    "officename": "Kanker H.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494335": {
    "state": "Chattisgarh",
    "district": "Kanker",
    "block": "Kanker",
    "officename": "Sarona S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494336": {
    "state": "Chattisgarh",
    "district": "Kanker",
    "block": "Kanker",
    "officename": "Lakhanpuri S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494337": {
    "state": "Chattisgarh",
    "district": "Kanker",
    "block": "Charama",
    "officename": "Charama S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494347": {
    "state": "Chattisgarh",
    "district": "Bastar",
    "block": "Keshkal",
    "officename": "Vishrampuri S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494441": {
    "state": "Chattisgarh",
    "district": "Dantewada",
    "block": "Danteawada",
    "officename": "Geedam S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494442": {
    "state": "Chattisgarh",
    "district": "Bastar",
    "block": "Jagdalpur",
    "officename": "Tokapal Rajoor S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494444": {
    "state": "Chattisgarh",
    "district": "Bijapur(CGH)",
    "block": "Bijapur",
    "officename": "Bijapur S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494446": {
    "state": "Chattisgarh",
    "district": "Bijapur(CGH)",
    "block": "Bhopalpatnam",
    "officename": "Bhopalpatnam S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494447": {
    "state": "Chattisgarh",
    "district": "Bijapur(CGH)",
    "block": "Bhopalpatnam",
    "officename": "Awapalli S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494448": {
    "state": "Chattisgarh",
    "district": "Bijapur(CGH)",
    "block": "Bhopalpatnam",
    "officename": "Madded S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494449": {
    "state": "Chattisgarh",
    "district": "Dantewada",
    "block": "Dantaewada",
    "officename": "Dantewada S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494450": {
    "state": "Chattisgarh",
    "district": "Bijapur(CGH)",
    "block": "Bijapur",
    "officename": "Bhairamgarh S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494552": {
    "state": "Chattisgarh",
    "district": "Dantewada",
    "block": "Dantewada",
    "officename": "Nakulnar S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494553": {
    "state": "Chattisgarh",
    "district": "Dantewada",
    "block": "Dantewada",
    "officename": "Bacheli S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494556": {
    "state": "Chattisgarh",
    "district": "Dantewada",
    "block": "Dantewada",
    "officename": "Kirandul S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494635": {
    "state": "Chattisgarh",
    "district": "Kanker",
    "block": "Bhanupratappur",
    "officename": "Sambalpur S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494661": {
    "state": "Chattisgarh",
    "district": "Narayanpur",
    "block": "Narayanpur",
    "officename": "Narayanpur S.O (Narayanpur)",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494665": {
    "state": "Chattisgarh",
    "district": "Kanker",
    "block": "Antagarh",
    "officename": "Antagarh S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494669": {
    "state": "Chattisgarh",
    "district": "Kanker",
    "block": "Bhaupratappur",
    "officename": "Bhanupratappur S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494670": {
    "state": "Chattisgarh",
    "district": "Kanker",
    "block": "Kanker",
    "officename": "Korar S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494771": {
    "state": "Chattisgarh",
    "district": "Kanker",
    "block": "Pakhanjore",
    "officename": "Chotekapsi S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494776": {
    "state": "Chattisgarh",
    "district": "Kanker",
    "block": "Pakhanjore",
    "officename": "Pakhanjore Camp S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494777": {
    "state": "Chattisgarh",
    "district": "Kanker",
    "block": "Pakhanjore",
    "officename": "Bandecolony S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "495001": {
    "state": "Chattisgarh",
    "district": "Bilaspur(CGH)",
    "block": "Bilaspur",
    "officename": "Bilaspur BilaspurCGH HO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495003": {
    "state": "Chattisgarh",
    "district": "Bilaspur(CGH)",
    "block": "Bilaspur",
    "officename": "Sakri",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495004": {
    "state": "Chattisgarh",
    "district": "Bilaspur(CGH)",
    "block": "Bilaspur",
    "officename": "Bilaspur RS SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495006": {
    "state": "Chattisgarh",
    "district": "Bilaspur(CGH)",
    "block": "Bilaspur",
    "officename": "South Eastern Coals Limited",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495009": {
    "state": "Chattisgarh",
    "district": "Bilaspur(CGH)",
    "block": "Koni",
    "officename": "Koni SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495112": {
    "state": "Chattisgarh",
    "district": "Bilaspur(CGH)",
    "block": "Ganiyari",
    "officename": "Ganiyari SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495113": {
    "state": "Chattisgarh",
    "district": "Bilaspur(CGH)",
    "block": "Kargi Road",
    "officename": "Kargi Road SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495115": {
    "state": "Chattisgarh",
    "district": "Bilaspur(CGH)",
    "block": "Lormi",
    "officename": "Lormi SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495116": {
    "state": "Chattisgarh",
    "district": "Bilaspur(CGH)",
    "block": "Kargiroad",
    "officename": "Belgahana SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495117": {
    "state": "Chattisgarh",
    "district": "Bilaspur(CGH)",
    "block": "Pendra Road",
    "officename": "Pendra Road SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495118": {
    "state": "Chattisgarh",
    "district": "Korba",
    "block": "Marwahi",
    "officename": "Marwahi SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495119": {
    "state": "Chattisgarh",
    "district": "Bilaspur(CGH)",
    "block": "Pendra",
    "officename": "Pendra SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495220": {
    "state": "Chattisgarh",
    "district": "Bilaspur(CGH)",
    "block": "Bilha",
    "officename": "Chakarbhata Camp SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495222": {
    "state": "Chattisgarh",
    "district": "Bilaspur(CGH)",
    "block": "Hirri Mines",
    "officename": "Hirri Mines SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495224": {
    "state": "Chattisgarh",
    "district": "Bilaspur(CGH)",
    "block": "Bilha",
    "officename": "Bilha SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495330": {
    "state": "Chattisgarh",
    "district": "Bilaspur(CGH)",
    "block": "Takhatpur",
    "officename": "Takhatpur SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495334": {
    "state": "Chattisgarh",
    "district": "Bilaspur(CGH)",
    "block": "Mungeli",
    "officename": "Mungeli SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495335": {
    "state": "Chattisgarh",
    "district": "Bilaspur(CGH)",
    "block": "Patharia",
    "officename": "Patharia SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495442": {
    "state": "Chattisgarh",
    "district": "Bilaspur(CGH)",
    "block": "Ratanpur",
    "officename": "Ratanpur SO Bilaspur",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495445": {
    "state": "Chattisgarh",
    "district": "Korba",
    "block": "Katghora",
    "officename": "Katghora SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495446": {
    "state": "Chattisgarh",
    "district": "Korba",
    "block": "Hardibazar",
    "officename": "Hardi Bazar SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495447": {
    "state": "Chattisgarh",
    "district": "Korba",
    "block": "Katghora",
    "officename": "Banki Mongra SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495448": {
    "state": "Chattisgarh",
    "district": "Korba",
    "block": "Machadoli",
    "officename": "PondiUproda SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495449": {
    "state": "Chattisgarh",
    "district": "Korba",
    "block": "Pali",
    "officename": "Pali SO Korba",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495450": {
    "state": "Chattisgarh",
    "district": "Korba",
    "block": "Jamnipali",
    "officename": "Jamnipali SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495452": {
    "state": "Chattisgarh",
    "district": "Korba",
    "block": "Korba",
    "officename": "Wcl Gevra Project SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495454": {
    "state": "Chattisgarh",
    "district": "Korba",
    "block": "Kusmunda",
    "officename": "Kusmunda Colliery SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495455": {
    "state": "Chattisgarh",
    "district": "Korba",
    "block": "Korba",
    "officename": "Balgi Project Korba SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495550": {
    "state": "Chattisgarh",
    "district": "Bilaspur(CGH)",
    "block": "Jairamnagar",
    "officename": "Jairam Nagar SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495551": {
    "state": "Chattisgarh",
    "district": "Bilaspur(CGH)",
    "block": "Masturi",
    "officename": "Masturi SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495552": {
    "state": "Chattisgarh",
    "district": "Bilaspur(CGH)",
    "block": "Dabhara",
    "officename": "Akaltara SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495553": {
    "state": "Chattisgarh",
    "district": "Janjgir-champa",
    "block": "Nariyara",
    "officename": "Nariyara SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495554": {
    "state": "Chattisgarh",
    "district": "Janjgir-champa",
    "block": "Pamgarh",
    "officename": "Pamgarh SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495555": {
    "state": "Chattisgarh",
    "district": "Bilaspur(CGH)",
    "block": "Bilaspur",
    "officename": "Ujwal Nagar SO Bilaspur",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495556": {
    "state": "Chattisgarh",
    "district": "Janjgir-champa",
    "block": "Kharod",
    "officename": "Kharod SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495557": {
    "state": "Chattisgarh",
    "district": "Janjgir-champa",
    "block": "Seorinarayan",
    "officename": "Seorinarayan SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495559": {
    "state": "Chattisgarh",
    "district": "Janjgir-champa",
    "block": "Baloda",
    "officename": "Baloda SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495660": {
    "state": "Chattisgarh",
    "district": "Janjgir-champa",
    "block": "Champa",
    "officename": "Bamhni Bazar SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495661": {
    "state": "Chattisgarh",
    "district": "Janjgir-champa",
    "block": "Champa",
    "officename": "Birra SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495663": {
    "state": "Chattisgarh",
    "district": "Janjgir-champa",
    "block": "Gopalnagar",
    "officename": "Gopal Nagar SO Chattisgarh Circle",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495668": {
    "state": "Chattisgarh",
    "district": "Janjgir-champa",
    "block": "Janjgir",
    "officename": "Janjgir HO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495671": {
    "state": "Chattisgarh",
    "district": "Janjgir-champa",
    "block": "Champa",
    "officename": "Champa SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495674": {
    "state": "Chattisgarh",
    "district": "Korba",
    "block": "Bhaisma",
    "officename": "Bhaisma SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495677": {
    "state": "Chattisgarh",
    "district": "Korba",
    "block": "Korba",
    "officename": "Korba HO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495682": {
    "state": "Chattisgarh",
    "district": "Korba",
    "block": "Manikpur",
    "officename": "Manikpur Colliery SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495683": {
    "state": "Chattisgarh",
    "district": "Korba",
    "block": "Rajgamar",
    "officename": "Rajgamar Colliery SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495684": {
    "state": "Chattisgarh",
    "district": "Korba",
    "block": "Balconagar",
    "officename": "Balco Nagar Korba SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495686": {
    "state": "Chattisgarh",
    "district": "Korba",
    "block": "Baradwar",
    "officename": "Saragaon SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495687": {
    "state": "Chattisgarh",
    "district": "Janjgir-champa",
    "block": "Sakti",
    "officename": "Baradwar SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495688": {
    "state": "Chattisgarh",
    "district": "Janjgir-champa",
    "block": "Dabhra",
    "officename": "Dabhra SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495689": {
    "state": "Chattisgarh",
    "district": "Janjgir-champa",
    "block": "Sakti",
    "officename": "Sakti SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495690": {
    "state": "Chattisgarh",
    "district": "Korba",
    "block": "Jaijaipur",
    "officename": "Jaijaipur SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495691": {
    "state": "Chattisgarh",
    "district": "Korba",
    "block": "Malkharoda",
    "officename": "Malkharoda SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495692": {
    "state": "Chattisgarh",
    "district": "Janjgir-champa",
    "block": "Chandrapur",
    "officename": "Chandrapur SO Janjgirchampa",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495695": {
    "state": "Chattisgarh",
    "district": "Janjgir-champa",
    "block": "Malkharoda",
    "officename": "Adbhar SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "496001": {
    "state": "Chattisgarh",
    "district": "Raigarh",
    "block": "Raigarh",
    "officename": "Raigarh HO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raigarh Division"
  },
  "496005": {
    "state": "Chattisgarh",
    "district": "Raigarh",
    "block": "Raigarh",
    "officename": "JSPL Patrapali SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raigarh Division"
  },
  "496100": {
    "state": "Chattisgarh",
    "district": "Raigarh",
    "block": "Raigarh",
    "officename": "Kondatarai SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raigarh Division"
  },
  "496107": {
    "state": "Chattisgarh",
    "district": "Raigarh",
    "block": "Raigarh",
    "officename": "Tamnar SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raigarh Division"
  },
  "496108": {
    "state": "Chattisgarh",
    "district": "Raigarh",
    "block": "Tamnar",
    "officename": "Urjanagar Telirampur SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raigarh Division"
  },
  "496109": {
    "state": "Chattisgarh",
    "district": "Raigarh",
    "block": "Gharghoda",
    "officename": "Punjipathra SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raigarh Division"
  },
  "496111": {
    "state": "Chattisgarh",
    "district": "Raigarh",
    "block": "Gharghoda",
    "officename": "Gharghoda SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raigarh Division"
  },
  "496113": {
    "state": "Chattisgarh",
    "district": "Raigarh",
    "block": "Raigarh",
    "officename": "Lailunga SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raigarh Division"
  },
  "496115": {
    "state": "Chattisgarh",
    "district": "Raigarh",
    "block": "Raigarh",
    "officename": "Rajpur RIH SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raigarh Division"
  },
  "496116": {
    "state": "Chattisgarh",
    "district": "Raigarh",
    "block": "Udaipur (Dharamjaigarh)",
    "officename": "Dharamjaigarh SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raigarh Division"
  },
  "496118": {
    "state": "Chattisgarh",
    "district": "Jashpur",
    "block": "Pathalgaon",
    "officename": "Pathalgaon SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raigarh Division"
  },
  "496220": {
    "state": "Chattisgarh",
    "district": "Jashpur",
    "block": "Jashpurnagar",
    "officename": "Ludeg SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raigarh Division"
  },
  "496223": {
    "state": "Chattisgarh",
    "district": "Jashpur",
    "block": "Pathalgaon",
    "officename": "Kansabel SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raigarh Division"
  },
  "496224": {
    "state": "Chattisgarh",
    "district": "Jashpur",
    "block": "Bagicha",
    "officename": "Bagicha SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raigarh Division"
  },
  "496225": {
    "state": "Chattisgarh",
    "district": "Jashpur",
    "block": "Pathalgaon",
    "officename": "Kunkuri SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raigarh Division"
  },
  "496227": {
    "state": "Chattisgarh",
    "district": "Jashpur",
    "block": "Kunkuri",
    "officename": "Tapkara SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raigarh Division"
  },
  "496242": {
    "state": "Chattisgarh",
    "district": "Jashpur",
    "block": "Kunkuri",
    "officename": "Farsabahar SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raigarh Division"
  },
  "496245": {
    "state": "Chattisgarh",
    "district": "Jashpur",
    "block": "Kunkuri",
    "officename": "Lawakera SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raigarh Division"
  },
  "496330": {
    "state": "Chattisgarh",
    "district": "Jashpur",
    "block": "Pathalgaon",
    "officename": "Manora SO Jashpur",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raigarh Division"
  },
  "496331": {
    "state": "Chattisgarh",
    "district": "Jashpur",
    "block": "Pathalgaon",
    "officename": "Jashpurnagar SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raigarh Division"
  },
  "496334": {
    "state": "Chattisgarh",
    "district": "Jashpur",
    "block": "Kunkuri",
    "officename": "Duldula SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raigarh Division"
  },
  "496336": {
    "state": "Chattisgarh",
    "district": "Jashpur",
    "block": "Pathalgaon",
    "officename": "Sanna SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raigarh Division"
  },
  "496338": {
    "state": "Chattisgarh",
    "district": "Jashpur",
    "block": "Pathalgaon",
    "officename": "Gholeng SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raigarh Division"
  },
  "496440": {
    "state": "Chattisgarh",
    "district": "Raigarh",
    "block": "Raigarh",
    "officename": "Pussore SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raigarh Division"
  },
  "496445": {
    "state": "Chattisgarh",
    "district": "Raigarh",
    "block": "Raigarh",
    "officename": "Sarangarh SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raigarh Division"
  },
  "496450": {
    "state": "Chattisgarh",
    "district": "Raigarh",
    "block": "Sarangarh",
    "officename": "Hardi SO Raigarh",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raigarh Division"
  },
  "496551": {
    "state": "Chattisgarh",
    "district": "Raigarh",
    "block": "Sarangarh",
    "officename": "Baramkela SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raigarh Division"
  },
  "496554": {
    "state": "Chattisgarh",
    "district": "Raigarh",
    "block": "Sarangarh",
    "officename": "Saria SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raigarh Division"
  },
  "496661": {
    "state": "Chattisgarh",
    "district": "Raigarh",
    "block": "Raigarh",
    "officename": "Kharsia SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raigarh Division"
  },
  "496665": {
    "state": "Chattisgarh",
    "district": "Raigarh",
    "block": "Udaipur (Dharamjaigarh)",
    "officename": "Chhal SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raigarh Division"
  },
  "497001": {
    "state": "Chattisgarh",
    "district": "Surguja",
    "block": "Ambikapur",
    "officename": "Ambikapur HO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "SURGUJA DIVISION"
  },
  "497101": {
    "state": "Chattisgarh",
    "district": "Surguja",
    "block": "Ambikapur",
    "officename": "Batouli SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "SURGUJA DIVISION"
  },
  "497111": {
    "state": "Chattisgarh",
    "district": "Surguja",
    "block": "Ambikapur",
    "officename": "Sitapur SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "SURGUJA DIVISION"
  },
  "497114": {
    "state": "Chattisgarh",
    "district": "Surguja",
    "block": "Ambikapur",
    "officename": "Pratapgarh SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "SURGUJA DIVISION"
  },
  "497116": {
    "state": "Chattisgarh",
    "district": "Surguja",
    "block": "Ambikapur",
    "officename": "Lakhanpur SO Surguja",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "SURGUJA DIVISION"
  },
  "497117": {
    "state": "Chattisgarh",
    "district": "Surguja",
    "block": "Lakhanpur",
    "officename": "Udaipur SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "SURGUJA DIVISION"
  },
  "497118": {
    "state": "Chattisgarh",
    "district": "Surguja",
    "block": "Surguja",
    "officename": "Rajpur SIJ SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "SURGUJA DIVISION"
  },
  "497119": {
    "state": "Chattisgarh",
    "district": "Surguja",
    "block": "Ambikapur",
    "officename": "Balrampur SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "SURGUJA DIVISION"
  },
  "497220": {
    "state": "Chattisgarh",
    "district": "Surguja",
    "block": "Ambikapur",
    "officename": "Ramanujganj SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "SURGUJA DIVISION"
  },
  "497223": {
    "state": "Chattisgarh",
    "district": "Surguja",
    "block": "Ambikapur",
    "officename": "Pratappur SO Surguja",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "SURGUJA DIVISION"
  },
  "497224": {
    "state": "Chattisgarh",
    "district": "Surguja",
    "block": "Ambikapur",
    "officename": "Kusmi SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "SURGUJA DIVISION"
  },
  "497225": {
    "state": "Chattisgarh",
    "district": "Surguja",
    "block": "Ambikapur",
    "officename": "Wadrafnagar SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "SURGUJA DIVISION"
  },
  "497226": {
    "state": "Chattisgarh",
    "district": "Surguja",
    "block": "Ambikapur",
    "officename": "Bishrampur SO Surguja",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "SURGUJA DIVISION"
  },
  "497229": {
    "state": "Chattisgarh",
    "district": "Surguja",
    "block": "Surajpur",
    "officename": "Surajpur SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "SURGUJA DIVISION"
  },
  "497231": {
    "state": "Chattisgarh",
    "district": "Surguja",
    "block": "Ambikapur",
    "officename": "Bhaiyathan SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "SURGUJA DIVISION"
  },
  "497235": {
    "state": "Chattisgarh",
    "district": "Surguja",
    "block": "Surajpur",
    "officename": "Bhatgaon Colly SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "SURGUJA DIVISION"
  },
  "497331": {
    "state": "Chattisgarh",
    "district": "Koriya",
    "block": "Baikunthapur",
    "officename": "Patna SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "SURGUJA DIVISION"
  },
  "497333": {
    "state": "Chattisgarh",
    "district": "Surguja",
    "block": "Ambikapur",
    "officename": "Ramanujnagar SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "SURGUJA DIVISION"
  },
  "497335": {
    "state": "Chattisgarh",
    "district": "Koriya",
    "block": "Baikunthapur",
    "officename": "Baikunthpur SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "SURGUJA DIVISION"
  },
  "497339": {
    "state": "Chattisgarh",
    "district": "Koriya",
    "block": "Baikunthapur",
    "officename": "Churcha Colly SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "SURGUJA DIVISION"
  },
  "497442": {
    "state": "Chattisgarh",
    "district": "Koriya",
    "block": "Manendragarh",
    "officename": "Manendragarh SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "SURGUJA DIVISION"
  },
  "497446": {
    "state": "Chattisgarh",
    "district": "Koriya",
    "block": "Manendragarh",
    "officename": "Jhagrakhand Colly SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "SURGUJA DIVISION"
  },
  "497447": {
    "state": "Chattisgarh",
    "district": "Koriya",
    "block": "Manendragarh",
    "officename": "West Jhagrakhand Colly SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "SURGUJA DIVISION"
  },
  "497448": {
    "state": "Chattisgarh",
    "district": "Koriya",
    "block": "Manendragarh",
    "officename": "South Jhagrakhand Colly SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "SURGUJA DIVISION"
  },
  "497449": {
    "state": "Chattisgarh",
    "district": "Koriya",
    "block": "Baikunthapur",
    "officename": "Chirimiri Colly SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "SURGUJA DIVISION"
  },
  "497451": {
    "state": "Chattisgarh",
    "district": "Koriya",
    "block": "Chirimiri",
    "officename": "Haldibadi SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "SURGUJA DIVISION"
  },
  "497553": {
    "state": "Chattisgarh",
    "district": "Koriya",
    "block": "Chirimiri",
    "officename": "Kurasia Colly SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "SURGUJA DIVISION"
  },
  "497555": {
    "state": "Chattisgarh",
    "district": "Koriya",
    "block": "Manendragarh",
    "officename": "Godripara SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "SURGUJA DIVISION"
  },
  "497557": {
    "state": "Chattisgarh",
    "district": "Koriya",
    "block": "Chirimiri",
    "officename": "Sonawani Colly SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "SURGUJA DIVISION"
  },
  "497559": {
    "state": "Chattisgarh",
    "district": "Koriya",
    "block": "Janakpur",
    "officename": "Korea Colly SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "SURGUJA DIVISION"
  },
  "497773": {
    "state": "Chattisgarh",
    "district": "Koriya",
    "block": "Manendragarh",
    "officename": "West Chirimiri SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "SURGUJA DIVISION"
  },
  "497778": {
    "state": "Chattisgarh",
    "district": "Koriya",
    "block": "Baikunthapur",
    "officename": "Janakpur SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "SURGUJA DIVISION"
  },
  "500001": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Nampally",
    "officename": "Hyderabad G.P.O.",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad GPO Division"
  },
  "500002": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Charminar",
    "officename": "Charminar H.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "500003": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Secunderabad",
    "officename": "Secunderabad H.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "500004": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Khairatabad",
    "officename": "Khairatabad H.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad City Division"
  },
  "500005": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Saroornagar",
    "officename": "Keshogiri S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "500006": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Asifnagar",
    "officename": "Karwan Sahu S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad City Division"
  },
  "500007": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Secunderabad",
    "officename": "Jama I Osmania S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "500008": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Rajendranagar",
    "officename": "Golconda S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad City Division"
  },
  "500009": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Tirumalagiri",
    "officename": "Manovikasnagar S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "500010": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Tirumalagiri",
    "officename": "Bolarum S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "500011": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Tirumalagiri",
    "officename": "Bowenpally S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "500012": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Nampally",
    "officename": "Begum Bazar S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "500013": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Amberpet",
    "officename": "Amberpet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "500014": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Tirumalagiri",
    "officename": "Hakimpet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "500015": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Tirumalagiri",
    "officename": "Trimulgherry H.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "500016": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Secunderabad",
    "officename": "Begumpet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "500017": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Secunderabad",
    "officename": "Lallaguda S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "500018": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Balanagar",
    "officename": "Sanathnagar I E S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad City Division"
  },
  "500019": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Serilingampally",
    "officename": "Lingampalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad City Division"
  },
  "500020": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Musheerabad",
    "officename": "Musheerabad (D) S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "500022": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Khairatabad",
    "officename": "Central Secretariat S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad City Division"
  },
  "500023": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Charminar",
    "officename": "Yakutpura S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "500024": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Charminar",
    "officename": "Sahifa S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "500026": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Secunderabad",
    "officename": "Nehrunagar S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "500027": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Himayathnagar",
    "officename": "Stn.Kachiguda S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "500028": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Asifnagar",
    "officename": "Humayunnagar S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad City Division"
  },
  "500029": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Himayathnagar",
    "officename": "Himayathnagar S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad City Division"
  },
  "500030": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Rajendranagar",
    "officename": "Rajendranagar S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "500031": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Golconda",
    "officename": "Ibrahim Bagh Lines S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad City Division"
  },
  "500032": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Seri Lingampally",
    "officename": "Manuu S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad City Division"
  },
  "500033": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Shaikpet",
    "officename": "Jubilee Hills S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad City Division"
  },
  "500034": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Khairatabad",
    "officename": "Banjara Hills S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad City Division"
  },
  "500035": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Saroornagar",
    "officename": "Saroornagar S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "500036": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Amberpet",
    "officename": "Malakpet Colony S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "500037": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Rangareddy",
    "officename": "Balanagar Township S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "500038": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Ameerpet",
    "officename": "Sanjeev Reddy Nagar S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad City Division"
  },
  "500039": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Hyderabad",
    "officename": "UPPAL H.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "500040": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Secunderabad",
    "officename": "Ie Moulali S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "500041": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Khairatabad",
    "officename": "Raj Bhawan S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad City Division"
  },
  "500042": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Tirumalagiri",
    "officename": "Hal S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "500043": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Tirumalagiri",
    "officename": "Airforce Academy S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "500044": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Musheerabad",
    "officename": "New Nallakunta S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "500045": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Khairatabad",
    "officename": "Yousufguda S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad City Division"
  },
  "500046": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Serilingampally",
    "officename": "CUC S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad City Division"
  },
  "500047": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Tirumalagiri",
    "officename": "Malkajgiri S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "500048": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Rajendranagar",
    "officename": "Hyderguda S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "500049": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Serilingampally",
    "officename": "Miyapur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "500050": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Tirumalagiri",
    "officename": "Chandanagar S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "500051": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Uppal",
    "officename": "Hindustan Cables S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "500052": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Rajendranagar",
    "officename": "S.V.P.N.P.A. S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "500053": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Charminar",
    "officename": "Falaknuma S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "500054": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Tirumalagiri",
    "officename": "HMT Township S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "500055": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Hyd",
    "officename": "IDA Jeedimetla S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "500056": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Tirumalagiri",
    "officename": "Ramakrishna Puram S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "500057": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Asifnagar",
    "officename": "Vijay Nagar Colony S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad City Division"
  },
  "500058": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Hyderabad",
    "officename": "Kanchanbagh S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "500059": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Hyderabad",
    "officename": "Saidabad S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "500060": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Saroornagar",
    "officename": "P and T Colony (Gaddiannaram) S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "500061": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Secunderabad",
    "officename": "Sitaphalmandi S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "500062": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Secunderabad",
    "officename": "Ecil S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "500064": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Hyderabad",
    "officename": "Bahadurpura S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "500065": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Charminar",
    "officename": "Shahalibanda S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "500066": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Charminar",
    "officename": "High Court S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "500067": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "NA",
    "officename": "Suchitra Junction S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "500068": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Hayathnagar",
    "officename": "G.S.I (S.R) Bandlaguda S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "500069": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Bandlaguda",
    "officename": "Research Centre Imarat S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "500070": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Hayathnagar",
    "officename": "Vanasthalipuram S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "500072": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Tirumalagiri",
    "officename": "Kukatpally S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "500073": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Khairatabad",
    "officename": "Srinagar Colony S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad City Division"
  },
  "500074": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Hyderabad",
    "officename": "Lal Bahadurnagar S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "500075": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Moinabad",
    "officename": "C.B.I.T S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad City Division"
  },
  "500076": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Uppal",
    "officename": "I.E.Nacharam S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "500077": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Rajendranagar",
    "officename": "Kattedan I.E. S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "500078": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Tirumalagiri",
    "officename": "Nisa Hakimpet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "500079": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Saroornagar",
    "officename": "Vaishalinagar S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "500080": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Secunderabad",
    "officename": "Gandhinagar S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "500081": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Shaikpet",
    "officename": "Cyberabad S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad City Division"
  },
  "500082": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Khairatabad",
    "officename": "Somajiguda S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad City Division"
  },
  "500083": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Rangareddy",
    "officename": "Dammaiguda SO",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "500084": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Serilingampally",
    "officename": "Kothaguda S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad City Division"
  },
  "500085": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Tirumalagiri",
    "officename": "Jntu Kukat Pally S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "500086": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Rajendranagar",
    "officename": "Don Bosco Nagar S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "500087": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Tirumalagiri",
    "officename": "JJ Nagar Colony S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "500088": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Secunderabad",
    "officename": "Samskruthi S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "500089": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "NA",
    "officename": "Manikonda S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad City Division"
  },
  "500090": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Qutubullapur",
    "officename": "Nizampet  S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "500091": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Rajendra Nagar",
    "officename": "Hydershahkote S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad City Division"
  },
  "500092": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Ghatkesar",
    "officename": "Boduppal S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "500094": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Tirumalagiri",
    "officename": "Sainikpuri S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "500096": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Shaikpet",
    "officename": "Film Nagar S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad City Division"
  },
  "500097": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "saroornagar",
    "officename": "Meerpet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "500098": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Ghatkesar",
    "officename": "Medipalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "500100": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Rangareddy",
    "officename": "Kompally S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "500101": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Hyd",
    "officename": "Shamirpet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "501101": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Hyd",
    "officename": "Vikarabad H.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "501102": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Vikarabad",
    "officename": "Allampalli S.O.",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "501106": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "R",
    "officename": "Kotpalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "501111": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Nawabpet",
    "officename": "Nawabpet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "501121": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Rangareddy",
    "officename": "Dharur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "501141": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Rangareddy",
    "officename": "Tandur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "501142": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Rangareddy",
    "officename": "Peddimal S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "501143": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Hyd",
    "officename": "Basheerabad S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "501144": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Rangareddy",
    "officename": "Yalal S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "501158": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Tandur",
    "officename": "CCI Tandur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "501202": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Rangareddy",
    "officename": "Mominpet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "501203": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Rangareddy",
    "officename": "Shankarpalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "501218": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Shamshabad",
    "officename": "Shamshabad S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "501301": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Hyd",
    "officename": "Ghatkesar S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "501359": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Rangareddy",
    "officename": "Mankhal S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "501401": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Rangareddy",
    "officename": "Medchal S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "501501": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Rangareddy",
    "officename": "Purgi S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "501502": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Rangareddy",
    "officename": "Bompalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "501503": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Rangareddy",
    "officename": "Chevella S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "501504": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Rangareddy",
    "officename": "Moinabad S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "501505": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Rangareddy",
    "officename": "Hayatnagar S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "501506": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Rangareddy",
    "officename": "Ibrahimpatnam S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "501508": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Rangareddy",
    "officename": "Raipole S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "501509": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Rangareddy",
    "officename": "Yacharam S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "501510": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Rangareddy",
    "officename": "Ragannaguda X Road S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "501512": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Rangareddy",
    "officename": "Ramoji Film City S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "502001": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Sangareddy",
    "officename": "Sangareddy H.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502032": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Ramachandrapuram",
    "officename": "Ramachandrapuram He S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502101": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Gujvail",
    "officename": "Ramayampet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Medak Division"
  },
  "502102": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Gujvail",
    "officename": "Nizampet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Medak Division"
  },
  "502103": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Siddipet",
    "officename": "Siddipet H.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Medak Division"
  },
  "502107": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Gujvail",
    "officename": "Pullur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Medak Division"
  },
  "502108": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Dubbak",
    "officename": "Dubbak S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Medak Division"
  },
  "502109": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Gujvail",
    "officename": "Machavaram S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Medak Division"
  },
  "502110": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Medak",
    "officename": "Medak H.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Medak Division"
  },
  "502113": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Gujvail",
    "officename": "Haveli Ghanpur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Medak Division"
  },
  "502114": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Gujvail",
    "officename": "Irkode S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Medak Division"
  },
  "502115": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Gujvail",
    "officename": "Akkannapet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Medak Division"
  },
  "502117": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Medak",
    "officename": "Rajpally S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Medak Division"
  },
  "502125": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Gujvail",
    "officename": "Podichanpally S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Medak Division"
  },
  "502130": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Gujvail",
    "officename": "Kuchanpally S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Medak Division"
  },
  "502205": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Sangareddy",
    "officename": "O.F.Yeddumailaram S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502210": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Zaheerabad",
    "officename": "Kohir S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502220": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Zaheerabad",
    "officename": "Zaheerabad H.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502221": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Zaheerabad",
    "officename": "Charakpally S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502228": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Zaheerabad",
    "officename": "Madhunagar S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502246": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Zaheerabad",
    "officename": "Zarasangam S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502247": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Gujvail",
    "officename": "Makkarajpet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Medak Division"
  },
  "502248": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Gujvail",
    "officename": "Narsingee S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Medak Division"
  },
  "502249": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Zaheerabad",
    "officename": "Mirzapur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502251": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Zaheerabad",
    "officename": "Hadnur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502255": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Gujvail",
    "officename": "Chegunta S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Medak Division"
  },
  "502256": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Zaheerabad",
    "officename": "Nyalkal S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502257": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Zaheerabad",
    "officename": "Raikode S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502267": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Gujvail",
    "officename": "Ibrahimnagar S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Medak Division"
  },
  "502269": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Alladurg",
    "officename": "Alladurg S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502270": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Jogipet",
    "officename": "Jogipet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502271": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Jogipet",
    "officename": "Shankarampet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502273": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Jogipet",
    "officename": "Andole S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502276": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Gujvail",
    "officename": "Kodurkurd S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Medak Division"
  },
  "502277": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Gujvail",
    "officename": "Duddeda S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Medak Division"
  },
  "502278": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Gujvail",
    "officename": "Gujvail S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Medak Division"
  },
  "502279": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Gujvail",
    "officename": "Pamulaparthy S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Medak Division"
  },
  "502280": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Gujvail",
    "officename": "Nangnoor S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Medak Division"
  },
  "502281": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Gujvail",
    "officename": "Jagadevpur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Medak Division"
  },
  "502285": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Sangareddy",
    "officename": "Kandi S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502286": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Narayankhed",
    "officename": "Narayankhed S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502287": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Narayankhed",
    "officename": "Sirgapur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502290": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Narayankhed",
    "officename": "Regode S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502291": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Sadasivpet",
    "officename": "Sadasivpet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502293": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Sangareddy",
    "officename": "Singoor Project S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502294": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Sangareddy",
    "officename": "Manjira Barrage S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502295": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Sangareddy",
    "officename": "P.R.Pally Chowrasta S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502296": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Sangareddy",
    "officename": "Ismailkhanpet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502300": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Patancheru",
    "officename": "Muthangi S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502301": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Gujvail",
    "officename": "Kuknoorpally S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Medak Division"
  },
  "502302": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Gujvail",
    "officename": "Tekmal S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Medak Division"
  },
  "502303": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Gujvail",
    "officename": "Papannapet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Medak Division"
  },
  "502305": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Patancheru",
    "officename": "Bdl Bhanur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502306": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Sangareddy",
    "officename": "Nandikandi S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502307": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Sangareddy",
    "officename": "IDA Pashamailaram S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502310": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Gujvail",
    "officename": "Allipur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Medak Division"
  },
  "502311": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Gujvail",
    "officename": "Pregnapur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Medak Division"
  },
  "502312": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Gujvail",
    "officename": "Kodakandla S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Medak Division"
  },
  "502313": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Narsapur",
    "officename": "Narsapur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502314": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Narsapur",
    "officename": "Sirpura S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502316": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Narsapur",
    "officename": "Kowdipally S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502318": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Zaheerabad",
    "officename": "Ranjhole S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502319": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Patancheru",
    "officename": "Patancheru S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502321": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Zaheerabad",
    "officename": "Digwal S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502324": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Patancheru",
    "officename": "Icrisat S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502325": {
    "state": "Telangana",
    "district": "Medak",
    "block": "R.c.puram",
    "officename": "Aie Bollaram S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502329": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Sangareddy",
    "officename": "Rudraram S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502331": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Gujvail",
    "officename": "Yousufpet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Medak Division"
  },
  "502334": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Gujvail",
    "officename": "Toopran S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Medak Division"
  },
  "502335": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Gujvail",
    "officename": "Masaipet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Medak Division"
  },
  "502336": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Gujvail",
    "officename": "Kadlakal S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Medak Division"
  },
  "502345": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Sadasivpet",
    "officename": "Kamkole S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502371": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Narayankhed",
    "officename": "Nizampet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502372": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Gujvail",
    "officename": "Kondapak S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Medak Division"
  },
  "502375": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Gujvail",
    "officename": "Palamakula S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Medak Division"
  },
  "502381": {
    "state": "Telangana",
    "district": "Medak",
    "block": "Gujvail",
    "officename": "Rangampet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Medak Division"
  },
  "503001": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Nizamabad",
    "officename": "Nizamabad H.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503002": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Nizamabad",
    "officename": "Subhashnagar S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503003": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Nizamabad",
    "officename": "Nizamabad RS S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503101": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Kamareddy",
    "officename": "Bhiknoor S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503102": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Kamareddy",
    "officename": "Jangampalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503108": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Kamareddy",
    "officename": "Nagireddypet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503110": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Kamareddy",
    "officename": "Rajampet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503111": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Kamareddy",
    "officename": "Kamareddy H.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503112": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Kamareddy",
    "officename": "Kamareddy RS S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503114": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Kamareddy",
    "officename": "Gandhari S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503120": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Kamareddy",
    "officename": "Yerrapahad S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503122": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Yellareddy",
    "officename": "Yellareddy S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503123": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Kamareddy",
    "officename": "Domakonda S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503124": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Kamareddy",
    "officename": "Lingampet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503125": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Kamareddy",
    "officename": "Bibipet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503144": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Kamareddy",
    "officename": "Ramareddy S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503145": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Kamareddy",
    "officename": "Sadasivanagar S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503164": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Dichpalle",
    "officename": "Indalwai RS S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503165": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Armoor",
    "officename": "Darpalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503174": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Armoor",
    "officename": "APSP Camp S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503175": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Armoor",
    "officename": "Dichpalli RS S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503180": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Nizamabad",
    "officename": "Shakkarnagar S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503185": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Bodhan",
    "officename": "Bodhan S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503186": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Nizamabad",
    "officename": "Sarangapur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503187": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Banswada",
    "officename": "Banswada S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503188": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Nizamabad",
    "officename": "Rudrur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503201": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Nizamabad",
    "officename": "Varni S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503202": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Yedpalle",
    "officename": "Edapalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503206": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Nizamabad",
    "officename": "Mosra S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503207": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Nizamabad",
    "officename": "Kotgir S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503212": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Armoor",
    "officename": "Nandipet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503213": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Dichpalle",
    "officename": "Makloor S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503217": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Armoor",
    "officename": "Balkonda S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503218": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Armoor",
    "officename": "Kissannagar S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503219": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Armoor",
    "officename": "Sriramsagar Project S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503223": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Nizamabad",
    "officename": "Zirayathnagar S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503224": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Nizamabad",
    "officename": "Armoor H.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503225": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Armoor",
    "officename": "Modtad S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503230": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Nizamabad",
    "officename": "Dharmaram S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503235": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Nizamabad",
    "officename": "Renjal S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503245": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Nizamabad",
    "officename": "Navipet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503246": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Nizamabad",
    "officename": "Jannepalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503301": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Nizamabad",
    "officename": "Mirzapur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503302": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Kamareddy",
    "officename": "Nizamsagar S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503305": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Nizamabad",
    "officename": "Jukkal S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503306": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Kamareddy",
    "officename": "Bichkunda S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503307": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Armoor",
    "officename": "Bhimgal S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503308": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Armoor",
    "officename": "Kammarpalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503309": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Madnoor",
    "officename": "Madnoor S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503310": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Kamareddy",
    "officename": "Pitlam S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503311": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Armoor",
    "officename": "Vailpur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503321": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Nizamabad",
    "officename": "Birkur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "503322": {
    "state": "Telangana",
    "district": "Nizamabad",
    "block": "Nizamabad",
    "officename": "Telangana University S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nizamabad Division"
  },
  "504001": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Adilabad",
    "officename": "Adilabad H.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504002": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Adilabad",
    "officename": "Dasnapur Colony  D.S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504101": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Mudhole",
    "officename": "Basar S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504102": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Mudhole",
    "officename": "Mudhole S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504103": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Mudhole",
    "officename": "Bhainsa S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504104": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Nirmal",
    "officename": "Narsapur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504105": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Nirmal",
    "officename": "Soan S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504106": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Nirmal",
    "officename": "Nirmal S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504107": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Mudhole",
    "officename": "RGU IIIT Campus Basar S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504109": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Nirmal",
    "officename": "Kuntala S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504110": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Nirmal",
    "officename": "Chincholi  S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504201": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Chennur",
    "officename": "Chinnoor S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504202": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Khanapur",
    "officename": "Peddur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504203": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Khanapur",
    "officename": "Khanapur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504204": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Chennur",
    "officename": "Bheemaram S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504205": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Luxettipet",
    "officename": "Jannaram S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504206": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Luxettipet",
    "officename": "Dandepalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504207": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Luxettipet",
    "officename": "Donabanda S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504208": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Mancherial",
    "officename": "Mancherial H.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504209": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Luxettipet",
    "officename": "Mancherial Cement Works S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504214": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Chennur",
    "officename": "Kotapalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504215": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Luxettipet",
    "officename": "Luxettipet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504216": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Chennur",
    "officename": "Jaipur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504218": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Luxettipet",
    "officename": "Devapur Cement Works S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504219": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Luxettipet",
    "officename": "Nennel S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504220": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Luxettipet",
    "officename": "Madaram Township S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504231": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Luxettipet",
    "officename": "Kalyani Khani S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504251": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Bellampalle",
    "officename": "Bellampalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504272": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Asifabad",
    "officename": "Tandur  S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504273": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Asifabad",
    "officename": "Rechini S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504292": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Asifabad",
    "officename": "Rebbena S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504293": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Asifabad",
    "officename": "Asifabad S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504294": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Asifabad",
    "officename": "Chirrakunta S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504295": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Asifabad",
    "officename": "Wankidi S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504296": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Sirpur (t)",
    "officename": "Sirpur Khagaznagar S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504297": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Asifabad",
    "officename": "Tiryani S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504299": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Kagaznagar",
    "officename": "Sirpur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504301": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Mandamarri",
    "officename": "Ramakrishnapur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504302": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Mancherial",
    "officename": "Coal Chemical Complex S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504303": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Mancherial",
    "officename": "Srirampur Colony S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504304": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Boath",
    "officename": "Boath S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504306": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Nirmal",
    "officename": "Dilawarpur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504307": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Boath",
    "officename": "Echoda S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504308": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Adilabad",
    "officename": "Gudihatnoor S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504309": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Adilabad",
    "officename": "Gumma S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504310": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Nirmal",
    "officename": "Mamda S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504311": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Utnoor",
    "officename": "Ootnur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504312": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Adilabad",
    "officename": "Tamsi S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504313": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Utnoor",
    "officename": "Jainoor S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504323": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Neradigonda",
    "officename": "Neradigonda S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "504346": {
    "state": "Telangana",
    "district": "Adilabad",
    "block": "Utnoor",
    "officename": "Indervelli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Adilabad Division"
  },
  "505001": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Karimnagar",
    "officename": "Karimnagar H.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505101": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Karimnagar",
    "officename": "Uppal S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505102": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Karimnagar",
    "officename": "Kamalapur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505122": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Karimnagar",
    "officename": "Jammikunta S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505129": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Karimnagar",
    "officename": "Khadeemabadi S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505152": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Karimnagar",
    "officename": "Pothkapalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505153": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Srirampur",
    "officename": "Kalvasrirampur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505162": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Karimnagar",
    "officename": "Kolanur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505172": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Peddapalli",
    "officename": "Peddapalli H.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505174": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Karimnagar",
    "officename": "P.P Colony S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505184": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Karimnagar",
    "officename": "Manthani S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505185": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Karimnagar",
    "officename": "Sultanabad S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505186": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Karimnagar",
    "officename": "Garrepalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505187": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Peddapalli",
    "officename": "Basanthnagar S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505188": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Karimnagar",
    "officename": "Kamanpur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505208": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Karimnagar",
    "officename": "Ramagundam S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505209": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Ramagundam",
    "officename": "Godavarikhani S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505210": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Karimnagar",
    "officename": "Fertilizercity S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505211": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Ramagundam",
    "officename": "Gv8incline S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505212": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Karimnagar",
    "officename": "Centanary Colony S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505214": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Peddapalli",
    "officename": "Vithalnagar S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505215": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Ramagundam",
    "officename": "Jyothinagar NTPC S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505301": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Sirsilla",
    "officename": "Sirsilla S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505302": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Vemulawada",
    "officename": "Vemulawada S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505303": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Kishandaspet",
    "officename": "Kishandaspet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505304": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Gambhiraopet",
    "officename": "Gambhiraopet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505305": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Yellareddipet",
    "officename": "Racherla Boppapur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505306": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Kathalapur",
    "officename": "Ambaripet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505307": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Chandurthi",
    "officename": "Rudrangi S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505325": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Metpalli",
    "officename": "Metpalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505326": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Koratla",
    "officename": "Koratla S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505327": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Jagtial",
    "officename": "Jagtial H.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505330": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Koratla",
    "officename": "Ailapur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505331": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Mallapur",
    "officename": "Muthyampet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505401": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Karimnagar",
    "officename": "Elgandal S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505402": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Ellanthakunta",
    "officename": "Ellanthakunta S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505403": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Vemulawada",
    "officename": "Marripalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505404": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Mustabad",
    "officename": "Mustabad S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505405": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Sirsilla",
    "officename": "Tadoor S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505415": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Choppadandi",
    "officename": "Choppadandi S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505416": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Dharmaram",
    "officename": "Dharmaram S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505425": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Dharmapuri",
    "officename": "Dharmapuri S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505445": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Gangadhara",
    "officename": "Gangadhara S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505450": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Ibrahimpatnam",
    "officename": "Ibrahimpatnam S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505451": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Ramadugu",
    "officename": "Kothapalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505452": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Pegadapalli",
    "officename": "Mallial S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505453": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Medpalli",
    "officename": "Medpalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505454": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Karimnagar",
    "officename": "Nerella S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505455": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Jagtial",
    "officename": "Pochampad Project Colony S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505460": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Raikal",
    "officename": "Raikal S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505462": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Kathalapur",
    "officename": "Sirikonda S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505466": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Husnabad",
    "officename": "Anthakpet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505467": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Chigurumamidi",
    "officename": "Husnabad S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505468": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Huzurabad",
    "officename": "Huzurabad H.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505469": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Manakondur",
    "officename": "Manakondur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505470": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Karimnagar",
    "officename": "Molangur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505471": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Bheemadevarpalle",
    "officename": "Mulkunur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505472": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Karimnagar",
    "officename": "Saidapur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505473": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Koheda",
    "officename": "Shanigaram S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505474": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Karimnagar",
    "officename": "Tadikal S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505475": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Karimnagar",
    "officename": "Vavilala S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505476": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Karimnagar",
    "officename": "Yelkathurthi S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505480": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Karimnagar",
    "officename": "Vangara S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505481": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Chigurumamidi",
    "officename": "Nustulapur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505490": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Karimnagar",
    "officename": "Keshavapatnam S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505497": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Huzurabad",
    "officename": "Bheemdevarpalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505498": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Karimnagar",
    "officename": "Kakatiya Cannal Campus S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505501": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Kodimial",
    "officename": "Kodimial S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505502": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Veenavanka",
    "officename": "Veenavanka S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505503": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Karimnagar",
    "officename": "Kataram S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505504": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Karimnagar",
    "officename": "Mahadeopur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505505": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Karimnagar",
    "officename": "Ootur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505514": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Ramagundam",
    "officename": "Anthergaon Textiles S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505524": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Boenpalli",
    "officename": "Boenpalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505525": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Karimnagar",
    "officename": "Elgaid S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "505526": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Karimnagar",
    "officename": "Endapalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505527": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Thimmapur",
    "officename": "Lower Manair Dam Colony S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505528": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Bejjanki",
    "officename": "Bejjanki S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505529": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Sarangapur",
    "officename": "Polas S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505530": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Ellanthakunta",
    "officename": "Thotapalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505531": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Pegadapalli",
    "officename": "Ramadugu S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505532": {
    "state": "Telangana",
    "district": "Karim Nagar",
    "block": "Gollapalli",
    "officename": "Gollapalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "506001": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Hanamkonda",
    "officename": "Hanamkonda H.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506002": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Warangal",
    "officename": "Warangal H.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Warangal Division"
  },
  "506003": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Hanamkonda",
    "officename": "Kazipet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506004": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Hanamkonda",
    "officename": "R E College S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506005": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Sangam",
    "officename": "Rangshaipet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Warangal Division"
  },
  "506006": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Hanamkonda",
    "officename": "Deshaipet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Warangal Division"
  },
  "506007": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Warangal",
    "officename": "K.M.College S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Warangal Division"
  },
  "506008": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Warangal",
    "officename": "Fort Warangal S.O.",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Warangal Division"
  },
  "506009": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Hanamkonda",
    "officename": "Vidyaranyapuri S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506011": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Hanamkonda",
    "officename": "D H Suthoon S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506013": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Warangal",
    "officename": "Laxmipur  S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Warangal Division"
  },
  "506015": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Hasanparthy",
    "officename": "K C Colony S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506101": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Mahabubabad",
    "officename": "Mahabubabad H.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Warangal Division"
  },
  "506102": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Mahabubabad",
    "officename": "New Abadi S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Warangal Division"
  },
  "506104": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Neerada",
    "officename": "Neerada S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Warangal Division"
  },
  "506105": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Kuravi",
    "officename": "Kuravi S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Warangal Division"
  },
  "506112": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Kesamudram",
    "officename": "Kesamudram S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Warangal Division"
  },
  "506122": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Nekkonda",
    "officename": "Nekkonda S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Warangal Division"
  },
  "506132": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Narsampet",
    "officename": "Narsampet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Warangal Division"
  },
  "506134": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Gudur",
    "officename": "Gudur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Warangal Division"
  },
  "506135": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Kothaguda",
    "officename": "Kothaguda S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Warangal Division"
  },
  "506142": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Dharmasagar",
    "officename": "Madikonda S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506143": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Zafargadh",
    "officename": "Ghanpur Station S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506144": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Jangaon",
    "officename": "Abadighanpur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506145": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Narmitta",
    "officename": "Malkapur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506151": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Dharmasagar",
    "officename": "Peddapendyal S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506163": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Turrur",
    "officename": "Turrur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Warangal Division"
  },
  "506164": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Parkal",
    "officename": "Parkal H.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506165": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Eturunagaram",
    "officename": "Eturunagaram S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506166": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Warangal",
    "officename": "Mamnoor S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Warangal Division"
  },
  "506167": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Jangaon",
    "officename": "Jangaon H.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506168": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Ghanpur (Mulug)",
    "officename": "Chelpur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506169": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Bhupalapalli",
    "officename": "Bhupalapalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506170": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Chityal",
    "officename": "KTPP S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506172": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Mangapet",
    "officename": "Kamalapur Town Ship S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506175": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Jangaon",
    "officename": "Jangaon Bazar S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506201": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Lingal Ghanpur",
    "officename": "Pembarthy S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506221": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Buchannapet",
    "officename": "Buchannapet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506222": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Palakurthy",
    "officename": "Kodakondla S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Warangal Division"
  },
  "506223": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Cherial",
    "officename": "Chiryal S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506224": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Narmetta",
    "officename": "Mustial S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506244": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Raghunathapalli",
    "officename": "Raghunath Pally S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506252": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Palakurthy",
    "officename": "Ippaguda S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506301": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Ghanpur Station",
    "officename": "Chagal S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506302": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Devaruppula",
    "officename": "Devaruppal S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506303": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Devaruppula",
    "officename": "Waddicherla Nawabpet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506310": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Wardhannapet",
    "officename": "Panthani S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Warangal Division"
  },
  "506313": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Wardhannapet",
    "officename": "Wardhannapet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Warangal Division"
  },
  "506314": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Raiparthy",
    "officename": "Raiparthy S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Warangal Division"
  },
  "506315": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Maripeda",
    "officename": "Maripeda S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Warangal Division"
  },
  "506316": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Zaffargadh",
    "officename": "Zaffargadh S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Warangal Division"
  },
  "506317": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Turrur",
    "officename": "Peddavangara S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Warangal Division"
  },
  "506318": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Kodakandal",
    "officename": "Waddekothapally S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Warangal Division"
  },
  "506319": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Regonda",
    "officename": "Shayampet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506324": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Narasimulapet",
    "officename": "Dantalapalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Warangal Division"
  },
  "506329": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Sangem",
    "officename": "Sangam S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Warangal Division"
  },
  "506330": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Geesugonda",
    "officename": "Dharmaram S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Warangal Division"
  },
  "506331": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Duggondi",
    "officename": "Togarrai S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Warangal Division"
  },
  "506332": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Chennaraopet",
    "officename": "Chennaraopet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Warangal Division"
  },
  "506342": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Atmakur",
    "officename": "Atmakur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506343": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Mulug",
    "officename": "Mulug S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506344": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Tadvai",
    "officename": "Govindaraopet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506345": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Regonda",
    "officename": "Ghanpur  S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506347": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Tadvai",
    "officename": "Pasra S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506348": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Regonda",
    "officename": "Regonda S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506349": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Mulug",
    "officename": "Mallampalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506352": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Mulug",
    "officename": "Jangalapally S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506355": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Cherial",
    "officename": "Marrimuchal S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506356": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Chityal",
    "officename": "Chityal S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506365": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Parvathagiri",
    "officename": "Parwathagiri S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Warangal Division"
  },
  "506366": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Mogullapalli",
    "officename": "Mogullapalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506367": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Narmetta",
    "officename": "Maddur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506368": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Nallikaddur",
    "officename": "Nallikaddur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Warangal Division"
  },
  "506369": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Nekkonda",
    "officename": "Redlawada S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Warangal Division"
  },
  "506370": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Hasanparthy",
    "officename": "Waddepalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506371": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Hasanparthy",
    "officename": "Hasanparthy S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506381": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Dornakal",
    "officename": "Dornakal S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Warangal Division"
  },
  "506391": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Parkal",
    "officename": "Nadikuda S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "507001": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Khammam (Urban)",
    "officename": "Khammam H.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507002": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Khammam",
    "officename": "Collectorate S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507003": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Khammam (Urban)",
    "officename": "Gandhichowk S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507101": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Kothagudem",
    "officename": "Kothagudem Colls H.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507103": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Vkhani",
    "officename": "Penagadapa B.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507111": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Bhadrachalam",
    "officename": "Bhadrachalam H.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507114": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Burgampahad",
    "officename": "Burgampahad S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507115": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Paloncha",
    "officename": "Paloncha S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507116": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Manuguru",
    "officename": "Hwp Aswapur Colony S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507117": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Manugurq",
    "officename": "Manuguru Colls S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507118": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Kothagudem",
    "officename": "Ramavaram S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507119": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Rudrampur",
    "officename": "Rudrampur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507120": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Sujathanagar",
    "officename": "Sujathanagar S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507122": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Karepalli",
    "officename": "Karepalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507123": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Yellandu",
    "officename": "Yellandu S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507124": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Kothagudem",
    "officename": "Yellandu Colls S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507125": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Manuguru",
    "officename": "P.V.Township S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507128": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Bhadrachalam",
    "officename": "Sarapaka S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507133": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Charla",
    "officename": "Charla S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507136": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Venkatapuram",
    "officename": "Venkatapuram S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507137": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Dummagudem",
    "officename": "Dummagudem S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507140": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Snpuram",
    "officename": "S.N.Puram S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507154": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Palwancha",
    "officename": "Siil Campus S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507157": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Palair",
    "officename": "Palair S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507158": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Gokinepalli",
    "officename": "Gokinepalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507159": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Kusumanchi",
    "officename": "Kusumanchi S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507160": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Nkpally",
    "officename": "Nelakondapalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507161": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Subled",
    "officename": "Subled S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507163": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "T. Palem",
    "officename": "Tirumalayapalem S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507164": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Vemsur",
    "officename": "Vemsur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507165": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Wyra",
    "officename": "Wyra S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507166": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Julurupadu",
    "officename": "Julurpahad S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507167": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Tallada",
    "officename": "Tallada S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507168": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Enkoor",
    "officename": "Enkoor S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507169": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Ch.madharam",
    "officename": "Cheruvumadharam S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507170": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Tallampahad",
    "officename": "Tallampahad S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507182": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Aswapuram",
    "officename": "Komminepalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507183": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Pindipole",
    "officename": "Pindipolu S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507201": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Yerrupalem",
    "officename": "Yerrupalem S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507202": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Bnpahad",
    "officename": "Banigandlapahad S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507203": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Aswapuram",
    "officename": "Madhira S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507204": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Bonnakal",
    "officename": "Bommakal S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507208": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Chintakani",
    "officename": "Chintakani S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507209": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Kallur",
    "officename": "Kallur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507210": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Garla",
    "officename": "Garla S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507211": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Aswapuram",
    "officename": "Bayyaram S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507301": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Aswaraopet",
    "officename": "Aswaraopet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507302": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Penuballi",
    "officename": "Penuballi S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507303": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Sathupalli",
    "officename": "Sathupalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507304": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Siripuram",
    "officename": "Siripuram S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507305": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Tanikella",
    "officename": "Tanikella S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507306": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Dammapeta",
    "officename": "Dammapeta S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507316": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "P.r.gudem",
    "officename": "Peddireddigudem S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507318": {
    "state": "Telangana",
    "district": "Khammam",
    "block": "Vvpalem",
    "officename": "V.V.Palem S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "508001": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Nalgonda",
    "officename": "Nalgonda H.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nalgonda Division"
  },
  "508002": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Nalgonda",
    "officename": "Ramagiri S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nalgonda Division"
  },
  "508004": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Nalgonda",
    "officename": "S.L.B.C Camp Colony Gandamvarigudem S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nalgonda Division"
  },
  "508101": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Alair",
    "officename": "Alir S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nalgonda Division"
  },
  "508105": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Nalgonda",
    "officename": "Raghunathpur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nalgonda Division"
  },
  "508111": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Nalgonda",
    "officename": "Atmakur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nalgonda Division"
  },
  "508112": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Nalgonda",
    "officename": "Valigonda S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nalgonda Division"
  },
  "508113": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Nalgodna",
    "officename": "Ramannapeta S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nalgonda Division"
  },
  "508114": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Nalgonda",
    "officename": "Chityala S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nalgonda Division"
  },
  "508115": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Nalgonda",
    "officename": "Yadgarpalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nalgonda Division"
  },
  "508116": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Bhongiri",
    "officename": "Bhongir H.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nalgonda Division"
  },
  "508117": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Nalgonda",
    "officename": "Bhongir Gunj S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nalgonda Division"
  },
  "508126": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Bibinagar",
    "officename": "Bibinagar S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nalgonda Division"
  },
  "508201": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Huzurnagar",
    "officename": "Garidepally S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Suryapet Division"
  },
  "508202": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Nalgonda",
    "officename": "Hillcolony S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nalgonda Division"
  },
  "508204": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Huzurnagar",
    "officename": "Huzurnagar S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Suryapet Division"
  },
  "508205": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Nalgonda",
    "officename": "Kattangur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Suryapet Division"
  },
  "508206": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Nalgonda",
    "officename": "Kodad S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Suryapet Division"
  },
  "508207": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Miryalguda",
    "officename": "Miryalguda H.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Suryapet Division"
  },
  "508208": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Miryalguda",
    "officename": "NSP Camp Miryalaguda S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Suryapet Division"
  },
  "508210": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Nakrekal",
    "officename": "Vallala S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Suryapet Division"
  },
  "508211": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Nakrekal",
    "officename": "Nakrekal S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Suryapet Division"
  },
  "508212": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Suryapet",
    "officename": "Sirikonda S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Suryapet Division"
  },
  "508213": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Suryapet",
    "officename": "Suryapet H.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Suryapet Division"
  },
  "508217": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Miryalguda",
    "officename": "Vemulapally S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Suryapet Division"
  },
  "508218": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Miryalguda",
    "officename": "Nereducharla S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Suryapet Division"
  },
  "508221": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Thungathurthy",
    "officename": "Noothankal S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Suryapet Division"
  },
  "508223": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Thungathurthi",
    "officename": "Tirumalgiri S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Suryapet Division"
  },
  "508224": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Suryapet",
    "officename": "Arvapalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Suryapet Division"
  },
  "508233": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Huzurnagar",
    "officename": "Munagala S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Suryapet Division"
  },
  "508234": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Huzurnagar",
    "officename": "Nadigudem S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Suryapet Division"
  },
  "508238": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Huzurnagar",
    "officename": "Gudibanda S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Suryapet Division"
  },
  "508243": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Nalgonda",
    "officename": "Kondamallepalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nalgonda Division"
  },
  "508244": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Munugode",
    "officename": "Munugode S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nalgonda Division"
  },
  "508245": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Nalgonda",
    "officename": "Marriguda S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nalgonda Division"
  },
  "508246": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Huzurnagar",
    "officename": "Medlacheruvu S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Suryapet Division"
  },
  "508247": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Nalgonda",
    "officename": "Thipparthi S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Suryapet Division"
  },
  "508248": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Nalgonda",
    "officename": "Devarakonda S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nalgonda Division"
  },
  "508250": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Nalgonda",
    "officename": "Chintapalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nalgonda Division"
  },
  "508252": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Nalgonda",
    "officename": "Choutuppala S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nalgonda Division"
  },
  "508253": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Nalgonda",
    "officename": "Narayanpur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nalgonda Division"
  },
  "508254": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Nalgonda",
    "officename": "Narkatpalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nalgonda Division"
  },
  "508255": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Chandur",
    "officename": "Chandur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nalgonda Division"
  },
  "508256": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Nalgonda",
    "officename": "Gurrampode S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nalgonda Division"
  },
  "508257": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Nalgonda",
    "officename": "Gudipally S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nalgonda Division"
  },
  "508258": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Nalgonda",
    "officename": "Dindi Project S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nalgonda Division"
  },
  "508266": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Nalgonda",
    "officename": "Pedavoora S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nalgonda Division"
  },
  "508277": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Nalgodna",
    "officename": "Mothcore S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nalgonda Division"
  },
  "508278": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Miryalguda",
    "officename": "Nidamanoor S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Suryapet Division"
  },
  "508279": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Thungathurthy",
    "officename": "Nagaram S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Suryapet Division"
  },
  "508280": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Thungathurthi",
    "officename": "Thungathurthi S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Suryapet Division"
  },
  "508284": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Nalgonda",
    "officename": "Pochampalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nalgonda Division"
  },
  "508285": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Nalgonda",
    "officename": "Tekulasomaram S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nalgonda Division"
  },
  "508286": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Nalgonda",
    "officename": "Wangapalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nalgonda Division"
  },
  "508355": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Miryalguda",
    "officename": "Wadapally S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Suryapet Division"
  },
  "508373": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Nalgonda",
    "officename": "Nampalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nalgonda Division"
  },
  "508374": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Miryalguda",
    "officename": "Madgulapally S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Suryapet Division"
  },
  "508376": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Suryapet",
    "officename": "Tekumatla S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Suryapet Division"
  },
  "508377": {
    "state": "Telangana",
    "district": "Nalgonda",
    "block": "Nalgonda",
    "officename": "Halia S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Nalgonda Division"
  },
  "509001": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Mahabubnagar H.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Mahabubnagar Division"
  },
  "509002": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Ind. Estate S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Mahabubnagar Division"
  },
  "509102": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Kodair",
    "officename": "Kollapur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509103": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Wanaparthy",
    "officename": "Wanaparthy H.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509104": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Veepangandla",
    "officename": "Pebbair S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509105": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Pentlavally S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509106": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Wanapathy",
    "officename": "Gandhichowk",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509110": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Kothakota",
    "officename": "Madanapuram S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509120": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Pangal",
    "officename": "Srirangapur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509125": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Gadwal",
    "officename": "Gadwal H.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Mahabubnagar Division"
  },
  "509126": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Rajoli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Mahabubnagar Division"
  },
  "509127": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Ieeja S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Mahabubnagar Division"
  },
  "509128": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Manavapad S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Mahabubnagar Division"
  },
  "509129": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Macherla S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Mahabubnagar Division"
  },
  "509130": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Amerchinta S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Mahabubnagar Division"
  },
  "509131": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Atmacore S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Mahabubnagar Division"
  },
  "509132": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Muldakal S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Mahabubnagar Division"
  },
  "509133": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Krishna Nagar S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Mahabubnagar Division"
  },
  "509135": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Uppal Camp S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Mahabubnagar Division"
  },
  "509152": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Alampur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Mahabubnagar Division"
  },
  "509153": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Undavelly S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Mahabubnagar Division"
  },
  "509201": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Amrabad",
    "officename": "Amrabad S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509202": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Farooqnagar",
    "officename": "Balanagar S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509203": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Bijnapally",
    "officename": "Bijnapally S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509204": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Devarkadra S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Mahabubnagar Division"
  },
  "509205": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Dhanwada S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Mahabubnagar Division"
  },
  "509206": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Gopalpet",
    "officename": "Gopalpet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509207": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Kondurgu",
    "officename": "Kondurgu S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509208": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Makthal S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Mahabubnagar Division"
  },
  "509209": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Tadoor",
    "officename": "Nagarkurnool S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509210": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Narayanpet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Mahabubnagar Division"
  },
  "509215": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Tadoor",
    "officename": "Palem S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509216": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Farooqnagar",
    "officename": "Shadnagar S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509217": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Shahabad",
    "officename": "Shahabad S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509219": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Koukuntla S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Mahabubnagar Division"
  },
  "509228": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Kothur",
    "officename": "Kothur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509235": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Nagarkurnool",
    "officename": "Thoodukurthy S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509301": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Stn. Jadcherla",
    "officename": "Stn. Jadcherla H.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509302": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Thimmajipet",
    "officename": "Town Jadcherla S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509311": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Utkur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Mahabubnagar Division"
  },
  "509320": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Talakondapally",
    "officename": "Marchala S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509321": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Amangal",
    "officename": "Amangal S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509324": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Vangoor",
    "officename": "Kalwakurthy S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509325": {
    "state": "Telangana",
    "district": "K.V.Rangareddy",
    "block": "Maheswaram",
    "officename": "Palmakole S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509326": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Amrabad",
    "officename": "Srisailam Dam  S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509327": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Madgul",
    "officename": "Madgul S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509334": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Hunwada S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Mahabubnagar Division"
  },
  "509335": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Kulakcherla S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Mahabubnagar Division"
  },
  "509336": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Rawulapally S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Mahabubnagar Division"
  },
  "509337": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Mohammadabad S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Mahabubnagar Division"
  },
  "509338": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Kodangal S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Mahabubnagar Division"
  },
  "509339": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Kosgi S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Mahabubnagar Division"
  },
  "509340": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Nawabpet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Mahabubnagar Division"
  },
  "509349": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Vangoor",
    "officename": "Vangoor S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509350": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Husnabad S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Mahabubnagar Division"
  },
  "509351": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Marrikal S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Mahabubnagar Division"
  },
  "509352": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Krishna S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Mahabubnagar Division"
  },
  "509353": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Jaklair S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Mahabubnagar Division"
  },
  "509357": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Midjil S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509358": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Amangal",
    "officename": "Kadthal S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509360": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Veldanda",
    "officename": "Veldanda S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509371": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Koilkonda S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Mahabubnagar Division"
  },
  "509375": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Achampet",
    "officename": "Achampet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509376": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Uppanunthala",
    "officename": "Uppununthala S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509380": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Musapet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Mahabubnagar Division"
  },
  "509381": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Kothakota",
    "officename": "Kothakota S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509382": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Bhutpur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Mahabubnagar Division"
  },
  "509385": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Thelkapally",
    "officename": "Thelkapally S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509401": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Lingala",
    "officename": "Lingala S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509406": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Thimmajipet",
    "officename": "Thimmajipet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509407": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Damargidda S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Mahabubnagar Division"
  },
  "509408": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Keshampet",
    "officename": "Keshampet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509409": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Lalkot S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Mahabubnagar Division"
  },
  "509410": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Farooqnqgar",
    "officename": "Mogalgidda S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "509411": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Mahbubnagar",
    "officename": "Maddur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Mahabubnagar Division"
  },
  "509412": {
    "state": "Telangana",
    "district": "Mahabub Nagar",
    "block": "Thelkapally",
    "officename": "Peddakothapally S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "515001": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Anantapur",
    "officename": "Anantapur H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515002": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Anantapur",
    "officename": "Anantapur Engg College S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515003": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Anantapur",
    "officename": "Sri Venkateswara Puram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515004": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Anantapur",
    "officename": "Georgepet S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515005": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Anantapur",
    "officename": "Old Town S.O (Ananthapur)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515101": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "C.k.palli",
    "officename": "Chennekothapalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515110": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Kothacheruvu",
    "officename": "Penukonda S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515122": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Somandepalle",
    "officename": "Somandepalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515123": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Roddam",
    "officename": "Roddam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515124": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Penukonda",
    "officename": "Peddamanthur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515133": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Puttaparthi",
    "officename": "Kothacheruvu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515134": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Puttaparthi",
    "officename": "Prasanthinilayam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515144": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Puttaparthi",
    "officename": "Bukkapatnam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515154": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Bukkapatnam",
    "officename": "Pamudurthi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515159": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Dharmavaram",
    "officename": "Krishnapuram S.O (Ananthapur)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515164": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Penukonda",
    "officename": "Guttur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515201": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Hindupur",
    "officename": "Hindupur H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515202": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Hindupur",
    "officename": "Muddireddypalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515211": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Hindupur",
    "officename": "Kirikera S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515212": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Hindupur",
    "officename": "Hindupur Sevamandir S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515231": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Gorantla",
    "officename": "Gorantla S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515241": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Gorantla",
    "officename": "Budili S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515261": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Parigi",
    "officename": "Parigi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515271": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Gudibanda",
    "officename": "Gudibanda S.O (Ananthapur)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515281": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Amarapuram",
    "officename": "Amarapuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515286": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Gudibanda",
    "officename": "Hemavathi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515291": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Rolla",
    "officename": "Neelakantapuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515301": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Madakasira",
    "officename": "Madakasira S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515303": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Madakasira",
    "officename": "Kallumarri S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515305": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Amarapuram",
    "officename": "Rallahalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515311": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Agali",
    "officename": "Agali S.O (Ananthapur)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515321": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Rolla",
    "officename": "Rolla S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515331": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Lepakshi",
    "officename": "Lepakshi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515341": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Chilamathur",
    "officename": "Chilamathur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515401": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Gooty",
    "officename": "Gooty S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515402": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Gooty",
    "officename": "Gooty R.S. S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515405": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Pedda Vadagur",
    "officename": "Pedda Vadagur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515408": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Peddapappur",
    "officename": "Yadiki S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515411": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Tadipatri",
    "officename": "Tadpatri S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515413": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Tadpatri",
    "officename": "Bhogasamudram Project S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515414": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Putlur",
    "officename": "Putlur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515415": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Tadipatri",
    "officename": "Chukkalur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515425": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Narpala",
    "officename": "Narapla S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515435": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Singanamala",
    "officename": "Singanamala S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515445": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Tadpatri",
    "officename": "Ammaladinne S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515455": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Peddavadugur",
    "officename": "Rayalacheruvu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515465": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Yellanur",
    "officename": "Yellanur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515501": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Bathalapalle",
    "officename": "Patnam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515511": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Mudigubba",
    "officename": "Mudigubba S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515521": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "N.p. Kunta",
    "officename": "Gandlapenta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515531": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Puttaparthi",
    "officename": "Kondakamarla S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515541": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Kadiri",
    "officename": "Kutagulla S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515551": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Nallacheruvu",
    "officename": "Nallacheruvu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515556": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Amadagur",
    "officename": "Amadagur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515561": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Obuladevaracheruvu",
    "officename": "Obula Devara Cheruvu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515571": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Tanakallu",
    "officename": "Tanakallu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515581": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Talupula",
    "officename": "Talupula S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515591": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Kadiri",
    "officename": "Kadiri S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515601": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Chilamathur",
    "officename": "Kodikonda S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515611": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Peddavadugur",
    "officename": "Tarimala S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515621": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Kambadur",
    "officename": "Perur S.O (Ananthapur)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515631": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Tadimarri",
    "officename": "Tadimarri S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515641": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Kanaganapalle",
    "officename": "Kanaganapalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515651": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Hindupur",
    "officename": "Medapuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515661": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Bathalapalli",
    "officename": "Bathalapalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515671": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Dharmavaram",
    "officename": "Dharmavaram H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515672": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Dharmavaram",
    "officename": "Dharmavaram R.S S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "515701": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Bukkrayasamudram",
    "officename": "Bukkarayasamudram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515711": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Kuderu",
    "officename": "Kuderu S.O (Ananthapur)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515721": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Anantapur",
    "officename": "Kandukur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515722": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Raptadu",
    "officename": "Jayalakshmipuram S.O (Ananthapur)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515731": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Singanamala",
    "officename": "Garladinne S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515741": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Beluguppa",
    "officename": "Belguppa S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515751": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Atmakur",
    "officename": "Atmakur(ATP) S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515761": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Kalyandurg",
    "officename": "Kalyandurg S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515763": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Settur",
    "officename": "Bommaganipalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515765": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Kalyandurg",
    "officename": "Kambadur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515766": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Kundurpi",
    "officename": "Kundurpi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515767": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Shetturu",
    "officename": "Shettur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515774": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Garladinna",
    "officename": "Kallur R.S. S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515775": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Pamidi",
    "officename": "Pamidi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515787": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Kalyandurg",
    "officename": "Nuthimadugu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515801": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Guntakal",
    "officename": "Guntakal H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515803": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Guntakal",
    "officename": "Old Guntakal S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515812": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Uravakonda",
    "officename": "Uravakonda S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515822": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Uravakonda",
    "officename": "Amidyaya S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515832": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Vajrakarur",
    "officename": "Vajrakarur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515842": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Vajrakarur",
    "officename": "Konakondla S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515863": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Gummagatta",
    "officename": "Gummaghatta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515865": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Rayadurg",
    "officename": "Rayadurg S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515867": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Rayadurg",
    "officename": "Udegolam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515870": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Bommanahal",
    "officename": "Vidapanakal S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515871": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Bommanahal",
    "officename": "Kanekal S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515872": {
    "state": "Andhra Pradesh",
    "district": "Ananthapur",
    "block": "Herial",
    "officename": "Herial S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "516001": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Cuddapah",
    "officename": "Cuddapah H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516002": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Cuddapah",
    "officename": "Shankarapuram (Cuddapah) S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516003": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Cuddapah",
    "officename": "Ravindra Nagar S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516004": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Chinthakommadinne",
    "officename": "Yerramukkapalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516101": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Kodur",
    "officename": "Kodur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516104": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Chitvel",
    "officename": "Chitvel S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516105": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Kodur",
    "officename": "Anantharajupet S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516107": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Pullampeta",
    "officename": "Pullampet S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516108": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Obulavaripalle",
    "officename": "Obulavaripalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516110": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Obulavaripalle",
    "officename": "Peddarachapalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516115": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Rajampet",
    "officename": "Rajampet H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516126": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Rajampet",
    "officename": "Mannur S.O (Cuddapah)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516127": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Penagalur",
    "officename": "Penagalur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516128": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Penagalur",
    "officename": "Chakrapunayanipet S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516129": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "T Sundupalle",
    "officename": "Rayavaram S.O (Cuddapah)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516130": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "T Sundupalle",
    "officename": "T. Sundupalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516150": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Nandalur",
    "officename": "Nandalur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516151": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Nandalur",
    "officename": "Tangatur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516152": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Vontimitta",
    "officename": "Mantapampalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516162": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Chennur",
    "officename": "Chennur S.O (Cuddapah)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516163": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Chennur",
    "officename": "Cuddapah Coop Sugars S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516172": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "S.Mydukur",
    "officename": "Mydekur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516173": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "S.Mydukur",
    "officename": "Onipenta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516175": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Duvvur",
    "officename": "Duvvur S.O (Cuddapah)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516193": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Porumamilla",
    "officename": "Porumamilla S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516203": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Khajipet",
    "officename": "Khajipet S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516213": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Vontimitta",
    "officename": "Vontimitta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516214": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Chinnamandem",
    "officename": "Chinnamandem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516215": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Sambepalle",
    "officename": "Sambepalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516216": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Pendlimarri",
    "officename": "Pendlimarri S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516217": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Kalasapadu",
    "officename": "Kalasapadu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516218": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Nandimandalam",
    "officename": "Nandimandalam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516227": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Badvel",
    "officename": "Badvel S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516228": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Badvel",
    "officename": "Anantharajupuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516233": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Gopavaram",
    "officename": "Gopavaram Project Site S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516237": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Sidhout",
    "officename": "Siddavattam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516247": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Vontimitta",
    "officename": "Madhavaram S.O (Cuddapah)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516257": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Lakkireddipalle",
    "officename": "Lakkireddy Palli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516259": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Chakrayapet",
    "officename": "Balathimmayyagaripalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516267": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Galiveedu",
    "officename": "Galiveedu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516268": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Veeraballe",
    "officename": "Veeraballi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516269": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Rayachoti",
    "officename": "Rayachoti S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516270": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Rayachoty",
    "officename": "Masapet Bazar S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516289": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Kamalapuram",
    "officename": "Kamalapuram S.O (Cuddapah)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516293": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Vallur",
    "officename": "Vallur S.O (Cuddapah)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516309": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Yerraguntla",
    "officename": "Yerraguntla S.O (Cuddapah)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516310": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Kamalapuram",
    "officename": "Chilamakur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516311": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Yerraguntla",
    "officename": "Krishna Nagar S.O (Cuddapah)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516312": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Yerraguntla",
    "officename": "Vv Reddy Nagar S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516321": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Verrapanayanipalle",
    "officename": "Veerapunayanipalle S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516329": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Vaimpalle",
    "officename": "Vaimpalle S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516330": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Pulivendla",
    "officename": "Idupulapaya(IIIT) S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516339": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Chapad",
    "officename": "Payasampalle S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516349": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Vemula",
    "officename": "Vemula S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516350": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Vaimpalle",
    "officename": "Tallapalle S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516355": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Mydekur",
    "officename": "Kallur S.O (Cuddapah)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516356": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Mydekur",
    "officename": "Chapadu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516359": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Rajupalam",
    "officename": "Korrapadu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516360": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Proddatur",
    "officename": "Proddatur H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516361": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Proddatur",
    "officename": "Holmespet S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516362": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Proddatur",
    "officename": "Khadarabad S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516380": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Muddanur",
    "officename": "Muddanur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516390": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Pulivendla",
    "officename": "Pulivendla H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516391": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Pulivendla",
    "officename": "Pulivendla Bus stand S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516396": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Lingala",
    "officename": "Lingala S.O (Cuddapah)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516401": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Tondur",
    "officename": "Tondur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516411": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Jammalamadugu",
    "officename": "Peddapasupula S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516421": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Pulivendla",
    "officename": "Agadur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516431": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Proddatur",
    "officename": "Dommaranandyala S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516432": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Jammalamadugu",
    "officename": "Vaddirala S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516433": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Proddatur",
    "officename": "Chinnakomerla S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516434": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Jammalamdugu",
    "officename": "Jammalamadugu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516439": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Mylavaram",
    "officename": "Mylavaram S.O (Cuddapah)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516444": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Kondapuram",
    "officename": "Kondapuram S.O (Cuddapah)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516454": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Simhadripuram",
    "officename": "Simhadripuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516464": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Lavanur",
    "officename": "Lavanur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516474": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Tallaproddatur",
    "officename": "Tallaproddatur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516484": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Balapanur",
    "officename": "Balapanur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Proddatur Division"
  },
  "516501": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Atlur",
    "officename": "Atlur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516502": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Badvel",
    "officename": "Chennampalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516503": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Brahmamgarimattam",
    "officename": "Kandimallayapalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516504": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Ramapuram",
    "officename": "Ramapuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "516505": {
    "state": "Andhra Pradesh",
    "district": "Cuddapah",
    "block": "Porumamilla",
    "officename": "Tekurpet S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "517001": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Chittoor",
    "officename": "Chittoor H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517002": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Chittoor",
    "officename": "Ctr Collectorate S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517004": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Chittoor",
    "officename": "Chittoor North S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517101": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Chandragiri",
    "officename": "Chandragiri H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517102": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Chandragiri",
    "officename": "Narasingapuram S.O (Chittoor)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517112": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Pakala",
    "officename": "Pakala S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517113": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Pulicherla",
    "officename": "Kallur S.O (Chittoor)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517123": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Madanapalle",
    "officename": "Sodam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517124": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Puthalpattu",
    "officename": "Puthalapattu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517125": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Chittoor",
    "officename": "Gangadhara Nellore S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517126": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Chittoor",
    "officename": "Penumur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517127": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Murakambattu",
    "officename": "Murukambattu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517128": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Yadamarri",
    "officename": "Iruvaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517129": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Arugonda",
    "officename": "Arugonda S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517130": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Iral",
    "officename": "Iral S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517131": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Kanipakam",
    "officename": "Kanipakam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517132": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Chittoor",
    "officename": "Nangamangalam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517152": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Damalacheruvu",
    "officename": "Damalacheruvu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517167": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Chittoor",
    "officename": "Kothapalle S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517172": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Pulicherla",
    "officename": "Mangalampet S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517192": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Rompicherla",
    "officename": "Rompicherla S.O (Chittoor)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517193": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Chinnagottigallu",
    "officename": "Chinnagottigallu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517194": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Chinnagottigallu Mandal",
    "officename": "Bhakarapet S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517213": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Kambhamvaripalle",
    "officename": "Gyarampalle kothapalle S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517214": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Piler",
    "officename": "Piler S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517234": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Kalikiri",
    "officename": "Kalikiri S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517235": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Kalikiri",
    "officename": "Mahal S.O (Chittoor)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517236": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Vayalpad",
    "officename": "Kalakada S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517237": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Kalikiri",
    "officename": "Medikurthi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517247": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Madanapalle",
    "officename": "Punganur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517257": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Madanapalle",
    "officename": "Chowdepalle S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517277": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Valmikipuram",
    "officename": "Chintaparthi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517280": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Madanapalle",
    "officename": "Nimmanapalle S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517291": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Gurramkonda",
    "officename": "Tarigonda S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517297": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Gurramkonda",
    "officename": "Gurramkonda S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517299": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Valmikipuram",
    "officename": "Vayalpad S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517305": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Gurramkonda",
    "officename": "Cherlopalle S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517319": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Madanapalle",
    "officename": "Chinnatippasamudram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517325": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Madanapalle",
    "officename": "Madanapalle H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517326": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Madanapalle",
    "officename": "Madanapalle Bazar S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517350": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Madanapalle",
    "officename": "Kurabalakota S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517351": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Madanapalle",
    "officename": "Burakayalakota S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517352": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Madanapalle",
    "officename": "Rishivalley S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517370": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Madanapalle",
    "officename": "Beerangi Kothakota S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517390": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Mulakalacheruvu",
    "officename": "Mulakalacheruvu R.S. S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517391": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Madanapalle",
    "officename": "Peddatippasamudram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517401": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Palamaner",
    "officename": "Ramakuppam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517403": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Chittoor",
    "officename": "Ramapuram S.O (Chittoor)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517408": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Palamaner",
    "officename": "Palamaner S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517414": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Peddapanjani",
    "officename": "Royalpet S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517415": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Palamaner",
    "officename": "Baireddipalle S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517416": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Palamaner",
    "officename": "Bangarupalem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517417": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Madanapalle",
    "officename": "Chembakur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517418": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Madanapalle",
    "officename": "Thamballapalle S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517419": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Chittoor",
    "officename": "Narasingarayanipettah S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517421": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Chittoor",
    "officename": "Thugundram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517422": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Chittoor",
    "officename": "Yadamari S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517423": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Palamaner",
    "officename": "Rallabudugur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517424": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Palamaner",
    "officename": "Venkatagirikota S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517425": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Palamaner",
    "officename": "Kuppam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517426": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Palamaner",
    "officename": "Dravidian University S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517429": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Palamaner",
    "officename": "Mogili Venkatagiri S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517432": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Madanapalle",
    "officename": "Kolamasanapalle S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517501": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Tirupati (Urban)",
    "officename": "Tirupati H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517502": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Tirupati (Urban)",
    "officename": "S.V.University S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517503": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Tirupati (Rural)",
    "officename": "Tiruchanoor S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517504": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Tirupati (Urban)",
    "officename": "Tirumala S.O (Chittoor)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517505": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Tirupati Rural",
    "officename": "Perumallapalle S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517506": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Renigunta",
    "officename": "Settipalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517507": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Tirupati (Rural)",
    "officename": "Tirupati North S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517520": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Renigunta",
    "officename": "Renigunta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517526": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Yerpedu",
    "officename": "Papanaidupet S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517536": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Akkurthi",
    "officename": "Akkurthi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517541": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Varadaiahpalem",
    "officename": "Varadaiahpalem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517551": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Srikalahasti",
    "officename": "Vadamalpet S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517561": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Ramachandrapuram",
    "officename": "Kattakindavenkatapuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517569": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Vedurukuppam",
    "officename": "Pachikapallam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517571": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Vadamalapeta",
    "officename": "Sri Bommarajapuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517581": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Puttur",
    "officename": "Narayanavaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517582": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Karvetinagar",
    "officename": "Karvetinagar S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517583": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Puttur",
    "officename": "Puttur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517584": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Puttur",
    "officename": "Vepagunta S.O (Chittoor)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517586": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Vijayapuram",
    "officename": "Pannur S.O (Chittoor)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517587": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Pissatur",
    "officename": "Pissatur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517588": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Satyavedu",
    "officename": "Satyavedu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517589": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Pichatur",
    "officename": "Nagalapuram S.O (Chittoor)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517590": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Nagari",
    "officename": "Nagari S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517591": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Nindra",
    "officename": "Nindra S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517592": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Nagari",
    "officename": "Ekambarakuppam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517599": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Vengalrajukuppam",
    "officename": "Vengalrajukuppam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Chittoor Division"
  },
  "517619": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Yerpedu",
    "officename": "Yerpedu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517620": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Yerpedu",
    "officename": "Pallam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517640": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Srikalahasti",
    "officename": "Panagal S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517641": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Thondamanadu",
    "officename": "Thondamanadu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517642": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Buchinaidu Kandriga",
    "officename": "Peddakannali S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517643": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "K.v.b.puram",
    "officename": "Kovanur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517644": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Srikalahasti",
    "officename": "Srikalahasti H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517645": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Srikalahasti",
    "officename": "Buchinaidu Kandriga S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "518001": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Kurnool H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518002": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "KNL camp B S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518003": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kallur",
    "officename": "SAP Camp kNL S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518004": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "N R Peta KNL S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518005": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Ashoknagar S.O (Kurnool)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518006": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Balaji Nagar S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518007": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "GPRE College S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518010": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Vorvakallu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518101": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Srisailam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "518102": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Srisailam",
    "officename": "S.S.Dam East S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "518112": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Banaganapalle",
    "officename": "Panem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "518122": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Koilkuntla",
    "officename": "Owk S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "518123": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Banaganapalli",
    "officename": "Kolimigundla S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "518124": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Banaganapalle",
    "officename": "Banaganapalle S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "518134": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Koilkuntla",
    "officename": "Koilakuntla S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "518135": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Dornipadu",
    "officename": "Dornipadu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "518145": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Sanjamala",
    "officename": "Nossam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "518155": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Koilkuntla",
    "officename": "Uyyalawada S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "518165": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Koilkuntla",
    "officename": "Sanjamala S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "518166": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Koilkuntla",
    "officename": "Perusomula S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "518176": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Banaganapalle",
    "officename": "Nandivargam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "518186": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Banaganapalle",
    "officename": "Illuri Kotha Peta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "518196": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Koilkuntla",
    "officename": "Akumalla S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "518206": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Bethamcherla",
    "officename": "Cement Nagar S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518216": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Veldurthi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518217": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Veldurthi",
    "officename": "Ramalla Kota S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518218": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Ulindakonda S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518220": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Veldurthi",
    "officename": "Jaladurgam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518221": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Peapully S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518222": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Dhone",
    "officename": "Dhone S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518225": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Krishnagiri S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518301": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Adoni",
    "officename": "Adoni H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518302": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Adoni Arts College S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518308": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Ingaladahal S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518313": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Kosigi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518323": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Veldurthi",
    "officename": "Peddakadubur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518333": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Halvi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518343": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Veldurthi",
    "officename": "Nandavaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518344": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Kavuthalam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518345": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Mantralaya S.O (Kurnool)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518346": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Holalagondi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518347": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Aspari S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518348": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Halaharvi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518349": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Tungabhadra S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518350": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Gonegandla",
    "officename": "Kadivella S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518360": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Yemmiganur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518380": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Pattikonda S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518385": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Maddikera S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518390": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Tuggali",
    "officename": "Tuggali S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518395": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Alur S.O (Kurnool)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518396": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Nemakallu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518401": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Nandikotkur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "518405": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Midthur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "518411": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Veldurthi",
    "officename": "Konidela S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "518412": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Prathakota S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "518422": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Atmakur S.O (Kurnool)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "518432": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Brahmanakotkur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518442": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Pamulapadu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "518452": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Gargeyapuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518462": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Belagal S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518463": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Gonegandla S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518464": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Veldurthi",
    "officename": "Kodumur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518465": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Devanakonda",
    "officename": "Devanakonda S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518466": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Gudur S.O (Kurnool)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518467": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "K.N.Puram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518468": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Pendekallu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518501": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Nandyal",
    "officename": "Nandyal H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "518502": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Nandyal",
    "officename": "Nandyal R.S. S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "518508": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Gadivemula S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "518510": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Allagadda",
    "officename": "Yerraguntla S.O (Kurnool)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "518511": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Nandyal",
    "officename": "Polur S.O (Kurnool)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "518512": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Nandyal",
    "officename": "Thimmapuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "518513": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Nandyal",
    "officename": "Santajutur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "518523": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Nandyal",
    "officename": "Bandi Atmakur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "518533": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Velgode S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "518543": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Allagadda",
    "officename": "Allagadda MDG S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "518553": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Allagadda",
    "officename": "Chagalamarri S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "518563": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Allagadda",
    "officename": "Sirvel S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "518573": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Gospadu",
    "officename": "Yallur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "518583": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Allagadda",
    "officename": "Gajulapalle S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "518593": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Allagadda",
    "officename": "Kanala S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "518594": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Allagadda",
    "officename": "Rudravaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "518598": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Bethamcherla",
    "officename": "Rangapuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518599": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Kurnool",
    "officename": "Bethamcherla S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Kurnool Division"
  },
  "518674": {
    "state": "Andhra Pradesh",
    "district": "Kurnool",
    "block": "Allagadda",
    "officename": "Gospadu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Nandyal Division"
  },
  "520001": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Vijayawada (Urban)",
    "officename": "Vijayawada GPO",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "520002": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Vijayawada (Urban)",
    "officename": "Buckinghampet H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "520003": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Vijayawada (Urban)",
    "officename": "Gandhinagaram S.O (Vijayawada)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "520004": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Vijayawada (Urban)",
    "officename": "Machavaram S.O (Krishna)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "520007": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Vijayawada (Urban)",
    "officename": "Autonagar S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "520008": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Vijayawada (Urban)",
    "officename": "Vj Polytechnic S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "520010": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Vijayawada (Urban)",
    "officename": "Venkateswarapuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "520011": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Vijayawada (Urban)",
    "officename": "Satyanarayanapuram S.O (Vijayawada)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "520012": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Vijayawada (Urban)",
    "officename": "Kamakotinagar S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "520013": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Vijayawada (Urban)",
    "officename": "Krishnalanka S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "520015": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Vijayawada (Urban)",
    "officename": "Azitnagar S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521001": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Machilipatnam",
    "officename": "Machilipatnam H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Machilipatnam Division"
  },
  "521002": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Bandar",
    "officename": "Chilakalapudi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Machilipatnam Division"
  },
  "521003": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Bandar",
    "officename": "Chintaguntapalem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Machilipatnam Division"
  },
  "521101": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Krishna",
    "officename": "Gannavaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521102": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Krishna",
    "officename": "Bacon Factory S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521104": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Krishna",
    "officename": "Nidamanuru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521105": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Bapulapadu",
    "officename": "Hanuman Junction S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudivada Division"
  },
  "521106": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Nandivada",
    "officename": "Kanumolu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudivada Division"
  },
  "521107": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Krishna",
    "officename": "Mustabad S.O (Krishna)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521108": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Krishna",
    "officename": "Ramavarappadu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521109": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Telaprolu",
    "officename": "Telaprolu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521110": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Veeravalli",
    "officename": "Veeravalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521111": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Bapulapadu",
    "officename": "Gollapalli S.O (Krishna)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudivada Division"
  },
  "521120": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Nagayalanka",
    "officename": "Nagayalanka S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Machilipatnam Division"
  },
  "521121": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Avanigadda",
    "officename": "Avanigadda H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Machilipatnam Division"
  },
  "521122": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Avanigadda",
    "officename": "Gandhikshetram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Machilipatnam Division"
  },
  "521125": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Mopidevi",
    "officename": "Mopidevi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Machilipatnam Division"
  },
  "521126": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Challapalli",
    "officename": "Challapalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Machilipatnam Division"
  },
  "521130": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Mopidevi",
    "officename": "Pedakallepalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Machilipatnam Division"
  },
  "521131": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Challapalli",
    "officename": "Lakshmipuram S.O (Krishna)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Machilipatnam Division"
  },
  "521132": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Ghantasala",
    "officename": "Kodali S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Machilipatnam Division"
  },
  "521133": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Ghantasala",
    "officename": "Ghantasala S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Machilipatnam Division"
  },
  "521134": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Poranki",
    "officename": "Tadigadapa S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521135": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Movva",
    "officename": "Movva S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Machilipatnam Division"
  },
  "521136": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Movva",
    "officename": "K.P.Centre S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Machilipatnam Division"
  },
  "521137": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Krishna",
    "officename": "Poranki S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521138": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Movva",
    "officename": "Pedasanagallu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Machilipatnam Division"
  },
  "521139": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Krishna",
    "officename": "Penamaluru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521148": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Pedaparupudi",
    "officename": "Elamarru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudivada Division"
  },
  "521149": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Guduru",
    "officename": "Guduru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Machilipatnam Division"
  },
  "521150": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Movva",
    "officename": "Kaja S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Machilipatnam Division"
  },
  "521151": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Kankipadu",
    "officename": "Kankipadu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521153": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Vuyyuru",
    "officename": "Kolavennu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521156": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Guduru",
    "officename": "Nidumolu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Machilipatnam Division"
  },
  "521157": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Pamarru",
    "officename": "Pamarru S.O (Krishna)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Machilipatnam Division"
  },
  "521158": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Pamarru",
    "officename": "Nimmakuru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Machilipatnam Division"
  },
  "521162": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Guduru",
    "officename": "Polavaram(K) S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Machilipatnam Division"
  },
  "521163": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Thotlavalluru",
    "officename": "Thotlavalluru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521164": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Krishna",
    "officename": "Katuru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521165": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Vuyyuru",
    "officename": "Vuyyuru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521170": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Veerullapadu",
    "officename": "Veerullapadu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521175": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Krishna",
    "officename": "Jaggaiahpet S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521178": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Krishna",
    "officename": "Chillakallu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521180": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Krishna",
    "officename": "Kanchikacharla S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521181": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Krishna",
    "officename": "Juzzuru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521182": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Krishna",
    "officename": "Chandarlapadu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521183": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Krishna",
    "officename": "Muppalla S.O (Krishna)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521185": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Krishna",
    "officename": "Nandigama S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521190": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Krishna",
    "officename": "Penuganchiprolu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521201": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Nuzvid",
    "officename": "Nuzvid SO",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudivada Division"
  },
  "521202": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Nuzvid",
    "officename": "APIIIT S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudivada Division"
  },
  "521207": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Musunuru",
    "officename": "Musunuru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudivada Division"
  },
  "521211": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Krishna",
    "officename": "Aukiripalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521212": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Krishna",
    "officename": "Nunna S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521213": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Musunuru",
    "officename": "Ramanakkapet S.O.",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudivada Division"
  },
  "521214": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Chatrai",
    "officename": "Tsanubanda S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudivada Division"
  },
  "521215": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Reddigudem",
    "officename": "Vissannapet S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudivada Division"
  },
  "521225": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Krishna",
    "officename": "Gollapudi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521226": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "A.Konduru",
    "officename": "A.Konduru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521227": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Krishna",
    "officename": "Khambhampadu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521228": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Kondapalli",
    "officename": "Kondapalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521229": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Krishna",
    "officename": "G Konduru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521230": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Krishna",
    "officename": "Mylavaram S.O (Krishna)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521235": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Tiruvuru",
    "officename": "Tiruvuru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521241": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Krishna",
    "officename": "Railway Wagon Work Shop S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521245": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Krishna",
    "officename": "Akunuru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521246": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Krishna",
    "officename": "Kapileswarapuram S.O (Krishna)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521247": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Krishna",
    "officename": "Meduru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521250": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Krishna",
    "officename": "Virankilock S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521256": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Krishna",
    "officename": "Mantada S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521260": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Vunguturu",
    "officename": "Manikonda S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudivada Division"
  },
  "521261": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Vuyyuru",
    "officename": "Mudunuru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudivada Division"
  },
  "521263": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Pedaparupudi",
    "officename": "Ventrapragada S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudivada Division"
  },
  "521286": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Krishna",
    "officename": "Pedavutapalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521301": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Gudivada",
    "officename": "Gudivada H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudivada Division"
  },
  "521311": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Vunguturu",
    "officename": "Indupalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudivada Division"
  },
  "521312": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Vunguturu",
    "officename": "Vunguturu S.O (Krishna)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudivada Division"
  },
  "521321": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Nandivada",
    "officename": "Janardhanapuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudivada Division"
  },
  "521322": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Gudivada",
    "officename": "Golvepalli (Zami) S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudivada Division"
  },
  "521323": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Gudivada",
    "officename": "Moturu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudivada Division"
  },
  "521324": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Bantumilli",
    "officename": "Bantumilli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudivada Division"
  },
  "521325": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Mudinepalli",
    "officename": "Mudinepalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudivada Division"
  },
  "521326": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Nandivada",
    "officename": "Rudrapaka S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudivada Division"
  },
  "521327": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Nandivada",
    "officename": "Tamirisa S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudivada Division"
  },
  "521328": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Koduru",
    "officename": "Koduru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Machilipatnam Division"
  },
  "521329": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Mudinepalli",
    "officename": "Pedagonnuru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudivada Division"
  },
  "521330": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Gudlavalleru",
    "officename": "Angaluru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudivada Division"
  },
  "521331": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Gudlavalleru",
    "officename": "Kavutaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Machilipatnam Division"
  },
  "521332": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Gudlavallru",
    "officename": "Dokiparru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Machilipatnam Division"
  },
  "521333": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Kaikalur",
    "officename": "Kaikalur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudivada Division"
  },
  "521340": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Kaikalur",
    "officename": "Pallevada S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudivada Division"
  },
  "521343": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Mudinepelli",
    "officename": "Korukollu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudivada Division"
  },
  "521344": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Kalidindi",
    "officename": "Kalidindi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudivada Division"
  },
  "521345": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Mandavalli",
    "officename": "Mandavalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudivada Division"
  },
  "521356": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Gudlavalleru",
    "officename": "Gudlavalleru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Machilipatnam Division"
  },
  "521366": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Pedana",
    "officename": "Pedana S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Machilipatnam Division"
  },
  "521369": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Bantumilli",
    "officename": "Munjuluru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Machilipatnam Division"
  },
  "521390": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Pamarru",
    "officename": "Pedamaddali S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudivada Division"
  },
  "521401": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Penugolanu",
    "officename": "Penugolanu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521402": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Krishna",
    "officename": "Vatsavai S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521403": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Gampalagudem",
    "officename": "Gampalagudem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521456": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Krishna",
    "officename": "VTPS S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521457": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Krishna",
    "officename": "Kumaraswamy Raja Nagar S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "522001": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Guntur",
    "officename": "Kothapeta(Guntur) S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Guntur Division"
  },
  "522002": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Guntur",
    "officename": "Guntur H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Guntur Division"
  },
  "522003": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Guntur",
    "officename": "Guntur Bazar S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Guntur Division"
  },
  "522004": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Guntur",
    "officename": "Guntur Collectorate S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Guntur Division"
  },
  "522005": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Guntur",
    "officename": "Nallapadu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Guntur Division"
  },
  "522006": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Guntur",
    "officename": "Pattabhipuram(Guntur) S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Guntur Division"
  },
  "522007": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Guntur",
    "officename": "Chandramoulinagar S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Guntur Division"
  },
  "522009": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Guntur",
    "officename": "Perecherla Junction S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Guntur Division"
  },
  "522015": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Guntur",
    "officename": "Abbineniguntapalem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Guntur Division"
  },
  "522016": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Lemalle",
    "officename": "Lemalle S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Guntur Division"
  },
  "522017": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Guntur",
    "officename": "Etukuru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Guntur Division"
  },
  "522018": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Ponnekallu",
    "officename": "Ponnekallu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Guntur Division"
  },
  "522019": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Prathipadu",
    "officename": "Prathipadu S.O (Guntur)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Guntur Division"
  },
  "522020": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Guntur",
    "officename": "Amaravathi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Guntur Division"
  },
  "522034": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Guntur",
    "officename": "Industrial Estate S.O (Guntur)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Guntur Division"
  },
  "522101": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Bapatla",
    "officename": "Bapatla H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522102": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Bapatla",
    "officename": "Bapatla Engg College S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522111": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Karlapalem",
    "officename": "Karlapalem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522112": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Kakumanu",
    "officename": "Kakumanu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Guntur Division"
  },
  "522113": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Cheruvu",
    "officename": "Cheruvu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522124": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Ponnuru",
    "officename": "Ponnur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522201": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Tenali",
    "officename": "Tenali H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522202": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Tenali",
    "officename": "Morrispeta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522211": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Angalakudur",
    "officename": "Angalakudur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522212": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Bapatla",
    "officename": "Chebrole S.O (Guntur)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522213": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Chebrole",
    "officename": "Sangamjagarlamudi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522233": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Edlapadu",
    "officename": "Edlapadu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522234": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Nadendla",
    "officename": "Nadendla S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522235": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Pedanandipadu",
    "officename": "Pedanandipadu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Guntur Division"
  },
  "522236": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Tadikonda",
    "officename": "Tadikonda S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Guntur Division"
  },
  "522237": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Tulluru",
    "officename": "Tulluru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Guntur Division"
  },
  "522256": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Bhattiprolu",
    "officename": "Bhattiprolu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522257": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Bhattiprole",
    "officename": "Vellaturu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522258": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Dhulipudi",
    "officename": "Dhulipudi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522259": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Cherukupalli",
    "officename": "Kanagala S.O (Guntur)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522261": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Vemuru",
    "officename": "Vemuru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522262": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Kuchinapudi",
    "officename": "Kuchinapudi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522264": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Chodayapalem",
    "officename": "Chodayapalem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522265": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Repalle",
    "officename": "Repalle S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522268": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Nagaram",
    "officename": "Nagaram S.O (Guntur)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522301": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Anantavaram",
    "officename": "Anantavaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522302": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Mangalagiri Ho",
    "officename": "Pedavadlapudi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Guntur Division"
  },
  "522303": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Nutakki",
    "officename": "Nutakki S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Guntur Division"
  },
  "522304": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Kollipara",
    "officename": "Kollipara S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522305": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Pedapalem",
    "officename": "Pedapalem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Guntur Division"
  },
  "522306": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Tenali",
    "officename": "Nandivelugu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522307": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Tenali",
    "officename": "Kolakaluru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522308": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Emani",
    "officename": "Emani S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522309": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Cherukupalle",
    "officename": "Cherukupalle S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522310": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Appikatla",
    "officename": "Appikatla S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522311": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Bapatla",
    "officename": "Chandole S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522312": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Turumella",
    "officename": "Turumella S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522313": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Amartaluru",
    "officename": "Kuchipudi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522314": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Nizampatnam",
    "officename": "Nizampatnam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522315": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Machavaram",
    "officename": "Machavaram S.O (Tenali)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522316": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Patsalatadiparru",
    "officename": "Patsalatadiparru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522317": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Stuvartpuram",
    "officename": "Stuvartpuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522318": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Tsunduru",
    "officename": "Tsunduru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522324": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Kolluru",
    "officename": "Kolluru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522325": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Amartaluru",
    "officename": "Amartaluru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522329": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Bapatla",
    "officename": "Pittalavanipalem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522330": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Duggirala",
    "officename": "Duggirala S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522341": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Inturu",
    "officename": "Intur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tenali Division"
  },
  "522401": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Medikonduru",
    "officename": "Siripuram S.O (Guntur)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522402": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Sattenapalle",
    "officename": "Pedakurapadu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522403": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Sattenapalle",
    "officename": "Sattenapalle H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522408": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Sattenapalle",
    "officename": "Muppalla S.O (Guntur)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522409": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Atchampet",
    "officename": "Atchampet S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522410": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Krosuru",
    "officename": "Krosuru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522411": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Bellamkonda",
    "officename": "Bellamkonda S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522412": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Rajupalem",
    "officename": "Rajupalem S.O (Guntur)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522413": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Piduguralla",
    "officename": "Piduguralla S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522414": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Dachepalle",
    "officename": "Dachpalle S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522415": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Gurazalla",
    "officename": "Gurazalla S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522421": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Rentachintala",
    "officename": "Rentachintala S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522426": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Macherla",
    "officename": "Macherla S.O (Guntur)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522435": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Machavaram",
    "officename": "Machavaram S.O (Narasaraopet)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522436": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Pedakurapadu",
    "officename": "Parastyalluru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522437": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Sattenapalle",
    "officename": "Brahmanapalle S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522438": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Medikonduru",
    "officename": "Medikonduru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522439": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Macherla",
    "officename": "Vijayapuri South S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522501": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Tadepalle",
    "officename": "Tadepalle S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Guntur Division"
  },
  "522502": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Mangalagiri Ho",
    "officename": "K.C.Works S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Guntur Division"
  },
  "522503": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Mangalagiri",
    "officename": "Mangalagiri H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Guntur Division"
  },
  "522508": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Mangalagiri Ho",
    "officename": "Namburu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Guntur Division"
  },
  "522509": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Pedakakani",
    "officename": "Pedakakani S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Guntur Division"
  },
  "522510": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Guntur",
    "officename": "Nagarjuna Nagar S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Guntur Division"
  },
  "522529": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Phirangipuram",
    "officename": "Phirangipuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522549": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Nadendla",
    "officename": "Satuluru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522601": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Narasaraopet",
    "officename": "Narasaraopet H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522603": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Narasaraopet",
    "officename": "Ravipadu S.O (Guntur)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522611": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Chilakaluripet",
    "officename": "Kavuru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522612": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Durgi",
    "officename": "Durgi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522613": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Veldurthy",
    "officename": "Veldurthy S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522614": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Karempudi",
    "officename": "Karempudi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522615": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Nekarikallu",
    "officename": "Nekarikallu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522616": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Chilakaluripet",
    "officename": "Chilakaluripet S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522617": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Rompicherla",
    "officename": "Rompicherla S.O (Guntur)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522619": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Nadendla",
    "officename": "Ganapavaram S.O (Guntur)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522626": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Chilakaluripet",
    "officename": "Murikipudi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522646": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Savalyapuram",
    "officename": "Savalyapuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522647": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Vinukonda",
    "officename": "Vinukonda S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522649": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Vinukonda",
    "officename": "Pedakancherla S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522657": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Vinukonda",
    "officename": "Vellatur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522658": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Ipuru",
    "officename": "Ipuru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522659": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Nuzendla",
    "officename": "Ainavole S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522660": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Nuzendla",
    "officename": "Nuzendla S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522661": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Ipuru",
    "officename": "Muppalla(VKD) S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "522663": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Narasaraopet",
    "officename": "Bandlamottu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Narasaraopet Division"
  },
  "523001": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Ongole",
    "officename": "Ongole H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523002": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Ongole",
    "officename": "Lawyer Pet (O) S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523101": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Kandukur",
    "officename": "S.Konda S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523104": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Kandukur",
    "officename": "Woollapalem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523105": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Kandukur",
    "officename": "Kandukur H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523108": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Kanigiri",
    "officename": "Pamur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523109": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Kandukur",
    "officename": "Ponnalore S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523110": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Kanigiri",
    "officename": "Botlagudur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523111": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Kanigiri",
    "officename": "Pa Padu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523112": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Kanigiri",
    "officename": "C.S.Puram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523113": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Kandukur",
    "officename": "Pokur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523114": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Kandukur",
    "officename": "Linga Samudram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523115": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Kandukur",
    "officename": "Peda Pavani S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523116": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Voletivaripalem",
    "officename": "V V Palem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523117": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Kanigiri",
    "officename": "P.C.Palli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523135": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Chirala",
    "officename": "Chinaganjam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523155": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Chirala",
    "officename": "Chirala H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523157": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Chiral",
    "officename": "Perala S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523165": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Chirala",
    "officename": "Jandrapet S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523166": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Chirala",
    "officename": "Ipurupalem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523167": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Chirala",
    "officename": "Inkollu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523168": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Chirala",
    "officename": "Karamchedu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523169": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Parchur",
    "officename": "Parchur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523170": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Chirala",
    "officename": "Swarna S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523171": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Chirala",
    "officename": "A.B.V.Palem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523180": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Ongole",
    "officename": "Ammanabrolu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523181": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Chirala",
    "officename": "Kadavakuduru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523182": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Kotha Patnam",
    "officename": "Karavadi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523183": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Ongole",
    "officename": "N.G.Padu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523184": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Chirala",
    "officename": "Pandillapalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523185": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Chirala",
    "officename": "Santharavur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523186": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Ongole",
    "officename": "Uppugundur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523187": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Chirala",
    "officename": "Vetapalem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523190": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Chirala",
    "officename": "Idupulapadu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523201": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Ongole",
    "officename": "Addanki S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523211": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Ongole",
    "officename": "Maddipadu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523212": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Ongole",
    "officename": "M.M.T. Road S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523213": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Ongole",
    "officename": "Ravinuthala S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523214": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Ongole",
    "officename": "J.Pangulur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523223": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Kanigiri",
    "officename": "Mogallur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523224": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Kanigiri",
    "officename": "Veligandla S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523225": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Ongole",
    "officename": "Santhanuthalapadu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523226": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Ongole",
    "officename": "Chimakurty S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523227": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Kanigiri",
    "officename": "H.M.Padu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523228": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Kanigiri",
    "officename": "P.G.Palli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523230": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Kanigiri",
    "officename": "Kanigiri S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523240": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Kanigiri",
    "officename": "Podili H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523241": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Kanigiri",
    "officename": "Konakana Metla S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523245": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Kanigiri",
    "officename": "Pedarikatla S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523246": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Kanigiri",
    "officename": "Gotlagattu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523247": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Kanigiri",
    "officename": "Darsi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523252": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Kanigiri",
    "officename": "Pothakamur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523253": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Kanigiri",
    "officename": "Uppalapadu (P) S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523254": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Kanigiri",
    "officename": "Sankavaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523260": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Ongole",
    "officename": "Valaparla S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523261": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Ongole",
    "officename": "Muppavaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523262": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Ongole",
    "officename": "Throvagunta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523263": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Ongole",
    "officename": "Tellapadu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523264": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Ongole",
    "officename": "Tallur S.O (Prakasam)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523265": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Kanigiri",
    "officename": "Mundlamur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523270": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Kandukur",
    "officename": "Kondepi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523271": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Kandukur",
    "officename": "Kamepalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523272": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Chirala",
    "officename": "Vallur S.O (Prakasam)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523273": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Kandukur",
    "officename": "Peridepi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523274": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Kandukur",
    "officename": "Tangutur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523279": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Chirala",
    "officename": "Uppalapadu (K) S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523280": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Ongole",
    "officename": "Ethamukkala S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523281": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Kandukur",
    "officename": "Gudluru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523286": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Ongole",
    "officename": "Kothapatnam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523291": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Kandukur",
    "officename": "Ramapatnam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523292": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Kandukur",
    "officename": "Ulavapadu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523301": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Ongole",
    "officename": "Marturu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523302": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Ongole",
    "officename": "Santhamagulur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523303": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Ongole",
    "officename": "Kommalapadu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "523304": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Kanigiri",
    "officename": "Kurichedu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523305": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Markapur",
    "officename": "Donakonda R.S. S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523315": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Markapur",
    "officename": "Gajjalakonda S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523316": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Markapur",
    "officename": "Markapur H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523320": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Peda  Araveedu",
    "officename": "Tokapalle S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523326": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Markapur",
    "officename": "Tripurantakam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523327": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Yerragondapalem",
    "officename": "Erragondapalem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523328": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Pullalacheruvu",
    "officename": "Pullala Cheruvu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523329": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Markapur",
    "officename": "Vemulakota S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523330": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Markapur",
    "officename": "Dupadu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523331": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Markapur",
    "officename": "Pedda Dornala S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523332": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Markapur",
    "officename": "Tarlupadu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523333": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Cumbum",
    "officename": "Cumbum S.O (Prakasam)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523334": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Cumbum",
    "officename": "Besthavari  Peta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523335": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Cumbum",
    "officename": "Ardhaveedu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523336": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Cumbum",
    "officename": "Mohiddin Puram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523346": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Cumbum",
    "officename": "Pitikayagulla S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523356": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Racherla",
    "officename": "Edavalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523357": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Giddalur",
    "officename": "Giddalur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523367": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Giddalur",
    "officename": "Mundlapadu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523368": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Giddalur",
    "officename": "Racherla S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523369": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Giddalur",
    "officename": "Rajupalem S.O (Prakasam)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523370": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Cumbum",
    "officename": "Ravipadu S.O (Prakasam)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523371": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Markapur",
    "officename": "Thummalacheruvu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523372": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Giddalur",
    "officename": "Thurimella S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "523373": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Giddalur",
    "officename": "Komarole S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Markapur  Division"
  },
  "524001": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Nellore",
    "officename": "Nellore H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524002": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Nellore",
    "officename": "Stonehousepet S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524003": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Nellore",
    "officename": "Dargamitta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524004": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Nellore",
    "officename": "Andhrakesari Nagar S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524005": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Nellore",
    "officename": "Polytechnic S.O (Nellore)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524101": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Gudur",
    "officename": "Gudur H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudur Division"
  },
  "524121": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Tada",
    "officename": "Sullurpeta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudur Division"
  },
  "524123": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Sullurpeta",
    "officename": "Kotapolur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudur Division"
  },
  "524124": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Sullurpeta",
    "officename": "Sriharikota Range S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudur Division"
  },
  "524126": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Naidupeta",
    "officename": "Nayudupeta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudur Division"
  },
  "524127": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Naidupeta",
    "officename": "Yellasiri S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudur Division"
  },
  "524129": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Pellakur",
    "officename": "Pellakur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudur Division"
  },
  "524131": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Gudur",
    "officename": "Jayampu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudur Division"
  },
  "524132": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Venkatagiri",
    "officename": "Venkatagiri Town S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudur Division"
  },
  "524134": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Dakkili",
    "officename": "Dakkili S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudur Division"
  },
  "524137": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Kovur",
    "officename": "Kovur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524142": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Bitragunta",
    "officename": "Bitragunta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524152": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Damavaram",
    "officename": "Damavaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524201": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Kavali",
    "officename": "Kavali H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524203": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Kavali",
    "officename": "Anemadugu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524221": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Chakalakonda",
    "officename": "Chakalakonda S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524222": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Duthalur",
    "officename": "Duthalur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524223": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Jaladanki",
    "officename": "Jaladanki S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524224": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Kaligiri",
    "officename": "Kaligiri S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524225": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Siddanakonduru",
    "officename": "Siddanakonduru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524226": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Udayagiri",
    "officename": "Udayagiri S.O (Nellore)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524227": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Varikuntapadu",
    "officename": "Varikuntapadu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524228": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Vinjamoor",
    "officename": "Vinjamur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524230": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Nandipadu",
    "officename": "Nandipadu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524234": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Gumparlapadu",
    "officename": "Gumparlapadu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524236": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Gandipalem",
    "officename": "Gandipalem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524239": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Kondapuram",
    "officename": "Kondapuram S.O (Nellore)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524240": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Dagadarthi",
    "officename": "Dagadarthi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524302": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Anantasagaram",
    "officename": "Anantasagaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524303": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Revur",
    "officename": "Revur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524304": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "A.s.peta",
    "officename": "Anumasamudrampeta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524305": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Buchireddypalem",
    "officename": "Buchireddypalem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524306": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Duvvur",
    "officename": "Duvvur S.O (Nellore)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524307": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Karatampadu",
    "officename": "Karatampadu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524308": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Sangam",
    "officename": "Sangam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524309": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Virur",
    "officename": "Virur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudur Division"
  },
  "524310": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Seetharamapuram",
    "officename": "Seetaramapuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524311": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Tp Gudur",
    "officename": "Thotapalliguduru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524312": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Marripadu",
    "officename": "Marripadu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524313": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Mypadu",
    "officename": "Mypadu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524314": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Indukurpeta",
    "officename": "Indukurpeta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524315": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Allur Mandalam",
    "officename": "Allur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524316": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Kodavaluru",
    "officename": "Kodavaluru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524317": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Gandavaram",
    "officename": "Gandavaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524318": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Vidavalur",
    "officename": "Vidavalur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524319": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Kodavaluru",
    "officename": "Kammapalem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524320": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Venkatachalam",
    "officename": "Venkatachalasatram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudur Division"
  },
  "524321": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Survepalli",
    "officename": "Survepalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudur Division"
  },
  "524322": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Atmakur",
    "officename": "Atmakur (NL) S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524323": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Venkatachalam",
    "officename": "Nidiguntapalem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudur Division"
  },
  "524341": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Chejerla",
    "officename": "Chejerla S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudur Division"
  },
  "524342": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Kaluvoya",
    "officename": "Dachur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudur Division"
  },
  "524343": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Kaluvoya",
    "officename": "Kaluvoya S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudur Division"
  },
  "524344": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Muthukur",
    "officename": "Muthukur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524345": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Podalakur",
    "officename": "Podalakur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudur Division"
  },
  "524346": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Muthukur",
    "officename": "Brahmadevam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524366": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Nr Palem",
    "officename": "Northrajupalem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524401": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Tada",
    "officename": "Tada S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudur Division"
  },
  "524402": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Vojili",
    "officename": "Vojili S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudur Division"
  },
  "524403": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Chittamur",
    "officename": "Mallam S.O (Nellore)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudur Division"
  },
  "524404": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Balayapalli",
    "officename": "Bangarupeta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudur Division"
  },
  "524405": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Manubolu",
    "officename": "Manubolu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudur Division"
  },
  "524406": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Gudur",
    "officename": "Chennur S.O (Nellore)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudur Division"
  },
  "524407": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Sydapuram",
    "officename": "Sydapuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudur Division"
  },
  "524408": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Rapur",
    "officename": "Rapur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudur Division"
  },
  "524409": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Sydapuram",
    "officename": "Kalichedu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudur Division"
  },
  "524410": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Gudur",
    "officename": "Kadivedu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudur Division"
  },
  "524411": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Kota",
    "officename": "Kota(NL) S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudur Division"
  },
  "524412": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Chillakur",
    "officename": "Chillakur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudur Division"
  },
  "524413": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Vakadu",
    "officename": "Vidyanagar S.O (Nellore)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudur Division"
  },
  "524414": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Rapur",
    "officename": "Gundavolu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudur Division"
  },
  "524415": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Vakadu",
    "officename": "Vakadu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudur Division"
  },
  "524421": {
    "state": "Andhra Pradesh",
    "district": "Nellore",
    "block": "Naidupeta",
    "officename": "Menakur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudur Division"
  },
  "530001": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Visakhapatnam",
    "officename": "Visakhapatnam H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530002": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Visakhapatnam (Urban)",
    "officename": "Maharanipeta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530003": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Visakhapatnam (Urban)",
    "officename": "Andhra University S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530004": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Visakhapatnam",
    "officename": "Waltair R S H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530005": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Pedagantyada",
    "officename": "Gandhigram S.O (Visakhapatnam)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530007": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Visakhapatnam (Urban)",
    "officename": "Industrial Estate S.O (Visakhapatnam)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530008": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Visakhapatnam",
    "officename": "Kancharapalem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530009": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Visakhapatnam",
    "officename": "N A D S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530011": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Visakhapatnam (Urban)",
    "officename": "Malkapuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530012": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Visakhapatnam",
    "officename": "B H P V S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530013": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Visakhapatnam (Urban)",
    "officename": "P and T Colony (VM) S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530014": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Pedagantyada",
    "officename": "Naval Base S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530015": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Visakhapatnam (Urban)",
    "officename": "Zinc Smelter P S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530016": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Visakhapatnam (Urban)",
    "officename": "Akkayyapalem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530017": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Visakhapatnam (Urban)",
    "officename": "L B Colony S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530018": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Visakhapatnam (Urban)",
    "officename": "Marripalem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530020": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Visakhapatnam (Urban)",
    "officename": "Dabagardens S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530022": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Visakhapatnam (Urban)",
    "officename": "H B Colony S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530024": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Visakhapatnam (Urban)",
    "officename": "Salagramapuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530026": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Visakhapatnam",
    "officename": "Gajuwaka S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530027": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Visakhapatnam (Urban)",
    "officename": "Gopalapatnam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530028": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Visakhapatnam (Rural)",
    "officename": "Simhachalam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530029": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Visakhapatnam (Urban)",
    "officename": "R R V Puram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530031": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Visakhapatnam",
    "officename": "Visakhapatnam Steel Project S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530032": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Pedagantyada",
    "officename": "Ukkunagaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530040": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Visakhapatnam (Urban)",
    "officename": "Govt Dairy Farm S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530041": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Visakhapatnam (Rural)",
    "officename": "Pothinamallayapalem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530043": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Visakhapatnam (Urban)",
    "officename": "Visalakshinagar S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530044": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Pedagantyada",
    "officename": "Pedagantyada S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530045": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Visakhapatnam (Rural)",
    "officename": "Gitam Engg. College S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530046": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Visakhapatnam",
    "officename": "Vadlapudi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530047": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Pendurthi",
    "officename": "Vepagunta S.O (Visakhapatnam)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530048": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Visakhapatnam (Rural)",
    "officename": "Madhurawada S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530049": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Visakhapatnam (Rural)",
    "officename": "Special Economic Zone P.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530051": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Pendurthi",
    "officename": "Sujatha Nagar S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530052": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Anandapuram",
    "officename": "Anandapuram S.O (Visakhapatnam)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530053": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Gajuwaka",
    "officename": "Aganampudi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "531001": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Anakapalle",
    "officename": "Anakapalle H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531002": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Anakapalle",
    "officename": "Nidanam Doddi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531011": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Anakapalle",
    "officename": "Atchutapuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531019": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Paravada",
    "officename": "Jawaharlalnehru Pharmacity S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531020": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Anakapalle",
    "officename": "Ntpc Simhadri S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531021": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Anakapalle",
    "officename": "Paravada S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531022": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Chodavaram",
    "officename": "A Koduru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531023": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Chodavaram",
    "officename": "Govada S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531024": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Chodavaram",
    "officename": "Paderoo S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531025": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Chodavaram",
    "officename": "Ravikamatham S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531026": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Chodavaram",
    "officename": "Vaddadi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531027": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Chodavaram",
    "officename": "Madugula S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531028": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Chodavaram",
    "officename": "Kj Puram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531029": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Chodavaram",
    "officename": "G Madugula S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531030": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Chodavaram",
    "officename": "Devarapalli S.O (Visakhapatnam)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531031": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Anakapalle",
    "officename": "Kasimkota S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531032": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Anakapalle",
    "officename": "Thummapala S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531033": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Anakapalle",
    "officename": "Munagapaka S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531034": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Chodavaram",
    "officename": "K Kotapadu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531035": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Anakapalle",
    "officename": "Subbavaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531036": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Chodavaram",
    "officename": "Chodavaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531040": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Chodavaram",
    "officename": "Pedabayalu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531055": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Anakapalle",
    "officename": "Yellamanchili S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531060": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Anakapalle",
    "officename": "S Rayavaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531061": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Anakapalle",
    "officename": "Dimili S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531075": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Chodavaram",
    "officename": "Lakkavaram S.O (Visakhapatnam)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531077": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Chodavaram",
    "officename": "Hukumpeta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531081": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Anakapalle",
    "officename": "Nakkapalle S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531082": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Anakapalle",
    "officename": "Etikoppaka S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531083": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Anakapalle",
    "officename": "Pedagummuluru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531084": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Narsipatnam",
    "officename": "Kd Peta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531085": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Narsipatnam",
    "officename": "Kotauratla S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531087": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Narsipatnam",
    "officename": "Koyyuru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531105": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Narsipatnam",
    "officename": "Sileru Project S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531111": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Narsipatnam",
    "officename": "Chintapalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531113": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Narsipatnam",
    "officename": "Makavarapalem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531114": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Narsipatnam",
    "officename": "Kothakota S.O (Visakhapatnam)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531115": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Narsipatnam",
    "officename": "Nathavaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531116": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Narsipatnam",
    "officename": "Narsipatnam H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531117": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Narsipatnam",
    "officename": "Vemulapudi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531118": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Narsipatnam",
    "officename": "Krishna Bazar(Narsipatnam) S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531126": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Anakapalle",
    "officename": "Payakaraopeta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531127": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Anakapalle",
    "officename": "Satyavaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531133": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Narsipatnam",
    "officename": "Gudem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531149": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Araku",
    "officename": "Araku Colony S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531151": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Chodavaram",
    "officename": "Araku Rs S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Anakapalle Division"
  },
  "531162": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Visakhapatnam.",
    "officename": "Chittivalasa S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "531163": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Visakhapatnam",
    "officename": "Bheemunipatnam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "531173": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Visakhapatnam",
    "officename": "Pendurthy S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "531219": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Viskhapatnam",
    "officename": "R P Agraharam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "532001": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Srikakulam",
    "officename": "Srikakulam H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532005": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Srikakulam",
    "officename": "Gujarathipeta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532122": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Regidi Amadalavalasa",
    "officename": "Vunukuru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532123": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Regidi Mandal",
    "officename": "S.R.Puram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532127": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Rajam Mandal",
    "officename": "Rajam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532148": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Sigadam Mandal",
    "officename": "Sigadam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Parvathipuram Division"
  },
  "532168": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Sigadam Mandal",
    "officename": "Ponduru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532185": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Amadalavalasa",
    "officename": "Amadalavalasa H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532186": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Amadalavalasa Mandal",
    "officename": "Vengala Rao Colony S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532190": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Sarubujjili Mandal",
    "officename": "P.S.Puram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532195": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Santabommali Mandal",
    "officename": "Kotabommali S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532201": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Tekkali",
    "officename": "Tekkali H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532203": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Tekkali",
    "officename": "Venkateswara Colony S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532211": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Vajrapukotturu Mandal",
    "officename": "Naupada S.O (Srikakulam)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532212": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Tekkali Mandal",
    "officename": "Naupada RS S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532213": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Pathapatnam",
    "officename": "Pathapatnam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532214": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Pathapatnam Mandal",
    "officename": "Korasavada S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532215": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Meliaputti Mandal",
    "officename": "Meliaputti S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532216": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Meliaputti Mandal",
    "officename": "Chapara S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532218": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Vajrapukotturu Mandal",
    "officename": "Pundi R S S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532219": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Vajrapukotturu Mandal",
    "officename": "Akkupalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532220": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Palasa Mandal",
    "officename": "Brahmanatarla S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532221": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Meliaputti Mandal",
    "officename": "Palasa S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532222": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Palasa Mandal",
    "officename": "Kasibugga S.O (Srikakulam)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532242": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Mandasa Mandal",
    "officename": "Mandasa S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532243": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Palasa",
    "officename": "Haripuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532263": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Sompeta Mandal",
    "officename": "Baruva S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532264": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Sompeta Mandal",
    "officename": "Baruva R S S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532284": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Sompeta Mandal",
    "officename": "Sompeta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532290": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Kaviti Mandal",
    "officename": "Kanchili S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532291": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Kanchili Mandal",
    "officename": "Ms Palli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532292": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Kaviti Mandal",
    "officename": "Manikyapuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532312": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Ichchapuram Mandal",
    "officename": "Ichchapuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532322": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Kaviti Mandal",
    "officename": "Kaviti S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532401": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Srikakulam",
    "officename": "Arasavilli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532402": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Ponduru Mandal",
    "officename": "S.M.Puram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532403": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Laveru Mandal",
    "officename": "Murapaka S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532404": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Gara Mandal",
    "officename": "Srikurmam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532405": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Srikakulam Mandal",
    "officename": "Gara S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532406": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Gara Mandal",
    "officename": "Calingapatnam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532407": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Cheepurupalle",
    "officename": "J.R.Puram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532408": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Etcherla",
    "officename": "Bontalakoduru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532409": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Ranasthalam Mandal",
    "officename": "Pydibheemavaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532410": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Etcherla",
    "officename": "Etcherla S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532421": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Narasannapeta",
    "officename": "Narasannapeta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532425": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Jalumuru Mandal",
    "officename": "Urlam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532426": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Saravakota Mandal",
    "officename": "Saravakota S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532427": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Saravakota Mandal",
    "officename": "Budithi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532428": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Jalumuru",
    "officename": "Mukhalingam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532429": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Polaki Mandal",
    "officename": "Polaki S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532430": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Polaki Mandal",
    "officename": "Priyagraharam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532432": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Jalumuru Mandal",
    "officename": "Jalumuru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532440": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "R.amadalavalasa",
    "officename": "Palakonda S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Parvathipuram Division"
  },
  "532443": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Seethampeta",
    "officename": "Seethampeta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Parvathipuram Division"
  },
  "532445": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Burja Mandal",
    "officename": "Burja S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532455": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Bhamini",
    "officename": "Kotturu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532456": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Bhamini",
    "officename": "Battili S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532457": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Kotturu Mandal",
    "officename": "Nivagam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532458": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Sarubujjili Mandal",
    "officename": "L.N.Peta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532459": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Kotturu Mandal",
    "officename": "Hiramandalam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532460": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Veeraghattam",
    "officename": "Veeraghattam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Parvathipuram Division"
  },
  "532461": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Vangara",
    "officename": "Seetharampuram Inam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Parvathipuram Division"
  },
  "532462": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Palakonda",
    "officename": "Neelanagaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Parvathipuram Division"
  },
  "532474": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Kotabommali Mandal",
    "officename": "Tilaru RS S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532484": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Amadalavalasa Mandal",
    "officename": "Dusi Rs S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "533001": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Kakinada (Urban)",
    "officename": "Kakinada H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533002": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Kakinada (Urban)",
    "officename": "Jagannaickpur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533003": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Kakinada (Urban)",
    "officename": "Engg.College S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533004": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Kakinada (Urban)",
    "officename": "Gandhinagar(KKD) S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533005": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Kakinada (Urban)",
    "officename": "APSP Camp S.O (East Godavari)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533006": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Kakinada",
    "officename": "Indrapalem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533016": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Karapa",
    "officename": "Turangi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533101": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Rajahmundry (Urban)",
    "officename": "Rajahmundry H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533102": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Korukonda",
    "officename": "Konthamuru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533103": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Rajahmundry (Urban)",
    "officename": "Danavaipeta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533104": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Rajahmundry (Urban)",
    "officename": "Aryapuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533105": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Rajahmundry (Urban)",
    "officename": "Sriramnagar S.O(Rajahmundry)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533106": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Rajahmundry (Urban)",
    "officename": "Spinning Mills Centre S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533107": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Rajahmundry Rural",
    "officename": "Hukumpeta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533124": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Rajahmundry Rural",
    "officename": "Industrial Estate S.O (East Godavari)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533125": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Rajahmundry Rural",
    "officename": "Dowlaiswaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533126": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Alamuru",
    "officename": "Kadiyam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533201": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Amalapuram",
    "officename": "Amalapuram H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Amalapuram Division"
  },
  "533210": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Allavaram Mandal",
    "officename": "Bendamurlanka S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Amalapuram Division"
  },
  "533211": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Ainavilli",
    "officename": "Mukteswaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Amalapuram Division"
  },
  "533212": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Katrenikona",
    "officename": "Katrenikona S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Amalapuram Division"
  },
  "533213": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Uppalaguptam",
    "officename": "Samanasa S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Amalapuram Division"
  },
  "533214": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Ambajipeta",
    "officename": "Ambajipeta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Amalapuram Division"
  },
  "533215": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Allavaram",
    "officename": "Bodasakurru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Amalapuram Division"
  },
  "533216": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Mummidivaram",
    "officename": "Mummidivaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Amalapuram Division"
  },
  "533217": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Allavaram",
    "officename": "Allavaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Amalapuram Division"
  },
  "533218": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Amalapuram",
    "officename": "Peruru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Amalapuram Division"
  },
  "533220": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "I.polavaram Mandal",
    "officename": "Kesanakurrupalem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Amalapuram Division"
  },
  "533221": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Amalapuram Mandal",
    "officename": "Bandarlanka S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Amalapuram Division"
  },
  "533222": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Uppalaguptan Mandal",
    "officename": "Anatavaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Amalapuram Division"
  },
  "533223": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Kothapeta Taluk",
    "officename": "Kothapeta S.O (East Godavari)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Amalapuram Division"
  },
  "533228": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Kothapeta",
    "officename": "Vanapalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Amalapuram Division"
  },
  "533229": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Kothapeta Taluk",
    "officename": "Palivela S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Amalapuram Division"
  },
  "533232": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Alamuru",
    "officename": "Chintaluru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533233": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Alamuru",
    "officename": "Alamuru S.O (East Godavari)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533234": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Alamuru",
    "officename": "Yeditha S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533235": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Atreyapuram Mandal",
    "officename": "Atreyapuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Amalapuram Division"
  },
  "533236": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Atreyapuram",
    "officename": "Ryali S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Amalapuram Division"
  },
  "533237": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Atreypauram",
    "officename": "Vubalanka S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Amalapuram Division"
  },
  "533238": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Ravulapalem",
    "officename": "Ravulapalem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Amalapuram Division"
  },
  "533239": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Ambajipeta",
    "officename": "Pulletikurru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Amalapuram Division"
  },
  "533240": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "D.gannavaram Mandal",
    "officename": "D.Gannavaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Amalapuram Division"
  },
  "533241": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Ambajipeta",
    "officename": "Mukkamala S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Amalapuram Division"
  },
  "533242": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Razole",
    "officename": "Razole H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Amalapuram Division"
  },
  "533244": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Razole",
    "officename": "Sivakodu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Amalapuram Division"
  },
  "533247": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Mamidikuduru",
    "officename": "Nagaram S.O (East Godavari)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Amalapuram Division"
  },
  "533248": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Razole",
    "officename": "Ponnamanda S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Amalapuram Division"
  },
  "533249": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Razole",
    "officename": "Tatipaka S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Amalapuram Division"
  },
  "533250": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Sakhinetipalli",
    "officename": "Mori S.O (East Godavari)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Amalapuram Division"
  },
  "533251": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Sakhinetipalli",
    "officename": "Sakhinetipalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Amalapuram Division"
  },
  "533252": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Sakhinetipalli Mandal",
    "officename": "Antarvedipalem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Amalapuram Division"
  },
  "533253": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Malikipuram",
    "officename": "Malikipuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Amalapuram Division"
  },
  "533254": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Malikipuram",
    "officename": "Lakkavaram S.O (East Godavari)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Amalapuram Division"
  },
  "533255": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Ramachandrapuram",
    "officename": "Ramachandrapuram H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533256": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Bikkavolu",
    "officename": "Ramachandrapuram Old Town S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533260": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Karapa",
    "officename": "Velangi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533261": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Rayavaram",
    "officename": "Chelluru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533262": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Pamarru",
    "officename": "Draksharamam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533263": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Pamarru",
    "officename": "Dangeru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533264": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Anaparthy",
    "officename": "Kutukuluru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533274": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "P.gannavaram",
    "officename": "Gopalapuram S.O (East Godavari)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Amalapuram Division"
  },
  "533284": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Gangavaram",
    "officename": "Gangavaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533285": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Gokavaram",
    "officename": "Kothapalli S.O (East Godavari)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533286": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Gokavaram",
    "officename": "Gokaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533287": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Sithanagaram",
    "officename": "Sithanagaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533288": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Rampachodavaram",
    "officename": "Rampachodavaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533289": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Gokavaram",
    "officename": "Korukonda S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533290": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Korukonda",
    "officename": "Kotikesavaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533291": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Rajavommangi",
    "officename": "Rangampeta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533292": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Korukonda",
    "officename": "Dosakayapalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533293": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Sithanagram",
    "officename": "Torredu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533294": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Rajanagaram",
    "officename": "Rajanagaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533295": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Maredumilli",
    "officename": "Maredumilli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533296": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Rajahmundry Rural",
    "officename": "GSL Medical College S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533297": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Gandepalli",
    "officename": "Gandepalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533305": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Pamarru",
    "officename": "Pamarru S.O (East Godavari)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533306": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Pamarru",
    "officename": "Kotipalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533307": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Kapileswarapuram",
    "officename": "Angara S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533308": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Mandapeta",
    "officename": "Mandapeta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533309": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Kapileswarapuram",
    "officename": "Kapileswarapuram S.O (East Godavari)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533339": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Devipatnam",
    "officename": "Chinaramanayyapeta B.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533340": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Mandapeta",
    "officename": "Tapeswaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533341": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Mandapeta",
    "officename": "Dwarapudi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533342": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Anaparthy",
    "officename": "Anaparthy S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533343": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Bikkavolu",
    "officename": "Bikkavolu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533344": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Pedapudi",
    "officename": "G.Mamidada S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533345": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Bikkavolu",
    "officename": "Pandalapaka S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533346": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Bikkavolu",
    "officename": "Rayavaram S.O (East Godavari)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533401": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Tuni",
    "officename": "Tuni S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533406": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Sankhavaram",
    "officename": "Annavaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533407": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Kotananduru",
    "officename": "Kotananduru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533408": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Thondangi",
    "officename": "Thondangi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533428": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Addatigala",
    "officename": "Addatigala S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533429": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Yeleswaram",
    "officename": "Yeleswaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533430": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Prathipadu",
    "officename": "Dharamavaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533431": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Kirlampudi",
    "officename": "Kirlampudi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533432": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Prathipadu",
    "officename": "Prathipadu S.O (East Godavari)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533433": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Pithapuram",
    "officename": "Mallam S.O (East Godavari)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533434": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Samalkot",
    "officename": "Vetlapalem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533435": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Jaggampeta",
    "officename": "Jaggampeta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533436": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Rajavommangi",
    "officename": "Rajavommangi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533437": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Peddapuram",
    "officename": "Peddapuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533440": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Kakinada",
    "officename": "Samalkot H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533444": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Gollaprolu",
    "officename": "Kathipudi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533445": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Gollaprolu",
    "officename": "Gollaprolu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533446": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Sankhavaram",
    "officename": "Sankhavaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533447": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Kothapalli",
    "officename": "Kothapalli (U) S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533448": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Kothapalli",
    "officename": "Uppada S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533449": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Gollaprolu",
    "officename": "Chebrolu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533450": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Peddapuram",
    "officename": "Pithapuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533461": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Kakinada",
    "officename": "Coringa S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533462": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Karapa",
    "officename": "Karapa S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533463": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Tallarevu",
    "officename": "Tallarevu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533464": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Pondicherry",
    "officename": "Yanam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533468": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Kakinada",
    "officename": "Gollapalem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533483": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Y .ramavaram",
    "officename": "Y .Ramavaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533577": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Amalapuram.",
    "officename": "Vilasa S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Amalapuram Division"
  },
  "534001": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Eluru",
    "officename": "Eluru H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Eluru Division"
  },
  "534002": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Eluru",
    "officename": "Venkata Rao Peta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Eluru Division"
  },
  "534003": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "S.v.peta",
    "officename": "Sanivarapu Peta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Eluru Division"
  },
  "534004": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Eluru",
    "officename": "Chataparru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Eluru Division"
  },
  "534005": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Eluru",
    "officename": "Eluru R.S S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Eluru Division"
  },
  "534006": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Eluru",
    "officename": "Narasimharao Peta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Eluru Division"
  },
  "534007": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Eluru",
    "officename": "Industrial Estate S.O (West Godavari)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Eluru Division"
  },
  "534101": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Tadepalligudem",
    "officename": "Tadepalligudem H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tadepalligudem Division"
  },
  "534102": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Tadepalligudem Mandalam",
    "officename": "Tadepalligudem Bazar S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tadepalligudem Division"
  },
  "534111": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Nallajerla Mandal",
    "officename": "Ananthapallli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tadepalligudem Division"
  },
  "534112": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Nallajarlamandalam",
    "officename": "Nallajerla S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tadepalligudem Division"
  },
  "534122": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Maruteru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534123": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Atchanta (mdl)",
    "officename": "Atchanta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534124": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Penumantra S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534126": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Alamuru S.O (West Godavari)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534134": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Attili (mdl)",
    "officename": "Attili S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534145": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Tadepalligudem Mandalam",
    "officename": "Madhavaram S.O (West Godavari)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tadepalligudem Division"
  },
  "534146": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Pentapadu Mandalam",
    "officename": "Prattipadu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tadepalligudem Division"
  },
  "534156": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Pentapadu Mandalam",
    "officename": "Duvva S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tadepalligudem Division"
  },
  "534165": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Vunguturu Mandalam",
    "officename": "West Vipparru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tadepalligudem Division"
  },
  "534166": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Pentapadumandalam",
    "officename": "Pentapadu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tadepalligudem Division"
  },
  "534176": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Nallajarla Mandalam",
    "officename": "Pothavaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tadepalligudem Division"
  },
  "534186": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Yandagandi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tadepalligudem Division"
  },
  "534195": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Nidamarrumandalam",
    "officename": "P.N.Kolanu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tadepalligudem Division"
  },
  "534196": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Pentapadu Mandalam",
    "officename": "Ch.Agraharam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tadepalligudem Division"
  },
  "534197": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Ganapavaramandalam",
    "officename": "Pippara S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tadepalligudem Division"
  },
  "534198": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Ganapavaram Mandalam",
    "officename": "Ganapavaram S.O (West Godavari)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tadepalligudem Division"
  },
  "534199": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Undi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534201": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Bhimavaram (mdl)",
    "officename": "Bhimavaram H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534202": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Sivaraopeta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534204": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "S.R.K.R .Engg.college S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534206": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Kopalle S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534207": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Tundurru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534208": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Rayalam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534209": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Mogallu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534210": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Palakoderu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534211": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Tanuku",
    "officename": "Tanuku H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534215": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Tanuku (mdl)",
    "officename": "Venkatrayapuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534216": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Vundrajavaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534217": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Iragavaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534218": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Tanuku (mdl)",
    "officename": "Mandapaka S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534222": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Velpur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534225": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Iragavaram(mdl)",
    "officename": "Relangi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534227": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Mortha S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534230": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Attili (mdl)",
    "officename": "Aravalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534235": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Akividu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534236": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Yelurupadu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534237": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Kalla S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534238": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Polamuru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534239": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Dirusumarru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534240": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Konithiwada S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534243": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Srungavruksham S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534244": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Vissakoderu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534245": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Viravasaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534247": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Rayakuduru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534250": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Lankalakoderu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534260": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Palakol (mdl)",
    "officename": "Palakol H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534265": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Palakol (mdl)",
    "officename": "Jinnuru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534266": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Doddipatla S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534267": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Poduru (mdl)",
    "officename": "Gummaluru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534268": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Ellamanchili S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534269": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Kodamanchili S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534275": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Narsapur S.O (West Godavari)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534280": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Sitaramapuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534281": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Mogalturu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534301": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Nidadavole",
    "officename": "Nidadavole S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tadepalligudem Division"
  },
  "534302": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Nidadavole Mandalam",
    "officename": "Samisragudem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tadepalligudem Division"
  },
  "534305": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Chagallu Mandalam",
    "officename": "Tadimalla S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tadepalligudem Division"
  },
  "534311": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Kannapuram",
    "officename": "Kannapuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Eluru Division"
  },
  "534312": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Koyyalagudem",
    "officename": "Koyyalagudem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Eluru Division"
  },
  "534313": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Devarapalli Mandalam",
    "officename": "Devarapalli S.O (West Godavari)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tadepalligudem Division"
  },
  "534315": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Polavarammandal",
    "officename": "Polavaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tadepalligudem Division"
  },
  "534316": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Gopalapuram Mandalam",
    "officename": "Gopalapuram S.O (West Godavari)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tadepalligudem Division"
  },
  "534318": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Gopalapuram Mandalam",
    "officename": "Dondapudi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tadepalligudem Division"
  },
  "534320": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Penugonda S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534324": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Vadali S.O (West Godavari)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534326": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Sidhantam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534327": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Poduru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534328": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Peravali S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534329": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Peravali Mandalam",
    "officename": "Kanuru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tadepalligudem Division"
  },
  "534330": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Penumantra (mdl)",
    "officename": "Khandavalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534331": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Peravali Mandalam",
    "officename": "Kakaraparru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tadepalligudem Division"
  },
  "534338": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Poduru(mdl)",
    "officename": "Kavitam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Bhimavaram Division"
  },
  "534340": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Kovvuru Mandalam",
    "officename": "Vegeswarapuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tadepalligudem Division"
  },
  "534341": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Tallapudi Mandalam",
    "officename": "Tallapudi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tadepalligudem Division"
  },
  "534342": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Chagallu Mandal",
    "officename": "Chagallu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tadepalligudem Division"
  },
  "534350": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Kovvur",
    "officename": "Kovvur SO",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tadepalligudem Division"
  },
  "534401": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Pulla",
    "officename": "Pulla S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Eluru Division"
  },
  "534406": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Chebrole",
    "officename": "Chebrole S.O (West Godavari)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Eluru Division"
  },
  "534411": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Vunguturu Mandalam",
    "officename": "Vunguturu S.O (West Godavari)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Tadepalligudem Division"
  },
  "534416": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Kaikaram",
    "officename": "Kaikaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Eluru Division"
  },
  "534425": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Bhimadole",
    "officename": "Bhimadole S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Eluru Division"
  },
  "534426": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Dwarakatirumala",
    "officename": "Dwaraka Tirumala S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Eluru Division"
  },
  "534427": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Gundugolanu",
    "officename": "Gundugolanu So. S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Eluru Division"
  },
  "534432": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Eluru",
    "officename": "Denduluru S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Eluru Division"
  },
  "534437": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Pedapadu",
    "officename": "Pedapadu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Eluru Division"
  },
  "534442": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Kovvali",
    "officename": "Kovvali S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Eluru Division"
  },
  "534447": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Jangareddigudem",
    "officename": "Jangareddygudem H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Eluru Division"
  },
  "534448": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Buttayagudem",
    "officename": "Buttayagudem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Eluru Division"
  },
  "534449": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Kamavarapukota",
    "officename": "Kamavarapukota S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Eluru Division"
  },
  "534450": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Gopannapalem",
    "officename": "Gopannapalem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Eluru Division"
  },
  "534451": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Lakkavaram",
    "officename": "Lakkavaram S.O (West Godavari)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Eluru Division"
  },
  "534452": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Tadikalapudi",
    "officename": "Tadikalapudi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Eluru Division"
  },
  "534455": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "J.r.gudem",
    "officename": "Gowrisankara Puram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Eluru Division"
  },
  "534456": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Jeelugumilli",
    "officename": "Jeelugumilli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Eluru Division"
  },
  "534460": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Chintalapudi",
    "officename": "Chintalapudi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Eluru Division"
  },
  "534461": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Pragadavaram",
    "officename": "Pragadavaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Eluru Division"
  },
  "534462": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Dharmajigudem",
    "officename": "Dharmajigudem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Eluru Division"
  },
  "534467": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "T.narasapuram",
    "officename": "T.Narasapuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Eluru Division"
  },
  "534475": {
    "state": "Andhra Pradesh",
    "district": "West Godavari",
    "block": "Vijaayrai",
    "officename": "Vijayarai S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Eluru Division"
  },
  "535001": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Vizianagaram",
    "officename": "Vizianagaram City S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Vizianagaram Division"
  },
  "535002": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Vizianagaram",
    "officename": "Vizianagaram H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Vizianagaram Division"
  },
  "535003": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Bondapalli",
    "officename": "Vizianagaram Contonment S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Vizianagaram Division"
  },
  "535004": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Vizianagaram",
    "officename": "Industrial Estate S.O (Vizianagaram)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Vizianagaram Division"
  },
  "535005": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Apspqrs",
    "officename": "Apsp Quarters S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Vizianagaram Division"
  },
  "535006": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Denkada",
    "officename": "Denkada S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Vizianagaram Division"
  },
  "535101": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Garividi",
    "officename": "Shreeramnagar S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Parvathipuram Division"
  },
  "535102": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Merakamudidam",
    "officename": "Garbham S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Parvathipuram Division"
  },
  "535124": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Badangi",
    "officename": "Uttaravalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Parvathipuram Division"
  },
  "535125": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Sigadam",
    "officename": "Mettapalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Parvathipuram Division"
  },
  "535126": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Therlam",
    "officename": "Therlam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Parvathipuram Division"
  },
  "535128": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Merakamudidam",
    "officename": "Chipurupalle S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Parvathipuram Division"
  },
  "535145": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatnam",
    "block": "Ananthagiri",
    "officename": "S Kota S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Vizianagaram Division"
  },
  "535148": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Srungavarapukota",
    "officename": "Dharmavaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Vizianagaram Division"
  },
  "535160": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Bonangi",
    "officename": "Bonangi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Vizianagaram Division"
  },
  "535161": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Vepada",
    "officename": "L Kota S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Vizianagaram Division"
  },
  "535183": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Kothavalasa",
    "officename": "Kothavalasa S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Vizianagaram Division"
  },
  "535204": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Pusapatirega",
    "officename": "Pusapatirega S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Vizianagaram Division"
  },
  "535213": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Konada",
    "officename": "Singavaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Vizianagaram Division"
  },
  "535214": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Jami",
    "officename": "Ss Korukonda S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Vizianagaram Division"
  },
  "535215": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Mentada",
    "officename": "Gantyada S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Vizianagaram Division"
  },
  "535216": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Denkada",
    "officename": "Bhogapuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Vizianagaram Division"
  },
  "535217": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Gurla",
    "officename": "Nellimarla S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Vizianagaram Division"
  },
  "535218": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Nellimarla",
    "officename": "Ramathirtam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Vizianagaram Division"
  },
  "535220": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Gurla",
    "officename": "Kotagandredu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Vizianagaram Division"
  },
  "535221": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Gantyada",
    "officename": "Pedamajjipalem S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Vizianagaram Division"
  },
  "535240": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Alamanda Rs",
    "officename": "Alamanda R S S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Vizianagaram Division"
  },
  "535250": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "S Kota",
    "officename": "Jami S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Vizianagaram Division"
  },
  "535260": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Gajapathinagaram",
    "officename": "Bondapalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Vizianagaram Division"
  },
  "535270": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Mentada",
    "officename": "Gajapathinagaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Vizianagaram Division"
  },
  "535273": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Bondapalli",
    "officename": "Mentada S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Vizianagaram Division"
  },
  "535280": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Gurla",
    "officename": "Moida S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Vizianagaram Division"
  },
  "535281": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Vepada",
    "officename": "Vepada S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Vizianagaram Division"
  },
  "535463": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Garugubilli",
    "officename": "Garugubilli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Parvathipuram Division"
  },
  "535501": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Parvathipuram",
    "officename": "Parvatipuram H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Parvathipuram Division"
  },
  "535502": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Parvatipuram",
    "officename": "Parvatipuram Bus Stand S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Parvathipuram Division"
  },
  "535521": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Komarada",
    "officename": "Komarada S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Parvathipuram Division"
  },
  "535522": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Parvatipuram",
    "officename": "Mrutyunjayarayanagaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Parvathipuram Division"
  },
  "535523": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Gummalakshmipuram",
    "officename": "Gummalakshmipuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Parvathipuram Division"
  },
  "535524": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Kurupam",
    "officename": "Kurupam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Parvathipuram Division"
  },
  "535525": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Jiyyammavalasa",
    "officename": "Ravivalasa S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Parvathipuram Division"
  },
  "535526": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Jiyyammavalasa",
    "officename": "Merangi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Parvathipuram Division"
  },
  "535527": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Parvatipuram",
    "officename": "Pedabondapalli S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Parvathipuram Division"
  },
  "535534": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Kurupam",
    "officename": "Mondemkhallu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Parvathipuram Division"
  },
  "535546": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Balijipeta",
    "officename": "Seethanagaram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Parvathipuram Division"
  },
  "535547": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Makkuva",
    "officename": "Makkuva S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Parvathipuram Division"
  },
  "535557": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Balijipeta",
    "officename": "Balijipeta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Parvathipuram Division"
  },
  "535558": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Bobbili",
    "officename": "Bobbili H.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Parvathipuram Division"
  },
  "535559": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Balijipeta",
    "officename": "Bobbili Govt.Hospital Road S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Parvathipuram Division"
  },
  "535568": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Bobbili",
    "officename": "Piridi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Parvathipuram Division"
  },
  "535573": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Bobbili",
    "officename": "Bobbili Bazar S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Parvathipuram Division"
  },
  "535578": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Badangi",
    "officename": "Donkinavalasa S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Parvathipuram Division"
  },
  "535579": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Ramabhadrapuram",
    "officename": "Ramabhadrapuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Parvathipuram Division"
  },
  "535580": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Gantyada",
    "officename": "Pedamanapuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Vizianagaram Division"
  },
  "535581": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Challapeta",
    "officename": "Challapeta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Vizianagaram Division"
  },
  "535591": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Salur",
    "officename": "Salur S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Parvathipuram Division"
  },
  "535592": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Pachipenta",
    "officename": "Pachipenta S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Parvathipuram Division"
  },
  "535593": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Salur",
    "officename": "Mamidipalle S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Parvathipuram Division"
  },
  "535594": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Jiyyammavalasa",
    "officename": "Jiyyammavalsa S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Parvathipuram Division"
  },
  "560001": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Bengaluru G.P.O.",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru GPO Division"
  },
  "560002": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Bengaluru City S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "560003": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Malleswaram S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "560004": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore South",
    "officename": "Basavanagudi H.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560005": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Fraser Town S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560006": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "J C Nagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560007": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore South",
    "officename": "Agram S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560008": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "H A L II Stage H.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560009": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "K. G. Road S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "560010": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Rajajinagar H.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "560011": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore South",
    "officename": "Jayangar III Block S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560012": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Science Institute S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "560013": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Jalahalli H.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "560015": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Jalahalli West S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "560016": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Doorvaninagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560017": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Vimanapura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560018": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore South",
    "officename": "Chamrajpet S.O (Bengaluru)",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560020": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Seshadripuram S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "560021": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Srirampuram S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "560022": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Yeswanthpura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "560023": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Magadi Road S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "560024": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "H A Farm S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560025": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Museum Road S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560026": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore South",
    "officename": "Governmemnt Electric Factory S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560027": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore South",
    "officename": "Wilson Garden S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560029": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore South",
    "officename": "Dharmaram College S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560030": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore South",
    "officename": "Adugodi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560032": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "R T Nagar H.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560033": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Maruthi Sevanagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560034": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore South",
    "officename": "Koramangala S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560035": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore South",
    "officename": "Carmelram S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560036": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Krishnarajapuram S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560037": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Marathahalli Colony S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560038": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Indiranagar S.O (Bengaluru)",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560040": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Vijayanagar S.O (Bengaluru)",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "560041": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore South",
    "officename": "Jayanagar H.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560042": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Sivan Chetty Gardens S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560043": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Kalyananagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560045": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Arabic College S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560047": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Viveknagar S.O (Bengaluru)",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560048": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Mahadevapura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560049": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Virgonagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560050": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore South",
    "officename": "Banashankari S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560051": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "H K P Road S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560053": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore South",
    "officename": "Chickpet S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560054": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Msrit S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "560055": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Malleswaram West S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "560056": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore South",
    "officename": "Bengaluru vishwavidyalaya S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560057": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Peenya Dasarahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "560058": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Peenya Small Industries S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "560059": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore South",
    "officename": "Rv Niketan S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560060": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore South",
    "officename": "Kengeri S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560061": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore South",
    "officename": "Subramanyapura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560062": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore South",
    "officename": "Doddakallasandra S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560063": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "A F Station Yelahanka S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560064": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Yelahanka S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560065": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "G K V K S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560066": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore",
    "officename": "Whitefield S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560067": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore South",
    "officename": "Kadugodi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560068": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore South",
    "officename": "Bommanahalli S.O (Bengaluru)",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560070": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore South",
    "officename": "B Sk II Stage S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560071": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Domlur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560072": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Nagarbhavi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "560073": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Nagasandra S.O (Bengaluru)",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "560074": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore South",
    "officename": "Kumbalagodu S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560075": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "New Thippasandra S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560076": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore South",
    "officename": "Bannerghatta Road S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560077": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Dr. Shivarama Karanth Nagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560078": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore South",
    "officename": "J P Nagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560079": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Basaveshwaranagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "560080": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Sadashivanagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560081": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore",
    "officename": "Chandapura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560082": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore South",
    "officename": "Udaypura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560083": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore South",
    "officename": "Bannerghatta S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560084": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "St. Thomas Town S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560085": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore South",
    "officename": "Banashankari III Stage S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560086": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Mahalakshmipuram Layout S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "560087": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Vartur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560088": {
    "state": "Karnataka",
    "district": "Bangalore Rural",
    "block": "Bangalore North",
    "officename": "Hessarghatta S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "560089": {
    "state": "Karnataka",
    "district": "Bangalore Rural",
    "block": "Bangalore North",
    "officename": "Hessarghatta Lake S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "560090": {
    "state": "Karnataka",
    "district": "Bangalore Rural",
    "block": "Bangalore North",
    "officename": "Chikkabanavara S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "560091": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Viswaneedam S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "560092": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Sahakaranagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560093": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "C V Raman Nagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560094": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "R M V Extension II Stage S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560095": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore South",
    "officename": "Koramangala VI Bk S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560096": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Nandinilayout S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "560097": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Vidyaranyapura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "560098": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore South",
    "officename": "Rajarajeshwarinagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560099": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore South",
    "officename": "Bommasandra Industrial Estate S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560100": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore South",
    "officename": "Electronics City S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560102": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore South",
    "officename": "HSR Layout S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560103": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore South",
    "officename": "Bellandur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560104": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Hampinagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "560105": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Anekal",
    "officename": "Jigani S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560107": {
    "state": "Karnataka",
    "district": "Bangalore Rural",
    "block": "Bangalore North",
    "officename": "Achitnagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "560108": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore",
    "officename": "Anjanapura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560109": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore South",
    "officename": "Thalaghattapura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560110": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore",
    "officename": "Ullalu Upanagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560112": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore",
    "officename": "Kodigehalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "560300": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Kempegowda International Airport S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "561101": {
    "state": "Karnataka",
    "district": "Bangalore Rural",
    "block": "Magadi",
    "officename": "Kudur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Channapatna Division"
  },
  "561201": {
    "state": "Karnataka",
    "district": "Bangalore Rural",
    "block": "Magadi",
    "officename": "Veeregowdanadoddi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Channapatna Division"
  },
  "561202": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Pavagada",
    "officename": "Pavagada S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "561203": {
    "state": "Karnataka",
    "district": "Bangalore Rural",
    "block": "Doddaballapura",
    "officename": "Dodballapura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "561204": {
    "state": "Karnataka",
    "district": "Bangalore Rural",
    "block": "Dodballapura",
    "officename": "Doddabelavangala S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "561205": {
    "state": "Karnataka",
    "district": "Bangalore Rural",
    "block": "Dodballapura",
    "officename": "Melekote S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "561206": {
    "state": "Karnataka",
    "district": "Chikkaballapur",
    "block": "Gauribidanur",
    "officename": "Dn Palya S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "561207": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Bagepalli",
    "officename": "Bagepalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "561208": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Gauribidanur",
    "officename": "Gauribidanur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "561209": {
    "state": "Karnataka",
    "district": "Chikkaballapur",
    "block": "Gudibanda",
    "officename": "Gudibanda S.O (Kolar)",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "561210": {
    "state": "Karnataka",
    "district": "Chikkaballapur",
    "block": "Gauribidanur",
    "officename": "Hossur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "561211": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Gauribidanur",
    "officename": "MANCHENAHALLI S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "561212": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Chickballapur",
    "officename": "Pathapalya S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "561213": {
    "state": "Karnataka",
    "district": "Chikkaballapur",
    "block": "Gauribidanure",
    "officename": "Thondebhavi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "561228": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Gauribidanur",
    "officename": "Vatadahosahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "562101": {
    "state": "Karnataka",
    "district": "Chikkaballapur",
    "block": "Chickballapur",
    "officename": "Chickballapur H.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "562102": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Sidlaghatta",
    "officename": "Melur S.O (Kolar)",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "562103": {
    "state": "Karnataka",
    "district": "Chikkaballapur",
    "block": "Chik Ballapur",
    "officename": "Nandi S.O (Kolar)",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "562104": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Chickballapur",
    "officename": "Peresandra S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "562105": {
    "state": "Karnataka",
    "district": "Chikkaballapur",
    "block": "Sidlghatta",
    "officename": "Sidlaghatta S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "562106": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Anekal",
    "officename": "Anekal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "562107": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Anekal",
    "officename": "Attibele S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "562108": {
    "state": "Karnataka",
    "district": "Ramanagar",
    "block": "Channapatna",
    "officename": "Bevur S.O (Ramanagar)",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Channapatna Division"
  },
  "562109": {
    "state": "Karnataka",
    "district": "Ramanagar",
    "block": "Ramanagara",
    "officename": "Bidadi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Channapatna Division"
  },
  "562110": {
    "state": "Karnataka",
    "district": "Bangalore Rural",
    "block": "Devanahalli",
    "officename": "Devanahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "562111": {
    "state": "Karnataka",
    "district": "Bangalore Rural",
    "block": "Nelamangala",
    "officename": "Dobbespet S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "562112": {
    "state": "Karnataka",
    "district": "Ramanagar",
    "block": "Kanakapura",
    "officename": "Harohalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Channapatna Division"
  },
  "562114": {
    "state": "Karnataka",
    "district": "Bangalore Rural",
    "block": "Hoskote",
    "officename": "Hoskote S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "562117": {
    "state": "Karnataka",
    "district": "Ramanagar",
    "block": "Kanakapura",
    "officename": "Kanakapura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Channapatna Division"
  },
  "562119": {
    "state": "Karnataka",
    "district": "Ramanagar",
    "block": "Kanakapura",
    "officename": "Kodihalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Channapatna Division"
  },
  "562120": {
    "state": "Karnataka",
    "district": "Ramanagar",
    "block": "Magadi",
    "officename": "Magadi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Channapatna Division"
  },
  "562121": {
    "state": "Karnataka",
    "district": "Ramanagar",
    "block": "Kanakapura",
    "officename": "Maralavadi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Channapatna Division"
  },
  "562122": {
    "state": "Karnataka",
    "district": "Bangalore Rural",
    "block": "Hoskote",
    "officename": "Nandagudi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Kolar Division"
  },
  "562123": {
    "state": "Karnataka",
    "district": "Bangalore Rural",
    "block": "Nelamangala",
    "officename": "Nelamangala S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "562125": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Anekal",
    "officename": "Sarjapura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "562126": {
    "state": "Karnataka",
    "district": "Ramanagar",
    "block": "Kanakapura",
    "officename": "Sathanur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Channapatna Division"
  },
  "562127": {
    "state": "Karnataka",
    "district": "Bangalore Rural",
    "block": "Magadi",
    "officename": "Solur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Channapatna Division"
  },
  "562128": {
    "state": "Karnataka",
    "district": "Ramanagar",
    "block": "Ramanagara",
    "officename": "Sugganahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Channapatna Division"
  },
  "562129": {
    "state": "Karnataka",
    "district": "Bangalore Rural",
    "block": "Hoskote",
    "officename": "Sulebele S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "562130": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bgsouth",
    "officename": "Tavarekere S.O (Bengaluru)",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "562131": {
    "state": "Karnataka",
    "district": "Bangalore Rural",
    "block": "Magadi",
    "officename": "Thippasandra S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Channapatna Division"
  },
  "562132": {
    "state": "Karnataka",
    "district": "Bangalore Rural",
    "block": "Nelamangala",
    "officename": "Tyamagondlu S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "562135": {
    "state": "Karnataka",
    "district": "Bangalore Rural",
    "block": "Devanahalli",
    "officename": "Vijayapura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "562138": {
    "state": "Karnataka",
    "district": "Ramanagar",
    "block": "Channapatna",
    "officename": "Honganur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Channapatna Division"
  },
  "562149": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Banglorenorth",
    "officename": "Bagalur S.O (Bengaluru)",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "562157": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Bangalore North",
    "officename": "Bettahalsur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "562159": {
    "state": "Karnataka",
    "district": "Ramanagar",
    "block": "Ramanagara",
    "officename": "Ramanagaram S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Channapatna Division"
  },
  "562160": {
    "state": "Karnataka",
    "district": "Ramanagar",
    "block": "Channapatna",
    "officename": "Channapatna H.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Channapatna Division"
  },
  "562161": {
    "state": "Karnataka",
    "district": "Ramanagar",
    "block": "Channapatna",
    "officename": "Government Silk Farm S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Channapatna Division"
  },
  "562162": {
    "state": "Karnataka",
    "district": "Bangalore Rural",
    "block": "Nelamangala",
    "officename": "Madanayakanahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "562163": {
    "state": "Karnataka",
    "district": "Bangalore Rural",
    "block": "Doddaballapura",
    "officename": "Nagadenahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru West Division"
  },
  "562164": {
    "state": "Karnataka",
    "district": "Bangalore",
    "block": "Devanahalli",
    "officename": "Avathi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "563101": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Kolar",
    "officename": "Kolar H.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "563103": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Kolar",
    "officename": "Tamaka S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "563113": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Bangarpet",
    "officename": "Andersonpet S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "563114": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Bangarapet",
    "officename": "Bangarpet S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "563115": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Bangarapet",
    "officename": "Beml Nagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "563116": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Bangarpet",
    "officename": "Bethamangala S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "563117": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Bangarapet",
    "officename": "Championreefs S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "563118": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Bangarapet",
    "officename": "Coromandel S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "563119": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Bangarapet",
    "officename": "Marikuppam S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "563120": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Bangarpet",
    "officename": "Oorgaum S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "563121": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Bangarpet",
    "officename": "Oorgaumpet S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "563122": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Bangarapet",
    "officename": "ROBERTSONPET MDG",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "563123": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Chintamani",
    "officename": "Batlahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "563124": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Bagepalli",
    "officename": "Chelur S.O (Kolar)",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "563125": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Chintamani",
    "officename": "Chintamani S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "563126": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Srinivasapura",
    "officename": "Dalasanur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "563127": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Mulbagal",
    "officename": "Devarayasamudra S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "563128": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Chintamani",
    "officename": "Kaiwara S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "563129": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Bangarpet",
    "officename": "Kamasamudra S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "563130": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Malur",
    "officename": "Malur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "563131": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Mulbagal",
    "officename": "Mulbagal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "563132": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Mulbagal",
    "officename": "Nangli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "563133": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Kolar",
    "officename": "Narasapura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "563134": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Srinivaspur",
    "officename": "Rayalpadu S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "563135": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Srinivasapura",
    "officename": "Srinivaspur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "563136": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Mulbagal",
    "officename": "Tayalur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "563137": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Malur",
    "officename": "Tekal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "563138": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Srinivaspur",
    "officename": "Yeldur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "563139": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Malur",
    "officename": "Masthi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "563146": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Chintamani",
    "officename": "Murugamale S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "563159": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Chintamani",
    "officename": "Burudugunte S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "563160": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Malur",
    "officename": "Malur Railway Station S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "563161": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Srinivaspur",
    "officename": "Gownipalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "563162": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Bangarpet",
    "officename": "Deshihalli Bangarpet S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "570001": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Mysore",
    "officename": "Mysuru H.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "570002": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Mysore",
    "officename": "Vani Vilas Mohalla S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "570003": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Mysore",
    "officename": "Note Mudran Nagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "570004": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Mysore",
    "officename": "Lakshmipuram S.O (Mysuru)",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "570005": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Mysore",
    "officename": "Mysuru University S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "570006": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Mysore",
    "officename": "Manasagangothri S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "570007": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Mysore",
    "officename": "Narasimha Raja Mohalla S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "570008": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Mysore",
    "officename": "Mysuru South S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "570009": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Mysore",
    "officename": "Saraswathipuram H.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "570010": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Mysore",
    "officename": "Ittigegud S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "570011": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Mysore",
    "officename": "Siddarthanagar Nagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "570012": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Mysore",
    "officename": "Jayalakshmipuram S.O (Mysuru)",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "570014": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Mysore",
    "officename": "Jayanagar S.O (Mysuru)",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "570015": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Mysore",
    "officename": "Bannimantap S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "570016": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Mysore",
    "officename": "Metagalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "570017": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Mysore",
    "officename": "Vijaynagar II Stage S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "570018": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Mysore",
    "officename": "Belavadi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "570019": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Mysore",
    "officename": "Udayagiri S.O (Mysuru)",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "570020": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Mysore",
    "officename": "Yadavagiri S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "570022": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Mysore",
    "officename": "Ramakrishna Nagar S.O (Mysuru)",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "570023": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Mysore",
    "officename": "Kuvempunagar S.O (Mysuru)",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "570025": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Mysore",
    "officename": "G S Ashram S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "570026": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "H D Kote",
    "officename": "Bogadi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "570027": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Mysore",
    "officename": "Infosys Campus S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "570028": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Mysore",
    "officename": "Alanahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "570029": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Mysore",
    "officename": "Shakthinagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "570030": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "NA",
    "officename": "Vijayanagar III Stage S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "570031": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "NA",
    "officename": "Jaya Prakash Nagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "571101": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "T Narasipura",
    "officename": "Bannur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Nanjangud Division"
  },
  "571102": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Periyapatna",
    "officename": "Bettadapura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "571103": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Hunsur",
    "officename": "Bilikere S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "571104": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Periyapatna",
    "officename": "Bylakuppe S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "571105": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Hunsur",
    "officename": "Hunsur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "571106": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Hunsur",
    "officename": "Hanagodu S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "571107": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Periyapatna",
    "officename": "Periyapatna S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "571108": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Periyapatna",
    "officename": "Ravandur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "571109": {
    "state": "Karnataka",
    "district": "Chamrajnagar",
    "block": "Gundlupet",
    "officename": "Begur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Nanjangud Division"
  },
  "571110": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "T Narasipura",
    "officename": "Gargeshwari S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Nanjangud Division"
  },
  "571111": {
    "state": "Karnataka",
    "district": "Chamrajnagar",
    "block": "Gundlupet",
    "officename": "Gundlupet S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Nanjangud Division"
  },
  "571114": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "H D Kote",
    "officename": "Heggadedevana Kote S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "571115": {
    "state": "Karnataka",
    "district": "Chamrajnagar",
    "block": "Chamarajanagara",
    "officename": "Santhemaranahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Nanjangud Division"
  },
  "571116": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "H D Kote",
    "officename": "Kabini Colony S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "571117": {
    "state": "Karnataka",
    "district": "Chamrajnagar",
    "block": "Chamarajanagara",
    "officename": "Kagalavadi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Nanjangud Division"
  },
  "571118": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Nanjangud",
    "officename": "Kalale S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Nanjangud Division"
  },
  "571119": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Nanjangud",
    "officename": "Tagadur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Nanjangud Division"
  },
  "571120": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "T Narasipura",
    "officename": "Old Sosale S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Nanjangud Division"
  },
  "571121": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "H D Kote",
    "officename": "Sargur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "571122": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "T Narasipura",
    "officename": "Talakad S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Nanjangud Division"
  },
  "571123": {
    "state": "Karnataka",
    "district": "Chamrajnagar",
    "block": "Gundlupet",
    "officename": "Tirukanambi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Nanjangud Division"
  },
  "571124": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "T Narasipura",
    "officename": "T Narasipura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Nanjangud Division"
  },
  "571125": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "H D Kote",
    "officename": "Hampapura (H D Kote) S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "571126": {
    "state": "Karnataka",
    "district": "Chamrajnagar",
    "block": "Gundlupet",
    "officename": "Hangala S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Nanjangud Division"
  },
  "571127": {
    "state": "Karnataka",
    "district": "Chamrajnagar",
    "block": "Chamarajanagara",
    "officename": "Haradanahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Nanjangud Division"
  },
  "571128": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Nanjangud",
    "officename": "Harave S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Nanjangud Division"
  },
  "571129": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Nanjangud",
    "officename": "Nagarle S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Nanjangud Division"
  },
  "571130": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Mysore",
    "officename": "Yelwal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "571134": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Hunsur",
    "officename": "Kattemalalavadi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "571187": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Periyapatna",
    "officename": "Kanagal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "571189": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Hunsur",
    "officename": "Rathnapuri Colony S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "571201": {
    "state": "Karnataka",
    "district": "Kodagu",
    "block": "Madikeri",
    "officename": "Madikeri H.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kodagu Division"
  },
  "571211": {
    "state": "Karnataka",
    "district": "Kodagu",
    "block": "Virajpet",
    "officename": "Ammathi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kodagu Division"
  },
  "571212": {
    "state": "Karnataka",
    "district": "Kodagu",
    "block": "Virajpet",
    "officename": "Cheyandane S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kodagu Division"
  },
  "571213": {
    "state": "Karnataka",
    "district": "Kodagu",
    "block": "Virajpet",
    "officename": "Gonikoppal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kodagu Division"
  },
  "571214": {
    "state": "Karnataka",
    "district": "Kodagu",
    "block": "Madikeri",
    "officename": "Napoklu S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kodagu Division"
  },
  "571215": {
    "state": "Karnataka",
    "district": "Kodagu",
    "block": "Virajpet",
    "officename": "Pollibetta S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kodagu Division"
  },
  "571216": {
    "state": "Karnataka",
    "district": "Kodagu",
    "block": "Virajpet",
    "officename": "Ponnampet S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kodagu Division"
  },
  "571217": {
    "state": "Karnataka",
    "district": "Kodagu",
    "block": "Virajpet",
    "officename": "Srimangala S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kodagu Division"
  },
  "571218": {
    "state": "Karnataka",
    "district": "Kodagu",
    "block": "Virajpet",
    "officename": "Virajpet S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kodagu Division"
  },
  "571219": {
    "state": "Karnataka",
    "district": "Kodagu",
    "block": "Virajpet",
    "officename": "Balele S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kodagu Division"
  },
  "571231": {
    "state": "Karnataka",
    "district": "Kodagu",
    "block": "Somvarpet",
    "officename": "Kodlipet S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kodagu Division"
  },
  "571232": {
    "state": "Karnataka",
    "district": "Kodagu",
    "block": "Somwarpet",
    "officename": "Kudige S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kodagu Division"
  },
  "571234": {
    "state": "Karnataka",
    "district": "Kodagu",
    "block": "Somwarpet",
    "officename": "Kushalnagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kodagu Division"
  },
  "571235": {
    "state": "Karnataka",
    "district": "Kodagu",
    "block": "Somwarpet",
    "officename": "Shanivarasanthe S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kodagu Division"
  },
  "571236": {
    "state": "Karnataka",
    "district": "Kodagu",
    "block": "Somvarpet",
    "officename": "Somwarpet S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kodagu Division"
  },
  "571237": {
    "state": "Karnataka",
    "district": "Kodagu",
    "block": "Somwarpet",
    "officename": "Suntikoppa S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kodagu Division"
  },
  "571247": {
    "state": "Karnataka",
    "district": "Kodagu",
    "block": "Madikeri",
    "officename": "Bhagamandala S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kodagu Division"
  },
  "571248": {
    "state": "Karnataka",
    "district": "Kodagu",
    "block": "Somvarpet",
    "officename": "Chettalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kodagu Division"
  },
  "571249": {
    "state": "Karnataka",
    "district": "Kodagu",
    "block": "Virajpet",
    "officename": "Hudikeri S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kodagu Division"
  },
  "571250": {
    "state": "Karnataka",
    "district": "Kodagu",
    "block": "Virajpet",
    "officename": "Kutta S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kodagu Division"
  },
  "571251": {
    "state": "Karnataka",
    "district": "Kodagu",
    "block": "Somwarpet",
    "officename": "Madapura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kodagu Division"
  },
  "571252": {
    "state": "Karnataka",
    "district": "Kodagu",
    "block": "Madikeri",
    "officename": "Murnad S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kodagu Division"
  },
  "571253": {
    "state": "Karnataka",
    "district": "Kodagu",
    "block": "Virajpet",
    "officename": "Siddapura Kodagu S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kodagu Division"
  },
  "571254": {
    "state": "Karnataka",
    "district": "Kodagu",
    "block": "Virajpet",
    "officename": "Thithimathi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kodagu Division"
  },
  "571301": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Nanjangud",
    "officename": "Nanjangud H.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Nanjangud Division"
  },
  "571302": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Nanjangud",
    "officename": "Thandavapura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Nanjangud Division"
  },
  "571311": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Mysore",
    "officename": "Kadakola S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "571312": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Nanjangud",
    "officename": "Kavalande S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Nanjangud Division"
  },
  "571313": {
    "state": "Karnataka",
    "district": "Chamrajnagar",
    "block": "Chamarajanagara",
    "officename": "Chamarajanagara S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Nanjangud Division"
  },
  "571314": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Nanjangud",
    "officename": "Hullahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Nanjangud Division"
  },
  "571315": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Nanjangud",
    "officename": "Hura S.O (Mysuru)",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Nanjangud Division"
  },
  "571316": {
    "state": "Karnataka",
    "district": "Chamrajnagar",
    "block": "Chamarajanagara",
    "officename": "Kuderu S.O (Chamrajnagar)",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Nanjangud Division"
  },
  "571320": {
    "state": "Karnataka",
    "district": "Chamrajnagar",
    "block": "Kollegal",
    "officename": "Cowdalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Nanjangud Division"
  },
  "571342": {
    "state": "Karnataka",
    "district": "Chamrajnagar",
    "block": "Chamarajanagar",
    "officename": "Ramasamudra S.O (Chamrajnagar)",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Nanjangud Division"
  },
  "571401": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Mandya",
    "officename": "Mandya H.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571402": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Mandya",
    "officename": "Sugar Town S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571403": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Mandya",
    "officename": "Guthal Colony S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571404": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Mandya",
    "officename": "Acetate Town S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571405": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Mandya",
    "officename": "V C Farm S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571415": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Srirangapatna",
    "officename": "Arakere S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571416": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Mandya",
    "officename": "Basaralu S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571417": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Malavalli",
    "officename": "Belakavadi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571418": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Nagamangala",
    "officename": "Bellur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571419": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Maddur",
    "officename": "Besagarahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571421": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Malavalli",
    "officename": "Halagur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571422": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Maddur",
    "officename": "Bharathinagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571423": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "K.r.pete",
    "officename": "Kikkeri S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571424": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Malavalli",
    "officename": "Kiragavalu S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571425": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Maddur",
    "officename": "Koppa mandya S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571426": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "K.r.pete",
    "officename": "Krishnarajapete S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571427": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Pandavapura",
    "officename": "Kyathanahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571428": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Maddur",
    "officename": "Maddur S.O (Mandya)",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571429": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Maddur",
    "officename": "Shivapura Maddur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571430": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Malavalli",
    "officename": "Malavalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571431": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Pandavapura",
    "officename": "Melukote S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571432": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Nagamangala",
    "officename": "Nagamangala S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571433": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Maddur",
    "officename": "Nidaghatta S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571434": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Pandavapura",
    "officename": "Pandavapura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571435": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Pandavapura",
    "officename": "Pandavapura R S S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571436": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "K.r.pete",
    "officename": "Santhebachahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571438": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Srirangapatna",
    "officename": "Srirangapatna H.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571439": {
    "state": "Karnataka",
    "district": "Chamrajnagar",
    "block": "Kollegal",
    "officename": "Hanur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Nanjangud Division"
  },
  "571440": {
    "state": "Karnataka",
    "district": "Chamrajnagar",
    "block": "Kollegal",
    "officename": "Kollegal H.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Nanjangud Division"
  },
  "571441": {
    "state": "Karnataka",
    "district": "Chamrajnagar",
    "block": "Yelandur",
    "officename": "Yelandur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Nanjangud Division"
  },
  "571442": {
    "state": "Karnataka",
    "district": "Chamrajnagar",
    "block": "Yelandur",
    "officename": "Mamballi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Nanjangud Division"
  },
  "571443": {
    "state": "Karnataka",
    "district": "Chamrajnagar",
    "block": "Kollegal",
    "officename": "Kamakerai S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Nanjangud Division"
  },
  "571444": {
    "state": "Karnataka",
    "district": "Chamrajnagar",
    "block": "Kollegal",
    "officename": "Ramapuram Ghat S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Nanjangud Division"
  },
  "571445": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Nagamangala",
    "officename": "Devalapura S.O (Mandya)",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571446": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Mandya",
    "officename": "Keragodu S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571448": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Nagamangala",
    "officename": "Balagangadaranathnagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571450": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Mandya",
    "officename": "Keelara S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571455": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Pandavapura",
    "officename": "Chinakurali S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571457": {
    "state": "Karnataka",
    "district": "Chamrajnagar",
    "block": "Kollegal",
    "officename": "Tibetan Settlement S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Nanjangud Division"
  },
  "571463": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Malavalli",
    "officename": "Purigali S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571475": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Malavalli",
    "officename": "Hadli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571476": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Maddur",
    "officename": "Kestur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571477": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Srirangapatna",
    "officename": "Ganjam S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571478": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Mandya",
    "officename": "Kottatti S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571490": {
    "state": "Karnataka",
    "district": "Chamrajnagar",
    "block": "Kollegal",
    "officename": "Mahadeshwara Malai S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Nanjangud Division"
  },
  "571601": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "K R Nagar",
    "officename": "Hampapura (K R Nagar) S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "571602": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "K R Nagar",
    "officename": "Krishna Raja Nagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "571603": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "K R Nagar",
    "officename": "Mirle S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "571604": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "K R Nagar",
    "officename": "Saligrama S.O (Mysuru)",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "571605": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "K.r.pete",
    "officename": "Akkihebbal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571606": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Srirangapatna",
    "officename": "Belagola S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571607": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Shrirangapattana",
    "officename": "Krishnaraja Sagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571610": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "Hunsur",
    "officename": "Gavadagere S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "571617": {
    "state": "Karnataka",
    "district": "Mysore",
    "block": "K R Nagar",
    "officename": "Chunchunakatte S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "571802": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Nagamangala",
    "officename": "Bindiganavile S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571807": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Srirangapatna",
    "officename": "Kirangoor S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571811": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "Nagamangala",
    "officename": "Chunchanahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "571812": {
    "state": "Karnataka",
    "district": "Mandya",
    "block": "K.r.pete",
    "officename": "Bukkinakere S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mandya Division"
  },
  "572101": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Tumkur",
    "officename": "Tumakuru H.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572102": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Tumkur",
    "officename": "Someswarapuram S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572103": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Tumkur",
    "officename": "Kuvempunagara S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572104": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Tumkur",
    "officename": "Kyathasandra S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572105": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Tumkur",
    "officename": "Maralur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572106": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Tumkur",
    "officename": "Northren Extension S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572107": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Tumkur",
    "officename": "M C Campus Tumakuru S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572111": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Kunigal",
    "officename": "Amruthur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572112": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Madhugiri",
    "officename": "Badavanahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572113": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Sira",
    "officename": "Baragur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572114": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Tiptur",
    "officename": "Biligere S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572115": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Sira",
    "officename": "Bukkapatna S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572116": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Pavagada",
    "officename": "Channakeshavapura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572117": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Gubbi",
    "officename": "Chelur S.O (Tumakuru)",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572118": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Tumkur",
    "officename": "Gulur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572119": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "C.n.hally",
    "officename": "Handanakere S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572120": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Kunigal",
    "officename": "Hebbur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572121": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Koratagere",
    "officename": "Holavanahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572122": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Tumkur",
    "officename": "Honnudike S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572123": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Kunigal",
    "officename": "Huliyur Durga S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572124": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Madhugiri",
    "officename": "Ittakadibbanahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572125": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Sira",
    "officename": "Kallambella S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572126": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Kunigal",
    "officename": "Kempanahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572127": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Madhugiri",
    "officename": "Kodigenahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572128": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Tumkur",
    "officename": "Kora S.O (Tumakuru)",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572129": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Koratagere",
    "officename": "Koratagere S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572130": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Kunigal",
    "officename": "Kunigal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572132": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Madhugiri",
    "officename": "Madhugiri S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572133": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Madhugiri",
    "officename": "Medigeshi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572134": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Kunigal",
    "officename": "Nagasandra S.O (Tumakuru)",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572135": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Sira",
    "officename": "P N Halli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572136": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Pavagada",
    "officename": "Palavalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572137": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Sira",
    "officename": "Sira S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572138": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Tumkur",
    "officename": "Tovinakere S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572139": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Sira",
    "officename": "Tavarekere S.O (Tumakuru)",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572140": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Tumkur",
    "officename": "Urdigere S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572141": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Pavagada",
    "officename": "Y N Hoskote S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572142": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Kunigal",
    "officename": "Yediyur S.O (Tumakuru)",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572168": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Tumkur",
    "officename": "Hirehalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572175": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Madhugiri",
    "officename": "Puravara S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572201": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Tiptur",
    "officename": "Tiptur H.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572211": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Gubbi",
    "officename": "Ammasandra S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572212": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Turuvekere",
    "officename": "Banasandra S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572213": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Gubbi",
    "officename": "Chandrashekarapura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572214": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Chikkanayakanahlli",
    "officename": "Chikkanayakanahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572215": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Turuvekere",
    "officename": "Dandinashivara S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572216": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Gubbi",
    "officename": "Gubbi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572217": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Tiptur",
    "officename": "Honnavalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572218": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "C.n.halli",
    "officename": "Huliyar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572219": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Gubbi",
    "officename": "Kadaba S.O (Tumakuru)",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572220": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Gubbi",
    "officename": "Kallur S.O (Tumakuru)",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572221": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Turuvekere",
    "officename": "Mayasandra S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572222": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Gubbi",
    "officename": "Mooganayakana Kote S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572223": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Gubbi",
    "officename": "Nittur S.O (Tumakuru)",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572224": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Tiptur",
    "officename": "Nonavinakere S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572225": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Turuvekere",
    "officename": "Sampige S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572226": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "C.n.hally",
    "officename": "Settikere S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572227": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "Turuvekere",
    "officename": "Turuvekere S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "572228": {
    "state": "Karnataka",
    "district": "Tumkur",
    "block": "C.n.halli",
    "officename": "Kandikere S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Tumakuru Division"
  },
  "573101": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Belur",
    "officename": "Arehalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573102": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Arkalgud",
    "officename": "Arkalgud S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573103": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Arsikere",
    "officename": "Arsikere H.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573111": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Channarayapatna",
    "officename": "Bagur S.O (Hassan)",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573112": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Arsikere",
    "officename": "Banavara S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573113": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Arkalgud",
    "officename": "Basavapatna S.O (Hassan)",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573115": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Arsikere",
    "officename": "Belur Hassan S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573116": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Channarayapatna",
    "officename": "Channarayapatna S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573117": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Arsikere",
    "officename": "Doddamettikurke S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573118": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Hassan",
    "officename": "Dudda R S S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573119": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Arsikere",
    "officename": "Gandasi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573120": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Hassan",
    "officename": "Gorur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573121": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Belur",
    "officename": "Halebeedu S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573122": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Arsikere",
    "officename": "Haranahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573123": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Sakleshpur",
    "officename": "Hethur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573124": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Channarayaptna",
    "officename": "Hirisave S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573125": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Arsikere",
    "officename": "Javagal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573126": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Arsikere",
    "officename": "Jaya Chamaraja Pura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573127": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Sakleshpur",
    "officename": "Bykere S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573128": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Hassan",
    "officename": "Kattaya S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573129": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Alur",
    "officename": "Kenchammanahosakote S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573130": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Arkalgud",
    "officename": "Konanur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573131": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Channarayapatna",
    "officename": "Nuggihalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573133": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Arkalgud",
    "officename": "Ramanathapura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573134": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Sakleshpur",
    "officename": "Sakleshpur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573135": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Channarayapatna",
    "officename": "Shravanabelagola S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573136": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Arkalgud",
    "officename": "Keralapura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573137": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Sakleshpura",
    "officename": "Yeslur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573141": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Channarayapatna",
    "officename": "Didaga S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573142": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Arkalgud",
    "officename": "Doddamagge S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573144": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Arsikere",
    "officename": "Kanakatte S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573162": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Arsikere",
    "officename": "Bageshpura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573164": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Arsikere",
    "officename": "Lalanakere S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573165": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Skaleshpur",
    "officename": "Hanbalu S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573201": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Hassan",
    "officename": "Hassan H.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573202": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Hassan",
    "officename": "Vidyanagar (Hassan) S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573210": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Holenarasipura",
    "officename": "Hallymysore S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573211": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Holenarasipur",
    "officename": "Holenarsipur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573212": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Hassan",
    "officename": "Mosale Hosahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573213": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Alur",
    "officename": "Alur S.O (Hassan)",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573214": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Alur",
    "officename": "Ballupet S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573215": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Belur",
    "officename": "Bikkodu S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573216": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Belur",
    "officename": "Hagare S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573217": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Hassan",
    "officename": "Kandali S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573218": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Alur",
    "officename": "Palya S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573219": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Hassan",
    "officename": "Salagame S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573220": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Hassan",
    "officename": "Shanthigrama S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "573225": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Hassan",
    "officename": "Agriculture College Campus Dly S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "574101": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Karkala",
    "officename": "Ajekar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574102": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Karkala",
    "officename": "Bailur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574103": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Udupi",
    "officename": "Hejmadi SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "574104": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Karkal",
    "officename": "Karkala H.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574105": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Udupi",
    "officename": "KatapadiUdupi SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "574106": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Udupi",
    "officename": "Kaup SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "574107": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Karkal",
    "officename": "Miyar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574108": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Karkala",
    "officename": "Muniyal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574109": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Karkala",
    "officename": "Naravi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574110": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Karkala",
    "officename": "Nitte S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574111": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Udupi",
    "officename": "Padubidri SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "574112": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Udupi",
    "officename": "Palimar SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "574113": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Udupi",
    "officename": "Pilar SO Udupi",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "574114": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Karkala",
    "officename": "Sanur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574115": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Udupi",
    "officename": "Shankarapura SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "574116": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Udupi",
    "officename": "Shirva SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "574117": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Udupi",
    "officename": "Uchila SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "574118": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Udupi",
    "officename": "Udyavara SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "574119": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Udupi",
    "officename": "Yermal SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "574122": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Karkala",
    "officename": "Bajegoli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574129": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Karkal",
    "officename": "Kanthavara S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574141": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Aikala S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "574142": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Bajpe S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "574143": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Bantval",
    "officename": "Farangipet S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "574144": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Ganjimat S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "574145": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Gurpur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "574146": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Haleangady S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "574148": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Kateel S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "574150": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Kinnigoli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "574151": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Kinnikambla S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "574153": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Bantwal",
    "officename": "Kurnad S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "574154": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Mulki S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "574197": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Kodangallu S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574198": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Belthangady",
    "officename": "Kokkada S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574199": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Mangalagangothri S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "574201": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Puttur",
    "officename": "Puttur(D.K.) H.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574202": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Puttur",
    "officename": "Darbe(Puttur) S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574203": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Puttur",
    "officename": "Nehrunagar(Puttur DK) S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574210": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Puttur",
    "officename": "Aryapu S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574211": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Bantval",
    "officename": "Bantval S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574212": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Sullia",
    "officename": "Bellare S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574213": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Belvai S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574214": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Belthangady",
    "officename": "Belthangady S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574216": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Belthangady",
    "officename": "Dharmasthala S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574217": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Belthangady",
    "officename": "Guruvayanakere S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574218": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Sullia",
    "officename": "Guthigar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574219": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Bantval",
    "officename": "Jodumarga S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574220": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Bantval",
    "officename": "Kabaka S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574221": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Puttur",
    "officename": "Kadaba S.O (Dakshina Kannada)",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574222": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Bantval",
    "officename": "Kalladka S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574223": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Puttur",
    "officename": "Kav S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574224": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Belthangady",
    "officename": "Madanthyar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574225": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Mijar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574226": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Mithabail S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574227": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Moodbidri S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574228": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Belthangady",
    "officename": "Mundaje S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574229": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Puttur",
    "officename": "Nellyadi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574230": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Puttur",
    "officename": "Nettana S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574231": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Bantval",
    "officename": "Panemangalore S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574232": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Sullia",
    "officename": "Panja S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574233": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Bantval",
    "officename": "Punjalkatte S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574234": {
    "state": "Karnataka",
    "district": "Kodagu",
    "block": "Madikeri",
    "officename": "Sampaje S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574235": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Bantval",
    "officename": "Sathya Sai Vihar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574236": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Belthangady",
    "officename": "Shirthady S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574237": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Belthangady",
    "officename": "Siddakatte S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574238": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Puttur",
    "officename": "Subramanya S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574239": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Sullia",
    "officename": "Sullia S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574240": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Belthangady",
    "officename": "Ujire S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574241": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Puttur",
    "officename": "Uppinangady S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574242": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Belthangady",
    "officename": "Venur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574243": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Puttur",
    "officename": "Vittal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574244": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Karkal",
    "officename": "Palli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574248": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Sulya",
    "officename": "Doddathota S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574253": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Bantval",
    "officename": "Mani S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574259": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Puttur",
    "officename": "Panaje S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574260": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Bantval",
    "officename": "Adyanadka S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574265": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Bantval",
    "officename": "Vogga S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574267": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Badagayedapadavu S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "574274": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Kallamundkur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574279": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Bantval",
    "officename": "Kanyana S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574285": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Puttur",
    "officename": "Alankar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574313": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Puttur",
    "officename": "Ishwaramangala S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574314": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Sulya",
    "officename": "Aranthodu S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574323": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Bantval",
    "officename": "Manchi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574324": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Bantval",
    "officename": "Vamadapadavu S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574325": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Bantval",
    "officename": "Nekkilady(34) S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574326": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Belthangady",
    "officename": "Kalleri S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574327": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Sulya",
    "officename": "Kurunjibag S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574328": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Puttur",
    "officename": "Kaniyur(Puttur) S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "574509": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Permude S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "575001": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Mangaluru H.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "575002": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Kankanady S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "575003": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Kodiyalbail S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "575004": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Bijai S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "575005": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Kulshekar H.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "575006": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Ashoknagar(MR) S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "575007": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Padil S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "575008": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Konchady S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "575010": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Panambur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "575011": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Baikampady S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "575013": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Kulur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "575014": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Surathkal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "575015": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Kavur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "575016": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Shakthinagar (Dakshina Kannada) S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "575017": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Permannur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "575018": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Derlakatte S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "575019": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Kulai S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "575020": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Ullal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "575022": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Kotekar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "575023": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Someshwar Uchil S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "575025": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Srinivasnagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "575028": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Vamanjoor S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "575029": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Pedamale S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "575030": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangalore",
    "officename": "Katipalla S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "576101": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Udupi",
    "officename": "Udupi HO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576102": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Udupi",
    "officename": "Kunjibettu SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576103": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Udupi",
    "officename": "Ambalapadi SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576104": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Udupi",
    "officename": "Manipal HO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576105": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Udupi",
    "officename": "Santhekatte SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576106": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Udupi",
    "officename": "Krodashrama SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576107": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Udupi",
    "officename": "Parkala SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576108": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Udupi",
    "officename": "Malpe SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576111": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Karkala",
    "officename": "Belmannu S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "576112": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Karkala",
    "officename": "Hebri S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "576113": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Udupi",
    "officename": "Hiriadka SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576114": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Udupi",
    "officename": "Kallianapura SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576115": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Udupi",
    "officename": "Kemmannu SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576117": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Karkal",
    "officename": "Kukkundur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Puttur Division"
  },
  "576120": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Udupi",
    "officename": "Moodubelle SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576121": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Karkala",
    "officename": "Mundkur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "576122": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Udupi",
    "officename": "Pangala SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576124": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Udupi",
    "officename": "Perdur SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576201": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Kundapura",
    "officename": "Kundapura HO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576210": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Udupi",
    "officename": "Barkur SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576211": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Kundapura",
    "officename": "Basrur SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576212": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Kundapura",
    "officename": "Belve SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576213": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Udupi",
    "officename": "Brahmavara SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576214": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Kundapura",
    "officename": "Byndoor SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576215": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Udupi",
    "officename": "Cherkadi SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576216": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Kundapura",
    "officename": "Ganguli SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576217": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Kundpaura",
    "officename": "Hanglur SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576218": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Udupi",
    "officename": "Hungarcutta SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576219": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Kundapura",
    "officename": "Khambadakone SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576220": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Kundapura",
    "officename": "Kollur SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576221": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Kundapura",
    "officename": "Kota SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576222": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Kundapura",
    "officename": "Koteshwara SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576223": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Udupi",
    "officename": "Mandarthi SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576224": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Kundapura",
    "officename": "Navunda SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576225": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Udupi",
    "officename": "Saligrama SO Udupi",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576226": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Udupi",
    "officename": "Sasthan SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576227": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Kundapura",
    "officename": "Shankaranarayana SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576228": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Kundapura",
    "officename": "Shiruru Udupi SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576229": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Kundapura",
    "officename": "Siddapura Udupi SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576230": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Kundapura",
    "officename": "Tallur SO Udupi",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576231": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Kundapura",
    "officename": "Tekkatte SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576232": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Kundapura",
    "officename": "Uppunda SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576233": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Kundapura",
    "officename": "Vandse SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576234": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Udupi",
    "officename": "Kokkarne SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576235": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Kundapura",
    "officename": "Trasi SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576247": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Kundapura",
    "officename": "Gujjadi SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576257": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Kundapura",
    "officename": "Kumbhashi SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576282": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Kundapura",
    "officename": "Hosangadi SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "576283": {
    "state": "Karnataka",
    "district": "Udupi",
    "block": "Kundapura",
    "officename": "Hattiangadi SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Udupi Division"
  },
  "577001": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Davanagere",
    "officename": "Davangere H.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "DAVANAGERE DIVISION"
  },
  "577002": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Davanagere",
    "officename": "Jayadeva Circle Davanagere S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "DAVANAGERE DIVISION"
  },
  "577003": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Davanagere",
    "officename": "Rm Yard  Davanagere S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "DAVANAGERE DIVISION"
  },
  "577004": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Davanagere",
    "officename": "Southern Extension DVG S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "DAVANAGERE DIVISION"
  },
  "577005": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Davanagere",
    "officename": "Bapuji Vidyanagara S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "DAVANAGERE DIVISION"
  },
  "577006": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Davanagere",
    "officename": "Devaraj Urs Layout Dvg S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "DAVANAGERE DIVISION"
  },
  "577101": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Chikmagalur",
    "officename": "Chikkamagaluru H.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577102": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Chikmagalur",
    "officename": "Jyothinagar S.O (Chikkamagaluru)",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577111": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Chikmagalur",
    "officename": "Aldur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577112": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Koppa",
    "officename": "Balehonnur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577113": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Mudigere",
    "officename": "Banakal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577114": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Koppa",
    "officename": "Basarikatte S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577115": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Bhadravati",
    "officename": "Bhadra Reservoir Project S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577116": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Kadur",
    "officename": "Birur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577117": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Koppa",
    "officename": "C.R.Station S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577120": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Sringeri",
    "officename": "Hariharapura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577121": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Mudigere",
    "officename": "Hirebyle S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577122": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Mudigere",
    "officename": "Javali S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577123": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Koppa",
    "officename": "Jayapura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577124": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Mudigere",
    "officename": "Kalasa S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577125": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Koppa",
    "officename": "Kammaradi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577126": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Koppa",
    "officename": "Koppa H.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577127": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Narasimharajapura",
    "officename": "Kudregundi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577128": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Tarikere",
    "officename": "Lakkavalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577129": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Tarikere",
    "officename": "Lingadahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577130": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Chikmagalur",
    "officename": "Mallandur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577131": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Chikmagalur",
    "officename": "Mallenahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577132": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Mudigere",
    "officename": "Mudigere S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577133": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Chikmagalur",
    "officename": "Mugthihalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577134": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Narasimharajapura",
    "officename": "Narasimharajapura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577135": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Kadur",
    "officename": "Sakrepatna S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577136": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Chikmagalur",
    "officename": "Sangameshwarapete S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577137": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Chikmagalur",
    "officename": "Santaveri S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577138": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Kadur",
    "officename": "Singatagere S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577139": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Koppa",
    "officename": "Sringeri S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577140": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Kadur",
    "officename": "Yagati S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577144": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Tarikere",
    "officename": "Rangenahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577145": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Tarikere",
    "officename": "Bukkambudhi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577146": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Chikmagalur",
    "officename": "Kalasapura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577160": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Mudigere",
    "officename": "Magundi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577168": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Chikmagalur",
    "officename": "Uddeboranahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577175": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Kadur",
    "officename": "Devanur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577179": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Koppa",
    "officename": "Balehole S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577180": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Kadur",
    "officename": "Chowlahiriyur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577181": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Mudigere",
    "officename": "Horanadu S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577182": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Kadur",
    "officename": "Panchanahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577201": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Shimoga",
    "officename": "Shivamogga H.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577202": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Shimoga",
    "officename": "Shivamogga Doddapete S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577203": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Shimoga",
    "officename": "Vidyanagar Shivamogga S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577204": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Shimoga",
    "officename": "Vinobanagar Shivamogga S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577205": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Shimoga",
    "officename": "Gopala Extension S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577211": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Shimoga",
    "officename": "Ayanur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577213": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Channagiri",
    "officename": "Channagiri S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "DAVANAGERE DIVISION"
  },
  "577214": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Shikarpur",
    "officename": "Hithla S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577215": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Channagiri",
    "officename": "Hodikere S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "DAVANAGERE DIVISION"
  },
  "577216": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Shimoga",
    "officename": "Holalur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577217": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Honnali",
    "officename": "Honnali S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "DAVANAGERE DIVISION"
  },
  "577218": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Channagiri",
    "officename": "Kerebilichi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "DAVANAGERE DIVISION"
  },
  "577219": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Honnali",
    "officename": "Kundur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "DAVANAGERE DIVISION"
  },
  "577220": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Tirthahalli",
    "officename": "Mandagadde S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577221": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Channagiri",
    "officename": "Nallur S.O (Davangere)",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "DAVANAGERE DIVISION"
  },
  "577222": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Shimoga",
    "officename": "Nidige S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577223": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Honnali",
    "officename": "Nyamthi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "DAVANAGERE DIVISION"
  },
  "577224": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Channagiri",
    "officename": "Sasvehalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "DAVANAGERE DIVISION"
  },
  "577225": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Honnali",
    "officename": "Saualanga S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "DAVANAGERE DIVISION"
  },
  "577226": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Tirthahalli",
    "officename": "Tudur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577227": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Bhadravathi",
    "officename": "Holehonner S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577228": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Tarikere",
    "officename": "Tarikere S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577229": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Bhadravati",
    "officename": "Kawalgundi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577230": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Honnali",
    "officename": "Chilur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "DAVANAGERE DIVISION"
  },
  "577231": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Channagiri",
    "officename": "Kanivebilichi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "DAVANAGERE DIVISION"
  },
  "577232": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Thirthahalli",
    "officename": "Bejjavalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577233": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Bhadravathi",
    "officename": "Kudligere S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577243": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Bhadravathi",
    "officename": "Anaveri S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577245": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Bhadravati",
    "officename": "Barandur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577301": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Bhadravathii",
    "officename": "Bhadravati H.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577302": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Bhadravati",
    "officename": "Bhadravathi Paper Town S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577401": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Sagar",
    "officename": "Sagar H.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577411": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Tirthahalli",
    "officename": "Agumbe S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577412": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Sagar",
    "officename": "Anandapuram S.O (Shivamogga)",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577413": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Sorab",
    "officename": "Anavatti S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577414": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Tirthahalli",
    "officename": "Arga S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577415": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Tirthahalli",
    "officename": "Devangi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577416": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Shimoga",
    "officename": "Harnahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577417": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Sagar",
    "officename": "Honnesara S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577418": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Hosanagar",
    "officename": "Hosanagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577419": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Sorab",
    "officename": "Jade S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577421": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Sagar",
    "officename": "Kargal Colony S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577422": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Tirthahalli",
    "officename": "Konandur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577423": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Shimoga",
    "officename": "Kumsi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577424": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Tirthahalli",
    "officename": "Megaravalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577425": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Sagar",
    "officename": "Nagara Shimoga SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577426": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Hosanagara",
    "officename": "Ripponpet S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577427": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Shikarpur",
    "officename": "Shikaripur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577428": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Shikarpur",
    "officename": "Shiralakoppa S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577429": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Sorab",
    "officename": "Sorab S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577430": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Sagar",
    "officename": "Talaguppa S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577431": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Sagar",
    "officename": "Thagarthi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577432": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Tirthahalli",
    "officename": "Thirthahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577433": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Shikarpur",
    "officename": "Togarsi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577434": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Sorab",
    "officename": "Ulavi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577435": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Sagar",
    "officename": "Jog Falls S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577436": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Hosanagara",
    "officename": "Humcha S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577451": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Bhadravati",
    "officename": "KVV Shankaraghattta S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577452": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Hosanagara",
    "officename": "Nittur S.O (Shivamogga)",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577453": {
    "state": "Karnataka",
    "district": "Shimoga",
    "block": "Sagar",
    "officename": "Avinahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Shivamogga Division"
  },
  "577501": {
    "state": "Karnataka",
    "district": "Chitradurga",
    "block": "Chitradurga",
    "officename": "Chitradurga H.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chitradurga Division"
  },
  "577502": {
    "state": "Karnataka",
    "district": "Chitradurga",
    "block": "Chitradurga",
    "officename": "Station Road chitradurga S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chitradurga Division"
  },
  "577511": {
    "state": "Karnataka",
    "district": "Chitradurga",
    "block": "Hiriyur",
    "officename": "Adivala S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chitradurga Division"
  },
  "577512": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Davanagere",
    "officename": "Anaji S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "DAVANAGERE DIVISION"
  },
  "577513": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Jagalur",
    "officename": "Asagodu S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "DAVANAGERE DIVISION"
  },
  "577514": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Davanagere",
    "officename": "Bada S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "DAVANAGERE DIVISION"
  },
  "577515": {
    "state": "Karnataka",
    "district": "Chitradurga",
    "block": "Hosadurga",
    "officename": "Bagur S.O (Chitradurga)",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chitradurga Division"
  },
  "577516": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Harihara",
    "officename": "Bhanuvally S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "DAVANAGERE DIVISION"
  },
  "577517": {
    "state": "Karnataka",
    "district": "Chitradurga",
    "block": "Chitradurga",
    "officename": "Turuvanur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chitradurga Division"
  },
  "577518": {
    "state": "Karnataka",
    "district": "Chitradurga",
    "block": "Davanagere",
    "officename": "Bndurga S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chitradurga Division"
  },
  "577519": {
    "state": "Karnataka",
    "district": "Chitradurga",
    "block": "Chitradurga",
    "officename": "Bharamasagara S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chitradurga Division"
  },
  "577520": {
    "state": "Karnataka",
    "district": "Chitradurga",
    "block": "Chitradurga",
    "officename": "Bheemasamudra S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chitradurga Division"
  },
  "577521": {
    "state": "Karnataka",
    "district": "Chitradurga",
    "block": "Chitradurga",
    "officename": "Bidarakere S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "DAVANAGERE DIVISION"
  },
  "577522": {
    "state": "Karnataka",
    "district": "Chitradurga",
    "block": "Davanagere",
    "officename": "Challakere S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chitradurga Division"
  },
  "577523": {
    "state": "Karnataka",
    "district": "Chitradurga",
    "block": "Holalkere",
    "officename": "Chickjajur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chitradurga Division"
  },
  "577524": {
    "state": "Karnataka",
    "district": "Chitradurga",
    "block": "Chitradurga",
    "officename": "Doddasiddavvanahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chitradurga Division"
  },
  "577525": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Davangere",
    "officename": "Hadadi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "DAVANAGERE DIVISION"
  },
  "577526": {
    "state": "Karnataka",
    "district": "Chitradurga",
    "block": "Holalkere",
    "officename": "Holalkere S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chitradurga Division"
  },
  "577527": {
    "state": "Karnataka",
    "district": "Chitradurga",
    "block": "Hoadurga",
    "officename": "Hosadurga S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chitradurga Division"
  },
  "577528": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Davanagere",
    "officename": "Jagalur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "DAVANAGERE DIVISION"
  },
  "577529": {
    "state": "Karnataka",
    "district": "Chitradurga",
    "block": "Molakalmuru",
    "officename": "Kondlahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chitradurga Division"
  },
  "577530": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Harihara",
    "officename": "Malebennur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "DAVANAGERE DIVISION"
  },
  "577531": {
    "state": "Karnataka",
    "district": "Chitradurga",
    "block": "Holalkere",
    "officename": "Malladihalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chitradurga Division"
  },
  "577532": {
    "state": "Karnataka",
    "district": "Chitradurga",
    "block": "Hiriyur",
    "officename": "Maradihalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chitradurga Division"
  },
  "577533": {
    "state": "Karnataka",
    "district": "Chitradurga",
    "block": "Hosadurga",
    "officename": "Mathodu S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chitradurga Division"
  },
  "577534": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Davanagere",
    "officename": "Mayakonda S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "DAVANAGERE DIVISION"
  },
  "577535": {
    "state": "Karnataka",
    "district": "Chitradurga",
    "block": "Molakalmuru",
    "officename": "Molakalmuru S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chitradurga Division"
  },
  "577536": {
    "state": "Karnataka",
    "district": "Chitradurga",
    "block": "Challakere",
    "officename": "Nayakanahatti S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chitradurga Division"
  },
  "577537": {
    "state": "Karnataka",
    "district": "Chitradurga",
    "block": "Challakere",
    "officename": "Obalapura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chitradurga Division"
  },
  "577538": {
    "state": "Karnataka",
    "district": "Chitradurga",
    "block": "Challakere",
    "officename": "Parasurampura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chitradurga Division"
  },
  "577539": {
    "state": "Karnataka",
    "district": "Chitradurga",
    "block": "Holalkere",
    "officename": "Ramagiri S.O (Chitradurga)",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chitradurga Division"
  },
  "577540": {
    "state": "Karnataka",
    "district": "Chitradurga",
    "block": "Molakalmuru",
    "officename": "Rampura S.O (Chitradurga)",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chitradurga Division"
  },
  "577541": {
    "state": "Karnataka",
    "district": "Chitradurga",
    "block": "Chitradurga",
    "officename": "Sirigere S.O (Chitradurga)",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chitradurga Division"
  },
  "577542": {
    "state": "Karnataka",
    "district": "Chitradurga",
    "block": "Hosadurga",
    "officename": "Srirampura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chitradurga Division"
  },
  "577543": {
    "state": "Karnataka",
    "district": "Chitradurga",
    "block": "Challakere",
    "officename": "Thallak S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chitradurga Division"
  },
  "577544": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Channagiri",
    "officename": "Thyavanige S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "DAVANAGERE DIVISION"
  },
  "577545": {
    "state": "Karnataka",
    "district": "Chitradurga",
    "block": "Hiriyur",
    "officename": "Yerabally S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chitradurga Division"
  },
  "577546": {
    "state": "Karnataka",
    "district": "Chitradurga",
    "block": "Hiriyur",
    "officename": "Hariyabbe S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chitradurga Division"
  },
  "577547": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Tarikere",
    "officename": "Ajjampura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577548": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Kadur",
    "officename": "Kadur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577549": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Tarikere",
    "officename": "Sivane S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577550": {
    "state": "Karnataka",
    "district": "Chickmagalur",
    "block": "Kadur",
    "officename": "Sollapura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chikkamagaluru Division"
  },
  "577551": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Channagiri",
    "officename": "Basavapatna S.O (Davangere)",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "DAVANAGERE DIVISION"
  },
  "577552": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Channagiri",
    "officename": "Santhebennur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "DAVANAGERE DIVISION"
  },
  "577553": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Davanagere",
    "officename": "Bilichodu S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "DAVANAGERE DIVISION"
  },
  "577554": {
    "state": "Karnataka",
    "district": "Chitradurga",
    "block": "Hosadurga",
    "officename": "Mallappanahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chitradurga Division"
  },
  "577555": {
    "state": "Karnataka",
    "district": "Chitradurga",
    "block": "Chitradurga",
    "officename": "Godabanahal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chitradurga Division"
  },
  "577556": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Davanangere",
    "officename": "Anagodu S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "DAVANAGERE DIVISION"
  },
  "577557": {
    "state": "Karnataka",
    "district": "Chitradurga",
    "block": "Davanagere",
    "officename": "H.D.Pura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chitradurga Division"
  },
  "577558": {
    "state": "Karnataka",
    "district": "Chitradurga",
    "block": "Hiriyur",
    "officename": "Aimangala S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chitradurga Division"
  },
  "577566": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Davanagere",
    "officename": "Doddabathi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "DAVANAGERE DIVISION"
  },
  "577589": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Davanagere",
    "officename": "Kondajji S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "DAVANAGERE DIVISION"
  },
  "577596": {
    "state": "Karnataka",
    "district": "Chitradurga",
    "block": "Hiriyur",
    "officename": "Dharmapura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chitradurga Division"
  },
  "577597": {
    "state": "Karnataka",
    "district": "Chitradurga",
    "block": "Hosadurga",
    "officename": "Belagur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chitradurga Division"
  },
  "577598": {
    "state": "Karnataka",
    "district": "Chitradurga",
    "block": "Hiriyur",
    "officename": "Hiriyur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chitradurga Division"
  },
  "577599": {
    "state": "Karnataka",
    "district": "Chitradurga",
    "block": "Hiriyur",
    "officename": "Hiriyur  Sugar Factory S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Chitradurga Division"
  },
  "577601": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Harihar",
    "officename": "Harihara S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "DAVANAGERE DIVISION"
  },
  "580001": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Dharwad",
    "officename": "Dharwad H.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "580002": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Dharwad",
    "officename": "Dharwad Saraswatpur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "580003": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Dharwad",
    "officename": "Dharwad K V V S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "580004": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Dharwad",
    "officename": "Dharwad Vidyagiri S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "580005": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Dharwad",
    "officename": "Dharwad U A S S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "580006": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Dharwad",
    "officename": "Dharwad M J Nagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "580007": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Dharwad",
    "officename": "Dharwad R S S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "580008": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Dharwad",
    "officename": "Dharwad K.C.Park S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "580009": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Dharwad",
    "officename": "Dharwad Sattur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "580011": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Dharwad",
    "officename": "Dharwad High Court S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "580020": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Hubli",
    "officename": "Hubballi H.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "580021": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Hubli",
    "officename": "Hubballi Vidyanagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "580023": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Hubli",
    "officename": "Hubballi Keshwapur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "580024": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Hubli",
    "officename": "Old Hubballi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "580025": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Hubli",
    "officename": "Hubballi Navanagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "580026": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Hubli",
    "officename": "Hubballi Tarihal Indl. Estate S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "580028": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Hubli",
    "officename": "Hubballi Mv Galli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "580029": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Hubli",
    "officename": "Hubballii Traffic Island S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "580030": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Hubli",
    "officename": "Hubballi Udyamnagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "580031": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Hubli",
    "officename": "Hubballi Eng College S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "580032": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Hubli",
    "officename": "Hubballi Vijayanagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "580112": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Dharwad",
    "officename": "Morab S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "580114": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Kalghatgi",
    "officename": "Dhumwad S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "580118": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Dharwad",
    "officename": "Hulkoppa S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "581101": {
    "state": "Karnataka",
    "district": "Haveri",
    "block": "Hangal",
    "officename": "Adur S.O (Haveri)",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Haveri Division"
  },
  "581102": {
    "state": "Karnataka",
    "district": "Haveri",
    "block": "Hangal",
    "officename": "Akkialur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Haveri Division"
  },
  "581103": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Dharwad",
    "officename": "Alnavar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "581104": {
    "state": "Karnataka",
    "district": "Haveri",
    "block": "Hangal",
    "officename": "Hangal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Haveri Division"
  },
  "581105": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Dharwad",
    "officename": "Garag S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "581106": {
    "state": "Karnataka",
    "district": "Haveri",
    "block": "Byadgi",
    "officename": "Byadgi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Haveri Division"
  },
  "581107": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Kundgol",
    "officename": "Gudgeri S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "581108": {
    "state": "Karnataka",
    "district": "Haveri",
    "block": "Haveri",
    "officename": "Guttal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Haveri Division"
  },
  "581109": {
    "state": "Karnataka",
    "district": "Haveri",
    "block": "Hirekerur",
    "officename": "Haunsabhavi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Haveri Division"
  },
  "581110": {
    "state": "Karnataka",
    "district": "Haveri",
    "block": "Haveri",
    "officename": "Haveri H.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Haveri Division"
  },
  "581111": {
    "state": "Karnataka",
    "district": "Haveri",
    "block": "Hirekerur",
    "officename": "Hirekerur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Haveri Division"
  },
  "581112": {
    "state": "Karnataka",
    "district": "Haveri",
    "block": "Haveri",
    "officename": "Karajagi S.O (Haveri)",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Haveri Division"
  },
  "581113": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Kundgol",
    "officename": "Kundgol S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "581115": {
    "state": "Karnataka",
    "district": "Haveri",
    "block": "Ranebennur",
    "officename": "Ranebennur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Haveri Division"
  },
  "581116": {
    "state": "Karnataka",
    "district": "Haveri",
    "block": "Hirekerur",
    "officename": "Rattihalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Haveri Division"
  },
  "581117": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Kundgol",
    "officename": "Saunshi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "581118": {
    "state": "Karnataka",
    "district": "Haveri",
    "block": "Savanur",
    "officename": "Savanur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Haveri Division"
  },
  "581119": {
    "state": "Karnataka",
    "district": "Haveri",
    "block": "Hirekerur",
    "officename": "Tumminakatti S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Haveri Division"
  },
  "581120": {
    "state": "Karnataka",
    "district": "Haveri",
    "block": "Byadgi",
    "officename": "Tilavalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Haveri Division"
  },
  "581121": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Supa",
    "officename": "Castlerock S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Sirsi Division"
  },
  "581123": {
    "state": "Karnataka",
    "district": "Haveri",
    "block": "Ranebennur",
    "officename": "Kumarapattanam S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Haveri Division"
  },
  "581126": {
    "state": "Karnataka",
    "district": "Haveri",
    "block": "Savanur",
    "officename": "Hulgur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Haveri Division"
  },
  "581128": {
    "state": "Karnataka",
    "district": "Haveri",
    "block": "Haveri",
    "officename": "Agadi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Haveri Division"
  },
  "581129": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Joida",
    "officename": "Jagalbet S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Sirsi Division"
  },
  "581145": {
    "state": "Karnataka",
    "district": "Haveri",
    "block": "Ranebennur",
    "officename": "Chalageri S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Haveri Division"
  },
  "581148": {
    "state": "Karnataka",
    "district": "Haveri",
    "block": "Haveri",
    "officename": "Sangur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Haveri Division"
  },
  "581186": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Joida",
    "officename": "Joida S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Sirsi Division"
  },
  "581187": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Joida",
    "officename": "Kumbarwada S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Sirsi Division"
  },
  "581193": {
    "state": "Karnataka",
    "district": "Haveri",
    "block": "Shiggaon",
    "officename": "Dhundashi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Haveri Division"
  },
  "581195": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Kundgol",
    "officename": "Koliwad S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "581196": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Kalghatgi",
    "officename": "Mishrikoti S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "581198": {
    "state": "Karnataka",
    "district": "Haveri",
    "block": "NA",
    "officename": "Motebennur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Haveri Division"
  },
  "581201": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Dharwad",
    "officename": "Amminabhavi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "581202": {
    "state": "Karnataka",
    "district": "Haveri",
    "block": "Shiggaon",
    "officename": "Bankapur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Haveri Division"
  },
  "581203": {
    "state": "Karnataka",
    "district": "Haveri",
    "block": "Hangal",
    "officename": "Bommanahalli S.O (Haveri)",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Haveri Division"
  },
  "581204": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Kalghatgi",
    "officename": "Kalghatagi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "581205": {
    "state": "Karnataka",
    "district": "Haveri",
    "block": "Shiggaon",
    "officename": "Shiggaon S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Haveri Division"
  },
  "581206": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Dharwad",
    "officename": "Uppinabetageri S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "581207": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Hubli",
    "officename": "Aralikatti S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "581208": {
    "state": "Karnataka",
    "district": "Haveri",
    "block": "Ranebennur",
    "officename": "Halageri S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Haveri Division"
  },
  "581209": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Navalagund",
    "officename": "Hebsur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "581210": {
    "state": "Karnataka",
    "district": "Haveri",
    "block": "Hirekerur",
    "officename": "Masur S.O (Haveri)",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Haveri Division"
  },
  "581211": {
    "state": "Karnataka",
    "district": "Haveri",
    "block": "Ranebennur",
    "officename": "Medleri S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Haveri Division"
  },
  "581212": {
    "state": "Karnataka",
    "district": "Haveri",
    "block": "Shiggoan",
    "officename": "Tadas S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Haveri Division"
  },
  "581213": {
    "state": "Karnataka",
    "district": "Haveri",
    "block": "Haveri",
    "officename": "Hosaritti S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Haveri Division"
  },
  "581301": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Karwar",
    "officename": "Karwar H.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581302": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Karwar",
    "officename": "Karwar Baitkhol S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581303": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Karwar",
    "officename": "Kodibag S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581304": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Karwar",
    "officename": "Nandangadda S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581306": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Karwar",
    "officename": "Habbuwada S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581307": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Karwar",
    "officename": "Binaga S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581308": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Karwar",
    "officename": "Karwar Naval Base S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581314": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Ankola",
    "officename": "Ankola S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581315": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Sirsi",
    "officename": "Aminalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Sirsi Division"
  },
  "581316": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Ankola",
    "officename": "Aversa S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581317": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Karwar",
    "officename": "Asnoti S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581318": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Sirsi",
    "officename": "Banavasi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Sirsi Division"
  },
  "581319": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Ankola",
    "officename": "Bankikodla S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581320": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Bhatkal",
    "officename": "Bhatkal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581321": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Ankola",
    "officename": "Belekeri S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581322": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Siddapur",
    "officename": "Bilgi S.O (Uttara Kannada)",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Sirsi Division"
  },
  "581323": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Honavar",
    "officename": "Chandavar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581324": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Karwar",
    "officename": "Chendiye S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581325": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Haliyal",
    "officename": "Dandeli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Sirsi Division"
  },
  "581326": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Kumta",
    "officename": "Gokarn S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581327": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Honavar",
    "officename": "Haldipur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581328": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Karwar",
    "officename": "Halge S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581329": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Haliyal",
    "officename": "Haliyal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Sirsi Division"
  },
  "581330": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Kumta",
    "officename": "Hegde S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581331": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Siddapur",
    "officename": "Heggarni S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Sirsi Division"
  },
  "581332": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Kumta",
    "officename": "Herwatta S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581333": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Kumta",
    "officename": "Hiregutti S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581334": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Honavar",
    "officename": "Honavar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581335": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Honavar",
    "officename": "Hosad S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581336": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Sirsi",
    "officename": "Hulekal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Sirsi Division"
  },
  "581337": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Yellapur",
    "officename": "Idgundi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Sirsi Division"
  },
  "581338": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Honavar",
    "officename": "Kadtoka S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581339": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Karwar",
    "officename": "Kadwad S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581340": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Siddapur",
    "officename": "Kansur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Sirsi Division"
  },
  "581341": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Honavar",
    "officename": "Karki S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581342": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Honavar",
    "officename": "Kasarkod S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581343": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Kumta",
    "officename": "Kumta H.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581344": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Kumta",
    "officename": "Madangeri S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581345": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Karwar",
    "officename": "Majali S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581346": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Mundgod",
    "officename": "Malgi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Sirsi Division"
  },
  "581347": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Yellapur",
    "officename": "Manchikeri S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Sirsi Division"
  },
  "581348": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Honavar",
    "officename": "Manki S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581349": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Mundgod",
    "officename": "Mundgod S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Sirsi Division"
  },
  "581350": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Bhatkal",
    "officename": "Murdeshwar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581351": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Kumta",
    "officename": "Gudeangadi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581352": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Karwar",
    "officename": "Sadashivgad S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581353": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Ankola",
    "officename": "Shetgeri S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581354": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Bhatkal",
    "officename": "Shirali S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581355": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Siddapur",
    "officename": "Siddapur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Sirsi Division"
  },
  "581356": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Haliyal",
    "officename": "Tergaon S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Sirsi Division"
  },
  "581357": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Ankola",
    "officename": "Vandige S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581358": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Sirsi",
    "officename": "Yekkambi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Sirsi Division"
  },
  "581359": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Yellapur",
    "officename": "Yellapur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Sirsi Division"
  },
  "581360": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Karwar",
    "officename": "Angadi S.O (Uttara Kannada)",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581361": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Honavar",
    "officename": "Hadinbal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581362": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Kumta",
    "officename": "Kumta Kanara College Road S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581363": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Haliyal",
    "officename": "Ambikanagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Sirsi Division"
  },
  "581365": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Joida",
    "officename": "Ganeshgudi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Sirsi Division"
  },
  "581384": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Honavar",
    "officename": "Gersoppa Jyothinagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581396": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Karwar",
    "officename": "Kadra S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581400": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Karwar",
    "officename": "Kaiga S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581401": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Sirsi",
    "officename": "Sirsi H.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Sirsi Division"
  },
  "581402": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Sirsi",
    "officename": "Sirsi Market S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Sirsi Division"
  },
  "581403": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Sirsi",
    "officename": "Nilekani S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Sirsi Division"
  },
  "581411": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Mundgod",
    "officename": "Tibetan Colony S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Sirsi Division"
  },
  "581412": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Yellapur",
    "officename": "Kirwatti S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Sirsi Division"
  },
  "581421": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Bhatkal",
    "officename": "Kaikini S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581423": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Honavar",
    "officename": "Melin Idgunji S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581440": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Kumta",
    "officename": "Mirjan S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Karwar Division"
  },
  "581450": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Siddapur",
    "officename": "Neggu S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Sirsi Division"
  },
  "581453": {
    "state": "Karnataka",
    "district": "Uttara Kannada",
    "block": "Sirsi",
    "officename": "Ramnagar S.O (Uttara Kannada)",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Sirsi Division"
  },
  "582101": {
    "state": "Karnataka",
    "district": "Gadag",
    "block": "Gadag",
    "officename": "Gadag H.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gadag Division"
  },
  "582102": {
    "state": "Karnataka",
    "district": "Gadag",
    "block": "Gadag",
    "officename": "Gadag Betgeri S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gadag Division"
  },
  "582103": {
    "state": "Karnataka",
    "district": "Gadag",
    "block": "Gadag",
    "officename": "Gadag City S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gadag Division"
  },
  "582111": {
    "state": "Karnataka",
    "district": "Gadag",
    "block": "Ron",
    "officename": "Abbigeri S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gadag Division"
  },
  "582112": {
    "state": "Karnataka",
    "district": "Gadag",
    "block": "Shirahatti",
    "officename": "Bellatti S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gadag Division"
  },
  "582113": {
    "state": "Karnataka",
    "district": "Gadag",
    "block": "Mundargi",
    "officename": "Dambal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gadag Division"
  },
  "582114": {
    "state": "Karnataka",
    "district": "Gadag",
    "block": "Ron",
    "officename": "Gajendragad S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gadag Division"
  },
  "582115": {
    "state": "Karnataka",
    "district": "Gadag",
    "block": "Mundargi",
    "officename": "Lakkundi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gadag Division"
  },
  "582116": {
    "state": "Karnataka",
    "district": "Gadag",
    "block": "Shirahatti",
    "officename": "Lakshmeshwar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gadag Division"
  },
  "582117": {
    "state": "Karnataka",
    "district": "Gadag",
    "block": "Gadag",
    "officename": "Mulgund S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gadag Division"
  },
  "582118": {
    "state": "Karnataka",
    "district": "Gadag",
    "block": "Mundargi",
    "officename": "Mundargi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gadag Division"
  },
  "582119": {
    "state": "Karnataka",
    "district": "Gadag",
    "block": "Ron",
    "officename": "Naregal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gadag Division"
  },
  "582120": {
    "state": "Karnataka",
    "district": "Gadag",
    "block": "Shirhatti",
    "officename": "Shiratti S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gadag Division"
  },
  "582201": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Navalgund",
    "officename": "Annigeri S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "582202": {
    "state": "Karnataka",
    "district": "Gadag",
    "block": "Ron",
    "officename": "Belvanki S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gadag Division"
  },
  "582203": {
    "state": "Karnataka",
    "district": "Gadag",
    "block": "Ron",
    "officename": "Holealur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gadag Division"
  },
  "582204": {
    "state": "Karnataka",
    "district": "Gadag",
    "block": "Ron",
    "officename": "Hombal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gadag Division"
  },
  "582205": {
    "state": "Karnataka",
    "district": "Gadag",
    "block": "Gadag",
    "officename": "Hulkoti S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gadag Division"
  },
  "582206": {
    "state": "Karnataka",
    "district": "Gadag",
    "block": "Nargund",
    "officename": "Konnur S.O (Gadag)",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gadag Division"
  },
  "582207": {
    "state": "Karnataka",
    "district": "Gadag",
    "block": "Nargund",
    "officename": "Nargund S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gadag Division"
  },
  "582208": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Navalgund",
    "officename": "Navalgund S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "582209": {
    "state": "Karnataka",
    "district": "Gadag",
    "block": "Ron",
    "officename": "Ron S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gadag Division"
  },
  "582210": {
    "state": "Karnataka",
    "district": "Gadag",
    "block": "Shirhatti",
    "officename": "Shigli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gadag Division"
  },
  "582211": {
    "state": "Karnataka",
    "district": "Gadag",
    "block": "Ron",
    "officename": "Sudi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gadag Division"
  },
  "583101": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Bellary",
    "officename": "Ballari H.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583102": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Bellary",
    "officename": "Ballari Cowl Bazar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583103": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Bellary",
    "officename": "Ballari Gandhinagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583104": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Bellary",
    "officename": "Ballari Cantonment S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583105": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Bellary",
    "officename": "Ballari Jnanasagara S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583111": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Bellary",
    "officename": "Chellakurki S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583112": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Sandur",
    "officename": "Deogiri S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583113": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Bellary",
    "officename": "Emmiganur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583114": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Siruguppa",
    "officename": "Hatcholi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583115": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Bellary",
    "officename": "Kudathini S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583116": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Bellary",
    "officename": "Kurugodu S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583117": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Bellary",
    "officename": "Moka S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583118": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Sandur",
    "officename": "D T Ship S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583119": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Sandur",
    "officename": "Sandur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583120": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Siruguppa",
    "officename": "Sirigere S.O(Ballari)",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583121": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Siruguppa",
    "officename": "Siruguppa S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583122": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Siruguppa",
    "officename": "Tekkalakota S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583123": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Sandur",
    "officename": "Toranagallu S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583124": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Sandur",
    "officename": "Yeshwantnagar S.O(Ballari)",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583125": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Harapanahalli",
    "officename": "Arasikere S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583126": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Kudligi",
    "officename": "Chikkajogihalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583127": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Harapanahalli",
    "officename": "Chigatere S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583128": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Sandur",
    "officename": "Choranur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583129": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Hospet",
    "officename": "Devalapura S.O(Ballari)",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583130": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Kudligi",
    "officename": "Gudekota S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583131": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Davanagere",
    "officename": "Harapanahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583132": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Hospet",
    "officename": "Kampli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583134": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Kudligi",
    "officename": "Kottur S.O(Ballari)",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583135": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Kudligi",
    "officename": "Kudligi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583136": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Kudligi",
    "officename": "Oojein S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583137": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Harapanahalli",
    "officename": "Teligi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583152": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Bellary",
    "officename": "Ballari Thermal Power Station S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583201": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Hospet",
    "officename": "Hosapete H.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583203": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Hospet",
    "officename": "Hosapete N C C S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583211": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Hospet",
    "officename": "Chitwadgi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583212": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Hb Halli",
    "officename": "Hagaribommanahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583213": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Harapanahalli",
    "officename": "Halavagalu S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583214": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Hb Halli",
    "officename": "Hampasagara S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583215": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Hospet",
    "officename": "Hampi Power House S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583216": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Huvinahadagali",
    "officename": "Hirehadagali S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583217": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Huvinahadagali",
    "officename": "Holalu S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583218": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Kudligi",
    "officename": "Hosahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583219": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Huvinahadagali",
    "officename": "Huvinahadagali S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583220": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Huvinahadagali",
    "officename": "Ittigi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583221": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Hospet",
    "officename": "Kamalapura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583222": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Hospet Ho",
    "officename": "Mariammanahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583223": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Hospet",
    "officename": "Papinayakanahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583224": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Hagaribommanahalli",
    "officename": "Thambrahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583225": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Hospet",
    "officename": "T B Dam S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583226": {
    "state": "Karnataka",
    "district": "Koppal",
    "block": "Koppal",
    "officename": "Alawandi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "KOPPAL DIVISION"
  },
  "583227": {
    "state": "Karnataka",
    "district": "Koppal",
    "block": "Gangavathi",
    "officename": "Gangavathi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "KOPPAL DIVISION"
  },
  "583228": {
    "state": "Karnataka",
    "district": "Koppal",
    "block": "Koppal",
    "officename": "Ginigera S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "KOPPAL DIVISION"
  },
  "583229": {
    "state": "Karnataka",
    "district": "Koppal",
    "block": "Gamgavatjhi",
    "officename": "Karatgi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "KOPPAL DIVISION"
  },
  "583230": {
    "state": "Karnataka",
    "district": "Koppal",
    "block": "Koppal",
    "officename": "Kinhal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "KOPPAL DIVISION"
  },
  "583231": {
    "state": "Karnataka",
    "district": "Koppal",
    "block": "Koppal",
    "officename": "Koppal H.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "KOPPAL DIVISION"
  },
  "583232": {
    "state": "Karnataka",
    "district": "Koppal",
    "block": "Yelburga",
    "officename": "Kuknoor S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "KOPPAL DIVISION"
  },
  "583233": {
    "state": "Karnataka",
    "district": "Gadag",
    "block": "Ron",
    "officename": "Munirabad S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "KOPPAL DIVISION"
  },
  "583234": {
    "state": "Karnataka",
    "district": "Koppal",
    "block": "Koppal",
    "officename": "Munirabad RS S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "KOPPAL DIVISION"
  },
  "583235": {
    "state": "Karnataka",
    "district": "Koppal",
    "block": "Gangavati",
    "officename": "Wadderhatti SO",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "KOPPAL DIVISION"
  },
  "583236": {
    "state": "Karnataka",
    "district": "Koppal",
    "block": "Yelburga",
    "officename": "Yelburga S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "KOPPAL DIVISION"
  },
  "583237": {
    "state": "Karnataka",
    "district": "Koppal",
    "block": "Yelburga",
    "officename": "Bewoor S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "KOPPAL DIVISION"
  },
  "583238": {
    "state": "Karnataka",
    "district": "Koppal",
    "block": "Koppal",
    "officename": "Bhagyanagar S.O (Koppal)",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "KOPPAL DIVISION"
  },
  "583239": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Hospet",
    "officename": "Hampi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583268": {
    "state": "Karnataka",
    "district": "Koppal",
    "block": "Gangavahi",
    "officename": "Pragathinagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "KOPPAL DIVISION"
  },
  "583275": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Sandur",
    "officename": "Vidyanagar S.O(Ballari)",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583276": {
    "state": "Karnataka",
    "district": "Bellary",
    "block": "Hospet",
    "officename": "K U Campus S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583277": {
    "state": "Karnataka",
    "district": "Koppal",
    "block": "Kushtagi",
    "officename": "Kushtagi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "KOPPAL DIVISION"
  },
  "583278": {
    "state": "Karnataka",
    "district": "Koppal",
    "block": "Kushtagi",
    "officename": "Dotihal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "KOPPAL DIVISION"
  },
  "583279": {
    "state": "Karnataka",
    "district": "Koppal",
    "block": "Kushtagi",
    "officename": "Tavargera S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "KOPPAL DIVISION"
  },
  "583280": {
    "state": "Karnataka",
    "district": "Koppal",
    "block": "Kushtagi",
    "officename": "Hanumanhal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "KOPPAL DIVISION"
  },
  "583281": {
    "state": "Karnataka",
    "district": "Koppal",
    "block": "Kushtagi",
    "officename": "Hanamsagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "KOPPAL DIVISION"
  },
  "583282": {
    "state": "Karnataka",
    "district": "Koppal",
    "block": "Gangavati",
    "officename": "Sriramnagar S.O (Koppal)",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "KOPPAL DIVISION"
  },
  "583283": {
    "state": "Karnataka",
    "district": "Koppal",
    "block": "Gangavathi",
    "officename": "Kanakgiri S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "KOPPAL DIVISION"
  },
  "584101": {
    "state": "Karnataka",
    "district": "Raichur",
    "block": "Raichur",
    "officename": "Raichur H.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Raichur Division"
  },
  "584102": {
    "state": "Karnataka",
    "district": "Raichur",
    "block": "Raichur",
    "officename": "Raichur Mukram Gunj S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Raichur Division"
  },
  "584103": {
    "state": "Karnataka",
    "district": "Raichur",
    "block": "Raichur",
    "officename": "Raichur Jawahar Nagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Raichur Division"
  },
  "584104": {
    "state": "Karnataka",
    "district": "Raichur",
    "block": "Raichur",
    "officename": "Raichur UAS S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Raichur Division"
  },
  "584111": {
    "state": "Karnataka",
    "district": "Raichur",
    "block": "Deodurga",
    "officename": "Deodurga S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Raichur Division"
  },
  "584113": {
    "state": "Karnataka",
    "district": "Raichur",
    "block": "Raichur",
    "officename": "Gabbur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Raichur Division"
  },
  "584115": {
    "state": "Karnataka",
    "district": "Raichur",
    "block": "Manvi",
    "officename": "Hutti S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Raichur Division"
  },
  "584116": {
    "state": "Karnataka",
    "district": "Raichur",
    "block": "Deodurga",
    "officename": "Jalahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Raichur Division"
  },
  "584118": {
    "state": "Karnataka",
    "district": "Raichur",
    "block": "Manvi",
    "officename": "Kallur S.O (Raichur)",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Raichur Division"
  },
  "584120": {
    "state": "Karnataka",
    "district": "Raichur",
    "block": "Manvi",
    "officename": "Kowthal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Raichur Division"
  },
  "584122": {
    "state": "Karnataka",
    "district": "Raichur",
    "block": "Lingasugur",
    "officename": "Lingasugur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Raichur Division"
  },
  "584123": {
    "state": "Karnataka",
    "district": "Raichur",
    "block": "Manvi",
    "officename": "Manvi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Raichur Division"
  },
  "584124": {
    "state": "Karnataka",
    "district": "Raichur",
    "block": "Sindhanur",
    "officename": "Maski S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Raichur Division"
  },
  "584125": {
    "state": "Karnataka",
    "district": "Raichur",
    "block": "Lingasugur",
    "officename": "Mudgal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Raichur Division"
  },
  "584126": {
    "state": "Karnataka",
    "district": "Raichur",
    "block": "Deodurga",
    "officename": "Mosarkal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Raichur Division"
  },
  "584127": {
    "state": "Karnataka",
    "district": "Raichur",
    "block": "Lingasugur",
    "officename": "Rodalbanda S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Raichur Division"
  },
  "584128": {
    "state": "Karnataka",
    "district": "Raichur",
    "block": "Sindhanur",
    "officename": "Sindhanur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Raichur Division"
  },
  "584129": {
    "state": "Karnataka",
    "district": "Raichur",
    "block": "Deodurga",
    "officename": "Sirwar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Raichur Division"
  },
  "584132": {
    "state": "Karnataka",
    "district": "Raichur",
    "block": "Sindhanur",
    "officename": "Turvihal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Raichur Division"
  },
  "584133": {
    "state": "Karnataka",
    "district": "Raichur",
    "block": "Raichur",
    "officename": "Yergera S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Raichur Division"
  },
  "584134": {
    "state": "Karnataka",
    "district": "Raichur",
    "block": "Raichur",
    "officename": "Yeramarus S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Raichur Division"
  },
  "584135": {
    "state": "Karnataka",
    "district": "Raichur",
    "block": "Raichur",
    "officename": "Yeramarus Camp S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Raichur Division"
  },
  "584136": {
    "state": "Karnataka",
    "district": "Raichur",
    "block": "Raichur",
    "officename": "Kalmala S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Raichur Division"
  },
  "584138": {
    "state": "Karnataka",
    "district": "Raichur",
    "block": "Sindhanur",
    "officename": "Balaganur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Raichur Division"
  },
  "584139": {
    "state": "Karnataka",
    "district": "Raichur",
    "block": "Lingasugur",
    "officename": "Gurgunta S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Raichur Division"
  },
  "584140": {
    "state": "Karnataka",
    "district": "Raichur",
    "block": "Raichur",
    "officename": "Gunjahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Raichur Division"
  },
  "584143": {
    "state": "Karnataka",
    "district": "Raichur",
    "block": "Sindhnur",
    "officename": "Jawalgera S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Raichur Division"
  },
  "584167": {
    "state": "Karnataka",
    "district": "Raichur",
    "block": "Sindhanur",
    "officename": "Dhadesugur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Raichur Division"
  },
  "584170": {
    "state": "Karnataka",
    "district": "Raichur",
    "block": "Raichur",
    "officename": "Shaktinagar S.O (Raichur)",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Raichur Division"
  },
  "584202": {
    "state": "Karnataka",
    "district": "Raichur",
    "block": "Raichur",
    "officename": "Matmari S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Raichur Division"
  },
  "584203": {
    "state": "Karnataka",
    "district": "Raichur",
    "block": "Manvi",
    "officename": "Kurdi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Raichur Division"
  },
  "585101": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Gulbarga",
    "officename": "Kalaburagi H.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Kalaburagi Division"
  },
  "585102": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Gulbarga",
    "officename": "GB RS S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Kalaburagi Division"
  },
  "585103": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Gulbarga",
    "officename": "GB Bahamanipura S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Kalaburagi Division"
  },
  "585104": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Gulbarga",
    "officename": "GB N Gunj S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Kalaburagi Division"
  },
  "585105": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Gulbarga",
    "officename": "GB Ggh S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Kalaburagi Division"
  },
  "585106": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Gulbarga",
    "officename": "GB Jnanaganga S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Kalaburagi Division"
  },
  "585201": {
    "state": "Karnataka",
    "district": "Yadgir",
    "block": "Yadgiri",
    "officename": "Yadgiri H.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "YADGIRI DIVISION"
  },
  "585202": {
    "state": "Karnataka",
    "district": "Yadgir",
    "block": "Yadgiri",
    "officename": "Yadgiri Station S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "YADGIRI DIVISION"
  },
  "585210": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Sedam",
    "officename": "Kurkunta C.F S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "YADGIRI DIVISION"
  },
  "585211": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Chittapur",
    "officename": "Chittapur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "YADGIRI DIVISION"
  },
  "585212": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Afjalpur",
    "officename": "Ghanagapur T S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Kalaburagi Division"
  },
  "585213": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Afjalpur",
    "officename": "Station Ghanagapur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Kalaburagi Division"
  },
  "585214": {
    "state": "Karnataka",
    "district": "Yadgir",
    "block": "Yadgiri",
    "officename": "Gurmitkal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "YADGIRI DIVISION"
  },
  "585215": {
    "state": "Karnataka",
    "district": "Yadgir",
    "block": "Shorapur",
    "officename": "Hunasgi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "YADGIRI DIVISION"
  },
  "585216": {
    "state": "Karnataka",
    "district": "Yadgir",
    "block": "Shorapur",
    "officename": "Kembhavi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "YADGIRI DIVISION"
  },
  "585217": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Afzalpur",
    "officename": "Mashal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Kalaburagi Division"
  },
  "585218": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Chittapur",
    "officename": "Nalwar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Kalaburagi Division"
  },
  "585219": {
    "state": "Karnataka",
    "district": "Yadgir",
    "block": "Shorapur",
    "officename": "Narayanpur S.O (Yadgir)",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "YADGIRI DIVISION"
  },
  "585220": {
    "state": "Karnataka",
    "district": "Yadgir",
    "block": "Shorapur",
    "officename": "Rangampeth S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "YADGIRI DIVISION"
  },
  "585221": {
    "state": "Karnataka",
    "district": "Yadgir",
    "block": "Yadgiri",
    "officename": "Saidapur S.O (Yadgir)",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "YADGIRI DIVISION"
  },
  "585222": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Sedam",
    "officename": "Sedam S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "YADGIRI DIVISION"
  },
  "585223": {
    "state": "Karnataka",
    "district": "Yadgir",
    "block": "Shahpur",
    "officename": "Shahapur S.O (Yadgir)",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "YADGIRI DIVISION"
  },
  "585224": {
    "state": "Karnataka",
    "district": "Yadgir",
    "block": "Shorapur",
    "officename": "Shorapur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "YADGIRI DIVISION"
  },
  "585225": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Chittapur",
    "officename": "Wadi S.O (Kalaburagi)",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Kalaburagi Division"
  },
  "585226": {
    "state": "Karnataka",
    "district": "Bidar",
    "block": "Bidar",
    "officename": "Kamthana S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bidar Division"
  },
  "585227": {
    "state": "Karnataka",
    "district": "Bidar",
    "block": "Humnabad",
    "officename": "Mannakhelli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bidar Division"
  },
  "585228": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Chitapur",
    "officename": "Shahabad S.O (Kalaburagi)",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Kalaburagi Division"
  },
  "585229": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Chitapur",
    "officename": "Shahabad ACC S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Kalaburagi Division"
  },
  "585236": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Afjalpur",
    "officename": "Nimbal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Kalaburagi Division"
  },
  "585237": {
    "state": "Karnataka",
    "district": "Yadgir",
    "block": "Shorapur",
    "officename": "Kodekal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "YADGIRI DIVISION"
  },
  "585265": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Afzalpur",
    "officename": "Gobbur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Kalaburagi Division"
  },
  "585287": {
    "state": "Karnataka",
    "district": "Yadgir",
    "block": "Shahpur",
    "officename": "Bheemarayanagudi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "YADGIRI DIVISION"
  },
  "585290": {
    "state": "Karnataka",
    "district": "Yadgir",
    "block": "Shorapur",
    "officename": "Kumbarpeth S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "YADGIRI DIVISION"
  },
  "585291": {
    "state": "Karnataka",
    "district": "Yadgir",
    "block": "Shorapur",
    "officename": "Rajankollur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "YADGIRI DIVISION"
  },
  "585292": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Sedam",
    "officename": "Malkhed Road S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "YADGIRI DIVISION"
  },
  "585301": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Afjalpur",
    "officename": "Afjalpur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Kalaburagi Division"
  },
  "585302": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Aland",
    "officename": "Alund S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Kalaburagi Division"
  },
  "585303": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Jewargi",
    "officename": "Andola S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Kalaburagi Division"
  },
  "585304": {
    "state": "Karnataka",
    "district": "Yadgir",
    "block": "Shorapur",
    "officename": "Bijaspur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "YADGIRI DIVISION"
  },
  "585305": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Chincholi",
    "officename": "Chandapur S.O (Kalaburagi)",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Kalaburagi Division"
  },
  "585306": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Chincholi",
    "officename": "Chimmanchod S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Kalaburagi Division"
  },
  "585307": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Chincholi",
    "officename": "Chincholi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Kalaburagi Division"
  },
  "585308": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Gulbarga",
    "officename": "Farhatabad S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Kalaburagi Division"
  },
  "585309": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Jewargi",
    "officename": "Gogi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "YADGIRI DIVISION"
  },
  "585310": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Jewargi",
    "officename": "Jewargi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Kalaburagi Division"
  },
  "585311": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Gulbarga",
    "officename": "Kadaganchi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Kalaburagi Division"
  },
  "585312": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Gulbarga",
    "officename": "Kalgi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Kalaburagi Division"
  },
  "585313": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Chincholi",
    "officename": "Kamalapur S.O (Kalaburagi)",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Kalaburagi Division"
  },
  "585314": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Aland",
    "officename": "Khajuri S.O (Kalaburagi)",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Kalaburagi Division"
  },
  "585315": {
    "state": "Karnataka",
    "district": "Yadgir",
    "block": "Yadgiri",
    "officename": "Madhwar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "YADGIRI DIVISION"
  },
  "585316": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Aland",
    "officename": "Mahagaon (Kalaburagi) S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Kalaburagi Division"
  },
  "585317": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Chittapur",
    "officename": "Malkhed S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "YADGIRI DIVISION"
  },
  "585318": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Sedam",
    "officename": "Mudhol (Kalaburagi) S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "YADGIRI DIVISION"
  },
  "585319": {
    "state": "Karnataka",
    "district": "Yadgir",
    "block": "Shahapur",
    "officename": "Naikal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "YADGIRI DIVISION"
  },
  "585320": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Sedam",
    "officename": "Nidgunda S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Kalaburagi Division"
  },
  "585321": {
    "state": "Karnataka",
    "district": "Yadgir",
    "block": "Yadgir",
    "officename": "Ramasamudra S.O (Yadgir)",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "YADGIRI DIVISION"
  },
  "585322": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Chittapur",
    "officename": "Ratkal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Kalaburagi Division"
  },
  "585323": {
    "state": "Karnataka",
    "district": "Yadgir",
    "block": "Shorapur",
    "officename": "Sagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "YADGIRI DIVISION"
  },
  "585324": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Chincholi",
    "officename": "Sulahpeth S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Kalaburagi Division"
  },
  "585325": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Jewargi",
    "officename": "Yedrami S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Kalaburagi Division"
  },
  "585326": {
    "state": "Karnataka",
    "district": "Bidar",
    "block": "Aurad (b)",
    "officename": "Aurad (B) S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bidar Division"
  },
  "585327": {
    "state": "Karnataka",
    "district": "Bidar",
    "block": "Basavakalyan",
    "officename": "Basavakalyan S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bidar Division"
  },
  "585328": {
    "state": "Karnataka",
    "district": "Bidar",
    "block": "Bhalki",
    "officename": "Bhalki S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bidar Division"
  },
  "585329": {
    "state": "Karnataka",
    "district": "Bidar",
    "block": "Humnabad",
    "officename": "Hoodgi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bidar Division"
  },
  "585330": {
    "state": "Karnataka",
    "district": "Bidar",
    "block": "Humnabad",
    "officename": "Humnabad S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bidar Division"
  },
  "585331": {
    "state": "Karnataka",
    "district": "Bidar",
    "block": "Basavakalyan",
    "officename": "Rajeshwar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bidar Division"
  },
  "585353": {
    "state": "Karnataka",
    "district": "Bidar",
    "block": "Humnabad",
    "officename": "Maniknagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bidar Division"
  },
  "585355": {
    "state": "Karnataka",
    "district": "Yadgir",
    "block": "Shahapur",
    "officename": "Wadgera S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "YADGIRI DIVISION"
  },
  "585367": {
    "state": "Karnataka",
    "district": "Gulbarga",
    "block": "Alund",
    "officename": "Central University of KarnatakaKad",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Kalaburagi Division"
  },
  "585401": {
    "state": "Karnataka",
    "district": "Bidar",
    "block": "Bidar",
    "officename": "Bidar H.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bidar Division"
  },
  "585402": {
    "state": "Karnataka",
    "district": "Bidar",
    "block": "Bidar",
    "officename": "Bidar G.N.Jhira S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bidar Division"
  },
  "585403": {
    "state": "Karnataka",
    "district": "Bidar",
    "block": "Bidar",
    "officename": "Bidar Gandhi Gunj S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bidar Division"
  },
  "585411": {
    "state": "Karnataka",
    "district": "Bidar",
    "block": "Bhalki",
    "officename": "Bhatambra S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bidar Division"
  },
  "585412": {
    "state": "Karnataka",
    "district": "Bidar",
    "block": "Humnabad",
    "officename": "Chitguppa S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bidar Division"
  },
  "585413": {
    "state": "Karnataka",
    "district": "Bidar",
    "block": "Bhalki",
    "officename": "Halbarga S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bidar Division"
  },
  "585414": {
    "state": "Karnataka",
    "district": "Bidar",
    "block": "Humnabad",
    "officename": "Hallikhed (B) S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bidar Division"
  },
  "585416": {
    "state": "Karnataka",
    "district": "Bidar",
    "block": "Bhalki",
    "officename": "Hulsoor S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bidar Division"
  },
  "585417": {
    "state": "Karnataka",
    "district": "Bidar",
    "block": "Aurad (b)",
    "officename": "Kamalnagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bidar Division"
  },
  "585418": {
    "state": "Karnataka",
    "district": "Bidar",
    "block": "Humnabad",
    "officename": "Dubalgundi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bidar Division"
  },
  "585419": {
    "state": "Karnataka",
    "district": "Bidar",
    "block": "Basavakalyan",
    "officename": "Matala S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bidar Division"
  },
  "585421": {
    "state": "Karnataka",
    "district": "Bidar",
    "block": "Aurad (b)",
    "officename": "Santhpur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bidar Division"
  },
  "585436": {
    "state": "Karnataka",
    "district": "Bidar",
    "block": "Aurad (b)",
    "officename": "Thanna Kushnoor S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bidar Division"
  },
  "585437": {
    "state": "Karnataka",
    "district": "Bidar",
    "block": "Basavakalyan",
    "officename": "Mudbi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bidar Division"
  },
  "585443": {
    "state": "Karnataka",
    "district": "Bidar",
    "block": "Aurad (b)",
    "officename": "Mudhol (B) S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bidar Division"
  },
  "585444": {
    "state": "Karnataka",
    "district": "Bidar",
    "block": "Bhalki",
    "officename": "Nittur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bidar Division"
  },
  "586101": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "Bijapur",
    "officename": "Vijayapura H.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586103": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "Bijapur",
    "officename": "B.L.D.E.A Campus SO",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586104": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "Bijapur",
    "officename": "Gol Gumbaz S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586108": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "Bijapur",
    "officename": "Vijayapura Amc S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586109": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "Bijapur",
    "officename": "Vijayapura Jalanagar SO",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586111": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "Indi",
    "officename": "Agarkhed S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586112": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "Indi",
    "officename": "Atharga S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586113": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "Bijapur",
    "officename": "Bableshwar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586114": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "B.bagewadi",
    "officename": "Bijjargi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586115": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "Sindgi",
    "officename": "Devar Hippargi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586116": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "Muddebihal",
    "officename": "Dhavalgi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586117": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "Indi",
    "officename": "Horti S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586118": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "Sindgi",
    "officename": "Kalkeri S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586119": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "Bijapur",
    "officename": "Kannur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586120": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "Sindgi",
    "officename": "Korwar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586121": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "B.bagewadi",
    "officename": "Kudgi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586122": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "Indi",
    "officename": "Mangoli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586123": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "Sindgi",
    "officename": "Moratgi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586124": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "Muddebihal",
    "officename": "Nalatwad S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586125": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "Bijapur",
    "officename": "Sarwad S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586127": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "Bijapur",
    "officename": "Shivangi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586128": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "Sindgi",
    "officename": "Sindgi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586129": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "Muddebihal",
    "officename": "Tangadgi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586130": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "Bijapur",
    "officename": "Tikota S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586201": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "B.bagewadi",
    "officename": "Almatti  Damsite S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586202": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "Sindgi",
    "officename": "Almel S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586203": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "B.bagewadi",
    "officename": "Basavan Bagewadi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586204": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "Indi",
    "officename": "Bardol S.O (Vijayapura(KAR))",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586205": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "Indi",
    "officename": "Chadchan S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586206": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "Sindgi",
    "officename": "Devangaon S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586207": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "Indi",
    "officename": "Halsangi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586208": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "Muddebihal",
    "officename": "Huvin Hippargi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586209": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "Indi",
    "officename": "Indi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586210": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "B.bagewadi",
    "officename": "Kolhar S.O (Vijayapura(KAR))",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586211": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "Indi",
    "officename": "Lachyan S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586212": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "Muddebihal",
    "officename": "Muddebiahl S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586213": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "B.bagewadi",
    "officename": "Nidgundi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586214": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "B.bagewadi",
    "officename": "Talikoti S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586215": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "Indi",
    "officename": "Tamba S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586216": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "Muddebihal",
    "officename": "Telgi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586217": {
    "state": "Karnataka",
    "district": "Bijapur(KAR)",
    "block": "Indi",
    "officename": "Salotgi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "587101": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Bagalkot",
    "officename": "Bagalkot H.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "587102": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Bagalkot",
    "officename": "Gaddankeri Cross S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "587103": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Bagalkot",
    "officename": "Bagalkot Navanagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "587104": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Bagalkot",
    "officename": "Bagalkot UHS Campus S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "587111": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Bagalkot",
    "officename": "Bagalkot Alokudyog S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "587112": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Hungund",
    "officename": "Amingad S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "587113": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Mudhol",
    "officename": "Belagali S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "587114": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Badami",
    "officename": "Belur S.O (Bagalkot)",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "587115": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Hungund Taluk",
    "officename": "Bevur S.O (Bagalkot)",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "587116": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Bilgi",
    "officename": "Bilgi S.O (Bagalkot)",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "587117": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Bilgi",
    "officename": "Galagali S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "587118": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Hungund",
    "officename": "Hungund S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "587119": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Jamkhandi",
    "officename": "Hunnur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "587120": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Hungund",
    "officename": "Kamatgi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "587121": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Bilgi",
    "officename": "Konnur S.O (Bagalkot)",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "587122": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Mudhol",
    "officename": "Lokapur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "587124": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Hungund",
    "officename": "Sulebhavi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "587125": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Hungund",
    "officename": "Ilkal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "587154": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Hungund",
    "officename": "Ilkal  Alampurpet S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "587155": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Badami",
    "officename": "Kulgeri Cross S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "587201": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Badami",
    "officename": "Badami S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "587202": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Hungund",
    "officename": "Gudur S.O (Bagalkot)",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "587203": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Badami",
    "officename": "Guledgudd S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "587204": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Mudhol",
    "officename": "Kaladgi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "587205": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Badami",
    "officename": "Katageri S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "587206": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Badami",
    "officename": "Kerur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "587207": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Bagalkot",
    "officename": "Rampur S.O (Bagalkot)",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "587301": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Jamkhandi",
    "officename": "Jamkhandi H.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "587311": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Jamkhandi",
    "officename": "Banahatti S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "587312": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Jamkhandi",
    "officename": "Mahalingpur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "587313": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Mudhol",
    "officename": "Mudhol (Bagalkot) S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "587314": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Jamkhandi",
    "officename": "Rabkavi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "587315": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Jamkhandi",
    "officename": "Terdal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "587316": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Mudhol",
    "officename": "Sameerwadi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "587330": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Jamkhandi",
    "officename": "Savalagi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "590001": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Belgaum",
    "officename": "Belagavi H.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "590003": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Belgaum",
    "officename": "Belagavi Shahapur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "590005": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Belgaum",
    "officename": "Belagavi M. Vadgaon S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "590006": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Belgaum",
    "officename": "Tilakwadi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "590008": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Belgaum",
    "officename": "Udyambag S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "590009": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Belgaum",
    "officename": "Belagavi Records MLI S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "590010": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Belgaum",
    "officename": "Belagavi Nehru Nagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "590011": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Belgaum",
    "officename": "Hindawadi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "590014": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Belgaum",
    "officename": "Peeranwadi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "590015": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Belgaum",
    "officename": "Kanabargi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "590016": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Belgaum",
    "officename": "Belagavi Shivaji Nagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "590017": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Belgaum",
    "officename": "Belagavi MalMaruti Extension S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "590018": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Belgaum",
    "officename": "VTU Campus Belagavi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "590019": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Belgaum",
    "officename": "Belagavi Doordarshan Nagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "590020": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Belgaum",
    "officename": "Suvarna Soudha Belagavi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "591101": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Gokak",
    "officename": "Ankalgi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gokak Division"
  },
  "591102": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Bailhongal",
    "officename": "Bailhongal H.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "591103": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Belgaum",
    "officename": "Balekundri S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "591104": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Bailhongal",
    "officename": "Belvadi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "591106": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Khanapur",
    "officename": "Bidi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "591107": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Hukeri",
    "officename": "Hidkal Dam S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gokak Division"
  },
  "591108": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Belgaum",
    "officename": "Hindalga S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "591109": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Belgaum",
    "officename": "Hirebagewadi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "591110": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Saundatti",
    "officename": "Hirekumbi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "591111": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Saundatti",
    "officename": "Hosur S.O (Belagavi)",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "591112": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Bailhongal",
    "officename": "Itagi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "591113": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Belgaum",
    "officename": "Kakati S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "591114": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Ramdurg",
    "officename": "Katkol S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "591115": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Bailhongal",
    "officename": "Kittur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "591117": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Saundatti",
    "officename": "Manoli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "591118": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Bailhongal",
    "officename": "M.K.Hubballi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "591119": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Saundatti",
    "officename": "Murgod S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "591120": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Londa",
    "officename": "Nandgad S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "591121": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Bailhongal",
    "officename": "Nesargi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "591122": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Hukeri",
    "officename": "Pachhapur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gokak Division"
  },
  "591123": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Ramdurg",
    "officename": "Ramdurg H.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "591124": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Belgaum",
    "officename": "Sambra S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "591125": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Bailhongal",
    "officename": "Sampgaon S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "591126": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Parasgad",
    "officename": "Saundatti S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "591127": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Ramdurg",
    "officename": "Sureban S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "591128": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Belgaum",
    "officename": "Uchgaon S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "591129": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Saundatti",
    "officename": "Yargatti S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "591130": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Ramdurg",
    "officename": "Salahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "591131": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Khanapur",
    "officename": "Pariswad S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "591136": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Gokak",
    "officename": "Yadwad S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gokak Division"
  },
  "591143": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Belgaum",
    "officename": "Kadoli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "591147": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Bailhongal",
    "officename": "Deshnur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "591153": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Bailhongal",
    "officename": "M.K.Hubballi S.F. S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "591156": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Belgaum",
    "officename": "Bhutaramanahatti S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "591173": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Ramdurg",
    "officename": "Yallammahill S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "591201": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Chikodi",
    "officename": "Chikodi H.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Chikodi Division"
  },
  "591211": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Chikodi",
    "officename": "Akol S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Chikodi Division"
  },
  "591212": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Athni",
    "officename": "Anantpur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Chikodi Division"
  },
  "591213": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Chikodi",
    "officename": "Ankali S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Chikodi Division"
  },
  "591214": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Chikodi",
    "officename": "Bedkihal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Chikodi Division"
  },
  "591215": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Chikodi",
    "officename": "Benadi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Chikodi Division"
  },
  "591216": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Chikodi",
    "officename": "Borgaon S.O (Belagavi)",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Chikodi Division"
  },
  "591217": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Raibag",
    "officename": "Chinchali S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Chikodi Division"
  },
  "591218": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Gokak",
    "officename": "Lolsur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gokak Division"
  },
  "591219": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Chikodi",
    "officename": "Galataga S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Chikodi Division"
  },
  "591220": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Raibag",
    "officename": "Harugeri S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Chikodi Division"
  },
  "591221": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Hukeri",
    "officename": "Hebbal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gokak Division"
  },
  "591222": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Chikodi",
    "officename": "Kabbur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Chikodi Division"
  },
  "591223": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Athani",
    "officename": "Kagvad S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Chikodi Division"
  },
  "591224": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Gokak",
    "officename": "Kalloli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gokak Division"
  },
  "591225": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Hukeri",
    "officename": "Kanagala S.O (Belagavi)",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gokak Division"
  },
  "591226": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Chikodi",
    "officename": "Karoshi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Chikodi Division"
  },
  "591227": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Gokak",
    "officename": "Kaujalgi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gokak Division"
  },
  "591228": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Chikodi",
    "officename": "Khadaklat S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Chikodi Division"
  },
  "591229": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Chikodi",
    "officename": "Kognoli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Chikodi Division"
  },
  "591230": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Athni",
    "officename": "Kokatnur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Chikodi Division"
  },
  "591231": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Gokak",
    "officename": "Konnur S.O (Belagavi)",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gokak Division"
  },
  "591232": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Athni",
    "officename": "Madbhavi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Chikodi Division"
  },
  "591233": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Gokak",
    "officename": "Mamadapur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gokak Division"
  },
  "591234": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Athni",
    "officename": "Mangsuli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Chikodi Division"
  },
  "591235": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Raibag",
    "officename": "Mugalkhod S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Chikodi Division"
  },
  "591236": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Hukeri",
    "officename": "Nidasoshi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gokak Division"
  },
  "591237": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Chikodi",
    "officename": "Nipani S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Chikodi Division"
  },
  "591238": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Chikodi",
    "officename": "Pattankudi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Chikodi Division"
  },
  "591239": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Chikodi",
    "officename": "Sadalga S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Chikodi Division"
  },
  "591240": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Athni",
    "officename": "Satti S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Chikodi Division"
  },
  "591241": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Chikodi",
    "officename": "Saundalga S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Chikodi Division"
  },
  "591242": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Chikodi",
    "officename": "Shirguppi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Chikodi Division"
  },
  "591243": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Hukeri",
    "officename": "Thana Hattargi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gokak Division"
  },
  "591244": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Chikodi",
    "officename": "Yaksamba S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Chikodi Division"
  },
  "591246": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Hukeri",
    "officename": "Yamakanmardi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gokak Division"
  },
  "591247": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Chikodi",
    "officename": "Chikodi Sugar Factory S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Chikodi Division"
  },
  "591248": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Athni",
    "officename": "Aigali S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Chikodi Division"
  },
  "591254": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Hukeri",
    "officename": "Daddi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gokak Division"
  },
  "591263": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Chikodi",
    "officename": "Bhoj S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Chikodi Division"
  },
  "591265": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Athni",
    "officename": "Telsang S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Chikodi Division"
  },
  "591287": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Chikodi",
    "officename": "Kothali S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Chikodi Division"
  },
  "591301": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Khanapur",
    "officename": "Londa S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "591302": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Khanapur",
    "officename": "Khanapur SO Belagavi",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "591303": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Athani",
    "officename": "Ainapur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Chikodi Division"
  },
  "591304": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Athani",
    "officename": "Athani H.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Chikodi Division"
  },
  "591305": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Hukeri",
    "officename": "Bellad Bagewadi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gokak Division"
  },
  "591306": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Gokak",
    "officename": "Ghataprabha RS S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gokak Division"
  },
  "591307": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Gokak",
    "officename": "Gokak H.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gokak Division"
  },
  "591308": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Gokak",
    "officename": "Gokak Falls S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gokak Division"
  },
  "591309": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Hukeri",
    "officename": "Hukeri S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gokak Division"
  },
  "591310": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Gokak",
    "officename": "Kulgod S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gokak Division"
  },
  "591311": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Raibag",
    "officename": "Kudchi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Chikodi Division"
  },
  "591312": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Gokak",
    "officename": "Mudalgi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gokak Division"
  },
  "591313": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Hukeri",
    "officename": "Sankeshwar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gokak Division"
  },
  "591314": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Hukeri",
    "officename": "Sankeshwar Sugar Factory S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gokak Division"
  },
  "591315": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Athani",
    "officename": "Shedbal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Chikodi Division"
  },
  "591316": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Athni",
    "officename": "Ugarkhurd S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Chikodi Division"
  },
  "591317": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Raibag",
    "officename": "Raibag S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Chikodi Division"
  },
  "591340": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Hukeri",
    "officename": "Nerli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gokak Division"
  },
  "591344": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Gokak",
    "officename": "Khangaon S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Gokak Division"
  },
  "591345": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Khanapur",
    "officename": "Jamboti S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "591346": {
    "state": "Karnataka",
    "district": "Belgaum",
    "block": "Belgaum",
    "officename": "Hudli",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Belagavi Division"
  },
  "600001": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Chennai",
    "officename": "Chennai G.P.O.",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai GPO Division"
  },
  "600002": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Chennai",
    "officename": "Anna Road H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Anna Road H.O Division"
  },
  "600003": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Tondiarpet Fort St George",
    "officename": "Park Town H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City North Division"
  },
  "600004": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Chennai",
    "officename": "Mylapore H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City Central Division"
  },
  "600005": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Chennai",
    "officename": "Tiruvallikeni S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City Central Division"
  },
  "600006": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Chennai",
    "officename": "Greams Road S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City Central Division"
  },
  "600007": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Perambur Purasawalkam",
    "officename": "Vepery S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City North Division"
  },
  "600008": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Egmore Nungambakka",
    "officename": "EGMORE MDO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City North Division"
  },
  "600009": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Tondiarpet Fort St George",
    "officename": "Fort St George S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City North Division"
  },
  "600010": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Perambur Purasawalkam",
    "officename": "Kilpauk S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City North Division"
  },
  "600011": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Perambur Purasawalkam",
    "officename": "Perambur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City North Division"
  },
  "600012": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Perambur Purasawalkam",
    "officename": "Perambur Barracks S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City North Division"
  },
  "600013": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Egmore Nungambakkam",
    "officename": "Rayapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City North Division"
  },
  "600014": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Chennai",
    "officename": "Royapettah S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City Central Division"
  },
  "600015": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Chennai City Corporation",
    "officename": "Saidapet S.O (Chennai)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City South Division"
  },
  "600016": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Saidapet",
    "officename": "St Thomas Mount HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City South Division"
  },
  "600017": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Chennai",
    "officename": "Thygarayanagar H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City Central Division"
  },
  "600018": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Chennai",
    "officename": "Teynampet S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City Central Division"
  },
  "600019": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Ambattur",
    "officename": "Tiruvottiyur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600020": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Chennai City Corporation",
    "officename": "Adyar S.O (Chennai)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City South Division"
  },
  "600021": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Tondiarpet Fort St George",
    "officename": "Washermanpet S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City North Division"
  },
  "600022": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Chennai City Corporation",
    "officename": "Rajbhavan S.O (Chennai)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City South Division"
  },
  "600023": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Perambur Purasawalkam",
    "officename": "Aynavaram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City North Division"
  },
  "600024": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Chennai City Corporation",
    "officename": "Kodambakkam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City South Division"
  },
  "600025": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Chennai City Corporation",
    "officename": "Engineering College S.O (Chennai)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City South Division"
  },
  "600026": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Chennai City Corporation",
    "officename": "Vadapalani S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City South Division"
  },
  "600028": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Chennai City Corporation",
    "officename": "Raja Annamalaipuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City South Division"
  },
  "600030": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Egmore Nungambakkam",
    "officename": "Shenoy Nagar S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City North Division"
  },
  "600031": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Egmore Nungambakkam",
    "officename": "Chetput S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City North Division"
  },
  "600032": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Chennai City Corporation",
    "officename": "Guindy Industrial Estate S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City South Division"
  },
  "600033": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Chennai City Corporation",
    "officename": "West Mambalam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City South Division"
  },
  "600034": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Chennai",
    "officename": "Nungambakkam MDO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City Central Division"
  },
  "600035": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Chennai City Corporation",
    "officename": "Nandanam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City South Division"
  },
  "600036": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Chennai City Corporation",
    "officename": "Indian Institute Of Technology S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City South Division"
  },
  "600037": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Ambattur",
    "officename": "Mogappair SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600038": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Perambur Purasawalkam",
    "officename": "Icf Colony S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City North Division"
  },
  "600039": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Tondiarpet Fort St George",
    "officename": "Vyasarpadi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City North Division"
  },
  "600040": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Egmore Nungambakkam",
    "officename": "Anna Nagar S.O (Chennai)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City North Division"
  },
  "600041": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Chennai City Corporation",
    "officename": "Tiruvanmiyur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City South Division"
  },
  "600042": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Chennai City Corporation",
    "officename": "Velacheri S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City South Division"
  },
  "600043": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Sriperumbudur",
    "officename": "Pallavaram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600044": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Sriperumbudur",
    "officename": "Chromepet SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600045": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Tambaram",
    "officename": "Tambaram HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600046": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Tambaram",
    "officename": "Tambaram IAF SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600047": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Tambaram",
    "officename": "Tambaram Sanatorium SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600048": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Chinglepet",
    "officename": "Vandalur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600049": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Ambattur",
    "officename": "Villivakkam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600050": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Ambattur",
    "officename": "Padi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600051": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Ponneri",
    "officename": "Madhavaram Milk Colony SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600052": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Ponneri",
    "officename": "Redhills SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600053": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Ambattur",
    "officename": "Ambattur HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600054": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Ambattur",
    "officename": "Avadi Camp HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600055": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Ambattur",
    "officename": "Avadi IAF SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600056": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Sriperumbudur",
    "officename": "Poonamallee SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600057": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Ambattur",
    "officename": "Ennore Thermal Station SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600058": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Ambattur",
    "officename": "Ambattur Indl Estate SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600059": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Tambaram",
    "officename": "Tambaram East SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600060": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Ponneri",
    "officename": "Madhavaram SO Tiruvallur",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600061": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Saidapet",
    "officename": "Nanganallur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City South Division"
  },
  "600062": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Poonamallee",
    "officename": "Tirumullaivoyal SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600063": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Tambaram",
    "officename": "Srinivasanagar SO Kanchipuram",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600064": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Sriperumbudur",
    "officename": "Chitlapakkam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600066": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Ambattur",
    "officename": "Pozhal SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600067": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Ponneri",
    "officename": "Sholavaram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600068": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Ambattur",
    "officename": "Manali SO Tiruvallur",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600069": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Sriperumbudur",
    "officename": "Kunnathur SO Kanchipuram",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600070": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Sriperumbudur",
    "officename": "Anakaputhur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600071": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Poonamallee",
    "officename": "Kamarajnagar SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600072": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Poonamallee",
    "officename": "Pattabiram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600073": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Sriperumbudur",
    "officename": "Selaiyur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600074": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Tambaram",
    "officename": "Polichalur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600075": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Sriperumbudur",
    "officename": "Pammal SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600076": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Ambattur",
    "officename": "Korattur RS SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600077": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Poonamallee",
    "officename": "Thiruverkadu SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600078": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Chennai City Corporation",
    "officename": "Kalaignar Karunanidhi Nagar S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City South Division"
  },
  "600081": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Tondiarpet Fort St George",
    "officename": "Tondiarpet S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City North Division"
  },
  "600082": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Perambur Purasawalkam",
    "officename": "Periyar Nagar S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City North Division"
  },
  "600083": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Chennai City Corporation",
    "officename": "Ashoknagar S.O (Chennai)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City South Division"
  },
  "600084": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Perambur Purasawalkam",
    "officename": "Flowers Road S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City North Division"
  },
  "600085": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Chennai City Corporation",
    "officename": "Kotturpuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City South Division"
  },
  "600086": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Chennai",
    "officename": "Gopalapuram S.O (Chennai)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City Central Division"
  },
  "600087": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Pallipat",
    "officename": "Alwarthirunagar S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City South Division"
  },
  "600088": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Sriperumbudur",
    "officename": "Adambakkam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City South Division"
  },
  "600089": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Saidapet",
    "officename": "Nandambakkam Kudiyiruppu S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City South Division"
  },
  "600090": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Chennai City Corporation",
    "officename": "Besantnagar S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City South Division"
  },
  "600091": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Saidapet",
    "officename": "Madipakkam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City South Division"
  },
  "600092": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Chennai City Corporation",
    "officename": "Virugambakkam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City South Division"
  },
  "600093": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Chennai City Corporation",
    "officename": "Saligramam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City South Division"
  },
  "600094": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Chennai",
    "officename": "Choolaimedu S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City Central Division"
  },
  "600095": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Poonamallee",
    "officename": "Maduravoyal SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600096": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Saidapet",
    "officename": "Perungudi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City South Division"
  },
  "600097": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Sriperumbudur",
    "officename": "Oggiamthoraipakkam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City South Division"
  },
  "600099": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Ambattur",
    "officename": "Kolathur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600100": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Tambaram",
    "officename": "Medavakkam  SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600101": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Ambattur",
    "officename": "Anna Nagar Western Extn S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City North Division"
  },
  "600102": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Perambur Purasawalkam",
    "officename": "Anna Nagar East S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City North Division"
  },
  "600103": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Ambattur",
    "officename": "Manali New Town SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600104": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Tondiarpet Fort St George",
    "officename": "High Court Building S.O (Chennai)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City North Division"
  },
  "600106": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Maduravoyal",
    "officename": "Arumbakkam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City North Division"
  },
  "600107": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Maduravoyal",
    "officename": "Koyambedu S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City North Division"
  },
  "600110": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Ambattur",
    "officename": "Ponniammanmedu SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600113": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Mambalam",
    "officename": "TTTI Taramani S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City South Division"
  },
  "600115": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Kancheepuram",
    "officename": "Injambakkam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City South Division"
  },
  "600116": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Sriperumbudur",
    "officename": "Porur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600117": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Sriperumbudur",
    "officename": "Old Pallavaram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600118": {
    "state": "Tamil Nadu",
    "district": "Chennai",
    "block": "Chennai",
    "officename": "Kodungaiyur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600119": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Saidapet",
    "officename": "Sholinganallur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chennai City South Division"
  },
  "600120": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Ambattur",
    "officename": "North Chennai Thermal PP SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600122": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Sriperumbudur",
    "officename": "Mangadu SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600123": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Poonamallee",
    "officename": "Nazarethpettai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600124": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Poonamallee",
    "officename": "Thirumushi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600125": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Sriperumbudur",
    "officename": "Mugalivakkam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600126": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Tambaram",
    "officename": "Madambakkam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600127": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Chinglepet",
    "officename": "Melakkottaiyur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600128": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Poonamallee",
    "officename": "Kovur SO Tamilnadu Circle",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600129": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Sholinganallur",
    "officename": "Kovilambakkam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600130": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Chinglepet",
    "officename": "Thazambur",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "601101": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Ponneri",
    "officename": "Arni CPT SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "601102": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Kancheepuram",
    "officename": "Periapalayam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "601103": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Tiruvallur",
    "officename": "Vengal S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "601201": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Gummidipundi",
    "officename": "Gummidipundi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "601202": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Gummidipundi",
    "officename": "Madarpakkam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "601203": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Ponneri",
    "officename": "Minjur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "601204": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Ponneri",
    "officename": "Ponneri SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "601205": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Ponneri",
    "officename": "Pulicat SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "601206": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Ponneri",
    "officename": "Kavarapettai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "601301": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Sriperumbudur",
    "officename": "Padappai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "602001": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Thiruvallur",
    "officename": "Tiruvallur H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "602002": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Thiruvallur",
    "officename": "Manavalanagar S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "602003": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Tiruvallur",
    "officename": "Kakalur Ind Estate S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "602021": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Thiruvallur",
    "officename": "Ikkadu S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "602023": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Tiruvallur",
    "officename": "Poondi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "602024": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Pallipat",
    "officename": "Tiruninravur Rs S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "602025": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Tiruvallur",
    "officename": "Tirur Cpt S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "602026": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Uttukottai",
    "officename": "Uttukottai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "602105": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Sriperumbudur",
    "officename": "Sriperumbudur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "602106": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Sriperumbudur",
    "officename": "Sunguvarchatram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "602108": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Sriperumbudur",
    "officename": "Pannur S.O (Kanchipuram)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "602117": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Sriperumbudur",
    "officename": "Irungattukottai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "603001": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Chengalpattu",
    "officename": "Chengalpattu HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603002": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Chengalpattu",
    "officename": "Nathamchengalpattu SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603003": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Chengalpattu",
    "officename": "Vallam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603101": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Chengalpattu",
    "officename": "Athurchengalpattu SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603102": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Tiruklalikundram",
    "officename": "Kalpakkam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603103": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Chingleput",
    "officename": "Kelambakkam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "603104": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Tirukalikundram",
    "officename": "Mamallapuram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603105": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Tirukalikundram",
    "officename": "Manambathi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603106": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Uthiramerur",
    "officename": "Orakattupettai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603107": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Uthiramerur",
    "officename": "Salavakkam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603108": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Chengalpattu Taluk",
    "officename": "Sembakkam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603109": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Tirukalikundram",
    "officename": "Tirukalikundram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603110": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Chengalpattu",
    "officename": "Tiruporur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603111": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Chengalpattu",
    "officename": "Venpakkam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603112": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Chinglepet",
    "officename": "Kovalam SO Kanchipuram",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "603127": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Tirukalikundram",
    "officename": "Anupuram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603201": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Madurantakam",
    "officename": "Elapakkam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603202": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Chengalpattu",
    "officename": "Guduvancheri SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603203": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Chengalpattu",
    "officename": "Kattankolathur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603204": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Chengalpattu",
    "officename": "Singaperumalkoil SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603209": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Chengalpattu",
    "officename": "Maraimalai Nagar SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603210": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Chengalpattu",
    "officename": "Urapakkam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603211": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Sriperumbudur",
    "officename": "Annai Anjugam Nagar SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603301": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Sriperumbudur",
    "officename": "Acharapakkam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603302": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Cheyur",
    "officename": "Cheyur SO Kanchipuram",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603303": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Madurantakam",
    "officename": "Karunguli SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603304": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Cheyur",
    "officename": "Kudapakkam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603305": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Madurantakam",
    "officename": "Kuvathur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603306": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Madurantakam",
    "officename": "Madurantakam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603307": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Chengalpattu",
    "officename": "Orathy SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603308": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Madurantakam",
    "officename": "Padalam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603309": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Cheyur",
    "officename": "Polambakkam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603310": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Sriperumbudur",
    "officename": "Thozhupedu SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603311": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Cheyur",
    "officename": "Zamin Endathur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603312": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Sriperumbudur",
    "officename": "Pavunjur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603313": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Cheyur",
    "officename": "Chithamur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603314": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Sriperumbudur",
    "officename": "Malaivaiyavur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603319": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Cheyyur",
    "officename": "Melmaruvathur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603401": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Cheyyur",
    "officename": "Chunampet SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603402": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Kanchipuram",
    "officename": "Kaliyampoondi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "603403": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Uttiramerur",
    "officename": "Manampathi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "603405": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Chengalpattu",
    "officename": "Ponvilainthakalathur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "603406": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Uttiramerur",
    "officename": "Uttiramerur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "604001": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tindivanam",
    "officename": "Tindivanam HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "604101": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tindivanam",
    "officename": "Akshipakkam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "604102": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tindivanam",
    "officename": "Kiliyanur SO Villupuram",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "604151": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tindivanam",
    "officename": "Alampoondi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "604152": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Gingee",
    "officename": "Nallanpillaipetral SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "604153": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tindivanam",
    "officename": "Sathyamangalam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "604154": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tindivanam",
    "officename": "Velur SA SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "604201": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Gingee",
    "officename": "Avalurpet SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "604202": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tindivanam",
    "officename": "Gingee MDG",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "604203": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tindivanam",
    "officename": "Melolakkur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "604204": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tindivanam",
    "officename": "Melmalayanur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "604205": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tindivanam",
    "officename": "Minambur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "604206": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tindivanam",
    "officename": "Vallam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "604207": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tindivanam",
    "officename": "Vellimedupettai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "604208": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tindivanam",
    "officename": "Valathi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "604210": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tindivanam",
    "officename": "Illodu SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "604301": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tindivanam",
    "officename": "Brahmadesam SO Villupuram",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "604302": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tindivanam",
    "officename": "Kutteripattu SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "604303": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tindivanam",
    "officename": "Markanum SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "604304": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tindivanam",
    "officename": "Mailam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "604305": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tindivanam",
    "officename": "Olakkur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "604306": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tindivanam",
    "officename": "Rettanai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "604307": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tindivanam",
    "officename": "Saram  Tindivanam  SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "604401": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Cheyyar",
    "officename": "Anukkavoor SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "604402": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Cheyyar",
    "officename": "Hasanamapettai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "604403": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Arni",
    "officename": "Kilkodungalur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "604404": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Vandavasi",
    "officename": "Kilkovalavedu SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "604405": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Vandavasi",
    "officename": "Marudadu SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "604406": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Vandavasi",
    "officename": "Tellar SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "604407": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Cheyyar",
    "officename": "Tiruvettipuram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "604408": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Cheyyar",
    "officename": "Vandavasi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "604409": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Cheyyar",
    "officename": "Valkadai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "604410": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Cheyyaru",
    "officename": "Vembakkam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "604501": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Vandavasi",
    "officename": "Desur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "604502": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Vandavasi",
    "officename": "Malayur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "604503": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Vandavasi",
    "officename": "Pernamallur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "604504": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Cheyyar",
    "officename": "Tirumani SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "604505": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Vandavasi",
    "officename": "Vallam Arni SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "604601": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Tvmalai",
    "officename": "Kilpennathur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "605001": {
    "state": "Pondicherry",
    "district": "Pondicherry",
    "block": "Pondicherry",
    "officename": "Pondicherry HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605002": {
    "state": "Pondicherry",
    "district": "Pondicherry",
    "block": "Pondicherry",
    "officename": "Sri Aurobindo Ashram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605003": {
    "state": "Pondicherry",
    "district": "Pondicherry",
    "block": "Pondicherry",
    "officename": "Muthialpet SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605004": {
    "state": "Pondicherry",
    "district": "Pondicherry",
    "block": "Pondicherry",
    "officename": "Mudaliarpet SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605005": {
    "state": "Pondicherry",
    "district": "Pondicherry",
    "block": "Pondicherry",
    "officename": "Nellithope SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605006": {
    "state": "Pondicherry",
    "district": "Pondicherry",
    "block": "Pondicherry",
    "officename": "Dhanvantri Nagar SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605007": {
    "state": "Pondicherry",
    "district": "Pondicherry",
    "block": "Pondicherry",
    "officename": "Ariyankuppam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605008": {
    "state": "Pondicherry",
    "district": "Pondicherry",
    "block": "Pondicherry",
    "officename": "Lawspet SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605009": {
    "state": "Pondicherry",
    "district": "Pondicherry",
    "block": "Pondicherry",
    "officename": "Thattanchavady SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605010": {
    "state": "Pondicherry",
    "district": "Pondicherry",
    "block": "Pondicherry",
    "officename": "Reddiarpalayam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605011": {
    "state": "Pondicherry",
    "district": "Pondicherry",
    "block": "Pondicherry",
    "officename": "Venkata Nagar SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605012": {
    "state": "Pondicherry",
    "district": "Pondicherry",
    "block": "Podicherry",
    "officename": "Pondicherry NDC",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605013": {
    "state": "Pondicherry",
    "district": "Pondicherry",
    "block": "Pondicherry",
    "officename": "SaramPy SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605014": {
    "state": "Pondicherry",
    "district": "Pondicherry",
    "block": "Pondicherry",
    "officename": "Pondicherry University SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605101": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Vanur",
    "officename": "Auroville SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605102": {
    "state": "Pondicherry",
    "district": "Pondicherry",
    "block": "Pondicherry",
    "officename": "Kandamangalam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605103": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Villupuram",
    "officename": "Koliyanur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605104": {
    "state": "Pondicherry",
    "district": "Pondicherry",
    "block": "Pondichery",
    "officename": "Kottakuppam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605105": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Villupuram",
    "officename": "Mokshakulam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605106": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Cuddalore",
    "officename": "Nettapakkam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605107": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Villupuram",
    "officename": "Pallineliyanur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605108": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Villupuram",
    "officename": "Valavanur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605109": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tindivanam",
    "officename": "Vanur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605110": {
    "state": "Pondicherry",
    "district": "Pondicherry",
    "block": "Villianur Commune Panchayat",
    "officename": "Villiyanur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605111": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Vanur",
    "officename": "Tiruchitambalam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605201": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tindivanam",
    "officename": "Ananthapuram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605202": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Villupuram",
    "officename": "Anniyur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605203": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Viluppuram",
    "officename": "Kanjanur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605301": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Villupuram",
    "officename": "Kanai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605302": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Villupuram",
    "officename": "Mambazhapattu SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605401": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Viluppuram",
    "officename": "Kandamanadi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605402": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Villupuram",
    "officename": "Kedar SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605501": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tindivanam",
    "officename": "Tirukkanur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605502": {
    "state": "Pondicherry",
    "district": "Pondicherry",
    "block": "Pondicherry",
    "officename": "Valudavur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605601": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Villupuram",
    "officename": "Mundiyambakkam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605602": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Viluppuram",
    "officename": "VILUPPURAM HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605651": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Villupuram",
    "officename": "Periyathatchur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605652": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Villupuram",
    "officename": "Vikravandi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "605701": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tirukkoyilur",
    "officename": "Kandachipuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "605702": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Sankarapuram",
    "officename": "Moongilthuraipattu S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "605751": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tirukkoyilur",
    "officename": "Ariyur S.O (Villupuram)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "605752": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tirukkoyilur",
    "officename": "Arakandanallur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "605754": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tirukkoyilur",
    "officename": "Manalurpet S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "605755": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tirukkoyilur",
    "officename": "Mogaiyur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "605756": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tirukkoyilur",
    "officename": "Thapovanam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "605757": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tirukkoyilur",
    "officename": "Tirukkoyilur H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "605758": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tirukkoyilur",
    "officename": "Virapandi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "605759": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tirukkoyilur",
    "officename": "Manampoondi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "605766": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tirukkoyilur",
    "officename": "Santhapettai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "605801": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tirukkoyilur",
    "officename": "Ariyalur (Villupuram) S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "605802": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tirukkoyilur",
    "officename": "Kadambur S.O (Villupuram)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "605803": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tirukkoyilur",
    "officename": "Sithalingamadam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "606001": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Vriddhachalam",
    "officename": "Vriddhachalam H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "606003": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Vriddhachalam",
    "officename": "Budamur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "606102": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Ulundurpet",
    "officename": "Kalamarudur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "606103": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Vriddhachalam",
    "officename": "Kammapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "606104": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Vriddhachalam",
    "officename": "Mangalam (SA) S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "606105": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Tittagudi",
    "officename": "Pennadam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "606106": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Tittagudi",
    "officename": "Tittagudi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "606107": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Ulundurpet",
    "officename": "Ulundurpet S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "606108": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Tittagudi",
    "officename": "Mangalur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "606110": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Vriddhachalam",
    "officename": "Karuvepilankurichi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "606111": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Tittakudi",
    "officename": "Pennadam R.S. S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "606115": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Ulundurpet",
    "officename": "Padur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "606201": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Kallakurichi",
    "officename": "Chinnasalem S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "606202": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Kallakurichi",
    "officename": "Kallakurichi H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "606203": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Kallakurichi",
    "officename": "Nagalur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "606204": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Kallakurichi",
    "officename": "Pukkiravari S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "606205": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Sankarapuram",
    "officename": "Rishivandiyam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "606206": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Kallakurichi",
    "officename": "Tiyagadrug S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "606207": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Kallakurichi",
    "officename": "Vadakkanandal S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "606208": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Sankarapuram",
    "officename": "Murarbad S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "606209": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Kallakurichi",
    "officename": "Vellimalai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "606213": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Kallakurichi",
    "officename": "Kallakurichi South S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "606301": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Kallakurichi",
    "officename": "Nainarpalayam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "606302": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Vriddhachalam",
    "officename": "Nallur S.O (Cuddalore)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "606303": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Tittagudi",
    "officename": "Toludur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "606304": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Vriddhachalam",
    "officename": "Veppur (SA) S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "606305": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Ulundurpet",
    "officename": "Asanur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "606401": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Sankarapuram",
    "officename": "Sankarapuram (Villupuram) S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "606402": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Sankarapuram",
    "officename": "Pandalam S.O (Villupuram)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "606601": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Tiruvannamalai",
    "officename": "Tiruvannamalai HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "606603": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Tiruvannamalai",
    "officename": "Sriramanashramam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "606604": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Tiruvannamalai",
    "officename": "Vengikkal SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "606611": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Tiruvannamalai",
    "officename": "Somasipadi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "606701": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Chengam",
    "officename": "Chengam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "606702": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Chengam",
    "officename": "Kanji SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "606703": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Chengam",
    "officename": "Melpallipattu SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "606704": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Vandavasi",
    "officename": "Pachal SO Tiruvannamalai",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "606705": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Chengam",
    "officename": "Pudupalayam SO Tiruvannamalai",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "606706": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Chengam",
    "officename": "Sathanurdam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "606707": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Chengam",
    "officename": "Tandarampattu SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "606708": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Chengam",
    "officename": "Tanipadi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "606709": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Chengam",
    "officename": "Thukkapettai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "606710": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Chengam",
    "officename": "Paramanandal SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "606751": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Polur",
    "officename": "Kalasapakkam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "606752": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Tiruvannamalai",
    "officename": "Mangalam SO Tiruvannamalai",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "606753": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Tiruvannamalai",
    "officename": "Vanapuram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "606754": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Vandavasi",
    "officename": "Vettavalam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "606755": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Tiruvannamalai Taluk",
    "officename": "Avur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "606801": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Vandavasi",
    "officename": "Chettupattu Polur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "606802": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Tiruvannamalai",
    "officename": "Nayudumangalam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "606803": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Polur",
    "officename": "Polur SO Tiruvannamalai",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "606804": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Tiruvannamalai",
    "officename": "Tandarai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "606805": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Tiruvananamalai",
    "officename": "Turinjapuram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "606806": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Tiruvannamalai",
    "officename": "Pavithiram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "606807": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Vandavasi",
    "officename": "Nedungunam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "606808": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Thandrampattu",
    "officename": "Kattampoondi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "606811": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Tiruvannamalai",
    "officename": "Thachampattu SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "606901": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Polur",
    "officename": "Adamangalam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "606902": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Arni",
    "officename": "Devikapuram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "606903": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Vandavasi",
    "officename": "Kalambur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "606904": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Polur",
    "officename": "Mandakolathur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "606905": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Polur",
    "officename": "Santhavasal SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "606906": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Polur",
    "officename": "Vilvarani SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "606907": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Polur",
    "officename": "Vadamadimangalam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "606908": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Polur",
    "officename": "Kadaladi SO Tiruvannamalai",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "607001": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Cuddalore",
    "officename": "Cuddalore H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "607002": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Cuddalore",
    "officename": "Tirupadiripuliyur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "607003": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Cuddalore",
    "officename": "Cuddalore Old Town S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "607004": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Cuddalore",
    "officename": "Vandipalayam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "607005": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Cuddalore",
    "officename": "Sipcot Cuddalore S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "607006": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Cuddalore",
    "officename": "Kondur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "607101": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Panruti",
    "officename": "Anathur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "607102": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Panruti",
    "officename": "Chinnapanaickenpalayam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "607103": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Panruti",
    "officename": "Kadambuliyur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "607104": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Panruti",
    "officename": "Melpattambakkam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "607105": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Cuddalore",
    "officename": "Nellikkuppam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "607106": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Panruti",
    "officename": "Panruti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "607107": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Ulundurpet",
    "officename": "Perangiyur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "607108": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Panruti",
    "officename": "Puthupet (CDL) S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "607109": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Cuddalore",
    "officename": "Varakalpattu S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "607112": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Panruti",
    "officename": "Kilkavarappattu S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "607201": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Ulundurpettai",
    "officename": "Eraiyur S.O (Villupuram)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "607202": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Ulundurpettai",
    "officename": "Elavanasur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "607203": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tirukkoyilur",
    "officename": "Tiruvennainallur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "607204": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Ulundurpet",
    "officename": "Tirunavalur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "607205": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Panruti",
    "officename": "Tiruthuraiyur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "607209": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Tirukkoyilur",
    "officename": "Periyasevalai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "607301": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Cuddalore",
    "officename": "Kullanchavadi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "607302": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Cuddalore",
    "officename": "Kurinjipadi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "607303": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Panruti",
    "officename": "Vadalur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "607308": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Cuddalore",
    "officename": "Gandhi Nagar S.O (Cuddalore)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "607401": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Cuddalore",
    "officename": "Tiruvendhipuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "607402": {
    "state": "Pondicherry",
    "district": "Pondicherry",
    "block": "Pondicherry",
    "officename": "Bahoor SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "607403": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Pondicherry",
    "officename": "Kirumambakkam",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "607801": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Virudhachalam",
    "officename": "Neyveli 1 S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "607802": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Virudhachalam",
    "officename": "Neyveli 2 S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "607803": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Virudhachalam",
    "officename": "Neyveli 3 S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "607804": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Vriddhachalam",
    "officename": "Oomangalam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "607805": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Panruti",
    "officename": "Perperiyankuppam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "607807": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Virudhachalam",
    "officename": "Block 29 Neyveli S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "608001": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Chidambaram North",
    "officename": "Chidambaram H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "608002": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Chidambaram",
    "officename": "Annamalainagar S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "608102": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Chidambaram",
    "officename": "Killai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "608201": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Chidambaram",
    "officename": "Orathur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "608301": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Kattumannarkoil",
    "officename": "Kattumannarkoil S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "608302": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Chidambaram",
    "officename": "Komaratchi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "608303": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Chidambaram North",
    "officename": "Lalpet S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "608304": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Kattumannarkoil",
    "officename": "Reddiyur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "608305": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Kattumannarkoil",
    "officename": "T.Nedunjeri S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "608306": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Kattumannarkoil",
    "officename": "Ayangudi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "608401": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Chidambaram",
    "officename": "Vallampadugai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "608501": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Chidambaram",
    "officename": "B.Mutlur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "608502": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Chidambaram North",
    "officename": "Parangipettai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "608601": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Chidambaram",
    "officename": "Bhuvanagiri S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "608602": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Chidambaram",
    "officename": "Keerapalayam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "608701": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Kattumannarkoil",
    "officename": "Palayamkottai(CDL) S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "608702": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Kattumannarkoil",
    "officename": "Sethiathope S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "608703": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Kattumannarkoil",
    "officename": "Srimushnam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "608704": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Kattumannarkoil",
    "officename": "Pinnalur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "608801": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Cuddalore",
    "officename": "Alapakkam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Cuddalore Division"
  },
  "608901": {
    "state": "Tamil Nadu",
    "district": "Ariyalur",
    "block": "Jayamkondacholapuram",
    "officename": "Kavarapalayam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "609001": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Mayiladuthurai",
    "officename": "Mayiladuthurai H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609003": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Mayiladuthurai",
    "officename": "Mayiladuthurai R.S S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609101": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Sirkali",
    "officename": "Achalpuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609102": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Sirkali",
    "officename": "Anaikaranchatram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609103": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Mayiladuthurai",
    "officename": "Anandatandavapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609104": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Sirkali",
    "officename": "Kadavasal S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609105": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Tharangambadi",
    "officename": "Kaveripattinam S.O (Nagapattinam)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609106": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Sirkali",
    "officename": "Mangamadam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609107": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Tharangambadi",
    "officename": "Melaiyur TVG S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609108": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Sirkali",
    "officename": "Puthur (SRK) S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609109": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Sirkali",
    "officename": "Sattanathapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609110": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Sirkali Tk",
    "officename": "Sirkali H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609111": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Sirkali",
    "officename": "Sirkali Thenpathi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609112": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Sirkali",
    "officename": "Tirupungur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609113": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Sirkali",
    "officename": "Tirumullaivasal S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609114": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Sirkali",
    "officename": "Tiruvengadu S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609115": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Sirkali",
    "officename": "Varisapathu Vadagal S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609116": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Sirkali",
    "officename": "Valluvakudi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609117": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Mayiladuthurai",
    "officename": "Vaithiswarankoil S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609118": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Mayiladuthurai",
    "officename": "Solasakkaranallur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609201": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Mayiladuthurai",
    "officename": "Ilanthope S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609202": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Mayiladuthurai",
    "officename": "Manalmedu S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609203": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Mayiladuthurai",
    "officename": "Nidur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609204": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Tirupanandal",
    "officename": "Tirumeniarkoil S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "609205": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Mayiladuthurai",
    "officename": "Tiruvalaputhur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609301": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Tharangambadi",
    "officename": "Akkur S.O (Nagapattinam)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609302": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Tharangambadi",
    "officename": "Arangakudi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609303": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Tharangambadi",
    "officename": "Ayappadi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609304": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Tharangambadi",
    "officename": "Kilaiyur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609305": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Mayiladuthurai",
    "officename": "Mannampandal S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609306": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Tharangambadi",
    "officename": "Nalladai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609307": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Tharangambadi",
    "officename": "Porayar S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609308": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Tharangambadi",
    "officename": "Sankaranpandal S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609309": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Tharangambadi",
    "officename": "Sembanarkoil S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609310": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Tharangambadi",
    "officename": "Tillaiyadi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609311": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Tharangambadi",
    "officename": "Tirucadaiyur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609312": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Tharangambadi",
    "officename": "Tirukkalachery S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609313": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Tharangambadi",
    "officename": "Tarangambadi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609314": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Mayiladuthurai",
    "officename": "Vadakarai S.O (Nagapattinam)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609401": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Mayiladuthurai",
    "officename": "Elandangudi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609402": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Tharangambadi",
    "officename": "Kiliyanur S.O (Nagapattinam)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609403": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Mayiladuthurai",
    "officename": "Kollumangudi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609404": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Mayiladuthurai",
    "officename": "Manganallur Bazaar S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609405": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Nannilam",
    "officename": "Peralam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609501": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Mayiladuthurai",
    "officename": "Eravancheri S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "609502": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Nannilam",
    "officename": "Mudikondan S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "609503": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Nannilam",
    "officename": "Punthottam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Mayiladuthurai Division"
  },
  "609504": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Nannilam",
    "officename": "Sannanallur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "609601": {
    "state": "Pondicherry",
    "district": "Karaikal",
    "block": "Karaikal",
    "officename": "Ambagarathur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "609602": {
    "state": "Pondicherry",
    "district": "Karaikal",
    "block": "NA",
    "officename": "Karaikal S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "609603": {
    "state": "Pondicherry",
    "district": "Karaikal",
    "block": "Nedungadu Commune Panchayat",
    "officename": "Nedungadu S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "609604": {
    "state": "Pondicherry",
    "district": "Karaikal",
    "block": "Neravy Commune Panchayat",
    "officename": "Neravy S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "609605": {
    "state": "Pondicherry",
    "district": "Karaikal",
    "block": "NA",
    "officename": "Thalatheru S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "609606": {
    "state": "Pondicherry",
    "district": "Karaikal",
    "block": "Thirumalairayan Pattinam Commune Panchayat",
    "officename": "Tirumalairayanpattinam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "609607": {
    "state": "Pondicherry",
    "district": "Karaikal",
    "block": "Thirunallar Commune Panchayat",
    "officename": "Tirunallar S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "609608": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Nannilam",
    "officename": "Kollapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "609609": {
    "state": "Pondicherry",
    "district": "Karaikal",
    "block": "Kottucherry Commune Panchayat",
    "officename": "Kottuchery S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "609701": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Nagapattinam",
    "officename": "Enangudi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "609702": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Nagapattinam",
    "officename": "Tirumarugal S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "609703": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Nagapattinam",
    "officename": "Tittachery S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "609704": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Nagapattinam",
    "officename": "Tirukannapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "609801": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Kuttalam",
    "officename": "Kuttalam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "609802": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Mayiladuthurai",
    "officename": "Narasinganpettai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "609803": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Kuttalam",
    "officename": "Tiruvavaduthurai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "609804": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Tiruvidamarudur",
    "officename": "Thuhili S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "609805": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Mayiladuthurai",
    "officename": "Komal S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "609806": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Mayiladuthurai",
    "officename": "Malliyam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "609807": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Thiruvidaimarudur",
    "officename": "Pandanallur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "609808": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Mayiladuthurai",
    "officename": "Terizhandur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "609810": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Kuttalam",
    "officename": "Tiruvalangadu S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "609811": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Kuttalam",
    "officename": "Kali S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "610001": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Thiruvarur",
    "officename": "Tiruvarur H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "610003": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Thiruvarur",
    "officename": "Kidarankondan S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "610004": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Thiruvarur",
    "officename": "Tiruvarur Collectorate S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "610101": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Tiruvarur",
    "officename": "Kangalanchery S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "610102": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Mannarkudi",
    "officename": "Kamalapuram S.O (Tiruvarur)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "610103": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Tiruvarur",
    "officename": "Mangudi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "610104": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Kodavasal",
    "officename": "Manakkal Ayyampet S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "610105": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Nannilam",
    "officename": "Nannilam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "610106": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Tiruvarur",
    "officename": "Thappalampuliyur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "610107": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Kodavasal",
    "officename": "Tiruvidacherry S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "610109": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Thiruvarur",
    "officename": "Pulivalam S.O (Tiruvarur)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "610201": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Tiruturipundi",
    "officename": "Kachanam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "610202": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Tiruturipundi",
    "officename": "Mavoor S.O (Tiruvarur)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "610203": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Tiruturaipundi",
    "officename": "Ponnirai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "610204": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Tirukuvalai",
    "officename": "Tirukuvalai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "610205": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Mannargudi",
    "officename": "Tirunellikaval S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "610206": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Nidamangalam",
    "officename": "Vadapathimangalam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "610207": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Kilvelur",
    "officename": "Valivalam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "611001": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Nagapattinam",
    "officename": "Nagapattinam H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "611002": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Nagapattinam",
    "officename": "Nagore S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "611003": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Nagapattinam",
    "officename": "Nagapattinam Collectorate S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "611101": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Tiruvarur",
    "officename": "Adiakkamangalam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "611102": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Nagapattinam",
    "officename": "Andanapettai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "611103": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Kilvelur",
    "officename": "Kilaiyur (Tiruvarur) S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "611104": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Kilvelur",
    "officename": "Kilvelur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "611105": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Kilvelur",
    "officename": "Kuthur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "611106": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Nagapattinam",
    "officename": "Manjakollai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "611108": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Nagapattinam",
    "officename": "Sikkal S.O (Nagapattinam)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "611109": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Kilvelur",
    "officename": "Thevur S.O (Nagapattinam)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "611110": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Kilvelur",
    "officename": "Tirupundi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "611111": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Kilvelur",
    "officename": "Vailankanni S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "611112": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Vedaraniam",
    "officename": "Vettaikaraniruppu S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "612001": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Kumbakonam",
    "officename": "Kumbakonam H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "612002": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Kumbakonam",
    "officename": "Melakaveri H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "612101": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Kumbakonam",
    "officename": "Aduthurai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "612102": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Thiruvidaimarudur",
    "officename": "Tirumangalakudi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "612103": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Kumbakonam",
    "officename": "Tirupuvanam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "612104": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Thiruvidaimarudur",
    "officename": "Tiruvidamarudur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "612105": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Tiruvidamarudur",
    "officename": "Veppathur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "612106": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Kuttalam",
    "officename": "Kadiramangalam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "612201": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Kuttalam",
    "officename": "Konerirajapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "612202": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Tiruvidamarudur",
    "officename": "Murukkangudi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "612203": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Kuttalam",
    "officename": "Palaiyur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "612204": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Kumbakonam",
    "officename": "Tirunageswaram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "612301": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Papanasam",
    "officename": "Pullabudangudi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "612302": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Kumbakonam",
    "officename": "Swamimalai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "612303": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Kumbakonam",
    "officename": "Tirupirambiyam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "612401": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Kumbakonam",
    "officename": "Sakkottai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "612402": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Valangaiman",
    "officename": "Tippirajapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "612501": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Kumbakonam",
    "officename": "Koranattukkaruppur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "612502": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Thiruvidaimarudur",
    "officename": "Lower Anicut S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "612503": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Tirupanandal",
    "officename": "Sholapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "612504": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Tirupanandal",
    "officename": "Tirupanandal S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "612601": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Kodavasal",
    "officename": "Kodavasal S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "612602": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Kumbakonam",
    "officename": "Natchar Koil S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "612603": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Kodavasal",
    "officename": "Sembangudi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "612604": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Kodavasal",
    "officename": "Sengalipuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "612605": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Tiruvidamarudur",
    "officename": "Tiruchirai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "612610": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Kodavasal",
    "officename": "Manjakudi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "612701": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Valangaman",
    "officename": "Avoor S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "612702": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Kumbakonam",
    "officename": "Darasuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "612703": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Kumbakonam",
    "officename": "Patteeswaram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "612801": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Nidamangalam",
    "officename": "Alangudi NID S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "612802": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Valangaman",
    "officename": "Haridwaramangalam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "612803": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Nidamangalam",
    "officename": "Puvanur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "612804": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Valangaman",
    "officename": "Valangaman S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "612901": {
    "state": "Tamil Nadu",
    "district": "Ariyalur",
    "block": "Udayarpalayam",
    "officename": "Gangaikondacholapuram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "612902": {
    "state": "Tamil Nadu",
    "district": "Ariyalur",
    "block": "Jayamkondacholapuram",
    "officename": "Kodalikaruppur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "612903": {
    "state": "Tamil Nadu",
    "district": "Ariyalur",
    "block": "Udayarpalayam",
    "officename": "Minsuritti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "612904": {
    "state": "Tamil Nadu",
    "district": "Ariyalur",
    "block": "Ariyalur",
    "officename": "Thathampettai Palur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "613001": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Thanjavur",
    "officename": "Thanjavur H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "613002": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Thanjavur",
    "officename": "Karuntattankudi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "613003": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Thanjavur",
    "officename": "Vennar Bank S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "613004": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Thanjavur",
    "officename": "Thanjavur Medical College S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "613005": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Thanjavur",
    "officename": "Raja Serfoji Govt College S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "613006": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Thanjavur",
    "officename": "Thanjavur Pandt Colony S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "613007": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Thanjavur",
    "officename": "Voc Nagar S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "613008": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Thanjavur",
    "officename": "Thanjavur North Gate S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "613009": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Thanjavur",
    "officename": "Thanjavur West S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "613010": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Thanjavur",
    "officename": "Tamil University S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "613101": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Thiruvaiyaru",
    "officename": "Nadukaveri S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "613102": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Thanjavur",
    "officename": "Thogur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "613103": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Thiruvaiyaru",
    "officename": "Thiruppanthuruthi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "613104": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Thiruvaiyaru",
    "officename": "Tirukattupalli S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "613105": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Thiruvaiyaru",
    "officename": "Poondi TPL S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "613201": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Thiruvaiyaru",
    "officename": "Kalyanapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "613202": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Thiruvaiyaru",
    "officename": "Kandiyur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "613203": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Thiruvaiyaru",
    "officename": "Thillaisthanam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "613204": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Thiruvaiyaru",
    "officename": "Thiruvaiyaru S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "613205": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Thiruvaiyaru",
    "officename": "Vediapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "613301": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Gandarvakkottai",
    "officename": "Ghandarvakottai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "613303": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Thanjavur",
    "officename": "Kurungulam Melpathi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "613401": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Thanjavur",
    "officename": "Tirumalaisamudram East S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "613402": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Thanjavur",
    "officename": "Sengipatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "613403": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Thanjavur",
    "officename": "Vallam TJ S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "613501": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Thanjavur",
    "officename": "Mariammancoil S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "613502": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Papanasam",
    "officename": "Pundi TJ S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "613503": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Papanasam",
    "officename": "Sri Pushpam College S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "613504": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Papanasam",
    "officename": "Saliamangalam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "613601": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Thanjavur",
    "officename": "Alakkudi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "613602": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Thanjavur",
    "officename": "Budalur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "613701": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Kodavasal",
    "officename": "Ammayappan S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "613702": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Needamangalam",
    "officename": "Attikkadai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "613703": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Koradacherry",
    "officename": "Koradacheri S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "613704": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Tiruvarur",
    "officename": "Kulikarai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "613705": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Koradacherry",
    "officename": "Sellur S.O (Tiruvarur)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Kumbakonam Division"
  },
  "614001": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Mannargudi",
    "officename": "Mannargudi H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "614013": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Mannargudi",
    "officename": "Idangankottai Melaiyur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "614014": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Mannargudi",
    "officename": "Pamani MNG S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "614015": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Pattukottai",
    "officename": "Paravakottai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "614016": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Tiruvarur",
    "officename": "Serangolam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "614017": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Mannargudi",
    "officename": "Tirumakottai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "614018": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Mannargudi",
    "officename": "Ullikottai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "614019": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Orattanad",
    "officename": "Vaduvur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "614020": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Mannargudi",
    "officename": "Painganadu S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "614101": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Mannargudi",
    "officename": "Koothanallur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "614102": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Nidamangalam",
    "officename": "Lakshmangudi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "614103": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Nidamangalam",
    "officename": "Podakudi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "614201": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Papanasam",
    "officename": "Ayyampet S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "614202": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Papanasam",
    "officename": "Ganapathi Agraharam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "614203": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Papanasam",
    "officename": "Kabistalam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "614204": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Papanasam",
    "officename": "Pandaravadai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "614205": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Papanasam",
    "officename": "Papanasam H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "614206": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Thanjavur",
    "officename": "Pasupathikoil S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "614207": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Papanasam",
    "officename": "Rajaghiri S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "614208": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Valangaman",
    "officename": "Sundaraperumalkoil S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "614210": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Papanasam",
    "officename": "Valoothoor S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "614211": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Papanasam",
    "officename": "Chakrapalli S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "614301": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Papanasam",
    "officename": "Melattur S.O (Thanjavur)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "614302": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Papanasam",
    "officename": "Tirukkarugavur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "614303": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Papanasam",
    "officename": "Vadakkumangudi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "614401": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Papanasam",
    "officename": "Ammapet S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "614402": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Papanasam",
    "officename": "Kokkeri S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "614403": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Nidamangalam",
    "officename": "Kovilvenni S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "614404": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Nidamangalam",
    "officename": "Nidamangalam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "614601": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Pattukottai",
    "officename": "Pattukottai H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "614602": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Pattukottai",
    "officename": "Nadimuthunagar S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "614612": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Peravurani",
    "officename": "Perumagalur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "614613": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Pattukottai",
    "officename": "Tamarankottai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "614614": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Orattanad",
    "officename": "Tiruvonam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "614615": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Pattukottai",
    "officename": "Aladikkumulai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "614616": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Arantangi",
    "officename": "Arantangi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "614617": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Aranthangi",
    "officename": "Ammapattinam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "614618": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Avudayarkoil",
    "officename": "Tirupperunthurai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "614619": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Manamelkudi",
    "officename": "Kottaipattinam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "614620": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Manamelkudi",
    "officename": "Manamelkudi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "614621": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Manamelkudi",
    "officename": "Mimisal S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "614622": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Aranthangi",
    "officename": "Silattur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "614623": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Peravurni",
    "officename": "Avanam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "614624": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Alangudi",
    "officename": "Keeramangalam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "614625": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Orattanad",
    "officename": "Orattanad S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "614626": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Orattanad",
    "officename": "Pappanad S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "614628": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Peravurni",
    "officename": "Tiruchitrambalam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "614629": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Avudayarkoil",
    "officename": "Ponbethi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "614630": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Aranthangi",
    "officename": "Attani S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "614701": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Pattukottai",
    "officename": "Adirampattinam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "614702": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Thiruthuraipoondi",
    "officename": "Idaiyur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "614703": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Tiruturaipundi",
    "officename": "Kunnalur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "614704": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Tiruturaipundi",
    "officename": "Mutupet S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "614705": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Mannargudi",
    "officename": "Peruvazhandan S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "614706": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Thiruthuraipoondi",
    "officename": "Udayamarthandapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "614707": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Vedaraniam",
    "officename": "Ayakkarambalam Ii Sethi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "614708": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Mannargudi",
    "officename": "Kottur S.O (Tiruvarur)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "614710": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Tiruturaipundi",
    "officename": "Naduvakalappal S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "614711": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Thirukkuvalai",
    "officename": "Pamani TTP S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "614712": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Vedaraniam",
    "officename": "Talanayar Agraharam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "614713": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Tiruturaipundi",
    "officename": "Tiruturaipundi H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "614714": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Vedaranyam",
    "officename": "Takattur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "614715": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Tiruturaipundi",
    "officename": "Vilakudi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "614716": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Tiruturaipundi",
    "officename": "Kattimodu S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "614717": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Mannargudi",
    "officename": "Adichapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Thanjavur Division"
  },
  "614723": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Peravurni",
    "officename": "Mallipattinam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "614738": {
    "state": "Tamil Nadu",
    "district": "Tiruvarur",
    "block": "Tiruturaipundi",
    "officename": "Jambavanodai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "614801": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Arantangi",
    "officename": "Arasarkulam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "614802": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Peravurni",
    "officename": "Kuruvikarambai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "614803": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Peravurni",
    "officename": "Ottangadu S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "614804": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Peravurni",
    "officename": "Peravurni S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "614805": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Arantangi",
    "officename": "Subramaniapuram S.O (Pudukkottai)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "614806": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Vedaranyam",
    "officename": "Kariyapattinam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "614807": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Vedaraniam",
    "officename": "Kodiakkarai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "614808": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Vedaraniam",
    "officename": "Kuruvapulam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "614809": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Vedaranyam",
    "officename": "Topputhurai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "614810": {
    "state": "Tamil Nadu",
    "district": "Nagapattinam",
    "block": "Vedaranyam",
    "officename": "Vedaraniam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "614901": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Pattukottai",
    "officename": "Alathur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "614902": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Gandarvakkottai",
    "officename": "Kottaitheru S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "614903": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Pattukottai",
    "officename": "Madukkur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "614904": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Orattanad",
    "officename": "Melauluvur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "614905": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Orathanadu",
    "officename": "Vadaseri S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "614906": {
    "state": "Tamil Nadu",
    "district": "Thanjavur",
    "block": "Pattukottai",
    "officename": "Nattuchalai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pattukottai Division"
  },
  "620001": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Tiruchirappalli",
    "officename": "Tiruchirappalli HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "620002": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Tiruchirappalli",
    "officename": "Teppakulam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "620003": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Tiruchirappalli",
    "officename": "Woriur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "620004": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Tiruchirappalli",
    "officename": "Golden Rock SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "620005": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Srirangam",
    "officename": "Tiruvanaikoil S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "620006": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Srirangam",
    "officename": "Srirangam H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "620007": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Tiruchirappalli",
    "officename": "Tiruchirappalli Airport SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "620008": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Tiruchirappalli",
    "officename": "Tiruchirappalli Fort SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "620009": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Tiruchirappalli",
    "officename": "Ramjeenagar SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "620010": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Tiruchirappalli",
    "officename": "Industrial Colony SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "620011": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Tiruchirappalli",
    "officename": "Melakalkandarkottai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "620012": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Tiruchirappalli",
    "officename": "Edamalaipatti Pudur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "620013": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Tiruchirappalli",
    "officename": "Thiruverumbur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "620014": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Tiruchirappalli",
    "officename": "Boiler Project  TR SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "620015": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Tiruchirappalli",
    "officename": "National Institute of Technology SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "620016": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Tiruchirappalli",
    "officename": "Ordnance Estate  TR SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "620017": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Tiruchirappalli",
    "officename": "Tennur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "620018": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Tiruchirappalli",
    "officename": "Thillai Nagar SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "620019": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Tiruchirappalli",
    "officename": "Pappakurichi Kattur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "620020": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Tiruchirappalli",
    "officename": "Jamal Mohamed College SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "620021": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Tiruchirappalli",
    "officename": "KKNagar SO Tiruchirappalli",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "620022": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Tiruchirappalli",
    "officename": "Thuvakudimalai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "620023": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Tiruchirappalli",
    "officename": "Khajanagar SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "620024": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Tiruchirappalli",
    "officename": "Bharathidasan University SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "620025": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Tiruchirappalli",
    "officename": "Hapf Township SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "620026": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Tiruchirappalli",
    "officename": "Annanagar SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "620101": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Tiruchirappalli",
    "officename": "Mutharasanallur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "620102": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Srirangam",
    "officename": "Somarasampettai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "621001": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Turaiyur",
    "officename": "Erakudi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621002": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Thuraiyur",
    "officename": "Kirambur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621003": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Turaiyur",
    "officename": "Kottapalayam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621004": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Thuraiyur",
    "officename": "Kottathur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621005": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Manachanallur",
    "officename": "Manachanalloor S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621006": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Musiri",
    "officename": "Pulivalam S.O (Tiruchirappalli)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621007": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Musiri",
    "officename": "Puthanampatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621008": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Thuraiyur",
    "officename": "Sikkathambur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621009": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Musiri",
    "officename": "Tiruvellerai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621010": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Turaiyur",
    "officename": "Turaiyur H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621011": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Thuraiyur",
    "officename": "Uppliapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621012": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Turaiyur",
    "officename": "Vyrichettipalayam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621014": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Turaiyur",
    "officename": "Pagalavadi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621101": {
    "state": "Tamil Nadu",
    "district": "Perambalur",
    "block": "Perambalur",
    "officename": "Ammapalayam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621102": {
    "state": "Tamil Nadu",
    "district": "Perambalur",
    "block": "Veppanthattai",
    "officename": "Annamangalam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621103": {
    "state": "Tamil Nadu",
    "district": "Perambalur",
    "block": "Veppanthattai",
    "officename": "Arumbavur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621104": {
    "state": "Tamil Nadu",
    "district": "Perambalur",
    "block": "Perambalur",
    "officename": "Chettikulam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621105": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Trichy",
    "officename": "Irungalur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621106": {
    "state": "Tamil Nadu",
    "district": "Perambalur",
    "block": "Perambalur",
    "officename": "Kolakkanatham S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621107": {
    "state": "Tamil Nadu",
    "district": "Perambalur",
    "block": "Perambalur",
    "officename": "Kurumbalur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621108": {
    "state": "Tamil Nadu",
    "district": "Perambalur",
    "block": "Kunnam",
    "officename": "Labbaikudikadu S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621109": {
    "state": "Tamil Nadu",
    "district": "Perambalur",
    "block": "Kunnam",
    "officename": "Padalur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621110": {
    "state": "Tamil Nadu",
    "district": "Perambalur",
    "block": "Veppanthattai",
    "officename": "Poolambadi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621111": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Trichy",
    "officename": "Purathakudi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621112": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Manachanallur",
    "officename": "Samayapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621113": {
    "state": "Tamil Nadu",
    "district": "Perambalur",
    "block": "Perambalur",
    "officename": "Siruvachur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621114": {
    "state": "Tamil Nadu",
    "district": "Perambalur",
    "block": "Kunnam",
    "officename": "T.Kalathur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621115": {
    "state": "Tamil Nadu",
    "district": "Perambalur",
    "block": "Kunnam",
    "officename": "Valikondapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621116": {
    "state": "Tamil Nadu",
    "district": "Perambalur",
    "block": "Veppanthattai",
    "officename": "Veppanthattai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621117": {
    "state": "Tamil Nadu",
    "district": "Perambalur",
    "block": "Veppanthattai",
    "officename": "V.Kalathur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621118": {
    "state": "Tamil Nadu",
    "district": "Perambalur",
    "block": "Kunnam",
    "officename": "Nakkasalem S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621133": {
    "state": "Tamil Nadu",
    "district": "Perambalur",
    "block": "Veppanthattai",
    "officename": "Eraiyur S.O (Perambalur)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621202": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Musiri",
    "officename": "Ayyampalayam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621203": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Musiri",
    "officename": "Balasamudram S.O (Tiruchirappalli)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621204": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Musiri",
    "officename": "Gunasilam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621205": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Musiri",
    "officename": "Jambunathapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621206": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Thuraiyur",
    "officename": "Kannanur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621207": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Thottiam",
    "officename": "Kattuputhur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621208": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Musiri",
    "officename": "Kolakkudi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621209": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Thottiam",
    "officename": "Manamedu S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621210": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Musiri",
    "officename": "Mettupalayam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621211": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Manachanallur",
    "officename": "Musiri S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621212": {
    "state": "Tamil Nadu",
    "district": "Perambalur",
    "block": "Perambalur",
    "officename": "Perambalur H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621213": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Manachanalloor",
    "officename": "Sirugambur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621214": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Musiri",
    "officename": "Thathiengarpet S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621215": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Thottiam",
    "officename": "Thottiam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621216": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Manachanallur",
    "officename": "Bikshandarkoil S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621217": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Musiri",
    "officename": "Thandalaiputhur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621218": {
    "state": "Tamil Nadu",
    "district": "Ariyalur",
    "block": "Lalgudi",
    "officename": "Valady SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "621219": {
    "state": "Tamil Nadu",
    "district": "Perambalur",
    "block": "Veppanthattai",
    "officename": "Yesanai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621220": {
    "state": "Tamil Nadu",
    "district": "Perambalur",
    "block": "Perambalur",
    "officename": "Thoramangalam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621301": {
    "state": "Tamil Nadu",
    "district": "Karur",
    "block": "Kulithalai",
    "officename": "Chinthamanipatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "621302": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Manaparai",
    "officename": "Elangakurichi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "621305": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Manapparai",
    "officename": "Kovilpatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "621306": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Manapparai",
    "officename": "Manaparai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "621307": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Manaparai",
    "officename": "Manjampatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "621308": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Manaparai",
    "officename": "Palakurichi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "621310": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Manapparai",
    "officename": "Puthanatham S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "621311": {
    "state": "Tamil Nadu",
    "district": "Karur",
    "block": "Kulittalai",
    "officename": "Tharagampatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "621312": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Manapparai",
    "officename": "Thiagesaralai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "621313": {
    "state": "Tamil Nadu",
    "district": "Karur",
    "block": "Kulithalai",
    "officename": "Thogaimalai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "621314": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Manapparai",
    "officename": "Thuvarankurichi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "621315": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Manaparai",
    "officename": "Vaiyampatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "621316": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Iluppur",
    "officename": "Viralimalai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "621601": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Lalgudi",
    "officename": "Lalgudi HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "621651": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Lalgudi",
    "officename": "Kallakudi TR SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "621652": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Lalgudi",
    "officename": "Kallakudi North SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "621653": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Lalgudi",
    "officename": "Kallagam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "621701": {
    "state": "Tamil Nadu",
    "district": "Ariyalur",
    "block": "Ariyalur",
    "officename": "Ambapur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "621702": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Lalgudi",
    "officename": "Ambil SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "621703": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Lalgudi",
    "officename": "Angarai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "621704": {
    "state": "Tamil Nadu",
    "district": "Ariyalur",
    "block": "Ariyalur",
    "officename": "Ariyalur Ariyalur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "621705": {
    "state": "Tamil Nadu",
    "district": "Ariyalur",
    "block": "Ariyalur",
    "officename": "Kallankurichi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "621706": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Lalgudi",
    "officename": "Kattur Puvalur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "621707": {
    "state": "Tamil Nadu",
    "district": "Ariyalur",
    "block": "Ariyalur",
    "officename": "Kilapaluvur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "621708": {
    "state": "Tamil Nadu",
    "district": "Perambalur",
    "block": "Kunnam",
    "officename": "Kunnam S.O (Perambalur)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621709": {
    "state": "Tamil Nadu",
    "district": "Ariyalur",
    "block": "Sendurai",
    "officename": "Mathur SO Ariyalur",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "621710": {
    "state": "Tamil Nadu",
    "district": "Ariyalur",
    "block": "Ariyalur",
    "officename": "Ponparappi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "621711": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Lalgudi",
    "officename": "Pullambadi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "621712": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Lalgudi",
    "officename": "Puvalur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "621713": {
    "state": "Tamil Nadu",
    "district": "Ariyalur",
    "block": "Ariyalur",
    "officename": "Rajajinagar SO Ariyalur",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "621714": {
    "state": "Tamil Nadu",
    "district": "Ariyalur",
    "block": "Sendurai",
    "officename": "Sendurai SO Ariyalur",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "621715": {
    "state": "Tamil Nadu",
    "district": "Ariyalur",
    "block": "Lalgudi",
    "officename": "Tirumanur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "621716": {
    "state": "Tamil Nadu",
    "district": "Perambalur",
    "block": "Perambalur",
    "officename": "Tungapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621717": {
    "state": "Tamil Nadu",
    "district": "Perambalur",
    "block": "Kunnam",
    "officename": "Veppur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621718": {
    "state": "Tamil Nadu",
    "district": "Ariyalur",
    "block": "Ariyalur",
    "officename": "Rayambaram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "621719": {
    "state": "Tamil Nadu",
    "district": "Ariyalur",
    "block": "Sendurai",
    "officename": "Asaveerankudikadu SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "621722": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Lalgudi",
    "officename": "Viragalur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "621729": {
    "state": "Tamil Nadu",
    "district": "Ariyalur",
    "block": "Ariyalur",
    "officename": "Ariyalur Cement Factory SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "621730": {
    "state": "Tamil Nadu",
    "district": "Ariyalur",
    "block": "Sendurai",
    "officename": "Cement Nagar Dalavoy SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "621801": {
    "state": "Tamil Nadu",
    "district": "Ariyalur",
    "block": "Jayamkondacholapuram",
    "officename": "Andimadam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "621802": {
    "state": "Tamil Nadu",
    "district": "Ariyalur",
    "block": "Udayarpalayam",
    "officename": "Jayamkondacholapuram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "621803": {
    "state": "Tamil Nadu",
    "district": "Ariyalur",
    "block": "Udayarpalayam",
    "officename": "Kallathur Thandalai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "621804": {
    "state": "Tamil Nadu",
    "district": "Ariyalur",
    "block": "Jayamkondacholapuram",
    "officename": "Udayarpalayam SO Ariyalur",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "621805": {
    "state": "Tamil Nadu",
    "district": "Ariyalur",
    "block": "Udayarpalayam",
    "officename": "Varadarajampettai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "621806": {
    "state": "Tamil Nadu",
    "district": "Ariyalur",
    "block": "Jayamkondacholapuram",
    "officename": "Variyankaval SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "621851": {
    "state": "Tamil Nadu",
    "district": "Ariyalur",
    "block": "Ariyalur",
    "officename": "Thirumazhapadi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "622001": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Pudukkottai",
    "officename": "Pudukkottai H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "622002": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Pudukkottai",
    "officename": "Tirugokarnam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "622003": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Pudukkottai",
    "officename": "Rajagopalapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "622004": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Pudukkottai",
    "officename": "Pudukkottai Ind. Estate S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "622005": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Pudukkottai",
    "officename": "Pudukkottai Collectorate S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "622101": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Iluppur",
    "officename": "Annavasal S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "622102": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Illuppur",
    "officename": "Illuppur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "622103": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Iluppur",
    "officename": "Muckanamalaipatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "622104": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Annavasal",
    "officename": "Vayalogam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "622201": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Thirumayam",
    "officename": "Arimalam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "622202": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Tirumayam",
    "officename": "Kilanilai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "622203": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Gandarvakottai",
    "officename": "Perungalur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "622204": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Arantangi",
    "officename": "Yembal S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "622209": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Thirumayam",
    "officename": "Kilanilaikottai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "622301": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Alangudi",
    "officename": "Alangudi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "622302": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Alangudi",
    "officename": "Karambakudi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "622303": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Alangudi",
    "officename": "Tiruvarankulam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "622304": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Alangudi",
    "officename": "Vadakadu S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "622401": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Tirumayam",
    "officename": "Koppanapatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "622402": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Tirumayam",
    "officename": "Kulipirai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "622403": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Thirumayam",
    "officename": "Melasivapuri S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "622404": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Tirumayam",
    "officename": "Nachandupatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "622407": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Tirumayam",
    "officename": "Ponnamaravathy S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "622409": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Tirumayaam",
    "officename": "Rangiem S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "622411": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Thirumayam",
    "officename": "Valayapatti S.O (Pudukkottai)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "622412": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Tirumayam",
    "officename": "Virachilai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "622422": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Thirumayam",
    "officename": "Sivapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "622501": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Kulathur",
    "officename": "Cauvery Nagar S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "622502": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Kulathur",
    "officename": "Keeranur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "622503": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Tirumayam",
    "officename": "Konapet S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "622504": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Kulathur",
    "officename": "Kulathur S.O (Pudukkottai)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "622505": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Thirumayam",
    "officename": "Ramachandrapuram S.O (Pudukkottai)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "622506": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Thirumayam",
    "officename": "Rayavaram S.O (Pudukkottai)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "622507": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Tirumayam",
    "officename": "Tirumayam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "622515": {
    "state": "Tamil Nadu",
    "district": "Pudukkottai",
    "block": "Kulathur",
    "officename": "Mathur Ind. Estate S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Pudukkottai Division"
  },
  "623115": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Kamudhi",
    "officename": "Perunali SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623120": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Kadaladi",
    "officename": "Sayalgudi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623135": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Kadaladi",
    "officename": "Kannirajapuram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623308": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Tiruvadanai",
    "officename": "Mangalakudi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623315": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Tiruvadanai",
    "officename": "Vellayapuram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623401": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Tiruvadanai",
    "officename": "Anandur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623402": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Tiruvadanai",
    "officename": "Chinnakeeramangalam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623403": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Tiruvadanai",
    "officename": "Nambuthalai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623404": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Tiruvadanai",
    "officename": "Pandugudi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623406": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Tiruvadanai",
    "officename": "Sundarapandiapattinam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623407": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Tiruvadanai",
    "officename": "Tiruvadanai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623409": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Tiruvadanai",
    "officename": "Tondi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623501": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Ramanathapuram",
    "officename": "Ramanathapuram HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623502": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Ramanathapuram",
    "officename": "Achunthanvayal SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623503": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Ramanathapuram",
    "officename": "Ramanathapuram Collectorate SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623504": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Ramanathapuram",
    "officename": "Velipattanam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623512": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Ramanathapuram",
    "officename": "Alagankulam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623513": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Ramanathapuram",
    "officename": "Chitharkottai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623514": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Ramanathapuram",
    "officename": "Devipattinam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623515": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Kadaladi",
    "officename": "Ervadi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623516": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Ramanathapuram",
    "officename": "Irumeni SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623517": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Ramanathapuram",
    "officename": "Kilakarai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623518": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Ramanathapuram",
    "officename": "Mandapam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623519": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Ramanathapuram",
    "officename": "Mandapam Camp SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623520": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Ramanathapuram",
    "officename": "Marine Fisheries SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623521": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Rameswaram",
    "officename": "Pamban SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623522": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Ramanathapuram",
    "officename": "Panaikulam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623523": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Ramanathapuram",
    "officename": "Periyapattinam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623524": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Ramanathapuram",
    "officename": "Pudumadam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623525": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Tiruvadanai",
    "officename": "Rajasingamangalam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623526": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Rameswaram",
    "officename": "Rameswaram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623527": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Paramakudi",
    "officename": "Chathirakudi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623528": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Kadaladi",
    "officename": "Sikkal SO Ramanathapuram",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623529": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Rameswaram",
    "officename": "Thangachimadam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623530": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Ramanathapuram",
    "officename": "Toruvalur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623531": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Tiruvadanai",
    "officename": "Tirupalaikudi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623532": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Ramanathapuram",
    "officename": "Thiruppullani SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623533": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Ramanathapuram",
    "officename": "Uthirakosamangai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623534": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Ramanathapuram",
    "officename": "Uchipuli SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623536": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Ramanathapuram",
    "officename": "Perungulam SO Ramanathapuram",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623537": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Tiruvadanai",
    "officename": "Pottagavayal SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623538": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Tiruvadanai",
    "officename": "Sanaveli SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623566": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Kadaladi",
    "officename": "Ervadi Dargha SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623601": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Kamudhi",
    "officename": "Abiramam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623603": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Kamudhi",
    "officename": "Kamudi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623604": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Kamuthi",
    "officename": "Kottaimedu SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623605": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Kamudi",
    "officename": "Mandalamanickam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623608": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Paramakudi",
    "officename": "Parthibanur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623701": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Paramakudi",
    "officename": "Emaneswaram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623703": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Kadaladi",
    "officename": "Kadaladi SO Ramanathapuram",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623704": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Mudukulathur",
    "officename": "Mudukulathur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623705": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Paramakudi",
    "officename": "Nainarkoil SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623706": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Paramakudi",
    "officename": "Pambur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623707": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Paramakudi",
    "officename": "Paramakudi HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623708": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Mudukulathur",
    "officename": "Peraiyur SO Ramanathapuram",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623711": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Mudukulathur",
    "officename": "Teriruveli SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623712": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Mudukulathur",
    "officename": "Tiruvarangam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "623806": {
    "state": "Tamil Nadu",
    "district": "Ramanathapuram",
    "block": "Ramanathapuram",
    "officename": "Sathaksalai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Ramanathapuram Division"
  },
  "624001": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Dindigul HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624002": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Begampur SO Dindigul",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624003": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Nagalnagar SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624004": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Dindigul Collectorate SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624005": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Vedasandur",
    "officename": "Balakrishnapurampudur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624101": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Kodaikanal",
    "officename": "Kodaikanal SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624103": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Kodaikanal",
    "officename": "Kodaikanal Observatory SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624201": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Nilakkottai",
    "officename": "Ammayanaickanur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624202": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Batlagundu SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624204": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Iyyampalayam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624206": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Kodairoad RS SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624208": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Nilakottai HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624210": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Pannaikadu SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624211": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Pattiveeranpatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624212": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Perumbarai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624215": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Nilakkottai",
    "officename": "Silukkuvarpatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624216": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Tandigudi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624219": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Vilampatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624220": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Viruveedu SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624301": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Chinnalapatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624302": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Gandhigram SO Dindigul",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624303": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "NPanjampatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624304": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Sanarpatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624306": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Siluvathur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624307": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Vellodu SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624308": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Vembarpatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624401": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Natham SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624402": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Samudrapatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624403": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Sendurai SO Dindigul",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624601": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Palani HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624610": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Balasamudram SO Dindigul",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624612": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Ambilikai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624613": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Ayakudi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624614": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Chatrapatti SO Dindigul",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624615": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Kalayamputhur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624616": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Kallimandayam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624617": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "KeeranurMA SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624618": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Narikalpatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624619": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Oddanchatram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624620": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Palayam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624621": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Pappampatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624622": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Reddiarchatram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624701": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Attur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624702": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Eriyodu SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624703": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Vedasandur",
    "officename": "Guziliamparai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624704": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Idayakottai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624705": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Kannivadi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624706": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Vedasandur",
    "officename": "Kovilur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624707": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Nilakkottai",
    "officename": "Sembatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624708": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Sithayankottai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624709": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Tadicombu SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624710": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Vedasandur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624711": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Vedasandur",
    "officename": "Kasipalayam SO Dindigul",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624712": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Dindigul",
    "officename": "Markkampatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624801": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Vedasandur",
    "officename": "Ayyalur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "624802": {
    "state": "Tamil Nadu",
    "district": "Dindigul",
    "block": "Vedasandur",
    "officename": "Vadamadurai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Dindigul Division"
  },
  "625001": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Madurai South",
    "officename": "Madurai HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625002": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Madurai North",
    "officename": "Tallakulam HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625003": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Madurai South",
    "officename": "Palanganatham SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625004": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Madurai South",
    "officename": "Pasumalai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625005": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Madurai South",
    "officename": "Thiruparankundram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625006": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Madurai South",
    "officename": "Tirunagar SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625007": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Madurai North",
    "officename": "KPudur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625008": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Madurai South",
    "officename": "Kappalur IndlEstate SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625009": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Madurai North",
    "officename": "Ma Munichalai Road SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625011": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Madurai South",
    "officename": "Subramaniapuram SO Madurai",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625012": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Madurai South",
    "officename": "Avaniapuram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625014": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Madurai North",
    "officename": "Ma Reserve Lines SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625015": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Madurai South",
    "officename": "Thiagarajar Engg College SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625016": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Madurai South",
    "officename": "Arasaradi HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625017": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Madurai North",
    "officename": "Anaiyur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625018": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Madurai North",
    "officename": "Thathaneri SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625019": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Madurai South",
    "officename": "Nagamalai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625020": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Madurai North",
    "officename": "Gandhi Nagar MA SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625021": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Madurai South",
    "officename": "Palkalai Nagar SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625022": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Madurai South",
    "officename": "Postal Training Centre SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625023": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Madurai North",
    "officename": "Madras High Court Madurai Bench SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625101": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Melur",
    "officename": "Karungalakudi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625102": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Melur",
    "officename": "Kilavalavu SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625103": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Melur",
    "officename": "Kottampatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625104": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Melur",
    "officename": "Madurai Agricultural College SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625105": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Melur",
    "officename": "Melavlavu SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625106": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Melur",
    "officename": "Melur SO Madurai",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625107": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Madurai North",
    "officename": "Othakadai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625108": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Melur",
    "officename": "Thumbaipatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625109": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Melur",
    "officename": "Vellalur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625110": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Melur",
    "officename": "Tiruvadur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625122": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Melur",
    "officename": "Therkutheru SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625201": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Madurai South",
    "officename": "Silaiman SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625203": {
    "state": "Tamil Nadu",
    "district": "Theni",
    "block": "Periyakulam",
    "officename": "Genguvarpatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Theni Division"
  },
  "625205": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Vadipatti",
    "officename": "Karupatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625207": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Vadipatti",
    "officename": "Mullipallam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625214": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Vadipatti",
    "officename": "Sholavandan SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625218": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Vadipatti",
    "officename": "Vadipatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625221": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Vadipatti",
    "officename": "Thanichiyam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625234": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Vadipatti",
    "officename": "Tiruvedagam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625301": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Madurai North",
    "officename": "Alagarkoil SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625402": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Madurai North",
    "officename": "Samayanallur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625501": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Vadipatti",
    "officename": "Alanganallur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625503": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Vadipatti",
    "officename": "Palamedu SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625512": {
    "state": "Tamil Nadu",
    "district": "Theni",
    "block": "Andipatti",
    "officename": "Aundipatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Theni Division"
  },
  "625513": {
    "state": "Tamil Nadu",
    "district": "Theni",
    "block": "Bodinayakanur",
    "officename": "Bodinayakanur H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Theni Division"
  },
  "625514": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Thirumangalam",
    "officename": "Checkanurani SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625515": {
    "state": "Tamil Nadu",
    "district": "Theni",
    "block": "Uthamapalayam",
    "officename": "Chinnamanur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Theni Division"
  },
  "625516": {
    "state": "Tamil Nadu",
    "district": "Theni",
    "block": "Uthamapalayam",
    "officename": "Cumbum S.O (Theni)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Theni Division"
  },
  "625517": {
    "state": "Tamil Nadu",
    "district": "Theni",
    "block": "Andipatti",
    "officename": "Gandamanayakanur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Theni Division"
  },
  "625518": {
    "state": "Tamil Nadu",
    "district": "Theni",
    "block": "Uthamapalayam",
    "officename": "Gudalur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Theni Division"
  },
  "625520": {
    "state": "Tamil Nadu",
    "district": "Theni",
    "block": "Periyakulam",
    "officename": "Kamatchipuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Theni Division"
  },
  "625521": {
    "state": "Tamil Nadu",
    "district": "Theni",
    "block": "Uthamapalayam",
    "officename": "Kamayakoundanpatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Theni Division"
  },
  "625522": {
    "state": "Tamil Nadu",
    "district": "Theni",
    "block": "Uthamapalayam",
    "officename": "Kombai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Theni Division"
  },
  "625523": {
    "state": "Tamil Nadu",
    "district": "Theni",
    "block": "Periyakulam",
    "officename": "Lakshmipuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Theni Division"
  },
  "625524": {
    "state": "Tamil Nadu",
    "district": "Theni",
    "block": "Uthamapalayam",
    "officename": "Pannaipuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Theni Division"
  },
  "625525": {
    "state": "Tamil Nadu",
    "district": "Theni",
    "block": "Uthamapalayam",
    "officename": "Periyar Project S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Theni Division"
  },
  "625526": {
    "state": "Tamil Nadu",
    "district": "Theni",
    "block": "Uthamapalayam",
    "officename": "Royappanpatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Theni Division"
  },
  "625527": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Peraiyur",
    "officename": "Sedapatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Theni Division"
  },
  "625528": {
    "state": "Tamil Nadu",
    "district": "Theni",
    "block": "Uthamapalayam",
    "officename": "Sillamarathupatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Theni Division"
  },
  "625529": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Usilampatti",
    "officename": "Sindhupatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Theni Division"
  },
  "625530": {
    "state": "Tamil Nadu",
    "district": "Theni",
    "block": "Uthamapalayam",
    "officename": "Thevaram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Theni Division"
  },
  "625531": {
    "state": "Tamil Nadu",
    "district": "Theni",
    "block": "Theni",
    "officename": "Theni S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Theni Division"
  },
  "625532": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Usilampatti",
    "officename": "Usilampatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Theni Division"
  },
  "625533": {
    "state": "Tamil Nadu",
    "district": "Theni",
    "block": "Uthamapalayam",
    "officename": "Uthamapalayam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Theni Division"
  },
  "625534": {
    "state": "Tamil Nadu",
    "district": "Theni",
    "block": "Bodinayakanur",
    "officename": "Veerapandi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Theni Division"
  },
  "625535": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Peraiyur",
    "officename": "Yelumalai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Theni Division"
  },
  "625536": {
    "state": "Tamil Nadu",
    "district": "Theni",
    "block": "Andipatti",
    "officename": "T.Subbulapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Theni Division"
  },
  "625537": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Usilampatti",
    "officename": "Uthappanayakanur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Theni Division"
  },
  "625540": {
    "state": "Tamil Nadu",
    "district": "Theni",
    "block": "Uthamapalayam",
    "officename": "Odaipatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Theni Division"
  },
  "625556": {
    "state": "Tamil Nadu",
    "district": "Theni",
    "block": "Uthamapalayam",
    "officename": "C.Pudupatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Theni Division"
  },
  "625562": {
    "state": "Tamil Nadu",
    "district": "Theni",
    "block": "Periyakulam",
    "officename": "Varadharajnagar S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Theni Division"
  },
  "625579": {
    "state": "Tamil Nadu",
    "district": "Theni",
    "block": "Aundipatti",
    "officename": "Kadamalaikundu S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Theni Division"
  },
  "625582": {
    "state": "Tamil Nadu",
    "district": "Theni",
    "block": "Bodinayakanur",
    "officename": "Subburajnagar S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Theni Division"
  },
  "625601": {
    "state": "Tamil Nadu",
    "district": "Theni",
    "block": "Periyakulam",
    "officename": "Periyakulam H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Theni Division"
  },
  "625602": {
    "state": "Tamil Nadu",
    "district": "Theni",
    "block": "Periyakulam",
    "officename": "Devadanapatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Theni Division"
  },
  "625603": {
    "state": "Tamil Nadu",
    "district": "Theni",
    "block": "Periyakulam",
    "officename": "Vadugapatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Theni Division"
  },
  "625604": {
    "state": "Tamil Nadu",
    "district": "Theni",
    "block": "Periyakulam",
    "officename": "Periyakulam East S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Theni Division"
  },
  "625605": {
    "state": "Tamil Nadu",
    "district": "Theni",
    "block": "Periyakulam",
    "officename": "Tamarakulam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Theni Division"
  },
  "625701": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Tirumangalam",
    "officename": "Kalligudi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625702": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Tirumangalam",
    "officename": "TKallupatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625703": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Peraiyur",
    "officename": "Peraiyur SO Madurai",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625704": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Thirumangalam",
    "officename": "TPudupatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625705": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Peraiyur",
    "officename": "Saptur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Theni Division"
  },
  "625706": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Tirumangalam",
    "officename": "Tirumangalam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625707": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Tirumangalam",
    "officename": "Villur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "625708": {
    "state": "Tamil Nadu",
    "district": "Madurai",
    "block": "Tirumangalam",
    "officename": "TKunnathur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Madurai Division"
  },
  "626001": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Virudhunagar",
    "officename": "Virudhunagar HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626002": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Virudhunagar",
    "officename": "Virudhunagar Collectorate SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626003": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Virudhunagar",
    "officename": "Virudhunagar Industrial Estate SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626004": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Aruppukkottai",
    "officename": "Palavanatham SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626005": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Virudhunagar",
    "officename": "Amathur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626101": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Aruppukkottai",
    "officename": "Aruppukottai HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626102": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Sattur",
    "officename": "Chatrapatti SO Virudhunagar",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626103": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Sivakasi",
    "officename": "Erichanatham SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626104": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Kariapatti",
    "officename": "Kalkurichi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626105": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Aruppukottai",
    "officename": "Kallurani SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626106": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Kariapatti",
    "officename": "Kariapatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626107": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Aruppukottai",
    "officename": "Kovilangulam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626108": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Rajapalayam",
    "officename": "Kumarasamy Raja Nagar SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626109": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Kariapatti",
    "officename": "Mallanginar SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626110": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Rajapalayam",
    "officename": "Mohamed Sahibpuram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626111": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Rajapalayam",
    "officename": "Muhavur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626112": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Aruppukottai",
    "officename": "Palayampatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626113": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Aruppukottai",
    "officename": "Pandalgudi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626114": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Aruppukottai",
    "officename": "Paralachi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626115": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Kariapatti",
    "officename": "Sethu Institute of Technology SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626116": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Srivilliputhur",
    "officename": "W Pudupatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626117": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Rajapalayam",
    "officename": "Rajapalayam HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626118": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Aruppukkottai",
    "officename": "MReddiapatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626119": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Virudhunagar",
    "officename": "Sankaralingapuram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626121": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Rajapalayam",
    "officename": "Seithur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626122": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Rajapalayam",
    "officename": "Settiyarpatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626123": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Sivakasi",
    "officename": "Sivakasi HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626124": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Sivakasi",
    "officename": "Sivakasi West SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626125": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Srivilliputhur",
    "officename": "Srivilliputhur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626126": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Srivilliputhur",
    "officename": "Sundarapandiam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626127": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Sivakasi",
    "officename": "Tamilnadu Cements Alangulam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626128": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Sivakasi",
    "officename": "Thayilpatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626129": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Aruppukkottai",
    "officename": "Tiruchuli SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626130": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Sivakasi",
    "officename": "Tiruthangal SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626131": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Sivakasi",
    "officename": "Vembakottai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626132": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Srivilliputhur",
    "officename": "Watrap SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626133": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Srivilliputtur",
    "officename": "Kummapatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626134": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Aruppukottai",
    "officename": "Chettikurichi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626135": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Srivilliputhur",
    "officename": "Srivilliputhur Court Complex SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626136": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Rajapalayam",
    "officename": "Kilarajakularaman SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626137": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Srivilliputtur",
    "officename": "Pillayarkulam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626138": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Srivilliputhur",
    "officename": "Kunnur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626139": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Rajapalayam",
    "officename": "Cholapuram South SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626140": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Sattur",
    "officename": "Sevalpatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626141": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Sivakasi",
    "officename": "Malli SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626142": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Rajapalayam",
    "officename": "Sundaranachiarpuram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626149": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Srivilliputtur",
    "officename": "Maharajapuram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626188": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Rajapalayam",
    "officename": "Dhalavaipuram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626189": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Sivakasi",
    "officename": "Sivakasi East SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626201": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Sattur",
    "officename": "Elayirampannai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626202": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Sattur",
    "officename": "Nenmeni SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626203": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Sattur",
    "officename": "Sattur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626204": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Virudhunagar",
    "officename": "Ramasamy Raja Nagar SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626205": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Ettayapuram",
    "officename": "Uppathur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626607": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Tiruchuli",
    "officename": "Narikudi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "626612": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Tiruchuli",
    "officename": "Viracholan SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "627001": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Tirunelveli",
    "officename": "Tirunelveli HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627002": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Palayamkottai",
    "officename": "Palayankottai HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627003": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Palayamkottai",
    "officename": "Vannarpettai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627004": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Tirunelveli",
    "officename": "Tirunelveli Pettai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627005": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Palayamkottai",
    "officename": "Melapalayam SO Tirunelveli",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627006": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Tirunelveli",
    "officename": "Tirunelveli Town SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627007": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Palayamkottai",
    "officename": "Perumalpuram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627008": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Tirunelveli",
    "officename": "Gandhinagar SO Tirunelveli",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627009": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Palayamkottai",
    "officename": "Tirunelveli Collectorate SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627010": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Tirunelveli",
    "officename": "Industrial Colony Pettai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627011": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Palayankottai",
    "officename": "Maharajangar SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627012": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Tirunelveli",
    "officename": "Manonmaniam Sundaranar Univers SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627101": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Nanguneri",
    "officename": "Dalapathisamudram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627102": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Nanguneri",
    "officename": "Dohnavur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627103": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Nanguneri",
    "officename": "Eruvadi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627104": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Radhapuram",
    "officename": "Idindakarai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627105": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Radhapuram",
    "officename": "Kavalkinaru SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627106": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Nanguneri",
    "officename": "Kudankulam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627107": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Nanguneri",
    "officename": "Mavadi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627108": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Nanguneri",
    "officename": "Nanguneri SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627109": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Radhapuram",
    "officename": "Panagudi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627110": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Nanguneri",
    "officename": "Parappadi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627111": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Radhapuram",
    "officename": "Radhapuram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627112": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Radhapuram",
    "officename": "Samugarengapuram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627113": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Radhapuram",
    "officename": "Terkukallikulam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627114": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Radhapuram",
    "officename": "Terkukarungulam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627115": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Nanguneri",
    "officename": "Tirukurungudi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627116": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Radhapuram",
    "officename": "Vadakangulam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627117": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Radhapuram",
    "officename": "Vallioor SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627118": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Nanguneri",
    "officename": "Vijayanarayanam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627119": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Nanguneri",
    "officename": "Vijayanarayanam Naval Base SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627120": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Radhapuram",
    "officename": "Anuvijay Township SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627127": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Radhapuram",
    "officename": "Kuttapuli SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627133": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Radhapuram",
    "officename": "Mahendragiri SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627151": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Nanguneri",
    "officename": "Maruthakulam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627152": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Nenguneri",
    "officename": "Mundradaippu SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627201": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Tirunelveli",
    "officename": "Manur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627202": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Tirunelveli",
    "officename": "Ukkirankottai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627351": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Palayamkottai",
    "officename": "Burkitmanagaram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627352": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Tirunelveli",
    "officename": "Gangaikondan SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627353": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Palayankottai",
    "officename": "Kizhanatham SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627354": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Nanguneri",
    "officename": "Mulaikaraipatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627355": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Nanguneri",
    "officename": "Munanjipatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627356": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Palayamkottai",
    "officename": "Munnirpallam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627357": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Tirunelveli",
    "officename": "Sankarnagar SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627358": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Tirunelveli",
    "officename": "Tachanallur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627359": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Tirunelveli",
    "officename": "Rajavallipuram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627401": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Ambasamudram",
    "officename": "Ambasamudram HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627412": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Ambasamudram",
    "officename": "Alwarkurichi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627413": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Ambasamudram",
    "officename": "Brahmadesam SO Tirunelveli",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627414": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Ambasamudram",
    "officename": "Cheranmahadevi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627415": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Ambasamudram",
    "officename": "Kadayam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627416": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Ambasamudram",
    "officename": "Kallidaikurichi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627417": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Ambasamudram",
    "officename": "Karaikurichi SO Tirunelveli",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627418": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Ambasamudram",
    "officename": "Kila Ambur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627420": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Ambasamudram",
    "officename": "Manjolai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627421": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Ambasamudram",
    "officename": "Manimuthar Project SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627422": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Ambasamudram",
    "officename": "Papanasam Mills SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627423": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Alangulam",
    "officename": "Pottalpudur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627424": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Ambasamudram",
    "officename": "Ravanasamudram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627425": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Ambasamudram",
    "officename": "Vickramasingapuram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627426": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Ambasamudram",
    "officename": "Viravanallur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627427": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Ambasamudram",
    "officename": "Nalumukku SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627428": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Ambasamudram",
    "officename": "Agasthiyarpatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627451": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Ambasamudram",
    "officename": "Gopalasamudram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627452": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Ambasamudram",
    "officename": "Melaseval SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627453": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Ambasamudram",
    "officename": "Pattamadai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627501": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Nanguneri",
    "officename": "Kalakad SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627502": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Nanguneri",
    "officename": "Padmaneri SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627601": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Ambasamudram",
    "officename": "Mukkudal SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627602": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Ambasamudram",
    "officename": "Pappagudi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627603": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Ambasamudram",
    "officename": "Vadakku Ariyanayagipuram Petta SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627604": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Tirunelveli",
    "officename": "Suttamally SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627651": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Radhapuram",
    "officename": "Idayangudi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627652": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Nanguneri",
    "officename": "Ittamozhi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627654": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Radhapuram",
    "officename": "Pettaikulam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627657": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Radhapuram",
    "officename": "Tisayanvillai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tirunelveli Division"
  },
  "627713": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Sankarankovil",
    "officename": "ILAYARASANENDAL S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627719": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Sankarankovil",
    "officename": "Tiruvengadam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627751": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Tenkasi",
    "officename": "Kadayanallur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627753": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Sankarankovil",
    "officename": "Karivalamvandanallur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627754": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Sankarankovil",
    "officename": "Kuruvikulam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627755": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Sivigiri",
    "officename": "Mullikulam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627756": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Sankarankovil",
    "officename": "Sankarankovil H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627757": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Sivagiri",
    "officename": "Sivagiri S.O (Tirunelveli)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627758": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Sivigiri",
    "officename": "Vasudevanallur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627759": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Tenkasi",
    "officename": "Krishnapuram (TVL) S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627760": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Sankarankovil",
    "officename": "Athuvazhi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627761": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Sankarankovil",
    "officename": "Panaiyur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627764": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Sivagiri",
    "officename": "Rayagiri S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627802": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Tenkasi",
    "officename": "Courtallam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627803": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Shenkottai",
    "officename": "Elathur S.O (Tirunelveli)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627804": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Tenkasi",
    "officename": "Idaikal(TKS) S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627805": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Tenkasi",
    "officename": "Ilanji S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627806": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Tenkasi",
    "officename": "Kilapavur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627807": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Sengottai",
    "officename": "Panpuli S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627808": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Alangulam",
    "officename": "Pavoorchatram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627809": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Shenkottai",
    "officename": "Sengottai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627811": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Tenkasi",
    "officename": "Tenkasi H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627812": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Sengottai",
    "officename": "Vadakarai S.O (Tirunelveli)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627813": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Sengottai",
    "officename": "PULIYARAI S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627814": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Tenkasi",
    "officename": "Kizhapuliyur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627818": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Tenkasi",
    "officename": "Melagaram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627851": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Alangulam",
    "officename": "Alangulam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627852": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Tenkasi",
    "officename": "Ayikudi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627853": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Alangulam",
    "officename": "Nallur S.O (Tirunelveli)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627854": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Virakeralampudur",
    "officename": "Nettur S.O (Tirunelveli)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627855": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Sankarankovil",
    "officename": "Puliyangudi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627856": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Tenkasi",
    "officename": "Sambavarvadakarai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627857": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Sankarankovil",
    "officename": "Serndamangalam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627858": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Tenkasi",
    "officename": "SUNDARAPANDIAPURAM",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627859": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Virakeralampudur",
    "officename": "Surandai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627860": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Virakeralampudur",
    "officename": "Uthumalai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627861": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Virakeralampudur",
    "officename": "VIRAKERALAMPUDUR S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627862": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Sankarankovil",
    "officename": "VEERASIGAMANI S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627951": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Alangulam",
    "officename": "Devarkulam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "627953": {
    "state": "Tamil Nadu",
    "district": "Tirunelveli",
    "block": "Virakeralampudur",
    "officename": "MELANILIDANALLUR S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "628001": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Thoothukkudi",
    "officename": "Tuticorin H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628002": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Thoothukkudi",
    "officename": "Melur Tuticorin S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628003": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Thoothukkudi",
    "officename": "Tuticorin courts S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628004": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Thoothukkudi",
    "officename": "Tuticorin Harbour Estate S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628005": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Thoothukkudi",
    "officename": "Muthiahpuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628006": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Thoothukkudi",
    "officename": "Thermal Nagagr S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628007": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Thoothukkudi",
    "officename": "Heavy Water Project Colony S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628008": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Thoothukkudi",
    "officename": "Chidambaranagar S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628101": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Tuticorin",
    "officename": "Korampollam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628102": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Srivaikuntam",
    "officename": "Mudittanendal S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628103": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Tiruchendur",
    "officename": "Pudukottai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628104": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Srivaikuntam",
    "officename": "Sekkarakudi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628105": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Ottapidaram",
    "officename": "Taruvaikulam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628151": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Tiruchendur",
    "officename": "Autoor S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628152": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Tiruchendur",
    "officename": "Pazhaiyalkayal S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628201": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Tiruchendur",
    "officename": "Ammanpuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628202": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Tiruchendur",
    "officename": "Arumuganeri S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628203": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Tiruchendur",
    "officename": "Udangudi Christianagaram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628204": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Tiruchendur",
    "officename": "Kayalpatnam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628205": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Tiruchendur",
    "officename": "Kayamozhi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628206": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Tiruchendur",
    "officename": "Kulasekarapatnam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628207": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Tiruchendur",
    "officename": "Kurumbur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628208": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Tiruchendur",
    "officename": "Manaduthandapathu S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628209": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Tiruchendur",
    "officename": "Manapad S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628210": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Tiruchendur",
    "officename": "Megnanapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628211": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Tiruchendur",
    "officename": "Nalumavadi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628212": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Tiruchendur",
    "officename": "Panickanadarkudiyiruppu S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628213": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Tiruchendur",
    "officename": "Paramankurichi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628215": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Tiruchendur",
    "officename": "Tiruchendur H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628216": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Tiruchendur",
    "officename": "Virapandianpatanam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628217": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Tiruchendur",
    "officename": "Adaikalapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628218": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Tiruchendur",
    "officename": "Mannanvilai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628219": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Tiruchendur",
    "officename": "Vellalanvilai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628229": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Tiruchendur",
    "officename": "Sahupuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628251": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Srivaikuntam",
    "officename": "Sawyerpuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628252": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Srivaikuntam",
    "officename": "Vallanad S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628301": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Thoothukkudi",
    "officename": "Kailasapuram S.O (Tuticorin)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628302": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Ottapidaram",
    "officename": "Ottanatham S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628303": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Ottapidaram",
    "officename": "Naraikinar S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628304": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Tuticorin",
    "officename": "Tattaparai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628401": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Ottapidaram",
    "officename": "Otapidaram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628402": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Otapidaram",
    "officename": "Pudiyamputhur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628501": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Kovilpatti",
    "officename": "Kovilpatti H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "628502": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Kovilpatti",
    "officename": "Lakshmipuram S.O (Tuticorin)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "628503": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Kovilpatti",
    "officename": "K.RAMASAMYNAGAR S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "628552": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Kovilpatti",
    "officename": "Kalugumalai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "628601": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Srivaikuntam",
    "officename": "Srivaikuntam H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628612": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Tiruchendur",
    "officename": "Alwartirunagari S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628613": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Thoothukkudi",
    "officename": "Asirvathapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628614": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Thoothukkudi",
    "officename": "Campbellabad S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628615": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Srivaikuntam",
    "officename": "Karungulam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628616": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Satankulam",
    "officename": "Mukuperi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628617": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Satankulam",
    "officename": "Nazareth S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628618": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Satankulam",
    "officename": "Neivilai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628619": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Srivaikuntam",
    "officename": "Padmanabamangalam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628620": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Srivaikuntam",
    "officename": "Patemanagaram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628621": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Rivaikuntam",
    "officename": "Puthukudi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628622": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Srivaikuntam",
    "officename": "Thathankulam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628623": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Tiruchendur",
    "officename": "Thenthiruperai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628653": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Sathankulam",
    "officename": "Kommadikottai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628656": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Satankulam",
    "officename": "Puthantharuvai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628701": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Sathankulam",
    "officename": "Anandapuram S.O (Tuticorin)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628702": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Sathankulam",
    "officename": "Mudalur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628703": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Sathankulam",
    "officename": "Padukkapathu S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628704": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Sathankulam",
    "officename": "Satankulam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628712": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Otapidaram",
    "officename": "Eppodumvendran S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "628714": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Kovilpatti",
    "officename": "Kadambur S.O (Tuticorin)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "628716": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Kovilpatti",
    "officename": "NALATTINPUTHUR S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "628718": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Otapidaram",
    "officename": "PASUVANTHANAI S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "628720": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Kovilpatti",
    "officename": "Turaiyur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "628721": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Thoothukkudi",
    "officename": "Vanaramutti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "628722": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Ottapidaram",
    "officename": "Kurukkuchalai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "628751": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Srivaikuntam",
    "officename": "Pannaivilai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628752": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Thoothukkudi",
    "officename": "Perungulam S.O (Tuticorin)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628753": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Srivaikuntam",
    "officename": "Sivagalai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628801": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Thoothukkudi",
    "officename": "Eral S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628802": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Srivaikuntam",
    "officename": "Siruthondanallur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628809": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Srivaikuntam",
    "officename": "Seydunganallur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628851": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Srivaikuntam",
    "officename": "Ellanaickenpatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "628901": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Vilathikulam",
    "officename": "Ariyanayagipuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "628902": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Ettayapuram",
    "officename": "Ettaiyapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "628903": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Vilathikulam",
    "officename": "Kulathur (TVL) S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "628904": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Vilathikulam",
    "officename": "Nagalapuram S.O (Tuticorin)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "628905": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Vilathikulam",
    "officename": "Pudur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "628906": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Vilathikulam (kol)",
    "officename": "Vembar S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "628907": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Thoothukkudi",
    "officename": "Vilathikulam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "628908": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Ettayapuram",
    "officename": "Kilairal S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "628952": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Kovilpatti",
    "officename": "Kayathar S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kovilpatti Division"
  },
  "629001": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Agastheeswaram",
    "officename": "Nagercoil H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629002": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Agastheeswaram",
    "officename": "Kottar S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629003": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Agastheeswaram",
    "officename": "Vetturnimadam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629004": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Agastheeswaram",
    "officename": "Nagercoil Industrial Estate S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629101": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Vilavancode",
    "officename": "Kaliyal S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629102": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Kalkulam",
    "officename": "Kodayarkilthangal S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629151": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Kalkulam",
    "officename": "Arumanai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629152": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Vilavancode",
    "officename": "Idaikkode S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629153": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Vilavancode",
    "officename": "Kaliakkavilai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629154": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Vilavancode",
    "officename": "Kanjampuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629155": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Vilavancode",
    "officename": "Kanjiracode S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629156": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Vilavancode",
    "officename": "Kappiyarai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629157": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Vilavancode",
    "officename": "Karinkal S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629158": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Kalkulam",
    "officename": "Kattathurai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629159": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Kalkulam",
    "officename": "Palapalam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629160": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Vilavancode",
    "officename": "Kollangodu S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629161": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Kalkulam",
    "officename": "Kulasekharam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629162": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Vilavancode",
    "officename": "Kappukadu S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629163": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Vilavancode",
    "officename": "Kuzhithurai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629164": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Kalkulam",
    "officename": "Manalikarai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629165": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Vilavancode",
    "officename": "Marthandam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629166": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Kalkulam",
    "officename": "Mekkamandapam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629167": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Kalkulam",
    "officename": "Mulagumoodu S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629168": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Vilavancode",
    "officename": "Pacode S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629169": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Kalkulam",
    "officename": "Palliyadi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629170": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Vilavancode",
    "officename": "Palukal S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629171": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Vilavancode",
    "officename": "Pudukadai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629172": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Vilavancode",
    "officename": "S.T.Mankad S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629173": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Vilavancode",
    "officename": "Thengapattanam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629174": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Kalkulam",
    "officename": "Thiruvithancode S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629175": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Kalkulam",
    "officename": "Thuckalay H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629176": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Vilavancode",
    "officename": "Thuthur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629177": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Kalkulam",
    "officename": "Tiruvattar S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629178": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Vilavancode",
    "officename": "Udayamarthandam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629179": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Vilavancode",
    "officename": "Unnamalakada S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629180": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Kalkulam",
    "officename": "Villukuri S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629193": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Vilavancode",
    "officename": "Keezhkulam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629201": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Agastheeswaram",
    "officename": "Asaripallam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629202": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Kalkulam",
    "officename": "Muttom S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629203": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Kalkulam",
    "officename": "Friday Market S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629204": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Kalkulam",
    "officename": "Ammandivilai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629251": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Kalkulam",
    "officename": "Colachel S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629252": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Kalkulam",
    "officename": "Manavalakurichi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629301": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Agastheeswaram",
    "officename": "Aralvaymoli S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629302": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Thovala",
    "officename": "Thovalai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629401": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Agastheeswaram",
    "officename": "Azhakappapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629402": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Vilavancode",
    "officename": "Marungoor S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629403": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Agasteeswaram",
    "officename": "Mayiladi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629501": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Agastheeswaram",
    "officename": "Eathamozhi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629502": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Agastheeswaram",
    "officename": "Ganapathipuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629601": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Agastheeswaram",
    "officename": "Parakkai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629602": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Agastheeswaram",
    "officename": "Puthalam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629701": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Agastheeswaram",
    "officename": "Agasteeswaram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629702": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Agasteeswaram",
    "officename": "Kanniyakumari S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629703": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Agastheeswaram",
    "officename": "Kottaram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629704": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Agastheeswaram",
    "officename": "Suchindrum S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629801": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Agastheeswaram",
    "officename": "Aloor S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629802": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Kalkulam",
    "officename": "Neyyoor S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629803": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Kalkulam",
    "officename": "Neyyoor West S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629804": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Kalkulam",
    "officename": "Thickanamcode S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629809": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Kalkulam",
    "officename": "Karankad S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629810": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Kalkulam",
    "officename": "Kandanvilai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629851": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Agastheeswaram",
    "officename": "Azhakiapandipuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629852": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Thovala",
    "officename": "Bhoothapandy S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "629901": {
    "state": "Tamil Nadu",
    "district": "Kanyakumari",
    "block": "Thovalai",
    "officename": "Thazhakudy S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Kanniyakumari Division"
  },
  "630001": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Karaikudi",
    "officename": "Karaikudi H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Karaikudi Division"
  },
  "630002": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Karaikudi",
    "officename": "Sekkalai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Karaikudi Division"
  },
  "630003": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Karaikudi",
    "officename": "Alagappapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Karaikudi Division"
  },
  "630005": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Devakottai",
    "officename": "Devakottai Road S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Karaikudi Division"
  },
  "630101": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Karaikudi",
    "officename": "Attangudi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Karaikudi Division"
  },
  "630102": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Karaikudi",
    "officename": "Chettinad S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Karaikudi Division"
  },
  "630103": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Karaikudi",
    "officename": "Kanadukathan S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Karaikudi Division"
  },
  "630104": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Karaikudi",
    "officename": "Kandanur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Karaikudi Division"
  },
  "630105": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Karaikudi",
    "officename": "Kothamangalam S.O (Sivaganga)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Karaikudi Division"
  },
  "630106": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Karaikudi -sakkottai Block",
    "officename": "Kottaiyur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Karaikudi Division"
  },
  "630107": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Karaikudi-sakkottai Block",
    "officename": "Pallattur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Karaikudi Division"
  },
  "630108": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Karaikudi-sakkottaiblock",
    "officename": "Puduvayal S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Karaikudi Division"
  },
  "630201": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Tiruppathur",
    "officename": "A.Thekkur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Karaikudi Division"
  },
  "630202": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Karaikudi",
    "officename": "Ariyakudi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Karaikudi Division"
  },
  "630203": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Tirupattur",
    "officename": "Kandavarayanpatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Sivaganga Division"
  },
  "630204": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Tirupattur",
    "officename": "Kandramanickam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Sivaganga Division"
  },
  "630205": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Tiruppattur",
    "officename": "Kilasevalpatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Karaikudi Division"
  },
  "630206": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Karaikudi-kallal Block",
    "officename": "Kunnakudi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Karaikudi Division"
  },
  "630207": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Tiruppattur",
    "officename": "Nachiapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Karaikudi Division"
  },
  "630208": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Tiruppattur",
    "officename": "O.Siruvayal S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Karaikudi Division"
  },
  "630210": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Sivaganga",
    "officename": "Tirukoshtiyur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Sivaganga Division"
  },
  "630211": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Tirupattur",
    "officename": "Tirupattur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Sivaganga Division"
  },
  "630212": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Tiruppattur",
    "officename": "Viramathi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Karaikudi Division"
  },
  "630301": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Devakottai",
    "officename": "Amaravathipudur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Karaikudi Division"
  },
  "630302": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Devakottai",
    "officename": "Devakottai H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Karaikudi Division"
  },
  "630303": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Devakottai",
    "officename": "Devakottai Extension S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Karaikudi Division"
  },
  "630305": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Devakottai",
    "officename": "Kallal SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Sivaganga Division"
  },
  "630306": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Devakottai",
    "officename": "Kallupatti S.O (Sivaganga)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Karaikudi Division"
  },
  "630307": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Karaikudi-kallal Block",
    "officename": "Managiri S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Karaikudi Division"
  },
  "630309": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Tiruppattur-singampunariblock",
    "officename": "Pulidipatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Karaikudi Division"
  },
  "630311": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Devakottai",
    "officename": "Periyakarai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Karaikudi Division"
  },
  "630312": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Devakottai",
    "officename": "Puliyal S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Karaikudi Division"
  },
  "630313": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Devakottai",
    "officename": "Sembanur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Sivaganga Division"
  },
  "630314": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Devakottai",
    "officename": "Shanmuganathapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Karaikudi Division"
  },
  "630321": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Karaikudi",
    "officename": "Vethiyur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Sivaganga Division"
  },
  "630405": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Tiruppattur",
    "officename": "Nerkuppai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Karaikudi Division"
  },
  "630408": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Devakottai",
    "officename": "Tiruvegampet SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Sivaganga Division"
  },
  "630410": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Tiruppattur-singampunariblock",
    "officename": "Ulagampatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Karaikudi Division"
  },
  "630411": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Devakottai",
    "officename": "Sarakeni SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Sivaganga Division"
  },
  "630501": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Singampunari Block",
    "officename": "CVmangalam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Karaikudi Division"
  },
  "630502": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Tiruppattur-singampunariblock",
    "officename": "Singampunari S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Karaikudi Division"
  },
  "630551": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Sivaganga",
    "officename": "Kalayarkoil SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Sivaganga Division"
  },
  "630552": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Sivaganga",
    "officename": "Kilapungudi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Sivaganga Division"
  },
  "630553": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Sivaganga",
    "officename": "Madagupatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Sivaganga Division"
  },
  "630554": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Sivaganga",
    "officename": "Mangalam SO Sivaganga",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Sivaganga Division"
  },
  "630555": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Sivaganga",
    "officename": "Natarajapuram SO Sivaganga",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Sivaganga Division"
  },
  "630556": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Sivaganga",
    "officename": "Nattarasankottai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Sivaganga Division"
  },
  "630557": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Sivaganga",
    "officename": "Okkur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Sivaganga Division"
  },
  "630558": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Sivaganga",
    "officename": "Paganeri SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Sivaganga Division"
  },
  "630559": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Sivaganga",
    "officename": "Periakottai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Sivaganga Division"
  },
  "630561": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Sivaganga",
    "officename": "Sivaganga HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Sivaganga Division"
  },
  "630562": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Sivaganga",
    "officename": "Sivaganga Collectorate SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Sivaganga Division"
  },
  "630566": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Tirupattur",
    "officename": "Eriyur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Sivaganga Division"
  },
  "630602": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Manamadurai",
    "officename": "Idaikattur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Sivaganga Division"
  },
  "630606": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Manamadurai",
    "officename": "Manamadurai HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Sivaganga Division"
  },
  "630609": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Manamadurai",
    "officename": "Rajagambiram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Sivaganga Division"
  },
  "630610": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Manamadurai",
    "officename": "Tiruppachetti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Sivaganga Division"
  },
  "630611": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Manamadurai",
    "officename": "Tiruppuvanam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Sivaganga Division"
  },
  "630612": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Manamadurai",
    "officename": "Pottapalayam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Sivaganga Division"
  },
  "630702": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Ilayangudi",
    "officename": "Ilayangudi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Sivaganga Division"
  },
  "630709": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Ilayangudi",
    "officename": "Pudur Ilayangudi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Sivaganga Division"
  },
  "630710": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Ilayangudi",
    "officename": "Salaigramam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Sivaganga Division"
  },
  "630713": {
    "state": "Tamil Nadu",
    "district": "Sivaganga",
    "block": "Ilayangudi",
    "officename": "Suranam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Sivaganga Division"
  },
  "631001": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Arakkonam",
    "officename": "Arakkonam HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "631002": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Arakkonam",
    "officename": "Palanipet SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "631003": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Arakkonam",
    "officename": "Jothinagar SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "631004": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Arakonam",
    "officename": "Ekhunagar SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "631005": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Arakonam",
    "officename": "Winterpet SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "631006": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Arakonam",
    "officename": "Ins Rajali SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "631051": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Arakkonam",
    "officename": "Namali SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "631052": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Arakkonam",
    "officename": "Panapakkam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "631101": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Arakonam",
    "officename": "Guruvarajpet SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "631102": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Arakkonam",
    "officename": "Sholingur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "631151": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Arakkonam",
    "officename": "Takkolam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "631152": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Arakkonam",
    "officename": "Suraksha Cisf Campus SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "631201": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Tirutani",
    "officename": "Arungolam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "631202": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Tirutani",
    "officename": "Athimanjeripeta S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "631203": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Tiruvallur",
    "officename": "Kadambathur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "631204": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Tiruttani",
    "officename": "Kanakammachatram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "631205": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Tiruttani",
    "officename": "Kg Kandigai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "631206": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Pallipat",
    "officename": "Madduru S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "631207": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Pallipat",
    "officename": "Pallipat S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "631208": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Pallipat",
    "officename": "Podaturpeta S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "631209": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Tiruttani",
    "officename": "Tiruttani S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "631210": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Tirutani",
    "officename": "Tiruvelangadu S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "631211": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Tirutani",
    "officename": "Saraswathinagar S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "631212": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Tirutani",
    "officename": "Poonimangadu S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "631213": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Trutani",
    "officename": "Ponpadi Rs S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "631301": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Pallipat",
    "officename": "Ammavarikuppam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "631302": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Pallipat",
    "officename": "Erumbi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "631303": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Pallipat",
    "officename": "Ramakrishnarajupeta S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "631304": {
    "state": "Tamil Nadu",
    "district": "Tiruvallur",
    "block": "Pallipat",
    "officename": "Vanganur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "631402": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Sriperumbudur",
    "officename": "Perambakkam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "631501": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Kancheepuram",
    "officename": "Kanchipuram H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "631502": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Kanchipuram",
    "officename": "Big Kanchipuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "631551": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Kancheepuram",
    "officename": "Balchettychatram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "631552": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Kanchipuram",
    "officename": "Karaipettai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "631553": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Sriperumbudur",
    "officename": "Edayarpakkam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "631561": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Kanchipuram",
    "officename": "Enathur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "631601": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Kanchipuram",
    "officename": "Ayyampettai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "631603": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Kanchipuram",
    "officename": "Magaral S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "631604": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Sriperumbudur",
    "officename": "Thenneri S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "631605": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Kanchipuram",
    "officename": "Walajabad S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "631606": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Sriperumbudur",
    "officename": "Palayaseevaram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "631701": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Vandavasi",
    "officename": "Akkur SO Tiruvannamalai",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "631702": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Cheyyar",
    "officename": "Mamandur Kanchipuram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "632001": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Vellore",
    "officename": "Vellore H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Vellore Division"
  },
  "632002": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Vellore",
    "officename": "Thorapadi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Vellore Division"
  },
  "632004": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Vellore",
    "officename": "Vellore Fort S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Vellore Division"
  },
  "632006": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Vellore",
    "officename": "Gandhinagar S.O (Vellore)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Vellore Division"
  },
  "632007": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Vlr",
    "officename": "Katpadi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Vellore Division"
  },
  "632008": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Vellore",
    "officename": "Shenbakkam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Vellore Division"
  },
  "632009": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Vellore",
    "officename": "Sathuvachari S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Vellore Division"
  },
  "632010": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Vellore",
    "officename": "Abdullapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Vellore Division"
  },
  "632011": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Vlr",
    "officename": "T.B. Sanatorium S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Vellore Division"
  },
  "632012": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Vellore",
    "officename": "Saidapet S.O (Vellore)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Vellore Division"
  },
  "632013": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Vlr",
    "officename": "Konavattam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Vellore Division"
  },
  "632014": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Katpadi",
    "officename": "Vellore Institute Of Technology S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Vellore Division"
  },
  "632055": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Vellore",
    "officename": "Ariyur S.O (Vellore)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Vellore Division"
  },
  "632057": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Vellore",
    "officename": "Munjurpattu S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Vellore Division"
  },
  "632058": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Vellore",
    "officename": "Pennathur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Vellore Division"
  },
  "632059": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Vlr",
    "officename": "TAMILNADU INDUSTRIAL EXPLOSIVES LTD",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Vellore Division"
  },
  "632101": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Vlr",
    "officename": "Anaikattu S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Vellore Division"
  },
  "632102": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Vlr",
    "officename": "Kaniyambadi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Vellore Division"
  },
  "632103": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Vlr",
    "officename": "Odugathur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Vellore Division"
  },
  "632104": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Vlr",
    "officename": "Virinjipuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Vellore Division"
  },
  "632105": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Vlr",
    "officename": "Ussoor S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Vellore Division"
  },
  "632106": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Katpadi",
    "officename": "S.L.R. Sanatorium S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Vellore Division"
  },
  "632107": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Vlr",
    "officename": "Guruvarajapalayam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Vellore Division"
  },
  "632113": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Vlr",
    "officename": "Cholavaram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Vellore Division"
  },
  "632114": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Vlr",
    "officename": "Sathyamangalam (Vellore)S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Vellore Division"
  },
  "632115": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Katpadi",
    "officename": "Thiruvalluvar University S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Vellore Division"
  },
  "632201": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Katpadi",
    "officename": "Kilvayathinankuppam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "632202": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Katpadi",
    "officename": "Latteri S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Vellore Division"
  },
  "632203": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Katpadi",
    "officename": "Melmayil S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "632204": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Katpadi",
    "officename": "Vaduganthangal S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Vellore Division"
  },
  "632209": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Katpadi",
    "officename": "Ruhsa Campus S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "632301": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Arni",
    "officename": "Arni HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "632311": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Arni",
    "officename": "Kannamangalam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "632312": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Vellore",
    "officename": "Kattukanur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "632313": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Vandavasi",
    "officename": "Kolappalur SO Tiruvannamalai",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "632314": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Arni",
    "officename": "Kunnathur Arni SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "632315": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Arni",
    "officename": "Onnupuram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "632316": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Arni",
    "officename": "Chevur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "632317": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Vandavasi",
    "officename": "Sathiyaviziyanagaram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "632318": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Arcot",
    "officename": "Valapandal SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "632319": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Vellore",
    "officename": "Kammavanpettai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "632326": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Polur",
    "officename": "Susainagar SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "632401": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Walajapet",
    "officename": "Ranipet HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "632403": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Walajapet",
    "officename": "Ranipet Industrial Estate SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "632404": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Walajapet",
    "officename": "Karai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "632405": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Walajapet",
    "officename": "Mukundarayapuram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "632406": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Walajapet",
    "officename": "Bhel Ranipet SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "632501": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Wallajah",
    "officename": "Ammoor SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "632502": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Arakkonam",
    "officename": "Anvardhikhanpet SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "632503": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Arcot",
    "officename": "Arcot SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "632504": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Arcot",
    "officename": "Damarapakkam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "632505": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Arakkonam",
    "officename": "Banavaram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "632506": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Arcot",
    "officename": "Kalavai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "632507": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Arcot",
    "officename": "Kavanur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "632508": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Walajapet",
    "officename": "Kaveripak SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "632509": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Walajapet",
    "officename": "Melvisharam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "632510": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Arakkonam",
    "officename": "Minnal SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "632511": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Arcot",
    "officename": "Sakkaramallur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "632512": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Arcot",
    "officename": "Timiri SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "632513": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Walajapet",
    "officename": "Walajapet SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "632514": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Katpadi",
    "officename": "Ponnai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "632515": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Walajapet",
    "officename": "Tiruvalam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "632516": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Katpadi",
    "officename": "Vennampalle SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "632517": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Walajapet",
    "officename": "Ratnagiri Kilminnal SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "632518": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Arakonam",
    "officename": "Pennagar SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "632519": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Walajapet",
    "officename": "Vellore Sugar Mills SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "632520": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Wallajah",
    "officename": "Melpadi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "632521": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Arcot",
    "officename": "Vilapakkam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "632531": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Arakkonam",
    "officename": "Ocheri SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Arakkonam Division"
  },
  "632601": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Gudiyatham",
    "officename": "Dharanampet S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "632602": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Gudiyatham",
    "officename": "Gudiyattam H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "632603": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Gudiyattam",
    "officename": "Paradarami S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "632604": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Gudiyattam",
    "officename": "Erthangal S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "635001": {
    "state": "Tamil Nadu",
    "district": "Krishnagiri",
    "block": "Krishnagiri",
    "officename": "Krishnagiri H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Krishnagiri Division"
  },
  "635002": {
    "state": "Tamil Nadu",
    "district": "Krishnagiri",
    "block": "Krishnagiri",
    "officename": "Krishnagiri Indl. Estate S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Krishnagiri Division"
  },
  "635101": {
    "state": "Tamil Nadu",
    "district": "Krishnagiri",
    "block": "Krishnagiri",
    "officename": "Krishnagiri Project S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Krishnagiri Division"
  },
  "635102": {
    "state": "Tamil Nadu",
    "district": "Krishnagiri",
    "block": "Denkanikotta",
    "officename": "Anchetty S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Krishnagiri Division"
  },
  "635103": {
    "state": "Tamil Nadu",
    "district": "Krishnagiri",
    "block": "Hosur",
    "officename": "Bagalur S.O (Krishnagiri)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Krishnagiri Division"
  },
  "635104": {
    "state": "Tamil Nadu",
    "district": "Krishnagiri",
    "block": "Krishnagiri",
    "officename": "Barugur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Krishnagiri Division"
  },
  "635105": {
    "state": "Tamil Nadu",
    "district": "Krishnagiri",
    "block": "Hosur",
    "officename": "Berigai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Krishnagiri Division"
  },
  "635106": {
    "state": "Tamil Nadu",
    "district": "Krishnagiri",
    "block": "Krishnagiri",
    "officename": "Chaparthi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Krishnagiri Division"
  },
  "635107": {
    "state": "Tamil Nadu",
    "district": "Krishnagiri",
    "block": "Denkanikotta",
    "officename": "Denkanikotta S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Krishnagiri Division"
  },
  "635108": {
    "state": "Tamil Nadu",
    "district": "Krishnagiri",
    "block": "Krishnagiri",
    "officename": "Elathagiri S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Krishnagiri Division"
  },
  "635109": {
    "state": "Tamil Nadu",
    "district": "Krishnagiri",
    "block": "Hosur",
    "officename": "Hosur S.O (Dharmapuri)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Krishnagiri Division"
  },
  "635110": {
    "state": "Tamil Nadu",
    "district": "Krishnagiri",
    "block": "Hosur",
    "officename": "Hosur Cattle Farm S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Krishnagiri Division"
  },
  "635111": {
    "state": "Tamil Nadu",
    "district": "Dharmapuri",
    "block": "Palakkodu",
    "officename": "Karimangalam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Krishnagiri Division"
  },
  "635112": {
    "state": "Tamil Nadu",
    "district": "Krishnagiri",
    "block": "Krishnagiri",
    "officename": "Kaveripattinam S.O (Krishnagiri)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Krishnagiri Division"
  },
  "635113": {
    "state": "Tamil Nadu",
    "district": "Krishnagiri",
    "block": "Denkanikotta",
    "officename": "Kelamangalam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Krishnagiri Division"
  },
  "635114": {
    "state": "Tamil Nadu",
    "district": "Krishnagiri",
    "block": "Hosur",
    "officename": "Mathagondapalli S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Krishnagiri Division"
  },
  "635115": {
    "state": "Tamil Nadu",
    "district": "Krishnagiri",
    "block": "Krishnagiri",
    "officename": "Ramapuram S.O (Dharmapuri)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Krishnagiri Division"
  },
  "635116": {
    "state": "Tamil Nadu",
    "district": "Krishnagiri",
    "block": "Denkanikottai",
    "officename": "Royakottah S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Krishnagiri Division"
  },
  "635117": {
    "state": "Tamil Nadu",
    "district": "Krishnagiri",
    "block": "Hosur",
    "officename": "Shoolagiri S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Krishnagiri Division"
  },
  "635118": {
    "state": "Tamil Nadu",
    "district": "Krishnagiri",
    "block": "Denkanikotta",
    "officename": "Thally S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Krishnagiri Division"
  },
  "635119": {
    "state": "Tamil Nadu",
    "district": "Krishnagiri",
    "block": "Hosur",
    "officename": "Uddanapalli S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Krishnagiri Division"
  },
  "635120": {
    "state": "Tamil Nadu",
    "district": "Krishnagiri",
    "block": "Krishnagiri",
    "officename": "Varattanapalli S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Krishnagiri Division"
  },
  "635121": {
    "state": "Tamil Nadu",
    "district": "Krishnagiri",
    "block": "Krishnagiri",
    "officename": "Veppanapalli S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Krishnagiri Division"
  },
  "635122": {
    "state": "Tamil Nadu",
    "district": "Krishnagiri",
    "block": "Krishnagiri",
    "officename": "Alapatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Krishnagiri Division"
  },
  "635123": {
    "state": "Tamil Nadu",
    "district": "Krishnagiri",
    "block": "Pochampalli",
    "officename": "Pannandur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Krishnagiri Division"
  },
  "635124": {
    "state": "Tamil Nadu",
    "district": "Krishnagiri",
    "block": "Hosur",
    "officename": "Belathur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Krishnagiri Division"
  },
  "635126": {
    "state": "Tamil Nadu",
    "district": "Krishnagiri",
    "block": "Hosur",
    "officename": "Hosur Indl. Complex S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Krishnagiri Division"
  },
  "635201": {
    "state": "Tamil Nadu",
    "district": "Dharmapuri",
    "block": "Krishnagiri",
    "officename": "Barur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Dharmapuri Division"
  },
  "635202": {
    "state": "Tamil Nadu",
    "district": "Dharmapuri",
    "block": "Harur",
    "officename": "Kambainallore S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Dharmapuri Division"
  },
  "635203": {
    "state": "Tamil Nadu",
    "district": "Krishnagiri",
    "block": "Pochampalli",
    "officename": "Mathur S.O (Dharmapuri)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Krishnagiri Division"
  },
  "635204": {
    "state": "Tamil Nadu",
    "district": "Krishnagiri",
    "block": "Pochampalli",
    "officename": "Nagarasampatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Krishnagiri Division"
  },
  "635205": {
    "state": "Tamil Nadu",
    "district": "Dharmapuri",
    "block": "Dharmapuri",
    "officename": "Periyanahalli S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Dharmapuri Division"
  },
  "635206": {
    "state": "Tamil Nadu",
    "district": "Krishnagiri",
    "block": "Pochampalli",
    "officename": "Pochampalli S.O (Krishnagiri)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Krishnagiri Division"
  },
  "635207": {
    "state": "Tamil Nadu",
    "district": "Krishnagiri",
    "block": "Uttangarai",
    "officename": "Uttangarai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Krishnagiri Division"
  },
  "635301": {
    "state": "Tamil Nadu",
    "district": "Dharmapuri",
    "block": "Dharmapuri",
    "officename": "Bommidi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Dharmapuri Division"
  },
  "635302": {
    "state": "Tamil Nadu",
    "district": "Dharmapuri",
    "block": "Dharmapuri",
    "officename": "Buddireddipatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Dharmapuri Division"
  },
  "635303": {
    "state": "Tamil Nadu",
    "district": "Dharmapuri",
    "block": "Pappireddipatti",
    "officename": "Kadathur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Dharmapuri Division"
  },
  "635304": {
    "state": "Tamil Nadu",
    "district": "Krishnagiri",
    "block": "Uttangarai",
    "officename": "Kallavi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Krishnagiri Division"
  },
  "635305": {
    "state": "Tamil Nadu",
    "district": "Dharmapuri",
    "block": "Harur",
    "officename": "Morappur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Dharmapuri Division"
  },
  "635306": {
    "state": "Tamil Nadu",
    "district": "Krishnagiri",
    "block": "Uttangarai",
    "officename": "Samalpatti R.S S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Krishnagiri Division"
  },
  "635307": {
    "state": "Tamil Nadu",
    "district": "Krishnagiri",
    "block": "Uttangarai",
    "officename": "Singarapettai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Krishnagiri Division"
  },
  "635601": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Tirupathur",
    "officename": "Tirupattur H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "635602": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Tirupathur",
    "officename": "Tirupattur Bazaar S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "635651": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Tirupattur",
    "officename": "Pudupettai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "635652": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Tirupattur",
    "officename": "Vishamangalam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "635653": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Tirupathur",
    "officename": "Vengalapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "635654": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Tirupattur",
    "officename": "Sundarampalli S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "635655": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Tirupathur",
    "officename": "Matrapalli S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "635701": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Vaniyambadi",
    "officename": "Alangayam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "635702": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Tirupattur",
    "officename": "Andiappanur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "635703": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Polur",
    "officename": "Jamanamarathur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "635710": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Vaniyambadi",
    "officename": "Mittur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "635751": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Vaniyambadi",
    "officename": "Vaniyambadi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "635752": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Vaniyambadi",
    "officename": "Newtown Vaniyambadi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "635754": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Vaniyambadi",
    "officename": "Jaffarabad S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "635801": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Tirupattur",
    "officename": "Ambalur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "635802": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Vaniyambadi",
    "officename": "Ambur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "635803": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Gudiyatham",
    "officename": "Gudiyattam RS S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "635804": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Vaniyambadi",
    "officename": "Madanur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "635805": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Gudiyattam",
    "officename": "Mailpatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "635806": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Gudiyattam",
    "officename": "Melalathur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "635807": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Vaniyambadi",
    "officename": "Minnur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "635808": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Gudiyatham",
    "officename": "Oomerabad S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "635809": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Katpadi",
    "officename": "Pallikonda S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "635810": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Gudiyattam",
    "officename": "Pernambut S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "635811": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Vaniyambadi",
    "officename": "Thuthipattu S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "635812": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Vaniyambadi",
    "officename": "Vadapudupet S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "635813": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Gudiyattam",
    "officename": "Valathoor S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "635814": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Vaniyambadi",
    "officename": "Shanankuppam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "635815": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Tirupattur",
    "officename": "Kethandapatti Sugar Mills S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "635851": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Tirupathur",
    "officename": "Jolarpettai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "635852": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Tirupathur",
    "officename": "Natrampalli S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "635853": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Tirupattur",
    "officename": "Pakkirithakka S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "635854": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Tirupattur",
    "officename": "Pachur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "635901": {
    "state": "Tamil Nadu",
    "district": "Vellore",
    "block": "Tirupattur",
    "officename": "Kandili S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupattur Division"
  },
  "636001": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Salem",
    "officename": "Salem H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636002": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Salem",
    "officename": "Shevapet S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636003": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Salem",
    "officename": "Ammapettai Salem S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636004": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Salem",
    "officename": "Alagapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636005": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Salem",
    "officename": "Suramangalam H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "636006": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Salem",
    "officename": "Salem South S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636007": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Salem",
    "officename": "Hasthampatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636008": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Salem",
    "officename": "Kannankurichi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636009": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Salem",
    "officename": "Leigh Bazaar S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "636010": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Salem",
    "officename": "Kondalampatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636011": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Salem",
    "officename": "Periyar University S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "636012": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Omalur",
    "officename": "Karuppur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "636013": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Salem",
    "officename": "Salem Steel Plant S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "636014": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Salem",
    "officename": "Kamaraj Nagar Colony S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636015": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Salem",
    "officename": "Kitchipalayam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636016": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Salem",
    "officename": "Fairlands S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636030": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Salem",
    "officename": "Mohan Nagar S.O (Salem)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "636101": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Atur",
    "officename": "Aragalur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636102": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Atur",
    "officename": "Atur H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636103": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Salem",
    "officename": "Ayodhiyapattinam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636104": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Salem",
    "officename": "Belur S.O (Salem)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636105": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Gangavalli",
    "officename": "Gangavalli S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636106": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Salem",
    "officename": "Karipatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636107": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Atur",
    "officename": "Malliakarai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636108": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Atur",
    "officename": "Narasingapuram S.O (Salem)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636109": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Atur",
    "officename": "Pethanaickenpalayam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636110": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Gangavalli",
    "officename": "Sendarapatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636111": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Valapady",
    "officename": "Seshanchavadi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636112": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Atur",
    "officename": "Talaivasal S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636113": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Gangavalli",
    "officename": "Thammampatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636114": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Atur",
    "officename": "Thumbal S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636115": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Valapady",
    "officename": "Valapady S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636116": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Atur",
    "officename": "Viraganur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636117": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Attur",
    "officename": "Yethapur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636118": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Rasipuram",
    "officename": "Ulipuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636119": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Atur",
    "officename": "Puthiragoundampalayam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636121": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Atur",
    "officename": "Vadachennimalai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636122": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Salem",
    "officename": "Sukkampatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636138": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Salem",
    "officename": "Karumanthurai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636139": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Salem",
    "officename": "Koottathupatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636140": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Salem",
    "officename": "Odayapatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636141": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Atur",
    "officename": "Pudupet S.O(ATUR)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636142": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Attur",
    "officename": "Mullukurichi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636201": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Salem",
    "officename": "Dasanaickenpatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636202": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Rasipuram",
    "officename": "Mangalapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "636203": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Salem",
    "officename": "Mullur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636204": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Salem",
    "officename": "Panamarathupatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636301": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Rasipuram",
    "officename": "Attanur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "636302": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Salem",
    "officename": "Jagir Ammapalayam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "636303": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Mettur",
    "officename": "Kolathur (Salem)S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "636304": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Salem",
    "officename": "Muthunaickenpatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "636305": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Omalur",
    "officename": "Pannapatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "636306": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Edappadi",
    "officename": "Sinnappampatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "636307": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Salem",
    "officename": "Sivadapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "636308": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Salem",
    "officename": "Veerapandi Salem S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636309": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Omalur",
    "officename": "Kamalapuram S.O (Salem)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "636351": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Omalur",
    "officename": "Kadayampatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "636352": {
    "state": "Tamil Nadu",
    "district": "Dharmapuri",
    "block": "Dharmapuri",
    "officename": "Thoppur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Dharmapuri Division"
  },
  "636354": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Omalur",
    "officename": "Danishpet S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "636401": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Mettur",
    "officename": "Metturdam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "636402": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Mettur",
    "officename": "Metturdam RS S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "636403": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Mettur",
    "officename": "Raman Nagar S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "636404": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Mettur",
    "officename": "Gonur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "636406": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Mettur",
    "officename": "Mettur Thermal Project S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "636451": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Mettur",
    "officename": "Chamrajpet S.O (Salem)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "636452": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Mettur",
    "officename": "Madayankuttai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "636453": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Mettur",
    "officename": "Mecheri S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "636454": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Mettur",
    "officename": "Nangavalli S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "636455": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Omalur",
    "officename": "Omalur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "636456": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Mettur",
    "officename": "Salem Camp S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "636457": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Mettur",
    "officename": "Vanavasi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "636458": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Mettur",
    "officename": "Mallikundam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "636501": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Mettur",
    "officename": "Jalakantapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "636502": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Omalur",
    "officename": "Tharamangalam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "636503": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Omalur",
    "officename": "Tholasampatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "636601": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Yercaud",
    "officename": "Yercaud S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636602": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Yercaud",
    "officename": "Ondikadai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636701": {
    "state": "Tamil Nadu",
    "district": "Dharmapuri",
    "block": "Dharmapuri",
    "officename": "Dharmapuri H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Dharmapuri Division"
  },
  "636704": {
    "state": "Tamil Nadu",
    "district": "Dharmapuri",
    "block": "Dharmapuri",
    "officename": "Annasagaram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Dharmapuri Division"
  },
  "636705": {
    "state": "Tamil Nadu",
    "district": "Dharmapuri",
    "block": "Dharmapuri",
    "officename": "Dharmapuri Collectorate S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Dharmapuri Division"
  },
  "636803": {
    "state": "Tamil Nadu",
    "district": "Dharmapuri",
    "block": "Pennagaram",
    "officename": "Indur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Dharmapuri Division"
  },
  "636804": {
    "state": "Tamil Nadu",
    "district": "Dharmapuri",
    "block": "Dharmapuri",
    "officename": "Laligam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Dharmapuri Division"
  },
  "636805": {
    "state": "Tamil Nadu",
    "district": "Dharmapuri",
    "block": "Pennagaram",
    "officename": "Mallupatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Dharmapuri Division"
  },
  "636806": {
    "state": "Tamil Nadu",
    "district": "Dharmapuri",
    "block": "Palakkodu",
    "officename": "Marandahalli S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Dharmapuri Division"
  },
  "636807": {
    "state": "Tamil Nadu",
    "district": "Dharmapuri",
    "block": "Dharmapuri",
    "officename": "Nallampalli S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Dharmapuri Division"
  },
  "636808": {
    "state": "Tamil Nadu",
    "district": "Dharmapuri",
    "block": "Palacode",
    "officename": "Palacode S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Dharmapuri Division"
  },
  "636809": {
    "state": "Tamil Nadu",
    "district": "Dharmapuri",
    "block": "Pennagaram",
    "officename": "Paupparapatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Dharmapuri Division"
  },
  "636810": {
    "state": "Tamil Nadu",
    "district": "Dharmapuri",
    "block": "Pennagaram",
    "officename": "Pennagaram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Dharmapuri Division"
  },
  "636811": {
    "state": "Tamil Nadu",
    "district": "Dharmapuri",
    "block": "Pennagaram",
    "officename": "Perumbalai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Dharmapuri Division"
  },
  "636812": {
    "state": "Tamil Nadu",
    "district": "Dharmapuri",
    "block": "Palacode",
    "officename": "Thumjepalli B.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Dharmapuri Division"
  },
  "636813": {
    "state": "Tamil Nadu",
    "district": "Dharmapuri",
    "block": "Pennagaram",
    "officename": "Biliyanur Agraharam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Dharmapuri Division"
  },
  "636902": {
    "state": "Tamil Nadu",
    "district": "Dharmapuri",
    "block": "Harur",
    "officename": "Eachambadi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Dharmapuri Division"
  },
  "636903": {
    "state": "Tamil Nadu",
    "district": "Dharmapuri",
    "block": "Harur",
    "officename": "Harur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Dharmapuri Division"
  },
  "636904": {
    "state": "Tamil Nadu",
    "district": "Dharmapuri",
    "block": "Pappireddipatti",
    "officename": "Menisi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Dharmapuri Division"
  },
  "636905": {
    "state": "Tamil Nadu",
    "district": "Dharmapuri",
    "block": "Pappireddipatti",
    "officename": "Pappireddipatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Dharmapuri Division"
  },
  "636906": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Atur",
    "officename": "Tirtamalai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Dharmapuri Division"
  },
  "637001": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Namakkal",
    "officename": "Namakkal H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637002": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Namakkal",
    "officename": "Ganesapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637003": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Namakkal",
    "officename": "Nallipalayam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637013": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Namakkal",
    "officename": "Erampatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637014": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Namakkal",
    "officename": "Karaikurichi S.O (Namakkal)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637015": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Namakkal",
    "officename": "Mohanur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637017": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Namakkal",
    "officename": "Palapatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637018": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Namakkal",
    "officename": "Puduchatram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637019": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Namakkal",
    "officename": "Sellappampatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637020": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Namakkal",
    "officename": "Valayapatti S.O (Namakkal)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637021": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Namakkal",
    "officename": "Varagur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637101": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Tiruchengode",
    "officename": "Idappadi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637102": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Idappadi",
    "officename": "Konganapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637103": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Sankari",
    "officename": "Mc Donalds Choultry S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637104": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Sankari",
    "officename": "Thevur S.O (Namakkal)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637105": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Tiruchengode",
    "officename": "Vellandivalasai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637107": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Tiruchengode",
    "officename": "Poolampatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637201": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Tiruchengodu",
    "officename": "Chittalandur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637202": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Tiruchengodu",
    "officename": "Elachipalayam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637203": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Tiruchengode",
    "officename": "Kandampalayam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637204": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Paramthi Velur",
    "officename": "Kapilamalai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637205": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Tiruchengodu",
    "officename": "Kumaramangalam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637206": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Paramathi Velur",
    "officename": "Nadandai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637207": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Namakkal",
    "officename": "Paramathi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637208": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Paramathi-Velur",
    "officename": "Paundamangalam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637209": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Tiruchengodu",
    "officename": "Seetharamapalayam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637210": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Tiruchengodu",
    "officename": "Solasiramani S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637211": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Tiruchengodu",
    "officename": "Tiruchengodu H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637212": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Namakkal",
    "officename": "Velagoundampatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637213": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Paramathi-Velur",
    "officename": "Jedarpalayam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637214": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Tiruchengodu",
    "officename": "Koottapalli S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637215": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Tiruchengode",
    "officename": "Kuchipalayam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637301": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Tiruchengode",
    "officename": "Sankaridrug S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637302": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Sankari",
    "officename": "Sankaridrug.R.S S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637303": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Sankari",
    "officename": "Sankari West S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637304": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Tiruchengodu",
    "officename": "Thannirpandalpalayam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637401": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Rasipuram",
    "officename": "Andagalur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "637402": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Namakkal",
    "officename": "Belukurichi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637403": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Rasipuram",
    "officename": "Gurusamipalayam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "637404": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Namakkal",
    "officename": "Kalappanaickenpatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637405": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Namakkal",
    "officename": "Muthugapatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637406": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Rasipuram",
    "officename": "Namagiripettai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "637407": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Rasipuram",
    "officename": "Pudupatti S.O (Salem)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "637408": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Rasipuram",
    "officename": "Rasipuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "637409": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Namakkal",
    "officename": "Sendamangalam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637410": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Tiruchengode",
    "officename": "Vaiyappamalai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637411": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Namakkal",
    "officename": "Semmedu S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637412": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Rasipuram",
    "officename": "Singalandapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "637501": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Salem",
    "officename": "Attayampatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "637502": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Salem",
    "officename": "Elampillai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "637503": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Rasipuram",
    "officename": "Mallasamudram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637504": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Salem",
    "officename": "Vembadithalam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "637505": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Rasipuram",
    "officename": "Vennandur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem West Division"
  },
  "638001": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Erode",
    "officename": "Erode HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638002": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Erode",
    "officename": "Erode Railway Colony SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638003": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Erode",
    "officename": "Karungalpalayam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638004": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Erode",
    "officename": "Veerappanchatram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638005": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Erode",
    "officename": "Peria Agraharam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638006": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Namakkal",
    "officename": "Pallipalayam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638007": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Namakkal",
    "officename": "Cauvery Railway Station SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638008": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Tiruchengode",
    "officename": "Pallipalayamagraharam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "638009": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Erode",
    "officename": "Surampatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638010": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Namakkal",
    "officename": "SPB Colony SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638011": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Erode",
    "officename": "Erode Collectorate SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638012": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Erode",
    "officename": "Thindal SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638051": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Erode",
    "officename": "Chennimalai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638052": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Erode",
    "officename": "Perundurai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638053": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Perundurai",
    "officename": "Perundurai Sanitorium SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638054": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Erode",
    "officename": "Siruvalur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638055": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Perundurai",
    "officename": "Tingalur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638056": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Perundurai",
    "officename": "Vijayamangalam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638057": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Perundurai",
    "officename": "Tudupathi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638101": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Erode",
    "officename": "Arachalur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638102": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Erode",
    "officename": "Chittode SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638103": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Erode",
    "officename": "Kunnathur SO Erode",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638104": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Erode",
    "officename": "Modakurichi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638105": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Dharapuram",
    "officename": "Muthur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "638106": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Dharapuram",
    "officename": "Mulanur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "638107": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Erode",
    "officename": "Nasiyanur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638108": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Kangayam",
    "officename": "Nathakadayur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "638109": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Erode",
    "officename": "Sivagiri SO Erode",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638110": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Gobichettipalayam",
    "officename": "Getticheyur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638111": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Kangeyam",
    "officename": "Vellakoil SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "638112": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Perundurai",
    "officename": "Vadamugam Vellode SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638115": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Erode",
    "officename": "Avalpundurai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638116": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Perundurai",
    "officename": "Kanjikovil SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638151": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Erode",
    "officename": "Kodumudi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638152": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Erode",
    "officename": "Unjalur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638153": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Erode",
    "officename": "Ganapathipalayam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638154": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Erode",
    "officename": "Pasur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638181": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Paramathi-Velur",
    "officename": "Pothanur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "638182": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Paramathi-Velur",
    "officename": "Velur (Namakkal) S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "638183": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Tiruchengode",
    "officename": "Komarapalayam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "638301": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Erode",
    "officename": "Bhavani HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638311": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Bhavani",
    "officename": "Ammapettai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638312": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Bhavani",
    "officename": "Jambai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638313": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Erode",
    "officename": "Kugalur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638314": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Erode",
    "officename": "Olagadam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638315": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Bhavani",
    "officename": "Sakthinagar SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638316": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Erode",
    "officename": "Vasavi College SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638401": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Sathyamangalam",
    "officename": "Sathyamangalam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "638402": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Sathyamangalam",
    "officename": "Rangasamudram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "638451": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Sathyamangalam",
    "officename": "Bhavanisagar SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "638452": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Erode",
    "officename": "Gobichettipalayam HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638453": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Erode",
    "officename": "Karattadipalayam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638454": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Erode",
    "officename": "Kasipalayam SO Erode",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638455": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Erode",
    "officename": "Kavindapadi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638456": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Gobichettipalayam",
    "officename": "Kolappalur SO Erode",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638457": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Gobichettipalayam",
    "officename": "Kurumandur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638458": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Gobichettipalayam",
    "officename": "Nambiyur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638459": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Sathy",
    "officename": "Punjai Puliampatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "638460": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Namakkal",
    "officename": "Savakattupalayam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "638461": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Sathy",
    "officename": "Talavadi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "638462": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Erode",
    "officename": "Vemandampalayam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638476": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Gobichettipalayam",
    "officename": "Gobichettipalayam South SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638501": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Bhavani",
    "officename": "Anthiyur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638502": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Bhavani",
    "officename": "Athani SO Erode",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638503": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Gobichettipalayam",
    "officename": "Dasappagoundenpudur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638504": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Erode",
    "officename": "Guruvareddiyur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638505": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Gobichettipalayam",
    "officename": "Kallipatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638506": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Erode",
    "officename": "Thuckanaickenpalayam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638656": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Dharapuram",
    "officename": "Dharapuram HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "638657": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Dharapuram",
    "officename": "Ellisnagar SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "638660": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Kangayam",
    "officename": "Koduvoi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "638661": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Dharapuram",
    "officename": "Kolathupalayam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "638672": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Dharapuram",
    "officename": "Dalavoipatnam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "638673": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Dharapuram",
    "officename": "Kolinjivadi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "638701": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Kangayam",
    "officename": "Kangayam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "638702": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Namakkal",
    "officename": "Kundadam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "638703": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Dharapuram",
    "officename": "Udhiyur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "638706": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Namakkal",
    "officename": "Sankarandampalayam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "638751": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Perundurai",
    "officename": "Uttukuli SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638752": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Erode",
    "officename": "Uttukuli Rs SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "638812": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Perundurai",
    "officename": "Chengapalli SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "639001": {
    "state": "Tamil Nadu",
    "district": "Karur",
    "block": "Karur",
    "officename": "Karur H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "639002": {
    "state": "Tamil Nadu",
    "district": "Karur",
    "block": "Aravakurichi",
    "officename": "Sengunthapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "639003": {
    "state": "Tamil Nadu",
    "district": "Karur",
    "block": "Karur",
    "officename": "Tirumanilaiyur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "639004": {
    "state": "Tamil Nadu",
    "district": "Karur",
    "block": "Karur",
    "officename": "Pasupathipalayam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "639005": {
    "state": "Tamil Nadu",
    "district": "Karur",
    "block": "Karur",
    "officename": "Thanthonimalai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "639006": {
    "state": "Tamil Nadu",
    "district": "Karur",
    "block": "Karur",
    "officename": "Vengamedu S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "639007": {
    "state": "Tamil Nadu",
    "district": "Karur",
    "block": "Karur",
    "officename": "Karur Collectorate S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "639008": {
    "state": "Tamil Nadu",
    "district": "Karur",
    "block": "Karur",
    "officename": "Andankoil S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "639101": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Tiruchirappalli",
    "officename": "Andanallur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "639102": {
    "state": "Tamil Nadu",
    "district": "Karur",
    "block": "Krishnarayapuram",
    "officename": "Krishnarayapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "639103": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Srirangam",
    "officename": "Kulumani SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "639104": {
    "state": "Tamil Nadu",
    "district": "Karur",
    "block": "Kulittalai",
    "officename": "Kulittalai H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "639105": {
    "state": "Tamil Nadu",
    "district": "Karur",
    "block": "Krishnarayapuram",
    "officename": "Lalapet S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "639107": {
    "state": "Tamil Nadu",
    "district": "Karur",
    "block": "Kulithalai",
    "officename": "Marudur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "639108": {
    "state": "Tamil Nadu",
    "district": "Karur",
    "block": "Karur",
    "officename": "Mayanur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "639109": {
    "state": "Tamil Nadu",
    "district": "Karur",
    "block": "Aravakurichi",
    "officename": "Moolapatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "639110": {
    "state": "Tamil Nadu",
    "district": "Karur",
    "block": "Kulittalai",
    "officename": "Nungavaram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "639111": {
    "state": "Tamil Nadu",
    "district": "Karur",
    "block": "Aravakurichi",
    "officename": "Paramathi (Karur) S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "639112": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Tiruchirappalli",
    "officename": "Pettavaithalai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "639113": {
    "state": "Tamil Nadu",
    "district": "Karur",
    "block": "Karur",
    "officename": "Pugalur Sugar Factory S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "639114": {
    "state": "Tamil Nadu",
    "district": "Karur",
    "block": "Karur",
    "officename": "Puliyur Cement Factory S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "639115": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Tiruchirappalli",
    "officename": "Tirupparaithurai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "639116": {
    "state": "Tamil Nadu",
    "district": "Karur",
    "block": "Karur",
    "officename": "Vangal S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "639117": {
    "state": "Tamil Nadu",
    "district": "Karur",
    "block": "Karur",
    "officename": "Velayuthampalayam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "639118": {
    "state": "Tamil Nadu",
    "district": "Karur",
    "block": "Karur",
    "officename": "Velliyanai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "639119": {
    "state": "Tamil Nadu",
    "district": "Karur",
    "block": "Kulittalai",
    "officename": "Panjapatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "639120": {
    "state": "Tamil Nadu",
    "district": "Karur",
    "block": "Kulittalai",
    "officename": "Vaiganallur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "639136": {
    "state": "Tamil Nadu",
    "district": "Karur",
    "block": "Karur",
    "officename": "Kagtithapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "639201": {
    "state": "Tamil Nadu",
    "district": "Karur",
    "block": "Aravakurichi",
    "officename": "Aravakurichi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "639202": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Dharapuram",
    "officename": "Chinnadharapuram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "639203": {
    "state": "Tamil Nadu",
    "district": "Karur",
    "block": "Aravakurichi",
    "officename": "Isanatham S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "639205": {
    "state": "Tamil Nadu",
    "district": "Karur",
    "block": "Aravakurichi",
    "officename": "Pallapatti S.O (Karur)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "639206": {
    "state": "Tamil Nadu",
    "district": "Karur",
    "block": "Aravakurichi",
    "officename": "Tennilai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "639207": {
    "state": "Tamil Nadu",
    "district": "Karur",
    "block": "Aravakurichi",
    "officename": "Pallapatti Bazaar S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Karur Division"
  },
  "641001": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore South",
    "officename": "Coimbatore HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641002": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore South",
    "officename": "Rathinasabapathy Puram HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641003": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore South",
    "officename": "Lawley Road SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641004": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore South",
    "officename": "Peelamedu SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641005": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore South",
    "officename": "Singanallur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641006": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore North",
    "officename": "Ganapathy SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641007": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore South",
    "officename": "SBInstitute SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641008": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore South",
    "officename": "Kuniamuthur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641009": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore South",
    "officename": "Ramnagar Coimbatore SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641010": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore South",
    "officename": "Perur SO Coimbatore",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641011": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore North",
    "officename": "Saibaba Mission SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641012": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore South",
    "officename": "Tatabad SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641013": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore South",
    "officename": "GovtCollege Of Technology SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641014": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore South",
    "officename": "Coimbatore Aerodrome SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641015": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore South",
    "officename": "Uppilipalayam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641016": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore South",
    "officename": "Ondipudur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641017": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore North",
    "officename": "Vadamadurai Kurudampalayam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641018": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore South",
    "officename": "Coimbatore Central SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641019": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore North",
    "officename": "Coimbatore Press Colony SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641020": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore North",
    "officename": "Sri Ramakrishna Vidyalaya SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641021": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore South",
    "officename": "Coimbatore Industrial Estate SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641022": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore North",
    "officename": "NGGO Colony SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641023": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore South",
    "officename": "Podanur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641024": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore South",
    "officename": "Sundarapuram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641025": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore North",
    "officename": "Velandipalayam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641026": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore South",
    "officename": "Komarapalayam Coimbatore SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641027": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore North",
    "officename": "Rathinapuri SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641028": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore South",
    "officename": "Sowripalayam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641029": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore North",
    "officename": "Gnanambika Mills SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641030": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore North",
    "officename": "Kavundampalayam Colony SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641031": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore North",
    "officename": "Narasimhanaickenpalayam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641032": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore South",
    "officename": "Othakkalmandapam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641033": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore South",
    "officename": "Neelikonampalayam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641034": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore North",
    "officename": "Tudiyalur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641035": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore North",
    "officename": "Saravanampatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641036": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore South",
    "officename": "Nanjundapuram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641037": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore South",
    "officename": "Pappanaickenpalayam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641038": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore North",
    "officename": "Kuppakonanpudur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641039": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore South",
    "officename": "Telungupalayam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641041": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore North",
    "officename": "Pappanaickenpudur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641042": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore South",
    "officename": "Kovaipudur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641043": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore North",
    "officename": "Sahs College SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641044": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore South",
    "officename": "Siddhapudur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641045": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore South",
    "officename": "Ramanathapuram Coimbatore SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641046": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore North",
    "officename": "Bharathiyar University SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641047": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore North",
    "officename": "Jothipuram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641048": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore South",
    "officename": "Kalapatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641049": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore North",
    "officename": "Chinnavedampatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641050": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore",
    "officename": "Malumichampatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641062": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore South",
    "officename": "Sinniampalayam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641101": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore North",
    "officename": "Alandurai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641103": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Mettupalayam",
    "officename": "Irugur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "641104": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Mettupalayam",
    "officename": "Karamadai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "641105": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore South",
    "officename": "Madukkarai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641107": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore South",
    "officename": "Sarkarsamakulam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641108": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore North",
    "officename": "Tadagam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641109": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore North",
    "officename": "Thondamuthur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641110": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore North",
    "officename": "Vaiyampalayam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641111": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore South",
    "officename": "Vellalore SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641112": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore South",
    "officename": "Amritanagar SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641113": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Mettupalayam",
    "officename": "Seeliyur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "641114": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Madhavapuram",
    "officename": "Karunyanagar SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641201": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore South",
    "officename": "Chettipalayam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641202": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Pollachi",
    "officename": "Vadasithur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "641301": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Mettupalayam",
    "officename": "Mettupalayam HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "641302": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Mettupalayam",
    "officename": "Sirumugai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "641305": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Mettupalayam",
    "officename": "Mahadevapuram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "641401": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Palladam",
    "officename": "Kangayampalayam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "641402": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Palladam",
    "officename": "Sulur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "641407": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Palladam",
    "officename": "Arasur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "641601": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Avanashi",
    "officename": "Tirupur HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "641602": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Tiruppur",
    "officename": "Tirupur North SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "641603": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Tiruppur",
    "officename": "Gandhinagar SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "641604": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Tiruppur",
    "officename": "Tirupur Cotton Market SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "641605": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Kangayam",
    "officename": "Veerapandi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "641606": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Tiruppur",
    "officename": "Vijayapuram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "641607": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Tirupur",
    "officename": "Tirupur East SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "641652": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Tiruppur",
    "officename": "Anuppapalayam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "641653": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Avanashi",
    "officename": "Annur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "641654": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Avanashi",
    "officename": "Avanashi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "641655": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Avanashi",
    "officename": "Cheyur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "641658": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Palladam",
    "officename": "Karadibavi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "641659": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Mettupalayam",
    "officename": "Karumathampatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "641662": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Palladam",
    "officename": "Kuppusamynaidupuram SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "641663": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Palladam",
    "officename": "Mangalam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "641664": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Palladam",
    "officename": "Palladam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "641665": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Avanashi",
    "officename": "Pallikalipalayam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "641666": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Tirupur",
    "officename": "Perumanallur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "641667": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Palladam",
    "officename": "Pongalur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "641668": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Palladam",
    "officename": "Somanur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "641669": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Palladam",
    "officename": "Sultanpet SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "641670": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Avanashi",
    "officename": "Karavalur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "641671": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Palladam",
    "officename": "Kettanur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "641687": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Tiruppur",
    "officename": "Iduvampalayam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "641697": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Mettupalayam",
    "officename": "Pogalur SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Tirupur Division"
  },
  "642001": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Pollachi",
    "officename": "Pollachi H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642002": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Pollachi",
    "officename": "Mahalinga Puram S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642003": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Pollachi",
    "officename": "Makkinaicken Patti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642004": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Pollachi",
    "officename": "Uthukuli Zamin S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642005": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Pollachi",
    "officename": "Zamin Muthur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642006": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Pollachi",
    "officename": "Suleeswaran Patti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642007": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Pollachi",
    "officename": "Angalakurichi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642101": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Pollachi",
    "officename": "Aliyar Nagar S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642102": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Udamalpet",
    "officename": "Amaravathi Nagar S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642103": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Pollachi",
    "officename": "Ambarampalayam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642104": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Pollachi",
    "officename": "Anaimalai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642105": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Valparai",
    "officename": "Water Falls Estate S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642106": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Valparai",
    "officename": "Cinchona S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642107": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Udamalpet",
    "officename": "Gomangalam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642108": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Valparai",
    "officename": "Iyerpadi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642109": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Pollachi",
    "officename": "Kinathukadavoo S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642110": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Pollachi",
    "officename": "Kovilpalayam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642111": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Udumalaipettai",
    "officename": "Krishnapuram S.O (Coimbatore)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642112": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Udamalpet",
    "officename": "Kurichikottai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642113": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Udamalpet",
    "officename": "Madathukulam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642114": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Pollachi",
    "officename": "Malayandipattinam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642117": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Valparai",
    "officename": "Mudis S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642120": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Pollachi",
    "officename": "Negamam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642122": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Udamalpet",
    "officename": "Pulankinar S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642123": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Pollachi",
    "officename": "Samathur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642125": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Valparai",
    "officename": "Sholayar Nagar S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642126": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Udumalaipettai",
    "officename": "Udamalpet H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642127": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Valparai",
    "officename": "Valparai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642128": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Udumalaipettai",
    "officename": "Venkatesa Mills S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642129": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Pollachi",
    "officename": "Vettaikaran Pudur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642130": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Valparai",
    "officename": "Karamalai Bazaar S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642132": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Udamalpet",
    "officename": "Valavadi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642133": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Udumalaipettai",
    "officename": "Sethumadai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642134": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Pollachi",
    "officename": "Somandurai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642154": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Udamalpet",
    "officename": "Gandhinagar S.O (Pollachi)",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642201": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Udamalpet",
    "officename": "Gudimangalam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642202": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Pollachi",
    "officename": "Jakkarpalayam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642203": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Udamalpet",
    "officename": "Kaniyur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642204": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Udamalpet",
    "officename": "Komaralingam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642205": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Udamalpet",
    "officename": "Pedappampatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642206": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Udamalpet",
    "officename": "Pulavadi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "642207": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Udaamalpet",
    "officename": "Pungamuthur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Pollachi Division"
  },
  "643001": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Udhagamandalam",
    "officename": "Udagamandalam H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643002": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Udhagamandalam",
    "officename": "Stone House Hill S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643003": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Udhagamandalam",
    "officename": "Lovedale S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643004": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Udhagamandalam",
    "officename": "Fernhill S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643005": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Udhagamandalam",
    "officename": "Indunagar S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643006": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Udhagamandalam",
    "officename": "Finger Post S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643007": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Udhagamandalam",
    "officename": "Dr. Basuviah Nagar S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643101": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Coonoor",
    "officename": "Coonoor H.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643102": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Coonoor",
    "officename": "Coonoor RS S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643103": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Kotagiri",
    "officename": "Pasteur Institute S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643105": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Coonoor",
    "officename": "Ottupattarai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643201": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Kotagiri",
    "officename": "Aravenu S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643202": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Coonoor",
    "officename": "Aruvankadu S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643203": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Coonoor",
    "officename": "Balacola S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643204": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Udhagamandalam",
    "officename": "Chamraj Estate S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643205": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Gudalur",
    "officename": "Cherambadi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643206": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Udhagamandalam",
    "officename": "Denaducombai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643207": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Gudalur",
    "officename": "Devarshola S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643209": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Kundah",
    "officename": "Emerald S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643211": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Gudalur",
    "officename": "Gudalur Nilgiris S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643212": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Gudalur",
    "officename": "Gudalur Bazaar S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643213": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Coonoor",
    "officename": "Katary S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643214": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Kotagiri",
    "officename": "Kattabettu S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643215": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Coonoor",
    "officename": "Ketti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643216": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Kotagiri",
    "officename": "Kil Kotagiri S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643217": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Kotagiri",
    "officename": "Kotagiri S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643218": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Coonoor",
    "officename": "Kullakamby S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643219": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Kundah",
    "officename": "Kundah Bridge S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643220": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Gudalur",
    "officename": "Mangorange S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643221": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Coonoor",
    "officename": "Melur Nilgiris S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643223": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Udagamandalam",
    "officename": "Masinagudi S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643224": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Gudalur",
    "officename": "Naduvattam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643225": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Gudalur",
    "officename": "Nellakotta S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643226": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Gudalur",
    "officename": "Newhope S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643231": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Coonoor",
    "officename": "Wellington S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643233": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Pandalur",
    "officename": "Pandalur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643236": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Coonoor",
    "officename": "Kotada Estate S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643237": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Udhagamandalam",
    "officename": "Sandynallah S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643238": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Coonoor",
    "officename": "Nonsuch S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643239": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Pandalur",
    "officename": "Konnachal S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643240": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Gudalur",
    "officename": "Bitherkad S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643241": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Gudalur",
    "officename": "Uppatti S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643242": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Kotagiri",
    "officename": "Tuttapallam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643243": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Udhagamandalam",
    "officename": "Yellanhalli S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "643253": {
    "state": "Tamil Nadu",
    "district": "Nilgiris",
    "block": "Gudalur",
    "officename": "Kolapalli S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "670001": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Kannur",
    "officename": "Kannur HO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670002": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Kannur",
    "officename": "Civil Station Kannur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670003": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Kannur",
    "officename": "Kannur City SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670004": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Kannur",
    "officename": "Pallikunnu SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670005": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Kannur",
    "officename": "Kakkat SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670006": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Kannur",
    "officename": "Chovva SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670007": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Kannur",
    "officename": "Thottada SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670008": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Kannur",
    "officename": "Alavil SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670009": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Kannur",
    "officename": "Azhikode SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670010": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Kannur",
    "officename": "Valapattanam SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670011": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Kannur",
    "officename": "Chirakkal SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670012": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Kannur",
    "officename": "Kannur Thana SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670013": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Kannur",
    "officename": "Burnacherry SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670014": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Kannur",
    "officename": "Chalad SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670017": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Kannur",
    "officename": "Kannur District Hospital SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670018": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Kannur",
    "officename": "Thazhe Chovva SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670101": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalassery",
    "officename": "Thalassery HO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "670102": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalassery",
    "officename": "Temple Gate SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "670103": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalassery",
    "officename": "Tiruvangad SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "670104": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalassery",
    "officename": "Cherakkara SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "670105": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalassery",
    "officename": "Nettur SO Kannur",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "670106": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalasery",
    "officename": "Dharmadam SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "670107": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalassery",
    "officename": "Eranholi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "670141": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Taliparamba",
    "officename": "Taliparamba HO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670142": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Taliparamba",
    "officename": "Karimbam SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670143": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Taliparamba",
    "officename": "Pattuvam SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670301": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Kannur",
    "officename": "Cherukunnu SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670302": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Kannur",
    "officename": "Mattul SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670303": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Taliaparamba",
    "officename": "Payangadi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670304": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Taliparamba",
    "officename": "Madayi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670305": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Taliparamba",
    "officename": "Vengarakannur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670306": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Kannur",
    "officename": "Mathamangalam Bazar SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670307": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Taliparamba",
    "officename": "Payyanur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670308": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Taliparamba",
    "officename": "Ramanthali SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670309": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Taliparamba",
    "officename": "Kunhimangalam SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670310": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Taliparamba",
    "officename": "Ezhimala Naval Academy SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670325": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Kannur",
    "officename": "Mattul North SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670327": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Kannur",
    "officename": "Edat SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670331": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Kannur",
    "officename": "Mottammal SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670334": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Kannur",
    "officename": "Ezhome SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670353": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Taliparamba",
    "officename": "CRPF Camp Aravanchal SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670358": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Kannur",
    "officename": "Payangadi R S SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670501": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Taliparamba",
    "officename": "Mandurkannur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670502": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Taliparamba",
    "officename": "Pariyaramkannur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670503": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Kannur",
    "officename": "Kannur Government Medical College SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670504": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Taliparamba",
    "officename": "Pilathara SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670511": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Taliparamba",
    "officename": "Cherupuzha SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670521": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Taliparamba",
    "officename": "Karivellur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670561": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Kannur",
    "officename": "Pappinisseri SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670562": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Kannur",
    "officename": "Kalliasseri SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670563": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Taliparamba",
    "officename": "Parassinikadavu SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670567": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Kannur",
    "officename": "Kannur University Campus SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670571": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Taliparamba",
    "officename": "Alakode SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670581": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Taliparamba",
    "officename": "Chepparapadava SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670582": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Taliparamba",
    "officename": "Naduvil SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670591": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Kannur",
    "officename": "Eachur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670592": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Taliparamba",
    "officename": "Koodali SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670593": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Taliparamba",
    "officename": "Irukkur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670594": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Kannur",
    "officename": "Varam SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670595": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalassery",
    "officename": "Edayannur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670601": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Taliparamba",
    "officename": "Kolacherry SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670602": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Taliparamba",
    "officename": "Mayyil SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670604": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Taliparamba",
    "officename": "Kannadiparamba SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670611": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Kannur",
    "officename": "Mamba SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670612": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalassery",
    "officename": "Anjarakandy SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670613": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Kannur",
    "officename": "Mowancheri SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670621": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Kannur",
    "officename": "Kadachira SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670622": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Kannur",
    "officename": "Mundalur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670631": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Taliparamba",
    "officename": "Sreekandapuram SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670632": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Taliparamba",
    "officename": "Chemperi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670633": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Taliparamba",
    "officename": "Payyavur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670641": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalassery",
    "officename": "Ponniam West SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "670642": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalassery",
    "officename": "Kadirurtly SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "670643": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalassery",
    "officename": "Kuthuparamba SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "670644": {
    "state": "Kerala",
    "district": "Wayanad",
    "block": "Mananthavady",
    "officename": "Thalappuzha SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "670645": {
    "state": "Kerala",
    "district": "Wayanad",
    "block": "Mananthavady",
    "officename": "Mananthavady SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "670646": {
    "state": "Kerala",
    "district": "Wayanad",
    "block": "Mananthavady",
    "officename": "Kartikulam SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "670649": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalassery",
    "officename": "Ummenchira SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "670650": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalassery",
    "officename": "Chittariparamba SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "670651": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalassery",
    "officename": "Kottiyur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "670661": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalassery",
    "officename": "Palayad SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "670662": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalassery",
    "officename": "Muzhappilangad SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "670663": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Kannur",
    "officename": "Etakkad SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "670671": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalassery",
    "officename": "Paral SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "670672": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalassery",
    "officename": "Chokli SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "670673": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalassery",
    "officename": "Peravoor SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "670674": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalassery",
    "officename": "Kelakam SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "670675": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalassery",
    "officename": "Peringathur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "670676": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalassery",
    "officename": "Kadavathur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "670691": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalassery",
    "officename": "Pathayakunnu SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "670692": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalassery",
    "officename": "Panoor SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "670693": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalassery",
    "officename": "Thuvakunnu SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "670694": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalassery",
    "officename": "Champad SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "670701": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalasseery",
    "officename": "Nirmalagiri SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "670702": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalassery",
    "officename": "Mattanur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "670703": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalassery",
    "officename": "Iritty SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "670704": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalassery",
    "officename": "Payam SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "670705": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Taliparamba",
    "officename": "Ulikkal SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "670706": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalassery",
    "officename": "Kiliyanthara SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "670721": {
    "state": "Kerala",
    "district": "Wayanad",
    "block": "Mananthavady",
    "officename": "Panamaram SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "670731": {
    "state": "Kerala",
    "district": "Wayanad",
    "block": "Mananthavady",
    "officename": "Vellamunda SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "670741": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalasery",
    "officename": "Pinarayi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "671121": {
    "state": "Kerala",
    "district": "Kasargod",
    "block": "Kasaragod",
    "officename": "Kasaragod HO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Kasaragod Division"
  },
  "671122": {
    "state": "Kerala",
    "district": "Kasargod",
    "block": "Kasaragod",
    "officename": "Talangara SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Kasaragod Division"
  },
  "671123": {
    "state": "Kerala",
    "district": "Kasargod",
    "block": "Kasaragod",
    "officename": "Vidyanagar SO Kasargod",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Kasaragod Division"
  },
  "671124": {
    "state": "Kerala",
    "district": "Kasargod",
    "block": "Kasaragod",
    "officename": "Kudlu SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Kasaragod Division"
  },
  "671310": {
    "state": "Kerala",
    "district": "Kasargod",
    "block": "Hosdurg",
    "officename": "Trikarpur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Kasaragod Division"
  },
  "671311": {
    "state": "Kerala",
    "district": "Kasargod",
    "block": "Hosdurg",
    "officename": "Elambachi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Kasaragod Division"
  },
  "671312": {
    "state": "Kerala",
    "district": "Kasargod",
    "block": "Hosdurg",
    "officename": "Padne SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Kasaragod Division"
  },
  "671313": {
    "state": "Kerala",
    "district": "Kasargod",
    "block": "Hosdurg",
    "officename": "Chervathur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Kasaragod Division"
  },
  "671314": {
    "state": "Kerala",
    "district": "Kasargod",
    "block": "Hosdurg",
    "officename": "Nileshwar SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Kasaragod Division"
  },
  "671315": {
    "state": "Kerala",
    "district": "Kasargod",
    "block": "Hosdurg",
    "officename": "Kanhangad HO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Kasaragod Division"
  },
  "671316": {
    "state": "Kerala",
    "district": "Kasargod",
    "block": "Hosdurg",
    "officename": "Bekal Fort SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Kasaragod Division"
  },
  "671317": {
    "state": "Kerala",
    "district": "Kasargod",
    "block": "Kasaragod",
    "officename": "Kalnad SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Kasaragod Division"
  },
  "671318": {
    "state": "Kerala",
    "district": "Kasargod",
    "block": "Hosdurg",
    "officename": "Bekal SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Kasaragod Division"
  },
  "671319": {
    "state": "Kerala",
    "district": "Kasargod",
    "block": "Hosdurg",
    "officename": "Udma SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Kasaragod Division"
  },
  "671321": {
    "state": "Kerala",
    "district": "Kasargod",
    "block": "Kasaragod",
    "officename": "Kumbla SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Kasaragod Division"
  },
  "671322": {
    "state": "Kerala",
    "district": "Kasargod",
    "block": "Kasaragod",
    "officename": "Uppala SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Kasaragod Division"
  },
  "671323": {
    "state": "Kerala",
    "district": "Kasargod",
    "block": "Kasaragod",
    "officename": "Manjeshwar SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Kasaragod Division"
  },
  "671324": {
    "state": "Kerala",
    "district": "Kasargod",
    "block": "Kasaragod",
    "officename": "Mangalpady SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Kasaragod Division"
  },
  "671326": {
    "state": "Kerala",
    "district": "Kasargod",
    "block": "Hosdurg",
    "officename": "Chittarikkal SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Kasaragod Division"
  },
  "671348": {
    "state": "Kerala",
    "district": "Kasargod",
    "block": "Kasaragod",
    "officename": "Paivalike SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Kasaragod Division"
  },
  "671351": {
    "state": "Kerala",
    "district": "Kasargod",
    "block": "Hosdurg",
    "officename": "Thuruthi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Kasaragod Division"
  },
  "671531": {
    "state": "Kerala",
    "district": "Kasargod",
    "block": "Hosdurg",
    "officename": "Anandashrama SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Kasaragod Division"
  },
  "671532": {
    "state": "Kerala",
    "district": "Kasargod",
    "block": "Hosdurg",
    "officename": "Rajapuram SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Kasaragod Division"
  },
  "671533": {
    "state": "Kerala",
    "district": "Kasargod",
    "block": "Hosdurg",
    "officename": "Parappa SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Kasaragod Division"
  },
  "671541": {
    "state": "Kerala",
    "district": "Kasargod",
    "block": "Kasaragod",
    "officename": "Changala SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Kasaragod Division"
  },
  "671542": {
    "state": "Kerala",
    "district": "Kasargod",
    "block": "Kasaragod",
    "officename": "Muliyar SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Kasaragod Division"
  },
  "671543": {
    "state": "Kerala",
    "district": "Kasargod",
    "block": "Kasaragod",
    "officename": "Mulleria SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Kasaragod Division"
  },
  "671551": {
    "state": "Kerala",
    "district": "Kasargod",
    "block": "Kasaragod",
    "officename": "Perdala SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Kasaragod Division"
  },
  "671552": {
    "state": "Kerala",
    "district": "Kasargod",
    "block": "Kasaragod",
    "officename": "Perla SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Kasaragod Division"
  },
  "673001": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Calicut HO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673002": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Chalapuram SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673003": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Kallaikozhikode SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673004": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Puthiyara SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673005": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "West Hill SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673006": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Eranhipalam SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673007": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Mankavu SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673008": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Calicut Medical College SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673009": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Malaparamba SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673010": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Karaparamba SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673011": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Nadakavu SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673012": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Marikunnu SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673014": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Guruvayurappan College SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673015": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Beypore SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673016": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Kuthiravattom SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673017": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Chevayur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673018": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Calicut Arts  Science College SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673019": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Pantheerankavu SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673020": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Calicut Civil Station HO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673021": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Puthiyangadi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673027": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Nallalam SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673028": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Arakinar SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673029": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Tiruvannur Nada SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673032": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Calicut Beach SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673101": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Vadakara",
    "officename": "Vadakara HO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673102": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Vadakara",
    "officename": "Madappalli College SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673103": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Vadakara",
    "officename": "Vadakara Beach SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673104": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Vadakara",
    "officename": "Nut Street SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673105": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Vadakara",
    "officename": "Puduppanam SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673106": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Vadakara",
    "officename": "Chorode SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673121": {
    "state": "Kerala",
    "district": "Wayanad",
    "block": "Vythiri",
    "officename": "Kalpetta HO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673122": {
    "state": "Kerala",
    "district": "Wayanad",
    "block": "Vythiri",
    "officename": "Kalpetta North SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673123": {
    "state": "Kerala",
    "district": "Wayanad",
    "block": "Vythiri",
    "officename": "Chundale SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673301": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Chaliyam SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673302": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Kadalundi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673303": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Elathur SO Kozhikode",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673304": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Koyilandi",
    "officename": "Chemancheri SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673305": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Koyilandi",
    "officename": "Koyilandi HO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673306": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Quilandy",
    "officename": "Edakulam  Koyilandi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673307": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Koyilandi",
    "officename": "Kollam SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673308": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Vadakara",
    "officename": "Chombala SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673309": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Vadakara",
    "officename": "Azhiyur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673310": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Vadakara",
    "officename": "Mahe SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673311": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalassery",
    "officename": "New Mahe SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "673312": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalassery",
    "officename": "Peringadi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "673313": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalassery",
    "officename": "Olavilam SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "673314": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirurangadi",
    "officename": "Kadalundinagaram SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "673315": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Koyilani",
    "officename": "Atholi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673316": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalassery",
    "officename": "Kariyad South SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "673317": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Thalakolathur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673328": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Mannur SO Kozhikode",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673501": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Vadakara",
    "officename": "Orkatteri SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673502": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Vadakara",
    "officename": "Edacheri SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673503": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Vadakara",
    "officename": "Purameri SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673504": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Vadakara",
    "officename": "Nadapuram SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673505": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Vadakara",
    "officename": "Tuneri SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673506": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Vadakara",
    "officename": "Kallachi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673507": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Vadakara",
    "officename": "Kakkattil SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673508": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Vadakara",
    "officename": "Kuttiadi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673509": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Vadakara",
    "officename": "Parakkadavu SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673513": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Vadakara",
    "officename": "Kavilampara SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673517": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Vadakara",
    "officename": "Valayam SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673521": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Quilandy",
    "officename": "Iringal SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673522": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Koyilandi",
    "officename": "Payyoli SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673523": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Quilandy",
    "officename": "Payyoli Angadi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673524": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Quilandy",
    "officename": "Meppayur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673525": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Koyilandi",
    "officename": "Perampra SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673526": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Quilandy",
    "officename": "Kayanna SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673527": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Quilandy",
    "officename": "Koorachundu SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673528": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Quilandy",
    "officename": "Peruvannamuzhi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673529": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Quilandy",
    "officename": "Tikkoti SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673541": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Vadakara",
    "officename": "Thiruvallur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673542": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Vadakara",
    "officename": "Villyappalli SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673570": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Iim Kozhikode Campus SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673571": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Kunnamangalam SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673572": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Kotuvalli SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673573": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Tamaracheri SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673574": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Koyilandi",
    "officename": "Unnikulam SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673575": {
    "state": "Kerala",
    "district": "Wayanad",
    "block": "Vythiri",
    "officename": "Pozhuthana SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673576": {
    "state": "Kerala",
    "district": "Wayanad",
    "block": "Vythiri",
    "officename": "Vythiri SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673577": {
    "state": "Kerala",
    "district": "Wayanad",
    "block": "Vythiri",
    "officename": "Meppadi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673579": {
    "state": "Kerala",
    "district": "Wayanad",
    "block": "Sulthanbathery",
    "officename": "Pulpalli SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673580": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Kotancheritamaracheri SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673581": {
    "state": "Kerala",
    "district": "Wayanad",
    "block": "Vythiri",
    "officename": "Vatuvanchal SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673582": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Omasseri SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673585": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Narikkuni SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673586": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Puduppadi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673591": {
    "state": "Kerala",
    "district": "Wayanad",
    "block": "Sulthanbathery",
    "officename": "Meenangadi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673592": {
    "state": "Kerala",
    "district": "Wayanad",
    "block": "Sulthanbathery",
    "officename": "Sulthan Bathery SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673593": {
    "state": "Kerala",
    "district": "Wayanad",
    "block": "Sulthanbathery",
    "officename": "Ambalavayal SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673595": {
    "state": "Kerala",
    "district": "Wayanad",
    "block": "Sulthan Batheri",
    "officename": "Cheeral SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673596": {
    "state": "Kerala",
    "district": "Wayanad",
    "block": "Sulthanbathery",
    "officename": "Kenichira SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673601": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Nit  Campus PoKozhikode SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673602": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Mokkam SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673603": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Tiruvambadi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673604": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Kutaranni SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673611": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Kakkoti SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673612": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Quilandy",
    "officename": "Balusseri SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673613": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Nanminda SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673614": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Koyilandi",
    "officename": "Naduvannur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673616": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Chelannur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673620": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Koyilandi",
    "officename": "Quilandibazar SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "673631": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Feroke SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673632": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Ernad",
    "officename": "Farook College SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673633": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Eranad",
    "officename": "Ramanattukara SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673634": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirurangadi",
    "officename": "Chelembra SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "673635": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirurangadi",
    "officename": "Calicut University SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "673636": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirurangadi",
    "officename": "Tenhipalam SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "673637": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Ernad",
    "officename": "Pulikkal SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "673638": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Ernad",
    "officename": "Kondotti SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "673639": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Ernad",
    "officename": "Areacode SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "673640": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Ernad",
    "officename": "Vazhakkad SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "673641": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Ernad",
    "officename": "Kuzhimanna SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "673642": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Ernad",
    "officename": "Mongam SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "673645": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Ernad",
    "officename": "Cheruvayur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "673647": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirurangadi",
    "officename": "Calicut Airport SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "673655": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Kolathara SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673661": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Kozhikode",
    "officename": "Mavoor SO Kozhikode",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "676101": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirur",
    "officename": "TirurKerala HO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "676102": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirur",
    "officename": "Bettath Pudiangadi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "676103": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirur",
    "officename": "Thalakkadathur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "676104": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "NA",
    "officename": "Trikkandiyur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "676105": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirur",
    "officename": "Thekkummuri SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "676106": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirur",
    "officename": "Ponmundam SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "676107": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirur",
    "officename": "Pookayil Bazar SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "676108": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirur",
    "officename": "Triprangode SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "676109": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirur",
    "officename": "Niramaruthur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "676121": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Ernad",
    "officename": "Manjerikla HO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "676122": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Ernad",
    "officename": "Manjeri College SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "676123": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Ernad",
    "officename": "Karuvambram SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "676301": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirur",
    "officename": "Tirunavaya SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "676302": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirur",
    "officename": "TanurMBR SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "676303": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirurangadi",
    "officename": "Parpanangadi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "676304": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirurangadi",
    "officename": "Vengara MLP SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "676305": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirurangadi",
    "officename": "Abdurahiman Nagar SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "676306": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirurangadi",
    "officename": "Tirurangadi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "676307": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirur",
    "officename": "Tanalur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "676309": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirurangadi",
    "officename": "Kodinhi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "676311": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirurangadi",
    "officename": "Moonniyur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "676312": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirurangadi",
    "officename": "Ariyallur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "676317": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirurangadi",
    "officename": "Velimukku SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "676319": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirurangadi",
    "officename": "Chettipadi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "676320": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirurangadi",
    "officename": "Tayyalingal SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "676501": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirurangadi",
    "officename": "Edarikode SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "676502": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirur",
    "officename": "Paravanna SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "676503": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirur",
    "officename": "Kottakkal SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "676504": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Perinthalmanna",
    "officename": "Kodurmalabar SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "676505": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Ernad",
    "officename": "Malappuram HO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "676506": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Perintalmanna",
    "officename": "Kottilangadi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "676507": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Perinthalmanna",
    "officename": "Makkaraparamba SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "676508": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirurangadi",
    "officename": "Valakolam SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "676509": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Ernad",
    "officename": "Munduparmba SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "676510": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirurangadi",
    "officename": "Randathani SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "676517": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Ernad",
    "officename": "Pookkottur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "676519": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Ernad",
    "officename": "Downhill SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "676521": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Ernad",
    "officename": "Pandikkad SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "676522": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Ernad",
    "officename": "Kolaparamba SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "676523": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Nilambur",
    "officename": "Karuvarakundu SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "676525": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Nilambur",
    "officename": "Kalikavu SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "676528": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirurangadi",
    "officename": "Othukkungal SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "676541": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Ernad",
    "officename": "Edavanna SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "676542": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Nilambur",
    "officename": "Mampad SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "676551": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirur",
    "officename": "Kalpakancheri SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "676552": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirur",
    "officename": "Valancheri SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "676553": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirur",
    "officename": "Kadampuzha SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "676561": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirur",
    "officename": "MangalamMLP SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "676562": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirur",
    "officename": "Kuttayi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "678001": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Palakkad",
    "officename": "Palakkad HO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678002": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Palakkad",
    "officename": "Olavakkot HO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678003": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Palakkad",
    "officename": "Kalpathi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678004": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Palakkad",
    "officename": "Nurani SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678005": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Palakkad",
    "officename": "Chokkanathapuram SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678006": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Palakkad",
    "officename": "Pallipuram PG SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678007": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Palakkad",
    "officename": "Chandranagar SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678008": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Palakkad",
    "officename": "Palakkad Engineering College SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678009": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Palakkad",
    "officename": "Kallekulangara SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678010": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Palakkad",
    "officename": "Sekharipuram SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678011": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Palakkad",
    "officename": "Ambikapuram SO Palakkad",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678012": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Palakkad",
    "officename": "Vadakanthara SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678013": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Palakkad",
    "officename": "Kunnathurmedu SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678014": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Palakkad",
    "officename": "Palakkad City SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678101": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Chittur",
    "officename": "Chittur PG SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678102": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Chittur",
    "officename": "Tattamangalam SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678103": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Chittur",
    "officename": "Thekkegramam SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678104": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Palakkad",
    "officename": "Chittur College SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678501": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Palakkad",
    "officename": "Koduvayur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678502": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Chittur",
    "officename": "Ettanur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678503": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Palakkad",
    "officename": "Pudunagaram SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678504": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Chittur",
    "officename": "Vadavannur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678505": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Chittur",
    "officename": "Pallassana SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678506": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Chittur",
    "officename": "Kollengode SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678507": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Alathur",
    "officename": "Muthalamada SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678508": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Chittur",
    "officename": "Nemmara SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678510": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Chittur",
    "officename": "Ayalur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678512": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Chittur",
    "officename": "Kakkayur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678531": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Palakkad",
    "officename": "Peruvemba SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678532": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Chittur",
    "officename": "Pattancheri SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678533": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Chittur",
    "officename": "Meenakshipuram SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678534": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Chittur",
    "officename": "Vandithavalam SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678541": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Alathur",
    "officename": "Alathur Mbr HO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678542": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Alatur",
    "officename": "Perinkulam SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678543": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Alathur",
    "officename": "Kavasseri SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678544": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Alathur",
    "officename": "Palampalakode SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678545": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Alathur",
    "officename": "Pudiyankam SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678546": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Alathur",
    "officename": "Erimayur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678551": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Palakkad",
    "officename": "Kotambu SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678552": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Palakkad",
    "officename": "Polpulli SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678553": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Chittur",
    "officename": "Nallepilly SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678554": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Chittur",
    "officename": "Nattukal SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678555": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Chittur",
    "officename": "Kozhinjampara SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678556": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Chittur",
    "officename": "Menonpara SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678557": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Chittur",
    "officename": "Kozhipara SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678571": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Alathur",
    "officename": "Mathur PG SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678572": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Alathur",
    "officename": "Kottayi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678573": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Alathur",
    "officename": "Paruthipulli SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678574": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Alathur",
    "officename": "Peringottukurussi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678581": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Mannarkad",
    "officename": "Agali SO Palakkad",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "678582": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Mannarkad",
    "officename": "Mannarkkad SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "678583": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Mannarkad",
    "officename": "Mannarkad College SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "678591": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Mannarkad",
    "officename": "Kanhirapuzha SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "678592": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Palakkad",
    "officename": "Mundur Palakkad SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678593": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottapalam",
    "officename": "Tachampara SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "678594": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Palakkad",
    "officename": "Muttikulangara SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678595": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Karakurissi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "678596": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Mannarkkad",
    "officename": "Kalladikode SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "678597": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Mannarkad",
    "officename": "Karimba SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "678598": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Mannarkad",
    "officename": "Pottasseri SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "678601": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Mannarkad",
    "officename": "Alanallur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "678611": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Palakkad",
    "officename": "Edathara SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678612": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Palakkad",
    "officename": "Parli PG SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678613": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Palakkad",
    "officename": "Mankarai SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678621": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Palakkad",
    "officename": "Kanjikode SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678622": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Palakkad",
    "officename": "Elapulli SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678623": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Palakkad",
    "officename": "Kanjikode West SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678624": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Palakkad",
    "officename": "Walayar Dam SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678631": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Palakkad",
    "officename": "Kongad SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678632": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Pulappatta SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "678633": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Katambazhipuram SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "678641": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Palakkad",
    "officename": "Keralasseri SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678642": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Palakkad",
    "officename": "Mannur SO Palakkad",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678651": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Palakkad",
    "officename": "Malampuzha Dam SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678661": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Chittur",
    "officename": "Parambikulam SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678671": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Alathur",
    "officename": "Thenkurussi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678681": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Alathur",
    "officename": "Kunisseri SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678682": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Alathur",
    "officename": "Anjumoorthy SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678683": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Alathur",
    "officename": "Vadakkancherry MBR SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678684": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Alathur",
    "officename": "Kilakkancheri SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678685": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Alathur",
    "officename": "Mannapra SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678686": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Alathur",
    "officename": "Kannambra SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678687": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Alathur",
    "officename": "Puthucode SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678688": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Alathur",
    "officename": "Pallavur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678701": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Palakkad",
    "officename": "Kannadi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678702": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Alathur",
    "officename": "Coyalmanna SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678703": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Alathur",
    "officename": "Melarcode SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678704": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Alathur",
    "officename": "Chittilancheri SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678705": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Alathur",
    "officename": "Mudappallur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678706": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Alathur",
    "officename": "Vandali SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678721": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Alathur",
    "officename": "Kuttanur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678722": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Alathur",
    "officename": "Tolanur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678731": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Palakkad",
    "officename": "Puduppariyaram SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678732": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Palakkad",
    "officename": "Kottekkad SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "678762": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Mannarkad",
    "officename": "Perimbadari SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679101": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottapalam",
    "officename": "Ottapalam HO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679102": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Thottakkara SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679103": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Palappuram SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679104": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Kanniampuram SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679105": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thalapilly",
    "officename": "Mayannur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "679106": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thalapilly",
    "officename": "Kondazhi SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "679121": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottpalam",
    "officename": "Shornur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679122": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottapalam",
    "officename": "S G Press SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679123": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottapalam",
    "officename": "Ganeshgiri SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679301": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Lakkidi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679302": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottapalam",
    "officename": "PerurOPM SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679303": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Pattambi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679304": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Thiruvegapura SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679305": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Pallipuram SO Palakkad",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679306": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Melepattambi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679307": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Pulasseri SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679308": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Naduvattom SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679309": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Vilayur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679313": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottapalam",
    "officename": "Kalladipatta SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679321": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Perinthalmanna",
    "officename": "Angadipuram SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "679322": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Perinthalmanna",
    "officename": "Perintalmanna SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "679323": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Perinthalmanna",
    "officename": "Pulamanthole SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "679324": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Perinthalmanna",
    "officename": "Mankada SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "679325": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Perinthalmanna",
    "officename": "Pattikkad SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "679326": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Perintalmanna",
    "officename": "Melattur SO Malappuram",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "679327": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Ernad",
    "officename": "Tuvvur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "679328": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Nilambur",
    "officename": "Wandoor SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "679329": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Nilambur",
    "officename": "Nilambur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "679330": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Nilambur",
    "officename": "Nilambur RS SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "679331": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Nilambur",
    "officename": "Edakkaranilambur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "679332": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Nilambur",
    "officename": "Pookkottumpadam SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "679333": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Nilambur",
    "officename": "Manimooly SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "679334": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Nilambur",
    "officename": "Chungathara SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "679335": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Nellaya SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679336": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Vallapuzha SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679337": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Kulukkallur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679338": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Perinthalmanna",
    "officename": "KolathurMLP SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "679339": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Nilambur",
    "officename": "Vaniyambalam SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "679340": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Perintalmanna",
    "officename": "Cherukara SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "679341": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Perinthalmanna",
    "officename": "Talekode SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "679357": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Perintalmanna",
    "officename": "Anamangad SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Manjeri Division"
  },
  "679501": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Panamanna SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679502": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottapalam",
    "officename": "Trikkatiri SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679503": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Cherpalcheri SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679504": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Vellinezhi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679505": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Chalavara SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679506": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Karalmanna SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679511": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Chunangad SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679512": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Ambalapara SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679513": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Srikrishnapuram SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679514": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Thiruvazhiyode SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679515": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Kadambur SO Palakkad",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679516": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Vengasseri SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679521": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Manisseri SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679522": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Vaniamkulam SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679523": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Kavalappara SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679531": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Talappilly",
    "officename": "Cheruthuruthy SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "679532": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thalapilly",
    "officename": "Desamangalam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "679533": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Koottanad",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679534": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Mannarkad",
    "officename": "Trithala SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679535": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Peringode SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679536": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Chalisseri SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679551": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Anakkara SO Palakkad",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679552": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Kumaranellur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679553": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Kumbidi SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679554": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Ottappalam",
    "officename": "Kudallur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Ottapalam Division"
  },
  "679561": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Chavakkad",
    "officename": "Punnayurkulam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "679562": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Chavakkad",
    "officename": "Vadakkekad SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "679563": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Chavakkad",
    "officename": "Nhamanghat SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "679564": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Chavakkad",
    "officename": "Andathode SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "679571": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirur",
    "officename": "Kuttippuram SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "679572": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Tirur",
    "officename": "Irimbiliyam SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "679573": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Ponnani",
    "officename": "Tavanur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "679574": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Ponnani",
    "officename": "Mookkuthala SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "679575": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Ponnani",
    "officename": "Nannamukku SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "679576": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Ponnani",
    "officename": "Edapal SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "679577": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Ponnani",
    "officename": "Ponani HO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "679578": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Ponnani",
    "officename": "Vattamkulam SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "679579": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Ponnani",
    "officename": "Veliankode SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "679580": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Ponnani",
    "officename": "Perumbadappu SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "679581": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Ponani",
    "officename": "Marancheri SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "679582": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Ponnani",
    "officename": "KaladiMLP SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "679583": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Ponnani",
    "officename": "Ponani Nagaram SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "679584": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Ponnani",
    "officename": "Kanhiramukku SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "679585": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Ponani",
    "officename": "Alankode SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "679586": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Ponani",
    "officename": "Ponani South SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "679587": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Ponnani",
    "officename": "Eramangalam SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "679591": {
    "state": "Kerala",
    "district": "Malappuram",
    "block": "Ponnani",
    "officename": "Kokkur SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Tirur Division"
  },
  "680001": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Thrissur HO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680002": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Punkunnu SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680003": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Ayyanthole SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680004": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Poothole SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680005": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Thrissur East SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680006": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Kuriachira SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680007": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Kurkancheri SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680008": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Cherur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680009": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Thrissur Engg College SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680010": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Viyyur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680011": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Kanattukara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680012": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Pullazhi SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680013": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Kuttur SO Thrissur",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680014": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "PuthurThrissur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680020": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Thrissur City SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680021": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Thrissur R S SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680022": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Thiruvambady TSR SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680026": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Chiyyaram SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680027": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Kanimangalam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680028": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Kuruchikkara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680101": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Guruvayur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680102": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thalapilly",
    "officename": "Ariyannur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680103": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Puthanpalli SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680104": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Thaikkad SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680121": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram",
    "officename": "Irinjalakuda HO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680122": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram",
    "officename": "Edathirinji SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680123": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram",
    "officename": "Konathukunnu SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680125": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram",
    "officename": "Irinjalakuda North SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680301": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram",
    "officename": "Pudukad SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680302": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram",
    "officename": "Alagappanagar SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680303": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram",
    "officename": "Varandarappilly SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680304": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram",
    "officename": "Palappilly SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680305": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram",
    "officename": "Nellayithrissur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680306": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Ollur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680307": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram Taluk",
    "officename": "Chalakudi HO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680308": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram",
    "officename": "Koratti SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680309": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram",
    "officename": "Kinfra Park Koratti SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680310": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram",
    "officename": "Parappukkara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680311": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram",
    "officename": "Melur SO Thrissur",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680312": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram",
    "officename": "Chengallur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680317": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram",
    "officename": "Kallur SO Thrissur",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680501": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Talappilly",
    "officename": "Kecheri SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680502": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thalapilly",
    "officename": "Choondal SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680503": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Kunnamkulam HO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680504": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Talappilly",
    "officename": "Koonamoochi SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680505": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Kottappadi SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680506": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Chavakkad",
    "officename": "Chavakkad SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680507": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Pavaratty SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680508": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Chavakkad",
    "officename": "Puvathur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680509": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Chavakkad",
    "officename": "Mullassery SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680510": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Chavakkad",
    "officename": "Venkitangu SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680511": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Chavakkad",
    "officename": "Chittattukara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680512": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Chavakkad",
    "officename": "Orumanayur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680513": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Chavakkad",
    "officename": "Toyakkavu SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680514": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Chavakkad",
    "officename": "Kadappuram SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680515": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Chavakkad",
    "officename": "Edakkaliyur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680516": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Tiruvatra SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680517": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Kanippayur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680518": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Chavakkad",
    "officename": "Agalad SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680519": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thalapilly",
    "officename": "Karikkad SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680520": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Chavakkad",
    "officename": "Thozhiyur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680521": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Arthat SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680522": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Paluvai SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680523": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Kizhur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680524": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Chavakkad",
    "officename": "Padoor SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680541": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "MundurTC SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680542": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Talappilly",
    "officename": "Pazhanji SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680543": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Talappilly",
    "officename": "Kadavallur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680544": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thalapilly",
    "officename": "Kattakampal SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680545": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Peramangalam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680546": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Kaiparamba SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680551": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Puranattukara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680552": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Parappur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680553": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Puzhakkal SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680555": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Amalanagar SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680561": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Cherpu SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680562": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Urakam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680563": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Ammadam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680564": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Pazhuvil SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680565": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Peringottukara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680566": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Chavakkad",
    "officename": "Nattika SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680567": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Chavakkad",
    "officename": "Valapad SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680568": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Chavakkad",
    "officename": "Edamuttam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680569": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Chavakkad",
    "officename": "Talikulam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680570": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Vadakkummuri SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680571": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Kilakkummuri SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680581": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Mulagunnathukavu SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680582": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thalapilly",
    "officename": "WadakancheryTC HO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680583": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Talappilly",
    "officename": "Mullurkkara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680584": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thalapilly",
    "officename": "Erumapetty SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680585": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Varavur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680586": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thalapilly",
    "officename": "Chelakkara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680587": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thalapilly",
    "officename": "Pazhayannur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680588": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Talappilly",
    "officename": "Thiruvilwamala SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680589": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thalapilly",
    "officename": "Enkakad SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680590": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Talappilly",
    "officename": "Kumaranellur TC SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680591": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thalapilly",
    "officename": "Killimangalam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680594": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Talappilly",
    "officename": "Kaniyarkod SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680596": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Thrissur Medical College SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680601": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Talappilly",
    "officename": "Velur Thrissur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680602": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Talappilly",
    "officename": "Mattom SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680604": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Talappilly",
    "officename": "Maruthancode SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680611": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Elthuruth SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680612": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Kanjani SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680613": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Kandassankadavu SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680614": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Chavakkad",
    "officename": "Vatanappally SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680615": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Chavakkad",
    "officename": "Engandiyur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680616": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Chavakkad",
    "officename": "Kundaliyur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680617": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Manalur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680618": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Aranattukara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680619": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Chavakkad",
    "officename": "Trithallur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680620": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Arimpur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680623": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Talappilly",
    "officename": "WadakkancheriThrissur RS SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680631": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Ramavarmapuram SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680641": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Anthikad SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680642": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Puthenpeedika SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680651": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Mannuthy SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680652": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Pattikkad TC SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680653": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Peechi SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680654": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Vellanikkara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680655": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Ollukkara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680656": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Kerala Agriuniversity SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "680661": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram",
    "officename": "Nadavaramba SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680662": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram",
    "officename": "Vellangallur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680663": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Kodungallur",
    "officename": "Pullut SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680664": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Kodungallur",
    "officename": "Kodungallur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680665": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Kodungallur",
    "officename": "Panangad SO Thrissur",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680666": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Kodungallur",
    "officename": "Eriyad SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680667": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Kodungallur",
    "officename": "Kottappuram SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680668": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Kodungallur",
    "officename": "Kothaparamba SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680669": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Kodungallur",
    "officename": "Methala SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680670": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram",
    "officename": "Karupadanna SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680671": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Kodungallur",
    "officename": "Edavilangu SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680681": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Kodungallur",
    "officename": "Kaipamangalam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680682": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram",
    "officename": "Puthenchira SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680683": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram",
    "officename": "Kallettumkara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680684": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram",
    "officename": "Kodakara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680685": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Kodungallur",
    "officename": "Mathilakam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680686": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Kodungallur",
    "officename": "Perinjanam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680687": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Kodungallur",
    "officename": "Chentrappinni SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680688": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram",
    "officename": "Aripalam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680689": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram",
    "officename": "Perambrathrissur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680691": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Kodungallur",
    "officename": "Koolimuttam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680697": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram",
    "officename": "Thazhekkad SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680699": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram",
    "officename": "Pady SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680701": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram",
    "officename": "Thanissery SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680702": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram",
    "officename": "Kattoor SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680703": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram",
    "officename": "Edathuruthy SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680711": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram",
    "officename": "Karuvannur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680712": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram",
    "officename": "Madayikonam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680721": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram",
    "officename": "Pariyaram SO Thrissur",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680722": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram",
    "officename": "Potta SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680724": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram",
    "officename": "Kuttichira SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680731": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram",
    "officename": "Ashtamichira SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680732": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram",
    "officename": "Malathrissur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680733": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Kodungallur",
    "officename": "Poyya SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680734": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram",
    "officename": "Kuzhur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680741": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Mukundapuram",
    "officename": "Annamanada SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Irinjalakuda Division"
  },
  "680751": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Thrissur",
    "officename": "Nadathara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "682001": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kochi",
    "officename": "Kochi HO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682002": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kochi",
    "officename": "Mattancherry SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682003": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kochi",
    "officename": "Willingdon Island SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682004": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kochi",
    "officename": "Kochi Naval Base SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682005": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kochi",
    "officename": "Thoppumpady SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682006": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kochi",
    "officename": "Palluruthy SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682007": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kochi",
    "officename": "Kumbalangi SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682008": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kochi",
    "officename": "Kannamali SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682009": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kochi",
    "officename": "North End SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682010": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kochi",
    "officename": "Edakochi SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682011": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "Ernakulam HO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682012": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "Pachalam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682013": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "Thevara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682015": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "Perumanur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682016": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "Kochi MGRoad SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682017": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "Kaloor SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682018": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "Ernakulam North SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682019": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "Vyttila SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682020": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "Kadavanthara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682021": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "Thrikkakara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682022": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "Kochi University SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682023": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "Vaduthala SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682024": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "Edapally SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682025": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "Palarivattom SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682026": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "Elamakkara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682027": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "ChittoorEkm SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682028": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "Vennala SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682029": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kochi",
    "officename": "Matsyapuri SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682030": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "Kakkanad SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682031": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "Shanmugham Road SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682032": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "Thammanam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682033": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kanayannur",
    "officename": "Changampuzha Nagar SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682034": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "Cheranallur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682035": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "Ernakulam College SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682036": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "Panampilly Nagar SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682037": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "Cochin Special Economic Zone SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682038": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "Poonithura SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682039": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "Rajagiri Valley SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682040": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kanayannur",
    "officename": "Nettoor SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682041": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kanayannur",
    "officename": "AIMS Ponekkara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682042": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kanayannur",
    "officename": "InfoparkKochi SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682301": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "Tripunithura SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682302": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kunnathunad",
    "officename": "Ambalamugal SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682303": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kunnathunad",
    "officename": "Ambalamedu SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682304": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "Maradu SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682305": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kanayannur",
    "officename": "Thiruvamkulam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682306": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "Eroor SO Ernakulam",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682307": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kanayannur",
    "officename": "Udayamperoor SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682308": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kunnathunad",
    "officename": "Puthencruz SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682309": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "Irimbanam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682310": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kunnathunad",
    "officename": "Vadavucode SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682311": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kunnathunad",
    "officename": "Kolenchery SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "682312": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kanayannur",
    "officename": "Chottanikkara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682313": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kanayannur",
    "officename": "Arakunnam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682314": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "Mulanthuruthy SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682315": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "Kanjiramattom SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682316": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Muvattupuzha",
    "officename": "Kunnackal SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "682501": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kochi",
    "officename": "Ayyampilly SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682502": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kochi",
    "officename": "Edavanakad SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682503": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kochi",
    "officename": "Elamkunnapuzha SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682504": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "Mulavukad SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682505": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kochi",
    "officename": "Narakkal SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682506": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "Panangad SO Ernakulam",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682507": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kochi",
    "officename": "Mundamveli SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682508": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kochi",
    "officename": "Ochanthuruth SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682509": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kochi",
    "officename": "Nayarambalam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682511": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kochi",
    "officename": "Malipuram SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682551": {
    "state": "Lakshadweep",
    "district": "Lakshadweep",
    "block": "Lakshadweep",
    "officename": "Androth S.O",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Lakshadweep Division"
  },
  "682552": {
    "state": "Lakshadweep",
    "district": "Lakshadweep",
    "block": "Amini",
    "officename": "Amini S.O",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Lakshadweep Division"
  },
  "682553": {
    "state": "Lakshadweep",
    "district": "Lakshadweep",
    "block": "Lakshadweep",
    "officename": "Agathi S.O",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Lakshadweep Division"
  },
  "682554": {
    "state": "Lakshadweep",
    "district": "Lakshadweep",
    "block": "Amini",
    "officename": "Chetlat S.O",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Lakshadweep Division"
  },
  "682555": {
    "state": "Lakshadweep",
    "district": "Lakshadweep",
    "block": "Lakshadweep",
    "officename": "Kavaratti H.O",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Lakshadweep Division"
  },
  "682556": {
    "state": "Lakshadweep",
    "district": "Lakshadweep",
    "block": "Lakshadweep",
    "officename": "Kadamat S.O",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Lakshadweep Division"
  },
  "682557": {
    "state": "Lakshadweep",
    "district": "Lakshadweep",
    "block": "Lakshadweep",
    "officename": "Kalpeni S.O",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Lakshadweep Division"
  },
  "682558": {
    "state": "Lakshadweep",
    "district": "Lakshadweep",
    "block": "Lakshadweep",
    "officename": "Kiltan S.O",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Lakshadweep Division"
  },
  "682559": {
    "state": "Lakshadweep",
    "district": "Lakshadweep",
    "block": "Lakshadweep",
    "officename": "Minicoy S.O",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Lakshadweep Division"
  },
  "683101": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Aluva",
    "officename": "Aluva HO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683102": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Aluva",
    "officename": "Union Christian College SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683104": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kanayannur",
    "officename": "Kalamassery SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "683105": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kunnathunad",
    "officename": "Thottumughom SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683106": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Aluva",
    "officename": "Thaikkattukara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683108": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Aluva",
    "officename": "Thottakkattukara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683110": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Paravur",
    "officename": "Muppathadam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683111": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Aluva",
    "officename": "Kochi Airport SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683112": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kunnathunad",
    "officename": "Erumathala SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683501": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "Udyogamandal SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "683502": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Paravur",
    "officename": "Binanipuram SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683503": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kanayannur",
    "officename": "Hmt Colony SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "683511": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Paravur",
    "officename": "Alangad SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683512": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Paravur",
    "officename": "Chendamangalam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683513": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Paravur",
    "officename": "Paravur SO Ernakulam",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683514": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Paravur",
    "officename": "Cherai SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683515": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kochi",
    "officename": "Palliport SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683516": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Paravur",
    "officename": "Moothakunnam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683517": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Paravur",
    "officename": "Varapuzha SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683518": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Paravur",
    "officename": "Koonammavu SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683519": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Paravur",
    "officename": "Kaitharam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683520": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Paravur",
    "officename": "Mannam Paravur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683521": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Paravur",
    "officename": "Vadakkumpuram SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683522": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Paravur",
    "officename": "Vadakkekara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683541": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kunnathunad",
    "officename": "Keezhillam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683542": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kunnathunad",
    "officename": "Perumbavoor HO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683543": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kunnathunad",
    "officename": "Rayonpuram SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683544": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kunnathunad",
    "officename": "Koovappady SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683545": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kunnathunad",
    "officename": "Kuruppampady SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683546": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kunnathunad",
    "officename": "Vengoor SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683547": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kunnathunad",
    "officename": "Mudikkal SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683549": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kunnathunad",
    "officename": "Asamannoor SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683550": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kunnathunad",
    "officename": "Okkal SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683556": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kunnathunad",
    "officename": "Valayanchirangara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683561": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Aluva",
    "officename": "Edathala SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683562": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Aluva",
    "officename": "Kizhakkambalam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683563": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Aluva",
    "officename": "Naval Armament Depot  Aluva SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683565": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kunnathunad",
    "officename": "Kumarapuram SO Ernakulam",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683571": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Aluva",
    "officename": "Chowara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683572": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Paravur",
    "officename": "Angamally SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683573": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Aluva",
    "officename": "Angamally South SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683574": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Aluva",
    "officename": "Kalady SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683575": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Aluva",
    "officename": "Kanjoor SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683576": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Aluva",
    "officename": "Karukutty SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683577": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Aluva",
    "officename": "Mookkannur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683578": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Paravur",
    "officename": "Chengamanad SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683579": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Paravur",
    "officename": "Kurumassery SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683580": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Aluva",
    "officename": "Sreemoolanagaram SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683581": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Aluva",
    "officename": "Manjapra SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683585": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Aluva",
    "officename": "Athani SO Ernakulam",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683587": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Aluva",
    "officename": "Malayattoor SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683589": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Aluva",
    "officename": "Mekkad SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "683594": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Paravur",
    "officename": "Puthenvelikkara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "685501": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Peerumade",
    "officename": "Elappara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685503": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Peerumade",
    "officename": "Vagamon SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685505": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Udumbanchola",
    "officename": "Upputhara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685507": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Udumbanchola",
    "officename": "Ayyappancoil SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685508": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Udumbanchola",
    "officename": "Kattappana HO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685509": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Peerumade",
    "officename": "Kumily SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685511": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Udumbanchola",
    "officename": "Kanchiyar SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685512": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Udumbanchola",
    "officename": "Anakkara SO Idukki",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685514": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Udumbanchola",
    "officename": "Erattayar SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685515": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Udumbanchola",
    "officename": "Kattappana South SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685531": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Peerumade",
    "officename": "Peermade SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685532": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Peerumade",
    "officename": "Peruvanthanam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685533": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Peerumade",
    "officename": "Vandiperiyar SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685535": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Udumbanchola",
    "officename": "Viswanathapuram SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685551": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Udumbanchola",
    "officename": "Vandanmettu SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685552": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Udumbanchola",
    "officename": "Kallar SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685553": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Udumbanchola",
    "officename": "Nedumkandam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685554": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Udumbanchola",
    "officename": "Udumbanchola SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685561": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Devikulam",
    "officename": "Adimali SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685562": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Devikulam",
    "officename": "Kallarkutty SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685563": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Udumbanchola",
    "officename": "Vellathooval SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685565": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Devikulam",
    "officename": "Chithirapuram SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685566": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Udumbanchola",
    "officename": "Rajakad SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685571": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Udumbanchola",
    "officename": "Parathode SO Idukki",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685581": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Thodupuzha",
    "officename": "Karimannoor SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685582": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Thodupuzha",
    "officename": "Kodikulam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685583": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Thodupuzha",
    "officename": "Vazhithala SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685584": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Thodupuzha",
    "officename": "Thodupuzha HO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685585": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Thodupuzha",
    "officename": "Thodupuzha East SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685586": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Thodupuzha",
    "officename": "Karimkunnam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685587": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Thodupuzha",
    "officename": "Muttom EK SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685588": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Thodupuzha",
    "officename": "Kalayanthani SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685589": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Thodupuzha",
    "officename": "Moolamattom SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685590": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Thodupuzha",
    "officename": "Kudayathur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685591": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Thodupuzha",
    "officename": "Arakulam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685595": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Thodupuzha",
    "officename": "Udumbannur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685601": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Thodupuzha",
    "officename": "Kulamavu SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685602": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Thodupuzha",
    "officename": "Idukki Colony SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685603": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Thodupuzha",
    "officename": "Idukki Painavu SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685604": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Udumbanchola",
    "officename": "Murickassery SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685605": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Thodupuzha",
    "officename": "Muthalakodam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685606": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Thodupuzha",
    "officename": "Kanjikuzhi  Idukki SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685607": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Thodupuzha",
    "officename": "Vannapuram SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685608": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Thodupuzha",
    "officename": "Vengallur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685609": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Udumbanchola",
    "officename": "Thankamany SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685612": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Devikulam",
    "officename": "Munnar SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685613": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Udumbanchola",
    "officename": "Devikulam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685614": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Devikulam",
    "officename": "Talliar SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685615": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Devikulam",
    "officename": "Ellapatti SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685616": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Devikulam",
    "officename": "Mattuppatti SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685618": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Udumbanchola",
    "officename": "Surianalle SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685619": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Udumbanchola",
    "officename": "Santhanpara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "685620": {
    "state": "Kerala",
    "district": "Idukki",
    "block": "Devikulam",
    "officename": "Maraiyur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Idukki Division"
  },
  "686001": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Kottayam HO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686002": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Kottayam Collectorate SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686003": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Kottayam West SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686004": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Muttambalam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686005": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Thazhathangady SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686006": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Nattassery S H Mount SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686007": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Pallom SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686008": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Gandhi Nagar SO Kottayam",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686009": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Rubber Board SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686010": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Vadavathoor SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686011": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Puthupalli SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686012": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Pakkil SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686013": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Nattakom SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686014": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Olessa SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686015": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Aymanam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686016": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Kumaranalloor SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686017": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Kudamaloor SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686018": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Manganam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686019": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Manarcaudu SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686020": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Kiliroor North SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686021": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Pariyaram SO Kottayam",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686022": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Chengalam South SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686041": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Malloossery SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686101": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Changanacherry",
    "officename": "Changanacherry HO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686102": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Changanassery",
    "officename": "Perunna SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686103": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Kuttanadu",
    "officename": "Vazhappally West SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686104": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Changanacherry",
    "officename": "Kurisummoodu SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686105": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Changanassery",
    "officename": "Thrickodithanam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686106": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Changanassery",
    "officename": "Changanacherry Industrialnagar SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686121": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Meenachil",
    "officename": "Erattupetta SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686122": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Meenachil",
    "officename": "Aruvithura SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686123": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Meenachil",
    "officename": "Thidanad SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686141": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Vaikom",
    "officename": "Vaikom HO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686143": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Vaikom",
    "officename": "Udayanapuram SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686144": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Vaikom",
    "officename": "Kudavechoor SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686146": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Vaikom",
    "officename": "Padinjarekkara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686501": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Velloor SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686502": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Pampady SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686503": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Anikad SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686504": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Changanacherry",
    "officename": "Vazhoor SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686505": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Changanassery",
    "officename": "Theerthapadapuram SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686506": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kanjirapally",
    "officename": "Ponkunnam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686507": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kanjirappally",
    "officename": "Kanjirapally HO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686508": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kanjirapally",
    "officename": "Kalaketty SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686509": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kanjirapally",
    "officename": "Erumely SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686510": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Ranni",
    "officename": "Mukkoottuthara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686511": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Ranni",
    "officename": "Kunnam Vechoochira SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686512": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kanjirapally",
    "officename": "Parathode SO Kottayam",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686513": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kanjirappally",
    "officename": "Mundakayam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686514": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kanjirappally",
    "officename": "Koottickal SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686515": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Changanassery",
    "officename": "Pulickakavala SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686516": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Meenadom SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686517": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Changanassery",
    "officename": "Chakompathal SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686518": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kanjirapally",
    "officename": "Koovapally SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686519": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kanjirappally",
    "officename": "Thekkethukavala SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686520": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kanjirappally",
    "officename": "Chirakadavu SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686521": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Pampady South SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686522": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kanjirapally",
    "officename": "Koorali SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686531": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Changanacherry",
    "officename": "Chingavanam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686532": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Changanassery",
    "officename": "Sachivothamapuram SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686533": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Kuzhimattom SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686534": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Kuttanad",
    "officename": "Neelamperoor SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686535": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Changanassery",
    "officename": "Thuruthy SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686536": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Changanassery",
    "officename": "Perumpanachy SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686537": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Changanacherry",
    "officename": "Pallickachirakavala SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686538": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Changanassery",
    "officename": "Vakathanam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686539": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Changanassery",
    "officename": "Thottakadu SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686540": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Changanassery",
    "officename": "Karukachal SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686541": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Changanassery",
    "officename": "Kangazha SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686542": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Changanassery",
    "officename": "Nedumkunnam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686543": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Changanacherry",
    "officename": "Manimala SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686544": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kanjirappally",
    "officename": "Karikkattoor SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686545": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Changanassery",
    "officename": "Nedungadappally SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686546": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Changanassery",
    "officename": "Madappally SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686547": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Mallappally",
    "officename": "Chunkapara SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "686548": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Changanassery",
    "officename": "Nalukody SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686555": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Changanassery",
    "officename": "Devagiri SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686560": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Priyadarsini Hills SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686561": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Mannanam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686562": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Athirampuzha SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686563": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Kumarakom SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686564": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Ayarkunnam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686571": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Meenachil",
    "officename": "Kadaplamattom SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686572": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Meenachil",
    "officename": "Kidangoor SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686573": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Meenachil",
    "officename": "Puliyannoor SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686574": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Meenachil",
    "officename": "Arunapuram SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686575": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Meenachil",
    "officename": "Pala HO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686576": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Meenachil",
    "officename": "Ramapuram Bazar SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686577": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Meenachil",
    "officename": "Poovarani SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686578": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Meenachil",
    "officename": "Bharananganam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686579": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Meenachil",
    "officename": "Plassanal SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686580": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Meenachil",
    "officename": "Teekoy SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686581": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Meenachil",
    "officename": "Poonjar SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686582": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Meenachil",
    "officename": "Poonjar Thekkekara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686583": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Meenachil",
    "officename": "Kidangoor South SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686584": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Meenachil",
    "officename": "Cherpunkal SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686585": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Chengalam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Changanacherry Division"
  },
  "686586": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Meenachil",
    "officename": "Moonnilavu SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686587": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Meenachil",
    "officename": "Vayala SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686601": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Neendoor SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686602": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Kaipuzha SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686603": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Vaikom",
    "officename": "Manjoor SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686604": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Vaikom",
    "officename": "Kaduthuruthy SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686605": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Vaikom",
    "officename": "Thalayolaparambu SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686606": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Vaikom",
    "officename": "Thirumani Venkita Puram SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686607": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Vaikom",
    "officename": "Thalayazham SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686608": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Vaikom",
    "officename": "Kulasekharamangalam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686609": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Vaikom",
    "officename": "Mevelloor SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686610": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Vaikom",
    "officename": "Peruva SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686611": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Vaikom",
    "officename": "Kallara SO Kottayam",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686612": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Vaikom",
    "officename": "Njizhoor SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686613": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Vaikom",
    "officename": "Muttuchira SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686616": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Vaikom",
    "officename": "Newsprint Nagar SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686630": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Thellakom SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686631": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Ettumanur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686632": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Meenachil",
    "officename": "Kanakari SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686633": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Meenachil",
    "officename": "Kuravilangadu SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686634": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Vaikom",
    "officename": "Ozhavur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686635": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Meenachil",
    "officename": "Marangattupally SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686636": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Meenachil",
    "officename": "Monippally SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686637": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Kottayam",
    "officename": "Peroor SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686651": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Meenachil",
    "officename": "Anthinad SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686652": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Meenachil",
    "officename": "Melukavumattom SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686653": {
    "state": "Kerala",
    "district": "Kottayam",
    "block": "Meenachil",
    "officename": "Kadanad Meenachil SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Kottayam Division"
  },
  "686661": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Muvattupuzha",
    "officename": "Muvattupuzha HO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "686662": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Muvattupuzha",
    "officename": "Koothattukulam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "686663": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Muvattupuzha",
    "officename": "Ramamangalam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "686664": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Muvattupuzha",
    "officename": "Piravom SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "686665": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Muvattupuzha",
    "officename": "Elanji SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "686666": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kothamangalam",
    "officename": "Kothamangalam College SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "686667": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Muvattupuzha",
    "officename": "Pampakuda SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "686668": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Muvattupuzha",
    "officename": "Kalloorkkad SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "686669": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kunnathunad",
    "officename": "Mudavoor SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "686670": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Muvattupuzha",
    "officename": "Vazhakulam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "686671": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kothamangalam",
    "officename": "Pothanicaud SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "686672": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Muvattupuzha",
    "officename": "Arakuzha SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "686673": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Muvattupuzha",
    "officename": "Muvattupuzha Market SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "686681": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kothamangalam",
    "officename": "Chelad Junction SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "686691": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kothamangalam",
    "officename": "Kothamangalam SO Ernakulam",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "686692": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kothamangalam",
    "officename": "Thrikkariyoor SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "686693": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Kothamangalam",
    "officename": "Nellimattam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "688001": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Ambalapuzha",
    "officename": "Alappuzha HO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688002": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Ambalapuha",
    "officename": "Thiruvampady Junction SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688003": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Ambalapuzha",
    "officename": "Sanathanapuram SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688004": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Ambalapuzha",
    "officename": "Punnapra SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688005": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Ambalappuzha",
    "officename": "Alappuzha Medical College SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688006": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Ambalapuzha",
    "officename": "Avalukkunnu SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688007": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Ambalapuzh A",
    "officename": "Alappuzha North SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688008": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Ambalapuzha",
    "officename": "Thumpoly SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688009": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Ambalapuzha",
    "officename": "Pazhaveedu SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688011": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Ambalapuzha",
    "officename": "Alappuzha Iron Bridge SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688013": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Ambalappuzha",
    "officename": "Thathampally SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688014": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Ambalapuzha",
    "officename": "Punnapra North SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688501": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Kuttanad",
    "officename": "Kainakary SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688502": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Kuttanad",
    "officename": "Moncombu SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688503": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Kuttanad",
    "officename": "Moncombu Thekkekara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688504": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Kuttanad",
    "officename": "Pulincunnu SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688505": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Kuttanad",
    "officename": "Champakulam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688506": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Kuttanad",
    "officename": "Kavalam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688521": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Ambalapuzha",
    "officename": "Pathirappally SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688522": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Ambalapuzha",
    "officename": "Kalavoor SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688523": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Cherthala",
    "officename": "Sethulekshmipuram SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688524": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Cherthala",
    "officename": "Cherthala HO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688525": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Cherthala",
    "officename": "Muhamma SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688526": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Cherthala",
    "officename": "Poochackal SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688527": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Cherthala",
    "officename": "Thanneermukkom SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688528": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Cherthala",
    "officename": "Thycattussery SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688529": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Cherthala",
    "officename": "Kadakkarapally SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688530": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Cherthala",
    "officename": "Arthingal SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688531": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Cherthala",
    "officename": "Pattanacaud SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688532": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Cherthala",
    "officename": "Thuravoor SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688533": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Cherthala",
    "officename": "Kuthiathode SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688534": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Cherthla",
    "officename": "Aroor SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688535": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Cherthala",
    "officename": "Arookutty SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688536": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Cherthala",
    "officename": "Vayalar SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688537": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Cherthala",
    "officename": "Eramallur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688538": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Mararikulam",
    "officename": "Mannancherry SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688539": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Cherthala",
    "officename": "Mayithara Market SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688540": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Cherthala",
    "officename": "Thirumalabhagom SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688541": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Cherthala",
    "officename": "Pallippuram SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688555": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Cherthala",
    "officename": "Varanam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688561": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Ambalapuzha",
    "officename": "Ambalapuzha SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688562": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Kuttanad",
    "officename": "Thakazhy SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688570": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Cherthala",
    "officename": "Perumbalam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "688582": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Cherthala",
    "officename": "Sreenarayanapuram SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "689101": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Tiruvalla",
    "officename": "Tiruvalla HO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689102": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Thiruvalla",
    "officename": "Kavumbhagom SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689103": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Tiruvalla",
    "officename": "Kuttapuzha SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689104": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Thiruvalla",
    "officename": "Valanjavattom SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689105": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Tiruvalla",
    "officename": "Manjady Jn SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689106": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Tiruvalla",
    "officename": "Kuttur SO Pathanamthitta",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689107": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Thiruvalla",
    "officename": "Muthoor SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689108": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Thiruvalla",
    "officename": "Peringara SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689109": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Chengannur",
    "officename": "Tiruvanvandur SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689110": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Thiruvalla",
    "officename": "Podiyadi SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689111": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Ranni",
    "officename": "Tiruvalla RS SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689112": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Thiruvalla",
    "officename": "Chathankary SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689113": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Thiruvalla",
    "officename": "Azhiyadathuchira SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689115": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Thiruvalla",
    "officename": "Thirumoolapuram SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689121": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Chengannur",
    "officename": "Chengannur HO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689122": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Chengannur",
    "officename": "Angadical Chengannur SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689123": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Kozhenchery",
    "officename": "Puthencavu SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689124": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Chengannur",
    "officename": "Kallisserry SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689126": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Chengannur",
    "officename": "Ala SO Alappuzha",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689501": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Adur",
    "officename": "Pandalam SO Pathanamthitta",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689502": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Adoor",
    "officename": "Thumpamon SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689503": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Kozhencherry",
    "officename": "Kulanada SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689504": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Chengannur",
    "officename": "Karakkad SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "689505": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Chengannur",
    "officename": "Mulakuzha SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "689506": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Chengannur",
    "officename": "Pandanad SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689507": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Kozhencherry",
    "officename": "Mezhuveli SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689508": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Chengannur",
    "officename": "Kodukulanji SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "689509": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Chengannur",
    "officename": "Venmony SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "689510": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Chengannur",
    "officename": "Puliyoor SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689511": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Chengannur",
    "officename": "Cheriyanadu SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689512": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Mavelikkara",
    "officename": "Kudassanad SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "689513": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Kozhenchery",
    "officename": "Nariapuram SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689514": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Kozhenchery",
    "officename": "Kidangannur SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689520": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Chengannur",
    "officename": "Pennukkara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "689521": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Chengannur",
    "officename": "Kozhuvallur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "689531": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Tiruvalla",
    "officename": "Koipuram SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689532": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Kozhenchery",
    "officename": "Edayarnmula SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689533": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Kozhencherry",
    "officename": "Aranmula SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689541": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Thiruvalla",
    "officename": "Vallamkulam SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689542": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Thiruvalla",
    "officename": "Eraviperoor SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689543": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Mallappally",
    "officename": "Puramattom SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689544": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Mallappally",
    "officename": "Vennikulam SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689545": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Mallappally",
    "officename": "Thadiyur SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689546": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Thiruvalla",
    "officename": "Othera SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689547": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Thiruvalla",
    "officename": "Kumbanadu SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689548": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Thiruvalla",
    "officename": "Pullad SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689549": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Thiruvalla",
    "officename": "Maramon SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689550": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Thiruvalla",
    "officename": "Kuriannoor SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689551": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Thiruvalla",
    "officename": "Otherawest SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689571": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Kuttanad",
    "officename": "Neerattupuram SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689572": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Kuttanad",
    "officename": "Thalavady SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689573": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Kuttanad",
    "officename": "Edathua SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689574": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Kuttanadu",
    "officename": "Muttar SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689581": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Tiruvalla",
    "officename": "Kunnamthanam SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689582": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Thiruvalla",
    "officename": "Kaviyoor SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689583": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Mallappally",
    "officename": "Kallooppara SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689584": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Mallappally",
    "officename": "Mallappally East SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689585": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Mallappally",
    "officename": "Mallappally West SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689586": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Mallappally",
    "officename": "Ezhumattoor SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689587": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Mallappally",
    "officename": "Keezhvaipur SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689588": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Mallappally",
    "officename": "Vaipur SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689589": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Mallappally",
    "officename": "Punnavely SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689590": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Kuttanadu",
    "officename": "Veliyanadu SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689591": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Thiruvalla",
    "officename": "Mepral SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689592": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Mallappally",
    "officename": "Perumpatty SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689594": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Mallappally",
    "officename": "Chengaroor SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689595": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Kuttanad",
    "officename": "Ramankary SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689597": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Mallappally",
    "officename": "Thuruthicaud SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689602": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Mallappally",
    "officename": "Puthusserry South SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689611": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Ranni",
    "officename": "Ayroor South SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689612": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Ranni",
    "officename": "Ayroor North SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689613": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Mallappally",
    "officename": "Theodical SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689614": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Ranni",
    "officename": "Kottathoor SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689615": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Mallappally",
    "officename": "Kottanad SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689621": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Tiruvalla",
    "officename": "Niranam SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689622": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Chengannur",
    "officename": "Mannar SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "689623": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Chengannur",
    "officename": "Kuttemperur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "689624": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Chengannur",
    "officename": "Ennakkad SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "689625": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Kozhenchery",
    "officename": "Elavanthitta SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689626": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Thiruvalla",
    "officename": "Parumala SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tiruvalla Division"
  },
  "689627": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Mavelikara",
    "officename": "Melpadom SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "689641": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Kozhencherry",
    "officename": "Kozhencherry SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689642": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Kozhencherry",
    "officename": "Naranganam SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689643": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Kozhenchery",
    "officename": "Elanthur SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689644": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Kozhenchery",
    "officename": "Kuzhikala SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689645": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Kozhenchery",
    "officename": "Pathanamthitta HO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689646": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Kozhencherry",
    "officename": "Mallasseri SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689647": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Kozhenchery",
    "officename": "Omallurkla SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689648": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Adoor",
    "officename": "Kaipattur SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689649": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Kozhenchery",
    "officename": "Kadammanitta SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689650": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Kozhencherri",
    "officename": "Cherukole Kozhencherri SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689652": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Kozhencherry",
    "officename": "Punnakkad SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689653": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Kozhenchery",
    "officename": "Kumbazhamuri SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689654": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Kozhenchery",
    "officename": "Kozhencherry  Thekkemala SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689656": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Kozhenchery",
    "officename": "Vallicode Kottayam SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689661": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Ranni",
    "officename": "Kumpalampoika SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689662": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Ranni",
    "officename": "Vadasserikara SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689663": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Ranny",
    "officename": "Chittar SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689664": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Kozhenchery",
    "officename": "Malayalapuzha Eram SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689666": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Ranny",
    "officename": "Malayalapuzha Thazham SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689667": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Ranni",
    "officename": "Seethathode SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689668": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Kozhenchery",
    "officename": "Churulicode SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689671": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Kozhenchery",
    "officename": "Mylapra SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689672": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Ranni",
    "officename": "Ranny SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689673": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Ranni",
    "officename": "Rannypazhavangadi SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689674": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Ranny",
    "officename": "Angadi SO Pathanamthitta",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689675": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Ranni",
    "officename": "Ettichuvadu SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689676": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Ranni",
    "officename": "Makkapuzha SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689677": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Ranni",
    "officename": "Chellakkad SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689678": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Kozhenchery",
    "officename": "Mylapra Town SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689691": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Kozhencherry",
    "officename": "Konny SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689692": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Kozhencherry",
    "officename": "Payyanamon SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689693": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Adoor",
    "officename": "Koodal SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689694": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Adoor",
    "officename": "Kalanjoor SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689695": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Pathanapuram",
    "officename": "Pathanapuram SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689696": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Pathanapuram",
    "officename": "Piravanthur SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689698": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Kozhenchery",
    "officename": "Vakayar SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689699": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Kozhenchery",
    "officename": "Thannithode SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "689711": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Ranni",
    "officename": "Ranny Perinad SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "690101": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Mavelikara",
    "officename": "Mavelikara HO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690102": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Mavelikkara",
    "officename": "Thazhakara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690103": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Mavelikkara",
    "officename": "Thattarambalam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690104": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Mavelikkara",
    "officename": "Cherukole SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690105": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Mavelikara",
    "officename": "Chennithala SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690106": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Mavelikara",
    "officename": "Chettikulangara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690107": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Mavelikkara",
    "officename": "Thekkekara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690108": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Mavelikkara",
    "officename": "Kunnam SO Alappuzha",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690110": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Mavelikkara",
    "officename": "Kallumala SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690501": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Mavelikkara",
    "officename": "Vallikunnam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690502": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Karthikappally",
    "officename": "Kayangulam HO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690503": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Mavelikkara",
    "officename": "Pallickal SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690504": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Mavelikkara",
    "officename": "Nooranad SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690505": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Mavelikkara",
    "officename": "Charumoodu SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690506": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Karthikappally",
    "officename": "Muthukulam South SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690507": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Karthikappally",
    "officename": "Cheppaud SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690508": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Karthikappally",
    "officename": "Keerikad SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690509": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Mavelikkara",
    "officename": "Kollakadavu SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690510": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Chengannur",
    "officename": "Olakettiambalam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690511": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Karthikappally",
    "officename": "Muttomalleppey SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690512": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Karthikappally",
    "officename": "Pallipad SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690513": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Karthikappally",
    "officename": "Nangiarkulangara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690514": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Karthikappally",
    "officename": "Haripad SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690515": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Karthikappally",
    "officename": "Thrikkunnapuzha SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690516": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Karthikappally",
    "officename": "Karthikappally SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690517": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Karthikappally",
    "officename": "Karuvatta SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690518": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Karunagappaly",
    "officename": "Karunagappally HO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "690519": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Karunagapally",
    "officename": "Mynagappally SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "690520": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kunnathur",
    "officename": "Poruvazhy SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "690521": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kunnathur",
    "officename": "Sasthamcottah SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "690522": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kunnathur",
    "officename": "Sooranad SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "690523": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Karunagappally",
    "officename": "Thazhava SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "690524": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Karunagappally",
    "officename": "Thevalakkara SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "690525": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Karunagappally",
    "officename": "Clappana SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "690526": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Karunagappally",
    "officename": "Ochira SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "690527": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Karthikappally",
    "officename": "Puthuppally SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690528": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Karunagappally",
    "officename": "Vavvakkavu SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "690529": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Mavelikara",
    "officename": "Padanilam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690530": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Mavelikara",
    "officename": "Thamarakulam SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690531": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Karthikappally",
    "officename": "Puthiyavila SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690532": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Karthikappally",
    "officename": "Chingoli SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690533": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Mavelikara",
    "officename": "Krishnapuram SO Alappuzha",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690534": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Mavelikara",
    "officename": "Chunakara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690535": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Karthikappally",
    "officename": "Kandallur SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690536": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Karunagappally",
    "officename": "Vadakkumthala East SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "690537": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Mavelikkara",
    "officename": "Pullikanakku SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690538": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Karunagappally",
    "officename": "Arinallur SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "690539": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Karunagappally",
    "officename": "S R P Market SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "690540": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kunnathur",
    "officename": "Kunnathur East SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "690542": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Karunagappally",
    "officename": "Athinad North SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "690544": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Karunagappally",
    "officename": "Kulasekharapuram SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "690547": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Karunagappally",
    "officename": "Prayar SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "690548": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Karthikappally",
    "officename": "Kumarapuram SO Alappuzha",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690558": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Mavelikkara",
    "officename": "Mankamkuzhy SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690559": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Karthikappally",
    "officename": "Perungala SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690561": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kunnathur",
    "officename": "Sooranad North SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "690571": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Mavelikkara",
    "officename": "Nooranad Sanatorium SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690572": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Karthikappally",
    "officename": "Kareelakulangara SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690573": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Karunagappally",
    "officename": "Alumkadavu SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "690574": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Karunagappally",
    "officename": "Manappally North SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691001": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Kollam HO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691002": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Asramom SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691003": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Kavanad SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691004": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Kilikollur SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691005": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "T K M College SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691006": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Pallithottam SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691007": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Thangasserry SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691008": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Kadappakada SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691009": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Thevally SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691010": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Vadakkevila SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691011": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Eravipuram SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691012": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Thirumullavaram SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691013": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Kollam Cutchery SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691014": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Chandanathope SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691015": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Mangad SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691016": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Thekkevila SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691019": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Uliyakovil SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691020": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Thattamala SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691021": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Pattathanam SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691301": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Paravur SO Kollam",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691302": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Bhoothakulam SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691303": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Mayyanad SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691304": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Pullichira SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691305": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Pathanapuram",
    "officename": "Punalur HO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "691306": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Pathanapuram",
    "officename": "Anchal SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "691307": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Pathanapuram",
    "officename": "Edamon SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "691308": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Pathanapuram",
    "officename": "Thenmala SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "691309": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Pathanapuram",
    "officename": "Kalthuruthy SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "691310": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Pathanapuram",
    "officename": "Kulathupuzha SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "691311": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Pathanapuram",
    "officename": "Channapettah SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "691312": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Pathanapuram",
    "officename": "Eroor SO Kollam",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "691319": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Thekkumbhagom SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691322": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Pathanapuram",
    "officename": "Elampal SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "691331": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Pathanapuram",
    "officename": "Valacode SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "691332": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Pathanapuram",
    "officename": "Punalur Paper Mills SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "691333": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Pathanapuram",
    "officename": "Tholicode SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "691334": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Nedungolam SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691500": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "West Kallada SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691501": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Kundara SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691502": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "East Kallada SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691503": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Mulavana SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691504": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Perumpuzha SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691505": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kottarakkara",
    "officename": "Ezhukone SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691506": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kottarakara",
    "officename": "Kottarakara HO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691507": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kottarakkara",
    "officename": "Puthurkollam SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691508": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Pathanapuram",
    "officename": "Kunnicode SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "691509": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kottarakara",
    "officename": "Kuzhimathicaud SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691510": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kottarakkara",
    "officename": "Oyur SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691511": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Vellimon SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691512": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kottarakkara",
    "officename": "Odanavattom SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691515": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Nallila SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691516": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kottarakkara",
    "officename": "Karingannur SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691520": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kottarakkara",
    "officename": "Cheppara SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691521": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kottarakara",
    "officename": "Kulakada SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691522": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Pathanapuram",
    "officename": "Pattazhy SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "691523": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Adur",
    "officename": "Adur Kla HO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "691524": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Adur",
    "officename": "Elamannur SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "691525": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Adoor",
    "officename": "Thattayil SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "691526": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Adur",
    "officename": "Enathu SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "691530": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Adoor",
    "officename": "Mannady SO Pathanamthitta",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "691531": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kottarakkara",
    "officename": "Pulamon SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691532": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kottarakkara",
    "officename": "Valakom SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691533": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kottarakkara",
    "officename": "Ayur SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "691534": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kottarakkara",
    "officename": "Chadayamangalam SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691535": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kottarakkara",
    "officename": "Nilamel SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691536": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kottarakkara",
    "officename": "Kadakkal SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691537": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kottarakkara",
    "officename": "Pooyapally SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691538": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kottarakkara",
    "officename": "Vettikavala SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691540": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kottarakara",
    "officename": "Veliyam SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691541": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kottarakkara",
    "officename": "Madathara SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691543": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kottarakkara",
    "officename": "Kaithacode SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691551": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Adoor",
    "officename": "Manakala SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "691552": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kunnathur",
    "officename": "Kadambanad SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "691553": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Adoor",
    "officename": "Kadambanad South SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "691554": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Adoor",
    "officename": "Parakode SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "691555": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Adoor",
    "officename": "Kodumon SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "691556": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Adoor",
    "officename": "Nedumon SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pathanamthitta Division"
  },
  "691557": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kottarakara",
    "officename": "Chengamanad Jn SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691559": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kottarakkara",
    "officename": "Chithara SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691560": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kottarakara",
    "officename": "Kalayapuram SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691566": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kottarakkara",
    "officename": "Pallickalkottarakara SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691571": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Kottiyam SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691572": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kolllam",
    "officename": "Chathannur SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691573": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Adichanallur",
    "officename": "Adichanallur SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691574": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Parippally SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691576": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Kannanallur SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691577": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Mukathala SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691578": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Kalluvathukkal SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691579": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Karamcode SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691581": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Sakthikulangara SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691582": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Karunagapally",
    "officename": "Neendakara SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691583": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Karunagappally",
    "officename": "Chavara SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691584": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Karunagapally",
    "officename": "Chavara South SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691585": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Karunagappally",
    "officename": "Mukundapuram SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691589": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Umayanallur I E SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691590": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Karunagappally",
    "officename": "Koivila SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691601": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Perinad SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691602": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Kollam",
    "officename": "Kanjavely SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "695001": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Thiruvananthapuram GPO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695002": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Karamana SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695003": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Kaudiar SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695004": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Trivandrum",
    "officename": "Pattom Palace SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695005": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Perurkada SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695006": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Tirumala SO Thiruvananthapuram",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695007": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Thiruvananthapuram  Beach SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695008": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Vallakkadavoo SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695009": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Manacaud SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695010": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Sasthamangalam SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695011": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Thiruvananthapuram  Medical College SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695012": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Poojapura HO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695013": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Nedumangad",
    "officename": "Vattiyoorkavu SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695014": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Thycaud SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695015": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Trivendrum",
    "officename": "Nalanchira SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695016": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Thiruvananthapuram  Engg College SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695017": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Sreekaryam SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695018": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Pappanamcode SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695019": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Industrial Estate SO Thiruvananthapuram",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695020": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Nemom SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695021": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Karikkakom SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695022": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Thiruvananthapuram  ISRO SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695023": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Thiruvananthapuram  Fort SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695024": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Thiruvananthapuram  Pettah SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695025": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Muttada SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695026": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Poonthura SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695027": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Thiruvallom SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695028": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Nedumangad",
    "officename": "Vattappara SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695029": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Anayara SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695030": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Kanjirampara SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695032": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Aramada SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695033": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Vikas Bhavan SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695034": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Thiruvananthapuram  University SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695035": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Vanchiyur SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695036": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Thiruvananthapuram  Chalai SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695038": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "PTP Nagar SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695040": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Kaimanam SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695042": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Kalliyoor SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695043": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Nedumangad",
    "officename": "Kudappanakunnu SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695099": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Kerala Governors Camp SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695101": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Chirayinkeezhu",
    "officename": "Attingal HO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695102": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Chirayinkeezhu",
    "officename": "Alamcode SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695103": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "chirayinkeezhu",
    "officename": "Avanavancherry SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695104": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Chirayinkeezhu",
    "officename": "Kizhuvalam SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695121": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Neyyattinkara",
    "officename": "Neyyattinkara HO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695122": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Neyyattinkara",
    "officename": "Amaravila SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695123": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Neyyattinkara",
    "officename": "Aralumoodu SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695124": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Neyyattinkara",
    "officename": "Perumkadavila SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695125": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Neyyattinkara",
    "officename": "Ottasekharamangalam SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695126": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Neyyattinkara",
    "officename": "Perumpazhuthoor SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695132": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Neyyattinkara",
    "officename": "Chenkal SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695133": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Neyyattinkara",
    "officename": "Tirupuram SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695134": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Neyyattinkara",
    "officename": "Vlathankara SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695141": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Chirayinkeezhu",
    "officename": "Varkala SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695142": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Chirayinkeezhu",
    "officename": "Cherunniyur SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695143": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Chirayinkeezhu",
    "officename": "Vadasserikonam SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695144": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Chirayinkeezhu",
    "officename": "Moongode SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695145": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Chirayinkeezhu",
    "officename": "Sreenivasapuram SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695146": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Chirayinkeezhu",
    "officename": "Palayamkunnu SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695301": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Kaniyapuram SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695302": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Murukumpuzhaa SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695303": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Chirayinkeezhu",
    "officename": "Puthencurichy SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695304": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Chirayinkeezhu",
    "officename": "Chirayinkeezhu SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695305": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Chirayinkeezhu",
    "officename": "Perunguzhi SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695306": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Chirayinkeezhu",
    "officename": "Kadakkavur SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695307": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Chirayinkeezhu",
    "officename": "Nedunganda SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695308": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Chirayinkeezhu",
    "officename": "Vakkom SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695309": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Chirayinkeezhu",
    "officename": "Anjengo SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695310": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Chirayinkeezhu",
    "officename": "Ayroorvarkala SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695311": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Chirayinkeezhu",
    "officename": "Edava SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695312": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Melvettoor SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695313": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Chirayinkeezhu",
    "officename": "Kudavur SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695316": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Pallipuram SO Thiruvananthapuram",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695317": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Thonnakkal SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695318": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Chirayinkeezhu",
    "officename": "Vennicode SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695501": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Neyyattinkara",
    "officename": "Balaramapuram SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695502": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Neyyattinkara",
    "officename": "Parassala SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695503": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Neyyattinkara",
    "officename": "Dhanuvachapuram SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695504": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Neyyattinkara",
    "officename": "Karakonam SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695505": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Neyyattinkara",
    "officename": "Vellarada SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695506": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Neyyattinkara",
    "officename": "Uchakada SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695507": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Neyyattinkara",
    "officename": "Ooruttambalam SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695508": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Neyyattinkara",
    "officename": "Parasuvaickal SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695512": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Neyyattinkara",
    "officename": "Kuvalassery SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695513": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Neyyattinkara",
    "officename": "Pozhiyoor SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695521": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Neyyattinkara",
    "officename": "Vizhinjam SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695522": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Vellayani SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695523": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Neyyattinkara",
    "officename": "Venganur SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695524": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Neyyattinkara",
    "officename": "Kanjiramkulam SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695525": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Neyyattinkara",
    "officename": "Puvar SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695526": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Neyyattinkara",
    "officename": "Pulluvila SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695527": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Kovalam SO Thiruvananthapuram",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695528": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Neyyattinkara",
    "officename": "Naruvamoodu SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695541": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Nedumangad",
    "officename": "Nedumangad SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695542": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Nedumangad",
    "officename": "Aryanad SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695543": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Nedumangad",
    "officename": "Vellanad SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695547": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Nedumangad",
    "officename": "Valiamala SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695551": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Nedumangad",
    "officename": "Vithura SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695561": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Nedumangad",
    "officename": "Pazhakutty SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695562": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Nedumangad",
    "officename": "Pacha SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695563": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Nedumangad",
    "officename": "Peringamala SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695564": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Nedumangad",
    "officename": "Karakulam SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695568": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Nedumangad",
    "officename": "Panavoor SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695571": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Neyyattinkara",
    "officename": "Malayinkil SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695572": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Neyyattinkara",
    "officename": "Kattakada SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695573": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Neyyattinkara",
    "officename": "Peyad SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695574": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Nedumangad",
    "officename": "Kuttichal SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695575": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Nedumangad",
    "officename": "Poovachal SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "695581": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Karyavattom SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695582": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Kazhakuttam SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695583": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Kulathur SO Thiruvananthapuram",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695584": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Chirayinkil",
    "officename": "Pothencode SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695585": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Sainik School SO Thiruvananthapuram",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695586": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "StXaviers College SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695587": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Chempazhanthy SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695588": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Tiruvanathapuram",
    "officename": "Powdikonam",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695589": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Thiruvananthapuram",
    "officename": "Santhigiri SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695601": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Chirayinkeezhu",
    "officename": "Kilmanur SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695602": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Chirayinkeezhu",
    "officename": "Madavoorpallickal SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695603": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Chirayinkeezhu",
    "officename": "Navaikulam SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695604": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Chirayinkeezhu",
    "officename": "Pallickal Kilimanur SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695605": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Chirayinkeezhu",
    "officename": "Kallambalam SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695606": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Nedumangad",
    "officename": "Vamanapuram SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695607": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Nedumangad",
    "officename": "Venjaramoodu SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695608": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Chirayinkeezhu",
    "officename": "Kallara SO Thiruvananthapuram",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695609": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Nedumangad",
    "officename": "Pangode SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695610": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Nedumangad",
    "officename": "Mithirmala SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695611": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Chirayinkeezhu",
    "officename": "Manambur SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695612": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Chirayinkil",
    "officename": "Pulimath SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695614": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Chirayinkeezhu",
    "officename": "Thattathumala SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695615": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Nedumangad",
    "officename": "Vembayam SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "700001": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "KOLKATA GPO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata GPO Division"
  },
  "700002": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Cossipore HO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata North Division"
  },
  "700003": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Baghbazar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata North Division"
  },
  "700004": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Shyambazar Mail SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata North Division"
  },
  "700005": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Hatkhola SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata North Division"
  },
  "700006": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Beadon Street SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata North Division"
  },
  "700007": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Barabazar H O",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata North Division"
  },
  "700008": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Barisha SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700009": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Parsibagan",
    "officename": "Raja Ram Mohan Sarani SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata East Division"
  },
  "700010": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Beleghata",
    "officename": "Beleghata HO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata East Division"
  },
  "700011": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Narkeldanga",
    "officename": "Narkeldanga SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata East Division"
  },
  "700012": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Bowbazar SO Kolkata",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata Central Division"
  },
  "700013": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Dharmatala SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata Central Division"
  },
  "700014": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Intally SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata East Division"
  },
  "700015": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Tangra SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata East Division"
  },
  "700016": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Park Street HO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata Central Division"
  },
  "700017": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Circus Avenue",
    "officename": "Circus Avenue SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata East Division"
  },
  "700018": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Bartala SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700019": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Ballygunge SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700020": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "LRSarani SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700021": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Fort William SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata Central Division"
  },
  "700022": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Hastings SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700023": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Khiddirpore SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700024": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Garden Reach SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700025": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Bhawanipore SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700026": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Kalighat SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700027": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Alipore HO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700028": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Dumdum SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata North Division"
  },
  "700029": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Sarat Bose Road SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700030": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Ghugudanga SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata North Division"
  },
  "700031": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Dhakuria SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700032": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Jadavpur University SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700033": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Tollygunge HO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700034": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Behala SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700035": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Alambazar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata North Division"
  },
  "700036": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Baranagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata North Division"
  },
  "700037": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Belgachia SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata North Division"
  },
  "700038": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Sahapur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700039": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Bediadanga",
    "officename": "Tiljala SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata East Division"
  },
  "700040": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Regent Park SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700041": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Paschim Putiari SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700042": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Kasba SO Kolkata",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700043": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "South Eastern Railway SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700044": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Badartala SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700045": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Lake Gardens SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700046": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "A. C Lane",
    "officename": "Gobinda Khatick Road SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata East Division"
  },
  "700047": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Naktala SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700048": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Patipukur",
    "officename": "Sreebhumi SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata East Division"
  },
  "700049": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "North 24 Paraganas",
    "officename": "Nimta SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "700050": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Sinthee SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata North Division"
  },
  "700051": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "North 24 Paraganas",
    "officename": "Birati SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "700052": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Kolkata Airport SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata North Division"
  },
  "700053": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "New Alipore SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700054": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kankurgachi",
    "officename": "Kankurgachi SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata East Division"
  },
  "700055": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Jessore Road",
    "officename": "Bangur Avenue SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata East Division"
  },
  "700056": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Belgharia",
    "officename": "Belgharia HO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "700057": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "North 24 Paraganas",
    "officename": "Ariadaha SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "700058": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Barrackpore",
    "officename": "Kamarhati SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "700059": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "D B Nagr",
    "officename": "Desh Bandhu Nagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata East Division"
  },
  "700060": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Parnasree Pally SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700061": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Sarsoona SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700062": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "West Bengal Governors Camp SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata Central Division"
  },
  "700063": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Thakurpukur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700064": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Sakltlake",
    "officename": "Bidhannagr CC Block SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata East Division"
  },
  "700065": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Rabindra Nagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata North Division"
  },
  "700066": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Bidhangarh SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700067": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Ultadanga Main Road SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata North Division"
  },
  "700068": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Jodhpur Park SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700069": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Esplanade SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata Central Division"
  },
  "700070": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Budge Budge - I",
    "officename": "Bansdroni SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "700071": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Middleton Row SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata Central Division"
  },
  "700072": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Princep Street SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata Central Division"
  },
  "700073": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Chittaranjan Avenue SO Kolkata",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata Central Division"
  },
  "700074": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Motijheel SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata North Division"
  },
  "700075": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Santoshpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700076": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "North 24 Paraganas",
    "officename": "Dakshineswar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "700077": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Bediapara SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata North Division"
  },
  "700078": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Haltu SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700079": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "North 24 Paraganas",
    "officename": "Italghacha SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "700080": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Mall Road SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata North Division"
  },
  "700081": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "North 24 Paraganas",
    "officename": "Rajbari Colony SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "700082": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Haridevpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700083": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "North 24 Parganas",
    "officename": "Nandan Nagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "700084": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Garia SO South 24 Parganas",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "700085": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "KG Bose Sarani SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata East Division"
  },
  "700086": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Baghajatin SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700087": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "New Market SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata Central Division"
  },
  "700088": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Brace Bridge SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700089": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "North 24 Pgs",
    "officename": "Lake Town SO North 24 Parganas",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata East Division"
  },
  "700090": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Noapara SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata North Division"
  },
  "700091": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Saltlake",
    "officename": "Sech Bhawan SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata East Division"
  },
  "700092": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Regent Estate SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700093": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Purba Putiary SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "700094": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Panchasayar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700095": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Golf Green SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700096": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Brahmapur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "700097": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Saltklake",
    "officename": "Purbachal SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata East Division"
  },
  "700099": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Mukundapur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700100": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Vip Nagar",
    "officename": "Vip Nagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata East Division"
  },
  "700101": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "North 24 Pgs",
    "officename": "Prafulla Kanan SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata East Division"
  },
  "700102": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "North 24 Pgs",
    "officename": "Krishnapur SO North 24 Parganas",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata East Division"
  },
  "700103": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Narendrapur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "700104": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Bishnupur - I",
    "officename": "Joka SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "700105": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Dhapa",
    "officename": "Dhapa SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata East Division"
  },
  "700106": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Saltlake",
    "officename": "Bidhan Nagar IB Market SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata East Division"
  },
  "700107": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "Madurdaha SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "South Kolkata Division"
  },
  "700108": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "Kolkata",
    "officename": "ISI PO SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata North Division"
  },
  "700109": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "North 24 Paraganas",
    "officename": "Agarpara SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "700110": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Barrackpore",
    "officename": "Sodepur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "700111": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "North 24 Paraganas",
    "officename": "Ghola Bazar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "700112": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Barrackpur - I",
    "officename": "Pansila SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "700113": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Barrackpur - I",
    "officename": "Natagarh SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "700114": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "North 24 Paraganas",
    "officename": "Panihati SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "700115": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "North 24 Paraganas",
    "officename": "Sukchar SO North 24 Parganas",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "700116": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "North 24 Paraganas",
    "officename": "BDSopan SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "700117": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Barrackpore",
    "officename": "Khardah SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "700118": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "North 24 Paraganas",
    "officename": "Rahara SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "700119": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Barrackpur - I",
    "officename": "Titagarh SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "700120": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Barrackpore",
    "officename": "Barrackpore HO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "700121": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Barrackpur - I",
    "officename": "Nilganj Bazaar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "700122": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Barrackpore",
    "officename": "Nonachandanpukur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "700123": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Barrackpur - I",
    "officename": "Talpukur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "700124": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Barasat - I",
    "officename": "Barasat HO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "700125": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Kadambagachi",
    "officename": "Noapara SO North 24 Parganas",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "700126": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Bodai",
    "officename": "Nabapally SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "700127": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Barasat - I",
    "officename": "Hridaypur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "700128": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Barasat - I",
    "officename": "Badu SO North 24 Parganas",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "700129": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Barasat - II",
    "officename": "Madhyamgram SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "700130": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Barrackpur - II",
    "officename": "Madhyamgram Bazar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "700131": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Habra - I",
    "officename": "Newbarrackpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "700132": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Barasat - II",
    "officename": "Ganganagar SO North 24 Parganas",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "700133": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Barasat - II",
    "officename": "Michealnagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "700134": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "North 24 Paraganas",
    "officename": "Nilachal SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "700135": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Akandakeshari",
    "officename": "Rajarhat SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "700136": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Rajarhat",
    "officename": "Rajarhat Gopalpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "700137": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Budge Budge - II",
    "officename": "Budge Budge SO Hsgii SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "700138": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Gosaba",
    "officename": "Pujali SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "700139": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Vivekananda Pally SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "700140": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Batanagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "700141": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Mahestala SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "700142": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Santosh Pur Maheshtalaso SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "700143": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Sarkarpool SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "700144": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Baruipur",
    "officename": "Baruipur HO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "700145": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sonarpur",
    "officename": "Malancha Mahinagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "700146": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Kodalia SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "700147": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Subhas Gram SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "700148": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Harinavi SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "700149": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Rajpur SO South 24 Parganas",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "700150": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Sonarpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "700151": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Dakshin Jagatdal SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "700152": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Panchpota SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "700153": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Laskar Pur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "700154": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Boral SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "700155": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Amdanga",
    "officename": "Abdalpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "700156": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "New Town",
    "officename": "New Town SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata East Division"
  },
  "700157": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "North 24 Pgs",
    "officename": "Hatiara SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata East Division"
  },
  "700158": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Barrackpur - I",
    "officename": "Bisharpara SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "700159": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Deshbandhunagar",
    "officename": "Aswini Nagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata East Division"
  },
  "700160": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Barrackpur - I",
    "officename": "New Town Action Area III",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata East Division"
  },
  "711101": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Domjur",
    "officename": "Howrah HO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711102": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Bally Jagachha",
    "officename": "Sibpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711103": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Sankrail",
    "officename": "BGarden SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711104": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Domjur",
    "officename": "Santragachi SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711105": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Domjur",
    "officename": "Dasnagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711106": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Bally Jagachha",
    "officename": "Salkia HO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711107": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Uluberia - I",
    "officename": "Ghusuri SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711108": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Uluberia - I",
    "officename": "Netajigarh SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711109": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Bally Jagachha",
    "officename": "Danesh SkLane SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711110": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Bally Jagachha",
    "officename": "Baksara SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711111": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Uluberia - I",
    "officename": "Jagacha SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711112": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Bally Jagachha",
    "officename": "Gip Colony SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711113": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Bally Jagachha",
    "officename": "Balitikuri SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711114": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Sankrail",
    "officename": "Kona SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711201": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Bally Jagachha",
    "officename": "Bally SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711202": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Domjur",
    "officename": "Belur Math SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711203": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Sankrail",
    "officename": "Bhattanagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711204": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Bally Jagachha",
    "officename": "Liluah SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711205": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Bally Jagachha",
    "officename": "Samabaypalli SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711225": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Howrah",
    "officename": "Pancharul SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711226": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Domjur",
    "officename": "Udaynarayanpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711227": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Bally Jagachha",
    "officename": "Ghoshpara SO Howrah",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711301": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Howrah",
    "officename": "Anantapur SO Howrah",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711302": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Howrah",
    "officename": "Andul mouri SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711303": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Howrah",
    "officename": "Bagnan SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711304": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Sankrail",
    "officename": "Banipur SO Howrah",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711305": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Howrah",
    "officename": "Bauria SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711306": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Howrah",
    "officename": "Kulgachia SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711307": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Howrah",
    "officename": "Chackasi SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711308": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Domjur",
    "officename": "Chengail SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711309": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Sankrail",
    "officename": "Delta Mil SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711310": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Sankrail",
    "officename": "Fortgloster SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711312": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Howrah",
    "officename": "Mugkalyan SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711313": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Domjur",
    "officename": "Sankrail SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711314": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Domjur",
    "officename": "Shyampur SO Howrah",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711315": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Howrah",
    "officename": "Uluberia SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711316": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Howrah",
    "officename": "Uluberia RS SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711317": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Uluberia - II",
    "officename": "Radhadasi SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711322": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Howrah",
    "officename": "Panchla SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711401": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Howrah",
    "officename": "Amta SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711403": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Bally Jagachha",
    "officename": "Bankra SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711404": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Howrah",
    "officename": "Bargachia SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711405": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Howrah",
    "officename": "Domjur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711408": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Howrah",
    "officename": "Jagatballavpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711409": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Howrah",
    "officename": "Makardaha SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711410": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Howrah",
    "officename": "Munshirhat SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711411": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Howrah",
    "officename": "Begri SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711412": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Howrah",
    "officename": "Chitrasenpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711413": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Howrah",
    "officename": "Gazipur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711414": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Uluberia - II",
    "officename": "Maju SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "712101": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Chinsurah",
    "officename": "Chinsurah HO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712102": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Chinsurah - Magra",
    "officename": "Chinsurah RS SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712103": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Chinsurah - Magra",
    "officename": "Hooghly SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712104": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Chinsurah - Magra",
    "officename": "Sahaganj SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712105": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Chinsurah - Magra",
    "officename": "Buroshibtala SO Hooghly",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712121": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Addconagar",
    "officename": "Addconagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712122": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Goghat-ii",
    "officename": "Badanganj SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712123": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Chinsurah - Magra",
    "officename": "Bandel Junction SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712124": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Chandannagar",
    "officename": "Bhadreswar SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "712125": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Chinsurah - Magra",
    "officename": "Telinipara SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "712134": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Boinchi",
    "officename": "Boinchi SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712135": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Pandua",
    "officename": "Boinchigram SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712136": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Chinsurah - Magra",
    "officename": "Chandannagar SO Hooghly",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "712137": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Chinsurah - Magra",
    "officename": "Gondalpara SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "712138": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Chinsurah - Magra",
    "officename": "Khalisani SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "712139": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Chinsurah - Magra",
    "officename": "Mankundu SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "712146": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Pandua",
    "officename": "Ilsobamondalai SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712147": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Itachuna",
    "officename": "Itachuna SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712148": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Magra",
    "officename": "Magra SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712149": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Pandua",
    "officename": "Pandua SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712152": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Pandua",
    "officename": "Rameswarpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712201": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Serampur Uttarpara",
    "officename": "Serampore HO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "712202": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Serampur Uttarpara",
    "officename": "Mahesh 1 SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "712203": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Serampur Uttarpara",
    "officename": "Mallickpara SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "712204": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Serampur Uttarpara",
    "officename": "Chatra SO Hooghly",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "712221": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Singur",
    "officename": "Angus SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "712222": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Singur",
    "officename": "Baidyabati SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "712223": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Chandannagar",
    "officename": "Sheoraphuli SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "712232": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Serampur Uttarpara",
    "officename": "Bhadrakali SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "712233": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Serampur Uttarpara",
    "officename": "Hindmotor SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "712234": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Serampore",
    "officename": "Kanaipur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "712235": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Serampur Uttarpara",
    "officename": "Konnagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "712245": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Serampur Uttarpara",
    "officename": "Makhla SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "712246": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Serampur Uttarpara",
    "officename": "Nabagram SO Hooghly",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "712248": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Serampur Uttarpara",
    "officename": "Rishra SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "712249": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Serampur Uttarpara",
    "officename": "Prabasnagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "712250": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Serampur Uttarpara",
    "officename": "Morepukur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "712258": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Serampur Uttarpara",
    "officename": "Uttarpara SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "712301": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Dhaniakhali",
    "officename": "Bhandarhati SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712302": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Dhaniakhali",
    "officename": "Dhaniakhali SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712303": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Gurap",
    "officename": "Gurap SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712304": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Serampore",
    "officename": "Janai SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "712305": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Puinan",
    "officename": "Puinan SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712306": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Chanditala - II",
    "officename": "Begampur SO Hooghly",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "712308": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Khanpur",
    "officename": "Khanpur SO Hooghly",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712310": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Serampore",
    "officename": "Dankuni Coal Complex SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "712311": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Serampore",
    "officename": "Dankuni SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "712401": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Chandannagar",
    "officename": "Champadanga SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "712402": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Dasghara",
    "officename": "Dasghara SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712403": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Chandannagar",
    "officename": "Haripal SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "712404": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Jangipara",
    "officename": "Jangipara SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "712405": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Chandannagar",
    "officename": "Khamarchandi SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "712406": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Khanakul-2b",
    "officename": "Khanakul SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712407": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Chandannagar",
    "officename": "Nalikul SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "712408": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Jangipara",
    "officename": "Rajbalhat SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "712409": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Chandannagar",
    "officename": "Singur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "712410": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Chandannagar",
    "officename": "Tarakeswar SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "712412": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Pursurah",
    "officename": "Helan SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712413": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Arambagh",
    "officename": "Mayapur SO Hooghly",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712414": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Pursurah",
    "officename": "Deulpara SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712415": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Pursurah",
    "officename": "Saidpur SO Hooghly",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712416": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Khanakul 2b",
    "officename": "Natibpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712417": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Khanakul 2b",
    "officename": "Rajhati Bandar SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712501": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Balagarh",
    "officename": "Balagarh SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712502": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Bansberia",
    "officename": "Bansberia SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712503": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Chinsurah - Magra",
    "officename": "Tribeni SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712504": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Chinsurah - Magra",
    "officename": "Chandrahati SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712512": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Guptipara",
    "officename": "Guptipara SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712513": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Nayasarai",
    "officename": "Nayasarai SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712514": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Balagarh",
    "officename": "Sripur Bazar SO Hooghly",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712515": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Khamargachi",
    "officename": "Khamargachi SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712601": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Arambagh",
    "officename": "Arambagh HO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712602": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Goghat-i",
    "officename": "Chandur SO Hooghly",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712611": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Goghat - II",
    "officename": "Bengai SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712612": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Goghat-ii",
    "officename": "Kamarpukur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712613": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Arambag",
    "officename": "Gourhati SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712614": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Goghat-ii",
    "officename": "Goghat SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712615": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Arambagh",
    "officename": "Batanal SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712616": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Goghat-i",
    "officename": "Balidewanganj SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712617": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Arambagh",
    "officename": "Baradangal SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly North Division"
  },
  "712701": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Serampore",
    "officename": "Masat Bazar SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "712702": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Serampore",
    "officename": "Chanditala SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "712706": {
    "state": "West Bengal",
    "district": "Hooghly",
    "block": "Serampore",
    "officename": "NEW SEAKHALA SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Hooghly South Division"
  },
  "713101": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Burdwan - I",
    "officename": "Burdwan HO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713102": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Burdwan",
    "officename": "Nutanganj SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713103": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Galsi - I",
    "officename": "Sripalli SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713104": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Burdwan",
    "officename": "Burdwan Rajbati SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713121": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Bhatar",
    "officename": "Aruar SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713122": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Kalna",
    "officename": "Baidyapur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713123": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Ketugram - I",
    "officename": "Banwaribad Raj SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713124": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Burdwan - II",
    "officename": "Barsul Unnayani SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713125": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Bhatar",
    "officename": "Bhatar SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713126": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Ausgram - I",
    "officename": "Bhedia SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713127": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Burdwan - II",
    "officename": "Bonpas SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713128": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Ausgram - I",
    "officename": "Gushkara SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713129": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Ketugram - I",
    "officename": "Kandara SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713130": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Katwa - I",
    "officename": "Katwa HO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713131": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Mangolkote",
    "officename": "Kasemnagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713140": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Katwa",
    "officename": "Ketugram SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713141": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Burdwan - II",
    "officename": "Khana Jn SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713142": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Burdwan",
    "officename": "Khandaghosh SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713143": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Bhatar",
    "officename": "Koychor SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713144": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Gushkara",
    "officename": "Mankar SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713145": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Bhatar",
    "officename": "Monteswar SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713146": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Memari",
    "officename": "Memari SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713147": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Mangolkote",
    "officename": "Nutanhat SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713148": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Burdwan",
    "officename": "Panagar Bazara SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713149": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Burdwan - II",
    "officename": "Saktigarh SO Bardhaman",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713150": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Katwa",
    "officename": "Srikhanda SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713151": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Memari - I",
    "officename": "Rasulpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713152": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Ausgram - I",
    "officename": "Bannabagram SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713153": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Burdwan - II",
    "officename": "Bhatkunda SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713154": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Burdwan - II",
    "officename": "Amadpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713166": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Burdwan",
    "officename": "Nabagram SO Bardhaman",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713201": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Durgapur Municipal Corporation",
    "officename": "Durgapur HO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713202": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Durgapur Mc",
    "officename": "Durgapur Coke Oven Colony SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713203": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Faridpur Durgapur",
    "officename": "Durgapur Steel Project SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713204": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Faridpur Durgapur",
    "officename": "Durgapur Steel Town West SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713205": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Durgapur Mc",
    "officename": "Durgapur Steel Town East SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713206": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Durgapur Mc",
    "officename": "Durgapur Abl Township SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713207": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Durgapur Mc",
    "officename": "Durgapur Thermal Power Station SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713208": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Burdwan - II",
    "officename": "Durgapur Alloy Steel Project SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713209": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Durgapur Mc",
    "officename": "Durgapur Re College SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713210": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Durgapur Mc",
    "officename": "Durgapur Heavy Engg Plant SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713211": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Durgapur Mc",
    "officename": "Durgapur Sagarbhanga Colony SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713212": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Kanksa",
    "officename": "Bidhannagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713213": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Durgapur Mc",
    "officename": "Benachity SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713214": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Durgapur Mc",
    "officename": "Durgapur CRPF Camp SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713215": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Durgapur Mc",
    "officename": "Angadpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713216": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Durgapur Mc",
    "officename": "City Centre SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713217": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Durgapur Mc",
    "officename": "Oyaria SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713301": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Jamuria",
    "officename": "Asansol HO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713302": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Barabani",
    "officename": "Dakhin Dhadka SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713303": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Barabani",
    "officename": "Ushagram SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713304": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Barabani",
    "officename": "U C Danga SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713305": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Barabani",
    "officename": "Ramkrishna Mission SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713315": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Baraboni",
    "officename": "Panuria SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713321": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Andal",
    "officename": "Andal SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713322": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Barabani",
    "officename": "Bahula SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713323": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Pandabeswar",
    "officename": "Ballavpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713324": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Kulti Mc",
    "officename": "Barakar SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713325": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Barabani",
    "officename": "Burnpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713326": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Asansol Mc",
    "officename": "Chotodighari SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713330": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Jamuria",
    "officename": "Charanpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713331": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Barabani",
    "officename": "Chittaranjan SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713332": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Jamuria",
    "officename": "Devchandnagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713333": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Kulti Mc",
    "officename": "Disergarh SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713334": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Baraboni",
    "officename": "Domahani Bazar SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713335": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Salanpur",
    "officename": "Hindustan Cables SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713336": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Jamuriahat",
    "officename": "Jamuriahat SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713337": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Pandabeswar",
    "officename": "Bidhanbag SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713338": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Andal",
    "officename": "Kajoragram SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713339": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Raniganj Mc",
    "officename": "Kalipahari SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713340": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Barabani",
    "officename": "Kalla Central Hospital SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713341": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Baraboni",
    "officename": "Kanyapur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713342": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Pandabeswar",
    "officename": "Kenda SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713343": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Barabani",
    "officename": "Kulti SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713344": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Jamuria",
    "officename": "Nandi SO Bardhaman",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713346": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Pandaveshwr",
    "officename": "Pandaveshwar SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713347": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Andal",
    "officename": "Raniganj HO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713357": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Salanpur",
    "officename": "Salanpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713358": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Barabani",
    "officename": "Searsole Rajbari SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713359": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Kulti Mc",
    "officename": "Sitarampur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713360": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Kulti Mc",
    "officename": "Sunderchak SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713361": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Barabani",
    "officename": "Suryanagar SO Bardhaman",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713362": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Jamuria",
    "officename": "Toposi SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713363": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Laudoha",
    "officename": "Ukhra SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713365": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Salanpur",
    "officename": "Chittaranjan TS SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713369": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Barabani",
    "officename": "Kalyaneshwari SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713370": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Barabani",
    "officename": "Ningha SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713371": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Barabani",
    "officename": "Mithani SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713372": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Barabani",
    "officename": "Radhanagar Rly Colony SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713373": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Jamuria",
    "officename": "Sripur Bazar SO Bardhaman",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713376": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Pandabeswar",
    "officename": "Dhandadihi SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713378": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Jamuria",
    "officename": "Haripur SO Bardhaman",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713381": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Laudoha",
    "officename": "Nutandanga SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713384": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Jamuria",
    "officename": "Parasea SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713385": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Laudoha",
    "officename": "Laudoha SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713386": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Burdwan - II",
    "officename": "Rupnarayanpur Bazar SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Asansol Division"
  },
  "713401": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Burdwan - II",
    "officename": "Ajhapur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713403": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Burdwan - II",
    "officename": "Budbud SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713404": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Memari",
    "officename": "Chakdighi SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713405": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Kalna",
    "officename": "Dhatrigram SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713406": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Burdwan",
    "officename": "Galsi SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713407": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Bhatar",
    "officename": "Hatgobindapur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713408": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Memari",
    "officename": "Jamalpur SO Bardhaman",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713409": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Kalna - II",
    "officename": "Kalna SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713420": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Kanksa",
    "officename": "Panagar SO Bardhaman",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713421": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Raina - II",
    "officename": "Raina SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713422": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Kalna",
    "officename": "Satgachia SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713423": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Burdwan",
    "officename": "Sehara SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713424": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Burdwan",
    "officename": "Shyamsundar SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713426": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Memari",
    "officename": "Mandalgram SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713427": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Raina - II",
    "officename": "Uchalan SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713428": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Galsi - II",
    "officename": "Adrahati SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713502": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Katwa - II",
    "officename": "Dainhat SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713512": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Katwa",
    "officename": "Patuli SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713513": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Kalna",
    "officename": "Purbasthali SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713514": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Katwa",
    "officename": "Singhi SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713515": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Purbasthali - I",
    "officename": "Nadanghat SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713519": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Memari",
    "officename": "Samudragarh SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "713520": {
    "state": "West Bengal",
    "district": "Bardhaman",
    "block": "Burdwan - II",
    "officename": "Nityanandapur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "721101": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Midnapore",
    "officename": "Midnapore HO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721102": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Midnapore",
    "officename": "Vidyasagar University SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721121": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Garhbeta-I",
    "officename": "Amlagora SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721122": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Midnapore",
    "officename": "Anandapur SO West Midnapore",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721124": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Ballichak",
    "officename": "Ballichak SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721125": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Baligeria",
    "officename": "Baligeria SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721126": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Kharagpur",
    "officename": "Debra Bazar SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721127": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Garhbeta-III",
    "officename": "Garhbeta SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721128": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Garhbeta-II",
    "officename": "Goaltore SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721129": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Salboni",
    "officename": "Godapeasal SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721130": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Daspur",
    "officename": "Gopalnagar SO East Midnapore",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721131": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Panskura-I",
    "officename": "Hour SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721132": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Salboni",
    "officename": "Reserve Bank Nm Ltd SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721133": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Amda",
    "officename": "Keshiary SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721134": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Panskura",
    "officename": "Kolaghat SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721135": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Bakrachak",
    "officename": "Kultikri SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721136": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Kharagpur",
    "officename": "Lowada SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721137": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Sahid Matangini",
    "officename": "Mechada SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721139": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Panskura-i",
    "officename": "Panskura SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721140": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Pingla",
    "officename": "Pingla SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721143": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Andhari",
    "officename": "Rohini SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721144": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Sabang",
    "officename": "Sabang SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721145": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Midnapore",
    "officename": "Salua SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721146": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Ghatal",
    "officename": "Sekendari SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721147": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Midnapore",
    "officename": "Shalboni SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721148": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Daspur",
    "officename": "Kheput SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721149": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Kharagpur",
    "officename": "Madpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721150": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Midnapore",
    "officename": "Keshpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721151": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Panskura-ii",
    "officename": "Bhogpur SO East Midnapore",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721152": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Panskura",
    "officename": "Panskura RS SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721153": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Panskura",
    "officename": "Joteghanashyam SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721154": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Panskura",
    "officename": "Pulsita SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721155": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Pingla",
    "officename": "Jalchak SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721156": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Midnapore",
    "officename": "Marhtala SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721157": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Midnapore",
    "officename": "Hoomgarh SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721158": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Panskura-ii",
    "officename": "Baishnabchak SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721159": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Jharia",
    "officename": "Kharikamathani SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721160": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Debra",
    "officename": "Radhamohanpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721161": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Midnapore",
    "officename": "Mohar SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721166": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Sabang",
    "officename": "Lutunia SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721171": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Sahid Matangini",
    "officename": "Ktpp TS SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721172": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Sahid Matangini",
    "officename": "Nonakuribazar SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721201": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Garhbeta-III",
    "officename": "Chandrakona SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721211": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Ghatal",
    "officename": "Daspur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721212": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Midnapore",
    "officename": "Ghatal SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721222": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Binpur-I",
    "officename": "Kharar SO West Midnapore",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721232": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Midnapore",
    "officename": "Khirpai SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721242": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Kharagpur",
    "officename": "Ramjibanpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721253": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Garhbeta-I",
    "officename": "Satbankura SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721260": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Midnapore",
    "officename": "Neradeul SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721301": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Kharagpur-I",
    "officename": "Kharagpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721302": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Midnapore",
    "officename": "Kharagpur Technology SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721303": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Midnapore",
    "officename": "Kalaikunda A F SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721304": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Kharagpur",
    "officename": "Nimpura SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721305": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Midnapore",
    "officename": "Inda SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721306": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Kharagpur-I",
    "officename": "Hijli SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721401": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Ajodhyapur",
    "officename": "Contai HO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721420": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Alangiri",
    "officename": "Baita Bazar SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721422": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Astichak",
    "officename": "Balighai SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721423": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Balisai",
    "officename": "Balisai SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721424": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Akanda",
    "officename": "Belda SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721425": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Basuli Bazar",
    "officename": "Bhupatinagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721426": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Angua",
    "officename": "Dantan SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721427": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Amtalia",
    "officename": "Deulbarh SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721428": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Digha",
    "officename": "Digha SO East Midnapore",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721429": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Baranihary",
    "officename": "Egra SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721430": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Ajoya",
    "officename": "Haria SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721431": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Baratala",
    "officename": "Janka SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721432": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Baharganj",
    "officename": "Kalagachia SO East Midnapore",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721433": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Battala",
    "officename": "Khalisabhanga SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721434": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Barmakhal",
    "officename": "Manglamaro SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721435": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Chhoto Srikrishnapur",
    "officename": "Menkapur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721436": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Amarda",
    "officename": "Mohanpur SO West Midnapore",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721437": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Bahurupa",
    "officename": "Narayangarh SO West Midnapore",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721438": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Chandanpur",
    "officename": "Panchetgarh SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721439": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Alamchak Belda",
    "officename": "Patashpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721440": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Ballyagobindapur",
    "officename": "Pratapdighi SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721441": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Alankarpur",
    "officename": "Ramnagar SO East Midnapore",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721442": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Baikunthapur",
    "officename": "Basantia SO East Midnapore",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721443": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Bandhuchak",
    "officename": "Jahalda SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721444": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Analberia",
    "officename": "Nachinda Bazar SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721445": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Asda",
    "officename": "Khakurda SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721446": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Aswathapur",
    "officename": "Sagareswar SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721447": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Kalyanpur Tentulmuri",
    "officename": "Panchrol SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721448": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Barada Bazar",
    "officename": "Paniparul SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721449": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Banamalichatta",
    "officename": "Marisda SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721450": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Barabantalia",
    "officename": "Junput SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721451": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Bakurpada",
    "officename": "Nekurseni SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721452": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Basudebpur",
    "officename": "Satmile SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721453": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Depal",
    "officename": "Depal SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721454": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Alukaranbarh",
    "officename": "Amarshi SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721455": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Bhuniajibarh",
    "officename": "Chaulkhola SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721456": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Argoal",
    "officename": "Argoal SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721457": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Akpura",
    "officename": "Gomunda SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721458": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Bankibheri",
    "officename": "Palpara SO East Midnapore",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721463": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Digha",
    "officename": "Digha New Township SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721467": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Adasimla",
    "officename": "Dasagram SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721501": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Jhargram",
    "officename": "Belpahari SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721503": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Jamboni",
    "officename": "Chilkigarh SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721504": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Binpur-I",
    "officename": "Dahijuri SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721505": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Jhargram",
    "officename": "Gidni SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721506": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Jhargram",
    "officename": "Gopi Ballavpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721507": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Jhargram",
    "officename": "Jhargram HO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721513": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Jhargram",
    "officename": "Manikpara SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721514": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Jhargram",
    "officename": "Sevayatan SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721515": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Midnapore",
    "officename": "Silda SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721516": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Binpur-I",
    "officename": "Lalgarh SO West Midnapore",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721517": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Jhargram",
    "officename": "Tapsia SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Midnapore Division"
  },
  "721601": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Bhagawanpur",
    "officename": "Bhagwanpur SO East Midnapore",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721602": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Sutahata",
    "officename": "Durgachak SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721603": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Mahisadal",
    "officename": "Geonkhali SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721604": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Haldia Municipality",
    "officename": "Haldia SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721606": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Haldia Municipality",
    "officename": "Haldia OR SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721607": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Haldia Municipality",
    "officename": "Haldia TS SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721625": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Reapara",
    "officename": "Hanschara SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721626": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Kajlagarh",
    "officename": "Kajlagarh SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721627": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Tamkluk-i",
    "officename": "Kelomal SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721628": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Mahisadal",
    "officename": "Mahisadal SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721629": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Moyna",
    "officename": "Moyna SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721631": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Nandigram-i",
    "officename": "Nandigram SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721632": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Nandakumar",
    "officename": "Nandakumar SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721633": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Nandigram-iii",
    "officename": "Narghat SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721634": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Panskura",
    "officename": "Raghunathbari SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721635": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Sutahata",
    "officename": "Sutahata SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721636": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Tamluk-i",
    "officename": "Tamluk HO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721641": {
    "state": "West Bengal",
    "district": "West Midnapore",
    "block": "Khukurdaha",
    "officename": "Khukurdaha SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721642": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Arankiarana",
    "officename": "Arankiarana SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721643": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Nandakumar",
    "officename": "Khanchi SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721644": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Moyna",
    "officename": "Paramanandapur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721645": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Haldia Municipality",
    "officename": "Chaitannyapur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721646": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Nandigram",
    "officename": "Tekhalibazar SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721647": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Moyna",
    "officename": "Ramchandrapur SO East Midnapore",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721648": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Nandakumar",
    "officename": "Byabattarhat SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721649": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Tamluk-i",
    "officename": "Mirikpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721650": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Reapara",
    "officename": "Reapara SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721651": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Moyna",
    "officename": "Srirampur Mid SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721652": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Nandakumar",
    "officename": "Kumarchak SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721653": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Tamluk",
    "officename": "Chanserpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721654": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Mahisadal",
    "officename": "Lakshya SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721655": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Kajlagarh",
    "officename": "Kismatbajkul SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721656": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Nandigram",
    "officename": "Terapakhia SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721657": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Haldia Municipality",
    "officename": "Debhog SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721658": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Sutahata",
    "officename": "Kukrahati SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721659": {
    "state": "West Bengal",
    "district": "East Midnapore",
    "block": "Nandigram-iii",
    "officename": "Mathchandipur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "722101": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Bankura - I",
    "officename": "Bankura HO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722102": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Bankura - I",
    "officename": "Kenduadihi SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722121": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Indpur",
    "officename": "Bheduasole SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722122": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Vishnupur",
    "officename": "Bishnupur SO Bankura",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722132": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Saltora",
    "officename": "Chhatna SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722133": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Gangajalghati",
    "officename": "Gangajalghati SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722134": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Raipur",
    "officename": "Garhraipur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722135": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Ranibandh",
    "officename": "Gorabari SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722136": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Indpur",
    "officename": "Indpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722137": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Chhatna",
    "officename": "Jhantipahari SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722138": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Jaypur",
    "officename": "Joypur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722139": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Chhatna",
    "officename": "Kenjakura SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722140": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Khatra",
    "officename": "Khatra SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722141": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Kotalpur",
    "officename": "Kotalpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722142": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Mejia",
    "officename": "Maliara SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722143": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Mejhia",
    "officename": "Mejhia SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722144": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Onda",
    "officename": "Onda SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722146": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Bankura",
    "officename": "Rajagram SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722147": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Onda",
    "officename": "Ramsagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722148": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Ranibundh",
    "officename": "Ranibandh SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722149": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Taldangra",
    "officename": "Sabrakone SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722150": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Sarenga",
    "officename": "Sarenga SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722151": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Raipur",
    "officename": "Simlapal SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722152": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Taldangra",
    "officename": "Taldangra SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722153": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Saltora",
    "officename": "Tiluri SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722154": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Khatra",
    "officename": "Gelia SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722155": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Bankura - II",
    "officename": "Kesiakole SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722156": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Taldangra",
    "officename": "Panchmura SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722157": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Bishnupur",
    "officename": "Bonradhanagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722158": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Saltora",
    "officename": "Saltora SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722160": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Simlapal",
    "officename": "Lakshmisagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722161": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Kotulpur",
    "officename": "Jayrambati SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722162": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Raipur",
    "officename": "Fulkusma SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722164": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Vishnupur",
    "officename": "Bankadaha SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722173": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Indpur",
    "officename": "Jorda SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722176": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Bankura",
    "officename": "Narrah S.O.",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722183": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Gangajalghati",
    "officename": "Mejia Th Power Station SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722201": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Indus",
    "officename": "Akui SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722202": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Barjora",
    "officename": "Barjora SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722203": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Barjora",
    "officename": "Beliatore SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722204": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Barjora",
    "officename": "Hatasuria SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722205": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Indas",
    "officename": "Indas SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722206": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Patrasayer",
    "officename": "Patrasayer SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722207": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Sonamukhi",
    "officename": "Sonamukhi SO Bankura",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "722208": {
    "state": "West Bengal",
    "district": "Bankura",
    "block": "Sonamukhi",
    "officename": "Pakhanna SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Bankura Division"
  },
  "723101": {
    "state": "West Bengal",
    "district": "Puruliya",
    "block": "Purulia - I",
    "officename": "Purulia HO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Purulia Division"
  },
  "723102": {
    "state": "West Bengal",
    "district": "Puruliya",
    "block": "Purulia",
    "officename": "Dulminadiha SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Purulia Division"
  },
  "723103": {
    "state": "West Bengal",
    "district": "Puruliya",
    "block": "Chharrah",
    "officename": "Namopara SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Purulia Division"
  },
  "723104": {
    "state": "West Bengal",
    "district": "Puruliya",
    "block": "Purulia - I",
    "officename": "Sainik School SO Puruliya",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Purulia Division"
  },
  "723121": {
    "state": "West Bengal",
    "district": "Puruliya",
    "block": "Adra",
    "officename": "Adra SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Purulia Division"
  },
  "723126": {
    "state": "West Bengal",
    "district": "Puruliya",
    "block": "Anara",
    "officename": "Anara RS SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Purulia Division"
  },
  "723127": {
    "state": "West Bengal",
    "district": "Puruliya",
    "block": "Barabhum",
    "officename": "Barabhum SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Purulia Division"
  },
  "723128": {
    "state": "West Bengal",
    "district": "Puruliya",
    "block": "Puncha",
    "officename": "Balakdih SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Purulia Division"
  },
  "723129": {
    "state": "West Bengal",
    "district": "Puruliya",
    "block": "Bundwan",
    "officename": "Bundwan SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Purulia Division"
  },
  "723130": {
    "state": "West Bengal",
    "district": "Puruliya",
    "block": "Hura",
    "officename": "Hura SO Puruliya",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Purulia Division"
  },
  "723131": {
    "state": "West Bengal",
    "district": "Puruliya",
    "block": "Manbazar - II",
    "officename": "Manbazar SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Purulia Division"
  },
  "723132": {
    "state": "West Bengal",
    "district": "Puruliya",
    "block": "Kashipur",
    "officename": "Panchakotraj SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Purulia Division"
  },
  "723133": {
    "state": "West Bengal",
    "district": "Puruliya",
    "block": "Raghuathpur",
    "officename": "Raghunathpur SO Puruliya",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Purulia Division"
  },
  "723142": {
    "state": "West Bengal",
    "district": "Puruliya",
    "block": "Santuri",
    "officename": "Ramchandrapur Ashram SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Purulia Division"
  },
  "723143": {
    "state": "West Bengal",
    "district": "Puruliya",
    "block": "Balarampur",
    "officename": "Rangadih SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Purulia Division"
  },
  "723145": {
    "state": "West Bengal",
    "district": "Puruliya",
    "block": "Santaldih",
    "officename": "Santaldih SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Purulia Division"
  },
  "723146": {
    "state": "West Bengal",
    "district": "Puruliya",
    "block": "Para",
    "officename": "Santaldih TP SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Purulia Division"
  },
  "723147": {
    "state": "West Bengal",
    "district": "Puruliya",
    "block": "Purulia",
    "officename": "Vivekananda Nagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Purulia Division"
  },
  "723148": {
    "state": "West Bengal",
    "district": "Puruliya",
    "block": "Hutmura",
    "officename": "Hutmura SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Purulia Division"
  },
  "723149": {
    "state": "West Bengal",
    "district": "Puruliya",
    "block": "Purulia",
    "officename": "Manguria SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Purulia Division"
  },
  "723151": {
    "state": "West Bengal",
    "district": "Puruliya",
    "block": "Puncha",
    "officename": "Puncha SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Purulia Division"
  },
  "723152": {
    "state": "West Bengal",
    "district": "Puruliya",
    "block": "Bagmundi",
    "officename": "Bagmundi SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Purulia Division"
  },
  "723153": {
    "state": "West Bengal",
    "district": "Puruliya",
    "block": "Sirkabad",
    "officename": "Kantadih SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Purulia Division"
  },
  "723154": {
    "state": "West Bengal",
    "district": "Puruliya",
    "block": "Sirkabad",
    "officename": "Sirkabad SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Purulia Division"
  },
  "723155": {
    "state": "West Bengal",
    "district": "Puruliya",
    "block": "Para",
    "officename": "Para SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Purulia Division"
  },
  "723156": {
    "state": "West Bengal",
    "district": "Puruliya",
    "block": "Murardih",
    "officename": "Murardih SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Purulia Division"
  },
  "723201": {
    "state": "West Bengal",
    "district": "Puruliya",
    "block": "Arsha",
    "officename": "Garjaipur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Purulia Division"
  },
  "723202": {
    "state": "West Bengal",
    "district": "Puruliya",
    "block": "Jhalda",
    "officename": "Jhalda SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Purulia Division"
  },
  "723212": {
    "state": "West Bengal",
    "district": "Puruliya",
    "block": "Tulin",
    "officename": "Tulin SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Purulia Division"
  },
  "723213": {
    "state": "West Bengal",
    "district": "Puruliya",
    "block": "Jiudaru",
    "officename": "Jiudaru SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Purulia Division"
  },
  "723215": {
    "state": "West Bengal",
    "district": "Puruliya",
    "block": "Jaipur",
    "officename": "Baglata SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Purulia Division"
  },
  "731101": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "Suri HO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731102": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "Hatjanbazar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731103": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "Barabagan SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731104": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "BkTPP SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731121": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "Abinashpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731123": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "Dubrajpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731124": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "Hetampur Rajbati SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731125": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "Khoyrasole SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731126": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "Karidhya SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731127": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "MdBazar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731129": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "Purundarpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731130": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "Rajnagar SO Birbhum",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731132": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "MdBazar Town Ship SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731133": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "Panchrahat SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731201": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "Ahmadpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731202": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "Baswa SO Birbhum",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731204": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "Bolpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731214": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "Illambazar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731215": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Nanoor",
    "officename": "Khujutipara SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731216": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "Mallarpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731219": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "Murarai SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731220": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "Nalhati SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731221": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "Paikar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731222": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "Rajgaon SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731223": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "R K Sikshapith SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731224": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Rampurhat - I",
    "officename": "Rampurhat HO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731233": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "Chandipur Tarapith SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731234": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "Sainthia SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731235": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "Santiniketan SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731236": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "Sriniketan SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731237": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "Lohapur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731238": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "Chatra SO Birbhum",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731240": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "Bahiri SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731241": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "Chandpara SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731242": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "Kurumgram SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731243": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "Nalhati Township SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731244": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "Bishnupur SO Birbhum",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731245": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "Dakshingram SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731301": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "ChNanoor SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731302": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "Kirnahar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731303": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "Labpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "732101": {
    "state": "West Bengal",
    "district": "Malda",
    "block": "Englishbazar",
    "officename": "Malda HO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Malda Division"
  },
  "732102": {
    "state": "West Bengal",
    "district": "Malda",
    "block": "Englishbazar",
    "officename": "Jhaljhalia Railway Colony SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Malda Division"
  },
  "732103": {
    "state": "West Bengal",
    "district": "Malda",
    "block": "Englishbazar",
    "officename": "Mukdumpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Malda Division"
  },
  "732121": {
    "state": "West Bengal",
    "district": "Malda",
    "block": "Habibpir",
    "officename": "Aiho SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Malda Division"
  },
  "732122": {
    "state": "West Bengal",
    "district": "Malda",
    "block": "Habibpur",
    "officename": "Bulbulchandi SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Malda Division"
  },
  "732123": {
    "state": "West Bengal",
    "district": "Malda",
    "block": "Chanchal",
    "officename": "Chanchal SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Malda Division"
  },
  "732124": {
    "state": "West Bengal",
    "district": "Malda",
    "block": "Habibpur  (arajimistrabati)",
    "officename": "Gajol SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Malda Division"
  },
  "732125": {
    "state": "West Bengal",
    "district": "Malda",
    "block": "Harishchandrapur",
    "officename": "Harishchandrapur SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Malda Division"
  },
  "732126": {
    "state": "West Bengal",
    "district": "Malda",
    "block": "Chanchal",
    "officename": "Kaligaon SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Malda Division"
  },
  "732127": {
    "state": "West Bengal",
    "district": "Malda",
    "block": "Lakshipur",
    "officename": "Khejuriaghat SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Malda Division"
  },
  "732128": {
    "state": "West Bengal",
    "district": "Malda",
    "block": "Old Malda",
    "officename": "Old Malda SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Malda Division"
  },
  "732138": {
    "state": "West Bengal",
    "district": "Malda",
    "block": "Habibpur",
    "officename": "Pakuahat SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Malda Division"
  },
  "732139": {
    "state": "West Bengal",
    "district": "Malda",
    "block": "Amarsinghi",
    "officename": "Samsi SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Malda Division"
  },
  "732140": {
    "state": "West Bengal",
    "district": "Malda",
    "block": "Harishchandrapur",
    "officename": "Tulsihatta SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Malda Division"
  },
  "732141": {
    "state": "West Bengal",
    "district": "Malda",
    "block": "Englishbazar",
    "officename": "Narayanpur SO Malda",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Malda Division"
  },
  "732142": {
    "state": "West Bengal",
    "district": "Malda",
    "block": "Old Malda",
    "officename": "Mangalbari SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Malda Division"
  },
  "732144": {
    "state": "West Bengal",
    "district": "Malda",
    "block": "Sahajalalpur",
    "officename": "Kotwali SO Malda",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Malda Division"
  },
  "732201": {
    "state": "West Bengal",
    "district": "Malda",
    "block": "Kaliachak-1",
    "officename": "Kaliachak SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Malda Division"
  },
  "732202": {
    "state": "West Bengal",
    "district": "Malda",
    "block": "Manikchak",
    "officename": "Manikchak SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Malda Division"
  },
  "732203": {
    "state": "West Bengal",
    "district": "Malda",
    "block": "Manikchjak",
    "officename": "Mathurapur SO Malda",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Malda Division"
  },
  "732204": {
    "state": "West Bengal",
    "district": "Malda",
    "block": "Chanchal",
    "officename": "Paranpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Malda Division"
  },
  "732205": {
    "state": "West Bengal",
    "district": "Malda",
    "block": "Ratua",
    "officename": "Ratua SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Malda Division"
  },
  "732206": {
    "state": "West Bengal",
    "district": "Malda",
    "block": "Kaliachak",
    "officename": "Sujapur SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Malda Division"
  },
  "732207": {
    "state": "West Bengal",
    "district": "Malda",
    "block": "Kaliachak-1",
    "officename": "Mothabari SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Malda Division"
  },
  "732208": {
    "state": "West Bengal",
    "district": "Malda",
    "block": "Englishbazar",
    "officename": "Amrity SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Malda Division"
  },
  "732209": {
    "state": "West Bengal",
    "district": "Malda",
    "block": "Englishbazar",
    "officename": "Sovanagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Malda Division"
  },
  "732210": {
    "state": "West Bengal",
    "district": "Malda",
    "block": "Kaliachak-ii",
    "officename": "Baishnabnagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Malda Division"
  },
  "732215": {
    "state": "West Bengal",
    "district": "Malda",
    "block": "Baishnabnagar",
    "officename": "Pubarun SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Malda Division"
  },
  "732216": {
    "state": "West Bengal",
    "district": "Malda",
    "block": "Kaliachak",
    "officename": "Mahadipur SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Malda Division"
  },
  "733101": {
    "state": "West Bengal",
    "district": "South Dinajpur",
    "block": "Balurghat",
    "officename": "Balurghat HO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Dakshin Dinajpur Division"
  },
  "733102": {
    "state": "West Bengal",
    "district": "South Dinajpur",
    "block": "Balurghat",
    "officename": "Chakvrigu SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Dakshin Dinajpur Division"
  },
  "733103": {
    "state": "West Bengal",
    "district": "South Dinajpur",
    "block": "Balurghat",
    "officename": "Beltala Park SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Dakshin Dinajpur Division"
  },
  "733121": {
    "state": "West Bengal",
    "district": "South Dinajpur",
    "block": "Banshihari",
    "officename": "Buniadpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Dakshin Dinajpur Division"
  },
  "733123": {
    "state": "West Bengal",
    "district": "North Dinajpur",
    "block": "Raiganj",
    "officename": "Debinagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Uttar Dinajpur Division"
  },
  "733124": {
    "state": "West Bengal",
    "district": "South Dinajpur",
    "block": "Gangarampur",
    "officename": "Gangarampur SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Dakshin Dinajpur Division"
  },
  "733125": {
    "state": "West Bengal",
    "district": "South Dinajpur",
    "block": "Harirampur",
    "officename": "Harirampur SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Dakshin Dinajpur Division"
  },
  "733126": {
    "state": "West Bengal",
    "district": "South Dinajpur",
    "block": "Hili",
    "officename": "Hili SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Dakshin Dinajpur Division"
  },
  "733127": {
    "state": "West Bengal",
    "district": "South Dinajpur",
    "block": "Tapan",
    "officename": "Tapan SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Dakshin Dinajpur Division"
  },
  "733128": {
    "state": "West Bengal",
    "district": "North Dinajpur",
    "block": "Itahar",
    "officename": "Itahar SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Uttar Dinajpur Division"
  },
  "733129": {
    "state": "West Bengal",
    "district": "North Dinajpur",
    "block": "Kaliganj",
    "officename": "Kaliyaganj SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Uttar Dinajpur Division"
  },
  "733130": {
    "state": "West Bengal",
    "district": "North Dinajpur",
    "block": "Raiganj",
    "officename": "Karnojora SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Uttar Dinajpur Division"
  },
  "733132": {
    "state": "West Bengal",
    "district": "South Dinajpur",
    "block": "Kushmandi",
    "officename": "Kushmandi SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Dakshin Dinajpur Division"
  },
  "733133": {
    "state": "West Bengal",
    "district": "South Dinajpur",
    "block": "Kumarganj",
    "officename": "Patiram SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Dakshin Dinajpur Division"
  },
  "733134": {
    "state": "West Bengal",
    "district": "North Dinajpur",
    "block": "Raiganj",
    "officename": "Raiganj H.O",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Uttar Dinajpur Division"
  },
  "733140": {
    "state": "West Bengal",
    "district": "South Dinajpur",
    "block": "Gangarampur",
    "officename": "Rampur SO South Dinajpur",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Dakshin Dinajpur Division"
  },
  "733141": {
    "state": "West Bengal",
    "district": "South Dinajpur",
    "block": "Kumarganj",
    "officename": "Gopalganj SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Dakshin Dinajpur Division"
  },
  "733142": {
    "state": "West Bengal",
    "district": "South Dinajpur",
    "block": "Tapan",
    "officename": "Nayabazar SO South Dinajpur",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Dakshin Dinajpur Division"
  },
  "733143": {
    "state": "West Bengal",
    "district": "North Dinajpur",
    "block": "Itahar",
    "officename": "Bhupalpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Uttar Dinajpur Division"
  },
  "733145": {
    "state": "West Bengal",
    "district": "South Dinajpur",
    "block": "Balurghat",
    "officename": "Teor SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Dakshin Dinajpur Division"
  },
  "733156": {
    "state": "West Bengal",
    "district": "North Dinajpur",
    "block": "Raiganj",
    "officename": "Bindole SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Uttar Dinajpur Division"
  },
  "733158": {
    "state": "West Bengal",
    "district": "South Dinajpur",
    "block": "Balurghat",
    "officename": "Atrai SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Dakshin Dinajpur Division"
  },
  "733201": {
    "state": "West Bengal",
    "district": "North Dinajpur",
    "block": "Dalkhola",
    "officename": "Dalkhola SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Uttar Dinajpur Division"
  },
  "733202": {
    "state": "West Bengal",
    "district": "North Dinajpur",
    "block": "Islampur",
    "officename": "Islampur SO North Dinajpur",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Uttar Dinajpur Division"
  },
  "733207": {
    "state": "West Bengal",
    "district": "North Dinajpur",
    "block": "Chopra",
    "officename": "Ramganj SO North Dinajpur",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Uttar Dinajpur Division"
  },
  "733208": {
    "state": "West Bengal",
    "district": "North Dinajpur",
    "block": "Islampur",
    "officename": "Panjipara SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Uttar Dinajpur Division"
  },
  "733209": {
    "state": "West Bengal",
    "district": "North Dinajpur",
    "block": "Karandighi",
    "officename": "Kanki SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Uttar Dinajpur Division"
  },
  "733210": {
    "state": "West Bengal",
    "district": "North Dinajpur",
    "block": "Goalpukher",
    "officename": "Goalpokher SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Uttar Dinajpur Division"
  },
  "733215": {
    "state": "West Bengal",
    "district": "North Dinajpur",
    "block": "Karandighi",
    "officename": "Karandighi SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Uttar Dinajpur Division"
  },
  "734001": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Siliguri",
    "officename": "Siliguri HO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734002": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Kurseong",
    "officename": "Salbari SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734003": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Siliguri",
    "officename": "Pradhan Nagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734004": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Rajganj",
    "officename": "Siliguri Town SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734005": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Siliguri",
    "officename": "Siliguri Bazar SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734006": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Rajganj",
    "officename": "Rabindra Sarani SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734007": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Rajganj",
    "officename": "Bhaktinagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734008": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Kurseong",
    "officename": "Salugarah SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734009": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Siliguri",
    "officename": "Sukna SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734010": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Siliguri",
    "officename": "Matigara SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734011": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Naxalbari",
    "officename": "Kadamtala SO Darjiling",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734012": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Siliguri",
    "officename": "Sushrut Nagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734013": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Matigara",
    "officename": "North Bengal University SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734014": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Phansidewa",
    "officename": "Bagdogra SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734015": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Rajganj",
    "officename": "Mahananda Project SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734101": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Darjeeling Pulbazar",
    "officename": "Darjeeling HO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734102": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Darjeeling Pulbazar",
    "officename": "Ghoom SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734103": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Darjeeling Pulbazar",
    "officename": "Jalapahar SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734104": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Darjeeling",
    "officename": "North Point SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734105": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Darjeeling",
    "officename": "Lebong SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734201": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Darjeeling Pulbazar",
    "officename": "Bijanbari SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734203": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Kurseong",
    "officename": "Kurseong MDG",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734204": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Kurseong",
    "officename": "Dowhill SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734209": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Kurseong",
    "officename": "Sonada SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734213": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Rangli Rangliot",
    "officename": "Lopchu SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734214": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Kurseong",
    "officename": "Mirik SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734215": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Kalimpong",
    "officename": "Nagrispur SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734216": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Kurseong",
    "officename": "Pokhriabong SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734217": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Kurseong",
    "officename": "Pankhabari SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734218": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Mirik",
    "officename": "Phuguri SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734220": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Kurseong",
    "officename": "StMarys Hill SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734221": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Jorebunglow Sukiapokhri",
    "officename": "Sukhiapokhari SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734222": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Kurseong",
    "officename": "Takdah SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734223": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Kurseong",
    "officename": "Tindharia SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734224": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Kurseong",
    "officename": "Tung SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734226": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Darjeeling",
    "officename": "Rangli Rangliot SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734301": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Kalimpong -I",
    "officename": "Kalimpong MDG",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734311": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Kalimpong",
    "officename": "Pedong SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734312": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Kalimpong",
    "officename": "Tista Bridge SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734313": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Kalimpong",
    "officename": "Mungpoo SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734314": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Kalimpong - II",
    "officename": "Algarah SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734315": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Kalimpong",
    "officename": "Munsong SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734316": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Kalimpong - II",
    "officename": "Topkhana SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734421": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Phansidewa",
    "officename": "Bagdogra Air Port SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734423": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Siliguri",
    "officename": "Belgachi SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734424": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Phansidewa",
    "officename": "Bendubi SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734426": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Siliguri",
    "officename": "Kamala Bagan SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734427": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Kharibari",
    "officename": "Khoribari SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734429": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Rangli Rangliot",
    "officename": "Naksalbari SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734434": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Phansidewa",
    "officename": "Phansidewa SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "734501": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Mal",
    "officename": "Bagrakote SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "734503": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Gorubathan",
    "officename": "Jaldhaka Hydel Project SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735101": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Jalpaiguri",
    "officename": "Jalpaiguri HO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735102": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Jalpaiguri",
    "officename": "JpgGovt Engg College SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735121": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Jalpaiguri",
    "officename": "Danguajhar SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735122": {
    "state": "West Bengal",
    "district": "Cooch Behar",
    "block": "Haldibari",
    "officename": "Haldibari SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735132": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Jalpaiguri",
    "officename": "Pandapara Kalibari SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735133": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Jalpaiguri",
    "officename": "Prasannanagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735134": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Rajganj",
    "officename": "Rajganj SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735135": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Rajganj",
    "officename": "Kamarvita SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735202": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Nagrakata",
    "officename": "Banarhat SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735203": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Mal",
    "officename": "Binnaguri SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735204": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Falakata",
    "officename": "Birpara SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735205": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Mal",
    "officename": "Carron SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735206": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Matteli",
    "officename": "Chalsa SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735207": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Madarihat",
    "officename": "Chamurchi SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735208": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Alipurduar",
    "officename": "Dalshingpara SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "735209": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Mal",
    "officename": "Damdim SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735210": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Dhupguri",
    "officename": "Dhupguri SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735211": {
    "state": "West Bengal",
    "district": "Cooch Behar",
    "block": "Mathabhanga - II",
    "officename": "Falakata SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735212": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Dhupguri",
    "officename": "Gairkata SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735213": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Falakata",
    "officename": "Gopal Bagan SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735214": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Alipurduar",
    "officename": "Hamiltonganj SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "735215": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Kalchini",
    "officename": "Hasimara SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "735216": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Falakata",
    "officename": "Jateswar SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735217": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Alipurduar",
    "officename": "Kalchini SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "735218": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Mal",
    "officename": "Krantihat SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735219": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Mal",
    "officename": "Lataguri SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735220": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Falakata",
    "officename": "Madarihat SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735221": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Mal",
    "officename": "Mal HO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735222": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Jalpaiguri",
    "officename": "Manabari SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735223": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Matteli",
    "officename": "Matelli SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735224": {
    "state": "West Bengal",
    "district": "Cooch Behar",
    "block": "Mekhliganj",
    "officename": "Maynaguri SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735225": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Nagrakata",
    "officename": "Nagrakata SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735226": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Kalchini",
    "officename": "Panabasti SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "735227": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Kalchini",
    "officename": "Rajabhatkhawa SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "735228": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Madarihat",
    "officename": "Ramjhora SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735229": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Mal",
    "officename": "Sailihat SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735230": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Matteli",
    "officename": "Baradighi SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735231": {
    "state": "West Bengal",
    "district": "Darjiling",
    "block": "Gorubathan",
    "officename": "Fagu SO Darjeeling",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735232": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Dhupguri",
    "officename": "Binnaguri Cantt SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735233": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Dhupguri",
    "officename": "Nathuahat SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735234": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Mal",
    "officename": "Gajoldoba SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735301": {
    "state": "West Bengal",
    "district": "Cooch Behar",
    "block": "Mekhliganj",
    "officename": "Changrabandha SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735302": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Maynaguri",
    "officename": "Domohani SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735303": {
    "state": "West Bengal",
    "district": "Cooch Behar",
    "block": "Mekliganj",
    "officename": "Jamaldah SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735304": {
    "state": "West Bengal",
    "district": "Cooch Behar",
    "block": "Mekhliganj",
    "officename": "Mekhliganj SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "735305": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Maynaguri",
    "officename": "Bhotepatty SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Jalpaiguri Division"
  },
  "736101": {
    "state": "West Bengal",
    "district": "Cooch Behar",
    "block": "Cooch Behar - I",
    "officename": "Cooch Behar HO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "736121": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Alipurduar - I",
    "officename": "Alipurduar SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "736122": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Alipurduar - I",
    "officename": "Alipurduar Court SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "736123": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Alipurduar - I",
    "officename": "Alipurduar Junction SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "736131": {
    "state": "West Bengal",
    "district": "Cooch Behar",
    "block": "Tufanganj",
    "officename": "Bakshirhat SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "736133": {
    "state": "West Bengal",
    "district": "Cooch Behar",
    "block": "Cooch Behar",
    "officename": "Baneswar SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "736134": {
    "state": "West Bengal",
    "district": "Cooch Behar",
    "block": "Dinhata - I",
    "officename": "Dewanhat SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "736135": {
    "state": "West Bengal",
    "district": "Cooch Behar",
    "block": "Dinhata",
    "officename": "Dinhata SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "736145": {
    "state": "West Bengal",
    "district": "Cooch Behar",
    "block": "Dinhata",
    "officename": "Gossanimari SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "736146": {
    "state": "West Bengal",
    "district": "Cooch Behar",
    "block": "Mathabhanga",
    "officename": "Mathabhanga SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "736156": {
    "state": "West Bengal",
    "district": "Cooch Behar",
    "block": "Cooch Behar",
    "officename": "Nilkuthi SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "736157": {
    "state": "West Bengal",
    "district": "Cooch Behar",
    "block": "Mathabhanga - II",
    "officename": "Nishiganj SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "736158": {
    "state": "West Bengal",
    "district": "Cooch Behar",
    "block": "Sitalkuchi",
    "officename": "Sitalkuchi SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "736159": {
    "state": "West Bengal",
    "district": "Cooch Behar",
    "block": "Tufanganj",
    "officename": "Tufanganj SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "736160": {
    "state": "West Bengal",
    "district": "Cooch Behar",
    "block": "Tufanganj",
    "officename": "Tufanganj New Town SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "736165": {
    "state": "West Bengal",
    "district": "Cooch Behar",
    "block": "Cooch Behar",
    "officename": "Pundibari SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "736167": {
    "state": "West Bengal",
    "district": "Cooch Behar",
    "block": "Sitai",
    "officename": "Sitaihat SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "736168": {
    "state": "West Bengal",
    "district": "Cooch Behar",
    "block": "Dinhata - I",
    "officename": "Bamanhat SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "736169": {
    "state": "West Bengal",
    "district": "Cooch Behar",
    "block": "Dinhata",
    "officename": "Nigamnagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "736170": {
    "state": "West Bengal",
    "district": "Cooch Behar",
    "block": "Cooch Behar",
    "officename": "Ghughumari SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "736171": {
    "state": "West Bengal",
    "district": "Cooch Behar",
    "block": "Mathabhanga - II",
    "officename": "Ghoksadanga SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "736172": {
    "state": "West Bengal",
    "district": "Cooch Behar",
    "block": "Mathabhanga`",
    "officename": "Gossairhat Bandar SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "736176": {
    "state": "West Bengal",
    "district": "Cooch Behar",
    "block": "Dinhata",
    "officename": "Sahebganj SO Cooch Behar",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "736179": {
    "state": "West Bengal",
    "district": "Cooch Behar",
    "block": "Cooch Behar - II",
    "officename": "New Cooch Behar SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "736182": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Kalchini",
    "officename": "New Market Jaigaon SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "736201": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Alipurduar",
    "officename": "Hatipotha SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "736202": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Alipurduar",
    "officename": "Kamaskhyaguri SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "736203": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Alipurduar",
    "officename": "Kumargramduar SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "736204": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Alipurduar",
    "officename": "Mathurabagan SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "736205": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Kumargram",
    "officename": "New Lands SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "736206": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Alipurduar",
    "officename": "Saontalpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "736207": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Alipurduar",
    "officename": "Barobisha SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "736208": {
    "state": "West Bengal",
    "district": "Jalpaiguri",
    "block": "Alipurduar",
    "officename": "Salsalabari SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Cooch Behar Division"
  },
  "737101": {
    "state": "Sikkim",
    "district": "East Sikkim",
    "block": "Gangtok",
    "officename": "Gangtok HO",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sikkim Division"
  },
  "737102": {
    "state": "Sikkim",
    "district": "East Sikkim",
    "block": "Gangtok",
    "officename": "Tadong SO",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sikkim Division"
  },
  "737103": {
    "state": "Sikkim",
    "district": "East Sikkim",
    "block": "Gangtok",
    "officename": "Rajbhawan SO East Sikkim",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sikkim Division"
  },
  "737106": {
    "state": "Sikkim",
    "district": "East Sikkim",
    "block": "Pakyong",
    "officename": "Pakyong SO",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sikkim Division"
  },
  "737107": {
    "state": "Sikkim",
    "district": "East Sikkim",
    "block": "Dikchu",
    "officename": "Dikchu SO",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sikkim Division"
  },
  "737111": {
    "state": "Sikkim",
    "district": "West Sikkim",
    "block": "Gayzing",
    "officename": "Gayzing SO",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sikkim Division"
  },
  "737113": {
    "state": "Sikkim",
    "district": "East Sikkim",
    "block": "Pelling",
    "officename": "Pelling SO",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sikkim Division"
  },
  "737116": {
    "state": "Sikkim",
    "district": "North Sikkim",
    "block": "Mangan",
    "officename": "Mangan SO",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sikkim Division"
  },
  "737120": {
    "state": "Sikkim",
    "district": "North Sikkim",
    "block": "Chungthang",
    "officename": "Chungthang SO",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sikkim Division"
  },
  "737121": {
    "state": "Sikkim",
    "district": "West Sikkim",
    "block": "Jorethang",
    "officename": "Naya Bazar SO West Sikkim",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sikkim Division"
  },
  "737126": {
    "state": "Sikkim",
    "district": "South Sikkim",
    "block": "Namchi",
    "officename": "Namchi SO",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sikkim Division"
  },
  "737128": {
    "state": "Sikkim",
    "district": "South Sikkim",
    "block": "Melli",
    "officename": "Melli Bazar SO",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sikkim Division"
  },
  "737131": {
    "state": "Sikkim",
    "district": "East Sikkim",
    "block": "Rangli",
    "officename": "Rangli Bazar SO",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sikkim Division"
  },
  "737132": {
    "state": "Sikkim",
    "district": "East Sikkim",
    "block": "Rangpo",
    "officename": "Rangpo SO",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sikkim Division"
  },
  "737133": {
    "state": "Sikkim",
    "district": "East Sikkim",
    "block": "Rhenock",
    "officename": "Rhenock SO",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sikkim Division"
  },
  "737134": {
    "state": "Sikkim",
    "district": "East Sikkim",
    "block": "Singtam",
    "officename": "Singtam SO",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sikkim Division"
  },
  "737135": {
    "state": "Sikkim",
    "district": "East Sikkim",
    "block": "Ranipool",
    "officename": "Ranipool SO",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sikkim Division"
  },
  "737136": {
    "state": "Sikkim",
    "district": "East Sikkim",
    "block": "Rangpo",
    "officename": "Majitar SO",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sikkim Division"
  },
  "737139": {
    "state": "Sikkim",
    "district": "South Sikkim",
    "block": "Ravangla",
    "officename": "Ravangla SO",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sikkim Division"
  },
  "741101": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Krishnagar - I",
    "officename": "Krishnanagar HO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia North Division"
  },
  "741102": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Krishnanagar I",
    "officename": "Saktinagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia North Division"
  },
  "741103": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Krishnanagar I",
    "officename": "Ghurni SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia North Division"
  },
  "741121": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Hanskhali",
    "officename": "Badkulla SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "741122": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Karimpur I",
    "officename": "Bagchi Jamsherpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia North Division"
  },
  "741123": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Chapra",
    "officename": "Bangaljhi SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia North Division"
  },
  "741124": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Tehatta",
    "officename": "Bara Andulia SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia North Division"
  },
  "741125": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Krishnagar - II",
    "officename": "Belpukur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia North Division"
  },
  "741126": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Debagram",
    "officename": "Bethuadahari SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia North Division"
  },
  "741127": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Ranaghat - I",
    "officename": "Birnagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "741137": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Nakashipara",
    "officename": "Debagram SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia North Division"
  },
  "741138": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Nakashipara",
    "officename": "Dharmada SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia North Division"
  },
  "741139": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Hanskhali",
    "officename": "Dhubulia SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia North Division"
  },
  "741140": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Krishnangar Ii",
    "officename": "Dhubulia T B Hospital SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia North Division"
  },
  "741150": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Kaliganj",
    "officename": "Kaliganj SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia North Division"
  },
  "741151": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Hanskhali",
    "officename": "Dhakshinpara SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "741152": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Karimpur I",
    "officename": "Karimpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia North Division"
  },
  "741153": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Kaliganj",
    "officename": "Matiari SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia North Division"
  },
  "741154": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Nakashipara",
    "officename": "Muragachha SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia North Division"
  },
  "741155": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Tehatta I",
    "officename": "Palashipara SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia North Division"
  },
  "741156": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Nowda (murshidabad)",
    "officename": "Plassey SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia North Division"
  },
  "741157": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Hanskhali",
    "officename": "Plassey Sugar Mill SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia North Division"
  },
  "741158": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Tehatta",
    "officename": "Shikarpur SO Nadia",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia North Division"
  },
  "741159": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Hanskhali",
    "officename": "Taherpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "741160": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Tehatta I",
    "officename": "Tehatta SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia North Division"
  },
  "741161": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Krishnanagar-i",
    "officename": "Assannagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia North Division"
  },
  "741162": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Nakashipara",
    "officename": "Kasiadanga SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia North Division"
  },
  "741163": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Tehatta",
    "officename": "Betai SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia North Division"
  },
  "741164": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Chapra",
    "officename": "Dayer Bazar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia North Division"
  },
  "741165": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Karimpur Ii (mohisbatan)",
    "officename": "Nazirpur SO Nadia",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia North Division"
  },
  "741166": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Chapra",
    "officename": "Seemanagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia North Division"
  },
  "741167": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Krishnaganj",
    "officename": "Bhimpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia North Division"
  },
  "741181": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Kaliganj",
    "officename": "Paglachandi SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia North Division"
  },
  "741201": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Ranaghat - I",
    "officename": "Ranaghat HO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "741202": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Ranaghat-ii",
    "officename": "Nasra SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "741221": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Haringhata",
    "officename": "Barajaguli SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "741222": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Chakdah",
    "officename": "Chakdah SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "741223": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Chakdaha",
    "officename": "Purbabishnupur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "741232": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Ranaghat - I",
    "officename": "Coopers Camp SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "741234": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Haringhata",
    "officename": "Gayeshpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "741235": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Hanskhali",
    "officename": "Kalyani HO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "741238": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Ranaghat-ii",
    "officename": "Gangnapur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "741245": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Chakdah",
    "officename": "Madanpur SO Nadia",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "741246": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Haringhata",
    "officename": "Mohanpur SO Nadia",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "741247": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Ranaghat",
    "officename": "Pritinagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "741248": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Chakdah",
    "officename": "Simurali SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "741249": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Haringhata",
    "officename": "Subarnapur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "741250": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Haringhata",
    "officename": "Kataganj SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "741251": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Chakdah",
    "officename": "Netajisubhas Sanatorium SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "741252": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Haringhata",
    "officename": "Krishivisyavidyalaya SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "741253": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Ranaghat-ii",
    "officename": "Anishmali SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "741254": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Ranaghat-ii",
    "officename": "Kalinarayanpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "741255": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Ranaghat-i",
    "officename": "Anulia SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "741256": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Hanskhali",
    "officename": "Begopara SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "741257": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Haringhata",
    "officename": "Nagarukhra SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "741301": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Nabadwip",
    "officename": "Char Brahmanagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia North Division"
  },
  "741302": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Nabadwip",
    "officename": "Nabadwip HO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia North Division"
  },
  "741313": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Sreemayapur",
    "officename": "Sreemayapur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia North Division"
  },
  "741315": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Krishnagar-ii",
    "officename": "Swarupganj SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia North Division"
  },
  "741316": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Nabadwip",
    "officename": "Srirampur SO Nadia",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia North Division"
  },
  "741317": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Krishnagar - I",
    "officename": "Joania Bhaluka SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia North Division"
  },
  "741319": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Burdwan",
    "officename": "Bidyanagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia North Division"
  },
  "741401": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Santipur",
    "officename": "Dignagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "741402": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Santipur",
    "officename": "Fulia Colony SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "741404": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Santipur",
    "officename": "Santipur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "741501": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Ranaghat - II",
    "officename": "Arangahta SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "741502": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Hanskhali",
    "officename": "Bagula SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "741503": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Krishnaganj",
    "officename": "Banpur SO Nadia",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "741504": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Ranaghat - II",
    "officename": "Duttapulia SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "741505": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Hanskhlai",
    "officename": "Hanskhali SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "741506": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Krishnaganj",
    "officename": "Krishnaganj SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "741507": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Santipur",
    "officename": "Majdia SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "741508": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Krishnaganj",
    "officename": "Khalboalia SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "741509": {
    "state": "West Bengal",
    "district": "Nadia",
    "block": "Krishnaganj",
    "officename": "Chandannagar SO Nadia",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Nadia South Division"
  },
  "742101": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Berhampore",
    "officename": "Berhampore WB HO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742102": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "Cossimbazar Raj SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742103": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Berhampore",
    "officename": "Khagra SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742104": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad Jiaganj",
    "officename": "DLSSJdham SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742113": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "Debipur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742121": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Nawda",
    "officename": "Amtala SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742122": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "Azimganj SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742123": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "Jiaganj SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742132": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "Barwan SO Murshidabad",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742133": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "Beldanga SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742134": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Berhampore",
    "officename": "Bhabta SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742135": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "Bhagabangola SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742136": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "Gokarna SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742137": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "Kandi HO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742138": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "Bagdanga SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742140": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "Jemo Rajbati SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742147": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "Khargram SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742148": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Lalgola",
    "officename": "Lalgola SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742149": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad Jiaganj",
    "officename": "Murshidabad SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742151": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "Rajarampur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742159": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "Nagar SO Murshidabad",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742160": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad Jiaganj",
    "officename": "Nashipur Rajbati SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742161": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Burwan",
    "officename": "Panchthupi SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742163": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "Saktipur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742164": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad Jiaganj",
    "officename": "Roshanbagh SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742165": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "Baruipara SO Murshidabad",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742166": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "Hariharpara SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742168": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "Andi SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742174": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "Sarbangapur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742175": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "Sabdarnagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742184": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Nabagram",
    "officename": "Nabagram SO Murshidabad",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742187": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Hariharpara",
    "officename": "Radharghat SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742189": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Beldanga - II",
    "officename": "Barua SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742201": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "Aurangabad SO Murshidabad",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742202": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "Dhuliyan SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742212": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "Farakka Barrage SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742213": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "Jangipur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742223": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "Jangipur Barrage SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742224": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "Nimtita SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742225": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Raghunathganj - I",
    "officename": "Raghunathganj HO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742226": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "Sagardighi SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742227": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "Gankar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742235": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "Barala SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742236": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Farakka",
    "officename": "Nabarun SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742237": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "Manigram SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742238": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Palsanda",
    "officename": "Palsandamore SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742301": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "Bharatpur SO Murshidabad",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742302": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Raninagar - I",
    "officename": "Daulatabad SO Murshidabad",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742303": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "Dumkal SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742304": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Raninagar - I",
    "officename": "Islampore SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742305": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Jalangi",
    "officename": "Jalangi SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742306": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Jalangi",
    "officename": "Sagarpara SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742308": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "Raninagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742401": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "Salar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742402": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Bharatpur - II",
    "officename": "Talibpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742404": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "Tenya SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742405": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "Satui SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742406": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "Basantpur SO Murshidabad",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742407": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Berhampore",
    "officename": "Chaltia SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742408": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Behrampore",
    "officename": "Sargachi Ashram SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "742409": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Raninagar-II",
    "officename": "Shaikhpara SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "743122": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Palta",
    "officename": "Bengal Enamel SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "743123": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Bhatpara",
    "officename": "Bhatpara SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "743124": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Jagatdal",
    "officename": "ESD M SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "743125": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Jagatdal",
    "officename": "Jagatdal SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "743126": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Kankinara",
    "officename": "Kankinara SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "743127": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Shyamnagar",
    "officename": "Shyamnagar SO North 24 Parganas",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "743128": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Athpur",
    "officename": "Athpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "743129": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Fingapara",
    "officename": "Fingapara SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "743130": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Barrackpur - I",
    "officename": "Dogachia SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "743133": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Garulia",
    "officename": "Garulia SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "743134": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Halishahar",
    "officename": "Halishahar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "743135": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Barrackpur - I",
    "officename": "Hazinagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "743136": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Barrackpur - I",
    "officename": "Nabanagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "743144": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Ichapur",
    "officename": "Ichapur Nawabganj SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "743145": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Kanchrapara",
    "officename": "Kanchrapara SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "743165": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Barrackpur - I",
    "officename": "Naihati SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "743166": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Gorifa",
    "officename": "Gorifa SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "743193": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Kanchrapara",
    "officename": "Kampa SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "743194": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Jagatdal",
    "officename": "Ramlakshi Busti Lane SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "BARRACKPORE DIVISION"
  },
  "743221": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Adhata",
    "officename": "Arkhali Amdanga SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743222": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Habra - II",
    "officename": "Asoknagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743223": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Habra - II",
    "officename": "Haripur SO North 24 Parganas",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743232": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Bagdah",
    "officename": "Bagdah SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743233": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Habra - I",
    "officename": "Banipur SO North 24 Parganas",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743234": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Bira",
    "officename": "Bira Ballavepara SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743235": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Angrail",
    "officename": "Bangaon SO North 24 Parganas",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743245": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Baikara",
    "officename": "Chand Para Bazar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743247": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Barghorai",
    "officename": "Dakshin Chatra SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743248": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Adhikashimpur",
    "officename": "Duttapukur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743249": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Amandikandi",
    "officename": "Gaighata SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743251": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Ambikapur",
    "officename": "Ganrapota SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743252": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Habra - I",
    "officename": "Gobardanga SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743262": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Bairampur",
    "officename": "Gopalnagar SO North 24 Parganas",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743263": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Habra - I",
    "officename": "Habra SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743268": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Habra - I",
    "officename": "Habra Prafulla Nagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743270": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Baneswarpur",
    "officename": "Helencha Colony SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743271": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Habra - I",
    "officename": "Hijalpukuria SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743272": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Habra - II",
    "officename": "Kalyangarh SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743273": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Amudia",
    "officename": "Khantura SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743286": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Banglani",
    "officename": "Swarupnagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743287": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Chikanpara",
    "officename": "Thakurnagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743289": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Ghoshpur",
    "officename": "Maslandapur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743290": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Bhanderkhola",
    "officename": "Nahata SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743291": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Basirhat",
    "officename": "Champapukur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743292": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Basirhat - I",
    "officename": "Itinda SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743293": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Eojnagar",
    "officename": "Jadurhati SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743294": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Bohara",
    "officename": "Chhoto Jagulia SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743297": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Bagda",
    "officename": "Sindrani SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743312": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Basanti SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743318": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Birlapur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743329": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Canning Town SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743330": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Champahati",
    "officename": "Champahati SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743331": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Diamond Harbour - I",
    "officename": "Diamond Harbour HO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743332": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Hatuganj SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743336": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Ghateswar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743337": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Canning - I",
    "officename": "Joynagar Majilpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743338": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Nimpith Ashram SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743345": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Mandirbazar",
    "officename": "Bijoyganj Bazar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743347": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Kakdwip SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743348": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Karanjali SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743349": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Mathurapur - II",
    "officename": "Kashinagar SO South 24 Parganas",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743351": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Kulpi SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743354": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Mathurapur - I",
    "officename": "Mathurapur RS SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743355": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Baruipur",
    "officename": "Magrahat SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743356": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Ghoramara Mandirtala BO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743357": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Nam Khana SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743363": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Canning",
    "officename": "Bansra SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743368": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Diamond Harbour - I",
    "officename": "Sarisha SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743370": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Gosaba SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743371": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Pathar Pratima SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743372": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Dakshin Barasat SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743373": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Rudra Nagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743374": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Kulpi",
    "officename": "Nishchinta Pur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743375": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Usthi SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743376": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Taldi SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743377": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Bakrahat SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743378": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Chhoto Mollakhali SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743383": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Raidighi SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743387": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Baruipur",
    "officename": "Piyali Town SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743395": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Mandirbazar",
    "officename": "South Bishnupur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743399": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Kulpi",
    "officename": "Dholahat SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743401": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Baduria",
    "officename": "Baduria SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743405": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Chaigharia",
    "officename": "Petrapole SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743411": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Basirhat - I",
    "officename": "Basirhat HO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743412": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Basirhat - I",
    "officename": "Basirhat College SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743422": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Basirhat - I",
    "officename": "Bhabla SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743423": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Baidyapur",
    "officename": "Deganga SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743424": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Chakla",
    "officename": "Debalaya SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743425": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Adampur",
    "officename": "Haroa SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743426": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Barunhat",
    "officename": "Hasnabad SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743427": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Aturia",
    "officename": "Katiahat SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743428": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Kholapota",
    "officename": "Kholapota SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743429": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Bagundi",
    "officename": "Taki SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743435": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Amberia",
    "officename": "Hingalganj SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743437": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Basirhat - II",
    "officename": "Dhanyakuria SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743438": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Atghara",
    "officename": "Kolsur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743439": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Bhanderkhali",
    "officename": "Hatgachha SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743442": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Bamanibad",
    "officename": "Nazat Hatkhola SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743445": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Amta",
    "officename": "Gopalpur SO North 24 Parganas",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743446": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Atapur",
    "officename": "Sandeshkhali SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743456": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Kuliadanga",
    "officename": "Bhebia SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743502": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Bhangar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743503": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Bishnupur SO South 24 Parganas",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743504": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Falta",
    "officename": "Falta SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743513": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Falta",
    "officename": "Fatehpur SO South 24 Parganas",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743609": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Hansuri SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743610": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Madarat SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743611": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "Pathan Khali SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743613": {
    "state": "West Bengal",
    "district": "South 24 Parganas",
    "block": "Sagar",
    "officename": "South Garia SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Baruipur Division"
  },
  "743701": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Belta",
    "officename": "Palla SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743702": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Rajibpur",
    "officename": "Rajibpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743704": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Guma",
    "officename": "Guma SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743710": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Akaipur",
    "officename": "Goribpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "743711": {
    "state": "West Bengal",
    "district": "North 24 Parganas",
    "block": "Beraberi",
    "officename": "Suria SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Barasat Division"
  },
  "744101": {
    "state": "Andaman & Nicobar",
    "district": "South Andaman",
    "block": "Portblair",
    "officename": "Port Blair H.O",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "A - N Islands Division"
  },
  "744102": {
    "state": "Andaman & Nicobar",
    "district": "South Andaman",
    "block": "Portblair",
    "officename": "Haddo S.O",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "A - N Islands Division"
  },
  "744103": {
    "state": "Andaman & Nicobar",
    "district": "South Andaman",
    "block": "Port Blair",
    "officename": "Junglighat S.O",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "A - N Islands Division"
  },
  "744104": {
    "state": "Andaman & Nicobar",
    "district": "South Andaman",
    "block": "Port  Blair",
    "officename": "Aberdeen  Bazar S.O",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "A - N Islands Division"
  },
  "744105": {
    "state": "Andaman & Nicobar",
    "district": "South Andaman",
    "block": "Port Blair",
    "officename": "Garacharama S.O",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "A - N Islands Division"
  },
  "744106": {
    "state": "Andaman & Nicobar",
    "district": "South Andaman",
    "block": "Port Blair",
    "officename": "Shadipur S.O",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "A - N Islands Division"
  },
  "744107": {
    "state": "Andaman & Nicobar",
    "district": "South Andaman",
    "block": "Ferrargunj",
    "officename": "Bambooflat S.O",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "A - N Islands Division"
  },
  "744112": {
    "state": "Andaman & Nicobar",
    "district": "South Andaman",
    "block": "Portblair",
    "officename": "Chakargoan S.O",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "A - N Islands Division"
  },
  "744201": {
    "state": "Andaman & Nicobar",
    "district": "North And Middle Andaman",
    "block": "Rangat",
    "officename": "Betapur S.O",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "A - N Islands Division"
  },
  "744202": {
    "state": "Andaman & Nicobar",
    "district": "North And Middle Andaman",
    "block": "Diglipur",
    "officename": "Diglipur S.O",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "A - N Islands Division"
  },
  "744203": {
    "state": "Andaman & Nicobar",
    "district": "North And Middle Andaman",
    "block": "Rangat",
    "officename": "Long Island S.O",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "A - N Islands Division"
  },
  "744204": {
    "state": "Andaman & Nicobar",
    "district": "North And Middle Andaman",
    "block": "Mayabander",
    "officename": "Mayabander S.O",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "A - N Islands Division"
  },
  "744205": {
    "state": "Andaman & Nicobar",
    "district": "North And Middle Andaman",
    "block": "Rangat",
    "officename": "Rangat S.O",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "A - N Islands Division"
  },
  "744206": {
    "state": "Andaman & Nicobar",
    "district": "South Andaman",
    "block": "Ferrargunj",
    "officename": "Wimberlygunj S.O",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "A - N Islands Division"
  },
  "744207": {
    "state": "Andaman & Nicobar",
    "district": "South Andaman",
    "block": "Hut Bay",
    "officename": "Hut  Bay S.O",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "A - N Islands Division"
  },
  "744209": {
    "state": "Andaman & Nicobar",
    "district": "North And Middle Andaman",
    "block": "Rangat",
    "officename": "Kadamtala S.O (North And Middle Andaman)",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "A - N Islands Division"
  },
  "744210": {
    "state": "Andaman & Nicobar",
    "district": "North And Middle Andaman",
    "block": "Port Blair",
    "officename": "Oralkatcha S.O",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "A - N Islands Division"
  },
  "744211": {
    "state": "Andaman & Nicobar",
    "district": "South Andaman",
    "block": "Port Blair",
    "officename": "Swaraj Dweep SO",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "A - N Islands Division"
  },
  "744301": {
    "state": "Andaman & Nicobar",
    "district": "Nicobar",
    "block": "Carnicobar",
    "officename": "Carnicobar S.O",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "A - N Islands Division"
  },
  "744302": {
    "state": "Andaman & Nicobar",
    "district": "Nicobar",
    "block": "Nancowrie",
    "officename": "Campbelbay S.O",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "A - N Islands Division"
  },
  "744303": {
    "state": "Andaman & Nicobar",
    "district": "Nicobar",
    "block": "Nancowrie",
    "officename": "Nancowrie S.O",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "A - N Islands Division"
  },
  "744304": {
    "state": "Andaman & Nicobar",
    "district": "Nicobar",
    "block": "Nancowrie",
    "officename": "Kapanga S.O",
    "circlename": "West Bengal Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "A - N Islands Division"
  },
  "751001": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Bhubaneswar",
    "officename": "Bhubaneswar G.P.O.",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "751002": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Bhubaneswar",
    "officename": "Old Town S.O (Khorda)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "751003": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Bhubaneswar",
    "officename": "Baramunda Colony S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "751004": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Bhubaneswar",
    "officename": "Utkal University S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "751005": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Bhubaneswar",
    "officename": "Sainik School S.O (Khorda)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "751006": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Bhubaneswar",
    "officename": "Budheswari Colony S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "751007": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Bhubaneswar",
    "officename": "Saheed Nagar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "751008": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Bhubaneswar",
    "officename": "Rajbhawan S.O (Khorda)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "751009": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Bhubaneswar",
    "officename": "Ashok Nagar S.O (Khorda)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "751010": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Bhubaneswar",
    "officename": "Rasulgarh S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "751011": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Bhubaneswar",
    "officename": "C R P Lines S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "751012": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Bhubaneswar",
    "officename": "Nayapalli S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "751013": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Bhubaneswar",
    "officename": "Regional Research Laboratory S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "751014": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Bhubaneswar",
    "officename": "B J B Nagar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "751015": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Bhubaneswar",
    "officename": "I R C Village S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "751016": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Bhubaneswar",
    "officename": "Chandra Sekhar Pur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "751017": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Bhubaneswar",
    "officename": "Mancheswar Railway  Colony S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "751018": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Bhubaneswar",
    "officename": "Badagarh Brit Colony S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "751019": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Balianta",
    "officename": "Dumduma Housing Board Colony S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "751020": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Bhubaneswar",
    "officename": "Aerodrome Area S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "751021": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Bhubaneswar",
    "officename": "Sailashree Vihar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "751022": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Bhubaneswar",
    "officename": "Bhoinagar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "751023": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Bhubaneswar",
    "officename": "S.E Rly.Proj. Complex S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "751024": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Bhubaneswar",
    "officename": "K I I T S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "751025": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Bhubaneswar",
    "officename": "G.G.P.Colony S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "751030": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Bhubaneswar",
    "officename": "Khandagiri S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "752001": {
    "state": "Odisha",
    "district": "Puri",
    "block": "Puri",
    "officename": "Puri H.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Puri Division"
  },
  "752002": {
    "state": "Odisha",
    "district": "Puri",
    "block": "Puri",
    "officename": "Puri Station Road S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Puri Division"
  },
  "752003": {
    "state": "Odisha",
    "district": "Puri",
    "block": "Puri",
    "officename": "Srivihar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Puri Division"
  },
  "752011": {
    "state": "Odisha",
    "district": "Puri",
    "block": "Brahmagiri",
    "officename": "Brahmagiri S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Puri Division"
  },
  "752012": {
    "state": "Odisha",
    "district": "Puri",
    "block": "Puri",
    "officename": "Chandanpur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Puri Division"
  },
  "752013": {
    "state": "Odisha",
    "district": "Puri",
    "block": "Puri",
    "officename": "Basudevpur S.O (Puri)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Puri Division"
  },
  "752014": {
    "state": "Odisha",
    "district": "Puri",
    "block": "Satyabadi",
    "officename": "Sakhigopal S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Puri Division"
  },
  "752015": {
    "state": "Odisha",
    "district": "Puri",
    "block": "Puri",
    "officename": "Delang S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Puri Division"
  },
  "752016": {
    "state": "Odisha",
    "district": "Puri",
    "block": "Puri",
    "officename": "Berboi S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Puri Division"
  },
  "752017": {
    "state": "Odisha",
    "district": "Puri",
    "block": "Puri",
    "officename": "Kanas S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Puri Division"
  },
  "752018": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Khurda",
    "officename": "Narangarh S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "752019": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Banpur",
    "officename": "Nirakarpur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "752020": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Khurda",
    "officename": "Jankia S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "752021": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Tangi",
    "officename": "Singipur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "752022": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Tangi",
    "officename": "Kaluparaghat S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "752023": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Tangi",
    "officename": "Tangi S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "752024": {
    "state": "Odisha",
    "district": "Nayagarh",
    "block": "Ranpur",
    "officename": "Chandapur S.O (Nayagarh)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Nayagarh Division"
  },
  "752025": {
    "state": "Odisha",
    "district": "Nayagarh",
    "block": "Ranpur",
    "officename": "Gopalpur S.O (Nayagarh)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Nayagarh Division"
  },
  "752026": {
    "state": "Odisha",
    "district": "Nayagarh",
    "block": "Ranpur",
    "officename": "Rajranpur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Nayagarh Division"
  },
  "752027": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Banpur",
    "officename": "Kuhuri S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "752030": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Banpur",
    "officename": "Balugaon S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "752031": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Banpur",
    "officename": "Banpur  S.O (Khorda)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "752034": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Banpur",
    "officename": "Gangadharpur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "752035": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Banpur",
    "officename": "Gambharimunda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "752037": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Banpur",
    "officename": "Navalbasechilika  S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "752038": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Begunia",
    "officename": "Siko S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "752045": {
    "state": "Odisha",
    "district": "Puri",
    "block": "Sakhigopal",
    "officename": "Gabakunda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Puri Division"
  },
  "752046": {
    "state": "Odisha",
    "district": "Puri",
    "block": "Satyabadi",
    "officename": "Satasankha S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Puri Division"
  },
  "752050": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Bhubaneswar",
    "officename": "Jatni S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "752054": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Bhubaneswar",
    "officename": "Janla S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "752055": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Khurda",
    "officename": "Khurda H.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "752056": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Khurda",
    "officename": "Pallahat S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "752057": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Khurda",
    "officename": "P N College S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "752060": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Khurda",
    "officename": "Bajpur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "752061": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Khurda",
    "officename": "Baghamari S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "752062": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Nayagarh",
    "officename": "Begunia S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "752063": {
    "state": "Odisha",
    "district": "Nayagarh",
    "block": "Bhapur",
    "officename": "Bhapur S.O (Nayagarh)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Nayagarh Division"
  },
  "752064": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Khurda",
    "officename": "Pichikuli S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "752065": {
    "state": "Odisha",
    "district": "Nayagarh",
    "block": "Ranpur",
    "officename": "Rajsunakhala S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Nayagarh Division"
  },
  "752066": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Bolagarh",
    "officename": "Bolagarh S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "752068": {
    "state": "Odisha",
    "district": "Nayagarh",
    "block": "Nayagarh",
    "officename": "Itamati S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Nayagarh Division"
  },
  "752069": {
    "state": "Odisha",
    "district": "Nayagarh",
    "block": "Nayagarh",
    "officename": "Nayagarh H.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Nayagarh Division"
  },
  "752070": {
    "state": "Odisha",
    "district": "Nayagarh",
    "block": "Ranpur",
    "officename": "Nayagarh Bazar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Nayagarh Division"
  },
  "752077": {
    "state": "Odisha",
    "district": "Nayagarh",
    "block": "Khandaparagarh",
    "officename": "Khandapadagarh S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Nayagarh Division"
  },
  "752078": {
    "state": "Odisha",
    "district": "Nayagarh",
    "block": "Khandaparagarh",
    "officename": "Kantilo S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Nayagarh Division"
  },
  "752079": {
    "state": "Odisha",
    "district": "Nayagarh",
    "block": "Ranpur",
    "officename": "Mandhatapur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Nayagarh Division"
  },
  "752080": {
    "state": "Odisha",
    "district": "Nayagarh",
    "block": "Nayagarh",
    "officename": "Sarankul S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Nayagarh Division"
  },
  "752081": {
    "state": "Odisha",
    "district": "Nayagarh",
    "block": "Nayagarh",
    "officename": "Odagaon S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Nayagarh Division"
  },
  "752082": {
    "state": "Odisha",
    "district": "Nayagarh",
    "block": "Nayagarh",
    "officename": "Bahadajhola S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Nayagarh Division"
  },
  "752083": {
    "state": "Odisha",
    "district": "Nayagarh",
    "block": "Nayagarh",
    "officename": "Nuagaon S.O (Nayagarh)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Nayagarh Division"
  },
  "752084": {
    "state": "Odisha",
    "district": "Nayagarh",
    "block": "Ranpur",
    "officename": "Daspalla S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Nayagarh Division"
  },
  "752085": {
    "state": "Odisha",
    "district": "Nayagarh",
    "block": "Ranpur",
    "officename": "Gania S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Nayagarh Division"
  },
  "752089": {
    "state": "Odisha",
    "district": "Nayagarh",
    "block": "Nayagarh",
    "officename": "Banigochha S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Nayagarh Division"
  },
  "752090": {
    "state": "Odisha",
    "district": "Nayagarh",
    "block": "Khandapara",
    "officename": "Kural S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Nayagarh Division"
  },
  "752091": {
    "state": "Odisha",
    "district": "Nayagarh",
    "block": "Nayagarh",
    "officename": "Satpatna S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Nayagarh Division"
  },
  "752092": {
    "state": "Odisha",
    "district": "Nayagarh",
    "block": "Ranpur",
    "officename": "Godipada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Nayagarh Division"
  },
  "752093": {
    "state": "Odisha",
    "district": "Nayagarh",
    "block": "Khandapara",
    "officename": "Madhyakhand S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Nayagarh Division"
  },
  "752094": {
    "state": "Odisha",
    "district": "Nayagarh",
    "block": "Khandapara",
    "officename": "Mahipur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Nayagarh Division"
  },
  "752100": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Bhubaneswar",
    "officename": "Balakati S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "752101": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Bhubaneswar",
    "officename": "Balianta S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "752102": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Bhubaneswar",
    "officename": "Balipatna S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "752103": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Bhubaneswar",
    "officename": "Banamalipur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "752104": {
    "state": "Odisha",
    "district": "Puri",
    "block": "Pipili",
    "officename": "Pipili SO",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Puri Division"
  },
  "752105": {
    "state": "Odisha",
    "district": "Puri",
    "block": "Nimapara",
    "officename": "Balanga SO",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Puri Division"
  },
  "752106": {
    "state": "Odisha",
    "district": "Puri",
    "block": "Nimapada",
    "officename": "Nimapara",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Puri Division"
  },
  "752107": {
    "state": "Odisha",
    "district": "Puri",
    "block": "Kakatpur",
    "officename": "Nayahat",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Puri Division"
  },
  "752108": {
    "state": "Odisha",
    "district": "Puri",
    "block": "Kakatpur",
    "officename": "Kakatpur",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Puri Division"
  },
  "752109": {
    "state": "Odisha",
    "district": "Puri",
    "block": "Kakatpur",
    "officename": "Astarang",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Puri Division"
  },
  "752110": {
    "state": "Odisha",
    "district": "Puri",
    "block": "Gop",
    "officename": "Gop",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Puri Division"
  },
  "752111": {
    "state": "Odisha",
    "district": "Puri",
    "block": "Kakatpur",
    "officename": "Konark",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Puri Division"
  },
  "752113": {
    "state": "Odisha",
    "district": "Puri",
    "block": "Nimapara",
    "officename": "Brahmakundi",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Puri Division"
  },
  "752114": {
    "state": "Odisha",
    "district": "Puri",
    "block": "Nimapara",
    "officename": "Rench",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Puri Division"
  },
  "752115": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Balianta",
    "officename": "Bhatpatna S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "752116": {
    "state": "Odisha",
    "district": "Puri",
    "block": "Nimapara",
    "officename": "Birtung",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Puri Division"
  },
  "752118": {
    "state": "Odisha",
    "district": "Puri",
    "block": "Kakatpur",
    "officename": "Bangurigaon",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Puri Division"
  },
  "752119": {
    "state": "Odisha",
    "district": "Puri",
    "block": "Kakatpur",
    "officename": "Lataharan",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Puri Division"
  },
  "752120": {
    "state": "Odisha",
    "district": "Puri",
    "block": "Nimapada",
    "officename": "NUAPALAMHAT S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "752121": {
    "state": "Odisha",
    "district": "Puri",
    "block": "Nimapara",
    "officename": "Bamanal",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Puri Division"
  },
  "753001": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Cuttack Sadar",
    "officename": "Cuttack G.P.O.",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "753002": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Cuttack Sadar",
    "officename": "Chandinchowk H.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "753003": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Cuttack Sadar",
    "officename": "College Square S.O (Cuttack)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "753004": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Cuttack Sadar",
    "officename": "Nayabazar S.O (Cuttack)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "753006": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Cuttack Sadar",
    "officename": "C R R I S.O (Cuttack)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "753007": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Cuttack Sadar",
    "officename": "Medical College S.O (Cuttack)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "753008": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Cuttack Sadar",
    "officename": "Tulasipur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "753009": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Cuttack Sadar",
    "officename": "Telenga Bazar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "753010": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Cuttack Sadar",
    "officename": "Madhupatna S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "753011": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Cuttack Sadar",
    "officename": "Gopalpur S.O (Cuttack)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "753012": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Cuttack Sadar",
    "officename": "A D Market S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "753013": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Cuttack Sadar",
    "officename": "Kalyani Nagar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "753014": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Cuttack Sadar",
    "officename": "Avinab Bidanasi S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "753015": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Cuttack Sadar",
    "officename": "Sector ll CDA Cuttack S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "754001": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Cuttack Sadar",
    "officename": "Fulnakhara S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "754002": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Niali",
    "officename": "Sundargram S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "754003": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Cuttack Sadar",
    "officename": "Govindpur S.O (Cuttack)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "754004": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Niali",
    "officename": "Niali S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "754005": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Cuttack Sadar",
    "officename": "Barang S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "754006": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Cuttack Sadar",
    "officename": "Mundali Colony S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "754007": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Banki",
    "officename": "Dompara S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754008": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Banki",
    "officename": "Banki S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754009": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Banki",
    "officename": "Kalapathar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754010": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Cuttack Sadar",
    "officename": "Bairoi S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "754011": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Niali",
    "officename": "Adaspur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "754012": {
    "state": "Odisha",
    "district": "Khorda",
    "block": "Chandaka",
    "officename": "ASBM UNIVERSITY SOBhola",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "754013": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Cuttack Sadar",
    "officename": "CISF Mundali S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "754018": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Niali",
    "officename": "Bramhansailo S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "754021": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Jagatpur",
    "officename": "JAGATPUR S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "754022": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Tangi Choudwar",
    "officename": "Kotasahi S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754023": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Darpan",
    "officename": "CHHATIA S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "JAJPUR DIVISION"
  },
  "754024": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Darpan",
    "officename": "Dhanmandal S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "JAJPUR DIVISION"
  },
  "754025": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Jagatpur",
    "officename": "Choudwar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754026": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Choudwar",
    "officename": "Daulatabad S.O (Cuttack)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754027": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Choudwar",
    "officename": "Chasapara S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754028": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Jagatpur",
    "officename": "Charbatia S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754029": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Athagarh",
    "officename": "Athagarh H.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754030": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Tigiria",
    "officename": "Tigiria S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754031": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Badamba",
    "officename": "Barambagarh S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754032": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Narasinghpur",
    "officename": "Narasinghpur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754035": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Badamba",
    "officename": "Nuapatna S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754037": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Narasinghpur",
    "officename": "Kanpur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754071": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Choudwar",
    "officename": "Kapaleswar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754082": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Darpan",
    "officename": "BYREE S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "JAJPUR DIVISION"
  },
  "754100": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Cuttack  Sadar",
    "officename": "Biribati S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "754102": {
    "state": "Odisha",
    "district": "Jagatsinghapur",
    "block": "Jagatsinghpur",
    "officename": "Anakhia S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754103": {
    "state": "Odisha",
    "district": "Jagatsinghapur",
    "block": "Jagatsinghpur",
    "officename": "Jagatsinghpur H.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754104": {
    "state": "Odisha",
    "district": "Jagatsinghapur",
    "block": "Jagatsinghpur",
    "officename": "Nalibar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754105": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Niali",
    "officename": "Kasarda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "754106": {
    "state": "Odisha",
    "district": "Jagatsinghapur",
    "block": "Jagatsinghpur",
    "officename": "Kaduapada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754107": {
    "state": "Odisha",
    "district": "Jagatsinghapur",
    "block": "Naugaon",
    "officename": "Alanahat S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754108": {
    "state": "Odisha",
    "district": "Jagatsinghapur",
    "block": "Balikuda",
    "officename": "Balikuda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754109": {
    "state": "Odisha",
    "district": "Jagatsinghapur",
    "block": "Naugaon",
    "officename": "Debidol S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754110": {
    "state": "Odisha",
    "district": "Jagatsinghapur",
    "block": "Balikuda",
    "officename": "Borikina S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754111": {
    "state": "Odisha",
    "district": "Jagatsinghapur",
    "block": "Jagatsinghpur",
    "officename": "Biridiroad S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754112": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Cuttack Sadar",
    "officename": "Bentakar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "754113": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Athagarh",
    "officename": "Naugaonhat S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754114": {
    "state": "Odisha",
    "district": "Jagatsinghapur",
    "block": "Jagatsinghapur",
    "officename": "Mandasahi S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754119": {
    "state": "Odisha",
    "district": "Jagatsinghapur",
    "block": "Balikuda",
    "officename": "Machhagaon S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754120": {
    "state": "Odisha",
    "district": "Jagatsinghapur",
    "block": "Paradip",
    "officename": "Atharbanki Rly Colony S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754130": {
    "state": "Odisha",
    "district": "Jagatsinghapur",
    "block": "Jagatsinghpur",
    "officename": "SOMPUR S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "754131": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Kishannagar",
    "officename": "KISHORENAGAR S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "754132": {
    "state": "Odisha",
    "district": "Jagatsinghapur",
    "block": "Jagatsinghpur",
    "officename": "Raghunathpur S.O (Jagatsinghapur)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754133": {
    "state": "Odisha",
    "district": "Jagatsinghapur",
    "block": "Tirtol",
    "officename": "Tarpur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754134": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Kishorenagar",
    "officename": "TYANDAKURA S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "KENDRAPARA DIVISION"
  },
  "754135": {
    "state": "Odisha",
    "district": "Jagatsinghapur",
    "block": "Tirtol",
    "officename": "Krishnanandapur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754136": {
    "state": "Odisha",
    "district": "Jagatsinghapur",
    "block": "Tirtol",
    "officename": "Kanakpur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754137": {
    "state": "Odisha",
    "district": "Jagatsinghapur",
    "block": "Tirtol",
    "officename": "Tirtol S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754138": {
    "state": "Odisha",
    "district": "Jagatsinghapur",
    "block": "Tirtol",
    "officename": "Tiran S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754139": {
    "state": "Odisha",
    "district": "Jagatsinghapur",
    "block": "Kujang",
    "officename": "Ersama S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754140": {
    "state": "Odisha",
    "district": "Jagatsinghapur",
    "block": "Tirtol",
    "officename": "Rahama S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754141": {
    "state": "Odisha",
    "district": "Jagatsinghapur",
    "block": "Kujang",
    "officename": "Kujang S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754142": {
    "state": "Odisha",
    "district": "Jagatsinghapur",
    "block": "Paradip",
    "officename": "Paradip S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754145": {
    "state": "Odisha",
    "district": "Jagatsinghapur",
    "block": "Paradip",
    "officename": "Ppl Township S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754153": {
    "state": "Odisha",
    "district": "Kendrapara",
    "block": "Patkura",
    "officename": "GARADPUR S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "KENDRAPARA DIVISION"
  },
  "754160": {
    "state": "Odisha",
    "district": "Jagatsinghapur",
    "block": "Tirtol",
    "officename": "Manijanga S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754162": {
    "state": "Odisha",
    "district": "Jagatsinghapur",
    "block": "Tirtol",
    "officename": "Kolar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754200": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Salipur",
    "officename": "Bahugram S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754201": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Salepur",
    "officename": "Rameswar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754202": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Salipur",
    "officename": "SALIPUR S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "754203": {
    "state": "Odisha",
    "district": "Kendrapara",
    "block": "Kendrapara",
    "officename": "KENDUPATNA S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "754204": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Salipur",
    "officename": "KUANPAL S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "754205": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Darpanigarh",
    "officename": "Balichandrapur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "KENDRAPARA DIVISION"
  },
  "754206": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Salipur",
    "officename": "MAHANGA S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "754207": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Salipur",
    "officename": "NISCHINTAKOILI S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "754208": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Salipur",
    "officename": "Chandol S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "KENDRAPARA DIVISION"
  },
  "754209": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Salipur",
    "officename": "ASURESWAR S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "754210": {
    "state": "Odisha",
    "district": "Kendrapara",
    "block": "Kendrapara",
    "officename": "Danpur S.O (Kendrapara)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "KENDRAPARA DIVISION"
  },
  "754211": {
    "state": "Odisha",
    "district": "Kendrapara",
    "block": "Kendrapara",
    "officename": "Kendrapara H.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "KENDRAPARA DIVISION"
  },
  "754212": {
    "state": "Odisha",
    "district": "Kendrapara",
    "block": "Kendrapara",
    "officename": "Sribaldevjew S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "KENDRAPARA DIVISION"
  },
  "754213": {
    "state": "Odisha",
    "district": "Kendrapara",
    "block": "Marsaghai",
    "officename": "Marsaghai S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "KENDRAPARA DIVISION"
  },
  "754214": {
    "state": "Odisha",
    "district": "Kendrapara",
    "block": "Kendrapara",
    "officename": "Indupur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "KENDRAPARA DIVISION"
  },
  "754215": {
    "state": "Odisha",
    "district": "Kendrapara",
    "block": "Pattamundai",
    "officename": "Pattamundai S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "KENDRAPARA DIVISION"
  },
  "754216": {
    "state": "Odisha",
    "district": "Kendrapara",
    "block": "Pattamundai",
    "officename": "Jaria S.O (Kendrapara)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "KENDRAPARA DIVISION"
  },
  "754217": {
    "state": "Odisha",
    "district": "Kendrapara",
    "block": "Pattamundai",
    "officename": "Alba S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "KENDRAPARA DIVISION"
  },
  "754218": {
    "state": "Odisha",
    "district": "Kendrapara",
    "block": "Pattamundai",
    "officename": "Batipada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "KENDRAPARA DIVISION"
  },
  "754219": {
    "state": "Odisha",
    "district": "Kendrapara",
    "block": "Aul",
    "officename": "Aul S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "KENDRAPARA DIVISION"
  },
  "754220": {
    "state": "Odisha",
    "district": "Kendrapara",
    "block": "Rajkanika",
    "officename": "Rajkanika S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "KENDRAPARA DIVISION"
  },
  "754221": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Salipur",
    "officename": "SUNGRA S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "754222": {
    "state": "Odisha",
    "district": "Kendrapara",
    "block": "Pattamundai",
    "officename": "Chaudakulat S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "KENDRAPARA DIVISION"
  },
  "754223": {
    "state": "Odisha",
    "district": "Kendrapara",
    "block": "Kendrapara",
    "officename": "Karilopatna S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "KENDRAPARA DIVISION"
  },
  "754224": {
    "state": "Odisha",
    "district": "Kendrapara",
    "block": "Kendrapara",
    "officename": "Mahakalpara S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "KENDRAPARA DIVISION"
  },
  "754225": {
    "state": "Odisha",
    "district": "Kendrapara",
    "block": "Rajnagar",
    "officename": "Rajnagar S.O (Kendrapara)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "KENDRAPARA DIVISION"
  },
  "754227": {
    "state": "Odisha",
    "district": "Kendrapara",
    "block": "Rajkanika",
    "officename": "Olavar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "KENDRAPARA DIVISION"
  },
  "754228": {
    "state": "Odisha",
    "district": "Kendrapara",
    "block": "Kendrapara",
    "officename": "Patakura S.O (Kendrapara)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "KENDRAPARA DIVISION"
  },
  "754231": {
    "state": "Odisha",
    "district": "Kendrapara",
    "block": "Aul",
    "officename": "Namouza S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "KENDRAPARA DIVISION"
  },
  "754239": {
    "state": "Odisha",
    "district": "Kendrapara",
    "block": "Aul",
    "officename": "Bhuinpur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "KENDRAPARA DIVISION"
  },
  "754240": {
    "state": "Odisha",
    "district": "Kendrapara",
    "block": "Pattamundai",
    "officename": "Dandisahi S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "KENDRAPARA DIVISION"
  },
  "754244": {
    "state": "Odisha",
    "district": "Kendrapara",
    "block": "Kendrapara",
    "officename": "Jampara S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "KENDRAPARA DIVISION"
  },
  "754245": {
    "state": "Odisha",
    "district": "Kendrapara",
    "block": "Pattamundai",
    "officename": "Barpada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "KENDRAPARA DIVISION"
  },
  "754246": {
    "state": "Odisha",
    "district": "Kendrapara",
    "block": "Pattamundai",
    "officename": "Madanpur S.O (Kendrapara)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "KENDRAPARA DIVISION"
  },
  "754248": {
    "state": "Odisha",
    "district": "Kendrapara",
    "block": "Rajnagar",
    "officename": "Iswarpur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "KENDRAPARA DIVISION"
  },
  "754250": {
    "state": "Odisha",
    "district": "Kendrapara",
    "block": "Kendrapara",
    "officename": "Thakurpatna S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "KENDRAPARA DIVISION"
  },
  "754253": {
    "state": "Odisha",
    "district": "Kendrapara",
    "block": "Kendrapara",
    "officename": "Bedari S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "KENDRAPARA DIVISION"
  },
  "754289": {
    "state": "Odisha",
    "district": "Kendrapara",
    "block": "Kendrapara",
    "officename": "Derabish S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "KENDRAPARA DIVISION"
  },
  "754290": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Mahanga",
    "officename": "Mouda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754292": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Darpanigarh",
    "officename": "Charinangal S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "KENDRAPARA DIVISION"
  },
  "754293": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Salipur",
    "officename": "Lemalo S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "754294": {
    "state": "Odisha",
    "district": "Jagatsinghapur",
    "block": "Jagatsinghapur",
    "officename": "Chatra S.O (Jagatsinghapur)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754295": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Athagad",
    "officename": "Athagarh Bazar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754296": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Darpan",
    "officename": "SUNGUDA S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "JAJPUR DIVISION"
  },
  "755001": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Jajpur",
    "officename": "Jajpur H.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "JAJPUR DIVISION"
  },
  "755003": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Dharmasala",
    "officename": "Bari Cuttack S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "JAJPUR DIVISION"
  },
  "755004": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Jajapur",
    "officename": "Binjharpur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "JAJPUR DIVISION"
  },
  "755005": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Dharmasala",
    "officename": "Brahmabarada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "JAJPUR DIVISION"
  },
  "755006": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Jajpur",
    "officename": "Dasarathpur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "JAJPUR DIVISION"
  },
  "755007": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Jajpur",
    "officename": "Debidwar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "JAJPUR DIVISION"
  },
  "755008": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Dharmasala",
    "officename": "Dharmasala S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "JAJPUR DIVISION"
  },
  "755009": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Jajpur",
    "officename": "Kabirpur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "JAJPUR DIVISION"
  },
  "755010": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Dharmasala",
    "officename": "Kaipara S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "JAJPUR DIVISION"
  },
  "755011": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Jajpur",
    "officename": "Mangalpur S.O (Jajapur)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "JAJPUR DIVISION"
  },
  "755012": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Jajpur",
    "officename": "Mashra S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "JAJPUR DIVISION"
  },
  "755013": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Jajpur",
    "officename": "Pritipur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "JAJPUR DIVISION"
  },
  "755014": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Jajpur",
    "officename": "Rambag S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "JAJPUR DIVISION"
  },
  "755015": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Jajpur Road",
    "officename": "Sankhachilla S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "JAJPUR DIVISION"
  },
  "755016": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Binjharpur",
    "officename": "Singhpur S.O (Jajapur)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "JAJPUR DIVISION"
  },
  "755017": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Dharmasala",
    "officename": "Sujanpur S.O (Jajapur)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "JAJPUR DIVISION"
  },
  "755018": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Jajpur Road",
    "officename": "Sukinda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "JAJPUR DIVISION"
  },
  "755019": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Jajpur Road",
    "officename": "Jajpur Road RS S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "JAJPUR DIVISION"
  },
  "755020": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Jajpur Road",
    "officename": "Ferro Chrome Project S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "JAJPUR DIVISION"
  },
  "755022": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Jajpur Road",
    "officename": "Korei S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "JAJPUR DIVISION"
  },
  "755023": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Jajpur Road",
    "officename": "Jenapur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "JAJPUR DIVISION"
  },
  "755024": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Darpanigarh",
    "officename": "Haridaspur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "JAJPUR DIVISION"
  },
  "755025": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Jajpur Road",
    "officename": "Barundai S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "JAJPUR DIVISION"
  },
  "755026": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Jajpur Road",
    "officename": "Dangadi S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "JAJPUR DIVISION"
  },
  "755027": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Jajpur",
    "officename": "Arei S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "JAJPUR DIVISION"
  },
  "755028": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Jajpur Road",
    "officename": "Kalaringatta S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "JAJPUR DIVISION"
  },
  "755036": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Jajpur",
    "officename": "Ahiyas S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "JAJPUR DIVISION"
  },
  "755043": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Jajpur",
    "officename": "Panikoili S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "JAJPUR DIVISION"
  },
  "755044": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Darpanigarh",
    "officename": "Chandikhol S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "JAJPUR DIVISION"
  },
  "755049": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Darpanigarh",
    "officename": "Kantigadia S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "JAJPUR DIVISION"
  },
  "755050": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Dharmasala",
    "officename": "Jaraka S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "JAJPUR DIVISION"
  },
  "755061": {
    "state": "Odisha",
    "district": "Kendrapara",
    "block": "Aul",
    "officename": "Govindpur Kutchery S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "KENDRAPARA DIVISION"
  },
  "755062": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Jajpur",
    "officename": "Chitalo S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "JAJPUR DIVISION"
  },
  "756001": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Balasore",
    "officename": "Balasore H.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756002": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Balasore",
    "officename": "Sunhat S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756003": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Balasore",
    "officename": "Motiganj S.O (Baleswar)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756019": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Balasore",
    "officename": "Remuna S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756020": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Niligiri",
    "officename": "Mitrapur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756021": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Balasore",
    "officename": "Rasalpur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756022": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Basta",
    "officename": "Darada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756023": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Baliapal",
    "officename": "Singla S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756024": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Baliapal",
    "officename": "Nangaleswar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756025": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Balasore",
    "officename": "Chandipur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756026": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Baliapal",
    "officename": "Baliapal S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756027": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Basta",
    "officename": "Haldipada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756028": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Basta",
    "officename": "Rupsa S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756029": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Basta",
    "officename": "Basta S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756030": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Basta",
    "officename": "Amarda Road S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756032": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Jaleswar",
    "officename": "Jaleswar H.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756033": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Raibania",
    "officename": "Hatigarh S.O (Baleswar)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756034": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Jaleswar",
    "officename": "Nampo S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756035": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Bhograi",
    "officename": "Kamarda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756036": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Bhograi",
    "officename": "Dehurda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756037": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Bhograi",
    "officename": "Fulbani S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756038": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Bhograi",
    "officename": "Bhograi S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756039": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Bhograi",
    "officename": "Kakhra S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756040": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Nilgiri",
    "officename": "Raj Nilgiri S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756041": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Nilgiri",
    "officename": "Sajanagarh S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756042": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Soro",
    "officename": "Bahanaga S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756043": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Soro",
    "officename": "Khantapada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756044": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Soro",
    "officename": "Gopalpur S.O (Balasore)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756045": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Soro",
    "officename": "Soro S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756046": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Soro",
    "officename": "Anantapur S.O (Baleswar)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756047": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Soro",
    "officename": "Turigaria S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756048": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Soro",
    "officename": "Khaira S.O (Baleswar)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756049": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Niligiri",
    "officename": "Oupada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756051": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Soro",
    "officename": "Avana S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756055": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Soro",
    "officename": "Chakabarahapur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756056": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Baleshwar Sadar",
    "officename": "Kuruda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756058": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Nilgiri",
    "officename": "Raj Berhampur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756059": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Simulia",
    "officename": "Kupari S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756060": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Nilgiri",
    "officename": "Sergarh S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756079": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Bhograi",
    "officename": "Dahamunda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756080": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Jaleswar",
    "officename": "Irda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756081": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Singla",
    "officename": "Jamsuli S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756083": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Baliapal",
    "officename": "Pratappur S.O (Baleswar)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756084": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Jaleswar",
    "officename": "Dhansimulia S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756085": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Bhograi",
    "officename": "Chandaneswar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756086": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Jaleswar",
    "officename": "Jaleswar Railway Station S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756100": {
    "state": "Odisha",
    "district": "Bhadrak",
    "block": "Bhadrak Rural",
    "officename": "Bhadrak H.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756101": {
    "state": "Odisha",
    "district": "Bhadrak",
    "block": "Bhadrak",
    "officename": "Charampa S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756111": {
    "state": "Odisha",
    "district": "Bhadrak",
    "block": "Bhadrak",
    "officename": "Ranital S.O (Bhadrak)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756112": {
    "state": "Odisha",
    "district": "Bhadrak",
    "block": "Bant",
    "officename": "Barikpur Bazar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756113": {
    "state": "Odisha",
    "district": "Bhadrak",
    "block": "Bant",
    "officename": "Barapada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756114": {
    "state": "Odisha",
    "district": "Bhadrak",
    "block": "Bant",
    "officename": "Bant S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756115": {
    "state": "Odisha",
    "district": "Bhadrak",
    "block": "Bant",
    "officename": "B T Pur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756116": {
    "state": "Odisha",
    "district": "Bhadrak",
    "block": "Bhadrak Rural",
    "officename": "Arnapal S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756117": {
    "state": "Odisha",
    "district": "Bhadrak",
    "block": "Dhamanagar",
    "officename": "Dhamnagar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756118": {
    "state": "Odisha",
    "district": "Bhadrak",
    "block": "Dhusuri",
    "officename": "Kothar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756119": {
    "state": "Odisha",
    "district": "Bhadrak",
    "block": "Dhamanagar",
    "officename": "Dhusuri S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756120": {
    "state": "Odisha",
    "district": "Bhadrak",
    "block": "Dhamnagar",
    "officename": "Bhandari Pokhari S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756121": {
    "state": "Odisha",
    "district": "Bhadrak",
    "block": "Dhamnagar",
    "officename": "Manjuri Road S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756122": {
    "state": "Odisha",
    "district": "Bhadrak",
    "block": "Dhamnagar",
    "officename": "Akhuapada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756123": {
    "state": "Odisha",
    "district": "Bhadrak",
    "block": "Basudevpur",
    "officename": "Sabrang S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756124": {
    "state": "Odisha",
    "district": "Bhadrak",
    "block": "Basudevpur",
    "officename": "Ertal S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756125": {
    "state": "Odisha",
    "district": "Bhadrak",
    "block": "Basudebpur",
    "officename": "Basudevpur S.O (Bhadrak)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756126": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Similia",
    "officename": "Simulia S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756127": {
    "state": "Odisha",
    "district": "Bhadrak",
    "block": "Tihidi",
    "officename": "Dolasahi S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756128": {
    "state": "Odisha",
    "district": "Bhadrak",
    "block": "Bhadrak",
    "officename": "Gujidarada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756129": {
    "state": "Odisha",
    "district": "Bhadrak",
    "block": "Chandabali",
    "officename": "Ghanteswar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756130": {
    "state": "Odisha",
    "district": "Bhadrak",
    "block": "Tihidi",
    "officename": "Tihidi S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756131": {
    "state": "Odisha",
    "district": "Bhadrak",
    "block": "Tihidi",
    "officename": "Pirahatbazar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756132": {
    "state": "Odisha",
    "district": "Bhadrak",
    "block": "Chandbali",
    "officename": "Motto S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756133": {
    "state": "Odisha",
    "district": "Bhadrak",
    "block": "Chandbali",
    "officename": "Chandbali S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756134": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Similia",
    "officename": "Ada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756135": {
    "state": "Odisha",
    "district": "Bhadrak",
    "block": "Bhadrak",
    "officename": "Randiahat S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756137": {
    "state": "Odisha",
    "district": "Bhadrak",
    "block": "Dhamnagar",
    "officename": "Asurali S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756138": {
    "state": "Odisha",
    "district": "Bhadrak",
    "block": "Chandbali",
    "officename": "Aradi S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756139": {
    "state": "Odisha",
    "district": "Bhadrak",
    "block": "Tihidi",
    "officename": "Arsa S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756144": {
    "state": "Odisha",
    "district": "Bhadrak",
    "block": "Bant",
    "officename": "Basantia S.O (Bhadrak)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756162": {
    "state": "Odisha",
    "district": "Bhadrak",
    "block": "Basudevpur",
    "officename": "Eram S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756163": {
    "state": "Odisha",
    "district": "Bhadrak",
    "block": "Bhadrak Rural",
    "officename": "Guamal S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756164": {
    "state": "Odisha",
    "district": "Bhadrak",
    "block": "Basudevpur",
    "officename": "Naikanidihi S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756165": {
    "state": "Odisha",
    "district": "Bhadrak",
    "block": "Basudevpur",
    "officename": "Brahmanigaon S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756166": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Similia",
    "officename": "Balikhanda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756167": {
    "state": "Odisha",
    "district": "Bhadrak",
    "block": "Tihidi",
    "officename": "Paliabindha S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756168": {
    "state": "Odisha",
    "district": "Bhadrak",
    "block": "Basudevpur",
    "officename": "Betada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756171": {
    "state": "Odisha",
    "district": "Bhadrak",
    "block": "Basudebpur",
    "officename": "Dhamara S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756181": {
    "state": "Odisha",
    "district": "Bhadrak",
    "block": "Bhadrak Rural",
    "officename": "Madhabnagar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "756182": {
    "state": "Odisha",
    "district": "Baleswar",
    "block": "Simulia",
    "officename": "Dungura S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhadrak Division"
  },
  "757001": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Baripada",
    "officename": "Baripada H.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757002": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Baripada",
    "officename": "Bhanjpur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757003": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Baripada",
    "officename": "Takatpur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757014": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Baripada",
    "officename": "Chandua Ashram S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757016": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "R.g.pur",
    "officename": "Rasgovindpur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757017": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Barsahi",
    "officename": "Mantri S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757018": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Rasgovindpur",
    "officename": "Chitrada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757019": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Udala",
    "officename": "Khunta S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757020": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Rg Pur",
    "officename": "Moroda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757021": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Baripada",
    "officename": "Deuli S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757022": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Baripada",
    "officename": "Suliapada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757023": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Baripada",
    "officename": "Garia S.O (Mayurbhanj)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757024": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Barsahi",
    "officename": "Sankerko S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757025": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Betnoti",
    "officename": "Betnoti S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757026": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Barsahi",
    "officename": "Barsahi S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757027": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Udala",
    "officename": "Kuamara S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757028": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Betnoti",
    "officename": "Baisinga S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757029": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Betnoti",
    "officename": "Krushnachandrapur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757030": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Baripada",
    "officename": "Kuliana S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757031": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Baripada",
    "officename": "Shirsa S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Rairangpur Division"
  },
  "757032": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Baripada",
    "officename": "Bangriposi S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Rairangpur Division"
  },
  "757033": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Rairangpur",
    "officename": "Bisoi S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Rairangpur Division"
  },
  "757034": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Karanjia",
    "officename": "Jashipur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Rairangpur Division"
  },
  "757035": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Karanjia",
    "officename": "Raruan S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Rairangpur Division"
  },
  "757036": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Karanjia",
    "officename": "Tato S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Rairangpur Division"
  },
  "757037": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Karanjia",
    "officename": "Karanjia S.O (Mayurbhanj)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Rairangpur Division"
  },
  "757038": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Karanjia",
    "officename": "Thakurmunda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Rairangpur Division"
  },
  "757039": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Karanjia",
    "officename": "Sukruli S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Rairangpur Division"
  },
  "757040": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Udala",
    "officename": "Kaptipada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757041": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Udala",
    "officename": "Udala S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757042": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Rairangpur",
    "officename": "Gorumahisani S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Rairangpur Division"
  },
  "757043": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Rairangpur",
    "officename": "Rairangpur H.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Rairangpur Division"
  },
  "757045": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Rairangpur",
    "officename": "Jamda S.O (Mayurbhanj)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Rairangpur Division"
  },
  "757046": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Bahalda",
    "officename": "Bahalda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Rairangpur Division"
  },
  "757047": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Rairangpur",
    "officename": "Badampahar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Rairangpur Division"
  },
  "757048": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Rairangpur",
    "officename": "Bijatala S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Rairangpur Division"
  },
  "757049": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Baripada",
    "officename": "Shyamakhunta S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757050": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Rairangpur",
    "officename": "Hatbadra S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Rairangpur Division"
  },
  "757051": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Baripada",
    "officename": "Saraskana S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Rairangpur Division"
  },
  "757052": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Betnoti",
    "officename": "Jugpura S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757053": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Bahalda",
    "officename": "Tiring S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Rairangpur Division"
  },
  "757054": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Rairangpur",
    "officename": "Bahalda Rd RS S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Rairangpur Division"
  },
  "757055": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Rasgovindpur",
    "officename": "Amarda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757073": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "R.g.pur",
    "officename": "Nalagaja S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757074": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Barsahi",
    "officename": "Basipitha S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757075": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Barsahi",
    "officename": "Dukura S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757077": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Udala",
    "officename": "Nudadiha S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757079": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Udala",
    "officename": "Sarat S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Rairangpur Division"
  },
  "757081": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Baripada",
    "officename": "Kumbharmundakata S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757082": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Betnoti",
    "officename": "Garhdeulia S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757083": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Barsahi",
    "officename": "Bhimda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757084": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Baripada",
    "officename": "Kostha S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757085": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Udala",
    "officename": "Kushalda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757086": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Baripada",
    "officename": "Jharpokharia S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Rairangpur Division"
  },
  "757087": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Udala",
    "officename": "Brundaban Chandrapur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757091": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Karanjia",
    "officename": "Khairi Jashipur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Rairangpur Division"
  },
  "757092": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Baripada",
    "officename": "Kusumbandi S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Rairangpur Division"
  },
  "757093": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Baripada",
    "officename": "Joka S.O (Mayurbhanj)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Rairangpur Division"
  },
  "757100": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Betnoti",
    "officename": "Bahanada Sathilo S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757101": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Udala",
    "officename": "Radho S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757102": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Udala",
    "officename": "Puruna Baripada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757103": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Barsahi",
    "officename": "Pratappur S.O (Mayurbhanj)",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757104": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Khunta",
    "officename": "Bahanada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757105": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Baripada",
    "officename": "Kuchei S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757106": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Udala",
    "officename": "Salchua S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "757107": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Baripada",
    "officename": "Laxmiposi S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "758001": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Kendujhar Town",
    "officename": "Keonjhargarh H.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758002": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Keonjhar",
    "officename": "Keonjhar Bazar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758013": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Keonjhar",
    "officename": "Raisuan S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758014": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Keonjhar",
    "officename": "Naranpur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758015": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Anandapur",
    "officename": "Ghasipura S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758016": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Ghatagaon",
    "officename": "Saharpada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758017": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Patna",
    "officename": "Rajanagar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758018": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Keonjhar",
    "officename": "Suakati S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758019": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Telkoi",
    "officename": "Telkoi S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758020": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Anandapur",
    "officename": "Salapada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758021": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Anandapur",
    "officename": "Anandapur S.O (Kendujhar)",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758022": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Anandapur",
    "officename": "Fakirpur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758023": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Hatadihi",
    "officename": "Hadagarh S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758025": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Anandapur",
    "officename": "Kushaleswar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758026": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Ghatagaon",
    "officename": "Talapada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758027": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Ghatagaon",
    "officename": "Ghatagaon S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758028": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Ghatagaon",
    "officename": "Harichandanpur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758029": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Ghatagaon",
    "officename": "Dhenkikote S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758030": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Patna",
    "officename": "Swampatna S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758031": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Champua",
    "officename": "Jhumpura S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758032": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Champua",
    "officename": "Ukhunda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758034": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Barbil",
    "officename": "Joda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758035": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Barbil",
    "officename": "Barbil S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758036": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Barbil",
    "officename": "Matkambeda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758037": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Barbil",
    "officename": "Bolani S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758038": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Barbil",
    "officename": "Baneikala S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758040": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Barbil",
    "officename": "Kiriburu Hill Top S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758041": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Champua",
    "officename": "Champua S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758043": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Anandapur",
    "officename": "Sainkul S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758044": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Champua",
    "officename": "Karanjia S.O (Kendujhar)",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758045": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Patna",
    "officename": "Udayapur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758046": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Champua",
    "officename": "Turumunga S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758047": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Champua",
    "officename": "Remuli S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758076": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Telkoi",
    "officename": "Sirigida S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758078": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Hatadihi",
    "officename": "Dhanurjaypur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758079": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Ghatagaon",
    "officename": "Janghira S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758080": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Ghatagaon",
    "officename": "Bhagamunda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758081": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Ghatagaon",
    "officename": "Machhagarh S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758082": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Ghatagaon",
    "officename": "Brahmanipal S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758083": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Hatadihi",
    "officename": "Hatadihi S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758084": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Telkoi",
    "officename": "Jagamohanpur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758085": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Banspal",
    "officename": "Banspal S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "759001": {
    "state": "Odisha",
    "district": "Dhenkanal",
    "block": "Dhenkanal",
    "officename": "Dhenkanal H.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759013": {
    "state": "Odisha",
    "district": "Dhenkanal",
    "block": "Dhenkanal Sadar",
    "officename": "Dhenkanal R S S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759014": {
    "state": "Odisha",
    "district": "Dhenkanal",
    "block": "Dhenkanal",
    "officename": "Mahimagadi S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759015": {
    "state": "Odisha",
    "district": "Dhenkanal",
    "block": "Dhenkanal",
    "officename": "Bhapur S.O (Dhenkanal)",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759016": {
    "state": "Odisha",
    "district": "Dhenkanal",
    "block": "Dhenkanal",
    "officename": "Gondiapatna S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759017": {
    "state": "Odisha",
    "district": "Dhenkanal",
    "block": "Kamakhyanagar",
    "officename": "Bhuban S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759018": {
    "state": "Odisha",
    "district": "Dhenkanal",
    "block": "Kamakhyanagar",
    "officename": "Kamakhyanagar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759019": {
    "state": "Odisha",
    "district": "Dhenkanal",
    "block": "Hindol",
    "officename": "Hindol Road R.S. S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759020": {
    "state": "Odisha",
    "district": "Dhenkanal",
    "block": "Hindol",
    "officename": "Balimi S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759021": {
    "state": "Odisha",
    "district": "Dhenkanal",
    "block": "Hindol",
    "officename": "Rasol S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759022": {
    "state": "Odisha",
    "district": "Dhenkanal",
    "block": "Hindol",
    "officename": "Hindol S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759023": {
    "state": "Odisha",
    "district": "Dhenkanal",
    "block": "Kamakhyanagar",
    "officename": "Marthapur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759024": {
    "state": "Odisha",
    "district": "Dhenkanal",
    "block": "Kamakhyanagar",
    "officename": "Mathakargola S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759025": {
    "state": "Odisha",
    "district": "Dhenkanal",
    "block": "Dhenkanal",
    "officename": "Gadasila S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759026": {
    "state": "Odisha",
    "district": "Dhenkanal",
    "block": "Kamakhyanagar",
    "officename": "Anlabereni S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759027": {
    "state": "Odisha",
    "district": "Dhenkanal",
    "block": "Dhenkanal",
    "officename": "Govindpur S.O (Dhenkanal)",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759028": {
    "state": "Odisha",
    "district": "Dhenkanal",
    "block": "Kamakhyanagar",
    "officename": "Kankadahad S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759037": {
    "state": "Odisha",
    "district": "Angul",
    "block": "Talcher",
    "officename": "Samal Barrage Township S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759039": {
    "state": "Odisha",
    "district": "Dhenkanal",
    "block": "Kamakhyanagar",
    "officename": "Badasuanlo S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759040": {
    "state": "Odisha",
    "district": "Angul",
    "block": "Banarpal",
    "officename": "Talmul S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759100": {
    "state": "Odisha",
    "district": "Angul",
    "block": "Rengali Damsite",
    "officename": "Talcher S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759101": {
    "state": "Odisha",
    "district": "Angul",
    "block": "Talcher",
    "officename": "Talcher Thermal S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759102": {
    "state": "Odisha",
    "district": "Angul",
    "block": "Talcher",
    "officename": "Deulbera Colliery S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759103": {
    "state": "Odisha",
    "district": "Angul",
    "block": "Talcher",
    "officename": "Dera S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759105": {
    "state": "Odisha",
    "district": "Angul",
    "block": "Talcher",
    "officename": "Rengali Dam Site S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759106": {
    "state": "Odisha",
    "district": "Angul",
    "block": "Talcher",
    "officename": "Vikrampur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759107": {
    "state": "Odisha",
    "district": "Angul",
    "block": "Talcher Sadar",
    "officename": "Talcher Town S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759111": {
    "state": "Odisha",
    "district": "Angul",
    "block": "Chhendipada",
    "officename": "Jindal Nagar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759116": {
    "state": "Odisha",
    "district": "Angul",
    "block": "Talcher",
    "officename": "Balanda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759117": {
    "state": "Odisha",
    "district": "Angul",
    "block": "Talcher",
    "officename": "Kaniha S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759118": {
    "state": "Odisha",
    "district": "Angul",
    "block": "Pallahara",
    "officename": "Khamar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759119": {
    "state": "Odisha",
    "district": "Angul",
    "block": "Pallahara",
    "officename": "Pallahara S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759120": {
    "state": "Odisha",
    "district": "Dhenkanal",
    "block": "Kamakhyanagar",
    "officename": "Parjang S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759121": {
    "state": "Odisha",
    "district": "Dhenkanal",
    "block": "Hindol",
    "officename": "Meramandali S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759122": {
    "state": "Odisha",
    "district": "Angul",
    "block": "Angul",
    "officename": "Angul H.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759123": {
    "state": "Odisha",
    "district": "Angul",
    "block": "Angul",
    "officename": "P.T.C.Angul S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759124": {
    "state": "Odisha",
    "district": "Angul",
    "block": "Angul",
    "officename": "Chhendipada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759125": {
    "state": "Odisha",
    "district": "Angul",
    "block": "Athamallik",
    "officename": "Athamallik S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759126": {
    "state": "Odisha",
    "district": "Angul",
    "block": "Athamallik",
    "officename": "Rajkishorenagar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759127": {
    "state": "Odisha",
    "district": "Angul",
    "block": "Athamallik",
    "officename": "Kishoreganj S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759128": {
    "state": "Odisha",
    "district": "Angul",
    "block": "Angul",
    "officename": "Banarpal S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759129": {
    "state": "Odisha",
    "district": "Angul",
    "block": "Angul",
    "officename": "Bantala S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759130": {
    "state": "Odisha",
    "district": "Angul",
    "block": "Angul",
    "officename": "Kosala S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759132": {
    "state": "Odisha",
    "district": "Angul",
    "block": "Angul",
    "officename": "Hulurisinga S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759141": {
    "state": "Odisha",
    "district": "Angul",
    "block": "Angul",
    "officename": "Bagedia S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759143": {
    "state": "Odisha",
    "district": "Angul",
    "block": "Angul",
    "officename": "Hakimpada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759145": {
    "state": "Odisha",
    "district": "Angul",
    "block": "Angul",
    "officename": "Nalconagar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759146": {
    "state": "Odisha",
    "district": "Dhenkanal",
    "block": "Parajang",
    "officename": "Igit Sarang S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759147": {
    "state": "Odisha",
    "district": "Angul",
    "block": "Talcher",
    "officename": "Deepasikha S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759148": {
    "state": "Odisha",
    "district": "Angul",
    "block": "Colliery",
    "officename": "Nehru Satabdi Nagar(Bharatpu) S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "760001": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Brahmapur Sadar",
    "officename": "Berhampur(GM) H.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "760002": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Brahmapur Sadar",
    "officename": "Berhampur City S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "760003": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Berhampur",
    "officename": "Gosaninuagam S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "760004": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Brahmapur Sadar",
    "officename": "Medical College S.O (Ganjam)",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "760005": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Brahmapur Sadar",
    "officename": "Hillpatna S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "760006": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Brahmapur Sadar",
    "officename": "Panigrahipentho S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "760007": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Berhampur",
    "officename": "Berhampur University S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "760008": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Brahmapur Sadar",
    "officename": "Lanjipalli S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "760009": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Brahmapur Sadar",
    "officename": "Nabeen S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "760010": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Brahmapur Sadar",
    "officename": "Engineering School S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "761001": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Berhampur",
    "officename": "Nimakhandi S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "761002": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Gopalpur",
    "officename": "Gopalpur S.O (Ganjam)",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "761003": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Purushottampur",
    "officename": "Bhatakumarada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "761004": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Jarada",
    "officename": "Patrapur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "761005": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Berhampur",
    "officename": "Jaradagada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "761006": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Berhampur",
    "officename": "Jayantipur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "761007": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Digapahandi",
    "officename": "Padmanavapur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "761008": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Berhampur",
    "officename": "Golanthara S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "761009": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Girisola",
    "officename": "Girisola S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "761010": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Chikiti",
    "officename": "Chikiti S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "761011": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Berhampur",
    "officename": "Nuapada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "761012": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Digapahandi",
    "officename": "Digapahandi S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "761013": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Aska",
    "officename": "Pattapur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Aska Division"
  },
  "761014": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Digapahandi",
    "officename": "Pudamari S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "761015": {
    "state": "Odisha",
    "district": "Gajapati",
    "block": "Mohana",
    "officename": "Mohana S.O.",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Rayagada Division"
  },
  "761016": {
    "state": "Odisha",
    "district": "Gajapati",
    "block": "R.udayagiri",
    "officename": "R.Udayagiri S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Rayagada Division"
  },
  "761017": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Mohana",
    "officename": "Chandragiri S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Rayagada Division"
  },
  "761018": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Purushottampur",
    "officename": "Purushottampur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "761019": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Purushottampur",
    "officename": "Pratapur S.O (Ganjam)",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "761020": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Chatrapur",
    "officename": "Chatrapur H.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "761025": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Chhatrapur",
    "officename": "Jayashree S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "761026": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Chatrapur",
    "officename": "Ganjam S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "761027": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Chatrapur",
    "officename": "Humma S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "761028": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Chatrapur",
    "officename": "Rambha S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "761029": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Khallikote",
    "officename": "Khallikote RS S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "761030": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Kkhallikote",
    "officename": "Khallikote S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "761031": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Kodala",
    "officename": "Beguniapada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "761032": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Kodala",
    "officename": "Kodala S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "761035": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Khallikote",
    "officename": "Sumandala S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "761037": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Chikiti",
    "officename": "Surangi S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "761041": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Purushottampur",
    "officename": "Badakharida S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "761042": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Digapahandi",
    "officename": "Bomokei S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "761043": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Purushottampur",
    "officename": "Pandia S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "761045": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Chatrapur",
    "officename": "Matikhalo S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "761052": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Berhampur",
    "officename": "Golabandha S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "761054": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Brahmapur Sadar",
    "officename": "Ballipada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "761055": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Digapahandi",
    "officename": "Bissmagiri S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "761100": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Berhampur",
    "officename": "Kukudakhandi S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "761101": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Hinjili",
    "officename": "Kanchuru S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Aska Division"
  },
  "761102": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Aska",
    "officename": "Hinjilicut S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Aska Division"
  },
  "761103": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Aska",
    "officename": "Pitala S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Aska Division"
  },
  "761104": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Aska",
    "officename": "Kabisuryanagar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Aska Division"
  },
  "761105": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Chhatrapur",
    "officename": "Polosara S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "761106": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Asika",
    "officename": "Seragada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Aska Division"
  },
  "761107": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Aska",
    "officename": "Dharakote S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Aska Division"
  },
  "761108": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Surada",
    "officename": "Surada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Aska Division"
  },
  "761109": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Surada",
    "officename": "Badagada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Aska Division"
  },
  "761110": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Aska",
    "officename": "Aska H.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Aska Division"
  },
  "761111": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Aska",
    "officename": "Nuagam S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Aska Division"
  },
  "761114": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Aska",
    "officename": "Mundamarai S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Aska Division"
  },
  "761115": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Aska",
    "officename": "Gunthapada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Aska Division"
  },
  "761116": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Aska",
    "officename": "Bhetonoi S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Aska Division"
  },
  "761117": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Buguda",
    "officename": "Ballipadar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Aska Division"
  },
  "761118": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Buguda",
    "officename": "Buguda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Aska Division"
  },
  "761119": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Bhanjanagar",
    "officename": "Bellaguntha S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Aska Division"
  },
  "761120": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Bhanjanagar",
    "officename": "Baragam S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Aska Division"
  },
  "761121": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Bhanjanagar",
    "officename": "Jagannath Prasad S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Aska Division"
  },
  "761122": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Aska",
    "officename": "Nimina S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Aska Division"
  },
  "761123": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Bhanjanagar",
    "officename": "Gangapur (Ganjam) S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Aska Division"
  },
  "761124": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Bhanjanagar",
    "officename": "Gobara S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Aska Division"
  },
  "761125": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Bhanjanagar",
    "officename": "Badakodanda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Aska Division"
  },
  "761126": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Bhanjanagar",
    "officename": "Bhanjanagar H.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Aska Division"
  },
  "761131": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Bhanjanagar",
    "officename": "Kullada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Aska Division"
  },
  "761132": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Bhanjanagar",
    "officename": "Mujjagada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Aska Division"
  },
  "761133": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Bhanjanagar",
    "officename": "Jillundi S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Aska Division"
  },
  "761140": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Bhanjanagar",
    "officename": "Tanarada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Aska Division"
  },
  "761141": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Bhanjanagar",
    "officename": "Gallery S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Aska Division"
  },
  "761143": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Bhanjanagar",
    "officename": "Karachulli S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Aska Division"
  },
  "761144": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Digapahandi",
    "officename": "Konkarada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Aska Division"
  },
  "761146": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Hinjili",
    "officename": "Burupada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Aska Division"
  },
  "761151": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Surada",
    "officename": "Asura Bandha S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Aska Division"
  },
  "761200": {
    "state": "Odisha",
    "district": "Gajapati",
    "block": "Parlakhemundi",
    "officename": "Parlakhemundi H.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Rayagada Division"
  },
  "761201": {
    "state": "Odisha",
    "district": "Gajapati",
    "block": "Parlakhemundi",
    "officename": "Station Road Paralakhemundi S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Rayagada Division"
  },
  "761206": {
    "state": "Odisha",
    "district": "Gajapati",
    "block": "Paralakhemundi",
    "officename": "Kashinagar S.O Gajapati",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Rayagada Division"
  },
  "761207": {
    "state": "Odisha",
    "district": "Gajapati",
    "block": "Parlakhemundi",
    "officename": "Gumma S.O Gajapati",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Rayagada Division"
  },
  "761208": {
    "state": "Odisha",
    "district": "Gajapati",
    "block": "Paralakhemundi",
    "officename": "Kharada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Rayagada Division"
  },
  "761209": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Digapahandi",
    "officename": "Khariaguda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "761210": {
    "state": "Odisha",
    "district": "Gajapati",
    "block": "Paralakhemundi",
    "officename": "Gurandi S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Rayagada Division"
  },
  "761211": {
    "state": "Odisha",
    "district": "Gajapati",
    "block": "Paralakhemundi",
    "officename": "Uppalada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Rayagada Division"
  },
  "761212": {
    "state": "Odisha",
    "district": "Gajapati",
    "block": "Mohana",
    "officename": "Narayanapur S.O (Gajapati)",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Rayagada Division"
  },
  "761213": {
    "state": "Odisha",
    "district": "Gajapati",
    "block": "R.udayagiri",
    "officename": "Rayagada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Rayagada Division"
  },
  "761214": {
    "state": "Odisha",
    "district": "Gajapati",
    "block": "R.udayagiri",
    "officename": "Nuagada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Rayagada Division"
  },
  "761215": {
    "state": "Odisha",
    "district": "Gajapati",
    "block": "Paralakhemundi",
    "officename": "Garabandha S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Rayagada Division"
  },
  "761217": {
    "state": "Odisha",
    "district": "Gajapati",
    "block": "Mohana",
    "officename": "Odava S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Rayagada Division"
  },
  "762001": {
    "state": "Odisha",
    "district": "Kandhamal",
    "block": "Phulbani",
    "officename": "Phulbani H.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Phulbani Division"
  },
  "762002": {
    "state": "Odisha",
    "district": "Kandhamal",
    "block": "Phulbani",
    "officename": "Contractorpada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Phulbani Division"
  },
  "762010": {
    "state": "Odisha",
    "district": "Kandhamal",
    "block": "Tikabali",
    "officename": "Tikabali S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Phulbani Division"
  },
  "762011": {
    "state": "Odisha",
    "district": "Kandhamal",
    "block": "Phiringia",
    "officename": "Phiringia S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Phulbani Division"
  },
  "762012": {
    "state": "Odisha",
    "district": "Kandhamal",
    "block": "Khajuripada",
    "officename": "Khajuripada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Phulbani Division"
  },
  "762013": {
    "state": "Odisha",
    "district": "Boudh",
    "block": "Purunakatak",
    "officename": "Purunakatak S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Phulbani Division"
  },
  "762014": {
    "state": "Odisha",
    "district": "Boudh",
    "block": "Boudh",
    "officename": "Boudhraj S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Phulbani Division"
  },
  "762015": {
    "state": "Odisha",
    "district": "Boudh",
    "block": "Boudh",
    "officename": "Bounsoni S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Phulbani Division"
  },
  "762016": {
    "state": "Odisha",
    "district": "Boudh",
    "block": "Manamunda",
    "officename": "Manamunda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Phulbani Division"
  },
  "762017": {
    "state": "Odisha",
    "district": "Boudh",
    "block": "Kantamal",
    "officename": "Kantamal S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Phulbani Division"
  },
  "762018": {
    "state": "Odisha",
    "district": "Kandhamal",
    "block": "Ghantapada",
    "officename": "Ghantapada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Phulbani Division"
  },
  "762019": {
    "state": "Odisha",
    "district": "Kandhamal",
    "block": "Sankarakhole",
    "officename": "Sankarakhole S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Phulbani Division"
  },
  "762020": {
    "state": "Odisha",
    "district": "Boudh",
    "block": "Harabhanga",
    "officename": "Harabhanga S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Phulbani Division"
  },
  "762021": {
    "state": "Odisha",
    "district": "Kandhamal",
    "block": "Bamunigaon",
    "officename": "Bamunigaon S.O (Kandhamal)",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Phulbani Division"
  },
  "762022": {
    "state": "Odisha",
    "district": "Kandhamal",
    "block": "Kalinga",
    "officename": "Kalinga S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Phulbani Division"
  },
  "762023": {
    "state": "Odisha",
    "district": "Boudh",
    "block": "Jhadrajing",
    "officename": "Jhadrajing S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Phulbani Division"
  },
  "762024": {
    "state": "Odisha",
    "district": "Boudh",
    "block": "Bounsuni",
    "officename": "Biranarasinghpur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Phulbani Division"
  },
  "762026": {
    "state": "Odisha",
    "district": "Boudh",
    "block": "Sarsara",
    "officename": "Sarsara S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Phulbani Division"
  },
  "762027": {
    "state": "Odisha",
    "district": "Kandhamal",
    "block": "Linepada",
    "officename": "Linepada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Phulbani Division"
  },
  "762028": {
    "state": "Odisha",
    "district": "Kandhamal",
    "block": "Chakapad",
    "officename": "Chakapada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Phulbani Division"
  },
  "762029": {
    "state": "Odisha",
    "district": "Kandhamal",
    "block": "Gumagarh",
    "officename": "Gumagarh S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Phulbani Division"
  },
  "762030": {
    "state": "Odisha",
    "district": "Boudh",
    "block": "Baghiabahal",
    "officename": "Baghiabahal S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Phulbani Division"
  },
  "762100": {
    "state": "Odisha",
    "district": "Kandhamal",
    "block": "G.udayagiri",
    "officename": "G.Udayagiri S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Phulbani Division"
  },
  "762101": {
    "state": "Odisha",
    "district": "Kandhamal",
    "block": "Raikia",
    "officename": "Raikia S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Phulbani Division"
  },
  "762102": {
    "state": "Odisha",
    "district": "Kandhamal",
    "block": "Nuagaon",
    "officename": "Nuagaon S.O (Kandhamal)",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Phulbani Division"
  },
  "762103": {
    "state": "Odisha",
    "district": "Kandhamal",
    "block": "Balliguda",
    "officename": "Balliguda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Phulbani Division"
  },
  "762104": {
    "state": "Odisha",
    "district": "Kandhamal",
    "block": "Daringbadi",
    "officename": "Daringbadiso S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Phulbani Division"
  },
  "762105": {
    "state": "Odisha",
    "district": "Kandhamal",
    "block": "Kothagarh",
    "officename": "Kothagarh S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Phulbani Division"
  },
  "762106": {
    "state": "Odisha",
    "district": "Kandhamal",
    "block": "Sarangada",
    "officename": "Sarangada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Phulbani Division"
  },
  "762107": {
    "state": "Odisha",
    "district": "Kandhamal",
    "block": "Tumudibandha",
    "officename": "Tumudibandha S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Phulbani Division"
  },
  "762109": {
    "state": "Odisha",
    "district": "Kandhamal",
    "block": "Kurtamgarh",
    "officename": "Kurtamgarh S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Phulbani Division"
  },
  "762110": {
    "state": "Odisha",
    "district": "Kandhamal",
    "block": "Barakhama",
    "officename": "Barakhama S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Phulbani Division"
  },
  "762112": {
    "state": "Odisha",
    "district": "Kandhamal",
    "block": "Paburia",
    "officename": "Paburia S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Phulbani Division"
  },
  "763001": {
    "state": "Odisha",
    "district": "Koraput",
    "block": "Sunabeda",
    "officename": "Sunabeda 1 S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "763002": {
    "state": "Odisha",
    "district": "Koraput",
    "block": "Sunabeda",
    "officename": "Sunabeda 2 S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "763003": {
    "state": "Odisha",
    "district": "Koraput",
    "block": "Sunabeda",
    "officename": "D.P.Camp Sunabeda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "763004": {
    "state": "Odisha",
    "district": "Koraput",
    "block": "Sunabeda",
    "officename": "Nad Sunabeda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "763008": {
    "state": "Odisha",
    "district": "Koraput",
    "block": "Koraput",
    "officename": "Damanjodi S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764001": {
    "state": "Odisha",
    "district": "Koraput",
    "block": "Jeypur",
    "officename": "Jeypore(K) H.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764002": {
    "state": "Odisha",
    "district": "Koraput",
    "block": "Jeypore(k)",
    "officename": "Jeypore(K) R.S. S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764003": {
    "state": "Odisha",
    "district": "Koraput",
    "block": "Boipariguda",
    "officename": "Prasadraopeta S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764004": {
    "state": "Odisha",
    "district": "Koraput",
    "block": "Jeypur",
    "officename": "Jeypore(K) Irrigation Colony S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764005": {
    "state": "Odisha",
    "district": "Koraput",
    "block": "Jeypore(k)",
    "officename": "Jayanagar S.O (Koraput)",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764006": {
    "state": "Odisha",
    "district": "Koraput",
    "block": "NA",
    "officename": "Bariniput S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764011": {
    "state": "Odisha",
    "district": "Koraput",
    "block": "Koraput",
    "officename": "Kolab Nagar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764014": {
    "state": "Odisha",
    "district": "Koraput",
    "block": "Narayanpatna",
    "officename": "Narayanpatna S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764020": {
    "state": "Odisha",
    "district": "Koraput",
    "block": "Koraput",
    "officename": "Koraput H.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764021": {
    "state": "Odisha",
    "district": "Koraput",
    "block": "Koraput",
    "officename": "Omp Line S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764027": {
    "state": "Odisha",
    "district": "Koraput",
    "block": "Koraput",
    "officename": "Bandhugam S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764028": {
    "state": "Odisha",
    "district": "Koraput",
    "block": "Dasamantapur",
    "officename": "Dasamanthpur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764036": {
    "state": "Odisha",
    "district": "Koraput",
    "block": "Koraput",
    "officename": "Semiliguda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764037": {
    "state": "Odisha",
    "district": "Koraput",
    "block": "Pottangi",
    "officename": "Nandapur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764038": {
    "state": "Odisha",
    "district": "Koraput",
    "block": "Pottangi",
    "officename": "Padwa S.O (Koraput)",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764039": {
    "state": "Odisha",
    "district": "Koraput",
    "block": "Pottangi",
    "officename": "Pottangi S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764040": {
    "state": "Odisha",
    "district": "Koraput",
    "block": "Machkund",
    "officename": "Machhkund S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764041": {
    "state": "Odisha",
    "district": "Malkangiri",
    "block": "Machhkund",
    "officename": "Jolaput S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764042": {
    "state": "Odisha",
    "district": "Koraput",
    "block": "Machh kund",
    "officename": "Onukadeli S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764043": {
    "state": "Odisha",
    "district": "Koraput",
    "block": "Jeypore(k)",
    "officename": "Boipariguda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764044": {
    "state": "Odisha",
    "district": "Malkangiri",
    "block": "Malkangiri",
    "officename": "Mathili S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764045": {
    "state": "Odisha",
    "district": "Malkangiri",
    "block": "Malkangiri",
    "officename": "Malkangiri S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764046": {
    "state": "Odisha",
    "district": "Malkangiri",
    "block": "Malkangiri",
    "officename": "Khairaput S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764047": {
    "state": "Odisha",
    "district": "Malkangiri",
    "block": "Motu",
    "officename": "Kalimela S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764048": {
    "state": "Odisha",
    "district": "Malkangiri",
    "block": "Malkangiri",
    "officename": "Malkangiri Colony S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764049": {
    "state": "Odisha",
    "district": "Nabarangapur",
    "block": "Nabarangpur",
    "officename": "Anchalgumma S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764051": {
    "state": "Odisha",
    "district": "Malkangiri",
    "block": "Kalimela",
    "officename": "Balimela S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764052": {
    "state": "Odisha",
    "district": "Malkangiri",
    "block": "Chitrakonda",
    "officename": "Chitrakonda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764055": {
    "state": "Odisha",
    "district": "Koraput",
    "block": "Jeypore(k)",
    "officename": "Ambaguda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764056": {
    "state": "Odisha",
    "district": "Koraput",
    "block": "Borigumma",
    "officename": "Borigumma S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764057": {
    "state": "Odisha",
    "district": "Koraput",
    "block": "Borigumma",
    "officename": "Bhairabsinghpur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764058": {
    "state": "Odisha",
    "district": "Koraput",
    "block": "Kotpad",
    "officename": "Kotpad S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764059": {
    "state": "Odisha",
    "district": "Nabarangapur",
    "block": "Nabarangpur",
    "officename": "Nabarangpur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764061": {
    "state": "Odisha",
    "district": "Nabarangapur",
    "block": "Kodinga",
    "officename": "Kosagumuda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764062": {
    "state": "Odisha",
    "district": "Rayagada",
    "block": "Gunupur",
    "officename": "Bikrampur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Rayagada Division"
  },
  "764063": {
    "state": "Odisha",
    "district": "Nabarangapur",
    "block": "Nabarangpur",
    "officename": "Mirganiguda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764070": {
    "state": "Odisha",
    "district": "Nabarangapur",
    "block": "Nabarangpur",
    "officename": "Tentulikhunti S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764071": {
    "state": "Odisha",
    "district": "Nabarangapur",
    "block": "Nabarangpur",
    "officename": "Papadahandi S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764072": {
    "state": "Odisha",
    "district": "Nabarangapur",
    "block": "Umarkote",
    "officename": "Dabugam S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764073": {
    "state": "Odisha",
    "district": "Nabarangapur",
    "block": "Umerkote",
    "officename": "Umerkote S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764074": {
    "state": "Odisha",
    "district": "Nabarangapur",
    "block": "Umerkote",
    "officename": "Raighar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764075": {
    "state": "Odisha",
    "district": "Nabarangapur",
    "block": "Kodinga",
    "officename": "Kodinga S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764076": {
    "state": "Odisha",
    "district": "Nabarangapur",
    "block": "Umerkote",
    "officename": "Jharigam S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764077": {
    "state": "Odisha",
    "district": "Nabarangapur",
    "block": "Umerkote",
    "officename": "Chandahandi S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764078": {
    "state": "Odisha",
    "district": "Nabarangapur",
    "block": "Nabarangapur",
    "officename": "Dongerbheja S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764081": {
    "state": "Odisha",
    "district": "Koraput",
    "block": "Machkund",
    "officename": "Lamtaput S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764085": {
    "state": "Odisha",
    "district": "Nabarangapur",
    "block": "Nabarangpur",
    "officename": "Khatiguda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764086": {
    "state": "Odisha",
    "district": "Malkangiri",
    "block": "Kalimela",
    "officename": "Saradhapalli S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764087": {
    "state": "Odisha",
    "district": "Malkangiri",
    "block": "Motu",
    "officename": "Lachipeta S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "764088": {
    "state": "Odisha",
    "district": "Nabarangapur",
    "block": "Umerkote",
    "officename": "Turudihi",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "765001": {
    "state": "Odisha",
    "district": "Rayagada",
    "block": "Rayagada",
    "officename": "Rayagada(K) H.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Rayagada Division"
  },
  "765002": {
    "state": "Odisha",
    "district": "Rayagada",
    "block": "Rayagada",
    "officename": "Rayagada S.F. S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Rayagada Division"
  },
  "765013": {
    "state": "Odisha",
    "district": "Koraput",
    "block": "Narayanpatna",
    "officename": "Laxmipur (Koraput) S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Koraput Division"
  },
  "765015": {
    "state": "Odisha",
    "district": "Rayagada",
    "block": "Kashipur",
    "officename": "Kashipur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Rayagada Division"
  },
  "765016": {
    "state": "Odisha",
    "district": "Rayagada",
    "block": "Kashipur",
    "officename": "K.Singhpur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Rayagada Division"
  },
  "765017": {
    "state": "Odisha",
    "district": "Rayagada",
    "block": "Rayagada",
    "officename": "J.K.Pur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Rayagada Division"
  },
  "765018": {
    "state": "Odisha",
    "district": "Rayagada",
    "block": "Rayagada",
    "officename": "Therubali S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Rayagada Division"
  },
  "765019": {
    "state": "Odisha",
    "district": "Rayagada",
    "block": "Bissamcuttack",
    "officename": "Bissamcuttack S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Rayagada Division"
  },
  "765020": {
    "state": "Odisha",
    "district": "Rayagada",
    "block": "Muniguda",
    "officename": "Muniguda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Rayagada Division"
  },
  "765021": {
    "state": "Odisha",
    "district": "Rayagada",
    "block": "Bissamcuttack",
    "officename": "Ambadola S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Rayagada Division"
  },
  "765022": {
    "state": "Odisha",
    "district": "Rayagada",
    "block": "Gunupur",
    "officename": "Gunupur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Rayagada Division"
  },
  "765023": {
    "state": "Odisha",
    "district": "Rayagada",
    "block": "Gunupur",
    "officename": "Kujendri S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Rayagada Division"
  },
  "765024": {
    "state": "Odisha",
    "district": "Rayagada",
    "block": "Gunupur",
    "officename": "Ukkamba S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Rayagada Division"
  },
  "765025": {
    "state": "Odisha",
    "district": "Rayagada",
    "block": "Gunupur",
    "officename": "Padmapur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Rayagada Division"
  },
  "765026": {
    "state": "Odisha",
    "district": "Rayagada",
    "block": "Gudari",
    "officename": "Gudari S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Rayagada Division"
  },
  "765029": {
    "state": "Odisha",
    "district": "Rayagada",
    "block": "Gunupur",
    "officename": "Ramanaguda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Rayagada Division"
  },
  "765033": {
    "state": "Odisha",
    "district": "Rayagada",
    "block": "Gunupur",
    "officename": "Dambasora S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Rayagada Division"
  },
  "765034": {
    "state": "Odisha",
    "district": "Rayagada",
    "block": "Gunupur",
    "officename": "Jaganathpur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Rayagada Division"
  },
  "766001": {
    "state": "Odisha",
    "district": "Kalahandi",
    "block": "Kesinga",
    "officename": "Bhawanipatna H.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Kalahandi Division"
  },
  "766002": {
    "state": "Odisha",
    "district": "Kalahandi",
    "block": "Bhawanipatna",
    "officename": "Bhawanipatna G.Chowk S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Kalahandi Division"
  },
  "766011": {
    "state": "Odisha",
    "district": "Kalahandi",
    "block": "Kesinga",
    "officename": "Utkela S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Kalahandi Division"
  },
  "766012": {
    "state": "Odisha",
    "district": "Kalahandi",
    "block": "Kesinga",
    "officename": "Kesinga S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Kalahandi Division"
  },
  "766013": {
    "state": "Odisha",
    "district": "Kalahandi",
    "block": "Kalampur",
    "officename": "Kalampur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Kalahandi Division"
  },
  "766014": {
    "state": "Odisha",
    "district": "Kalahandi",
    "block": "Junagarh",
    "officename": "Junagarh S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Kalahandi Division"
  },
  "766015": {
    "state": "Odisha",
    "district": "Kalahandi",
    "block": "Dharamgarh",
    "officename": "Dharamgarh S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Kalahandi Division"
  },
  "766016": {
    "state": "Odisha",
    "district": "Kalahandi",
    "block": "Golamunda",
    "officename": "Golamunda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Kalahandi Division"
  },
  "766017": {
    "state": "Odisha",
    "district": "Kalahandi",
    "block": "Junagarh",
    "officename": "Charbahal S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Kalahandi Division"
  },
  "766018": {
    "state": "Odisha",
    "district": "Kalahandi",
    "block": "Jaipatna",
    "officename": "Jaipatna S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Kalahandi Division"
  },
  "766019": {
    "state": "Odisha",
    "district": "Kalahandi",
    "block": "Jaipatna",
    "officename": "Koksara S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Kalahandi Division"
  },
  "766020": {
    "state": "Odisha",
    "district": "Kalahandi",
    "block": "Lanjigarh",
    "officename": "Biswanathpur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Kalahandi Division"
  },
  "766023": {
    "state": "Odisha",
    "district": "Kalahandi",
    "block": "Junagarh",
    "officename": "Mahichala S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Kalahandi Division"
  },
  "766026": {
    "state": "Odisha",
    "district": "Kalahandi",
    "block": "Thuamulrampur",
    "officename": "Mukhiguda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Kalahandi Division"
  },
  "766027": {
    "state": "Odisha",
    "district": "Kalahandi",
    "block": "Lanjigarh",
    "officename": "Lanjigarh S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Kalahandi Division"
  },
  "766028": {
    "state": "Odisha",
    "district": "Kalahandi",
    "block": "Jaipatna",
    "officename": "Ampani S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Kalahandi Division"
  },
  "766029": {
    "state": "Odisha",
    "district": "Kalahandi",
    "block": "Dharamgarh",
    "officename": "Sosia S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Kalahandi Division"
  },
  "766031": {
    "state": "Odisha",
    "district": "Kalahandi",
    "block": "Karlamunda",
    "officename": "Risida S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Kalahandi Division"
  },
  "766032": {
    "state": "Odisha",
    "district": "Kalahandi",
    "block": "Bhawanipatna",
    "officename": "Karlamunda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Kalahandi Division"
  },
  "766036": {
    "state": "Odisha",
    "district": "Kalahandi",
    "block": "Bhawanipatna",
    "officename": "Borda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Kalahandi Division"
  },
  "766037": {
    "state": "Odisha",
    "district": "Kalahandi",
    "block": "Thuamulrampur",
    "officename": "Thuamul Rampur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Kalahandi Division"
  },
  "766100": {
    "state": "Odisha",
    "district": "Kalahandi",
    "block": "Narla",
    "officename": "Narla S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Kalahandi Division"
  },
  "766101": {
    "state": "Odisha",
    "district": "Kalahandi",
    "block": "Narla",
    "officename": "Rupra Road S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Kalahandi Division"
  },
  "766102": {
    "state": "Odisha",
    "district": "Kalahandi",
    "block": "M.rampur",
    "officename": "Madanpur Rampur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Kalahandi Division"
  },
  "766103": {
    "state": "Odisha",
    "district": "Kalahandi",
    "block": "Dharamgarh",
    "officename": "Parla S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Kalahandi Division"
  },
  "766104": {
    "state": "Odisha",
    "district": "Nuapada",
    "block": "Nuapada",
    "officename": "Khariar Road S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Kalahandi Division"
  },
  "766105": {
    "state": "Odisha",
    "district": "Nuapada",
    "block": "Nuapada",
    "officename": "Nawapara Tanwat S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Kalahandi Division"
  },
  "766106": {
    "state": "Odisha",
    "district": "Nuapada",
    "block": "Komna",
    "officename": "Komna S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Kalahandi Division"
  },
  "766107": {
    "state": "Odisha",
    "district": "Nuapada",
    "block": "Khariar",
    "officename": "Khariar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Kalahandi Division"
  },
  "766108": {
    "state": "Odisha",
    "district": "Nuapada",
    "block": "Sinhapalli",
    "officename": "Sinhapalli S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Kalahandi Division"
  },
  "766110": {
    "state": "Odisha",
    "district": "Kalahandi",
    "block": "Narla",
    "officename": "Narla Road S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Kalahandi Division"
  },
  "766111": {
    "state": "Odisha",
    "district": "Nuapada",
    "block": "Boden",
    "officename": "Boden S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Kalahandi Division"
  },
  "766118": {
    "state": "Odisha",
    "district": "Nuapada",
    "block": "Duajhar",
    "officename": "Duajhar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Kalahandi Division"
  },
  "767001": {
    "state": "Odisha",
    "district": "Balangir",
    "block": "Balangir",
    "officename": "Balangir H.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "767002": {
    "state": "Odisha",
    "district": "Balangir",
    "block": "Balangir",
    "officename": "Rajendra College S.O (Balangir)",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "767016": {
    "state": "Odisha",
    "district": "Balangir",
    "block": "Balangir",
    "officename": "Tarbha S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "767017": {
    "state": "Odisha",
    "district": "Sonapur",
    "block": "Sonepur",
    "officename": "Sonepur S.O (Sonapur)",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "767018": {
    "state": "Odisha",
    "district": "Sonapur",
    "block": "Birmaharajpur",
    "officename": "Birmaharajpur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "767019": {
    "state": "Odisha",
    "district": "Sonapur",
    "block": "Binka",
    "officename": "Binka S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "767020": {
    "state": "Odisha",
    "district": "Balangir",
    "block": "Loisingha",
    "officename": "Loisingha S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "767021": {
    "state": "Odisha",
    "district": "Balangir",
    "block": "Loisingha",
    "officename": "Salebhata S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "767022": {
    "state": "Odisha",
    "district": "Balangir",
    "block": "Loisingha",
    "officename": "Agalpur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "767023": {
    "state": "Odisha",
    "district": "Sonapur",
    "block": "S Rampur",
    "officename": "Dungripali S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "767024": {
    "state": "Odisha",
    "district": "Balangir",
    "block": "Balangir",
    "officename": "Churapali S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "767025": {
    "state": "Odisha",
    "district": "Balangir",
    "block": "Patnagarh",
    "officename": "Patnagarh S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "767026": {
    "state": "Odisha",
    "district": "Balangir",
    "block": "Patnagarh",
    "officename": "Belpara S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "767027": {
    "state": "Odisha",
    "district": "Balangir",
    "block": "Patnagarh",
    "officename": "Jogimunda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "767028": {
    "state": "Odisha",
    "district": "Balangir",
    "block": "Patnagarh",
    "officename": "Khaprakhol S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "767029": {
    "state": "Odisha",
    "district": "Balangir",
    "block": "Tusra",
    "officename": "Deogaon S.O (Balangir)",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "767030": {
    "state": "Odisha",
    "district": "Balangir",
    "block": "Tusra",
    "officename": "Tusra S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "767032": {
    "state": "Odisha",
    "district": "Balangir",
    "block": "Titilagarh",
    "officename": "Saintala S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "767033": {
    "state": "Odisha",
    "district": "Balangir",
    "block": "Kantabanji",
    "officename": "Titilagarh S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "767035": {
    "state": "Odisha",
    "district": "Balangir",
    "block": "Kantabanji",
    "officename": "Sindhekela S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "767037": {
    "state": "Odisha",
    "district": "Balangir",
    "block": "Titilagarh",
    "officename": "Muribahal S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "767038": {
    "state": "Odisha",
    "district": "Balangir",
    "block": "Kantabanji",
    "officename": "Harisankar Road S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "767039": {
    "state": "Odisha",
    "district": "Balangir",
    "block": "Patnagarh",
    "officename": "Kantabanji S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "767040": {
    "state": "Odisha",
    "district": "Balangir",
    "block": "Kantabanji",
    "officename": "Banganmura S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "767041": {
    "state": "Odisha",
    "district": "Balangir",
    "block": "Patnagarh",
    "officename": "P.Rampur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "767042": {
    "state": "Odisha",
    "district": "Balangir",
    "block": "Titilagarh",
    "officename": "Bhatipara S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "767045": {
    "state": "Odisha",
    "district": "Sonapur",
    "block": "Binka",
    "officename": "Sonepur Rampur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "767046": {
    "state": "Odisha",
    "district": "Balangir",
    "block": "Tusura",
    "officename": "Gudvella S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "767048": {
    "state": "Odisha",
    "district": "Balangir",
    "block": "Patnagarh",
    "officename": "Bhainsa S.O (Balangir)",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "767060": {
    "state": "Odisha",
    "district": "Balangir",
    "block": "Kantabanji",
    "officename": "Turekela S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "767061": {
    "state": "Odisha",
    "district": "Balangir",
    "block": "Loisingha",
    "officename": "Duduka S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "767062": {
    "state": "Odisha",
    "district": "Sonapur",
    "block": "Ullunda",
    "officename": "Ullunda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "767065": {
    "state": "Odisha",
    "district": "Balangir",
    "block": "Balangir",
    "officename": "Chandanbhati S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "767066": {
    "state": "Odisha",
    "district": "Balangir",
    "block": "Titilagarh",
    "officename": "Kholan S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "767067": {
    "state": "Odisha",
    "district": "Balangir",
    "block": "Tusra",
    "officename": "Jarasingha S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "767068": {
    "state": "Odisha",
    "district": "Balangir",
    "block": "Loisingha",
    "officename": "Lachhipur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "767070": {
    "state": "Odisha",
    "district": "Balangir",
    "block": "Titilagarh",
    "officename": "Of Badmal S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "768001": {
    "state": "Odisha",
    "district": "Sambalpur",
    "block": "Sadar",
    "officename": "Sambalpur H.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768002": {
    "state": "Odisha",
    "district": "Sambalpur",
    "block": "Sadar",
    "officename": "Mudipara S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768003": {
    "state": "Odisha",
    "district": "Sambalpur",
    "block": "Sadar",
    "officename": "Khetrajpur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768004": {
    "state": "Odisha",
    "district": "Sambalpur",
    "block": "Sambalpur",
    "officename": "Budharaja S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768005": {
    "state": "Odisha",
    "district": "Sambalpur",
    "block": "Maneswar",
    "officename": "Dhanupali S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768006": {
    "state": "Odisha",
    "district": "Sambalpur",
    "block": "Sadar",
    "officename": "Remed S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768016": {
    "state": "Odisha",
    "district": "Sambalpur",
    "block": "Hirakud",
    "officename": "Hirakud S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768017": {
    "state": "Odisha",
    "district": "Sambalpur",
    "block": "Dhankauda",
    "officename": "Burla S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768018": {
    "state": "Odisha",
    "district": "Sambalpur",
    "block": "Burla",
    "officename": "Engineering College Burla S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768019": {
    "state": "Odisha",
    "district": "Sambalpur",
    "block": "Burla",
    "officename": "Jyoti Vihar Burla S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768020": {
    "state": "Odisha",
    "district": "Sambalpur",
    "block": "Burla",
    "officename": "Jagruti Vihar Burla S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768025": {
    "state": "Odisha",
    "district": "Sambalpur",
    "block": "Dhankauda",
    "officename": "C.A. Chiplima S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768027": {
    "state": "Odisha",
    "district": "Bargarh",
    "block": "Attabira",
    "officename": "Attabira S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768028": {
    "state": "Odisha",
    "district": "Bargarh",
    "block": "Bargarh",
    "officename": "Bargarh H.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768029": {
    "state": "Odisha",
    "district": "Bargarh",
    "block": "Barpali",
    "officename": "Barpali S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768030": {
    "state": "Odisha",
    "district": "Bargarh",
    "block": "Bargarh",
    "officename": "Bhatli S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768031": {
    "state": "Odisha",
    "district": "Bargarh",
    "block": "Ambabhana",
    "officename": "Ambabhana S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768032": {
    "state": "Odisha",
    "district": "Bargarh",
    "block": "Bijepur",
    "officename": "Bijepur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768033": {
    "state": "Odisha",
    "district": "Bargarh",
    "block": "Sohella",
    "officename": "Sohella S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768034": {
    "state": "Odisha",
    "district": "Bargarh",
    "block": "Sohella",
    "officename": "Ghess S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768035": {
    "state": "Odisha",
    "district": "Bargarh",
    "block": "Rajborasambar",
    "officename": "Melchhamunda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768036": {
    "state": "Odisha",
    "district": "Bargarh",
    "block": "Paikmal",
    "officename": "Rajborasamber S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768037": {
    "state": "Odisha",
    "district": "Bargarh",
    "block": "Gaisilet",
    "officename": "Gaisilet S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768038": {
    "state": "Odisha",
    "district": "Bargarh",
    "block": "Bijepur",
    "officename": "Bardol S.O (Bargarh)",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768039": {
    "state": "Odisha",
    "district": "Bargarh",
    "block": "Paikamal",
    "officename": "Paikmal S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768040": {
    "state": "Odisha",
    "district": "Bargarh",
    "block": "Bargarh",
    "officename": "Tora S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768042": {
    "state": "Odisha",
    "district": "Bargarh",
    "block": "Jharbandh",
    "officename": "Jharbandh S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768045": {
    "state": "Odisha",
    "district": "Bargarh",
    "block": "Ambabhana",
    "officename": "Bhukta S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768048": {
    "state": "Odisha",
    "district": "Bargarh",
    "block": "Bijepur",
    "officename": "Laumunda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768049": {
    "state": "Odisha",
    "district": "Bargarh",
    "block": "Padmapur",
    "officename": "Jamla S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768050": {
    "state": "Odisha",
    "district": "Bargarh",
    "block": "Paikmal",
    "officename": "Mandosil S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768052": {
    "state": "Odisha",
    "district": "Bargarh",
    "block": "Ambabhana",
    "officename": "Dunguri Lsq Colony Campus S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768102": {
    "state": "Odisha",
    "district": "Bargarh",
    "block": "Bheden",
    "officename": "Larambha S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768103": {
    "state": "Odisha",
    "district": "Bargarh",
    "block": "Bheden",
    "officename": "Remunda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768104": {
    "state": "Odisha",
    "district": "Sambalpur",
    "block": "Dhama",
    "officename": "Bheden S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768105": {
    "state": "Odisha",
    "district": "Sambalpur",
    "block": "Rairakhol",
    "officename": "Jujumura S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768106": {
    "state": "Odisha",
    "district": "Sambalpur",
    "block": "Naktideul",
    "officename": "Rairakhol S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768107": {
    "state": "Odisha",
    "district": "Sambalpur",
    "block": "Jamankira",
    "officename": "Jamankira S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768108": {
    "state": "Odisha",
    "district": "Debagarh",
    "block": "Barkote",
    "officename": "Deogarh S.O (Debagarh)",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768109": {
    "state": "Odisha",
    "district": "Debagarh",
    "block": "Reamal",
    "officename": "Reamal S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768110": {
    "state": "Odisha",
    "district": "Debagarh",
    "block": "Barkote",
    "officename": "Barkote S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768111": {
    "state": "Odisha",
    "district": "Bargarh",
    "block": "Attabira",
    "officename": "Godbhaga S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768112": {
    "state": "Odisha",
    "district": "Sambalpur",
    "block": "Jujumura",
    "officename": "Gourpali S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768113": {
    "state": "Odisha",
    "district": "Sambalpur",
    "block": "Maneswar",
    "officename": "Dhama S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768115": {
    "state": "Odisha",
    "district": "Bargarh",
    "block": "Bheden",
    "officename": "Gondturum S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768118": {
    "state": "Odisha",
    "district": "Sambalpur",
    "block": "NA",
    "officename": "Naktideul S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768119": {
    "state": "Odisha",
    "district": "Debagarh",
    "block": "Barkot",
    "officename": "Purunagarh S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768121": {
    "state": "Odisha",
    "district": "Debagarh",
    "block": "Tileibani",
    "officename": "Gohira Dam Site S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768200": {
    "state": "Odisha",
    "district": "Sambalpur",
    "block": "Dhankauda",
    "officename": "Sasan Rs S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768201": {
    "state": "Odisha",
    "district": "Jharsuguda",
    "block": "Jharsuguda",
    "officename": "Jharsuguda H.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "768202": {
    "state": "Odisha",
    "district": "Jharsuguda",
    "block": "Jharsuguda Sadar",
    "officename": "K.M. Road Jharsuguda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "768203": {
    "state": "Odisha",
    "district": "Jharsuguda",
    "block": "Jharsuguda",
    "officename": "Industrial Estate Jharsuguda S S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "768204": {
    "state": "Odisha",
    "district": "Jharsuguda",
    "block": "Jharsuguda Sadar",
    "officename": "O.M.P. Line Jharsuguda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "768211": {
    "state": "Odisha",
    "district": "Jharsuguda",
    "block": "Lakhanpur",
    "officename": "Bandhbahal Colony S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "768212": {
    "state": "Odisha",
    "district": "Sambalpur",
    "block": "Katarbaga",
    "officename": "Rengali SO",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768213": {
    "state": "Odisha",
    "district": "Jharsuguda",
    "block": "Laikera",
    "officename": "Kolabira S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "768214": {
    "state": "Odisha",
    "district": "Sambalpur",
    "block": "Kochinda",
    "officename": "Laida S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "768215": {
    "state": "Odisha",
    "district": "Jharsuguda",
    "block": "Laikera",
    "officename": "Laikera S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "768216": {
    "state": "Odisha",
    "district": "Jharsuguda",
    "block": "Brajarajnagar",
    "officename": "Brajarajnagar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "768217": {
    "state": "Odisha",
    "district": "Jharsuguda",
    "block": "Belpahar",
    "officename": "Belpahar Rs S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "768218": {
    "state": "Odisha",
    "district": "Jharsuguda",
    "block": "Belpahar",
    "officename": "Belpahar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "768219": {
    "state": "Odisha",
    "district": "Jharsuguda",
    "block": "Lakhanpur",
    "officename": "Lakhanpur S.O Jharsuguda",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "768220": {
    "state": "Odisha",
    "district": "Jharsuguda",
    "block": "Jharsuguda",
    "officename": "Bagdehi S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "768221": {
    "state": "Odisha",
    "district": "Sambalpur",
    "block": "Laikera",
    "officename": "Bamra S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "768222": {
    "state": "Odisha",
    "district": "Sambalpur",
    "block": "Mahulpalli",
    "officename": "Kuchinda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "768224": {
    "state": "Odisha",
    "district": "Sambalpur",
    "block": "Govindpur",
    "officename": "Garposh S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "768225": {
    "state": "Odisha",
    "district": "Jharsuguda",
    "block": "Banaharapali",
    "officename": "Rampur Colliery S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "768226": {
    "state": "Odisha",
    "district": "Jharsuguda",
    "block": "Lakhanpur",
    "officename": "Panchgaon S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "768227": {
    "state": "Odisha",
    "district": "Sambalpur",
    "block": "Rairakhol",
    "officename": "Kusumi S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "768228": {
    "state": "Odisha",
    "district": "Sambalpur",
    "block": "Kuchinda",
    "officename": "Kesaibahal S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "768233": {
    "state": "Odisha",
    "district": "Jharsuguda",
    "block": "Brajarajnagar",
    "officename": "Orient Colliery Brajarajnagar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "768234": {
    "state": "Odisha",
    "district": "Jharsuguda",
    "block": "Jharsuguda",
    "officename": "Itps Banaharpali S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "769001": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Rourkela Steel City",
    "officename": "Rourkela H.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Rourkela Division"
  },
  "769002": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Raurkela (M)",
    "officename": "Rourkela - 2 S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Rourkela Division"
  },
  "769003": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Raurkela (M)",
    "officename": "Rourkela - 3 S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Rourkela Division"
  },
  "769004": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Lathikata",
    "officename": "Rourkela - 4 S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Rourkela Division"
  },
  "769005": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Raurkela (M)",
    "officename": "Rourkela - 5 S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Rourkela Division"
  },
  "769006": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Raurkela (M)",
    "officename": "Rourkela - 6 S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Rourkela Division"
  },
  "769007": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Raurkela Industrial Township (ITS)",
    "officename": "Rourkela - 7 S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Rourkela Division"
  },
  "769008": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Raurkela (M)",
    "officename": "Rourkela - 8 S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Rourkela Division"
  },
  "769009": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Rourkela",
    "officename": "Rourkela - 9 S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Rourkela Division"
  },
  "769010": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Raurkela (M)",
    "officename": "Rourkela - 10 S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Rourkela Division"
  },
  "769011": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Raurkela (M)",
    "officename": "Rourkela - 11 S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Rourkela Division"
  },
  "769012": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Raurkela Industrial Township (ITS)",
    "officename": "Uditnagar H.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Rourkela Division"
  },
  "769013": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Raurkela (M)",
    "officename": "Rourkela - 13 S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Rourkela Division"
  },
  "769014": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Raurkela (M)",
    "officename": "Rourkela - 14 S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Rourkela Division"
  },
  "769015": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Raurkela (M)",
    "officename": "Rourkela - 15 S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Rourkela Division"
  },
  "769016": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Raurkela (M)",
    "officename": "Rourkela -16 S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Rourkela Division"
  },
  "769042": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Koida",
    "officename": "Jhirpani S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Rourkela Division"
  },
  "769043": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Tangarapali",
    "officename": "Jalda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Rourkela Division"
  },
  "770001": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Sundargarh",
    "officename": "Sundargarh H.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "770002": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Tangarpali",
    "officename": "Rangadhipa S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "770011": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Tangarpali",
    "officename": "Ujalpur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "770012": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Lephripara",
    "officename": "Lephripara S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "770013": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Hemgir",
    "officename": "Hemgir S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "770014": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Talasara",
    "officename": "Subdega S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "770015": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Talasara",
    "officename": "Balisankara S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "770016": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Bargaon",
    "officename": "Bargaon (Sundergarh) S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "770017": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Rajgangpur",
    "officename": "Rajgangpur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "770018": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Kutra",
    "officename": "Kutra S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "770019": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Bhasma",
    "officename": "Kundukela S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "770020": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Tangarpali",
    "officename": "Sankara S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "770021": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Lephripara",
    "officename": "Sargipali S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "770022": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Bhasma",
    "officename": "Dharuadihi S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "770023": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Kuta",
    "officename": "Lanjiberna S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "770024": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Hemgir",
    "officename": "Gopalpur S.O (Sundergarh)",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "770031": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Raghunathapali",
    "officename": "Kalunga S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Rourkela Division"
  },
  "770032": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Bisra",
    "officename": "Bandomunda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Rourkela Division"
  },
  "770033": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Kuarmunda",
    "officename": "Biramitrapur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Rourkela Division"
  },
  "770034": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Rajagangapur",
    "officename": "KANSBAHAL",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Rourkela Division"
  },
  "770035": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Bisra",
    "officename": "Purnapani S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Rourkela Division"
  },
  "770036": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Bisra",
    "officename": "Bisra S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Rourkela Division"
  },
  "770037": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Lathikata",
    "officename": "Lathikata S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Rourkela Division"
  },
  "770038": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Bonaigarh",
    "officename": "Bonaigarh S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Rourkela Division"
  },
  "770039": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Kuarmunda",
    "officename": "Kuarmunda S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Rourkela Division"
  },
  "770040": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Lahunipara",
    "officename": "Lahunipara S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Rourkela Division"
  },
  "770041": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Lahunipara",
    "officename": "Barsuan S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Rourkela Division"
  },
  "770042": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Koida",
    "officename": "Tensa S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Rourkela Division"
  },
  "770043": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Gurundia",
    "officename": "Gurundia S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Rourkela Division"
  },
  "770044": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Lahunipara",
    "officename": "Khuntgaon S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Rourkela Division"
  },
  "770046": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Nuagaon",
    "officename": "Hatibari S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Rourkela Division"
  },
  "770048": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Koira",
    "officename": "Koira S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Rourkela Division"
  },
  "770051": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Banei",
    "officename": "Kenaveta S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Rourkela Division"
  },
  "770052": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Koida",
    "officename": "Kalta S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Rourkela Division"
  },
  "770070": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Kutra",
    "officename": "Tunmura S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "770072": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Tangarpali",
    "officename": "Zincnagar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "770073": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Sundargarh",
    "officename": "Kirei S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "770074": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Balisankara",
    "officename": "Talsara S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "770075": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Hemgir",
    "officename": "Hemgir Road S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "770076": {
    "state": "Odisha",
    "district": "Sundergarh",
    "block": "Hemgir",
    "officename": "Basundhara S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "781001": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Gmc",
    "officename": "Guwahati G.P.O.",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781003": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Gmc",
    "officename": "Silpukhuri S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781004": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Gmc",
    "officename": "Kharguli S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781005": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Gmc",
    "officename": "Dispur S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781006": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Gmc",
    "officename": "Assam Sachivalaya S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781007": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Gmc",
    "officename": "Ulubari S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781008": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Gmc",
    "officename": "Rehabari S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781009": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Gmc",
    "officename": "Bharalumukh S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781010": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Gmc",
    "officename": "Kamakhya S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781011": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Gmc",
    "officename": "Mlg Rly Hqs S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781012": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Palasbari Circle",
    "officename": "Pandu S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781013": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Jalukbari Lac",
    "officename": "Jalukbari S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781014": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Palashbari Circle",
    "officename": "Guwahati University H.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781015": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Kamalpur Block",
    "officename": "Guwahati Airport S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781016": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Gmc",
    "officename": "Gopinathnagar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781017": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Gmc",
    "officename": "Azara S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781018": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Gmc",
    "officename": "Binovanagar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781019": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Gmc",
    "officename": "Kahilipara S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781020": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Gmc",
    "officename": "Noonmati S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781021": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Gmc",
    "officename": "Bamunimaidan S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781022": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Gmc",
    "officename": "Khanapara S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781023": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Sonapur Block",
    "officename": "Amerigog S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781024": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Gmc",
    "officename": "Zoo Road S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781025": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Gmc",
    "officename": "Ambari Fatasil S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781026": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Gmc",
    "officename": "Narangi S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781027": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Gmc",
    "officename": "Satgaon S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781028": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Gmc",
    "officename": "Beltola S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781029": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Gmc",
    "officename": "Basistha S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781030": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Bezera Block",
    "officename": "North Guwahati S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781031": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Gmc ( North Gh Circle )",
    "officename": "Amingaon S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781032": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Gmc",
    "officename": "Indrapur S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781034": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Gmc",
    "officename": "Odalbakra S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781035": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Gmc",
    "officename": "Garchuk S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781036": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Gmc",
    "officename": "Hengrabari S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781037": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Gmc",
    "officename": "Panjabari S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781038": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Gmc",
    "officename": "Hatigaon Chariali S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781039": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Gmc",
    "officename": "I I T S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781040": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Sanekuchi",
    "officename": "Sawkuchi S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781101": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Bezera Block",
    "officename": "Changsari S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781102": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Hajo Block",
    "officename": "Hajo S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781103": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Hajo Block",
    "officename": "Soalkuchi S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781104": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Hajo Block",
    "officename": "Kulhati S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781120": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Jharobari Block",
    "officename": "Borduar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781121": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Bezera Block",
    "officename": "Bezera S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781122": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Rampur Block",
    "officename": "Bijoynagar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781123": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Boko",
    "officename": "Boko S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781124": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Chhaygaonpantan",
    "officename": "Chhaygaon S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781125": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Jharobari Block",
    "officename": "Mirza S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781126": {
    "state": "Assam",
    "district": "Nalbari",
    "block": "Barkhetri",
    "officename": "Mukalmua S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781127": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Mandia",
    "officename": "Nagarbera S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781128": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Rani Block ( Palasbari Circle)",
    "officename": "Palashbari S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781129": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Luki ( Boko Block)",
    "officename": "Hahimbazar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781131": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Rani Block",
    "officename": "Rani S.O (Kamrup)",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781132": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Rampur",
    "officename": "Rampur S.O (Kamrup)",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781133": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Kamalpur Block Taluk of Kamrup",
    "officename": "Dagaon S.O.",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781134": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Dakhin Sarubanswar (rampur)",
    "officename": "Kukurmara S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781135": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Boko",
    "officename": "Singra S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781136": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Chamaria",
    "officename": "Pachim Samaria S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781137": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Dakhin Sarubanswar Mauza",
    "officename": "Aggumi S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781138": {
    "state": "Assam",
    "district": "Nalbari",
    "block": "Bartola",
    "officename": "Bartola S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781141": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Chhaygaon Pantan",
    "officename": "Bamunigaon S.O (Kamrup)",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781150": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Chandrapur Block",
    "officename": "Chandrapur S.O (Kamrup)",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781171": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Gmc",
    "officename": "Udayan Vihar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781301": {
    "state": "Assam",
    "district": "Barpeta",
    "block": "Barpeta",
    "officename": "Barpeta H.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781302": {
    "state": "Assam",
    "district": "Barpeta",
    "block": "Baharihat",
    "officename": "Baharihat S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781303": {
    "state": "Assam",
    "district": "Nalbari",
    "block": "Banagrasm",
    "officename": "Banagram S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781304": {
    "state": "Assam",
    "district": "Nalbari",
    "block": "Belsor",
    "officename": "Belsor S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781305": {
    "state": "Assam",
    "district": "Barpeta",
    "block": "Barkhetri",
    "officename": "Chenga S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781306": {
    "state": "Assam",
    "district": "Nalbari",
    "block": "Chamata",
    "officename": "Chamata S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781307": {
    "state": "Assam",
    "district": "Barpeta",
    "block": "Barkhetri",
    "officename": "Sarthebari S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781308": {
    "state": "Assam",
    "district": "Barpeta",
    "block": "Barkhetri",
    "officename": "Mandia S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781309": {
    "state": "Assam",
    "district": "Barpeta",
    "block": "Bhella",
    "officename": "Bhella S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781310": {
    "state": "Assam",
    "district": "Nalbari",
    "block": "Jagra",
    "officename": "Jagra S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781311": {
    "state": "Assam",
    "district": "Barpeta",
    "block": "Barkhetri",
    "officename": "Nagaon Bazar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781312": {
    "state": "Assam",
    "district": "Nalbari",
    "block": "Rampur",
    "officename": "Rampur S.O (Nalbari)",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781313": {
    "state": "Assam",
    "district": "Barpeta",
    "block": "Barkhetri",
    "officename": "Simlaguri S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781314": {
    "state": "Assam",
    "district": "Barpeta",
    "block": "Barkhetri",
    "officename": "Santinagar S.O (Barpeta)",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781315": {
    "state": "Assam",
    "district": "Barpeta",
    "block": "Barkhetri",
    "officename": "Barpeta Road S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781316": {
    "state": "Assam",
    "district": "Barpeta",
    "block": "Barkhetri",
    "officename": "Howly S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781317": {
    "state": "Assam",
    "district": "Barpeta",
    "block": "Barkhetri",
    "officename": "Sorbhog S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781318": {
    "state": "Assam",
    "district": "Barpeta",
    "block": "Barkhetri",
    "officename": "Sarupeta S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781319": {
    "state": "Assam",
    "district": "Barpeta",
    "block": "Barkhetri",
    "officename": "Kalgachia S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781321": {
    "state": "Assam",
    "district": "Barpeta",
    "block": "Barkhetri",
    "officename": "Mayanbari S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781325": {
    "state": "Assam",
    "district": "Barpeta",
    "block": "Barkhetri",
    "officename": "Pathsala S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781326": {
    "state": "Assam",
    "district": "Barpeta",
    "block": "Barkhetri",
    "officename": "Patacharkuchi S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781327": {
    "state": "Assam",
    "district": "Barpeta",
    "block": "Barkhetri",
    "officename": "Jalahghat S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781328": {
    "state": "Assam",
    "district": "Barpeta",
    "block": "Baghmarabazar",
    "officename": "Baghmarabazar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781329": {
    "state": "Assam",
    "district": "Barpeta",
    "block": "Barkhetri",
    "officename": "Nityananda S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781330": {
    "state": "Assam",
    "district": "Barpeta",
    "block": "Barkhetri",
    "officename": "Simla S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781333": {
    "state": "Assam",
    "district": "Nalbari",
    "block": "Barimakha",
    "officename": "Barimakha S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781334": {
    "state": "Assam",
    "district": "Nalbari",
    "block": "Chowk Bazar",
    "officename": "Chowkbazar S.O (Nalbari)",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781335": {
    "state": "Assam",
    "district": "Nalbari",
    "block": "Nalbari",
    "officename": "Nalbari H.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781337": {
    "state": "Assam",
    "district": "Nalbari",
    "block": "Milanpur",
    "officename": "Milanpur S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781338": {
    "state": "Assam",
    "district": "Nalbari",
    "block": "Rampur",
    "officename": "Solmara S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781339": {
    "state": "Assam",
    "district": "Nalbari",
    "block": "Arikuchi",
    "officename": "Karia S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781340": {
    "state": "Assam",
    "district": "Nalbari",
    "block": "Bakuajari",
    "officename": "Banekuchi S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781341": {
    "state": "Assam",
    "district": "Nalbari",
    "block": "Balikaria",
    "officename": "Kazipara S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781343": {
    "state": "Assam",
    "district": "Nalbari",
    "block": "Dhanbil",
    "officename": "Dhanbil S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781344": {
    "state": "Assam",
    "district": "Nalbari",
    "block": "Angardhowa",
    "officename": "Baganpara S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781346": {
    "state": "Assam",
    "district": "Nalbari",
    "block": "Barama",
    "officename": "Barama S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781347": {
    "state": "Assam",
    "district": "Nalbari",
    "block": "Kamarkuchi",
    "officename": "Kamarkuchi S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781348": {
    "state": "Assam",
    "district": "Nalbari",
    "block": "Marowa",
    "officename": "Marowa S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781349": {
    "state": "Assam",
    "district": "Nalbari",
    "block": "Rampur",
    "officename": "Nizdhamdhama S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781350": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Sanekuchi",
    "officename": "Sanekuchi S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781351": {
    "state": "Assam",
    "district": "Nalbari",
    "block": "Barbari",
    "officename": "Kalag S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781352": {
    "state": "Assam",
    "district": "Barpeta",
    "block": "Bhowanipur",
    "officename": "Bhowanipur S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781353": {
    "state": "Assam",
    "district": "Nalbari",
    "block": "Nalbari",
    "officename": "Gopalbazar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781354": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Rangia Block",
    "officename": "Rangia S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781355": {
    "state": "Assam",
    "district": "Nalbari",
    "block": "Niz Namati",
    "officename": "Assam Syntex S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781360": {
    "state": "Assam",
    "district": "Nalbari",
    "block": "Angarkata",
    "officename": "Kumarikata S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781364": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Goreswar Block",
    "officename": "Maharipara S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781365": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Rangia Block",
    "officename": "Rangia R.S. S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781366": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Goreswar Block",
    "officename": "Goreswar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781367": {
    "state": "Assam",
    "district": "Nalbari",
    "block": "Rampur",
    "officename": "Tambulpur S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781368": {
    "state": "Assam",
    "district": "Nalbari",
    "block": "Rampur",
    "officename": "Nagrijuli S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781369": {
    "state": "Assam",
    "district": "Nalbari",
    "block": "Allia",
    "officename": "Ghograpar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781370": {
    "state": "Assam",
    "district": "Nalbari",
    "block": "Gobradal",
    "officename": "Kaithalkuchi S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781371": {
    "state": "Assam",
    "district": "Nalbari",
    "block": "Rampur",
    "officename": "Tihu S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781372": {
    "state": "Assam",
    "district": "Nalbari",
    "block": "Adalbari",
    "officename": "Mussalpur S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781373": {
    "state": "Assam",
    "district": "Nalbari",
    "block": "Ahopa",
    "officename": "Doomni S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781374": {
    "state": "Assam",
    "district": "Nalbari",
    "block": "Rampur",
    "officename": "Makhibaha S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781375": {
    "state": "Assam",
    "district": "Nalbari",
    "block": "Bangaon",
    "officename": "Bangaon S.O (Nalbari)",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781376": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Rangia Block",
    "officename": "Darkuchi S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781377": {
    "state": "Assam",
    "district": "Nalbari",
    "block": "Rampur",
    "officename": "Thamna S.O (Nalbari)",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781378": {
    "state": "Assam",
    "district": "Nalbari",
    "block": "Bali",
    "officename": "Haribhanga S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "781380": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Kamalpur",
    "officename": "Baihata S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781381": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Bezera Block",
    "officename": "Baihata Chariali S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781382": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Kamalpur Block",
    "officename": "Soneswar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "782001": {
    "state": "Assam",
    "district": "Marigaon",
    "block": "Morigaon",
    "officename": "Nagaon H.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782002": {
    "state": "Assam",
    "district": "Nagaon",
    "block": "Nagaon",
    "officename": "Haiborgaon S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782003": {
    "state": "Assam",
    "district": "Nagaon",
    "block": "Nagaon",
    "officename": "Itachali S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782101": {
    "state": "Assam",
    "district": "Nagaon",
    "block": "Nagaon",
    "officename": "Nonoi S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782102": {
    "state": "Assam",
    "district": "Nagaon",
    "block": "Nagaon",
    "officename": "Barhampur S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782103": {
    "state": "Assam",
    "district": "Marigaon",
    "block": "Morigaon",
    "officename": "Raha S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782104": {
    "state": "Assam",
    "district": "Marigaon",
    "block": "Morigaon",
    "officename": "Jaluguti S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782105": {
    "state": "Assam",
    "district": "Marigaon",
    "block": "Morigaon",
    "officename": "Morigaon S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782106": {
    "state": "Assam",
    "district": "Marigaon",
    "block": "Morigaon",
    "officename": "Charaibahi S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782120": {
    "state": "Assam",
    "district": "Nagaon",
    "block": "Ambagan",
    "officename": "Ambagan S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782121": {
    "state": "Assam",
    "district": "Marigaon",
    "block": "Bhuragaon",
    "officename": "Bhuragaon S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782122": {
    "state": "Assam",
    "district": "Nagaon",
    "block": "Nagaon",
    "officename": "Batadraba S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782123": {
    "state": "Assam",
    "district": "Nagaon",
    "block": "Nagaon",
    "officename": "Dhing S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782124": {
    "state": "Assam",
    "district": "Nagaon",
    "block": "Nagaon",
    "officename": "Juria S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782125": {
    "state": "Assam",
    "district": "Nagaon",
    "block": "Nagaon",
    "officename": "Rupahi S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782126": {
    "state": "Assam",
    "district": "Marigaon",
    "block": "Morigaon",
    "officename": "Moirabari S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782127": {
    "state": "Assam",
    "district": "Marigaon",
    "block": "Morigaon",
    "officename": "Lahorighat S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782128": {
    "state": "Assam",
    "district": "Nagaon",
    "block": "Nagaon",
    "officename": "Garajan Bazar S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782135": {
    "state": "Assam",
    "district": "Nagaon",
    "block": "Nagaon",
    "officename": "Chapanalla S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782136": {
    "state": "Assam",
    "district": "Nagaon",
    "block": "Nagaon",
    "officename": "Jakhalabandha S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782137": {
    "state": "Assam",
    "district": "Nagaon",
    "block": "Nagaon",
    "officename": "Kuworitul S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782138": {
    "state": "Assam",
    "district": "Nagaon",
    "block": "Nagaon",
    "officename": "Missa S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782139": {
    "state": "Assam",
    "district": "Karbi Anglong",
    "block": "Diphu",
    "officename": "Salana S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782140": {
    "state": "Assam",
    "district": "Nagaon",
    "block": "Nagaon",
    "officename": "Samaguri S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782141": {
    "state": "Assam",
    "district": "Nagaon",
    "block": "Nagaon",
    "officename": "Puranigudam S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782142": {
    "state": "Assam",
    "district": "Nagaon",
    "block": "Nagaon",
    "officename": "Bebejia S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782143": {
    "state": "Assam",
    "district": "Nagaon",
    "block": "Nagaon",
    "officename": "Silghat S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782144": {
    "state": "Assam",
    "district": "Nagaon",
    "block": "Nagaon",
    "officename": "Baligaon S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782401": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Sonapur Block",
    "officename": "Digaru S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "782402": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Sonapur Block",
    "officename": "Sonapur S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "782403": {
    "state": "Assam",
    "district": "Kamrup",
    "block": "Sonapur Block",
    "officename": "Khetri S.O (Kamrup)",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "782410": {
    "state": "Assam",
    "district": "Karbi Anglong",
    "block": "Diphu",
    "officename": "Jagiroad S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782411": {
    "state": "Assam",
    "district": "Marigaon",
    "block": "Morigaon",
    "officename": "Jagibhakatgaon S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782412": {
    "state": "Assam",
    "district": "Marigaon",
    "block": "Morigaon",
    "officename": "Dharamtul S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782413": {
    "state": "Assam",
    "district": "Marigaon",
    "block": "Jagiroad",
    "officename": "Kagajnagar S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782425": {
    "state": "Assam",
    "district": "Nagaon",
    "block": "Nagaon",
    "officename": "Chaparmukh S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782426": {
    "state": "Assam",
    "district": "Nagaon",
    "block": "Nagaon",
    "officename": "Kampur S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782427": {
    "state": "Assam",
    "district": "Nagaon",
    "block": "Nagaon",
    "officename": "Kathiatoli S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782428": {
    "state": "Assam",
    "district": "Nagaon",
    "block": "Nagaon",
    "officename": "Jamunamukh S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782429": {
    "state": "Assam",
    "district": "Nagaon",
    "block": "Hojai",
    "officename": "Jogijan Bazar S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782435": {
    "state": "Assam",
    "district": "Nagaon",
    "block": "Hojai",
    "officename": "Hojai S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782439": {
    "state": "Assam",
    "district": "Nagaon",
    "block": "Hojai",
    "officename": "Murazar Bazar S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782440": {
    "state": "Assam",
    "district": "Nagaon",
    "block": "Nagaon",
    "officename": "Daboka S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782441": {
    "state": "Assam",
    "district": "Karbi Anglong",
    "block": "Diphu",
    "officename": "Dokmaka S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782442": {
    "state": "Assam",
    "district": "Nagaon",
    "block": "Hojai",
    "officename": "Sankardev Nagar S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782445": {
    "state": "Assam",
    "district": "Nagaon",
    "block": "Hojai",
    "officename": "Nilbagan S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782446": {
    "state": "Assam",
    "district": "Nagaon",
    "block": "Lanka",
    "officename": "Lanka S.O (Nagaon)",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782447": {
    "state": "Assam",
    "district": "Karbi Anglong",
    "block": "Diphu",
    "officename": "Lumding S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782448": {
    "state": "Assam",
    "district": "Karbi Anglong",
    "block": "Donka",
    "officename": "Kheroni S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782450": {
    "state": "Assam",
    "district": "Karbi Anglong",
    "block": "Hamren",
    "officename": "Baithalangsho S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782460": {
    "state": "Assam",
    "district": "Karbi Anglong",
    "block": "Nagaon",
    "officename": "Diphu H.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782461": {
    "state": "Assam",
    "district": "Karbi Anglong",
    "block": "Diphu",
    "officename": "Manja S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782462": {
    "state": "Assam",
    "district": "Karbi Anglong",
    "block": "Diphu",
    "officename": "Diphu Govt.College S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782470": {
    "state": "Assam",
    "district": "Karbi Anglong",
    "block": "Diphu",
    "officename": "Dhansripar S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782480": {
    "state": "Assam",
    "district": "Karbi Anglong",
    "block": "Bokajan",
    "officename": "Bokajan S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782481": {
    "state": "Assam",
    "district": "Karbi Anglong",
    "block": "Diphu",
    "officename": "Howraghat S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782482": {
    "state": "Assam",
    "district": "Karbi Anglong",
    "block": "Diphu",
    "officename": "Bakalighat S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782485": {
    "state": "Assam",
    "district": "Karbi Anglong",
    "block": "Donkamokam",
    "officename": "Donkamokam S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782486": {
    "state": "Assam",
    "district": "Karbi Anglong",
    "block": "Hamren",
    "officename": "Hamren S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "782490": {
    "state": "Assam",
    "district": "Karbi Anglong",
    "block": "Bokajan",
    "officename": "Bokajan C F S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "783101": {
    "state": "Assam",
    "district": "Goalpara",
    "block": "Goalpara",
    "officename": "Goalpara Head Post Office",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783120": {
    "state": "Assam",
    "district": "Goalpara",
    "block": "Balijana",
    "officename": "Agia S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783122": {
    "state": "Assam",
    "district": "Goalpara",
    "block": "Dudnai",
    "officename": "Damra S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783123": {
    "state": "Meghalaya",
    "district": "East Garo Hills",
    "block": "Dambo Rongjeng",
    "officename": "Dhupdhara S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783124": {
    "state": "Assam",
    "district": "Goalpara",
    "block": "Dudnai",
    "officename": "Dudhnoi S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783125": {
    "state": "Assam",
    "district": "Goalpara",
    "block": "Matia",
    "officename": "Matia S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783126": {
    "state": "Assam",
    "district": "Goalpara",
    "block": "Krishnai",
    "officename": "Krishnai S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783127": {
    "state": "Assam",
    "district": "Dhubri",
    "block": "Salmara South",
    "officename": "Salmara South S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783128": {
    "state": "Assam",
    "district": "Dhubri",
    "block": "South Salmara",
    "officename": "Sukchar S.O (Dhubri)",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783129": {
    "state": "Assam",
    "district": "Goalpara",
    "block": "Lakhipur",
    "officename": "Lakhipur S.O (Goalpara)",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783130": {
    "state": "Assam",
    "district": "Goalpara",
    "block": "Rangjuli",
    "officename": "Rangjuli S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783131": {
    "state": "Assam",
    "district": "Dhubri",
    "block": "Mankachar",
    "officename": "Mankachar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783132": {
    "state": "Assam",
    "district": "Goalpara",
    "block": "Lakhipur",
    "officename": "Jaleswar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783133": {
    "state": "Assam",
    "district": "Goalpara",
    "block": "Matia",
    "officename": "Rajapara S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783134": {
    "state": "Assam",
    "district": "Goalpara",
    "block": "Dudnai",
    "officename": "Darrangiri S.O.",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783135": {
    "state": "Assam",
    "district": "Dhubri",
    "block": "Fekamari",
    "officename": "Fekamari S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783301": {
    "state": "Assam",
    "district": "Dhubri",
    "block": "Dhubri",
    "officename": "Dhubri H.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783323": {
    "state": "Assam",
    "district": "Dhubri",
    "block": "Dhubri",
    "officename": "Amco Road S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783324": {
    "state": "Assam",
    "district": "Dhubri",
    "block": "Dhubri",
    "officename": "Bidyapara S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783325": {
    "state": "Assam",
    "district": "Dhubri",
    "block": "Dhubri",
    "officename": "Jhagrarpar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783330": {
    "state": "Assam",
    "district": "Dhubri",
    "block": "South Salmara",
    "officename": "Fakirganj S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783331": {
    "state": "Assam",
    "district": "Dhubri",
    "block": "Rupsi",
    "officename": "Gauripur S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783332": {
    "state": "Assam",
    "district": "Kokrajhar",
    "block": "Hatidhura",
    "officename": "Tamarhat S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783333": {
    "state": "Assam",
    "district": "Kokrajhar",
    "block": "Hatidhura",
    "officename": "Dingdinga S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783334": {
    "state": "Assam",
    "district": "Dhubri",
    "block": "Golakganj",
    "officename": "Golakganj S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783335": {
    "state": "Assam",
    "district": "Dhubri",
    "block": "Agomoni",
    "officename": "Agomoni S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783336": {
    "state": "Assam",
    "district": "Kokrajhar",
    "block": "Gossaigaon",
    "officename": "Bhowraguri S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783337": {
    "state": "Assam",
    "district": "Kokrajhar",
    "block": "Bilasipara",
    "officename": "Sapatgram S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783339": {
    "state": "Assam",
    "district": "Dhubri",
    "block": "Debitala",
    "officename": "Alamganj S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783345": {
    "state": "Assam",
    "district": "Kokrajhar",
    "block": "Dotma",
    "officename": "Fakiragram S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783346": {
    "state": "Assam",
    "district": "Kokrajhar",
    "block": "Dotma",
    "officename": "Serfanguri S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783347": {
    "state": "Assam",
    "district": "Kokrajhar",
    "block": "Dotma",
    "officename": "Dotma S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783348": {
    "state": "Assam",
    "district": "Dhubri",
    "block": "Bilasipara",
    "officename": "Bilasipara S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783349": {
    "state": "Assam",
    "district": "Dhubri",
    "block": "Bagribari",
    "officename": "Bagribari S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783350": {
    "state": "Assam",
    "district": "Kokrajhar",
    "block": "Kachugaon",
    "officename": "Kachugaon S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783354": {
    "state": "Assam",
    "district": "Kokrajhar",
    "block": "Dotma",
    "officename": "Saktiashram S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783360": {
    "state": "Assam",
    "district": "Kokrajhar",
    "block": "Gossaigaon",
    "officename": "Gossaigaon S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783361": {
    "state": "Assam",
    "district": "Kokrajhar",
    "block": "Gossaigaon",
    "officename": "Srirampur S.O (Kokrajhar)",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783369": {
    "state": "Assam",
    "district": "Kokrajhar",
    "block": "Kokrajhar",
    "officename": "Salakati Project S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783370": {
    "state": "Assam",
    "district": "Kokrajhar",
    "block": "Kokrajhar",
    "officename": "Kokrajhar H.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783371": {
    "state": "Assam",
    "district": "Dhubri",
    "block": "Chapar Salkocha",
    "officename": "Chapar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783372": {
    "state": "Assam",
    "district": "Kokrajhar",
    "block": "Kokrajhar",
    "officename": "Basugaon S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783373": {
    "state": "Assam",
    "district": "Bongaigaon",
    "block": "Sidli Chirang",
    "officename": "Sidli S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783375": {
    "state": "Assam",
    "district": "Kokrajhar",
    "block": "Bengtal",
    "officename": "Runikhata S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783376": {
    "state": "Assam",
    "district": "Kokrajhar",
    "block": "Kokrajhar",
    "officename": "Choraikhola S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783380": {
    "state": "Assam",
    "district": "Bongaigaon",
    "block": "Bongaigaon",
    "officename": "Bongaigaon S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783381": {
    "state": "Assam",
    "district": "Bongaigaon",
    "block": "Bongaigaon",
    "officename": "New Bongaigaon S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783382": {
    "state": "Assam",
    "district": "Bongaigaon",
    "block": "Baitamari",
    "officename": "Jogighopa S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783383": {
    "state": "Assam",
    "district": "Bongaigaon",
    "block": "Baitamari",
    "officename": "Salmara North S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783384": {
    "state": "Assam",
    "district": "Bongaigaon",
    "block": "Abhayapuri",
    "officename": "Abhayapuri S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783385": {
    "state": "Assam",
    "district": "Bongaigaon",
    "block": "Bongaigaon",
    "officename": "Dhaligaon S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783388": {
    "state": "Assam",
    "district": "Bongaigaon",
    "block": "Bongaigaon",
    "officename": "A.P.Mill S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783389": {
    "state": "Assam",
    "district": "Bongaigaon",
    "block": "Boitamari",
    "officename": "Boitamari S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783390": {
    "state": "Assam",
    "district": "Bongaigaon",
    "block": "Bijni",
    "officename": "Bijni S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783391": {
    "state": "Assam",
    "district": "Bongaigaon",
    "block": "Boitamari",
    "officename": "Patiladaha S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783392": {
    "state": "Assam",
    "district": "Bongaigaon",
    "block": "Manikpur",
    "officename": "Manikpur S.O (Bongaigaon)",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783393": {
    "state": "Assam",
    "district": "Bongaigaon",
    "block": "Borobazar",
    "officename": "Boro Bazar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783394": {
    "state": "Assam",
    "district": "Bongaigaon",
    "block": "Bengtal",
    "officename": "Bengtal S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "784001": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Hazarapar",
    "officename": "Tezpur H.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784010": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Tezpur",
    "officename": "Tezpur Medical College S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784025": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Panchmile",
    "officename": "Panchmile S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784026": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Khalihamari",
    "officename": "Khalihamari S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784027": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Kaliabhomora",
    "officename": "Kaliabhomora S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784028": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Napaam",
    "officename": "Napaam S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784101": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Balipara",
    "officename": "Balipara S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784102": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Lokra",
    "officename": "Lokra S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784103": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Chariduar",
    "officename": "Chariduar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784104": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Shalonibari",
    "officename": "Shalonibari S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784105": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Ghoramari",
    "officename": "Ghoramari S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784110": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Dhekiajuli",
    "officename": "Dhekiajuli S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784111": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Darrang Panbari",
    "officename": "Darrang Panbari S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784112": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Alisinga",
    "officename": "Alisinga S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784113": {
    "state": "Assam",
    "district": "Darrang",
    "block": "Kopati",
    "officename": "Kopati S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784114": {
    "state": "Assam",
    "district": "Darrang",
    "block": "Orang",
    "officename": "Orang S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784115": {
    "state": "Assam",
    "district": "Darrang",
    "block": "Kharupetiaghat",
    "officename": "Kharupetiaghat S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784116": {
    "state": "Assam",
    "district": "Darrang",
    "block": "Dalgaon",
    "officename": "Dalgaon S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784117": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Sirajuli",
    "officename": "Sirajuli S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784125": {
    "state": "Assam",
    "district": "Darrang",
    "block": "Mangaldoi",
    "officename": "Mangaldoi H.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784144": {
    "state": "Assam",
    "district": "Darrang",
    "block": "Pathorighat",
    "officename": "Pathorighat S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784145": {
    "state": "Assam",
    "district": "Darrang",
    "block": "Sipajhar",
    "officename": "Sipajhar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784146": {
    "state": "Assam",
    "district": "Darrang",
    "block": "Dhula",
    "officename": "Dhula S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784147": {
    "state": "Assam",
    "district": "Darrang",
    "block": "Deomornoi",
    "officename": "Deomornoi S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784148": {
    "state": "Assam",
    "district": "Darrang",
    "block": "Duni",
    "officename": "Duni S.O (Darrang",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784149": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Thelamara",
    "officename": "Thelamara S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784150": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Besseria",
    "officename": "Besseria S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784153": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Bandarmari",
    "officename": "Bihaguri S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784154": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Ketekibari",
    "officename": "Ketekibari S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784160": {
    "state": "Assam",
    "district": "Lakhimpur",
    "block": "Laluk",
    "officename": "Laluk S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "784161": {
    "state": "Assam",
    "district": "Lakhimpur",
    "block": "Bihupuria",
    "officename": "Bihupuria S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "784163": {
    "state": "Assam",
    "district": "Lakhimpur",
    "block": "Pathalipahar",
    "officename": "Pathalipahar S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "784164": {
    "state": "Assam",
    "district": "Lakhimpur",
    "block": "Dikrong",
    "officename": "Dikrong S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "784165": {
    "state": "Assam",
    "district": "Lakhimpur",
    "block": "Dhalpur",
    "officename": "Dhalpur S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "784166": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Behali",
    "officename": "Behali S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784167": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Borgong",
    "officename": "Borgong S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784168": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Gohpur",
    "officename": "Gohpur S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784169": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Howajan",
    "officename": "Howajan  S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784170": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Halem",
    "officename": "Halem S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784171": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Tetenbari",
    "officename": "Tetenbari S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784172": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Barangabari",
    "officename": "Barangabari S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784173": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Mijikajan",
    "officename": "Mijikajan S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784174": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Pabhoi",
    "officename": "Pabhoi S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784175": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Sootea",
    "officename": "Sootea S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784176": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Charilai",
    "officename": "Chariali MDG",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784177": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Biswanathghat",
    "officename": "Biswanathghat S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784178": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Kalabari",
    "officename": "Kalabari S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784179": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Bedeti",
    "officename": "Bedeti S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784180": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Jamugurihat",
    "officename": "Jamugurihat S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784182": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Bakola",
    "officename": "Naharbari S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784184": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Gingia",
    "officename": "Gingia S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784189": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Karsontala",
    "officename": "Karsontala S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784190": {
    "state": "Assam",
    "district": "Darrang",
    "block": "Bhakatpara",
    "officename": "Bhakatpara S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784501": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Dekargaon",
    "officename": "Dekargaon S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784502": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Bindukuri",
    "officename": "Bindukuri S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784504": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Borjuli",
    "officename": "Borjuli S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784505": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Rangapara",
    "officename": "Rangapara S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784506": {
    "state": "Assam",
    "district": "Sonitpur",
    "block": "Missamari",
    "officename": "Missamari S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784507": {
    "state": "Assam",
    "district": "Darrang",
    "block": "Mazbat",
    "officename": "Mazbat S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784508": {
    "state": "Assam",
    "district": "Darrang",
    "block": "Rowta",
    "officename": "Rowta S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784509": {
    "state": "Assam",
    "district": "Darrang",
    "block": "Udalguri",
    "officename": "Udalguri S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784510": {
    "state": "Assam",
    "district": "Darrang",
    "block": "Harisinga",
    "officename": "Harisinga S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784513": {
    "state": "Assam",
    "district": "Darrang",
    "block": "Bhairabkunda",
    "officename": "Sapangaon S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784514": {
    "state": "Assam",
    "district": "Darrang",
    "block": "Lalpul Bazar",
    "officename": "Lalpul Bazar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784521": {
    "state": "Assam",
    "district": "Darrang",
    "block": "Tangla",
    "officename": "Tangla S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784522": {
    "state": "Assam",
    "district": "Darrang",
    "block": "Khoirabari",
    "officename": "Khoirabari S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784523": {
    "state": "Assam",
    "district": "Darrang",
    "block": "Panerihat",
    "officename": "Panerihat S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784524": {
    "state": "Assam",
    "district": "Darrang",
    "block": "Hatigarh",
    "officename": "Hatigarh S.O (Darrang",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784525": {
    "state": "Assam",
    "district": "Darrang",
    "block": "Kalaigaon",
    "officename": "Kalaigaon S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784526": {
    "state": "Assam",
    "district": "Darrang",
    "block": "Dimakuchi",
    "officename": "Dimakuchi S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784527": {
    "state": "Assam",
    "district": "Darrang",
    "block": "Atterikhat",
    "officename": "Atterikhat S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784528": {
    "state": "Assam",
    "district": "Darrang",
    "block": "Purani Tangla",
    "officename": "Purani Tangla S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "784529": {
    "state": "Assam",
    "district": "Darrang",
    "block": "Mangaldoi",
    "officename": "Chapaichowka S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Darrang Division"
  },
  "785001": {
    "state": "Assam",
    "district": "Jorhat",
    "block": "Jorhat",
    "officename": "Jorhat H.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785004": {
    "state": "Assam",
    "district": "Jorhat",
    "block": "Jorhat",
    "officename": "Barbheta S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785006": {
    "state": "Assam",
    "district": "Jorhat",
    "block": "Jorhat",
    "officename": "Jorhat Reserch Lab S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785007": {
    "state": "Assam",
    "district": "Jorhat",
    "block": "Jorhat",
    "officename": "Jorhat Engg College S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785008": {
    "state": "Assam",
    "district": "Jorhat",
    "block": "Jorhat",
    "officename": "Cinnamara S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785009": {
    "state": "Assam",
    "district": "Jorhat",
    "block": "Jorhat",
    "officename": "Na Ali Dhekiajuli S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785010": {
    "state": "Assam",
    "district": "Jorhat",
    "block": "Jorhat",
    "officename": "Chengeli Gaon S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785013": {
    "state": "Assam",
    "district": "Jorhat",
    "block": "Jorhat",
    "officename": "Assam Agriculture University S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785014": {
    "state": "Assam",
    "district": "Jorhat",
    "block": "Jorhat",
    "officename": "Rajabari S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785015": {
    "state": "Assam",
    "district": "Jorhat",
    "block": "Jorhat",
    "officename": "Korokatoly S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785101": {
    "state": "Assam",
    "district": "Jorhat",
    "block": "Jorhat",
    "officename": "Bahana S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785102": {
    "state": "Assam",
    "district": "Jorhat",
    "block": "Jorhat",
    "officename": "Dakhin Pat Satra S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785104": {
    "state": "Assam",
    "district": "Golaghat",
    "block": "Jorhat",
    "officename": "Garmursatra S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785105": {
    "state": "Assam",
    "district": "Jorhat",
    "block": "Majuli",
    "officename": "Jengraimukh S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785106": {
    "state": "Assam",
    "district": "Jorhat",
    "block": "Jorhat",
    "officename": "Kamalabari S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785107": {
    "state": "Assam",
    "district": "Jorhat",
    "block": "Jorhat",
    "officename": "Kakajan S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785108": {
    "state": "Assam",
    "district": "Jorhat",
    "block": "Jorhat",
    "officename": "Kakilamukh S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785110": {
    "state": "Assam",
    "district": "Jorhat",
    "block": "Majuli",
    "officename": "Majulibongaon S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785111": {
    "state": "Assam",
    "district": "Jorhat",
    "block": "Jorhat",
    "officename": "Neamatighat S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785112": {
    "state": "Assam",
    "district": "Jorhat",
    "block": "Jorhat",
    "officename": "Teok S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785601": {
    "state": "Assam",
    "district": "Golaghat",
    "block": "Glt",
    "officename": "Sarupathar S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785602": {
    "state": "Assam",
    "district": "Golaghat",
    "block": "Golaghat",
    "officename": "Barpathar S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785603": {
    "state": "Assam",
    "district": "Golaghat",
    "block": "Glt",
    "officename": "Oating S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785609": {
    "state": "Assam",
    "district": "Golaghat",
    "block": "Glt",
    "officename": "Kaziranga National Park S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785610": {
    "state": "Assam",
    "district": "Golaghat",
    "block": "Glt",
    "officename": "Furkating S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785611": {
    "state": "Assam",
    "district": "Golaghat",
    "block": "Golaghat",
    "officename": "Badulipaar S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785612": {
    "state": "Assam",
    "district": "Golaghat",
    "block": "Bkt",
    "officename": "Bokakhat S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785613": {
    "state": "Assam",
    "district": "Golaghat",
    "block": "Glt",
    "officename": "Letekujaan S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785614": {
    "state": "Assam",
    "district": "Golaghat",
    "block": "Glt",
    "officename": "Dergaon S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785615": {
    "state": "Assam",
    "district": "Golaghat",
    "block": "Glt",
    "officename": "Numaligarh S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785616": {
    "state": "Assam",
    "district": "Jorhat",
    "block": "Jorhat",
    "officename": "Gatanga S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785618": {
    "state": "Assam",
    "district": "Golaghat",
    "block": "Golaghat",
    "officename": "Baruabamungaon S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785619": {
    "state": "Assam",
    "district": "Golaghat",
    "block": "Glt",
    "officename": "Kamargaon S.O (Golaghat)",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785621": {
    "state": "Assam",
    "district": "Golaghat",
    "block": "Golaghat",
    "officename": "Golaghat H.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785622": {
    "state": "Assam",
    "district": "Golaghat",
    "block": "Glt",
    "officename": "Dhekial S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785625": {
    "state": "Assam",
    "district": "Golaghat",
    "block": "Glt",
    "officename": "Kamarbandha Ali S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785626": {
    "state": "Assam",
    "district": "Golaghat",
    "block": "Glt",
    "officename": "Maheema S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785630": {
    "state": "Assam",
    "district": "Jorhat",
    "block": "Ttb",
    "officename": "Titabor S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785631": {
    "state": "Assam",
    "district": "Jorhat",
    "block": "Jorhat",
    "officename": "Borholla S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785632": {
    "state": "Assam",
    "district": "Jorhat",
    "block": "Ttb",
    "officename": "Purana Titabor S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785633": {
    "state": "Assam",
    "district": "Jorhat",
    "block": "Jorhat",
    "officename": "Khorikotia S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785634": {
    "state": "Assam",
    "district": "Jorhat",
    "block": "Jorhat",
    "officename": "Mariani S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785635": {
    "state": "Assam",
    "district": "Jorhat",
    "block": "Jorhat",
    "officename": "Nakachari S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785636": {
    "state": "Assam",
    "district": "Jorhat",
    "block": "Jorhat",
    "officename": "Selenghat S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785640": {
    "state": "Assam",
    "district": "Sibsagar",
    "block": "Sibsagar",
    "officename": "Sivasagar H.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785661": {
    "state": "Assam",
    "district": "Sibsagar",
    "block": "Svs",
    "officename": "Charing S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785662": {
    "state": "Assam",
    "district": "Sibsagar",
    "block": "Svs",
    "officename": "Demow S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785663": {
    "state": "Assam",
    "district": "Sibsagar",
    "block": "Svs",
    "officename": "Disangmukh S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785664": {
    "state": "Assam",
    "district": "Sibsagar",
    "block": "Svs",
    "officename": "Gaurisagar S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785665": {
    "state": "Assam",
    "district": "Sibsagar",
    "block": "Sibsagar",
    "officename": "Joysagar S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785666": {
    "state": "Assam",
    "district": "Sibsagar",
    "block": "Svs",
    "officename": "Kaloogaon S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785667": {
    "state": "Assam",
    "district": "Sibsagar",
    "block": "Svs",
    "officename": "Konwarpur S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785669": {
    "state": "Assam",
    "district": "Sibsagar",
    "block": "NA",
    "officename": "Moran S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785670": {
    "state": "Assam",
    "district": "Sibsagar",
    "block": "Svs",
    "officename": "Moranhat S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785671": {
    "state": "Assam",
    "district": "Sibsagar",
    "block": "Svs",
    "officename": "Nitaipukhuri S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785672": {
    "state": "Assam",
    "district": "Sibsagar",
    "block": "Svs",
    "officename": "Rajmai S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785673": {
    "state": "Assam",
    "district": "Sibsagar",
    "block": "Svs",
    "officename": "Sepon S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785674": {
    "state": "Assam",
    "district": "Sibsagar",
    "block": "Svs",
    "officename": "Nemuguri S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785675": {
    "state": "Assam",
    "district": "Dibrugarh",
    "block": "Khowang",
    "officename": "Khowang S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "785676": {
    "state": "Assam",
    "district": "Dibrugarh",
    "block": "Khowang Ghat",
    "officename": "Khowang Ghat S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "785680": {
    "state": "Assam",
    "district": "Sibsagar",
    "block": "Sibsagar",
    "officename": "Amguri S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785681": {
    "state": "Assam",
    "district": "Sibsagar",
    "block": "Sibsagar",
    "officename": "Amguri Haloating S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785682": {
    "state": "Assam",
    "district": "Sibsagar",
    "block": "Svs",
    "officename": "Tamulichiga S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785683": {
    "state": "Assam",
    "district": "Sibsagar",
    "block": "Svs",
    "officename": "Jhanji S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785684": {
    "state": "Assam",
    "district": "Sibsagar",
    "block": "Svs",
    "officename": "Namtidoll S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785685": {
    "state": "Assam",
    "district": "Sibsagar",
    "block": "Svs",
    "officename": "Nazira S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785686": {
    "state": "Assam",
    "district": "Sibsagar",
    "block": "Svs",
    "officename": "Simaluguri S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785687": {
    "state": "Assam",
    "district": "Sibsagar",
    "block": "Svs",
    "officename": "Santak S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785688": {
    "state": "Assam",
    "district": "Sibsagar",
    "block": "Svs",
    "officename": "Lakowah S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785689": {
    "state": "Assam",
    "district": "Sibsagar",
    "block": "Svs",
    "officename": "Suffry S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785690": {
    "state": "Assam",
    "district": "Sibsagar",
    "block": "Svs",
    "officename": "Sonari S.O (Sibsagar)",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785691": {
    "state": "Assam",
    "district": "Sibsagar",
    "block": "Svs",
    "officename": "Bhojo S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785692": {
    "state": "Assam",
    "district": "Sibsagar",
    "block": "Svs",
    "officename": "Sapekhati S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785693": {
    "state": "Assam",
    "district": "Sibsagar",
    "block": "Svs",
    "officename": "Borhat S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785696": {
    "state": "Assam",
    "district": "Sibsagar",
    "block": "Svs",
    "officename": "Geleky S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785697": {
    "state": "Assam",
    "district": "Sibsagar",
    "block": "Svs",
    "officename": "ONGC Colony S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785698": {
    "state": "Assam",
    "district": "Sibsagar",
    "block": "Sibsagar",
    "officename": "Lakwah R.S. S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785699": {
    "state": "Assam",
    "district": "Golaghat",
    "block": "Glt",
    "officename": "Numaligarh Refinery Project S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785700": {
    "state": "Assam",
    "district": "Jorhat",
    "block": "Jorhat",
    "officename": "Lahdoigarh Chariali S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785701": {
    "state": "Assam",
    "district": "Sibsagar",
    "block": "Svs",
    "officename": "Hahchara S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785702": {
    "state": "Assam",
    "district": "Golaghat",
    "block": "Glt",
    "officename": "Bengenakhowa S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785703": {
    "state": "Assam",
    "district": "Jorhat",
    "block": "Glt",
    "officename": "Ptc Dergaon S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785704": {
    "state": "Assam",
    "district": "Jorhat",
    "block": "Jorhat",
    "officename": "Ongc Jorhat S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "785705": {
    "state": "Assam",
    "district": "Sibsagar",
    "block": "NA",
    "officename": "Merapani S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Sibsagar Division"
  },
  "786001": {
    "state": "Assam",
    "district": "Dibrugarh",
    "block": "Dibrugarh",
    "officename": "Dibrugarh H.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "786002": {
    "state": "Assam",
    "district": "Dibrugarh",
    "block": "Dibrugarh",
    "officename": "Assam Medical College S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "786003": {
    "state": "Assam",
    "district": "Dibrugarh",
    "block": "Dibrugarh",
    "officename": "Central Revenue Building S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "786004": {
    "state": "Assam",
    "district": "Dibrugarh",
    "block": "Dibrugarh",
    "officename": "Dibrugarh University S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "786006": {
    "state": "Assam",
    "district": "Dibrugarh",
    "block": "Barbarua",
    "officename": "Lepetkata S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "786007": {
    "state": "Assam",
    "district": "Dibrugarh",
    "block": "Barabruah",
    "officename": "Barbaruah S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "786008": {
    "state": "Assam",
    "district": "Dibrugarh",
    "block": "Dibrugarh",
    "officename": "Mohanaghat S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "786010": {
    "state": "Assam",
    "district": "Dibrugarh",
    "block": "Lahoal",
    "officename": "Lahoal S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "786012": {
    "state": "Assam",
    "district": "Dibrugarh",
    "block": "Mohanbari",
    "officename": "Mohanbari Air Field S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "786101": {
    "state": "Assam",
    "district": "Dibrugarh",
    "block": "Dikom",
    "officename": "Dikom S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "786102": {
    "state": "Assam",
    "district": "Dibrugarh",
    "block": "Chabua",
    "officename": "Chabua Air Field S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "786103": {
    "state": "Assam",
    "district": "Dibrugarh",
    "block": "Tengakhat",
    "officename": "Tengakhat S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "786125": {
    "state": "Assam",
    "district": "Tinsukia",
    "block": "Tinsukia",
    "officename": "Tinsukia H.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Tinsukia Division"
  },
  "786126": {
    "state": "Assam",
    "district": "Tinsukia",
    "block": "Tinsukia",
    "officename": "Borguri S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Tinsukia Division"
  },
  "786145": {
    "state": "Assam",
    "district": "Tinsukia",
    "block": "Tinsukia",
    "officename": "Sripuria S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Tinsukia Division"
  },
  "786146": {
    "state": "Assam",
    "district": "Tinsukia",
    "block": "Tinsukia",
    "officename": "Sukhanpukhuri S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Tinsukia Division"
  },
  "786147": {
    "state": "Assam",
    "district": "Tinsukia",
    "block": "Tinsukia",
    "officename": "Rangagora S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Tinsukia Division"
  },
  "786150": {
    "state": "Assam",
    "district": "Tinsukia",
    "block": "Doomdooma",
    "officename": "Barhapjan S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Tinsukia Division"
  },
  "786151": {
    "state": "Assam",
    "district": "Tinsukia",
    "block": "Doom Dooma",
    "officename": "Doom Dooma S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Tinsukia Division"
  },
  "786152": {
    "state": "Assam",
    "district": "Tinsukia",
    "block": "Doom Dooma",
    "officename": "Kakapathar S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Tinsukia Division"
  },
  "786153": {
    "state": "Assam",
    "district": "Tinsukia",
    "block": "Doomdooma",
    "officename": "Rupaisiding S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Tinsukia Division"
  },
  "786154": {
    "state": "Assam",
    "district": "Tinsukia",
    "block": "Doomdooma",
    "officename": "Saikhowaghat S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Tinsukia Division"
  },
  "786155": {
    "state": "Assam",
    "district": "Tinsukia",
    "block": "Chapakhowa",
    "officename": "Sadiya S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Tinsukia Division"
  },
  "786156": {
    "state": "Assam",
    "district": "Tinsukia",
    "block": "Doom Dooma",
    "officename": "Talap S.O (Tinsukia)",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Tinsukia Division"
  },
  "786157": {
    "state": "Assam",
    "district": "Tinsukia",
    "block": "Chapakhowa",
    "officename": "Chapakhowa S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Tinsukia Division"
  },
  "786158": {
    "state": "Assam",
    "district": "Tinsukia",
    "block": "Chapakhowa",
    "officename": "Kundil S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Tinsukia Division"
  },
  "786159": {
    "state": "Assam",
    "district": "Tinsukia",
    "block": "Doom Dooma",
    "officename": "Sukriting S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Tinsukia Division"
  },
  "786160": {
    "state": "Assam",
    "district": "Tinsukia",
    "block": "Doom Dooma",
    "officename": "Phillobari S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Tinsukia Division"
  },
  "786170": {
    "state": "Assam",
    "district": "Tinsukia",
    "block": "Tinsukia",
    "officename": "Makum Junction S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Tinsukia Division"
  },
  "786171": {
    "state": "Assam",
    "district": "Tinsukia",
    "block": "Margherita",
    "officename": "Digboi S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Tinsukia Division"
  },
  "786173": {
    "state": "Assam",
    "district": "Tinsukia",
    "block": "Margherita",
    "officename": "Jubilee Digboi S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Tinsukia Division"
  },
  "786174": {
    "state": "Assam",
    "district": "Tinsukia",
    "block": "Margherita",
    "officename": "Pengri S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Tinsukia Division"
  },
  "786179": {
    "state": "Assam",
    "district": "Tinsukia",
    "block": "Margherita",
    "officename": "Tipong S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Tinsukia Division"
  },
  "786181": {
    "state": "Assam",
    "district": "Tinsukia",
    "block": "Margherita",
    "officename": "Margherita S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Tinsukia Division"
  },
  "786182": {
    "state": "Assam",
    "district": "Tinsukia",
    "block": "Margfherita",
    "officename": "Ledo S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Tinsukia Division"
  },
  "786183": {
    "state": "Assam",
    "district": "Tinsukia",
    "block": "Tinsukia",
    "officename": "Panitola S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Tinsukia Division"
  },
  "786184": {
    "state": "Assam",
    "district": "Dibrugarh",
    "block": "Chabua",
    "officename": "Chabua S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "786187": {
    "state": "Assam",
    "district": "Tinsukia",
    "block": "Margherita",
    "officename": "Makum Pathar S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Tinsukia Division"
  },
  "786188": {
    "state": "Assam",
    "district": "Tinsukia",
    "block": "Margherita",
    "officename": "Jagun S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Tinsukia Division"
  },
  "786189": {
    "state": "Assam",
    "district": "Tinsukia",
    "block": "Tinsukia",
    "officename": "Dinjan S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Tinsukia Division"
  },
  "786190": {
    "state": "Assam",
    "district": "Tinsukia",
    "block": "Doomdooma",
    "officename": "Hansara S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Tinsukia Division"
  },
  "786191": {
    "state": "Assam",
    "district": "Dibrugarh",
    "block": "Naholia",
    "officename": "Naoholia S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "786192": {
    "state": "Assam",
    "district": "Tinsukia",
    "block": "Tinsukia",
    "officename": "Hijiguri S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Tinsukia Division"
  },
  "786601": {
    "state": "Assam",
    "district": "Tinsukia",
    "block": "Teghakhat",
    "officename": "Hoogrijan S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Tinsukia Division"
  },
  "786602": {
    "state": "Assam",
    "district": "Dibrugarh",
    "block": "Duliajan",
    "officename": "Duliajan S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "786610": {
    "state": "Assam",
    "district": "Dibrugarh",
    "block": "Naharkatia",
    "officename": "Naharkatia S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "786611": {
    "state": "Assam",
    "district": "Dibrugarh",
    "block": "Rajgarh",
    "officename": "Rajgarh (Dibrugarh) S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "786612": {
    "state": "Assam",
    "district": "Dibrugarh",
    "block": "Tingkhong",
    "officename": "Tingkhong S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "786613": {
    "state": "Assam",
    "district": "Dibrugarh",
    "block": "Bamunbari",
    "officename": "Bamunbari S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "786614": {
    "state": "Assam",
    "district": "Dibrugarh",
    "block": "Naharkatia",
    "officename": "Jeypore S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "786621": {
    "state": "Assam",
    "district": "Dibrugarh",
    "block": "Namrup",
    "officename": "Namrup S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "786622": {
    "state": "Assam",
    "district": "Dibrugarh",
    "block": "Namrup",
    "officename": "Namrup Thermal Power Station S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "786623": {
    "state": "Assam",
    "district": "Dibrugarh",
    "block": "Parbatpur",
    "officename": "Parbatpur S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "786692": {
    "state": "Assam",
    "district": "Dibrugarh",
    "block": "Duliajan",
    "officename": "Anandapara S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "787001": {
    "state": "Assam",
    "district": "Lakhimpur",
    "block": "North Lakhimpur",
    "officename": "North Lakhimpur H.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "787023": {
    "state": "Assam",
    "district": "Lakhimpur",
    "block": "Lakhimpur",
    "officename": "Naoboicha S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "787026": {
    "state": "Assam",
    "district": "Dhemaji",
    "block": "Bordoloni",
    "officename": "Bordoloni S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "787031": {
    "state": "Assam",
    "district": "Lakhimpur",
    "block": "Lakhimpur",
    "officename": "Khelmati S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "787032": {
    "state": "Assam",
    "district": "Lakhimpur",
    "block": "Lakhimpur",
    "officename": "Moidumia S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "787033": {
    "state": "Assam",
    "district": "Lakhimpur",
    "block": "Bhogpur",
    "officename": "Bhogpur Chariali S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "787034": {
    "state": "Assam",
    "district": "Lakhimpur",
    "block": "Gogamukh",
    "officename": "Gogamukh S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "787035": {
    "state": "Assam",
    "district": "Lakhimpur",
    "block": "Gogamukh",
    "officename": "Gerukamukh S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "787051": {
    "state": "Assam",
    "district": "Lakhimpur",
    "block": "Lakhimpur",
    "officename": "Lilabari AF S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "787052": {
    "state": "Assam",
    "district": "Lakhimpur",
    "block": "Lakhimpur",
    "officename": "Panigaon S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "787053": {
    "state": "Assam",
    "district": "Lakhimpur",
    "block": "Ghilamara",
    "officename": "Ghilamara S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "787054": {
    "state": "Assam",
    "district": "Lakhimpur",
    "block": "Islamgaon",
    "officename": "Islamgaon S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "787055": {
    "state": "Assam",
    "district": "Lakhimpur",
    "block": "Dhakuakhana",
    "officename": "Dhakuakhana S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "787056": {
    "state": "Assam",
    "district": "Lakhimpur",
    "block": "Pathalipam",
    "officename": "Pathalipam S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "787057": {
    "state": "Assam",
    "district": "Dhemaji",
    "block": "Dhemaji",
    "officename": "Dhemaji S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "787058": {
    "state": "Assam",
    "district": "Dhemaji",
    "block": "Machkhowa",
    "officename": "Machkhowa S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "787059": {
    "state": "Assam",
    "district": "Dhemaji",
    "block": "Silapathar",
    "officename": "Silapathar S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "787060": {
    "state": "Assam",
    "district": "Dhemaji",
    "block": "Jonai",
    "officename": "Jonai S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "787061": {
    "state": "Assam",
    "district": "Dhemaji",
    "block": "Simen Chapori",
    "officename": "Simen Chapori S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "787110": {
    "state": "Assam",
    "district": "Dhemaji",
    "block": "Sissiborgaon",
    "officename": "Sissiborgaon S.O",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Dibrugarh Division"
  },
  "788001": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Silchar H.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788002": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Malugram S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788003": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Tarapur S.O (Cachar",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788004": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "G C College S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788005": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Rangirkhari S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788006": {
    "state": "Assam",
    "district": "Karimganj",
    "block": "Karimganj",
    "officename": "Link Road S.O (Cachar",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788007": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Vivekananda Road S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788009": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Rongpur S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788010": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Silchar REC S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788011": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Assam University S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788013": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Sonabarighat S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788014": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Silchar Medical College S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788015": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Meherpur S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788025": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Arunachal S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788026": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Srikona S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788030": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Udarbond S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788031": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Salganga S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788098": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Pailapool S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788099": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Matinagar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788101": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Banskandi S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788102": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Dewan S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788103": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Lakhipur S.O (Cachar",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788104": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Jirighat S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788106": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Fulertal S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788107": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Joypur Rajabazar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788108": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Kumbhir S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788109": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Kumbhirgram Airport S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788110": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Borkhola S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788111": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Dalu",
    "officename": "Dalu S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788112": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Derby S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788113": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Dwarband S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788114": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Dholai Bazar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788115": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Narsingpur S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788116": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Palonghat S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788117": {
    "state": "Assam",
    "district": "Hailakandi",
    "block": "NA",
    "officename": "Barjalenga S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788118": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Silcuri S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788119": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Sonaimukh S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788120": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Bhaga Bazar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788121": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Kabuganj Bazar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788123": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Bekirpar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788126": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Binnakandi Ghat S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788127": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Jarailtala Bazar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788150": {
    "state": "Assam",
    "district": "Hailakandi",
    "block": "NA",
    "officename": "Kalibari Bazar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788151": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Hailakandi H.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788152": {
    "state": "Assam",
    "district": "Hailakandi",
    "block": "NA",
    "officename": "Lakshmisahar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788155": {
    "state": "Assam",
    "district": "Hailakandi",
    "block": "NA",
    "officename": "Ratanpur Road S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788156": {
    "state": "Assam",
    "district": "Hailakandi",
    "block": "NA",
    "officename": "Anilgarh S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788160": {
    "state": "Assam",
    "district": "Hailakandi",
    "block": "NA",
    "officename": "Jaffirband S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788161": {
    "state": "Assam",
    "district": "Hailakandi",
    "block": "NA",
    "officename": "Katlacherra S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788162": {
    "state": "Assam",
    "district": "Hailakandi",
    "block": "NA",
    "officename": "Jamira Bazar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788163": {
    "state": "Assam",
    "district": "Hailakandi",
    "block": "NA",
    "officename": "Lala S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788164": {
    "state": "Assam",
    "district": "Hailakandi",
    "block": "NA",
    "officename": "Monacherra S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788165": {
    "state": "Assam",
    "district": "Hailakandi",
    "block": "NA",
    "officename": "Manipur Bagan S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788166": {
    "state": "Assam",
    "district": "Karimganj",
    "block": "Karimanj",
    "officename": "Ramkrishnanagar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788168": {
    "state": "Assam",
    "district": "Hailakandi",
    "block": "NA",
    "officename": "Rajyeswarpur S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788701": {
    "state": "Assam",
    "district": "Karimganj",
    "block": "Karimanj",
    "officename": "Bhanga Bazaar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788709": {
    "state": "Assam",
    "district": "Karimganj",
    "block": "Karimanj",
    "officename": "Tillabazar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788710": {
    "state": "Assam",
    "district": "Karimganj",
    "block": "Karimanj",
    "officename": "Sribhumi HO",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788711": {
    "state": "Assam",
    "district": "Karimganj",
    "block": "Karimanj",
    "officename": "Sribhumi Bazar SO",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788712": {
    "state": "Assam",
    "district": "Karimganj",
    "block": "Karimanj",
    "officename": "Settlement Road S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788713": {
    "state": "Assam",
    "district": "Karimganj",
    "block": "Karimanj",
    "officename": "Silchar Road S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788719": {
    "state": "Assam",
    "district": "Karimganj",
    "block": "Karimanj",
    "officename": "Kayasthagram S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788720": {
    "state": "Assam",
    "district": "Karimganj",
    "block": "Karimanj",
    "officename": "Kaliganj Bazar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788722": {
    "state": "Assam",
    "district": "Karimganj",
    "block": "Karimanj",
    "officename": "Nilam Bazar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788723": {
    "state": "Assam",
    "district": "Karimganj",
    "block": "Karimanj",
    "officename": "Baraigram S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788724": {
    "state": "Assam",
    "district": "Karimganj",
    "block": "Karimanj",
    "officename": "Patharkandi S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788725": {
    "state": "Assam",
    "district": "Karimganj",
    "block": "Karimanj",
    "officename": "Chandkhira S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788726": {
    "state": "Assam",
    "district": "Karimganj",
    "block": "Karimanj",
    "officename": "Hatikhira S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788727": {
    "state": "Assam",
    "district": "Karimganj",
    "block": "Karimanj",
    "officename": "Bazaricherra Bazar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788728": {
    "state": "Assam",
    "district": "Karimganj",
    "block": "Karimanj",
    "officename": "Isabeel S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788733": {
    "state": "Assam",
    "district": "Karimganj",
    "block": "Karimanj",
    "officename": "BAZARGHAT B.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788734": {
    "state": "Assam",
    "district": "Hailakandi",
    "block": "NA",
    "officename": "Anipur S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788735": {
    "state": "Assam",
    "district": "Hailakandi",
    "block": "NA",
    "officename": "Ratabari S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788736": {
    "state": "Assam",
    "district": "Hailakandi",
    "block": "NA",
    "officename": "Dullabcherra S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788737": {
    "state": "Assam",
    "district": "Hailakandi",
    "block": "NA",
    "officename": "Olivacherra S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788781": {
    "state": "Assam",
    "district": "Karimganj",
    "block": "Karimanj",
    "officename": "Mahisashan S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788801": {
    "state": "Assam",
    "district": "Hailakandi",
    "block": "NA",
    "officename": "Kalinagar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788802": {
    "state": "Assam",
    "district": "Hailakandi",
    "block": "NA",
    "officename": "Panchgram S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788803": {
    "state": "Assam",
    "district": "Karimganj",
    "block": "Karimanj",
    "officename": "Badarpurghat S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788804": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Katirail S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788805": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Katigorah S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788806": {
    "state": "Assam",
    "district": "Karimganj",
    "block": "Karimanj",
    "officename": "Badarpur S.O (Karimganj",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788815": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Kalain S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788816": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Jalalpur S.O (Cachar",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788817": {
    "state": "Assam",
    "district": "Cachar",
    "block": "Silchar",
    "officename": "Behara Bazar S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788818": {
    "state": "Assam",
    "district": "North Cachar Hills",
    "block": "NA",
    "officename": "Harengajao S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788819": {
    "state": "Assam",
    "district": "North Cachar Hills",
    "block": "NA",
    "officename": "Haflong S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788820": {
    "state": "Assam",
    "district": "North Cachar Hills",
    "block": "NA",
    "officename": "Haflong Ptc S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788830": {
    "state": "Assam",
    "district": "North Cachar Hills",
    "block": "NA",
    "officename": "Mahur S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788831": {
    "state": "Assam",
    "district": "North Cachar Hills",
    "block": "NA",
    "officename": "Maibong S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788832": {
    "state": "Assam",
    "district": "North Cachar Hills",
    "block": "NA",
    "officename": "Langting S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "788931": {
    "state": "Assam",
    "district": "North Cachar Hills",
    "block": "NA",
    "officename": "Umrangshu S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "790001": {
    "state": "Arunachal Pradesh",
    "district": "West Kameng",
    "block": "Bomdila",
    "officename": "Bomdila S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "790002": {
    "state": "Arunachal Pradesh",
    "district": "West Kameng",
    "block": "Kalaktang",
    "officename": "Kalaktang S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "790003": {
    "state": "Arunachal Pradesh",
    "district": "West Kameng",
    "block": "Rupa",
    "officename": "Rupa S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "790101": {
    "state": "Arunachal Pradesh",
    "district": "West Kameng",
    "block": "Dirang",
    "officename": "Dirang S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "790102": {
    "state": "Arunachal Pradesh",
    "district": "East Kameng",
    "block": "Seppa",
    "officename": "Seppa S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "790103": {
    "state": "Arunachal Pradesh",
    "district": "East Kameng",
    "block": "Seijosa",
    "officename": "Seijosa S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "790104": {
    "state": "Arunachal Pradesh",
    "district": "Tawang",
    "block": "Tawang",
    "officename": "Tawang S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "790105": {
    "state": "Arunachal Pradesh",
    "district": "Tawang",
    "block": "Tang",
    "officename": "Jang S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "790106": {
    "state": "Arunachal Pradesh",
    "district": "Tawang",
    "block": "Lumla",
    "officename": "Lumla S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "790114": {
    "state": "Arunachal Pradesh",
    "district": "West Kameng",
    "block": "Bhalukpong",
    "officename": "Bhalukpong S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "790116": {
    "state": "Arunachal Pradesh",
    "district": "West Kameng",
    "block": "Tenga Market",
    "officename": "Tenga Market S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "791001": {
    "state": "Arunachal Pradesh",
    "district": "West Siang",
    "block": "Bordumsa Circle",
    "officename": "Along S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "791002": {
    "state": "Arunachal Pradesh",
    "district": "Upper Siang",
    "block": "Yingkiong",
    "officename": "Yingkiong S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "791003": {
    "state": "Arunachal Pradesh",
    "district": "West Siang",
    "block": "Mechuka",
    "officename": "Mechuka S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "791101": {
    "state": "Arunachal Pradesh",
    "district": "West Siang",
    "block": "Bame",
    "officename": "Basar S.O (West Siang)",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "791102": {
    "state": "Arunachal Pradesh",
    "district": "East Siang",
    "block": "Pasighat",
    "officename": "Pasighat S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "791103": {
    "state": "Arunachal Pradesh",
    "district": "East Siang",
    "block": "Pasighat",
    "officename": "Hill Top S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "791104": {
    "state": "Arunachal Pradesh",
    "district": "East Siang",
    "block": "Mebo",
    "officename": "Mebo S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "791105": {
    "state": "Arunachal Pradesh",
    "district": "Upper Siang",
    "block": "Tuting",
    "officename": "Tuting S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "791109": {
    "state": "Arunachal Pradesh",
    "district": "Papum Pare",
    "block": "Nirjuli",
    "officename": "Nirjuli S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "791110": {
    "state": "Arunachal Pradesh",
    "district": "Papum Pare",
    "block": "Naharlagun",
    "officename": "Naharlagun S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "791111": {
    "state": "Arunachal Pradesh",
    "district": "Papum Pare",
    "block": "Itanagar",
    "officename": "Itanagar H.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "791112": {
    "state": "Arunachal Pradesh",
    "district": "Papum Pare",
    "block": "Yupia",
    "officename": "Doimukh S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "791113": {
    "state": "Arunachal Pradesh",
    "district": "Lower Subansiri",
    "block": "Itanagar",
    "officename": "Ram Krishna Mission S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "791118": {
    "state": "Arunachal Pradesh",
    "district": "Kurung Kumey",
    "block": "Chambang",
    "officename": "Palin S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "791119": {
    "state": "Arunachal Pradesh",
    "district": "Papum Pare",
    "block": "Ziro",
    "officename": "Ranga Nadi Project S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "791120": {
    "state": "Arunachal Pradesh",
    "district": "Lower Subansiri",
    "block": "Ziro",
    "officename": "Ziro S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "791121": {
    "state": "Arunachal Pradesh",
    "district": "Papum Pare",
    "block": "Kimin",
    "officename": "Kimin S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "791122": {
    "state": "Arunachal Pradesh",
    "district": "Upper Subansiri",
    "block": "Daporijo",
    "officename": "Daporijo S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "791123": {
    "state": "Arunachal Pradesh",
    "district": "Papum Pare",
    "block": "Balijan",
    "officename": "Banderdewa S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "791125": {
    "state": "Arunachal Pradesh",
    "district": "West Siang",
    "block": "Likabali",
    "officename": "Likabali S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "792001": {
    "state": "Arunachal Pradesh",
    "district": "Lohit",
    "block": "Tezu",
    "officename": "Tezu S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "792055": {
    "state": "Arunachal Pradesh",
    "district": "Changlang",
    "block": "Vijoynagar",
    "officename": "Two-hat B.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "792056": {
    "state": "Arunachal Pradesh",
    "district": "Changlang",
    "block": "Bordumsa",
    "officename": "Bordumsa S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "792101": {
    "state": "Arunachal Pradesh",
    "district": "Dibang Valley",
    "block": "Alinye",
    "officename": "Anini S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "792102": {
    "state": "Arunachal Pradesh",
    "district": "Lohit",
    "block": "Chowkham",
    "officename": "Chowkham S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "792103": {
    "state": "Arunachal Pradesh",
    "district": "Lohit",
    "block": "Namsai",
    "officename": "Namsai S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "792104": {
    "state": "Arunachal Pradesh",
    "district": "Papum Pare",
    "block": "Hayuliang",
    "officename": "Hayuliang S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "792105": {
    "state": "Arunachal Pradesh",
    "district": "Lohit",
    "block": "Mahadevpur",
    "officename": "Mahadevpur S.O (Lohit)",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "792110": {
    "state": "Arunachal Pradesh",
    "district": "Lower Dibang Valley",
    "block": "Roing",
    "officename": "Roing S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "792111": {
    "state": "Arunachal Pradesh",
    "district": "Lohit",
    "block": "Sunpura",
    "officename": "Sunpura S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "792120": {
    "state": "Arunachal Pradesh",
    "district": "Changlang",
    "block": "Bubang",
    "officename": "Changlang S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "792121": {
    "state": "Arunachal Pradesh",
    "district": "Changlang",
    "block": "Jairampur",
    "officename": "Jairampur S.O (Changlang)",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "792122": {
    "state": "Arunachal Pradesh",
    "district": "Changlang",
    "block": "Miao",
    "officename": "Miao S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "792123": {
    "state": "Arunachal Pradesh",
    "district": "Changlang",
    "block": "Nampong",
    "officename": "Nampong S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "792129": {
    "state": "Arunachal Pradesh",
    "district": "Tirap",
    "block": "Deomali",
    "officename": "Deomali S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "792130": {
    "state": "Arunachal Pradesh",
    "district": "Tirap",
    "block": "Khonsa",
    "officename": "Khonsa S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "792131": {
    "state": "Arunachal Pradesh",
    "district": "Tirap",
    "block": "Longding",
    "officename": "Longding S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "793001": {
    "state": "Meghalaya",
    "district": "East Khasi Hills",
    "block": "Shillong",
    "officename": "Shillong G.P.O.",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793002": {
    "state": "Meghalaya",
    "district": "East Khasi Hills",
    "block": "Shillong",
    "officename": "Iewduh S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793003": {
    "state": "Meghalaya",
    "district": "East Khasi Hills",
    "block": "Shillong",
    "officename": "Laitumkhrah S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793004": {
    "state": "Meghalaya",
    "district": "East Khasi Hills",
    "block": "Shillong",
    "officename": "Laban S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793005": {
    "state": "Meghalaya",
    "district": "East Khasi Hills",
    "block": "Upper Shillong",
    "officename": "Upper Shillong S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793006": {
    "state": "Meghalaya",
    "district": "East Khasi Hills",
    "block": "Shillong",
    "officename": "Rynjah S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793007": {
    "state": "Meghalaya",
    "district": "East Khasi Hills",
    "block": "Shillong",
    "officename": "Happy Valley S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793008": {
    "state": "Meghalaya",
    "district": "East Khasi Hills",
    "block": "Mawlai",
    "officename": "Phudmawri S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793009": {
    "state": "Meghalaya",
    "district": "East Khasi Hills",
    "block": "Nonglyer",
    "officename": "Nonglyer S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793010": {
    "state": "Meghalaya",
    "district": "East Khasi Hills",
    "block": "Laitkor Peak",
    "officename": "Laitkor Peak S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793011": {
    "state": "Meghalaya",
    "district": "East Khasi Hills",
    "block": "Shillong",
    "officename": "Assam Rifles S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793012": {
    "state": "Meghalaya",
    "district": "East Khasi Hills",
    "block": "Mawpat",
    "officename": "Mawpat S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793014": {
    "state": "Meghalaya",
    "district": "East Khasi Hills",
    "block": "Shillong",
    "officename": "Nongthymmai S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793015": {
    "state": "Meghalaya",
    "district": "East Khasi Hills",
    "block": "Smit",
    "officename": "Smit S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793016": {
    "state": "Meghalaya",
    "district": "East Khasi Hills",
    "block": "Shillong",
    "officename": "Mawiong S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793017": {
    "state": "Meghalaya",
    "district": "East Khasi Hills",
    "block": "Shillong",
    "officename": "Mawlai S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793018": {
    "state": "Meghalaya",
    "district": "East Khasi Hills",
    "block": "NA",
    "officename": "Neigrihms S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793019": {
    "state": "Meghalaya",
    "district": "East Khasi Hills",
    "block": "Shillong",
    "officename": "Nongmynsong S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793021": {
    "state": "Meghalaya",
    "district": "East Khasi Hills",
    "block": "Madanriting",
    "officename": "Madanriting S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793022": {
    "state": "Meghalaya",
    "district": "East Khasi Hills",
    "block": "Mawlai",
    "officename": "Nehu S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793101": {
    "state": "Meghalaya",
    "district": "Ri Bhoi",
    "block": "Byrnihat",
    "officename": "Byrnihat S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793102": {
    "state": "Meghalaya",
    "district": "Ri Bhoi",
    "block": "Nongpoh",
    "officename": "Nongpoh S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793103": {
    "state": "Meghalaya",
    "district": "Ri Bhoi",
    "block": "Umiam",
    "officename": "Umiam S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793104": {
    "state": "Meghalaya",
    "district": "Ri Bhoi",
    "block": "Sumer",
    "officename": "Sumer S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793105": {
    "state": "Meghalaya",
    "district": "Ri Bhoi",
    "block": "Umsning",
    "officename": "Umsning S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793106": {
    "state": "Meghalaya",
    "district": "East Khasi Hills",
    "block": "Balat",
    "officename": "Balat S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793107": {
    "state": "Meghalaya",
    "district": "East Khasi Hills",
    "block": "Bholaganj Bazar",
    "officename": "Bholaganj Bazar S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793108": {
    "state": "Meghalaya",
    "district": "East Khasi Hills",
    "block": "Cherrapunjee",
    "officename": "Cherrapunjee S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793109": {
    "state": "Meghalaya",
    "district": "Jaintia Hills",
    "block": "Amlarem",
    "officename": "Dawki S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793110": {
    "state": "Meghalaya",
    "district": "East Khasi Hills",
    "block": "Pynursla",
    "officename": "Pynursla S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793111": {
    "state": "Meghalaya",
    "district": "East Khasi Hills",
    "block": "Cherrabazar",
    "officename": "Ladmawphlang B.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793112": {
    "state": "Meghalaya",
    "district": "East Khasi Hills",
    "block": "Shella",
    "officename": "Shella S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793113": {
    "state": "Meghalaya",
    "district": "East Khasi Hills",
    "block": "Mawsynram",
    "officename": "Mawsynram S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793114": {
    "state": "Meghalaya",
    "district": "West Khasi Hills",
    "block": "Mawkyrwat",
    "officename": "Mawkyrwat S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793115": {
    "state": "Meghalaya",
    "district": "West Khasi Hills",
    "block": "NA",
    "officename": "Sohiong S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793119": {
    "state": "Meghalaya",
    "district": "West Khasi Hills",
    "block": "Nongstoin",
    "officename": "Nongstoin S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793120": {
    "state": "Meghalaya",
    "district": "West Khasi Hills",
    "block": "Mairang",
    "officename": "Mairang S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793121": {
    "state": "Meghalaya",
    "district": "East Khasi Hills",
    "block": "Mawphlang",
    "officename": "Mawphlang S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793122": {
    "state": "Meghalaya",
    "district": "Ri Bhoi",
    "block": "Ucc",
    "officename": "Ucc S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793123": {
    "state": "Meghalaya",
    "district": "Ri Bhoi",
    "block": "Umsaw",
    "officename": "Umsaw S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793150": {
    "state": "Meghalaya",
    "district": "Jaintia Hills",
    "block": "Jowai",
    "officename": "Jowai MDG",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793151": {
    "state": "Meghalaya",
    "district": "Jaintia Hills",
    "block": "Thadlaskein",
    "officename": "Thadlaskein S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793160": {
    "state": "Meghalaya",
    "district": "Jaintia Hills",
    "block": "Ladrymbai",
    "officename": "Ladrymbai S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793200": {
    "state": "Meghalaya",
    "district": "Jaintia Hills",
    "block": "Khliehriat",
    "officename": "Khliehriat S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793210": {
    "state": "Meghalaya",
    "district": "Jaintia Hills",
    "block": "NA",
    "officename": "Lumshnong S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "794001": {
    "state": "Meghalaya",
    "district": "West Garo Hills",
    "block": "Tura",
    "officename": "Tura H.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "794002": {
    "state": "Meghalaya",
    "district": "West Garo Hills",
    "block": "Lower Chandmari",
    "officename": "Lower Chandmari S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "794003": {
    "state": "Meghalaya",
    "district": "West Garo Hills",
    "block": "NA",
    "officename": "Dadenggre S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "794005": {
    "state": "Meghalaya",
    "district": "West Garo Hills",
    "block": "Dobasipara",
    "officename": "Dobasipara S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "794101": {
    "state": "Meghalaya",
    "district": "West Garo Hills",
    "block": "Araimile",
    "officename": "Araimile S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "794102": {
    "state": "Meghalaya",
    "district": "South Garo Hills",
    "block": "Baghmara",
    "officename": "Baghmara S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "794103": {
    "state": "Meghalaya",
    "district": "West Garo Hills",
    "block": "Barengapara",
    "officename": "Barengapara S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "794104": {
    "state": "Meghalaya",
    "district": "West Garo Hills",
    "block": "Fulbari",
    "officename": "Fulbari S.O (West Garo Hills)",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "794105": {
    "state": "Meghalaya",
    "district": "West Garo Hills",
    "block": "Garobadha",
    "officename": "Garobadha S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "794106": {
    "state": "Meghalaya",
    "district": "West Garo Hills",
    "block": "Mahendraganj",
    "officename": "Mahendraganj S.O (West Garo Hills)",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "794107": {
    "state": "Meghalaya",
    "district": "East Garo Hills",
    "block": "Nangwalbibra",
    "officename": "Nangwalbibra S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "794108": {
    "state": "Meghalaya",
    "district": "East Garo Hills",
    "block": "Resubelpara",
    "officename": "Resubelpara S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "794109": {
    "state": "Meghalaya",
    "district": "West Garo Hills",
    "block": "Tikrikilla",
    "officename": "Tikrikilla S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "794110": {
    "state": "Meghalaya",
    "district": "East Garo Hills",
    "block": "Rongjeng",
    "officename": "Rongjeng S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "794111": {
    "state": "Meghalaya",
    "district": "East Garo Hills",
    "block": "Williamnagar",
    "officename": "Williamnagar S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "794112": {
    "state": "Meghalaya",
    "district": "West Garo Hills",
    "block": "Mendipathar",
    "officename": "Mendipathar S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "794114": {
    "state": "Meghalaya",
    "district": "South Garo Hills",
    "block": "Rongra",
    "officename": "Rongra S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "794115": {
    "state": "Meghalaya",
    "district": "West Garo Hills",
    "block": "Ampati",
    "officename": "Ampati S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "795001": {
    "state": "Manipur",
    "district": "Imphal West",
    "block": "Nil",
    "officename": "Imphal H.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795002": {
    "state": "Manipur",
    "district": "Imphal West",
    "block": "Nil",
    "officename": "Mantripukhri S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795003": {
    "state": "Manipur",
    "district": "Imphal West",
    "block": "Nil",
    "officename": "Manipur University S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795004": {
    "state": "Manipur",
    "district": "Imphal West",
    "block": "Nil",
    "officename": "Lamphelpat S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795005": {
    "state": "Manipur",
    "district": "Imphal East",
    "block": "Nil",
    "officename": "Porompat S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795006": {
    "state": "Manipur",
    "district": "Churachandpur",
    "block": "Churachandpur",
    "officename": "New Lamka S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795007": {
    "state": "Manipur",
    "district": "Senapati",
    "block": "Nil",
    "officename": "Karong S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795008": {
    "state": "Manipur",
    "district": "Imphal East",
    "block": "Nil",
    "officename": "Singjamei S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795009": {
    "state": "Manipur",
    "district": "Imphal West",
    "block": "Nil;",
    "officename": "Wangoi S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795010": {
    "state": "Manipur",
    "district": "Imphal East",
    "block": "Nil",
    "officename": "Lamlong S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795015": {
    "state": "Manipur",
    "district": "Senapati",
    "block": "Nil",
    "officename": "Koide B.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795101": {
    "state": "Manipur",
    "district": "Thoubal",
    "block": "Nil",
    "officename": "Sugnu S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795102": {
    "state": "Manipur",
    "district": "Chandel",
    "block": "Nil",
    "officename": "Chakpikarong S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795103": {
    "state": "Manipur",
    "district": "Thoubal",
    "block": "Nil",
    "officename": "Kakching S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795104": {
    "state": "Manipur",
    "district": "Senapati",
    "block": "Nil",
    "officename": "Tadubi S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795106": {
    "state": "Manipur",
    "district": "Senapati",
    "block": "Nil",
    "officename": "Senapati S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795107": {
    "state": "Manipur",
    "district": "Senapati",
    "block": "Nil",
    "officename": "Motbung S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795112": {
    "state": "Manipur",
    "district": "Senapati",
    "block": "Nil",
    "officename": "T Waichong S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795113": {
    "state": "Manipur",
    "district": "Imphal West",
    "block": "Nil",
    "officename": "CRPF Camp Langjing S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795114": {
    "state": "Manipur",
    "district": "Imphal East",
    "block": "Nil",
    "officename": "Pngaei Yangdong S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795115": {
    "state": "Manipur",
    "district": "Imphal West",
    "block": "Nil",
    "officename": "Gularthol S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795116": {
    "state": "Manipur",
    "district": "Imphal West",
    "block": "Nil",
    "officename": "Jiribam Bazar S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795117": {
    "state": "Manipur",
    "district": "Churachandpur",
    "block": "Nil",
    "officename": "Saikot S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795118": {
    "state": "Manipur",
    "district": "Senapati",
    "block": "Nil",
    "officename": "Saikul S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795122": {
    "state": "Manipur",
    "district": "Senapati",
    "block": "Nil",
    "officename": "Kalapahar S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795124": {
    "state": "Manipur",
    "district": "Bishnupur",
    "block": "Nil",
    "officename": "Loktak Project S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795125": {
    "state": "Manipur",
    "district": "Tamenglong",
    "block": "Nil",
    "officename": "Tamei S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795126": {
    "state": "Manipur",
    "district": "Bishnupur",
    "block": "Nil",
    "officename": "Bishnupur S.O (Bishnupur)",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795127": {
    "state": "Manipur",
    "district": "Chandel",
    "block": "Nil",
    "officename": "Chandel S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795128": {
    "state": "Manipur",
    "district": "Churachandpur",
    "block": "Nil",
    "officename": "Churachandpur S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795129": {
    "state": "Manipur",
    "district": "Senapati",
    "block": "Nil",
    "officename": "Kangpokpi S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795130": {
    "state": "Manipur",
    "district": "Thoubal",
    "block": "Nil",
    "officename": "Lilong S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795131": {
    "state": "Manipur",
    "district": "Chandel",
    "block": "Nil",
    "officename": "Moreh S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795132": {
    "state": "Manipur",
    "district": "Imphal West",
    "block": "Nil",
    "officename": "Mayang Imphal S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795133": {
    "state": "Manipur",
    "district": "Bishnupur",
    "block": "Nil",
    "officename": "Moirang S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795134": {
    "state": "Manipur",
    "district": "Bishnupur",
    "block": "Nil",
    "officename": "Nambol S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795135": {
    "state": "Manipur",
    "district": "Thoubal",
    "block": "Nil",
    "officename": "Pallel S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795136": {
    "state": "Manipur",
    "district": "Imphal West",
    "block": "Nil",
    "officename": "Sekmai S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795138": {
    "state": "Manipur",
    "district": "Thoubal",
    "block": "Nil",
    "officename": "Thoubal S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795139": {
    "state": "Manipur",
    "district": "Churachandpur",
    "block": "Nil",
    "officename": "Singhat S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795140": {
    "state": "Manipur",
    "district": "Imphal West",
    "block": "Nil",
    "officename": "Tulihal S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795141": {
    "state": "Manipur",
    "district": "Tamenglong",
    "block": "Nil",
    "officename": "Tamenglong S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795142": {
    "state": "Manipur",
    "district": "Ukhrul",
    "block": "Nil",
    "officename": "Ukhrul S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795143": {
    "state": "Manipur",
    "district": "Churachandpur",
    "block": "Nil",
    "officename": "Pamjal B.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795144": {
    "state": "Manipur",
    "district": "Ukhrul",
    "block": "Nil",
    "officename": "Somdal S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795145": {
    "state": "Manipur",
    "district": "Ukhrul",
    "block": "Nil",
    "officename": "Litan S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795146": {
    "state": "Manipur",
    "district": "Imphal West",
    "block": "Nil",
    "officename": "Lamsang S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795147": {
    "state": "Manipur",
    "district": "Tamenglong",
    "block": "Nil",
    "officename": "Nungba S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795148": {
    "state": "Manipur",
    "district": "Thoubal",
    "block": "Nil",
    "officename": "Wangjing S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795149": {
    "state": "Manipur",
    "district": "Thoubal",
    "block": "Nil;",
    "officename": "Yairipok S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795150": {
    "state": "Manipur",
    "district": "Senapati",
    "block": "Nil",
    "officename": "Mao S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795159": {
    "state": "Manipur",
    "district": "Tamenglong",
    "block": "Nil",
    "officename": "None S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "796001": {
    "state": "Mizoram",
    "district": "Aizawl",
    "block": "Tlangnuam (Part)",
    "officename": "Aizawl H.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796004": {
    "state": "Mizoram",
    "district": "Aizawl",
    "block": "Tlangnuam (Part)",
    "officename": "Mizoram University S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796005": {
    "state": "Mizoram",
    "district": "Aizawl",
    "block": "Tlangnuam (Part)",
    "officename": "Kulikawn S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796007": {
    "state": "Mizoram",
    "district": "Aizawl",
    "block": "Tlangnuam (Part)",
    "officename": "Chandmary S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796008": {
    "state": "Mizoram",
    "district": "Aizawl",
    "block": "Tlangnuam",
    "officename": "Armed Veng S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796009": {
    "state": "Mizoram",
    "district": "Aizawl",
    "block": "Tlangnuam (Part)",
    "officename": "Vaivakawn S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796012": {
    "state": "Mizoram",
    "district": "Aizawl",
    "block": "Tlangnuam (Part)",
    "officename": "Ramhlun S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796014": {
    "state": "Mizoram",
    "district": "Aizawl",
    "block": "Tlangnuam (Part)",
    "officename": "Bawngkawn S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796017": {
    "state": "Mizoram",
    "district": "Aizawl",
    "block": "Thingsulthliah (Part)",
    "officename": "Zemabawk S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796070": {
    "state": "Mizoram",
    "district": "Kolasib",
    "block": "North Thingdawl",
    "officename": "Kawnpui S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796081": {
    "state": "Mizoram",
    "district": "Kolasib",
    "block": "North Thingdawl",
    "officename": "Kolasib S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796091": {
    "state": "Mizoram",
    "district": "Kolasib",
    "block": "Bilkhawthlir",
    "officename": "Bilkhawthlir S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796101": {
    "state": "Mizoram",
    "district": "Kolasib",
    "block": "Vairengte",
    "officename": "Vairengte S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796111": {
    "state": "Mizoram",
    "district": "Aizawl",
    "block": "Darlawn",
    "officename": "Darlawn S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796161": {
    "state": "Mizoram",
    "district": "Aizawl",
    "block": "Thingsulthliah",
    "officename": "Thingsulthliah S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796181": {
    "state": "Mizoram",
    "district": "Serchhip",
    "block": "Serchhip",
    "officename": "Serchhip S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796184": {
    "state": "Mizoram",
    "district": "Serchhip",
    "block": "E. Lungdar",
    "officename": "N. Vanlaiphai S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796186": {
    "state": "Mizoram",
    "district": "Serchhip",
    "block": "Serchhip",
    "officename": "Thenzawl S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796190": {
    "state": "Mizoram",
    "district": "Aizawl",
    "block": "Aibawk",
    "officename": "Aibawk S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796261": {
    "state": "Mizoram",
    "district": "Aizawl",
    "block": "Saitual",
    "officename": "Saitual S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796290": {
    "state": "Mizoram",
    "district": "Champhai",
    "block": "Ngopa",
    "officename": "Ngopa S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796310": {
    "state": "Mizoram",
    "district": "Champhai",
    "block": "Khawzawl",
    "officename": "Khawzawl S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796320": {
    "state": "Mizoram",
    "district": "Champhai",
    "block": "S.khawbung",
    "officename": "S.Khawbung S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796321": {
    "state": "Mizoram",
    "district": "Champhai",
    "block": "Khawbung",
    "officename": "Champhai S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796370": {
    "state": "Mizoram",
    "district": "Champhai",
    "block": "East Lungdar (Part)",
    "officename": "Lungdar S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796410": {
    "state": "Mizoram",
    "district": "Mammit",
    "block": "Sairang",
    "officename": "Sairang S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796421": {
    "state": "Mizoram",
    "district": "Mammit",
    "block": "Sairang",
    "officename": "Lengpui Airport S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796431": {
    "state": "Mizoram",
    "district": "Mammit",
    "block": "Phaileng",
    "officename": "Phaileng S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796441": {
    "state": "Mizoram",
    "district": "Mammit",
    "block": "Mamit",
    "officename": "Mamit S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796501": {
    "state": "Mizoram",
    "district": "Mammit",
    "block": "Reiek",
    "officename": "Reiek S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796571": {
    "state": "Mizoram",
    "district": "Lunglei",
    "block": "Hnahthial",
    "officename": "Hnahthial S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796691": {
    "state": "Mizoram",
    "district": "Lunglei",
    "block": "Zotlang",
    "officename": "Zotlang S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796701": {
    "state": "Mizoram",
    "district": "Lunglei",
    "block": "Lunglei",
    "officename": "Lunglei M.D.G",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796710": {
    "state": "Mizoram",
    "district": "Lunglei",
    "block": "West Bunghmun",
    "officename": "Laisawral B.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796751": {
    "state": "Mizoram",
    "district": "Lunglei",
    "block": "Lunglei",
    "officename": "Tlabung S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796770": {
    "state": "Mizoram",
    "district": "Lunglei",
    "block": "Chawngte",
    "officename": "Chawngte S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796891": {
    "state": "Mizoram",
    "district": "Lawngtlai",
    "block": "Lawngtlai",
    "officename": "Lawngtlai S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796901": {
    "state": "Mizoram",
    "district": "Saiha",
    "block": "Tuipang",
    "officename": "Saiha S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "797001": {
    "state": "Nagaland",
    "district": "Kohima",
    "block": "Kohima",
    "officename": "Kohima H.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "797002": {
    "state": "Nagaland",
    "district": "Kohima",
    "block": "Kohima Science College",
    "officename": "Kohima Science College S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "797003": {
    "state": "Nagaland",
    "district": "Kohima",
    "block": "Kohima Village",
    "officename": "Kohima Village S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "797004": {
    "state": "Nagaland",
    "district": "Kohima",
    "block": "New Sectt Complex",
    "officename": "New Sectt Complex S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "797099": {
    "state": "Nagaland",
    "district": "Wokha",
    "block": "Bhandari",
    "officename": "Bhandari S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "797101": {
    "state": "Nagaland",
    "district": "Peren",
    "block": "Peren",
    "officename": "Peren S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "797103": {
    "state": "Nagaland",
    "district": "Dimapur",
    "block": "Dimapur",
    "officename": "Chumukedima S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "797104": {
    "state": "Nagaland",
    "district": "Phek",
    "block": "Chozuba",
    "officename": "Chozuba S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "797105": {
    "state": "Nagaland",
    "district": "Kohima",
    "block": "Chiechama",
    "officename": "Chiechama S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "797106": {
    "state": "Nagaland",
    "district": "Dimapur",
    "block": "Medziphema",
    "officename": "Medziphema S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "797107": {
    "state": "Nagaland",
    "district": "Phek",
    "block": "Pfutsero",
    "officename": "Pfutsero S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "797108": {
    "state": "Nagaland",
    "district": "Phek",
    "block": "Phek",
    "officename": "Phek S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "797109": {
    "state": "Nagaland",
    "district": "Kohima",
    "block": "Tseminyu",
    "officename": "Tseminyu S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "797110": {
    "state": "Nagaland",
    "district": "Peren",
    "block": "Zalukie",
    "officename": "Zalukie S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "797111": {
    "state": "Nagaland",
    "district": "Wokha",
    "block": "Doyang H Project",
    "officename": "Wokha S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "797112": {
    "state": "Nagaland",
    "district": "Dimapur",
    "block": "Dimapur",
    "officename": "Dimapur S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "797113": {
    "state": "Nagaland",
    "district": "Dimapur",
    "block": "Dimapur Sadar",
    "officename": "New Nepaligaon S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "797114": {
    "state": "Nagaland",
    "district": "Phek",
    "block": "Meluri",
    "officename": "Meluri S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "797115": {
    "state": "Nagaland",
    "district": "Dimapur",
    "block": "Artc",
    "officename": "Artc S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "797116": {
    "state": "Nagaland",
    "district": "Dimapur",
    "block": "Chumukedima",
    "officename": "Dimapur Bazar S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "797117": {
    "state": "Nagaland",
    "district": "Dimapur",
    "block": "Dimapur Sadar",
    "officename": "Circular Road S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "797118": {
    "state": "Nagaland",
    "district": "Dimapur",
    "block": "Dimapur",
    "officename": "Signal Village",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "797120": {
    "state": "Nagaland",
    "district": "Kohima",
    "block": "kohima",
    "officename": "P.R Hill S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "797121": {
    "state": "Nagaland",
    "district": "Kohima",
    "block": "Kohima Sadar",
    "officename": "Monkhola S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "798601": {
    "state": "Nagaland",
    "district": "Mokokchung",
    "block": "Mokokchung",
    "officename": "Mokokchung S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "798602": {
    "state": "Nagaland",
    "district": "Mon",
    "block": "Tizit",
    "officename": "Tizit S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "798603": {
    "state": "Nagaland",
    "district": "Mon",
    "block": "Champang",
    "officename": "Champang S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "798604": {
    "state": "Nagaland",
    "district": "Mokokchung",
    "block": "Mongkholemba",
    "officename": "Mongkholemba S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "798611": {
    "state": "Nagaland",
    "district": "Kiphire",
    "block": "Kiphire",
    "officename": "Kiphire S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "798612": {
    "state": "Nagaland",
    "district": "Tuensang",
    "block": "Tuensang",
    "officename": "Tuensang S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "798613": {
    "state": "Nagaland",
    "district": "Mokokchung",
    "block": "Changtongya",
    "officename": "Chantongia S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "798614": {
    "state": "Nagaland",
    "district": "Mokokchung",
    "block": "Mokokchung",
    "officename": "Chuchuyimlang S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "798615": {
    "state": "Nagaland",
    "district": "Mokokchung",
    "block": "Mokokchung",
    "officename": "Impur S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "798616": {
    "state": "Nagaland",
    "district": "Tuensang",
    "block": "Longkhim",
    "officename": "Longkhim S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "798617": {
    "state": "Nagaland",
    "district": "Mokokchung",
    "block": "Ongpang Kong",
    "officename": "Pungro",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "798618": {
    "state": "Nagaland",
    "district": "Mokokchung",
    "block": "Changtongya",
    "officename": "Tuli S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "798620": {
    "state": "Nagaland",
    "district": "Zunhebotto",
    "block": "Aghunato",
    "officename": "Zunheboto S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "798621": {
    "state": "Nagaland",
    "district": "Mon",
    "block": "Mon",
    "officename": "Mon S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "798622": {
    "state": "Nagaland",
    "district": "Mon",
    "block": "Naginimora",
    "officename": "Naginimora S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "798623": {
    "state": "Nagaland",
    "district": "Mokokchung",
    "block": "Tuli",
    "officename": "Paper Nagar S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "798625": {
    "state": "Nagaland",
    "district": "Longleng",
    "block": "Longleng",
    "officename": "Longleng S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "798626": {
    "state": "Nagaland",
    "district": "Tuensang",
    "block": "Noklak",
    "officename": "Noklak SO",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "798627": {
    "state": "Nagaland",
    "district": "Zunhebotto",
    "block": "Akuluto",
    "officename": "Lumami S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "799001": {
    "state": "Tripura",
    "district": "West Tripura",
    "block": "Sadar",
    "officename": "Agartala H.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799002": {
    "state": "Tripura",
    "district": "West Tripura",
    "block": "Sadar",
    "officename": "Ramnagar S.O (West Tripura)",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799003": {
    "state": "Tripura",
    "district": "West Tripura",
    "block": "Sadar",
    "officename": "Arundhutinagar S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799004": {
    "state": "Tripura",
    "district": "West Tripura",
    "block": "Sadar",
    "officename": "Agartala College S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799005": {
    "state": "Tripura",
    "district": "West Tripura",
    "block": "Sadar",
    "officename": "Abhoynagar S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799006": {
    "state": "Tripura",
    "district": "West Tripura",
    "block": "Sadar",
    "officename": "Kunjaban S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799007": {
    "state": "Tripura",
    "district": "West Tripura",
    "block": "Sadar",
    "officename": "Dhaleswar S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799008": {
    "state": "Tripura",
    "district": "West Tripura",
    "block": "Khayerpur",
    "officename": "Khayerpur S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799009": {
    "state": "Tripura",
    "district": "West Tripura",
    "block": "Mohanpur",
    "officename": "Agartala Aerodrome S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799010": {
    "state": "Tripura",
    "district": "West Tripura",
    "block": "Sadar",
    "officename": "Agartala Secretariat S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799012": {
    "state": "Tripura",
    "district": "West Tripura",
    "block": "Sadar",
    "officename": "Salbagan S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799013": {
    "state": "Tripura",
    "district": "South Tripura",
    "block": "Udaipur",
    "officename": "Matabari S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799014": {
    "state": "Tripura",
    "district": "West Tripura",
    "block": "Sadar",
    "officename": "Agartala ONGC S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799015": {
    "state": "Tripura",
    "district": "West Tripura",
    "block": "Sadar",
    "officename": "Narayanpur Bazar SO",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799022": {
    "state": "Tripura",
    "district": "West Tripura",
    "block": "Bishalgarh",
    "officename": "Tripura University S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799035": {
    "state": "Tripura",
    "district": "West Tripura",
    "block": "Ranirbazar",
    "officename": "Ranirbazar S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799045": {
    "state": "Tripura",
    "district": "West Tripura",
    "block": "Birendranagar",
    "officename": "Birendranagar S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799046": {
    "state": "Tripura",
    "district": "West Tripura",
    "block": "Jirania",
    "officename": "NIT Agartala S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799101": {
    "state": "Tripura",
    "district": "South Tripura",
    "block": "Amarpur",
    "officename": "Amarpur S.O (South Tripura)",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799102": {
    "state": "Tripura",
    "district": "West Tripura",
    "block": "Bishalgarh",
    "officename": "Bishalgarh S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799103": {
    "state": "Tripura",
    "district": "West Tripura",
    "block": "Bishramganj",
    "officename": "Bishramganj S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799104": {
    "state": "Tripura",
    "district": "South Tripura",
    "block": "Jatanbari",
    "officename": "Jatanbari S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799105": {
    "state": "Tripura",
    "district": "South Tripura",
    "block": "Kakranan",
    "officename": "Kakraban S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799114": {
    "state": "Tripura",
    "district": "South Tripura",
    "block": "Bagma",
    "officename": "Gakulpur S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799115": {
    "state": "Tripura",
    "district": "South Tripura",
    "block": "Melaghar",
    "officename": "Melaghar S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799120": {
    "state": "Tripura",
    "district": "South Tripura",
    "block": "Radhakishorepur",
    "officename": "Radhakishorepur H.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799125": {
    "state": "Tripura",
    "district": "South Tripura",
    "block": "Garjee",
    "officename": "Garjee S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799130": {
    "state": "Tripura",
    "district": "West Tripura",
    "block": "Sekerkote",
    "officename": "Sekerkote S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799131": {
    "state": "Tripura",
    "district": "West Tripura",
    "block": "Sonamura",
    "officename": "Sonamura S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799141": {
    "state": "Tripura",
    "district": "South Tripura",
    "block": "Udaipur",
    "officename": "Jolaibari S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799142": {
    "state": "Tripura",
    "district": "South Tripura",
    "block": "Muhuripur",
    "officename": "Muhuripur S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799143": {
    "state": "Tripura",
    "district": "South Tripura",
    "block": "Manubazar",
    "officename": "Manubazar S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799144": {
    "state": "Tripura",
    "district": "South Tripura",
    "block": "Santirbazar",
    "officename": "Santirbazar S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799145": {
    "state": "Tripura",
    "district": "South Tripura",
    "block": "Sabroom",
    "officename": "Sabroom S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799150": {
    "state": "Tripura",
    "district": "South Tripura",
    "block": "Rajnagar",
    "officename": "Rajnagar S.O (South Tripura)",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799153": {
    "state": "Tripura",
    "district": "West Tripura",
    "block": "Radhanagar",
    "officename": "Radhanagar S.O (West Tripura)",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799155": {
    "state": "Tripura",
    "district": "South Tripura",
    "block": "Udaipur",
    "officename": "Beloniya S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799156": {
    "state": "Tripura",
    "district": "South Tripura",
    "block": "Hrishyamukh",
    "officename": "Hrishyamukh S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799157": {
    "state": "Tripura",
    "district": "South Tripura",
    "block": "Udaipur",
    "officename": "Anandapur S.O (South Tripura)",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799201": {
    "state": "Tripura",
    "district": "West Tripura",
    "block": "Paschim Sonatala",
    "officename": "Khowai S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Dharmanagar Division"
  },
  "799202": {
    "state": "Tripura",
    "district": "West Tripura",
    "block": "Khowai",
    "officename": "Khowai Court S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Dharmanagar Division"
  },
  "799203": {
    "state": "Tripura",
    "district": "West Tripura",
    "block": "Baramaidan",
    "officename": "Kalyanpur S.O (West Tripura)",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Dharmanagar Division"
  },
  "799204": {
    "state": "Tripura",
    "district": "Dhalai",
    "block": "Balaram",
    "officename": "Kulaibazar S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Dharmanagar Division"
  },
  "799205": {
    "state": "Tripura",
    "district": "West Tripura",
    "block": "Teliamura",
    "officename": "Teliamura S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Dharmanagar Division"
  },
  "799207": {
    "state": "Tripura",
    "district": "West Tripura",
    "block": "Dakshin Padmabil",
    "officename": "Chebri S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Dharmanagar Division"
  },
  "799210": {
    "state": "Tripura",
    "district": "West Tripura",
    "block": "Kamalghat",
    "officename": "Kamalghat S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799211": {
    "state": "Tripura",
    "district": "West Tripura",
    "block": "Mohanpur",
    "officename": "Mohanpur S.O (West Tripura)",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799212": {
    "state": "Tripura",
    "district": "West Tripura",
    "block": "Sidhai",
    "officename": "Sidhai S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799250": {
    "state": "Tripura",
    "district": "North Tripura",
    "block": "Dharmanagar",
    "officename": "Dharmanagar H.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Dharmanagar Division"
  },
  "799251": {
    "state": "Tripura",
    "district": "North Tripura",
    "block": "Bishnupur",
    "officename": "Chandrapur S.O (North Tripura)",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Dharmanagar Division"
  },
  "799253": {
    "state": "Tripura",
    "district": "North Tripura",
    "block": "Baruakandi",
    "officename": "Rajbari S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Dharmanagar Division"
  },
  "799254": {
    "state": "Tripura",
    "district": "North Tripura",
    "block": "Balidhum",
    "officename": "Halflongcherra S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Dharmanagar Division"
  },
  "799256": {
    "state": "Tripura",
    "district": "North Tripura",
    "block": "Kacharicherra",
    "officename": "Tripura Damcherra S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Dharmanagar Division"
  },
  "799260": {
    "state": "Tripura",
    "district": "North Tripura",
    "block": "Panisagar",
    "officename": "Panisagar S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Dharmanagar Division"
  },
  "799261": {
    "state": "Tripura",
    "district": "North Tripura",
    "block": "Saraspur",
    "officename": "Kadamtala S.O (North Tripura)",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Dharmanagar Division"
  },
  "799262": {
    "state": "Tripura",
    "district": "North Tripura",
    "block": "Balicherra",
    "officename": "Churaibari S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Dharmanagar Division"
  },
  "799263": {
    "state": "Tripura",
    "district": "North Tripura",
    "block": "Pecharthal",
    "officename": "Pecharthal S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Dharmanagar Division"
  },
  "799264": {
    "state": "Tripura",
    "district": "North Tripura",
    "block": "Sonaimuri",
    "officename": "Kumarghat S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Dharmanagar Division"
  },
  "799266": {
    "state": "Tripura",
    "district": "North Tripura",
    "block": "Betchesrra",
    "officename": "Kanchancherra",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Dharmanagar Division"
  },
  "799269": {
    "state": "Tripura",
    "district": "North Tripura",
    "block": "Bhangmun",
    "officename": "Jampui S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Dharmanagar Division"
  },
  "799270": {
    "state": "Tripura",
    "district": "North Tripura",
    "block": "Uttarlaljuri",
    "officename": "Kanchanpur S.O (North Tripura)",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Dharmanagar Division"
  },
  "799271": {
    "state": "Tripura",
    "district": "North Tripura",
    "block": "Anandabazar",
    "officename": "Dasdabazar S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Dharmanagar Division"
  },
  "799273": {
    "state": "Tripura",
    "district": "North Tripura",
    "block": "Lalcherra",
    "officename": "Chailengta S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Dharmanagar Division"
  },
  "799275": {
    "state": "Tripura",
    "district": "Dhalai",
    "block": "Demcherra",
    "officename": "Manughat S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Dharmanagar Division"
  },
  "799277": {
    "state": "Tripura",
    "district": "North Tripura",
    "block": "Samrurpar",
    "officename": "Kailashahar S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Dharmanagar Division"
  },
  "799278": {
    "state": "Tripura",
    "district": "Dhalai",
    "block": "Kachucherra",
    "officename": "Salema S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Dharmanagar Division"
  },
  "799279": {
    "state": "Tripura",
    "district": "North Tripura",
    "block": "Bhagabannagar",
    "officename": "Paiturbazar S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Dharmanagar Division"
  },
  "799280": {
    "state": "Tripura",
    "district": "North Tripura",
    "block": "Jalai",
    "officename": "Sonamukhi S.O (North Tripura)",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Dharmanagar Division"
  },
  "799281": {
    "state": "Tripura",
    "district": "North Tripura",
    "block": "Gournagar",
    "officename": "Baburbazar S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Dharmanagar Division"
  },
  "799284": {
    "state": "Tripura",
    "district": "Dhalai",
    "block": "Bhagirathpara",
    "officename": "Sarma S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Dharmanagar Division"
  },
  "799285": {
    "state": "Tripura",
    "district": "Dhalai",
    "block": "Bagaicherri",
    "officename": "Kamalpur S.O (Dhalai)",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Dharmanagar Division"
  },
  "799286": {
    "state": "Tripura",
    "district": "Dhalai",
    "block": "Abhanga",
    "officename": "Halahali S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Dharmanagar Division"
  },
  "799287": {
    "state": "Tripura",
    "district": "Dhalai",
    "block": "Salema",
    "officename": "Manikbhander S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Dharmanagar Division"
  },
  "799288": {
    "state": "Tripura",
    "district": "North Tripura",
    "block": "Demdun",
    "officename": "Kanchanbari S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Dharmanagar Division"
  },
  "799289": {
    "state": "Tripura",
    "district": "Dhalai",
    "block": "Ambassa",
    "officename": "Ambassa S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Dharmanagar Division"
  },
  "799290": {
    "state": "Tripura",
    "district": "North Tripura",
    "block": "West Rataceherra",
    "officename": "Fatikroy S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Dharmanagar Division"
  },
  "800001": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Phulwari",
    "officename": "Patna GPO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna GPO Division"
  },
  "800002": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Phulwari",
    "officename": "ANISABAD S.O",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "800003": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Phulwari",
    "officename": "Kadamkuan SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "800004": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Sampatchak",
    "officename": "Bankipore HO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "800005": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Sampatchak",
    "officename": "Patna University SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "800006": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Sampatchak",
    "officename": "Mahendru SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "800007": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Patna Sadar",
    "officename": "Gulzarbagh SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "PATNA SAHIB DIVISION"
  },
  "800008": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Sampatchak",
    "officename": "PATNA CITY SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "PATNA SAHIB DIVISION"
  },
  "800009": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Sampatchak",
    "officename": "BEGUMPUR SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "PATNA SAHIB DIVISION"
  },
  "800010": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Phulwari",
    "officename": "Sadaquat Ashram SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "800011": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Dinapur-Cum-Khagaul",
    "officename": "Dighaghat SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "800012": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Dinapur-Cum-Khagaul",
    "officename": "DIGHA S.O",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "800013": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Phulwari",
    "officename": "Patliputra SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "800014": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Phulwari",
    "officename": "BV College SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "800015": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Phulwari",
    "officename": "Patna Sectt SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "800016": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Patna Sadar",
    "officename": "Rajendra Nagar SO Patna",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "800017": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Phulwari",
    "officename": "BSEBOARD SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "800019": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Phulwari",
    "officename": "CDA SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "800020": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Sampatchak",
    "officename": "LOHIA NAGAR H.O",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "PATNA SAHIB DIVISION"
  },
  "800021": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Phulwari",
    "officename": "Vidyut Parisad SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "800022": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Phulwari",
    "officename": "RAJ BHAWAN SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "800023": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Phulwari",
    "officename": "LBS Nagar SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "800024": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Phulwari",
    "officename": "Keshari Nagar S.O",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "800025": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Phulwari",
    "officename": "Ashiananagar SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "800026": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Sampatchak",
    "officename": "B H COLONY SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "PATNA SAHIB DIVISION"
  },
  "800027": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Sampatchak",
    "officename": "NEW JAGANPURA SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "PATNA SAHIB DIVISION"
  },
  "800028": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Patna City",
    "officename": "Patna High Court SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "801102": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Dulhin Bazar",
    "officename": "BELHAURI S.O",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "801103": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Bihta",
    "officename": "BIHTA S.O",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "801104": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Paliganj",
    "officename": "BIKRAM S.O",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "801105": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Dinapur-Cum-Khagaul",
    "officename": "KHAGAUL S.O",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "801108": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Maner",
    "officename": "MANER S.O",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "801109": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Naubatpur",
    "officename": "NAUBATPUR SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "801110": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Paliganj",
    "officename": "PALIGANJ S.O",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "801111": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Danapur",
    "officename": "SADISOPUR S.O",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "801112": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Paliganj",
    "officename": "LAI S.O",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "801113": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Patna Sadar",
    "officename": "NEORA S.O",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "801301": {
    "state": "Bihar",
    "district": "Nalanda",
    "block": "Ekangersarai",
    "officename": "Ekangersarai SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nalanda Division"
  },
  "801302": {
    "state": "Bihar",
    "district": "Nalanda",
    "block": "Hilsa",
    "officename": "Hilsa SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nalanda Division"
  },
  "801303": {
    "state": "Bihar",
    "district": "Nalanda",
    "block": "Islampur",
    "officename": "Islampur SO Nalanda",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nalanda Division"
  },
  "801304": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Daniyawan",
    "officename": "Karaipersurai SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nalanda Division"
  },
  "801305": {
    "state": "Bihar",
    "district": "Nalanda",
    "block": "Nagarnausa",
    "officename": "Nagarnausa SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nalanda Division"
  },
  "801306": {
    "state": "Bihar",
    "district": "Nalanda",
    "block": "Ekangersarai",
    "officename": "Telhara SO Nalanda",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nalanda Division"
  },
  "801307": {
    "state": "Bihar",
    "district": "Nalanda",
    "block": "Chandi",
    "officename": "Bhathar SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nalanda Division"
  },
  "801503": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Khagual",
    "officename": "D.CANTT. S.O",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "801505": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Patna Sadar",
    "officename": "P.SHARIF S.O",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "801506": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Phulwari",
    "officename": "SAHAYNAGAR S.O",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "801507": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Patna",
    "officename": "AIIMS SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "802101": {
    "state": "Bihar",
    "district": "Buxar",
    "block": "Buxar",
    "officename": "Buxar HO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Buxar Division"
  },
  "802102": {
    "state": "Bihar",
    "district": "Buxar",
    "block": "Buxar",
    "officename": "Buxar Jail SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802103": {
    "state": "Bihar",
    "district": "Buxar",
    "block": "Buxar",
    "officename": "Buxar Gajadhar Ganj SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Buxar Division"
  },
  "802111": {
    "state": "Bihar",
    "district": "Buxar",
    "block": "Duraon",
    "officename": "Arak SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Buxar Division"
  },
  "802112": {
    "state": "Bihar",
    "district": "Buxar",
    "block": "Barhampur",
    "officename": "Brahampur SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Buxar Division"
  },
  "802113": {
    "state": "Bihar",
    "district": "Buxar",
    "block": "Rajpur",
    "officename": "Barkarajpur SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802114": {
    "state": "Bihar",
    "district": "Buxar",
    "block": "Chausa",
    "officename": "Chausa SO Buxar",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Buxar Division"
  },
  "802115": {
    "state": "Bihar",
    "district": "Buxar",
    "block": "Dumraon",
    "officename": "Chaugai SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Buxar Division"
  },
  "802116": {
    "state": "Bihar",
    "district": "Buxar",
    "block": "Buxar",
    "officename": "Churamanpur SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802117": {
    "state": "Bihar",
    "district": "Buxar",
    "block": "Rajpur",
    "officename": "Dhansoi SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802118": {
    "state": "Bihar",
    "district": "Buxar",
    "block": "Simri",
    "officename": "Dulahpur SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802119": {
    "state": "Bihar",
    "district": "Buxar",
    "block": "Dumraon",
    "officename": "Dumraon SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Buxar Division"
  },
  "802120": {
    "state": "Bihar",
    "district": "Buxar",
    "block": "Simri",
    "officename": "Dumari SO Buxar",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802122": {
    "state": "Bihar",
    "district": "Buxar",
    "block": "Rajpur",
    "officename": "Hitawarajpur SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Buxar Division"
  },
  "802123": {
    "state": "Bihar",
    "district": "Buxar",
    "block": "Itarhi",
    "officename": "Itarhi SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Buxar Division"
  },
  "802125": {
    "state": "Bihar",
    "district": "Buxar",
    "block": "Kesath",
    "officename": "Kesath SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Buxar Division"
  },
  "802126": {
    "state": "Bihar",
    "district": "Buxar",
    "block": "Dumraon",
    "officename": "Koran Sarai SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802127": {
    "state": "Bihar",
    "district": "Buxar",
    "block": "Itarhi",
    "officename": "Murar SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Buxar Division"
  },
  "802128": {
    "state": "Bihar",
    "district": "Buxar",
    "block": "Rajpur",
    "officename": "Manoharpur SO Buxar",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Buxar Division"
  },
  "802129": {
    "state": "Bihar",
    "district": "Buxar",
    "block": "Nawanagar",
    "officename": "Nawanagar SO Buxar",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802130": {
    "state": "Bihar",
    "district": "Buxar",
    "block": "Dumraon",
    "officename": "Nimej SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Buxar Division"
  },
  "802131": {
    "state": "Bihar",
    "district": "Buxar",
    "block": "Simri",
    "officename": "Niazipur SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Buxar Division"
  },
  "802132": {
    "state": "Bihar",
    "district": "Kaimur (Bhabua)",
    "block": "Mohania",
    "officename": "Noan SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "802133": {
    "state": "Bihar",
    "district": "Buxar",
    "block": "Dumraon",
    "officename": "Purana Bhojpur SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802134": {
    "state": "Bihar",
    "district": "Buxar",
    "block": "Barhampur",
    "officename": "Raghunathpur SO Buxar",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802135": {
    "state": "Bihar",
    "district": "Buxar",
    "block": "Simri",
    "officename": "Simari SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Buxar Division"
  },
  "802136": {
    "state": "Bihar",
    "district": "Buxar",
    "block": "Dumraon",
    "officename": "Dumraon Textiles SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802152": {
    "state": "Bihar",
    "district": "Bhojpur",
    "block": "Behea",
    "officename": "Bihia SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802154": {
    "state": "Bihar",
    "district": "Bhojpur",
    "block": "Jagdishpur",
    "officename": "Chaurasta Bihia SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802155": {
    "state": "Bihar",
    "district": "Bhojpur",
    "block": "Jagdishpur",
    "officename": "Dalippur SO Bhojpur",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802156": {
    "state": "Bihar",
    "district": "Bhojpur",
    "block": "Arrah",
    "officename": "Dhamar SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802157": {
    "state": "Bihar",
    "district": "Bhojpur",
    "block": "Arrah",
    "officename": "Gajrajganj SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802158": {
    "state": "Bihar",
    "district": "Bhojpur",
    "block": "Jagdishpur",
    "officename": "Jagdishpur SO Bhojpur",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802159": {
    "state": "Bihar",
    "district": "Bhojpur",
    "block": "Jagdishpur",
    "officename": "Jitaura SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802160": {
    "state": "Bihar",
    "district": "Bhojpur",
    "block": "Arrah",
    "officename": "Koilwar SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802161": {
    "state": "Bihar",
    "district": "Bhojpur",
    "block": "Arrah",
    "officename": "Narhi Chandi SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802162": {
    "state": "Bihar",
    "district": "Bhojpur",
    "block": "Behea",
    "officename": "Nawada Ben SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802163": {
    "state": "Bihar",
    "district": "Bhojpur",
    "block": "Koilwar",
    "officename": "Naya Mohamad  Pur SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802164": {
    "state": "Bihar",
    "district": "Bhojpur",
    "block": "Arrah",
    "officename": "Sandesh SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802165": {
    "state": "Bihar",
    "district": "Bhojpur",
    "block": "Jagdishpur",
    "officename": "Shahpurpatti SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802166": {
    "state": "Bihar",
    "district": "Bhojpur",
    "block": "Arrah",
    "officename": "Umraonganj SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802183": {
    "state": "Bihar",
    "district": "Bhojpur",
    "block": "Jagdishpur",
    "officename": "Gaudarh Rudranagar SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802201": {
    "state": "Bihar",
    "district": "Bhojpur",
    "block": "Arrah",
    "officename": "Agiaon SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802202": {
    "state": "Bihar",
    "district": "Bhojpur",
    "block": "Piru",
    "officename": "Agiaon Bazar SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802203": {
    "state": "Bihar",
    "district": "Bhojpur",
    "block": "Garhani",
    "officename": "Garhani SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802204": {
    "state": "Bihar",
    "district": "Bhojpur",
    "block": "Piro",
    "officename": "Hasan Bazar SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802205": {
    "state": "Bihar",
    "district": "Bhojpur",
    "block": "Piru",
    "officename": "Karath SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802206": {
    "state": "Bihar",
    "district": "Bhojpur",
    "block": "Udwant Nagar",
    "officename": "Kasap SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802207": {
    "state": "Bihar",
    "district": "Bhojpur",
    "block": "Piru",
    "officename": "Piru SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802208": {
    "state": "Bihar",
    "district": "Bhojpur",
    "block": "Piru",
    "officename": "Sahar SO Bhojpur",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802209": {
    "state": "Bihar",
    "district": "Bhojpur",
    "block": "Arrah",
    "officename": "Tarari SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802210": {
    "state": "Bihar",
    "district": "Bhojpur",
    "block": "Arrah",
    "officename": "Udawant Nagar SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802211": {
    "state": "Bihar",
    "district": "Rohtas",
    "block": "Dawath",
    "officename": "Babhnaul SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "802212": {
    "state": "Bihar",
    "district": "Rohtas",
    "block": "Bikramganj",
    "officename": "Bikramganj SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "802213": {
    "state": "Bihar",
    "district": "Rohtas",
    "block": "Bikramganj",
    "officename": "Dinara SO Rohtas",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "802214": {
    "state": "Bihar",
    "district": "Rohtas",
    "block": "Karakat",
    "officename": "Gorari SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "802215": {
    "state": "Bihar",
    "district": "Rohtas",
    "block": "Sasaram",
    "officename": "Garh Nokha SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "802216": {
    "state": "Bihar",
    "district": "Rohtas",
    "block": "Dawath",
    "officename": "Koath SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "802217": {
    "state": "Bihar",
    "district": "Rohtas",
    "block": "Sasaram",
    "officename": "Meari Bazar SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "802218": {
    "state": "Bihar",
    "district": "Rohtas",
    "block": "Bikramganj",
    "officename": "Natwar SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "802219": {
    "state": "Bihar",
    "district": "Rohtas",
    "block": "Rajpur",
    "officename": "Rajpur SO Rohtas",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "802220": {
    "state": "Bihar",
    "district": "Rohtas",
    "block": "Bikramganj",
    "officename": "Sanjhauli SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "802221": {
    "state": "Bihar",
    "district": "Rohtas",
    "block": "Bikramganj",
    "officename": "Surajpura SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "802222": {
    "state": "Bihar",
    "district": "Bhojpur",
    "block": "Piru",
    "officename": "Khutahan SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802223": {
    "state": "Bihar",
    "district": "Bhojpur",
    "block": "Piru",
    "officename": "Charpokhari SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802226": {
    "state": "Bihar",
    "district": "Rohtas",
    "block": "Bikramganj",
    "officename": "Dawath SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "802301": {
    "state": "Bihar",
    "district": "Bhojpur",
    "block": "Arrah",
    "officename": "Arrah HO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802302": {
    "state": "Bihar",
    "district": "Bhojpur",
    "block": "Arrah",
    "officename": "Anaith SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802311": {
    "state": "Bihar",
    "district": "Bhojpur",
    "block": "Arrah",
    "officename": "Barahara SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802312": {
    "state": "Bihar",
    "district": "Bhojpur",
    "block": "Arrah",
    "officename": "Chandawa SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802313": {
    "state": "Bihar",
    "district": "Buxar",
    "block": "Rajpur",
    "officename": "Gunari SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802314": {
    "state": "Bihar",
    "district": "Bhojpur",
    "block": "Arrah",
    "officename": "Kayamnagar SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802316": {
    "state": "Bihar",
    "district": "Bhojpur",
    "block": "Arrah",
    "officename": "Sinha SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802351": {
    "state": "Bihar",
    "district": "Bhojpur",
    "block": "Shahpur",
    "officename": "Benwalia SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "802352": {
    "state": "Bihar",
    "district": "Bhojpur",
    "block": "Bhojpur",
    "officename": "Akhagaon SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "803101": {
    "state": "Bihar",
    "district": "Nalanda",
    "block": "Bihar",
    "officename": "Biharsharif HO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nalanda Division"
  },
  "803107": {
    "state": "Bihar",
    "district": "Nalanda",
    "block": "Asthawan",
    "officename": "Asthawan SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nalanda Division"
  },
  "803108": {
    "state": "Bihar",
    "district": "Nalanda",
    "block": "Chandi",
    "officename": "Chandi SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nalanda Division"
  },
  "803109": {
    "state": "Bihar",
    "district": "Nawada",
    "block": "Nawada",
    "officename": "Giriak SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nawadha Division"
  },
  "803110": {
    "state": "Bihar",
    "district": "Nalanda",
    "block": "Chandi",
    "officename": "Harnaut SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nalanda Division"
  },
  "803111": {
    "state": "Bihar",
    "district": "Nalanda",
    "block": "Silao",
    "officename": "Nalanda SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nalanda Division"
  },
  "803113": {
    "state": "Bihar",
    "district": "Nalanda",
    "block": "Nursarai",
    "officename": "Nursarai SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nalanda Division"
  },
  "803114": {
    "state": "Bihar",
    "district": "Nalanda",
    "block": "Nursarai",
    "officename": "Parwalpur SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nalanda Division"
  },
  "803115": {
    "state": "Bihar",
    "district": "Nalanda",
    "block": "Giriak",
    "officename": "Pawapuri SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nalanda Division"
  },
  "803116": {
    "state": "Bihar",
    "district": "Nalanda",
    "block": "Rajgir",
    "officename": "Rajgir SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nalanda Division"
  },
  "803117": {
    "state": "Bihar",
    "district": "Nalanda",
    "block": "Islampur",
    "officename": "Silao SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nalanda Division"
  },
  "803118": {
    "state": "Bihar",
    "district": "Nalanda",
    "block": "Sohsarai",
    "officename": "Sohsarai SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nalanda Division"
  },
  "803119": {
    "state": "Bihar",
    "district": "Nalanda",
    "block": "Rahui",
    "officename": "Rahui SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nalanda Division"
  },
  "803120": {
    "state": "Bihar",
    "district": "Nalanda",
    "block": "Nursarai",
    "officename": "Asta SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nalanda Division"
  },
  "803121": {
    "state": "Bihar",
    "district": "Nalanda",
    "block": "Rajgir",
    "officename": "Ordnance Factory Rajgir SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nalanda Division"
  },
  "803201": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Patna City",
    "officename": "FATWA SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "PATNA SAHIB DIVISION"
  },
  "803202": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Patna City",
    "officename": "KHUSHRUPUR SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "PATNA SAHIB DIVISION"
  },
  "803203": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Fatwa",
    "officename": "ALAWALPUR SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "PATNA SAHIB DIVISION"
  },
  "803211": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Athmalgola",
    "officename": "Athmalgola S.O",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "PATNA SAHIB DIVISION"
  },
  "803212": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Bakhtiarpur",
    "officename": "Bakhtiyarpur S.O",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "PATNA SAHIB DIVISION"
  },
  "803213": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Barh",
    "officename": "Barh  S.O",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "PATNA SAHIB DIVISION"
  },
  "803214": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Barh",
    "officename": "Barh RS S.O",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "PATNA SAHIB DIVISION"
  },
  "803215": {
    "state": "Bihar",
    "district": "Nalanda",
    "block": "Barh",
    "officename": "NTPC Barh S.O",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "PATNA SAHIB DIVISION"
  },
  "803216": {
    "state": "Bihar",
    "district": "Nalanda",
    "block": "Biharsharif",
    "officename": "Ramchandrapur SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nalanda Division"
  },
  "803221": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Pandarak",
    "officename": "Pandarak S.O",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "PATNA SAHIB DIVISION"
  },
  "803301": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Mokama",
    "officename": "Hathidah S.O",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "PATNA SAHIB DIVISION"
  },
  "803302": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Mokama",
    "officename": "Mokama S.O",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "PATNA SAHIB DIVISION"
  },
  "803303": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Mokama",
    "officename": "Mokama Ghat S.O",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "PATNA SAHIB DIVISION"
  },
  "803306": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Ghoshwari",
    "officename": "Samyagarh S.O",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "PATNA SAHIB DIVISION"
  },
  "803307": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Pandarak",
    "officename": "Bhadaur S.O",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "PATNA SAHIB DIVISION"
  },
  "804401": {
    "state": "Bihar",
    "district": "Arwal",
    "block": "Arwal",
    "officename": "Arwal S.O.",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "AurangabadBihar Division"
  },
  "804402": {
    "state": "Bihar",
    "district": "Gaya",
    "block": "Arwal",
    "officename": "Baidrabad S.O",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "AurangabadBihar Division"
  },
  "804403": {
    "state": "Bihar",
    "district": "Gaya",
    "block": "Belaganj",
    "officename": "Belaganj SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "804404": {
    "state": "Bihar",
    "district": "Gaya",
    "block": "Town Block Gaya",
    "officename": "Chakand SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "804405": {
    "state": "Bihar",
    "district": "Jehanabad",
    "block": "Jehanabad",
    "officename": "Dharaut SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "804406": {
    "state": "Bihar",
    "district": "Jehanabad",
    "block": "Ghoshi",
    "officename": "Ghosi SO Jehanabad",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "804407": {
    "state": "Bihar",
    "district": "Jehanabad",
    "block": "Hulasganj",
    "officename": "Hulashganj SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "804408": {
    "state": "Bihar",
    "district": "Jehanabad",
    "block": "Jehanabad",
    "officename": "Jehanabad HO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "804417": {
    "state": "Bihar",
    "district": "Jehanabad",
    "block": "Jehanabad",
    "officename": "Jehanabad RS SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "804418": {
    "state": "Bihar",
    "district": "Jehanabad",
    "block": "Jehanabad",
    "officename": "Kako SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "804419": {
    "state": "Bihar",
    "district": "Jehanabad",
    "block": "Jehanabad",
    "officename": "Karpi S.O",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "AurangabadBihar Division"
  },
  "804420": {
    "state": "Bihar",
    "district": "Jehanabad",
    "block": "Jehanabad",
    "officename": "Kazisarai SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "804421": {
    "state": "Bihar",
    "district": "Gaya",
    "block": "Kurtha",
    "officename": "Kurtha S.O",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "AurangabadBihar Division"
  },
  "804422": {
    "state": "Bihar",
    "district": "Jehanabad",
    "block": "Jehanabad",
    "officename": "Makhdumpur SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "804423": {
    "state": "Bihar",
    "district": "Gaya",
    "block": "Ratnifaridpur",
    "officename": "Nagla Kinger S.O",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "AurangabadBihar Division"
  },
  "804424": {
    "state": "Bihar",
    "district": "Jehanabad",
    "block": "Jehanabad",
    "officename": "Paibigha SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "804425": {
    "state": "Bihar",
    "district": "Jehanabad",
    "block": "Ratnifaridpur",
    "officename": "Sakurabad SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "804426": {
    "state": "Bihar",
    "district": "Jehanabad",
    "block": "Jehanabad",
    "officename": "S.P Imamganj S.O",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "AurangabadBihar Division"
  },
  "804427": {
    "state": "Bihar",
    "district": "Jehanabad",
    "block": "Jehanabad",
    "officename": "Tehta SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "804428": {
    "state": "Bihar",
    "district": "Jehanabad",
    "block": "Karpi",
    "officename": "Usari S.O",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "AurangabadBihar Division"
  },
  "804429": {
    "state": "Bihar",
    "district": "Jehanabad",
    "block": "Jehanabad",
    "officename": "Nehalpur SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "804432": {
    "state": "Bihar",
    "district": "Jehanabad",
    "block": "Jehanabad",
    "officename": "Bandhuganj SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "804435": {
    "state": "Bihar",
    "district": "Gaya",
    "block": "Belaganj",
    "officename": "Main SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "804451": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Masaurhi",
    "officename": "NADAUL SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "PATNA SAHIB DIVISION"
  },
  "804452": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Masaurhi",
    "officename": "MASAURHI SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "PATNA SAHIB DIVISION"
  },
  "804453": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Masaurhi",
    "officename": "PUNPUN SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "PATNA SAHIB DIVISION"
  },
  "804454": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Masaurhi",
    "officename": "Tineri BO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "PATNA SAHIB DIVISION"
  },
  "805101": {
    "state": "Bihar",
    "district": "Nawada",
    "block": "Pakribarawan",
    "officename": "Dhamul SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nawadha Division"
  },
  "805102": {
    "state": "Bihar",
    "district": "Nawada",
    "block": "Akbarpur",
    "officename": "Govindpur SO Nawada",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nawadha Division"
  },
  "805103": {
    "state": "Bihar",
    "district": "Nawada",
    "block": "Akbarpur",
    "officename": "Hasua SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nawadha Division"
  },
  "805104": {
    "state": "Bihar",
    "district": "Nawada",
    "block": "Nawada",
    "officename": "Kadirganj SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nawadha Division"
  },
  "805105": {
    "state": "Bihar",
    "district": "Nalanda",
    "block": "Islampur",
    "officename": "Katrisarai SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nawadha Division"
  },
  "805106": {
    "state": "Bihar",
    "district": "Nawada",
    "block": "Akbarpur",
    "officename": "Kawakol SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nawadha Division"
  },
  "805107": {
    "state": "Bihar",
    "district": "Nawada",
    "block": "Roh",
    "officename": "Kosi SO Nawada",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nawadha Division"
  },
  "805108": {
    "state": "Bihar",
    "district": "Nawada",
    "block": "Kashi Chak",
    "officename": "Lalbigha SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nawadha Division"
  },
  "805109": {
    "state": "Bihar",
    "district": "Nawada",
    "block": "Akbarpur",
    "officename": "Nardiganj SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nawadha Division"
  },
  "805110": {
    "state": "Bihar",
    "district": "Nawada",
    "block": "Nawadha",
    "officename": "Nawadha HO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nawadha Division"
  },
  "805111": {
    "state": "Bihar",
    "district": "Nawada",
    "block": "Akbarpur",
    "officename": "Nawada Kutchery SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nawadha Division"
  },
  "805112": {
    "state": "Bihar",
    "district": "Nawada",
    "block": "Pakribarawan",
    "officename": "Parnawada SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nawadha Division"
  },
  "805121": {
    "state": "Bihar",
    "district": "Nawada",
    "block": "Gobindpur",
    "officename": "Nemdarganj SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nawadha Division"
  },
  "805122": {
    "state": "Bihar",
    "district": "Nawada",
    "block": "Akbarpur",
    "officename": "Narhat SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nawadha Division"
  },
  "805123": {
    "state": "Bihar",
    "district": "Nawada",
    "block": "Akbarpur",
    "officename": "Orhanpur SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nawadha Division"
  },
  "805124": {
    "state": "Bihar",
    "district": "Nawada",
    "block": "Pakribarawan",
    "officename": "Pakaribarwan SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nawadha Division"
  },
  "805125": {
    "state": "Bihar",
    "district": "Nawada",
    "block": "Akbarpur",
    "officename": "Rajauli SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nawadha Division"
  },
  "805126": {
    "state": "Bihar",
    "district": "Nawada",
    "block": "Akbarpur",
    "officename": "Rajhat SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nawadha Division"
  },
  "805127": {
    "state": "Bihar",
    "district": "Nawada",
    "block": "Akbarpur",
    "officename": "Sirdala SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nawadha Division"
  },
  "805128": {
    "state": "Bihar",
    "district": "Gaya",
    "block": "Akbarpur",
    "officename": "Tarwan SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nawadha Division"
  },
  "805129": {
    "state": "Bihar",
    "district": "Nawada",
    "block": "Akbarpur",
    "officename": "Tungi SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nawadha Division"
  },
  "805130": {
    "state": "Bihar",
    "district": "Nawada",
    "block": "Akbarpur",
    "officename": "Warisaliganj SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nawadha Division"
  },
  "805131": {
    "state": "Bihar",
    "district": "Gaya",
    "block": "Akbarpur",
    "officename": "Wazirganj SO Gaya",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nawadha Division"
  },
  "805132": {
    "state": "Bihar",
    "district": "Nawada",
    "block": "Warisaliganj",
    "officename": "Dumrawan SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nawadha Division"
  },
  "805141": {
    "state": "Bihar",
    "district": "Nawada",
    "block": "Akbarpur",
    "officename": "Roh S.O",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nawadha Division"
  },
  "811101": {
    "state": "Bihar",
    "district": "Nalanda",
    "block": "Asthawan",
    "officename": "Barbigha SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nawadha Division"
  },
  "811102": {
    "state": "Bihar",
    "district": "Nalanda",
    "block": "Sarmera",
    "officename": "Mehus SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nawadha Division"
  },
  "811103": {
    "state": "Bihar",
    "district": "Sheikhpura",
    "block": "Shekhosarai",
    "officename": "Nimi SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nawadha Division"
  },
  "811104": {
    "state": "Bihar",
    "district": "Nalanda",
    "block": "Srmera",
    "officename": "Sarmera S.O.",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nalanda Division"
  },
  "811105": {
    "state": "Bihar",
    "district": "Sheikhpura",
    "block": "Sheikhpura",
    "officename": "Sheikhpura SO Sheikhpura",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nawadha Division"
  },
  "811106": {
    "state": "Bihar",
    "district": "Begusarai",
    "block": "Samho",
    "officename": "Surajgaraha SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Munger Division"
  },
  "811107": {
    "state": "Bihar",
    "district": "Lakhisarai",
    "block": "Ramgarh Chowk",
    "officename": "Sirari SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nawadha Division"
  },
  "811112": {
    "state": "Bihar",
    "district": "Lakhisarai",
    "block": "Surajgarha",
    "officename": "Piri Bazar SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Munger Division"
  },
  "811201": {
    "state": "Bihar",
    "district": "Munger",
    "block": "Munger",
    "officename": "Munger HO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Munger Division"
  },
  "811202": {
    "state": "Bihar",
    "district": "Munger",
    "block": "Munger",
    "officename": "Basudeopur SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Munger Division"
  },
  "811211": {
    "state": "Bihar",
    "district": "Munger",
    "block": "Haweli Kharagpur",
    "officename": "Bariarpur SO Munger",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Munger Division"
  },
  "811212": {
    "state": "Bihar",
    "district": "Munger",
    "block": "Dharhara",
    "officename": "Dharhara SO Munger",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Munger Division"
  },
  "811213": {
    "state": "Bihar",
    "district": "Munger",
    "block": "Haweli Kharagpur",
    "officename": "Haweli Kharagpur SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Munger Division"
  },
  "811214": {
    "state": "Bihar",
    "district": "Munger",
    "block": "Jamalpur",
    "officename": "Jamalpur SO Munger",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Munger Division"
  },
  "811301": {
    "state": "Bihar",
    "district": "Jamui",
    "block": "Islamnagar",
    "officename": "Aliganj SO Jamui",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Munger Division"
  },
  "811302": {
    "state": "Bihar",
    "district": "Lakhisarai",
    "block": "Barhiya",
    "officename": "Barhiya SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Munger Division"
  },
  "811303": {
    "state": "Bihar",
    "district": "Jamui",
    "block": "Chakai",
    "officename": "Chakai SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Munger Division"
  },
  "811304": {
    "state": "Bihar",
    "district": "Sheikhpura",
    "block": "Chewara",
    "officename": "Chewara SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nawadha Division"
  },
  "811305": {
    "state": "Bihar",
    "district": "Jamui",
    "block": "Khaira",
    "officename": "Gidhaur SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Munger Division"
  },
  "811307": {
    "state": "Bihar",
    "district": "Jamui",
    "block": "Jamui",
    "officename": "Jamui HO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Munger Division"
  },
  "811308": {
    "state": "Bihar",
    "district": "Jamui",
    "block": "Sono",
    "officename": "Jhajha SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Munger Division"
  },
  "811309": {
    "state": "Bihar",
    "district": "Lakhisarai",
    "block": "Surajgarha",
    "officename": "Kajra SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Munger Division"
  },
  "811310": {
    "state": "Bihar",
    "district": "Lakhisarai",
    "block": "Bandhu Bagicha",
    "officename": "Kiulrs SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Munger Division"
  },
  "811311": {
    "state": "Bihar",
    "district": "Lakhisarai",
    "block": "Ramgarh Chowk",
    "officename": "Lakhisarai SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Munger Division"
  },
  "811312": {
    "state": "Bihar",
    "district": "Jamui",
    "block": "Laxmipur",
    "officename": "Laxmipur Jamui SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Munger Division"
  },
  "811313": {
    "state": "Bihar",
    "district": "Jamui",
    "block": "Jamui",
    "officename": "Mallehpur SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Munger Division"
  },
  "811314": {
    "state": "Bihar",
    "district": "Jamui",
    "block": "Sono",
    "officename": "Sono SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Munger Division"
  },
  "811315": {
    "state": "Bihar",
    "district": "Jamui",
    "block": "Sikandra",
    "officename": "Sikandra SO Jamui",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Munger Division"
  },
  "811316": {
    "state": "Bihar",
    "district": "Jamui",
    "block": "Chakai",
    "officename": "Simultala SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Munger Division"
  },
  "811317": {
    "state": "Bihar",
    "district": "Jamui",
    "block": "Jamui",
    "officename": "Khaira SO Jamui",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Munger Division"
  },
  "812001": {
    "state": "Bihar",
    "district": "Bhagalpur",
    "block": "Jagdishpur",
    "officename": "Bhagalpur HO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Bhagalpur Division"
  },
  "812002": {
    "state": "Bihar",
    "district": "Bhagalpur",
    "block": "Jagdishpur",
    "officename": "Bhagalpur City SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Bhagalpur Division"
  },
  "812003": {
    "state": "Bihar",
    "district": "Bhagalpur",
    "block": "Jagdishpur",
    "officename": "Barari SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Bhagalpur Division"
  },
  "812004": {
    "state": "Bihar",
    "district": "Bhagalpur",
    "block": "Nathnagar",
    "officename": "Champanagar SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Bhagalpur Division"
  },
  "812005": {
    "state": "Bihar",
    "district": "Bhagalpur",
    "block": "Jagdishpur",
    "officename": "Mirjanhat SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Bhagalpur Division"
  },
  "812006": {
    "state": "Bihar",
    "district": "Bhagalpur",
    "block": "Sultanganj",
    "officename": "Nathnagar SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Bhagalpur Division"
  },
  "812007": {
    "state": "Bihar",
    "district": "Bhagalpur",
    "block": "Jagdishpur",
    "officename": "T N B College SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Bhagalpur Division"
  },
  "813101": {
    "state": "Bihar",
    "district": "Banka",
    "block": "Amarpur",
    "officename": "Amarpur SO Banka",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Bhagalpur Division"
  },
  "813102": {
    "state": "Bihar",
    "district": "Banka",
    "block": "Banka",
    "officename": "Banka HO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Bhagalpur Division"
  },
  "813103": {
    "state": "Bihar",
    "district": "Banka",
    "block": "Barahat",
    "officename": "Barahat SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Bhagalpur Division"
  },
  "813104": {
    "state": "Bihar",
    "district": "Banka",
    "block": "Banka",
    "officename": "Bounsi SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Bhagalpur Division"
  },
  "813105": {
    "state": "Bihar",
    "district": "Bhagalpur",
    "block": "Jagdishpur",
    "officename": "Jagdishpur SO Bhagalpur",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Bhagalpur Division"
  },
  "813106": {
    "state": "Bihar",
    "district": "Banka",
    "block": "Katoria",
    "officename": "Katoria SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Bhagalpur Division"
  },
  "813107": {
    "state": "Bihar",
    "district": "Banka",
    "block": "Rajoun",
    "officename": "Rajoun SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Bhagalpur Division"
  },
  "813108": {
    "state": "Bihar",
    "district": "Bhagalpur",
    "block": "Sahkund",
    "officename": "Sahkund SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Bhagalpur Division"
  },
  "813109": {
    "state": "Bihar",
    "district": "Banka",
    "block": "Banka",
    "officename": "Punsia SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Bhagalpur Division"
  },
  "813110": {
    "state": "Bihar",
    "district": "Banka",
    "block": "Barahat",
    "officename": "Panjwara SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Bhagalpur Division"
  },
  "813201": {
    "state": "Bihar",
    "district": "Munger",
    "block": "Tarapur",
    "officename": "Asarganj SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Munger Division"
  },
  "813202": {
    "state": "Bihar",
    "district": "Banka",
    "block": "Banka",
    "officename": "Belhar SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Bhagalpur Division"
  },
  "813203": {
    "state": "Bihar",
    "district": "Bhagalpur",
    "block": "Kahalgoan",
    "officename": "Kahalgaon SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Bhagalpur Division"
  },
  "813204": {
    "state": "Bihar",
    "district": "Bhagalpur",
    "block": "Kahalgoan",
    "officename": "Ekchari SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Bhagalpur Division"
  },
  "813205": {
    "state": "Bihar",
    "district": "Bhagalpur",
    "block": "Kahalgoan",
    "officename": "Ghogha SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Bhagalpur Division"
  },
  "813206": {
    "state": "Bihar",
    "district": "Bhagalpur",
    "block": "Pripainti",
    "officename": "Ishipur SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Bhagalpur Division"
  },
  "813207": {
    "state": "Bihar",
    "district": "Banka",
    "block": "Fullidumar",
    "officename": "Khesar SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Bhagalpur Division"
  },
  "813208": {
    "state": "Jharkhand",
    "district": "Godda",
    "block": "Meharma",
    "officename": "Mirzachowki SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "813209": {
    "state": "Bihar",
    "district": "Bhagalpur",
    "block": "Pirpainti",
    "officename": "Pripainti SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Bhagalpur Division"
  },
  "813210": {
    "state": "Bihar",
    "district": "Bhagalpur",
    "block": "Goradih",
    "officename": "Sabour SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Bhagalpur Division"
  },
  "813211": {
    "state": "Bihar",
    "district": "Banka",
    "block": "Shambhuganj",
    "officename": "Shambhuganj SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Bhagalpur Division"
  },
  "813212": {
    "state": "Bihar",
    "district": "Munger",
    "block": "Sangrampur",
    "officename": "Sangrampur SO Bhagalpur",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Munger Division"
  },
  "813213": {
    "state": "Bihar",
    "district": "Bhagalpur",
    "block": "Sultanganj",
    "officename": "Sultanganj SO Bhagalpur",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Bhagalpur Division"
  },
  "813214": {
    "state": "Bihar",
    "district": "Bhagalpur",
    "block": "Colgong",
    "officename": "STP Kahalgaon SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Bhagalpur Division"
  },
  "813221": {
    "state": "Bihar",
    "district": "Banka",
    "block": "Shambhuganj",
    "officename": "TARAPUR BO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Munger Division"
  },
  "813222": {
    "state": "Bihar",
    "district": "Bhagalpur",
    "block": "Kahalgoan",
    "officename": "Mathurapur SO Bhagalpur",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Bhagalpur Division"
  },
  "814101": {
    "state": "Jharkhand",
    "district": "Dumka",
    "block": "Dumka",
    "officename": "Dumka HO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "814102": {
    "state": "Jharkhand",
    "district": "Dumka",
    "block": "Ramgarah",
    "officename": "Ramgarah SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "814103": {
    "state": "Jharkhand",
    "district": "Dumka",
    "block": "Kathikund",
    "officename": "Kathikund SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "814110": {
    "state": "Jharkhand",
    "district": "Dumka",
    "block": "Jama",
    "officename": "Shivpahar SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "814111": {
    "state": "Jharkhand",
    "district": "Pakur",
    "block": "Amrapara",
    "officename": "Amrapara SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "814112": {
    "state": "Jharkhand",
    "district": "Deoghar",
    "block": "Deoghar",
    "officename": "BDeoghar HO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "B.Deoghar Division"
  },
  "814113": {
    "state": "Jharkhand",
    "district": "Deoghar",
    "block": "Mohanpur",
    "officename": "Deoghar College SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "B.Deoghar Division"
  },
  "814114": {
    "state": "Jharkhand",
    "district": "Deoghar",
    "block": "Deoghar",
    "officename": "Deosang BT SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "B.Deoghar Division"
  },
  "814115": {
    "state": "Jharkhand",
    "district": "Deoghar",
    "block": "Deoghar",
    "officename": "Hindipith SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "B.Deoghar Division"
  },
  "814116": {
    "state": "Jharkhand",
    "district": "Deoghar",
    "block": "Deoghar",
    "officename": "Satsang SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "B.Deoghar Division"
  },
  "814118": {
    "state": "Jharkhand",
    "district": "Dumka",
    "block": "Jama",
    "officename": "Basukinathdham SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "B.Deoghar Division"
  },
  "814119": {
    "state": "Jharkhand",
    "district": "Dumka",
    "block": "Dumka",
    "officename": "Kurwa SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "814120": {
    "state": "Jharkhand",
    "district": "Deoghar",
    "block": "Jarmundi",
    "officename": "Ghormara SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "B.Deoghar Division"
  },
  "814131": {
    "state": "Bihar",
    "district": "Banka",
    "block": "Chandan",
    "officename": "Chandan SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Bhagalpur Division"
  },
  "814133": {
    "state": "Jharkhand",
    "district": "Godda",
    "block": "Godda",
    "officename": "Godda SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "814141": {
    "state": "Jharkhand",
    "district": "Dumka",
    "block": "Jarmundi",
    "officename": "Jarmundi SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "B.Deoghar Division"
  },
  "814142": {
    "state": "Jharkhand",
    "district": "Deoghar",
    "block": "Deoghar",
    "officename": "Jasidih SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "B.Deoghar Division"
  },
  "814143": {
    "state": "Jharkhand",
    "district": "Deoghar",
    "block": "Deoghar",
    "officename": "Kunda SO Deoghar",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "B.Deoghar Division"
  },
  "814144": {
    "state": "Jharkhand",
    "district": "Dumka",
    "block": "Dumka",
    "officename": "Massanjore SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "814145": {
    "state": "Jharkhand",
    "district": "Dumka",
    "block": "Ramgarh",
    "officename": "Nonihat SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "814146": {
    "state": "Jharkhand",
    "district": "Dumka",
    "block": "Jama",
    "officename": "Palojori SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "B.Deoghar Division"
  },
  "814147": {
    "state": "Jharkhand",
    "district": "Godda",
    "block": "Pathergama",
    "officename": "Pathergama SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "814148": {
    "state": "Jharkhand",
    "district": "Dumka",
    "block": "Raniswar",
    "officename": "Raghunathpur SO Dumka",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "814149": {
    "state": "Jharkhand",
    "district": "Deoghar",
    "block": "Sarath",
    "officename": "Sarath SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "B.Deoghar Division"
  },
  "814150": {
    "state": "Jharkhand",
    "district": "Deoghar",
    "block": "Sarwan",
    "officename": "Sarwan SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "B.Deoghar Division"
  },
  "814151": {
    "state": "Jharkhand",
    "district": "Dumka",
    "block": "Sariyahat",
    "officename": "Saraiyahat SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "B.Deoghar Division"
  },
  "814152": {
    "state": "Jharkhand",
    "district": "Deoghar",
    "block": "Debipur",
    "officename": "Rohani SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "B.Deoghar Division"
  },
  "814153": {
    "state": "Jharkhand",
    "district": "Godda",
    "block": "Poraiyahat",
    "officename": "Poraiyahat SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "814154": {
    "state": "Jharkhand",
    "district": "Godda",
    "block": "Mahagama",
    "officename": "Mahgama SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "814155": {
    "state": "Jharkhand",
    "district": "Godda",
    "block": "Pathargama",
    "officename": "Basantrai SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "814156": {
    "state": "Jharkhand",
    "district": "Godda",
    "block": "Sunder Pahari",
    "officename": "Sarouni Bazar SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "814157": {
    "state": "Jharkhand",
    "district": "Deoghar",
    "block": "Mohanpur",
    "officename": "Dehijore SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "B.Deoghar Division"
  },
  "814158": {
    "state": "Jharkhand",
    "district": "Dumka",
    "block": "Jama",
    "officename": "Guhiajori SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "814160": {
    "state": "Jharkhand",
    "district": "Godda",
    "block": "Meharma",
    "officename": "Meharma SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "814165": {
    "state": "Jharkhand",
    "district": "Godda",
    "block": "Mahgama",
    "officename": "Lalmatia Colliery SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "814166": {
    "state": "Jharkhand",
    "district": "Dumka",
    "block": "Kundahit",
    "officename": "Fatehpur SO Jamtara",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "B.Deoghar Division"
  },
  "814167": {
    "state": "Jharkhand",
    "district": "Dumka",
    "block": "Masalia",
    "officename": "Ranga Masalia SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "815301": {
    "state": "Jharkhand",
    "district": "Giridh",
    "block": "Giridih",
    "officename": "Giridih HO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Giridih Division"
  },
  "815302": {
    "state": "Jharkhand",
    "district": "Giridh",
    "block": "Giridih",
    "officename": "Giridih  Town SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Giridih Division"
  },
  "815311": {
    "state": "Jharkhand",
    "district": "Giridh",
    "block": "Giridih",
    "officename": "Beniadih SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Giridih Division"
  },
  "815312": {
    "state": "Jharkhand",
    "district": "Giridh",
    "block": "Bengabad",
    "officename": "Bengabad SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Giridih Division"
  },
  "815313": {
    "state": "Jharkhand",
    "district": "Giridh",
    "block": "Ganwan",
    "officename": "Ganwan SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Giridih Division"
  },
  "815314": {
    "state": "Jharkhand",
    "district": "Giridh",
    "block": "Deori",
    "officename": "Kharagdiha SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Giridih Division"
  },
  "815315": {
    "state": "Jharkhand",
    "district": "Giridh",
    "block": "Jamua",
    "officename": "Mirzaganj SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Giridih Division"
  },
  "815316": {
    "state": "Jharkhand",
    "district": "Giridh",
    "block": "Giridih",
    "officename": "Pachamba SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Giridih Division"
  },
  "815317": {
    "state": "Jharkhand",
    "district": "Giridh",
    "block": "Tisri",
    "officename": "Tisri SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Giridih Division"
  },
  "815318": {
    "state": "Jharkhand",
    "district": "Giridh",
    "block": "Jamua",
    "officename": "Jamua SO Giridh",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Giridih Division"
  },
  "815351": {
    "state": "Jharkhand",
    "district": "Jamtara",
    "block": "Jamtara",
    "officename": "Jamtara SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "B.Deoghar Division"
  },
  "815352": {
    "state": "Jharkhand",
    "district": "Jamtara",
    "block": "Narayanpur",
    "officename": "Karmatar SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "B.Deoghar Division"
  },
  "815353": {
    "state": "Jharkhand",
    "district": "Deoghar",
    "block": "Madhupur",
    "officename": "Madhupur SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "B.Deoghar Division"
  },
  "815354": {
    "state": "Jharkhand",
    "district": "Jamtara",
    "block": "Jamtara",
    "officename": "Mihijam SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "B.Deoghar Division"
  },
  "815355": {
    "state": "Jharkhand",
    "district": "Jamtara",
    "block": "Nala",
    "officename": "Nala SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "B.Deoghar Division"
  },
  "815357": {
    "state": "Jharkhand",
    "district": "Deoghar",
    "block": "Sarath",
    "officename": "Karogram SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "B.Deoghar Division"
  },
  "815359": {
    "state": "Jharkhand",
    "district": "Jamtara",
    "block": "Jamtara",
    "officename": "Kundahit SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "B.Deoghar Division"
  },
  "816101": {
    "state": "Jharkhand",
    "district": "Sahibganj",
    "block": "Borio",
    "officename": "Barharwa SO Sahibganj",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "816102": {
    "state": "Jharkhand",
    "district": "Sahibganj",
    "block": "Barhait",
    "officename": "Barhait SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "816103": {
    "state": "Jharkhand",
    "district": "Dumka",
    "block": "Shikaripara",
    "officename": "Benagaria SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "816104": {
    "state": "Jharkhand",
    "district": "Pakur",
    "block": "Hiranpur",
    "officename": "Hiranpur SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "816105": {
    "state": "Jharkhand",
    "district": "Sahibganj",
    "block": "Barharwa",
    "officename": "Kotalpokhar SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "816106": {
    "state": "Jharkhand",
    "district": "Pakur",
    "block": "Maheshpur",
    "officename": "Maheshpur Raj SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "816107": {
    "state": "Jharkhand",
    "district": "Pakur",
    "block": "Pakaur",
    "officename": "Pakur SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "816108": {
    "state": "Jharkhand",
    "district": "Sahibganj",
    "block": "Udhua",
    "officename": "Rajmahal SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "816109": {
    "state": "Jharkhand",
    "district": "Sahibganj",
    "block": "Sahibganj",
    "officename": "Sahibganj SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "816110": {
    "state": "Jharkhand",
    "district": "Sahibganj",
    "block": "Pathna",
    "officename": "Pathna SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "816115": {
    "state": "Jharkhand",
    "district": "Sahibganj",
    "block": "Sahibganj",
    "officename": "Sakrigali Ghat SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "816116": {
    "state": "Jharkhand",
    "district": "Sahibganj",
    "block": "Taljhari",
    "officename": "Tinpahar RS SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "816117": {
    "state": "Jharkhand",
    "district": "Pakur",
    "block": "Pakuria",
    "officename": "Pakuria SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "816118": {
    "state": "Jharkhand",
    "district": "Dumka",
    "block": "Raneswar",
    "officename": "Shikaripara SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "816120": {
    "state": "Jharkhand",
    "district": "Sahibganj",
    "block": "Borio",
    "officename": "Borio SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "816129": {
    "state": "Jharkhand",
    "district": "Sahibganj",
    "block": "Taljhari",
    "officename": "Taljhari SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "821101": {
    "state": "Bihar",
    "district": "Kaimur (Bhabua)",
    "block": "Bhabua",
    "officename": "Bhabua SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "821102": {
    "state": "Bihar",
    "district": "Kaimur (Bhabua)",
    "block": "Adhaura",
    "officename": "Bhagwanpur SO Kaimur Bhabua",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "821103": {
    "state": "Bihar",
    "district": "Kaimur (Bhabua)",
    "block": "Mohania",
    "officename": "Chainpur SO Kaimur Bhabua",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "821104": {
    "state": "Bihar",
    "district": "Rohtas",
    "block": "Chenari",
    "officename": "Chenari SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "821105": {
    "state": "Bihar",
    "district": "Kaimur (Bhabua)",
    "block": "Mohania",
    "officename": "Durgawati SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "821106": {
    "state": "Bihar",
    "district": "Kaimur (Bhabua)",
    "block": "Mohania",
    "officename": "Hatta SO Kaimur Bhabua",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "821107": {
    "state": "Bihar",
    "district": "Rohtas",
    "block": "Sasaram",
    "officename": "Kargahar SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "821108": {
    "state": "Bihar",
    "district": "Kaimur (Bhabua)",
    "block": "Mohania",
    "officename": "Kudra SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "821109": {
    "state": "Bihar",
    "district": "Kaimur (Bhabua)",
    "block": "Mohania",
    "officename": "Mohania SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "821110": {
    "state": "Bihar",
    "district": "Kaimur (Bhabua)",
    "block": "Mohania",
    "officename": "Ramgarh SO Kaimur Bhabua",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "821111": {
    "state": "Bihar",
    "district": "Rohtas",
    "block": "Sasaram",
    "officename": "Sheosagar SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "821112": {
    "state": "Bihar",
    "district": "Rohtas",
    "block": "Kochas",
    "officename": "Kochas SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "821113": {
    "state": "Bihar",
    "district": "Rohtas",
    "block": "Sasaram",
    "officename": "Takia Bazar SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "821115": {
    "state": "Bihar",
    "district": "Rohtas",
    "block": "Sasaram",
    "officename": "Sasaram HO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "821301": {
    "state": "Bihar",
    "district": "Rohtas",
    "block": "Akorhi",
    "officename": "Akorhi Bazar SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "821302": {
    "state": "Bihar",
    "district": "Rohtas",
    "block": "Rohtas",
    "officename": "Amjhore Camp SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "821303": {
    "state": "Bihar",
    "district": "Rohtas",
    "block": "Rohtas",
    "officename": "Banjari SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "821304": {
    "state": "Bihar",
    "district": "Rohtas",
    "block": "Rohtas",
    "officename": "Baulia SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "821305": {
    "state": "Bihar",
    "district": "Rohtas",
    "block": "Dehri",
    "officename": "Dalmianagar SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "821306": {
    "state": "Bihar",
    "district": "Rohtas",
    "block": "Dehri",
    "officename": "Darihat SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "821307": {
    "state": "Bihar",
    "district": "Rohtas",
    "block": "Dehri",
    "officename": "Dehrionsone SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "821308": {
    "state": "Bihar",
    "district": "Rohtas",
    "block": "Tilouthu",
    "officename": "Indrapuri SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "821309": {
    "state": "Bihar",
    "district": "Rohtas",
    "block": "Dehri On Sone",
    "officename": "Kachhwa SO Rohtas",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "821310": {
    "state": "Bihar",
    "district": "Rohtas",
    "block": "Dehri On Sone",
    "officename": "Nasriganj SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "821311": {
    "state": "Bihar",
    "district": "Rohtas",
    "block": "Dehri On Sone",
    "officename": "Rohtas SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "821312": {
    "state": "Bihar",
    "district": "Rohtas",
    "block": "Dehri On Sone",
    "officename": "Tilouthu SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "822101": {
    "state": "Jharkhand",
    "district": "Palamau",
    "block": "Daltonganj",
    "officename": "Daltonganj HO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Palamau Division"
  },
  "822102": {
    "state": "Jharkhand",
    "district": "Palamau",
    "block": "Daltonganj",
    "officename": "Daltonganj College SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Palamau Division"
  },
  "822110": {
    "state": "Jharkhand",
    "district": "Palamau",
    "block": "Chainpur",
    "officename": "Raj Chainpur SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Palamau Division"
  },
  "822111": {
    "state": "Jharkhand",
    "district": "Latehar",
    "block": "Barwadih",
    "officename": "Barwadih SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Palamau Division"
  },
  "822112": {
    "state": "Jharkhand",
    "district": "Garhwa",
    "block": "Garhwa",
    "officename": "Bhawnathpur SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Palamau Division"
  },
  "822113": {
    "state": "Jharkhand",
    "district": "Palamau",
    "block": "Chhatarpur",
    "officename": "Chhatarpur SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Palamau Division"
  },
  "822114": {
    "state": "Jharkhand",
    "district": "Garhwa",
    "block": "Garhwa",
    "officename": "Garhwa SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Palamau Division"
  },
  "822115": {
    "state": "Jharkhand",
    "district": "Palamau",
    "block": "Japla",
    "officename": "Haidar Nagar SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Palamau Division"
  },
  "822116": {
    "state": "Jharkhand",
    "district": "Palamau",
    "block": "Japla",
    "officename": "Japla SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Palamau Division"
  },
  "822117": {
    "state": "Jharkhand",
    "district": "Palamau",
    "block": "Japla",
    "officename": "Japla C F SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Palamau Division"
  },
  "822118": {
    "state": "Jharkhand",
    "district": "Palamau",
    "block": "Lesliganj",
    "officename": "Lesliganj SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Palamau Division"
  },
  "822119": {
    "state": "Jharkhand",
    "district": "Latehar",
    "block": "Mahuwadand",
    "officename": "Mahuwadand SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Palamau Division"
  },
  "822120": {
    "state": "Jharkhand",
    "district": "Palamau",
    "block": "Japla",
    "officename": "Mohammad Ganj SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Palamau Division"
  },
  "822121": {
    "state": "Jharkhand",
    "district": "Palamau",
    "block": "Nagar Utari",
    "officename": "Nagar Utari SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Palamau Division"
  },
  "822122": {
    "state": "Jharkhand",
    "district": "Palamau",
    "block": "Panki",
    "officename": "Panki SO Palamau",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Palamau Division"
  },
  "822123": {
    "state": "Jharkhand",
    "district": "Palamau",
    "block": "Patan",
    "officename": "Patan SO Palamau",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Palamau Division"
  },
  "822124": {
    "state": "Jharkhand",
    "district": "Garhwa",
    "block": "Bisrampur",
    "officename": "Rehala SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Palamau Division"
  },
  "822125": {
    "state": "Jharkhand",
    "district": "Garhwa",
    "block": "Ranka Raj",
    "officename": "Ranka Raj SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Palamau Division"
  },
  "822126": {
    "state": "Jharkhand",
    "district": "Palamau",
    "block": "Satbarwa",
    "officename": "Satbarwa SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Palamau Division"
  },
  "822128": {
    "state": "Jharkhand",
    "district": "Garhwa",
    "block": "Meral",
    "officename": "Ramna SO Garhwa",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Palamau Division"
  },
  "822129": {
    "state": "Jharkhand",
    "district": "Garhwa",
    "block": "Bhawanathpur",
    "officename": "Bhawnathpur TownShip SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Palamau Division"
  },
  "822131": {
    "state": "Jharkhand",
    "district": "Palamau",
    "block": "Harihar Ganj",
    "officename": "Harihar Ganj SO Palamau",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Palamau Division"
  },
  "822132": {
    "state": "Jharkhand",
    "district": "Palamau",
    "block": "Daltoganj",
    "officename": "Bishrampur SO Palamau",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Palamau Division"
  },
  "822133": {
    "state": "Jharkhand",
    "district": "Garhwa",
    "block": "Garhwa",
    "officename": "Meral SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Palamau Division"
  },
  "822134": {
    "state": "Jharkhand",
    "district": "Garhwa",
    "block": "Garhwa",
    "officename": "Manjhiaon SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Palamau Division"
  },
  "823001": {
    "state": "Bihar",
    "district": "Gaya",
    "block": "Gaya",
    "officename": "Gaya HO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "823002": {
    "state": "Bihar",
    "district": "Gaya",
    "block": "Gaya",
    "officename": "Gaya RS SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "823003": {
    "state": "Bihar",
    "district": "Gaya",
    "block": "Gaya",
    "officename": "Buniyad Ganj SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "823004": {
    "state": "Bihar",
    "district": "Gaya",
    "block": "Gaya",
    "officename": "Civil Aerodram SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "823005": {
    "state": "Bihar",
    "district": "Gaya",
    "block": "Gaya",
    "officename": "Asc CentreN Gaya SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "823311": {
    "state": "Bihar",
    "district": "Gaya",
    "block": "Atri",
    "officename": "Atri SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "824101": {
    "state": "Bihar",
    "district": "Aurangabad(BH)",
    "block": "Aurangabad",
    "officename": "Aurangabad BH HO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "AurangabadBihar Division"
  },
  "824102": {
    "state": "Bihar",
    "district": "Aurangabad(BH)",
    "block": "Aurangabad",
    "officename": "S S College SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "AurangabadBihar Division"
  },
  "824103": {
    "state": "Bihar",
    "district": "Aurangabad(BH)",
    "block": "Madanpur",
    "officename": "War SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "AurangabadBihar Division"
  },
  "824111": {
    "state": "Bihar",
    "district": "Aurangabad(BH)",
    "block": "Amba",
    "officename": "Amba SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "AurangabadBihar Division"
  },
  "824112": {
    "state": "Bihar",
    "district": "Aurangabad(BH)",
    "block": "Barun",
    "officename": "Barun SO AurangabadBH",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "AurangabadBihar Division"
  },
  "824113": {
    "state": "Bihar",
    "district": "Aurangabad(BH)",
    "block": "Daudnagar",
    "officename": "Bhakharua SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "AurangabadBihar Division"
  },
  "824114": {
    "state": "Bihar",
    "district": "Aurangabad(BH)",
    "block": "Goh",
    "officename": "Deohara SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "AurangabadBihar Division"
  },
  "824115": {
    "state": "Bihar",
    "district": "Arwal",
    "block": "Kaler",
    "officename": "Sihari SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "AurangabadBihar Division"
  },
  "824116": {
    "state": "Bihar",
    "district": "Gaya",
    "block": "Rafiganj",
    "officename": "Anti SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "824118": {
    "state": "Bihar",
    "district": "Gaya",
    "block": "G.mills",
    "officename": "Guraru Mills SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "824120": {
    "state": "Bihar",
    "district": "Aurangabad(BH)",
    "block": "Haspura",
    "officename": "Haspura SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "AurangabadBihar Division"
  },
  "824121": {
    "state": "Bihar",
    "district": "Aurangabad(BH)",
    "block": "Jamhor",
    "officename": "Jamhor SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "AurangabadBihar Division"
  },
  "824122": {
    "state": "Bihar",
    "district": "Aurangabad(BH)",
    "block": "Rafiganj",
    "officename": "Jakhim SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "AurangabadBihar Division"
  },
  "824123": {
    "state": "Bihar",
    "district": "Aurangabad(BH)",
    "block": "Kutumba",
    "officename": "Kutumba SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "AurangabadBihar Division"
  },
  "824124": {
    "state": "Bihar",
    "district": "Aurangabad(BH)",
    "block": "Obra",
    "officename": "Obra SO AurangabadBH",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "AurangabadBihar Division"
  },
  "824125": {
    "state": "Bihar",
    "district": "Aurangabad(BH)",
    "block": "Rafiganj",
    "officename": "Rafiganj SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "AurangabadBihar Division"
  },
  "824127": {
    "state": "Bihar",
    "district": "Aurangabad(BH)",
    "block": "Kaler",
    "officename": "Kaler SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "AurangabadBihar Division"
  },
  "824129": {
    "state": "Bihar",
    "district": "Aurangabad(BH)",
    "block": "Goh",
    "officename": "Rukundi Jhikatia SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "AurangabadBihar Division"
  },
  "824143": {
    "state": "Bihar",
    "district": "Aurangabad(BH)",
    "block": "Daudnagar",
    "officename": "Daudnagar SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "AurangabadBihar Division"
  },
  "824201": {
    "state": "Bihar",
    "district": "Gaya",
    "block": "Brachatti",
    "officename": "Barachatti SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "824202": {
    "state": "Bihar",
    "district": "Aurangabad(BH)",
    "block": "Deo",
    "officename": "Deo SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "AurangabadBihar Division"
  },
  "824203": {
    "state": "Bihar",
    "district": "Aurangabad(BH)",
    "block": "Goh",
    "officename": "Goh SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "AurangabadBihar Division"
  },
  "824205": {
    "state": "Bihar",
    "district": "Gaya",
    "block": "Gurua",
    "officename": "Gurua SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "824206": {
    "state": "Bihar",
    "district": "Gaya",
    "block": "Imamgnaj",
    "officename": "Imamganj SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "824207": {
    "state": "Bihar",
    "district": "Gaya",
    "block": "Konch",
    "officename": "Konch SO Gaya",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "824208": {
    "state": "Bihar",
    "district": "Aurangabad(BH)",
    "block": "Madanpur",
    "officename": "Madanpur SO AurangabadBH",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "AurangabadBihar Division"
  },
  "824209": {
    "state": "Bihar",
    "district": "Gaya",
    "block": "Paraiya",
    "officename": "Paraiya SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "824210": {
    "state": "Bihar",
    "district": "Gaya",
    "block": "Raniganj",
    "officename": "Raniganj SO Gaya",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "824211": {
    "state": "Bihar",
    "district": "Gaya",
    "block": "Sherghati",
    "officename": "Sherghati SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "824217": {
    "state": "Bihar",
    "district": "Gaya",
    "block": "Bankey Bazar",
    "officename": "Bankey Bajar SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "824219": {
    "state": "Bihar",
    "district": "Gaya",
    "block": "Amas",
    "officename": "Amas SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "824220": {
    "state": "Bihar",
    "district": "Gaya",
    "block": "Barachatti",
    "officename": "Dobhi SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "824221": {
    "state": "Bihar",
    "district": "Gaya",
    "block": "Imamganj",
    "officename": "Dumaria SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "824231": {
    "state": "Bihar",
    "district": "Gaya",
    "block": "Bodhgaya",
    "officename": "Bodhgaya SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "824232": {
    "state": "Bihar",
    "district": "Gaya",
    "block": "Mohanpur",
    "officename": "Fatehpur SO Gaya",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "824233": {
    "state": "Bihar",
    "district": "Gaya",
    "block": "Khijersarai",
    "officename": "Khizersarai SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "824234": {
    "state": "Bihar",
    "district": "Gaya",
    "block": "Gaya",
    "officename": "Magadh University SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "824235": {
    "state": "Bihar",
    "district": "Gaya",
    "block": "Tikari",
    "officename": "Mow SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "824236": {
    "state": "Bihar",
    "district": "Gaya",
    "block": "Tekari",
    "officename": "Tekari SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "824237": {
    "state": "Bihar",
    "district": "Gaya",
    "block": "Gurua",
    "officename": "Cherki SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gaya Division"
  },
  "824301": {
    "state": "Bihar",
    "district": "Aurangabad(BH)",
    "block": "Sherghati",
    "officename": "Nabinagar SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "AurangabadBihar Division"
  },
  "824302": {
    "state": "Bihar",
    "district": "Aurangabad(BH)",
    "block": "Nabinagar",
    "officename": "Tandwa SO AurangabadBH",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "AurangabadBihar Division"
  },
  "824303": {
    "state": "Bihar",
    "district": "Aurangabad(BH)",
    "block": "Nabinagar",
    "officename": "Nabinagar Road SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "AurangabadBihar Division"
  },
  "825101": {
    "state": "Jharkhand",
    "district": "Ramgarh",
    "block": "Gola",
    "officename": "Chittarpur SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "825102": {
    "state": "Jharkhand",
    "district": "Bokaro",
    "block": "Bermo",
    "officename": "Dhori SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Giridih Division"
  },
  "825103": {
    "state": "Jharkhand",
    "district": "Chatra",
    "block": "Simaria",
    "officename": "Simaria SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "825106": {
    "state": "Jharkhand",
    "district": "Giridh",
    "block": "Dumri",
    "officename": "Dumri SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Giridih Division"
  },
  "825108": {
    "state": "Jharkhand",
    "district": "Giridh",
    "block": "Giridih",
    "officename": "Pirtand SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Giridih Division"
  },
  "825109": {
    "state": "Jharkhand",
    "district": "Koderma",
    "block": "Jainagar",
    "officename": "Jainagar SO Koderma",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "825132": {
    "state": "Jharkhand",
    "district": "Koderma",
    "block": "NA",
    "officename": "Satgawan SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "825167": {
    "state": "Jharkhand",
    "district": "Giridh",
    "block": "Dumri",
    "officename": "Isri Bazar SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Giridih Division"
  },
  "825301": {
    "state": "Jharkhand",
    "district": "Hazaribag",
    "block": "Hazaribagh",
    "officename": "Hazaribagh HO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "825302": {
    "state": "Jharkhand",
    "district": "Hazaribag",
    "block": "Sadar",
    "officename": "College More SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "825303": {
    "state": "Jharkhand",
    "district": "Hazaribag",
    "block": "Churchu",
    "officename": "Korrah SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "825311": {
    "state": "Jharkhand",
    "district": "Hazaribag",
    "block": "Barkagaon",
    "officename": "Barkagaon SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "825312": {
    "state": "Jharkhand",
    "district": "Hazaribag",
    "block": "Bishungarh",
    "officename": "Bishungarh SO Hazaribag",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "825313": {
    "state": "Jharkhand",
    "district": "Hazaribag",
    "block": "Sadar",
    "officename": "Daroo SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "825314": {
    "state": "Jharkhand",
    "district": "Ramgarh",
    "block": "Mandu",
    "officename": "Ghatotand SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "825315": {
    "state": "Jharkhand",
    "district": "Bokaro",
    "block": "Konardam",
    "officename": "Konardam SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "825316": {
    "state": "Jharkhand",
    "district": "Ramgarh",
    "block": "Mandu",
    "officename": "Kuju SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "825317": {
    "state": "Jharkhand",
    "district": "Hazaribag",
    "block": "Hazaribagh",
    "officename": "BSF Meru SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "825318": {
    "state": "Jharkhand",
    "district": "Koderma",
    "block": "Markacho",
    "officename": "Markacho SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "825319": {
    "state": "Jharkhand",
    "district": "Hazaribag",
    "block": "Katakamsandi",
    "officename": "Reformatory School SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "825320": {
    "state": "Jharkhand",
    "district": "Giridh",
    "block": "Bagodar",
    "officename": "Suriya SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Giridih Division"
  },
  "825321": {
    "state": "Jharkhand",
    "district": "Chatra",
    "block": "Tandwa",
    "officename": "Tandwa SO Chatra",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "825322": {
    "state": "Jharkhand",
    "district": "Giridh",
    "block": "Bagodar",
    "officename": "Bagodar SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Giridih Division"
  },
  "825323": {
    "state": "Jharkhand",
    "district": "Koderma",
    "block": "Barkatha",
    "officename": "Barkatha SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "825324": {
    "state": "Jharkhand",
    "district": "Giridh",
    "block": "Birni",
    "officename": "Palounjia SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Giridih Division"
  },
  "825325": {
    "state": "Jharkhand",
    "district": "Ramgarh",
    "block": "Mandu",
    "officename": "Kedla SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "825326": {
    "state": "Jharkhand",
    "district": "Ramgarh",
    "block": "Churchu",
    "officename": "Tapin SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "825329": {
    "state": "Jharkhand",
    "district": "Giridh",
    "block": "Giridih",
    "officename": "Shikherjee SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Giridih Division"
  },
  "825330": {
    "state": "Jharkhand",
    "district": "Ramgarh",
    "block": "Gola",
    "officename": "Topa Coliery SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "825336": {
    "state": "Jharkhand",
    "district": "Hazaribag",
    "block": "Churchu",
    "officename": "Charhi SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "825401": {
    "state": "Jharkhand",
    "district": "Chatra",
    "block": "Chatra",
    "officename": "Chatra SO Chatra",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "825402": {
    "state": "Jharkhand",
    "district": "Hazaribag",
    "block": "Ichak",
    "officename": "Ichak SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "825403": {
    "state": "Jharkhand",
    "district": "Chatra",
    "block": "Hunterganj",
    "officename": "Jori SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "825404": {
    "state": "Jharkhand",
    "district": "Chatra",
    "block": "Pratappur",
    "officename": "Pratappur SO Chatra",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "825405": {
    "state": "Jharkhand",
    "district": "Hazaribag",
    "block": "Barhi",
    "officename": "Barhi SO Hazaribag",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "825406": {
    "state": "Jharkhand",
    "district": "Hazaribag",
    "block": "Chauparan",
    "officename": "Chouparan SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "825407": {
    "state": "Jharkhand",
    "district": "Koderma",
    "block": "Kodarma",
    "officename": "Domchanch SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "825408": {
    "state": "Jharkhand",
    "district": "Chatra",
    "block": "Itkhori",
    "officename": "Itkhori SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "825409": {
    "state": "Jharkhand",
    "district": "Koderma",
    "block": "Kodarma",
    "officename": "Jhumri Telaiya SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "825410": {
    "state": "Jharkhand",
    "district": "Koderma",
    "block": "Kodarma",
    "officename": "Kodarma SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "825411": {
    "state": "Jharkhand",
    "district": "Hazaribag",
    "block": "Padma",
    "officename": "Padma SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "825412": {
    "state": "Jharkhand",
    "district": "Giridh",
    "block": "Dhanwar",
    "officename": "Rajdhanwarf SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Giridih Division"
  },
  "825413": {
    "state": "Jharkhand",
    "district": "Koderma",
    "block": "Kodarma",
    "officename": "Telaiya Dam SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "825418": {
    "state": "Jharkhand",
    "district": "Koderma",
    "block": "Kodarma",
    "officename": "Domchanch Bazar SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "825421": {
    "state": "Jharkhand",
    "district": "Koderma",
    "block": "Koderma",
    "officename": "Koderma Thermal Power Station SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "826001": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Dhanbad HO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "826003": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Jagjivan Nagar SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "826004": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Indian School Of Mines SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "826005": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "BCCl Township SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "827001": {
    "state": "Jharkhand",
    "district": "Bokaro",
    "block": "Chas",
    "officename": "Bokaro Steel City HO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "827003": {
    "state": "Jharkhand",
    "district": "Bokaro",
    "block": "Chas",
    "officename": "Sector III SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "827004": {
    "state": "Jharkhand",
    "district": "Bokaro",
    "block": "Chas",
    "officename": "Sector IV SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "827006": {
    "state": "Jharkhand",
    "district": "Bokaro",
    "block": "Chas",
    "officename": "SectorVI SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "827009": {
    "state": "Jharkhand",
    "district": "Bokaro",
    "block": "Bokaro",
    "officename": "Sector IX SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "827010": {
    "state": "Jharkhand",
    "district": "Bokaro",
    "block": "Chas",
    "officename": "BSCity RS SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "827012": {
    "state": "Jharkhand",
    "district": "Bokaro",
    "block": "Chas",
    "officename": "Marafari Colony SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "827013": {
    "state": "Jharkhand",
    "district": "Bokaro",
    "block": "Bokaro",
    "officename": "Chas SO Bokaro",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "827014": {
    "state": "Jharkhand",
    "district": "Bokaro",
    "block": "Chas",
    "officename": "Balidih SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "827302": {
    "state": "Jharkhand",
    "district": "Bokaro",
    "block": "Bokaro",
    "officename": "Kasmar SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828101": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Bansjora SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828103": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Bhelatand SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828104": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Bhuli SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828105": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Shramik Nagar SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828106": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Dhansar SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828107": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Domgarh SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828108": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Fri SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828109": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Govindpur SO Dhanbad",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828110": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Jealgora SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828111": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Jharia SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828112": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Jamadoba SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828113": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Katrasgarh SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828114": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Katras Bazar SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828115": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Khasjeena Gora SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828116": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Kusunda SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828117": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Kustore SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828119": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Patherdih SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828120": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Motinagar SO Dhanbad",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828121": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Sijua SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828122": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Sindri SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828123": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "SIT SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828124": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "ACC Colony SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828125": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Bokaro",
    "officename": "Sonardih SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828126": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Sudamdih SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828127": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Saraidhela SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828128": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Tundoo SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828129": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Moonidih SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828130": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "BPolytechnic SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828131": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Lodna SO Dhanbad",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828132": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Patherdih Coal Washery SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828133": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Bhulan Bararee SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828134": {
    "state": "Jharkhand",
    "district": "Bokaro",
    "block": "Bokaro",
    "officename": "Chandan Kiyari SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828135": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Chasnalla SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828201": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Baliapur SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828202": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Chirkunda SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828203": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Kumardhubi SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828204": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Mugma SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828205": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Nirsa Chatti SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828206": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Panchet Dam SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828207": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Maithon Dam SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828301": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Bhaga SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828302": {
    "state": "Jharkhand",
    "district": "Bokaro",
    "block": "Chas",
    "officename": "Bhowra SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828303": {
    "state": "Jharkhand",
    "district": "Bokaro",
    "block": "Chas",
    "officename": "Bhojudih SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828304": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Malkera SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828305": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Mohuda SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828306": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Nawagarh SO Dhanbad",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828307": {
    "state": "Jharkhand",
    "district": "Bokaro",
    "block": "Bokaro",
    "officename": "Nudkhurkee SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828309": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Jitpur SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828401": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Gomoh SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828402": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Topchanchi SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828403": {
    "state": "Jharkhand",
    "district": "Bokaro",
    "block": "Bokaro",
    "officename": "Chandrapura SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Giridih Division"
  },
  "828404": {
    "state": "Jharkhand",
    "district": "Bokaro",
    "block": "Bokaro",
    "officename": "Dugdha Coal washery SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Giridih Division"
  },
  "829101": {
    "state": "Jharkhand",
    "district": "Ramgarh",
    "block": "Ramgarh",
    "officename": "Argada SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "829102": {
    "state": "Jharkhand",
    "district": "Ramgarh",
    "block": "Ramgarh",
    "officename": "Barkakana SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "829103": {
    "state": "Jharkhand",
    "district": "Ramgarh",
    "block": "Ramgarh",
    "officename": "Barkakana NTS SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "829104": {
    "state": "Jharkhand",
    "district": "Bokaro",
    "block": "Bokaro",
    "officename": "Bermo SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Giridih Division"
  },
  "829105": {
    "state": "Jharkhand",
    "district": "Ramgarh",
    "block": "Ramgarh",
    "officename": "Bhadaninagar SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "829106": {
    "state": "Jharkhand",
    "district": "Ramgarh",
    "block": "Patratu",
    "officename": "Bhurkunda Bazar SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "829107": {
    "state": "Jharkhand",
    "district": "Bokaro",
    "block": "Bokaro",
    "officename": "Bokaro Thermal SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Giridih Division"
  },
  "829108": {
    "state": "Jharkhand",
    "district": "Ramgarh",
    "block": "Ramgarh",
    "officename": "Giddi A SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "829109": {
    "state": "Jharkhand",
    "district": "Ramgarh",
    "block": "Ramgarh",
    "officename": "Giddi C SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "829110": {
    "state": "Jharkhand",
    "district": "Ramgarh",
    "block": "Gola",
    "officename": "Gola SO Ramgarh",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "829111": {
    "state": "Jharkhand",
    "district": "Bokaro",
    "block": "Bokaro",
    "officename": "Gomia SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Giridih Division"
  },
  "829112": {
    "state": "Jharkhand",
    "district": "Bokaro",
    "block": "Gomia",
    "officename": "IEGomia SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Giridih Division"
  },
  "829113": {
    "state": "Jharkhand",
    "district": "Bokaro",
    "block": "Bokaro",
    "officename": "Jarangdih Colliery SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Giridih Division"
  },
  "829114": {
    "state": "Jharkhand",
    "district": "Bokaro",
    "block": "Bermo",
    "officename": "Jaridih Bazar SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Giridih Division"
  },
  "829116": {
    "state": "Jharkhand",
    "district": "Bokaro",
    "block": "Bokaro",
    "officename": "Kathara SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Giridih Division"
  },
  "829117": {
    "state": "Jharkhand",
    "district": "Ramgarh",
    "block": "Ramgarh",
    "officename": "Marar SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "829118": {
    "state": "Jharkhand",
    "district": "Ramgarh",
    "block": "Patratu",
    "officename": "Patratu SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "829119": {
    "state": "Jharkhand",
    "district": "Ramgarh",
    "block": "Patratu",
    "officename": "Patratu TPS SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "829121": {
    "state": "Jharkhand",
    "district": "Bokaro",
    "block": "Peterbar",
    "officename": "Peterbar SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Giridih Division"
  },
  "829122": {
    "state": "Jharkhand",
    "district": "Ramgarh",
    "block": "Ramgarh",
    "officename": "Ramgarh Cantt HO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "829123": {
    "state": "Jharkhand",
    "district": "Bokaro",
    "block": "Tenughat",
    "officename": "Right Bank Tenughat SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Giridih Division"
  },
  "829125": {
    "state": "Jharkhand",
    "district": "Ramgarh",
    "block": "Patratu",
    "officename": "Sayal SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "829126": {
    "state": "Jharkhand",
    "district": "Ramgarh",
    "block": "Patratu",
    "officename": "Sounda C SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "829127": {
    "state": "Jharkhand",
    "district": "Bokaro",
    "block": "Bermo",
    "officename": "Sunday Bazar SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Giridih Division"
  },
  "829128": {
    "state": "Jharkhand",
    "district": "Bokaro",
    "block": "Bermo",
    "officename": "Swang Colliery SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Giridih Division"
  },
  "829129": {
    "state": "Jharkhand",
    "district": "Ramgarh",
    "block": "Patratu",
    "officename": "Tenughat Dam SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Giridih Division"
  },
  "829130": {
    "state": "Jharkhand",
    "district": "Ramgarh",
    "block": "Ramgarh",
    "officename": "RAMGARH COURT SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "829131": {
    "state": "Jharkhand",
    "district": "Ramgarh",
    "block": "Ramgarh",
    "officename": "Src SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "829132": {
    "state": "Jharkhand",
    "district": "Bokaro",
    "block": "Bokaro",
    "officename": "Bhandaridah SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Giridih Division"
  },
  "829133": {
    "state": "Jharkhand",
    "district": "Ramgarh",
    "block": "Ramgarh",
    "officename": "Sounda D SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "829134": {
    "state": "Jharkhand",
    "district": "Ramgarh",
    "block": "Patratu",
    "officename": "Sarubera SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "829135": {
    "state": "Jharkhand",
    "district": "Ramgarh",
    "block": "Patratu",
    "officename": "Bhurkunda SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "829143": {
    "state": "Jharkhand",
    "district": "Ramgarh",
    "block": "Patratu",
    "officename": "Balkudra SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "829144": {
    "state": "Jharkhand",
    "district": "Bokaro",
    "block": "Bermo",
    "officename": "Phusro Bazar SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Giridih Division"
  },
  "829149": {
    "state": "Jharkhand",
    "district": "Bokaro",
    "block": "Bokaro",
    "officename": "TTPSLalpania SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Giridih Division"
  },
  "829150": {
    "state": "Jharkhand",
    "district": "Ramgarh",
    "block": "Gola",
    "officename": "Ramgarh Project SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "829201": {
    "state": "Jharkhand",
    "district": "Chatra",
    "block": "Bachra",
    "officename": "Bachra SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Palamau Division"
  },
  "829202": {
    "state": "Jharkhand",
    "district": "Latehar",
    "block": "Balumath",
    "officename": "Balumath SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Palamau Division"
  },
  "829203": {
    "state": "Jharkhand",
    "district": "Latehar",
    "block": "Chandwa",
    "officename": "Chandwa SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Palamau Division"
  },
  "829204": {
    "state": "Jharkhand",
    "district": "Latehar",
    "block": "Latehar",
    "officename": "Chhipadohar SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Palamau Division"
  },
  "829205": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Bundu",
    "officename": "Khalari SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Palamau Division"
  },
  "829206": {
    "state": "Jharkhand",
    "district": "Latehar",
    "block": "Latehar",
    "officename": "Latehar Hsgii SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Palamau Division"
  },
  "829207": {
    "state": "Jharkhand",
    "district": "Latehar",
    "block": "Latehar",
    "officename": "Latehar Rsso SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Palamau Division"
  },
  "829208": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Mander",
    "officename": "Mc Cluskiganj SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Palamau Division"
  },
  "829209": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Mander",
    "officename": "Ray SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Palamau Division"
  },
  "829210": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Dakra",
    "officename": "Dakra Colliery SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Palamau Division"
  },
  "829301": {
    "state": "Jharkhand",
    "district": "Bokaro",
    "block": "Bokaro",
    "officename": "Jaina SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "831001": {
    "state": "Jharkhand",
    "district": "East Singhbhum",
    "block": "Bistupur Bazar",
    "officename": "Jamshedpur HO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "831002": {
    "state": "Jharkhand",
    "district": "Seraikela-kharsawan",
    "block": "Dhalbhum",
    "officename": "Tatanagar SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "831003": {
    "state": "Jharkhand",
    "district": "East Singhbhum",
    "block": "Golmuri",
    "officename": "Golmuri SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "831004": {
    "state": "Jharkhand",
    "district": "East Singhbhum",
    "block": "Dhalbhum Jamshedpur",
    "officename": "Telco Works SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "831005": {
    "state": "Jharkhand",
    "district": "East Singhbhum",
    "block": "Kadma",
    "officename": "Kadma SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "831006": {
    "state": "Jharkhand",
    "district": "East Singhbhum",
    "block": "Jugsalai",
    "officename": "Jugsalai SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "831007": {
    "state": "Jharkhand",
    "district": "East Singhbhum",
    "block": "Burma Mines",
    "officename": "Burma Mines SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "831009": {
    "state": "Jharkhand",
    "district": "East Singhbhum",
    "block": "Agrico",
    "officename": "Agrico SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "831011": {
    "state": "Jharkhand",
    "district": "East Singhbhum",
    "block": "East Singhbhum",
    "officename": "Sonari SO East Singhbhum",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "831012": {
    "state": "Jharkhand",
    "district": "East Singhbhum",
    "block": "Mango",
    "officename": "Mango SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "831013": {
    "state": "Jharkhand",
    "district": "West Singhbhum",
    "block": "NA",
    "officename": "Adityapur SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "831014": {
    "state": "Jharkhand",
    "district": "Seraikela-kharsawan",
    "block": "Jamshedpur",
    "officename": "NIT SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "831015": {
    "state": "Jharkhand",
    "district": "East Singhbhum",
    "block": "Gobindpur",
    "officename": "Gobindpur Housing Colony SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "831016": {
    "state": "Jharkhand",
    "district": "East Singhbhum",
    "block": "Rahargora",
    "officename": "Rahargora SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "831017": {
    "state": "Jharkhand",
    "district": "East Singhbhum",
    "block": "Baridih Colony",
    "officename": "Baridih Colony SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "831019": {
    "state": "Jharkhand",
    "district": "East Singhbhum",
    "block": "NA",
    "officename": "Birsanagar SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "831020": {
    "state": "Jharkhand",
    "district": "East Singhbhum",
    "block": "Mango Notified Area",
    "officename": "Pardih",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "832101": {
    "state": "Jharkhand",
    "district": "East Singhbhum",
    "block": "Dhalbhum, Jamshedpur",
    "officename": "Baharagora SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "832102": {
    "state": "Jharkhand",
    "district": "East Singhbhum",
    "block": "Ghatshila",
    "officename": "Jadugoda Mines SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "832103": {
    "state": "Jharkhand",
    "district": "East Singhbhum",
    "block": "Moubhandar",
    "officename": "Moubhandar SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "832104": {
    "state": "Jharkhand",
    "district": "East Singhbhum",
    "block": "Dumaria",
    "officename": "Mosabani Mines SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "832105": {
    "state": "Jharkhand",
    "district": "East Singhbhum",
    "block": "Dhalbhum",
    "officename": "Patamda SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "832106": {
    "state": "Jharkhand",
    "district": "East Singhbhum",
    "block": "R.c.project",
    "officename": "Rakha Copper Project SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "832107": {
    "state": "Jharkhand",
    "district": "East Singhbhum",
    "block": "Tatanagar",
    "officename": "Sundarnagar SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "832108": {
    "state": "Jharkhand",
    "district": "Seraikela-kharsawan",
    "block": "Seraikella Kharsawan",
    "officename": "Gamharia SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "832109": {
    "state": "Jharkhand",
    "district": "Seraikela-kharsawan",
    "block": "A.i .area",
    "officename": "Adityapur Industrial Area SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "832111": {
    "state": "Jharkhand",
    "district": "East Singhbhum",
    "block": "NA",
    "officename": "Narwa Mines  SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "832112": {
    "state": "Jharkhand",
    "district": "East Singhbhum",
    "block": "Dhalbhum",
    "officename": "Boram SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "832301": {
    "state": "Jharkhand",
    "district": "East Singhbhum",
    "block": "East Singhbhum",
    "officename": "Chakulia SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "832302": {
    "state": "Jharkhand",
    "district": "East Singhbhum",
    "block": "Dhalbhum, Jamshedpur",
    "officename": "Dhalbhumgarh SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "832303": {
    "state": "Jharkhand",
    "district": "East Singhbhum",
    "block": "East Singhbhum",
    "officename": "Ghatsila SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "832304": {
    "state": "Jharkhand",
    "district": "East Singhbhum",
    "block": "Dhalbhum, Jamshedpur",
    "officename": "Mahulia SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "832401": {
    "state": "Jharkhand",
    "district": "Seraikela-kharsawan",
    "block": "East Singhbhum",
    "officename": "Chandil SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "832402": {
    "state": "Jharkhand",
    "district": "Seraikela-kharsawan",
    "block": "Gamharia",
    "officename": "Kandra SO Seraikelakharsawan",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "832403": {
    "state": "Jharkhand",
    "district": "Seraikela-kharsawan",
    "block": "Chandil",
    "officename": "Tiruldih SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "832404": {
    "state": "Jharkhand",
    "district": "Seraikela-kharsawan",
    "block": "Seraikella Kharsawan",
    "officename": "Chowka SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "833101": {
    "state": "Jharkhand",
    "district": "Seraikela-kharsawan",
    "block": "Amda",
    "officename": "Amda SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "833102": {
    "state": "Jharkhand",
    "district": "West Singhbhum",
    "block": "Chakradharpur",
    "officename": "Chakradharpur SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "833103": {
    "state": "Jharkhand",
    "district": "West Singhbhum",
    "block": "Goilkera",
    "officename": "Goilkera SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "833104": {
    "state": "Jharkhand",
    "district": "West Singhbhum",
    "block": "Chakradharpur",
    "officename": "Manoharpur SO West Singhbhum",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "833105": {
    "state": "Jharkhand",
    "district": "West Singhbhum",
    "block": "Chakradharpur",
    "officename": "Sonua SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "833106": {
    "state": "Jharkhand",
    "district": "West Singhbhum",
    "block": "Chiria",
    "officename": "Chiria SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "833201": {
    "state": "Jharkhand",
    "district": "West Singhbhum",
    "block": "Chaibasa",
    "officename": "Chaibasa HO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "833202": {
    "state": "Jharkhand",
    "district": "East Singhbhum",
    "block": "Chaibasa",
    "officename": "Tata College Chaibasa SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "833203": {
    "state": "Jharkhand",
    "district": "West Singhbhum",
    "block": "Jagannathpur",
    "officename": "Jagannathpur SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "833204": {
    "state": "Jharkhand",
    "district": "West Singhbhum",
    "block": "Chaibasa",
    "officename": "JMP Chowk SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "833212": {
    "state": "Jharkhand",
    "district": "West Singhbhum",
    "block": "Danguaposi",
    "officename": "Danguaposi SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "833213": {
    "state": "Jharkhand",
    "district": "West Singhbhum",
    "block": "Gua",
    "officename": "Gua SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "833214": {
    "state": "Jharkhand",
    "district": "West Singhbhum",
    "block": "Chaibasa",
    "officename": "Hatgamaria SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "833215": {
    "state": "Jharkhand",
    "district": "West Singhbhum",
    "block": "Chaibasa",
    "officename": "Jhinkpani SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "833216": {
    "state": "Jharkhand",
    "district": "Seraikela-kharsawan",
    "block": "Seraikella",
    "officename": "Kharsawangarh SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "833217": {
    "state": "Jharkhand",
    "district": "West Singhbhum",
    "block": "Chaibasa",
    "officename": "Noamundi SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "833218": {
    "state": "Jharkhand",
    "district": "West Singhbhum",
    "block": "Noamundi",
    "officename": "Noamundi Bazar SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "833219": {
    "state": "Jharkhand",
    "district": "Seraikela-kharsawan",
    "block": "Seraikella",
    "officename": "Seraikella SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "833220": {
    "state": "Jharkhand",
    "district": "Seraikela-kharsawan",
    "block": "Seraikera",
    "officename": "Sini SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "833221": {
    "state": "Jharkhand",
    "district": "West Singhbhum",
    "block": "Chaibasa",
    "officename": "Barajamda SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "833222": {
    "state": "Jharkhand",
    "district": "West Singhbhum",
    "block": "Kiriburu",
    "officename": "Kiriburu Base Camp SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "833223": {
    "state": "Jharkhand",
    "district": "West Singhbhum",
    "block": "Megahatuburu",
    "officename": "Meghahatuburu SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "834001": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Ranchi",
    "officename": "Ranchi GPO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ranchi Division"
  },
  "834002": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Ranchi",
    "officename": "Doranda HO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ranchi Division"
  },
  "834003": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Ranchi",
    "officename": "Hatia SO Ranchi",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ranchi Division"
  },
  "834004": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Ranchi",
    "officename": "Dhurwa SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ranchi Division"
  },
  "834005": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Ranchi",
    "officename": "Hehal SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ranchi Division"
  },
  "834006": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Ranchi",
    "officename": "Kanke SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ranchi Division"
  },
  "834008": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Ranchi",
    "officename": "Ranchi University SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ranchi Division"
  },
  "834009": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Ranchi",
    "officename": "Ranchi Medical College SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ranchi Division"
  },
  "834010": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Namkum",
    "officename": "Namkum SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ranchi Division"
  },
  "834011": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Bero",
    "officename": "Krishnapuri S O",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ranchi Division"
  },
  "835101": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Silli",
    "officename": "Chotamuri SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ranchi Division"
  },
  "835102": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Silli",
    "officename": "Silli SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ranchi Division"
  },
  "835103": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Angara",
    "officename": "Tatisilway SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ranchi Division"
  },
  "835201": {
    "state": "Jharkhand",
    "district": "Simdega",
    "block": "Bano",
    "officename": "Bano SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gumla Division"
  },
  "835202": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Bero",
    "officename": "Bero SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ranchi Division"
  },
  "835203": {
    "state": "Jharkhand",
    "district": "Gumla",
    "block": "Gumla",
    "officename": "Bharno SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gumla Division"
  },
  "835204": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Bundu",
    "officename": "Bundu SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ranchi Division"
  },
  "835205": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Mandar",
    "officename": "Brambe SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ranchi Division"
  },
  "835206": {
    "state": "Jharkhand",
    "district": "Gumla",
    "block": "Chainpur",
    "officename": "Chainpur SO Gumla",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gumla Division"
  },
  "835207": {
    "state": "Jharkhand",
    "district": "Gumla",
    "block": "Gumla",
    "officename": "Gumla HO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gumla Division"
  },
  "835208": {
    "state": "Jharkhand",
    "district": "Gumla",
    "block": "Gumla",
    "officename": "Ghaghra SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gumla Division"
  },
  "835209": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Karra",
    "officename": "Karra SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ranchi Division"
  },
  "835210": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Khunti",
    "officename": "Khunti SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ranchi Division"
  },
  "835211": {
    "state": "Jharkhand",
    "district": "Simdega",
    "block": "Kolibira",
    "officename": "Kolebira SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gumla Division"
  },
  "835212": {
    "state": "Jharkhand",
    "district": "Simdega",
    "block": "Simdega",
    "officename": "Kurdeg SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gumla Division"
  },
  "835213": {
    "state": "Jharkhand",
    "district": "Lohardaga",
    "block": "Kuru",
    "officename": "Kuru SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gumla Division"
  },
  "835214": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Mandar",
    "officename": "Mandar SO Ranchi",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ranchi Division"
  },
  "835215": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Ranchi",
    "officename": "Mesra SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ranchi Division"
  },
  "835216": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Murhu",
    "officename": "Murhu SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ranchi Division"
  },
  "835217": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Ranchi",
    "officename": "Neori Vikas Vidyalaya SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ranchi Division"
  },
  "835218": {
    "state": "Jharkhand",
    "district": "Lohardaga",
    "block": "Lohardaga",
    "officename": "Netarhat SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gumla Division"
  },
  "835219": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Ormanjhi",
    "officename": "Ormanjhi SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ranchi Division"
  },
  "835220": {
    "state": "Jharkhand",
    "district": "Gumla",
    "block": "Gumla",
    "officename": "Palkot SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gumla Division"
  },
  "835221": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Ranchi",
    "officename": "Tupudana SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ranchi Division"
  },
  "835222": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Ratu",
    "officename": "Ratu SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ranchi Division"
  },
  "835223": {
    "state": "Jharkhand",
    "district": "Simdega",
    "block": "Simdega",
    "officename": "Simdega SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gumla Division"
  },
  "835225": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Tamar",
    "officename": "Tamar SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ranchi Division"
  },
  "835226": {
    "state": "Jharkhand",
    "district": "Simdega",
    "block": "Thethaitangar",
    "officename": "Thethaitangar SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gumla Division"
  },
  "835227": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Torpa",
    "officename": "Torpa SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ranchi Division"
  },
  "835228": {
    "state": "Jharkhand",
    "district": "Simdega",
    "block": "Simdega",
    "officename": "Biru SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gumla Division"
  },
  "835229": {
    "state": "Jharkhand",
    "district": "Gumla",
    "block": "Basia",
    "officename": "Basia SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gumla Division"
  },
  "835230": {
    "state": "Jharkhand",
    "district": "Gumla",
    "block": "Noadih",
    "officename": "Noadih SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gumla Division"
  },
  "835231": {
    "state": "Jharkhand",
    "district": "Gumla",
    "block": "Gumla",
    "officename": "Bishunpur SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gumla Division"
  },
  "835232": {
    "state": "Jharkhand",
    "district": "Gumla",
    "block": "Nwagarh",
    "officename": "Nawagarh SO Gumla",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gumla Division"
  },
  "835233": {
    "state": "Jharkhand",
    "district": "Gumla",
    "block": "Toto",
    "officename": "Toto SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gumla Division"
  },
  "835234": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Karra",
    "officename": "Govindpur SO Ranchi",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ranchi Division"
  },
  "835235": {
    "state": "Jharkhand",
    "district": "Simdega",
    "block": "Simdega",
    "officename": "Gotra SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gumla Division"
  },
  "835301": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Itki",
    "officename": "Itki SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ranchi Division"
  },
  "835302": {
    "state": "Jharkhand",
    "district": "Lohardaga",
    "block": "Lohardaga",
    "officename": "Lohardaga SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gumla Division"
  },
  "835303": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Ratu",
    "officename": "Piskanagri SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ranchi Division"
  },
  "835325": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Bhandra",
    "officename": "Nagjua SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ranchi Division"
  },
  "841101": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Sonepur",
    "officename": "Sonepur SO Saran",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841201": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Bareja SO Saran",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841202": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Basant SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841203": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "Siwan",
    "officename": "Chainpur SO Siwan",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841204": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Chainwa SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841205": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Daudpur SO Saran",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841206": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Dayalpur SO Saran",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841207": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Dighwara SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841208": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Ekma SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841209": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Fulwaria Tajpur SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841210": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "Siswan",
    "officename": "Gangpur Siswan SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841211": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Gultenganj SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841212": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Jogia SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841213": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Kopa Samhota SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841214": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Lahladpur",
    "officename": "Kopa Bazar SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841215": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Maker SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841216": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Naraon SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841217": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Nayagaon SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841218": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Paiga SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841219": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Parsa SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841220": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Parsagarh SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841221": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Dariapur",
    "officename": "Sitalpur SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841222": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Dariapur",
    "officename": "Sutihar SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841223": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "Siswan",
    "officename": "Mohamadpur SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841224": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Panditpur SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841225": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Dighwara",
    "officename": "Pratappur SO Saran",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841226": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "Siwan",
    "officename": "Siwan HO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841227": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "Siwan",
    "officename": "Gaushalaroad Siwan SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841231": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "Andar",
    "officename": "Andar SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841232": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "Siwan",
    "officename": "Barhria SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841233": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "Siwan",
    "officename": "Daronda SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841234": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "Siwan",
    "officename": "Darauli SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841235": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "Siwan",
    "officename": "Done SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841236": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "Siwan",
    "officename": "Hasanpura SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841237": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "Siwan",
    "officename": "Hussainganj SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841238": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "Siwan",
    "officename": "Mahrajganj SO Siwan",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841239": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "Siwan",
    "officename": "Mairwa SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841240": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "Siwan",
    "officename": "Mahuwal Mahal SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841241": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "Siwan",
    "officename": "Pachrukhi SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841242": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "Siwan",
    "officename": "Paterhi SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841243": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "Siwan",
    "officename": "Sahpur SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841244": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "Siwan",
    "officename": "Takipur SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841245": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "Siwan",
    "officename": "Zeradei SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841286": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "Siwan",
    "officename": "Bakerganj SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841287": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "Siwan",
    "officename": "Asaon SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841301": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Chapra HO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841302": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Purwari Telpa SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841305": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Revelganj",
    "officename": "Revelganj SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841311": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Garkha",
    "officename": "Garkha SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841312": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Revelganj",
    "officename": "Gariba Tola SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841313": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Manjhi SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841316": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Naini SO Saran",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841401": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Amnour SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841402": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Aphar SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841403": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Baniapur SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841404": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "Siwan",
    "officename": "Bagaura SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841405": {
    "state": "Bihar",
    "district": "Gopalganj",
    "block": "Gopalganj",
    "officename": "Barauli SO Gopalganj",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841406": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "Siwan",
    "officename": "Basantpur SO Siwan",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841407": {
    "state": "Bihar",
    "district": "Gopalganj",
    "block": "Gopalganj",
    "officename": "Bishunpura SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841408": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "Bhagwanpur Hat",
    "officename": "Bhagwanpur Hat SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841409": {
    "state": "Bihar",
    "district": "Gopalganj",
    "block": "Gopalganj",
    "officename": "Dighwdubauli SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841410": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Dumarshan Bangra SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841411": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Ishuwapur SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841412": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Jalalpur Bazar SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841413": {
    "state": "Bihar",
    "district": "Gopalganj",
    "block": "Gopalganj",
    "officename": "Jamobazar SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841414": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Khaira SO Saran",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841415": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Khodaibagh SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841416": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "Lakri Nabiganj",
    "officename": "Kishunpura SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841417": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Masrakh SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841418": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Marhowrah HO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841419": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Mirzapur SO Saran",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841420": {
    "state": "Bihar",
    "district": "Gopalganj",
    "block": "Gopalganj",
    "officename": "Rajapatti SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841421": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Sarhwara SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841422": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "Bhagwanpur Hat",
    "officename": "Sahajitpur SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841423": {
    "state": "Bihar",
    "district": "Gopalganj",
    "block": "Gopalganj",
    "officename": "Sidhwalia SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841424": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Taraiya SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841425": {
    "state": "Bihar",
    "district": "Gopalganj",
    "block": "Gopalganj",
    "officename": "Bathubazar SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841426": {
    "state": "Bihar",
    "district": "Gopalganj",
    "block": "Gopalganj",
    "officename": "Bhore SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841427": {
    "state": "Bihar",
    "district": "Gopalganj",
    "block": "Gopalganj",
    "officename": "Garhmanjha SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841428": {
    "state": "Bihar",
    "district": "Gopalganj",
    "block": "Gopalganj",
    "officename": "Gopalganj HO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841434": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "Siwan",
    "officename": "Goreakothi SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841435": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "Siwan",
    "officename": "Guthni SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841436": {
    "state": "Bihar",
    "district": "Gopalganj",
    "block": "Gopalganj",
    "officename": "Hathwa SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841437": {
    "state": "Bihar",
    "district": "Gopalganj",
    "block": "Gopalganj",
    "officename": "Kateya SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841438": {
    "state": "Bihar",
    "district": "Gopalganj",
    "block": "Gopalganj",
    "officename": "Mirganj SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841439": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "Siwan",
    "officename": "Mustfabad SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841440": {
    "state": "Bihar",
    "district": "Gopalganj",
    "block": "Gopalganj",
    "officename": "Thawe SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841441": {
    "state": "Bihar",
    "district": "Gopalganj",
    "block": "Gopalganj",
    "officename": "Baghibazar SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841442": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Nagra SO Saran",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841443": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Gaura SO Saran",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841446": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "NA",
    "officename": "Narendrapur SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841460": {
    "state": "Bihar",
    "district": "Saran",
    "block": "Chapra",
    "officename": "Bhatha Sonho SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Saran Division"
  },
  "841501": {
    "state": "Bihar",
    "district": "Gopalganj",
    "block": "Gopalganj",
    "officename": "Kuchaikote SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841502": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "Siwan",
    "officename": "Khujhwa SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841503": {
    "state": "Bihar",
    "district": "Gopalganj",
    "block": "Gopalganj",
    "officename": "Nechwajalapur SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841504": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "Siwan",
    "officename": "Raghunathpur SO Siwan",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841505": {
    "state": "Bihar",
    "district": "Gopalganj",
    "block": "Gopalganj",
    "officename": "Sasamusa SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841506": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "Siwan",
    "officename": "Tarwara SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841507": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "Siwan",
    "officename": "Mora SO Siwan",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841508": {
    "state": "Bihar",
    "district": "Gopalganj",
    "block": "Gopalganj",
    "officename": "Bijaipur SO Gopalganj",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841509": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "Siwan",
    "officename": "Gabhirar SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "842001": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Muzaffarpur",
    "officename": "Muzaffarpur HO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "842002": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Mushahari",
    "officename": "Ramna SO Muzaffarpur",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "842003": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Muzaffarpur",
    "officename": "MIT SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "842004": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Bochaha",
    "officename": "Umanagar SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "842005": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Mushahari",
    "officename": "MIC SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "843101": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Saraiya",
    "officename": "Bakhra SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "843102": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Sakra",
    "officename": "Bariarpur SO Muzaffarpur",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "843103": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Bochaha",
    "officename": "Bochaha SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "843104": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Sakra",
    "officename": "Chandanpatti SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "843105": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Sakara",
    "officename": "Dholi SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "843106": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Kurhani",
    "officename": "Gidha SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "843107": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Paroo",
    "officename": "Geyaspur SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "843108": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Kanti",
    "officename": "PKolhua SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "843109": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Kanti",
    "officename": "Kanti SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "843110": {
    "state": "Bihar",
    "district": "Vaishali",
    "block": "Patepur",
    "officename": "Kumar Bajitpur SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vaishali Division"
  },
  "843111": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Motipur",
    "officename": "Motipur SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "843112": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Paroo",
    "officename": "Paroo SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "843113": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Bandra",
    "officename": "Patahi SO Muzaffarpur",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "843114": {
    "state": "Bihar",
    "district": "Vaishali",
    "block": "Patepur",
    "officename": "Patepur SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vaishali Division"
  },
  "843115": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Bandra",
    "officename": "Piar SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "843117": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Minapur",
    "officename": "Rampur Hari SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "843118": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Bochaha",
    "officename": "Sarfuddinpur SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "843119": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Kurhani",
    "officename": "Silout SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "843120": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Paroo",
    "officename": "Deoria SO Muzaffarpur",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "843121": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Muraul",
    "officename": "DACollege SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "843122": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Paroo",
    "officename": "Hardi SO Muzaffarpur",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "843123": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Motipur",
    "officename": "Jaintpur Estate SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "843124": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Motipur",
    "officename": "Kathaiya SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "843125": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Sahebganj",
    "officename": "Kurnowl SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "843126": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Minapur",
    "officename": "Saraiya Factory SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "843127": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Motipur",
    "officename": "Birihma Bazar SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "843128": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Minapur",
    "officename": "Minapur SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "843129": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Bochaha",
    "officename": "Narma SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "843130": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Kanti",
    "officename": "Kanti TPS SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "843301": {
    "state": "Bihar",
    "district": "Sitamarhi",
    "block": "Dumra",
    "officename": "Sitamarhi HO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Sitamarhi Division"
  },
  "843302": {
    "state": "Bihar",
    "district": "Sitamarhi",
    "block": "Dumra",
    "officename": "Sitamarhi Bazar SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Sitamarhi Division"
  },
  "843311": {
    "state": "Bihar",
    "district": "Sitamarhi",
    "block": "Runnisaidpur",
    "officename": "Athri SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Sitamarhi Division"
  },
  "843312": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Aurai",
    "officename": "Aurai SO Muzaffarpur",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "843313": {
    "state": "Bihar",
    "district": "Sitamarhi",
    "block": "Bairgania",
    "officename": "Bairgania SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Sitamarhi Division"
  },
  "843314": {
    "state": "Bihar",
    "district": "Sitamarhi",
    "block": "Bajpatti",
    "officename": "Bajpatti SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Sitamarhi Division"
  },
  "843315": {
    "state": "Bihar",
    "district": "Sitamarhi",
    "block": "Majorganj",
    "officename": "Barharwa SO Sitamarhi",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Sitamarhi Division"
  },
  "843316": {
    "state": "Bihar",
    "district": "Sitamarhi",
    "block": "Belsand",
    "officename": "Belsand SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Sitamarhi Division"
  },
  "843317": {
    "state": "Bihar",
    "district": "Sitamarhi",
    "block": "Sonbarsa",
    "officename": "Bhutahi SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Sitamarhi Division"
  },
  "843318": {
    "state": "Bihar",
    "district": "Sitamarhi",
    "block": "Bokhra",
    "officename": "Budhnagra Deorhi SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Sitamarhi Division"
  },
  "843319": {
    "state": "Bihar",
    "district": "Sitamarhi",
    "block": "Choraut",
    "officename": "Choraut SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Sitamarhi Division"
  },
  "843320": {
    "state": "Bihar",
    "district": "Sitamarhi",
    "block": "Pupri",
    "officename": "Janakpur Road SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Sitamarhi Division"
  },
  "843321": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Katra",
    "officename": "Katra SO Muzaffarpur",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "843322": {
    "state": "Bihar",
    "district": "Sitamarhi",
    "block": "Sonbarsa",
    "officename": "Majhaulia Estate SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Sitamarhi Division"
  },
  "843323": {
    "state": "Bihar",
    "district": "Sitamarhi",
    "block": "R. Saidpur",
    "officename": "Manikchowk SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Sitamarhi Division"
  },
  "843324": {
    "state": "Bihar",
    "district": "Sitamarhi",
    "block": "Parihar",
    "officename": "Parihar SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Sitamarhi Division"
  },
  "843325": {
    "state": "Bihar",
    "district": "Sitamarhi",
    "block": "Parsauni",
    "officename": "Parsauni SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Sitamarhi Division"
  },
  "843326": {
    "state": "Bihar",
    "district": "Sitamarhi",
    "block": "Nanpur",
    "officename": "Raipur SO Sitamarhi",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Sitamarhi Division"
  },
  "843327": {
    "state": "Bihar",
    "district": "Sitamarhi",
    "block": "Riga",
    "officename": "Riga SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Sitamarhi Division"
  },
  "843328": {
    "state": "Bihar",
    "district": "Sitamarhi",
    "block": "R.saidpur",
    "officename": "Runnisaidpur SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Sitamarhi Division"
  },
  "843329": {
    "state": "Bihar",
    "district": "Sheohar",
    "block": "Sheohar",
    "officename": "Sheohar SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Sitamarhi Division"
  },
  "843330": {
    "state": "Bihar",
    "district": "Sitamarhi",
    "block": "Sonbersa",
    "officename": "Sonbersa SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Sitamarhi Division"
  },
  "843331": {
    "state": "Bihar",
    "district": "Sitamarhi",
    "block": "Sursand",
    "officename": "Sursand SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Sitamarhi Division"
  },
  "843332": {
    "state": "Bihar",
    "district": "Sitamarhi",
    "block": "M. Ganj",
    "officename": "Majorganj SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Sitamarhi Division"
  },
  "843333": {
    "state": "Bihar",
    "district": "Sitamarhi",
    "block": "Nanpur",
    "officename": "Nanpur SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Sitamarhi Division"
  },
  "843334": {
    "state": "Bihar",
    "district": "Sheohar",
    "block": "Purnahiya",
    "officename": "Piprarhi SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Sitamarhi Division"
  },
  "843360": {
    "state": "Bihar",
    "district": "Sitamarhi",
    "block": "Katra",
    "officename": "Jajuar SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "844101": {
    "state": "Bihar",
    "district": "Vaishali",
    "block": "Hajipur",
    "officename": "Hajipur HO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vaishali Division"
  },
  "844102": {
    "state": "Bihar",
    "district": "Vaishali",
    "block": "Bidupur",
    "officename": "Hajipur IndArea SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vaishali Division"
  },
  "844103": {
    "state": "Bihar",
    "district": "Vaishali",
    "block": "Hajipur",
    "officename": "Anzanpeer Chok SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vaishali Division"
  },
  "844111": {
    "state": "Bihar",
    "district": "Vaishali",
    "block": "Paedhi Belsar",
    "officename": "Aniruddha Belsar SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vaishali Division"
  },
  "844112": {
    "state": "Bihar",
    "district": "Vaishali",
    "block": "Kurhani",
    "officename": "Baghi SO Muzaffarpur",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "844113": {
    "state": "Bihar",
    "district": "Vaishali",
    "block": "Vaishali",
    "officename": "Balukaram SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vaishali Division"
  },
  "844114": {
    "state": "Bihar",
    "district": "Vaishali",
    "block": "Bhagwanpur",
    "officename": "Bhagwanpur SO Vaishali",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vaishali Division"
  },
  "844115": {
    "state": "Bihar",
    "district": "Vaishali",
    "block": "Jhandaha",
    "officename": "Chaksikandar SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vaishali Division"
  },
  "844116": {
    "state": "Bihar",
    "district": "Vaishali",
    "block": "Rajapakar",
    "officename": "Dumari SO Vaishali",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vaishali Division"
  },
  "844117": {
    "state": "Bihar",
    "district": "Vaishali",
    "block": "Lalganj",
    "officename": "Dharhara SO Vaishali",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vaishali Division"
  },
  "844118": {
    "state": "Bihar",
    "district": "Vaishali",
    "block": "Goraul",
    "officename": "Goraul SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vaishali Division"
  },
  "844119": {
    "state": "Bihar",
    "district": "Vaishali",
    "block": "Goroul",
    "officename": "Ghataro SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vaishali Division"
  },
  "844120": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Kurhani",
    "officename": "Kurhani SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "844121": {
    "state": "Bihar",
    "district": "Vaishali",
    "block": "Lalganj",
    "officename": "Lalganj Vaishali SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vaishali Division"
  },
  "844122": {
    "state": "Bihar",
    "district": "Vaishali",
    "block": "Chehrakala",
    "officename": "Mahuwa SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vaishali Division"
  },
  "844123": {
    "state": "Bihar",
    "district": "Vaishali",
    "block": "Vaishali",
    "officename": "Prataptand SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vaishali Division"
  },
  "844124": {
    "state": "Bihar",
    "district": "Vaishali",
    "block": "Rajapakar",
    "officename": "Rajapakar SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vaishali Division"
  },
  "844125": {
    "state": "Bihar",
    "district": "Vaishali",
    "block": "Bhagwanpur",
    "officename": "Sarai SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vaishali Division"
  },
  "844126": {
    "state": "Bihar",
    "district": "Vaishali",
    "block": "Jhandaha",
    "officename": "Singhara SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vaishali Division"
  },
  "844127": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Kurhani",
    "officename": "Turki SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "844128": {
    "state": "Bihar",
    "district": "Vaishali",
    "block": "Vaishali",
    "officename": "Vaishali SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vaishali Division"
  },
  "844501": {
    "state": "Bihar",
    "district": "Vaishali",
    "block": "Mahnar",
    "officename": "Basudeopur Chandel SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vaishali Division"
  },
  "844502": {
    "state": "Bihar",
    "district": "Vaishali",
    "block": "Hajipur",
    "officename": "Bidupur Rs SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vaishali Division"
  },
  "844503": {
    "state": "Bihar",
    "district": "Vaishali",
    "block": "Bidupur",
    "officename": "Bidupur Bazar SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vaishali Division"
  },
  "844504": {
    "state": "Bihar",
    "district": "Vaishali",
    "block": "Sahdei Buzurg",
    "officename": "Desari SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vaishali Division"
  },
  "844505": {
    "state": "Bihar",
    "district": "Vaishali",
    "block": "Jandaha",
    "officename": "Jhandaha SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vaishali Division"
  },
  "844506": {
    "state": "Bihar",
    "district": "Vaishali",
    "block": "Mahnar",
    "officename": "Mahnar SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vaishali Division"
  },
  "844507": {
    "state": "Bihar",
    "district": "Vaishali",
    "block": "Mahnar",
    "officename": "Mahnar Road Rs SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vaishali Division"
  },
  "844508": {
    "state": "Bihar",
    "district": "Vaishali",
    "block": "Raghopur",
    "officename": "Raghopur SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vaishali Division"
  },
  "844509": {
    "state": "Bihar",
    "district": "Vaishali",
    "block": "Sahdai Buzurg",
    "officename": "Sahdei Buzurg SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vaishali Division"
  },
  "845101": {
    "state": "Bihar",
    "district": "West Champaran",
    "block": "Bettiah",
    "officename": "Bagaha SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "West Champaran Division"
  },
  "845103": {
    "state": "Bihar",
    "district": "West Champaran",
    "block": "Bettiah",
    "officename": "Harinagar SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "West Champaran Division"
  },
  "845104": {
    "state": "Bihar",
    "district": "West Champaran",
    "block": "Bettiah",
    "officename": "Madhubani SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "West Champaran Division"
  },
  "845105": {
    "state": "Bihar",
    "district": "West Champaran",
    "block": "Bettiah",
    "officename": "Naraipur SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "West Champaran Division"
  },
  "845106": {
    "state": "Bihar",
    "district": "West Champaran",
    "block": "Bettiah",
    "officename": "Ramnagar SO West Champaran",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "West Champaran Division"
  },
  "845107": {
    "state": "Bihar",
    "district": "West Champaran",
    "block": "Bettiah",
    "officename": "Valmiki Nagar SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "West Champaran Division"
  },
  "845301": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "Raxaul",
    "officename": "Adapur SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845302": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "Motihari",
    "officename": "Chauradano SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845303": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "Dhaka",
    "officename": "Ghora Sahan SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845304": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "Dhaka",
    "officename": "Kundwa Chainpur SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845305": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "Raxaul",
    "officename": "Raxaul SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845306": {
    "state": "Bihar",
    "district": "West Champaran",
    "block": "Bettiah",
    "officename": "Mainatand SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "West Champaran Division"
  },
  "845307": {
    "state": "Bihar",
    "district": "West Champaran",
    "block": "Bettiah",
    "officename": "Sikta SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "West Champaran Division"
  },
  "845315": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "Dhaka",
    "officename": "Bhelwa Circle SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845401": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "Motihari",
    "officename": "Motihari HO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845406": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "Chakia",
    "officename": "Rajepur Champaran SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845411": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "Areraj",
    "officename": "Areraj SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845412": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "Chakia",
    "officename": "Bara Chakia SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845413": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "Chakia",
    "officename": "Bakarpur Jagat SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845414": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "P.dayal",
    "officename": "Chaita SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845415": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "Sikrahana",
    "officename": "Chiraiya SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845416": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "Motihari",
    "officename": "Damodarpur SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845417": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "Areraj",
    "officename": "Dariapur SO East Champaran",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845418": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "Dhaka",
    "officename": "Dhaka SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845419": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "Areraj",
    "officename": "Gobindganj SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845420": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "P.dayal",
    "officename": "Gulwara Madhuban SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845422": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "Motihari",
    "officename": "Harsiddhi SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845423": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "Areraj",
    "officename": "Hussaini SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845424": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "Chakia",
    "officename": "Kesharia SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845425": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "Areraj",
    "officename": "Malahi SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845426": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "Chakia",
    "officename": "Mehsi SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845427": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "Dhaka",
    "officename": "Pachpakari SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845428": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "Pakari Dayal",
    "officename": "Pakari Dayal SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845429": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "Motihari",
    "officename": "Pipra Factory SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845430": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "P.dayal",
    "officename": "Phenhara SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845431": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "Raxaul",
    "officename": "Raghunathpur Bazar SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845432": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "Kalyanpur",
    "officename": "Rajpur SO East Champaran",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845433": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "Raxaul",
    "officename": "Ramgahrwa SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845434": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "Areraj",
    "officename": "Sangrampur SO East Champaran",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845435": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "Motihari",
    "officename": "Semra SO East Champaran",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845436": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "Motihari",
    "officename": "Tetaria Factory SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845437": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "Motihari",
    "officename": "Turkaulia SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845438": {
    "state": "Bihar",
    "district": "West Champaran",
    "block": "Bettiah",
    "officename": "Bettiah HO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "West Champaran Division"
  },
  "845440": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "Areraj",
    "officename": "Jaitapur Laukaria SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845449": {
    "state": "Bihar",
    "district": "West Champaran",
    "block": "Bettiah",
    "officename": "Chanpatia R S SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "West Champaran Division"
  },
  "845450": {
    "state": "Bihar",
    "district": "West Champaran",
    "block": "Bettiah",
    "officename": "Chuhari SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "West Champaran Division"
  },
  "845451": {
    "state": "Bihar",
    "district": "West Champaran",
    "block": "Bettiah",
    "officename": "DKShikarpur SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "West Champaran Division"
  },
  "845452": {
    "state": "Bihar",
    "district": "West Champaran",
    "block": "Bettiah",
    "officename": "Jogapatti SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "West Champaran Division"
  },
  "845453": {
    "state": "Bihar",
    "district": "West Champaran",
    "block": "Bettiah",
    "officename": "Lauriya SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "West Champaran Division"
  },
  "845454": {
    "state": "Bihar",
    "district": "West Champaran",
    "block": "Bettiah",
    "officename": "Majhaulia Rs SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "West Champaran Division"
  },
  "845455": {
    "state": "Bihar",
    "district": "West Champaran",
    "block": "Bettiah",
    "officename": "Narkaiaganj SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "West Champaran Division"
  },
  "845456": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "Motihari",
    "officename": "Sugauli SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845457": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "Dhaka",
    "officename": "Patahi SO East Champaran",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845458": {
    "state": "Bihar",
    "district": "East Champaran",
    "block": "Areraj",
    "officename": "Manguraha SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845459": {
    "state": "Bihar",
    "district": "West Champaran",
    "block": "Bettiah",
    "officename": "Jagdishpur SO West Champaran",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "West Champaran Division"
  },
  "846001": {
    "state": "Bihar",
    "district": "Darbhanga",
    "block": "Darbhanga",
    "officename": "Laheriasarai HO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "846002": {
    "state": "Bihar",
    "district": "Darbhanga",
    "block": "Darbhanga",
    "officename": "SHMC SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "846003": {
    "state": "Bihar",
    "district": "Darbhanga",
    "block": "Darbhanga",
    "officename": "DMC SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "846004": {
    "state": "Bihar",
    "district": "Darbhanga",
    "block": "Darbhanga",
    "officename": "Darbhanga HO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "846005": {
    "state": "Bihar",
    "district": "Darbhanga",
    "block": "Darbhanga",
    "officename": "Postal Traning Centre SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "846006": {
    "state": "Bihar",
    "district": "Darbhanga",
    "block": "Darbhanga",
    "officename": "Subhankarpur SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "846007": {
    "state": "Bihar",
    "district": "Darbhanga",
    "block": "Darbhanga",
    "officename": "Saramohanpur SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "846008": {
    "state": "Bihar",
    "district": "Darbhanga",
    "block": "Darbhanga",
    "officename": "K D S U SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "846009": {
    "state": "Bihar",
    "district": "Darbhanga",
    "block": "Darbhanga",
    "officename": "Laxmisagar SO Darbhanga",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "847101": {
    "state": "Bihar",
    "district": "Darbhanga",
    "block": "Darbhanga",
    "officename": "Anandpur SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "847102": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Benipatti",
    "officename": "Basaith Chandpura SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "847103": {
    "state": "Bihar",
    "district": "Darbhanga",
    "block": "Benipur",
    "officename": "Benipur SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "847104": {
    "state": "Bihar",
    "district": "Darbhanga",
    "block": "Darbhanga",
    "officename": "Bharwara SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "847105": {
    "state": "Bihar",
    "district": "Darbhanga",
    "block": "Darbhanga",
    "officename": "Baheri SO Darbhanga",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "847106": {
    "state": "Bihar",
    "district": "Darbhanga",
    "block": "Darbhanga",
    "officename": "Kansi Simri SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "847107": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Muzaffarpur",
    "officename": "Keotsa Baruari SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "847108": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Phulparas",
    "officename": "Narahiya SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "847109": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Jhanjharpur",
    "officename": "Tulapatganj SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "847115": {
    "state": "Bihar",
    "district": "Darbhanga",
    "block": "Darbhanga",
    "officename": "Muria SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "847121": {
    "state": "Bihar",
    "district": "Darbhanga",
    "block": "Darbhanga",
    "officename": "Keoti Ranway SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "847122": {
    "state": "Bihar",
    "district": "Darbhanga",
    "block": "Darbhanga",
    "officename": "Bisfi SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "847123": {
    "state": "Bihar",
    "district": "Darbhanga",
    "block": "Darbhanga",
    "officename": "Singhwara SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "847201": {
    "state": "Bihar",
    "district": "Darbhanga",
    "block": "Beniipur]",
    "officename": "Bahera SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "847203": {
    "state": "Bihar",
    "district": "Darbhanga",
    "block": "Darbhanga",
    "officename": "Biraul SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "847204": {
    "state": "Bihar",
    "district": "Darbhanga",
    "block": "Darbhanga",
    "officename": "Bishnupur SO Darbhanga",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "847211": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Sadar Madhubani",
    "officename": "Madhubani HO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "847212": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Madhubani",
    "officename": "Bhowara SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "847213": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Madhubani",
    "officename": "Mdb Bara Bazar SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "847214": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Madhubani",
    "officename": "M G Bazar SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "847215": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Madhubani",
    "officename": "RKCollage SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "847222": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Benipatti",
    "officename": "Arerhat SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "847223": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Benipatti",
    "officename": "Benipatti SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "847224": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Madhubani",
    "officename": "Baboobarhi SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "847225": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Jaynagar",
    "officename": "Basopatti SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "847226": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Jaynagar",
    "officename": "Jaynagar SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "847227": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Jhanjharpur",
    "officename": "Khutauna SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "847228": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Jaynagar",
    "officename": "Khajauli SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "847229": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Madhubani",
    "officename": "Kaluahi SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "847230": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Benipatti",
    "officename": "Khirhar SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "847231": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Madhubani",
    "officename": "Lohat SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "847232": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Madhubani",
    "officename": "Ladania SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "847233": {
    "state": "Bihar",
    "district": "Darbhanga",
    "block": "Benipur",
    "officename": "Nehra SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "847234": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Madhubani",
    "officename": "Pandaul SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "847235": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Madhubani",
    "officename": "Rajnagar SO Madhubani",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "847236": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Madhubani",
    "officename": "Rampatti SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "847238": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Madhubani",
    "officename": "Rahika SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "847239": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Madhubani",
    "officename": "Sakri Madhubani SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "847240": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Jaynagar",
    "officename": "Umgaon kothi SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "847301": {
    "state": "Bihar",
    "district": "Samastipur",
    "block": "Darbhanga",
    "officename": "Hayaghat Bilashpur SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "847302": {
    "state": "Bihar",
    "district": "Darbhanga",
    "block": "Darbhanga",
    "officename": "Jalley SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "847303": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Darbhanga",
    "officename": "Jogiara SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "847304": {
    "state": "Bihar",
    "district": "Darbhanga",
    "block": "Darbhanga",
    "officename": "Kamtaul SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "847305": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Benipatti",
    "officename": "Madhwapur SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "847306": {
    "state": "Bihar",
    "district": "Darbhanga",
    "block": "Darbhanga",
    "officename": "Pindaruch SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "847307": {
    "state": "Bihar",
    "district": "Darbhanga",
    "block": "Darbhanga",
    "officename": "Ratanpur SO Darbhanga",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "847308": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Benipatti",
    "officename": "Sahar SO Madhubani",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "847337": {
    "state": "Bihar",
    "district": "Darbhanga",
    "block": "Darbhanga",
    "officename": "Ryam Factory SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "847401": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Andhratharhi",
    "officename": "Andhra SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "847402": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Jhanjharpur",
    "officename": "Ghoghardiha SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "847403": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Jhanjharpur",
    "officename": "Jhanjharpur RS SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "847404": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Jhanjharpur",
    "officename": "Jhanjharpur SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "847405": {
    "state": "Bihar",
    "district": "Darbhanga",
    "block": "Benipur",
    "officename": "Kurso Nadiami SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "847407": {
    "state": "Bihar",
    "district": "Darbhanga",
    "block": "Darbhanga",
    "officename": "Lohna Road SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "847408": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Jhanjharpur",
    "officename": "Madhepur SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "847409": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Phulparas",
    "officename": "Phulparas SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "847410": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Jhanjharpur",
    "officename": "Tamuria SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "847411": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Andhratharhi",
    "officename": "Rudrapur SO Madhubani",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "847421": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Phulparas",
    "officename": "Laukaha SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "847422": {
    "state": "Bihar",
    "district": "Darbhanga",
    "block": "Benipur",
    "officename": "Manigachi SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "847423": {
    "state": "Bihar",
    "district": "Darbhanga",
    "block": "Benipur",
    "officename": "Putai SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "847424": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Jhanjharpur",
    "officename": "Sarisavpahi SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "847427": {
    "state": "Bihar",
    "district": "Darbhanga",
    "block": "Biraul",
    "officename": "Ghanshyampur SO Darbhanga",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "847428": {
    "state": "Bihar",
    "district": "Darbhanga",
    "block": "Darbhanga",
    "officename": "Bharathi SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "847429": {
    "state": "Bihar",
    "district": "Darbhanga",
    "block": "Darbhanga",
    "officename": "Kusothar SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "847451": {
    "state": "Bihar",
    "district": "Supaul",
    "block": "Nirmali",
    "officename": "KUNAUALI BAZAR SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "847452": {
    "state": "Bihar",
    "district": "Supaul",
    "block": "Nirmali",
    "officename": "Nirmali SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "848101": {
    "state": "Bihar",
    "district": "Samastipur",
    "block": "Samastipur",
    "officename": "Samastipur HO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Samastipur Division"
  },
  "848102": {
    "state": "Bihar",
    "district": "Samastipur",
    "block": "Samastipur",
    "officename": "Nauraga SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Samastipur Division"
  },
  "848113": {
    "state": "Bihar",
    "district": "Samastipur",
    "block": "Pusa",
    "officename": "Birouli Rural Institute SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Samastipur Division"
  },
  "848114": {
    "state": "Bihar",
    "district": "Samastipur",
    "block": "Samastipur",
    "officename": "Dalsinghsarai SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Samastipur Division"
  },
  "848115": {
    "state": "Bihar",
    "district": "Samastipur",
    "block": "Samastipur",
    "officename": "Dighra SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Samastipur Division"
  },
  "848117": {
    "state": "Bihar",
    "district": "Samastipur",
    "block": "Samastipur",
    "officename": "Ilmasnagar SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Samastipur Division"
  },
  "848121": {
    "state": "Bihar",
    "district": "Samastipur",
    "block": "Samastipur",
    "officename": "Morwa SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Samastipur Division"
  },
  "848122": {
    "state": "Bihar",
    "district": "Samastipur",
    "block": "Samastipur",
    "officename": "Madhopur Dighrua SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Samastipur Division"
  },
  "848125": {
    "state": "Bihar",
    "district": "Samastipur",
    "block": "Samastipur",
    "officename": "Pusa SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Samastipur Division"
  },
  "848127": {
    "state": "Bihar",
    "district": "Samastipur",
    "block": "Samastipur",
    "officename": "Sarairanjan SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Samastipur Division"
  },
  "848129": {
    "state": "Bihar",
    "district": "Samastipur",
    "block": "Samastipur",
    "officename": "Shambhupatti SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Samastipur Division"
  },
  "848130": {
    "state": "Bihar",
    "district": "Samastipur",
    "block": "Samastipur",
    "officename": "Tajpur SO Samastipur",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Samastipur Division"
  },
  "848131": {
    "state": "Bihar",
    "district": "Samastipur",
    "block": "Samastipur",
    "officename": "Waini SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Samastipur Division"
  },
  "848132": {
    "state": "Bihar",
    "district": "Samastipur",
    "block": "Samastipur",
    "officename": "Ujiarpur SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Samastipur Division"
  },
  "848133": {
    "state": "Bihar",
    "district": "Samastipur",
    "block": "Samastipur",
    "officename": "Warish Nagar SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Samastipur Division"
  },
  "848134": {
    "state": "Bihar",
    "district": "Samastipur",
    "block": "Samastipur",
    "officename": "Jitwarpur SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Samastipur Division"
  },
  "848160": {
    "state": "Bihar",
    "district": "Samastipur",
    "block": "Samastipur",
    "officename": "Kalyanpur SO Samastipur",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Samastipur Division"
  },
  "848201": {
    "state": "Bihar",
    "district": "Begusarai",
    "block": "Khagaria",
    "officename": "BBazar SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "848202": {
    "state": "Bihar",
    "district": "Begusarai",
    "block": "Begusarai",
    "officename": "Meghaul SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "848203": {
    "state": "Bihar",
    "district": "Khagaria",
    "block": "Khagaria",
    "officename": "Sakarpura SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "848204": {
    "state": "Bihar",
    "district": "Begusarai",
    "block": "Begusarai",
    "officename": "Garhpura SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "848205": {
    "state": "Bihar",
    "district": "Samastipur",
    "block": "Samastipur",
    "officename": "Hassanpur S Mill SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Samastipur Division"
  },
  "848206": {
    "state": "Bihar",
    "district": "Samastipur",
    "block": "Samastipur",
    "officename": "Kundal SO Samastipur",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Samastipur Division"
  },
  "848207": {
    "state": "Bihar",
    "district": "Samastipur",
    "block": "Samastipur",
    "officename": "Bithan SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Samastipur Division"
  },
  "848208": {
    "state": "Bihar",
    "district": "Samastipur",
    "block": "Samastipur",
    "officename": "Mangalgarh SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Samastipur Division"
  },
  "848209": {
    "state": "Bihar",
    "district": "Samastipur",
    "block": "Samastipur",
    "officename": "Singhia SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Samastipur Division"
  },
  "848210": {
    "state": "Bihar",
    "district": "Samastipur",
    "block": "Samastipur",
    "officename": "Rosera SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Samastipur Division"
  },
  "848211": {
    "state": "Bihar",
    "district": "Samastipur",
    "block": "Bibhutpur",
    "officename": "Narhan SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Samastipur Division"
  },
  "848213": {
    "state": "Bihar",
    "district": "Darbhanga",
    "block": "Samastipur",
    "officename": "Kuseshwar Asthan SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Samastipur Division"
  },
  "848216": {
    "state": "Bihar",
    "district": "Samastipur",
    "block": "Samastipur",
    "officename": "Bihrha SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Samastipur Division"
  },
  "848236": {
    "state": "Bihar",
    "district": "Samastipur",
    "block": "Samastipur",
    "officename": "Singhia Ghat SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Samastipur Division"
  },
  "848301": {
    "state": "Bihar",
    "district": "Samastipur",
    "block": "Samastipur",
    "officename": "Kishanpur SO Samastipur",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Samastipur Division"
  },
  "848302": {
    "state": "Bihar",
    "district": "Samastipur",
    "block": "Samastipur",
    "officename": "Kalyanpur Chowk SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Samastipur Division"
  },
  "848501": {
    "state": "Bihar",
    "district": "Samastipur",
    "block": "Samastipur",
    "officename": "Mohiuddin Nagar SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Samastipur Division"
  },
  "848502": {
    "state": "Bihar",
    "district": "Samastipur",
    "block": "Samastipur",
    "officename": "Mohiuddin Nagar RS SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Samastipur Division"
  },
  "848503": {
    "state": "Bihar",
    "district": "Samastipur",
    "block": "Samastipur",
    "officename": "Vidhyapati Nagar SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Samastipur Division"
  },
  "848504": {
    "state": "Bihar",
    "district": "Samastipur",
    "block": "Samastipur",
    "officename": "Patory SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Samastipur Division"
  },
  "848505": {
    "state": "Bihar",
    "district": "Samastipur",
    "block": "Samastipur",
    "officename": "P Pur Halai",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Samastipur Division"
  },
  "848506": {
    "state": "Bihar",
    "district": "Samastipur",
    "block": "Samastipur",
    "officename": "Baghra SO Samastipur",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Samastipur Division"
  },
  "851101": {
    "state": "Bihar",
    "district": "Begusarai",
    "block": "Begusarai",
    "officename": "Begusarai HO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "851111": {
    "state": "Bihar",
    "district": "Begusarai",
    "block": "Begusarai",
    "officename": "Bachhawara SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "851112": {
    "state": "Bihar",
    "district": "Begusarai",
    "block": "Begusarai",
    "officename": "Barauni SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "851113": {
    "state": "Bihar",
    "district": "Begusarai",
    "block": "Begusarai",
    "officename": "BDeorhi SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "851114": {
    "state": "Bihar",
    "district": "Begusarai",
    "block": "Begusarai",
    "officename": "Barauni Oil Refinery SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "851115": {
    "state": "Bihar",
    "district": "Begusarai",
    "block": "Begusarai",
    "officename": "Barauni Urvark Nagar SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "851116": {
    "state": "Bihar",
    "district": "Begusarai",
    "block": "Begusarai",
    "officename": "BTPP SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "851117": {
    "state": "Bihar",
    "district": "Begusarai",
    "block": "Begusarai",
    "officename": "Refinery Township SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "851118": {
    "state": "Bihar",
    "district": "Begusarai",
    "block": "Begusarai",
    "officename": "Baro SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "851120": {
    "state": "Bihar",
    "district": "Begusarai",
    "block": "Teghra",
    "officename": "Bhagwanpur SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "851126": {
    "state": "Bihar",
    "district": "Begusarai",
    "block": "Begusarai",
    "officename": "Garhara SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "851127": {
    "state": "Bihar",
    "district": "Begusarai",
    "block": "Begusarai",
    "officename": "Manjhaul SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "851128": {
    "state": "Bihar",
    "district": "Begusarai",
    "block": "Begusarai",
    "officename": "Mansurchak SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "851129": {
    "state": "Bihar",
    "district": "Begusarai",
    "block": "Begusarai H.o",
    "officename": "Mirzapur Banduar SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "851130": {
    "state": "Bihar",
    "district": "Begusarai",
    "block": "Begusarai",
    "officename": "Naokothi SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "851131": {
    "state": "Bihar",
    "district": "Begusarai",
    "block": "Begusarai",
    "officename": "Rajaura SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "851132": {
    "state": "Bihar",
    "district": "Begusarai",
    "block": "Begusarai",
    "officename": "Sripur SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "851133": {
    "state": "Bihar",
    "district": "Begusarai",
    "block": "Begusarai",
    "officename": "Teghra SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "851134": {
    "state": "Bihar",
    "district": "Begusarai",
    "block": "Begusarai",
    "officename": "Ullao SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "851135": {
    "state": "Bihar",
    "district": "Begusarai",
    "block": "Begusarai",
    "officename": "Bihat SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "851201": {
    "state": "Bihar",
    "district": "Khagaria",
    "block": "Khagaria",
    "officename": "Chautham SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "851202": {
    "state": "Bihar",
    "district": "Khagaria",
    "block": "Khagaria",
    "officename": "Gogri SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "851203": {
    "state": "Bihar",
    "district": "Khagaria",
    "block": "Khagaria",
    "officename": "Jamalpur Gogri SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "851204": {
    "state": "Bihar",
    "district": "Khagaria",
    "block": "Khagaria",
    "officename": "Khagaria Mukhya Dakghar SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "851205": {
    "state": "Bihar",
    "district": "Khagaria",
    "block": "Khagaria",
    "officename": "Koshi College SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "851210": {
    "state": "Bihar",
    "district": "Begusarai",
    "block": "Begusarai",
    "officename": "Mahna SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "851211": {
    "state": "Bihar",
    "district": "Begusarai",
    "block": "Balia",
    "officename": "Lakhminia SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "851212": {
    "state": "Bihar",
    "district": "Khagaria",
    "block": "Khagaria",
    "officename": "Mohaddipur SO Khagaria",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "851213": {
    "state": "Bihar",
    "district": "Khagaria",
    "block": "Khagaria",
    "officename": "Maheshkhunt SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "851214": {
    "state": "Bihar",
    "district": "Khagaria",
    "block": "Khagaria",
    "officename": "Mansi SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "851215": {
    "state": "Bihar",
    "district": "Khagaria",
    "block": "Khagaria",
    "officename": "Naya Gaon SO Begusarai",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "851216": {
    "state": "Bihar",
    "district": "Khagaria",
    "block": "Khagaria",
    "officename": "Parbatta SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "851217": {
    "state": "Bihar",
    "district": "Begusarai",
    "block": "Begusarai",
    "officename": "Sahebpur Kamal SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "851218": {
    "state": "Bihar",
    "district": "Begusarai",
    "block": "Begusarai",
    "officename": "Suhird Nagar SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "852101": {
    "state": "Bihar",
    "district": "Madhepura",
    "block": "Bihariganj",
    "officename": "Behariganj SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852105": {
    "state": "Bihar",
    "district": "Supaul",
    "block": "Saraigarh",
    "officename": "Bhaptiyahi Bazar SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852106": {
    "state": "Bihar",
    "district": "Saharsa",
    "block": "Simri Bakhtiarpur",
    "officename": "Chapraon SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852107": {
    "state": "Bihar",
    "district": "Saharsa",
    "block": "Patarghat",
    "officename": "Dhabauli SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852108": {
    "state": "Bihar",
    "district": "Supaul",
    "block": "Gamaharia",
    "officename": "Gamaharia SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852109": {
    "state": "Bihar",
    "district": "Supaul",
    "block": "Raghopur",
    "officename": "Ganpatganj SO Supaul",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852110": {
    "state": "Bihar",
    "district": "Supaul",
    "block": "Supaul",
    "officename": "Garh Baruari SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852111": {
    "state": "Bihar",
    "district": "Supaul",
    "block": "Raghopur",
    "officename": "Jia Ram Raghopur SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852112": {
    "state": "Bihar",
    "district": "Madhepura",
    "block": "Kumarkhan",
    "officename": "Kumarkhand SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852113": {
    "state": "Bihar",
    "district": "Madhepura",
    "block": "Madhepura",
    "officename": "Madhepura MDG",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852114": {
    "state": "Bihar",
    "district": "Madhepura",
    "block": "Madhepura",
    "officename": "Budhma SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852115": {
    "state": "Bihar",
    "district": "Madhepura",
    "block": "Udakishanganj",
    "officename": "Gwalpara SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852116": {
    "state": "Bihar",
    "district": "Madhepura",
    "block": "Puraini",
    "officename": "Puraini Bazar SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852121": {
    "state": "Bihar",
    "district": "Madhepura",
    "block": "Madhepura",
    "officename": "Mathahi SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852122": {
    "state": "Bihar",
    "district": "Madhepura",
    "block": "Murliganj",
    "officename": "Murliganj SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852123": {
    "state": "Bihar",
    "district": "Supaul",
    "block": "Saraigarh",
    "officename": "Nauhatta SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852124": {
    "state": "Bihar",
    "district": "Saharsa",
    "block": "Satar Kataiya",
    "officename": "Panchgachiya SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852125": {
    "state": "Bihar",
    "district": "Supaul",
    "block": "Chhatapur",
    "officename": "Pratapganj SO Supaul",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852126": {
    "state": "Bihar",
    "district": "Saharsa",
    "block": "Salkhua",
    "officename": "Salkhua Bazar SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852127": {
    "state": "Bihar",
    "district": "Saharsa",
    "block": "Satar Kataiya",
    "officename": "Simri Bakhtiarpur SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852128": {
    "state": "Bihar",
    "district": "Madhepura",
    "block": "Singheshwar",
    "officename": "Singheshwar SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852129": {
    "state": "Bihar",
    "district": "Saharsa",
    "block": "Sonbersa Raj",
    "officename": "Sonbersa Raj SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852130": {
    "state": "Bihar",
    "district": "Supaul",
    "block": "Saraigarh",
    "officename": "Sukhpur SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852131": {
    "state": "Bihar",
    "district": "Supaul",
    "block": "Supaul",
    "officename": "Supaul HO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852132": {
    "state": "Bihar",
    "district": "Madhepura",
    "block": "Singheshwar",
    "officename": "Shankarpur Bazar SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852137": {
    "state": "Bihar",
    "district": "Supaul",
    "block": "Chhatapur",
    "officename": "Surpatganj SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852138": {
    "state": "Bihar",
    "district": "Supaul",
    "block": "Kishanpur",
    "officename": "Tharbitta SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852139": {
    "state": "Bihar",
    "district": "Supaul",
    "block": "Triveniganj",
    "officename": "Triveniganj SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852161": {
    "state": "Bihar",
    "district": "Khagaria",
    "block": "Khagaria",
    "officename": "Beldaur SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "852201": {
    "state": "Bihar",
    "district": "Saharsa",
    "block": "Kahara",
    "officename": "Saharsa HO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852202": {
    "state": "Bihar",
    "district": "Saharsa",
    "block": "Kahara",
    "officename": "Saharsa Collec SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852212": {
    "state": "Bihar",
    "district": "Saharsa",
    "block": "Kahra",
    "officename": "Bangaon SO Saharsa",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852213": {
    "state": "Bihar",
    "district": "Madhepura",
    "block": "Chausa",
    "officename": "Chausa SO Madhepura",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852214": {
    "state": "Bihar",
    "district": "Supaul",
    "block": "Tribeniganj",
    "officename": "Jadia SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852215": {
    "state": "Bihar",
    "district": "Supaul",
    "block": "Raghopur",
    "officename": "Karjain Bazar SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852216": {
    "state": "Bihar",
    "district": "Saharsa",
    "block": "Mahishi",
    "officename": "Mahishi SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852217": {
    "state": "Bihar",
    "district": "Saharsa",
    "block": "S.b.raj",
    "officename": "Mangwar SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852218": {
    "state": "Bihar",
    "district": "Supaul",
    "block": "Pipra Bazar",
    "officename": "Pipra Bazar SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852219": {
    "state": "Bihar",
    "district": "Madhepura",
    "block": "Alamnagar",
    "officename": "Shah Alam Nagar SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852220": {
    "state": "Bihar",
    "district": "Madhepura",
    "block": "Kishanganj",
    "officename": "Udakishunganj SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852221": {
    "state": "Bihar",
    "district": "Saharsa",
    "block": "Sour Bazar",
    "officename": "Sour Bazar SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "853201": {
    "state": "Bihar",
    "district": "Bhagalpur",
    "block": "Bihpur",
    "officename": "Bihpur SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Bhagalpur Division"
  },
  "853202": {
    "state": "Bihar",
    "district": "Bhagalpur",
    "block": "Kharik",
    "officename": "Karik Bazar SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Bhagalpur Division"
  },
  "853203": {
    "state": "Bihar",
    "district": "Bhagalpur",
    "block": "Narayanpur",
    "officename": "Narayanpur SO Bhagalpur",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Bhagalpur Division"
  },
  "853204": {
    "state": "Bihar",
    "district": "Bhagalpur",
    "block": "Naugachia",
    "officename": "Naugachia SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Bhagalpur Division"
  },
  "853205": {
    "state": "Bihar",
    "district": "Bhagalpur",
    "block": "Ismailpur",
    "officename": "STGoriar SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Bhagalpur Division"
  },
  "854101": {
    "state": "Bihar",
    "district": "Katihar",
    "block": "Katihar",
    "officename": "Ayodhyaganj Bazar SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Divisional Office Katihar"
  },
  "854102": {
    "state": "Bihar",
    "district": "Purnia",
    "block": "Purnea",
    "officename": "Chopra Ram Nagar SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Purnea Division"
  },
  "854103": {
    "state": "Bihar",
    "district": "Katihar",
    "block": "Katihar",
    "officename": "Daharia Molls SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Divisional Office Katihar"
  },
  "854104": {
    "state": "Bihar",
    "district": "Katihar",
    "block": "Katihar",
    "officename": "Gurubazar SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Divisional Office Katihar"
  },
  "854105": {
    "state": "Bihar",
    "district": "Katihar",
    "block": "Katihar",
    "officename": "Katihar HO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Divisional Office Katihar"
  },
  "854106": {
    "state": "Bihar",
    "district": "Katihar",
    "block": "Katihar",
    "officename": "Katihar Bmp Camp SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Divisional Office Katihar"
  },
  "854107": {
    "state": "Bihar",
    "district": "Katihar",
    "block": "Katihar",
    "officename": "Katihar Mill SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Divisional Office Katihar"
  },
  "854108": {
    "state": "Bihar",
    "district": "Katihar",
    "block": "Katihar",
    "officename": "Korha SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Divisional Office Katihar"
  },
  "854109": {
    "state": "Bihar",
    "district": "Katihar",
    "block": "Katihar",
    "officename": "Katihar Court SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Divisional Office Katihar"
  },
  "854112": {
    "state": "Bihar",
    "district": "Katihar",
    "block": "NA",
    "officename": "Amdabad SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Divisional Office Katihar"
  },
  "854113": {
    "state": "Bihar",
    "district": "Katihar",
    "block": "Katihar",
    "officename": "Manihari SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Divisional Office Katihar"
  },
  "854114": {
    "state": "Bihar",
    "district": "Katihar",
    "block": "Katihar",
    "officename": "Pothia SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Divisional Office Katihar"
  },
  "854115": {
    "state": "Bihar",
    "district": "Katihar",
    "block": "Katihar",
    "officename": "Semapur Factory SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Divisional Office Katihar"
  },
  "854116": {
    "state": "Bihar",
    "district": "Katihar",
    "block": "Katihar",
    "officename": "Mahadevpur SO Katihar",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Divisional Office Katihar"
  },
  "854117": {
    "state": "Bihar",
    "district": "Katihar",
    "block": "Katihar",
    "officename": "Rosna SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Divisional Office Katihar"
  },
  "854201": {
    "state": "Bihar",
    "district": "Purnia",
    "block": "Purnea",
    "officename": "Banaili SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Purnea Division"
  },
  "854202": {
    "state": "Bihar",
    "district": "Purnia",
    "block": "Purnea",
    "officename": "Banmankhi SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Purnea Division"
  },
  "854203": {
    "state": "Bihar",
    "district": "Purnia",
    "block": "Purnea",
    "officename": "Barhara Kothi SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Purnea Division"
  },
  "854204": {
    "state": "Bihar",
    "district": "Purnia",
    "block": "Purnea",
    "officename": "Bhawanipur Rajdham SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Purnea Division"
  },
  "854205": {
    "state": "Bihar",
    "district": "Purnia",
    "block": "Purnea",
    "officename": "Dhamdaha SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Purnea Division"
  },
  "854301": {
    "state": "Bihar",
    "district": "Purnia",
    "block": "Purnea",
    "officename": "Purnea HO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Purnea Division"
  },
  "854302": {
    "state": "Bihar",
    "district": "Purnia",
    "block": "Purnea",
    "officename": "Purnea City SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Purnea Division"
  },
  "854303": {
    "state": "Bihar",
    "district": "Purnia",
    "block": "Purnea",
    "officename": "Purnea Polyticnic SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Purnea Division"
  },
  "854304": {
    "state": "Bihar",
    "district": "Purnia",
    "block": "Purnea",
    "officename": "Purnea Chowk SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Purnea Division"
  },
  "854305": {
    "state": "Bihar",
    "district": "Purnia",
    "block": "Purnea",
    "officename": "Khuskibagh SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Purnea Division"
  },
  "854306": {
    "state": "Bihar",
    "district": "Purnia",
    "block": "Purnea",
    "officename": "Sarsi SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Purnea Division"
  },
  "854311": {
    "state": "Bihar",
    "district": "Araria",
    "block": "Araria",
    "officename": "Araria SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Purnea Division"
  },
  "854312": {
    "state": "Bihar",
    "district": "Araria",
    "block": "Araria",
    "officename": "Araria RS SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Purnea Division"
  },
  "854315": {
    "state": "Bihar",
    "district": "Purnia",
    "block": "Purnea",
    "officename": "Baisi SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Purnea Division"
  },
  "854316": {
    "state": "Bihar",
    "district": "Purnia",
    "block": "Purnea",
    "officename": "Bathnaha SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Purnea Division"
  },
  "854317": {
    "state": "Bihar",
    "district": "Katihar",
    "block": "Katihar",
    "officename": "Barsoighat SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Divisional Office Katihar"
  },
  "854318": {
    "state": "Bihar",
    "district": "Araria",
    "block": "Araria",
    "officename": "Forbesganj SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Purnea Division"
  },
  "854325": {
    "state": "Bihar",
    "district": "Purnia",
    "block": "Purnea",
    "officename": "Garhbanaili SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Purnea Division"
  },
  "854326": {
    "state": "Bihar",
    "district": "Purnia",
    "block": "Purnea",
    "officename": "Gulabbagh SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Purnea Division"
  },
  "854327": {
    "state": "Bihar",
    "district": "Purnia",
    "block": "Purnea",
    "officename": "Jalalgarh SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Purnea Division"
  },
  "854328": {
    "state": "Bihar",
    "district": "Araria",
    "block": "Araria",
    "officename": "Jogbani SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Purnea Division"
  },
  "854329": {
    "state": "Bihar",
    "district": "Araria",
    "block": "Araria",
    "officename": "Jokihat SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Purnea Division"
  },
  "854330": {
    "state": "Bihar",
    "district": "Purnia",
    "block": "Purnea",
    "officename": "Kasba SO Purnia",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Purnea Division"
  },
  "854331": {
    "state": "Bihar",
    "district": "Araria",
    "block": "Araria",
    "officename": "Kursakanta SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Purnea Division"
  },
  "854332": {
    "state": "Bihar",
    "district": "Araria",
    "block": "Araria",
    "officename": "Kuari SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Purnea Division"
  },
  "854333": {
    "state": "Bihar",
    "district": "Araria",
    "block": "Araria",
    "officename": "Madanpur SO Araria",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Purnea Division"
  },
  "854334": {
    "state": "Bihar",
    "district": "Araria",
    "block": "Araria",
    "officename": "Maryganj SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Purnea Division"
  },
  "854335": {
    "state": "Bihar",
    "district": "Araria",
    "block": "Araria",
    "officename": "Narpatganj SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Purnea Division"
  },
  "854336": {
    "state": "Bihar",
    "district": "Araria",
    "block": "Araria",
    "officename": "Nawabganj SO Araria",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Purnea Division"
  },
  "854337": {
    "state": "Bihar",
    "district": "Purnia",
    "block": "Purnea",
    "officename": "Ranipatra SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Purnea Division"
  },
  "854338": {
    "state": "Bihar",
    "district": "Supaul",
    "block": "Birpur",
    "officename": "Bhimnagar Bairrage SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "854339": {
    "state": "Bihar",
    "district": "Supaul",
    "block": "Saharsa",
    "officename": "Balua Bazar SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "854340": {
    "state": "Bihar",
    "district": "Supaul",
    "block": "Saraigarh",
    "officename": "Birpur SO Supaul",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "855101": {
    "state": "Bihar",
    "district": "Kishanganj",
    "block": "Kishanganj",
    "officename": "Bahadurganj SO Kishanganj",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Divisional Office Katihar"
  },
  "855102": {
    "state": "Bihar",
    "district": "Katihar",
    "block": "Katihar",
    "officename": "Barsoi SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Divisional Office Katihar"
  },
  "855105": {
    "state": "Bihar",
    "district": "Katihar",
    "block": "Katihar",
    "officename": "Durgaganj SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Divisional Office Katihar"
  },
  "855106": {
    "state": "Bihar",
    "district": "Kishanganj",
    "block": "Kishanganj",
    "officename": "Galgalia SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Divisional Office Katihar"
  },
  "855107": {
    "state": "Bihar",
    "district": "Kishanganj",
    "block": "Kishanganj",
    "officename": "Kishanganj SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Divisional Office Katihar"
  },
  "855108": {
    "state": "Bihar",
    "district": "Kishanganj",
    "block": "Kishanganj",
    "officename": "Kishanganj Bazar SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Divisional Office Katihar"
  },
  "855113": {
    "state": "Bihar",
    "district": "Katihar",
    "block": "Katihar",
    "officename": "Salmari SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Divisional Office Katihar"
  },
  "855114": {
    "state": "Bihar",
    "district": "Katihar",
    "block": "Katihar",
    "officename": "Sonaili SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Divisional Office Katihar"
  },
  "855115": {
    "state": "Bihar",
    "district": "Kishanganj",
    "block": "Kishanganj",
    "officename": "Sontha SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Divisional Office Katihar"
  },
  "855116": {
    "state": "Bihar",
    "district": "Kishanganj",
    "block": "Kishanganj",
    "officename": "Thakurganj SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Divisional Office Katihar"
  },
  "855117": {
    "state": "Bihar",
    "district": "Kishanganj",
    "block": "Kishanganj",
    "officename": "Taiyabpur SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Divisional Office Katihar"
  },
  "110099": {
    "state": "Delhi",
    "district": "North West",
    "block": "Delhi North",
    "officename": "ROHINI SECTOR 23 SO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Delhi North Division"
  },
  "110102": {
    "state": "Delhi",
    "district": "New Delhi",
    "block": "New Delhi Central",
    "officename": "NDC NDHO",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi Central Division"
  },
  "110106": {
    "state": "Delhi",
    "district": "North",
    "block": "Delhi Gpo",
    "officename": "DELHI GPO NDC",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Delhi GPO Division"
  },
  "110110": {
    "state": "Delhi",
    "district": "North West",
    "block": "Delhi North",
    "officename": "Nodal Delivery Centre(Parcel) Rohini",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Delhi North Division"
  },
  "110119": {
    "state": "Delhi",
    "district": "South East",
    "block": "New Delhi South",
    "officename": "KALKAJI NDC",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi South Division"
  },
  "110124": {
    "state": "Delhi",
    "district": "South",
    "block": "New Delhi South",
    "officename": "LAJPAT NAGAR NDC",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "New Delhi South Division"
  },
  "110151": {
    "state": "Delhi",
    "district": "Shahdara",
    "block": "Delhi East",
    "officename": "KRISHNA NAGAR NDC",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Delhi East Division"
  },
  "110195": {
    "state": "Delhi",
    "district": "Shahdara",
    "block": "Delhi East",
    "officename": "JHILMIL NDC",
    "circlename": "Delhi Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Delhi East Division"
  },
  "121014": {
    "state": "Haryana",
    "district": "Faridabad",
    "block": "Faridabad",
    "officename": "Greater Faridabad PO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Faridabad Division"
  },
  "121015": {
    "state": "Haryana",
    "district": "Faridabad",
    "block": "Faridabad",
    "officename": "Sector55 PO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Faridabad Division"
  },
  "122012": {
    "state": "Haryana",
    "district": "Gurugram",
    "block": "Gurgaon",
    "officename": "Vatika India Sec 82 SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "122098": {
    "state": "Haryana",
    "district": "Gurugram",
    "block": "Gurgaon",
    "officename": "CRPF Kadarpur SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "123031": {
    "state": "Haryana",
    "district": "Mahendragarh",
    "block": "Bhiwani",
    "officename": "Central University Haryana Mohindergarh SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhiwani Division"
  },
  "123304": {
    "state": "Haryana",
    "district": "Rewari",
    "block": "Gurgaon",
    "officename": "Nehrugarh SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gurgaon Division"
  },
  "124515": {
    "state": "Haryana",
    "district": "Rohtak",
    "block": "Rohtak",
    "officename": "MET Dadri Toe S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtak Division"
  },
  "125061": {
    "state": "Haryana",
    "district": "Hisar",
    "block": "Hissar",
    "officename": "Nagpur S.O.",
    "circlename": "Haryana Circle",
    "regionname": "NA",
    "divisionname": "Hissar Division"
  },
  "127311": {
    "state": "Haryana",
    "district": "Bhiwani",
    "block": "Bhiwani",
    "officename": "Neemariwali PO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhiwani Division"
  },
  "127312": {
    "state": "Haryana",
    "district": "Charki Dadri",
    "block": "Bhiwani",
    "officename": "Nihalgard PO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhiwani Division"
  },
  "131030": {
    "state": "Haryana",
    "district": "Sonipat",
    "block": "Sonepat",
    "officename": "TDI City Kundli SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sonepat Division"
  },
  "133008": {
    "state": "Haryana",
    "district": "Ambala",
    "block": "Ambala",
    "officename": "Majri S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "133010": {
    "state": "Haryana",
    "district": "Ambala",
    "block": "Ambala",
    "officename": "Defence Colony S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "134008": {
    "state": "Haryana",
    "district": "Ambala",
    "block": "Ambala",
    "officename": "Durga Nagar S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "134105": {
    "state": "Haryana",
    "district": "Panchkula",
    "block": "Ambala",
    "officename": "Amravati  Enclave SO",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ambala Division"
  },
  "136134": {
    "state": "Haryana",
    "district": "Kurukshetra",
    "block": "Kurukshetra",
    "officename": "Mohri S.O",
    "circlename": "Haryana Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Kurukshetra Division"
  },
  "140127": {
    "state": "Punjab",
    "district": "Rupnagar",
    "block": "Chandigarh",
    "officename": "New Nangram SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "140128": {
    "state": "Punjab",
    "district": "Rupnagar",
    "block": "Chandigarh",
    "officename": "DUMEWAL SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "140408": {
    "state": "Punjab",
    "district": "Fatehgarh Sahib",
    "block": "Patiala",
    "officename": "Chunni Kalan SO",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patiala Division"
  },
  "141011": {
    "state": "Punjab",
    "district": "Ludhiana",
    "block": "Ludhiana City",
    "officename": "Nodal Delivery Centre Ludhiana",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ludhiana City Division"
  },
  "143004": {
    "state": "Punjab",
    "district": "Amritsar",
    "block": "Amritsar",
    "officename": "Nodal Delivery Centre Amritsar",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Amritsar Division"
  },
  "145002": {
    "state": "Punjab",
    "district": "Gurdaspur",
    "block": "Gurdaspur",
    "officename": "Jugial Road Dharkalan S.O",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Gurdaspur Division"
  },
  "147008": {
    "state": "Punjab",
    "district": "Patiala",
    "block": "Patiala",
    "officename": "Nodal Delivery Center (Parcel)  Patiala",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patiala Division"
  },
  "151006": {
    "state": "Punjab",
    "district": "Bathinda",
    "block": "Bhatinda",
    "officename": "NDC Bathinda",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Bhatinda Division"
  },
  "151007": {
    "state": "Punjab",
    "district": "Bathinda",
    "block": "Bhatinda",
    "officename": "Air Force Station Bhisiana",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Bhatinda Division"
  },
  "151214": {
    "state": "Punjab",
    "district": "Faridkot",
    "block": "Faridkot",
    "officename": "Golewala S.O",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Faridkot Division"
  },
  "151511": {
    "state": "Punjab",
    "district": "Bathinda",
    "block": "Bhatinda",
    "officename": "KOT FATTA SO",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Bhatinda Division"
  },
  "152020": {
    "state": "Punjab",
    "district": "Fazilka",
    "block": "Ferozpur",
    "officename": "Railway Road Mandi  Ladhuka",
    "circlename": "Punjab Circle",
    "regionname": "Punjab West Region",
    "divisionname": "Ferozpur Division"
  },
  "160006": {
    "state": "Chandigarh",
    "district": "Chandigarh",
    "block": "Chandigarh",
    "officename": "NDC Chandigarh",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "160043": {
    "state": "Chandigarh",
    "district": "Chandigarh",
    "block": "Chandigarh",
    "officename": "Sector43 Chandigarh",
    "circlename": "Punjab Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chandigarh Division"
  },
  "171014": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Shimla",
    "officename": "Ghanahatti SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "171015": {
    "state": "Himachal Pradesh",
    "district": "Shimla",
    "block": "Shimla",
    "officename": "Baldeyan SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shimla Division"
  },
  "173033": {
    "state": "Himachal Pradesh",
    "district": "Sirmaur",
    "block": "Solan",
    "officename": "Narag",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173236": {
    "state": "Himachal Pradesh",
    "district": "Solan",
    "block": "Solan",
    "officename": "Kuthar SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "173237": {
    "state": "Himachal Pradesh",
    "district": "Solan",
    "block": "Solan",
    "officename": "Panjhera",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Solan Division"
  },
  "175020": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Mandi",
    "officename": "Gumma (Mandi) S.O",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175022": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Mandi",
    "officename": "Kelodhar",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175045": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Mandi",
    "officename": "Chail Chowk SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "175075": {
    "state": "Himachal Pradesh",
    "district": "Mandi",
    "block": "Mandi",
    "officename": "Kamand SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Mandi Division"
  },
  "176002": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Dehra Gopipur",
    "officename": "Tanda SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehra Gopipur Division"
  },
  "176067": {
    "state": "Himachal Pradesh",
    "district": "Kangra",
    "block": "Dharamsala",
    "officename": "Rajpur SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dharamsala Division"
  },
  "176307": {
    "state": "Himachal Pradesh",
    "district": "Chamba",
    "block": "Chamba",
    "officename": "Sahoo SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamba Division"
  },
  "176326": {
    "state": "Himachal Pradesh",
    "district": "Chamba",
    "block": "Chamba",
    "officename": "Holi SO",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamba Division"
  },
  "176330": {
    "state": "Himachal Pradesh",
    "district": "Chamba",
    "block": "Chamba",
    "officename": "Telka",
    "circlename": "Himachal Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Chamba Division"
  },
  "181008": {
    "state": "Jammu And Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Raipur Satwari",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "181134": {
    "state": "Jammu And Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "AIIMS Vijaypur",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jammu Division"
  },
  "181208": {
    "state": "Jammu And Kashmir",
    "district": "Jammu",
    "block": "Jammu",
    "officename": "Bawa Talab",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "182129": {
    "state": "Jammu And Kashmir",
    "district": "Doda",
    "block": "Udhampur",
    "officename": "Bhart BO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182130": {
    "state": "Jammu And Kashmir",
    "district": "Udhampur",
    "block": "Udhampur",
    "officename": "Sharanwan BO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182131": {
    "state": "Jammu And Kashmir",
    "district": "Doda",
    "block": "Udhampur",
    "officename": "Tipri BO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182132": {
    "state": "Jammu And Kashmir",
    "district": "Kishtwar",
    "block": "Udhampur",
    "officename": "Kither BO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182133": {
    "state": "Jammu And Kashmir",
    "district": "Kishtwar",
    "block": "Udhampur",
    "officename": "Sukhnai BO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182134": {
    "state": "Jammu And Kashmir",
    "district": "Kishtwar",
    "block": "Udhampur",
    "officename": "Gumri BO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182135": {
    "state": "Jammu And Kashmir",
    "district": "Kishtwar",
    "block": "Udhampur",
    "officename": "Rinaie BO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182136": {
    "state": "Jammu And Kashmir",
    "district": "Kishtwar",
    "block": "Udhampur",
    "officename": "Deherna BO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182137": {
    "state": "Jammu And Kashmir",
    "district": "Kishtwar",
    "block": "Udhampur",
    "officename": "Kadail BO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182138": {
    "state": "Jammu And Kashmir",
    "district": "Kishtwar",
    "block": "Udhampur",
    "officename": "Palali BO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182139": {
    "state": "Jammu And Kashmir",
    "district": "Kishtwar",
    "block": "Udhampur",
    "officename": "Garh Padder BO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182140": {
    "state": "Jammu And Kashmir",
    "district": "Kishtwar",
    "block": "Udhampur",
    "officename": "Kaban BO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "182207": {
    "state": "Jammu And Kashmir",
    "district": "Doda",
    "block": "Udhampur",
    "officename": "GANDOH SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Udhampur Division"
  },
  "184210": {
    "state": "Jammu And Kashmir",
    "district": "Kathua",
    "block": "Jammu",
    "officename": "Nagrota Gujroo SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Jammu Division"
  },
  "185133": {
    "state": "Jammu And Kashmir",
    "district": "Rajouri",
    "block": "Rajouri",
    "officename": "Post Graduate College Rajouri SO",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "JAMMU RN",
    "divisionname": "Rajouri Division"
  },
  "190099": {
    "state": "Jammu And Kashmir",
    "district": "Srinagar",
    "block": "Srinagar",
    "officename": "Nodal Delivery Center Srinagar",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "193109": {
    "state": "Jammu And Kashmir",
    "district": "Baramulla",
    "block": "Baramulla",
    "officename": "WAGOORA S.O",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Baramulla Division"
  },
  "193306": {
    "state": "Jammu And Kashmir",
    "district": "Pulwama",
    "block": "Srinagar",
    "officename": "Rajpora",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Srinagar Division"
  },
  "193505": {
    "state": "Jammu And Kashmir",
    "district": "Bandipora",
    "block": "Baramulla",
    "officename": "Aloosa S.O",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Baramulla Division"
  },
  "194107": {
    "state": "Ladakh",
    "district": "Leh Ladakh",
    "block": "Leh",
    "officename": "SASPOL S.O",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Leh Division"
  },
  "194202": {
    "state": "Ladakh",
    "district": "Leh Ladakh",
    "block": "Leh",
    "officename": "NYOMA MUD",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Leh Division"
  },
  "194303": {
    "state": "Ladakh",
    "district": "Kargil",
    "block": "Leh",
    "officename": "Panikhar S.O",
    "circlename": "Jammu Kashmir Circle",
    "regionname": "Srinagar HQ Region",
    "divisionname": "Leh Division"
  },
  "201018": {
    "state": "Uttar Pradesh",
    "district": "Ghaziabad",
    "block": "Ghaziabad",
    "officename": "Model Town SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Ghaziabad Division"
  },
  "201020": {
    "state": "Uttar Pradesh",
    "district": "Ghaziabad",
    "block": "Ghaziabad",
    "officename": "Khora SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Ghaziabad Division"
  },
  "201021": {
    "state": "Uttar Pradesh",
    "district": "Ghaziabad",
    "block": "Ghaziabad",
    "officename": "Abhay Khand 03 SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Ghaziabad Division"
  },
  "201022": {
    "state": "Uttar Pradesh",
    "district": "Hapur",
    "block": "Ghaziabad",
    "officename": "Bhojpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Ghaziabad Division"
  },
  "201302": {
    "state": "Uttar Pradesh",
    "district": "Gautam Buddha Nagar",
    "block": "Gautam Buddha Nagar Office",
    "officename": "NDC Noida",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Gautam Buddha Nagar Division office"
  },
  "201315": {
    "state": "Uttar Pradesh",
    "district": "Gautam Buddha Nagar",
    "block": "Gautam Buddha Nagar Office",
    "officename": "Gurjinder Vihar SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Gautam Buddha Nagar Division office"
  },
  "201316": {
    "state": "Uttar Pradesh",
    "district": "Gautam Buddha Nagar",
    "block": "Gautam Buddha Nagar Office",
    "officename": "Sec 122 Noida SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Gautam Buddha Nagar Division office"
  },
  "201317": {
    "state": "Uttar Pradesh",
    "district": "Gautam Buddha Nagar",
    "block": "Gautam Buddha Nagar Office",
    "officename": "Sec 128 Noida SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Gautam Buddha Nagar Division office"
  },
  "201318": {
    "state": "Uttar Pradesh",
    "district": "Gautam Buddha Nagar",
    "block": "Gautam Buddha Nagar Office",
    "officename": "Sec 01 Greater Noida SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Gautam Buddha Nagar Division office"
  },
  "203413": {
    "state": "Uttar Pradesh",
    "district": "Bulandshahr",
    "block": "Bulandshahar",
    "officename": "Agauta SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Bulandshahar Division"
  },
  "204217": {
    "state": "Uttar Pradesh",
    "district": "Aligarh",
    "block": "Aligarh",
    "officename": "Mendu SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Agra Region",
    "divisionname": "Aligarh Division"
  },
  "208028": {
    "state": "Uttar Pradesh",
    "district": "Kanpur Nagar",
    "block": "Kanpur Ho",
    "officename": "NDC Kanpur",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur HO Division"
  },
  "209860": {
    "state": "Uttar Pradesh",
    "district": "Unnao",
    "block": "Kanpur Moffusil",
    "officename": "Achalganj",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Kanpur Moffusil Division"
  },
  "210122": {
    "state": "Uttar Pradesh",
    "district": "Banda",
    "block": "Banda",
    "officename": "Oran S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Kanpur Region",
    "divisionname": "Banda Division"
  },
  "211020": {
    "state": "Uttar Pradesh",
    "district": "Prayagraj",
    "block": "Prayagraj",
    "officename": "Central PO Kumbh Mela SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "211021": {
    "state": "Uttar Pradesh",
    "district": "Prayagraj",
    "block": "Prayagraj",
    "officename": "Rajarshi Tondon Open University SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "211022": {
    "state": "Uttar Pradesh",
    "district": "Prayagraj",
    "block": "Prayagraj",
    "officename": "CRPF Group Center Ismailganj SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "211023": {
    "state": "Uttar Pradesh",
    "district": "Prayagraj",
    "block": "Prayagraj",
    "officename": "Prayagraj NDC",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "212110": {
    "state": "Uttar Pradesh",
    "district": "Prayagraj",
    "block": "Prayagraj",
    "officename": "Nari Bari S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "212308": {
    "state": "Uttar Pradesh",
    "district": "Prayagraj",
    "block": "Prayagraj",
    "officename": "NTPC Kohdar Meja SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Prayagraj Division"
  },
  "221012": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi East",
    "officename": "Awadhoot Bhagwan Ram Kusth Seva Ashram SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi East Division"
  },
  "221109": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi West",
    "officename": "Jayapur SO Varanasi",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi West Division"
  },
  "221111": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi East",
    "officename": "Danganj Bazar S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi East Division"
  },
  "221407": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi East",
    "officename": "NDC Varanasi",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi East Division"
  },
  "222004": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Jaunpur",
    "officename": "MALHANI BAZAR SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222126": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Jaunpur",
    "officename": "RAJA BAZAR SO JAUNPUR",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "222205": {
    "state": "Uttar Pradesh",
    "district": "Jaunpur",
    "block": "Jaunpur",
    "officename": "SULTANPUR SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Jaunpur Division"
  },
  "224239": {
    "state": "Uttar Pradesh",
    "district": "Ambedkar Nagar",
    "block": "Faizabad",
    "officename": "Indaipur S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Faizabad Division"
  },
  "228172": {
    "state": "Uttar Pradesh",
    "district": "Sultanpur",
    "block": "Sultanpur",
    "officename": "Belwai SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Prayagraj Regional Office",
    "divisionname": "Sultanpur Division"
  },
  "232114": {
    "state": "Uttar Pradesh",
    "district": "Varanasi",
    "block": "Varanasi East",
    "officename": "Chahania S.O.",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi East Division"
  },
  "232115": {
    "state": "Uttar Pradesh",
    "district": "Chandauli",
    "block": "Varanasi East",
    "officename": "Majidaha BO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Varanasi East Division"
  },
  "232341": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Ghazipur",
    "officename": "SUHWAL SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "233234": {
    "state": "Uttar Pradesh",
    "district": "Ghazipur",
    "block": "Ghazipur",
    "officename": "Sherpur Kalan SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Varanasi Region",
    "divisionname": "Ghazipur Division"
  },
  "244105": {
    "state": "Uttar Pradesh",
    "district": "Moradabad",
    "block": "Moradabad",
    "officename": "Vikas Bhawan Moradabad SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Moradabad Division"
  },
  "244720": {
    "state": "Uttarakhand",
    "district": "Udam Singh Nagar",
    "block": "Nainital",
    "officename": "SULTANPUR PATTI",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "246150": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Pauri",
    "officename": "Padampur Sukhro",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "246178": {
    "state": "Uttarakhand",
    "district": "Pauri Garhwal",
    "block": "Pauri",
    "officename": "Srikot SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pauri Division"
  },
  "247552": {
    "state": "Uttar Pradesh",
    "district": "Saharanpur",
    "block": "Saharanpur",
    "officename": "Biharigarh S.O",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Saharanpur Division"
  },
  "247658": {
    "state": "Uttarakhand",
    "district": "Haridwar",
    "block": "Dehradun",
    "officename": "Sultanpur SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "NA",
    "divisionname": "Dehradun Division"
  },
  "248016": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Dehradun",
    "officename": "Jollygrant SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "248018": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Dehradun",
    "officename": "Mehunwala SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "248019": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Dehradun",
    "officename": "Balawala SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "249127": {
    "state": "Uttarakhand",
    "district": "Tehri Garhwal",
    "block": "Tehri",
    "officename": "Rajakhet SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tehri Division"
  },
  "249136": {
    "state": "Uttarakhand",
    "district": "Uttar Kashi",
    "block": "Tehri",
    "officename": "Gangotri Seasonal SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Tehri Division"
  },
  "249206": {
    "state": "Uttarakhand",
    "district": "Dehradun",
    "block": "Dehradun",
    "officename": "Chiddarwala SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "249412": {
    "state": "Uttarakhand",
    "district": "Haridwar",
    "block": "Dehradun",
    "officename": "Navoday Nagar S.O",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dehradun Division"
  },
  "261304": {
    "state": "Uttar Pradesh",
    "district": "Sitapur",
    "block": "Sitapur",
    "officename": "Atariya SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Lucknow  HQ Region",
    "divisionname": "Sitapur Division"
  },
  "262123": {
    "state": "Uttar Pradesh",
    "district": "Pilibhit",
    "block": "Bareilly",
    "officename": "Jograjpur SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Bareilly Region",
    "divisionname": "Bareilly Division"
  },
  "262572": {
    "state": "Uttarakhand",
    "district": "Pithoragarh",
    "block": "Pithoragarh",
    "officename": "Muwani SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Pithoragarh Division"
  },
  "263141": {
    "state": "Uttarakhand",
    "district": "Nainital",
    "block": "Nainital",
    "officename": "Kathghariya SO",
    "circlename": "Uttarakhand Circle",
    "regionname": "NA",
    "divisionname": "Nainital Division"
  },
  "263142": {
    "state": "Uttarakhand",
    "district": "Nainital",
    "block": "Nainital",
    "officename": "Halduchaur S.O",
    "circlename": "Uttarakhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nainital Division"
  },
  "271806": {
    "state": "Uttar Pradesh",
    "district": "Bahraich",
    "block": "Bahraich",
    "officename": "Khutehna Chauraha SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Bahraich Division"
  },
  "272178": {
    "state": "Uttar Pradesh",
    "district": "Basti",
    "block": "Basti",
    "officename": "Munderwa SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Basti Division"
  },
  "273312": {
    "state": "Uttar Pradesh",
    "district": "Maharajganj",
    "block": "Gorakhpur",
    "officename": "CHOWK BAZAR SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Gorakhpur Division"
  },
  "274307": {
    "state": "Uttar Pradesh",
    "district": "Kushi Nagar",
    "block": "Deoria",
    "officename": "Padrauna Sugar Factory SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274308": {
    "state": "Uttar Pradesh",
    "district": "Kushi Nagar",
    "block": "Deoria",
    "officename": "Padrauna City SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "274309": {
    "state": "Uttar Pradesh",
    "district": "Kushi Nagar",
    "block": "Deoria",
    "officename": "Padrauna Chhavani SO",
    "circlename": "Uttar Pradesh Circle",
    "regionname": "Gorakhpur Region",
    "divisionname": "Deoria Division"
  },
  "302038": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur City",
    "officename": "Kookas S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur City Division"
  },
  "302041": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur City",
    "officename": "Bindayaka S.O.",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur City Division"
  },
  "302042": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur City",
    "officename": "Bad Ke Balaji S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur City Division"
  },
  "302044": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur City",
    "officename": "Govindpura S.O.",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur City Division"
  },
  "302046": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur City",
    "officename": "Bhanpur kalan S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur City Division"
  },
  "302047": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur City",
    "officename": "NDC Mansarowar",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur City Division"
  },
  "302048": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur City",
    "officename": "Sun City  S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur City Division"
  },
  "302049": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur City",
    "officename": "NDC Jaipur GPO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur City Division"
  },
  "303123": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur Moffusil",
    "officename": "Karansar SO",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "303124": {
    "state": "Rajasthan",
    "district": "Jaipur",
    "block": "Jaipur Moffusil",
    "officename": "HINGONIA S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jaipur Moffusil Division"
  },
  "304026": {
    "state": "Rajasthan",
    "district": "Tonk",
    "block": "Tonk",
    "officename": "Nagarfort S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Tonk Division"
  },
  "305006": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Ajmer",
    "officename": "NODAL DELIVERY CENTRE",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Ajmer Division"
  },
  "305631": {
    "state": "Rajasthan",
    "district": "Ajmer",
    "block": "Beawar",
    "officename": "RAMGARH S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Beawar Division"
  },
  "306604": {
    "state": "Rajasthan",
    "district": "Pali",
    "block": "Pali",
    "officename": "Jeewand Kalan S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Pali Division"
  },
  "307032": {
    "state": "Rajasthan",
    "district": "Sirohi",
    "block": "Sirohi",
    "officename": "BHARJA S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sirohi Division"
  },
  "311606": {
    "state": "Rajasthan",
    "district": "Bhilwara",
    "block": "Bhilwara",
    "officename": "Shyampura S. O.",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Bhilwara Division"
  },
  "312624": {
    "state": "Rajasthan",
    "district": "Pratapgarh",
    "block": "Chittorgarh",
    "officename": "Peepalkhunt S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312625": {
    "state": "Rajasthan",
    "district": "Pratapgarh",
    "block": "Chittorgarh",
    "officename": "Dhariawad S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312626": {
    "state": "Rajasthan",
    "district": "Pratapgarh",
    "block": "Chittorgarh",
    "officename": "Parsola S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312627": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Chittorgarh",
    "officename": "Sadas S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312628": {
    "state": "Rajasthan",
    "district": "Pratapgarh",
    "block": "Chittorgarh",
    "officename": "DEVGARH D.S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "312629": {
    "state": "Rajasthan",
    "district": "Chittorgarh",
    "block": "Chittorgarh",
    "officename": "SUHAGPURA DSO",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Chittorgarh Division"
  },
  "313805": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Udaipur",
    "officename": "Dhelana",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "313806": {
    "state": "Rajasthan",
    "district": "Udaipur",
    "block": "Udaipur",
    "officename": "Kalyanpur",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Udaipur Division"
  },
  "323026": {
    "state": "Rajasthan",
    "district": "Bundi",
    "block": "Tonk",
    "officename": "Dablana S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Tonk Division"
  },
  "325224": {
    "state": "Rajasthan",
    "district": "Baran",
    "block": "Jhalawar",
    "officename": "Kelwara S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Ajmer Region",
    "divisionname": "Jhalawar Division"
  },
  "332003": {
    "state": "Rajasthan",
    "district": "Sikar",
    "block": "Sikar",
    "officename": "NDC Sikar",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Sikar Division"
  },
  "333010": {
    "state": "Rajasthan",
    "district": "Jhunjhunu",
    "block": "Jhunjhunu",
    "officename": "Churella S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333020": {
    "state": "Rajasthan",
    "district": "Jhunjhunu",
    "block": "Jhunjhunu",
    "officename": "Chanana S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333055": {
    "state": "Rajasthan",
    "district": "Jhunjhunu",
    "block": "Jhunjhunu",
    "officename": "Kankaria S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "333517": {
    "state": "Rajasthan",
    "district": "Jhunjhunu",
    "block": "Jhunjhunu",
    "officename": "Bhainsawata Kalan S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Jhunjhunu Division"
  },
  "334002": {
    "state": "Chhattisgarh",
    "district": "Raipur",
    "block": "Bikaner",
    "officename": "NDC BIKANER",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Bikaner Division"
  },
  "334024": {
    "state": "Rajasthan",
    "district": "Bikaner",
    "block": "Bikaner",
    "officename": "GAJNER S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Bikaner Division"
  },
  "334025": {
    "state": "Rajasthan",
    "district": "Bikaner",
    "block": "Bikaner",
    "officename": "JASRASAR S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Bikaner Division"
  },
  "335042": {
    "state": "Rajasthan",
    "district": "Ganganagar",
    "block": "Sriganganagar",
    "officename": "BINJHBAILA  S.O.",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335521": {
    "state": "Rajasthan",
    "district": "Hanumangarh",
    "block": "Sriganganagar",
    "officename": "PURABSAR S.O.",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335522": {
    "state": "Rajasthan",
    "district": "Hanumangarh",
    "block": "Sriganganagar",
    "officename": "PALLU S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "335708": {
    "state": "Rajasthan",
    "district": "Ganganagar",
    "block": "Sriganganagar",
    "officename": "RAWLA S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Sriganganagar Division"
  },
  "341002": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Nagaur",
    "officename": "JODHIYASI S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341003": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Nagaur",
    "officename": "Alai S.O",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341020": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Nagaur",
    "officename": "PANCHORI S.O.",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341307": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Nagaur",
    "officename": "MITHRI MARWAR S.O.",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341309": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Nagaur",
    "officename": "DAULATPURA S.O.",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "341521": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Nagaur",
    "officename": "Idwa S.O.",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Nagaur Division"
  },
  "342002": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Jodhpur",
    "officename": "NDC Jodhpur",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342016": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Jodhpur",
    "officename": "Rajasthan High Court NB SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342017": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Jodhpur",
    "officename": "JHANWAR SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342029": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Jodhpur",
    "officename": "Soyla PO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342030": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Jodhpur",
    "officename": "IIT JODHPUR",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "342032": {
    "state": "Rajasthan",
    "district": "Jodhpur",
    "block": "Jodhpur",
    "officename": "Cherai SO",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Jodhpur Division"
  },
  "344802": {
    "state": "Rajasthan",
    "district": "Barmer",
    "block": "Barmer",
    "officename": "GIRA",
    "circlename": "Rajasthan Circle",
    "regionname": "Jodhpur Region",
    "divisionname": "Barmer Division"
  },
  "360026": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Rajkot",
    "officename": "Sapar Veraval SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Rajkot Division"
  },
  "360028": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Rajkot",
    "officename": "Rajkot Bedi DSO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Rajkot Division"
  },
  "360045": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Gondal",
    "officename": "Vasavad S.O",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Gondal Division"
  },
  "360325": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Gondal",
    "officename": "Sultanpur S.O",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Gondal Division"
  },
  "360465": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Gondal",
    "officename": "Derdi Kumbaji S.O",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Gondal Division"
  },
  "360485": {
    "state": "Gujarat",
    "district": "Rajkot",
    "block": "Gondal",
    "officename": "Amarnagar S.O",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Gondal Division"
  },
  "363623": {
    "state": "Gujarat",
    "district": "Morbi",
    "block": "Rajkot",
    "officename": "Dhuva S.O",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Rajkot Division"
  },
  "363643": {
    "state": "Gujarat",
    "district": "Morbi",
    "block": "Rajkot",
    "officename": "Sakat Sanala SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Rajkot Division"
  },
  "363745": {
    "state": "Gujarat",
    "district": "Surendranagar",
    "block": "Surendranagar",
    "officename": "Bajana SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Surendranagar Division"
  },
  "363750": {
    "state": "Gujarat",
    "district": "Surendranagar",
    "block": "Surendranagar",
    "officename": "Dasada SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Surendranagar Division"
  },
  "363755": {
    "state": "Gujarat",
    "district": "Surendranagar",
    "block": "Surendranagar",
    "officename": "Zinzuwada SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Surendranagar Division"
  },
  "363760": {
    "state": "Gujarat",
    "district": "Surendranagar",
    "block": "Surendranagar",
    "officename": "Kharaghoda SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Surendranagar Division"
  },
  "363765": {
    "state": "Gujarat",
    "district": "Surendranagar",
    "block": "Surendranagar",
    "officename": "Patdi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Surendranagar Division"
  },
  "363775": {
    "state": "Gujarat",
    "district": "Surendranagar",
    "block": "Surendranagar",
    "officename": "Lakhtar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Surendranagar Division"
  },
  "363780": {
    "state": "Gujarat",
    "district": "Surendranagar",
    "block": "Surendranagar",
    "officename": "Adariyana SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Surendranagar Division"
  },
  "365730": {
    "state": "Gujarat",
    "district": "Amreli",
    "block": "Amreli",
    "officename": "Timbi S.O",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Amreli Division"
  },
  "370641": {
    "state": "Gujarat",
    "district": "Kachchh",
    "block": "Kutch",
    "officename": "Jakhau SO",
    "circlename": "Gujarat Circle",
    "regionname": "Rajkot Region",
    "divisionname": "Kutch Division"
  },
  "380003": {
    "state": "Gujarat",
    "district": "Ahmadabad",
    "block": "Ahmedabad City",
    "officename": "DELIVERY HUB AHMEDABAD",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "380049": {
    "state": "Gujarat",
    "district": "Ahmadabad",
    "block": "Ahmedabad City",
    "officename": "Nikol SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "380057": {
    "state": "Gujarat",
    "district": "Ahmadabad",
    "block": "Ahmedabad City",
    "officename": "South Bopal S.O",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Ahmedabad City Division"
  },
  "382050": {
    "state": "Gujarat",
    "district": "Gandhinagar",
    "block": "Gandhinagar",
    "officename": "Gift City SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382055": {
    "state": "Gujarat",
    "district": "Gandhinagar",
    "block": "Gandhinagar",
    "officename": "IIT Gandhinagar SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382122": {
    "state": "Gujarat",
    "district": "Gandhinagar",
    "block": "Gandhinagar",
    "officename": "Dantali B.O",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382419": {
    "state": "Gujarat",
    "district": "Gandhinagar",
    "block": "Gandhinagar",
    "officename": "Kudasan SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382426": {
    "state": "Gujarat",
    "district": "Gandhinagar",
    "block": "Gandhinagar",
    "officename": "Koba SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382501": {
    "state": "Gujarat",
    "district": "Gandhinagar",
    "block": "Gandhinagar",
    "officename": "Shantigram S.O",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "382722": {
    "state": "Gujarat",
    "district": "Ahmadabad",
    "block": "Gandhinagar",
    "officename": "Santej SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Gandhinagar Division"
  },
  "383002": {
    "state": "Gujarat",
    "district": "Sabar Kantha",
    "block": "Sabarkantha",
    "officename": "Himatnagar Station Road SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Sabarkantha Division"
  },
  "384005": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Mahesana",
    "officename": "PANCHOT S.O",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384135": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Mahesana",
    "officename": "Brahmanwada SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384266": {
    "state": "Gujarat",
    "district": "Patan",
    "block": "Patan",
    "officename": "Patan Siddhraj Road SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Patan Division"
  },
  "384316": {
    "state": "Rajasthan",
    "district": "Nagaur",
    "block": "Mahesana",
    "officename": "Kansa SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384412": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Mahesana",
    "officename": "Modhera SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384415": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Mahesana",
    "officename": "Becharaji SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384440": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Mahesana",
    "officename": "Kadi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384441": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Mahesana",
    "officename": "Thol I E SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384445": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Mahesana",
    "officename": "Kalyanpura SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384450": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Mahesana",
    "officename": "Dangarwa SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384455": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Mahesana",
    "officename": "Ambaliasan SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384460": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Mahesana",
    "officename": "Jagudan SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384465": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Mahesana",
    "officename": "Langhnaj SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384470": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Mahesana",
    "officename": "Gozaria SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384515": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Mahesana",
    "officename": "Gavada SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384520": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Mahesana",
    "officename": "Gerita Kolavda RS SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384530": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Mahesana",
    "officename": "Kukarwada SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384540": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Mahesana",
    "officename": "Ladol SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384550": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Mahesana",
    "officename": "Pilvai SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384560": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Mahesana",
    "officename": "Sardarpur SO Mahesana",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384565": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Mahesana",
    "officename": "Vasai Dabhala SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "384570": {
    "state": "Gujarat",
    "district": "Mahesana",
    "block": "Mahesana",
    "officename": "Vijapur SO",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Mahesana Division"
  },
  "385581": {
    "state": "Gujarat",
    "district": "Banas Kantha",
    "block": "Banaskantha",
    "officename": "LAKHANI S.O",
    "circlename": "Gujarat Circle",
    "regionname": "Ahmedabad HQ Region",
    "divisionname": "Banaskantha Division"
  },
  "387003": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Kheda",
    "officename": "Petlad Road SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "387105": {
    "state": "Gujarat",
    "district": "Kheda",
    "block": "Kheda",
    "officename": "Haldharvas S.O",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Kheda Division"
  },
  "389135": {
    "state": "Gujarat",
    "district": "Dohad",
    "block": "Panchmahals",
    "officename": "Singvad SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Panchmahals Division"
  },
  "391776": {
    "state": "Gujarat",
    "district": "Vadodara",
    "block": "Vadodara West",
    "officename": "Manjusar GIDC",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Vadodara West Division"
  },
  "394112": {
    "state": "Gujarat",
    "district": "Surat",
    "block": "Surat",
    "officename": "GIPCL SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Surat Division"
  },
  "394652": {
    "state": "Gujarat",
    "district": "Tapi",
    "block": "Bardoli",
    "officename": "Panwadi SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Bardoli Division"
  },
  "396067": {
    "state": "Gujarat",
    "district": "Valsad",
    "block": "Valsad",
    "officename": "Kaprada SO",
    "circlename": "Gujarat Circle",
    "regionname": "Vadodara Region",
    "divisionname": "Valsad Division"
  },
  "401205": {
    "state": "Maharashtra",
    "district": "Palghar",
    "block": "Palghar",
    "officename": "Juchandra",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Palghar Division"
  },
  "403525": {
    "state": "Goa",
    "district": "North Goa",
    "block": "Goa",
    "officename": "Goa High Court S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Goa Division"
  },
  "410209": {
    "state": "Maharashtra",
    "district": "Raigad",
    "block": "Navi Mumbai",
    "officename": "KAMOTHE S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Navi Mumbai Region",
    "divisionname": "Navi Mumbai Division"
  },
  "410517": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune Moffusil",
    "officename": "Khodad",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "411067": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City West",
    "officename": "Aundh S.O (Pune)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City West Division"
  },
  "411068": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City West",
    "officename": "Nanded S.O (Pune)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City West Division"
  },
  "411069": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City West",
    "officename": "Baner DSO (Pune)",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City West Division"
  },
  "411070": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City East",
    "officename": "Moshi SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City East Division"
  },
  "411071": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City West",
    "officename": "Bavdhan SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City West Division"
  },
  "411073": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune City West",
    "officename": "Ambegaon Bk DSO",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune City West Division"
  },
  "411081": {
    "state": "Maharashtra",
    "district": "Pune",
    "block": "Pune Moffusil",
    "officename": "Charholi SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Pune Region",
    "divisionname": "Pune Moffusil Division"
  },
  "413625": {
    "state": "Maharashtra",
    "district": "Osmanabad",
    "block": "Osmanabad",
    "officename": "Itkur S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "413626": {
    "state": "Maharashtra",
    "district": "Osmanabad",
    "block": "Osmanabad",
    "officename": "Terkheda S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Osmanabad Division"
  },
  "415418": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Sangli Division",
    "officename": "Mangale S.O.",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416138": {
    "state": "Maharashtra",
    "district": "Kolhapur",
    "block": "Kolhapur",
    "officename": "Kabnur SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "Kolhapur Division"
  },
  "416317": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Sangli Division",
    "officename": "Manjarde SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "416429": {
    "state": "Maharashtra",
    "district": "Sangli",
    "block": "Sangli Division",
    "officename": "Madgyal SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Goa-Panaji Region",
    "divisionname": "SANGLI DIVISION"
  },
  "425314": {
    "state": "Maharashtra",
    "district": "Jalgaon",
    "block": "Bhusaval",
    "officename": "Gadegaon BO",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Bhusaval Division"
  },
  "431011": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Chhatrapati Sambhajinagar",
    "officename": "Kanchanwadi SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431152": {
    "state": "Maharashtra",
    "district": "Aurangabad",
    "block": "Chhatrapati Sambhajinagar",
    "officename": "SAWANGI BAZAR S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Chhatrapati Sambhajinagar Division"
  },
  "431543": {
    "state": "Maharashtra",
    "district": "Hingoli",
    "block": "Pharbhani",
    "officename": "Jawala Bazar SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Pharbhani Division"
  },
  "431724": {
    "state": "Maharashtra",
    "district": "Nanded",
    "block": "Nanded",
    "officename": "Wai Bazar SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Regional Office Aurangabad",
    "divisionname": "Nanded Division"
  },
  "440029": {
    "state": "Maharashtra",
    "district": "Nagpur",
    "block": "Nagpur City",
    "officename": "Bhilgaon SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Nagpur City Division"
  },
  "442107": {
    "state": "Maharashtra",
    "district": "Wardha",
    "block": "Wardha",
    "officename": "Sawangi Meghe SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Wardha Division"
  },
  "442919": {
    "state": "Maharashtra",
    "district": "Gadchiroli",
    "block": "Chandrapur",
    "officename": "Mulchera SO",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "442920": {
    "state": "Maharashtra",
    "district": "Chandrapur",
    "block": "Chandrapur",
    "officename": "Bhisi S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Chandrapur Division"
  },
  "444007": {
    "state": "Maharashtra",
    "district": "Akola",
    "block": "Akola",
    "officename": "Wholesale Kirana Market Sub Post Office Akola",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Akola Division"
  },
  "444915": {
    "state": "Maharashtra",
    "district": "Amravati",
    "block": "Amaravati",
    "officename": "Yawali S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Amaravati Division"
  },
  "445324": {
    "state": "Maharashtra",
    "district": "Yavatmal",
    "block": "Yeotmal",
    "officename": "Zari Jamni S.O",
    "circlename": "Maharashtra Circle",
    "regionname": "Nagpur Region",
    "divisionname": "Yeotmal Division"
  },
  "451114": {
    "state": "Madhya Pradesh",
    "district": "Khargone",
    "block": "Khandwa",
    "officename": "SELDA S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Khandwa Division"
  },
  "453552": {
    "state": "Madhya Pradesh",
    "district": "Indore",
    "block": "Indore Moffusil",
    "officename": "Simrol S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Indore Moffusil Division"
  },
  "461335": {
    "state": "Madhya Pradesh",
    "district": "Harda",
    "block": "Hoshangabad",
    "officename": "SIRALI SO",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hoshangabad Division"
  },
  "461445": {
    "state": "Madhya Pradesh",
    "district": "Sehore",
    "block": "Sehore",
    "officename": "Budni Ghat B.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Sehore Division"
  },
  "462028": {
    "state": "Madhya Pradesh",
    "district": "Bhopal",
    "block": "Bhopal",
    "officename": "Kokta S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhopal Division"
  },
  "462040": {
    "state": "Madhya Pradesh",
    "district": "Bhopal",
    "block": "Bhopal",
    "officename": "IBD Hallmark city kolar road",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhopal Division"
  },
  "462100": {
    "state": "Madhya Pradesh",
    "district": "Bhopal",
    "block": "Bhopal",
    "officename": "Nariyalkheda S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhopal Division"
  },
  "464334": {
    "state": "Madhya Pradesh",
    "district": "Vidisha",
    "block": "Vidisha",
    "officename": "Tyonda S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vidisha Division"
  },
  "464570": {
    "state": "Madhya Pradesh",
    "district": "Raisen",
    "block": "Vidisha",
    "officename": "Sultanganj SO",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vidisha Division"
  },
  "464573": {
    "state": "Madhya Pradesh",
    "district": "Raisen",
    "block": "Vidisha",
    "officename": "Dehgaon S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Vidisha Division"
  },
  "465313": {
    "state": "Madhya Pradesh",
    "district": "Ujjain",
    "block": "Ujjain",
    "officename": "Mungawadi",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Indore Region",
    "divisionname": "Ujjain Division"
  },
  "470340": {
    "state": "Madhya Pradesh",
    "district": "Sagar",
    "block": "Sagar",
    "officename": "DALPATPUR S.O.",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "470776": {
    "state": "Madhya Pradesh",
    "district": "Damoh",
    "block": "Sagar",
    "officename": "Madiyado SO",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Sagar Division"
  },
  "473445": {
    "state": "Madhya Pradesh",
    "district": "Ashoknagar",
    "block": "Guna",
    "officename": "Bahadurpur S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guna Division"
  },
  "473447": {
    "state": "Madhya Pradesh",
    "district": "Ashoknagar",
    "block": "Guna",
    "officename": "Kadwaya S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "NA",
    "divisionname": "Guna Division"
  },
  "473773": {
    "state": "Madhya Pradesh",
    "district": "Shivpuri",
    "block": "Shivpuri",
    "officename": "Khatora S.O.",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Shivpuri Division"
  },
  "475331": {
    "state": "Madhya Pradesh",
    "district": "Gwalior",
    "block": "Gwalior",
    "officename": "Ghatigaon S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gwalior Division"
  },
  "477450": {
    "state": "Madhya Pradesh",
    "district": "Bhind",
    "block": "Morena",
    "officename": "Rawatpura sarkar ashram S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Morena Division"
  },
  "481883": {
    "state": "Madhya Pradesh",
    "district": "Dindori",
    "block": "Mandla",
    "officename": "Bajag S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Mandla Division"
  },
  "484447": {
    "state": "Madhya Pradesh",
    "district": "Anuppur",
    "block": "Shahdol",
    "officename": "Amadand S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Shahdol Division"
  },
  "485227": {
    "state": "Madhya Pradesh",
    "district": "Satna",
    "block": "Satna",
    "officename": "Kotar S.O",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Satna Division"
  },
  "486883": {
    "state": "Madhya Pradesh",
    "district": "Sidhi",
    "block": "Rewa",
    "officename": "SARAI",
    "circlename": "Madhya Pradesh Circle",
    "regionname": "Jabalpur Region",
    "divisionname": "Rewa Division"
  },
  "491002": {
    "state": "Chhattisgarh",
    "district": "Durg",
    "block": "Durg",
    "officename": "IIT Bhilai S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Durg Division"
  },
  "491230": {
    "state": "Chhattisgarh",
    "district": "Balod",
    "block": "Durg",
    "officename": "Dondi SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Durg Division"
  },
  "491443": {
    "state": "Chhattisgarh",
    "district": "Rajnandgaon",
    "block": "Rajnandgaon",
    "officename": "SOMNI S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rajnandgaon Division"
  },
  "491996": {
    "state": "Chhattisgarh",
    "district": "Kabirdham",
    "block": "Rajnandgaon",
    "officename": "SahasPur Lohara SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rajnandgaon Division"
  },
  "492016": {
    "state": "Chhattisgarh",
    "district": "Raipur",
    "block": "Raipur",
    "officename": "Mana Basti SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "492017": {
    "state": "Chhattisgarh",
    "district": "Raipur",
    "block": "Raipur",
    "officename": "IBC Raipur PO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "492018": {
    "state": "Chhattisgarh",
    "district": "Raipur",
    "block": "Raipur",
    "officename": "Sector  27 Naya Raipur SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Raipur Division"
  },
  "494220": {
    "state": "Chhattisgarh",
    "district": "Kondagaon",
    "block": "Bastar",
    "officename": "Mardapal S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494237": {
    "state": "Chhattisgarh",
    "district": "Kondagaon",
    "block": "Bastar",
    "officename": "Makdi SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494332": {
    "state": "Chhattisgarh",
    "district": "Raipur",
    "block": "Bastar",
    "officename": "Govindpur S.O.",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "494662": {
    "state": "Chhattisgarh",
    "district": "Narayanpur",
    "block": "Bastar",
    "officename": "Chotedongar S.O",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bastar Division"
  },
  "495444": {
    "state": "Chhattisgarh",
    "district": "Korba",
    "block": "Bilaspur",
    "officename": "Dhelwadih",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "495669": {
    "state": "Chhattisgarh",
    "district": "Janjgir-Champa",
    "block": "Bilaspur",
    "officename": "VIDYUT NAGAR LACHHANPUR S.O.",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bilaspur Division"
  },
  "497450": {
    "state": "Chhattisgarh",
    "district": "Korea",
    "block": "Surguja Division",
    "officename": "Khadgawan SO",
    "circlename": "Chattisgarh Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "SURGUJA DIVISION"
  },
  "500102": {
    "state": "Telangana",
    "district": "Ranga Reddy",
    "block": "Hyderabad South East",
    "officename": "Rama Krishnapuram S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "500103": {
    "state": "Telangana",
    "district": "Medchal Malkajgiri",
    "block": "Secunderabad",
    "officename": "Jai Jawan Colony S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "500104": {
    "state": "Telangana",
    "district": "Ranga Reddy",
    "block": "Hyderabad City",
    "officename": "Chitrapuri Colony S.O.",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad City Division"
  },
  "500106": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Hyderabad Gpo",
    "officename": "MANCHIREVULA SO",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad GPO Division"
  },
  "500108": {
    "state": "Telangana",
    "district": "Ranga Reddy",
    "block": "Hyderabad South East",
    "officename": "R.G.I. Airport S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "500109": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Hyderabad City",
    "officename": "IBC Hyderabad",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad City Division"
  },
  "500110": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Hyderabad City",
    "officename": "Prashasan Nagar S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad City Division"
  },
  "500111": {
    "state": "Telangana",
    "district": "Ranga Reddy",
    "block": "Hyderabad City",
    "officename": "I S B Campus S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad City Division"
  },
  "500112": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Hyderabad South East",
    "officename": "Badangpet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "500113": {
    "state": "Telangana",
    "district": "Ranga Reddy",
    "block": "Hyderabad South East",
    "officename": "Kandukur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "500114": {
    "state": "Telangana",
    "district": "Medchal Malkajgiri",
    "block": "Hyderabad City",
    "officename": "Motinagar SO",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad City Division"
  },
  "500117": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Secunderabad",
    "officename": "Kailash Hills Colony SO",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "500118": {
    "state": "Telangana",
    "district": "Hyderabad",
    "block": "Secunderabad",
    "officename": "Bachupally SO",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "501302": {
    "state": "Telangana",
    "district": "Medchal Malkajgiri",
    "block": "Secunderabad",
    "officename": "RAMPALLY SO",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "501303": {
    "state": "Telangana",
    "district": "Medchal Malkajgiri",
    "block": "Secunderabad",
    "officename": "Keesara SO",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Secunderabad Division"
  },
  "501513": {
    "state": "Telangana",
    "district": "Ranga Reddy",
    "block": "Hyderabad South East",
    "officename": "Pedda Amberpet SO",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Hyderabad South East Division"
  },
  "502033": {
    "state": "Telangana",
    "district": "Sangareddy",
    "block": "Sangareddy",
    "officename": "Ameenpur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502034": {
    "state": "Telangana",
    "district": "Sangareddy",
    "block": "Sangareddy",
    "officename": "Tellapur S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "502106": {
    "state": "Telangana",
    "district": "Siddipet",
    "block": "Medak",
    "officename": "MIRDODDI S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Medak Division"
  },
  "502284": {
    "state": "Telangana",
    "district": "Sangareddy",
    "block": "Sangareddy",
    "officename": "IIT HYDERABAD SO",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad City Region",
    "divisionname": "Sangareddy Division"
  },
  "505002": {
    "state": "Telangana",
    "district": "Karimnagar",
    "block": "Karimnagar",
    "officename": "Mukharampura S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Karimnagar Division"
  },
  "505506": {
    "state": "Telangana",
    "district": "Peddapalli",
    "block": "Peddapalli",
    "officename": "Mutharam S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Peddapalli Division"
  },
  "506103": {
    "state": "Telangana",
    "district": "Mahabubabad",
    "block": "Warangal",
    "officename": "Kambalapalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Warangal Division"
  },
  "506146": {
    "state": "Telangana",
    "district": "Jangoan",
    "block": "Hanamkonda",
    "officename": "Palakurthy S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "506325": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Warangal",
    "officename": "Narsimhulapeta S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Warangal Division"
  },
  "506333": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Warangal",
    "officename": "Duggondi S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Warangal Division"
  },
  "506350": {
    "state": "Telangana",
    "district": "Warangal",
    "block": "Hanamkonda",
    "officename": "Nallabelli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Hanamkonda Division"
  },
  "507112": {
    "state": "Telangana",
    "district": "Bhadradri Kothagudem",
    "block": "Khammam",
    "officename": "Mulkalapalli  S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507126": {
    "state": "Telangana",
    "district": "Bhadradri Kothagudem",
    "block": "Khammam",
    "officename": "Allapalli  S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507127": {
    "state": "Telangana",
    "district": "Bhadradri Kothagudem",
    "block": "Khammam",
    "officename": "Tekulapalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507171": {
    "state": "Telangana",
    "district": "Bhadradri Kothagudem",
    "block": "Khammam",
    "officename": "Chandrugonda S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "507315": {
    "state": "Telangana",
    "district": "Bhadradri Kothagudem",
    "block": "Khammam",
    "officename": "Annapureddipalli S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Khammam Division"
  },
  "508214": {
    "state": "Telangana",
    "district": "Suryapet",
    "block": "Suryapet",
    "officename": "I.E.Suryapet S.O",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Suryapet Division"
  },
  "509328": {
    "state": "Telangana",
    "district": "Ranga Reddy",
    "block": "Wanaparthy",
    "officename": "Kanha Shanti Vanam NDSO",
    "circlename": "Telangana Circle",
    "regionname": "Hyderabad Region",
    "divisionname": "Wanaparthy Division"
  },
  "515006": {
    "state": "Andhra Pradesh",
    "district": "Anantapur",
    "block": "Anantapur",
    "officename": "Syndicate Nagar",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Anantapur Division"
  },
  "515251": {
    "state": "Andhra Pradesh",
    "district": "Sri Sathya Sai",
    "block": "Hindupur",
    "officename": "NACIN S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Hindupur Division"
  },
  "516005": {
    "state": "Andhra Pradesh",
    "district": "Y.S.R.",
    "block": "Cuddapah",
    "officename": "Yogi Vemana University S.O.",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Cuddapah Division"
  },
  "517508": {
    "state": "Andhra Pradesh",
    "district": "Tirupati",
    "block": "Tirupati",
    "officename": "AVILALA SO",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517509": {
    "state": "Andhra Pradesh",
    "district": "Chittoor",
    "block": "Tirupati",
    "officename": "Mangalam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "517646": {
    "state": "Andhra Pradesh",
    "district": "Tirupati",
    "block": "Tirupati",
    "officename": "Sricity S.E.Z SO",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Kurnool Region",
    "divisionname": "Tirupati Division"
  },
  "521004": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Machilipatnam",
    "officename": "Krishna University S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Machilipatnam Division"
  },
  "521184": {
    "state": "Andhra Pradesh",
    "district": "Ntr",
    "block": "Vijayawada",
    "officename": "Magallu SO",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521224": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Vijayawada",
    "officename": "NDC VIJAYAWADA",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521231": {
    "state": "Andhra Pradesh",
    "district": "Ntr",
    "block": "Vijayawada",
    "officename": "JNNURM Colony S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Vijayawada Division"
  },
  "521320": {
    "state": "Andhra Pradesh",
    "district": "Krishna",
    "block": "Gudivada",
    "officename": "Kruthivennu SO",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudivada Division"
  },
  "522008": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Guntur",
    "officename": "NDC Guntur",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Guntur Division"
  },
  "522238": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Guntur",
    "officename": "A.P.Secretariat S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Guntur Division"
  },
  "522239": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Guntur",
    "officename": "A.P.High Court S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Guntur Division"
  },
  "522240": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Guntur",
    "officename": "SRM University S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Guntur Division"
  },
  "522241": {
    "state": "Andhra Pradesh",
    "district": "Guntur",
    "block": "Guntur",
    "officename": "VIT-AP UNIVERSITY SO",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Guntur Division"
  },
  "523003": {
    "state": "Andhra Pradesh",
    "district": "Prakasam",
    "block": "Prakasam",
    "officename": "NDC ONGOLE",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Prakasam Division"
  },
  "524300": {
    "state": "Andhra Pradesh",
    "district": "Spsr Nellore",
    "block": "Nellore",
    "officename": "Somasila Hill Colony S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "524324": {
    "state": "Andhra Pradesh",
    "district": "Spsr Nellore",
    "block": "Gudur",
    "officename": "VIKRAMASIMHAPURI UNIVERSITY SO",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Gudur Division"
  },
  "524347": {
    "state": "Andhra Pradesh",
    "district": "Spsr Nellore",
    "block": "Nellore",
    "officename": "AP Genco Nelatur SO",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Nellore Division"
  },
  "530055": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatanam",
    "block": "Visakhapatnam",
    "officename": "Duvvada SO",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530056": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatanam",
    "block": "Visakhapatnam",
    "officename": "Sheelanagar S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530057": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatanam",
    "block": "Visakhapatnam",
    "officename": "Arilova S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530058": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatanam",
    "block": "Visakhapatnam",
    "officename": "NDC Andhra University",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "530059": {
    "state": "Andhra Pradesh",
    "district": "Visakhapatanam",
    "block": "Visakhapatnam",
    "officename": "Sontyam S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Visakhapatnam Division"
  },
  "532167": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Srikakulam",
    "officename": "Laidam",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532187": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Srikakulam",
    "officename": "Bairisingupuram S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532204": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Srikakulam",
    "officename": "Nandigam SO",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "532207": {
    "state": "Andhra Pradesh",
    "district": "Srikakulam",
    "block": "Srikakulam",
    "officename": "VENUGOPALAPURAM",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Srikakulam Division"
  },
  "533007": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Kakinada",
    "officename": "Dairy Farm Center S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533108": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Rajahmundry",
    "officename": "NDC Rajahmundry",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533219": {
    "state": "Andhra Pradesh",
    "district": "Konaseema",
    "block": "Amalapuram",
    "officename": "Muramalla S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Amalapuram Division"
  },
  "533347": {
    "state": "Andhra Pradesh",
    "district": "Alluri Sitharama Raju",
    "block": "Rajahmundry",
    "officename": "Chinturu S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533348": {
    "state": "Andhra Pradesh",
    "district": "Alluri Sitharama Raju",
    "block": "Rajahmundry",
    "officename": "Donkarayi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533349": {
    "state": "Andhra Pradesh",
    "district": "Alluri Sitharama Raju",
    "block": "Rajahmundry",
    "officename": "V.R. PURAM S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533350": {
    "state": "Andhra Pradesh",
    "district": "Alluri Sitharama Raju",
    "block": "Rajahmundry",
    "officename": "KUNAVARAM S.O.",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533351": {
    "state": "Andhra Pradesh",
    "district": "Alluri Sitharama Raju",
    "block": "Rajahmundry",
    "officename": "Thotapalli S.O (Khammam)",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533352": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Rajahmundry",
    "officename": "Nellipaka S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533353": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Rajahmundry",
    "officename": "DEWANCHERUVU S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533354": {
    "state": "Andhra Pradesh",
    "district": "Alluri Sitharama Raju",
    "block": "Rajahmundry",
    "officename": "INDUKURUPETA S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533355": {
    "state": "Andhra Pradesh",
    "district": "East Godavari",
    "block": "Rajahmundry",
    "officename": "K gangavaram",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Rajahmundry Division"
  },
  "533451": {
    "state": "Andhra Pradesh",
    "district": "Kakinada",
    "block": "Kakinada",
    "officename": "Tatiparthi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "533460": {
    "state": "Andhra Pradesh",
    "district": "Kakinada",
    "block": "Kakinada",
    "officename": "Pedapudi S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Kakinada Division"
  },
  "534008": {
    "state": "Andhra Pradesh",
    "district": "Eluru",
    "block": "Eluru",
    "officename": "NDC ELURU",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Eluru Division"
  },
  "534435": {
    "state": "Andhra Pradesh",
    "district": "Eluru",
    "block": "Eluru",
    "officename": "Pedavegi",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Eluru Division"
  },
  "534444": {
    "state": "Andhra Pradesh",
    "district": "Eluru",
    "block": "Eluru",
    "officename": "KUKUNOOR SO",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Vijayawada Region",
    "divisionname": "Eluru Division"
  },
  "535569": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Parvathipuram",
    "officename": "Pakki SO",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Parvathipuram Division"
  },
  "535582": {
    "state": "Andhra Pradesh",
    "district": "Vizianagaram",
    "block": "Vizianagaram",
    "officename": "DATTIRAJERU S.O",
    "circlename": "Andhra Pradesh Circle",
    "regionname": "Visakhapatnam Region",
    "divisionname": "Vizianagaram Division"
  },
  "560111": {
    "state": "Karnataka",
    "district": "Bengaluru Urban",
    "block": "Bengaluru South",
    "officename": "Kumaraswamy Layout S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560113": {
    "state": "Karnataka",
    "district": "Bengaluru Urban",
    "block": "Bengaluru East",
    "officename": "Horamavu S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560114": {
    "state": "Karnataka",
    "district": "Bengaluru Urban",
    "block": "Bengaluru South",
    "officename": "Begur",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560115": {
    "state": "Karnataka",
    "district": "Bengaluru Urban",
    "block": "Bengaluru East",
    "officename": "Kannamangala S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560116": {
    "state": "Karnataka",
    "district": "Bengaluru Urban",
    "block": "Bengaluru South",
    "officename": "Kaggalipura P.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "560117": {
    "state": "Karnataka",
    "district": "Bengaluru Rural",
    "block": "Bengaluru East",
    "officename": "Doddadunnasandra S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560119": {
    "state": "Karnataka",
    "district": "Bengaluru Urban",
    "block": "Bengaluru East",
    "officename": "Singanayakanahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "560500": {
    "state": "Karnataka",
    "district": "Bengaluru Urban",
    "block": "Bengaluru South",
    "officename": "CPC ITD BNPL booking HUB",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "562165": {
    "state": "Karnataka",
    "district": "Bengaluru Rural",
    "block": "Channapatna",
    "officename": "Budigere S.O",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru East Division"
  },
  "562166": {
    "state": "Karnataka",
    "district": "Ramanagara",
    "block": "Bengaluru South",
    "officename": "Marasur SO",
    "circlename": "Karnataka Circle",
    "regionname": "Bengaluru HQ Region",
    "divisionname": "Bengaluru South Division"
  },
  "563147": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Kolar",
    "officename": "BUDIKOTE SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "563157": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Kolar",
    "officename": "VEMAGAL SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "563163": {
    "state": "Karnataka",
    "district": "Kolar",
    "block": "Kolar",
    "officename": "Chikkathirupathi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kolar Division"
  },
  "570032": {
    "state": "Karnataka",
    "district": "Mysuru",
    "block": "Mysuru",
    "officename": "Vijayanagar IV Stage S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "570033": {
    "state": "Karnataka",
    "district": "Mysuru",
    "block": "Mysuru",
    "officename": "Dattagalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "570034": {
    "state": "Karnataka",
    "district": "Mysuru",
    "block": "Mysuru",
    "officename": "Sri Rampura 2nd Stage S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "571190": {
    "state": "Karnataka",
    "district": "Mysuru",
    "block": "Mysuru",
    "officename": "SERA THEKCHENLING",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mysuru Division"
  },
  "571202": {
    "state": "Karnataka",
    "district": "Kodagu",
    "block": "Kodagu",
    "officename": "Vidyanagar S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Kodagu Division"
  },
  "573226": {
    "state": "Karnataka",
    "district": "Hassan",
    "block": "Hassan",
    "officename": "Boovanahalli S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Hassan Division"
  },
  "574162": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangaluru",
    "officename": "Kuppepadavu S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "575009": {
    "state": "Karnataka",
    "district": "Dakshina Kannada",
    "block": "Mangaluru",
    "officename": "Bajal S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "Mangaluru Division"
  },
  "577007": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Davanagere Division",
    "officename": "Davangere University Campus S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "DAVANAGERE DIVISION"
  },
  "577008": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Davanagere Division",
    "officename": "NITTUVALLI  B CLASS SO",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "DAVANAGERE DIVISION"
  },
  "577009": {
    "state": "Karnataka",
    "district": "Davangere",
    "block": "Davanagere Division",
    "officename": "Lokikere S.O",
    "circlename": "Karnataka Circle",
    "regionname": "South Karnataka Region",
    "divisionname": "DAVANAGERE DIVISION"
  },
  "580027": {
    "state": "Karnataka",
    "district": "Dharwad",
    "block": "Dharwad",
    "officename": "Gokul S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Dharwad Division"
  },
  "581199": {
    "state": "Karnataka",
    "district": "Haveri",
    "block": "Haveri",
    "officename": "Belagalapete S.O.",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Haveri Division"
  },
  "581237": {
    "state": "Karnataka",
    "district": "Haveri",
    "block": "Haveri",
    "officename": "Kadkol S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Haveri Division"
  },
  "583153": {
    "state": "Karnataka",
    "district": "Ballari",
    "block": "Ballari",
    "officename": "Shankar Hill Town Colony S.O.",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583154": {
    "state": "Karnataka",
    "district": "Ballari",
    "block": "Ballari",
    "officename": "Karur SO",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583155": {
    "state": "Karnataka",
    "district": "Ballari",
    "block": "Ballari",
    "officename": "Kolur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Ballari Division"
  },
  "583284": {
    "state": "Karnataka",
    "district": "Koppal",
    "block": "Koppal Division",
    "officename": "Mudhol S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "KOPPAL DIVISION"
  },
  "583285": {
    "state": "Karnataka",
    "district": "Koppal",
    "block": "Koppal Division",
    "officename": "Hiresindogi S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "KOPPAL DIVISION"
  },
  "583286": {
    "state": "Karnataka",
    "district": "Koppal",
    "block": "Koppal Division",
    "officename": "Siddapura SO",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "KOPPAL DIVISION"
  },
  "583287": {
    "state": "Karnataka",
    "district": "Koppal",
    "block": "Koppal Division",
    "officename": "Irkalgad S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "KOPPAL DIVISION"
  },
  "583288": {
    "state": "Karnataka",
    "district": "Koppal",
    "block": "Koppal Division",
    "officename": "Chalagera S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "KOPPAL DIVISION"
  },
  "585107": {
    "state": "Karnataka",
    "district": "Kalaburagi",
    "block": "Kalaburagi",
    "officename": "Kalaburagi HCB S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Kalaburagi Division"
  },
  "585404": {
    "state": "Karnataka",
    "district": "Bidar",
    "block": "Bidar",
    "officename": "Naubad SO",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bidar Division"
  },
  "585445": {
    "state": "Karnataka",
    "district": "Bidar",
    "block": "Bidar",
    "officename": "KOHINOOR SO",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bidar Division"
  },
  "585446": {
    "state": "Karnataka",
    "district": "Bidar",
    "block": "Bidar",
    "officename": "Dadgi SO",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bidar Division"
  },
  "585447": {
    "state": "Karnataka",
    "district": "Bidar",
    "block": "Bidar",
    "officename": "MANHALLI  S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bidar Division"
  },
  "585448": {
    "state": "Karnataka",
    "district": "Bidar",
    "block": "Bidar",
    "officename": "Dabka CH SO",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bidar Division"
  },
  "586162": {
    "state": "Karnataka",
    "district": "Vijayapura",
    "block": "Vijayapura",
    "officename": "Tadavalga SO",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "586170": {
    "state": "Karnataka",
    "district": "Vijayapura",
    "block": "Vijayapura",
    "officename": "Mamadapur SO",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Vijayapura Division"
  },
  "587156": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Bagalkot",
    "officename": "Shirur S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "587157": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Bagalkot",
    "officename": "Kudalasangam S.O",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "587331": {
    "state": "Karnataka",
    "district": "Bagalkot",
    "block": "Bagalkot",
    "officename": "HIPPARGI SO",
    "circlename": "Karnataka Circle",
    "regionname": "North Karnataka Region",
    "divisionname": "Bagalkot Division"
  },
  "600131": {
    "state": "Tamil Nadu",
    "district": "Chengalpattu",
    "block": "Tambaram",
    "officename": "SITHALAPAKKAM SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600132": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Tambaram",
    "officename": "Tirumudivakkam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "600133": {
    "state": "Tamil Nadu",
    "district": "Thiruvallur",
    "block": "Tambaram",
    "officename": "Somangalam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tambaram Division"
  },
  "602118": {
    "state": "Tamil Nadu",
    "district": "Kanchipuram",
    "block": "Kanchipuram",
    "officename": "Oragadam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Kanchipuram Division"
  },
  "603004": {
    "state": "Tamil Nadu",
    "district": "Chengalpattu",
    "block": "Chengalpattu",
    "officename": "Mahindra World City SO Kanchipuram",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Chengalpattu Division"
  },
  "604411": {
    "state": "Tamil Nadu",
    "district": "Tiruvannamalai",
    "block": "Tiruvannamalai",
    "officename": "Ponnur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Tiruvannamalai Division"
  },
  "605403": {
    "state": "Tamil Nadu",
    "district": "Villupuram",
    "block": "Pondicherry",
    "officename": "Valudareddy S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Chennai City Region",
    "divisionname": "Pondicherry Division"
  },
  "606109": {
    "state": "Tamil Nadu",
    "district": "Cuddalore",
    "block": "Vriddhachalam",
    "officename": "Sirupakkam S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Vriddhachalam Division"
  },
  "610005": {
    "state": "Tamil Nadu",
    "district": "Thiruvarur",
    "block": "Nagapattinam",
    "officename": "Tiruvarur Central University",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Nagapattinam Division"
  },
  "612905": {
    "state": "Tamil Nadu",
    "district": "Ariyalur",
    "block": "Tiruchirapalli",
    "officename": "Ulkottai SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "612906": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Tiruchirapalli",
    "officename": "Melanikuzhi SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "620027": {
    "state": "Tamil Nadu",
    "district": "Tiruchirappalli",
    "block": "Tiruchirapalli",
    "officename": "Tamilnadu National Law University S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "621119": {
    "state": "Tamil Nadu",
    "district": "Perambalur",
    "block": "Srirangam",
    "officename": "Kaikalathur S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Srirangam Division"
  },
  "621731": {
    "state": "Tamil Nadu",
    "district": "Ariyalur",
    "block": "Tiruchirapalli",
    "officename": "Reddipalayam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Central Region Trichirapalli",
    "divisionname": "Tiruchirapalli Division"
  },
  "625552": {
    "state": "Tamil Nadu",
    "district": "Theni",
    "block": "Theni",
    "officename": "Markayankottai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Theni Division"
  },
  "626161": {
    "state": "Tamil Nadu",
    "district": "Virudhunagar",
    "block": "Virudhunagar",
    "officename": "Athipatti SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Virudhunagar Division"
  },
  "628155": {
    "state": "Tamil Nadu",
    "district": "Tuticorin",
    "block": "Tuticorin",
    "officename": "Punnakayal SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Southern Region Madurai",
    "divisionname": "Tuticorin Division"
  },
  "635130": {
    "state": "Tamil Nadu",
    "district": "Krishnagiri",
    "block": "Krishnagiri",
    "officename": "Kumudepalli SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Krishnagiri Division"
  },
  "636017": {
    "state": "Tamil Nadu",
    "district": "Salem",
    "block": "Salem East",
    "officename": "Allikuttai S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Salem East Division"
  },
  "636907": {
    "state": "Tamil Nadu",
    "district": "Dharmapuri",
    "block": "Dharmapuri",
    "officename": "Naripalli SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Dharmapuri Division"
  },
  "637216": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Namakkal",
    "officename": "PERIYAMANALI SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "637415": {
    "state": "Tamil Nadu",
    "district": "Namakkal",
    "block": "Namakkal",
    "officename": "Solakkadu S.O",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Namakkal Division"
  },
  "638060": {
    "state": "Tamil Nadu",
    "district": "Erode",
    "block": "Erode",
    "officename": "Thoppupalayam SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Erode Division"
  },
  "641040": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore",
    "officename": "NDC KPColony SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641051": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore",
    "officename": "Cheranmaanagar SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "641063": {
    "state": "Tamil Nadu",
    "district": "Coimbatore",
    "block": "Coimbatore",
    "officename": "NDC Coimbatore HO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Coimbatore Division"
  },
  "643270": {
    "state": "Tamil Nadu",
    "district": "The Nilgiris",
    "block": "Nilgiris",
    "officename": "Devala SO",
    "circlename": "Tamilnadu Circle",
    "regionname": "Western Region Coimbatore",
    "divisionname": "Nilgiris Division"
  },
  "670051": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Cannanore",
    "officename": "Kannur NDC",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Cannanore Division"
  },
  "670708": {
    "state": "Kerala",
    "district": "Kannur",
    "block": "Thalassery",
    "officename": "Kannur International Airport S.O",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Thalassery Division"
  },
  "671320": {
    "state": "Kerala",
    "district": "Kasaragod",
    "block": "Kasaragod",
    "officename": "PERIYE S.O",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Kasaragod Division"
  },
  "671325": {
    "state": "Kerala",
    "district": "Kasaragod",
    "block": "Kasaragod",
    "officename": "Central University of Kerala Campus S.O",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Kasaragod Division"
  },
  "671534": {
    "state": "Kerala",
    "district": "Kasaragod",
    "block": "Kasaragod",
    "officename": "Vellarikundu SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Kasaragod Division"
  },
  "673051": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Calicut",
    "officename": "KOZHIKODE PARCEL CENTRE",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673124": {
    "state": "Kerala",
    "district": "Wayanad",
    "block": "Calicut",
    "officename": "KAMBALAKKAD SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Calicut Division"
  },
  "673323": {
    "state": "Kerala",
    "district": "Kozhikode",
    "block": "Vadakara",
    "officename": "ULLIYERI SO",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Vadakara Division"
  },
  "678051": {
    "state": "Kerala",
    "district": "Palakkad",
    "block": "Palghat",
    "officename": "PALAKKAD NDC",
    "circlename": "Kerala Circle",
    "regionname": "Calicut Region",
    "divisionname": "Palghat Division"
  },
  "680051": {
    "state": "Kerala",
    "district": "Thrissur",
    "block": "Trichur",
    "officename": "NODAL DELIVERY CENTER THRISSUR",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Trichur Division"
  },
  "682050": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "International Business Centre IBC",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682051": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "Kochi Parcel Centre PO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682052": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "Kakkanad NDC",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "682317": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Ernakulam",
    "officename": "KULAYATTIKKARA",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Ernakulam Division"
  },
  "683548": {
    "state": "Kerala",
    "district": "Ernakulam",
    "block": "Alwaye",
    "officename": "Iringole SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alwaye Division"
  },
  "688563": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Alleppey",
    "officename": "THOTTAPPALLY",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Alleppey Division"
  },
  "689515": {
    "state": "Kerala",
    "district": "Pathanamthitta",
    "block": "Mavelikara",
    "officename": "Poozhikkad SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690112": {
    "state": "Kerala",
    "district": "Alappuzha",
    "block": "Mavelikara",
    "officename": "Ayranikudy SO",
    "circlename": "Kerala Circle",
    "regionname": "Kochi Region",
    "divisionname": "Mavelikara Division"
  },
  "690546": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Quilon",
    "officename": "Amrithapuri SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "691527": {
    "state": "Kerala",
    "district": "Kollam",
    "block": "Quilon",
    "officename": "Nellikunnam SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Quilon Division"
  },
  "695051": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Trivandrum North",
    "officename": "NDC TRIVANDRUM FORT",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum North Division"
  },
  "695570": {
    "state": "Kerala",
    "district": "Thiruvananthapuram",
    "block": "Trivandrum South",
    "officename": "Machel SO",
    "circlename": "Kerala Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Trivandrum South Division"
  },
  "700161": {
    "state": "West Bengal",
    "district": "24 Paraganas North",
    "block": "Kolkata East",
    "officename": "New Town Action Area II SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata East Division"
  },
  "700162": {
    "state": "West Bengal",
    "district": "24 Paraganas North",
    "block": "Kolkata East",
    "officename": "Gouranganagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata East Division"
  },
  "700163": {
    "state": "West Bengal",
    "district": "24 Paraganas North",
    "block": "Kolkata East",
    "officename": "New Town Action Area I SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Kolkata East Division"
  },
  "711115": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Howrah",
    "officename": "Jagadishpurhat SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711206": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Howrah",
    "officename": "Sapuipara SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "711331": {
    "state": "West Bengal",
    "district": "Howrah",
    "block": "Howrah",
    "officename": "Paniara S.O",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Howrah Division"
  },
  "713132": {
    "state": "West Bengal",
    "district": "Purba Bardhaman",
    "block": "Burdwan",
    "officename": "Majigram SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Burdwan Division"
  },
  "721402": {
    "state": "West Bengal",
    "district": "Medinipur East",
    "block": "Contai",
    "officename": "Contai Super Market SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721403": {
    "state": "West Bengal",
    "district": "Medinipur East",
    "block": "Contai",
    "officename": "Contai Bazar SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721404": {
    "state": "West Bengal",
    "district": "Medinipur East",
    "block": "Contai",
    "officename": "Karkuli SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721405": {
    "state": "West Bengal",
    "district": "Medinipur East",
    "block": "Contai",
    "officename": "Athilagori SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721406": {
    "state": "West Bengal",
    "district": "Medinipur East",
    "block": "Contai",
    "officename": "Monoharchak SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Contai Division"
  },
  "721624": {
    "state": "West Bengal",
    "district": "Medinipur East",
    "block": "Tamluk",
    "officename": "Rangibasan SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721637": {
    "state": "West Bengal",
    "district": "Medinipur East",
    "block": "Tamluk",
    "officename": "Abasbari SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "721638": {
    "state": "West Bengal",
    "district": "Medinipur East",
    "block": "Tamluk",
    "officename": "Gopinathpur SO",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Tamluk Division"
  },
  "723134": {
    "state": "West Bengal",
    "district": "Purulia",
    "block": "Purulia",
    "officename": "NILDIH RTPS S.O.",
    "circlename": "West Bengal Circle",
    "regionname": "South Bengal Region",
    "divisionname": "Purulia Division"
  },
  "731218": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "Mayureswar SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "731304": {
    "state": "West Bengal",
    "district": "Birbhum",
    "block": "Birbhum",
    "officename": "KURUNNAHAR SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Birbhum Division"
  },
  "734425": {
    "state": "West Bengal",
    "district": "Darjeeling",
    "block": "Darjeeling",
    "officename": "Bidhannagar SO",
    "circlename": "West Bengal Circle",
    "regionname": "North Bengal Region",
    "divisionname": "Darjeeling Division"
  },
  "742410": {
    "state": "West Bengal",
    "district": "Murshidabad",
    "block": "Murshidabad",
    "officename": "REJINAGAR SO",
    "circlename": "West Bengal Circle",
    "regionname": "Kolkata Region",
    "divisionname": "Murshidabad Division"
  },
  "751026": {
    "state": "Odisha",
    "district": "Khordha",
    "block": "Bhubaneswar",
    "officename": "N.M.D Parcel Centre Bhubaneswar",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "751028": {
    "state": "Odisha",
    "district": "Khordha",
    "block": "Bhubaneswar",
    "officename": "Tamando S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "751029": {
    "state": "Odisha",
    "district": "Khordha",
    "block": "Bhubaneswar",
    "officename": "Mahalaxmivihar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "751031": {
    "state": "Odisha",
    "district": "Khordha",
    "block": "Bhubaneswar",
    "officename": "Patia S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "751032": {
    "state": "Odisha",
    "district": "Khordha",
    "block": "Bhubaneswar",
    "officename": "PAHAL S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "751033": {
    "state": "Odisha",
    "district": "Khordha",
    "block": "Bhubaneswar",
    "officename": "BARAMUNDA NDC",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "751034": {
    "state": "Odisha",
    "district": "Khordha",
    "block": "Bhubaneswar",
    "officename": "RASULGARH NDC",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "751035": {
    "state": "Odisha",
    "district": "Khordha",
    "block": "Bhubaneswar",
    "officename": "NAHARAKANTA S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Bhubaneswar Division"
  },
  "752004": {
    "state": "Odisha",
    "district": "Puri",
    "block": "Puri",
    "officename": "Baliguali S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Puri Division"
  },
  "752010": {
    "state": "Odisha",
    "district": "Puri",
    "block": "Puri",
    "officename": "Panaspada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Puri Division"
  },
  "752032": {
    "state": "Odisha",
    "district": "Puri",
    "block": "Puri",
    "officename": "Parikudgarh SO",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Puri Division"
  },
  "753016": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Cuttack City",
    "officename": "NDC Cuttack",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "754034": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Cuttack South",
    "officename": "Maniabandha S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754297": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Cuttack South",
    "officename": "Khuntuni S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754298": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Cuttack South",
    "officename": "KALARABANKA S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "754299": {
    "state": "Odisha",
    "district": "Cuttack",
    "block": "Cuttack South",
    "officename": "GHOLAPUR S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack South Division"
  },
  "755051": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Jajpur Division",
    "officename": "Rasulpur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "JAJPUR DIVISION"
  },
  "755063": {
    "state": "Odisha",
    "district": "Jajapur",
    "block": "Cuttack City",
    "officename": "KAITHA S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Cuttack City Division"
  },
  "756050": {
    "state": "Odisha",
    "district": "Baleshwar",
    "block": "Balasore",
    "officename": "Gandibed SO",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756087": {
    "state": "Odisha",
    "district": "Baleshwar",
    "block": "Balasore",
    "officename": "Lakhananath S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756088": {
    "state": "Odisha",
    "district": "Baleshwar",
    "block": "Balasore",
    "officename": "Chormara S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "756089": {
    "state": "Odisha",
    "district": "Baleshwar",
    "block": "Balasore",
    "officename": "VYASAVIHAR S.O",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Balasore Division"
  },
  "757056": {
    "state": "Odisha",
    "district": "Mayurbhanj",
    "block": "Mayurbhanj",
    "officename": "ANLA SO",
    "circlename": "Odisha Circle",
    "regionname": "Bhubaneswar HQ Region",
    "divisionname": "Mayurbhanj Division"
  },
  "758086": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Keonjhar",
    "officename": "Bamebari S.O.",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "758087": {
    "state": "Odisha",
    "district": "Kendujhar",
    "block": "Keonjhar",
    "officename": "Pandapada S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Keonjhar Division"
  },
  "759029": {
    "state": "Odisha",
    "district": "Dhenkanal",
    "block": "Dhenkanal",
    "officename": "Mahabirod S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759149": {
    "state": "Odisha",
    "district": "Anugul",
    "block": "Dhenkanal",
    "officename": "JARAPADA S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759150": {
    "state": "Odisha",
    "district": "Dhenkanal",
    "block": "Dhenkanal",
    "officename": "Gopalprasad S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "759151": {
    "state": "Odisha",
    "district": "Dhenkanal",
    "block": "Dhenkanal",
    "officename": "Pabitranagar S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Dhenkanal Division"
  },
  "760011": {
    "state": "Odisha",
    "district": "Ganjam",
    "block": "Berhampur",
    "officename": "AMBAPUA SO",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Berhampur Division"
  },
  "765010": {
    "state": "Odisha",
    "district": "Rayagada",
    "block": "Rayagada",
    "officename": "Kolnara  S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Rayagada Division"
  },
  "765011": {
    "state": "Odisha",
    "district": "Rayagada",
    "block": "Rayagada",
    "officename": "Chandrapur S.O",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Rayagada Division"
  },
  "766003": {
    "state": "Odisha",
    "district": "Kalahandi",
    "block": "Kalahandi",
    "officename": "Bhawanipatna Engineering College SO",
    "circlename": "Odisha Circle",
    "regionname": "Berhampur Region",
    "divisionname": "Kalahandi Division"
  },
  "767071": {
    "state": "Odisha",
    "district": "Balangir",
    "block": "Balangir",
    "officename": "Puintala S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Balangir Division"
  },
  "768007": {
    "state": "Odisha",
    "district": "Sambalpur",
    "block": "Sambalpur",
    "officename": "SAMBALPUR NDC",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768024": {
    "state": "Odisha",
    "district": "Sambalpur",
    "block": "Sambalpur",
    "officename": "Gosala Chowk S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768053": {
    "state": "Odisha",
    "district": "Bargarh",
    "block": "Sambalpur",
    "officename": "Renaglipali Canal  Colony  SO",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "768210": {
    "state": "Odisha",
    "district": "Sambalpur",
    "block": "Sambalpur",
    "officename": "Thelkuli S.O",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sambalpur Division"
  },
  "769017": {
    "state": "Odisha",
    "district": "Sundargarh",
    "block": "Rourkela",
    "officename": "Rourkela Parcel NDC",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Rourkela Division"
  },
  "770025": {
    "state": "Odisha",
    "district": "Sundargarh",
    "block": "Sundargarh",
    "officename": "NTPC  Darlipali SO",
    "circlename": "Odisha Circle",
    "regionname": "Sambalpur Region",
    "divisionname": "Sundargarh Division"
  },
  "781002": {
    "state": "Assam",
    "district": "Kamrup Metro",
    "block": "Guwahati",
    "officename": "IBC Guwahati P.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781033": {
    "state": "Assam",
    "district": "Kamrup Metro",
    "block": "Guwahati",
    "officename": "Jorabat SO",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Guwahati Division"
  },
  "781320": {
    "state": "Assam",
    "district": "Barpeta",
    "block": "Nalbari",
    "officename": "Salbari S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Nalbari Division"
  },
  "782436": {
    "state": "Assam",
    "district": "Karbi Anglong",
    "block": "Nagaon",
    "officename": "Rabindranath Tagore University",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Nagaon Division"
  },
  "783136": {
    "state": "Assam",
    "district": "South Salmara Mancachar",
    "block": "Goalpara",
    "officename": "Hatsingimari  S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "783386": {
    "state": "Assam",
    "district": "Chirang",
    "block": "Goalpara",
    "officename": "Kajalgaon S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Goalpara Division"
  },
  "786148": {
    "state": "Assam",
    "district": "Tinsukia",
    "block": "Tinsukia",
    "officename": "Monkhooli S.O.",
    "circlename": "Assam Circle",
    "regionname": "Dibrugarh Region",
    "divisionname": "Tinsukia Division"
  },
  "788738": {
    "state": "Assam",
    "district": "Karimganj",
    "block": "Cachar",
    "officename": "BIDYANAGAR S.O",
    "circlename": "Assam Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Cachar Division"
  },
  "791004": {
    "state": "Arunachal Pradesh",
    "district": "East Siang",
    "block": "Arunachal Pradesh",
    "officename": "BOLENG SO",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "791114": {
    "state": "Arunachal Pradesh",
    "district": "Papum Pare",
    "block": "Arunachal Pradesh",
    "officename": "Sagalee S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "791701": {
    "state": "Mizoram",
    "district": "Aizawl",
    "block": "Mizoram",
    "officename": "HLUMTE",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "792124": {
    "state": "Arunachal Pradesh",
    "district": "Papum Pare",
    "block": "Arunachal Pradesh",
    "officename": "KHARSANG SO",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Arunachal Pradesh Division"
  },
  "793116": {
    "state": "Meghalaya",
    "district": "Ri Bhoi",
    "block": "Meghalaya",
    "officename": "Bhoilymbong S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793126": {
    "state": "Meghalaya",
    "district": "West Khasi Hills",
    "block": "Meghalaya",
    "officename": "Riangdo Bazar S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "793161": {
    "state": "Meghalaya",
    "district": "West Jaintia Hills",
    "block": "Meghalaya",
    "officename": "Amlarem S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "794004": {
    "state": "Meghalaya",
    "district": "West Garo Hills",
    "block": "Meghalaya",
    "officename": "BAJENGDOBA S.O",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "794113": {
    "state": "Meghalaya",
    "district": "East Garo Hills",
    "block": "Meghalaya",
    "officename": "DAINADUBI SO",
    "circlename": "North Eastern Circle",
    "regionname": "Shillong HQ Region",
    "divisionname": "Meghalaya Division"
  },
  "795011": {
    "state": "Manipur",
    "district": "Bishnupur",
    "block": "Manipur",
    "officename": "Ningthoukhong SO",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795105": {
    "state": "Manipur",
    "district": "Senapati",
    "block": "Manipur",
    "officename": "Maram S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "795121": {
    "state": "Manipur",
    "district": "Imphal West",
    "block": "Manipur",
    "officename": "PARBUNG SO",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Manipur Division"
  },
  "796006": {
    "state": "Mizoram",
    "district": "Aizawl",
    "block": "Mizoram",
    "officename": "NEW SECRETARIAT",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796015": {
    "state": "Mizoram",
    "district": "Aizawl",
    "block": "Mizoram",
    "officename": "Durtlang SO",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796246": {
    "state": "Mizoram",
    "district": "Aizawl",
    "block": "Mizoram",
    "officename": "LUNGSEL",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796291": {
    "state": "Mizoram",
    "district": "Saitual",
    "block": "Mizoram",
    "officename": "MIMBUNG S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "796470": {
    "state": "Mizoram",
    "district": "Aizawl",
    "block": "Mizoram",
    "officename": "Kawrthah S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Mizoram Division"
  },
  "797006": {
    "state": "Nagaland",
    "district": "Kohima",
    "block": "Nagaland",
    "officename": "Jakhama S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "798607": {
    "state": "Nagaland",
    "district": "Mokokchung",
    "block": "Nagaland",
    "officename": "Alichen S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "798628": {
    "state": "Nagaland",
    "district": "Tuensang",
    "block": "Nagaland",
    "officename": "Shamator SO",
    "circlename": "North Eastern Circle",
    "regionname": "North East - II Region",
    "divisionname": "Nagaland Division"
  },
  "799011": {
    "state": "Tripura",
    "district": "Sepahijala",
    "block": "Agartala",
    "officename": "Jampuijala SO",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799113": {
    "state": "Tripura",
    "district": "Gomati",
    "block": "Agartala",
    "officename": "Tepania S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799132": {
    "state": "Tripura",
    "district": "Sepahijala",
    "block": "Agartala",
    "officename": "Kathalia S.O",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Agartala Division"
  },
  "799282": {
    "state": "Tripura",
    "district": "Unakoti",
    "block": "Dharmanagar",
    "officename": "Gournagar SO",
    "circlename": "North Eastern Circle",
    "regionname": "North East - I Region",
    "divisionname": "Dharmanagar Division"
  },
  "800030": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Patna Sahib Division",
    "officename": "PURVI LAXMINAGAR SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "PATNA SAHIB DIVISION"
  },
  "800031": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Patna",
    "officename": "Rupaspur S.O",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "800032": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Patna",
    "officename": "Saristabad SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "800034": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Patna",
    "officename": "Beur More SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "800035": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Patna Sahib Division",
    "officename": "Parsa SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "PATNA SAHIB DIVISION"
  },
  "801106": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Patna",
    "officename": "IIT Patna Bihta SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "801107": {
    "state": "Bihar",
    "district": "Patna",
    "block": "Patna",
    "officename": "Chiraura Bazar SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Patna Division"
  },
  "801308": {
    "state": "Bihar",
    "district": "Nalanda",
    "block": "Nalanda",
    "officename": "Daniyawan SO",
    "circlename": "Bihar Circle",
    "regionname": "NA",
    "divisionname": "Nalanda Division"
  },
  "802224": {
    "state": "Bihar",
    "district": "Bhojpur",
    "block": "Bhojpur",
    "officename": "Sikraul Fatehpur SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Bhojpur Division"
  },
  "804409": {
    "state": "Bihar",
    "district": "Aurangabad",
    "block": "Aurangabadbihar",
    "officename": "Mehandia SO",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "AurangabadBihar Division"
  },
  "805113": {
    "state": "Bihar",
    "district": "Nawada",
    "block": "Nawadha",
    "officename": "Kashichak SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nawadha Division"
  },
  "805114": {
    "state": "Bihar",
    "district": "Nawada",
    "block": "Nawadha",
    "officename": "Bihar Keshri sri Krishn Singh SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Nawadha Division"
  },
  "811306": {
    "state": "Bihar",
    "district": "Lakhisarai",
    "block": "Munger",
    "officename": "Halsi S.O",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Munger Division"
  },
  "814168": {
    "state": "Jharkhand",
    "district": "Dumka",
    "block": "Santhal Parganas",
    "officename": "Suggapahari B.O",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "814170": {
    "state": "Jharkhand",
    "district": "Dumka",
    "block": "Santhal Parganas",
    "officename": "Hathiyapathar B.O",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "815117": {
    "state": "Jharkhand",
    "district": "Pakur",
    "block": "Santhal Parganas",
    "officename": "Surajdih B.O",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Santhal Parganas Division"
  },
  "818142": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Jhinaki BO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "821015": {
    "state": "Bihar",
    "district": "Rohtas",
    "block": "Rohtas",
    "officename": "Sasaram Tarachandi Dham so",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "821114": {
    "state": "Bihar",
    "district": "Rohtas",
    "block": "Rohtas",
    "officename": "Kudra RS (Lalapur) S.O",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Rohtas Division"
  },
  "824126": {
    "state": "Bihar",
    "district": "Aurangabad",
    "block": "Aurangabadbihar",
    "officename": "Pothu S.O",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "AurangabadBihar Division"
  },
  "824304": {
    "state": "Bihar",
    "district": "Aurangabad",
    "block": "Aurangabadbihar",
    "officename": "NPGCL Aditi Nagar S.O",
    "circlename": "Bihar Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "AurangabadBihar Division"
  },
  "825414": {
    "state": "Jharkhand",
    "district": "Chatra",
    "block": "Hazaribagh",
    "officename": "Hunterganj SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "825415": {
    "state": "Jharkhand",
    "district": "Chatra",
    "block": "Hazaribagh",
    "officename": "NTPC North Karanpura SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Hazaribagh Division"
  },
  "826006": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Rajganj SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "826007": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Centralized Delivery Office PO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "826008": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "KGAshram SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "826009": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "KkPolytechnic SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "826010": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "BARWADDA S.O",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "826011": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "NDC DHANBAD",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "826012": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "99 Koylanchal City",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "826013": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Baramuri Sub Post Office",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "827015": {
    "state": "Jharkhand",
    "district": "Bokaro",
    "block": "Dhanbad",
    "officename": "Chira Chas SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "827016": {
    "state": "Jharkhand",
    "district": "Bokaro",
    "block": "Dhanbad",
    "officename": "NDC B.S.CITY",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "828142": {
    "state": "Jharkhand",
    "district": "Dhanbad",
    "block": "Dhanbad",
    "officename": "Tundi SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "829115": {
    "state": "Jharkhand",
    "district": "Bokaro",
    "block": "Dhanbad",
    "officename": "Garri BO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Dhanbad Division"
  },
  "831021": {
    "state": "Jharkhand",
    "district": "East Singhbum",
    "block": "Singhbhum",
    "officename": "Nodal Delivery Centre Jamshedpur",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "832113": {
    "state": "Jharkhand",
    "district": "East Singhbum",
    "block": "Singhbhum",
    "officename": "Hata Chowk SO",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Singhbhum Division"
  },
  "834007": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Ranchi",
    "officename": "Sail City S.O",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ranchi Division"
  },
  "834012": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Ranchi",
    "officename": "Buti Chowk S.O",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ranchi Division"
  },
  "834013": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Ranchi",
    "officename": "Nodal Delivery Centre Ranchi",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ranchi Division"
  },
  "834014": {
    "state": "Jharkhand",
    "district": "Ranchi",
    "block": "Ranchi",
    "officename": "SEMBO S.O",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Ranchi Division"
  },
  "835224": {
    "state": "Jharkhand",
    "district": "Gumla",
    "block": "Gumla",
    "officename": "Sisai SO Gumla",
    "circlename": "Jharkhand Circle",
    "regionname": "DivReportingCircle",
    "divisionname": "Gumla Division"
  },
  "841228": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "Siwan",
    "officename": "Station Road",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "841447": {
    "state": "Bihar",
    "district": "Siwan",
    "block": "Siwan",
    "officename": "Lakrinabiganj S.O",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Siwan Division"
  },
  "842006": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Muzaffarpur",
    "officename": "Kalwari SO Muzaffarpur",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "843116": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Muzaffarpur",
    "officename": "Kuahi SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "843131": {
    "state": "Bihar",
    "district": "Sitamarhi",
    "block": "Muzaffarpur",
    "officename": "Tariyani Chowk SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "843132": {
    "state": "Bihar",
    "district": "Muzaffarpur",
    "block": "Muzaffarpur",
    "officename": "Manika Harikishun S.O",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Muzaffarpur Division"
  },
  "843335": {
    "state": "Bihar",
    "district": "Sheohar",
    "block": "Sitamarhi",
    "officename": "B Jagdish SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Sitamarhi Division"
  },
  "845402": {
    "state": "Bihar",
    "district": "Purbi Champaran",
    "block": "East Champaran",
    "officename": "Motihari Court SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845404": {
    "state": "Bihar",
    "district": "Pashchim Champaran",
    "block": "West Champaran",
    "officename": "Balua Thori Bazar BO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "West Champaran Division"
  },
  "845405": {
    "state": "Bihar",
    "district": "Purbi Champaran",
    "block": "East Champaran",
    "officename": "Narha Panapur S.O",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "845439": {
    "state": "Bihar",
    "district": "Pashchim Champaran",
    "block": "West Champaran",
    "officename": "Naya Tola Bettiah S.O",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "West Champaran Division"
  },
  "845441": {
    "state": "Bihar",
    "district": "Purbi Champaran",
    "block": "East Champaran",
    "officename": "Kotwa SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "East Champaran Division"
  },
  "846010": {
    "state": "Bihar",
    "district": "Darbhanga",
    "block": "Darbhanga",
    "officename": "ROHAR S.O",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "847202": {
    "state": "Bihar",
    "district": "Darbhanga",
    "block": "Darbhanga",
    "officename": "Sahoparari SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Darbhanga Division"
  },
  "847412": {
    "state": "Bihar",
    "district": "Madhubani",
    "block": "Madhubani",
    "officename": "Madna S.O",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Madhubani Division"
  },
  "848103": {
    "state": "Bihar",
    "district": "Samastipur",
    "block": "Samastipur",
    "officename": "Musrigharari S.O.",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Samastipur Division"
  },
  "848104": {
    "state": "Bihar",
    "district": "Samastipur",
    "block": "Samastipur",
    "officename": "Kashipur Samastipur SO",
    "circlename": "Bihar Circle",
    "regionname": "Muzaffarpur Region",
    "divisionname": "Samastipur Division"
  },
  "851110": {
    "state": "Bihar",
    "district": "Begusarai",
    "block": "Begusarai",
    "officename": "Khamhar PO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "851121": {
    "state": "Bihar",
    "district": "Begusarai",
    "block": "Begusarai",
    "officename": "Barkhunt S.O",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "851206": {
    "state": "Bihar",
    "district": "Khagaria",
    "block": "Begusarai",
    "officename": "Alauli S.O",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Begusarai Division"
  },
  "852133": {
    "state": "Bihar",
    "district": "Supaul",
    "block": "Saharsa",
    "officename": "Janardanpur SO",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "852134": {
    "state": "Bihar",
    "district": "Supaul",
    "block": "Saharsa",
    "officename": "SUPAUL BAZAR",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Saharsa Division"
  },
  "854110": {
    "state": "Bihar",
    "district": "Katihar",
    "block": "Divisional Office Katihar",
    "officename": "Morsanda S.O",
    "circlename": "Bihar Circle",
    "regionname": "East Region Bhagalpur",
    "divisionname": "Divisional Office Katihar"
  },
  "900056": {
    "state": "Uttar Pradesh",
    "district": "Kushi Nagar",
    "block": "1Cbpo Dv",
    "officename": "1CBPO",
    "circlename": "APS CIRCLE",
    "regionname": "WESTERN COMMAND",
    "divisionname": "1CBPO DV"
  },
  "900099": {
    "state": "West Bengal",
    "district": "Kolkata",
    "block": "2Cbpo Dv",
    "officename": "2CBPO",
    "circlename": "APS CIRCLE",
    "regionname": "EASTERN COMMAND",
    "divisionname": "2CBPO DV"
  }
}
;